// Auto-generated from US Census Bureau Cartographic Boundary Files
// This file contains simplified state boundary coordinates for map visualization
// Data source: https://www.census.gov/geographies/mapping-files/time-series/geo/carto-boundary-file.html

export interface StateBoundary {
  coordinates: [number, number][]; // [lng, lat] pairs
}

export const stateBoundaries: Record<string, StateBoundary> = {
  "Mississippi": {
    coordinates: [
      [-91.6550, 31.2518],
    [-91.6487, 31.2622],
    [-91.6214, 31.2678],
    [-91.5745, 31.2613],
    [-91.5377, 31.2674],
    [-91.5121, 31.2842],
    [-91.5080, 31.3129],
    [-91.5185, 31.3233],
    [-91.5361, 31.3384],
    [-91.5489, 31.3540],
    [-91.5499, 31.3763],
    [-91.5524, 31.3857],
    [-91.5626, 31.3832],
    [-91.5739, 31.3909],
    [-91.5763, 31.4105],
    [-91.5548, 31.4286],
    [-91.5450, 31.4330],
    [-91.5371, 31.4242],
    [-91.5395, 31.4140],
    [-91.5218, 31.3752],
    [-91.5042, 31.3650],
    [-91.4711, 31.3769],
    [-91.4721, 31.3914],
    [-91.4802, 31.4044],
    [-91.5064, 31.4315],
    [-91.5151, 31.4492],
    [-91.5171, 31.4984],
    [-91.5168, 31.5118],
    [-91.5229, 31.5198],
    [-91.5180, 31.5281],
    [-91.5112, 31.5326],
    [-91.4896, 31.5343],
    [-91.4797, 31.5304],
    [-91.4500, 31.5397],
    [-91.4264, 31.5546],
    [-91.4199, 31.5589],
    [-91.4078, 31.5696],
    [-91.4043, 31.5863],
    [-91.4171, 31.5963],
    [-91.4363, 31.5950],
    [-91.4663, 31.5861],
    [-91.4852, 31.5862],
    [-91.5028, 31.5957],
    [-91.5166, 31.6118],
    [-91.5167, 31.6273],
    [-91.5073, 31.6391],
    [-91.4945, 31.6450],
    [-91.4875, 31.6371],
    [-91.4743, 31.6254],
    [-91.4296, 31.6114],
    [-91.4010, 31.6204],
    [-91.3961, 31.6393],
    [-91.4001, 31.6882],
    [-91.3971, 31.7114],
    [-91.3718, 31.7429],
    [-91.3387, 31.7500],
    [-91.3107, 31.7491],
    [-91.2634, 31.7545],
    [-91.2663, 31.7682],
    [-91.3013, 31.7667],
    [-91.3552, 31.7581],
    [-91.3595, 31.7994],
    [-91.3430, 31.8469],
    [-91.3269, 31.8550],
    [-91.2893, 31.8469],
    [-91.2878, 31.8242],
    [-91.2802, 31.8132],
    [-91.2620, 31.8094],
    [-91.2474, 31.8223],
    [-91.2611, 31.8461],
    [-91.2688, 31.8552],
    [-91.2670, 31.8637],
    [-91.2481, 31.8698],
    [-91.2088, 31.9005],
    [-91.2010, 31.9092],
    [-91.1926, 31.9102],
    [-91.1892, 31.9143],
    [-91.1812, 31.9175],
    [-91.1849, 31.9238],
    [-91.1847, 31.9351],
    [-91.1932, 31.9357],
    [-91.1891, 31.9575],
    [-91.1805, 31.9701],
    [-91.1644, 31.9826],
    [-91.0961, 31.9949],
    [-91.0799, 32.0183],
    [-91.0844, 32.0315],
    [-91.1251, 32.0429],
    [-91.1563, 32.0527],
    [-91.1620, 32.0624],
    [-91.1603, 32.0704],
    [-91.1451, 32.0814],
    [-91.1286, 32.0766],
    [-91.1037, 32.0503],
    [-91.0802, 32.0484],
    [-91.0815, 32.0778],
    [-91.0386, 32.0983],
    [-91.0307, 32.1143],
    [-91.0270, 32.1211],
    [-91.0118, 32.1312],
    [-91.0041, 32.1462],
    [-91.0250, 32.1626],
    [-91.0502, 32.1785],
    [-91.0557, 32.1638],
    [-91.0502, 32.1453],
    [-91.0616, 32.1269],
    [-91.0816, 32.1340],
    [-91.1037, 32.1300],
    [-91.1139, 32.1257],
    [-91.1444, 32.1304],
    [-91.1655, 32.1343],
    [-91.1735, 32.1490],
    [-91.1710, 32.1765],
    [-91.1621, 32.1990],
    [-91.1302, 32.2137],
    [-91.1173, 32.2067],
    [-91.1085, 32.2081],
    [-91.0837, 32.2264],
    [-91.0614, 32.2186],
    [-91.0518, 32.2344],
    [-91.0465, 32.2411],
    [-91.0266, 32.2387],
    [-91.0029, 32.2231],
    [-91.0025, 32.1959],
    [-90.9952, 32.1921],
    [-90.9890, 32.2013],
    [-90.9831, 32.2314],
    [-90.9700, 32.2517],
    [-90.9797, 32.2653],
    [-90.9841, 32.2800],
    [-90.9762, 32.2965],
    [-90.9641, 32.2969],
    [-90.9554, 32.2862],
    [-90.9478, 32.2835],
    [-90.9234, 32.2978],
    [-90.9065, 32.3140],
    [-90.9012, 32.3234],
    [-90.8879, 32.3491],
    [-90.8822, 32.3576],
    [-90.8783, 32.3745],
    [-90.8921, 32.3706],
    [-90.9124, 32.3395],
    [-90.9430, 32.3460],
    [-90.9936, 32.3540],
    [-91.0045, 32.3647],
    [-90.9962, 32.3881],
    [-90.9941, 32.4039],
    [-90.9711, 32.4146],
    [-90.9660, 32.4248],
    [-90.9686, 32.4381],
    [-90.9834, 32.4491],
    [-91.0048, 32.4457],
    [-91.0296, 32.4335],
    [-91.0818, 32.4504],
    [-91.1121, 32.4761],
    [-91.1167, 32.5001],
    [-91.0988, 32.5330],
    [-91.0937, 32.5491],
    [-91.0605, 32.5124],
    [-91.0381, 32.4904],
    [-91.0171, 32.4837],
    [-90.9964, 32.4839],
    [-90.9876, 32.4924],
    [-90.9949, 32.5086],
    [-91.0512, 32.5309],
    [-91.0804, 32.5564],
    [-91.0493, 32.5736],
    [-91.0310, 32.5833],
    [-91.0137, 32.5984],
    [-91.0030, 32.6147],
    [-91.0068, 32.6313],
    [-91.0258, 32.6466],
    [-91.0404, 32.6325],
    [-91.0489, 32.6136],
    [-91.0795, 32.6007],
    [-91.1128, 32.5902],
    [-91.1251, 32.5852],
    [-91.1411, 32.5972],
    [-91.1513, 32.6159],
    [-91.1538, 32.6313],
    [-91.1521, 32.6415],
    [-91.1420, 32.6493],
    [-91.1309, 32.6589],
    [-91.1044, 32.6824],
    [-91.0761, 32.6938],
    [-91.0547, 32.7192],
    [-91.0570, 32.7256],
    [-91.0906, 32.7361],
    [-91.1317, 32.7431],
    [-91.1586, 32.7434],
    [-91.1658, 32.7578],
    [-91.1569, 32.7803],
    [-91.1631, 32.7922],
    [-91.1616, 32.8083],
    [-91.1572, 32.8238],
    [-91.1450, 32.8429],
    [-91.1279, 32.8551],
    [-91.1056, 32.8584],
    [-91.0682, 32.8919],
    [-91.0638, 32.9039],
    [-91.0646, 32.9180],
    [-91.0648, 32.9265],
    [-91.0804, 32.9432],
    [-91.0819, 32.9494],
    [-91.0804, 32.9628],
    [-91.0943, 32.9844],
    [-91.1118, 32.9884],
    [-91.1355, 32.9797],
    [-91.1330, 32.9665],
    [-91.1312, 32.9609],
    [-91.1372, 32.9565],
    [-91.1313, 32.9300],
    [-91.1340, 32.9177],
    [-91.1600, 32.8999],
    [-91.1816, 32.9014],
    [-91.2083, 32.9154],
    [-91.2140, 32.9272],
    [-91.2107, 32.9398],
    [-91.2012, 32.9550],
    [-91.1996, 32.9636],
    [-91.1822, 32.9786],
    [-91.1662, 33.0022],
    [-91.1624, 33.0197],
    [-91.1424, 33.0272],
    [-91.1257, 33.0383],
    [-91.1203, 33.0559],
    [-91.1498, 33.0816],
    [-91.1715, 33.0878],
    [-91.1808, 33.0984],
    [-91.2002, 33.1069],
    [-91.2021, 33.1212],
    [-91.1932, 33.1367],
    [-91.1694, 33.1426],
    [-91.1530, 33.1351],
    [-91.1433, 33.1298],
    [-91.1043, 33.1316],
    [-91.0876, 33.1452],
    [-91.0849, 33.1618],
    [-91.0899, 33.2102],
    [-91.0829, 33.2216],
    [-91.0792, 33.2265],
    [-91.0707, 33.2273],
    [-91.0656, 33.2330],
    [-91.0504, 33.2512],
    [-91.0440, 33.2698],
    [-91.0481, 33.2828],
    [-91.0670, 33.2872],
    [-91.0812, 33.2813],
    [-91.0903, 33.2573],
    [-91.0969, 33.2416],
    [-91.1061, 33.2418],
    [-91.1152, 33.2552],
    [-91.1281, 33.2685],
    [-91.1401, 33.2966],
    [-91.1415, 33.3143],
    [-91.1434, 33.3305],
    [-91.1410, 33.3365],
    [-91.1402, 33.3515],
    [-91.1204, 33.3638],
    [-91.0909, 33.3958],
    [-91.0753, 33.4060],
    [-91.0592, 33.4269],
    [-91.0580, 33.4462],
    [-91.0676, 33.4551],
    [-91.0818, 33.4542],
    [-91.0943, 33.4427],
    [-91.0975, 33.4317],
    [-91.0993, 33.4082],
    [-91.1236, 33.3875],
    [-91.1663, 33.3797],
    [-91.1911, 33.3896],
    [-91.2081, 33.4020],
    [-91.2087, 33.4087],
    [-91.1994, 33.4183],
    [-91.1794, 33.4172],
    [-91.1477, 33.4272],
    [-91.1319, 33.4301],
    [-91.1286, 33.4363],
    [-91.1180, 33.4538],
    [-91.1251, 33.4728],
    [-91.1601, 33.4948],
    [-91.1722, 33.4967],
    [-91.1770, 33.4789],
    [-91.1694, 33.4526],
    [-91.1870, 33.4386],
    [-91.2103, 33.4338],
    [-91.2359, 33.4406],
    [-91.2334, 33.4440],
    [-91.2233, 33.4628],
    [-91.2085, 33.4686],
    [-91.1996, 33.4831],
    [-91.1856, 33.4964],
    [-91.1846, 33.5074],
    [-91.2193, 33.5324],
    [-91.2323, 33.5528],
    [-91.2309, 33.5614],
    [-91.2215, 33.5682],
    [-91.1889, 33.5762],
    [-91.1760, 33.5830],
    [-91.1521, 33.5827],
    [-91.1324, 33.5970],
    [-91.1309, 33.6109],
    [-91.1392, 33.6257],
    [-91.1712, 33.6478],
    [-91.2113, 33.6585],
    [-91.2265, 33.6687],
    [-91.2279, 33.6831],
    [-91.2206, 33.6929],
    [-91.2007, 33.7015],
    [-91.1658, 33.7051],
    [-91.1442, 33.6896],
    [-91.1010, 33.6606],
    [-91.0841, 33.6573],
    [-91.0592, 33.6664],
    [-91.0368, 33.6713],
    [-91.0315, 33.6781],
    [-91.0334, 33.6888],
    [-91.0390, 33.6966],
    [-91.0556, 33.7125],
    [-91.0683, 33.7165],
    [-91.1011, 33.7050],
    [-91.1255, 33.7088],
    [-91.1458, 33.7289],
    [-91.1433, 33.7471],
    [-91.1416, 33.7560],
    [-91.1436, 33.7621],
    [-91.1420, 33.7738],
    [-91.1339, 33.7828],
    [-91.1235, 33.7821],
    [-91.1115, 33.7746],
    [-91.0855, 33.7764],
    [-91.0268, 33.7636],
    [-91.0001, 33.7692],
    [-90.9894, 33.7806],
    [-90.9893, 33.7880],
    [-91.0078, 33.8026],
    [-91.0252, 33.8060],
    [-91.0497, 33.8187],
    [-91.0650, 33.8371],
    [-91.0730, 33.8574],
    [-91.0612, 33.8775],
    [-91.0367, 33.8985],
    [-91.0108, 33.9256],
    [-91.0103, 33.9294],
    [-91.0360, 33.9438],
    [-91.0790, 33.9543],
    [-91.0887, 33.9613],
    [-91.0891, 33.9727],
    [-91.0793, 33.9821],
    [-91.0623, 33.9851],
    [-91.0396, 33.9893],
    [-91.0136, 33.9945],
    [-91.0001, 33.9664],
    [-90.9834, 33.9602],
    [-90.9676, 33.9633],
    [-90.9612, 33.9762],
    [-90.9775, 33.9966],
    [-90.9827, 34.0205],
    [-90.9585, 34.0203],
    [-90.9349, 34.0193],
    [-90.9146, 34.0219],
    [-90.8890, 34.0298],
    [-90.8874, 34.0398],
    [-90.8878, 34.0554],
    [-90.8745, 34.0720],
    [-90.8705, 34.0805],
    [-90.8766, 34.0929],
    [-90.8881, 34.0978],
    [-90.9141, 34.0928],
    [-90.9463, 34.1094],
    [-90.9560, 34.1201],
    [-90.9543, 34.1385],
    [-90.9036, 34.1643],
    [-90.8768, 34.1481],
    [-90.8535, 34.1375],
    [-90.8303, 34.1398],
    [-90.8159, 34.1499],
    [-90.8072, 34.1675],
    [-90.8100, 34.1784],
    [-90.8284, 34.1848],
    [-90.8556, 34.1869],
    [-90.8697, 34.1830],
    [-90.8827, 34.1844],
    [-90.9118, 34.1939],
    [-90.9352, 34.2190],
    [-90.9364, 34.2367],
    [-90.9232, 34.2465],
    [-90.9059, 34.2435],
    [-90.8983, 34.2273],
    [-90.8671, 34.2121],
    [-90.8478, 34.2065],
    [-90.8400, 34.2231],
    [-90.8400, 34.2361],
    [-90.8324, 34.2675],
    [-90.8245, 34.2762],
    [-90.8029, 34.2825],
    [-90.7723, 34.2799],
    [-90.7527, 34.2893],
    [-90.7406, 34.3135],
    [-90.7489, 34.3310],
    [-90.7677, 34.3469],
    [-90.7658, 34.3621],
    [-90.7501, 34.3679],
    [-90.7291, 34.3642],
    [-90.7121, 34.3638],
    [-90.6786, 34.3711],
    [-90.6816, 34.3529],
    [-90.6931, 34.3226],
    [-90.6781, 34.3130],
    [-90.6575, 34.3222],
    [-90.6609, 34.3367],
    [-90.6553, 34.3718],
    [-90.6349, 34.3864],
    [-90.6139, 34.3907],
    [-90.5753, 34.4152],
    [-90.5684, 34.4248],
    [-90.5667, 34.4378],
    [-90.5769, 34.4544],
    [-90.5883, 34.4706],
    [-90.5875, 34.4965],
    [-90.5811, 34.5128],
    [-90.5693, 34.5249],
    [-90.5436, 34.5404],
    [-90.5410, 34.5509],
    [-90.5577, 34.5769],
    [-90.5748, 34.5952],
    [-90.5883, 34.6266],
    [-90.5831, 34.6436],
    [-90.5873, 34.6654],
    [-90.5820, 34.6802],
    [-90.5673, 34.6934],
    [-90.5556, 34.6979],
    [-90.5481, 34.6932],
    [-90.5389, 34.6825],
    [-90.5502, 34.6634],
    [-90.5551, 34.6462],
    [-90.5476, 34.6317],
    [-90.5322, 34.6275],
    [-90.5081, 34.6367],
    [-90.4879, 34.6549],
    [-90.4660, 34.6743],
    [-90.4626, 34.6876],
    [-90.4700, 34.6981],
    [-90.4800, 34.7015],
    [-90.5098, 34.6980],
    [-90.5390, 34.6988],
    [-90.5656, 34.7211],
    [-90.5682, 34.7274],
    [-90.5654, 34.7365],
    [-90.5563, 34.7415],
    [-90.5388, 34.7456],
    [-90.5406, 34.7605],
    [-90.5479, 34.7792],
    [-90.5441, 34.7912],
    [-90.5313, 34.8006],
    [-90.5147, 34.8018],
    [-90.5015, 34.7748],
    [-90.5055, 34.7646],
    [-90.5249, 34.7501],
    [-90.5202, 34.7319],
    [-90.4889, 34.7237],
    [-90.4579, 34.7329],
    [-90.4519, 34.7422],
    [-90.4530, 34.7534],
    [-90.4735, 34.7888],
    [-90.4723, 34.8025],
    [-90.4590, 34.8144],
    [-90.4638, 34.8349],
    [-90.4839, 34.8613],
    [-90.4840, 34.8772],
    [-90.4662, 34.8910],
    [-90.4448, 34.8880],
    [-90.4366, 34.8827],
    [-90.4291, 34.8651],
    [-90.4308, 34.8490],
    [-90.4224, 34.8337],
    [-90.4080, 34.8330],
    [-90.3522, 34.8532],
    [-90.3358, 34.8559],
    [-90.3192, 34.8449],
    [-90.3039, 34.8505],
    [-90.3037, 34.8597],
    [-90.3100, 34.8751],
    [-90.2501, 34.9073],
    [-90.2447, 34.9210],
    [-90.2478, 34.9479],
    [-90.2540, 34.9550],
    [-90.2822, 34.9677],
    [-90.2964, 34.9763],
    [-90.3093, 34.9957],
    [-90.1276, 34.9951],
    [-90.0608, 34.9949],
    [-90.0251, 34.9948],
    [-90.0081, 34.9947],
    [-89.9899, 34.9947],
    [-89.9559, 34.9946],
    [-89.9189, 34.9944],
    [-89.8934, 34.9944],
    [-89.8783, 34.9943],
    [-89.8484, 34.9942],
    [-89.8307, 34.9942],
    [-89.7952, 34.9943],
    [-89.7419, 34.9952],
    [-89.7066, 34.9952],
    [-89.6179, 34.9952],
    [-89.5822, 34.9950],
    [-89.5287, 34.9948],
    [-89.4937, 34.9944],
    [-89.4410, 34.9938],
    [-89.3811, 34.9940],
    [-89.2174, 34.9947],
    [-89.1568, 34.9939],
    [-89.0265, 34.9950],
    [-88.9311, 34.9948],
    [-88.8870, 34.9959],
    [-88.8230, 34.9952],
    [-88.6844, 34.9955],
    [-88.5639, 34.9958],
    [-88.5285, 34.9959],
    [-88.5054, 34.9959],
    [-88.4742, 34.9960],
    [-88.4628, 34.9960],
    [-88.2581, 34.9955],
    [-88.2516, 34.9956],
    [-88.1988, 34.9912],
    [-88.1761, 34.9625],
    [-88.1546, 34.9224],
    [-88.1367, 34.9076],
    [-88.1000, 34.8941],
    [-88.1076, 34.8116],
    [-88.1208, 34.7089],
    [-88.1343, 34.6227],
    [-88.1392, 34.5878],
    [-88.1561, 34.4650],
    [-88.1568, 34.4593],
    [-88.1614, 34.4196],
    [-88.1659, 34.3809],
    [-88.1769, 34.2939],
    [-88.1867, 34.2210],
    [-88.1921, 34.1754],
    [-88.2060, 34.0684],
    [-88.2117, 34.0217],
    [-88.2264, 33.9129],
    [-88.2289, 33.8942],
    [-88.2295, 33.8904],
    [-88.2401, 33.8109],
    [-88.2430, 33.7957],
    [-88.2489, 33.7450],
    [-88.2546, 33.6958],
    [-88.2620, 33.6354],
    [-88.2670, 33.5942],
    [-88.2691, 33.5769],
    [-88.2708, 33.5649],
    [-88.2746, 33.5340],
    [-88.2783, 33.5047],
    [-88.2911, 33.3991],
    [-88.3005, 33.3208],
    [-88.3044, 33.2883],
    [-88.3125, 33.2209],
    [-88.3219, 33.1462],
    [-88.3310, 33.0725],
    [-88.3543, 32.8751],
    [-88.3683, 32.7477],
    [-88.3830, 32.6270],
    [-88.3856, 32.6055],
    [-88.4000, 32.4854],
    [-88.4038, 32.4499],
    [-88.4039, 32.4488],
    [-88.4138, 32.3739],
    [-88.4149, 32.3645],
    [-88.4279, 32.2530],
    [-88.4338, 32.2087],
    [-88.4387, 32.1721],
    [-88.4430, 32.1370],
    [-88.4550, 32.0406],
    [-88.4689, 31.9303],
    [-88.4732, 31.8939],
    [-88.4711, 31.8509],
    [-88.4687, 31.7907],
    [-88.4644, 31.6980],
    [-88.4606, 31.6383],
    [-88.4578, 31.5896],
    [-88.4536, 31.5107],
    [-88.4516, 31.4815],
    [-88.4496, 31.4358],
    [-88.4452, 31.3560],
    [-88.4438, 31.3337],
    [-88.4392, 31.2586],
    [-88.4382, 31.2313],
    [-88.4320, 31.1143],
    [-88.4257, 31.0002],
    [-88.4196, 30.8752],
    [-88.4183, 30.8586],
    [-88.4125, 30.7356],
    [-88.4115, 30.7130],
    [-88.4081, 30.6370],
    [-88.4075, 30.6227],
    [-88.4042, 30.5490],
    [-88.4039, 30.5434],
    [-88.4020, 30.5047],
    [-88.4003, 30.4726],
    [-88.3972, 30.3677],
    [-88.3941, 30.3525],
    [-88.4012, 30.3444],
    [-88.4124, 30.3580],
    [-88.4309, 30.3556],
    [-88.4465, 30.3573],
    [-88.4465, 30.3478],
    [-88.4719, 30.3200],
    [-88.5062, 30.3224],
    [-88.5140, 30.3321],
    [-88.5269, 30.3424],
    [-88.5466, 30.3435],
    [-88.5795, 30.3442],
    [-88.5845, 30.3644],
    [-88.5905, 30.3656],
    [-88.5994, 30.3595],
    [-88.6069, 30.3544],
    [-88.6114, 30.3539],
    [-88.6124, 30.3651],
    [-88.6114, 30.3732],
    [-88.6255, 30.3686],
    [-88.6454, 30.3605],
    [-88.6644, 30.3619],
    [-88.6647, 30.3618],
    [-88.6922, 30.3473],
    [-88.7289, 30.3427],
    [-88.7491, 30.3491],
    [-88.8080, 30.3831],
    [-88.8126, 30.3867],
    [-88.7960, 30.3834],
    [-88.7898, 30.3863],
    [-88.7999, 30.3917],
    [-88.8237, 30.4024],
    [-88.8413, 30.4096],
    [-88.8533, 30.4230],
    [-88.8578, 30.4302],
    [-88.8652, 30.4272],
    [-88.8709, 30.4195],
    [-88.8686, 30.4088],
    [-88.8595, 30.3969],
    [-88.8569, 30.3903],
    [-88.8669, 30.3909],
    [-88.8831, 30.3919],
    [-88.8924, 30.3932],
    [-88.9021, 30.3935],
    [-88.9270, 30.3935],
    [-88.9615, 30.3875],
    [-88.9639, 30.3888],
    [-88.9728, 30.3906],
    [-89.0013, 30.3869],
    [-89.0279, 30.3814],
    [-89.0542, 30.3757],
    [-89.0851, 30.3674],
    [-89.0852, 30.3536],
    [-89.0924, 30.3503],
    [-89.1014, 30.3616],
    [-89.1243, 30.3535],
    [-89.1410, 30.3437],
    [-89.1539, 30.3429],
    [-89.2204, 30.3225],
    [-89.2453, 30.3110],
    [-89.2718, 30.3055],
    [-89.2857, 30.3031],
    [-89.2944, 30.3076],
    [-89.2918, 30.3281],
    [-89.2851, 30.3327],
    [-89.2728, 30.3340],
    [-89.2702, 30.3422],
    [-89.2850, 30.3538],
    [-89.2973, 30.3670],
    [-89.3122, 30.3606],
    [-89.3359, 30.3740],
    [-89.3494, 30.3710],
    [-89.3621, 30.3592],
    [-89.3602, 30.3506],
    [-89.3388, 30.3430],
    [-89.3224, 30.3194],
    [-89.3259, 30.3095],
    [-89.3299, 30.3029],
    [-89.3554, 30.2899],
    [-89.3587, 30.2888],
    [-89.3657, 30.2849],
    [-89.3719, 30.2784],
    [-89.3795, 30.2704],
    [-89.3877, 30.2663],
    [-89.4050, 30.2598],
    [-89.4246, 30.2454],
    [-89.4217, 30.2375],
    [-89.4304, 30.2232],
    [-89.4404, 30.2129],
    [-89.4488, 30.2021],
    [-89.4555, 30.1811],
    [-89.4698, 30.1763],
    [-89.4608, 30.1899],
    [-89.4802, 30.1938],
    [-89.4924, 30.1831],
    [-89.5142, 30.1843],
    [-89.5245, 30.1808],
    [-89.5334, 30.1948],
    [-89.5470, 30.1931],
    [-89.5547, 30.1858],
    [-89.5745, 30.1817],
    [-89.5874, 30.1952],
    [-89.5956, 30.2103],
    [-89.6077, 30.2171],
    [-89.6159, 30.2232],
    [-89.6159, 30.2353],
    [-89.6142, 30.2446],
    [-89.6239, 30.2499],
    [-89.6322, 30.2601],
    [-89.6262, 30.2623],
    [-89.6296, 30.2673],
    [-89.6324, 30.2715],
    [-89.6326, 30.2807],
    [-89.6434, 30.2877],
    [-89.6453, 30.2926],
    [-89.6416, 30.3034],
    [-89.6399, 30.3073],
    [-89.6262, 30.3143],
    [-89.6304, 30.3329],
    [-89.6452, 30.3481],
    [-89.6527, 30.3555],
    [-89.6622, 30.3713],
    [-89.6728, 30.3893],
    [-89.6837, 30.4059],
    [-89.6812, 30.4115],
    [-89.6805, 30.4289],
    [-89.6848, 30.4395],
    [-89.6898, 30.4593],
    [-89.6953, 30.4629],
    [-89.7018, 30.4651],
    [-89.7102, 30.4783],
    [-89.7197, 30.4832],
    [-89.7246, 30.4919],
    [-89.7346, 30.4947],
    [-89.7464, 30.5026],
    [-89.7586, 30.5059],
    [-89.7681, 30.5150],
    [-89.7716, 30.5302],
    [-89.7802, 30.5446],
    [-89.7910, 30.5450],
    [-89.8039, 30.5493],
    [-89.7940, 30.5483],
    [-89.7945, 30.5566],
    [-89.8039, 30.5606],
    [-89.8003, 30.5637],
    [-89.7877, 30.5664],
    [-89.7896, 30.5704],
    [-89.7914, 30.5655],
    [-89.7957, 30.5657],
    [-89.7999, 30.5694],
    [-89.8080, 30.5680],
    [-89.8072, 30.5732],
    [-89.8129, 30.5817],
    [-89.8137, 30.5860],
    [-89.8078, 30.5858],
    [-89.8114, 30.5866],
    [-89.8140, 30.5916],
    [-89.8198, 30.5953],
    [-89.8143, 30.5971],
    [-89.8172, 30.6009],
    [-89.8181, 30.6050],
    [-89.8154, 30.6086],
    [-89.8233, 30.6082],
    [-89.8214, 30.6198],
    [-89.8299, 30.6167],
    [-89.8303, 30.6198],
    [-89.8233, 30.6228],
    [-89.8206, 30.6284],
    [-89.8139, 30.6368],
    [-89.8205, 30.6383],
    [-89.8206, 30.6448],
    [-89.8250, 30.6494],
    [-89.8410, 30.6585],
    [-89.8505, 30.6648],
    [-89.8456, 30.6636],
    [-89.8388, 30.6691],
    [-89.8406, 30.6729],
    [-89.8438, 30.6688],
    [-89.8450, 30.6747],
    [-89.8358, 30.6984],
    [-89.8393, 30.7041],
    [-89.8459, 30.7042],
    [-89.8458, 30.7073],
    [-89.8301, 30.7163],
    [-89.8363, 30.7272],
    [-89.8358, 30.7359],
    [-89.8274, 30.7362],
    [-89.8165, 30.7379],
    [-89.8195, 30.7407],
    [-89.8277, 30.7384],
    [-89.8258, 30.7473],
    [-89.8266, 30.7531],
    [-89.8326, 30.7560],
    [-89.8293, 30.7606],
    [-89.8322, 30.7651],
    [-89.8288, 30.7687],
    [-89.8304, 30.7798],
    [-89.8201, 30.7824],
    [-89.8215, 30.7912],
    [-89.8192, 30.7952],
    [-89.8139, 30.7938],
    [-89.8121, 30.7884],
    [-89.8051, 30.7906],
    [-89.8062, 30.7934],
    [-89.8109, 30.7974],
    [-89.8107, 30.7994],
    [-89.8046, 30.8025],
    [-89.8004, 30.8104],
    [-89.7972, 30.8118],
    [-89.8000, 30.8191],
    [-89.7966, 30.8216],
    [-89.7962, 30.8181],
    [-89.7940, 30.8179],
    [-89.7917, 30.8204],
    [-89.7812, 30.8201],
    [-89.7864, 30.8212],
    [-89.7857, 30.8259],
    [-89.7823, 30.8326],
    [-89.7894, 30.8305],
    [-89.7901, 30.8380],
    [-89.7919, 30.8487],
    [-89.7895, 30.8514],
    [-89.7856, 30.8475],
    [-89.7806, 30.8455],
    [-89.7838, 30.8521],
    [-89.7834, 30.8560],
    [-89.7747, 30.8533],
    [-89.7680, 30.8639],
    [-89.7780, 30.8734],
    [-89.7781, 30.8796],
    [-89.7700, 30.8823],
    [-89.7731, 30.8983],
    [-89.7651, 30.8969],
    [-89.7570, 30.8989],
    [-89.7616, 30.9066],
    [-89.7642, 30.9119],
    [-89.7574, 30.9150],
    [-89.7467, 30.9158],
    [-89.7452, 30.9224],
    [-89.7528, 30.9254],
    [-89.7489, 30.9328],
    [-89.7558, 30.9395],
    [-89.7512, 30.9514],
    [-89.7357, 30.9666],
    [-89.7293, 30.9662],
    [-89.7271, 30.9697],
    [-89.7371, 30.9761],
    [-89.7322, 30.9781],
    [-89.7277, 30.9933],
    [-89.7342, 30.9956],
    [-89.7281, 31.0010],
    [-89.7296, 31.0039],
    [-89.7452, 31.0023],
    [-89.7515, 30.9997],
    [-89.7998, 31.0020],
    [-89.8355, 31.0021],
    [-89.8637, 31.0020],
    [-89.9231, 31.0014],
    [-89.9728, 31.0014],
    [-90.0053, 31.0014],
    [-90.0296, 31.0012],
    [-90.0731, 31.0012],
    [-90.1284, 31.0010],
    [-90.1643, 31.0010],
    [-90.1944, 31.0009],
    [-90.3460, 31.0004],
    [-90.3556, 31.0003],
    [-90.4221, 30.9998],
    [-90.4417, 30.9997],
    [-90.4569, 30.9998],
    [-90.4633, 30.9998],
    [-90.4773, 30.9997],
    [-90.4867, 30.9997],
    [-90.5835, 30.9997],
    [-90.5887, 30.9996],
    [-90.6512, 30.9995],
    [-90.7346, 30.9992],
    [-90.7693, 30.9994],
    [-90.7837, 30.9994],
    [-90.8349, 30.9994],
    [-90.9702, 30.9993],
    [-91.0602, 30.9990],
    [-91.1081, 30.9989],
    [-91.1762, 30.9991],
    [-91.2315, 30.9993],
    [-91.3482, 30.9992],
    [-91.4146, 30.9990],
    [-91.4873, 30.9990],
    [-91.5387, 30.9994],
    [-91.6369, 30.9994],
    [-91.5905, 31.0173],
    [-91.5644, 31.0390],
    [-91.5599, 31.0541],
    [-91.5676, 31.0702],
    [-91.6148, 31.1044],
    [-91.6260, 31.1169],
    [-91.6251, 31.1319],
    [-91.6042, 31.1545],
    [-91.5915, 31.1731],
    [-91.5889, 31.1890],
    [-91.5950, 31.2020],
    [-91.6444, 31.2344],
    [-91.6550, 31.2518]
    ]
  },
  "North Carolina": {
    coordinates: [
      [-84.3175, 35.0218],
    [-84.3100, 35.0789],
    [-84.3084, 35.0932],
    [-84.2980, 35.1675],
    [-84.2923, 35.2067],
    [-84.2896, 35.2247],
    [-84.2825, 35.2279],
    [-84.2577, 35.2462],
    [-84.2402, 35.2552],
    [-84.2237, 35.2691],
    [-84.2055, 35.2597],
    [-84.2017, 35.2478],
    [-84.1922, 35.2431],
    [-84.1770, 35.2424],
    [-84.1613, 35.2435],
    [-84.1553, 35.2465],
    [-84.1364, 35.2448],
    [-84.1279, 35.2411],
    [-84.1268, 35.2465],
    [-84.1236, 35.2497],
    [-84.1189, 35.2523],
    [-84.1150, 35.2498],
    [-84.1112, 35.2496],
    [-84.1084, 35.2503],
    [-84.1042, 35.2502],
    [-84.1007, 35.2484],
    [-84.0829, 35.2571],
    [-84.0747, 35.2632],
    [-84.0557, 35.2682],
    [-84.0360, 35.2887],
    [-84.0235, 35.2958],
    [-84.0287, 35.3104],
    [-84.0355, 35.3178],
    [-84.0322, 35.3286],
    [-84.0313, 35.3364],
    [-84.0363, 35.3392],
    [-84.0383, 35.3478],
    [-84.0353, 35.3508],
    [-84.0325, 35.3526],
    [-84.0235, 35.3542],
    [-84.0151, 35.3649],
    [-84.0077, 35.3726],
    [-84.0098, 35.3827],
    [-84.0082, 35.3897],
    [-84.0152, 35.3985],
    [-84.0215, 35.4042],
    [-84.0230, 35.4117],
    [-84.0147, 35.4120],
    [-84.0022, 35.4225],
    [-83.9982, 35.4308],
    [-83.9832, 35.4423],
    [-83.9732, 35.4526],
    [-83.9667, 35.4549],
    [-83.9611, 35.4628],
    [-83.9611, 35.4641],
    [-83.9529, 35.4606],
    [-83.9422, 35.4673],
    [-83.9249, 35.4739],
    [-83.9196, 35.4734],
    [-83.9093, 35.4797],
    [-83.9015, 35.4910],
    [-83.9014, 35.4953],
    [-83.8930, 35.5023],
    [-83.8826, 35.5172],
    [-83.8664, 35.5209],
    [-83.8485, 35.5193],
    [-83.8274, 35.5247],
    [-83.8087, 35.5364],
    [-83.7801, 35.5504],
    [-83.7646, 35.5615],
    [-83.7499, 35.5611],
    [-83.7235, 35.5619],
    [-83.7038, 35.5685],
    [-83.6978, 35.5684],
    [-83.6731, 35.5690],
    [-83.6630, 35.5691],
    [-83.6532, 35.5683],
    [-83.6372, 35.5671],
    [-83.6297, 35.5679],
    [-83.6048, 35.5793],
    [-83.5878, 35.5670],
    [-83.5820, 35.5627],
    [-83.5661, 35.5660],
    [-83.5408, 35.5657],
    [-83.5176, 35.5629],
    [-83.4855, 35.5682],
    [-83.4793, 35.5828],
    [-83.4729, 35.5864],
    [-83.4714, 35.5903],
    [-83.4524, 35.6029],
    [-83.4412, 35.6117],
    [-83.4210, 35.6116],
    [-83.4061, 35.6202],
    [-83.3927, 35.6251],
    [-83.3803, 35.6347],
    [-83.3737, 35.6389],
    [-83.3682, 35.6382],
    [-83.3562, 35.6500],
    [-83.3538, 35.6575],
    [-83.3473, 35.6605],
    [-83.3211, 35.6628],
    [-83.3105, 35.6545],
    [-83.2937, 35.6619],
    [-83.2892, 35.6745],
    [-83.2714, 35.6815],
    [-83.2613, 35.6892],
    [-83.2551, 35.7015],
    [-83.2542, 35.7095],
    [-83.2555, 35.7151],
    [-83.2435, 35.7225],
    [-83.2320, 35.7261],
    [-83.2170, 35.7258],
    [-83.2001, 35.7253],
    [-83.1857, 35.7299],
    [-83.1775, 35.7439],
    [-83.1648, 35.7546],
    [-83.1615, 35.7634],
    [-83.1481, 35.7643],
    [-83.1202, 35.7662],
    [-83.1111, 35.7708],
    [-83.1046, 35.7742],
    [-83.1003, 35.7748],
    [-83.0994, 35.7751],
    [-83.0861, 35.7836],
    [-83.0740, 35.7900],
    [-83.0615, 35.7868],
    [-83.0485, 35.7877],
    [-83.0427, 35.7854],
    [-83.0249, 35.7838],
    [-83.0015, 35.7738],
    [-82.9840, 35.7780],
    [-82.9696, 35.7897],
    [-82.9622, 35.7928],
    [-82.9590, 35.8033],
    [-82.9520, 35.8162],
    [-82.9375, 35.8273],
    [-82.9319, 35.8364],
    [-82.9166, 35.8414],
    [-82.9210, 35.8511],
    [-82.9206, 35.8685],
    [-82.8997, 35.8746],
    [-82.9000, 35.8812],
    [-82.9037, 35.8876],
    [-82.9045, 35.8970],
    [-82.9069, 35.9074],
    [-82.9117, 35.9168],
    [-82.9135, 35.9221],
    [-82.9204, 35.9272],
    [-82.9106, 35.9269],
    [-82.9003, 35.9290],
    [-82.9017, 35.9377],
    [-82.8969, 35.9446],
    [-82.8742, 35.9527],
    [-82.8607, 35.9474],
    [-82.8413, 35.9417],
    [-82.8301, 35.9330],
    [-82.8226, 35.9225],
    [-82.8111, 35.9268],
    [-82.8029, 35.9290],
    [-82.8062, 35.9369],
    [-82.7885, 35.9515],
    [-82.7852, 35.9592],
    [-82.7831, 35.9650],
    [-82.7764, 35.9739],
    [-82.7818, 35.9746],
    [-82.7853, 35.9879],
    [-82.7773, 35.9988],
    [-82.7592, 36.0042],
    [-82.7319, 36.0176],
    [-82.7160, 36.0228],
    [-82.7152, 36.0286],
    [-82.7011, 36.0344],
    [-82.6848, 36.0450],
    [-82.6684, 36.0529],
    [-82.6548, 36.0562],
    [-82.6436, 36.0628],
    [-82.6284, 36.0621],
    [-82.6181, 36.0512],
    [-82.6097, 36.0449],
    [-82.6017, 36.0380],
    [-82.5960, 36.0366],
    [-82.5908, 36.0319],
    [-82.6018, 36.0243],
    [-82.6033, 36.0173],
    [-82.6094, 36.0114],
    [-82.6119, 36.0062],
    [-82.6151, 36.0003],
    [-82.6069, 35.9922],
    [-82.6109, 35.9744],
    [-82.6104, 35.9672],
    [-82.6004, 35.9646],
    [-82.5810, 35.9656],
    [-82.5752, 35.9584],
    [-82.5532, 35.9606],
    [-82.5397, 35.9690],
    [-82.5313, 35.9722],
    [-82.5164, 35.9760],
    [-82.5055, 35.9777],
    [-82.4875, 35.9916],
    [-82.4847, 35.9928],
    [-82.4823, 35.9978],
    [-82.4607, 36.0078],
    [-82.4167, 36.0728],
    [-82.3900, 36.0969],
    [-82.3756, 36.1056],
    [-82.3666, 36.1076],
    [-82.3604, 36.1116],
    [-82.3484, 36.1159],
    [-82.3323, 36.1169],
    [-82.3252, 36.1194],
    [-82.3087, 36.1265],
    [-82.2977, 36.1335],
    [-82.2885, 36.1354],
    [-82.2741, 36.1294],
    [-82.2657, 36.1276],
    [-82.2563, 36.1339],
    [-82.2475, 36.1309],
    [-82.2434, 36.1343],
    [-82.2364, 36.1399],
    [-82.2331, 36.1430],
    [-82.2232, 36.1548],
    [-82.2139, 36.1591],
    [-82.2018, 36.1550],
    [-82.1919, 36.1488],
    [-82.1868, 36.1500],
    [-82.1847, 36.1454],
    [-82.1803, 36.1439],
    [-82.1746, 36.1436],
    [-82.1692, 36.1466],
    [-82.1485, 36.1494],
    [-82.1410, 36.1367],
    [-82.1365, 36.1237],
    [-82.1300, 36.1061],
    [-82.1104, 36.1067],
    [-82.1016, 36.1062],
    [-82.0809, 36.1058],
    [-82.0671, 36.1120],
    [-82.0560, 36.1239],
    [-82.0511, 36.1264],
    [-82.0338, 36.1205],
    [-82.0263, 36.1292],
    [-82.0165, 36.1451],
    [-81.9760, 36.2047],
    [-81.9601, 36.2281],
    [-81.9330, 36.2649],
    [-81.8977, 36.3074],
    [-81.8794, 36.3138],
    [-81.8631, 36.3302],
    [-81.8509, 36.3375],
    [-81.8332, 36.3473],
    [-81.8083, 36.3541],
    [-81.7965, 36.3598],
    [-81.7930, 36.3578],
    [-81.7906, 36.3521],
    [-81.7886, 36.3481],
    [-81.7789, 36.3486],
    [-81.7717, 36.3436],
    [-81.7649, 36.3387],
    [-81.7568, 36.3390],
    [-81.7502, 36.3379],
    [-81.7403, 36.3394],
    [-81.7310, 36.3412],
    [-81.7246, 36.3399],
    [-81.7183, 36.3361],
    [-81.7074, 36.3352],
    [-81.7060, 36.3385],
    [-81.7087, 36.3464],
    [-81.7215, 36.3512],
    [-81.7240, 36.3609],
    [-81.7312, 36.3741],
    [-81.7336, 36.3820],
    [-81.7301, 36.3864],
    [-81.7286, 36.3912],
    [-81.7387, 36.3948],
    [-81.7396, 36.4016],
    [-81.7414, 36.4032],
    [-81.7401, 36.4081],
    [-81.7373, 36.4136],
    [-81.7343, 36.4133],
    [-81.7292, 36.4177],
    [-81.7240, 36.4205],
    [-81.7201, 36.4239],
    [-81.7212, 36.4339],
    [-81.7142, 36.4415],
    [-81.7137, 36.4471],
    [-81.7151, 36.4534],
    [-81.7011, 36.4642],
    [-81.6954, 36.4678],
    [-81.6945, 36.4733],
    [-81.6973, 36.4847],
    [-81.6973, 36.4961],
    [-81.6999, 36.4980],
    [-81.6980, 36.5041],
    [-81.6977, 36.5084],
    [-81.7001, 36.5142],
    [-81.7068, 36.5252],
    [-81.7080, 36.5362],
    [-81.6975, 36.5444],
    [-81.6891, 36.5559],
    [-81.6925, 36.5657],
    [-81.6799, 36.5686],
    [-81.6790, 36.5789],
    [-81.6775, 36.5881],
    [-81.5353, 36.5817],
    [-81.4967, 36.5796],
    [-81.4582, 36.5785],
    [-81.3748, 36.5747],
    [-81.3236, 36.5749],
    [-81.2498, 36.5732],
    [-81.1767, 36.5719],
    [-81.1536, 36.5701],
    [-81.1034, 36.5682],
    [-81.0622, 36.5670],
    [-81.0114, 36.5644],
    [-80.9460, 36.5632],
    [-80.9442, 36.5631],
    [-80.8985, 36.5616],
    [-80.8371, 36.5592],
    [-80.7996, 36.5607],
    [-80.7451, 36.5617],
    [-80.6960, 36.5618],
    [-80.6534, 36.5592],
    [-80.6330, 36.5586],
    [-80.6121, 36.5579],
    [-80.5638, 36.5558],
    [-80.5265, 36.5543],
    [-80.4803, 36.5523],
    [-80.4316, 36.5502],
    [-80.2952, 36.5440],
    [-80.2283, 36.5439],
    [-80.1838, 36.5433],
    [-80.1697, 36.5432],
    [-80.0967, 36.5426],
    [-80.0273, 36.5425],
    [-79.9675, 36.5425],
    [-79.9201, 36.5424],
    [-79.8916, 36.5427],
    [-79.8413, 36.5426],
    [-79.7751, 36.5423],
    [-79.7319, 36.5421],
    [-79.6668, 36.5418],
    [-79.5178, 36.5408],
    [-79.4965, 36.5408],
    [-79.4657, 36.5411],
    [-79.4008, 36.5412],
    [-79.3431, 36.5412],
    [-79.2631, 36.5411],
    [-79.2130, 36.5416],
    [-79.2069, 36.5416],
    [-79.1379, 36.5417],
    [-78.9792, 36.5421],
    [-78.9645, 36.5421],
    [-78.9420, 36.5421],
    [-78.9145, 36.5420],
    [-78.7963, 36.5417],
    [-78.7776, 36.5417],
    [-78.7584, 36.5419],
    [-78.6701, 36.5420],
    [-78.6260, 36.5414],
    [-78.5392, 36.5410],
    [-78.5100, 36.5411],
    [-78.4708, 36.5423],
    [-78.4412, 36.5427],
    [-78.3240, 36.5438],
    [-78.2644, 36.5442],
    [-78.2347, 36.5444],
    [-78.1329, 36.5438],
    [-78.0465, 36.5442],
    [-78.0394, 36.5442],
    [-77.9007, 36.5447],
    [-77.8822, 36.5447],
    [-77.8587, 36.5449],
    [-77.7671, 36.5454],
    [-77.6456, 36.5453],
    [-77.5761, 36.5452],
    [-77.3727, 36.5449],
    [-77.2287, 36.5446],
    [-77.1697, 36.5473],
    [-77.1527, 36.5441],
    [-77.0951, 36.5446],
    [-76.9160, 36.5438],
    [-76.9170, 36.5507],
    [-76.7814, 36.5507],
    [-76.7497, 36.5504],
    [-76.6329, 36.5508],
    [-76.5579, 36.5505],
    [-76.4915, 36.5507],
    [-76.3133, 36.5506],
    [-76.2050, 36.5506],
    [-76.1224, 36.5506],
    [-76.0267, 36.5506],
    [-75.9557, 36.5506],
    [-75.9220, 36.5507],
    [-75.9069, 36.5507],
    [-75.9010, 36.5507],
    [-75.8919, 36.5508],
    [-75.8806, 36.5508],
    [-75.8675, 36.5508],
    [-75.8413, 36.4449],
    [-75.8349, 36.4224],
    [-75.8187, 36.3576],
    [-75.7964, 36.2904],
    [-75.7763, 36.2390],
    [-75.7725, 36.2294],
    [-75.7384, 36.1543],
    [-75.7294, 36.1361],
    [-75.7111, 36.1017],
    [-75.6967, 36.0775],
    [-75.6667, 36.0326],
    [-75.6274, 35.9653],
    [-75.5630, 35.8472],
    [-75.5471, 35.8127],
    [-75.5387, 35.7974],
    [-75.5337, 35.7768],
    [-75.5413, 35.7769],
    [-75.5484, 35.7809],
    [-75.5575, 35.7960],
    [-75.5687, 35.8079],
    [-75.5693, 35.8148],
    [-75.5760, 35.8231],
    [-75.5714, 35.8311],
    [-75.5945, 35.8533],
    [-75.6089, 35.8782],
    [-75.6224, 35.8983],
    [-75.6213, 35.9008],
    [-75.6123, 35.9055],
    [-75.6154, 35.9263],
    [-75.6262, 35.9412],
    [-75.6299, 35.9462],
    [-75.6439, 35.9636],
    [-75.6602, 35.9696],
    [-75.6671, 35.9714],
    [-75.6680, 35.9799],
    [-75.6708, 35.9842],
    [-75.6735, 35.9882],
    [-75.6766, 35.9909],
    [-75.6873, 35.9967],
    [-75.7114, 36.0032],
    [-75.7271, 36.0105],
    [-75.7106, 36.0256],
    [-75.7124, 36.0454],
    [-75.7157, 36.0481],
    [-75.7263, 36.0457],
    [-75.7322, 36.0407],
    [-75.7382, 36.0497],
    [-75.7414, 36.0564],
    [-75.7397, 36.0753],
    [-75.7427, 36.0924],
    [-75.7513, 36.1270],
    [-75.7453, 36.1315],
    [-75.7459, 36.1441],
    [-75.7573, 36.1669],
    [-75.7627, 36.1916],
    [-75.7724, 36.2175],
    [-75.7940, 36.2254],
    [-75.8020, 36.2425],
    [-75.8111, 36.2545],
    [-75.8068, 36.2849],
    [-75.8337, 36.2936],
    [-75.8508, 36.3197],
    [-75.8387, 36.3315],
    [-75.8235, 36.3399],
    [-75.8319, 36.3603],
    [-75.8477, 36.3784],
    [-75.8409, 36.3916],
    [-75.8461, 36.4114],
    [-75.8558, 36.4244],
    [-75.8711, 36.4387],
    [-75.8883, 36.4416],
    [-75.8979, 36.4651],
    [-75.9073, 36.4858],
    [-75.9241, 36.4821],
    [-75.9546, 36.4915],
    [-75.9824, 36.4920],
    [-75.9810, 36.5113],
    [-75.9988, 36.5344],
    [-76.0307, 36.5388],
    [-76.0262, 36.5237],
    [-76.0426, 36.5106],
    [-76.0392, 36.5001],
    [-76.0319, 36.4825],
    [-76.0039, 36.4419],
    [-75.9760, 36.4404],
    [-75.9623, 36.4172],
    [-75.9535, 36.4000],
    [-75.9407, 36.4188],
    [-75.9280, 36.4270],
    [-75.9230, 36.3999],
    [-75.9235, 36.3678],
    [-75.9153, 36.3523],
    [-75.8953, 36.3196],
    [-75.8727, 36.2828],
    [-75.8603, 36.2842],
    [-75.8638, 36.2563],
    [-75.8643, 36.2451],
    [-75.8587, 36.2226],
    [-75.8434, 36.2200],
    [-75.8282, 36.1892],
    [-75.8422, 36.1974],
    [-75.8399, 36.1771],
    [-75.8218, 36.1636],
    [-75.8225, 36.1460],
    [-75.7989, 36.1178],
    [-75.8020, 36.1012],
    [-75.7899, 36.0804],
    [-75.7944, 36.0769],
    [-75.7998, 36.0726],
    [-75.8669, 36.1279],
    [-75.8629, 36.1596],
    [-75.8893, 36.1926],
    [-75.9223, 36.2441],
    [-75.9646, 36.2544],
    [-75.9501, 36.2359],
    [-75.9364, 36.1809],
    [-75.9109, 36.1644],
    [-75.9390, 36.1655],
    [-76.0189, 36.1883],
    [-76.0423, 36.2110],
    [-76.0509, 36.2313],
    [-76.0815, 36.2379],
    [-76.1026, 36.2588],
    [-76.1134, 36.2737],
    [-76.1329, 36.2871],
    [-76.1536, 36.2890],
    [-76.1659, 36.2977],
    [-76.1930, 36.2977],
    [-76.1894, 36.2872],
    [-76.1881, 36.2807],
    [-76.1815, 36.2747],
    [-76.1557, 36.2644],
    [-76.1338, 36.2405],
    [-76.1197, 36.2190],
    [-76.0801, 36.1994],
    [-76.0689, 36.1681],
    [-76.0642, 36.1438],
    [-76.1160, 36.1324],
    [-76.1666, 36.1237],
    [-76.1875, 36.1254],
    [-76.2149, 36.1454],
    [-76.2331, 36.1652],
    [-76.2370, 36.1719],
    [-76.2491, 36.1849],
    [-76.2660, 36.1872],
    [-76.2771, 36.1909],
    [-76.2771, 36.1807],
    [-76.2691, 36.1728],
    [-76.2512, 36.1621],
    [-76.2364, 36.1461],
    [-76.2275, 36.1253],
    [-76.2004, 36.1089],
    [-76.2066, 36.1014],
    [-76.2289, 36.0999],
    [-76.2417, 36.1020],
    [-76.2579, 36.1064],
    [-76.2886, 36.1197],
    [-76.3147, 36.1285],
    [-76.3290, 36.1343],
    [-76.3399, 36.1381],
    [-76.3594, 36.1400],
    [-76.3794, 36.1429],
    [-76.3903, 36.1625],
    [-76.4050, 36.1721],
    [-76.4274, 36.1807],
    [-76.4447, 36.1916],
    [-76.4541, 36.1929],
    [-76.4578, 36.1859],
    [-76.4568, 36.1842],
    [-76.4425, 36.1747],
    [-76.4357, 36.1625],
    [-76.4029, 36.1446],
    [-76.3892, 36.1332],
    [-76.3717, 36.1178],
    [-76.3464, 36.1210],
    [-76.3397, 36.1091],
    [-76.3159, 36.1009],
    [-76.3040, 36.0945],
    [-76.3233, 36.0878],
    [-76.3349, 36.0853],
    [-76.3551, 36.0865],
    [-76.4042, 36.0788],
    [-76.4118, 36.0753],
    [-76.4146, 36.0643],
    [-76.4388, 36.0471],
    [-76.4561, 36.0338],
    [-76.4915, 36.0173],
    [-76.5141, 36.0065],
    [-76.5728, 36.0094],
    [-76.5934, 36.0229],
    [-76.6032, 36.0354],
    [-76.6101, 36.0553],
    [-76.6163, 36.0546],
    [-76.6284, 36.0423],
    [-76.6522, 36.0353],
    [-76.6765, 36.0436],
    [-76.6919, 36.0663],
    [-76.6907, 36.0849],
    [-76.6886, 36.1070],
    [-76.6952, 36.1087],
    [-76.7112, 36.1281],
    [-76.7214, 36.1478],
    [-76.7185, 36.1905],
    [-76.7143, 36.2153],
    [-76.7001, 36.2341],
    [-76.6914, 36.2471],
    [-76.6748, 36.2764],
    [-76.7000, 36.2854],
    [-76.6978, 36.2717],
    [-76.7218, 36.2455],
    [-76.7275, 36.2319],
    [-76.7371, 36.2348],
    [-76.7451, 36.2150],
    [-76.7478, 36.1974],
    [-76.7535, 36.1767],
    [-76.7546, 36.1554],
    [-76.7516, 36.1383],
    [-76.7406, 36.1181],
    [-76.7302, 36.1018],
    [-76.7295, 36.0809],
    [-76.7290, 36.0694],
    [-76.7204, 36.0521],
    [-76.7081, 36.0382],
    [-76.7038, 36.0194],
    [-76.6969, 36.0098],
    [-76.6819, 35.9896],
    [-76.6947, 35.9779],
    [-76.7195, 35.9640],
    [-76.7224, 35.9423],
    [-76.7073, 35.9450],
    [-76.6928, 35.9425],
    [-76.6739, 35.9351],
    [-76.6539, 35.9344],
    [-76.6038, 35.9398],
    [-76.5738, 35.9424],
    [-76.5600, 35.9415],
    [-76.5286, 35.9440],
    [-76.4970, 35.9551],
    [-76.4738, 35.9609],
    [-76.4236, 35.9774],
    [-76.3924, 35.9792],
    [-76.3814, 35.9627],
    [-76.3827, 35.9504],
    [-76.3746, 35.9436],
    [-76.3708, 35.9344],
    [-76.3641, 35.9355],
    [-76.3534, 35.9384],
    [-76.3454, 35.9407],
    [-76.3254, 35.9386],
    [-76.3135, 35.9488],
    [-76.2743, 35.9682],
    [-76.2453, 35.9767],
    [-76.2232, 35.9817],
    [-76.1987, 35.9865],
    [-76.1806, 35.9881],
    [-76.1644, 35.9940],
    [-76.1326, 35.9894],
    [-76.1015, 35.9917],
    [-76.0746, 35.9911],
    [-76.0540, 35.9871],
    [-76.0168, 35.9627],
    [-76.0171, 35.9455],
    [-76.0128, 35.9219],
    [-76.0252, 35.9136],
    [-76.0328, 35.9015],
    [-76.0460, 35.8703],
    [-76.0632, 35.8534],
    [-76.0635, 35.8391],
    [-76.0628, 35.8283],
    [-76.0559, 35.8144],
    [-76.0514, 35.8040],
    [-76.0533, 35.7751],
    [-76.0516, 35.7533],
    [-76.0514, 35.7328],
    [-76.0609, 35.7168],
    [-76.0575, 35.7072],
    [-76.0480, 35.7010],
    [-76.0414, 35.6929],
    [-76.0413, 35.6740],
    [-76.0464, 35.6591],
    [-76.0380, 35.6458],
    [-76.0238, 35.6502],
    [-76.0130, 35.6689],
    [-76.0060, 35.6778],
    [-75.9998, 35.6940],
    [-75.9988, 35.7104],
    [-76.0012, 35.7253],
    [-75.9905, 35.7421],
    [-75.9860, 35.7678],
    [-75.9838, 35.7874],
    [-75.9941, 35.8125],
    [-75.9869, 35.8256],
    [-75.9789, 35.8448],
    [-75.9880, 35.8653],
    [-75.9815, 35.8789],
    [-75.9662, 35.8993],
    [-75.9373, 35.9264],
    [-75.9251, 35.9407],
    [-75.9423, 35.9555],
    [-75.9366, 35.9650],
    [-75.8819, 35.9754],
    [-75.8647, 35.9776],
    [-75.8363, 35.9705],
    [-75.8056, 35.9461],
    [-75.7825, 35.9334],
    [-75.7823, 35.9196],
    [-75.7774, 35.9137],
    [-75.7680, 35.9119],
    [-75.7683, 35.9080],
    [-75.7688, 35.9014],
    [-75.7645, 35.8970],
    [-75.7642, 35.8924],
    [-75.7556, 35.8879],
    [-75.7491, 35.8818],
    [-75.7520, 35.8782],
    [-75.7530, 35.8714],
    [-75.7519, 35.8510],
    [-75.7280, 35.8245],
    [-75.7300, 35.8125],
    [-75.7319, 35.8026],
    [-75.7340, 35.7861],
    [-75.7424, 35.7749],
    [-75.7348, 35.7585],
    [-75.7386, 35.7494],
    [-75.7267, 35.7365],
    [-75.7257, 35.7145],
    [-75.7172, 35.6937],
    [-75.7329, 35.6815],
    [-75.7381, 35.6946],
    [-75.7578, 35.7060],
    [-75.7735, 35.6960],
    [-75.7737, 35.6799],
    [-75.7699, 35.6687],
    [-75.7621, 35.6554],
    [-75.7476, 35.6477],
    [-75.7381, 35.6388],
    [-75.7348, 35.6257],
    [-75.7504, 35.6129],
    [-75.7678, 35.6009],
    [-75.7802, 35.5990],
    [-75.7753, 35.5793],
    [-75.8372, 35.5709],
    [-75.8572, 35.5938],
    [-75.8788, 35.6032],
    [-75.8900, 35.5924],
    [-75.8826, 35.5793],
    [-75.8933, 35.5750],
    [-75.9038, 35.5650],
    [-75.9213, 35.5565],
    [-75.9085, 35.5528],
    [-75.9180, 35.5416],
    [-75.9518, 35.5321],
    [-75.9553, 35.5224],
    [-75.9717, 35.5188],
    [-75.9803, 35.5079],
    [-75.9680, 35.5038],
    [-75.9631, 35.4939],
    [-75.9888, 35.4849],
    [-75.9964, 35.4636],
    [-76.0052, 35.4499],
    [-76.0145, 35.4373],
    [-76.0202, 35.4166],
    [-76.0288, 35.4106],
    [-76.0326, 35.4216],
    [-76.0407, 35.4307],
    [-76.0585, 35.4336],
    [-76.0518, 35.4212],
    [-76.0649, 35.4177],
    [-76.0706, 35.4092],
    [-76.0687, 35.3976],
    [-76.0811, 35.3933],
    [-76.0780, 35.3873],
    [-76.0639, 35.3856],
    [-76.0666, 35.3805],
    [-76.0913, 35.3695],
    [-76.1093, 35.3586],
    [-76.1307, 35.3578],
    [-76.1417, 35.3491],
    [-76.1471, 35.3394],
    [-76.1536, 35.3301],
    [-76.1581, 35.3321],
    [-76.1742, 35.3470],
    [-76.1973, 35.3418],
    [-76.2058, 35.3396],
    [-76.2163, 35.3437],
    [-76.2232, 35.3464],
    [-76.2384, 35.3633],
    [-76.2559, 35.3663],
    [-76.2600, 35.3588],
    [-76.2576, 35.3444],
    [-76.2788, 35.3429],
    [-76.3057, 35.3549],
    [-76.3159, 35.3687],
    [-76.3225, 35.3803],
    [-76.3449, 35.3925],
    [-76.3575, 35.3836],
    [-76.3515, 35.3741],
    [-76.3439, 35.3493],
    [-76.3610, 35.3416],
    [-76.3796, 35.3416],
    [-76.3893, 35.3604],
    [-76.3992, 35.3489],
    [-76.4121, 35.3507],
    [-76.4243, 35.3650],
    [-76.4129, 35.3757],
    [-76.3753, 35.3639],
    [-76.3653, 35.3697],
    [-76.3679, 35.3823],
    [-76.3851, 35.3842],
    [-76.3962, 35.4069],
    [-76.3889, 35.4257],
    [-76.4093, 35.4290],
    [-76.4236, 35.4138],
    [-76.4373, 35.4034],
    [-76.4383, 35.3883],
    [-76.4497, 35.3896],
    [-76.4566, 35.4001],
    [-76.4656, 35.3997],
    [-76.4808, 35.4045],
    [-76.4754, 35.3890],
    [-76.4723, 35.3714],
    [-76.4963, 35.3817],
    [-76.5103, 35.3974],
    [-76.5322, 35.4013],
    [-76.5331, 35.4323],
    [-76.5525, 35.4369],
    [-76.5529, 35.4561],
    [-76.5517, 35.4634],
    [-76.5614, 35.4859],
    [-76.5806, 35.5006],
    [-76.5702, 35.5103],
    [-76.5455, 35.5081],
    [-76.5158, 35.5037],
    [-76.4960, 35.5052],
    [-76.4767, 35.5117],
    [-76.4706, 35.5257],
    [-76.4673, 35.5393],
    [-76.4564, 35.5526],
    [-76.4689, 35.5578],
    [-76.4770, 35.5547],
    [-76.4866, 35.5369],
    [-76.5086, 35.5369],
    [-76.5272, 35.5327],
    [-76.5429, 35.5321],
    [-76.5619, 35.5346],
    [-76.5889, 35.5401],
    [-76.6040, 35.5381],
    [-76.6084, 35.5330],
    [-76.6194, 35.5286],
    [-76.6340, 35.5160],
    [-76.6280, 35.5062],
    [-76.6147, 35.4874],
    [-76.5997, 35.4785],
    [-76.6028, 35.4634],
    [-76.6037, 35.4435],
    [-76.5916, 35.4286],
    [-76.5904, 35.4169],
    [-76.5819, 35.4075],
    [-76.5761, 35.3941],
    [-76.5854, 35.3892],
    [-76.6132, 35.3960],
    [-76.6479, 35.4034],
    [-76.6605, 35.4169],
    [-76.6629, 35.4255],
    [-76.6669, 35.4204],
    [-76.6807, 35.4159],
    [-76.7107, 35.4286],
    [-76.7390, 35.4270],
    [-76.7527, 35.4224],
    [-76.7779, 35.4282],
    [-76.7923, 35.4355],
    [-76.8055, 35.4396],
    [-76.8134, 35.4443],
    [-76.8172, 35.4520],
    [-76.8309, 35.4479],
    [-76.8697, 35.4576],
    [-76.8992, 35.4603],
    [-76.9315, 35.4723],
    [-76.9462, 35.4746],
    [-76.9576, 35.4830],
    [-76.9735, 35.4836],
    [-76.9826, 35.4876],
    [-76.9906, 35.4950],
    [-77.0001, 35.5013],
    [-77.0082, 35.5090],
    [-77.0244, 35.5234],
    [-77.0352, 35.5311],
    [-77.0403, 35.5347],
    [-77.0496, 35.5371],
    [-77.0541, 35.5314],
    [-77.0427, 35.5246],
    [-77.0225, 35.5062],
    [-77.0420, 35.5075],
    [-77.0451, 35.5033],
    [-77.0346, 35.4928],
    [-77.0142, 35.4826],
    [-76.9746, 35.4589],
    [-76.9707, 35.4453],
    [-76.9662, 35.4340],
    [-76.9250, 35.4488],
    [-76.9079, 35.4357],
    [-76.8766, 35.4247],
    [-76.8519, 35.4257],
    [-76.8221, 35.4057],
    [-76.8156, 35.3985],
    [-76.7903, 35.3900],
    [-76.7702, 35.3852],
    [-76.7380, 35.3749],
    [-76.7028, 35.3637],
    [-76.6707, 35.3456],
    [-76.6513, 35.3400],
    [-76.6163, 35.3427],
    [-76.5980, 35.3315],
    [-76.5445, 35.3262],
    [-76.4842, 35.3136],
    [-76.4922, 35.3078],
    [-76.4927, 35.2913],
    [-76.4906, 35.2779],
    [-76.4783, 35.2814],
    [-76.4771, 35.2867],
    [-76.4697, 35.2809],
    [-76.4758, 35.2768],
    [-76.4674, 35.2613],
    [-76.4741, 35.2657],
    [-76.4794, 35.2690],
    [-76.4907, 35.2627],
    [-76.4869, 35.2598],
    [-76.4851, 35.2525],
    [-76.4823, 35.2489],
    [-76.4863, 35.2469],
    [-76.5034, 35.2407],
    [-76.4914, 35.2207],
    [-76.5191, 35.2253],
    [-76.5559, 35.2339],
    [-76.5502, 35.2220],
    [-76.5210, 35.2061],
    [-76.5267, 35.1848],
    [-76.5376, 35.1923],
    [-76.5637, 35.1948],
    [-76.5937, 35.2011],
    [-76.6016, 35.1923],
    [-76.6059, 35.1873],
    [-76.6106, 35.1834],
    [-76.6220, 35.1764],
    [-76.6340, 35.1694],
    [-76.6137, 35.1630],
    [-76.5954, 35.1548],
    [-76.5840, 35.1634],
    [-76.5800, 35.1741],
    [-76.5655, 35.1725],
    [-76.5609, 35.1642],
    [-76.5438, 35.1515],
    [-76.5422, 35.1453],
    [-76.5571, 35.1247],
    [-76.5666, 35.1025],
    [-76.5887, 35.0959],
    [-76.5926, 35.0836],
    [-76.6035, 35.0699],
    [-76.6299, 35.0613],
    [-76.6410, 35.0524],
    [-76.6619, 35.0394],
    [-76.6686, 35.0333],
    [-76.6768, 35.0299],
    [-76.6893, 35.0257],
    [-76.6991, 35.0211],
    [-76.7064, 35.0109],
    [-76.7197, 35.0039],
    [-76.7482, 34.9930],
    [-76.7642, 34.9848],
    [-76.7908, 34.9737],
    [-76.8010, 34.9687],
    [-76.8067, 34.9679],
    [-76.8205, 34.9710],
    [-76.8400, 34.9847],
    [-76.8516, 34.9932],
    [-76.8685, 35.0019],
    [-76.8830, 35.0095],
    [-76.9011, 35.0251],
    [-76.9144, 35.0249],
    [-76.9340, 35.0342],
    [-76.9303, 35.0419],
    [-76.9407, 35.0436],
    [-76.9488, 35.0515],
    [-76.9534, 35.0571],
    [-76.9619, 35.0576],
    [-76.9677, 35.0573],
    [-76.9776, 35.0601],
    [-76.9921, 35.0718],
    [-77.0093, 35.0961],
    [-77.0189, 35.1027],
    [-77.0178, 35.1084],
    [-77.0193, 35.1153],
    [-77.0227, 35.1212],
    [-77.0287, 35.1297],
    [-77.0329, 35.1358],
    [-77.0389, 35.1397],
    [-77.0539, 35.1474],
    [-77.0615, 35.1441],
    [-77.0603, 35.1408],
    [-77.0510, 35.1311],
    [-77.0503, 35.1265],
    [-77.0346, 35.1112],
    [-77.0363, 35.1023],
    [-77.0339, 35.0922],
    [-77.0163, 35.0804],
    [-77.0147, 35.0681],
    [-76.9935, 35.0471],
    [-76.9810, 35.0167],
    [-76.9774, 35.0049],
    [-76.9563, 34.9896],
    [-76.9410, 34.9792],
    [-76.9262, 34.9698],
    [-76.8939, 34.9538],
    [-76.8892, 34.9482],
    [-76.8537, 34.9391],
    [-76.8478, 34.9363],
    [-76.8186, 34.9396],
    [-76.7877, 34.9289],
    [-76.7535, 34.9178],
    [-76.7437, 34.9264],
    [-76.7371, 34.9309],
    [-76.7180, 34.9361],
    [-76.6864, 34.9564],
    [-76.6764, 34.9589],
    [-76.6769, 34.9688],
    [-76.6574, 34.9825],
    [-76.6187, 34.9879],
    [-76.5785, 34.9762],
    [-76.5797, 34.9901],
    [-76.5647, 34.9983],
    [-76.5279, 35.0026],
    [-76.5101, 34.9967],
    [-76.4913, 34.9854],
    [-76.4832, 34.9916],
    [-76.4946, 35.0041],
    [-76.4887, 35.0152],
    [-76.4939, 35.0232],
    [-76.4823, 35.0444],
    [-76.4713, 35.0438],
    [-76.4706, 35.0584],
    [-76.4704, 35.0757],
    [-76.4509, 35.0670],
    [-76.4402, 35.0598],
    [-76.4350, 35.0426],
    [-76.4226, 35.0267],
    [-76.4376, 35.0245],
    [-76.4369, 35.0055],
    [-76.4255, 35.0015],
    [-76.4224, 34.9772],
    [-76.4228, 34.9507],
    [-76.4031, 34.9634],
    [-76.3927, 34.9484],
    [-76.3803, 34.9702],
    [-76.3782, 34.9786],
    [-76.3634, 34.9692],
    [-76.3468, 34.9719],
    [-76.3349, 34.9673],
    [-76.3297, 34.9646],
    [-76.3206, 34.9755],
    [-76.3340, 34.9924],
    [-76.3608, 35.0260],
    [-76.3641, 35.0366],
    [-76.3292, 35.0232],
    [-76.2493, 35.0007],
    [-76.2508, 34.9813],
    [-76.2743, 34.9872],
    [-76.3057, 34.9914],
    [-76.2893, 34.9681],
    [-76.2786, 34.9500],
    [-76.2859, 34.9381],
    [-76.2959, 34.9299],
    [-76.3266, 34.9344],
    [-76.3408, 34.9334],
    [-76.3342, 34.9215],
    [-76.3297, 34.9086],
    [-76.3200, 34.8977],
    [-76.3272, 34.8906],
    [-76.3317, 34.8847],
    [-76.3416, 34.8788],
    [-76.3560, 34.8732],
    [-76.3772, 34.8676],
    [-76.3822, 34.8570],
    [-76.3957, 34.8609],
    [-76.3919, 34.8739],
    [-76.4024, 34.8866],
    [-76.4053, 34.8769],
    [-76.4088, 34.8546],
    [-76.4121, 34.8322],
    [-76.4240, 34.8326],
    [-76.4343, 34.8230],
    [-76.4446, 34.8157],
    [-76.4514, 34.8080],
    [-76.4627, 34.7856],
    [-76.4712, 34.7771],
    [-76.4796, 34.7633],
    [-76.4880, 34.7551],
    [-76.4959, 34.7635],
    [-76.5041, 34.7586],
    [-76.5121, 34.7514],
    [-76.5032, 34.7447],
    [-76.4984, 34.7321],
    [-76.5056, 34.7293],
    [-76.5103, 34.7235],
    [-76.5198, 34.7188],
    [-76.5234, 34.7212],
    [-76.5286, 34.7217],
    [-76.5341, 34.7235],
    [-76.5403, 34.7190],
    [-76.5486, 34.7233],
    [-76.5544, 34.7252],
    [-76.5664, 34.7229],
    [-76.5814, 34.7346],
    [-76.5771, 34.7441],
    [-76.5776, 34.7604],
    [-76.5788, 34.7729],
    [-76.5937, 34.7717],
    [-76.6040, 34.7893],
    [-76.6173, 34.7879],
    [-76.6149, 34.7768],
    [-76.6177, 34.7531],
    [-76.6225, 34.7376],
    [-76.6223, 34.7283],
    [-76.6270, 34.7194],
    [-76.6329, 34.7063],
    [-76.6494, 34.7094],
    [-76.6724, 34.7143],
    [-76.6783, 34.7148],
    [-76.6793, 34.7068],
    [-76.6872, 34.7099],
    [-76.6928, 34.7159],
    [-76.7052, 34.7164],
    [-76.7140, 34.7158],
    [-76.7190, 34.7184],
    [-76.7344, 34.7212],
    [-76.7558, 34.7225],
    [-76.7733, 34.7243],
    [-76.7826, 34.7253],
    [-76.8008, 34.7251],
    [-76.8070, 34.7251],
    [-76.8189, 34.7263],
    [-76.8419, 34.7294],
    [-76.8519, 34.7274],
    [-76.8692, 34.7271],
    [-76.8816, 34.7271],
    [-76.8956, 34.7254],
    [-76.9027, 34.7265],
    [-76.9073, 34.7226],
    [-76.9153, 34.7204],
    [-76.9229, 34.7192],
    [-76.9324, 34.7162],
    [-76.9392, 34.7162],
    [-76.9508, 34.7113],
    [-76.9619, 34.7073],
    [-76.9717, 34.7092],
    [-76.9752, 34.7052],
    [-76.9863, 34.7011],
    [-76.9990, 34.6951],
    [-77.0052, 34.6925],
    [-77.0088, 34.6967],
    [-77.0121, 34.6962],
    [-77.0172, 34.6946],
    [-77.0161, 34.6899],
    [-77.0199, 34.6884],
    [-77.0256, 34.6883],
    [-77.0283, 34.6849],
    [-77.0305, 34.6818],
    [-77.0381, 34.6860],
    [-77.0422, 34.6897],
    [-77.0454, 34.6851],
    [-77.0495, 34.6847],
    [-77.0524, 34.6870],
    [-77.0562, 34.6873],
    [-77.0540, 34.6817],
    [-77.0592, 34.6803],
    [-77.0669, 34.6793],
    [-77.0736, 34.6782],
    [-77.0780, 34.6763],
    [-77.0832, 34.6744],
    [-77.0907, 34.6730],
    [-77.1003, 34.6744],
    [-77.1130, 34.6814],
    [-77.1171, 34.6870],
    [-77.1259, 34.6852],
    [-77.1303, 34.6826],
    [-77.1350, 34.6800],
    [-77.1351, 34.6749],
    [-77.1414, 34.6698],
    [-77.1546, 34.6679],
    [-77.1518, 34.6644],
    [-77.1551, 34.6599],
    [-77.1698, 34.6502],
    [-77.1884, 34.6404],
    [-77.2028, 34.6341],
    [-77.2047, 34.6343],
    [-77.2047, 34.6334],
    [-77.2116, 34.6235],
    [-77.2428, 34.5980],
    [-77.2372, 34.5937],
    [-77.2329, 34.5920],
    [-77.2480, 34.5838],
    [-77.2586, 34.5776],
    [-77.2665, 34.5721],
    [-77.3090, 34.5433],
    [-77.3380, 34.5295],
    [-77.4112, 34.4964],
    [-77.4946, 34.4544],
    [-77.5606, 34.4148],
    [-77.5823, 34.4005],
    [-77.6350, 34.3596],
    [-77.6539, 34.3451],
    [-77.6672, 34.3382],
    [-77.7133, 34.2949],
    [-77.7510, 34.2603],
    [-77.7646, 34.2450],
    [-77.7714, 34.2376],
    [-77.7897, 34.2145],
    [-77.8126, 34.1845],
    [-77.8418, 34.1407],
    [-77.8718, 34.0835],
    [-77.8782, 34.0680],
    [-77.8862, 34.0472],
    [-77.8946, 34.0255],
    [-77.9149, 33.9734],
    [-77.9201, 33.9667],
    [-77.9372, 33.9292],
    [-77.9483, 33.9081],
    [-77.9568, 33.8782],
    [-77.9597, 33.8565],
    [-77.9605, 33.8432],
    [-77.9714, 33.8473],
    [-78.0096, 33.8653],
    [-78.0059, 33.8704],
    [-78.0043, 33.8823],
    [-78.0254, 33.8892],
    [-78.0429, 33.8936],
    [-78.0601, 33.8980],
    [-78.0766, 33.9026],
    [-78.0945, 33.9059],
    [-78.1044, 33.9080],
    [-78.1260, 33.9110],
    [-78.1777, 33.9143],
    [-78.2244, 33.9128],
    [-78.2352, 33.9144],
    [-78.2395, 33.9158],
    [-78.2761, 33.9124],
    [-78.3153, 33.9097],
    [-78.3503, 33.9057],
    [-78.3645, 33.9027],
    [-78.3808, 33.9032],
    [-78.3871, 33.9020],
    [-78.4225, 33.8910],
    [-78.4821, 33.8740],
    [-78.5094, 33.8662],
    [-78.5412, 33.8523],
    [-78.5472, 33.8564],
    [-78.5741, 33.8795],
    [-78.5870, 33.8906],
    [-78.6158, 33.9155],
    [-78.6296, 33.9269],
    [-78.6503, 33.9443],
    [-78.6625, 33.9545],
    [-78.7122, 33.9967],
    [-78.7943, 34.0662],
    [-78.8274, 34.0943],
    [-78.8729, 34.1328],
    [-78.8762, 34.1356],
    [-78.9099, 34.1639],
    [-78.9637, 34.2090],
    [-78.9958, 34.2360],
    [-79.0712, 34.2993],
    [-79.1430, 34.3596],
    [-79.1907, 34.3998],
    [-79.1990, 34.4067],
    [-79.2160, 34.4211],
    [-79.2498, 34.4498],
    [-79.3067, 34.5004],
    [-79.3232, 34.5146],
    [-79.3366, 34.5265],
    [-79.3658, 34.5515],
    [-79.4500, 34.6210],
    [-79.4616, 34.6303],
    [-79.4793, 34.6446],
    [-79.5049, 34.6658],
    [-79.5325, 34.6884],
    [-79.5617, 34.7120],
    [-79.6213, 34.7605],
    [-79.6441, 34.7791],
    [-79.6902, 34.8049],
    [-79.7441, 34.8057],
    [-79.7728, 34.8060],
    [-79.8707, 34.8054],
    [-79.9274, 34.8066],
    [-79.9307, 34.8066],
    [-79.9940, 34.8080],
    [-80.0275, 34.8087],
    [-80.0432, 34.8091],
    [-80.0980, 34.8101],
    [-80.1312, 34.8108],
    [-80.1892, 34.8120],
    [-80.2836, 34.8136],
    [-80.3208, 34.8141],
    [-80.4170, 34.8155],
    [-80.4184, 34.8156],
    [-80.4348, 34.8160],
    [-80.4517, 34.8164],
    [-80.4998, 34.8173],
    [-80.5617, 34.8175],
    [-80.6260, 34.8182],
    [-80.6447, 34.8186],
    [-80.6710, 34.8188],
    [-80.7269, 34.8193],
    [-80.7777, 34.8197],
    [-80.7963, 34.8289],
    [-80.7841, 34.9204],
    [-80.7820, 34.9358],
    [-80.7977, 34.9532],
    [-80.8068, 34.9632],
    [-80.8169, 34.9745],
    [-80.8216, 34.9797],
    [-80.8513, 35.0144],
    [-80.8644, 35.0296],
    [-80.8849, 35.0535],
    [-80.9062, 35.0764],
    [-80.9201, 35.0914],
    [-80.9471, 35.0996],
    [-80.9784, 35.0809],
    [-80.9892, 35.0747],
    [-81.0190, 35.0576],
    [-81.0500, 35.0552],
    [-81.0576, 35.0624],
    [-81.0572, 35.0861],
    [-81.0501, 35.0988],
    [-81.0402, 35.1020],
    [-81.0328, 35.1080],
    [-81.0368, 35.1226],
    [-81.0510, 35.1317],
    [-81.0471, 35.1452],
    [-81.0429, 35.1492],
    [-81.0562, 35.1507],
    [-81.0928, 35.1530],
    [-81.1108, 35.1542],
    [-81.1806, 35.1573],
    [-81.2149, 35.1589],
    [-81.2652, 35.1610],
    [-81.2675, 35.1611],
    [-81.3280, 35.1634],
    [-81.4385, 35.1677],
    [-81.4456, 35.1680],
    [-81.4614, 35.1687],
    [-81.4934, 35.1700],
    [-81.5382, 35.1715],
    [-81.5817, 35.1731],
    [-81.6149, 35.1745],
    [-81.6808, 35.1773],
    [-81.7634, 35.1802],
    [-81.7752, 35.1806],
    [-81.8578, 35.1835],
    [-81.9187, 35.1853],
    [-82.0014, 35.1885],
    [-82.0397, 35.1894],
    [-82.0896, 35.1907],
    [-82.1677, 35.1937],
    [-82.1769, 35.1938],
    [-82.1997, 35.1952],
    [-82.2212, 35.1963],
    [-82.2309, 35.1968],
    [-82.2575, 35.1986],
    [-82.2809, 35.1999],
    [-82.2927, 35.1964],
    [-82.3135, 35.1914],
    [-82.3179, 35.1879],
    [-82.3305, 35.1868],
    [-82.3339, 35.1907],
    [-82.3401, 35.1892],
    [-82.3501, 35.1929],
    [-82.3633, 35.1896],
    [-82.3643, 35.1847],
    [-82.3732, 35.1822],
    [-82.3822, 35.1896],
    [-82.3792, 35.1959],
    [-82.3838, 35.2076],
    [-82.3929, 35.2154],
    [-82.4113, 35.2025],
    [-82.4245, 35.1931],
    [-82.4260, 35.1810],
    [-82.4307, 35.1783],
    [-82.4319, 35.1727],
    [-82.4347, 35.1683],
    [-82.4396, 35.1659],
    [-82.4505, 35.1661],
    [-82.4548, 35.1701],
    [-82.4523, 35.1738],
    [-82.4556, 35.1774],
    [-82.4723, 35.1746],
    [-82.4874, 35.1725],
    [-82.4985, 35.1630],
    [-82.5061, 35.1639],
    [-82.5131, 35.1631],
    [-82.5173, 35.1626],
    [-82.5199, 35.1591],
    [-82.5300, 35.1556],
    [-82.5365, 35.1548],
    [-82.5362, 35.1593],
    [-82.5416, 35.1621],
    [-82.5474, 35.1624],
    [-82.5558, 35.1593],
    [-82.5533, 35.1535],
    [-82.5608, 35.1516],
    [-82.5675, 35.1477],
    [-82.5783, 35.1421],
    [-82.5860, 35.1431],
    [-82.5981, 35.1377],
    [-82.6124, 35.1382],
    [-82.6180, 35.1353],
    [-82.6264, 35.1279],
    [-82.6362, 35.1255],
    [-82.6365, 35.1304],
    [-82.6410, 35.1323],
    [-82.6487, 35.1268],
    [-82.6535, 35.1220],
    [-82.6680, 35.1188],
    [-82.6733, 35.1175],
    [-82.6733, 35.1234],
    [-82.6789, 35.1273],
    [-82.6871, 35.1251],
    [-82.6876, 35.1193],
    [-82.6946, 35.1147],
    [-82.6873, 35.1107],
    [-82.6885, 35.1063],
    [-82.6949, 35.0985],
    [-82.6992, 35.0970],
    [-82.7054, 35.0980],
    [-82.7204, 35.0933],
    [-82.7290, 35.0920],
    [-82.7322, 35.0868],
    [-82.7384, 35.0795],
    [-82.7518, 35.0799],
    [-82.7542, 35.0696],
    [-82.7700, 35.0655],
    [-82.7820, 35.0668],
    [-82.7799, 35.0722],
    [-82.7774, 35.0769],
    [-82.7811, 35.0845],
    [-82.7879, 35.0850],
    [-82.9999, 35.0299],
    [-83.0233, 35.0236],
    [-83.1086, 35.0007],
    [-83.2969, 34.9966],
    [-83.3371, 34.9957],
    [-83.3550, 34.9954],
    [-83.3814, 34.9950],
    [-83.4830, 34.9935],
    [-83.5576, 34.9924],
    [-83.6200, 34.9866],
    [-83.7909, 34.9875],
    [-83.8311, 34.9873],
    [-83.9224, 34.9875],
    [-83.9633, 34.9875],
    [-84.0300, 34.9873],
    [-84.1295, 34.9875],
    [-84.1812, 34.9877],
    [-84.3219, 34.9884],
    [-84.3175, 35.0218]
    ]
  },
  "Oklahoma": {
    coordinates: [
      [-103.0026, 36.5266],
    [-103.0025, 36.6752],
    [-103.0020, 36.9096],
    [-102.9870, 36.9985],
    [-102.8867, 36.9995],
    [-102.8325, 36.9997],
    [-102.6981, 36.9951],
    [-102.3533, 36.9945],
    [-102.2608, 36.9944],
    [-102.1843, 36.9936],
    [-102.0421, 36.9930],
    [-102.0004, 36.9932],
    [-101.9024, 36.9937],
    [-101.8627, 36.9939],
    [-101.7037, 36.9946],
    [-101.6004, 36.9952],
    [-101.5552, 36.9954],
    [-101.4150, 36.9960],
    [-101.3782, 36.9962],
    [-101.3578, 36.9963],
    [-101.2129, 36.9970],
    [-101.0667, 36.9979],
    [-101.0177, 36.9982],
    [-100.9582, 36.9981],
    [-100.9046, 36.9986],
    [-100.8917, 36.9986],
    [-100.8500, 36.9987],
    [-100.7655, 36.9992],
    [-100.7345, 36.9991],
    [-100.6753, 36.9997],
    [-100.5914, 37.0004],
    [-100.5522, 37.0007],
    [-100.2700, 37.0018],
    [-100.1938, 37.0021],
    [-100.1245, 37.0022],
    [-100.0057, 37.0017],
    [-99.9952, 37.0016],
    [-99.8286, 37.0013],
    [-99.7743, 37.0008],
    [-99.6577, 37.0002],
    [-99.5581, 36.9995],
    [-99.5041, 36.9996],
    [-99.5004, 36.9996],
    [-99.4070, 36.9996],
    [-99.2775, 36.9996],
    [-99.1294, 36.9994],
    [-99.0293, 36.9996],
    [-98.9944, 36.9995],
    [-98.8800, 36.9993],
    [-98.7975, 36.9992],
    [-98.7616, 36.9994],
    [-98.6223, 36.9990],
    [-98.4764, 36.9987],
    [-98.4090, 36.9985],
    [-98.3462, 36.9980],
    [-98.2195, 36.9978],
    [-98.1777, 36.9980],
    [-98.1463, 36.9982],
    [-98.0453, 36.9983],
    [-98.0340, 36.9984],
    [-97.8765, 36.9986],
    [-97.7835, 36.9988],
    [-97.6971, 36.9988],
    [-97.6371, 36.9991],
    [-97.6065, 36.9987],
    [-97.5465, 36.9987],
    [-97.4729, 36.9987],
    [-97.4145, 36.9988],
    [-97.3724, 36.9989],
    [-97.3427, 36.9989],
    [-97.2199, 36.9990],
    [-97.1477, 36.9991],
    [-97.1114, 36.9990],
    [-97.0455, 36.9990],
    [-96.9756, 36.9990],
    [-96.9253, 36.9991],
    [-96.9037, 36.9991],
    [-96.8763, 36.9992],
    [-96.8229, 36.9992],
    [-96.7921, 36.9992],
    [-96.7366, 36.9993],
    [-96.7105, 36.9993],
    [-96.6074, 36.9989],
    [-96.4158, 36.9991],
    [-96.3816, 36.9992],
    [-96.2849, 36.9993],
    [-96.2353, 36.9991],
    [-96.1848, 36.9992],
    [-96.1524, 36.9991],
    [-96.1432, 36.9991],
    [-96.0358, 36.9989],
    [-95.9370, 36.9993],
    [-95.8772, 36.9993],
    [-95.8739, 36.9993],
    [-95.8080, 36.9991],
    [-95.7600, 36.9993],
    [-95.7465, 36.9993],
    [-95.7149, 36.9993],
    [-95.6967, 36.9992],
    [-95.6643, 36.9993],
    [-95.6380, 36.9993],
    [-95.6243, 36.9994],
    [-95.6157, 36.9994],
    [-95.5890, 36.9993],
    [-95.5224, 36.9993],
    [-95.4076, 36.9992],
    [-95.3283, 36.9994],
    [-95.2861, 36.9994],
    [-95.1773, 36.9995],
    [-95.1552, 36.9995],
    [-95.0735, 36.9995],
    [-95.0350, 36.9995],
    [-95.0076, 36.9995],
    [-94.9044, 36.9991],
    [-94.8498, 36.9989],
    [-94.8315, 36.9988],
    [-94.7773, 36.9988],
    [-94.7450, 36.9987],
    [-94.7361, 36.9987],
    [-94.7128, 36.9988],
    [-94.6997, 36.9988],
    [-94.6180, 36.9962],
    [-94.6180, 36.9947],
    [-94.6182, 36.9376],
    [-94.6182, 36.9261],
    [-94.6182, 36.8971],
    [-94.6187, 36.8801],
    [-94.6186, 36.8689],
    [-94.6184, 36.8473],
    [-94.6184, 36.8246],
    [-94.6183, 36.7713],
    [-94.6182, 36.7331],
    [-94.6181, 36.7014],
    [-94.6180, 36.6679],
    [-94.6179, 36.6247],
    [-94.6179, 36.6068],
    [-94.6178, 36.5836],
    [-94.6179, 36.5475],
    [-94.6179, 36.5361],
    [-94.6179, 36.5178],
    [-94.6179, 36.5075],
    [-94.6177, 36.4985],
    [-94.6127, 36.4686],
    [-94.6040, 36.4136],
    [-94.6020, 36.4021],
    [-94.5997, 36.3876],
    [-94.5917, 36.3349],
    [-94.5859, 36.2984],
    [-94.5811, 36.2693],
    [-94.5760, 36.2401],
    [-94.5744, 36.2300],
    [-94.5713, 36.2109],
    [-94.5672, 36.1871],
    [-94.5657, 36.1784],
    [-94.5628, 36.1619],
    [-94.5597, 36.1440],
    [-94.5522, 36.1022],
    [-94.5477, 36.0773],
    [-94.5357, 36.0078],
    [-94.5337, 35.9969],
    [-94.5321, 35.9878],
    [-94.5283, 35.9661],
    [-94.5243, 35.9440],
    [-94.5227, 35.9348],
    [-94.5183, 35.9063],
    [-94.5174, 35.9008],
    [-94.5056, 35.8336],
    [-94.5012, 35.8064],
    [-94.5005, 35.8026],
    [-94.4989, 35.7925],
    [-94.4929, 35.7592],
    [-94.4876, 35.7261],
    [-94.4828, 35.6980],
    [-94.4711, 35.6292],
    [-94.4645, 35.5889],
    [-94.4633, 35.5827],
    [-94.4568, 35.5418],
    [-94.4522, 35.5126],
    [-94.4496, 35.4963],
    [-94.4412, 35.4502],
    [-94.4356, 35.4195],
    [-94.4313, 35.3917],
    [-94.4356, 35.3861],
    [-94.4316, 35.3695],
    [-94.4322, 35.3636],
    [-94.4328, 35.3465],
    [-94.4337, 35.3200],
    [-94.4339, 35.3140],
    [-94.4351, 35.2921],
    [-94.4353, 35.2803],
    [-94.4353, 35.2759],
    [-94.4358, 35.2718],
    [-94.4366, 35.2501],
    [-94.4378, 35.2393],
    [-94.4378, 35.2233],
    [-94.4382, 35.2110],
    [-94.4391, 35.1973],
    [-94.4389, 35.1856],
    [-94.4397, 35.1634],
    [-94.4415, 35.1112],
    [-94.4433, 35.0625],
    [-94.4456, 34.9979],
    [-94.4479, 34.9339],
    [-94.4491, 34.8906],
    [-94.4496, 34.8753],
    [-94.4502, 34.8554],
    [-94.4511, 34.8307],
    [-94.4546, 34.7290],
    [-94.4558, 34.6935],
    [-94.4563, 34.6798],
    [-94.4575, 34.6349],
    [-94.4587, 34.5940],
    [-94.4604, 34.5347],
    [-94.4624, 34.4629],
    [-94.4633, 34.4327],
    [-94.4638, 34.4145],
    [-94.4654, 34.3595],
    [-94.4664, 34.3307],
    [-94.4711, 34.1592],
    [-94.4749, 34.0219],
    [-94.4749, 34.0197],
    [-94.4770, 33.9538],
    [-94.4774, 33.9378],
    [-94.4798, 33.8567],
    [-94.4808, 33.8231],
    [-94.4815, 33.7960],
    [-94.4818, 33.7890],
    [-94.4828, 33.7536],
    [-94.4829, 33.7506],
    [-94.4836, 33.7268],
    [-94.4838, 33.7113],
    [-94.4855, 33.6634],
    [-94.4911, 33.6362],
    [-94.4915, 33.6251],
    [-94.5115, 33.6231],
    [-94.5191, 33.6303],
    [-94.5274, 33.6158],
    [-94.5356, 33.6241],
    [-94.5202, 33.6360],
    [-94.5260, 33.6410],
    [-94.5442, 33.6341],
    [-94.5578, 33.6264],
    [-94.5704, 33.6310],
    [-94.5659, 33.6390],
    [-94.5454, 33.6462],
    [-94.5438, 33.6571],
    [-94.5521, 33.6603],
    [-94.5773, 33.6466],
    [-94.5881, 33.6438],
    [-94.5867, 33.6511],
    [-94.5625, 33.6633],
    [-94.5622, 33.6690],
    [-94.5739, 33.6670],
    [-94.5814, 33.6660],
    [-94.5803, 33.6754],
    [-94.5849, 33.6842],
    [-94.5931, 33.6832],
    [-94.5904, 33.6729],
    [-94.5980, 33.6634],
    [-94.6117, 33.6702],
    [-94.6168, 33.6796],
    [-94.6306, 33.6734],
    [-94.6423, 33.6628],
    [-94.6659, 33.6623],
    [-94.6688, 33.6719],
    [-94.6543, 33.6720],
    [-94.6453, 33.6744],
    [-94.6469, 33.6848],
    [-94.6387, 33.6929],
    [-94.6443, 33.7017],
    [-94.6478, 33.6929],
    [-94.6545, 33.6883],
    [-94.6718, 33.6933],
    [-94.7054, 33.6880],
    [-94.7123, 33.6965],
    [-94.7011, 33.7001],
    [-94.7114, 33.7089],
    [-94.7334, 33.7130],
    [-94.7270, 33.7052],
    [-94.7162, 33.6979],
    [-94.7359, 33.6916],
    [-94.7461, 33.7026],
    [-94.7535, 33.7087],
    [-94.7405, 33.7128],
    [-94.7324, 33.7232],
    [-94.7428, 33.7268],
    [-94.7455, 33.7172],
    [-94.7559, 33.7151],
    [-94.7503, 33.7236],
    [-94.7494, 33.7330],
    [-94.7556, 33.7323],
    [-94.7669, 33.7266],
    [-94.7859, 33.7315],
    [-94.7779, 33.7444],
    [-94.7618, 33.7465],
    [-94.7601, 33.7583],
    [-94.7746, 33.7580],
    [-94.7782, 33.7497],
    [-94.7958, 33.7376],
    [-94.8105, 33.7350],
    [-94.8119, 33.7468],
    [-94.8167, 33.7553],
    [-94.8218, 33.7688],
    [-94.8308, 33.7581],
    [-94.8221, 33.7331],
    [-94.8287, 33.7387],
    [-94.8493, 33.7396],
    [-94.8771, 33.7522],
    [-94.8667, 33.7618],
    [-94.8714, 33.7712],
    [-94.8746, 33.7629],
    [-94.8778, 33.7589],
    [-94.8869, 33.7691],
    [-94.9042, 33.7772],
    [-94.9145, 33.7822],
    [-94.9220, 33.7916],
    [-94.9170, 33.8083],
    [-94.9109, 33.8159],
    [-94.9186, 33.8268],
    [-94.9268, 33.8266],
    [-94.9231, 33.8155],
    [-94.9292, 33.8078],
    [-94.9535, 33.8165],
    [-94.9577, 33.8350],
    [-94.9685, 33.8592],
    [-94.9734, 33.8617],
    [-94.9833, 33.8514],
    [-94.9955, 33.8574],
    [-95.0020, 33.8630],
    [-95.0124, 33.8580],
    [-95.0314, 33.8598],
    [-95.0494, 33.8648],
    [-95.0582, 33.8875],
    [-95.0656, 33.9036],
    [-95.0722, 33.9056],
    [-95.0643, 33.9101],
    [-95.0657, 33.9160],
    [-95.0749, 33.9105],
    [-95.0788, 33.9030],
    [-95.0806, 33.8823],
    [-95.0938, 33.8852],
    [-95.0989, 33.8909],
    [-95.0916, 33.9021],
    [-95.0785, 33.9103],
    [-95.0824, 33.9218],
    [-95.0891, 33.9142],
    [-95.1126, 33.9046],
    [-95.1264, 33.9071],
    [-95.1273, 33.9203],
    [-95.1212, 33.9313],
    [-95.1360, 33.9354],
    [-95.1550, 33.9367],
    [-95.1634, 33.9409],
    [-95.1748, 33.9475],
    [-95.1850, 33.9495],
    [-95.1993, 33.9540],
    [-95.2119, 33.9612],
    [-95.2205, 33.9620],
    [-95.2264, 33.9620],
    [-95.2306, 33.9598],
    [-95.2329, 33.9497],
    [-95.2458, 33.9437],
    [-95.2497, 33.9028],
    [-95.2640, 33.8898],
    [-95.2661, 33.9098],
    [-95.2830, 33.9074],
    [-95.2804, 33.8968],
    [-95.2788, 33.8779],
    [-95.3058, 33.8748],
    [-95.3144, 33.8816],
    [-95.3299, 33.8855],
    [-95.3349, 33.8768],
    [-95.3625, 33.8666],
    [-95.3752, 33.8682],
    [-95.4021, 33.8642],
    [-95.4535, 33.8703],
    [-95.4642, 33.8734],
    [-95.4595, 33.8841],
    [-95.4638, 33.8872],
    [-95.4693, 33.8825],
    [-95.4845, 33.8759],
    [-95.5023, 33.8747],
    [-95.5056, 33.8772],
    [-95.5052, 33.8950],
    [-95.5127, 33.8964],
    [-95.5213, 33.8884],
    [-95.5398, 33.8799],
    [-95.5503, 33.8883],
    [-95.5480, 33.9012],
    [-95.5525, 33.9199],
    [-95.5545, 33.9281],
    [-95.5638, 33.9330],
    [-95.5780, 33.9332],
    [-95.5864, 33.9394],
    [-95.5967, 33.9421],
    [-95.5987, 33.9341],
    [-95.6082, 33.9287],
    [-95.6193, 33.9227],
    [-95.6259, 33.9103],
    [-95.6322, 33.9050],
    [-95.6453, 33.9065],
    [-95.6564, 33.9101],
    [-95.6700, 33.9058],
    [-95.6979, 33.8861],
    [-95.7183, 33.8897],
    [-95.7330, 33.8959],
    [-95.7564, 33.8926],
    [-95.7614, 33.8732],
    [-95.7516, 33.8611],
    [-95.7537, 33.8532],
    [-95.7706, 33.8453],
    [-95.7824, 33.8511],
    [-95.8008, 33.8612],
    [-95.8217, 33.8566],
    [-95.8195, 33.8484],
    [-95.8208, 33.8406],
    [-95.8319, 33.8352],
    [-95.8452, 33.8391],
    [-95.8555, 33.8493],
    [-95.8669, 33.8515],
    [-95.8835, 33.8627],
    [-95.9058, 33.8741],
    [-95.9258, 33.8850],
    [-95.9324, 33.8832],
    [-95.9366, 33.8706],
    [-95.9527, 33.8584],
    [-95.9843, 33.8527],
    [-95.9837, 33.8617],
    [-95.9986, 33.8722],
    [-96.0044, 33.8697],
    [-95.9981, 33.8617],
    [-95.9959, 33.8557],
    [-96.0016, 33.8477],
    [-96.0214, 33.8410],
    [-96.0195, 33.8535],
    [-96.0269, 33.8568],
    [-96.0314, 33.8472],
    [-96.0554, 33.8383],
    [-96.0846, 33.8467],
    [-96.1002, 33.8479],
    [-96.1008, 33.8442],
    [-96.0974, 33.8327],
    [-96.1100, 33.8324],
    [-96.1389, 33.8392],
    [-96.1516, 33.8319],
    [-96.1567, 33.8182],
    [-96.1790, 33.8106],
    [-96.1704, 33.7994],
    [-96.1688, 33.8077],
    [-96.1564, 33.8133],
    [-96.1612, 33.7957],
    [-96.1746, 33.7637],
    [-96.1891, 33.7556],
    [-96.1999, 33.7521],
    [-96.2482, 33.7590],
    [-96.2636, 33.7675],
    [-96.2778, 33.7705],
    [-96.2965, 33.7658],
    [-96.3061, 33.7410],
    [-96.3070, 33.7206],
    [-96.3100, 33.7105],
    [-96.3211, 33.6951],
    [-96.3380, 33.6887],
    [-96.3559, 33.6872],
    [-96.3633, 33.7010],
    [-96.3794, 33.7258],
    [-96.4085, 33.7512],
    [-96.4161, 33.7661],
    [-96.4200, 33.7730],
    [-96.4367, 33.7793],
    [-96.4487, 33.7809],
    [-96.4571, 33.7758],
    [-96.4731, 33.7754],
    [-96.5023, 33.7735],
    [-96.5159, 33.7884],
    [-96.5166, 33.8032],
    [-96.5267, 33.8209],
    [-96.5322, 33.8229],
    [-96.5466, 33.8201],
    [-96.5729, 33.8191],
    [-96.6013, 33.8343],
    [-96.6300, 33.8475],
    [-96.6254, 33.8565],
    [-96.6017, 33.8728],
    [-96.5875, 33.8843],
    [-96.5855, 33.8913],
    [-96.5929, 33.8956],
    [-96.6283, 33.8945],
    [-96.6460, 33.9072],
    [-96.6672, 33.9169],
    [-96.6753, 33.9091],
    [-96.6835, 33.8842],
    [-96.6847, 33.8629],
    [-96.6919, 33.8485],
    [-96.7022, 33.8369],
    [-96.7124, 33.8316],
    [-96.7616, 33.8244],
    [-96.7694, 33.8275],
    [-96.7768, 33.8420],
    [-96.7806, 33.8601],
    [-96.7943, 33.8689],
    [-96.8322, 33.8748],
    [-96.8398, 33.8684],
    [-96.8459, 33.8490],
    [-96.8664, 33.8531],
    [-96.8927, 33.8896],
    [-96.8965, 33.9133],
    [-96.9053, 33.9472],
    [-96.9113, 33.9540],
    [-96.9221, 33.9596],
    [-96.9348, 33.9544],
    [-96.9725, 33.9358],
    [-96.9798, 33.9416],
    [-96.9793, 33.9551],
    [-96.9879, 33.9547],
    [-96.9954, 33.9473],
    [-96.9940, 33.9290],
    [-96.9840, 33.8921],
    [-97.0179, 33.8501],
    [-97.0389, 33.8383],
    [-97.0510, 33.8466],
    [-97.0681, 33.8605],
    [-97.0872, 33.8534],
    [-97.0877, 33.8420],
    [-97.0583, 33.8368],
    [-97.0481, 33.8175],
    [-97.0626, 33.8161],
    [-97.0880, 33.8087],
    [-97.0952, 33.7941],
    [-97.0852, 33.7655],
    [-97.0860, 33.7454],
    [-97.0941, 33.7310],
    [-97.1045, 33.7226],
    [-97.1211, 33.7172],
    [-97.1494, 33.7220],
    [-97.1631, 33.7293],
    [-97.1853, 33.7555],
    [-97.1908, 33.7818],
    [-97.2049, 33.8152],
    [-97.1937, 33.8313],
    [-97.1716, 33.8353],
    [-97.1725, 33.8678],
    [-97.1855, 33.9007],
    [-97.2010, 33.9109],
    [-97.2246, 33.9148],
    [-97.2440, 33.9042],
    [-97.2492, 33.8751],
    [-97.2651, 33.8624],
    [-97.2753, 33.8632],
    [-97.2942, 33.8764],
    [-97.3098, 33.8830],
    [-97.3150, 33.8667],
    [-97.3287, 33.8554],
    [-97.3334, 33.8641],
    [-97.3325, 33.8843],
    [-97.3483, 33.8439],
    [-97.3729, 33.8195],
    [-97.4265, 33.8194],
    [-97.4591, 33.8346],
    [-97.4576, 33.8551],
    [-97.4536, 33.8952],
    [-97.4840, 33.9158],
    [-97.5010, 33.9196],
    [-97.5192, 33.9136],
    [-97.5432, 33.9013],
    [-97.5583, 33.8971],
    [-97.5609, 33.8996],
    [-97.5687, 33.9014],
    [-97.5781, 33.8992],
    [-97.5828, 33.9004],
    [-97.5874, 33.9025],
    [-97.5897, 33.9066],
    [-97.5937, 33.9101],
    [-97.5970, 33.9202],
    [-97.5915, 33.9282],
    [-97.5954, 33.9389],
    [-97.5917, 33.9466],
    [-97.5904, 33.9541],
    [-97.6009, 33.9589],
    [-97.6044, 33.9638],
    [-97.6156, 33.9696],
    [-97.6307, 33.9794],
    [-97.6615, 33.9908],
    [-97.6880, 33.9866],
    [-97.7042, 33.9633],
    [-97.7210, 33.9444],
    [-97.7323, 33.9367],
    [-97.7385, 33.9374],
    [-97.7627, 33.9308],
    [-97.7602, 33.9172],
    [-97.7755, 33.9181],
    [-97.7851, 33.9168],
    [-97.7803, 33.9048],
    [-97.7823, 33.8923],
    [-97.7898, 33.8947],
    [-97.7978, 33.8993],
    [-97.8017, 33.8900],
    [-97.8054, 33.8772],
    [-97.8125, 33.8812],
    [-97.8192, 33.8791],
    [-97.8221, 33.8680],
    [-97.8343, 33.8577],
    [-97.8433, 33.8568],
    [-97.8609, 33.8506],
    [-97.8774, 33.8502],
    [-97.8967, 33.8580],
    [-97.9388, 33.8799],
    [-97.9512, 33.8784],
    [-97.9742, 33.8866],
    [-97.9797, 33.8922],
    [-97.9846, 33.8991],
    [-97.9800, 33.9114],
    [-97.9731, 33.9080],
    [-97.9606, 33.9104],
    [-97.9527, 33.9295],
    [-97.9555, 33.9382],
    [-97.9712, 33.9371],
    [-97.9742, 33.9428],
    [-97.9657, 33.9474],
    [-97.9459, 33.9884],
    [-97.9476, 33.9911],
    [-97.9583, 33.9908],
    [-97.9717, 34.0054],
    [-97.9828, 34.0019],
    [-98.0057, 33.9960],
    [-98.0411, 33.9935],
    [-98.0853, 34.0033],
    [-98.0896, 34.0193],
    [-98.1035, 34.0385],
    [-98.0838, 34.0367],
    [-98.0991, 34.0486],
    [-98.1202, 34.0721],
    [-98.1194, 34.0845],
    [-98.0993, 34.1043],
    [-98.0907, 34.1220],
    [-98.0936, 34.1318],
    [-98.1032, 34.1352],
    [-98.1095, 34.1541],
    [-98.1308, 34.1505],
    [-98.1428, 34.1364],
    [-98.1691, 34.1142],
    [-98.2037, 34.1177],
    [-98.2310, 34.1340],
    [-98.2565, 34.1295],
    [-98.2662, 34.1321],
    [-98.2683, 34.1317],
    [-98.2730, 34.1322],
    [-98.2939, 34.1330],
    [-98.3226, 34.1497],
    [-98.3640, 34.1571],
    [-98.3705, 34.1521],
    [-98.3817, 34.1492],
    [-98.3871, 34.1409],
    [-98.3811, 34.1348],
    [-98.3809, 34.1305],
    [-98.3887, 34.1332],
    [-98.4005, 34.1218],
    [-98.3998, 34.1000],
    [-98.4067, 34.1011],
    [-98.4115, 34.0986],
    [-98.4161, 34.0841],
    [-98.4235, 34.0828],
    [-98.4337, 34.0853],
    [-98.4464, 34.0754],
    [-98.4751, 34.0643],
    [-98.5042, 34.0724],
    [-98.5363, 34.1073],
    [-98.5568, 34.1211],
    [-98.5606, 34.1236],
    [-98.5586, 34.1283],
    [-98.5518, 34.1271],
    [-98.5505, 34.1322],
    [-98.5602, 34.1332],
    [-98.5771, 34.1490],
    [-98.6040, 34.1602],
    [-98.6118, 34.1566],
    [-98.6217, 34.1572],
    [-98.6481, 34.1644],
    [-98.6774, 34.1425],
    [-98.6856, 34.1366],
    [-98.6965, 34.1335],
    [-98.7061, 34.1350],
    [-98.7141, 34.1321],
    [-98.7161, 34.1359],
    [-98.7227, 34.1353],
    [-98.7285, 34.1353],
    [-98.7355, 34.1352],
    [-98.7395, 34.1274],
    [-98.7508, 34.1243],
    [-98.7597, 34.1269],
    [-98.7618, 34.1338],
    [-98.7884, 34.1467],
    [-98.7998, 34.1479],
    [-98.8130, 34.1584],
    [-98.8321, 34.1618],
    [-98.8407, 34.1573],
    [-98.8447, 34.1591],
    [-98.8497, 34.1597],
    [-98.8556, 34.1616],
    [-98.8584, 34.1527],
    [-98.8681, 34.1496],
    [-98.8750, 34.1570],
    [-98.8715, 34.1650],
    [-98.8763, 34.1676],
    [-98.8890, 34.1694],
    [-98.9183, 34.1818],
    [-98.9234, 34.1863],
    [-98.9402, 34.2037],
    [-98.9525, 34.2126],
    [-98.9623, 34.2113],
    [-98.9663, 34.2013],
    [-98.9766, 34.2063],
    [-98.9873, 34.2212],
    [-99.0034, 34.2145],
    [-99.0131, 34.2032],
    [-99.0375, 34.2065],
    [-99.0435, 34.1982],
    [-99.0588, 34.2013],
    [-99.0665, 34.2084],
    [-99.0846, 34.2094],
    [-99.0929, 34.2107],
    [-99.1002, 34.2089],
    [-99.1093, 34.2055],
    [-99.1192, 34.2017],
    [-99.1298, 34.2044],
    [-99.1316, 34.2094],
    [-99.1266, 34.2153],
    [-99.1285, 34.2188],
    [-99.1382, 34.2192],
    [-99.1425, 34.2154],
    [-99.1478, 34.2094],
    [-99.1590, 34.2089],
    [-99.1927, 34.2188],
    [-99.1901, 34.2297],
    [-99.1972, 34.2443],
    [-99.1980, 34.2627],
    [-99.2002, 34.2812],
    [-99.2103, 34.3009],
    [-99.2066, 34.3170],
    [-99.2108, 34.3310],
    [-99.2069, 34.3383],
    [-99.2220, 34.3400],
    [-99.2286, 34.3486],
    [-99.2348, 34.3564],
    [-99.2372, 34.3627],
    [-99.2376, 34.3667],
    [-99.2445, 34.3637],
    [-99.2481, 34.3674],
    [-99.2435, 34.3707],
    [-99.2467, 34.3747],
    [-99.2507, 34.3754],
    [-99.2586, 34.3727],
    [-99.2604, 34.3781],
    [-99.2729, 34.3835],
    [-99.2739, 34.3876],
    [-99.2611, 34.3896],
    [-99.2618, 34.3950],
    [-99.2613, 34.4035],
    [-99.2677, 34.4050],
    [-99.2788, 34.4003],
    [-99.2828, 34.4055],
    [-99.2864, 34.4130],
    [-99.2946, 34.4154],
    [-99.3150, 34.4085],
    [-99.3242, 34.4145],
    [-99.3413, 34.4311],
    [-99.3568, 34.4465],
    [-99.3588, 34.4559],
    [-99.3810, 34.4569],
    [-99.3961, 34.4350],
    [-99.3938, 34.4290],
    [-99.3974, 34.4233],
    [-99.3965, 34.4173],
    [-99.3915, 34.4056],
    [-99.4030, 34.3735],
    [-99.4207, 34.3804],
    [-99.4249, 34.3858],
    [-99.4300, 34.3810],
    [-99.4306, 34.3744],
    [-99.4310, 34.3711],
    [-99.4365, 34.3705],
    [-99.4407, 34.3728],
    [-99.4424, 34.3755],
    [-99.4526, 34.3883],
    [-99.4555, 34.3861],
    [-99.4563, 34.3804],
    [-99.4618, 34.3824],
    [-99.4625, 34.3911],
    [-99.4684, 34.3966],
    [-99.4723, 34.3956],
    [-99.4759, 34.3964],
    [-99.4904, 34.3997],
    [-99.4971, 34.4077],
    [-99.5069, 34.4095],
    [-99.5111, 34.4127],
    [-99.5236, 34.4122],
    [-99.5560, 34.4146],
    [-99.5744, 34.4183],
    [-99.5853, 34.3981],
    [-99.5868, 34.3871],
    [-99.5930, 34.3824],
    [-99.6000, 34.3747],
    [-99.6101, 34.3766],
    [-99.6196, 34.3746],
    [-99.6309, 34.3760],
    [-99.6339, 34.3788],
    [-99.6418, 34.3811],
    [-99.6446, 34.3817],
    [-99.6486, 34.3819],
    [-99.6594, 34.3744],
    [-99.6714, 34.3777],
    [-99.6825, 34.3798],
    [-99.6906, 34.3782],
    [-99.6965, 34.3810],
    [-99.7027, 34.3855],
    [-99.7067, 34.3860],
    [-99.7148, 34.3945],
    [-99.7164, 34.4028],
    [-99.7409, 34.4148],
    [-99.7676, 34.4319],
    [-99.7656, 34.4375],
    [-99.7757, 34.4442],
    [-99.7854, 34.4500],
    [-99.7888, 34.4515],
    [-99.8143, 34.4762],
    [-99.8182, 34.4878],
    [-99.8223, 34.4981],
    [-99.8447, 34.5068],
    [-99.8724, 34.5321],
    [-99.8744, 34.5371],
    [-99.8960, 34.5555],
    [-99.9218, 34.5703],
    [-99.9457, 34.5793],
    [-99.9567, 34.5765],
    [-99.9589, 34.5713],
    [-99.9748, 34.5613],
    [-100.0004, 34.5605],
    [-100.0004, 34.7464],
    [-100.0004, 35.0304],
    [-100.0004, 35.3001],
    [-100.0004, 35.4285],
    [-100.0004, 35.6250],
    [-100.0004, 36.0426],
    [-100.0004, 36.2024],
    [-100.0004, 36.4209],
    [-100.0257, 36.4997],
    [-100.2533, 36.4996],
    [-100.3109, 36.4997],
    [-100.3242, 36.4997],
    [-100.3518, 36.4995],
    [-100.3786, 36.4995],
    [-100.4213, 36.4995],
    [-100.4340, 36.4995],
    [-100.4505, 36.4995],
    [-100.5221, 36.4993],
    [-100.5305, 36.4992],
    [-100.5461, 36.4993],
    [-100.5834, 36.4994],
    [-100.5926, 36.4995],
    [-100.6483, 36.4995],
    [-100.6578, 36.4995],
    [-100.7244, 36.4996],
    [-100.7618, 36.4996],
    [-100.8061, 36.4996],
    [-100.8242, 36.4996],
    [-100.8597, 36.4997],
    [-100.9185, 36.4996],
    [-100.9771, 36.4996],
    [-101.0852, 36.4992],
    [-101.5830, 36.4995],
    [-101.6537, 36.4996],
    [-101.6987, 36.4995],
    [-101.7732, 36.4997],
    [-101.7806, 36.4997],
    [-101.7872, 36.4997],
    [-101.8265, 36.4995],
    [-101.9302, 36.5005],
    [-102.1221, 36.5007],
    [-102.1625, 36.5003],
    [-102.3826, 36.5004],
    [-103.0024, 36.5004],
    [-103.0026, 36.5266]
    ]
  },
  "Virginia": {
    coordinates: [
      [-83.6746, 36.6031],
    [-83.6731, 36.6047],
    [-83.6577, 36.6118],
    [-83.6452, 36.6242],
    [-83.6289, 36.6241],
    [-83.6164, 36.6314],
    [-83.6056, 36.6378],
    [-83.6004, 36.6378],
    [-83.5873, 36.6430],
    [-83.5842, 36.6414],
    [-83.5692, 36.6457],
    [-83.5541, 36.6538],
    [-83.5331, 36.6619],
    [-83.5296, 36.6662],
    [-83.5117, 36.6691],
    [-83.4999, 36.6702],
    [-83.4889, 36.6677],
    [-83.4610, 36.6649],
    [-83.4547, 36.6648],
    [-83.4365, 36.6662],
    [-83.4195, 36.6685],
    [-83.3949, 36.6776],
    [-83.3893, 36.6850],
    [-83.3640, 36.6946],
    [-83.3592, 36.6936],
    [-83.3536, 36.6967],
    [-83.3497, 36.6984],
    [-83.3157, 36.7082],
    [-83.3071, 36.7114],
    [-83.2869, 36.7140],
    [-83.2755, 36.7180],
    [-83.2636, 36.7210],
    [-83.2385, 36.7271],
    [-83.2200, 36.7313],
    [-83.1946, 36.7395],
    [-83.1615, 36.7399],
    [-83.1364, 36.7431],
    [-83.1310, 36.7498],
    [-83.1288, 36.7579],
    [-83.1257, 36.7614],
    [-83.1288, 36.7628],
    [-83.1312, 36.7671],
    [-83.1311, 36.7712],
    [-83.1301, 36.7739],
    [-83.1323, 36.7816],
    [-83.1318, 36.7854],
    [-83.1191, 36.7895],
    [-83.1080, 36.8022],
    [-83.0989, 36.8230],
    [-83.1021, 36.8280],
    [-83.0989, 36.8318],
    [-83.0890, 36.8360],
    [-83.0752, 36.8409],
    [-83.0727, 36.8544],
    [-83.0662, 36.8519],
    [-83.0525, 36.8520],
    [-83.0422, 36.8544],
    [-83.0244, 36.8517],
    [-83.0092, 36.8473],
    [-83.0033, 36.8523],
    [-82.9792, 36.8597],
    [-82.9703, 36.8577],
    [-82.9491, 36.8664],
    [-82.9118, 36.8742],
    [-82.9078, 36.8747],
    [-82.9080, 36.8787],
    [-82.8952, 36.8823],
    [-82.8846, 36.8885],
    [-82.8779, 36.8918],
    [-82.8764, 36.8962],
    [-82.8726, 36.9034],
    [-82.8745, 36.9117],
    [-82.8671, 36.9180],
    [-82.8619, 36.9242],
    [-82.8580, 36.9295],
    [-82.8605, 36.9374],
    [-82.8606, 36.9458],
    [-82.8557, 36.9538],
    [-82.8629, 36.9578],
    [-82.8674, 36.9632],
    [-82.8695, 36.9721],
    [-82.8675, 36.9775],
    [-82.8649, 36.9790],
    [-82.8579, 36.9783],
    [-82.8537, 36.9852],
    [-82.8494, 36.9835],
    [-82.8401, 36.9871],
    [-82.8338, 36.9920],
    [-82.8306, 37.0009],
    [-82.8252, 37.0063],
    [-82.8197, 37.0062],
    [-82.8136, 37.0053],
    [-82.7962, 37.0085],
    [-82.7934, 37.0055],
    [-82.7899, 37.0075],
    [-82.7889, 37.0082],
    [-82.7774, 37.0153],
    [-82.7671, 37.0209],
    [-82.7541, 37.0266],
    [-82.7480, 37.0252],
    [-82.7425, 37.0430],
    [-82.7263, 37.0421],
    [-82.7225, 37.0451],
    [-82.7223, 37.0579],
    [-82.7270, 37.0730],
    [-82.7217, 37.0752],
    [-82.7167, 37.0772],
    [-82.7206, 37.0818],
    [-82.7244, 37.0930],
    [-82.7219, 37.1057],
    [-82.7264, 37.1150],
    [-82.7183, 37.1223],
    [-82.6957, 37.1315],
    [-82.6768, 37.1350],
    [-82.6677, 37.1419],
    [-82.6548, 37.1506],
    [-82.6516, 37.1519],
    [-82.6329, 37.1549],
    [-82.6174, 37.1681],
    [-82.5974, 37.1771],
    [-82.5925, 37.1828],
    [-82.5790, 37.1885],
    [-82.5582, 37.1996],
    [-82.5504, 37.2045],
    [-82.5366, 37.2069],
    [-82.5321, 37.2108],
    [-82.5245, 37.2150],
    [-82.5130, 37.2169],
    [-82.5082, 37.2219],
    [-82.4989, 37.2270],
    [-82.4915, 37.2251],
    [-82.4873, 37.2306],
    [-82.4631, 37.2383],
    [-82.4492, 37.2439],
    [-82.4181, 37.2513],
    [-82.3833, 37.2602],
    [-82.3645, 37.2644],
    [-82.3421, 37.2741],
    [-82.3316, 37.2822],
    [-82.3174, 37.2910],
    [-82.3147, 37.2959],
    [-82.3069, 37.3017],
    [-82.2545, 37.3377],
    [-82.2186, 37.3628],
    [-82.1498, 37.4103],
    [-82.1112, 37.4369],
    [-81.9680, 37.5380],
    [-81.9594, 37.5352],
    [-81.9574, 37.5332],
    [-81.9535, 37.5281],
    [-81.9440, 37.5303],
    [-81.9471, 37.5239],
    [-81.9455, 37.5166],
    [-81.9420, 37.5123],
    [-81.9361, 37.5154],
    [-81.9341, 37.5195],
    [-81.9311, 37.5168],
    [-81.9264, 37.5142],
    [-81.9279, 37.5121],
    [-81.9365, 37.5105],
    [-81.9430, 37.5086],
    [-81.9460, 37.5019],
    [-81.9531, 37.5013],
    [-81.9542, 37.4953],
    [-81.9533, 37.4918],
    [-81.9666, 37.4925],
    [-81.9707, 37.4885],
    [-81.9758, 37.4877],
    [-81.9792, 37.4846],
    [-81.9898, 37.4849],
    [-81.9966, 37.4767],
    [-81.9953, 37.4725],
    [-81.9956, 37.4698],
    [-81.9923, 37.4609],
    [-81.9879, 37.4564],
    [-81.9800, 37.4572],
    [-81.9734, 37.4561],
    [-81.9724, 37.4532],
    [-81.9705, 37.4486],
    [-81.9680, 37.4466],
    [-81.9656, 37.4469],
    [-81.9630, 37.4479],
    [-81.9606, 37.4482],
    [-81.9574, 37.4491],
    [-81.9537, 37.4468],
    [-81.9429, 37.4399],
    [-81.9356, 37.4384],
    [-81.9406, 37.4291],
    [-81.9235, 37.4114],
    [-81.9273, 37.4068],
    [-81.9283, 37.3981],
    [-81.9327, 37.3920],
    [-81.9331, 37.3880],
    [-81.9318, 37.3855],
    [-81.9357, 37.3831],
    [-81.9339, 37.3778],
    [-81.9318, 37.3770],
    [-81.9318, 37.3746],
    [-81.9329, 37.3721],
    [-81.9299, 37.3666],
    [-81.9285, 37.3606],
    [-81.9216, 37.3564],
    [-81.9203, 37.3534],
    [-81.9115, 37.3488],
    [-81.9073, 37.3431],
    [-81.9038, 37.3430],
    [-81.8995, 37.3403],
    [-81.8955, 37.3320],
    [-81.8938, 37.3301],
    [-81.8870, 37.3307],
    [-81.8797, 37.3320],
    [-81.8783, 37.3288],
    [-81.8702, 37.3207],
    [-81.8599, 37.3140],
    [-81.8657, 37.3095],
    [-81.8620, 37.3056],
    [-81.8545, 37.3066],
    [-81.8545, 37.2999],
    [-81.8536, 37.2877],
    [-81.8468, 37.2846],
    [-81.8388, 37.2863],
    [-81.8339, 37.2838],
    [-81.8251, 37.2795],
    [-81.8132, 37.2811],
    [-81.8072, 37.2832],
    [-81.7936, 37.2848],
    [-81.7934, 37.2817],
    [-81.7885, 37.2842],
    [-81.7793, 37.2774],
    [-81.7747, 37.2748],
    [-81.7638, 37.2752],
    [-81.7602, 37.2753],
    [-81.7577, 37.2711],
    [-81.7529, 37.2666],
    [-81.7477, 37.2643],
    [-81.7454, 37.2581],
    [-81.7417, 37.2548],
    [-81.7435, 37.2476],
    [-81.7440, 37.2425],
    [-81.7333, 37.2381],
    [-81.7231, 37.2405],
    [-81.7157, 37.2288],
    [-81.6867, 37.2131],
    [-81.6833, 37.2056],
    [-81.6782, 37.2015],
    [-81.5613, 37.2066],
    [-81.5573, 37.2077],
    [-81.5536, 37.2084],
    [-81.5444, 37.2208],
    [-81.5207, 37.2269],
    [-81.5063, 37.2393],
    [-81.5042, 37.2501],
    [-81.4989, 37.2580],
    [-81.4984, 37.2566],
    [-81.4923, 37.2510],
    [-81.4764, 37.2551],
    [-81.4599, 37.2639],
    [-81.4544, 37.2670],
    [-81.4483, 37.2706],
    [-81.4470, 37.2719],
    [-81.4426, 37.2718],
    [-81.4372, 37.2741],
    [-81.4335, 37.2738],
    [-81.4167, 37.2732],
    [-81.4167, 37.2772],
    [-81.4129, 37.2795],
    [-81.4096, 37.2840],
    [-81.4038, 37.2966],
    [-81.3982, 37.3030],
    [-81.3987, 37.3078],
    [-81.3881, 37.3199],
    [-81.3849, 37.3188],
    [-81.3773, 37.3184],
    [-81.3713, 37.3241],
    [-81.3693, 37.3306],
    [-81.3671, 37.3345],
    [-81.3201, 37.2993],
    [-81.2792, 37.2716],
    [-81.2633, 37.2608],
    [-81.2570, 37.2565],
    [-81.2251, 37.2349],
    [-81.1782, 37.2580],
    [-81.1590, 37.2654],
    [-81.1234, 37.2751],
    [-81.0948, 37.2826],
    [-81.0372, 37.2903],
    [-81.0006, 37.2979],
    [-80.9791, 37.3006],
    [-80.9801, 37.2927],
    [-80.9666, 37.2922],
    [-80.9311, 37.3029],
    [-80.9005, 37.3150],
    [-80.8653, 37.3405],
    [-80.8689, 37.3683],
    [-80.8628, 37.4118],
    [-80.8651, 37.4199],
    [-80.8596, 37.4296],
    [-80.8584, 37.4282],
    [-80.8507, 37.4261],
    [-80.8417, 37.4260],
    [-80.8116, 37.4075],
    [-80.8071, 37.4013],
    [-80.8022, 37.3965],
    [-80.7989, 37.3958],
    [-80.7903, 37.3957],
    [-80.7849, 37.3947],
    [-80.7834, 37.3906],
    [-80.7766, 37.3837],
    [-80.7487, 37.3800],
    [-80.7316, 37.3847],
    [-80.7135, 37.3915],
    [-80.6846, 37.4046],
    [-80.6567, 37.4176],
    [-80.6369, 37.4275],
    [-80.6344, 37.4312],
    [-80.6264, 37.4333],
    [-80.6168, 37.4394],
    [-80.5902, 37.4533],
    [-80.5614, 37.4698],
    [-80.5475, 37.4737],
    [-80.5369, 37.4740],
    [-80.5324, 37.4771],
    [-80.5223, 37.4772],
    [-80.5186, 37.4793],
    [-80.5134, 37.4794],
    [-80.4968, 37.4462],
    [-80.4756, 37.4229],
    [-80.4573, 37.4323],
    [-80.4257, 37.4499],
    [-80.3825, 37.4704],
    [-80.3694, 37.4766],
    [-80.3438, 37.4921],
    [-80.3206, 37.4989],
    [-80.3098, 37.5038],
    [-80.2824, 37.5335],
    [-80.3303, 37.5362],
    [-80.3212, 37.5414],
    [-80.3285, 37.5643],
    [-80.2703, 37.5911],
    [-80.2498, 37.6021],
    [-80.2234, 37.6232],
    [-80.2393, 37.6377],
    [-80.2633, 37.6451],
    [-80.2649, 37.6455],
    [-80.2704, 37.6489],
    [-80.2923, 37.6837],
    [-80.2941, 37.6939],
    [-80.2720, 37.7115],
    [-80.2531, 37.7259],
    [-80.2603, 37.7335],
    [-80.2564, 37.7564],
    [-80.2504, 37.7609],
    [-80.2504, 37.7658],
    [-80.2446, 37.7670],
    [-80.2412, 37.7718],
    [-80.2354, 37.7744],
    [-80.2305, 37.7783],
    [-80.2268, 37.7788],
    [-80.2218, 37.7783],
    [-80.2165, 37.7764],
    [-80.2163, 37.7798],
    [-80.2201, 37.7832],
    [-80.2235, 37.7824],
    [-80.2229, 37.7862],
    [-80.2244, 37.7876],
    [-80.2280, 37.7917],
    [-80.2271, 37.7989],
    [-80.2162, 37.8098],
    [-80.2058, 37.8189],
    [-80.1996, 37.8275],
    [-80.1818, 37.8383],
    [-80.1831, 37.8506],
    [-80.1721, 37.8601],
    [-80.1622, 37.8751],
    [-80.1490, 37.8869],
    [-80.1419, 37.8826],
    [-80.1305, 37.8932],
    [-80.1230, 37.8980],
    [-80.1175, 37.9006],
    [-80.1169, 37.9063],
    [-80.0966, 37.9181],
    [-80.0754, 37.9396],
    [-80.0637, 37.9480],
    [-80.0510, 37.9569],
    [-80.0242, 37.9769],
    [-80.0129, 37.9874],
    [-80.0025, 37.9928],
    [-79.9954, 38.0033],
    [-79.9901, 38.0132],
    [-79.9858, 38.0181],
    [-79.9784, 38.0291],
    [-79.9737, 38.0326],
    [-79.9739, 38.0400],
    [-79.9598, 38.0637],
    [-79.9535, 38.0815],
    [-79.9383, 38.0947],
    [-79.9339, 38.0992],
    [-79.9263, 38.1072],
    [-79.9381, 38.1108],
    [-79.9424, 38.1234],
    [-79.9338, 38.1355],
    [-79.9287, 38.1449],
    [-79.9253, 38.1505],
    [-79.9190, 38.1562],
    [-79.9198, 38.1585],
    [-79.9195, 38.1626],
    [-79.9159, 38.1637],
    [-79.9151, 38.1681],
    [-79.9189, 38.1704],
    [-79.9166, 38.1780],
    [-79.9171, 38.1837],
    [-79.9144, 38.1884],
    [-79.8984, 38.1930],
    [-79.8920, 38.2034],
    [-79.8864, 38.2080],
    [-79.8636, 38.2239],
    [-79.8464, 38.2400],
    [-79.8375, 38.2413],
    [-79.8340, 38.2450],
    [-79.8253, 38.2505],
    [-79.8171, 38.2495],
    [-79.8157, 38.2551],
    [-79.8063, 38.2592],
    [-79.7961, 38.2664],
    [-79.7875, 38.2733],
    [-79.7978, 38.2921],
    [-79.8033, 38.2967],
    [-79.8101, 38.3050],
    [-79.8041, 38.3139],
    [-79.7965, 38.3235],
    [-79.7793, 38.3316],
    [-79.7677, 38.3441],
    [-79.7691, 38.3465],
    [-79.7682, 38.3492],
    [-79.7662, 38.3525],
    [-79.7576, 38.3576],
    [-79.7406, 38.3541],
    [-79.7293, 38.3618],
    [-79.7256, 38.3638],
    [-79.7277, 38.3717],
    [-79.7299, 38.3804],
    [-79.7174, 38.4016],
    [-79.7091, 38.4121],
    [-79.6899, 38.4329],
    [-79.6914, 38.4396],
    [-79.6890, 38.4495],
    [-79.6889, 38.4587],
    [-79.6989, 38.4699],
    [-79.6956, 38.4778],
    [-79.6955, 38.4815],
    [-79.6945, 38.4942],
    [-79.6883, 38.4962],
    [-79.6816, 38.5082],
    [-79.6705, 38.5077],
    [-79.6688, 38.5120],
    [-79.6635, 38.5141],
    [-79.6668, 38.5243],
    [-79.6730, 38.5287],
    [-79.6697, 38.5434],
    [-79.6626, 38.5605],
    [-79.6616, 38.5673],
    [-79.6604, 38.5725],
    [-79.6577, 38.5737],
    [-79.6554, 38.5795],
    [-79.6540, 38.5847],
    [-79.6491, 38.5915],
    [-79.5555, 38.5602],
    [-79.5375, 38.5513],
    [-79.5332, 38.5447],
    [-79.5165, 38.5256],
    [-79.4764, 38.4572],
    [-79.3105, 38.4127],
    [-79.3064, 38.4149],
    [-79.3011, 38.4149],
    [-79.2957, 38.4181],
    [-79.2884, 38.4210],
    [-79.2830, 38.4181],
    [-79.2803, 38.4255],
    [-79.2827, 38.4310],
    [-79.2745, 38.4363],
    [-79.2653, 38.4418],
    [-79.2611, 38.4481],
    [-79.2559, 38.4542],
    [-79.2473, 38.4533],
    [-79.2420, 38.4643],
    [-79.2316, 38.4740],
    [-79.2210, 38.4806],
    [-79.2191, 38.4874],
    [-79.2100, 38.4942],
    [-79.2079, 38.5001],
    [-79.2110, 38.5074],
    [-79.1970, 38.5367],
    [-79.1841, 38.5515],
    [-79.1749, 38.5663],
    [-79.1710, 38.5681],
    [-79.1709, 38.5741],
    [-79.1673, 38.5793],
    [-79.1583, 38.5939],
    [-79.1544, 38.6065],
    [-79.1513, 38.6206],
    [-79.1427, 38.6344],
    [-79.1370, 38.6407],
    [-79.1355, 38.6441],
    [-79.1311, 38.6532],
    [-79.1259, 38.6552],
    [-79.1237, 38.6579],
    [-79.1203, 38.6602],
    [-79.1116, 38.6597],
    [-79.0928, 38.6614],
    [-79.0922, 38.6681],
    [-79.0844, 38.6865],
    [-79.0908, 38.6925],
    [-79.0928, 38.7023],
    [-79.0855, 38.7246],
    [-79.0766, 38.7392],
    [-79.0727, 38.7452],
    [-79.0610, 38.7567],
    [-79.0568, 38.7665],
    [-79.0516, 38.7726],
    [-79.0525, 38.7792],
    [-79.0550, 38.7857],
    [-79.0332, 38.7910],
    [-79.0231, 38.7986],
    [-79.0241, 38.8092],
    [-79.0120, 38.8204],
    [-79.0062, 38.8245],
    [-79.0024, 38.8365],
    [-79.0003, 38.8454],
    [-78.9940, 38.8501],
    [-78.8693, 38.7630],
    [-78.8482, 38.7950],
    [-78.8273, 38.8216],
    [-78.8109, 38.8496],
    [-78.8060, 38.8595],
    [-78.7916, 38.8776],
    [-78.7860, 38.8872],
    [-78.7591, 38.9005],
    [-78.7547, 38.9076],
    [-78.7387, 38.9274],
    [-78.7225, 38.9314],
    [-78.7196, 38.9265],
    [-78.7198, 38.9221],
    [-78.7198, 38.9059],
    [-78.7162, 38.9048],
    [-78.7043, 38.9152],
    [-78.6896, 38.9237],
    [-78.6805, 38.9253],
    [-78.6666, 38.9392],
    [-78.6590, 38.9474],
    [-78.6466, 38.9681],
    [-78.6325, 38.9770],
    [-78.6257, 38.9826],
    [-78.6200, 38.9773],
    [-78.6112, 38.9761],
    [-78.6014, 38.9665],
    [-78.5933, 38.9719],
    [-78.5820, 38.9884],
    [-78.5617, 39.0090],
    [-78.5523, 39.0164],
    [-78.5596, 39.0245],
    [-78.5658, 39.0263],
    [-78.5567, 39.0445],
    [-78.5457, 39.0551],
    [-78.5317, 39.0665],
    [-78.5168, 39.0776],
    [-78.5121, 39.0849],
    [-78.5044, 39.0914],
    [-78.4843, 39.1074],
    [-78.4754, 39.1075],
    [-78.4695, 39.1112],
    [-78.4394, 39.1321],
    [-78.4273, 39.1527],
    [-78.4037, 39.1675],
    [-78.4120, 39.1727],
    [-78.4148, 39.1778],
    [-78.4243, 39.1827],
    [-78.4269, 39.1856],
    [-78.4243, 39.1922],
    [-78.4287, 39.1926],
    [-78.4367, 39.1967],
    [-78.4321, 39.2047],
    [-78.4279, 39.2086],
    [-78.4056, 39.2312],
    [-78.3997, 39.2439],
    [-78.4091, 39.2526],
    [-78.4186, 39.2561],
    [-78.4028, 39.2755],
    [-78.4030, 39.2776],
    [-78.4005, 39.2809],
    [-78.3987, 39.2813],
    [-78.3959, 39.2822],
    [-78.3924, 39.2848],
    [-78.3888, 39.2886],
    [-78.3859, 39.2949],
    [-78.3672, 39.3101],
    [-78.3600, 39.3178],
    [-78.3455, 39.3410],
    [-78.3474, 39.3434],
    [-78.3413, 39.3456],
    [-78.3405, 39.3535],
    [-78.3623, 39.3578],
    [-78.3669, 39.3593],
    [-78.3432, 39.3888],
    [-78.3459, 39.3903],
    [-78.3500, 39.3907],
    [-78.3500, 39.3929],
    [-78.3494, 39.3973],
    [-78.3523, 39.3998],
    [-78.3599, 39.4090],
    [-78.3512, 39.4206],
    [-78.3479, 39.4309],
    [-78.3465, 39.4426],
    [-78.3470, 39.4507],
    [-78.3495, 39.4622],
    [-78.3074, 39.4410],
    [-78.2628, 39.4143],
    [-78.1874, 39.3640],
    [-78.1481, 39.3378],
    [-78.1240, 39.3226],
    [-78.1083, 39.3122],
    [-78.0800, 39.2943],
    [-78.0332, 39.2646],
    [-77.9913, 39.2376],
    [-77.8609, 39.1535],
    [-77.8283, 39.1324],
    [-77.8222, 39.1427],
    [-77.8214, 39.1524],
    [-77.8113, 39.1676],
    [-77.8060, 39.1724],
    [-77.8047, 39.1794],
    [-77.7977, 39.1942],
    [-77.7946, 39.2063],
    [-77.7888, 39.2152],
    [-77.7781, 39.2293],
    [-77.7673, 39.2494],
    [-77.7707, 39.2553],
    [-77.7680, 39.2577],
    [-77.7622, 39.2611],
    [-77.7612, 39.2637],
    [-77.7557, 39.2746],
    [-77.7531, 39.2780],
    [-77.7503, 39.2893],
    [-77.7300, 39.3157],
    [-77.7195, 39.3213],
    [-77.6975, 39.3186],
    [-77.6817, 39.3237],
    [-77.6713, 39.3217],
    [-77.6455, 39.3095],
    [-77.6403, 39.3082],
    [-77.6317, 39.3067],
    [-77.6069, 39.3036],
    [-77.6039, 39.3032],
    [-77.5882, 39.3020],
    [-77.5700, 39.3063],
    [-77.5632, 39.3039],
    [-77.5609, 39.2862],
    [-77.5511, 39.2759],
    [-77.5458, 39.2715],
    [-77.5406, 39.2649],
    [-77.5210, 39.2585],
    [-77.4966, 39.2510],
    [-77.4808, 39.2417],
    [-77.4602, 39.2284],
    [-77.4579, 39.2220],
    [-77.4701, 39.2118],
    [-77.4750, 39.1949],
    [-77.4860, 39.1857],
    [-77.5164, 39.1709],
    [-77.5249, 39.1485],
    [-77.5268, 39.1383],
    [-77.5210, 39.1225],
    [-77.5021, 39.1147],
    [-77.4858, 39.1093],
    [-77.4773, 39.1007],
    [-77.4726, 39.0929],
    [-77.4691, 39.0859],
    [-77.4614, 39.0752],
    [-77.4570, 39.0734],
    [-77.4436, 39.0714],
    [-77.4232, 39.0669],
    [-77.4046, 39.0645],
    [-77.3857, 39.0620],
    [-77.3751, 39.0613],
    [-77.3668, 39.0612],
    [-77.3421, 39.0628],
    [-77.3340, 39.0610],
    [-77.3283, 39.0578],
    [-77.3107, 39.0520],
    [-77.2930, 39.0464],
    [-77.2583, 39.0305],
    [-77.2484, 39.0269],
    [-77.2446, 39.0201],
    [-77.2557, 39.0024],
    [-77.2483, 38.9923],
    [-77.2411, 38.9812],
    [-77.2316, 38.9799],
    [-77.2250, 38.9733],
    [-77.2093, 38.9704],
    [-77.1975, 38.9668],
    [-77.1799, 38.9684],
    [-77.1718, 38.9675],
    [-77.1653, 38.9680],
    [-77.1482, 38.9650],
    [-77.1319, 38.9474],
    [-77.1198, 38.9343],
    [-77.1166, 38.9289],
    [-77.1063, 38.9191],
    [-77.1016, 38.9115],
    [-77.0937, 38.9059],
    [-77.0822, 38.9019],
    [-77.0784, 38.9015],
    [-77.0701, 38.9007],
    [-77.0673, 38.8992],
    [-77.0583, 38.8801],
    [-77.0511, 38.8752],
    [-77.0463, 38.8713],
    [-77.0454, 38.8752],
    [-77.0411, 38.8717],
    [-77.0389, 38.8658],
    [-77.0318, 38.8509],
    [-77.0385, 38.8393],
    [-77.0445, 38.8396],
    [-77.0435, 38.8332],
    [-77.0392, 38.8322],
    [-77.0388, 38.8196],
    [-77.0374, 38.8134],
    [-77.0388, 38.8017],
    [-77.0389, 38.7982],
    [-77.0390, 38.7916],
    [-77.0404, 38.7854],
    [-77.0416, 38.7610],
    [-77.0423, 38.7413],
    [-77.0424, 38.7378],
    [-77.0415, 38.7285],
    [-77.0433, 38.7190],
    [-77.0532, 38.7099],
    [-77.0718, 38.7101],
    [-77.0742, 38.7126],
    [-77.0796, 38.7128],
    [-77.0808, 38.7103],
    [-77.0918, 38.7034],
    [-77.1027, 38.6983],
    [-77.1226, 38.6852],
    [-77.1345, 38.6600],
    [-77.1322, 38.6412],
    [-77.1476, 38.6351],
    [-77.1631, 38.6312],
    [-77.1802, 38.6233],
    [-77.1859, 38.6215],
    [-77.1945, 38.6195],
    [-77.2020, 38.6177],
    [-77.2051, 38.6239],
    [-77.2125, 38.6329],
    [-77.2149, 38.6379],
    [-77.1980, 38.6468],
    [-77.1943, 38.6527],
    [-77.2035, 38.6585],
    [-77.2136, 38.6568],
    [-77.2261, 38.6603],
    [-77.2339, 38.6613],
    [-77.2280, 38.6526],
    [-77.2244, 38.6448],
    [-77.2283, 38.6379],
    [-77.2342, 38.6366],
    [-77.2406, 38.6389],
    [-77.2467, 38.6352],
    [-77.2484, 38.6263],
    [-77.2458, 38.6230],
    [-77.2462, 38.6176],
    [-77.2497, 38.6114],
    [-77.2500, 38.6061],
    [-77.2564, 38.6008],
    [-77.2547, 38.5958],
    [-77.2470, 38.5906],
    [-77.2605, 38.5846],
    [-77.2644, 38.5828],
    [-77.2570, 38.5612],
    [-77.2603, 38.5598],
    [-77.2638, 38.5554],
    [-77.2763, 38.5396],
    [-77.2831, 38.5330],
    [-77.2860, 38.5293],
    [-77.2839, 38.5279],
    [-77.2860, 38.5221],
    [-77.2911, 38.5157],
    [-77.2994, 38.5120],
    [-77.2964, 38.5092],
    [-77.3035, 38.4993],
    [-77.3102, 38.4921],
    [-77.3156, 38.4789],
    [-77.3243, 38.4587],
    [-77.3251, 38.4455],
    [-77.3233, 38.4385],
    [-77.3225, 38.4297],
    [-77.3124, 38.4018],
    [-77.3112, 38.3970],
    [-77.3169, 38.3935],
    [-77.3173, 38.3836],
    [-77.2961, 38.3698],
    [-77.2873, 38.3525],
    [-77.2862, 38.3470],
    [-77.2677, 38.3338],
    [-77.2501, 38.3317],
    [-77.2238, 38.3351],
    [-77.2011, 38.3402],
    [-77.1802, 38.3411],
    [-77.1627, 38.3460],
    [-77.1382, 38.3679],
    [-77.1162, 38.3681],
    [-77.0981, 38.3688],
    [-77.0848, 38.3683],
    [-77.0598, 38.3914],
    [-77.0514, 38.3991],
    [-77.0249, 38.3868],
    [-77.0118, 38.3746],
    [-77.0157, 38.3690],
    [-77.0146, 38.3592],
    [-77.0162, 38.3456],
    [-77.0148, 38.3382],
    [-77.0149, 38.3328],
    [-77.0216, 38.3258],
    [-77.0243, 38.3221],
    [-77.0296, 38.3202],
    [-77.0396, 38.3188],
    [-77.0450, 38.3228],
    [-77.0527, 38.3227],
    [-77.0578, 38.3206],
    [-77.0520, 38.3152],
    [-77.0458, 38.3117],
    [-77.0353, 38.3109],
    [-77.0284, 38.3087],
    [-77.0232, 38.3005],
    [-77.0144, 38.2944],
    [-77.0099, 38.2888],
    [-77.0010, 38.2761],
    [-76.9986, 38.2739],
    [-76.9955, 38.2733],
    [-76.9920, 38.2733],
    [-76.9832, 38.2746],
    [-76.9711, 38.2659],
    [-76.9611, 38.2533],
    [-76.9570, 38.2402],
    [-76.9594, 38.2328],
    [-76.9666, 38.2295],
    [-76.9628, 38.2182],
    [-76.9514, 38.2090],
    [-76.9307, 38.2012],
    [-76.9108, 38.1971],
    [-76.9022, 38.1904],
    [-76.8846, 38.1788],
    [-76.8689, 38.1714],
    [-76.8590, 38.1710],
    [-76.8552, 38.1678],
    [-76.8454, 38.1659],
    [-76.8305, 38.1633],
    [-76.8132, 38.1665],
    [-76.7967, 38.1683],
    [-76.7741, 38.1672],
    [-76.7549, 38.1643],
    [-76.7410, 38.1522],
    [-76.7367, 38.1327],
    [-76.7265, 38.1333],
    [-76.7159, 38.1403],
    [-76.7013, 38.1557],
    [-76.7006, 38.1602],
    [-76.6883, 38.1595],
    [-76.6789, 38.1543],
    [-76.6702, 38.1503],
    [-76.6615, 38.1418],
    [-76.6518, 38.1339],
    [-76.6428, 38.1252],
    [-76.6397, 38.1220],
    [-76.6323, 38.1287],
    [-76.6369, 38.1353],
    [-76.6359, 38.1413],
    [-76.6407, 38.1419],
    [-76.6434, 38.1482],
    [-76.6325, 38.1526],
    [-76.6198, 38.1500],
    [-76.6116, 38.1482],
    [-76.6131, 38.1402],
    [-76.6043, 38.1303],
    [-76.6009, 38.1146],
    [-76.5933, 38.1047],
    [-76.5795, 38.0949],
    [-76.5576, 38.0861],
    [-76.5374, 38.0755],
    [-76.5353, 38.0660],
    [-76.5228, 38.0490],
    [-76.5238, 38.0427],
    [-76.5238, 38.0455],
    [-76.5305, 38.0447],
    [-76.5369, 38.0413],
    [-76.5477, 38.0395],
    [-76.5514, 38.0368],
    [-76.5494, 38.0295],
    [-76.5551, 38.0246],
    [-76.5445, 38.0226],
    [-76.5366, 38.0209],
    [-76.5370, 38.0260],
    [-76.5282, 38.0250],
    [-76.5177, 38.0251],
    [-76.4959, 38.0188],
    [-76.4795, 38.0152],
    [-76.4718, 38.0130],
    [-76.4794, 38.0109],
    [-76.4713, 38.0070],
    [-76.4632, 38.0051],
    [-76.4624, 37.9967],
    [-76.4723, 37.9902],
    [-76.4730, 37.9855],
    [-76.4648, 37.9857],
    [-76.4510, 37.9848],
    [-76.4453, 37.9864],
    [-76.4399, 37.9827],
    [-76.4389, 37.9803],
    [-76.4348, 37.9775],
    [-76.4275, 37.9770],
    [-76.4092, 37.9637],
    [-76.3790, 37.9561],
    [-76.3380, 37.9449],
    [-76.3104, 37.9315],
    [-76.2660, 37.9114],
    [-76.2599, 37.9071],
    [-76.2563, 37.9043],
    [-76.2529, 37.9006],
    [-76.2504, 37.8958],
    [-76.2368, 37.8895],
    [-76.2388, 37.8817],
    [-76.2448, 37.8690],
    [-76.2463, 37.8564],
    [-76.2500, 37.8475],
    [-76.2505, 37.8350],
    [-76.2617, 37.8224],
    [-76.2752, 37.8127],
    [-76.2820, 37.8181],
    [-76.2883, 37.8215],
    [-76.2997, 37.8223],
    [-76.3122, 37.8141],
    [-76.3076, 37.8002],
    [-76.3120, 37.7923],
    [-76.3168, 37.7902],
    [-76.3153, 37.7820],
    [-76.3119, 37.7830],
    [-76.3077, 37.7869],
    [-76.2999, 37.7844],
    [-76.2954, 37.7851],
    [-76.2876, 37.7852],
    [-76.2868, 37.7780],
    [-76.2897, 37.7817],
    [-76.2978, 37.7807],
    [-76.3058, 37.7801],
    [-76.3073, 37.7762],
    [-76.3096, 37.7703],
    [-76.3081, 37.7642],
    [-76.3137, 37.7640],
    [-76.3142, 37.7592],
    [-76.3109, 37.7560],
    [-76.3146, 37.7504],
    [-76.3142, 37.7425],
    [-76.3072, 37.7313],
    [-76.3112, 37.7325],
    [-76.3166, 37.7365],
    [-76.3219, 37.7337],
    [-76.3192, 37.7277],
    [-76.3212, 37.7220],
    [-76.3166, 37.7162],
    [-76.3127, 37.7184],
    [-76.3109, 37.7112],
    [-76.3054, 37.7045],
    [-76.3011, 37.6954],
    [-76.3024, 37.6909],
    [-76.3073, 37.6923],
    [-76.3135, 37.6944],
    [-76.3152, 37.6898],
    [-76.3186, 37.6855],
    [-76.3272, 37.6870],
    [-76.3344, 37.6845],
    [-76.3287, 37.6784],
    [-76.3250, 37.6719],
    [-76.3329, 37.6708],
    [-76.3376, 37.6626],
    [-76.3382, 37.6575],
    [-76.3326, 37.6458],
    [-76.3336, 37.6416],
    [-76.3322, 37.6323],
    [-76.3261, 37.6274],
    [-76.3191, 37.6280],
    [-76.3156, 37.6314],
    [-76.3114, 37.6349],
    [-76.3143, 37.6409],
    [-76.3059, 37.6411],
    [-76.2925, 37.6361],
    [-76.2853, 37.6266],
    [-76.2796, 37.6173],
    [-76.2865, 37.6148],
    [-76.2952, 37.6172],
    [-76.3068, 37.6212],
    [-76.3086, 37.6246],
    [-76.3143, 37.6239],
    [-76.3257, 37.6207],
    [-76.3393, 37.6238],
    [-76.3501, 37.6217],
    [-76.3579, 37.6157],
    [-76.3588, 37.6109],
    [-76.3623, 37.6104],
    [-76.3811, 37.6270],
    [-76.3955, 37.6300],
    [-76.4033, 37.6274],
    [-76.4120, 37.6355],
    [-76.4184, 37.6399],
    [-76.4342, 37.6467],
    [-76.4412, 37.6524],
    [-76.4465, 37.6500],
    [-76.4521, 37.6488],
    [-76.4592, 37.6567],
    [-76.4629, 37.6605],
    [-76.4707, 37.6674],
    [-76.4581, 37.6750],
    [-76.4563, 37.6831],
    [-76.4626, 37.6902],
    [-76.4774, 37.6945],
    [-76.4871, 37.6854],
    [-76.4779, 37.6778],
    [-76.4869, 37.6698],
    [-76.4943, 37.6614],
    [-76.5029, 37.6542],
    [-76.4949, 37.6531],
    [-76.5015, 37.6438],
    [-76.5119, 37.6450],
    [-76.5220, 37.6529],
    [-76.5342, 37.6609],
    [-76.5361, 37.6746],
    [-76.5395, 37.7019],
    [-76.5468, 37.7115],
    [-76.5558, 37.7167],
    [-76.5640, 37.7319],
    [-76.5694, 37.7367],
    [-76.5714, 37.7467],
    [-76.5843, 37.7709],
    [-76.5901, 37.7713],
    [-76.5959, 37.7717],
    [-76.6190, 37.7836],
    [-76.6206, 37.7878],
    [-76.6295, 37.7877],
    [-76.6327, 37.7880],
    [-76.6325, 37.7905],
    [-76.6262, 37.7983],
    [-76.6325, 37.8006],
    [-76.6375, 37.8035],
    [-76.6424, 37.8055],
    [-76.6487, 37.8004],
    [-76.6514, 37.7962],
    [-76.6583, 37.8068],
    [-76.6730, 37.8153],
    [-76.6781, 37.8230],
    [-76.6833, 37.8253],
    [-76.6927, 37.8228],
    [-76.7016, 37.8227],
    [-76.7189, 37.8356],
    [-76.7270, 37.8384],
    [-76.7312, 37.8498],
    [-76.7403, 37.8545],
    [-76.7384, 37.8654],
    [-76.7469, 37.8745],
    [-76.7605, 37.8785],
    [-76.7648, 37.8836],
    [-76.7660, 37.8932],
    [-76.7730, 37.9032],
    [-76.7843, 37.9151],
    [-76.8007, 37.9240],
    [-76.8155, 37.9304],
    [-76.8250, 37.9332],
    [-76.8354, 37.9321],
    [-76.8436, 37.9417],
    [-76.8501, 37.9512],
    [-76.8467, 37.9561],
    [-76.8499, 37.9653],
    [-76.8516, 37.9732],
    [-76.8566, 37.9733],
    [-76.8712, 37.9859],
    [-76.8921, 37.9863],
    [-76.8981, 37.9960],
    [-76.9122, 38.0006],
    [-76.9186, 37.9984],
    [-76.9218, 37.9909],
    [-76.9274, 37.9818],
    [-76.9160, 37.9736],
    [-76.8968, 37.9739],
    [-76.8852, 37.9735],
    [-76.8796, 37.9665],
    [-76.8864, 37.9551],
    [-76.8896, 37.9528],
    [-76.8854, 37.9519],
    [-76.8700, 37.9417],
    [-76.8625, 37.9367],
    [-76.8602, 37.9332],
    [-76.8541, 37.9248],
    [-76.8522, 37.9208],
    [-76.8444, 37.9156],
    [-76.8326, 37.9162],
    [-76.8268, 37.9113],
    [-76.8238, 37.9060],
    [-76.8220, 37.9025],
    [-76.8121, 37.8988],
    [-76.7968, 37.8956],
    [-76.7942, 37.8852],
    [-76.7889, 37.8768],
    [-76.7846, 37.8696],
    [-76.7788, 37.8596],
    [-76.7710, 37.8548],
    [-76.7678, 37.8477],
    [-76.7662, 37.8425],
    [-76.7640, 37.8353],
    [-76.7608, 37.8309],
    [-76.7564, 37.8267],
    [-76.7497, 37.8224],
    [-76.7473, 37.8184],
    [-76.7432, 37.8113],
    [-76.7239, 37.7885],
    [-76.7155, 37.7859],
    [-76.6979, 37.7864],
    [-76.6898, 37.7852],
    [-76.6805, 37.7801],
    [-76.6833, 37.7758],
    [-76.6831, 37.7692],
    [-76.6770, 37.7561],
    [-76.6400, 37.7509],
    [-76.6247, 37.7464],
    [-76.6190, 37.7406],
    [-76.6232, 37.7394],
    [-76.6190, 37.7325],
    [-76.6000, 37.7204],
    [-76.5981, 37.7091],
    [-76.5905, 37.6961],
    [-76.5897, 37.6885],
    [-76.5794, 37.6733],
    [-76.5855, 37.6685],
    [-76.5897, 37.6658],
    [-76.5738, 37.6564],
    [-76.5743, 37.6508],
    [-76.5762, 37.6473],
    [-76.5671, 37.6420],
    [-76.5655, 37.6377],
    [-76.5554, 37.6316],
    [-76.5501, 37.6240],
    [-76.5427, 37.6169],
    [-76.5199, 37.6119],
    [-76.5062, 37.6113],
    [-76.4783, 37.6113],
    [-76.4565, 37.6132],
    [-76.4486, 37.6124],
    [-76.4355, 37.6128],
    [-76.4308, 37.6111],
    [-76.4344, 37.6057],
    [-76.4317, 37.6015],
    [-76.4339, 37.5979],
    [-76.4348, 37.5960],
    [-76.4321, 37.5929],
    [-76.4283, 37.5916],
    [-76.4235, 37.5909],
    [-76.4279, 37.5877],
    [-76.4229, 37.5854],
    [-76.4133, 37.5806],
    [-76.4084, 37.5817],
    [-76.3699, 37.5730],
    [-76.3578, 37.5737],
    [-76.3394, 37.5712],
    [-76.3243, 37.5666],
    [-76.3161, 37.5616],
    [-76.3106, 37.5630],
    [-76.2989, 37.5612],
    [-76.3028, 37.5513],
    [-76.3182, 37.5470],
    [-76.3286, 37.5460],
    [-76.3283, 37.5419],
    [-76.3290, 37.5307],
    [-76.3317, 37.5262],
    [-76.3324, 37.5414],
    [-76.3402, 37.5422],
    [-76.3400, 37.5383],
    [-76.3530, 37.5370],
    [-76.3588, 37.5366],
    [-76.3598, 37.5216],
    [-76.3594, 37.5134],
    [-76.3457, 37.5040],
    [-76.3362, 37.5044],
    [-76.3317, 37.4999],
    [-76.3276, 37.4898],
    [-76.3217, 37.4857],
    [-76.3103, 37.4877],
    [-76.3155, 37.4888],
    [-76.3134, 37.4923],
    [-76.2977, 37.5069],
    [-76.2977, 37.5154],
    [-76.2810, 37.5078],
    [-76.2710, 37.4896],
    [-76.2685, 37.4839],
    [-76.2664, 37.4757],
    [-76.2727, 37.4836],
    [-76.2812, 37.4855],
    [-76.2868, 37.4869],
    [-76.2923, 37.4933],
    [-76.2986, 37.4946],
    [-76.3047, 37.4944],
    [-76.3103, 37.4911],
    [-76.3048, 37.4888],
    [-76.2998, 37.4836],
    [-76.2931, 37.4819],
    [-76.2887, 37.4793],
    [-76.2837, 37.4758],
    [-76.2796, 37.4734],
    [-76.2807, 37.4658],
    [-76.2710, 37.4595],
    [-76.2603, 37.4570],
    [-76.2562, 37.4469],
    [-76.2524, 37.4366],
    [-76.2517, 37.4217],
    [-76.2495, 37.4172],
    [-76.2490, 37.4061],
    [-76.2479, 37.3851],
    [-76.2535, 37.3715],
    [-76.2593, 37.3622],
    [-76.2721, 37.3556],
    [-76.2741, 37.3448],
    [-76.2711, 37.3402],
    [-76.2721, 37.3367],
    [-76.2760, 37.3354],
    [-76.2722, 37.3215],
    [-76.2762, 37.3108],
    [-76.2804, 37.3170],
    [-76.2913, 37.3241],
    [-76.2972, 37.3271],
    [-76.3067, 37.3282],
    [-76.3141, 37.3395],
    [-76.3206, 37.3441],
    [-76.3209, 37.3486],
    [-76.3262, 37.3507],
    [-76.3341, 37.3597],
    [-76.3378, 37.3658],
    [-76.3517, 37.3698],
    [-76.3626, 37.3740],
    [-76.3673, 37.3775],
    [-76.3779, 37.3821],
    [-76.3940, 37.3959],
    [-76.3972, 37.4065],
    [-76.3990, 37.4168],
    [-76.4145, 37.4136],
    [-76.4152, 37.4021],
    [-76.4157, 37.3904],
    [-76.4147, 37.3817],
    [-76.4165, 37.3777],
    [-76.4096, 37.3715],
    [-76.4145, 37.3684],
    [-76.4206, 37.3729],
    [-76.4287, 37.3815],
    [-76.4483, 37.3812],
    [-76.4509, 37.3868],
    [-76.4610, 37.3874],
    [-76.4672, 37.3798],
    [-76.4696, 37.3706],
    [-76.4651, 37.3661],
    [-76.4586, 37.3597],
    [-76.4490, 37.3609],
    [-76.4453, 37.3665],
    [-76.4254, 37.3506],
    [-76.4238, 37.3454],
    [-76.4147, 37.3397],
    [-76.4123, 37.3450],
    [-76.4089, 37.3393],
    [-76.4027, 37.3361],
    [-76.4047, 37.3317],
    [-76.4077, 37.3311],
    [-76.4153, 37.3317],
    [-76.4134, 37.3256],
    [-76.4169, 37.3205],
    [-76.4214, 37.3206],
    [-76.4331, 37.3224],
    [-76.4382, 37.3219],
    [-76.4386, 37.3138],
    [-76.4274, 37.3107],
    [-76.4212, 37.3090],
    [-76.4148, 37.3076],
    [-76.4031, 37.3109],
    [-76.3947, 37.3129],
    [-76.3886, 37.3085],
    [-76.3930, 37.3045],
    [-76.3946, 37.3009],
    [-76.3890, 37.2962],
    [-76.3856, 37.2941],
    [-76.3824, 37.2879],
    [-76.3787, 37.2857],
    [-76.3689, 37.2784],
    [-76.3530, 37.2768],
    [-76.3624, 37.2686],
    [-76.3753, 37.2685],
    [-76.3831, 37.2662],
    [-76.3917, 37.2638],
    [-76.4030, 37.2645],
    [-76.4172, 37.2651],
    [-76.4245, 37.2587],
    [-76.4304, 37.2544],
    [-76.4451, 37.2546],
    [-76.4565, 37.2524],
    [-76.4689, 37.2511],
    [-76.4817, 37.2539],
    [-76.4933, 37.2495],
    [-76.5013, 37.2472],
    [-76.5050, 37.2452],
    [-76.5089, 37.2394],
    [-76.5043, 37.2348],
    [-76.4974, 37.2300],
    [-76.4886, 37.2240],
    [-76.4694, 37.2163],
    [-76.4473, 37.2192],
    [-76.4338, 37.2202],
    [-76.4214, 37.2232],
    [-76.3973, 37.2242],
    [-76.3886, 37.2277],
    [-76.3884, 37.2244],
    [-76.3951, 37.2171],
    [-76.3986, 37.2096],
    [-76.3961, 37.2011],
    [-76.3908, 37.1930],
    [-76.3917, 37.1812],
    [-76.3925, 37.1756],
    [-76.3979, 37.1779],
    [-76.4020, 37.1781],
    [-76.4080, 37.1720],
    [-76.4096, 37.1657],
    [-76.4057, 37.1600],
    [-76.3948, 37.1576],
    [-76.3785, 37.1581],
    [-76.3670, 37.1656],
    [-76.3597, 37.1686],
    [-76.3503, 37.1710],
    [-76.3425, 37.1690],
    [-76.3412, 37.1658],
    [-76.3434, 37.1632],
    [-76.3392, 37.1584],
    [-76.3370, 37.1505],
    [-76.3325, 37.1445],
    [-76.3244, 37.1429],
    [-76.3151, 37.1380],
    [-76.3037, 37.1316],
    [-76.2968, 37.1272],
    [-76.3006, 37.1187],
    [-76.2949, 37.1089],
    [-76.2854, 37.1023],
    [-76.2745, 37.0945],
    [-76.2735, 37.0807],
    [-76.2779, 37.0741],
    [-76.2812, 37.0630],
    [-76.2894, 37.0417],
    [-76.2929, 37.0351],
    [-76.2973, 37.0186],
    [-76.3043, 37.0014],
    [-76.3146, 37.0093],
    [-76.3194, 37.0131],
    [-76.3187, 37.0034],
    [-76.3207, 37.0026],
    [-76.3258, 37.0118],
    [-76.3313, 37.0131],
    [-76.3401, 37.0152],
    [-76.3434, 37.0121],
    [-76.3564, 37.0029],
    [-76.3621, 37.0024],
    [-76.3736, 36.9983],
    [-76.3834, 36.9933],
    [-76.3964, 36.9823],
    [-76.4056, 36.9715],
    [-76.4104, 36.9653],
    [-76.4119, 36.9626],
    [-76.4253, 36.9664],
    [-76.4350, 36.9764],
    [-76.4528, 37.0000],
    [-76.4482, 37.0077],
    [-76.4552, 37.0142],
    [-76.4613, 37.0245],
    [-76.4794, 37.0354],
    [-76.4892, 37.0412],
    [-76.5123, 37.0549],
    [-76.5263, 37.0629],
    [-76.5266, 37.0785],
    [-76.5357, 37.0842],
    [-76.5437, 37.0937],
    [-76.5535, 37.1015],
    [-76.5567, 37.1080],
    [-76.5648, 37.1124],
    [-76.5700, 37.1084],
    [-76.5620, 37.0972],
    [-76.5515, 37.0807],
    [-76.5585, 37.0794],
    [-76.5635, 37.0782],
    [-76.5708, 37.0875],
    [-76.5963, 37.1065],
    [-76.6024, 37.1130],
    [-76.6081, 37.1136],
    [-76.6184, 37.1214],
    [-76.6213, 37.1251],
    [-76.6270, 37.1258],
    [-76.6259, 37.1293],
    [-76.6213, 37.1358],
    [-76.6223, 37.1421],
    [-76.6063, 37.1576],
    [-76.6123, 37.1607],
    [-76.6087, 37.1650],
    [-76.6095, 37.1664],
    [-76.6128, 37.1712],
    [-76.6233, 37.1987],
    [-76.6411, 37.2160],
    [-76.6764, 37.2231],
    [-76.6936, 37.2232],
    [-76.7106, 37.2157],
    [-76.7315, 37.2122],
    [-76.7443, 37.2138],
    [-76.7582, 37.2155],
    [-76.7584, 37.2116],
    [-76.7513, 37.2092],
    [-76.7382, 37.2064],
    [-76.7379, 37.2011],
    [-76.7430, 37.1926],
    [-76.7604, 37.1940],
    [-76.7738, 37.2061],
    [-76.7863, 37.2208],
    [-76.7893, 37.2232],
    [-76.7989, 37.2347],
    [-76.8166, 37.2417],
    [-76.8268, 37.2436],
    [-76.8505, 37.2408],
    [-76.8695, 37.2422],
    [-76.8733, 37.2515],
    [-76.8661, 37.2555],
    [-76.8698, 37.2622],
    [-76.8789, 37.2584],
    [-76.8837, 37.2542],
    [-76.8948, 37.2519],
    [-76.8974, 37.2469],
    [-76.9048, 37.2424],
    [-76.9142, 37.2436],
    [-76.9186, 37.2373],
    [-76.9361, 37.2388],
    [-76.9484, 37.2309],
    [-76.9416, 37.2241],
    [-76.9326, 37.2177],
    [-76.9262, 37.2160],
    [-76.9085, 37.2027],
    [-76.8909, 37.1995],
    [-76.8609, 37.2088],
    [-76.8205, 37.2060],
    [-76.8086, 37.2060],
    [-76.8010, 37.2060],
    [-76.7969, 37.1894],
    [-76.7858, 37.1846],
    [-76.7834, 37.1813],
    [-76.7827, 37.1782],
    [-76.7731, 37.1736],
    [-76.7605, 37.1656],
    [-76.7544, 37.1586],
    [-76.7494, 37.1527],
    [-76.7373, 37.1462],
    [-76.7214, 37.1463],
    [-76.7078, 37.1587],
    [-76.7029, 37.1707],
    [-76.6929, 37.1861],
    [-76.6811, 37.1928],
    [-76.6728, 37.1855],
    [-76.6643, 37.1710],
    [-76.6703, 37.1516],
    [-76.6671, 37.1405],
    [-76.6654, 37.1347],
    [-76.6651, 37.1254],
    [-76.6624, 37.1177],
    [-76.6569, 37.1098],
    [-76.6577, 37.1015],
    [-76.6676, 37.0762],
    [-76.6683, 37.0551],
    [-76.6591, 37.0424],
    [-76.6460, 37.0362],
    [-76.6036, 37.0333],
    [-76.5810, 37.0249],
    [-76.5761, 37.0154],
    [-76.5811, 37.0098],
    [-76.5821, 37.0044],
    [-76.5768, 36.9983],
    [-76.5707, 36.9995],
    [-76.5694, 37.0032],
    [-76.5569, 37.0020],
    [-76.5454, 36.9936],
    [-76.5341, 36.9852],
    [-76.5241, 36.9783],
    [-76.5134, 36.9681],
    [-76.4960, 36.9650],
    [-76.4865, 36.9565],
    [-76.4864, 36.9445],
    [-76.4882, 36.9393],
    [-76.4992, 36.9375],
    [-76.4988, 36.9286],
    [-76.4952, 36.9225],
    [-76.4893, 36.9218],
    [-76.4811, 36.9116],
    [-76.4821, 36.9011],
    [-76.4894, 36.8942],
    [-76.4923, 36.8864],
    [-76.4834, 36.8782],
    [-76.4802, 36.8797],
    [-76.4699, 36.8829],
    [-76.4533, 36.8870],
    [-76.4416, 36.9061],
    [-76.4125, 36.8989],
    [-76.4038, 36.8978],
    [-76.3910, 36.8958],
    [-76.3883, 36.8972],
    [-76.3841, 36.9244],
    [-76.3494, 36.8952],
    [-76.3396, 36.8931],
    [-76.3217, 36.8858],
    [-76.3168, 36.8873],
    [-76.3148, 36.8954],
    [-76.3186, 36.9032],
    [-76.3260, 36.9037],
    [-76.3332, 36.9173],
    [-76.3302, 36.9421],
    [-76.3203, 36.9578],
    [-76.3005, 36.9564],
    [-76.3006, 36.9697],
    [-76.3026, 36.9872],
    [-76.3003, 36.9831],
    [-76.2965, 36.9690],
    [-76.2844, 36.9687],
    [-76.2747, 36.9670],
    [-76.2533, 36.9566],
    [-76.2421, 36.9498],
    [-76.2217, 36.9396],
    [-76.2058, 36.9352],
    [-76.1900, 36.9314],
    [-76.1755, 36.9301],
    [-76.1594, 36.9266],
    [-76.1396, 36.9230],
    [-76.1302, 36.9198],
    [-76.1196, 36.9161],
    [-76.0916, 36.9079],
    [-76.0826, 36.9122],
    [-76.0698, 36.9144],
    [-76.0580, 36.9170],
    [-76.0416, 36.9299],
    [-76.0299, 36.9321],
    [-76.0076, 36.9290],
    [-75.9922, 36.9154],
    [-75.9853, 36.8889],
    [-75.9770, 36.8595],
    [-75.9722, 36.8423],
    [-75.9655, 36.8124],
    [-75.9494, 36.7608],
    [-75.9217, 36.6921],
    [-75.9057, 36.6600],
    [-75.8899, 36.6277],
    [-75.8670, 36.5508],
    [-75.8797, 36.5508],
    [-75.8865, 36.5508],
    [-75.8941, 36.5508],
    [-75.9047, 36.5507],
    [-75.9114, 36.5507],
    [-75.9534, 36.5506],
    [-76.0267, 36.5506],
    [-76.0348, 36.5507],
    [-76.1931, 36.5506],
    [-76.3132, 36.5506],
    [-76.4653, 36.5510],
    [-76.5417, 36.5503],
    [-76.5755, 36.5507],
    [-76.7383, 36.5510],
    [-76.7813, 36.5507],
    [-76.9159, 36.5521],
    [-76.9161, 36.5438],
    [-77.0691, 36.5445],
    [-77.1248, 36.5440],
    [-77.1645, 36.5463],
    [-77.2052, 36.5446],
    [-77.2969, 36.5447],
    [-77.4987, 36.5451],
    [-77.5871, 36.5452],
    [-77.7497, 36.5455],
    [-77.8291, 36.5450],
    [-77.8753, 36.5448],
    [-77.8998, 36.5447],
    [-78.0389, 36.5442],
    [-78.0462, 36.5442],
    [-78.1297, 36.5438],
    [-78.1983, 36.5442],
    [-78.2467, 36.5443],
    [-78.3240, 36.5438],
    [-78.4363, 36.5427],
    [-78.4570, 36.5425],
    [-78.4767, 36.5421],
    [-78.5330, 36.5410],
    [-78.6053, 36.5411],
    [-78.6633, 36.5420],
    [-78.7341, 36.5419],
    [-78.7671, 36.5417],
    [-78.7963, 36.5417],
    [-78.9017, 36.5419],
    [-78.9202, 36.5420],
    [-78.9633, 36.5421],
    [-78.9718, 36.5421],
    [-79.1261, 36.5415],
    [-79.1468, 36.5417],
    [-79.2095, 36.5416],
    [-79.2497, 36.5411],
    [-79.3428, 36.5412],
    [-79.4008, 36.5412],
    [-79.4460, 36.5412],
    [-79.4700, 36.5410],
    [-79.5136, 36.5408],
    [-79.6289, 36.5415],
    [-79.7148, 36.5420],
    [-79.7715, 36.5423],
    [-79.8292, 36.5426],
    [-79.8873, 36.5428],
    [-79.9106, 36.5424],
    [-79.9670, 36.5425],
    [-79.9922, 36.5425],
    [-80.0535, 36.5425],
    [-80.1695, 36.5432],
    [-80.1730, 36.5432],
    [-80.2254, 36.5437],
    [-80.2948, 36.5440],
    [-80.3780, 36.5478],
    [-80.4401, 36.5506],
    [-80.5109, 36.5536],
    [-80.5635, 36.5558],
    [-80.6120, 36.5579],
    [-80.6329, 36.5586],
    [-80.6534, 36.5592],
    [-80.6719, 36.5603],
    [-80.7304, 36.5623],
    [-80.7737, 36.5603],
    [-80.8230, 36.5599],
    [-80.8380, 36.5591],
    [-80.9017, 36.5618],
    [-80.9443, 36.5631],
    [-81.0038, 36.5636],
    [-81.0619, 36.5670],
    [-81.0832, 36.5673],
    [-81.1418, 36.5695],
    [-81.1712, 36.5710],
    [-81.2040, 36.5724],
    [-81.3075, 36.5750],
    [-81.3533, 36.5747],
    [-81.4422, 36.5768],
    [-81.4894, 36.5790],
    [-81.5210, 36.5805],
    [-81.6179, 36.5873],
    [-81.7369, 36.6124],
    [-81.8267, 36.6142],
    [-81.9226, 36.6162],
    [-82.0195, 36.5944],
    [-82.0979, 36.5946],
    [-82.1385, 36.5947],
    [-82.1507, 36.5947],
    [-82.1738, 36.5946],
    [-82.1774, 36.5948],
    [-82.1807, 36.5949],
    [-82.1897, 36.5952],
    [-82.1981, 36.5954],
    [-82.2107, 36.5958],
    [-82.2234, 36.5957],
    [-82.2351, 36.5957],
    [-82.2658, 36.5957],
    [-82.2938, 36.5957],
    [-82.3869, 36.5951],
    [-82.4787, 36.5956],
    [-82.4938, 36.5957],
    [-82.5492, 36.5949],
    [-82.5611, 36.5948],
    [-82.5721, 36.5946],
    [-82.5934, 36.5943],
    [-82.6096, 36.5941],
    [-82.6541, 36.5938],
    [-82.6958, 36.5937],
    [-82.8304, 36.5938],
    [-82.9851, 36.5937],
    [-83.1017, 36.5939],
    [-83.2116, 36.5938],
    [-83.2499, 36.5939],
    [-83.2763, 36.5982],
    [-83.3468, 36.5976],
    [-83.4721, 36.5973],
    [-83.6221, 36.5981],
    [-83.6256, 36.5983],
    [-83.6604, 36.6005],
    [-83.6754, 36.6008],
    [-83.6746, 36.6031]
    ]
  },
  "West Virginia": {
    coordinates: [
      [-82.6432, 38.1691],
    [-82.6255, 38.1705],
    [-82.6113, 38.1715],
    [-82.5993, 38.1972],
    [-82.6004, 38.2189],
    [-82.6089, 38.2237],
    [-82.6123, 38.2361],
    [-82.6046, 38.2473],
    [-82.5861, 38.2456],
    [-82.5818, 38.2486],
    [-82.5746, 38.2747],
    [-82.5795, 38.2849],
    [-82.5831, 38.2968],
    [-82.5762, 38.3086],
    [-82.5754, 38.3230],
    [-82.5846, 38.3337],
    [-82.5925, 38.3417],
    [-82.5980, 38.3486],
    [-82.5975, 38.3648],
    [-82.5940, 38.3718],
    [-82.5935, 38.3803],
    [-82.5993, 38.3887],
    [-82.5947, 38.3978],
    [-82.5950, 38.4013],
    [-82.5963, 38.4177],
    [-82.5935, 38.4210],
    [-82.5876, 38.4127],
    [-82.5731, 38.4057],
    [-82.5498, 38.4032],
    [-82.5368, 38.4041],
    [-82.5214, 38.4073],
    [-82.4872, 38.4179],
    [-82.4712, 38.4219],
    [-82.4597, 38.4247],
    [-82.4360, 38.4297],
    [-82.4251, 38.4330],
    [-82.3921, 38.4351],
    [-82.3891, 38.4344],
    [-82.3739, 38.4362],
    [-82.3601, 38.4386],
    [-82.3406, 38.4409],
    [-82.3303, 38.4445],
    [-82.3181, 38.4579],
    [-82.3125, 38.4761],
    [-82.3064, 38.4907],
    [-82.3031, 38.5044],
    [-82.3035, 38.5200],
    [-82.3003, 38.5294],
    [-82.2933, 38.5603],
    [-82.2913, 38.5790],
    [-82.2734, 38.5942],
    [-82.2621, 38.5982],
    [-82.2222, 38.5914],
    [-82.2038, 38.5919],
    [-82.1820, 38.5994],
    [-82.1721, 38.6193],
    [-82.1743, 38.6332],
    [-82.1844, 38.6576],
    [-82.1866, 38.6686],
    [-82.1909, 38.6804],
    [-82.1844, 38.7010],
    [-82.1825, 38.7088],
    [-82.1866, 38.7225],
    [-82.1933, 38.7412],
    [-82.2015, 38.7604],
    [-82.2166, 38.7683],
    [-82.2215, 38.7798],
    [-82.2173, 38.7957],
    [-82.2093, 38.8027],
    [-82.1871, 38.8159],
    [-82.1616, 38.8246],
    [-82.1492, 38.8357],
    [-82.1449, 38.8405],
    [-82.1416, 38.8514],
    [-82.1403, 38.8590],
    [-82.1411, 38.8737],
    [-82.1453, 38.8835],
    [-82.1350, 38.9054],
    [-82.1210, 38.9211],
    [-82.1135, 38.9303],
    [-82.1108, 38.9390],
    [-82.1082, 38.9466],
    [-82.0989, 38.9583],
    [-82.0932, 38.9710],
    [-82.0860, 38.9776],
    [-82.0588, 38.9901],
    [-82.0492, 38.9973],
    [-82.0434, 39.0116],
    [-82.0388, 39.0227],
    [-82.0244, 39.0289],
    [-82.0107, 39.0298],
    [-82.0023, 39.0279],
    [-81.9939, 39.0213],
    [-81.9871, 39.0120],
    [-81.9838, 39.0055],
    [-81.9820, 38.9957],
    [-81.9775, 38.9927],
    [-81.9678, 38.9930],
    [-81.9593, 38.9952],
    [-81.9464, 38.9946],
    [-81.9358, 38.9896],
    [-81.9182, 38.9666],
    [-81.9113, 38.9526],
    [-81.8995, 38.9336],
    [-81.9009, 38.9243],
    [-81.9134, 38.9144],
    [-81.9267, 38.9013],
    [-81.9270, 38.8916],
    [-81.9086, 38.8785],
    [-81.8892, 38.8743],
    [-81.8589, 38.8902],
    [-81.8453, 38.9101],
    [-81.8445, 38.9287],
    [-81.8274, 38.9459],
    [-81.8209, 38.9469],
    [-81.8061, 38.9421],
    [-81.7856, 38.9262],
    [-81.7698, 38.9227],
    [-81.7600, 38.9258],
    [-81.7561, 38.9335],
    [-81.7576, 38.9371],
    [-81.7622, 38.9399],
    [-81.7671, 38.9463],
    [-81.7788, 38.9559],
    [-81.7816, 38.9636],
    [-81.7757, 38.9807],
    [-81.7756, 38.9901],
    [-81.7672, 39.0001],
    [-81.7643, 39.0153],
    [-81.7775, 39.0297],
    [-81.8004, 39.0450],
    [-81.8117, 39.0596],
    [-81.8142, 39.0735],
    [-81.8107, 39.0833],
    [-81.7982, 39.0829],
    [-81.7815, 39.0781],
    [-81.7608, 39.0841],
    [-81.7473, 39.0954],
    [-81.7439, 39.1024],
    [-81.7446, 39.1268],
    [-81.7436, 39.1419],
    [-81.7563, 39.1773],
    [-81.7537, 39.1835],
    [-81.7415, 39.1896],
    [-81.7358, 39.1963],
    [-81.7270, 39.2151],
    [-81.7191, 39.2176],
    [-81.6985, 39.2221],
    [-81.6914, 39.2279],
    [-81.6917, 39.2334],
    [-81.6966, 39.2461],
    [-81.6929, 39.2621],
    [-81.6836, 39.2709],
    [-81.6702, 39.2760],
    [-81.6432, 39.2772],
    [-81.6084, 39.2760],
    [-81.5952, 39.2734],
    [-81.5856, 39.2687],
    [-81.5702, 39.2677],
    [-81.5652, 39.2762],
    [-81.5651, 39.2907],
    [-81.5601, 39.3179],
    [-81.5575, 39.3388],
    [-81.5345, 39.3582],
    [-81.5135, 39.3670],
    [-81.4837, 39.3890],
    [-81.4809, 39.3918],
    [-81.4677, 39.4038],
    [-81.4465, 39.4104],
    [-81.4295, 39.4058],
    [-81.4273, 39.4045],
    [-81.4127, 39.3946],
    [-81.4028, 39.3769],
    [-81.3959, 39.3556],
    [-81.3846, 39.3434],
    [-81.3713, 39.3421],
    [-81.3476, 39.3458],
    [-81.3262, 39.3582],
    [-81.3043, 39.3708],
    [-81.2814, 39.3793],
    [-81.2703, 39.3859],
    [-81.2491, 39.3900],
    [-81.2236, 39.3861],
    [-81.2171, 39.3877],
    [-81.2117, 39.3930],
    [-81.2114, 39.4020],
    [-81.2082, 39.4071],
    [-81.2004, 39.4153],
    [-81.1907, 39.4236],
    [-81.1799, 39.4351],
    [-81.1525, 39.4432],
    [-81.1475, 39.4434],
    [-81.1325, 39.4463],
    [-81.1215, 39.4578],
    [-81.1008, 39.4872],
    [-81.0712, 39.5153],
    [-81.0551, 39.5269],
    [-81.0449, 39.5363],
    [-81.0302, 39.5452],
    [-81.0239, 39.5523],
    [-81.0087, 39.5628],
    [-80.9877, 39.5773],
    [-80.9732, 39.5879],
    [-80.9438, 39.6069],
    [-80.9258, 39.6174],
    [-80.9062, 39.6184],
    [-80.8922, 39.6168],
    [-80.8723, 39.6360],
    [-80.8708, 39.6401],
    [-80.8706, 39.6438],
    [-80.8659, 39.6593],
    [-80.8667, 39.6785],
    [-80.8644, 39.6900],
    [-80.8582, 39.6955],
    [-80.8447, 39.6994],
    [-80.8319, 39.7057],
    [-80.8297, 39.7140],
    [-80.8335, 39.7208],
    [-80.8461, 39.7378],
    [-80.8547, 39.7426],
    [-80.8676, 39.7571],
    [-80.8691, 39.7664],
    [-80.8469, 39.7842],
    [-80.8250, 39.8011],
    [-80.8222, 39.8117],
    [-80.8262, 39.8358],
    [-80.8243, 39.8472],
    [-80.7999, 39.8589],
    [-80.7902, 39.8723],
    [-80.7962, 39.8855],
    [-80.8090, 39.9032],
    [-80.8078, 39.9145],
    [-80.8034, 39.9188],
    [-80.7874, 39.9181],
    [-80.7683, 39.9096],
    [-80.7606, 39.9089],
    [-80.7564, 39.9139],
    [-80.7568, 39.9206],
    [-80.7645, 39.9466],
    [-80.7594, 39.9582],
    [-80.7570, 39.9603],
    [-80.7463, 39.9662],
    [-80.7397, 39.9746],
    [-80.7394, 39.9784],
    [-80.7400, 39.9939],
    [-80.7411, 39.9969],
    [-80.7419, 40.0079],
    [-80.7404, 40.0154],
    [-80.7373, 40.0230],
    [-80.7333, 40.0333],
    [-80.7314, 40.0391],
    [-80.7309, 40.0492],
    [-80.7312, 40.0503],
    [-80.7331, 40.0588],
    [-80.7371, 40.0650],
    [-80.7385, 40.0723],
    [-80.7351, 40.0818],
    [-80.7291, 40.0874],
    [-80.7102, 40.0996],
    [-80.7077, 40.1054],
    [-80.7076, 40.1154],
    [-80.7087, 40.1179],
    [-80.7104, 40.1281],
    [-80.7100, 40.1383],
    [-80.7064, 40.1494],
    [-80.7029, 40.1573],
    [-80.6875, 40.1796],
    [-80.6820, 40.1855],
    [-80.6791, 40.1868],
    [-80.6681, 40.1997],
    [-80.6643, 40.2192],
    [-80.6600, 40.2322],
    [-80.6521, 40.2450],
    [-80.6372, 40.2551],
    [-80.6225, 40.2618],
    [-80.6162, 40.2723],
    [-80.6150, 40.2916],
    [-80.6074, 40.3027],
    [-80.6019, 40.3105],
    [-80.6005, 40.3212],
    [-80.6076, 40.3356],
    [-80.6128, 40.3477],
    [-80.6087, 40.3620],
    [-80.6097, 40.3750],
    [-80.6192, 40.3818],
    [-80.6317, 40.3858],
    [-80.6297, 40.3950],
    [-80.6122, 40.4027],
    [-80.6127, 40.4077],
    [-80.6123, 40.4186],
    [-80.6115, 40.4370],
    [-80.6044, 40.4498],
    [-80.5983, 40.4584],
    [-80.5949, 40.4705],
    [-80.5980, 40.4803],
    [-80.6024, 40.4842],
    [-80.6180, 40.5020],
    [-80.6222, 40.5205],
    [-80.6275, 40.5358],
    [-80.6382, 40.5446],
    [-80.6553, 40.5652],
    [-80.6678, 40.5781],
    [-80.6626, 40.5916],
    [-80.6540, 40.5965],
    [-80.6445, 40.6043],
    [-80.6344, 40.6161],
    [-80.6160, 40.6217],
    [-80.5988, 40.6253],
    [-80.5891, 40.6201],
    [-80.5805, 40.6145],
    [-80.5752, 40.6146],
    [-80.5634, 40.6214],
    [-80.5511, 40.6288],
    [-80.5327, 40.6356],
    [-80.5219, 40.6370],
    [-80.5190, 40.6164],
    [-80.5191, 40.5902],
    [-80.5191, 40.5185],
    [-80.5190, 40.4774],
    [-80.5178, 40.4635],
    [-80.5179, 40.4234],
    [-80.5180, 40.3993],
    [-80.5180, 40.3680],
    [-80.5190, 40.3421],
    [-80.5190, 40.2817],
    [-80.5191, 40.1957],
    [-80.5191, 40.1597],
    [-80.5190, 40.1035],
    [-80.5190, 40.0958],
    [-80.5190, 40.0739],
    [-80.5192, 39.9634],
    [-80.5192, 39.9594],
    [-80.5192, 39.9370],
    [-80.5192, 39.8489],
    [-80.5194, 39.7917],
    [-80.4579, 39.7213],
    [-80.4034, 39.7212],
    [-80.2938, 39.7213],
    [-80.2436, 39.7213],
    [-80.2060, 39.7213],
    [-80.0848, 39.7213],
    [-80.0616, 39.7213],
    [-79.9163, 39.7209],
    [-79.8580, 39.7207],
    [-79.8531, 39.7207],
    [-79.7638, 39.7208],
    [-79.6329, 39.7212],
    [-79.5485, 39.7208],
    [-79.4766, 39.6637],
    [-79.4778, 39.6423],
    [-79.4786, 39.5561],
    [-79.4824, 39.5247],
    [-79.4828, 39.5098],
    [-79.4833, 39.4511],
    [-79.4836, 39.4190],
    [-79.4843, 39.3512],
    [-79.4861, 39.3443],
    [-79.4876, 39.2800],
    [-79.4868, 39.2758],
    [-79.4859, 39.2649],
    [-79.4732, 39.2021],
    [-79.4655, 39.2094],
    [-79.4546, 39.2102],
    [-79.4460, 39.2160],
    [-79.4326, 39.2241],
    [-79.4256, 39.2257],
    [-79.4205, 39.2357],
    [-79.4091, 39.2435],
    [-79.4002, 39.2509],
    [-79.3980, 39.2564],
    [-79.3929, 39.2618],
    [-79.3870, 39.2655],
    [-79.3845, 39.2674],
    [-79.3788, 39.2718],
    [-79.3613, 39.2749],
    [-79.3561, 39.2780],
    [-79.3521, 39.2806],
    [-79.3438, 39.2861],
    [-79.3470, 39.2906],
    [-79.3465, 39.2933],
    [-79.3443, 39.2935],
    [-79.3381, 39.2968],
    [-79.3218, 39.2999],
    [-79.3148, 39.3044],
    [-79.2990, 39.3001],
    [-79.2902, 39.3035],
    [-79.2820, 39.3230],
    [-79.2708, 39.3285],
    [-79.2676, 39.3363],
    [-79.2539, 39.3372],
    [-79.2573, 39.3423],
    [-79.2536, 39.3462],
    [-79.2567, 39.3550],
    [-79.2494, 39.3556],
    [-79.2393, 39.3593],
    [-79.2323, 39.3619],
    [-79.2288, 39.3645],
    [-79.2131, 39.3669],
    [-79.1989, 39.3863],
    [-79.1895, 39.3865],
    [-79.1810, 39.3866],
    [-79.1812, 39.3946],
    [-79.1714, 39.3912],
    [-79.1619, 39.3919],
    [-79.1645, 39.4057],
    [-79.1590, 39.4108],
    [-79.1553, 39.4183],
    [-79.1496, 39.4078],
    [-79.1438, 39.4052],
    [-79.1424, 39.4144],
    [-79.1365, 39.4189],
    [-79.1284, 39.4175],
    [-79.1294, 39.4266],
    [-79.1216, 39.4328],
    [-79.1106, 39.4327],
    [-79.1164, 39.4405],
    [-79.1042, 39.4484],
    [-79.1030, 39.4548],
    [-79.1079, 39.4571],
    [-79.1038, 39.4631],
    [-79.0970, 39.4682],
    [-79.1053, 39.4721],
    [-79.1005, 39.4770],
    [-79.0833, 39.4714],
    [-79.0678, 39.4768],
    [-79.0675, 39.4794],
    [-79.0642, 39.4784],
    [-79.0554, 39.4715],
    [-79.0541, 39.4790],
    [-79.0518, 39.4827],
    [-79.0469, 39.4831],
    [-79.0386, 39.4775],
    [-79.0356, 39.4733],
    [-79.0303, 39.4654],
    [-79.0205, 39.4670],
    [-79.0047, 39.4585],
    [-78.9900, 39.4526],
    [-78.9701, 39.4433],
    [-78.9580, 39.4400],
    [-78.9560, 39.4479],
    [-78.9551, 39.4534],
    [-78.9585, 39.4590],
    [-78.9533, 39.4636],
    [-78.9389, 39.4741],
    [-78.9415, 39.4769],
    [-78.9403, 39.4825],
    [-78.9336, 39.4862],
    [-78.9171, 39.4863],
    [-78.9138, 39.4938],
    [-78.9086, 39.4968],
    [-78.9055, 39.5115],
    [-78.8929, 39.5128],
    [-78.8934, 39.5220],
    [-78.8886, 39.5246],
    [-78.8768, 39.5212],
    [-78.8700, 39.5341],
    [-78.8692, 39.5394],
    [-78.8614, 39.5410],
    [-78.8510, 39.5540],
    [-78.8462, 39.5628],
    [-78.8403, 39.5661],
    [-78.8303, 39.5654],
    [-78.8168, 39.5617],
    [-78.8201, 39.5763],
    [-78.8260, 39.5888],
    [-78.8185, 39.5914],
    [-78.8122, 39.5977],
    [-78.8093, 39.6081],
    [-78.8040, 39.6072],
    [-78.7978, 39.6049],
    [-78.7959, 39.6141],
    [-78.8008, 39.6289],
    [-78.7968, 39.6321],
    [-78.7948, 39.6369],
    [-78.7840, 39.6367],
    [-78.7752, 39.6457],
    [-78.7658, 39.6485],
    [-78.7650, 39.6461],
    [-78.7681, 39.6393],
    [-78.7769, 39.6277],
    [-78.7775, 39.6217],
    [-78.7567, 39.6230],
    [-78.7401, 39.6237],
    [-78.7338, 39.6139],
    [-78.7471, 39.6057],
    [-78.7515, 39.6099],
    [-78.7769, 39.6040],
    [-78.7756, 39.5987],
    [-78.7705, 39.5950],
    [-78.7675, 39.5875],
    [-78.7518, 39.5818],
    [-78.7402, 39.5857],
    [-78.7331, 39.5837],
    [-78.7259, 39.5665],
    [-78.7148, 39.5626],
    [-78.7071, 39.5559],
    [-78.6920, 39.5508],
    [-78.6824, 39.5438],
    [-78.6640, 39.5368],
    [-78.6308, 39.5371],
    [-78.6286, 39.5392],
    [-78.6133, 39.5372],
    [-78.6049, 39.5326],
    [-78.5976, 39.5353],
    [-78.5903, 39.5364],
    [-78.5907, 39.5302],
    [-78.5827, 39.5276],
    [-78.5679, 39.5199],
    [-78.5528, 39.5214],
    [-78.5279, 39.5247],
    [-78.5214, 39.5248],
    [-78.4990, 39.5189],
    [-78.4840, 39.5195],
    [-78.4712, 39.5161],
    [-78.4610, 39.5260],
    [-78.4630, 39.5337],
    [-78.4575, 39.5384],
    [-78.4504, 39.5379],
    [-78.4506, 39.5440],
    [-78.4618, 39.5480],
    [-78.4576, 39.5514],
    [-78.4420, 39.5412],
    [-78.4351, 39.5417],
    [-78.4385, 39.5496],
    [-78.4351, 39.5534],
    [-78.4288, 39.5489],
    [-78.4200, 39.5454],
    [-78.4195, 39.5521],
    [-78.4382, 39.5635],
    [-78.4544, 39.5743],
    [-78.4572, 39.5874],
    [-78.4460, 39.5912],
    [-78.4230, 39.5841],
    [-78.4080, 39.5786],
    [-78.3953, 39.5842],
    [-78.4027, 39.5936],
    [-78.4206, 39.6032],
    [-78.4330, 39.6165],
    [-78.4303, 39.6233],
    [-78.4129, 39.6211],
    [-78.3836, 39.6089],
    [-78.3732, 39.6095],
    [-78.3791, 39.6181],
    [-78.3834, 39.6251],
    [-78.3732, 39.6305],
    [-78.3625, 39.6260],
    [-78.3539, 39.6277],
    [-78.3556, 39.6335],
    [-78.3583, 39.6397],
    [-78.3339, 39.6365],
    [-78.3082, 39.6296],
    [-78.2829, 39.6205],
    [-78.2668, 39.6188],
    [-78.2633, 39.6264],
    [-78.2467, 39.6448],
    [-78.2277, 39.6568],
    [-78.2239, 39.6626],
    [-78.2316, 39.6744],
    [-78.2029, 39.6767],
    [-78.1924, 39.6891],
    [-78.1828, 39.6951],
    [-78.1621, 39.6936],
    [-78.1435, 39.6904],
    [-78.1239, 39.6857],
    [-78.1017, 39.6803],
    [-78.0898, 39.6717],
    [-78.0823, 39.6712],
    [-78.0683, 39.6611],
    [-78.0499, 39.6453],
    [-78.0389, 39.6381],
    [-78.0239, 39.6217],
    [-78.0100, 39.6029],
    [-77.9916, 39.6002],
    [-77.9767, 39.5997],
    [-77.9690, 39.6058],
    [-77.9576, 39.6086],
    [-77.9509, 39.6012],
    [-77.9498, 39.5871],
    [-77.9390, 39.5871],
    [-77.9355, 39.6081],
    [-77.9446, 39.6168],
    [-77.9375, 39.6191],
    [-77.9260, 39.6076],
    [-77.9168, 39.6029],
    [-77.8919, 39.5980],
    [-77.8830, 39.5988],
    [-77.8811, 39.6062],
    [-77.8870, 39.6145],
    [-77.8687, 39.6111],
    [-77.8578, 39.6079],
    [-77.8428, 39.6073],
    [-77.8318, 39.6011],
    [-77.8298, 39.5873],
    [-77.8308, 39.5812],
    [-77.8347, 39.5688],
    [-77.8558, 39.5646],
    [-77.8727, 39.5639],
    [-77.8861, 39.5604],
    [-77.8886, 39.5581],
    [-77.8715, 39.5443],
    [-77.8643, 39.5348],
    [-77.8665, 39.5200],
    [-77.8637, 39.5150],
    [-77.8419, 39.5185],
    [-77.8391, 39.5311],
    [-77.8272, 39.5305],
    [-77.8236, 39.5241],
    [-77.8451, 39.5058],
    [-77.8479, 39.5013],
    [-77.8319, 39.4947],
    [-77.8078, 39.4902],
    [-77.7929, 39.4904],
    [-77.7865, 39.4966],
    [-77.7744, 39.4995],
    [-77.7684, 39.4978],
    [-77.7654, 39.4942],
    [-77.7671, 39.4913],
    [-77.7717, 39.4892],
    [-77.7955, 39.4818],
    [-77.7982, 39.4757],
    [-77.7896, 39.4678],
    [-77.7778, 39.4619],
    [-77.7835, 39.4601],
    [-77.7985, 39.4607],
    [-77.7931, 39.4514],
    [-77.7861, 39.4442],
    [-77.8029, 39.4393],
    [-77.8025, 39.4360],
    [-77.7965, 39.4323],
    [-77.7749, 39.4278],
    [-77.7587, 39.4268],
    [-77.7527, 39.4202],
    [-77.7364, 39.3927],
    [-77.7369, 39.3872],
    [-77.7497, 39.3842],
    [-77.7538, 39.3796],
    [-77.7441, 39.3644],
    [-77.7504, 39.3494],
    [-77.7611, 39.3425],
    [-77.7579, 39.3358],
    [-77.7544, 39.3334],
    [-77.7309, 39.3247],
    [-77.7274, 39.3217],
    [-77.7199, 39.3197],
    [-77.7349, 39.3124],
    [-77.7527, 39.2834],
    [-77.7531, 39.2773],
    [-77.7584, 39.2692],
    [-77.7618, 39.2630],
    [-77.7628, 39.2584],
    [-77.7690, 39.2564],
    [-77.7709, 39.2498],
    [-77.7709, 39.2382],
    [-77.7813, 39.2269],
    [-77.7936, 39.2101],
    [-77.7982, 39.2007],
    [-77.7979, 39.1928],
    [-77.8044, 39.1780],
    [-77.8064, 39.1719],
    [-77.8132, 39.1650],
    [-77.8229, 39.1478],
    [-77.8222, 39.1400],
    [-77.8491, 39.1458],
    [-77.9194, 39.1912],
    [-78.0073, 39.2479],
    [-78.0332, 39.2646],
    [-78.0817, 39.2953],
    [-78.1083, 39.3122],
    [-78.1359, 39.3304],
    [-78.1582, 39.3434],
    [-78.2054, 39.3751],
    [-78.2744, 39.4210],
    [-78.3470, 39.4660],
    [-78.3451, 39.4595],
    [-78.3473, 39.4477],
    [-78.3478, 39.4406],
    [-78.3467, 39.4276],
    [-78.3566, 39.4159],
    [-78.3579, 39.4042],
    [-78.3506, 39.3983],
    [-78.3493, 39.3966],
    [-78.3512, 39.3914],
    [-78.3479, 39.3905],
    [-78.3452, 39.3894],
    [-78.3548, 39.3716],
    [-78.3653, 39.3588],
    [-78.3576, 39.3567],
    [-78.3390, 39.3499],
    [-78.3425, 39.3468],
    [-78.3476, 39.3427],
    [-78.3463, 39.3391],
    [-78.3616, 39.3180],
    [-78.3716, 39.3077],
    [-78.3872, 39.2934],
    [-78.3915, 39.2853],
    [-78.3934, 39.2830],
    [-78.3970, 39.2817],
    [-78.3992, 39.2815],
    [-78.4029, 39.2786],
    [-78.4023, 39.2772],
    [-78.4142, 39.2639],
    [-78.4161, 39.2554],
    [-78.3999, 39.2442],
    [-78.4042, 39.2412],
    [-78.4179, 39.2175],
    [-78.4298, 39.2070],
    [-78.4371, 39.1998],
    [-78.4308, 39.1962],
    [-78.4260, 39.1941],
    [-78.4287, 39.1872],
    [-78.4271, 39.1843],
    [-78.4233, 39.1813],
    [-78.4139, 39.1753],
    [-78.4070, 39.1709],
    [-78.4126, 39.1600],
    [-78.4367, 39.1417],
    [-78.4599, 39.1134],
    [-78.4703, 39.1101],
    [-78.4773, 39.1094],
    [-78.4952, 39.1010],
    [-78.5081, 39.0886],
    [-78.5165, 39.0818],
    [-78.5227, 39.0711],
    [-78.5402, 39.0606],
    [-78.5477, 39.0541],
    [-78.5600, 39.0416],
    [-78.5651, 39.0259],
    [-78.5574, 39.0214],
    [-78.5549, 39.0151],
    [-78.5705, 39.0016],
    [-78.5829, 38.9854],
    [-78.5960, 38.9702],
    [-78.6017, 38.9646],
    [-78.6143, 38.9759],
    [-78.6199, 38.9813],
    [-78.6296, 38.9809],
    [-78.6325, 38.9747],
    [-78.6524, 38.9607],
    [-78.6621, 38.9457],
    [-78.6707, 38.9338],
    [-78.6816, 38.9258],
    [-78.6915, 38.9222],
    [-78.7126, 38.9087],
    [-78.7172, 38.9043],
    [-78.7209, 38.9098],
    [-78.7198, 38.9226],
    [-78.7171, 38.9360],
    [-78.7241, 38.9308],
    [-78.7389, 38.9273],
    [-78.7545, 38.9057],
    [-78.7728, 38.8937],
    [-78.7880, 38.8851],
    [-78.7962, 38.8746],
    [-78.8061, 38.8593],
    [-78.8151, 38.8416],
    [-78.8323, 38.8144],
    [-78.8637, 38.7718],
    [-78.8960, 38.7817],
    [-78.9949, 38.8495],
    [-78.9989, 38.8410],
    [-79.0052, 38.8299],
    [-79.0066, 38.8237],
    [-79.0168, 38.8200],
    [-79.0245, 38.8037],
    [-79.0273, 38.7921],
    [-79.0466, 38.7921],
    [-79.0557, 38.7830],
    [-79.0517, 38.7780],
    [-79.0538, 38.7723],
    [-79.0573, 38.7614],
    [-79.0649, 38.7544],
    [-79.0728, 38.7446],
    [-79.0797, 38.7347],
    [-79.0873, 38.7201],
    [-79.0926, 38.7001],
    [-79.0881, 38.6901],
    [-79.0879, 38.6738],
    [-79.0926, 38.6644],
    [-79.0930, 38.6595],
    [-79.1135, 38.6597],
    [-79.1223, 38.6598],
    [-79.1236, 38.6567],
    [-79.1289, 38.6555],
    [-79.1317, 38.6514],
    [-79.1355, 38.6437],
    [-79.1376, 38.6380],
    [-79.1467, 38.6258],
    [-79.1554, 38.6112],
    [-79.1592, 38.6012],
    [-79.1587, 38.5923],
    [-79.1680, 38.5787],
    [-79.1717, 38.5716],
    [-79.1741, 38.5667],
    [-79.1767, 38.5655],
    [-79.1890, 38.5474],
    [-79.2015, 38.5278],
    [-79.2070, 38.5035],
    [-79.2097, 38.4956],
    [-79.2106, 38.4929],
    [-79.2214, 38.4848],
    [-79.2243, 38.4777],
    [-79.2344, 38.4730],
    [-79.2419, 38.4571],
    [-79.2531, 38.4558],
    [-79.2560, 38.4530],
    [-79.2629, 38.4446],
    [-79.2674, 38.4383],
    [-79.2822, 38.4321],
    [-79.2825, 38.4292],
    [-79.2797, 38.4242],
    [-79.2856, 38.4192],
    [-79.2905, 38.4208],
    [-79.2978, 38.4164],
    [-79.3025, 38.4154],
    [-79.3072, 38.4139],
    [-79.3123, 38.4119],
    [-79.4766, 38.4572],
    [-79.5215, 38.5339],
    [-79.5334, 38.5462],
    [-79.5383, 38.5518],
    [-79.5663, 38.5625],
    [-79.6507, 38.5881],
    [-79.6555, 38.5824],
    [-79.6561, 38.5762],
    [-79.6582, 38.5730],
    [-79.6629, 38.5704],
    [-79.6607, 38.5662],
    [-79.6651, 38.5609],
    [-79.6669, 38.5383],
    [-79.6716, 38.5275],
    [-79.6630, 38.5187],
    [-79.6657, 38.5138],
    [-79.6691, 38.5110],
    [-79.6741, 38.5104],
    [-79.6816, 38.5045],
    [-79.6913, 38.4968],
    [-79.6976, 38.4872],
    [-79.6934, 38.4810],
    [-79.6990, 38.4751],
    [-79.6956, 38.4691],
    [-79.6884, 38.4569],
    [-79.6915, 38.4463],
    [-79.6917, 38.4364],
    [-79.6897, 38.4314],
    [-79.7090, 38.4096],
    [-79.7227, 38.3895],
    [-79.7317, 38.3734],
    [-79.7268, 38.3708],
    [-79.7260, 38.3632],
    [-79.7321, 38.3602],
    [-79.7441, 38.3540],
    [-79.7644, 38.3565],
    [-79.7659, 38.3517],
    [-79.7700, 38.3482],
    [-79.7681, 38.3462],
    [-79.7699, 38.3418],
    [-79.7860, 38.3309],
    [-79.7982, 38.3192],
    [-79.8087, 38.3094],
    [-79.8075, 38.3017],
    [-79.8029, 38.2928],
    [-79.7954, 38.2902],
    [-79.7889, 38.2687],
    [-79.7983, 38.2660],
    [-79.8120, 38.2604],
    [-79.8157, 38.2536],
    [-79.8196, 38.2482],
    [-79.8309, 38.2497],
    [-79.8342, 38.2429],
    [-79.8430, 38.2416],
    [-79.8503, 38.2333],
    [-79.8791, 38.2110],
    [-79.8880, 38.2074],
    [-79.8923, 38.2024],
    [-79.9061, 38.1890],
    [-79.9163, 38.1863],
    [-79.9212, 38.1804],
    [-79.9168, 38.1755],
    [-79.9179, 38.1684],
    [-79.9149, 38.1675],
    [-79.9164, 38.1630],
    [-79.9191, 38.1611],
    [-79.9186, 38.1581],
    [-79.9187, 38.1548],
    [-79.9255, 38.1502],
    [-79.9287, 38.1444],
    [-79.9427, 38.1343],
    [-79.9423, 38.1228],
    [-79.9344, 38.1097],
    [-79.9276, 38.1048],
    [-79.9342, 38.0977],
    [-79.9424, 38.0916],
    [-79.9544, 38.0804],
    [-79.9682, 38.0477],
    [-79.9738, 38.0387],
    [-79.9753, 38.0301],
    [-79.9803, 38.0276],
    [-79.9848, 38.0166],
    [-79.9950, 38.0079],
    [-79.9961, 38.0010],
    [-80.0089, 37.9908],
    [-80.0126, 37.9860],
    [-80.0362, 37.9679],
    [-80.0563, 37.9523],
    [-80.0666, 37.9472],
    [-80.0808, 37.9355],
    [-80.1029, 37.9189],
    [-80.1190, 37.9036],
    [-80.1177, 37.8977],
    [-80.1236, 37.8979],
    [-80.1310, 37.8907],
    [-80.1461, 37.8845],
    [-80.1526, 37.8831],
    [-80.1690, 37.8671],
    [-80.1767, 37.8540],
    [-80.1836, 37.8468],
    [-80.1864, 37.8377],
    [-80.2014, 37.8258],
    [-80.2065, 37.8160],
    [-80.2169, 37.8095],
    [-80.2292, 37.7947],
    [-80.2261, 37.7898],
    [-80.2242, 37.7875],
    [-80.2242, 37.7856],
    [-80.2221, 37.7818],
    [-80.2186, 37.7833],
    [-80.2157, 37.7789],
    [-80.2169, 37.7761],
    [-80.2230, 37.7773],
    [-80.2275, 37.7789],
    [-80.2320, 37.7756],
    [-80.2359, 37.7731],
    [-80.2414, 37.7694],
    [-80.2469, 37.7683],
    [-80.2513, 37.7630],
    [-80.2498, 37.7571],
    [-80.2574, 37.7561],
    [-80.2520, 37.7298],
    [-80.2581, 37.7206],
    [-80.2750, 37.7078],
    [-80.2961, 37.6918],
    [-80.2794, 37.6571],
    [-80.2675, 37.6461],
    [-80.2648, 37.6455],
    [-80.2545, 37.6423],
    [-80.2393, 37.6377],
    [-80.2260, 37.6201],
    [-80.2589, 37.5955],
    [-80.2824, 37.5855],
    [-80.3124, 37.5462],
    [-80.3244, 37.5411],
    [-80.3093, 37.5274],
    [-80.2829, 37.5328],
    [-80.3093, 37.5029],
    [-80.3271, 37.4954],
    [-80.3668, 37.4849],
    [-80.3720, 37.4741],
    [-80.3999, 37.4623],
    [-80.4430, 37.4381],
    [-80.4648, 37.4261],
    [-80.4949, 37.4351],
    [-80.4930, 37.4577],
    [-80.5151, 37.4786],
    [-80.5197, 37.4792],
    [-80.5235, 37.4769],
    [-80.5334, 37.4764],
    [-80.5398, 37.4745],
    [-80.5508, 37.4738],
    [-80.5663, 37.4666],
    [-80.5914, 37.4514],
    [-80.6221, 37.4360],
    [-80.6319, 37.4322],
    [-80.6374, 37.4294],
    [-80.6459, 37.4221],
    [-80.6641, 37.4142],
    [-80.6917, 37.4017],
    [-80.7155, 37.3907],
    [-80.7380, 37.3825],
    [-80.7599, 37.3749],
    [-80.7768, 37.3841],
    [-80.7833, 37.3928],
    [-80.7892, 37.3955],
    [-80.7921, 37.3957],
    [-80.8004, 37.3957],
    [-80.8025, 37.3966],
    [-80.8064, 37.4041],
    [-80.8364, 37.4244],
    [-80.8442, 37.4236],
    [-80.8532, 37.4269],
    [-80.8585, 37.4283],
    [-80.8596, 37.4296],
    [-80.8652, 37.4170],
    [-80.8832, 37.3839],
    [-80.8669, 37.3661],
    [-80.8690, 37.3386],
    [-80.9193, 37.3062],
    [-80.9381, 37.3003],
    [-80.9739, 37.2914],
    [-80.9813, 37.2935],
    [-80.9796, 37.3023],
    [-81.0085, 37.2961],
    [-81.0528, 37.2883],
    [-81.1126, 37.2785],
    [-81.1237, 37.2750],
    [-81.1670, 37.2629],
    [-81.1845, 37.2544],
    [-81.2327, 37.2400],
    [-81.2583, 37.2574],
    [-81.2654, 37.2622],
    [-81.2922, 37.2804],
    [-81.3622, 37.3377],
    [-81.3681, 37.3324],
    [-81.3680, 37.3294],
    [-81.3726, 37.3202],
    [-81.3802, 37.3178],
    [-81.3858, 37.3201],
    [-81.3943, 37.3164],
    [-81.3974, 37.3064],
    [-81.4022, 37.3017],
    [-81.4092, 37.2861],
    [-81.4108, 37.2818],
    [-81.4141, 37.2796],
    [-81.4160, 37.2767],
    [-81.4279, 37.2710],
    [-81.4349, 37.2734],
    [-81.4391, 37.2720],
    [-81.4442, 37.2715],
    [-81.4477, 37.2722],
    [-81.4491, 37.2696],
    [-81.4589, 37.2665],
    [-81.4600, 37.2625],
    [-81.4801, 37.2511],
    [-81.4957, 37.2524],
    [-81.4978, 37.2572],
    [-81.4990, 37.2579],
    [-81.5049, 37.2477],
    [-81.5073, 37.2338],
    [-81.5275, 37.2258],
    [-81.5452, 37.2202],
    [-81.5561, 37.2074],
    [-81.5584, 37.2081],
    [-81.5613, 37.2066],
    [-81.6786, 37.2025],
    [-81.6840, 37.2111],
    [-81.6951, 37.2136],
    [-81.7162, 37.2343],
    [-81.7262, 37.2405],
    [-81.7385, 37.2383],
    [-81.7443, 37.2442],
    [-81.7410, 37.2541],
    [-81.7418, 37.2548],
    [-81.7455, 37.2613],
    [-81.7513, 37.2651],
    [-81.7550, 37.2677],
    [-81.7577, 37.2719],
    [-81.7618, 37.2757],
    [-81.7652, 37.2751],
    [-81.7747, 37.2748],
    [-81.7794, 37.2800],
    [-81.7893, 37.2844],
    [-81.7936, 37.2822],
    [-81.8033, 37.2859],
    [-81.8092, 37.2830],
    [-81.8167, 37.2799],
    [-81.8345, 37.2818],
    [-81.8334, 37.2845],
    [-81.8423, 37.2856],
    [-81.8499, 37.2852],
    [-81.8541, 37.2914],
    [-81.8540, 37.3004],
    [-81.8560, 37.3067],
    [-81.8648, 37.3084],
    [-81.8654, 37.3101],
    [-81.8603, 37.3157],
    [-81.8727, 37.3233],
    [-81.8787, 37.3318],
    [-81.8809, 37.3311],
    [-81.8877, 37.3312],
    [-81.8948, 37.3314],
    [-81.8960, 37.3320],
    [-81.8995, 37.3411],
    [-81.9059, 37.3428],
    [-81.9079, 37.3438],
    [-81.9120, 37.3493],
    [-81.9207, 37.3554],
    [-81.9256, 37.3573],
    [-81.9267, 37.3646],
    [-81.9302, 37.3667],
    [-81.9339, 37.3727],
    [-81.9311, 37.3755],
    [-81.9325, 37.3773],
    [-81.9359, 37.3786],
    [-81.9341, 37.3840],
    [-81.9317, 37.3861],
    [-81.9336, 37.3892],
    [-81.9298, 37.3928],
    [-81.9308, 37.4017],
    [-81.9258, 37.4069],
    [-81.9325, 37.4152],
    [-81.9378, 37.4321],
    [-81.9388, 37.4405],
    [-81.9458, 37.4402],
    [-81.9541, 37.4469],
    [-81.9587, 37.4480],
    [-81.9612, 37.4478],
    [-81.9642, 37.4474],
    [-81.9663, 37.4467],
    [-81.9690, 37.4471],
    [-81.9693, 37.4503],
    [-81.9733, 37.4544],
    [-81.9748, 37.4561],
    [-81.9849, 37.4543],
    [-81.9876, 37.4587],
    [-81.9935, 37.4643],
    [-81.9961, 37.4715],
    [-81.9960, 37.4744],
    [-81.9930, 37.4798],
    [-81.9857, 37.4857],
    [-81.9776, 37.4846],
    [-81.9732, 37.4880],
    [-81.9707, 37.4899],
    [-81.9650, 37.4935],
    [-81.9527, 37.4923],
    [-81.9544, 37.4961],
    [-81.9518, 37.5020],
    [-81.9439, 37.5029],
    [-81.9412, 37.5095],
    [-81.9351, 37.5105],
    [-81.9278, 37.5122],
    [-81.9272, 37.5153],
    [-81.9321, 37.5183],
    [-81.9350, 37.5190],
    [-81.9370, 37.5142],
    [-81.9439, 37.5129],
    [-81.9438, 37.5196],
    [-81.9477, 37.5251],
    [-81.9440, 37.5310],
    [-81.9566, 37.5285],
    [-81.9569, 37.5343],
    [-81.9676, 37.5328],
    [-81.9654, 37.5412],
    [-81.9701, 37.5465],
    [-81.9825, 37.5418],
    [-81.9926, 37.5383],
    [-81.9969, 37.5428],
    [-82.0074, 37.5337],
    [-82.0159, 37.5343],
    [-82.0210, 37.5405],
    [-82.0369, 37.5427],
    [-82.0428, 37.5484],
    [-82.0448, 37.5418],
    [-82.0444, 37.5290],
    [-82.0485, 37.5340],
    [-82.0575, 37.5369],
    [-82.0644, 37.5369],
    [-82.0644, 37.5445],
    [-82.0750, 37.5558],
    [-82.1000, 37.5528],
    [-82.1048, 37.5531],
    [-82.1019, 37.5581],
    [-82.1107, 37.5587],
    [-82.1220, 37.5528],
    [-82.1305, 37.5518],
    [-82.1353, 37.5574],
    [-82.1344, 37.5629],
    [-82.1437, 37.5662],
    [-82.1435, 37.5704],
    [-82.1296, 37.5720],
    [-82.1243, 37.5778],
    [-82.1299, 37.5903],
    [-82.1464, 37.5926],
    [-82.1576, 37.5968],
    [-82.1586, 37.6095],
    [-82.1673, 37.6079],
    [-82.1695, 37.6132],
    [-82.1642, 37.6202],
    [-82.1695, 37.6220],
    [-82.1771, 37.6185],
    [-82.1816, 37.6222],
    [-82.1817, 37.6271],
    [-82.1728, 37.6340],
    [-82.1773, 37.6417],
    [-82.1747, 37.6465],
    [-82.1776, 37.6490],
    [-82.1880, 37.6476],
    [-82.1901, 37.6413],
    [-82.1860, 37.6284],
    [-82.2007, 37.6278],
    [-82.2027, 37.6263],
    [-82.2134, 37.6252],
    [-82.2202, 37.6339],
    [-82.2169, 37.6401],
    [-82.2236, 37.6443],
    [-82.2261, 37.6531],
    [-82.2342, 37.6563],
    [-82.2437, 37.6608],
    [-82.2571, 37.6567],
    [-82.2720, 37.6638],
    [-82.2818, 37.6751],
    [-82.2847, 37.6753],
    [-82.2918, 37.6691],
    [-82.2941, 37.6734],
    [-82.2967, 37.6781],
    [-82.3023, 37.6756],
    [-82.3045, 37.6772],
    [-82.2961, 37.6862],
    [-82.3015, 37.6908],
    [-82.2973, 37.6998],
    [-82.2975, 37.7035],
    [-82.3057, 37.7067],
    [-82.3107, 37.7133],
    [-82.3162, 37.7215],
    [-82.3189, 37.7338],
    [-82.3330, 37.7410],
    [-82.3275, 37.7494],
    [-82.3200, 37.7586],
    [-82.3130, 37.7607],
    [-82.3124, 37.7648],
    [-82.3274, 37.7622],
    [-82.3340, 37.7651],
    [-82.3235, 37.7722],
    [-82.3262, 37.7759],
    [-82.3360, 37.7745],
    [-82.3391, 37.7783],
    [-82.3405, 37.7861],
    [-82.3543, 37.7931],
    [-82.3639, 37.7950],
    [-82.3678, 37.8006],
    [-82.3764, 37.8022],
    [-82.3785, 37.8083],
    [-82.3866, 37.8182],
    [-82.3937, 37.8117],
    [-82.4017, 37.8101],
    [-82.3984, 37.8216],
    [-82.4079, 37.8355],
    [-82.4121, 37.8439],
    [-82.4195, 37.8458],
    [-82.4199, 37.8487],
    [-82.4169, 37.8570],
    [-82.4240, 37.8632],
    [-82.4090, 37.8658],
    [-82.4079, 37.8681],
    [-82.4168, 37.8696],
    [-82.4193, 37.8751],
    [-82.4226, 37.8867],
    [-82.4353, 37.8968],
    [-82.4473, 37.9039],
    [-82.4523, 37.9087],
    [-82.4600, 37.9095],
    [-82.4629, 37.9148],
    [-82.4689, 37.9110],
    [-82.4711, 37.8994],
    [-82.4761, 37.9021],
    [-82.4742, 37.9081],
    [-82.4793, 37.9148],
    [-82.4883, 37.9177],
    [-82.4803, 37.9258],
    [-82.4973, 37.9276],
    [-82.5004, 37.9365],
    [-82.4907, 37.9360],
    [-82.4967, 37.9416],
    [-82.4977, 37.9457],
    [-82.4878, 37.9453],
    [-82.4751, 37.9549],
    [-82.4727, 37.9607],
    [-82.4850, 37.9644],
    [-82.4694, 37.9731],
    [-82.4643, 37.9834],
    [-82.4731, 37.9866],
    [-82.4861, 37.9905],
    [-82.4892, 37.9990],
    [-82.5082, 38.0014],
    [-82.5130, 37.9993],
    [-82.5191, 38.0020],
    [-82.5180, 38.0073],
    [-82.5258, 38.0196],
    [-82.5304, 38.0288],
    [-82.5386, 38.0374],
    [-82.5373, 38.0452],
    [-82.5439, 38.0521],
    [-82.5473, 38.0611],
    [-82.5507, 38.0701],
    [-82.5657, 38.0806],
    [-82.5855, 38.0943],
    [-82.5878, 38.1089],
    [-82.5947, 38.1121],
    [-82.6012, 38.1178],
    [-82.6066, 38.1208],
    [-82.6161, 38.1202],
    [-82.6212, 38.1232],
    [-82.6262, 38.1348],
    [-82.6365, 38.1379],
    [-82.6384, 38.1522],
    [-82.6432, 38.1691]
    ]
  },
  "Louisiana": {
    coordinates: [
      [-94.0431, 32.6930],
    [-94.0429, 32.7680],
    [-94.0428, 32.7853],
    [-94.0430, 32.8190],
    [-94.0429, 32.8810],
    [-94.0429, 32.8989],
    [-94.0431, 32.9556],
    [-94.0430, 33.0192],
    [-94.0280, 33.0191],
    [-93.8958, 33.0193],
    [-93.8049, 33.0194],
    [-93.6749, 33.0193],
    [-93.5254, 33.0186],
    [-93.5210, 33.0186],
    [-93.4909, 33.0184],
    [-93.4671, 33.0186],
    [-93.4376, 33.0185],
    [-93.3921, 33.0183],
    [-93.3084, 33.0182],
    [-93.2232, 33.0183],
    [-93.1579, 33.0179],
    [-93.1014, 33.0177],
    [-93.0732, 33.0179],
    [-92.9887, 33.0173],
    [-92.9466, 33.0168],
    [-92.8542, 33.0161],
    [-92.8308, 33.0157],
    [-92.7332, 33.0143],
    [-92.7236, 33.0143],
    [-92.7115, 33.0143],
    [-92.7029, 33.0142],
    [-92.5380, 33.0125],
    [-92.5038, 33.0122],
    [-92.4698, 33.0120],
    [-92.3919, 33.0110],
    [-92.3629, 33.0106],
    [-92.2228, 33.0091],
    [-92.0691, 33.0082],
    [-91.9520, 33.0074],
    [-91.8751, 33.0077],
    [-91.7551, 33.0070],
    [-91.6563, 33.0069],
    [-91.6237, 33.0067],
    [-91.5798, 33.0065],
    [-91.5595, 33.0068],
    [-91.4604, 33.0059],
    [-91.4255, 33.0060],
    [-91.3330, 33.0055],
    [-91.3250, 33.0054],
    [-91.3120, 33.0053],
    [-91.2844, 33.0050],
    [-91.1662, 33.0022],
    [-91.1822, 32.9786],
    [-91.1996, 32.9636],
    [-91.2012, 32.9550],
    [-91.2107, 32.9398],
    [-91.2140, 32.9272],
    [-91.2083, 32.9154],
    [-91.1816, 32.9014],
    [-91.1600, 32.8999],
    [-91.1340, 32.9177],
    [-91.1313, 32.9300],
    [-91.1372, 32.9565],
    [-91.1312, 32.9609],
    [-91.1330, 32.9665],
    [-91.1355, 32.9797],
    [-91.1118, 32.9884],
    [-91.0943, 32.9844],
    [-91.0804, 32.9628],
    [-91.0819, 32.9494],
    [-91.0804, 32.9432],
    [-91.0648, 32.9265],
    [-91.0646, 32.9180],
    [-91.0638, 32.9039],
    [-91.0682, 32.8919],
    [-91.1056, 32.8584],
    [-91.1279, 32.8551],
    [-91.1450, 32.8429],
    [-91.1572, 32.8238],
    [-91.1616, 32.8083],
    [-91.1631, 32.7922],
    [-91.1569, 32.7803],
    [-91.1658, 32.7578],
    [-91.1586, 32.7434],
    [-91.1317, 32.7431],
    [-91.0906, 32.7361],
    [-91.0570, 32.7256],
    [-91.0547, 32.7192],
    [-91.0761, 32.6938],
    [-91.1044, 32.6824],
    [-91.1309, 32.6589],
    [-91.1420, 32.6493],
    [-91.1521, 32.6415],
    [-91.1538, 32.6313],
    [-91.1513, 32.6159],
    [-91.1411, 32.5972],
    [-91.1251, 32.5852],
    [-91.1128, 32.5902],
    [-91.0795, 32.6007],
    [-91.0489, 32.6136],
    [-91.0404, 32.6325],
    [-91.0258, 32.6466],
    [-91.0068, 32.6313],
    [-91.0030, 32.6147],
    [-91.0137, 32.5984],
    [-91.0310, 32.5833],
    [-91.0493, 32.5736],
    [-91.0804, 32.5564],
    [-91.0512, 32.5309],
    [-90.9949, 32.5086],
    [-90.9876, 32.4924],
    [-90.9964, 32.4839],
    [-91.0171, 32.4837],
    [-91.0381, 32.4904],
    [-91.0605, 32.5124],
    [-91.0937, 32.5491],
    [-91.0988, 32.5330],
    [-91.1167, 32.5001],
    [-91.1121, 32.4761],
    [-91.0818, 32.4504],
    [-91.0296, 32.4335],
    [-91.0048, 32.4457],
    [-90.9834, 32.4491],
    [-90.9686, 32.4381],
    [-90.9660, 32.4248],
    [-90.9711, 32.4146],
    [-90.9941, 32.4039],
    [-90.9962, 32.3881],
    [-91.0045, 32.3647],
    [-90.9936, 32.3540],
    [-90.9430, 32.3460],
    [-90.9124, 32.3395],
    [-90.8921, 32.3706],
    [-90.8783, 32.3745],
    [-90.8822, 32.3576],
    [-90.8879, 32.3491],
    [-90.9012, 32.3234],
    [-90.9065, 32.3140],
    [-90.9234, 32.2978],
    [-90.9478, 32.2835],
    [-90.9554, 32.2862],
    [-90.9641, 32.2969],
    [-90.9762, 32.2965],
    [-90.9841, 32.2800],
    [-90.9797, 32.2653],
    [-90.9700, 32.2517],
    [-90.9831, 32.2314],
    [-90.9890, 32.2013],
    [-90.9952, 32.1921],
    [-91.0025, 32.1959],
    [-91.0029, 32.2231],
    [-91.0266, 32.2387],
    [-91.0465, 32.2411],
    [-91.0518, 32.2344],
    [-91.0614, 32.2186],
    [-91.0837, 32.2264],
    [-91.1085, 32.2081],
    [-91.1173, 32.2067],
    [-91.1302, 32.2137],
    [-91.1621, 32.1990],
    [-91.1710, 32.1765],
    [-91.1735, 32.1490],
    [-91.1655, 32.1343],
    [-91.1444, 32.1304],
    [-91.1139, 32.1257],
    [-91.1037, 32.1300],
    [-91.0816, 32.1340],
    [-91.0616, 32.1269],
    [-91.0502, 32.1453],
    [-91.0557, 32.1638],
    [-91.0502, 32.1785],
    [-91.0250, 32.1626],
    [-91.0041, 32.1462],
    [-91.0118, 32.1312],
    [-91.0270, 32.1211],
    [-91.0307, 32.1143],
    [-91.0386, 32.0983],
    [-91.0815, 32.0778],
    [-91.0802, 32.0484],
    [-91.1037, 32.0503],
    [-91.1286, 32.0766],
    [-91.1451, 32.0814],
    [-91.1603, 32.0704],
    [-91.1620, 32.0624],
    [-91.1563, 32.0527],
    [-91.1251, 32.0429],
    [-91.0844, 32.0315],
    [-91.0799, 32.0183],
    [-91.0961, 31.9949],
    [-91.1644, 31.9826],
    [-91.1805, 31.9701],
    [-91.1891, 31.9575],
    [-91.1932, 31.9357],
    [-91.1847, 31.9351],
    [-91.1849, 31.9238],
    [-91.1812, 31.9175],
    [-91.1892, 31.9143],
    [-91.1926, 31.9102],
    [-91.2010, 31.9092],
    [-91.2088, 31.9005],
    [-91.2481, 31.8698],
    [-91.2670, 31.8637],
    [-91.2688, 31.8552],
    [-91.2611, 31.8461],
    [-91.2474, 31.8223],
    [-91.2620, 31.8094],
    [-91.2802, 31.8132],
    [-91.2878, 31.8242],
    [-91.2893, 31.8469],
    [-91.3269, 31.8550],
    [-91.3430, 31.8469],
    [-91.3595, 31.7994],
    [-91.3552, 31.7581],
    [-91.3013, 31.7667],
    [-91.2663, 31.7682],
    [-91.2634, 31.7545],
    [-91.3107, 31.7491],
    [-91.3387, 31.7500],
    [-91.3718, 31.7429],
    [-91.3971, 31.7114],
    [-91.4001, 31.6882],
    [-91.3961, 31.6393],
    [-91.4010, 31.6204],
    [-91.4296, 31.6114],
    [-91.4743, 31.6254],
    [-91.4875, 31.6371],
    [-91.4945, 31.6450],
    [-91.5073, 31.6391],
    [-91.5167, 31.6273],
    [-91.5166, 31.6118],
    [-91.5028, 31.5957],
    [-91.4852, 31.5862],
    [-91.4663, 31.5861],
    [-91.4363, 31.5950],
    [-91.4171, 31.5963],
    [-91.4043, 31.5863],
    [-91.4078, 31.5696],
    [-91.4199, 31.5589],
    [-91.4264, 31.5546],
    [-91.4500, 31.5397],
    [-91.4797, 31.5304],
    [-91.4896, 31.5343],
    [-91.5112, 31.5326],
    [-91.5180, 31.5281],
    [-91.5229, 31.5198],
    [-91.5168, 31.5118],
    [-91.5171, 31.4984],
    [-91.5151, 31.4492],
    [-91.5064, 31.4315],
    [-91.4802, 31.4044],
    [-91.4721, 31.3914],
    [-91.4711, 31.3769],
    [-91.5042, 31.3650],
    [-91.5218, 31.3752],
    [-91.5395, 31.4140],
    [-91.5371, 31.4242],
    [-91.5450, 31.4330],
    [-91.5548, 31.4286],
    [-91.5763, 31.4105],
    [-91.5739, 31.3909],
    [-91.5626, 31.3832],
    [-91.5524, 31.3857],
    [-91.5499, 31.3763],
    [-91.5489, 31.3540],
    [-91.5361, 31.3384],
    [-91.5185, 31.3233],
    [-91.5080, 31.3129],
    [-91.5121, 31.2842],
    [-91.5377, 31.2674],
    [-91.5745, 31.2613],
    [-91.6214, 31.2678],
    [-91.6487, 31.2622],
    [-91.6550, 31.2518],
    [-91.6444, 31.2344],
    [-91.5950, 31.2020],
    [-91.5889, 31.1890],
    [-91.5915, 31.1731],
    [-91.6042, 31.1545],
    [-91.6251, 31.1319],
    [-91.6260, 31.1169],
    [-91.6148, 31.1044],
    [-91.5676, 31.0702],
    [-91.5599, 31.0541],
    [-91.5644, 31.0390],
    [-91.5905, 31.0173],
    [-91.6369, 30.9994],
    [-91.5387, 30.9994],
    [-91.4873, 30.9990],
    [-91.4146, 30.9990],
    [-91.3482, 30.9992],
    [-91.2315, 30.9993],
    [-91.1762, 30.9991],
    [-91.1081, 30.9989],
    [-91.0602, 30.9990],
    [-90.9702, 30.9993],
    [-90.8349, 30.9994],
    [-90.7837, 30.9994],
    [-90.7693, 30.9994],
    [-90.7346, 30.9992],
    [-90.6512, 30.9995],
    [-90.5887, 30.9996],
    [-90.5835, 30.9997],
    [-90.4867, 30.9997],
    [-90.4773, 30.9997],
    [-90.4633, 30.9998],
    [-90.4569, 30.9998],
    [-90.4417, 30.9997],
    [-90.4221, 30.9998],
    [-90.3556, 31.0003],
    [-90.3460, 31.0004],
    [-90.1944, 31.0009],
    [-90.1643, 31.0010],
    [-90.1284, 31.0010],
    [-90.0731, 31.0012],
    [-90.0296, 31.0012],
    [-90.0053, 31.0014],
    [-89.9728, 31.0014],
    [-89.9231, 31.0014],
    [-89.8637, 31.0020],
    [-89.8355, 31.0021],
    [-89.7998, 31.0020],
    [-89.7515, 30.9997],
    [-89.7452, 31.0023],
    [-89.7296, 31.0039],
    [-89.7281, 31.0010],
    [-89.7342, 30.9956],
    [-89.7277, 30.9933],
    [-89.7322, 30.9781],
    [-89.7371, 30.9761],
    [-89.7271, 30.9697],
    [-89.7293, 30.9662],
    [-89.7357, 30.9666],
    [-89.7512, 30.9514],
    [-89.7558, 30.9395],
    [-89.7489, 30.9328],
    [-89.7528, 30.9254],
    [-89.7452, 30.9224],
    [-89.7467, 30.9158],
    [-89.7574, 30.9150],
    [-89.7642, 30.9119],
    [-89.7616, 30.9066],
    [-89.7570, 30.8989],
    [-89.7651, 30.8969],
    [-89.7731, 30.8983],
    [-89.7700, 30.8823],
    [-89.7781, 30.8796],
    [-89.7780, 30.8734],
    [-89.7680, 30.8639],
    [-89.7747, 30.8533],
    [-89.7834, 30.8560],
    [-89.7838, 30.8521],
    [-89.7806, 30.8455],
    [-89.7856, 30.8475],
    [-89.7895, 30.8514],
    [-89.7919, 30.8487],
    [-89.7901, 30.8380],
    [-89.7894, 30.8305],
    [-89.7823, 30.8326],
    [-89.7857, 30.8259],
    [-89.7864, 30.8212],
    [-89.7812, 30.8201],
    [-89.7917, 30.8204],
    [-89.7940, 30.8179],
    [-89.7962, 30.8181],
    [-89.7966, 30.8216],
    [-89.8000, 30.8191],
    [-89.7972, 30.8118],
    [-89.8004, 30.8104],
    [-89.8046, 30.8025],
    [-89.8107, 30.7994],
    [-89.8109, 30.7974],
    [-89.8062, 30.7934],
    [-89.8051, 30.7906],
    [-89.8121, 30.7884],
    [-89.8139, 30.7938],
    [-89.8192, 30.7952],
    [-89.8215, 30.7912],
    [-89.8201, 30.7824],
    [-89.8304, 30.7798],
    [-89.8288, 30.7687],
    [-89.8322, 30.7651],
    [-89.8293, 30.7606],
    [-89.8326, 30.7560],
    [-89.8266, 30.7531],
    [-89.8258, 30.7473],
    [-89.8277, 30.7384],
    [-89.8195, 30.7407],
    [-89.8165, 30.7379],
    [-89.8274, 30.7362],
    [-89.8358, 30.7359],
    [-89.8363, 30.7272],
    [-89.8301, 30.7163],
    [-89.8458, 30.7073],
    [-89.8459, 30.7042],
    [-89.8393, 30.7041],
    [-89.8358, 30.6984],
    [-89.8450, 30.6747],
    [-89.8438, 30.6688],
    [-89.8406, 30.6729],
    [-89.8388, 30.6691],
    [-89.8456, 30.6636],
    [-89.8505, 30.6648],
    [-89.8410, 30.6585],
    [-89.8250, 30.6494],
    [-89.8206, 30.6448],
    [-89.8205, 30.6383],
    [-89.8139, 30.6368],
    [-89.8206, 30.6284],
    [-89.8233, 30.6228],
    [-89.8303, 30.6198],
    [-89.8299, 30.6167],
    [-89.8214, 30.6198],
    [-89.8233, 30.6082],
    [-89.8154, 30.6086],
    [-89.8181, 30.6050],
    [-89.8172, 30.6009],
    [-89.8143, 30.5971],
    [-89.8198, 30.5953],
    [-89.8140, 30.5916],
    [-89.8114, 30.5866],
    [-89.8078, 30.5858],
    [-89.8137, 30.5860],
    [-89.8129, 30.5817],
    [-89.8072, 30.5732],
    [-89.8080, 30.5680],
    [-89.7999, 30.5694],
    [-89.7957, 30.5657],
    [-89.7914, 30.5655],
    [-89.7896, 30.5704],
    [-89.7877, 30.5664],
    [-89.8003, 30.5637],
    [-89.8039, 30.5606],
    [-89.7945, 30.5566],
    [-89.7940, 30.5483],
    [-89.8039, 30.5493],
    [-89.7910, 30.5450],
    [-89.7802, 30.5446],
    [-89.7716, 30.5302],
    [-89.7681, 30.5150],
    [-89.7586, 30.5059],
    [-89.7464, 30.5026],
    [-89.7346, 30.4947],
    [-89.7246, 30.4919],
    [-89.7197, 30.4832],
    [-89.7102, 30.4783],
    [-89.7018, 30.4651],
    [-89.6953, 30.4629],
    [-89.6898, 30.4593],
    [-89.6848, 30.4395],
    [-89.6805, 30.4289],
    [-89.6812, 30.4115],
    [-89.6837, 30.4059],
    [-89.6728, 30.3893],
    [-89.6622, 30.3713],
    [-89.6527, 30.3555],
    [-89.6452, 30.3481],
    [-89.6304, 30.3329],
    [-89.6262, 30.3143],
    [-89.6399, 30.3073],
    [-89.6416, 30.3034],
    [-89.6453, 30.2926],
    [-89.6434, 30.2877],
    [-89.6326, 30.2807],
    [-89.6324, 30.2715],
    [-89.6296, 30.2673],
    [-89.6262, 30.2623],
    [-89.6322, 30.2601],
    [-89.6239, 30.2499],
    [-89.6142, 30.2446],
    [-89.6159, 30.2353],
    [-89.6159, 30.2232],
    [-89.6077, 30.2171],
    [-89.5956, 30.2103],
    [-89.5874, 30.1952],
    [-89.5745, 30.1817],
    [-89.5547, 30.1858],
    [-89.5470, 30.1931],
    [-89.5334, 30.1948],
    [-89.5245, 30.1808],
    [-89.5388, 30.1818],
    [-89.5691, 30.1727],
    [-89.5871, 30.1506],
    [-89.6175, 30.1564],
    [-89.6285, 30.1500],
    [-89.6350, 30.1432],
    [-89.6570, 30.1184],
    [-89.6692, 30.1107],
    [-89.6807, 30.1046],
    [-89.6982, 30.0707],
    [-89.7209, 30.0684],
    [-89.7330, 30.0527],
    [-89.7172, 30.0284],
    [-89.7333, 30.0221],
    [-89.7465, 30.0326],
    [-89.7582, 30.0410],
    [-89.7936, 30.0470],
    [-89.8211, 30.0411],
    [-89.8526, 30.0100],
    [-89.8570, 30.0018],
    [-89.8523, 29.9776],
    [-89.8385, 29.9458],
    [-89.8078, 29.9317],
    [-89.7746, 29.9369],
    [-89.7473, 29.9455],
    [-89.7148, 29.9470],
    [-89.7427, 29.9359],
    [-89.7449, 29.9079],
    [-89.7205, 29.8900],
    [-89.6886, 29.8676],
    [-89.6703, 29.8647],
    [-89.6348, 29.8632],
    [-89.5964, 29.8796],
    [-89.5923, 29.9173],
    [-89.5816, 29.9459],
    [-89.5719, 29.9711],
    [-89.5801, 29.9905],
    [-89.5513, 30.0057],
    [-89.5016, 30.0340],
    [-89.4927, 30.0452],
    [-89.4930, 30.0645],
    [-89.4804, 30.0745],
    [-89.4564, 30.0589],
    [-89.4311, 30.0518],
    [-89.4371, 30.0361],
    [-89.4155, 30.0439],
    [-89.3805, 30.0522],
    [-89.3803, 30.0416],
    [-89.3746, 30.0326],
    [-89.3893, 30.0300],
    [-89.4078, 30.0239],
    [-89.4021, 30.0093],
    [-89.4045, 30.0046],
    [-89.4136, 30.0232],
    [-89.4235, 30.0169],
    [-89.4300, 30.0289],
    [-89.4445, 30.0233],
    [-89.4349, 30.0130],
    [-89.4487, 30.0118],
    [-89.4535, 29.9939],
    [-89.4366, 29.9832],
    [-89.4259, 29.9714],
    [-89.4240, 29.9688],
    [-89.4102, 29.9646],
    [-89.3905, 29.9626],
    [-89.3865, 29.9560],
    [-89.3979, 29.9548],
    [-89.3805, 29.9416],
    [-89.3724, 29.9012],
    [-89.3556, 29.8962],
    [-89.3443, 29.9115],
    [-89.3270, 29.9180],
    [-89.2982, 29.9525],
    [-89.2758, 29.9776],
    [-89.2733, 29.9938],
    [-89.2478, 29.9973],
    [-89.2500, 29.9756],
    [-89.2255, 29.9671],
    [-89.2324, 29.9304],
    [-89.2631, 29.9295],
    [-89.2862, 29.9226],
    [-89.2988, 29.9093],
    [-89.3157, 29.9023],
    [-89.3349, 29.8861],
    [-89.3351, 29.8728],
    [-89.2966, 29.8795],
    [-89.2605, 29.8842],
    [-89.2403, 29.8786],
    [-89.2581, 29.8670],
    [-89.2709, 29.8521],
    [-89.2912, 29.8602],
    [-89.3060, 29.8657],
    [-89.3152, 29.8528],
    [-89.3087, 29.8411],
    [-89.3122, 29.8264],
    [-89.3241, 29.8264],
    [-89.3344, 29.8327],
    [-89.3384, 29.8399],
    [-89.3294, 29.8432],
    [-89.3633, 29.8458],
    [-89.3832, 29.8292],
    [-89.3623, 29.8267],
    [-89.3493, 29.8208],
    [-89.3564, 29.8114],
    [-89.3446, 29.7977],
    [-89.3365, 29.7852],
    [-89.3184, 29.7837],
    [-89.2990, 29.7988],
    [-89.2929, 29.7753],
    [-89.2951, 29.7604],
    [-89.3104, 29.7635],
    [-89.3328, 29.7799],
    [-89.3606, 29.7814],
    [-89.3760, 29.7886],
    [-89.4003, 29.7857],
    [-89.4120, 29.7596],
    [-89.4255, 29.7312],
    [-89.4224, 29.7067],
    [-89.3877, 29.6838],
    [-89.3939, 29.6808],
    [-89.4242, 29.6976],
    [-89.4403, 29.6820],
    [-89.4338, 29.6564],
    [-89.4656, 29.6517],
    [-89.4625, 29.6798],
    [-89.4764, 29.7064],
    [-89.4916, 29.7239],
    [-89.5120, 29.7277],
    [-89.5201, 29.7064],
    [-89.5077, 29.6920],
    [-89.5249, 29.6828],
    [-89.5141, 29.6712],
    [-89.5315, 29.6664],
    [-89.5080, 29.6468],
    [-89.5005, 29.6341],
    [-89.5076, 29.6364],
    [-89.5249, 29.6459],
    [-89.5319, 29.6515],
    [-89.5461, 29.6529],
    [-89.5654, 29.6593],
    [-89.6008, 29.6411],
    [-89.6327, 29.6442],
    [-89.6616, 29.6464],
    [-89.6590, 29.6372],
    [-89.6299, 29.6289],
    [-89.6211, 29.6103],
    [-89.6119, 29.6101],
    [-89.6092, 29.5971],
    [-89.6111, 29.5865],
    [-89.6380, 29.6117],
    [-89.6747, 29.6266],
    [-89.6820, 29.6169],
    [-89.6737, 29.5983],
    [-89.6504, 29.5869],
    [-89.6447, 29.5725],
    [-89.6845, 29.5633],
    [-89.6772, 29.5377],
    [-89.6573, 29.5227],
    [-89.6291, 29.5024],
    [-89.6092, 29.4898],
    [-89.5931, 29.4943],
    [-89.5673, 29.4834],
    [-89.5590, 29.4617],
    [-89.5452, 29.4511],
    [-89.5228, 29.4562],
    [-89.5355, 29.4508],
    [-89.5388, 29.4317],
    [-89.5218, 29.4138],
    [-89.5223, 29.3987],
    [-89.5407, 29.4050],
    [-89.5528, 29.4095],
    [-89.5613, 29.3952],
    [-89.5464, 29.3927],
    [-89.5123, 29.3823],
    [-89.4873, 29.3933],
    [-89.4743, 29.3983],
    [-89.4470, 29.3893],
    [-89.4221, 29.3884],
    [-89.4217, 29.3763],
    [-89.4076, 29.3861],
    [-89.3837, 29.3884],
    [-89.3604, 29.3793],
    [-89.3326, 29.3798],
    [-89.3208, 29.3551],
    [-89.3194, 29.3780],
    [-89.3201, 29.3887],
    [-89.3078, 29.3811],
    [-89.2929, 29.3679],
    [-89.2667, 29.3499],
    [-89.2535, 29.3228],
    [-89.2297, 29.3074],
    [-89.2197, 29.3244],
    [-89.1878, 29.3420],
    [-89.1729, 29.3244],
    [-89.1403, 29.2911],
    [-89.1297, 29.2656],
    [-89.1208, 29.2436],
    [-89.1306, 29.2266],
    [-89.1153, 29.2127],
    [-89.1027, 29.1998],
    [-89.0913, 29.1911],
    [-89.0711, 29.1936],
    [-89.0540, 29.2017],
    [-89.0360, 29.2089],
    [-89.0260, 29.2152],
    [-89.0039, 29.1799],
    [-89.0174, 29.1712],
    [-89.0471, 29.1844],
    [-89.0894, 29.1664],
    [-89.1118, 29.1600],
    [-89.0970, 29.1388],
    [-89.0395, 29.1355],
    [-89.0640, 29.0949],
    [-89.0745, 29.1001],
    [-89.0916, 29.1177],
    [-89.1063, 29.1115],
    [-89.1127, 29.0924],
    [-89.1165, 29.0741],
    [-89.1470, 29.0710],
    [-89.1443, 29.0602],
    [-89.1470, 29.0517],
    [-89.1586, 29.0218],
    [-89.1404, 29.0197],
    [-89.1441, 28.9954],
    [-89.1543, 28.9927],
    [-89.1777, 29.0052],
    [-89.2187, 29.0225],
    [-89.2175, 29.0557],
    [-89.2412, 29.0845],
    [-89.2536, 29.0650],
    [-89.2863, 29.0503],
    [-89.3092, 29.0238],
    [-89.3638, 28.9720],
    [-89.4052, 28.9316],
    [-89.4199, 28.9297],
    [-89.4107, 28.9499],
    [-89.4024, 28.9618],
    [-89.3930, 28.9871],
    [-89.3808, 28.9892],
    [-89.3703, 29.0005],
    [-89.3621, 29.0121],
    [-89.3506, 29.0343],
    [-89.3409, 29.0458],
    [-89.3297, 29.0560],
    [-89.3100, 29.0710],
    [-89.3129, 29.0874],
    [-89.3038, 29.1084],
    [-89.3019, 29.1206],
    [-89.2853, 29.1356],
    [-89.2815, 29.1599],
    [-89.2950, 29.1989],
    [-89.3285, 29.1906],
    [-89.3319, 29.1486],
    [-89.3506, 29.1296],
    [-89.3996, 29.1237],
    [-89.4274, 29.1445],
    [-89.4555, 29.1917],
    [-89.5366, 29.2362],
    [-89.6050, 29.2607],
    [-89.6111, 29.2650],
    [-89.6266, 29.2760],
    [-89.6397, 29.2905],
    [-89.6819, 29.2921],
    [-89.7821, 29.3111],
    [-89.8426, 29.3188],
    [-89.8339, 29.3315],
    [-89.8278, 29.3451],
    [-89.8161, 29.3573],
    [-89.7906, 29.3283],
    [-89.7407, 29.3548],
    [-89.6886, 29.3589],
    [-89.6468, 29.3763],
    [-89.6233, 29.3463],
    [-89.6033, 29.3753],
    [-89.6214, 29.3937],
    [-89.6421, 29.4060],
    [-89.6474, 29.4099],
    [-89.6528, 29.4002],
    [-89.6696, 29.3902],
    [-89.7164, 29.3881],
    [-89.7697, 29.3980],
    [-89.7909, 29.4108],
    [-89.8222, 29.4095],
    [-89.8436, 29.4217],
    [-89.8296, 29.4532],
    [-89.8232, 29.4651],
    [-89.8364, 29.4749],
    [-89.8643, 29.4550],
    [-89.8759, 29.4367],
    [-89.8862, 29.4402],
    [-89.9053, 29.4397],
    [-89.9193, 29.4484],
    [-89.9447, 29.4589],
    [-89.9687, 29.4633],
    [-89.9918, 29.4506],
    [-89.9814, 29.4381],
    [-89.9804, 29.4190],
    [-89.9911, 29.4053],
    [-90.0006, 29.3923],
    [-90.0156, 29.3761],
    [-90.0374, 29.3727],
    [-90.0384, 29.3568],
    [-90.0237, 29.3548],
    [-90.0086, 29.3670],
    [-89.9861, 29.3577],
    [-89.9827, 29.3413],
    [-90.0035, 29.3439],
    [-90.0124, 29.3489],
    [-90.0206, 29.3486],
    [-90.0318, 29.3443],
    [-90.0364, 29.3144],
    [-90.0253, 29.3013],
    [-90.0186, 29.2868],
    [-90.0476, 29.2855],
    [-90.0898, 29.2844],
    [-90.1081, 29.2650],
    [-90.0995, 29.2393],
    [-90.0750, 29.2197],
    [-90.0635, 29.2084],
    [-90.0505, 29.2154],
    [-90.0477, 29.2159],
    [-90.0447, 29.2077],
    [-90.0351, 29.2116],
    [-90.0280, 29.2166],
    [-90.0199, 29.2254],
    [-90.0145, 29.2320],
    [-90.0056, 29.2369],
    [-90.0026, 29.2395],
    [-90.0019, 29.2462],
    [-89.9940, 29.2492],
    [-89.9882, 29.2601],
    [-89.9798, 29.2600],
    [-89.9728, 29.2596],
    [-89.9667, 29.2636],
    [-89.9585, 29.2675],
    [-89.9523, 29.2681],
    [-89.9499, 29.2632],
    [-89.9587, 29.2514],
    [-89.9978, 29.2300],
    [-90.0430, 29.1969],
    [-90.0788, 29.1729],
    [-90.1166, 29.1480],
    [-90.1798, 29.1090],
    [-90.2229, 29.0871],
    [-90.2358, 29.0915],
    [-90.2481, 29.0966],
    [-90.2465, 29.1101],
    [-90.2334, 29.1210],
    [-90.2408, 29.1306],
    [-90.2690, 29.1392],
    [-90.2636, 29.1421],
    [-90.2453, 29.1497],
    [-90.2648, 29.1555],
    [-90.2779, 29.1570],
    [-90.2775, 29.1611],
    [-90.2588, 29.1656],
    [-90.2680, 29.1719],
    [-90.2768, 29.1745],
    [-90.2809, 29.1831],
    [-90.2672, 29.1777],
    [-90.2605, 29.1899],
    [-90.2629, 29.1994],
    [-90.2712, 29.2019],
    [-90.2767, 29.2108],
    [-90.2849, 29.2233],
    [-90.2932, 29.2411],
    [-90.3011, 29.2610],
    [-90.3053, 29.2684],
    [-90.3131, 29.2688],
    [-90.3221, 29.2730],
    [-90.3227, 29.2843],
    [-90.3317, 29.2793],
    [-90.3399, 29.2880],
    [-90.3474, 29.3008],
    [-90.3505, 29.3058],
    [-90.3583, 29.3020],
    [-90.3740, 29.2950],
    [-90.3769, 29.2887],
    [-90.3785, 29.2788],
    [-90.3720, 29.2747],
    [-90.3761, 29.2625],
    [-90.3835, 29.2579],
    [-90.3888, 29.2519],
    [-90.4014, 29.2341],
    [-90.4005, 29.2412],
    [-90.3952, 29.2571],
    [-90.3971, 29.2665],
    [-90.3988, 29.2779],
    [-90.3970, 29.2874],
    [-90.3929, 29.2966],
    [-90.3977, 29.3065],
    [-90.4026, 29.3122],
    [-90.4249, 29.3292],
    [-90.4301, 29.3441],
    [-90.4344, 29.3485],
    [-90.4474, 29.3476],
    [-90.4566, 29.3404],
    [-90.4582, 29.3358],
    [-90.4528, 29.3279],
    [-90.4516, 29.3215],
    [-90.4586, 29.3138],
    [-90.4660, 29.3084],
    [-90.4741, 29.2973],
    [-90.5013, 29.3010],
    [-90.5232, 29.3042],
    [-90.5465, 29.2938],
    [-90.5662, 29.3039],
    [-90.5796, 29.3117],
    [-90.5905, 29.3053],
    [-90.5978, 29.2969],
    [-90.5890, 29.2601],
    [-90.5927, 29.2459],
    [-90.5805, 29.2414],
    [-90.5618, 29.2350],
    [-90.5958, 29.2399],
    [-90.6061, 29.2244],
    [-90.6357, 29.2139],
    [-90.6449, 29.1828],
    [-90.6468, 29.1687],
    [-90.6850, 29.1656],
    [-90.6943, 29.1251],
    [-90.7144, 29.1176],
    [-90.7232, 29.1360],
    [-90.7358, 29.1346],
    [-90.7511, 29.1192],
    [-90.7711, 29.1113],
    [-90.7795, 29.1061],
    [-90.7912, 29.1030],
    [-90.7984, 29.0960],
    [-90.8037, 29.0677],
    [-90.8208, 29.0677],
    [-90.8361, 29.0661],
    [-90.8475, 29.0725],
    [-90.8574, 29.0903],
    [-90.8667, 29.0971],
    [-90.8678, 29.1063],
    [-90.8749, 29.1071],
    [-90.8752, 29.1190],
    [-90.8888, 29.1224],
    [-90.8820, 29.1264],
    [-90.8893, 29.1276],
    [-90.8946, 29.1321],
    [-90.9007, 29.1359],
    [-90.9032, 29.1428],
    [-90.9070, 29.1435],
    [-90.9197, 29.1504],
    [-90.9249, 29.1549],
    [-90.9364, 29.1638],
    [-90.9377, 29.1704],
    [-90.9526, 29.1808],
    [-90.9579, 29.1854],
    [-90.9642, 29.1825],
    [-90.9787, 29.1756],
    [-90.9909, 29.1756],
    [-91.0004, 29.1730],
    [-91.0108, 29.1758],
    [-91.0137, 29.1813],
    [-91.0196, 29.1791],
    [-91.0219, 29.1852],
    [-91.0271, 29.2011],
    [-91.0373, 29.2076],
    [-91.0437, 29.2096],
    [-91.0495, 29.1995],
    [-91.0520, 29.1930],
    [-91.0618, 29.1841],
    [-91.0714, 29.1891],
    [-91.0791, 29.1919],
    [-91.0879, 29.1907],
    [-91.1090, 29.2056],
    [-91.1299, 29.2207],
    [-91.1558, 29.2230],
    [-91.1794, 29.2228],
    [-91.2458, 29.2383],
    [-91.2883, 29.2557],
    [-91.3356, 29.3030],
    [-91.3307, 29.3082],
    [-91.3151, 29.3046],
    [-91.3065, 29.3083],
    [-91.2918, 29.3114],
    [-91.2898, 29.3200],
    [-91.2766, 29.3298],
    [-91.2752, 29.3393],
    [-91.2725, 29.3470],
    [-91.2655, 29.3610],
    [-91.2511, 29.3673],
    [-91.2370, 29.3713],
    [-91.2385, 29.3615],
    [-91.2393, 29.3537],
    [-91.2332, 29.3465],
    [-91.2255, 29.3365],
    [-91.2166, 29.3247],
    [-91.2120, 29.3173],
    [-91.2037, 29.3143],
    [-91.1922, 29.3100],
    [-91.1780, 29.3210],
    [-91.1717, 29.3251],
    [-91.1621, 29.3182],
    [-91.1688, 29.3089],
    [-91.1709, 29.2947],
    [-91.1723, 29.2759],
    [-91.1766, 29.2711],
    [-91.1686, 29.2651],
    [-91.1600, 29.2581],
    [-91.1566, 29.2561],
    [-91.1655, 29.2538],
    [-91.1698, 29.2456],
    [-91.1725, 29.2380],
    [-91.1684, 29.2374],
    [-91.1570, 29.2435],
    [-91.1463, 29.2440],
    [-91.1448, 29.2517],
    [-91.1318, 29.2484],
    [-91.1232, 29.2513],
    [-91.1184, 29.2555],
    [-91.1194, 29.2665],
    [-91.1281, 29.2735],
    [-91.1328, 29.2844],
    [-91.1249, 29.2956],
    [-91.1189, 29.3062],
    [-91.1237, 29.3200],
    [-91.1263, 29.3334],
    [-91.1385, 29.3432],
    [-91.1531, 29.3510],
    [-91.1550, 29.3575],
    [-91.1774, 29.3637],
    [-91.1928, 29.3711],
    [-91.2046, 29.3920],
    [-91.2196, 29.3971],
    [-91.2160, 29.4125],
    [-91.2151, 29.4275],
    [-91.2212, 29.4364],
    [-91.2404, 29.4403],
    [-91.2465, 29.4300],
    [-91.2518, 29.4413],
    [-91.2578, 29.4443],
    [-91.2707, 29.4141],
    [-91.3019, 29.4131],
    [-91.3099, 29.4005],
    [-91.3368, 29.4140],
    [-91.3345, 29.4311],
    [-91.3451, 29.4227],
    [-91.3464, 29.4320],
    [-91.3570, 29.4309],
    [-91.3633, 29.4303],
    [-91.3521, 29.4397],
    [-91.3475, 29.4444],
    [-91.3485, 29.4599],
    [-91.3339, 29.4725],
    [-91.3219, 29.4802],
    [-91.3411, 29.4806],
    [-91.3605, 29.4707],
    [-91.3506, 29.4840],
    [-91.3407, 29.4906],
    [-91.3511, 29.4970],
    [-91.3524, 29.5029],
    [-91.3572, 29.5052],
    [-91.3663, 29.5128],
    [-91.3794, 29.5124],
    [-91.3864, 29.5081],
    [-91.3943, 29.4971],
    [-91.4173, 29.4851],
    [-91.4393, 29.4828],
    [-91.4610, 29.4700],
    [-91.4856, 29.4991],
    [-91.4954, 29.5244],
    [-91.4961, 29.5389],
    [-91.5112, 29.5326],
    [-91.5414, 29.5263],
    [-91.5336, 29.5348],
    [-91.5255, 29.5519],
    [-91.5383, 29.5746],
    [-91.5365, 29.5877],
    [-91.5452, 29.6062],
    [-91.5546, 29.6358],
    [-91.5670, 29.6387],
    [-91.5818, 29.6386],
    [-91.6078, 29.6321],
    [-91.6307, 29.6307],
    [-91.6454, 29.6341],
    [-91.6439, 29.6390],
    [-91.6315, 29.6518],
    [-91.6274, 29.6602],
    [-91.6230, 29.6710],
    [-91.6221, 29.6875],
    [-91.6172, 29.7129],
    [-91.6193, 29.7279],
    [-91.6239, 29.7384],
    [-91.6485, 29.7456],
    [-91.6974, 29.7427],
    [-91.7181, 29.7381],
    [-91.7371, 29.7503],
    [-91.7654, 29.7475],
    [-91.7923, 29.7374],
    [-91.8228, 29.7246],
    [-91.8361, 29.7167],
    [-91.8518, 29.7083],
    [-91.8662, 29.7103],
    [-91.8735, 29.7135],
    [-91.8807, 29.7108],
    [-91.8630, 29.7245],
    [-91.8544, 29.7347],
    [-91.8580, 29.7441],
    [-91.8729, 29.7479],
    [-91.8741, 29.7588],
    [-91.8689, 29.7615],
    [-91.8612, 29.7732],
    [-91.8521, 29.7869],
    [-91.8497, 29.7896],
    [-91.8464, 29.7827],
    [-91.8401, 29.7779],
    [-91.8306, 29.7775],
    [-91.8251, 29.7868],
    [-91.8237, 29.7976],
    [-91.8249, 29.8085],
    [-91.8313, 29.8233],
    [-91.8413, 29.8284],
    [-91.8595, 29.8261],
    [-91.8737, 29.8322],
    [-91.9010, 29.8334],
    [-91.9153, 29.8194],
    [-91.9267, 29.8224],
    [-91.9375, 29.8168],
    [-91.9483, 29.8230],
    [-91.9617, 29.8260],
    [-91.9671, 29.8324],
    [-91.9721, 29.8337],
    [-91.9828, 29.8254],
    [-91.9820, 29.8120],
    [-91.9782, 29.7999],
    [-92.0011, 29.7934],
    [-92.0357, 29.7817],
    [-92.0836, 29.7591],
    [-92.1159, 29.7395],
    [-92.1496, 29.7168],
    [-92.1498, 29.7260],
    [-92.1357, 29.7324],
    [-92.1279, 29.7410],
    [-92.1236, 29.7535],
    [-92.1365, 29.7673],
    [-92.1498, 29.7630],
    [-92.1469, 29.7576],
    [-92.1568, 29.7560],
    [-92.1626, 29.7622],
    [-92.1691, 29.7632],
    [-92.1749, 29.7595],
    [-92.1758, 29.7522],
    [-92.1717, 29.7474],
    [-92.1669, 29.7434],
    [-92.1764, 29.7412],
    [-92.1896, 29.7475],
    [-92.2033, 29.7534],
    [-92.2089, 29.7459],
    [-92.2061, 29.7373],
    [-92.2013, 29.7304],
    [-92.1974, 29.7247],
    [-92.1887, 29.7186],
    [-92.1824, 29.7124],
    [-92.1731, 29.7036],
    [-92.1667, 29.6995],
    [-92.1550, 29.6980],
    [-92.1457, 29.6958],
    [-92.1321, 29.6985],
    [-92.1179, 29.6985],
    [-92.1039, 29.6991],
    [-92.1186, 29.6823],
    [-92.1338, 29.6724],
    [-92.1363, 29.6626],
    [-92.1262, 29.6534],
    [-92.1246, 29.6402],
    [-92.1202, 29.6315],
    [-92.1136, 29.6220],
    [-92.1058, 29.6118],
    [-92.0995, 29.6129],
    [-92.1033, 29.6201],
    [-92.0934, 29.6187],
    [-92.0787, 29.6217],
    [-92.0656, 29.6200],
    [-92.0511, 29.6229],
    [-92.0423, 29.6284],
    [-92.0311, 29.6311],
    [-92.0270, 29.6244],
    [-92.0177, 29.6182],
    [-92.0089, 29.6129],
    [-92.0169, 29.6158],
    [-92.0348, 29.6184],
    [-92.0428, 29.6170],
    [-92.0520, 29.6133],
    [-92.0633, 29.6050],
    [-92.0707, 29.6000],
    [-92.0689, 29.5940],
    [-92.0602, 29.5933],
    [-92.0484, 29.5925],
    [-92.0419, 29.5868],
    [-92.0579, 29.5841],
    [-92.0696, 29.5853],
    [-92.1048, 29.5881],
    [-92.1470, 29.5857],
    [-92.2025, 29.5673],
    [-92.2649, 29.5375],
    [-92.2922, 29.5340],
    [-92.3152, 29.5324],
    [-92.3647, 29.5395],
    [-92.4170, 29.5488],
    [-92.4482, 29.5574],
    [-92.4772, 29.5636],
    [-92.5041, 29.5675],
    [-92.5349, 29.5721],
    [-92.5393, 29.5735],
    [-92.5563, 29.5785],
    [-92.5596, 29.5829],
    [-92.5614, 29.5884],
    [-92.5693, 29.5879],
    [-92.5755, 29.5816],
    [-92.5668, 29.5772],
    [-92.5876, 29.5808],
    [-92.6095, 29.5849],
    [-92.6190, 29.5867],
    [-92.6247, 29.5917],
    [-92.6361, 29.5965],
    [-92.6420, 29.5926],
    [-92.6550, 29.5961],
    [-92.6715, 29.5999],
    [-92.6876, 29.6056],
    [-92.7099, 29.6124],
    [-92.7345, 29.6195],
    [-92.7578, 29.6302],
    [-92.7653, 29.6355],
    [-92.7780, 29.6367],
    [-92.7994, 29.6465],
    [-92.8370, 29.6630],
    [-92.8800, 29.6803],
    [-92.9475, 29.7088],
    [-92.9818, 29.7215],
    [-93.0102, 29.7277],
    [-93.0312, 29.7363],
    [-93.0780, 29.7477],
    [-93.1334, 29.7607],
    [-93.2286, 29.7770],
    [-93.2674, 29.7768],
    [-93.3202, 29.7678],
    [-93.3456, 29.7628],
    [-93.3663, 29.7641],
    [-93.4390, 29.7689],
    [-93.5103, 29.7674],
    [-93.5701, 29.7602],
    [-93.6353, 29.7528],
    [-93.7397, 29.7358],
    [-93.7800, 29.7232],
    [-93.8143, 29.7083],
    [-93.8327, 29.6951],
    [-93.8632, 29.7241],
    [-93.8888, 29.7422],
    [-93.8908, 29.7617],
    [-93.9224, 29.7850],
    [-93.9288, 29.7971],
    [-93.9227, 29.8188],
    [-93.9007, 29.8370],
    [-93.8636, 29.8572],
    [-93.8384, 29.8829],
    [-93.8165, 29.9207],
    [-93.8034, 29.9626],
    [-93.7944, 29.9748],
    [-93.7901, 29.9866],
    [-93.7822, 29.9937],
    [-93.7716, 29.9959],
    [-93.7684, 30.0017],
    [-93.7551, 30.0153],
    [-93.7421, 30.0208],
    [-93.7374, 30.0373],
    [-93.7208, 30.0530],
    [-93.7173, 30.0657],
    [-93.7119, 30.0570],
    [-93.7039, 30.0543],
    [-93.7006, 30.0637],
    [-93.7164, 30.0691],
    [-93.7287, 30.0802],
    [-93.7341, 30.0861],
    [-93.7299, 30.0883],
    [-93.7258, 30.0820],
    [-93.7238, 30.0941],
    [-93.7130, 30.1079],
    [-93.7037, 30.1111],
    [-93.7034, 30.1172],
    [-93.7065, 30.1217],
    [-93.7013, 30.1274],
    [-93.7020, 30.1307],
    [-93.6983, 30.1386],
    [-93.6886, 30.1404],
    [-93.6937, 30.1425],
    [-93.7002, 30.1527],
    [-93.7076, 30.1498],
    [-93.7039, 30.1611],
    [-93.7020, 30.1678],
    [-93.7097, 30.1833],
    [-93.7085, 30.1968],
    [-93.7150, 30.1973],
    [-93.7192, 30.2185],
    [-93.7093, 30.2339],
    [-93.7031, 30.2392],
    [-93.7054, 30.2470],
    [-93.7032, 30.2600],
    [-93.7072, 30.2755],
    [-93.7046, 30.2897],
    [-93.7129, 30.2879],
    [-93.7242, 30.2951],
    [-93.7439, 30.3040],
    [-93.7510, 30.3209],
    [-93.7643, 30.3302],
    [-93.7589, 30.3385],
    [-93.7615, 30.3522],
    [-93.7573, 30.3643],
    [-93.7584, 30.3837],
    [-93.7577, 30.3904],
    [-93.7522, 30.3934],
    [-93.7486, 30.3968],
    [-93.7455, 30.3987],
    [-93.7418, 30.4014],
    [-93.7356, 30.4069],
    [-93.7349, 30.4128],
    [-93.7320, 30.4139],
    [-93.7280, 30.4147],
    [-93.7275, 30.4187],
    [-93.7223, 30.4207],
    [-93.7230, 30.4321],
    [-93.7171, 30.4231],
    [-93.7140, 30.4297],
    [-93.7083, 30.4303],
    [-93.7024, 30.4309],
    [-93.6993, 30.4374],
    [-93.6983, 30.4449],
    [-93.7069, 30.4440],
    [-93.7021, 30.4498],
    [-93.6994, 30.4579],
    [-93.7064, 30.4669],
    [-93.7112, 30.4727],
    [-93.7168, 30.4819],
    [-93.7148, 30.4852],
    [-93.7098, 30.4826],
    [-93.7120, 30.4876],
    [-93.7145, 30.4977],
    [-93.7085, 30.5004],
    [-93.7097, 30.5065],
    [-93.7073, 30.5114],
    [-93.7116, 30.5120],
    [-93.7108, 30.5177],
    [-93.7190, 30.5211],
    [-93.7277, 30.5257],
    [-93.7322, 30.5358],
    [-93.7395, 30.5380],
    [-93.7348, 30.5417],
    [-93.7314, 30.5514],
    [-93.7239, 30.5592],
    [-93.7264, 30.5681],
    [-93.7278, 30.5741],
    [-93.7179, 30.5778],
    [-93.7136, 30.5874],
    [-93.7060, 30.5880],
    [-93.6929, 30.5944],
    [-93.6894, 30.5891],
    [-93.6881, 30.5857],
    [-93.6828, 30.5937],
    [-93.6792, 30.5998],
    [-93.6844, 30.6092],
    [-93.6891, 30.6114],
    [-93.6820, 30.6186],
    [-93.6851, 30.6252],
    [-93.6838, 30.6326],
    [-93.6805, 30.6352],
    [-93.6831, 30.6408],
    [-93.6741, 30.6487],
    [-93.6701, 30.6538],
    [-93.6704, 30.6580],
    [-93.6613, 30.6612],
    [-93.6532, 30.6704],
    [-93.6466, 30.6714],
    [-93.6362, 30.6761],
    [-93.6272, 30.6874],
    [-93.6204, 30.6942],
    [-93.6228, 30.6971],
    [-93.6245, 30.7011],
    [-93.6197, 30.7089],
    [-93.6172, 30.7186],
    [-93.6128, 30.7166],
    [-93.6097, 30.7292],
    [-93.6177, 30.7385],
    [-93.6178, 30.7433],
    [-93.6090, 30.7455],
    [-93.6083, 30.7478],
    [-93.6148, 30.7561],
    [-93.6135, 30.7608],
    [-93.6101, 30.7575],
    [-93.6062, 30.7594],
    [-93.6008, 30.7622],
    [-93.5935, 30.7723],
    [-93.5899, 30.7778],
    [-93.5832, 30.7786],
    [-93.5870, 30.7829],
    [-93.5872, 30.7879],
    [-93.5814, 30.7916],
    [-93.5843, 30.7967],
    [-93.5784, 30.8020],
    [-93.5632, 30.8062],
    [-93.5638, 30.8136],
    [-93.5578, 30.8210],
    [-93.5562, 30.8264],
    [-93.5536, 30.8351],
    [-93.5680, 30.8430],
    [-93.5573, 30.8521],
    [-93.5619, 30.8583],
    [-93.5588, 30.8688],
    [-93.5629, 30.8728],
    [-93.5735, 30.8827],
    [-93.5699, 30.8906],
    [-93.5663, 30.8948],
    [-93.5525, 30.8967],
    [-93.5486, 30.8999],
    [-93.5540, 30.9028],
    [-93.5553, 30.9093],
    [-93.5549, 30.9157],
    [-93.5495, 30.9238],
    [-93.5432, 30.9201],
    [-93.5278, 30.9328],
    [-93.5264, 30.9394],
    [-93.5326, 30.9507],
    [-93.5305, 30.9557],
    [-93.5346, 30.9580],
    [-93.5463, 30.9578],
    [-93.5535, 30.9674],
    [-93.5648, 30.9695],
    [-93.5740, 30.9722],
    [-93.5693, 30.9762],
    [-93.5659, 30.9852],
    [-93.5662, 30.9907],
    [-93.5751, 30.9946],
    [-93.5730, 31.0047],
    [-93.5675, 31.0127],
    [-93.5559, 31.0037],
    [-93.5485, 31.0103],
    [-93.5404, 31.0078],
    [-93.5316, 31.0202],
    [-93.5149, 31.0257],
    [-93.5150, 31.0349],
    [-93.5249, 31.0399],
    [-93.5199, 31.0419],
    [-93.5235, 31.0462],
    [-93.5321, 31.0553],
    [-93.5189, 31.0619],
    [-93.5207, 31.0661],
    [-93.5272, 31.0732],
    [-93.5401, 31.0780],
    [-93.5546, 31.0869],
    [-93.5635, 31.0940],
    [-93.5493, 31.1001],
    [-93.5487, 31.1060],
    [-93.5403, 31.1289],
    [-93.5489, 31.1484],
    [-93.5464, 31.1566],
    [-93.5364, 31.1604],
    [-93.5431, 31.1707],
    [-93.5328, 31.1743],
    [-93.5333, 31.1845],
    [-93.5418, 31.1832],
    [-93.5525, 31.1856],
    [-93.5671, 31.1790],
    [-93.5792, 31.1674],
    [-93.6003, 31.1762],
    [-93.6019, 31.1994],
    [-93.6038, 31.2158],
    [-93.5950, 31.2210],
    [-93.5992, 31.2253],
    [-93.5966, 31.2297],
    [-93.6017, 31.2295],
    [-93.6098, 31.2297],
    [-93.6132, 31.2324],
    [-93.6183, 31.2331],
    [-93.6163, 31.2446],
    [-93.6212, 31.2496],
    [-93.6154, 31.2542],
    [-93.6146, 31.2614],
    [-93.6203, 31.2710],
    [-93.6415, 31.2699],
    [-93.6452, 31.2763],
    [-93.6509, 31.2843],
    [-93.6599, 31.2820],
    [-93.6754, 31.3010],
    [-93.6879, 31.3098],
    [-93.6752, 31.3220],
    [-93.6773, 31.3305],
    [-93.6686, 31.3411],
    [-93.6655, 31.3544],
    [-93.6459, 31.3590],
    [-93.6403, 31.3687],
    [-93.6488, 31.3706],
    [-93.6703, 31.3661],
    [-93.6700, 31.3705],
    [-93.6702, 31.3872],
    [-93.6959, 31.4094],
    [-93.7047, 31.4181],
    [-93.6925, 31.4382],
    [-93.7059, 31.4403],
    [-93.7042, 31.4530],
    [-93.7091, 31.4567],
    [-93.7117, 31.4530],
    [-93.7177, 31.4571],
    [-93.7418, 31.4659],
    [-93.7495, 31.4687],
    [-93.7454, 31.4781],
    [-93.7480, 31.4816],
    [-93.7530, 31.4817],
    [-93.7452, 31.4856],
    [-93.7276, 31.4889],
    [-93.7215, 31.4997],
    [-93.7116, 31.5101],
    [-93.7134, 31.5148],
    [-93.7334, 31.5132],
    [-93.7439, 31.5165],
    [-93.7439, 31.5181],
    [-93.7406, 31.5185],
    [-93.7473, 31.5284],
    [-93.7519, 31.5275],
    [-93.7581, 31.5299],
    [-93.7549, 31.5248],
    [-93.7877, 31.5273],
    [-93.7992, 31.5381],
    [-93.7999, 31.5419],
    [-93.8033, 31.5436],
    [-93.8102, 31.5499],
    [-93.8208, 31.5582],
    [-93.8170, 31.5616],
    [-93.8216, 31.5637],
    [-93.8222, 31.5688],
    [-93.8184, 31.5709],
    [-93.8349, 31.5862],
    [-93.8304, 31.6136],
    [-93.8196, 31.6141],
    [-93.8222, 31.6185],
    [-93.8269, 31.6210],
    [-93.8207, 31.6214],
    [-93.8172, 31.6256],
    [-93.8206, 31.6297],
    [-93.8180, 31.6479],
    [-93.8257, 31.6610],
    [-93.8189, 31.6738],
    [-93.8152, 31.6680],
    [-93.8139, 31.6759],
    [-93.7955, 31.7005],
    [-93.7976, 31.7056],
    [-93.8111, 31.7037],
    [-93.8163, 31.7075],
    [-93.8128, 31.7168],
    [-93.8150, 31.7287],
    [-93.8246, 31.7344],
    [-93.8330, 31.7464],
    [-93.8326, 31.7542],
    [-93.8262, 31.7623],
    [-93.8288, 31.7656],
    [-93.8226, 31.7736],
    [-93.8312, 31.7802],
    [-93.8356, 31.7945],
    [-93.8384, 31.7981],
    [-93.8429, 31.8007],
    [-93.8471, 31.7999],
    [-93.8515, 31.8001],
    [-93.8534, 31.8055],
    [-93.8585, 31.8085],
    [-93.8614, 31.8123],
    [-93.8708, 31.8138],
    [-93.8734, 31.8158],
    [-93.8748, 31.8217],
    [-93.8771, 31.8322],
    [-93.8748, 31.8406],
    [-93.8810, 31.8448],
    [-93.8818, 31.8522],
    [-93.8890, 31.8557],
    [-93.8825, 31.8619],
    [-93.8850, 31.8659],
    [-93.8915, 31.8749],
    [-93.8974, 31.8744],
    [-93.9025, 31.8753],
    [-93.8966, 31.8873],
    [-93.8981, 31.8949],
    [-93.9032, 31.8962],
    [-93.9196, 31.8907],
    [-93.9267, 31.8883],
    [-93.9309, 31.8965],
    [-93.9233, 31.9078],
    [-93.9332, 31.9109],
    [-93.9535, 31.9106],
    [-93.9618, 31.9240],
    [-93.9717, 31.9204],
    [-93.9793, 31.9307],
    [-93.9813, 31.9395],
    [-93.9904, 31.9486],
    [-93.9987, 31.9591],
    [-94.0074, 31.9738],
    [-94.0164, 31.9808],
    [-94.0173, 31.9893],
    [-94.0252, 31.9944],
    [-94.0384, 31.9924],
    [-94.0427, 31.9993],
    [-94.0423, 32.1199],
    [-94.0427, 32.1380],
    [-94.0426, 32.1669],
    [-94.0427, 32.2250],
    [-94.0427, 32.2697],
    [-94.0427, 32.3480],
    [-94.0428, 32.3734],
    [-94.0429, 32.4007],
    [-94.0429, 32.4399],
    [-94.0429, 32.4704],
    [-94.0430, 32.4780],
    [-94.0431, 32.4866],
    [-94.0431, 32.5136],
    [-94.0431, 32.5165],
    [-94.0431, 32.5643],
    [-94.0429, 32.6183],
    [-94.0428, 32.6435],
    [-94.0431, 32.6930]
    ]
  },
  "Michigan": {
    coordinates: [
      [-86.8248, 41.7602],
    [-86.8021, 41.7720],
    [-86.7748, 41.7861],
    [-86.7509, 41.7999],
    [-86.7422, 41.8053],
    [-86.7170, 41.8193],
    [-86.7059, 41.8279],
    [-86.6919, 41.8356],
    [-86.6794, 41.8448],
    [-86.6610, 41.8610],
    [-86.6521, 41.8675],
    [-86.6298, 41.8854],
    [-86.6170, 41.8970],
    [-86.6079, 41.9066],
    [-86.5910, 41.9287],
    [-86.5783, 41.9501],
    [-86.5627, 41.9857],
    [-86.5564, 42.0000],
    [-86.5399, 42.0256],
    [-86.5165, 42.0601],
    [-86.5112, 42.0687],
    [-86.5087, 42.0726],
    [-86.4901, 42.1051],
    [-86.4879, 42.1137],
    [-86.4875, 42.1171],
    [-86.4790, 42.1235],
    [-86.4666, 42.1341],
    [-86.4429, 42.1577],
    [-86.4239, 42.1760],
    [-86.4137, 42.1865],
    [-86.4022, 42.1985],
    [-86.3852, 42.2173],
    [-86.3649, 42.2431],
    [-86.3562, 42.2542],
    [-86.3292, 42.2985],
    [-86.3114, 42.3308],
    [-86.2972, 42.3582],
    [-86.2933, 42.3721],
    [-86.2890, 42.3830],
    [-86.2839, 42.3981],
    [-86.2809, 42.4068],
    [-86.2739, 42.4193],
    [-86.2616, 42.4439],
    [-86.2497, 42.4802],
    [-86.2471, 42.4910],
    [-86.2451, 42.5059],
    [-86.2427, 42.5242],
    [-86.2397, 42.5434],
    [-86.2344, 42.5683],
    [-86.2281, 42.5834],
    [-86.2256, 42.5948],
    [-86.2268, 42.6067],
    [-86.2281, 42.6169],
    [-86.2291, 42.6377],
    [-86.2235, 42.6504],
    [-86.2179, 42.6594],
    [-86.2150, 42.6675],
    [-86.2137, 42.6770],
    [-86.2087, 42.6921],
    [-86.2068, 42.7163],
    [-86.2071, 42.7465],
    [-86.2084, 42.7554],
    [-86.2092, 42.7675],
    [-86.2105, 42.7717],
    [-86.2111, 42.7765],
    [-86.2107, 42.7866],
    [-86.2118, 42.8317],
    [-86.2107, 42.8591],
    [-86.2139, 42.8908],
    [-86.2157, 42.9002],
    [-86.2154, 42.9057],
    [-86.2165, 42.9215],
    [-86.2193, 42.9430],
    [-86.2213, 42.9571],
    [-86.2235, 42.9718],
    [-86.2282, 42.9965],
    [-86.2388, 43.0336],
    [-86.2443, 43.0497],
    [-86.2513, 43.0601],
    [-86.2518, 43.0731],
    [-86.2567, 43.0874],
    [-86.2720, 43.1184],
    [-86.2936, 43.1586],
    [-86.3127, 43.1895],
    [-86.3209, 43.2026],
    [-86.3373, 43.2236],
    [-86.3441, 43.2371],
    [-86.3675, 43.2742],
    [-86.3839, 43.2985],
    [-86.4017, 43.3271],
    [-86.4088, 43.3414],
    [-86.4218, 43.3672],
    [-86.4270, 43.3755],
    [-86.4344, 43.3954],
    [-86.4485, 43.4313],
    [-86.4606, 43.4691],
    [-86.4651, 43.4846],
    [-86.4793, 43.5153],
    [-86.4930, 43.5368],
    [-86.5011, 43.5486],
    [-86.5295, 43.5935],
    [-86.5389, 43.6200],
    [-86.5405, 43.6464],
    [-86.5345, 43.6680],
    [-86.5179, 43.6903],
    [-86.4733, 43.7342],
    [-86.4531, 43.7585],
    [-86.4451, 43.7716],
    [-86.4405, 43.7841],
    [-86.4370, 43.7906],
    [-86.4310, 43.8160],
    [-86.4312, 43.8407],
    [-86.4388, 43.8668],
    [-86.4455, 43.8897],
    [-86.4463, 43.8954],
    [-86.4479, 43.9181],
    [-86.4541, 43.9401],
    [-86.4605, 43.9495],
    [-86.4608, 43.9521],
    [-86.4614, 43.9575],
    [-86.4631, 43.9710],
    [-86.4717, 43.9845],
    [-86.4833, 44.0012],
    [-86.5030, 44.0238],
    [-86.5127, 44.0409],
    [-86.5122, 44.0631],
    [-86.4899, 44.0820],
    [-86.4469, 44.1060],
    [-86.4269, 44.1231],
    [-86.4035, 44.1528],
    [-86.3934, 44.1684],
    [-86.3875, 44.1813],
    [-86.3801, 44.1895],
    [-86.3628, 44.2081],
    [-86.3516, 44.2294],
    [-86.3438, 44.2496],
    [-86.3273, 44.2631],
    [-86.3201, 44.2765],
    [-86.3092, 44.2946],
    [-86.3003, 44.3082],
    [-86.2754, 44.3357],
    [-86.2663, 44.3511],
    [-86.2652, 44.3590],
    [-86.2614, 44.3688],
    [-86.2545, 44.3939],
    [-86.2482, 44.4278],
    [-86.2494, 44.4420],
    [-86.2509, 44.4700],
    [-86.2489, 44.4830],
    [-86.2423, 44.4927],
    [-86.2387, 44.5017],
    [-86.2349, 44.5164],
    [-86.2293, 44.5367],
    [-86.2220, 44.5601],
    [-86.2246, 44.5902],
    [-86.2299, 44.6047],
    [-86.2372, 44.6185],
    [-86.2441, 44.6271],
    [-86.2477, 44.6367],
    [-86.2590, 44.6637],
    [-86.2570, 44.6843],
    [-86.2550, 44.6919],
    [-86.2469, 44.6999],
    [-86.2107, 44.7117],
    [-86.1806, 44.7187],
    [-86.1659, 44.7242],
    [-86.1583, 44.7304],
    [-86.1548, 44.7321],
    [-86.1419, 44.7300],
    [-86.1211, 44.7280],
    [-86.0957, 44.7368],
    [-86.0749, 44.7662],
    [-86.0748, 44.7805],
    [-86.0722, 44.8041],
    [-86.0665, 44.8199],
    [-86.0665, 44.8349],
    [-86.0725, 44.8848],
    [-86.0638, 44.9081],
    [-86.0414, 44.9142],
    [-86.0312, 44.9073],
    [-86.0094, 44.8995],
    [-85.9852, 44.9029],
    [-85.9728, 44.9148],
    [-85.9616, 44.9356],
    [-85.9467, 44.9485],
    [-85.9386, 44.9646],
    [-85.9238, 44.9692],
    [-85.8915, 44.9578],
    [-85.8762, 44.9411],
    [-85.8543, 44.9381],
    [-85.8133, 44.9470],
    [-85.8046, 44.9527],
    [-85.7884, 44.9691],
    [-85.7783, 44.9831],
    [-85.7762, 45.0006],
    [-85.7788, 45.0066],
    [-85.7772, 45.0127],
    [-85.7695, 45.0170],
    [-85.7635, 45.0243],
    [-85.7603, 45.0263],
    [-85.7557, 45.0367],
    [-85.7472, 45.0505],
    [-85.7408, 45.0556],
    [-85.7211, 45.0624],
    [-85.6985, 45.0746],
    [-85.6931, 45.0816],
    [-85.6915, 45.0842],
    [-85.6797, 45.0960],
    [-85.6766, 45.1078],
    [-85.6734, 45.1196],
    [-85.6631, 45.1318],
    [-85.6560, 45.1458],
    [-85.6451, 45.1574],
    [-85.6325, 45.1693],
    [-85.6297, 45.1746],
    [-85.6186, 45.1856],
    [-85.6160, 45.1858],
    [-85.6070, 45.1785],
    [-85.5860, 45.1804],
    [-85.5758, 45.1871],
    [-85.5629, 45.1955],
    [-85.5573, 45.2036],
    [-85.5511, 45.2107],
    [-85.5380, 45.2074],
    [-85.5321, 45.1979],
    [-85.5369, 45.1728],
    [-85.5544, 45.1653],
    [-85.5601, 45.1607],
    [-85.5595, 45.1549],
    [-85.5551, 45.1448],
    [-85.5577, 45.1439],
    [-85.5605, 45.1394],
    [-85.5584, 45.1332],
    [-85.5648, 45.1429],
    [-85.5657, 45.1518],
    [-85.5739, 45.1555],
    [-85.5768, 45.1516],
    [-85.5826, 45.1541],
    [-85.5961, 45.1514],
    [-85.6015, 45.1453],
    [-85.6049, 45.1382],
    [-85.6143, 45.1276],
    [-85.6108, 45.1189],
    [-85.6056, 45.1080],
    [-85.5997, 45.1043],
    [-85.5954, 45.0992],
    [-85.5984, 45.0915],
    [-85.5915, 45.0846],
    [-85.5880, 45.0789],
    [-85.5829, 45.0716],
    [-85.5794, 45.0665],
    [-85.5741, 45.0694],
    [-85.5709, 45.0652],
    [-85.5671, 45.0605],
    [-85.5661, 45.0541],
    [-85.5659, 45.0475],
    [-85.5702, 45.0413],
    [-85.5787, 45.0516],
    [-85.5798, 45.0551],
    [-85.5888, 45.0541],
    [-85.5901, 45.0482],
    [-85.5942, 45.0456],
    [-85.5972, 45.0406],
    [-85.5992, 45.0311],
    [-85.5995, 45.0263],
    [-85.5995, 45.0241],
    [-85.5997, 45.0217],
    [-85.6056, 45.0162],
    [-85.6147, 45.0107],
    [-85.6266, 45.0038],
    [-85.6347, 44.9979],
    [-85.6405, 44.9883],
    [-85.6436, 44.9816],
    [-85.6474, 44.9784],
    [-85.6493, 44.9741],
    [-85.6455, 44.9697],
    [-85.6395, 44.9697],
    [-85.6361, 44.9673],
    [-85.6284, 44.9676],
    [-85.6238, 44.9726],
    [-85.6112, 44.9831],
    [-85.6042, 44.9920],
    [-85.5992, 44.9891],
    [-85.5995, 44.9830],
    [-85.6024, 44.9743],
    [-85.6014, 44.9646],
    [-85.6037, 44.9578],
    [-85.6022, 44.9524],
    [-85.6036, 44.9462],
    [-85.6048, 44.9384],
    [-85.6038, 44.9321],
    [-85.6009, 44.9249],
    [-85.6067, 44.9242],
    [-85.6163, 44.9239],
    [-85.6259, 44.9191],
    [-85.6299, 44.9064],
    [-85.6354, 44.8967],
    [-85.6369, 44.8933],
    [-85.6455, 44.8836],
    [-85.6492, 44.8718],
    [-85.6488, 44.8629],
    [-85.6501, 44.8555],
    [-85.6510, 44.8452],
    [-85.6514, 44.8316],
    [-85.6436, 44.8166],
    [-85.6395, 44.8085],
    [-85.6340, 44.8015],
    [-85.6346, 44.7961],
    [-85.6335, 44.7924],
    [-85.6364, 44.7881],
    [-85.6396, 44.7789],
    [-85.6407, 44.7755],
    [-85.6346, 44.7696],
    [-85.6235, 44.7675],
    [-85.6197, 44.7663],
    [-85.6108, 44.7652],
    [-85.5954, 44.7671],
    [-85.5944, 44.7745],
    [-85.5903, 44.7821],
    [-85.5886, 44.7884],
    [-85.5817, 44.8078],
    [-85.5791, 44.8177],
    [-85.5735, 44.8217],
    [-85.5670, 44.8280],
    [-85.5622, 44.8368],
    [-85.5584, 44.8437],
    [-85.5539, 44.8570],
    [-85.5459, 44.8640],
    [-85.5316, 44.8777],
    [-85.5295, 44.8847],
    [-85.5307, 44.8893],
    [-85.5265, 44.8940],
    [-85.5255, 44.8966],
    [-85.5386, 44.9002],
    [-85.5482, 44.9004],
    [-85.5488, 44.8967],
    [-85.5535, 44.8909],
    [-85.5587, 44.8879],
    [-85.5606, 44.8889],
    [-85.5643, 44.8938],
    [-85.5611, 44.8990],
    [-85.5480, 44.9111],
    [-85.5382, 44.9189],
    [-85.5350, 44.9245],
    [-85.5344, 44.9275],
    [-85.5301, 44.9340],
    [-85.5298, 44.9444],
    [-85.5243, 44.9508],
    [-85.5202, 44.9603],
    [-85.5221, 44.9667],
    [-85.5118, 44.9776],
    [-85.4969, 44.9835],
    [-85.4926, 44.9898],
    [-85.4749, 44.9917],
    [-85.4727, 44.9855],
    [-85.4703, 44.9760],
    [-85.4674, 44.9685],
    [-85.4649, 44.9611],
    [-85.4744, 44.9606],
    [-85.4821, 44.9622],
    [-85.4875, 44.9569],
    [-85.4846, 44.9525],
    [-85.4857, 44.9472],
    [-85.4892, 44.9379],
    [-85.4913, 44.9276],
    [-85.4903, 44.9207],
    [-85.4897, 44.9133],
    [-85.4925, 44.9082],
    [-85.4895, 44.9001],
    [-85.4918, 44.8915],
    [-85.4934, 44.8841],
    [-85.4975, 44.8780],
    [-85.4990, 44.8708],
    [-85.4989, 44.8643],
    [-85.4997, 44.8561],
    [-85.5071, 44.8525],
    [-85.5099, 44.8473],
    [-85.5190, 44.8455],
    [-85.5221, 44.8420],
    [-85.5326, 44.8389],
    [-85.5350, 44.8356],
    [-85.5429, 44.8312],
    [-85.5487, 44.8240],
    [-85.5559, 44.8183],
    [-85.5602, 44.8101],
    [-85.5581, 44.8041],
    [-85.5596, 44.7988],
    [-85.5615, 44.7921],
    [-85.5596, 44.7859],
    [-85.5648, 44.7781],
    [-85.5649, 44.7767],
    [-85.5702, 44.7728],
    [-85.5712, 44.7693],
    [-85.5743, 44.7636],
    [-85.5766, 44.7602],
    [-85.5713, 44.7553],
    [-85.5543, 44.7487],
    [-85.5272, 44.7475],
    [-85.5222, 44.7534],
    [-85.5074, 44.7653],
    [-85.5047, 44.7685],
    [-85.5063, 44.7758],
    [-85.5064, 44.7837],
    [-85.5093, 44.7873],
    [-85.5068, 44.7929],
    [-85.5036, 44.7982],
    [-85.4971, 44.8049],
    [-85.4895, 44.8080],
    [-85.4748, 44.8150],
    [-85.4629, 44.8251],
    [-85.4604, 44.8357],
    [-85.4514, 44.8540],
    [-85.4431, 44.8598],
    [-85.4294, 44.8766],
    [-85.4257, 44.8819],
    [-85.4240, 44.8903],
    [-85.4237, 44.8948],
    [-85.4179, 44.8987],
    [-85.4096, 44.9051],
    [-85.4069, 44.9095],
    [-85.4063, 44.9138],
    [-85.4023, 44.9217],
    [-85.3954, 44.9343],
    [-85.3917, 44.9433],
    [-85.3893, 44.9502],
    [-85.3876, 44.9625],
    [-85.3831, 44.9714],
    [-85.3831, 44.9851],
    [-85.3841, 44.9896],
    [-85.3808, 44.9943],
    [-85.3759, 45.0033],
    [-85.3804, 45.0156],
    [-85.3816, 45.0211],
    [-85.3813, 45.0290],
    [-85.3796, 45.0364],
    [-85.3807, 45.0463],
    [-85.3712, 45.0627],
    [-85.3665, 45.0715],
    [-85.3705, 45.0744],
    [-85.3668, 45.0864],
    [-85.3670, 45.0931],
    [-85.3645, 45.1022],
    [-85.3640, 45.1069],
    [-85.3669, 45.1169],
    [-85.3731, 45.1282],
    [-85.3754, 45.1366],
    [-85.3803, 45.1447],
    [-85.3789, 45.1516],
    [-85.3787, 45.1579],
    [-85.3785, 45.1641],
    [-85.3797, 45.1722],
    [-85.3823, 45.1819],
    [-85.3838, 45.1872],
    [-85.3867, 45.1895],
    [-85.3864, 45.1973],
    [-85.3872, 45.2008],
    [-85.3887, 45.2076],
    [-85.3884, 45.2132],
    [-85.3899, 45.2172],
    [-85.3875, 45.2237],
    [-85.3864, 45.2294],
    [-85.3888, 45.2338],
    [-85.3857, 45.2385],
    [-85.3827, 45.2459],
    [-85.3784, 45.2563],
    [-85.3716, 45.2708],
    [-85.3642, 45.2763],
    [-85.3559, 45.2818],
    [-85.3576, 45.2860],
    [-85.3614, 45.2871],
    [-85.3566, 45.2873],
    [-85.3508, 45.2845],
    [-85.3374, 45.2906],
    [-85.3349, 45.2976],
    [-85.3279, 45.3030],
    [-85.3177, 45.3040],
    [-85.3106, 45.3092],
    [-85.3049, 45.3150],
    [-85.3007, 45.3213],
    [-85.2945, 45.3179],
    [-85.2918, 45.3142],
    [-85.2814, 45.3153],
    [-85.2735, 45.3155],
    [-85.2649, 45.3188],
    [-85.2626, 45.3198],
    [-85.2550, 45.3257],
    [-85.2508, 45.3371],
    [-85.2419, 45.3393],
    [-85.2356, 45.3394],
    [-85.2264, 45.3448],
    [-85.2192, 45.3496],
    [-85.2152, 45.3526],
    [-85.2097, 45.3569],
    [-85.2048, 45.3606],
    [-85.1927, 45.3602],
    [-85.1785, 45.3617],
    [-85.1728, 45.3633],
    [-85.1660, 45.3659],
    [-85.1590, 45.3673],
    [-85.1535, 45.3698],
    [-85.1457, 45.3694],
    [-85.1414, 45.3721],
    [-85.1329, 45.3726],
    [-85.1300, 45.3715],
    [-85.1242, 45.3704],
    [-85.1145, 45.3676],
    [-85.1059, 45.3665],
    [-85.1008, 45.3665],
    [-85.0945, 45.3665],
    [-85.0852, 45.3659],
    [-85.0703, 45.3654],
    [-85.0431, 45.3615],
    [-85.0245, 45.3680],
    [-85.0103, 45.3708],
    [-84.9984, 45.3700],
    [-84.9873, 45.3688],
    [-84.9813, 45.3718],
    [-84.9692, 45.3757],
    [-84.9605, 45.3779],
    [-84.9528, 45.3801],
    [-84.9413, 45.3848],
    [-84.9299, 45.3870],
    [-84.9180, 45.3926],
    [-84.9145, 45.3956],
    [-84.9130, 45.4098],
    [-84.9162, 45.4176],
    [-84.9220, 45.4219],
    [-84.9303, 45.4231],
    [-84.9502, 45.4260],
    [-84.9711, 45.4274],
    [-84.9777, 45.4290],
    [-84.9860, 45.4284],
    [-84.9907, 45.4252],
    [-84.9771, 45.4200],
    [-84.9841, 45.4195],
    [-84.9931, 45.4227],
    [-85.0000, 45.4268],
    [-85.0108, 45.4302],
    [-85.0207, 45.4324],
    [-85.0296, 45.4340],
    [-85.0383, 45.4361],
    [-85.0473, 45.4422],
    [-85.0552, 45.4470],
    [-85.0625, 45.4513],
    [-85.0667, 45.4553],
    [-85.0717, 45.4616],
    [-85.0810, 45.4708],
    [-85.0904, 45.4781],
    [-85.0937, 45.4816],
    [-85.0963, 45.4922],
    [-85.1020, 45.5080],
    [-85.1093, 45.5216],
    [-85.1155, 45.5394],
    [-85.1160, 45.5476],
    [-85.1177, 45.5533],
    [-85.1197, 45.5690],
    [-85.1119, 45.5858],
    [-85.0935, 45.6001],
    [-85.0888, 45.6089],
    [-85.0760, 45.6231],
    [-85.0710, 45.6322],
    [-85.0668, 45.6357],
    [-85.0615, 45.6395],
    [-85.0508, 45.6409],
    [-85.0434, 45.6454],
    [-85.0381, 45.6458],
    [-85.0281, 45.6493],
    [-85.0180, 45.6513],
    [-85.0012, 45.6612],
    [-84.9949, 45.6725],
    [-84.9930, 45.6800],
    [-84.9828, 45.6812],
    [-84.9710, 45.6863],
    [-84.9616, 45.6981],
    [-84.9543, 45.7018],
    [-84.9467, 45.7085],
    [-84.9427, 45.7141],
    [-84.9404, 45.7254],
    [-84.9529, 45.7375],
    [-84.9603, 45.7422],
    [-84.9685, 45.7452],
    [-84.9735, 45.7461],
    [-84.9781, 45.7523],
    [-84.9835, 45.7480],
    [-84.9978, 45.7527],
    [-85.0122, 45.7562],
    [-85.0157, 45.7599],
    [-85.0096, 45.7629],
    [-84.9948, 45.7582],
    [-84.9826, 45.7599],
    [-84.9785, 45.7591],
    [-84.9662, 45.7579],
    [-84.9432, 45.7588],
    [-84.9247, 45.7569],
    [-84.9078, 45.7475],
    [-84.8925, 45.7497],
    [-84.8866, 45.7555],
    [-84.8787, 45.7562],
    [-84.8513, 45.7488],
    [-84.8375, 45.7451],
    [-84.8277, 45.7522],
    [-84.8184, 45.7510],
    [-84.8110, 45.7467],
    [-84.7996, 45.7471],
    [-84.7913, 45.7516],
    [-84.7814, 45.7611],
    [-84.7812, 45.7711],
    [-84.7875, 45.7721],
    [-84.7923, 45.7785],
    [-84.7803, 45.7872],
    [-84.7695, 45.7884],
    [-84.7558, 45.7842],
    [-84.7420, 45.7841],
    [-84.7341, 45.7882],
    [-84.7262, 45.7869],
    [-84.7222, 45.7818],
    [-84.7190, 45.7782],
    [-84.7241, 45.7770],
    [-84.7246, 45.7727],
    [-84.7230, 45.7681],
    [-84.7177, 45.7662],
    [-84.7094, 45.7642],
    [-84.6983, 45.7607],
    [-84.6908, 45.7587],
    [-84.6802, 45.7536],
    [-84.6751, 45.7479],
    [-84.6616, 45.7439],
    [-84.6453, 45.7412],
    [-84.6387, 45.7364],
    [-84.6142, 45.7257],
    [-84.5736, 45.7104],
    [-84.5571, 45.7089],
    [-84.5555, 45.7023],
    [-84.5466, 45.6948],
    [-84.5367, 45.6878],
    [-84.5291, 45.6863],
    [-84.5111, 45.6757],
    [-84.5007, 45.6737],
    [-84.4936, 45.6675],
    [-84.4905, 45.6639],
    [-84.4831, 45.6621],
    [-84.4796, 45.6596],
    [-84.4694, 45.6575],
    [-84.4652, 45.6550],
    [-84.4559, 45.6531],
    [-84.4466, 45.6547],
    [-84.4393, 45.6527],
    [-84.4360, 45.6494],
    [-84.4236, 45.6471],
    [-84.4189, 45.6554],
    [-84.4268, 45.6610],
    [-84.4354, 45.6641],
    [-84.4288, 45.6675],
    [-84.4209, 45.6698],
    [-84.3991, 45.6630],
    [-84.3870, 45.6593],
    [-84.3687, 45.6578],
    [-84.3443, 45.6618],
    [-84.3037, 45.6572],
    [-84.2897, 45.6533],
    [-84.2782, 45.6483],
    [-84.2628, 45.6435],
    [-84.2517, 45.6412],
    [-84.2406, 45.6379],
    [-84.2293, 45.6373],
    [-84.2046, 45.6270],
    [-84.2011, 45.6231],
    [-84.1917, 45.6169],
    [-84.1805, 45.6046],
    [-84.1715, 45.5978],
    [-84.1687, 45.5937],
    [-84.1596, 45.5897],
    [-84.1571, 45.5853],
    [-84.1361, 45.5704],
    [-84.1308, 45.5644],
    [-84.1273, 45.5539],
    [-84.1261, 45.5380],
    [-84.1223, 45.5238],
    [-84.1128, 45.5083],
    [-84.0959, 45.4973],
    [-84.0758, 45.4905],
    [-84.0634, 45.4889],
    [-84.0479, 45.4916],
    [-84.0400, 45.4937],
    [-84.0367, 45.4978],
    [-84.0209, 45.4957],
    [-84.0096, 45.4951],
    [-84.0000, 45.4912],
    [-83.9838, 45.4931],
    [-83.9718, 45.4952],
    [-83.9624, 45.4932],
    [-83.9533, 45.4944],
    [-83.9416, 45.4929],
    [-83.9258, 45.4893],
    [-83.9095, 45.4858],
    [-83.9004, 45.4788],
    [-83.8845, 45.4697],
    [-83.8715, 45.4599],
    [-83.8586, 45.4469],
    [-83.8456, 45.4382],
    [-83.8388, 45.4340],
    [-83.8308, 45.4348],
    [-83.8289, 45.4324],
    [-83.8268, 45.4289],
    [-83.8168, 45.4253],
    [-83.8108, 45.4206],
    [-83.7889, 45.4158],
    [-83.7782, 45.4170],
    [-83.7731, 45.4172],
    [-83.7818, 45.4149],
    [-83.7826, 45.4107],
    [-83.7677, 45.4072],
    [-83.7612, 45.4103],
    [-83.7579, 45.4120],
    [-83.7556, 45.4110],
    [-83.7468, 45.4057],
    [-83.7412, 45.4038],
    [-83.7385, 45.4063],
    [-83.7373, 45.4109],
    [-83.7302, 45.4121],
    [-83.7130, 45.4129],
    [-83.7058, 45.4027],
    [-83.6973, 45.3962],
    [-83.6852, 45.3907],
    [-83.6789, 45.3896],
    [-83.6699, 45.3847],
    [-83.6599, 45.3817],
    [-83.6398, 45.3706],
    [-83.6307, 45.3650],
    [-83.6177, 45.3636],
    [-83.6105, 45.3631],
    [-83.6047, 45.3593],
    [-83.5993, 45.3526],
    [-83.5946, 45.3532],
    [-83.5921, 45.3546],
    [-83.5892, 45.3514],
    [-83.5860, 45.3522],
    [-83.5846, 45.3558],
    [-83.5797, 45.3507],
    [-83.5733, 45.3478],
    [-83.5670, 45.3500],
    [-83.5618, 45.3505],
    [-83.5524, 45.3500],
    [-83.5462, 45.3540],
    [-83.5383, 45.3582],
    [-83.5250, 45.3514],
    [-83.5147, 45.3465],
    [-83.5056, 45.3436],
    [-83.4945, 45.3394],
    [-83.4917, 45.3421],
    [-83.4914, 45.3498],
    [-83.4969, 45.3565],
    [-83.4971, 45.3599],
    [-83.4891, 45.3579],
    [-83.4867, 45.3517],
    [-83.4775, 45.3455],
    [-83.4778, 45.3419],
    [-83.4860, 45.3425],
    [-83.4896, 45.3360],
    [-83.4814, 45.3273],
    [-83.4756, 45.3276],
    [-83.4744, 45.3332],
    [-83.4694, 45.3329],
    [-83.4634, 45.3292],
    [-83.4633, 45.3234],
    [-83.4612, 45.3191],
    [-83.4537, 45.3192],
    [-83.4504, 45.3200],
    [-83.4499, 45.3144],
    [-83.4452, 45.3081],
    [-83.4370, 45.3049],
    [-83.4322, 45.3033],
    [-83.4251, 45.2978],
    [-83.4224, 45.2908],
    [-83.4112, 45.2883],
    [-83.4040, 45.2855],
    [-83.3975, 45.2810],
    [-83.3940, 45.2782],
    [-83.3822, 45.2706],
    [-83.3848, 45.2642],
    [-83.3874, 45.2557],
    [-83.3964, 45.2534],
    [-83.4061, 45.2549],
    [-83.4156, 45.2558],
    [-83.4183, 45.2541],
    [-83.4175, 45.2525],
    [-83.4117, 45.2503],
    [-83.4094, 45.2470],
    [-83.4123, 45.2398],
    [-83.4078, 45.2340],
    [-83.4026, 45.2251],
    [-83.3948, 45.2200],
    [-83.3974, 45.2159],
    [-83.3901, 45.2089],
    [-83.3843, 45.2035],
    [-83.3793, 45.2020],
    [-83.3705, 45.1890],
    [-83.3674, 45.1839],
    [-83.3692, 45.1784],
    [-83.3647, 45.1700],
    [-83.3637, 45.1665],
    [-83.3545, 45.1631],
    [-83.3473, 45.1599],
    [-83.3400, 45.1505],
    [-83.3329, 45.1422],
    [-83.3251, 45.1448],
    [-83.3193, 45.1377],
    [-83.3219, 45.1357],
    [-83.3197, 45.1314],
    [-83.3159, 45.1285],
    [-83.3156, 45.1239],
    [-83.3204, 45.1184],
    [-83.3171, 45.1172],
    [-83.3163, 45.1128],
    [-83.3109, 45.1077],
    [-83.3133, 45.1008],
    [-83.3038, 45.0963],
    [-83.2975, 45.0885],
    [-83.2905, 45.0724],
    [-83.2909, 45.0683],
    [-83.2924, 45.0599],
    [-83.3052, 45.0562],
    [-83.2995, 45.0480],
    [-83.2849, 45.0455],
    [-83.2784, 45.0458],
    [-83.2714, 45.0394],
    [-83.2659, 45.0268],
    [-83.2608, 45.0248],
    [-83.2646, 45.0202],
    [-83.2687, 45.0228],
    [-83.2772, 45.0250],
    [-83.3024, 45.0310],
    [-83.3088, 45.0334],
    [-83.3152, 45.0346],
    [-83.3234, 45.0381],
    [-83.3403, 45.0415],
    [-83.3491, 45.0497],
    [-83.3576, 45.0506],
    [-83.3632, 45.0572],
    [-83.3668, 45.0664],
    [-83.3727, 45.0748],
    [-83.3827, 45.0755],
    [-83.3897, 45.0739],
    [-83.3910, 45.0729],
    [-83.3930, 45.0685],
    [-83.3993, 45.0704],
    [-83.4073, 45.0663],
    [-83.4093, 45.0695],
    [-83.4091, 45.0675],
    [-83.4090, 45.0663],
    [-83.4168, 45.0672],
    [-83.4186, 45.0655],
    [-83.4207, 45.0603],
    [-83.4229, 45.0609],
    [-83.4260, 45.0609],
    [-83.4269, 45.0578],
    [-83.4306, 45.0580],
    [-83.4421, 45.0511],
    [-83.4477, 45.0418],
    [-83.4529, 45.0324],
    [-83.4475, 45.0273],
    [-83.4526, 45.0287],
    [-83.4546, 45.0216],
    [-83.4485, 45.0177],
    [-83.4313, 45.0080],
    [-83.4433, 45.0043],
    [-83.4505, 45.0015],
    [-83.4500, 44.9902],
    [-83.4459, 44.9808],
    [-83.4456, 44.9635],
    [-83.4389, 44.9408],
    [-83.4253, 44.9268],
    [-83.4194, 44.9253],
    [-83.4112, 44.9210],
    [-83.4015, 44.9135],
    [-83.3967, 44.9077],
    [-83.3916, 44.9031],
    [-83.3811, 44.9008],
    [-83.3750, 44.9014],
    [-83.3744, 44.8969],
    [-83.3640, 44.8902],
    [-83.3528, 44.8862],
    [-83.3439, 44.8846],
    [-83.3357, 44.8836],
    [-83.3248, 44.8818],
    [-83.3123, 44.8828],
    [-83.3150, 44.8806],
    [-83.3179, 44.8746],
    [-83.3150, 44.8684],
    [-83.3195, 44.8606],
    [-83.3212, 44.8530],
    [-83.3144, 44.8422],
    [-83.3086, 44.8368],
    [-83.3039, 44.8326],
    [-83.3001, 44.8198],
    [-83.2952, 44.8109],
    [-83.2944, 44.8027],
    [-83.2932, 44.7961],
    [-83.2967, 44.7871],
    [-83.2949, 44.7751],
    [-83.2928, 44.7690],
    [-83.2920, 44.7639],
    [-83.2976, 44.7575],
    [-83.2964, 44.7493],
    [-83.2961, 44.7450],
    [-83.2907, 44.7293],
    [-83.2714, 44.7134],
    [-83.2720, 44.7086],
    [-83.2746, 44.7007],
    [-83.2758, 44.6923],
    [-83.2787, 44.6854],
    [-83.2825, 44.6769],
    [-83.2844, 44.6704],
    [-83.2861, 44.6635],
    [-83.2872, 44.6573],
    [-83.2909, 44.6490],
    [-83.3026, 44.6368],
    [-83.3122, 44.6172],
    [-83.3156, 44.5951],
    [-83.3145, 44.5809],
    [-83.3089, 44.5484],
    [-83.3085, 44.5399],
    [-83.3183, 44.5144],
    [-83.3180, 44.5013],
    [-83.3176, 44.4861],
    [-83.3235, 44.4607],
    [-83.3268, 44.4444],
    [-83.3265, 44.4253],
    [-83.3247, 44.4154],
    [-83.3205, 44.4069],
    [-83.3249, 44.3970],
    [-83.3319, 44.3771],
    [-83.3349, 44.3557],
    [-83.3335, 44.3374],
    [-83.3405, 44.3310],
    [-83.3536, 44.3325],
    [-83.3701, 44.3302],
    [-83.3845, 44.3178],
    [-83.3919, 44.3121],
    [-83.4143, 44.2945],
    [-83.4280, 44.2702],
    [-83.4452, 44.2528],
    [-83.4592, 44.2510],
    [-83.4520, 44.2534],
    [-83.4466, 44.2595],
    [-83.4403, 44.2644],
    [-83.4458, 44.2734],
    [-83.4630, 44.2788],
    [-83.4829, 44.2795],
    [-83.4892, 44.2779],
    [-83.5004, 44.2766],
    [-83.5088, 44.2737],
    [-83.5136, 44.2685],
    [-83.5256, 44.2608],
    [-83.5279, 44.2572],
    [-83.5352, 44.2507],
    [-83.5423, 44.2411],
    [-83.5524, 44.2129],
    [-83.5538, 44.1980],
    [-83.5565, 44.1884],
    [-83.5614, 44.1739],
    [-83.5679, 44.1510],
    [-83.5675, 44.1417],
    [-83.5689, 44.1267],
    [-83.5655, 44.1137],
    [-83.5640, 44.1052],
    [-83.5729, 44.1015],
    [-83.5771, 44.0963],
    [-83.5885, 44.0857],
    [-83.5904, 44.0696],
    [-83.5799, 44.0494],
    [-83.6105, 44.0562],
    [-83.6593, 44.0476],
    [-83.6715, 44.0418],
    [-83.6797, 44.0362],
    [-83.6811, 44.0295],
    [-83.6834, 44.0267],
    [-83.6841, 44.0160],
    [-83.6770, 43.9912],
    [-83.6830, 43.9866],
    [-83.6932, 43.9888],
    [-83.7005, 43.9915],
    [-83.7043, 43.9929],
    [-83.7134, 43.9956],
    [-83.7198, 43.9903],
    [-83.7217, 43.9932],
    [-83.7263, 44.0002],
    [-83.7340, 44.0001],
    [-83.7409, 43.9943],
    [-83.7437, 43.9921],
    [-83.7486, 43.9884],
    [-83.7562, 43.9900],
    [-83.7552, 43.9871],
    [-83.7631, 43.9852],
    [-83.7766, 43.9852],
    [-83.7904, 43.9893],
    [-83.7955, 43.9860],
    [-83.8127, 43.9871],
    [-83.8239, 43.9879],
    [-83.8319, 43.9878],
    [-83.8358, 43.9852],
    [-83.8418, 43.9806],
    [-83.8484, 43.9791],
    [-83.8495, 43.9730],
    [-83.8542, 43.9713],
    [-83.8586, 43.9631],
    [-83.8666, 43.9582],
    [-83.8696, 43.9607],
    [-83.8771, 43.9571],
    [-83.8792, 43.9528],
    [-83.8804, 43.9490],
    [-83.8810, 43.9426],
    [-83.8879, 43.9315],
    [-83.8928, 43.9217],
    [-83.9018, 43.9171],
    [-83.9086, 43.9156],
    [-83.9085, 43.9034],
    [-83.9138, 43.8595],
    [-83.9168, 43.8486],
    [-83.9163, 43.8244],
    [-83.9182, 43.8085],
    [-83.9232, 43.8004],
    [-83.9294, 43.7771],
    [-83.9400, 43.7714],
    [-83.9467, 43.7622],
    [-83.9526, 43.7496],
    [-83.9459, 43.7386],
    [-83.9439, 43.7269],
    [-83.9295, 43.7013],
    [-83.9241, 43.6936],
    [-83.9095, 43.6747],
    [-83.8952, 43.6652],
    [-83.8830, 43.6610],
    [-83.8646, 43.6512],
    [-83.8511, 43.6459],
    [-83.8409, 43.6537],
    [-83.8337, 43.6499],
    [-83.8163, 43.6434],
    [-83.8000, 43.6347],
    [-83.7686, 43.6279],
    [-83.7372, 43.6190],
    [-83.7030, 43.6010],
    [-83.6994, 43.5890],
    [-83.6789, 43.5888],
    [-83.6635, 43.5946],
    [-83.6584, 43.5955],
    [-83.6526, 43.6012],
    [-83.6345, 43.6163],
    [-83.6165, 43.6315],
    [-83.6004, 43.6468],
    [-83.5930, 43.6536],
    [-83.5850, 43.6627],
    [-83.5706, 43.6740],
    [-83.5612, 43.6865],
    [-83.5534, 43.6900],
    [-83.5512, 43.6981],
    [-83.5348, 43.7073],
    [-83.5242, 43.7169],
    [-83.5172, 43.7183],
    [-83.5134, 43.7153],
    [-83.5112, 43.7132],
    [-83.5033, 43.7124],
    [-83.4980, 43.7074],
    [-83.4852, 43.7145],
    [-83.4691, 43.7279],
    [-83.4670, 43.7292],
    [-83.4669, 43.7331],
    [-83.4719, 43.7376],
    [-83.4748, 43.7465],
    [-83.4630, 43.7418],
    [-83.4528, 43.7496],
    [-83.4431, 43.7624],
    [-83.4323, 43.7853],
    [-83.4312, 43.7896],
    [-83.4275, 43.7970],
    [-83.4255, 43.8012],
    [-83.4243, 43.8037],
    [-83.4251, 43.8134],
    [-83.4356, 43.8178],
    [-83.4434, 43.8127],
    [-83.4561, 43.8123],
    [-83.4606, 43.8029],
    [-83.4693, 43.7905],
    [-83.4751, 43.7895],
    [-83.4802, 43.7926],
    [-83.4761, 43.7978],
    [-83.4725, 43.8015],
    [-83.4661, 43.8043],
    [-83.4644, 43.8106],
    [-83.4631, 43.8267],
    [-83.4485, 43.8383],
    [-83.4479, 43.8497],
    [-83.4493, 43.8593],
    [-83.4376, 43.8625],
    [-83.4274, 43.8589],
    [-83.4298, 43.8531],
    [-83.4307, 43.8489],
    [-83.4339, 43.8407],
    [-83.4175, 43.8420],
    [-83.4153, 43.8354],
    [-83.4061, 43.8392],
    [-83.3974, 43.8415],
    [-83.3939, 43.8344],
    [-83.3937, 43.8424],
    [-83.3866, 43.8515],
    [-83.3845, 43.8543],
    [-83.3760, 43.8552],
    [-83.3712, 43.8572],
    [-83.3596, 43.8605],
    [-83.3569, 43.8624],
    [-83.3539, 43.8644],
    [-83.3492, 43.8677],
    [-83.3428, 43.8722],
    [-83.3323, 43.8905],
    [-83.3318, 43.8935],
    [-83.3358, 43.8972],
    [-83.3396, 43.9012],
    [-83.3417, 43.9046],
    [-83.3779, 43.9097],
    [-83.3824, 43.9100],
    [-83.3976, 43.9071],
    [-83.4048, 43.9127],
    [-83.3990, 43.9170],
    [-83.3803, 43.9132],
    [-83.3381, 43.9146],
    [-83.3107, 43.9198],
    [-83.2923, 43.9318],
    [-83.2907, 43.9331],
    [-83.2887, 43.9344],
    [-83.2884, 43.9350],
    [-83.2869, 43.9369],
    [-83.2844, 43.9391],
    [-83.2828, 43.9413],
    [-83.2807, 43.9454],
    [-83.2716, 43.9534],
    [-83.2641, 43.9649],
    [-83.2621, 43.9746],
    [-83.2477, 43.9759],
    [-83.2431, 43.9767],
    [-83.2260, 43.9807],
    [-83.2113, 43.9817],
    [-83.1983, 43.9836],
    [-83.1806, 43.9821],
    [-83.1708, 43.9862],
    [-83.1591, 43.9869],
    [-83.1349, 43.9931],
    [-83.1191, 44.0027],
    [-83.0961, 44.0018],
    [-83.0720, 44.0020],
    [-83.0587, 44.0062],
    [-83.0410, 44.0246],
    [-83.0396, 44.0271],
    [-83.0380, 44.0315],
    [-83.0330, 44.0357],
    [-83.0301, 44.0420],
    [-83.0277, 44.0462],
    [-83.0190, 44.0455],
    [-83.0101, 44.0463],
    [-82.9993, 44.0465],
    [-82.9907, 44.0488],
    [-82.9839, 44.0539],
    [-82.9806, 44.0564],
    [-82.9709, 44.0651],
    [-82.9676, 44.0672],
    [-82.9594, 44.0685],
    [-82.9567, 44.0633],
    [-82.9474, 44.0622],
    [-82.9374, 44.0664],
    [-82.9289, 44.0694],
    [-82.9214, 44.0685],
    [-82.9168, 44.0654],
    [-82.9093, 44.0629],
    [-82.8950, 44.0575],
    [-82.8933, 44.0558],
    [-82.8759, 44.0450],
    [-82.8596, 44.0442],
    [-82.8548, 44.0416],
    [-82.8516, 44.0411],
    [-82.8402, 44.0382],
    [-82.8331, 44.0369],
    [-82.8301, 44.0355],
    [-82.8195, 44.0330],
    [-82.8136, 44.0311],
    [-82.8113, 44.0284],
    [-82.8050, 44.0273],
    [-82.7930, 44.0230],
    [-82.7853, 44.0118],
    [-82.7763, 44.0084],
    [-82.7682, 44.0089],
    [-82.7610, 44.0039],
    [-82.7561, 44.0010],
    [-82.7494, 43.9956],
    [-82.7455, 43.9917],
    [-82.7416, 43.9912],
    [-82.7359, 43.9861],
    [-82.7341, 43.9840],
    [-82.7275, 43.9745],
    [-82.7261, 43.9690],
    [-82.7220, 43.9630],
    [-82.7180, 43.9545],
    [-82.7154, 43.9513],
    [-82.7098, 43.9482],
    [-82.7080, 43.9448],
    [-82.7050, 43.9392],
    [-82.7010, 43.9348],
    [-82.6996, 43.9296],
    [-82.6971, 43.9244],
    [-82.6934, 43.9191],
    [-82.6826, 43.9082],
    [-82.6843, 43.9042],
    [-82.6847, 43.9007],
    [-82.6788, 43.8843],
    [-82.6773, 43.8828],
    [-82.6678, 43.8763],
    [-82.6586, 43.8711],
    [-82.6551, 43.8692],
    [-82.6513, 43.8625],
    [-82.6466, 43.8567],
    [-82.6429, 43.8464],
    [-82.6478, 43.8427],
    [-82.6431, 43.8368],
    [-82.6364, 43.8341],
    [-82.6329, 43.8261],
    [-82.6315, 43.8207],
    [-82.6296, 43.8147],
    [-82.6253, 43.8023],
    [-82.6235, 43.7941],
    [-82.6202, 43.7841],
    [-82.6145, 43.7769],
    [-82.6132, 43.7718],
    [-82.6180, 43.7686],
    [-82.6191, 43.7561],
    [-82.6123, 43.7425],
    [-82.6107, 43.7368],
    [-82.6103, 43.7301],
    [-82.6104, 43.7194],
    [-82.6080, 43.7137],
    [-82.6057, 43.7092],
    [-82.6079, 43.7060],
    [-82.6100, 43.7029],
    [-82.6067, 43.6905],
    [-82.6066, 43.6833],
    [-82.6043, 43.6731],
    [-82.6057, 43.6687],
    [-82.6060, 43.6619],
    [-82.6044, 43.6518],
    [-82.6017, 43.6434],
    [-82.6022, 43.6382],
    [-82.6013, 43.6301],
    [-82.5984, 43.6216],
    [-82.5997, 43.6133],
    [-82.6005, 43.6073],
    [-82.5993, 43.6010],
    [-82.5988, 43.5937],
    [-82.5938, 43.5815],
    [-82.5903, 43.5679],
    [-82.5863, 43.5583],
    [-82.5857, 43.5519],
    [-82.5803, 43.5346],
    [-82.5715, 43.5165],
    [-82.5717, 43.5105],
    [-82.5661, 43.5008],
    [-82.5658, 43.4928],
    [-82.5613, 43.4861],
    [-82.5547, 43.4795],
    [-82.5558, 43.4719],
    [-82.5535, 43.4641],
    [-82.5466, 43.4571],
    [-82.5471, 43.4474],
    [-82.5401, 43.4385],
    [-82.5371, 43.4331],
    [-82.5373, 43.4301],
    [-82.5394, 43.4263],
    [-82.5387, 43.4197],
    [-82.5390, 43.4147],
    [-82.5370, 43.4079],
    [-82.5394, 43.4013],
    [-82.5367, 43.3911],
    [-82.5331, 43.3837],
    [-82.5345, 43.3763],
    [-82.5361, 43.3603],
    [-82.5375, 43.3532],
    [-82.5339, 43.3421],
    [-82.5294, 43.3162],
    [-82.5324, 43.3058],
    [-82.5300, 43.2977],
    [-82.5285, 43.2858],
    [-82.5279, 43.2777],
    [-82.5256, 43.2712],
    [-82.5227, 43.2675],
    [-82.5257, 43.2672],
    [-82.5262, 43.2554],
    [-82.5256, 43.2498],
    [-82.5232, 43.2289],
    [-82.5195, 43.2145],
    [-82.5158, 43.2081],
    [-82.5080, 43.1925],
    [-82.5032, 43.1680],
    [-82.4942, 43.1437],
    [-82.4910, 43.1208],
    [-82.4894, 43.1157],
    [-82.4860, 43.1025],
    [-82.4711, 43.0876],
    [-82.4662, 43.0768],
    [-82.4625, 43.0686],
    [-82.4435, 43.0401],
    [-82.4404, 43.0352],
    [-82.4303, 43.0214],
    [-82.4244, 43.0130],
    [-82.4223, 43.0078],
    [-82.4178, 43.0040],
    [-82.4244, 42.9970],
    [-82.4209, 42.9853],
    [-82.4142, 42.9785],
    [-82.4165, 42.9675],
    [-82.4240, 42.9586],
    [-82.4431, 42.9408],
    [-82.4556, 42.9269],
    [-82.4699, 42.8875],
    [-82.4682, 42.8591],
    [-82.4727, 42.8368],
    [-82.4798, 42.8194],
    [-82.4826, 42.8086],
    [-82.4804, 42.8023],
    [-82.4702, 42.7805],
    [-82.4712, 42.7553],
    [-82.4839, 42.7182],
    [-82.4945, 42.7008],
    [-82.5105, 42.6533],
    [-82.5156, 42.6222],
    [-82.5254, 42.6057],
    [-82.5542, 42.5840],
    [-82.5724, 42.5714],
    [-82.5840, 42.5540],
    [-82.6057, 42.5482],
    [-82.6168, 42.5546],
    [-82.6409, 42.5550],
    [-82.6617, 42.5419],
    [-82.6807, 42.5232],
    [-82.6710, 42.5380],
    [-82.6488, 42.5562],
    [-82.6569, 42.5677],
    [-82.6759, 42.5615],
    [-82.6851, 42.5556],
    [-82.6927, 42.5579],
    [-82.6876, 42.5661],
    [-82.6810, 42.5747],
    [-82.6675, 42.5788],
    [-82.6601, 42.5847],
    [-82.6607, 42.5959],
    [-82.6771, 42.5974],
    [-82.7112, 42.5909],
    [-82.6871, 42.6064],
    [-82.6765, 42.6130],
    [-82.6816, 42.6187],
    [-82.6898, 42.6271],
    [-82.6680, 42.6252],
    [-82.6647, 42.6321],
    [-82.6667, 42.6400],
    [-82.6590, 42.6403],
    [-82.6486, 42.6490],
    [-82.6353, 42.6400],
    [-82.6230, 42.6560],
    [-82.6309, 42.6733],
    [-82.6445, 42.6759],
    [-82.6532, 42.6722],
    [-82.6688, 42.6838],
    [-82.6796, 42.6887],
    [-82.6962, 42.6903],
    [-82.7051, 42.6870],
    [-82.7091, 42.6836],
    [-82.7264, 42.6828],
    [-82.7327, 42.6789],
    [-82.7331, 42.6755],
    [-82.7378, 42.6728],
    [-82.7470, 42.6728],
    [-82.7566, 42.6673],
    [-82.7599, 42.6603],
    [-82.7635, 42.6559],
    [-82.7740, 42.6542],
    [-82.7920, 42.6550],
    [-82.8056, 42.6488],
    [-82.8092, 42.6444],
    [-82.8180, 42.6310],
    [-82.8201, 42.6263],
    [-82.8182, 42.6154],
    [-82.8046, 42.6087],
    [-82.7930, 42.6011],
    [-82.7815, 42.5961],
    [-82.7741, 42.5949],
    [-82.7708, 42.5936],
    [-82.7779, 42.5932],
    [-82.7873, 42.5883],
    [-82.7860, 42.5807],
    [-82.7815, 42.5716],
    [-82.7845, 42.5636],
    [-82.8101, 42.5714],
    [-82.8127, 42.5701],
    [-82.8162, 42.5697],
    [-82.8189, 42.5703],
    [-82.8330, 42.5681],
    [-82.8368, 42.5663],
    [-82.8428, 42.5625],
    [-82.8437, 42.5597],
    [-82.8493, 42.5557],
    [-82.8533, 42.5470],
    [-82.8680, 42.5320],
    [-82.8706, 42.5263],
    [-82.8717, 42.5252],
    [-82.8744, 42.5235],
    [-82.8789, 42.5107],
    [-82.8823, 42.5010],
    [-82.8825, 42.4971],
    [-82.8827, 42.4925],
    [-82.8793, 42.4856],
    [-82.8834, 42.4791],
    [-82.8837, 42.4766],
    [-82.8814, 42.4756],
    [-82.8770, 42.4720],
    [-82.8708, 42.4608],
    [-82.8715, 42.4582],
    [-82.8688, 42.4559],
    [-82.8677, 42.4537],
    [-82.8703, 42.4509],
    [-82.8704, 42.4357],
    [-82.8713, 42.4334],
    [-82.8788, 42.4269],
    [-82.8815, 42.4066],
    [-82.8822, 42.4052],
    [-82.8869, 42.4028],
    [-82.8837, 42.4025],
    [-82.8872, 42.4019],
    [-82.8892, 42.3960],
    [-82.9000, 42.3844],
    [-82.9118, 42.3793],
    [-82.9185, 42.3730],
    [-82.9235, 42.3676],
    [-82.9284, 42.3597],
    [-82.9250, 42.3537],
    [-82.9454, 42.3473],
    [-82.9886, 42.3324],
    [-83.0190, 42.3306],
    [-83.0406, 42.3241],
    [-83.0636, 42.3169],
    [-83.0763, 42.3096],
    [-83.0973, 42.2901],
    [-83.1084, 42.2699],
    [-83.1264, 42.2384],
    [-83.1308, 42.2087],
    [-83.1329, 42.1697],
    [-83.1253, 42.1376],
    [-83.1213, 42.1175],
    [-83.1335, 42.0881],
    [-83.1688, 42.0736],
    [-83.1911, 42.0646],
    [-83.1862, 42.0519],
    [-83.1906, 42.0409],
    [-83.2002, 42.0367],
    [-83.1935, 42.0265],
    [-83.1709, 42.0218],
    [-83.1850, 42.0045],
    [-83.1989, 41.9953],
    [-83.2167, 41.9886],
    [-83.2234, 41.9892],
    [-83.2431, 41.9772],
    [-83.2504, 41.9728],
    [-83.2570, 41.9597],
    [-83.2538, 41.9472],
    [-83.2602, 41.9414],
    [-83.2638, 41.9318],
    [-83.2662, 41.9343],
    [-83.2705, 41.9393],
    [-83.2904, 41.9449],
    [-83.3029, 41.9431],
    [-83.3159, 41.9359],
    [-83.3260, 41.9250],
    [-83.3255, 41.9206],
    [-83.3336, 41.9073],
    [-83.3360, 41.8897],
    [-83.3428, 41.8794],
    [-83.3481, 41.8766],
    [-83.3536, 41.8761],
    [-83.3651, 41.8752],
    [-83.3748, 41.8746],
    [-83.3752, 41.8683],
    [-83.3820, 41.8709],
    [-83.3943, 41.8552],
    [-83.3980, 41.8516],
    [-83.4129, 41.8256],
    [-83.4168, 41.8226],
    [-83.4280, 41.8205],
    [-83.4397, 41.8128],
    [-83.4419, 41.8030],
    [-83.4434, 41.7891],
    [-83.4375, 41.7697],
    [-83.4283, 41.7412],
    [-83.4334, 41.7460],
    [-83.4541, 41.7372],
    [-83.4538, 41.7326],
    [-83.4674, 41.7324],
    [-83.4924, 41.7319],
    [-83.5034, 41.7315],
    [-83.5284, 41.7309],
    [-83.5477, 41.7304],
    [-83.5852, 41.7293],
    [-83.5947, 41.7291],
    [-83.6120, 41.7286],
    [-83.6245, 41.7282],
    [-83.6396, 41.7277],
    [-83.6457, 41.7276],
    [-83.6659, 41.7269],
    [-83.6854, 41.7264],
    [-83.7089, 41.7251],
    [-83.7444, 41.7241],
    [-83.7631, 41.7235],
    [-83.8111, 41.7224],
    [-83.8804, 41.7201],
    [-83.8998, 41.7200],
    [-83.9988, 41.7168],
    [-84.0767, 41.7148],
    [-84.1344, 41.7129],
    [-84.2111, 41.7108],
    [-84.2307, 41.7102],
    [-84.3604, 41.7066],
    [-84.3995, 41.7059],
    [-84.4664, 41.7043],
    [-84.5728, 41.7020],
    [-84.6894, 41.6995],
    [-84.7500, 41.6982],
    [-84.8060, 41.7027],
    [-84.8061, 41.7329],
    [-84.8059, 41.7602],
    [-84.8251, 41.7600],
    [-84.9177, 41.7597],
    [-84.9325, 41.7597],
    [-84.9609, 41.7594],
    [-84.9716, 41.7595],
    [-85.0198, 41.7597],
    [-85.0379, 41.7598],
    [-85.0585, 41.7599],
    [-85.1173, 41.7597],
    [-85.1749, 41.7596],
    [-85.2328, 41.7598],
    [-85.2737, 41.7598],
    [-85.2984, 41.7600],
    [-85.3306, 41.7600],
    [-85.3683, 41.7599],
    [-85.4087, 41.7598],
    [-85.4866, 41.7595],
    [-85.5183, 41.7595],
    [-85.6075, 41.7591],
    [-85.6226, 41.7590],
    [-85.6477, 41.7591],
    [-85.6626, 41.7591],
    [-85.7245, 41.7591],
    [-85.7505, 41.7591],
    [-85.7913, 41.7591],
    [-85.8479, 41.7593],
    [-85.8780, 41.7594],
    [-85.8888, 41.7594],
    [-85.9423, 41.7597],
    [-85.9750, 41.7598],
    [-85.9958, 41.7600],
    [-86.0411, 41.7605],
    [-86.1085, 41.7606],
    [-86.1255, 41.7606],
    [-86.1718, 41.7603],
    [-86.2175, 41.7600],
    [-86.2261, 41.7600],
    [-86.2655, 41.7602],
    [-86.3038, 41.7601],
    [-86.3320, 41.7600],
    [-86.3607, 41.7599],
    [-86.4262, 41.7598],
    [-86.5193, 41.7594],
    [-86.5833, 41.7596],
    [-86.6412, 41.7596],
    [-86.6997, 41.7598],
    [-86.7462, 41.7600],
    [-86.7510, 41.7600],
    [-86.8006, 41.7603],
    [-86.8044, 41.7602],
    [-86.8161, 41.7602],
    [-86.8248, 41.7602]
    ]
  },
  "Massachusetts": {
    coordinates: [
      [-73.5081, 42.0863],
    [-73.4759, 42.1740],
    [-73.4314, 42.2952],
    [-73.4120, 42.3481],
    [-73.3916, 42.4037],
    [-73.3821, 42.4294],
    [-73.3416, 42.5393],
    [-73.2741, 42.7212],
    [-73.2132, 42.7449],
    [-73.0899, 42.7425],
    [-73.0229, 42.7411],
    [-72.9271, 42.7391],
    [-72.8577, 42.7376],
    [-72.7793, 42.7358],
    [-72.6164, 42.7312],
    [-72.5659, 42.7298],
    [-72.4512, 42.7266],
    [-72.4120, 42.7254],
    [-72.2830, 42.7216],
    [-72.1245, 42.7176],
    [-72.0814, 42.7163],
    [-72.0157, 42.7143],
    [-71.9559, 42.7128],
    [-71.8988, 42.7114],
    [-71.7726, 42.7080],
    [-71.7014, 42.7063],
    [-71.6362, 42.7049],
    [-71.6198, 42.7045],
    [-71.5425, 42.7027],
    [-71.4880, 42.7014],
    [-71.4517, 42.7005],
    [-71.4323, 42.7001],
    [-71.3697, 42.6986],
    [-71.3519, 42.6982],
    [-71.3303, 42.6972],
    [-71.3134, 42.6971],
    [-71.2789, 42.7113],
    [-71.2679, 42.7259],
    [-71.2455, 42.7426],
    [-71.2239, 42.7467],
    [-71.2104, 42.7438],
    [-71.2081, 42.7433],
    [-71.1937, 42.7402],
    [-71.1841, 42.7657],
    [-71.1823, 42.7943],
    [-71.1677, 42.8074],
    [-71.1497, 42.8155],
    [-71.1158, 42.8177],
    [-71.0912, 42.8123],
    [-71.0536, 42.8331],
    [-71.0444, 42.8488],
    [-71.0046, 42.8632],
    [-70.9747, 42.8677],
    [-70.9492, 42.8761],
    [-70.9306, 42.8846],
    [-70.9149, 42.8866],
    [-70.9028, 42.8865],
    [-70.8834, 42.8810],
    [-70.8486, 42.8609],
    [-70.8242, 42.8711],
    [-70.8173, 42.8723],
    [-70.8127, 42.8229],
    [-70.8085, 42.8149],
    [-70.7950, 42.7532],
    [-70.7723, 42.7111],
    [-70.7759, 42.6957],
    [-70.7527, 42.6843],
    [-70.7278, 42.6659],
    [-70.7058, 42.6582],
    [-70.6904, 42.6563],
    [-70.6785, 42.6653],
    [-70.6724, 42.6704],
    [-70.6668, 42.6726],
    [-70.6492, 42.6868],
    [-70.6402, 42.6893],
    [-70.6273, 42.6914],
    [-70.6200, 42.6880],
    [-70.6207, 42.6724],
    [-70.6209, 42.6665],
    [-70.6228, 42.6609],
    [-70.6161, 42.6605],
    [-70.6098, 42.6601],
    [-70.5955, 42.6603],
    [-70.5971, 42.6518],
    [-70.5950, 42.6432],
    [-70.5940, 42.6350],
    [-70.6051, 42.6349],
    [-70.6122, 42.6317],
    [-70.6180, 42.6260],
    [-70.6272, 42.6213],
    [-70.6323, 42.6101],
    [-70.6358, 42.6001],
    [-70.6480, 42.5875],
    [-70.6660, 42.5841],
    [-70.6570, 42.5983],
    [-70.6656, 42.6091],
    [-70.6765, 42.6033],
    [-70.6808, 42.5935],
    [-70.6881, 42.5859],
    [-70.7082, 42.5756],
    [-70.7297, 42.5715],
    [-70.7370, 42.5769],
    [-70.7586, 42.5686],
    [-70.7775, 42.5594],
    [-70.7933, 42.5643],
    [-70.8027, 42.5620],
    [-70.8233, 42.5515],
    [-70.8516, 42.5478],
    [-70.8576, 42.5463],
    [-70.8703, 42.5470],
    [-70.8759, 42.5434],
    [-70.8826, 42.5349],
    [-70.8755, 42.5338],
    [-70.8676, 42.5363],
    [-70.8776, 42.5235],
    [-70.8852, 42.5153],
    [-70.8864, 42.5086],
    [-70.8747, 42.5049],
    [-70.8695, 42.5119],
    [-70.8598, 42.5204],
    [-70.8456, 42.5175],
    [-70.8424, 42.5088],
    [-70.8517, 42.5002],
    [-70.8533, 42.4930],
    [-70.8446, 42.4966],
    [-70.8311, 42.5036],
    [-70.8416, 42.4876],
    [-70.8609, 42.4887],
    [-70.8797, 42.4788],
    [-70.8880, 42.4671],
    [-70.9015, 42.4642],
    [-70.9081, 42.4669],
    [-70.9220, 42.4667],
    [-70.9277, 42.4609],
    [-70.9352, 42.4565],
    [-70.9362, 42.4374],
    [-70.9334, 42.4334],
    [-70.9251, 42.4303],
    [-70.9076, 42.4218],
    [-70.9102, 42.4165],
    [-70.9199, 42.4236],
    [-70.9364, 42.4181],
    [-70.9370, 42.4304],
    [-70.9410, 42.4508],
    [-70.9401, 42.4551],
    [-70.9442, 42.4578],
    [-70.9488, 42.4545],
    [-70.9592, 42.4417],
    [-70.9755, 42.4316],
    [-70.9868, 42.4181],
    [-70.9906, 42.4071],
    [-70.9877, 42.4024],
    [-70.9832, 42.3959],
    [-70.9805, 42.3917],
    [-70.9728, 42.3900],
    [-70.9698, 42.3867],
    [-70.9727, 42.3818],
    [-70.9701, 42.3754],
    [-70.9660, 42.3663],
    [-70.9657, 42.3578],
    [-70.9533, 42.3497],
    [-70.9653, 42.3514],
    [-70.9753, 42.3590],
    [-70.9742, 42.3696],
    [-70.9901, 42.3672],
    [-70.9985, 42.3682],
    [-70.9936, 42.3629],
    [-70.9853, 42.3583],
    [-70.9995, 42.3553],
    [-71.0061, 42.3452],
    [-71.0157, 42.3305],
    [-71.0328, 42.3284],
    [-71.0442, 42.3226],
    [-71.0328, 42.3135],
    [-71.0385, 42.3080],
    [-71.0316, 42.3010],
    [-71.0235, 42.2994],
    [-71.0152, 42.3067],
    [-71.0178, 42.3131],
    [-70.9978, 42.3212],
    [-71.0059, 42.3163],
    [-71.0085, 42.3058],
    [-70.9945, 42.3050],
    [-70.9879, 42.3040],
    [-71.0036, 42.2953],
    [-71.0138, 42.2894],
    [-71.0198, 42.2855],
    [-71.0129, 42.2788],
    [-70.9928, 42.2674],
    [-70.9826, 42.2656],
    [-70.9692, 42.2666],
    [-70.9573, 42.2706],
    [-70.9574, 42.2801],
    [-70.9498, 42.2692],
    [-70.9530, 42.2575],
    [-70.9540, 42.2526],
    [-70.9446, 42.2516],
    [-70.9275, 42.2593],
    [-70.9171, 42.2725],
    [-70.9083, 42.2647],
    [-70.9035, 42.2623],
    [-70.8959, 42.2627],
    [-70.8930, 42.2605],
    [-70.8906, 42.2508],
    [-70.8868, 42.2480],
    [-70.8778, 42.2493],
    [-70.8828, 42.2681],
    [-70.8902, 42.2762],
    [-70.9018, 42.2829],
    [-70.8783, 42.2783],
    [-70.8805, 42.2837],
    [-70.8868, 42.2926],
    [-70.8933, 42.2987],
    [-70.9156, 42.3025],
    [-70.9175, 42.3057],
    [-70.8895, 42.3105],
    [-70.8812, 42.3007],
    [-70.8719, 42.2871],
    [-70.8618, 42.2760],
    [-70.8311, 42.2674],
    [-70.7914, 42.2550],
    [-70.7844, 42.2486],
    [-70.7739, 42.2542],
    [-70.7648, 42.2441],
    [-70.7545, 42.2287],
    [-70.7448, 42.2212],
    [-70.7306, 42.2109],
    [-70.7130, 42.2044],
    [-70.7159, 42.1959],
    [-70.7185, 42.1844],
    [-70.7114, 42.1668],
    [-70.6795, 42.1263],
    [-70.6520, 42.0985],
    [-70.6440, 42.0783],
    [-70.6482, 42.0684],
    [-70.6309, 42.0360],
    [-70.6085, 42.0136],
    [-70.6140, 42.0066],
    [-70.6391, 41.9939],
    [-70.6364, 42.0138],
    [-70.6299, 42.0015],
    [-70.6156, 42.0135],
    [-70.6504, 42.0462],
    [-70.6644, 42.0412],
    [-70.6712, 42.0248],
    [-70.6709, 42.0078],
    [-70.6958, 42.0133],
    [-70.7100, 41.9995],
    [-70.6988, 41.9919],
    [-70.6910, 41.9813],
    [-70.6763, 41.9723],
    [-70.6625, 41.9606],
    [-70.6532, 41.9525],
    [-70.6387, 41.9495],
    [-70.6385, 41.9564],
    [-70.6439, 41.9651],
    [-70.6458, 41.9681],
    [-70.6533, 41.9767],
    [-70.6531, 41.9813],
    [-70.6442, 41.9746],
    [-70.6165, 41.9402],
    [-70.5916, 41.9493],
    [-70.5660, 41.9362],
    [-70.5529, 41.9296],
    [-70.5392, 41.9268],
    [-70.5419, 41.9189],
    [-70.5474, 41.9119],
    [-70.5321, 41.8896],
    [-70.5313, 41.8783],
    [-70.5256, 41.8587],
    [-70.5363, 41.8347],
    [-70.5410, 41.8158],
    [-70.5327, 41.8048],
    [-70.5174, 41.7910],
    [-70.4945, 41.7782],
    [-70.4942, 41.7755],
    [-70.4716, 41.7616],
    [-70.4348, 41.7509],
    [-70.4181, 41.7460],
    [-70.3850, 41.7402],
    [-70.3635, 41.7382],
    [-70.2883, 41.7320],
    [-70.2743, 41.7236],
    [-70.2638, 41.7143],
    [-70.2592, 41.7140],
    [-70.2495, 41.7210],
    [-70.2393, 41.7269],
    [-70.2407, 41.7276],
    [-70.2060, 41.7464],
    [-70.1841, 41.7507],
    [-70.1499, 41.7570],
    [-70.1360, 41.7597],
    [-70.1146, 41.7610],
    [-70.0830, 41.7690],
    [-70.0665, 41.7729],
    [-70.0478, 41.7789],
    [-70.0332, 41.7842],
    [-70.0227, 41.7884],
    [-70.0089, 41.8005],
    [-70.0053, 41.8123],
    [-70.0045, 41.8388],
    [-70.0060, 41.8519],
    [-70.0064, 41.8808],
    [-70.0029, 41.8903],
    [-70.0242, 41.8963],
    [-70.0136, 41.9012],
    [-70.0201, 41.9076],
    [-70.0320, 41.9242],
    [-70.0352, 41.9300],
    [-70.0590, 41.9256],
    [-70.0542, 41.9209],
    [-70.0657, 41.9117],
    [-70.0664, 41.8863],
    [-70.0730, 41.8998],
    [-70.0773, 41.9578],
    [-70.0838, 42.0120],
    [-70.0956, 42.0328],
    [-70.1397, 42.0575],
    [-70.1474, 42.0605],
    [-70.1698, 42.0597],
    [-70.1831, 42.0531],
    [-70.1904, 42.0452],
    [-70.1962, 42.0361],
    [-70.1966, 42.0255],
    [-70.1738, 42.0274],
    [-70.1796, 42.0219],
    [-70.1963, 42.0220],
    [-70.2187, 42.0458],
    [-70.2389, 42.0605],
    [-70.2381, 42.0729],
    [-70.1893, 42.0823],
    [-70.1160, 42.0676],
    [-70.0585, 42.0404],
    [-70.0119, 41.9897],
    [-69.9971, 41.9668],
    [-69.9860, 41.9495],
    [-69.9575, 41.8799],
    [-69.9428, 41.8331],
    [-69.9382, 41.8104],
    [-69.9285, 41.7225],
    [-69.9337, 41.6786],
    [-69.9475, 41.6515],
    [-69.9540, 41.6340],
    [-69.9672, 41.6120],
    [-69.9884, 41.5944],
    [-69.9882, 41.5547],
    [-70.0039, 41.5406],
    [-70.0127, 41.5468],
    [-70.0086, 41.5580],
    [-69.9939, 41.5763],
    [-69.9898, 41.6072],
    [-69.9775, 41.6308],
    [-69.9705, 41.6455],
    [-69.9853, 41.6582],
    [-70.0070, 41.6716],
    [-70.0142, 41.6720],
    [-70.0291, 41.6678],
    [-70.0373, 41.6675],
    [-70.0555, 41.6648],
    [-70.0657, 41.6624],
    [-70.0892, 41.6628],
    [-70.1178, 41.6552],
    [-70.1575, 41.6518],
    [-70.1684, 41.6520],
    [-70.1952, 41.6479],
    [-70.2071, 41.6425],
    [-70.2354, 41.6317],
    [-70.2554, 41.6175],
    [-70.2676, 41.6109],
    [-70.2708, 41.6280],
    [-70.2906, 41.6352],
    [-70.3007, 41.6295],
    [-70.3216, 41.6305],
    [-70.3340, 41.6355],
    [-70.3505, 41.6348],
    [-70.3649, 41.6267],
    [-70.3699, 41.6159],
    [-70.4011, 41.6065],
    [-70.4268, 41.6047],
    [-70.4372, 41.6053],
    [-70.4444, 41.5943],
    [-70.4502, 41.5890],
    [-70.4613, 41.5718],
    [-70.4763, 41.5585],
    [-70.4952, 41.5518],
    [-70.5223, 41.5490],
    [-70.5324, 41.5493],
    [-70.5475, 41.5513],
    [-70.5592, 41.5484],
    [-70.5613, 41.5482],
    [-70.5767, 41.5458],
    [-70.5806, 41.5442],
    [-70.5938, 41.5451],
    [-70.6078, 41.5427],
    [-70.6160, 41.5419],
    [-70.6230, 41.5405],
    [-70.6338, 41.5381],
    [-70.6501, 41.5242],
    [-70.6566, 41.5148],
    [-70.6646, 41.5180],
    [-70.6730, 41.5236],
    [-70.6878, 41.5242],
    [-70.6806, 41.5315],
    [-70.6764, 41.5290],
    [-70.6686, 41.5365],
    [-70.6567, 41.5464],
    [-70.6539, 41.5652],
    [-70.6427, 41.5724],
    [-70.6409, 41.5773],
    [-70.6524, 41.6052],
    [-70.6520, 41.6102],
    [-70.6409, 41.6239],
    [-70.6438, 41.6311],
    [-70.6533, 41.6390],
    [-70.6507, 41.6461],
    [-70.6307, 41.6502],
    [-70.6251, 41.6562],
    [-70.6274, 41.6609],
    [-70.6350, 41.6632],
    [-70.6520, 41.6630],
    [-70.6419, 41.6715],
    [-70.6329, 41.6703],
    [-70.6460, 41.6809],
    [-70.6600, 41.6793],
    [-70.6466, 41.6933],
    [-70.6251, 41.7006],
    [-70.6265, 41.7130],
    [-70.6397, 41.7174],
    [-70.6505, 41.7134],
    [-70.6761, 41.6927],
    [-70.6566, 41.7154],
    [-70.6792, 41.7274],
    [-70.6883, 41.7237],
    [-70.7082, 41.7310],
    [-70.7187, 41.7357],
    [-70.7263, 41.7327],
    [-70.7258, 41.7246],
    [-70.7213, 41.7130],
    [-70.7142, 41.7017],
    [-70.7261, 41.7006],
    [-70.7149, 41.6919],
    [-70.7156, 41.6753],
    [-70.7294, 41.6881],
    [-70.7444, 41.6980],
    [-70.7553, 41.6943],
    [-70.7517, 41.6856],
    [-70.7451, 41.6724],
    [-70.7584, 41.6806],
    [-70.7619, 41.6729],
    [-70.7619, 41.6655],
    [-70.7624, 41.6527],
    [-70.7684, 41.6458],
    [-70.7737, 41.6450],
    [-70.7772, 41.6508],
    [-70.7861, 41.6522],
    [-70.8023, 41.6557],
    [-70.8138, 41.6574],
    [-70.8171, 41.6563],
    [-70.8222, 41.6527],
    [-70.8047, 41.6412],
    [-70.8011, 41.6295],
    [-70.8177, 41.6234],
    [-70.8353, 41.6245],
    [-70.8525, 41.6269],
    [-70.8596, 41.6241],
    [-70.8543, 41.6186],
    [-70.8496, 41.6103],
    [-70.8420, 41.5935],
    [-70.8487, 41.5941],
    [-70.8518, 41.5875],
    [-70.8567, 41.5837],
    [-70.8637, 41.5976],
    [-70.8687, 41.6144],
    [-70.8696, 41.6256],
    [-70.8777, 41.6294],
    [-70.8821, 41.6307],
    [-70.8892, 41.6329],
    [-70.8946, 41.6241],
    [-70.9058, 41.6236],
    [-70.9132, 41.6193],
    [-70.9072, 41.6131],
    [-70.9033, 41.6067],
    [-70.8986, 41.5927],
    [-70.9108, 41.5955],
    [-70.9171, 41.6079],
    [-70.9218, 41.6134],
    [-70.9256, 41.6139],
    [-70.9303, 41.6085],
    [-70.9312, 41.6069],
    [-70.9278, 41.5930],
    [-70.9313, 41.5842],
    [-70.9377, 41.5776],
    [-70.9444, 41.5811],
    [-70.9488, 41.5790],
    [-70.9354, 41.5557],
    [-70.9346, 41.5487],
    [-70.9463, 41.5376],
    [-70.9526, 41.5181],
    [-70.9580, 41.5217],
    [-70.9723, 41.5308],
    [-70.9846, 41.5204],
    [-70.9840, 41.5089],
    [-71.0194, 41.5089],
    [-71.0355, 41.4990],
    [-71.0355, 41.4816],
    [-71.0412, 41.4909],
    [-71.0486, 41.5027],
    [-71.0707, 41.5089],
    [-71.1068, 41.5025],
    [-71.1206, 41.4974],
    [-71.1276, 41.5632],
    [-71.1316, 41.5939],
    [-71.1406, 41.6051],
    [-71.1415, 41.6161],
    [-71.1357, 41.6285],
    [-71.1345, 41.6413],
    [-71.1347, 41.6605],
    [-71.1540, 41.6641],
    [-71.1761, 41.6685],
    [-71.1813, 41.6725],
    [-71.1912, 41.6743],
    [-71.1956, 41.6751],
    [-71.2083, 41.6905],
    [-71.2248, 41.7105],
    [-71.2452, 41.7339],
    [-71.2547, 41.7447],
    [-71.2948, 41.7664],
    [-71.3178, 41.7761],
    [-71.3294, 41.7826],
    [-71.3322, 41.7923],
    [-71.3393, 41.7963],
    [-71.3402, 41.8019],
    [-71.3390, 41.8077],
    [-71.3390, 41.8086],
    [-71.3459, 41.8259],
    [-71.3396, 41.8320],
    [-71.3352, 41.8355],
    [-71.3422, 41.8448],
    [-71.3340, 41.8623],
    [-71.3378, 41.8732],
    [-71.3397, 41.8901],
    [-71.3393, 41.8936],
    [-71.3388, 41.8984],
    [-71.3491, 41.8971],
    [-71.3547, 41.8965],
    [-71.3654, 41.8953],
    [-71.3738, 41.8944],
    [-71.3766, 41.8940],
    [-71.3817, 41.8938],
    [-71.3817, 41.9147],
    [-71.3817, 41.9227],
    [-71.3815, 41.9529],
    [-71.3815, 41.9667],
    [-71.3814, 42.0000],
    [-71.4581, 42.0178],
    [-71.4838, 42.0174],
    [-71.4999, 42.0172],
    [-71.5021, 42.0170],
    [-71.5273, 42.0151],
    [-71.5291, 42.0150],
    [-71.5637, 42.0143],
    [-71.5911, 42.0138],
    [-71.6453, 42.0125],
    [-71.6809, 42.0117],
    [-71.7992, 42.0081],
    [-71.8416, 42.0239],
    [-71.8660, 42.0241],
    [-71.8839, 42.0243],
    [-71.9210, 42.0252],
    [-71.9873, 42.0269],
    [-72.0100, 42.0270],
    [-72.0997, 42.0288],
    [-72.1357, 42.0302],
    [-72.1988, 42.0310],
    [-72.2495, 42.0316],
    [-72.3213, 42.0320],
    [-72.3974, 42.0331],
    [-72.4583, 42.0340],
    [-72.5092, 42.0342],
    [-72.5315, 42.0340],
    [-72.5531, 42.0320],
    [-72.5634, 42.0310],
    [-72.5823, 42.0247],
    [-72.6069, 42.0250],
    [-72.6080, 42.0308],
    [-72.6431, 42.0324],
    [-72.6959, 42.0368],
    [-72.7146, 42.0366],
    [-72.7558, 42.0362],
    [-72.7517, 42.0302],
    [-72.7582, 42.0209],
    [-72.7623, 42.0198],
    [-72.7612, 42.0146],
    [-72.7661, 42.0077],
    [-72.7706, 42.0026],
    [-72.8167, 41.9976],
    [-72.8350, 42.0367],
    [-72.8636, 42.0377],
    [-72.9995, 42.0387],
    [-73.0533, 42.0399],
    [-73.2298, 42.0449],
    [-73.2334, 42.0450],
    [-73.2963, 42.0470],
    [-73.3405, 42.0482],
    [-73.4368, 42.0505],
    [-73.5030, 42.0697],
    [-73.5081, 42.0863]
    ]
  },
  "Idaho": {
    coordinates: [
      [-117.2427, 44.3965],
    [-117.2255, 44.4077],
    [-117.2146, 44.4480],
    [-117.2215, 44.4701],
    [-117.2259, 44.4794],
    [-117.2215, 44.4846],
    [-117.2089, 44.4857],
    [-117.1925, 44.5033],
    [-117.1898, 44.5134],
    [-117.1672, 44.5234],
    [-117.1492, 44.5362],
    [-117.1479, 44.5621],
    [-117.1425, 44.5714],
    [-117.1260, 44.5816],
    [-117.1205, 44.6147],
    [-117.1082, 44.6271],
    [-117.0968, 44.6574],
    [-117.0861, 44.6718],
    [-117.0790, 44.6777],
    [-117.0808, 44.6842],
    [-117.0787, 44.6901],
    [-117.0722, 44.7005],
    [-117.0605, 44.7217],
    [-117.0505, 44.7325],
    [-117.0463, 44.7431],
    [-117.0383, 44.7482],
    [-117.0214, 44.7508],
    [-117.0138, 44.7568],
    [-116.9920, 44.7592],
    [-116.9729, 44.7726],
    [-116.9490, 44.7780],
    [-116.9318, 44.7872],
    [-116.9331, 44.7945],
    [-116.9311, 44.8048],
    [-116.9058, 44.8348],
    [-116.9001, 44.8400],
    [-116.8962, 44.8483],
    [-116.8982, 44.8543],
    [-116.8899, 44.8552],
    [-116.8794, 44.8618],
    [-116.8717, 44.8676],
    [-116.8524, 44.8876],
    [-116.8421, 44.9149],
    [-116.8322, 44.9314],
    [-116.8507, 44.9581],
    [-116.8293, 44.9752],
    [-116.8349, 44.9858],
    [-116.8443, 44.9749],
    [-116.8570, 44.9752],
    [-116.8461, 44.9999],
    [-116.8458, 45.0185],
    [-116.8301, 45.0353],
    [-116.7973, 45.0603],
    [-116.7842, 45.0881],
    [-116.7748, 45.1055],
    [-116.7486, 45.1229],
    [-116.7430, 45.1349],
    [-116.7296, 45.1421],
    [-116.7251, 45.1591],
    [-116.7242, 45.1715],
    [-116.7097, 45.2172],
    [-116.6960, 45.2547],
    [-116.6870, 45.2679],
    [-116.6745, 45.2763],
    [-116.6726, 45.2980],
    [-116.6533, 45.3511],
    [-116.5974, 45.4128],
    [-116.5814, 45.4490],
    [-116.5617, 45.4612],
    [-116.5588, 45.4801],
    [-116.5535, 45.4991],
    [-116.5576, 45.5032],
    [-116.5525, 45.5083],
    [-116.5355, 45.5251],
    [-116.5239, 45.5482],
    [-116.5286, 45.5511],
    [-116.5222, 45.5556],
    [-116.5103, 45.5568],
    [-116.5032, 45.5628],
    [-116.4903, 45.5745],
    [-116.4812, 45.5806],
    [-116.4808, 45.5879],
    [-116.4716, 45.5936],
    [-116.4652, 45.6180],
    [-116.4712, 45.6277],
    [-116.4810, 45.6322],
    [-116.4828, 45.6368],
    [-116.4842, 45.6423],
    [-116.4873, 45.6477],
    [-116.5123, 45.6702],
    [-116.5354, 45.6917],
    [-116.5357, 45.7342],
    [-116.5466, 45.7510],
    [-116.5594, 45.7552],
    [-116.6050, 45.7810],
    [-116.6396, 45.7813],
    [-116.6653, 45.7820],
    [-116.6972, 45.8201],
    [-116.7118, 45.8263],
    [-116.7405, 45.8245],
    [-116.7553, 45.8171],
    [-116.7827, 45.8254],
    [-116.7889, 45.8367],
    [-116.7902, 45.8499],
    [-116.7966, 45.8590],
    [-116.8300, 45.8864],
    [-116.8598, 45.9073],
    [-116.8705, 45.9324],
    [-116.8749, 45.9503],
    [-116.8868, 45.9586],
    [-116.8929, 45.9764],
    [-116.9160, 45.9954],
    [-116.9212, 46.0135],
    [-116.9298, 46.0236],
    [-116.9317, 46.0397],
    [-116.9435, 46.0544],
    [-116.9574, 46.0754],
    [-116.9700, 46.0768],
    [-116.9825, 46.0894],
    [-116.9788, 46.0957],
    [-116.9595, 46.0991],
    [-116.9510, 46.1189],
    [-116.9430, 46.1293],
    [-116.9339, 46.1389],
    [-116.9306, 46.1568],
    [-116.9219, 46.1678],
    [-116.9336, 46.1736],
    [-116.9417, 46.1850],
    [-116.9630, 46.1997],
    [-116.9661, 46.2095],
    [-116.9553, 46.2309],
    [-116.9667, 46.2569],
    [-116.9761, 46.2660],
    [-116.9914, 46.2785],
    [-116.9846, 46.2927],
    [-116.9973, 46.3032],
    [-117.0207, 46.3148],
    [-117.0234, 46.3264],
    [-117.0238, 46.3359],
    [-117.0307, 46.3403],
    [-117.0517, 46.3438],
    [-117.0592, 46.3479],
    [-117.0626, 46.3525],
    [-117.0610, 46.3677],
    [-117.0531, 46.3747],
    [-117.0471, 46.3794],
    [-117.0438, 46.3875],
    [-117.0415, 46.3960],
    [-117.0383, 46.4060],
    [-117.0365, 46.4078],
    [-117.0356, 46.4205],
    [-117.0385, 46.4243],
    [-117.0398, 46.4259],
    [-117.0398, 46.4570],
    [-117.0398, 46.4718],
    [-117.0395, 46.6208],
    [-117.0394, 46.7002],
    [-117.0395, 46.7219],
    [-117.0395, 46.7367],
    [-117.0397, 46.8222],
    [-117.0397, 46.8609],
    [-117.0397, 46.9611],
    [-117.0398, 47.0902],
    [-117.0398, 47.1273],
    [-117.0399, 47.1819],
    [-117.0400, 47.2402],
    [-117.0398, 47.3472],
    [-117.0402, 47.3749],
    [-117.0400, 47.4124],
    [-117.0400, 47.4633],
    [-117.0405, 47.5224],
    [-117.0407, 47.5329],
    [-117.0409, 47.5715],
    [-117.0409, 47.5798],
    [-117.0411, 47.6218],
    [-117.0414, 47.6782],
    [-117.0416, 47.6954],
    [-117.0416, 47.6978],
    [-117.0416, 47.7045],
    [-117.0416, 47.7068],
    [-117.0416, 47.7353],
    [-117.0421, 47.7441],
    [-117.0426, 47.7612],
    [-117.0421, 47.7786],
    [-117.0425, 47.8390],
    [-117.0424, 47.8861],
    [-117.0423, 47.9775],
    [-117.0414, 48.0855],
    [-117.0398, 48.1664],
    [-117.0395, 48.1747],
    [-117.0396, 48.1803],
    [-117.0396, 48.1840],
    [-117.0395, 48.1876],
    [-117.0392, 48.1935],
    [-117.0386, 48.2079],
    [-117.0352, 48.3712],
    [-117.0353, 48.4298],
    [-117.0354, 48.4788],
    [-117.0346, 48.6082],
    [-117.0337, 48.6553],
    [-117.0324, 48.8467],
    [-116.7572, 48.9998],
    [-116.5042, 48.9999],
    [-116.3584, 49.0006],
    [-116.0491, 49.0008],
    [-116.0491, 48.6115],
    [-116.0491, 48.5020],
    [-116.0490, 48.3937],
    [-116.0490, 48.2164],
    [-116.0489, 48.1249],
    [-116.0491, 48.0795],
    [-116.0491, 47.9773],
    [-116.0304, 47.9726],
    [-116.0222, 47.9649],
    [-116.0075, 47.9508],
    [-116.0033, 47.9408],
    [-115.9934, 47.9291],
    [-115.9848, 47.9227],
    [-115.9823, 47.9156],
    [-115.9654, 47.9109],
    [-115.9664, 47.8983],
    [-115.9534, 47.8941],
    [-115.9456, 47.8858],
    [-115.9355, 47.8742],
    [-115.9252, 47.8669],
    [-115.9188, 47.8537],
    [-115.9068, 47.8464],
    [-115.8979, 47.8445],
    [-115.8753, 47.8433],
    [-115.8593, 47.8310],
    [-115.8506, 47.8253],
    [-115.8486, 47.8107],
    [-115.8458, 47.7932],
    [-115.8407, 47.7786],
    [-115.8354, 47.7617],
    [-115.8147, 47.7561],
    [-115.7973, 47.7571],
    [-115.7809, 47.7425],
    [-115.7842, 47.7320],
    [-115.7740, 47.7179],
    [-115.7592, 47.7192],
    [-115.7448, 47.7119],
    [-115.7317, 47.7052],
    [-115.7256, 47.6884],
    [-115.7265, 47.6732],
    [-115.7312, 47.6661],
    [-115.7304, 47.6423],
    [-115.7079, 47.6348],
    [-115.6925, 47.6175],
    [-115.6988, 47.6118],
    [-115.6920, 47.5978],
    [-115.6918, 47.5933],
    [-115.7051, 47.5844],
    [-115.7067, 47.5775],
    [-115.7220, 47.5754],
    [-115.7312, 47.5693],
    [-115.7443, 47.5590],
    [-115.7543, 47.5526],
    [-115.7444, 47.5392],
    [-115.7345, 47.5393],
    [-115.7167, 47.5337],
    [-115.7023, 47.5342],
    [-115.7005, 47.5257],
    [-115.7114, 47.5168],
    [-115.6986, 47.5023],
    [-115.6863, 47.4849],
    [-115.6767, 47.4865],
    [-115.6620, 47.4831],
    [-115.6473, 47.4780],
    [-115.6343, 47.4815],
    [-115.6401, 47.4597],
    [-115.6642, 47.4539],
    [-115.6823, 47.4569],
    [-115.7021, 47.4525],
    [-115.7254, 47.4476],
    [-115.7457, 47.4423],
    [-115.7524, 47.4322],
    [-115.7588, 47.4236],
    [-115.7427, 47.4236],
    [-115.7214, 47.4257],
    [-115.7167, 47.4186],
    [-115.7004, 47.4166],
    [-115.6921, 47.4153],
    [-115.6753, 47.4089],
    [-115.6730, 47.4024],
    [-115.6573, 47.4002],
    [-115.6506, 47.3926],
    [-115.6484, 47.3827],
    [-115.6301, 47.3793],
    [-115.6154, 47.3819],
    [-115.6021, 47.3775],
    [-115.5910, 47.3701],
    [-115.5776, 47.3674],
    [-115.5750, 47.3559],
    [-115.5603, 47.3522],
    [-115.5491, 47.3472],
    [-115.5410, 47.3258],
    [-115.5314, 47.3112],
    [-115.5153, 47.2968],
    [-115.4908, 47.2895],
    [-115.4804, 47.2816],
    [-115.4667, 47.2872],
    [-115.4573, 47.2783],
    [-115.4447, 47.2770],
    [-115.4358, 47.2803],
    [-115.4210, 47.2776],
    [-115.4121, 47.2646],
    [-115.3921, 47.2654],
    [-115.3713, 47.2653],
    [-115.3538, 47.2621],
    [-115.3404, 47.2629],
    [-115.3197, 47.2563],
    [-115.3244, 47.2447],
    [-115.3111, 47.2297],
    [-115.2988, 47.2255],
    [-115.2916, 47.2100],
    [-115.3005, 47.1881],
    [-115.2868, 47.1835],
    [-115.2726, 47.1827],
    [-115.2624, 47.1817],
    [-115.2568, 47.1698],
    [-115.2505, 47.1599],
    [-115.2453, 47.1518],
    [-115.2254, 47.1488],
    [-115.2163, 47.1454],
    [-115.2046, 47.1405],
    [-115.1991, 47.1396],
    [-115.1929, 47.1331],
    [-115.1865, 47.1247],
    [-115.1793, 47.1202],
    [-115.1735, 47.1097],
    [-115.1580, 47.1028],
    [-115.1443, 47.1020],
    [-115.1417, 47.0857],
    [-115.1378, 47.0775],
    [-115.1263, 47.0660],
    [-115.1220, 47.0633],
    [-115.1168, 47.0579],
    [-115.1026, 47.0474],
    [-115.0884, 47.0411],
    [-115.0810, 47.0298],
    [-115.0717, 47.0259],
    [-115.0694, 47.0151],
    [-115.0728, 47.0134],
    [-115.0674, 46.9955],
    [-115.0567, 46.9848],
    [-115.0484, 46.9698],
    [-115.0297, 46.9725],
    [-115.0170, 46.9739],
    [-115.0009, 46.9677],
    [-114.9864, 46.9542],
    [-114.9763, 46.9430],
    [-114.9643, 46.9375],
    [-114.9610, 46.9304],
    [-114.9419, 46.9241],
    [-114.9253, 46.9187],
    [-114.9310, 46.9041],
    [-114.9351, 46.8949],
    [-114.9311, 46.8821],
    [-114.9438, 46.8682],
    [-114.9421, 46.8565],
    [-114.9268, 46.8510],
    [-114.9243, 46.8475],
    [-114.9268, 46.8389],
    [-114.9252, 46.8337],
    [-114.9153, 46.8254],
    [-114.8996, 46.8226],
    [-114.8951, 46.8174],
    [-114.8952, 46.8016],
    [-114.8749, 46.8119],
    [-114.8606, 46.8057],
    [-114.8508, 46.7988],
    [-114.8368, 46.7926],
    [-114.8236, 46.7828],
    [-114.8034, 46.7779],
    [-114.7879, 46.7818],
    [-114.7864, 46.7779],
    [-114.7790, 46.7670],
    [-114.7652, 46.7583],
    [-114.7658, 46.7512],
    [-114.7656, 46.7456],
    [-114.7728, 46.7332],
    [-114.7779, 46.7315],
    [-114.7828, 46.7263],
    [-114.7823, 46.7193],
    [-114.7881, 46.7121],
    [-114.7788, 46.7067],
    [-114.7695, 46.6999],
    [-114.7639, 46.6977],
    [-114.7480, 46.6990],
    [-114.7417, 46.7086],
    [-114.7261, 46.7146],
    [-114.7108, 46.7173],
    [-114.7086, 46.7272],
    [-114.7012, 46.7349],
    [-114.6965, 46.7405],
    [-114.6820, 46.7389],
    [-114.6712, 46.7368],
    [-114.6610, 46.7357],
    [-114.6468, 46.7309],
    [-114.6446, 46.7228],
    [-114.6382, 46.7202],
    [-114.6305, 46.7146],
    [-114.6215, 46.7079],
    [-114.6242, 46.6955],
    [-114.6264, 46.6880],
    [-114.6402, 46.6754],
    [-114.6379, 46.6724],
    [-114.6331, 46.6700],
    [-114.6398, 46.6660],
    [-114.6346, 46.6592],
    [-114.6145, 46.6547],
    [-114.6117, 46.6475],
    [-114.6053, 46.6358],
    [-114.5923, 46.6328],
    [-114.5797, 46.6354],
    [-114.5698, 46.6433],
    [-114.5556, 46.6446],
    [-114.5413, 46.6497],
    [-114.5285, 46.6423],
    [-114.5012, 46.6413],
    [-114.4926, 46.6362],
    [-114.4671, 46.6318],
    [-114.4535, 46.6492],
    [-114.4368, 46.6557],
    [-114.4110, 46.6574],
    [-114.4043, 46.6595],
    [-114.3903, 46.6650],
    [-114.3781, 46.6671],
    [-114.3579, 46.6706],
    [-114.3444, 46.6620],
    [-114.3327, 46.6606],
    [-114.3249, 46.6536],
    [-114.3203, 46.6385],
    [-114.3222, 46.6267],
    [-114.3271, 46.6172],
    [-114.3303, 46.5995],
    [-114.3437, 46.5905],
    [-114.3337, 46.5790],
    [-114.3308, 46.5738],
    [-114.3395, 46.5640],
    [-114.3475, 46.5510],
    [-114.3462, 46.5361],
    [-114.3475, 46.5260],
    [-114.3428, 46.5183],
    [-114.3519, 46.5077],
    [-114.3683, 46.5050],
    [-114.3831, 46.5049],
    [-114.3999, 46.5022],
    [-114.4014, 46.4889],
    [-114.3961, 46.4734],
    [-114.3831, 46.4662],
    [-114.3798, 46.4607],
    [-114.3845, 46.4478],
    [-114.3740, 46.4432],
    [-114.3685, 46.4380],
    [-114.3814, 46.4339],
    [-114.3850, 46.4112],
    [-114.3991, 46.4051],
    [-114.4098, 46.3994],
    [-114.4222, 46.3873],
    [-114.4136, 46.3467],
    [-114.4177, 46.3321],
    [-114.4225, 46.3241],
    [-114.4328, 46.3061],
    [-114.4286, 46.2925],
    [-114.4273, 46.2836],
    [-114.4537, 46.2709],
    [-114.4669, 46.2720],
    [-114.4690, 46.2596],
    [-114.4681, 46.2487],
    [-114.4519, 46.2407],
    [-114.4513, 46.2155],
    [-114.4432, 46.2029],
    [-114.4450, 46.1859],
    [-114.4452, 46.1679],
    [-114.4629, 46.1681],
    [-114.4760, 46.1606],
    [-114.4944, 46.1680],
    [-114.5068, 46.1646],
    [-114.5156, 46.1661],
    [-114.5143, 46.1543],
    [-114.5271, 46.1462],
    [-114.5188, 46.1357],
    [-114.5205, 46.1249],
    [-114.5017, 46.1191],
    [-114.4862, 46.1134],
    [-114.4710, 46.1059],
    [-114.4651, 46.1022],
    [-114.4609, 46.0853],
    [-114.4713, 46.0771],
    [-114.4671, 46.0655],
    [-114.4747, 46.0584],
    [-114.4929, 46.0502],
    [-114.5062, 46.0389],
    [-114.5054, 46.0300],
    [-114.4862, 46.0299],
    [-114.4735, 46.0131],
    [-114.4850, 45.9969],
    [-114.4643, 45.9975],
    [-114.4476, 45.9874],
    [-114.4191, 45.9809],
    [-114.4061, 45.9700],
    [-114.4069, 45.9542],
    [-114.4249, 45.9436],
    [-114.4314, 45.9360],
    [-114.4162, 45.9187],
    [-114.3960, 45.9014],
    [-114.3937, 45.8930],
    [-114.3873, 45.8877],
    [-114.3966, 45.8710],
    [-114.4050, 45.8671],
    [-114.4215, 45.8552],
    [-114.4487, 45.8591],
    [-114.4650, 45.8521],
    [-114.4749, 45.8466],
    [-114.4990, 45.8507],
    [-114.5152, 45.8398],
    [-114.5144, 45.8271],
    [-114.5302, 45.8131],
    [-114.5376, 45.8028],
    [-114.5444, 45.7900],
    [-114.5665, 45.7733],
    [-114.5441, 45.7584],
    [-114.5475, 45.7443],
    [-114.5308, 45.7333],
    [-114.5152, 45.7274],
    [-114.5025, 45.7175],
    [-114.4968, 45.6993],
    [-114.5086, 45.6895],
    [-114.5009, 45.6823],
    [-114.5020, 45.6735],
    [-114.5127, 45.6560],
    [-114.5280, 45.6519],
    [-114.5413, 45.6486],
    [-114.5460, 45.6430],
    [-114.5635, 45.6323],
    [-114.5450, 45.6171],
    [-114.5432, 45.6015],
    [-114.5541, 45.5912],
    [-114.5583, 45.5843],
    [-114.5562, 45.5734],
    [-114.5655, 45.5626],
    [-114.5526, 45.5570],
    [-114.5330, 45.5658],
    [-114.5163, 45.5680],
    [-114.5035, 45.5592],
    [-114.4853, 45.5618],
    [-114.4719, 45.5652],
    [-114.4563, 45.5610],
    [-114.4639, 45.5454],
    [-114.4503, 45.5422],
    [-114.4370, 45.5308],
    [-114.4291, 45.5215],
    [-114.4180, 45.5097],
    [-114.3764, 45.4951],
    [-114.3603, 45.4782],
    [-114.3511, 45.4705],
    [-114.3400, 45.4597],
    [-114.3296, 45.4600],
    [-114.3187, 45.4661],
    [-114.3012, 45.4734],
    [-114.2863, 45.4794],
    [-114.2704, 45.4844],
    [-114.2607, 45.4967],
    [-114.2471, 45.5252],
    [-114.2516, 45.5375],
    [-114.2272, 45.5459],
    [-114.2037, 45.5356],
    [-114.1807, 45.5507],
    [-114.1655, 45.5523],
    [-114.1504, 45.5578],
    [-114.1290, 45.5654],
    [-114.1290, 45.5774],
    [-114.0907, 45.5911],
    [-114.0831, 45.6031],
    [-114.0718, 45.6177],
    [-114.0585, 45.6317],
    [-114.0432, 45.6405],
    [-114.0216, 45.6480],
    [-114.0153, 45.6634],
    [-114.0274, 45.6745],
    [-114.0148, 45.6835],
    [-114.0155, 45.6959],
    [-114.0013, 45.6964],
    [-113.9940, 45.7032],
    [-113.9813, 45.7027],
    [-113.9708, 45.6990],
    [-113.9619, 45.6897],
    [-113.9483, 45.6930],
    [-113.9382, 45.6954],
    [-113.9342, 45.6822],
    [-113.9291, 45.6704],
    [-113.9195, 45.6579],
    [-113.9084, 45.6531],
    [-113.8973, 45.6467],
    [-113.9022, 45.6377],
    [-113.9001, 45.6283],
    [-113.9037, 45.6216],
    [-113.8895, 45.6179],
    [-113.8742, 45.6201],
    [-113.8628, 45.6235],
    [-113.8551, 45.6222],
    [-113.8430, 45.6124],
    [-113.8290, 45.6126],
    [-113.8182, 45.6079],
    [-113.8045, 45.5942],
    [-113.7974, 45.5817],
    [-113.8110, 45.5746],
    [-113.8210, 45.5654],
    [-113.8179, 45.5567],
    [-113.8294, 45.5371],
    [-113.8331, 45.5242],
    [-113.8254, 45.5213],
    [-113.8091, 45.5199],
    [-113.7915, 45.5222],
    [-113.7666, 45.5209],
    [-113.7722, 45.5122],
    [-113.7710, 45.5078],
    [-113.7634, 45.4915],
    [-113.7649, 45.4766],
    [-113.7764, 45.4704],
    [-113.7836, 45.4557],
    [-113.7753, 45.4393],
    [-113.7650, 45.4311],
    [-113.7642, 45.4223],
    [-113.7760, 45.4085],
    [-113.7527, 45.4028],
    [-113.7344, 45.3924],
    [-113.7342, 45.3777],
    [-113.7334, 45.3631],
    [-113.7345, 45.3486],
    [-113.7381, 45.3284],
    [-113.7291, 45.3205],
    [-113.7185, 45.3134],
    [-113.7100, 45.3010],
    [-113.7006, 45.2925],
    [-113.6793, 45.2755],
    [-113.6910, 45.2722],
    [-113.6846, 45.2531],
    [-113.6719, 45.2488],
    [-113.6477, 45.2266],
    [-113.6370, 45.2129],
    [-113.6107, 45.1973],
    [-113.5972, 45.1865],
    [-113.5896, 45.1776],
    [-113.5909, 45.1618],
    [-113.5837, 45.1534],
    [-113.5708, 45.1480],
    [-113.5668, 45.1439],
    [-113.5766, 45.1315],
    [-113.5545, 45.1187],
    [-113.5296, 45.1164],
    [-113.5103, 45.1155],
    [-113.5069, 45.1069],
    [-113.5225, 45.0917],
    [-113.5071, 45.0834],
    [-113.4871, 45.0747],
    [-113.4853, 45.0635],
    [-113.4618, 45.0647],
    [-113.4506, 45.0537],
    [-113.4498, 45.0455],
    [-113.4462, 45.0335],
    [-113.4390, 45.0098],
    [-113.4462, 44.9993],
    [-113.4468, 44.9869],
    [-113.4452, 44.9726],
    [-113.4439, 44.9602],
    [-113.4523, 44.9522],
    [-113.4725, 44.9482],
    [-113.4877, 44.9469],
    [-113.4974, 44.9455],
    [-113.4950, 44.9314],
    [-113.4915, 44.9245],
    [-113.4767, 44.9118],
    [-113.4758, 44.8986],
    [-113.4729, 44.8924],
    [-113.4626, 44.8819],
    [-113.4551, 44.8654],
    [-113.4394, 44.8555],
    [-113.4260, 44.8484],
    [-113.4216, 44.8376],
    [-113.3943, 44.8369],
    [-113.3771, 44.8348],
    [-113.3561, 44.8198],
    [-113.3544, 44.7954],
    [-113.3464, 44.7885],
    [-113.3295, 44.7886],
    [-113.2994, 44.8026],
    [-113.2727, 44.8144],
    [-113.2476, 44.8229],
    [-113.2393, 44.8146],
    [-113.2217, 44.8106],
    [-113.1953, 44.8023],
    [-113.1795, 44.7872],
    [-113.1594, 44.7809],
    [-113.1406, 44.7767],
    [-113.1314, 44.7653],
    [-113.1343, 44.7523],
    [-113.1215, 44.7472],
    [-113.1160, 44.7323],
    [-113.1023, 44.7258],
    [-113.1013, 44.7062],
    [-113.0940, 44.6953],
    [-113.0799, 44.6872],
    [-113.0763, 44.6806],
    [-113.0697, 44.6690],
    [-113.0646, 44.6528],
    [-113.0515, 44.6369],
    [-113.0571, 44.6186],
    [-113.0704, 44.6163],
    [-113.0839, 44.6036],
    [-113.0798, 44.5965],
    [-113.0627, 44.5864],
    [-113.0672, 44.5791],
    [-113.0378, 44.5651],
    [-113.0478, 44.5483],
    [-113.0309, 44.5370],
    [-113.0132, 44.5282],
    [-113.0156, 44.5162],
    [-113.0170, 44.5040],
    [-113.0200, 44.4837],
    [-113.0088, 44.4659],
    [-113.0020, 44.4499],
    [-112.9794, 44.4336],
    [-112.9522, 44.4243],
    [-112.9396, 44.4125],
    [-112.9229, 44.4108],
    [-112.9126, 44.4021],
    [-112.8913, 44.4055],
    [-112.8847, 44.4021],
    [-112.8842, 44.3937],
    [-112.8767, 44.3775],
    [-112.8635, 44.3695],
    [-112.8419, 44.3608],
    [-112.8138, 44.3762],
    [-112.8119, 44.3879],
    [-112.8130, 44.3977],
    [-112.8199, 44.4002],
    [-112.8307, 44.4159],
    [-112.8394, 44.4251],
    [-112.8281, 44.4315],
    [-112.8259, 44.4440],
    [-112.8127, 44.4545],
    [-112.8077, 44.4531],
    [-112.7976, 44.4619],
    [-112.7855, 44.4791],
    [-112.7722, 44.4836],
    [-112.7489, 44.4901],
    [-112.7339, 44.4998],
    [-112.6980, 44.4999],
    [-112.6876, 44.4955],
    [-112.6720, 44.4914],
    [-112.6425, 44.4899],
    [-112.6285, 44.4828],
    [-112.6020, 44.4907],
    [-112.5772, 44.4804],
    [-112.5493, 44.4845],
    [-112.5347, 44.4783],
    [-112.5118, 44.4710],
    [-112.5002, 44.4630],
    [-112.4912, 44.4703],
    [-112.4799, 44.4750],
    [-112.4720, 44.4791],
    [-112.4604, 44.4751],
    [-112.4528, 44.4665],
    [-112.4409, 44.4648],
    [-112.4345, 44.4557],
    [-112.4229, 44.4547],
    [-112.4067, 44.4573],
    [-112.3908, 44.4507],
    [-112.3830, 44.4518],
    [-112.3667, 44.4671],
    [-112.3609, 44.4851],
    [-112.3583, 44.4960],
    [-112.3583, 44.5079],
    [-112.3567, 44.5246],
    [-112.3518, 44.5379],
    [-112.3307, 44.5384],
    [-112.3150, 44.5500],
    [-112.3076, 44.5577],
    [-112.2973, 44.5607],
    [-112.2887, 44.5679],
    [-112.2663, 44.5659],
    [-112.2508, 44.5677],
    [-112.2406, 44.5667],
    [-112.2292, 44.5636],
    [-112.2304, 44.5581],
    [-112.2289, 44.5532],
    [-112.1940, 44.5369],
    [-112.1776, 44.5352],
    [-112.1489, 44.5368],
    [-112.1352, 44.5371],
    [-112.1262, 44.5288],
    [-112.1068, 44.5208],
    [-112.0933, 44.5300],
    [-112.0696, 44.5369],
    [-112.0508, 44.5344],
    [-112.0388, 44.5328],
    [-112.0343, 44.5284],
    [-112.0341, 44.5377],
    [-112.0266, 44.5459],
    [-112.0132, 44.5426],
    [-112.0054, 44.5384],
    [-111.9964, 44.5356],
    [-111.9886, 44.5372],
    [-111.9716, 44.5376],
    [-111.9641, 44.5441],
    [-111.9598, 44.5495],
    [-111.9489, 44.5563],
    [-111.9350, 44.5580],
    [-111.9166, 44.5563],
    [-111.8949, 44.5600],
    [-111.8897, 44.5646],
    [-111.8795, 44.5604],
    [-111.8696, 44.5658],
    [-111.8676, 44.5596],
    [-111.8572, 44.5491],
    [-111.8518, 44.5428],
    [-111.8423, 44.5262],
    [-111.8309, 44.5168],
    [-111.8114, 44.5113],
    [-111.8092, 44.5131],
    [-111.8083, 44.5184],
    [-111.8011, 44.5260],
    [-111.7855, 44.5236],
    [-111.7776, 44.5251],
    [-111.7640, 44.5267],
    [-111.7464, 44.5408],
    [-111.7311, 44.5427],
    [-111.7156, 44.5434],
    [-111.7052, 44.5568],
    [-111.6912, 44.5566],
    [-111.6824, 44.5609],
    [-111.6667, 44.5561],
    [-111.6593, 44.5527],
    [-111.6459, 44.5547],
    [-111.6240, 44.5513],
    [-111.6146, 44.5488],
    [-111.6047, 44.5530],
    [-111.5926, 44.5609],
    [-111.5801, 44.5597],
    [-111.5628, 44.5552],
    [-111.5471, 44.5572],
    [-111.5364, 44.5506],
    [-111.5153, 44.5370],
    [-111.4996, 44.5420],
    [-111.4892, 44.5408],
    [-111.4797, 44.5421],
    [-111.4666, 44.5406],
    [-111.4669, 44.5470],
    [-111.4680, 44.5549],
    [-111.4758, 44.5546],
    [-111.4858, 44.5575],
    [-111.5048, 44.5620],
    [-111.5084, 44.5675],
    [-111.5009, 44.5713],
    [-111.5178, 44.5822],
    [-111.5226, 44.5902],
    [-111.5205, 44.6003],
    [-111.5249, 44.6041],
    [-111.5224, 44.6131],
    [-111.5159, 44.6204],
    [-111.5046, 44.6253],
    [-111.5076, 44.6325],
    [-111.5165, 44.6409],
    [-111.5081, 44.6455],
    [-111.5025, 44.6464],
    [-111.5002, 44.6488],
    [-111.4914, 44.6438],
    [-111.4880, 44.6511],
    [-111.4822, 44.6558],
    [-111.4733, 44.6650],
    [-111.4759, 44.6695],
    [-111.4705, 44.6770],
    [-111.4703, 44.6800],
    [-111.4761, 44.6813],
    [-111.4815, 44.6854],
    [-111.4838, 44.6945],
    [-111.4899, 44.7006],
    [-111.4795, 44.7068],
    [-111.4661, 44.7135],
    [-111.4427, 44.7202],
    [-111.4250, 44.7147],
    [-111.4143, 44.7107],
    [-111.4038, 44.7213],
    [-111.3984, 44.7259],
    [-111.3994, 44.7343],
    [-111.3974, 44.7468],
    [-111.3851, 44.7549],
    [-111.3751, 44.7485],
    [-111.3619, 44.7349],
    [-111.3416, 44.7294],
    [-111.3288, 44.7315],
    [-111.3237, 44.7246],
    [-111.3179, 44.7145],
    [-111.3003, 44.7039],
    [-111.2951, 44.6976],
    [-111.2905, 44.6860],
    [-111.2762, 44.6783],
    [-111.2668, 44.6675],
    [-111.2756, 44.6567],
    [-111.2805, 44.6548],
    [-111.2713, 44.6473],
    [-111.2532, 44.6512],
    [-111.2513, 44.6486],
    [-111.2430, 44.6434],
    [-111.2240, 44.6249],
    [-111.2272, 44.6183],
    [-111.2351, 44.6054],
    [-111.2323, 44.5975],
    [-111.2321, 44.5850],
    [-111.2275, 44.5772],
    [-111.2190, 44.5754],
    [-111.1937, 44.5731],
    [-111.1807, 44.5549],
    [-111.1551, 44.5424],
    [-111.1314, 44.5324],
    [-111.1307, 44.5001],
    [-111.1197, 44.4943],
    [-111.1072, 44.4869],
    [-111.0971, 44.4865],
    [-111.0773, 44.4833],
    [-111.0647, 44.4786],
    [-111.0490, 44.4741],
    [-111.0491, 44.3749],
    [-111.0491, 44.1249],
    [-111.0488, 44.0608],
    [-111.0473, 43.9999],
    [-111.0465, 43.9084],
    [-111.0466, 43.7833],
    [-111.0464, 43.7261],
    [-111.0461, 43.6858],
    [-111.0459, 43.6794],
    [-111.0453, 43.5433],
    [-111.0442, 43.2004],
    [-111.0442, 43.1844],
    [-111.0442, 43.1765],
    [-111.0442, 43.0682],
    [-111.0441, 43.0548],
    [-111.0440, 43.0414],
    [-111.0440, 43.0248],
    [-111.0441, 43.0194],
    [-111.0440, 42.9826],
    [-111.0440, 42.9680],
    [-111.0441, 42.8749],
    [-111.0447, 42.6570],
    [-111.0467, 42.5139],
    [-111.0471, 42.3495],
    [-111.0471, 42.1948],
    [-111.0471, 42.1425],
    [-111.2827, 42.0013],
    [-111.4490, 42.0002],
    [-111.5078, 41.9995],
    [-111.7508, 41.9993],
    [-111.8132, 41.9989],
    [-111.8961, 41.9986],
    [-111.9351, 41.9986],
    [-111.9743, 41.9985],
    [-112.0407, 41.9981],
    [-112.1538, 41.9972],
    [-112.1860, 42.0012],
    [-112.2413, 42.0012],
    [-112.4407, 42.0008],
    [-112.6870, 42.0002],
    [-112.8335, 41.9994],
    [-112.9794, 41.9983],
    [-113.0932, 41.9974],
    [-113.3585, 41.9947],
    [-113.5261, 41.9927],
    [-113.6769, 41.9908],
    [-113.8677, 41.9882],
    [-113.9901, 41.9931],
    [-114.0618, 41.9938],
    [-114.1074, 41.9940],
    [-114.4676, 41.9955],
    [-114.5983, 41.9945],
    [-114.6748, 41.9968],
    [-114.8064, 42.0018],
    [-114.8992, 41.9999],
    [-115.0318, 41.9960],
    [-115.2543, 41.9967],
    [-115.5868, 41.9969],
    [-115.7332, 41.9971],
    [-115.8876, 41.9980],
    [-116.0122, 41.9980],
    [-116.0190, 41.9978],
    [-116.0386, 41.9974],
    [-116.1639, 41.9976],
    [-116.3782, 41.9964],
    [-116.4671, 41.9970],
    [-116.5017, 41.9973],
    [-116.5869, 41.9974],
    [-116.8623, 41.9986],
    [-117.0182, 41.9993],
    [-117.0261, 42.1176],
    [-117.0261, 42.3572],
    [-117.0266, 42.5522],
    [-117.0263, 42.8072],
    [-117.0267, 43.0251],
    [-117.0267, 43.5457],
    [-117.0267, 43.5775],
    [-117.0269, 43.5960],
    [-117.0268, 43.6107],
    [-117.0269, 43.6249],
    [-117.0267, 43.6755],
    [-117.0267, 43.6937],
    [-117.0268, 43.7329],
    [-117.0266, 43.8081],
    [-117.0221, 43.8173],
    [-117.0279, 43.8263],
    [-117.0296, 43.8391],
    [-117.0128, 43.8400],
    [-117.0107, 43.8498],
    [-117.0227, 43.8544],
    [-117.0162, 43.8606],
    [-116.9991, 43.8646],
    [-116.9881, 43.8654],
    [-116.9823, 43.8688],
    [-116.9838, 43.8769],
    [-116.9824, 43.8832],
    [-116.9761, 43.8948],
    [-116.9764, 43.9013],
    [-116.9800, 43.9089],
    [-116.9796, 43.9153],
    [-116.9588, 43.9232],
    [-116.9618, 43.9328],
    [-116.9690, 43.9378],
    [-116.9643, 43.9443],
    [-116.9604, 43.9546],
    [-116.9716, 43.9570],
    [-116.9598, 43.9638],
    [-116.9663, 43.9689],
    [-116.9716, 43.9701],
    [-116.9762, 43.9747],
    [-116.9599, 43.9829],
    [-116.9356, 43.9869],
    [-116.9432, 44.0017],
    [-116.9415, 44.0074],
    [-116.9347, 44.0219],
    [-116.9373, 44.0291],
    [-116.9506, 44.0397],
    [-116.9562, 44.0429],
    [-116.9732, 44.0494],
    [-116.9770, 44.0818],
    [-116.9672, 44.0909],
    [-116.9403, 44.0956],
    [-116.9378, 44.0970],
    [-116.9277, 44.1094],
    [-116.9256, 44.1189],
    [-116.9142, 44.1273],
    [-116.9112, 44.1400],
    [-116.9017, 44.1486],
    [-116.8959, 44.1543],
    [-116.8950, 44.1664],
    [-116.9028, 44.1795],
    [-116.9254, 44.1915],
    [-116.9405, 44.1937],
    [-116.9495, 44.1916],
    [-116.9717, 44.1973],
    [-116.9702, 44.2175],
    [-116.9740, 44.2298],
    [-116.9720, 44.2357],
    [-116.9759, 44.2428],
    [-116.9818, 44.2443],
    [-117.0010, 44.2454],
    [-117.0156, 44.2454],
    [-117.0253, 44.2485],
    [-117.0358, 44.2468],
    [-117.0471, 44.2297],
    [-117.0530, 44.2291],
    [-117.0673, 44.2440],
    [-117.0895, 44.2582],
    [-117.0946, 44.2710],
    [-117.1042, 44.2799],
    [-117.1180, 44.2789],
    [-117.1325, 44.2670],
    [-117.1385, 44.2594],
    [-117.1703, 44.2589],
    [-117.1986, 44.2741],
    [-117.2225, 44.2990],
    [-117.2178, 44.3072],
    [-117.2055, 44.3118],
    [-117.1915, 44.3296],
    [-117.1961, 44.3464],
    [-117.2106, 44.3577],
    [-117.2351, 44.3739],
    [-117.2427, 44.3965]
    ]
  },
  "Florida": {
    coordinates: [
      [-87.6348, 30.8661],
    [-87.6244, 30.8847],
    [-87.6209, 30.8899],
    [-87.6207, 30.8989],
    [-87.6142, 30.9085],
    [-87.6083, 30.9219],
    [-87.6007, 30.9371],
    [-87.5921, 30.9515],
    [-87.5930, 30.9730],
    [-87.5942, 30.9776],
    [-87.5967, 30.9876],
    [-87.5713, 30.9979],
    [-87.5149, 30.9977],
    [-87.4838, 30.9981],
    [-87.4787, 30.9982],
    [-87.4668, 30.9982],
    [-87.4587, 30.9984],
    [-87.4323, 30.9982],
    [-87.3640, 30.9982],
    [-87.3479, 30.9983],
    [-87.3040, 30.9982],
    [-87.2910, 30.9984],
    [-87.2665, 30.9983],
    [-87.2597, 30.9982],
    [-87.2556, 30.9982],
    [-87.2400, 30.9966],
    [-87.2295, 30.9969],
    [-87.1637, 30.9990],
    [-87.1506, 30.9993],
    [-87.1189, 30.9994],
    [-87.0761, 30.9992],
    [-87.0641, 30.9992],
    [-87.0364, 30.9993],
    [-87.0044, 30.9993],
    [-86.9063, 30.9976],
    [-86.8319, 30.9974],
    [-86.7857, 30.9970],
    [-86.7273, 30.9969],
    [-86.6883, 30.9946],
    [-86.6278, 30.9948],
    [-86.5425, 30.9943],
    [-86.4999, 30.9933],
    [-86.4049, 30.9940],
    [-86.3886, 30.9942],
    [-86.3649, 30.9945],
    [-86.3340, 30.9942],
    [-86.3046, 30.9940],
    [-86.2891, 30.9938],
    [-86.2564, 30.9939],
    [-86.1802, 30.9940],
    [-86.1629, 30.9937],
    [-86.0562, 30.9931],
    [-85.9986, 30.9929],
    [-85.9358, 30.9932],
    [-85.8311, 30.9941],
    [-85.7499, 30.9948],
    [-85.7416, 30.9953],
    [-85.6463, 30.9960],
    [-85.5833, 30.9964],
    [-85.4980, 30.9969],
    [-85.4075, 30.9983],
    [-85.3289, 30.9996],
    [-85.2401, 31.0009],
    [-85.1860, 31.0009],
    [-85.1521, 31.0009],
    [-85.0575, 31.0006],
    [-85.0312, 31.0006],
    [-85.0241, 31.0007],
    [-85.0018, 30.9979],
    [-85.0059, 30.9774],
    [-85.0051, 30.9747],
    [-84.9998, 30.9715],
    [-84.9848, 30.9675],
    [-84.9796, 30.9590],
    [-84.9830, 30.9426],
    [-84.9806, 30.9327],
    [-84.9694, 30.9220],
    [-84.9523, 30.9023],
    [-84.9413, 30.8877],
    [-84.9368, 30.8847],
    [-84.9376, 30.8759],
    [-84.9378, 30.8705],
    [-84.9340, 30.8633],
    [-84.9353, 30.8543],
    [-84.9288, 30.8468],
    [-84.9294, 30.8403],
    [-84.9353, 30.8309],
    [-84.9354, 30.8172],
    [-84.9279, 30.8028],
    [-84.9283, 30.7931],
    [-84.9174, 30.7759],
    [-84.9172, 30.7633],
    [-84.9135, 30.7523],
    [-84.9031, 30.7518],
    [-84.8961, 30.7506],
    [-84.8838, 30.7326],
    [-84.8647, 30.7115],
    [-84.8011, 30.7091],
    [-84.6647, 30.7029],
    [-84.6252, 30.7009],
    [-84.5508, 30.6973],
    [-84.5259, 30.6960],
    [-84.3807, 30.6900],
    [-84.2826, 30.6853],
    [-84.2541, 30.6843],
    [-84.1249, 30.6780],
    [-84.0728, 30.6754],
    [-84.0466, 30.6742],
    [-84.0191, 30.6727],
    [-84.0074, 30.6721],
    [-83.8797, 30.6658],
    [-83.8105, 30.6619],
    [-83.6768, 30.6549],
    [-83.6117, 30.6513],
    [-83.4999, 30.6457],
    [-83.4400, 30.6420],
    [-83.3901, 30.6393],
    [-83.3410, 30.6363],
    [-83.3116, 30.6346],
    [-83.3092, 30.6344],
    [-83.1744, 30.6264],
    [-83.1633, 30.6259],
    [-83.1314, 30.6236],
    [-83.0560, 30.6193],
    [-82.8788, 30.6091],
    [-82.6986, 30.5982],
    [-82.5840, 30.5918],
    [-82.5532, 30.5899],
    [-82.5249, 30.5882],
    [-82.4189, 30.5817],
    [-82.2581, 30.5716],
    [-82.2148, 30.5685],
    [-82.2228, 30.5656],
    [-82.2344, 30.5566],
    [-82.2404, 30.5378],
    [-82.2294, 30.5208],
    [-82.2269, 30.5103],
    [-82.2129, 30.4988],
    [-82.2009, 30.4744],
    [-82.2075, 30.4569],
    [-82.2040, 30.4445],
    [-82.2103, 30.4246],
    [-82.1923, 30.3846],
    [-82.1864, 30.3774],
    [-82.1800, 30.3686],
    [-82.1701, 30.3589],
    [-82.1581, 30.3599],
    [-82.1048, 30.3683],
    [-82.1018, 30.3653],
    [-82.0811, 30.3588],
    [-82.0501, 30.3623],
    [-82.0407, 30.3702],
    [-82.0412, 30.3968],
    [-82.0412, 30.4100],
    [-82.0345, 30.4280],
    [-82.0301, 30.4449],
    [-82.0237, 30.4673],
    [-82.0173, 30.4876],
    [-82.0148, 30.5130],
    [-82.0177, 30.5210],
    [-82.0184, 30.5312],
    [-82.0081, 30.5770],
    [-82.0165, 30.6025],
    [-82.0273, 30.6067],
    [-82.0339, 30.6296],
    [-82.0391, 30.6411],
    [-82.0461, 30.6518],
    [-82.0472, 30.6629],
    [-82.0504, 30.6763],
    [-82.0376, 30.7186],
    [-82.0438, 30.7296],
    [-82.0396, 30.7477],
    [-82.0326, 30.7507],
    [-82.0127, 30.7613],
    [-82.0240, 30.7832],
    [-82.0171, 30.7917],
    [-82.0050, 30.7917],
    [-81.9886, 30.7801],
    [-81.9790, 30.7765],
    [-81.9704, 30.7846],
    [-81.9625, 30.7965],
    [-81.9627, 30.8136],
    [-81.9598, 30.8212],
    [-81.9376, 30.8277],
    [-81.9244, 30.8176],
    [-81.9045, 30.8177],
    [-81.9067, 30.8234],
    [-81.9014, 30.8299],
    [-81.8929, 30.8255],
    [-81.8827, 30.8051],
    [-81.8713, 30.7973],
    [-81.8471, 30.7912],
    [-81.8402, 30.7883],
    [-81.8085, 30.7900],
    [-81.7982, 30.7835],
    [-81.7916, 30.7838],
    [-81.7867, 30.7698],
    [-81.7803, 30.7617],
    [-81.7726, 30.7695],
    [-81.7665, 30.7760],
    [-81.7593, 30.7714],
    [-81.7512, 30.7675],
    [-81.7412, 30.7652],
    [-81.7424, 30.7597],
    [-81.7327, 30.7550],
    [-81.7322, 30.7496],
    [-81.7115, 30.7459],
    [-81.6918, 30.7440],
    [-81.6880, 30.7413],
    [-81.6693, 30.7413],
    [-81.6793, 30.7447],
    [-81.6698, 30.7517],
    [-81.6622, 30.7465],
    [-81.6551, 30.7439],
    [-81.6521, 30.7424],
    [-81.6518, 30.7323],
    [-81.6461, 30.7276],
    [-81.6350, 30.7333],
    [-81.6289, 30.7309],
    [-81.6208, 30.7316],
    [-81.6211, 30.7225],
    [-81.6107, 30.7162],
    [-81.6060, 30.7262],
    [-81.5965, 30.7272],
    [-81.5938, 30.7185],
    [-81.5762, 30.7226],
    [-81.5714, 30.7216],
    [-81.5638, 30.7177],
    [-81.5561, 30.7137],
    [-81.5490, 30.7182],
    [-81.5416, 30.7101],
    [-81.5338, 30.7121],
    [-81.5342, 30.7210],
    [-81.5262, 30.7234],
    [-81.5072, 30.7229],
    [-81.4838, 30.7239],
    [-81.4654, 30.7113],
    [-81.4487, 30.7094],
    [-81.4327, 30.7030],
    [-81.4258, 30.7005],
    [-81.4292, 30.6708],
    [-81.4355, 30.6386],
    [-81.4419, 30.6014],
    [-81.4434, 30.5705],
    [-81.4358, 30.5261],
    [-81.4401, 30.5085],
    [-81.4333, 30.4880],
    [-81.4163, 30.4910],
    [-81.4116, 30.4729],
    [-81.4067, 30.4374],
    [-81.4037, 30.4091],
    [-81.4048, 30.3972],
    [-81.3916, 30.3967],
    [-81.3971, 30.3795],
    [-81.3953, 30.3399],
    [-81.3920, 30.3144],
    [-81.3883, 30.2910],
    [-81.3857, 30.2794],
    [-81.3827, 30.2653],
    [-81.3708, 30.2193],
    [-81.3556, 30.1625],
    [-81.3219, 30.0205],
    [-81.3065, 29.9614],
    [-81.2996, 29.9398],
    [-81.2890, 29.9152],
    [-81.2818, 29.9083],
    [-81.2751, 29.8938],
    [-81.2706, 29.8765],
    [-81.2668, 29.8612],
    [-81.2662, 29.8598],
    [-81.2653, 29.8523],
    [-81.2635, 29.8329],
    [-81.2622, 29.8203],
    [-81.2615, 29.8144],
    [-81.2593, 29.7998],
    [-81.2561, 29.7859],
    [-81.2518, 29.7712],
    [-81.2305, 29.7179],
    [-81.2264, 29.7084],
    [-81.2245, 29.7025],
    [-81.2129, 29.6707],
    [-81.1948, 29.6280],
    [-81.1850, 29.6052],
    [-81.1482, 29.5241],
    [-81.1265, 29.4798],
    [-81.1141, 29.4538],
    [-81.1019, 29.4271],
    [-81.0705, 29.3593],
    [-81.0589, 29.3343],
    [-81.0571, 29.3303],
    [-81.0543, 29.3243],
    [-81.0467, 29.3079],
    [-81.0389, 29.2924],
    [-81.0331, 29.2809],
    [-81.0139, 29.2428],
    [-81.0027, 29.2205],
    [-80.9988, 29.2128],
    [-80.9930, 29.2012],
    [-80.9825, 29.1804],
    [-80.9680, 29.1516],
    [-80.9598, 29.1371],
    [-80.9383, 29.1028],
    [-80.9161, 29.0770],
    [-80.9098, 29.0712],
    [-80.8979, 29.0462],
    [-80.8894, 29.0307],
    [-80.8780, 29.0116],
    [-80.8661, 28.9938],
    [-80.8012, 28.8966],
    [-80.7399, 28.8016],
    [-80.6473, 28.6779],
    [-80.6168, 28.6346],
    [-80.5742, 28.5853],
    [-80.5674, 28.5624],
    [-80.5542, 28.5138],
    [-80.5251, 28.4595],
    [-80.5290, 28.4497],
    [-80.5423, 28.4457],
    [-80.5728, 28.4278],
    [-80.5847, 28.4118],
    [-80.5898, 28.4060],
    [-80.5975, 28.3855],
    [-80.5990, 28.3799],
    [-80.6016, 28.3695],
    [-80.6043, 28.3548],
    [-80.6062, 28.3390],
    [-80.6067, 28.3201],
    [-80.6068, 28.2964],
    [-80.6034, 28.2559],
    [-80.5967, 28.2126],
    [-80.5954, 28.2037],
    [-80.5945, 28.1980],
    [-80.5900, 28.1780],
    [-80.5864, 28.1647],
    [-80.5811, 28.1453],
    [-80.5725, 28.1135],
    [-80.5668, 28.0956],
    [-80.5603, 28.0780],
    [-80.5537, 28.0625],
    [-80.5477, 28.0488],
    [-80.5444, 28.0419],
    [-80.5310, 28.0137],
    [-80.5111, 27.9749],
    [-80.4727, 27.9066],
    [-80.4470, 27.8620],
    [-80.4138, 27.7964],
    [-80.4029, 27.7767],
    [-80.3933, 27.7585],
    [-80.3835, 27.7400],
    [-80.3785, 27.7251],
    [-80.3670, 27.6921],
    [-80.3629, 27.6792],
    [-80.3591, 27.6675],
    [-80.3576, 27.6607],
    [-80.3551, 27.6541],
    [-80.3525, 27.6449],
    [-80.3509, 27.6353],
    [-80.3479, 27.6243],
    [-80.3439, 27.6165],
    [-80.3319, 27.5993],
    [-80.3310, 27.5975],
    [-80.3212, 27.5574],
    [-80.2978, 27.4915],
    [-80.2901, 27.4733],
    [-80.2906, 27.4665],
    [-80.2805, 27.4417],
    [-80.2702, 27.4156],
    [-80.2335, 27.3413],
    [-80.2268, 27.3227],
    [-80.2038, 27.2723],
    [-80.1919, 27.2475],
    [-80.1598, 27.1884],
    [-80.1534, 27.1693],
    [-80.1558, 27.1585],
    [-80.1453, 27.1322],
    [-80.1386, 27.1115],
    [-80.1313, 27.0979],
    [-80.1168, 27.0724],
    [-80.0939, 27.0186],
    [-80.0810, 26.9742],
    [-80.0775, 26.9619],
    [-80.0743, 26.9525],
    [-80.0706, 26.9446],
    [-80.0710, 26.9413],
    [-80.0667, 26.9248],
    [-80.0627, 26.9118],
    [-80.0578, 26.8966],
    [-80.0531, 26.8820],
    [-80.0406, 26.8353],
    [-80.0356, 26.8142],
    [-80.0314, 26.7957],
    [-80.0323, 26.7872],
    [-80.0320, 26.7736],
    [-80.0375, 26.7663],
    [-80.0357, 26.7493],
    [-80.0347, 26.7256],
    [-80.0340, 26.7190],
    [-80.0331, 26.7056],
    [-80.0338, 26.6897],
    [-80.0362, 26.6653],
    [-80.0370, 26.6460],
    [-80.0365, 26.6243],
    [-80.0360, 26.6132],
    [-80.0365, 26.5985],
    [-80.0375, 26.5863],
    [-80.0416, 26.5544],
    [-80.0449, 26.5380],
    [-80.0504, 26.5091],
    [-80.0507, 26.5074],
    [-80.0578, 26.4617],
    [-80.0586, 26.4531],
    [-80.0617, 26.4321],
    [-80.0653, 26.3931],
    [-80.0676, 26.3690],
    [-80.0706, 26.3365],
    [-80.0748, 26.3210],
    [-80.0761, 26.3094],
    [-80.0802, 26.2587],
    [-80.0836, 26.2565],
    [-80.0844, 26.2521],
    [-80.0873, 26.2413],
    [-80.0888, 26.2317],
    [-80.0905, 26.2168],
    [-80.0929, 26.2051],
    [-80.0934, 26.2014],
    [-80.0960, 26.1819],
    [-80.0979, 26.1676],
    [-80.0996, 26.1576],
    [-80.1029, 26.1351],
    [-80.1039, 26.1141],
    [-80.1045, 26.1016],
    [-80.1080, 26.0922],
    [-80.1091, 26.0810],
    [-80.1111, 26.0592],
    [-80.1125, 26.0474],
    [-80.1152, 26.0108],
    [-80.1162, 25.9974],
    [-80.1173, 25.9866],
    [-80.1182, 25.9681],
    [-80.1187, 25.9538],
    [-80.1198, 25.9377],
    [-80.1205, 25.9285],
    [-80.1210, 25.9214],
    [-80.1217, 25.8995],
    [-80.1213, 25.8918],
    [-80.1209, 25.8832],
    [-80.1197, 25.8726],
    [-80.1189, 25.8561],
    [-80.1188, 25.8444],
    [-80.1190, 25.8391],
    [-80.1193, 25.8315],
    [-80.1198, 25.8247],
    [-80.1204, 25.8187],
    [-80.1211, 25.8126],
    [-80.1224, 25.8074],
    [-80.1242, 25.8014],
    [-80.1260, 25.7934],
    [-80.1284, 25.7809],
    [-80.1306, 25.7712],
    [-80.1308, 25.7642],
    [-80.1343, 25.7614],
    [-80.1396, 25.7555],
    [-80.1429, 25.7510],
    [-80.1486, 25.7383],
    [-80.1586, 25.7333],
    [-80.1525, 25.7288],
    [-80.1482, 25.7191],
    [-80.1523, 25.7053],
    [-80.1557, 25.6990],
    [-80.1566, 25.6912],
    [-80.1553, 25.6830],
    [-80.1563, 25.6662],
    [-80.1626, 25.6744],
    [-80.1783, 25.6867],
    [-80.1680, 25.7004],
    [-80.1745, 25.7082],
    [-80.1546, 25.7229],
    [-80.1621, 25.7316],
    [-80.1663, 25.7357],
    [-80.1789, 25.7460],
    [-80.1996, 25.7460],
    [-80.2085, 25.7456],
    [-80.2144, 25.7383],
    [-80.2220, 25.7366],
    [-80.2358, 25.7260],
    [-80.2392, 25.7256],
    [-80.2491, 25.7134],
    [-80.2475, 25.7092],
    [-80.2455, 25.7021],
    [-80.2498, 25.6902],
    [-80.2574, 25.6778],
    [-80.2626, 25.6692],
    [-80.2673, 25.6590],
    [-80.2682, 25.6545],
    [-80.2683, 25.6518],
    [-80.2707, 25.6476],
    [-80.2758, 25.6374],
    [-80.2863, 25.6201],
    [-80.2988, 25.6193],
    [-80.3034, 25.6174],
    [-80.3070, 25.6107],
    [-80.3084, 25.6070],
    [-80.3083, 25.5995],
    [-80.3077, 25.5933],
    [-80.3058, 25.5807],
    [-80.3027, 25.5695],
    [-80.3076, 25.5597],
    [-80.3118, 25.5470],
    [-80.3246, 25.5356],
    [-80.3287, 25.5326],
    [-80.3299, 25.5262],
    [-80.3308, 25.5192],
    [-80.3358, 25.5097],
    [-80.3327, 25.5041],
    [-80.3370, 25.4935],
    [-80.3400, 25.4894],
    [-80.3396, 25.4822],
    [-80.3401, 25.4699],
    [-80.3345, 25.4651],
    [-80.3349, 25.4621],
    [-80.3339, 25.4526],
    [-80.3309, 25.4481],
    [-80.3261, 25.4379],
    [-80.3253, 25.4308],
    [-80.3282, 25.4161],
    [-80.3293, 25.4065],
    [-80.3263, 25.3943],
    [-80.3198, 25.3891],
    [-80.3104, 25.3897],
    [-80.3068, 25.3844],
    [-80.3138, 25.3672],
    [-80.3228, 25.3615],
    [-80.3299, 25.3499],
    [-80.3389, 25.3365],
    [-80.3423, 25.3233],
    [-80.3493, 25.3210],
    [-80.3516, 25.3258],
    [-80.3573, 25.3247],
    [-80.3609, 25.3281],
    [-80.3654, 25.3248],
    [-80.3719, 25.3208],
    [-80.3734, 25.3128],
    [-80.3761, 25.3059],
    [-80.3759, 25.2995],
    [-80.3741, 25.2928],
    [-80.3723, 25.2890],
    [-80.3791, 25.2883],
    [-80.3859, 25.2911],
    [-80.3949, 25.2803],
    [-80.3999, 25.2654],
    [-80.3974, 25.2566],
    [-80.3970, 25.2479],
    [-80.4082, 25.2366],
    [-80.4131, 25.2265],
    [-80.4181, 25.2176],
    [-80.4167, 25.1987],
    [-80.4045, 25.1942],
    [-80.3934, 25.1926],
    [-80.3894, 25.1979],
    [-80.3843, 25.1985],
    [-80.3763, 25.1982],
    [-80.3725, 25.1990],
    [-80.3733, 25.2048],
    [-80.3696, 25.2061],
    [-80.3621, 25.2066],
    [-80.3528, 25.2076],
    [-80.3517, 25.2086],
    [-80.3493, 25.2129],
    [-80.3476, 25.2167],
    [-80.3454, 25.2198],
    [-80.3398, 25.2270],
    [-80.3350, 25.2478],
    [-80.3322, 25.2630],
    [-80.3402, 25.2649],
    [-80.3412, 25.2716],
    [-80.3432, 25.2740],
    [-80.3482, 25.2766],
    [-80.3536, 25.2790],
    [-80.3605, 25.2796],
    [-80.3631, 25.2834],
    [-80.3637, 25.2858],
    [-80.3509, 25.2866],
    [-80.3428, 25.2905],
    [-80.3368, 25.2875],
    [-80.3293, 25.2870],
    [-80.3173, 25.2944],
    [-80.3054, 25.3029],
    [-80.2990, 25.3085],
    [-80.2906, 25.3154],
    [-80.2897, 25.3238],
    [-80.2834, 25.3283],
    [-80.2795, 25.3314],
    [-80.2749, 25.3421],
    [-80.2718, 25.3484],
    [-80.2643, 25.3524],
    [-80.2594, 25.3492],
    [-80.2546, 25.3417],
    [-80.2544, 25.3369],
    [-80.2585, 25.3280],
    [-80.2663, 25.3216],
    [-80.2722, 25.3167],
    [-80.2752, 25.3105],
    [-80.2785, 25.3061],
    [-80.2839, 25.2904],
    [-80.2968, 25.2720],
    [-80.3079, 25.2560],
    [-80.3141, 25.2450],
    [-80.3186, 25.2360],
    [-80.3260, 25.2282],
    [-80.3304, 25.2190],
    [-80.3346, 25.2130],
    [-80.3371, 25.2094],
    [-80.3425, 25.2016],
    [-80.3449, 25.1948],
    [-80.3527, 25.1871],
    [-80.3588, 25.1777],
    [-80.3646, 25.1723],
    [-80.3673, 25.1687],
    [-80.3584, 25.1691],
    [-80.3503, 25.1702],
    [-80.3518, 25.1660],
    [-80.3544, 25.1631],
    [-80.3581, 25.1533],
    [-80.3651, 25.1519],
    [-80.3713, 25.1465],
    [-80.3714, 25.1370],
    [-80.3771, 25.1303],
    [-80.3814, 25.1280],
    [-80.3888, 25.1209],
    [-80.3979, 25.1107],
    [-80.4001, 25.1060],
    [-80.4103, 25.1029],
    [-80.4146, 25.1008],
    [-80.4192, 25.1003],
    [-80.4239, 25.1044],
    [-80.4282, 25.0998],
    [-80.4292, 25.0952],
    [-80.4334, 25.0869],
    [-80.4416, 25.0781],
    [-80.4462, 25.0751],
    [-80.4541, 25.0718],
    [-80.4647, 25.0675],
    [-80.4749, 25.0577],
    [-80.4812, 25.0500],
    [-80.4872, 25.0439],
    [-80.4929, 25.0367],
    [-80.4912, 25.0345],
    [-80.4925, 25.0273],
    [-80.4975, 25.0208],
    [-80.5041, 25.0167],
    [-80.5067, 25.0144],
    [-80.5118, 25.0107],
    [-80.5164, 25.0038],
    [-80.5242, 25.0016],
    [-80.5312, 24.9985],
    [-80.5326, 24.9963],
    [-80.5343, 24.9931],
    [-80.5398, 24.9880],
    [-80.5477, 24.9789],
    [-80.5549, 24.9690],
    [-80.5603, 24.9652],
    [-80.5657, 24.9592],
    [-80.5658, 24.9571],
    [-80.5715, 24.9537],
    [-80.5739, 24.9538],
    [-80.5812, 24.9518],
    [-80.5866, 24.9507],
    [-80.5949, 24.9478],
    [-80.6045, 24.9421],
    [-80.6143, 24.9344],
    [-80.6230, 24.9259],
    [-80.6312, 24.9171],
    [-80.6419, 24.9084],
    [-80.6531, 24.9011],
    [-80.6599, 24.8983],
    [-80.6610, 24.9002],
    [-80.6559, 24.9065],
    [-80.6504, 24.9122],
    [-80.6447, 24.9136],
    [-80.6385, 24.9178],
    [-80.6340, 24.9217],
    [-80.6292, 24.9253],
    [-80.6232, 24.9312],
    [-80.6236, 24.9390],
    [-80.6237, 24.9471],
    [-80.6133, 24.9442],
    [-80.6125, 24.9533],
    [-80.6027, 24.9496],
    [-80.5988, 24.9507],
    [-80.5965, 24.9556],
    [-80.6006, 24.9596],
    [-80.5988, 24.9661],
    [-80.5887, 24.9643],
    [-80.5851, 24.9624],
    [-80.5854, 24.9661],
    [-80.5815, 24.9653],
    [-80.5761, 24.9624],
    [-80.5710, 24.9628],
    [-80.5673, 24.9659],
    [-80.5638, 24.9699],
    [-80.5584, 24.9713],
    [-80.5562, 24.9763],
    [-80.5526, 24.9837],
    [-80.5517, 24.9903],
    [-80.5491, 24.9936],
    [-80.5448, 24.9991],
    [-80.5435, 25.0057],
    [-80.5443, 25.0131],
    [-80.5362, 25.0153],
    [-80.5297, 25.0177],
    [-80.5211, 25.0159],
    [-80.5134, 25.0174],
    [-80.5134, 25.0197],
    [-80.5138, 25.0276],
    [-80.5123, 25.0284],
    [-80.5059, 25.0317],
    [-80.5034, 25.0374],
    [-80.5008, 25.0385],
    [-80.5013, 25.0419],
    [-80.4947, 25.0483],
    [-80.4889, 25.0502],
    [-80.4808, 25.0573],
    [-80.4743, 25.0654],
    [-80.4667, 25.0737],
    [-80.4609, 25.0832],
    [-80.4611, 25.0891],
    [-80.4656, 25.0908],
    [-80.4616, 25.0930],
    [-80.4589, 25.0924],
    [-80.4574, 25.0896],
    [-80.4560, 25.0863],
    [-80.4464, 25.0925],
    [-80.4434, 25.0954],
    [-80.4418, 25.0991],
    [-80.4333, 25.1078],
    [-80.4339, 25.1139],
    [-80.4384, 25.1193],
    [-80.4472, 25.1231],
    [-80.4555, 25.1282],
    [-80.4610, 25.1341],
    [-80.4582, 25.1385],
    [-80.4586, 25.1439],
    [-80.4607, 25.1535],
    [-80.4619, 25.1601],
    [-80.4582, 25.1677],
    [-80.4528, 25.1766],
    [-80.4478, 25.1790],
    [-80.4462, 25.1826],
    [-80.4429, 25.1893],
    [-80.4474, 25.1918],
    [-80.4511, 25.1987],
    [-80.4585, 25.2060],
    [-80.4655, 25.2118],
    [-80.4746, 25.2120],
    [-80.4821, 25.2117],
    [-80.4872, 25.2071],
    [-80.4929, 25.2076],
    [-80.4973, 25.2094],
    [-80.5018, 25.2104],
    [-80.4963, 25.2053],
    [-80.4980, 25.1999],
    [-80.5028, 25.2032],
    [-80.5069, 25.2096],
    [-80.5105, 25.2158],
    [-80.5155, 25.2176],
    [-80.5242, 25.2219],
    [-80.5297, 25.2142],
    [-80.5414, 25.2121],
    [-80.5359, 25.2013],
    [-80.5403, 25.2048],
    [-80.5477, 25.2063],
    [-80.5483, 25.2133],
    [-80.5539, 25.2142],
    [-80.5628, 25.2123],
    [-80.5604, 25.2059],
    [-80.5650, 25.1967],
    [-80.5689, 25.1933],
    [-80.5758, 25.1988],
    [-80.5765, 25.2041],
    [-80.5735, 25.1989],
    [-80.5688, 25.2013],
    [-80.5645, 25.2038],
    [-80.5663, 25.2108],
    [-80.5738, 25.2100],
    [-80.5796, 25.2121],
    [-80.5845, 25.2073],
    [-80.5834, 25.2011],
    [-80.5916, 25.1992],
    [-80.5940, 25.1915],
    [-80.6018, 25.1880],
    [-80.6051, 25.1870],
    [-80.6076, 25.1852],
    [-80.6097, 25.1854],
    [-80.6075, 25.1877],
    [-80.6041, 25.1888],
    [-80.6039, 25.1933],
    [-80.6036, 25.2019],
    [-80.6098, 25.2004],
    [-80.6220, 25.1997],
    [-80.6252, 25.1953],
    [-80.6312, 25.1952],
    [-80.6364, 25.1926],
    [-80.6438, 25.1916],
    [-80.6482, 25.1929],
    [-80.6543, 25.1870],
    [-80.6575, 25.1854],
    [-80.6621, 25.1810],
    [-80.6640, 25.1767],
    [-80.6587, 25.1753],
    [-80.6579, 25.1779],
    [-80.6516, 25.1753],
    [-80.6441, 25.1773],
    [-80.6355, 25.1780],
    [-80.6377, 25.1765],
    [-80.6446, 25.1753],
    [-80.6492, 25.1686],
    [-80.6536, 25.1567],
    [-80.6562, 25.1525],
    [-80.6517, 25.1470],
    [-80.6568, 25.1449],
    [-80.6576, 25.1467],
    [-80.6585, 25.1444],
    [-80.6654, 25.1416],
    [-80.6715, 25.1400],
    [-80.6744, 25.1426],
    [-80.6688, 25.1469],
    [-80.6617, 25.1546],
    [-80.6556, 25.1576],
    [-80.6533, 25.1645],
    [-80.6597, 25.1690],
    [-80.6668, 25.1671],
    [-80.6689, 25.1682],
    [-80.6684, 25.1719],
    [-80.6723, 25.1747],
    [-80.6742, 25.1701],
    [-80.6726, 25.1676],
    [-80.6778, 25.1643],
    [-80.6799, 25.1662],
    [-80.6773, 25.1732],
    [-80.6840, 25.1723],
    [-80.6940, 25.1659],
    [-80.6982, 25.1626],
    [-80.6978, 25.1552],
    [-80.7031, 25.1536],
    [-80.7048, 25.1445],
    [-80.7042, 25.1408],
    [-80.7083, 25.1439],
    [-80.7101, 25.1494],
    [-80.7153, 25.1543],
    [-80.7227, 25.1546],
    [-80.7269, 25.1534],
    [-80.7241, 25.1579],
    [-80.7246, 25.1652],
    [-80.7323, 25.1676],
    [-80.7295, 25.1631],
    [-80.7344, 25.1612],
    [-80.7388, 25.1618],
    [-80.7475, 25.1649],
    [-80.7443, 25.1564],
    [-80.7381, 25.1503],
    [-80.7287, 25.1502],
    [-80.7227, 25.1454],
    [-80.7328, 25.1432],
    [-80.7477, 25.1474],
    [-80.7557, 25.1530],
    [-80.7574, 25.1610],
    [-80.7717, 25.1610],
    [-80.7710, 25.1542],
    [-80.7695, 25.1450],
    [-80.7768, 25.1381],
    [-80.7748, 25.1421],
    [-80.7733, 25.1536],
    [-80.7792, 25.1640],
    [-80.7887, 25.1645],
    [-80.7972, 25.1594],
    [-80.7989, 25.1509],
    [-80.8010, 25.1448],
    [-80.8005, 25.1585],
    [-80.7964, 25.1690],
    [-80.7945, 25.1799],
    [-80.8059, 25.1842],
    [-80.8146, 25.1827],
    [-80.8137, 25.1759],
    [-80.8099, 25.1689],
    [-80.8281, 25.1656],
    [-80.8389, 25.1759],
    [-80.8582, 25.1766],
    [-80.8805, 25.1714],
    [-80.8881, 25.1664],
    [-80.9016, 25.1538],
    [-80.9159, 25.1413],
    [-80.9492, 25.1302],
    [-80.9617, 25.1343],
    [-80.9718, 25.1340],
    [-81.0230, 25.1294],
    [-81.0799, 25.1188],
    [-81.0907, 25.1179],
    [-81.1034, 25.1371],
    [-81.1274, 25.1554],
    [-81.1410, 25.1639],
    [-81.1555, 25.2081],
    [-81.1709, 25.2459],
    [-81.1642, 25.2742],
    [-81.1628, 25.2848],
    [-81.1523, 25.3055],
    [-81.1481, 25.3328],
    [-81.1214, 25.3387],
    [-81.1192, 25.3593],
    [-81.1225, 25.3669],
    [-81.1230, 25.3791],
    [-81.1469, 25.3836],
    [-81.1471, 25.4043],
    [-81.1505, 25.4135],
    [-81.1575, 25.4266],
    [-81.1671, 25.4509],
    [-81.1734, 25.4721],
    [-81.2097, 25.5065],
    [-81.2044, 25.5389],
    [-81.2200, 25.5537],
    [-81.2336, 25.5689],
    [-81.2402, 25.5832],
    [-81.2417, 25.6065],
    [-81.2753, 25.6247],
    [-81.2830, 25.6449],
    [-81.2894, 25.6580],
    [-81.2919, 25.6725],
    [-81.3033, 25.6937],
    [-81.3303, 25.7106],
    [-81.3552, 25.7287],
    [-81.3700, 25.7434],
    [-81.3806, 25.7667],
    [-81.3890, 25.7813],
    [-81.4240, 25.7937],
    [-81.4579, 25.7978],
    [-81.4647, 25.8120],
    [-81.4794, 25.8213],
    [-81.4930, 25.8309],
    [-81.5115, 25.8323],
    [-81.5300, 25.8386],
    [-81.5424, 25.8525],
    [-81.5613, 25.8617],
    [-81.5727, 25.8656],
    [-81.5825, 25.8767],
    [-81.6050, 25.8921],
    [-81.6316, 25.8975],
    [-81.6461, 25.8973],
    [-81.6721, 25.8818],
    [-81.6696, 25.8664],
    [-81.6783, 25.8453],
    [-81.6895, 25.8527],
    [-81.7165, 25.9009],
    [-81.7180, 25.9079],
    [-81.7282, 25.9082],
    [-81.7293, 25.9184],
    [-81.7389, 25.9411],
    [-81.7534, 25.9519],
    [-81.7446, 25.9701],
    [-81.7396, 25.9757],
    [-81.7472, 25.9841],
    [-81.7579, 25.9987],
    [-81.7850, 26.0540],
    [-81.8019, 26.0924],
    [-81.8146, 26.1732],
    [-81.8168, 26.2072],
    [-81.8185, 26.2202],
    [-81.8207, 26.2367],
    [-81.8244, 26.2542],
    [-81.8331, 26.2945],
    [-81.8550, 26.3505],
    [-81.8631, 26.3642],
    [-81.8765, 26.3870],
    [-81.8869, 26.3984],
    [-81.9025, 26.4096],
    [-81.9086, 26.4223],
    [-81.9237, 26.4367],
    [-81.9569, 26.4526],
    [-81.9689, 26.4648],
    [-81.9695, 26.4765],
    [-81.9980, 26.4848],
    [-82.0136, 26.4876],
    [-82.0092, 26.5046],
    [-82.0103, 26.5208],
    [-82.0153, 26.5288],
    [-82.0326, 26.5278],
    [-82.0413, 26.5254],
    [-82.0431, 26.5327],
    [-82.0512, 26.5422],
    [-82.0647, 26.5407],
    [-82.0685, 26.5135],
    [-82.0590, 26.4990],
    [-82.0569, 26.4937],
    [-82.0693, 26.4927],
    [-82.0815, 26.4904],
    [-82.0871, 26.4889],
    [-82.1057, 26.4839],
    [-82.1027, 26.4997],
    [-82.1006, 26.5108],
    [-82.1021, 26.5195],
    [-82.1120, 26.5276],
    [-82.1225, 26.5550],
    [-82.1247, 26.5770],
    [-82.1273, 26.5928],
    [-82.1387, 26.6126],
    [-82.1444, 26.6389],
    [-82.1466, 26.6495],
    [-82.1528, 26.6568],
    [-82.1660, 26.6693],
    [-82.1757, 26.6785],
    [-82.1838, 26.6878],
    [-82.1799, 26.6995],
    [-82.1517, 26.7041],
    [-82.1229, 26.6959],
    [-82.1118, 26.6816],
    [-82.1050, 26.6665],
    [-82.0990, 26.6460],
    [-82.0821, 26.6536],
    [-82.0910, 26.6662],
    [-82.0867, 26.6852],
    [-82.0840, 26.7052],
    [-82.0746, 26.7269],
    [-82.0641, 26.7579],
    [-82.0636, 26.7610],
    [-82.0614, 26.7892],
    [-82.0561, 26.8095],
    [-82.0581, 26.8439],
    [-82.0619, 26.8754],
    [-82.0950, 26.8913],
    [-82.0976, 26.9079],
    [-82.0868, 26.9277],
    [-82.0677, 26.9278],
    [-82.0552, 26.9358],
    [-82.0579, 26.9457],
    [-82.0662, 26.9544],
    [-82.0875, 26.9581],
    [-82.1030, 26.9531],
    [-82.1165, 26.9633],
    [-82.1169, 26.9549],
    [-82.1373, 26.9261],
    [-82.1548, 26.9218],
    [-82.1679, 26.9383],
    [-82.1831, 26.9358],
    [-82.1534, 26.8540],
    [-82.1511, 26.7835],
    [-82.1722, 26.7699],
    [-82.1907, 26.7725],
    [-82.2021, 26.7702],
    [-82.2100, 26.7681],
    [-82.2381, 26.7681],
    [-82.2532, 26.7540],
    [-82.2598, 26.7280],
    [-82.2588, 26.7185],
    [-82.2643, 26.7202],
    [-82.2695, 26.7847],
    [-82.2827, 26.8042],
    [-82.2825, 26.8160],
    [-82.3017, 26.8416],
    [-82.3258, 26.8775],
    [-82.3425, 26.8947],
    [-82.3710, 26.9387],
    [-82.3816, 26.9577],
    [-82.4095, 27.0045],
    [-82.4457, 27.0607],
    [-82.4563, 27.0873],
    [-82.4603, 27.1000],
    [-82.4653, 27.1107],
    [-82.4689, 27.1136],
    [-82.4928, 27.1684],
    [-82.5028, 27.1897],
    [-82.5198, 27.2235],
    [-82.5283, 27.2374],
    [-82.5365, 27.2488],
    [-82.5412, 27.2561],
    [-82.5564, 27.2667],
    [-82.5643, 27.2702],
    [-82.5698, 27.2795],
    [-82.5617, 27.2892],
    [-82.5601, 27.2951],
    [-82.5692, 27.2986],
    [-82.5835, 27.3176],
    [-82.5895, 27.3267],
    [-82.5976, 27.3358],
    [-82.6120, 27.3503],
    [-82.6322, 27.3730],
    [-82.6428, 27.3897],
    [-82.6742, 27.4236],
    [-82.6901, 27.4344],
    [-82.6910, 27.4443],
    [-82.7072, 27.4861],
    [-82.7145, 27.5004],
    [-82.7242, 27.5132],
    [-82.7325, 27.5211],
    [-82.7430, 27.5311],
    [-82.7424, 27.5394],
    [-82.7224, 27.5288],
    [-82.7085, 27.5206],
    [-82.7094, 27.5120],
    [-82.7075, 27.4990],
    [-82.6974, 27.4973],
    [-82.6885, 27.4968],
    [-82.6836, 27.5131],
    [-82.6620, 27.5228],
    [-82.6453, 27.5238],
    [-82.6467, 27.5318],
    [-82.6341, 27.5428],
    [-82.6120, 27.5712],
    [-82.6117, 27.5853],
    [-82.5876, 27.5941],
    [-82.5774, 27.5996],
    [-82.5725, 27.6071],
    [-82.5645, 27.6218],
    [-82.5629, 27.6380],
    [-82.5371, 27.6729],
    [-82.5170, 27.6980],
    [-82.5164, 27.7026],
    [-82.4924, 27.7192],
    [-82.4795, 27.7223],
    [-82.4763, 27.7244],
    [-82.4769, 27.7340],
    [-82.4817, 27.7432],
    [-82.4728, 27.7479],
    [-82.4523, 27.7553],
    [-82.4422, 27.7605],
    [-82.4396, 27.7618],
    [-82.4328, 27.7685],
    [-82.4287, 27.7731],
    [-82.4322, 27.7731],
    [-82.4198, 27.7931],
    [-82.4154, 27.7927],
    [-82.4159, 27.7954],
    [-82.4125, 27.7941],
    [-82.4171, 27.8045],
    [-82.3991, 27.8191],
    [-82.3953, 27.8324],
    [-82.3947, 27.8422],
    [-82.3924, 27.8461],
    [-82.3969, 27.8455],
    [-82.3981, 27.8538],
    [-82.4013, 27.8608],
    [-82.4026, 27.8826],
    [-82.4348, 27.8965],
    [-82.4364, 27.9041],
    [-82.4453, 27.9101],
    [-82.4537, 27.9085],
    [-82.4625, 27.9202],
    [-82.4616, 27.9380],
    [-82.4664, 27.9362],
    [-82.4733, 27.9313],
    [-82.4822, 27.9248],
    [-82.4898, 27.9196],
    [-82.4908, 27.9129],
    [-82.4887, 27.9016],
    [-82.4868, 27.8944],
    [-82.4814, 27.8891],
    [-82.4811, 27.8805],
    [-82.4879, 27.8721],
    [-82.4801, 27.8532],
    [-82.4724, 27.8226],
    [-82.5112, 27.8280],
    [-82.5375, 27.8357],
    [-82.5367, 27.8408],
    [-82.5514, 27.8472],
    [-82.5518, 27.8565],
    [-82.5364, 27.8672],
    [-82.5304, 27.8779],
    [-82.5415, 27.8844],
    [-82.5428, 27.8906],
    [-82.5354, 27.8944],
    [-82.5355, 27.9032],
    [-82.5317, 27.9085],
    [-82.5342, 27.9152],
    [-82.5351, 27.9220],
    [-82.5330, 27.9246],
    [-82.5337, 27.9330],
    [-82.5393, 27.9450],
    [-82.5484, 27.9521],
    [-82.5539, 27.9670],
    [-82.5734, 27.9630],
    [-82.5734, 27.9742],
    [-82.5832, 27.9788],
    [-82.5932, 27.9795],
    [-82.6074, 27.9840],
    [-82.6220, 27.9937],
    [-82.6273, 28.0008],
    [-82.6390, 28.0071],
    [-82.6397, 28.0122],
    [-82.6416, 28.0168],
    [-82.6494, 28.0178],
    [-82.6571, 28.0123],
    [-82.6573, 28.0027],
    [-82.6654, 28.0010],
    [-82.6664, 28.0125],
    [-82.6651, 28.0250],
    [-82.6765, 28.0328],
    [-82.6867, 28.0302],
    [-82.6901, 28.0275],
    [-82.6850, 28.0204],
    [-82.6829, 28.0140],
    [-82.6768, 28.0092],
    [-82.6759, 28.0049],
    [-82.6863, 27.9890],
    [-82.6923, 27.9841],
    [-82.6935, 27.9792],
    [-82.6903, 27.9754],
    [-82.6951, 27.9641],
    [-82.7065, 27.9605],
    [-82.7106, 27.9570],
    [-82.7214, 27.9549],
    [-82.7242, 27.9493],
    [-82.7213, 27.9442],
    [-82.7248, 27.9384],
    [-82.7259, 27.9362],
    [-82.7152, 27.9325],
    [-82.7097, 27.9281],
    [-82.6983, 27.9231],
    [-82.6955, 27.9228],
    [-82.6910, 27.9259],
    [-82.6801, 27.9162],
    [-82.6712, 27.9130],
    [-82.6509, 27.9066],
    [-82.6462, 27.9100],
    [-82.6378, 27.9055],
    [-82.6299, 27.9085],
    [-82.6382, 27.8981],
    [-82.6328, 27.8913],
    [-82.6100, 27.8735],
    [-82.6033, 27.8652],
    [-82.5981, 27.8578],
    [-82.5893, 27.8357],
    [-82.5927, 27.8235],
    [-82.5885, 27.8154],
    [-82.6001, 27.8091],
    [-82.6055, 27.8005],
    [-82.6057, 27.7965],
    [-82.6173, 27.7889],
    [-82.6232, 27.7853],
    [-82.6240, 27.7777],
    [-82.6232, 27.7695],
    [-82.6280, 27.7584],
    [-82.6305, 27.7539],
    [-82.6232, 27.7446],
    [-82.6250, 27.7327],
    [-82.6292, 27.7198],
    [-82.6414, 27.7035],
    [-82.6532, 27.7004],
    [-82.6632, 27.7024],
    [-82.6773, 27.7004],
    [-82.6798, 27.6949],
    [-82.6803, 27.7058],
    [-82.6891, 27.6995],
    [-82.6986, 27.7081],
    [-82.7134, 27.7037],
    [-82.7173, 27.6940],
    [-82.7165, 27.6887],
    [-82.7191, 27.6860],
    [-82.7209, 27.6645],
    [-82.7204, 27.6610],
    [-82.7162, 27.6513],
    [-82.7126, 27.6466],
    [-82.7112, 27.6420],
    [-82.7050, 27.6253],
    [-82.7374, 27.6117],
    [-82.7374, 27.6235],
    [-82.7450, 27.6468],
    [-82.7462, 27.6538],
    [-82.7427, 27.6741],
    [-82.7395, 27.6811],
    [-82.7380, 27.7054],
    [-82.7435, 27.7242],
    [-82.7537, 27.7363],
    [-82.7634, 27.7507],
    [-82.7834, 27.7800],
    [-82.7905, 27.7910],
    [-82.8204, 27.8137],
    [-82.8273, 27.8209],
    [-82.8285, 27.8222],
    [-82.8376, 27.8367],
    [-82.8465, 27.8543],
    [-82.8507, 27.8716],
    [-82.8506, 27.8944],
    [-82.8478, 27.9102],
    [-82.8416, 27.9365],
    [-82.8327, 27.9580],
    [-82.8320, 27.9702],
    [-82.8296, 27.9891],
    [-82.8282, 28.0201],
    [-82.8137, 28.0313],
    [-82.8091, 28.0065],
    [-82.8162, 28.0000],
    [-82.8125, 27.9846],
    [-82.8108, 27.9696],
    [-82.8049, 27.9660],
    [-82.7994, 27.9880],
    [-82.7954, 27.9974],
    [-82.7939, 28.0110],
    [-82.7915, 28.0233],
    [-82.7885, 28.0365],
    [-82.7890, 28.0486],
    [-82.7992, 28.0485],
    [-82.8223, 28.0541],
    [-82.8362, 28.0919],
    [-82.8246, 28.0726],
    [-82.8177, 28.0623],
    [-82.8004, 28.0526],
    [-82.7904, 28.0531],
    [-82.7835, 28.0562],
    [-82.7792, 28.0728],
    [-82.7837, 28.0799],
    [-82.7838, 28.1063],
    [-82.7836, 28.1230],
    [-82.7813, 28.1276],
    [-82.7872, 28.1384],
    [-82.7866, 28.1450],
    [-82.8075, 28.1522],
    [-82.7992, 28.1610],
    [-82.8039, 28.1673],
    [-82.7997, 28.1845],
    [-82.7847, 28.2008],
    [-82.7701, 28.2077],
    [-82.7666, 28.2131],
    [-82.7573, 28.2283],
    [-82.7620, 28.2431],
    [-82.7514, 28.2457],
    [-82.7591, 28.2540],
    [-82.7462, 28.2612],
    [-82.7431, 28.2679],
    [-82.7423, 28.2799],
    [-82.7397, 28.2832],
    [-82.7372, 28.2863],
    [-82.7341, 28.3086],
    [-82.7315, 28.3251],
    [-82.7158, 28.3455],
    [-82.7130, 28.3520],
    [-82.7181, 28.3573],
    [-82.7121, 28.3609],
    [-82.7093, 28.3658],
    [-82.7063, 28.3749],
    [-82.7040, 28.3805],
    [-82.7074, 28.3955],
    [-82.6948, 28.4063],
    [-82.6993, 28.4116],
    [-82.6945, 28.4228],
    [-82.6787, 28.4335],
    [-82.6711, 28.4490],
    [-82.6804, 28.4572],
    [-82.6780, 28.4677],
    [-82.6726, 28.4693],
    [-82.6696, 28.4789],
    [-82.6670, 28.4897],
    [-82.6689, 28.4939],
    [-82.6664, 28.4973],
    [-82.6782, 28.4993],
    [-82.6694, 28.5199],
    [-82.6593, 28.5315],
    [-82.6567, 28.5448],
    [-82.6616, 28.5541],
    [-82.6511, 28.5570],
    [-82.6571, 28.5681],
    [-82.6562, 28.5754],
    [-82.6528, 28.5768],
    [-82.6542, 28.5891],
    [-82.6599, 28.6000],
    [-82.6641, 28.6066],
    [-82.6661, 28.6210],
    [-82.6691, 28.6269],
    [-82.6743, 28.6391],
    [-82.6692, 28.6440],
    [-82.6777, 28.6548],
    [-82.6680, 28.6632],
    [-82.6620, 28.6673],
    [-82.6551, 28.6805],
    [-82.6693, 28.6854],
    [-82.6746, 28.6939],
    [-82.6834, 28.7005],
    [-82.7048, 28.7145],
    [-82.7207, 28.7186],
    [-82.7048, 28.7359],
    [-82.6901, 28.7366],
    [-82.6979, 28.7481],
    [-82.6972, 28.7741],
    [-82.6920, 28.7889],
    [-82.6982, 28.7964],
    [-82.7067, 28.7976],
    [-82.7150, 28.8064],
    [-82.7321, 28.8205],
    [-82.7276, 28.8393],
    [-82.7310, 28.8584],
    [-82.7006, 28.8785],
    [-82.6887, 28.8952],
    [-82.6923, 28.9125],
    [-82.6986, 28.9179],
    [-82.6960, 28.9308],
    [-82.7239, 28.9535],
    [-82.7326, 28.9666],
    [-82.7509, 28.9824],
    [-82.7572, 28.9860],
    [-82.7603, 28.9929],
    [-82.7594, 29.0066],
    [-82.7573, 29.0342],
    [-82.7625, 29.0528],
    [-82.7771, 29.0574],
    [-82.7989, 29.0553],
    [-82.7936, 29.0616],
    [-82.7835, 29.0693],
    [-82.8082, 29.0728],
    [-82.8146, 29.0803],
    [-82.8194, 29.0919],
    [-82.8129, 29.1065],
    [-82.8027, 29.1210],
    [-82.8067, 29.1363],
    [-82.8081, 29.1484],
    [-82.8139, 29.1625],
    [-82.8271, 29.1584],
    [-82.8415, 29.1588],
    [-82.8764, 29.1594],
    [-82.9117, 29.1673],
    [-82.9382, 29.1679],
    [-82.9461, 29.1679],
    [-82.9695, 29.1704],
    [-82.9747, 29.1709],
    [-82.9862, 29.1727],
    [-82.9986, 29.1741],
    [-83.0032, 29.1573],
    [-83.0166, 29.1505],
    [-83.0145, 29.1405],
    [-83.0264, 29.1371],
    [-83.0414, 29.1376],
    [-83.0478, 29.1339],
    [-83.0483, 29.1297],
    [-83.0580, 29.1390],
    [-83.0647, 29.1424],
    [-83.0668, 29.1720],
    [-83.0790, 29.1969],
    [-83.0867, 29.2247],
    [-83.0803, 29.2417],
    [-83.0890, 29.2665],
    [-83.1160, 29.2736],
    [-83.1381, 29.2841],
    [-83.1616, 29.2857],
    [-83.1763, 29.3128],
    [-83.1654, 29.3187],
    [-83.1730, 29.3286],
    [-83.1735, 29.3317],
    [-83.1755, 29.3447],
    [-83.1886, 29.3588],
    [-83.1911, 29.3682],
    [-83.2025, 29.3713],
    [-83.2041, 29.3834],
    [-83.2113, 29.3983],
    [-83.2145, 29.4102],
    [-83.2286, 29.4212],
    [-83.2576, 29.4330],
    [-83.2720, 29.4323],
    [-83.2911, 29.4370],
    [-83.2938, 29.4411],
    [-83.2962, 29.4438],
    [-83.3078, 29.4689],
    [-83.3311, 29.4756],
    [-83.3567, 29.4999],
    [-83.3840, 29.5130],
    [-83.4016, 29.5233],
    [-83.3998, 29.5330],
    [-83.4031, 29.5650],
    [-83.4069, 29.5885],
    [-83.3995, 29.6130],
    [-83.4064, 29.6503],
    [-83.4107, 29.6644],
    [-83.4110, 29.6699],
    [-83.4250, 29.6695],
    [-83.4446, 29.6772],
    [-83.4583, 29.6782],
    [-83.4785, 29.6876],
    [-83.4877, 29.7003],
    [-83.4987, 29.7098],
    [-83.5096, 29.7124],
    [-83.5357, 29.7257],
    [-83.5493, 29.7296],
    [-83.5600, 29.7430],
    [-83.5660, 29.7614],
    [-83.5842, 29.7585],
    [-83.5790, 29.7684],
    [-83.5870, 29.7789],
    [-83.5830, 29.7873],
    [-83.5854, 29.8004],
    [-83.5859, 29.8118],
    [-83.5904, 29.8214],
    [-83.5955, 29.8280],
    [-83.6052, 29.8364],
    [-83.6186, 29.8423],
    [-83.6293, 29.8634],
    [-83.6365, 29.8827],
    [-83.6537, 29.8947],
    [-83.6687, 29.9060],
    [-83.6790, 29.9144],
    [-83.6843, 29.9234],
    [-83.7117, 29.9333],
    [-83.7392, 29.9492],
    [-83.7494, 29.9589],
    [-83.7620, 29.9608],
    [-83.7703, 29.9685],
    [-83.7808, 29.9722],
    [-83.7926, 29.9763],
    [-83.8077, 29.9767],
    [-83.8220, 29.9822],
    [-83.8589, 30.0048],
    [-83.9132, 30.0290],
    [-83.9254, 30.0346],
    [-83.9319, 30.0442],
    [-83.9439, 30.0508],
    [-83.9517, 30.0586],
    [-83.9675, 30.0658],
    [-83.9832, 30.0731],
    [-83.9860, 30.0846],
    [-83.9925, 30.0852],
    [-83.9992, 30.0914],
    [-84.0140, 30.0973],
    [-84.0403, 30.0996],
    [-84.0539, 30.1024],
    [-84.0760, 30.0955],
    [-84.0937, 30.0940],
    [-84.1189, 30.0885],
    [-84.1357, 30.0830],
    [-84.1791, 30.0732],
    [-84.1774, 30.0855],
    [-84.1771, 30.0961],
    [-84.1936, 30.0978],
    [-84.2056, 30.1143],
    [-84.2017, 30.0944],
    [-84.2034, 30.0846],
    [-84.2278, 30.0853],
    [-84.2457, 30.0930],
    [-84.2623, 30.1037],
    [-84.2725, 30.0924],
    [-84.2708, 30.0681],
    [-84.2822, 30.0612],
    [-84.2978, 30.0575],
    [-84.3254, 30.0423],
    [-84.3371, 30.0323],
    [-84.3395, 30.0293],
    [-84.3469, 30.0186],
    [-84.3552, 30.0167],
    [-84.3661, 30.0087],
    [-84.3625, 29.9928],
    [-84.3581, 29.9829],
    [-84.3522, 29.9791],
    [-84.3466, 29.9850],
    [-84.3411, 29.9789],
    [-84.3418, 29.9703],
    [-84.3538, 29.9697],
    [-84.3696, 29.9746],
    [-84.3827, 29.9769],
    [-84.3920, 29.9806],
    [-84.4025, 29.9837],
    [-84.4156, 29.9831],
    [-84.4289, 29.9869],
    [-84.4356, 29.9897],
    [-84.4355, 29.9817],
    [-84.4326, 29.9762],
    [-84.4365, 29.9697],
    [-84.4426, 29.9622],
    [-84.4363, 29.9610],
    [-84.4262, 29.9600],
    [-84.4178, 29.9655],
    [-84.4069, 29.9616],
    [-84.3968, 29.9597],
    [-84.3841, 29.9614],
    [-84.3721, 29.9525],
    [-84.3608, 29.9542],
    [-84.3466, 29.9480],
    [-84.3386, 29.9465],
    [-84.3337, 29.9237],
    [-84.3416, 29.9022],
    [-84.3517, 29.8964],
    [-84.3720, 29.8941],
    [-84.4050, 29.9012],
    [-84.4252, 29.9048],
    [-84.4437, 29.9169],
    [-84.4517, 29.9291],
    [-84.4809, 29.9177],
    [-84.4920, 29.9099],
    [-84.4946, 29.9140],
    [-84.5060, 29.9164],
    [-84.5154, 29.9154],
    [-84.5359, 29.9101],
    [-84.5616, 29.8952],
    [-84.5937, 29.8810],
    [-84.6132, 29.8680],
    [-84.6337, 29.8563],
    [-84.6480, 29.8471],
    [-84.6538, 29.8398],
    [-84.6611, 29.8371],
    [-84.6646, 29.8347],
    [-84.6683, 29.8373],
    [-84.6744, 29.8314],
    [-84.6921, 29.8291],
    [-84.7172, 29.8136],
    [-84.7343, 29.8051],
    [-84.7504, 29.7923],
    [-84.7617, 29.7887],
    [-84.7914, 29.7737],
    [-84.8079, 29.7661],
    [-84.8313, 29.7576],
    [-84.8579, 29.7470],
    [-84.8848, 29.7291],
    [-84.8881, 29.7224],
    [-84.8949, 29.7281],
    [-84.9021, 29.7353],
    [-84.8968, 29.7436],
    [-84.8890, 29.7596],
    [-84.8828, 29.7684],
    [-84.8711, 29.7813],
    [-84.8723, 29.7871],
    [-84.8736, 29.7970],
    [-84.8817, 29.7933],
    [-84.8818, 29.7873],
    [-84.8880, 29.7844],
    [-84.9041, 29.7863],
    [-84.9164, 29.7770],
    [-84.9341, 29.7558],
    [-84.9466, 29.7450],
    [-84.9688, 29.7271],
    [-84.9816, 29.7207],
    [-84.9977, 29.7140],
    [-85.0059, 29.7116],
    [-85.0291, 29.7113],
    [-85.0372, 29.7111],
    [-85.0533, 29.7155],
    [-85.1215, 29.7159],
    [-85.1723, 29.7035],
    [-85.1966, 29.6964],
    [-85.2191, 29.6890],
    [-85.2227, 29.6828],
    [-85.2369, 29.6767],
    [-85.2597, 29.6813],
    [-85.2986, 29.6840],
    [-85.3283, 29.6787],
    [-85.3465, 29.6686],
    [-85.3621, 29.6753],
    [-85.3753, 29.6919],
    [-85.3984, 29.7430],
    [-85.4115, 29.7924],
    [-85.4158, 29.8426],
    [-85.4089, 29.8642],
    [-85.3963, 29.8741],
    [-85.3847, 29.8776],
    [-85.3925, 29.8709],
    [-85.3990, 29.8606],
    [-85.4036, 29.8453],
    [-85.4104, 29.8307],
    [-85.4077, 29.8217],
    [-85.4089, 29.8138],
    [-85.4084, 29.7984],
    [-85.4043, 29.7847],
    [-85.4000, 29.7744],
    [-85.4008, 29.7648],
    [-85.3922, 29.7543],
    [-85.3892, 29.7388],
    [-85.3860, 29.7254],
    [-85.3707, 29.7023],
    [-85.3676, 29.6927],
    [-85.3627, 29.6815],
    [-85.3535, 29.6796],
    [-85.3441, 29.6840],
    [-85.3370, 29.6839],
    [-85.3266, 29.6862],
    [-85.3160, 29.6871],
    [-85.3100, 29.7054],
    [-85.3049, 29.7314],
    [-85.3054, 29.7446],
    [-85.3050, 29.7699],
    [-85.3024, 29.7833],
    [-85.3017, 29.7953],
    [-85.3028, 29.8089],
    [-85.3086, 29.8133],
    [-85.3145, 29.8223],
    [-85.3145, 29.8327],
    [-85.3183, 29.8395],
    [-85.3250, 29.8450],
    [-85.3323, 29.8459],
    [-85.3428, 29.8579],
    [-85.3481, 29.8723],
    [-85.3847, 29.9209],
    [-85.4051, 29.9385],
    [-85.4283, 29.9500],
    [-85.4467, 29.9545],
    [-85.4656, 29.9575],
    [-85.4878, 29.9606],
    [-85.5023, 29.9678],
    [-85.5245, 29.9875],
    [-85.5371, 30.0039],
    [-85.5690, 30.0261],
    [-85.5956, 30.0506],
    [-85.6169, 30.0621],
    [-85.6321, 30.0689],
    [-85.6997, 30.0987],
    [-85.7331, 30.1220],
    [-85.7499, 30.1365],
    [-85.7684, 30.1509],
    [-85.7803, 30.1593],
    [-85.7907, 30.1657],
    [-85.8112, 30.1783],
    [-85.8381, 30.1933],
    [-85.8781, 30.2156],
    [-85.8953, 30.2241],
    [-85.9204, 30.2366],
    [-85.9355, 30.2436],
    [-85.9961, 30.2692],
    [-86.0454, 30.2873],
    [-86.1241, 30.3141],
    [-86.1887, 30.3342],
    [-86.2226, 30.3436],
    [-86.2636, 30.3551],
    [-86.3140, 30.3664],
    [-86.3514, 30.3726],
    [-86.3808, 30.3767],
    [-86.3976, 30.3787],
    [-86.4439, 30.3832],
    [-86.4740, 30.3838],
    [-86.5061, 30.3823],
    [-86.5141, 30.3851],
    [-86.5411, 30.3889],
    [-86.5635, 30.3909],
    [-86.5967, 30.3938],
    [-86.6214, 30.3963],
    [-86.6571, 30.3968],
    [-86.7386, 30.3934],
    [-86.8003, 30.3871],
    [-86.8506, 30.3814],
    [-86.9097, 30.3724],
    [-87.0059, 30.3559],
    [-87.1554, 30.3277],
    [-87.2263, 30.3193],
    [-87.2878, 30.3212],
    [-87.3012, 30.3303],
    [-87.3125, 30.3258],
    [-87.3301, 30.3177],
    [-87.4143, 30.2990],
    [-87.4536, 30.2929],
    [-87.4922, 30.2851],
    [-87.5183, 30.2816],
    [-87.5055, 30.2871],
    [-87.4501, 30.3111],
    [-87.4630, 30.3078],
    [-87.4759, 30.3079],
    [-87.4949, 30.3050],
    [-87.5047, 30.3089],
    [-87.5059, 30.3194],
    [-87.5000, 30.3290],
    [-87.4756, 30.3314],
    [-87.4630, 30.3340],
    [-87.4510, 30.3463],
    [-87.4514, 30.3672],
    [-87.4387, 30.3808],
    [-87.4412, 30.3886],
    [-87.4373, 30.3959],
    [-87.4307, 30.4048],
    [-87.4262, 30.4092],
    [-87.4132, 30.4090],
    [-87.4035, 30.4102],
    [-87.3957, 30.4176],
    [-87.3821, 30.4229],
    [-87.3676, 30.4346],
    [-87.3687, 30.4446],
    [-87.3812, 30.4501],
    [-87.3999, 30.4510],
    [-87.4147, 30.4573],
    [-87.4306, 30.4766],
    [-87.4356, 30.4805],
    [-87.4306, 30.4911],
    [-87.4397, 30.5066],
    [-87.4477, 30.5105],
    [-87.4465, 30.5136],
    [-87.4464, 30.5203],
    [-87.4354, 30.5491],
    [-87.4279, 30.5542],
    [-87.4228, 30.5614],
    [-87.4186, 30.5618],
    [-87.4185, 30.5696],
    [-87.4145, 30.5735],
    [-87.4125, 30.5739],
    [-87.4046, 30.6034],
    [-87.3973, 30.6087],
    [-87.3964, 30.6169],
    [-87.3945, 30.6252],
    [-87.3936, 30.6303],
    [-87.3972, 30.6481],
    [-87.4002, 30.6572],
    [-87.4071, 30.6718],
    [-87.4127, 30.6781],
    [-87.4304, 30.6886],
    [-87.4401, 30.6907],
    [-87.4494, 30.6989],
    [-87.4663, 30.7008],
    [-87.4744, 30.7066],
    [-87.4812, 30.7165],
    [-87.4975, 30.7201],
    [-87.5052, 30.7263],
    [-87.5326, 30.7435],
    [-87.5365, 30.7614],
    [-87.5462, 30.7720],
    [-87.5521, 30.7863],
    [-87.5595, 30.7904],
    [-87.5681, 30.7991],
    [-87.5819, 30.8124],
    [-87.6005, 30.8206],
    [-87.6058, 30.8313],
    [-87.6154, 30.8370],
    [-87.6261, 30.8465],
    [-87.6254, 30.8544],
    [-87.6349, 30.8659],
    [-87.6348, 30.8661]
    ]
  },
  "Nebraska": {
    coordinates: [
      [-104.0534, 41.1705],
    [-104.0527, 41.2753],
    [-104.0526, 41.3162],
    [-104.0527, 41.3306],
    [-104.0522, 41.4077],
    [-104.0525, 41.5223],
    [-104.0526, 41.5526],
    [-104.0529, 41.5923],
    [-104.0529, 41.6382],
    [-104.0528, 41.7334],
    [-104.0530, 41.8855],
    [-104.0527, 41.9730],
    [-104.0528, 41.9901],
    [-104.0528, 41.9950],
    [-104.0527, 42.0030],
    [-104.0530, 42.0750],
    [-104.0530, 42.0891],
    [-104.0526, 42.1250],
    [-104.0525, 42.1668],
    [-104.0528, 42.2500],
    [-104.0531, 42.5000],
    [-104.0528, 42.6118],
    [-104.0526, 42.6501],
    [-104.0530, 43.0006],
    [-103.9249, 43.0009],
    [-103.8139, 43.0014],
    [-103.6183, 43.0007],
    [-103.5434, 43.0008],
    [-103.5052, 43.0008],
    [-103.3468, 43.0009],
    [-103.1330, 43.0008],
    [-102.7921, 43.0000],
    [-102.7128, 42.9999],
    [-102.5564, 42.9997],
    [-102.5529, 42.9996],
    [-102.4360, 42.9996],
    [-102.3578, 42.9996],
    [-102.0825, 42.9994],
    [-101.7138, 42.9966],
    [-101.5142, 42.9970],
    [-101.4264, 42.9973],
    [-101.2280, 42.9979],
    [-101.1408, 42.9979],
    [-100.9642, 42.9979],
    [-100.9070, 42.9979],
    [-100.8879, 42.9979],
    [-100.8076, 42.9982],
    [-100.6317, 42.9981],
    [-100.5440, 42.9988],
    [-100.4134, 42.9990],
    [-100.2837, 42.9988],
    [-100.1984, 42.9985],
    [-100.1269, 42.9987],
    [-100.0344, 42.9984],
    [-100.0048, 42.9984],
    [-99.9509, 42.9983],
    [-99.9184, 42.9981],
    [-99.8699, 42.9981],
    [-99.8500, 42.9982],
    [-99.8094, 42.9982],
    [-99.7882, 42.9980],
    [-99.7431, 42.9979],
    [-99.7014, 42.9980],
    [-99.6524, 42.9979],
    [-99.5340, 42.9980],
    [-99.4745, 42.9981],
    [-99.3743, 42.9980],
    [-99.3555, 42.9982],
    [-99.2627, 42.9982],
    [-99.2345, 42.9983],
    [-99.1614, 42.9985],
    [-99.1390, 42.9985],
    [-99.0819, 42.9983],
    [-99.0223, 42.9982],
    [-99.0004, 42.9983],
    [-98.9192, 42.9982],
    [-98.8999, 42.9981],
    [-98.8242, 42.9983],
    [-98.7644, 42.9983],
    [-98.7053, 42.9984],
    [-98.6637, 42.9984],
    [-98.5651, 42.9984],
    [-98.4957, 42.9880],
    [-98.4674, 42.9476],
    [-98.4585, 42.9434],
    [-98.4470, 42.9351],
    [-98.4397, 42.9282],
    [-98.4309, 42.9315],
    [-98.4207, 42.9319],
    [-98.3864, 42.9184],
    [-98.3580, 42.9075],
    [-98.3424, 42.9008],
    [-98.3335, 42.8915],
    [-98.3259, 42.8865],
    [-98.2975, 42.8801],
    [-98.2583, 42.8744],
    [-98.2468, 42.8684],
    [-98.2265, 42.8577],
    [-98.2177, 42.8523],
    [-98.1869, 42.8409],
    [-98.1675, 42.8369],
    [-98.1481, 42.8400],
    [-98.1300, 42.8224],
    [-98.1077, 42.8106],
    [-98.0878, 42.7958],
    [-98.0629, 42.7811],
    [-98.0566, 42.7708],
    [-98.0447, 42.7680],
    [-98.0350, 42.7642],
    [-98.0057, 42.7642],
    [-97.9925, 42.7651],
    [-97.9535, 42.7690],
    [-97.9367, 42.7758],
    [-97.9214, 42.7884],
    [-97.9050, 42.7989],
    [-97.8902, 42.8151],
    [-97.8799, 42.8354],
    [-97.8757, 42.8503],
    [-97.8753, 42.8587],
    [-97.8580, 42.8651],
    [-97.8285, 42.8688],
    [-97.8048, 42.8588],
    [-97.7793, 42.8510],
    [-97.7538, 42.8490],
    [-97.7204, 42.8474],
    [-97.6683, 42.8430],
    [-97.6354, 42.8514],
    [-97.6038, 42.8583],
    [-97.5919, 42.8538],
    [-97.5475, 42.8480],
    [-97.5159, 42.8538],
    [-97.4991, 42.8552],
    [-97.4849, 42.8504],
    [-97.4617, 42.8492],
    [-97.4522, 42.8460],
    [-97.4320, 42.8515],
    [-97.4232, 42.8612],
    [-97.4083, 42.8683],
    [-97.3940, 42.8642],
    [-97.3753, 42.8630],
    [-97.3618, 42.8551],
    [-97.3362, 42.8568],
    [-97.3285, 42.8595],
    [-97.3245, 42.8620],
    [-97.3089, 42.8673],
    [-97.3021, 42.8657],
    [-97.2875, 42.8552],
    [-97.2786, 42.8540],
    [-97.2665, 42.8528],
    [-97.2518, 42.8554],
    [-97.2486, 42.8554],
    [-97.2188, 42.8458],
    [-97.2183, 42.8296],
    [-97.2151, 42.8230],
    [-97.2124, 42.8118],
    [-97.2047, 42.8065],
    [-97.1785, 42.8032],
    [-97.1639, 42.8013],
    [-97.1446, 42.7901],
    [-97.1370, 42.7810],
    [-97.1346, 42.7748],
    [-97.1116, 42.7694],
    [-97.0961, 42.7693],
    [-97.0718, 42.7723],
    [-97.0332, 42.7659],
    [-97.0158, 42.7616],
    [-96.9822, 42.7606],
    [-96.9689, 42.7543],
    [-96.9612, 42.7374],
    [-96.9658, 42.7271],
    [-96.9635, 42.7206],
    [-96.9489, 42.7195],
    [-96.9302, 42.7264],
    [-96.9068, 42.7338],
    [-96.8985, 42.7303],
    [-96.8604, 42.7208],
    [-96.8296, 42.7084],
    [-96.8131, 42.7064],
    [-96.8005, 42.6925],
    [-96.8010, 42.6698],
    [-96.7926, 42.6659],
    [-96.7641, 42.6620],
    [-96.7469, 42.6662],
    [-96.7280, 42.6669],
    [-96.6877, 42.6531],
    [-96.6871, 42.6494],
    [-96.6926, 42.6420],
    [-96.7095, 42.6219],
    [-96.7110, 42.6081],
    [-96.6973, 42.5904],
    [-96.6760, 42.5716],
    [-96.6481, 42.5609],
    [-96.6380, 42.5520],
    [-96.6333, 42.5402],
    [-96.6329, 42.5290],
    [-96.6282, 42.5170],
    [-96.6115, 42.5061],
    [-96.6035, 42.5045],
    [-96.5911, 42.5054],
    [-96.5679, 42.5179],
    [-96.5488, 42.5205],
    [-96.5316, 42.5152],
    [-96.5207, 42.5048],
    [-96.5159, 42.4943],
    [-96.5060, 42.4849],
    [-96.4895, 42.4801],
    [-96.4756, 42.4800],
    [-96.4455, 42.4906],
    [-96.4239, 42.4890],
    [-96.4128, 42.4879],
    [-96.3961, 42.4841],
    [-96.3860, 42.4745],
    [-96.3801, 42.4516],
    [-96.3807, 42.4468],
    [-96.3876, 42.4325],
    [-96.4136, 42.4079],
    [-96.4150, 42.3934],
    [-96.4092, 42.3815],
    [-96.4140, 42.3659],
    [-96.4179, 42.3587],
    [-96.4155, 42.3468],
    [-96.4080, 42.3374],
    [-96.3842, 42.3259],
    [-96.3700, 42.3109],
    [-96.3685, 42.3036],
    [-96.3658, 42.2859],
    [-96.3564, 42.2765],
    [-96.3313, 42.2594],
    [-96.3290, 42.2419],
    [-96.3229, 42.2336],
    [-96.3320, 42.2216],
    [-96.3391, 42.2181],
    [-96.3567, 42.2151],
    [-96.3591, 42.2078],
    [-96.3481, 42.1947],
    [-96.3503, 42.1774],
    [-96.3440, 42.1623],
    [-96.3296, 42.1532],
    [-96.3170, 42.1432],
    [-96.3059, 42.1298],
    [-96.2988, 42.1277],
    [-96.2750, 42.1208],
    [-96.2673, 42.1103],
    [-96.2676, 42.0962],
    [-96.2741, 42.0859],
    [-96.2791, 42.0740],
    [-96.2776, 42.0580],
    [-96.2729, 42.0472],
    [-96.2639, 42.0399],
    [-96.2561, 42.0381],
    [-96.2384, 42.0411],
    [-96.2238, 42.0333],
    [-96.2236, 42.0227],
    [-96.2389, 42.0123],
    [-96.2420, 42.0009],
    [-96.2311, 41.9948],
    [-96.2239, 41.9955],
    [-96.2152, 42.0067],
    [-96.1946, 42.0087],
    [-96.1836, 42.0000],
    [-96.1895, 41.9893],
    [-96.1906, 41.9807],
    [-96.1842, 41.9767],
    [-96.1681, 41.9790],
    [-96.1412, 41.9781],
    [-96.1289, 41.9697],
    [-96.1354, 41.9522],
    [-96.1436, 41.9445],
    [-96.1366, 41.9272],
    [-96.1397, 41.9168],
    [-96.1543, 41.9124],
    [-96.1620, 41.9056],
    [-96.1582, 41.8972],
    [-96.1473, 41.8848],
    [-96.1445, 41.8719],
    [-96.1353, 41.8631],
    [-96.1162, 41.8549],
    [-96.1080, 41.8444],
    [-96.1109, 41.8308],
    [-96.1093, 41.8237],
    [-96.0983, 41.8142],
    [-96.0755, 41.8078],
    [-96.0649, 41.7962],
    [-96.0732, 41.7830],
    [-96.0783, 41.7620],
    [-96.0847, 41.7533],
    [-96.0975, 41.7491],
    [-96.1064, 41.7379],
    [-96.1026, 41.7280],
    [-96.0797, 41.7180],
    [-96.0725, 41.7088],
    [-96.0760, 41.7017],
    [-96.0906, 41.6974],
    [-96.1178, 41.6942],
    [-96.1214, 41.6885],
    [-96.1210, 41.6779],
    [-96.1115, 41.6685],
    [-96.0954, 41.6527],
    [-96.0977, 41.6396],
    [-96.1162, 41.6216],
    [-96.1176, 41.6100],
    [-96.1138, 41.6023],
    [-96.1075, 41.5955],
    [-96.0887, 41.5875],
    [-96.0820, 41.5807],
    [-96.0812, 41.5743],
    [-96.0884, 41.5644],
    [-96.0945, 41.5555],
    [-96.0966, 41.5454],
    [-96.0827, 41.5260],
    [-96.0692, 41.5196],
    [-96.0579, 41.5115],
    [-96.0407, 41.5071],
    [-96.0349, 41.5117],
    [-96.0344, 41.5211],
    [-96.0269, 41.5395],
    [-96.0191, 41.5451],
    [-96.0000, 41.5395],
    [-95.9926, 41.5142],
    [-95.9962, 41.5070],
    [-96.0160, 41.4927],
    [-96.0195, 41.4866],
    [-96.0118, 41.4762],
    [-95.9910, 41.4704],
    [-95.9655, 41.4635],
    [-95.9465, 41.4662],
    [-95.9329, 41.4638],
    [-95.9203, 41.4516],
    [-95.9218, 41.4421],
    [-95.9322, 41.4319],
    [-95.9312, 41.4190],
    [-95.9308, 41.4062],
    [-95.9369, 41.3910],
    [-95.9288, 41.3701],
    [-95.9355, 41.3606],
    [-95.9549, 41.3518],
    [-95.9567, 41.3456],
    [-95.9469, 41.3341],
    [-95.9393, 41.3289],
    [-95.9221, 41.3211],
    [-95.8993, 41.3212],
    [-95.8782, 41.3125],
    [-95.8728, 41.2901],
    [-95.8769, 41.2851],
    [-95.9025, 41.2734],
    [-95.9094, 41.2848],
    [-95.9043, 41.2976],
    [-95.9203, 41.3011],
    [-95.9296, 41.2923],
    [-95.9287, 41.2814],
    [-95.9140, 41.2714],
    [-95.9219, 41.2646],
    [-95.9213, 41.2585],
    [-95.9139, 41.2432],
    [-95.9109, 41.2319],
    [-95.9126, 41.2270],
    [-95.9249, 41.2112],
    [-95.9275, 41.2022],
    [-95.9232, 41.1910],
    [-95.9146, 41.1851],
    [-95.8648, 41.1883],
    [-95.8441, 41.1806],
    [-95.8413, 41.1750],
    [-95.8462, 41.1667],
    [-95.8673, 41.1687],
    [-95.8763, 41.1651],
    [-95.8835, 41.1549],
    [-95.8821, 41.1440],
    [-95.8750, 41.1330],
    [-95.8659, 41.1179],
    [-95.8654, 41.1013],
    [-95.8626, 41.0884],
    [-95.8706, 41.0752],
    [-95.8814, 41.0652],
    [-95.8795, 41.0533],
    [-95.8605, 41.0379],
    [-95.8599, 41.0254],
    [-95.8695, 41.0094],
    [-95.8668, 41.0011],
    [-95.8601, 40.9952],
    [-95.8402, 40.9872],
    [-95.8303, 40.9783],
    [-95.8298, 40.9639],
    [-95.8394, 40.9441],
    [-95.8384, 40.9274],
    [-95.8330, 40.9172],
    [-95.8143, 40.9029],
    [-95.8098, 40.8954],
    [-95.8121, 40.8842],
    [-95.8250, 40.8750],
    [-95.8425, 40.8703],
    [-95.8478, 40.8643],
    [-95.8485, 40.8586],
    [-95.8413, 40.8456],
    [-95.8386, 40.8262],
    [-95.8449, 40.8146],
    [-95.8437, 40.8038],
    [-95.8342, 40.7838],
    [-95.8369, 40.7765],
    [-95.8466, 40.7686],
    [-95.8700, 40.7596],
    [-95.8836, 40.7478],
    [-95.8889, 40.7319],
    [-95.8770, 40.7143],
    [-95.8632, 40.7096],
    [-95.8526, 40.7023],
    [-95.8479, 40.6942],
    [-95.8449, 40.6801],
    [-95.8377, 40.6745],
    [-95.8322, 40.6712],
    [-95.8229, 40.6672],
    [-95.7955, 40.6624],
    [-95.7819, 40.6533],
    [-95.7728, 40.6425],
    [-95.7703, 40.6315],
    [-95.7668, 40.6188],
    [-95.7529, 40.6102],
    [-95.7486, 40.6034],
    [-95.7531, 40.5928],
    [-95.7685, 40.5833],
    [-95.7718, 40.5661],
    [-95.7634, 40.5508],
    [-95.7684, 40.5403],
    [-95.7669, 40.5316],
    [-95.7487, 40.5243],
    [-95.7252, 40.5278],
    [-95.7100, 40.5238],
    [-95.6950, 40.5331],
    [-95.6949, 40.5507],
    [-95.6787, 40.5626],
    [-95.6621, 40.5500],
    [-95.6523, 40.5381],
    [-95.6617, 40.5173],
    [-95.6956, 40.5065],
    [-95.6947, 40.4936],
    [-95.6968, 40.4788],
    [-95.6931, 40.4694],
    [-95.6772, 40.4602],
    [-95.6582, 40.4419],
    [-95.6556, 40.4347],
    [-95.6607, 40.4188],
    [-95.6517, 40.3992],
    [-95.6421, 40.3782],
    [-95.6410, 40.3664],
    [-95.6315, 40.3573],
    [-95.6249, 40.3493],
    [-95.6227, 40.3409],
    [-95.6299, 40.3310],
    [-95.6537, 40.3226],
    [-95.6580, 40.3127],
    [-95.6515, 40.3067],
    [-95.6363, 40.3077],
    [-95.6135, 40.3142],
    [-95.5987, 40.3098],
    [-95.5902, 40.3032],
    [-95.5681, 40.2991],
    [-95.5533, 40.2912],
    [-95.5515, 40.2811],
    [-95.5548, 40.2645],
    [-95.5437, 40.2607],
    [-95.5210, 40.2501],
    [-95.5003, 40.2496],
    [-95.4860, 40.2478],
    [-95.4725, 40.2361],
    [-95.4701, 40.2215],
    [-95.4779, 40.2086],
    [-95.4825, 40.1923],
    [-95.4792, 40.1857],
    [-95.4694, 40.1757],
    [-95.4428, 40.1633],
    [-95.4348, 40.1560],
    [-95.4322, 40.1410],
    [-95.4248, 40.1328],
    [-95.4044, 40.1290],
    [-95.3933, 40.1192],
    [-95.3929, 40.1146],
    [-95.3942, 40.1083],
    [-95.4076, 40.0980],
    [-95.4085, 40.0792],
    [-95.4147, 40.0698],
    [-95.4216, 40.0590],
    [-95.4168, 40.0432],
    [-95.4027, 40.0306],
    [-95.3872, 40.0268],
    [-95.3569, 40.0315],
    [-95.3362, 40.0191],
    [-95.3153, 40.0121],
    [-95.3085, 40.0022],
    [-95.3399, 40.0000],
    [-95.4147, 40.0000],
    [-95.4213, 40.0001],
    [-95.4360, 40.0001],
    [-95.4386, 40.0001],
    [-95.4553, 40.0001],
    [-95.4637, 40.0001],
    [-95.5654, 40.0002],
    [-95.6730, 40.0003],
    [-95.7880, 40.0005],
    [-95.8825, 40.0005],
    [-95.9016, 40.0005],
    [-96.0107, 40.0006],
    [-96.0517, 40.0007],
    [-96.1239, 40.0005],
    [-96.1261, 40.0004],
    [-96.1544, 40.0005],
    [-96.2202, 40.0007],
    [-96.2392, 40.0007],
    [-96.3046, 40.0006],
    [-96.3518, 40.0007],
    [-96.4637, 40.0010],
    [-96.4699, 40.0010],
    [-96.5271, 40.0010],
    [-96.5540, 40.0009],
    [-96.5579, 40.0010],
    [-96.5768, 40.0010],
    [-96.5858, 40.0010],
    [-96.6049, 40.0009],
    [-96.6224, 40.0012],
    [-96.6637, 40.0012],
    [-96.6934, 40.0012],
    [-96.8058, 40.0014],
    [-96.8783, 40.0015],
    [-96.9164, 40.0015],
    [-96.9307, 40.0015],
    [-97.0102, 40.0015],
    [-97.0308, 40.0013],
    [-97.1379, 40.0018],
    [-97.1442, 40.0015],
    [-97.2023, 40.0014],
    [-97.2559, 40.0016],
    [-97.3509, 40.0019],
    [-97.3692, 40.0021],
    [-97.4178, 40.0020],
    [-97.4447, 40.0020],
    [-97.4966, 40.0019],
    [-97.5114, 40.0019],
    [-97.6118, 40.0019],
    [-97.6707, 40.0020],
    [-97.7677, 40.0020],
    [-97.7708, 40.0020],
    [-97.8194, 40.0020],
    [-97.8328, 40.0019],
    [-97.8575, 40.0021],
    [-97.9318, 40.0020],
    [-97.9884, 40.0021],
    [-98.0144, 40.0022],
    [-98.0477, 40.0022],
    [-98.0760, 40.0023],
    [-98.1420, 40.0025],
    [-98.1793, 40.0025],
    [-98.2500, 40.0023],
    [-98.3919, 40.0024],
    [-98.4996, 40.0023],
    [-98.5432, 40.0023],
    [-98.5933, 40.0025],
    [-98.6407, 40.0025],
    [-98.6697, 40.0024],
    [-98.6914, 40.0025],
    [-98.7263, 40.0022],
    [-98.7749, 40.0023],
    [-98.8345, 40.0024],
    [-98.9348, 40.0022],
    [-98.9609, 40.0023],
    [-98.9723, 40.0022],
    [-99.0203, 40.0023],
    [-99.0856, 40.0021],
    [-99.1698, 40.0019],
    [-99.1792, 40.0020],
    [-99.1976, 40.0020],
    [-99.2166, 40.0020],
    [-99.2540, 40.0021],
    [-99.2907, 40.0019],
    [-99.3668, 40.0020],
    [-99.4047, 40.0020],
    [-99.4236, 40.0023],
    [-99.4977, 40.0019],
    [-99.5153, 40.0020],
    [-99.6094, 40.0019],
    [-99.6283, 40.0019],
    [-99.7320, 40.0018],
    [-99.7568, 40.0013],
    [-99.7756, 40.0016],
    [-99.8501, 40.0014],
    [-99.9304, 40.0015],
    [-99.9577, 40.0017],
    [-100.0322, 40.0015],
    [-100.0992, 40.0016],
    [-100.1373, 40.0016],
    [-100.1778, 40.0016],
    [-100.1936, 40.0016],
    [-100.2295, 40.0017],
    [-100.3072, 40.0017],
    [-100.4200, 40.0018],
    [-100.4575, 40.0018],
    [-100.4759, 40.0018],
    [-100.5111, 40.0018],
    [-100.5337, 40.0019],
    [-100.5948, 40.0020],
    [-100.6089, 40.0019],
    [-100.6454, 40.0019],
    [-100.6651, 40.0022],
    [-100.7027, 40.0021],
    [-100.7333, 40.0023],
    [-100.7522, 40.0021],
    [-100.9374, 40.0021],
    [-101.0277, 40.0023],
    [-101.1309, 40.0024],
    [-101.1869, 40.0025],
    [-101.2150, 40.0026],
    [-101.2940, 40.0026],
    [-101.3429, 40.0026],
    [-101.4110, 40.0024],
    [-101.5423, 40.0026],
    [-101.6258, 40.0027],
    [-101.7834, 40.0027],
    [-101.8128, 40.0028],
    [-101.8617, 40.0029],
    [-102.0517, 40.0031],
    [-102.0519, 40.1627],
    [-102.0517, 40.2659],
    [-102.0518, 40.3601],
    [-102.0518, 40.3966],
    [-102.0517, 40.5378],
    [-102.0513, 40.7496],
    [-102.0516, 40.9596],
    [-102.0706, 41.0024],
    [-102.2091, 41.0024],
    [-102.2319, 41.0023],
    [-102.2678, 41.0024],
    [-102.2914, 41.0022],
    [-102.2928, 41.0022],
    [-102.3796, 41.0023],
    [-102.4705, 41.0024],
    [-102.5568, 41.0022],
    [-102.5757, 41.0023],
    [-102.6535, 41.0023],
    [-102.7546, 41.0024],
    [-102.7928, 41.0023],
    [-102.8465, 41.0023],
    [-102.8678, 41.0022],
    [-102.8874, 41.0022],
    [-102.9065, 41.0023],
    [-102.9431, 41.0021],
    [-102.9607, 41.0021],
    [-102.9815, 41.0021],
    [-103.0020, 41.0025],
    [-103.0580, 41.0024],
    [-103.0778, 41.0023],
    [-103.3653, 41.0018],
    [-103.4219, 41.0020],
    [-103.4974, 41.0016],
    [-103.5745, 41.0017],
    [-103.7633, 41.0020],
    [-103.8962, 41.0018],
    [-103.9535, 41.0016],
    [-104.0110, 41.0016],
    [-104.0392, 41.0015],
    [-104.0531, 41.0180],
    [-104.0531, 41.1050],
    [-104.0534, 41.1705]
    ]
  },
  "Washington": {
    coordinates: [
      [-124.7328, 48.1653],
    [-124.7198, 48.1774],
    [-124.7100, 48.1814],
    [-124.7051, 48.1839],
    [-124.6909, 48.2126],
    [-124.6989, 48.2280],
    [-124.7050, 48.2388],
    [-124.6998, 48.2439],
    [-124.6847, 48.2552],
    [-124.6808, 48.2749],
    [-124.6808, 48.2772],
    [-124.6851, 48.2851],
    [-124.6840, 48.2924],
    [-124.6809, 48.2976],
    [-124.6763, 48.2951],
    [-124.6621, 48.3104],
    [-124.6589, 48.3311],
    [-124.6701, 48.3413],
    [-124.6811, 48.3415],
    [-124.6946, 48.3434],
    [-124.6990, 48.3506],
    [-124.7075, 48.3546],
    [-124.7138, 48.3663],
    [-124.7273, 48.3746],
    [-124.7317, 48.3812],
    [-124.7258, 48.3860],
    [-124.7038, 48.3871],
    [-124.6914, 48.3902],
    [-124.6763, 48.3914],
    [-124.6594, 48.3909],
    [-124.6527, 48.3906],
    [-124.6357, 48.3882],
    [-124.6390, 48.3851],
    [-124.6311, 48.3765],
    [-124.6217, 48.3678],
    [-124.6023, 48.3695],
    [-124.5961, 48.3717],
    [-124.5893, 48.3728],
    [-124.5840, 48.3719],
    [-124.5729, 48.3662],
    [-124.5648, 48.3679],
    [-124.5553, 48.3606],
    [-124.5463, 48.3536],
    [-124.5211, 48.3473],
    [-124.5009, 48.3381],
    [-124.4858, 48.3325],
    [-124.4756, 48.3280],
    [-124.4558, 48.3187],
    [-124.4463, 48.3159],
    [-124.4343, 48.3066],
    [-124.4140, 48.3009],
    [-124.4058, 48.2956],
    [-124.3869, 48.2857],
    [-124.3626, 48.2873],
    [-124.3585, 48.2873],
    [-124.3438, 48.2793],
    [-124.3346, 48.2754],
    [-124.3161, 48.2719],
    [-124.2991, 48.2682],
    [-124.2976, 48.2607],
    [-124.2843, 48.2580],
    [-124.2734, 48.2542],
    [-124.2596, 48.2566],
    [-124.2514, 48.2633],
    [-124.2433, 48.2625],
    [-124.2275, 48.2572],
    [-124.2219, 48.2551],
    [-124.1993, 48.2477],
    [-124.1849, 48.2430],
    [-124.1632, 48.2351],
    [-124.1413, 48.2274],
    [-124.1176, 48.2208],
    [-124.1047, 48.2112],
    [-124.1069, 48.2049],
    [-124.1024, 48.1990],
    [-124.0907, 48.1965],
    [-124.0755, 48.1909],
    [-124.0657, 48.1864],
    [-124.0598, 48.1861],
    [-124.0507, 48.1777],
    [-124.0321, 48.1743],
    [-124.0233, 48.1730],
    [-124.0056, 48.1724],
    [-123.9881, 48.1671],
    [-123.9553, 48.1655],
    [-123.9461, 48.1664],
    [-123.9349, 48.1608],
    [-123.8939, 48.1596],
    [-123.8721, 48.1588],
    [-123.8588, 48.1543],
    [-123.8316, 48.1579],
    [-123.8176, 48.1571],
    [-123.7981, 48.1558],
    [-123.7476, 48.1616],
    [-123.7358, 48.1619],
    [-123.7300, 48.1651],
    [-123.7283, 48.1609],
    [-123.7062, 48.1634],
    [-123.7095, 48.1676],
    [-123.7010, 48.1665],
    [-123.6591, 48.1591],
    [-123.6514, 48.1570],
    [-123.6427, 48.1541],
    [-123.6415, 48.1472],
    [-123.6288, 48.1393],
    [-123.6072, 48.1369],
    [-123.5987, 48.1358],
    [-123.5908, 48.1349],
    [-123.5835, 48.1364],
    [-123.5689, 48.1466],
    [-123.5647, 48.1485],
    [-123.5511, 48.1514],
    [-123.5410, 48.1484],
    [-123.5302, 48.1420],
    [-123.5155, 48.1331],
    [-123.4927, 48.1323],
    [-123.4734, 48.1341],
    [-123.4557, 48.1394],
    [-123.4339, 48.1421],
    [-123.4034, 48.1414],
    [-123.4009, 48.1385],
    [-123.4464, 48.1361],
    [-123.4612, 48.1326],
    [-123.4559, 48.1280],
    [-123.4512, 48.1259],
    [-123.4368, 48.1224],
    [-123.4181, 48.1172],
    [-123.4096, 48.1174],
    [-123.4053, 48.1171],
    [-123.3836, 48.1147],
    [-123.3632, 48.1156],
    [-123.3542, 48.1177],
    [-123.3457, 48.1176],
    [-123.3327, 48.1130],
    [-123.3146, 48.1137],
    [-123.2883, 48.1210],
    [-123.2802, 48.1173],
    [-123.2572, 48.1170],
    [-123.2485, 48.1158],
    [-123.2172, 48.1272],
    [-123.1819, 48.1516],
    [-123.1596, 48.1684],
    [-123.1448, 48.1759],
    [-123.1019, 48.1850],
    [-123.1008, 48.1824],
    [-123.1250, 48.1756],
    [-123.1388, 48.1670],
    [-123.1420, 48.1570],
    [-123.1301, 48.1529],
    [-123.1238, 48.1531],
    [-123.1065, 48.1419],
    [-123.0809, 48.1257],
    [-123.0589, 48.1140],
    [-123.0466, 48.0973],
    [-123.0388, 48.0812],
    [-123.0167, 48.0854],
    [-122.9794, 48.0959],
    [-122.9291, 48.0962],
    [-122.9179, 48.0915],
    [-122.9266, 48.0741],
    [-122.9269, 48.0646],
    [-122.8784, 48.0470],
    [-122.8704, 48.0385],
    [-122.8610, 48.0213],
    [-122.8608, 48.0076],
    [-122.8758, 47.9960],
    [-122.8395, 48.0018],
    [-122.8353, 48.0145],
    [-122.8288, 48.0336],
    [-122.8449, 48.0518],
    [-122.8524, 48.0560],
    [-122.8577, 48.0658],
    [-122.8800, 48.0888],
    [-122.8848, 48.1037],
    [-122.8482, 48.1269],
    [-122.8218, 48.1359],
    [-122.7926, 48.1412],
    [-122.7541, 48.1447],
    [-122.7597, 48.1384],
    [-122.7617, 48.1305],
    [-122.7534, 48.1230],
    [-122.7541, 48.1149],
    [-122.7812, 48.1044],
    [-122.7939, 48.0943],
    [-122.8014, 48.0876],
    [-122.7881, 48.0781],
    [-122.7742, 48.0603],
    [-122.7706, 48.0534],
    [-122.7666, 48.0443],
    [-122.7567, 48.0372],
    [-122.7399, 48.0312],
    [-122.7370, 48.0434],
    [-122.7393, 48.0692],
    [-122.7483, 48.0721],
    [-122.7333, 48.0912],
    [-122.6927, 48.1033],
    [-122.6917, 48.0964],
    [-122.6854, 48.0720],
    [-122.6823, 48.0427],
    [-122.6691, 48.0292],
    [-122.6699, 48.0172],
    [-122.6921, 48.0098],
    [-122.7195, 48.0237],
    [-122.7291, 48.0197],
    [-122.7181, 47.9877],
    [-122.6832, 47.9722],
    [-122.6796, 47.9512],
    [-122.6844, 47.9396],
    [-122.6806, 47.9266],
    [-122.6901, 47.9226],
    [-122.6992, 47.9187],
    [-122.6941, 47.9182],
    [-122.6826, 47.9150],
    [-122.6704, 47.9220],
    [-122.6602, 47.9319],
    [-122.6560, 47.9244],
    [-122.6540, 47.9159],
    [-122.6527, 47.9022],
    [-122.6478, 47.8960],
    [-122.6286, 47.8895],
    [-122.6177, 47.8830],
    [-122.6251, 47.8787],
    [-122.6339, 47.8684],
    [-122.6657, 47.8666],
    [-122.6938, 47.8680],
    [-122.6852, 47.8525],
    [-122.6837, 47.8388],
    [-122.7014, 47.8256],
    [-122.7178, 47.8115],
    [-122.7377, 47.8059],
    [-122.7458, 47.8043],
    [-122.7442, 47.7906],
    [-122.7489, 47.7806],
    [-122.7499, 47.7745],
    [-122.7532, 47.7654],
    [-122.7563, 47.7548],
    [-122.7656, 47.7415],
    [-122.7754, 47.7327],
    [-122.7800, 47.7214],
    [-122.7822, 47.7072],
    [-122.7722, 47.6954],
    [-122.7846, 47.6866],
    [-122.8057, 47.6828],
    [-122.8299, 47.6891],
    [-122.8271, 47.7000],
    [-122.8204, 47.7128],
    [-122.8124, 47.7198],
    [-122.8076, 47.7371],
    [-122.8000, 47.7582],
    [-122.7957, 47.7707],
    [-122.7898, 47.7909],
    [-122.7933, 47.8086],
    [-122.7974, 47.8163],
    [-122.8065, 47.8323],
    [-122.8207, 47.8380],
    [-122.8238, 47.8195],
    [-122.8156, 47.8109],
    [-122.8276, 47.7848],
    [-122.8535, 47.7801],
    [-122.8506, 47.7968],
    [-122.8573, 47.8043],
    [-122.8680, 47.7989],
    [-122.8666, 47.7828],
    [-122.8647, 47.7802],
    [-122.8549, 47.7631],
    [-122.8509, 47.7497],
    [-122.8530, 47.7363],
    [-122.8675, 47.7445],
    [-122.8723, 47.7355],
    [-122.8736, 47.7305],
    [-122.8783, 47.7313],
    [-122.8837, 47.7230],
    [-122.8896, 47.7059],
    [-122.8808, 47.6862],
    [-122.8972, 47.6790],
    [-122.9062, 47.6710],
    [-122.9029, 47.6624],
    [-122.9014, 47.6539],
    [-122.9017, 47.6507],
    [-122.9041, 47.6456],
    [-122.9218, 47.6499],
    [-122.9274, 47.6508],
    [-122.9352, 47.6432],
    [-122.9417, 47.6323],
    [-122.9545, 47.6270],
    [-122.9664, 47.6188],
    [-122.9830, 47.6086],
    [-122.9825, 47.6030],
    [-123.0006, 47.5847],
    [-123.0099, 47.5714],
    [-123.0220, 47.5565],
    [-123.0253, 47.5485],
    [-123.0434, 47.5334],
    [-123.0515, 47.5199],
    [-123.0574, 47.5008],
    [-123.0743, 47.4862],
    [-123.0881, 47.4764],
    [-123.1016, 47.4624],
    [-123.1104, 47.4547],
    [-123.1199, 47.4337],
    [-123.1299, 47.4219],
    [-123.1365, 47.4097],
    [-123.1408, 47.4031],
    [-123.1454, 47.3872],
    [-123.1475, 47.3752],
    [-123.1579, 47.3673],
    [-123.1572, 47.3590],
    [-123.1418, 47.3471],
    [-123.1202, 47.3601],
    [-123.1011, 47.3596],
    [-123.0802, 47.3529],
    [-123.0704, 47.3497],
    [-123.0471, 47.3495],
    [-123.0324, 47.3518],
    [-123.0172, 47.3563],
    [-122.9939, 47.3703],
    [-122.9839, 47.3746],
    [-122.9734, 47.3805],
    [-122.9487, 47.3835],
    [-122.9269, 47.3893],
    [-122.9030, 47.3966],
    [-122.8779, 47.4110],
    [-122.8677, 47.4221],
    [-122.8774, 47.4221],
    [-122.8869, 47.4238],
    [-122.9012, 47.4216],
    [-122.9043, 47.4144],
    [-122.9131, 47.4145],
    [-122.9321, 47.4082],
    [-122.9440, 47.4026],
    [-122.9573, 47.3997],
    [-122.9694, 47.3963],
    [-122.9830, 47.3930],
    [-122.9884, 47.3886],
    [-123.0132, 47.3786],
    [-123.0193, 47.3699],
    [-123.0296, 47.3588],
    [-123.0517, 47.3640],
    [-123.0695, 47.3716],
    [-123.0785, 47.3729],
    [-123.0909, 47.3714],
    [-123.1058, 47.3724],
    [-123.1135, 47.3826],
    [-123.1202, 47.3915],
    [-123.1120, 47.4019],
    [-123.1019, 47.4148],
    [-123.0892, 47.4343],
    [-123.0832, 47.4451],
    [-123.0749, 47.4517],
    [-123.0685, 47.4583],
    [-123.0455, 47.4808],
    [-123.0312, 47.5021],
    [-123.0233, 47.5207],
    [-123.0148, 47.5284],
    [-123.0084, 47.5322],
    [-122.9855, 47.5567],
    [-122.9753, 47.5596],
    [-122.9751, 47.5677],
    [-122.9651, 47.5852],
    [-122.9366, 47.5901],
    [-122.9228, 47.5979],
    [-122.9159, 47.6093],
    [-122.9171, 47.6207],
    [-122.8916, 47.6283],
    [-122.8684, 47.6332],
    [-122.8596, 47.6388],
    [-122.8408, 47.6525],
    [-122.8273, 47.6532],
    [-122.8365, 47.6415],
    [-122.8242, 47.6423],
    [-122.7959, 47.6552],
    [-122.7852, 47.6599],
    [-122.7745, 47.6634],
    [-122.7630, 47.6680],
    [-122.7543, 47.6687],
    [-122.7476, 47.6813],
    [-122.7465, 47.7012],
    [-122.7473, 47.7214],
    [-122.7435, 47.7293],
    [-122.7401, 47.7359],
    [-122.7330, 47.7376],
    [-122.7227, 47.7489],
    [-122.7148, 47.7682],
    [-122.7018, 47.7749],
    [-122.6841, 47.7986],
    [-122.6749, 47.8044],
    [-122.6715, 47.8084],
    [-122.6584, 47.8137],
    [-122.6538, 47.8161],
    [-122.6479, 47.8252],
    [-122.6232, 47.8362],
    [-122.5813, 47.8574],
    [-122.5737, 47.8576],
    [-122.5733, 47.8677],
    [-122.5882, 47.9129],
    [-122.6052, 47.9223],
    [-122.6155, 47.9278],
    [-122.6170, 47.9390],
    [-122.6015, 47.9317],
    [-122.5818, 47.9203],
    [-122.5401, 47.9137],
    [-122.5253, 47.9123],
    [-122.5126, 47.8818],
    [-122.5128, 47.8639],
    [-122.5079, 47.8550],
    [-122.5066, 47.8414],
    [-122.5022, 47.8264],
    [-122.4824, 47.8093],
    [-122.5006, 47.7953],
    [-122.5019, 47.7907],
    [-122.4835, 47.7819],
    [-122.4831, 47.7771],
    [-122.4781, 47.7690],
    [-122.4726, 47.7528],
    [-122.4773, 47.7460],
    [-122.5033, 47.7432],
    [-122.5193, 47.7462],
    [-122.5373, 47.7471],
    [-122.5524, 47.7441],
    [-122.5497, 47.7309],
    [-122.5519, 47.7241],
    [-122.5432, 47.7109],
    [-122.5261, 47.7071],
    [-122.5171, 47.7072],
    [-122.5112, 47.7087],
    [-122.5045, 47.6859],
    [-122.5087, 47.6708],
    [-122.5007, 47.6596],
    [-122.5183, 47.6521],
    [-122.5082, 47.6437],
    [-122.4891, 47.6332],
    [-122.4945, 47.6236],
    [-122.4924, 47.6191],
    [-122.4979, 47.6203],
    [-122.4989, 47.6045],
    [-122.5064, 47.5965],
    [-122.5028, 47.5917],
    [-122.4791, 47.5837],
    [-122.4980, 47.5778],
    [-122.5228, 47.5712],
    [-122.5320, 47.5653],
    [-122.5378, 47.5625],
    [-122.5397, 47.5438],
    [-122.5435, 47.5263],
    [-122.5278, 47.5243],
    [-122.5204, 47.5231],
    [-122.5075, 47.5196],
    [-122.5006, 47.5153],
    [-122.4959, 47.5129],
    [-122.4955, 47.5096],
    [-122.5038, 47.5012],
    [-122.5147, 47.4899],
    [-122.5188, 47.4813],
    [-122.5287, 47.4723],
    [-122.5308, 47.4620],
    [-122.5356, 47.4493],
    [-122.5318, 47.4303],
    [-122.5398, 47.4207],
    [-122.5445, 47.4115],
    [-122.5504, 47.4067],
    [-122.5523, 47.3946],
    [-122.5521, 47.3938],
    [-122.5499, 47.3877],
    [-122.5398, 47.3779],
    [-122.5482, 47.3658],
    [-122.5680, 47.3344],
    [-122.5754, 47.3265],
    [-122.5758, 47.3258],
    [-122.5736, 47.3182],
    [-122.5663, 47.3065],
    [-122.5501, 47.2905],
    [-122.5554, 47.2750],
    [-122.5589, 47.2715],
    [-122.5770, 47.2568],
    [-122.5879, 47.2548],
    [-122.5958, 47.2602],
    [-122.6001, 47.2624],
    [-122.5924, 47.2720],
    [-122.6014, 47.2718],
    [-122.6143, 47.2696],
    [-122.6206, 47.2716],
    [-122.6307, 47.2772],
    [-122.6483, 47.2799],
    [-122.6599, 47.2823],
    [-122.6713, 47.2862],
    [-122.6809, 47.2801],
    [-122.6958, 47.2814],
    [-122.6959, 47.2874],
    [-122.6912, 47.2981],
    [-122.6842, 47.3031],
    [-122.6842, 47.3141],
    [-122.6795, 47.3278],
    [-122.6700, 47.3325],
    [-122.6651, 47.3329],
    [-122.6597, 47.3314],
    [-122.6664, 47.3379],
    [-122.6671, 47.3455],
    [-122.6537, 47.3552],
    [-122.6381, 47.3626],
    [-122.6290, 47.3722],
    [-122.6278, 47.3824],
    [-122.6502, 47.3746],
    [-122.6690, 47.3685],
    [-122.6823, 47.3655],
    [-122.6870, 47.3611],
    [-122.6892, 47.3554],
    [-122.7082, 47.3445],
    [-122.7258, 47.3373],
    [-122.7289, 47.3344],
    [-122.7322, 47.3162],
    [-122.7432, 47.3032],
    [-122.7507, 47.2905],
    [-122.7524, 47.2764],
    [-122.7568, 47.2738],
    [-122.7495, 47.2744],
    [-122.7500, 47.2669],
    [-122.7496, 47.2597],
    [-122.7457, 47.2607],
    [-122.7362, 47.2639],
    [-122.7379, 47.2579],
    [-122.7248, 47.2488],
    [-122.7184, 47.2515],
    [-122.7170, 47.2480],
    [-122.7229, 47.2373],
    [-122.7248, 47.2358],
    [-122.7196, 47.2272],
    [-122.7279, 47.2154],
    [-122.7370, 47.2100],
    [-122.7457, 47.2065],
    [-122.7552, 47.2097],
    [-122.7503, 47.2011],
    [-122.7457, 47.1992],
    [-122.7404, 47.2001],
    [-122.7472, 47.1892],
    [-122.7474, 47.1810],
    [-122.7521, 47.1725],
    [-122.7638, 47.1661],
    [-122.7744, 47.1716],
    [-122.7755, 47.1766],
    [-122.7790, 47.1853],
    [-122.7975, 47.1994],
    [-122.8075, 47.2180],
    [-122.8106, 47.2257],
    [-122.8277, 47.2388],
    [-122.8308, 47.2457],
    [-122.8250, 47.2576],
    [-122.8177, 47.2718],
    [-122.8148, 47.2759],
    [-122.7985, 47.2875],
    [-122.7902, 47.3051],
    [-122.7931, 47.3082],
    [-122.7947, 47.3168],
    [-122.7926, 47.3270],
    [-122.7911, 47.3360],
    [-122.7888, 47.3425],
    [-122.7961, 47.3470],
    [-122.7946, 47.3510],
    [-122.7913, 47.3556],
    [-122.7892, 47.3615],
    [-122.7936, 47.3607],
    [-122.8004, 47.3586],
    [-122.8059, 47.3585],
    [-122.8069, 47.3608],
    [-122.8103, 47.3673],
    [-122.8131, 47.3697],
    [-122.8160, 47.3754],
    [-122.8162, 47.3821],
    [-122.8133, 47.3879],
    [-122.8132, 47.3950],
    [-122.8151, 47.3988],
    [-122.8189, 47.4036],
    [-122.8217, 47.4055],
    [-122.8245, 47.4047],
    [-122.8284, 47.4052],
    [-122.8259, 47.3999],
    [-122.8234, 47.3965],
    [-122.8257, 47.3865],
    [-122.8290, 47.3811],
    [-122.8323, 47.3771],
    [-122.8286, 47.3742],
    [-122.8276, 47.3693],
    [-122.8252, 47.3666],
    [-122.8254, 47.3602],
    [-122.8246, 47.3551],
    [-122.8208, 47.3423],
    [-122.8292, 47.3342],
    [-122.8193, 47.3299],
    [-122.8315, 47.3143],
    [-122.8308, 47.3201],
    [-122.8377, 47.3233],
    [-122.8430, 47.3131],
    [-122.8526, 47.3068],
    [-122.8475, 47.2970],
    [-122.8563, 47.2894],
    [-122.8684, 47.2802],
    [-122.8639, 47.2720],
    [-122.8660, 47.2606],
    [-122.8703, 47.2486],
    [-122.8596, 47.2504],
    [-122.8613, 47.2365],
    [-122.8563, 47.2281],
    [-122.8472, 47.2197],
    [-122.8392, 47.2097],
    [-122.8456, 47.1976],
    [-122.8494, 47.1870],
    [-122.8632, 47.1705],
    [-122.8520, 47.1644],
    [-122.8418, 47.1632],
    [-122.8401, 47.1555],
    [-122.8441, 47.1477],
    [-122.8449, 47.1357],
    [-122.8420, 47.1294],
    [-122.8323, 47.1150],
    [-122.8306, 47.1207],
    [-122.8298, 47.1303],
    [-122.8294, 47.1388],
    [-122.8261, 47.1656],
    [-122.8125, 47.1710],
    [-122.7987, 47.1593],
    [-122.7914, 47.1451],
    [-122.7892, 47.1370],
    [-122.7864, 47.1267],
    [-122.7751, 47.1231],
    [-122.7629, 47.1197],
    [-122.7561, 47.1158],
    [-122.7498, 47.1108],
    [-122.7216, 47.0984],
    [-122.7018, 47.0987],
    [-122.6938, 47.1039],
    [-122.6749, 47.1066],
    [-122.6697, 47.1146],
    [-122.6451, 47.1351],
    [-122.6356, 47.1362],
    [-122.6262, 47.1419],
    [-122.6168, 47.1572],
    [-122.6138, 47.1696],
    [-122.6033, 47.1725],
    [-122.5932, 47.1758],
    [-122.5908, 47.1781],
    [-122.5850, 47.1873],
    [-122.5848, 47.1897],
    [-122.5834, 47.1958],
    [-122.5805, 47.2104],
    [-122.5722, 47.2183],
    [-122.5649, 47.2272],
    [-122.5634, 47.2365],
    [-122.5623, 47.2452],
    [-122.5563, 47.2444],
    [-122.5535, 47.2519],
    [-122.5444, 47.2641],
    [-122.5330, 47.2764],
    [-122.5287, 47.2909],
    [-122.5420, 47.3107],
    [-122.5413, 47.3189],
    [-122.5150, 47.3061],
    [-122.5070, 47.3028],
    [-122.4993, 47.2966],
    [-122.4902, 47.2891],
    [-122.4773, 47.2809],
    [-122.4611, 47.2754],
    [-122.4403, 47.2620],
    [-122.4332, 47.2635],
    [-122.4213, 47.2702],
    [-122.4138, 47.2850],
    [-122.4137, 47.2939],
    [-122.4325, 47.2970],
    [-122.4398, 47.2987],
    [-122.4346, 47.3075],
    [-122.4318, 47.3137],
    [-122.4254, 47.3193],
    [-122.4179, 47.3203],
    [-122.4034, 47.3225],
    [-122.3979, 47.3258],
    [-122.3860, 47.3274],
    [-122.3797, 47.3266],
    [-122.3762, 47.3293],
    [-122.3642, 47.3360],
    [-122.3369, 47.3414],
    [-122.3274, 47.3457],
    [-122.3250, 47.3611],
    [-122.3250, 47.3666],
    [-122.3249, 47.3714],
    [-122.3252, 47.3738],
    [-122.3265, 47.3826],
    [-122.3257, 47.3915],
    [-122.3305, 47.3964],
    [-122.3346, 47.4069],
    [-122.3512, 47.4231],
    [-122.3512, 47.4308],
    [-122.3551, 47.4419],
    [-122.3605, 47.4425],
    [-122.3670, 47.4476],
    [-122.3724, 47.4558],
    [-122.3693, 47.4644],
    [-122.3665, 47.4749],
    [-122.3613, 47.4814],
    [-122.3649, 47.4881],
    [-122.3757, 47.4964],
    [-122.3866, 47.5022],
    [-122.3988, 47.5174],
    [-122.3939, 47.5248],
    [-122.3967, 47.5355],
    [-122.3983, 47.5501],
    [-122.4097, 47.5665],
    [-122.4141, 47.5716],
    [-122.3914, 47.5923],
    [-122.3812, 47.5904],
    [-122.3754, 47.5852],
    [-122.3621, 47.5838],
    [-122.3447, 47.5907],
    [-122.3395, 47.5991],
    [-122.3442, 47.6077],
    [-122.3531, 47.6135],
    [-122.3645, 47.6203],
    [-122.3837, 47.6263],
    [-122.3896, 47.6306],
    [-122.4042, 47.6339],
    [-122.4183, 47.6444],
    [-122.4214, 47.6529],
    [-122.4255, 47.6647],
    [-122.4092, 47.6717],
    [-122.4078, 47.6801],
    [-122.4062, 47.6930],
    [-122.3932, 47.7016],
    [-122.3811, 47.7121],
    [-122.3763, 47.7226],
    [-122.3764, 47.7384],
    [-122.3827, 47.7478],
    [-122.3802, 47.7585],
    [-122.3875, 47.7643],
    [-122.3890, 47.7669],
    [-122.3936, 47.7739],
    [-122.3952, 47.7779],
    [-122.3924, 47.7852],
    [-122.3949, 47.8032],
    [-122.3920, 47.8077],
    [-122.3777, 47.8177],
    [-122.3532, 47.8406],
    [-122.3398, 47.8469],
    [-122.3349, 47.8593],
    [-122.3350, 47.8613],
    [-122.3306, 47.8667],
    [-122.3329, 47.8793],
    [-122.3280, 47.8934],
    [-122.3275, 47.8999],
    [-122.3222, 47.9112],
    [-122.3209, 47.9144],
    [-122.3184, 47.9176],
    [-122.3097, 47.9291],
    [-122.3070, 47.9491],
    [-122.2990, 47.9503],
    [-122.2932, 47.9515],
    [-122.2780, 47.9565],
    [-122.2487, 47.9596],
    [-122.2307, 47.9704],
    [-122.2283, 47.9751],
    [-122.2323, 47.9809],
    [-122.2302, 47.9849],
    [-122.2292, 47.9994],
    [-122.2288, 48.0125],
    [-122.2235, 48.0204],
    [-122.2232, 48.0246],
    [-122.2299, 48.0303],
    [-122.2469, 48.0342],
    [-122.2706, 48.0463],
    [-122.2862, 48.0514],
    [-122.2910, 48.0548],
    [-122.2886, 48.0550],
    [-122.2804, 48.0518],
    [-122.2772, 48.0511],
    [-122.2731, 48.0521],
    [-122.2722, 48.0535],
    [-122.2744, 48.0549],
    [-122.2735, 48.0567],
    [-122.2769, 48.0585],
    [-122.2825, 48.0636],
    [-122.2865, 48.0644],
    [-122.2927, 48.0642],
    [-122.2983, 48.0685],
    [-122.3058, 48.0734],
    [-122.3217, 48.0855],
    [-122.3432, 48.0976],
    [-122.3448, 48.1050],
    [-122.3516, 48.1144],
    [-122.3635, 48.1233],
    [-122.3621, 48.1299],
    [-122.3676, 48.1365],
    [-122.3638, 48.1428],
    [-122.3674, 48.1554],
    [-122.3703, 48.1648],
    [-122.3583, 48.1806],
    [-122.3638, 48.1845],
    [-122.3702, 48.1919],
    [-122.3678, 48.1971],
    [-122.3690, 48.2107],
    [-122.3763, 48.2242],
    [-122.3866, 48.2261],
    [-122.3881, 48.2271],
    [-122.3923, 48.2306],
    [-122.3947, 48.2299],
    [-122.4089, 48.2284],
    [-122.4183, 48.2269],
    [-122.4251, 48.2313],
    [-122.4306, 48.2362],
    [-122.4496, 48.2326],
    [-122.4508, 48.2226],
    [-122.4417, 48.2118],
    [-122.4619, 48.1931],
    [-122.4785, 48.1881],
    [-122.4764, 48.1741],
    [-122.4659, 48.1623],
    [-122.4559, 48.1460],
    [-122.4454, 48.1358],
    [-122.4330, 48.1261],
    [-122.4215, 48.1158],
    [-122.4116, 48.1132],
    [-122.3732, 48.0809],
    [-122.3594, 48.0628],
    [-122.3590, 48.0549],
    [-122.3771, 48.0576],
    [-122.3877, 48.0652],
    [-122.4007, 48.0853],
    [-122.4157, 48.0931],
    [-122.4237, 48.1029],
    [-122.4431, 48.1070],
    [-122.4578, 48.1208],
    [-122.4816, 48.1249],
    [-122.4930, 48.1212],
    [-122.5047, 48.1303],
    [-122.5120, 48.1339],
    [-122.5133, 48.1460],
    [-122.5183, 48.1554],
    [-122.5227, 48.1656],
    [-122.5271, 48.1690],
    [-122.5372, 48.1837],
    [-122.5329, 48.1954],
    [-122.5362, 48.2006],
    [-122.5382, 48.2134],
    [-122.5352, 48.2402],
    [-122.5221, 48.2513],
    [-122.5069, 48.2554],
    [-122.4977, 48.2534],
    [-122.4836, 48.2513],
    [-122.4745, 48.2552],
    [-122.4640, 48.2705],
    [-122.4512, 48.2666],
    [-122.4166, 48.2559],
    [-122.3970, 48.2532],
    [-122.3916, 48.2678],
    [-122.3891, 48.2793],
    [-122.3907, 48.2893],
    [-122.3880, 48.3008],
    [-122.3973, 48.3078],
    [-122.4050, 48.3233],
    [-122.4110, 48.3269],
    [-122.4227, 48.3313],
    [-122.4331, 48.3358],
    [-122.4501, 48.3424],
    [-122.4727, 48.3528],
    [-122.4826, 48.3549],
    [-122.4920, 48.3581],
    [-122.5058, 48.3594],
    [-122.5074, 48.3647],
    [-122.4953, 48.3693],
    [-122.5017, 48.3718],
    [-122.5195, 48.3700],
    [-122.5231, 48.3760],
    [-122.5332, 48.3751],
    [-122.5329, 48.3778],
    [-122.5475, 48.3999],
    [-122.5545, 48.4060],
    [-122.5535, 48.4164],
    [-122.5642, 48.4182],
    [-122.5775, 48.4122],
    [-122.5815, 48.4131],
    [-122.5758, 48.4169],
    [-122.5601, 48.4209],
    [-122.5512, 48.4395],
    [-122.5504, 48.4484],
    [-122.5528, 48.4486],
    [-122.5573, 48.4444],
    [-122.5661, 48.4455],
    [-122.5758, 48.4451],
    [-122.5789, 48.4384],
    [-122.5816, 48.4292],
    [-122.5958, 48.4224],
    [-122.6055, 48.4234],
    [-122.6140, 48.4152],
    [-122.6229, 48.4126],
    [-122.6264, 48.4151],
    [-122.6338, 48.4104],
    [-122.6367, 48.4097],
    [-122.6452, 48.4087],
    [-122.6485, 48.4086],
    [-122.6528, 48.4074],
    [-122.6578, 48.4104],
    [-122.6512, 48.4156],
    [-122.6595, 48.4161],
    [-122.6646, 48.4169],
    [-122.6687, 48.4202],
    [-122.6758, 48.4365],
    [-122.6742, 48.4433],
    [-122.6660, 48.4443],
    [-122.6615, 48.4481],
    [-122.6548, 48.4541],
    [-122.6575, 48.4715],
    [-122.6646, 48.4782],
    [-122.6672, 48.4840],
    [-122.6764, 48.4896],
    [-122.6963, 48.4910],
    [-122.7008, 48.4960],
    [-122.6930, 48.5001],
    [-122.6888, 48.5043],
    [-122.6791, 48.5078],
    [-122.6714, 48.5040],
    [-122.6152, 48.5214],
    [-122.5978, 48.5145],
    [-122.6053, 48.5091],
    [-122.6020, 48.5023],
    [-122.5951, 48.4853],
    [-122.5926, 48.4817],
    [-122.5892, 48.4754],
    [-122.5814, 48.4641],
    [-122.5749, 48.4633],
    [-122.5718, 48.4704],
    [-122.5746, 48.4845],
    [-122.5744, 48.4962],
    [-122.5568, 48.4988],
    [-122.5432, 48.4750],
    [-122.5290, 48.4647],
    [-122.5314, 48.4727],
    [-122.5280, 48.4729],
    [-122.5173, 48.4678],
    [-122.5007, 48.4609],
    [-122.4776, 48.4683],
    [-122.4696, 48.4722],
    [-122.4725, 48.4787],
    [-122.4789, 48.4817],
    [-122.4835, 48.4924],
    [-122.4828, 48.4988],
    [-122.4883, 48.5135],
    [-122.4839, 48.5219],
    [-122.4881, 48.5348],
    [-122.4906, 48.5373],
    [-122.4968, 48.5415],
    [-122.5005, 48.5507],
    [-122.5044, 48.5648],
    [-122.5122, 48.5657],
    [-122.5316, 48.5721],
    [-122.5520, 48.5758],
    [-122.5564, 48.5772],
    [-122.5603, 48.5832],
    [-122.5546, 48.5884],
    [-122.5518, 48.5832],
    [-122.5425, 48.5791],
    [-122.5237, 48.5756],
    [-122.5042, 48.5764],
    [-122.4958, 48.5756],
    [-122.4919, 48.5708],
    [-122.4914, 48.5678],
    [-122.4784, 48.5593],
    [-122.4660, 48.5603],
    [-122.4626, 48.5672],
    [-122.4539, 48.5662],
    [-122.4489, 48.5692],
    [-122.4438, 48.5735],
    [-122.4376, 48.5771],
    [-122.4292, 48.5940],
    [-122.4295, 48.6025],
    [-122.4382, 48.6131],
    [-122.4445, 48.6167],
    [-122.4642, 48.6257],
    [-122.4869, 48.6431],
    [-122.5003, 48.6562],
    [-122.5114, 48.6678],
    [-122.4979, 48.6674],
    [-122.4907, 48.6762],
    [-122.4979, 48.6958],
    [-122.4974, 48.7007],
    [-122.5081, 48.6988],
    [-122.5046, 48.6890],
    [-122.5156, 48.7015],
    [-122.5192, 48.7131],
    [-122.5163, 48.7202],
    [-122.5084, 48.7218],
    [-122.5057, 48.7245],
    [-122.5051, 48.7294],
    [-122.4997, 48.7328],
    [-122.4945, 48.7455],
    [-122.4905, 48.7492],
    [-122.4945, 48.7534],
    [-122.5064, 48.7546],
    [-122.5133, 48.7588],
    [-122.5282, 48.7684],
    [-122.5533, 48.7776],
    [-122.5724, 48.7737],
    [-122.5910, 48.7709],
    [-122.6081, 48.7628],
    [-122.6371, 48.7357],
    [-122.6474, 48.7176],
    [-122.6620, 48.7280],
    [-122.6735, 48.7331],
    [-122.6611, 48.7540],
    [-122.6474, 48.7740],
    [-122.6468, 48.7796],
    [-122.6468, 48.7850],
    [-122.6575, 48.7884],
    [-122.6664, 48.7894],
    [-122.6733, 48.7964],
    [-122.6794, 48.8021],
    [-122.6856, 48.8023],
    [-122.6941, 48.8007],
    [-122.6984, 48.8038],
    [-122.7068, 48.8023],
    [-122.7045, 48.7954],
    [-122.6997, 48.7897],
    [-122.7061, 48.7864],
    [-122.7112, 48.7915],
    [-122.7118, 48.8324],
    [-122.7227, 48.8529],
    [-122.7473, 48.8615],
    [-122.7653, 48.8738],
    [-122.7932, 48.8929],
    [-122.7761, 48.8986],
    [-122.7698, 48.9048],
    [-122.7513, 48.9112],
    [-122.7454, 48.9212],
    [-122.7486, 48.9339],
    [-122.7646, 48.9415],
    [-122.7875, 48.9317],
    [-122.8216, 48.9414],
    [-122.8190, 48.9523],
    [-122.8003, 48.9695],
    [-122.7743, 48.9910],
    [-122.7596, 48.9957],
    [-122.7580, 49.0024],
    [-122.7357, 49.0023],
    [-122.6558, 49.0023],
    [-122.4628, 49.0022],
    [-122.4060, 49.0022],
    [-122.2856, 49.0024],
    [-122.1449, 49.0023],
    [-122.0984, 49.0021],
    [-121.9715, 49.0004],
    [-121.4339, 48.9996],
    [-121.2569, 49.0001],
    [-121.2299, 49.0012],
    [-120.9790, 49.0004],
    [-120.3762, 49.0007],
    [-119.9193, 49.0001],
    [-119.7017, 49.0003],
    [-119.4421, 49.0003],
    [-119.1373, 49.0003],
    [-118.8366, 49.0003],
    [-118.3704, 49.0004],
    [-118.2226, 49.0004],
    [-118.0020, 49.0004],
    [-117.8761, 49.0005],
    [-117.4300, 49.0004],
    [-117.2682, 48.9998],
    [-117.0321, 48.8749],
    [-117.0337, 48.6569],
    [-117.0345, 48.6208],
    [-117.0354, 48.4999],
    [-117.0353, 48.4301],
    [-117.0353, 48.4227],
    [-117.0375, 48.2598],
    [-117.0391, 48.1957],
    [-117.0393, 48.1918],
    [-117.0396, 48.1844],
    [-117.0396, 48.1809],
    [-117.0394, 48.1773],
    [-117.0396, 48.1738],
    [-117.0414, 48.0855],
    [-117.0417, 48.0455],
    [-117.0424, 47.9584],
    [-117.0425, 47.8613],
    [-117.0420, 47.8224],
    [-117.0425, 47.7649],
    [-117.0421, 47.7451],
    [-117.0417, 47.7359],
    [-117.0417, 47.7227],
    [-117.0416, 47.7048],
    [-117.0416, 47.7011],
    [-117.0416, 47.6969],
    [-117.0414, 47.6800],
    [-117.0411, 47.6236],
    [-117.0409, 47.5847],
    [-117.0409, 47.5741],
    [-117.0413, 47.5582],
    [-117.0405, 47.5233],
    [-117.0399, 47.4778],
    [-117.0399, 47.4349],
    [-117.0399, 47.3991],
    [-117.0398, 47.3472],
    [-117.0400, 47.2593],
    [-117.0399, 47.2033],
    [-117.0398, 47.1340],
    [-117.0398, 47.0910],
    [-117.0397, 46.9673],
    [-117.0397, 46.8734],
    [-117.0397, 46.8258],
    [-117.0398, 46.8154],
    [-117.0395, 46.7324],
    [-117.0394, 46.7023],
    [-117.0395, 46.6381],
    [-117.0397, 46.5417],
    [-117.0397, 46.4627],
    [-117.0398, 46.4347],
    [-117.0397, 46.4253],
    [-117.0357, 46.4205],
    [-117.0355, 46.4100],
    [-117.0377, 46.4066],
    [-117.0415, 46.3960],
    [-117.0419, 46.3922],
    [-117.0469, 46.3796],
    [-117.0518, 46.3756],
    [-117.0608, 46.3680],
    [-117.0627, 46.3536],
    [-117.0600, 46.3485],
    [-117.0537, 46.3446],
    [-117.0344, 46.3413],
    [-117.0238, 46.3360],
    [-117.0227, 46.3290],
    [-117.0223, 46.3175],
    [-117.0075, 46.3053],
    [-116.9867, 46.2967],
    [-116.9909, 46.2804],
    [-116.9874, 46.2729],
    [-116.9703, 46.2612],
    [-116.9588, 46.2423],
    [-116.9594, 46.2198],
    [-116.9658, 46.2034],
    [-116.9524, 46.1935],
    [-116.9397, 46.1795],
    [-116.9240, 46.1709],
    [-116.9226, 46.1607],
    [-116.9355, 46.1424],
    [-116.9406, 46.1324],
    [-116.9503, 46.1235],
    [-116.9553, 46.1022],
    [-116.9770, 46.0967],
    [-116.9825, 46.0913],
    [-116.9789, 46.0800],
    [-116.9604, 46.0763],
    [-116.9427, 46.0610],
    [-116.9359, 46.0436],
    [-116.9304, 46.0324],
    [-116.9230, 46.0183],
    [-116.9172, 45.9966],
    [-116.9859, 45.9970],
    [-117.0902, 45.9976],
    [-117.2167, 45.9984],
    [-117.3539, 45.9963],
    [-117.4399, 45.9986],
    [-117.4799, 45.9979],
    [-117.6032, 45.9989],
    [-117.7179, 45.9999],
    [-117.9969, 46.0008],
    [-118.1460, 46.0007],
    [-118.2367, 46.0004],
    [-118.2835, 46.0008],
    [-118.3672, 46.0006],
    [-118.3873, 46.0006],
    [-118.4038, 46.0006],
    [-118.4970, 46.0006],
    [-118.5694, 46.0008],
    [-118.5905, 46.0008],
    [-118.6393, 46.0010],
    [-118.7252, 46.0009],
    [-118.8681, 46.0007],
    [-118.9871, 45.9999],
    [-119.0271, 45.9691],
    [-119.1261, 45.9329],
    [-119.1955, 45.9279],
    [-119.2571, 45.9399],
    [-119.3225, 45.9332],
    [-119.3644, 45.9216],
    [-119.4562, 45.9156],
    [-119.5369, 45.9130],
    [-119.6234, 45.9056],
    [-119.7299, 45.8503],
    [-119.8681, 45.8360],
    [-119.9075, 45.8281],
    [-119.9995, 45.8125],
    [-120.0701, 45.7852],
    [-120.1911, 45.7435],
    [-120.2822, 45.7212],
    [-120.4040, 45.6992],
    [-120.5059, 45.7000],
    [-120.5595, 45.7383],
    [-120.6535, 45.7372],
    [-120.7242, 45.7064],
    [-120.8557, 45.6715],
    [-120.8956, 45.6429],
    [-120.9159, 45.6413],
    [-120.9780, 45.6493],
    [-121.0336, 45.6510],
    [-121.0849, 45.6479],
    [-121.1222, 45.6161],
    [-121.1292, 45.6115],
    [-121.1406, 45.6112],
    [-121.1705, 45.6062],
    [-121.1961, 45.6206],
    [-121.2004, 45.6498],
    [-121.2512, 45.6784],
    [-121.3122, 45.6999],
    [-121.3655, 45.7035],
    [-121.4017, 45.6929],
    [-121.4628, 45.7014],
    [-121.4837, 45.7125],
    [-121.4992, 45.7208],
    [-121.5237, 45.7249],
    [-121.5338, 45.7264],
    [-121.6312, 45.7047],
    [-121.6760, 45.7031],
    [-121.7351, 45.6940],
    [-121.8582, 45.6954],
    [-121.8772, 45.6868],
    [-121.9009, 45.6620],
    [-121.9220, 45.6492],
    [-121.9557, 45.6436],
    [-121.9798, 45.6248],
    [-122.0226, 45.6152],
    [-122.1017, 45.5835],
    [-122.1262, 45.5826],
    [-122.1407, 45.5845],
    [-122.1975, 45.5673],
    [-122.2490, 45.5477],
    [-122.2667, 45.5438],
    [-122.3315, 45.5482],
    [-122.3528, 45.5694],
    [-122.3834, 45.5756],
    [-122.4012, 45.5711],
    [-122.4347, 45.5642],
    [-122.4539, 45.5673],
    [-122.4747, 45.5783],
    [-122.4923, 45.5833],
    [-122.5237, 45.5896],
    [-122.5494, 45.5970],
    [-122.5814, 45.6039],
    [-122.5889, 45.6053],
    [-122.6350, 45.6093],
    [-122.6753, 45.6182],
    [-122.6912, 45.6248],
    [-122.7381, 45.6441],
    [-122.7638, 45.6571],
    [-122.7725, 45.6996],
    [-122.7610, 45.7504],
    [-122.7706, 45.7818],
    [-122.7956, 45.8100],
    [-122.7857, 45.8442],
    [-122.7851, 45.8644],
    [-122.7968, 45.8827],
    [-122.8084, 45.9060],
    [-122.8112, 45.9139],
    [-122.8122, 45.9545],
    [-122.8376, 45.9808],
    [-122.8586, 46.0163],
    [-122.8813, 46.0460],
    [-122.8845, 46.0603],
    [-122.9041, 46.0837],
    [-122.9397, 46.0965],
    [-123.0042, 46.1338],
    [-123.0229, 46.1394],
    [-123.0511, 46.1536],
    [-123.1159, 46.1853],
    [-123.2131, 46.1725],
    [-123.2420, 46.1610],
    [-123.3010, 46.1446],
    [-123.3407, 46.1462],
    [-123.3637, 46.1463],
    [-123.3904, 46.1544],
    [-123.4281, 46.2233],
    [-123.4476, 46.2498],
    [-123.4748, 46.2678],
    [-123.5162, 46.2662],
    [-123.5477, 46.2591],
    [-123.5556, 46.2653],
    [-123.5605, 46.2648],
    [-123.5692, 46.2616],
    [-123.5891, 46.2606],
    [-123.6249, 46.2615],
    [-123.6514, 46.2654],
    [-123.6695, 46.2668],
    [-123.6801, 46.2779],
    [-123.6788, 46.2907],
    [-123.7007, 46.3046],
    [-123.7241, 46.2956],
    [-123.7286, 46.2887],
    [-123.7502, 46.2920],
    [-123.7596, 46.2751],
    [-123.7827, 46.2802],
    [-123.8117, 46.2804],
    [-123.8165, 46.2711],
    [-123.8188, 46.2697],
    [-123.8338, 46.2685],
    [-123.8497, 46.2601],
    [-123.8508, 46.2567],
    [-123.8628, 46.2492],
    [-123.8745, 46.2402],
    [-123.9196, 46.2512],
    [-123.9301, 46.2601],
    [-123.9491, 46.2716],
    [-123.9576, 46.2814],
    [-123.9694, 46.2914],
    [-123.9745, 46.3031],
    [-124.0013, 46.3133],
    [-124.0217, 46.3148],
    [-124.0306, 46.3072],
    [-124.0355, 46.3022],
    [-124.0493, 46.2958],
    [-124.0416, 46.2858],
    [-124.0523, 46.2755],
    [-124.0752, 46.2715],
    [-124.0763, 46.2965],
    [-124.0690, 46.3130],
    [-124.0643, 46.3304],
    [-124.0603, 46.3678],
    [-124.0580, 46.3953],
    [-124.0571, 46.4730],
    [-124.0575, 46.4998],
    [-124.0684, 46.6014],
    [-124.0691, 46.6473],
    [-124.0594, 46.6555],
    [-124.0528, 46.6489],
    [-124.0376, 46.6353],
    [-124.0378, 46.6280],
    [-124.0500, 46.6233],
    [-124.0409, 46.6062],
    [-124.0288, 46.5910],
    [-124.0260, 46.5316],
    [-124.0275, 46.5098],
    [-124.0317, 46.4964],
    [-124.0260, 46.4630],
    [-124.0162, 46.3944],
    [-124.0072, 46.3715],
    [-123.9765, 46.3797],
    [-123.9537, 46.3788],
    [-123.9520, 46.4026],
    [-123.9653, 46.4087],
    [-123.9701, 46.4244],
    [-123.9884, 46.4450],
    [-123.9909, 46.4657],
    [-123.9884, 46.4970],
    [-123.9792, 46.4899],
    [-123.9718, 46.4799],
    [-123.9568, 46.4691],
    [-123.9394, 46.4672],
    [-123.9426, 46.4878],
    [-123.9270, 46.4968],
    [-123.9243, 46.5112],
    [-123.9134, 46.5144],
    [-123.9074, 46.5077],
    [-123.8955, 46.5141],
    [-123.8972, 46.5285],
    [-123.8943, 46.5370],
    [-123.8946, 46.5473],
    [-123.9081, 46.5533],
    [-123.9226, 46.5702],
    [-123.9391, 46.5963],
    [-123.9592, 46.6136],
    [-123.9589, 46.6279],
    [-123.9569, 46.6372],
    [-123.9442, 46.6270],
    [-123.9406, 46.6409],
    [-123.9209, 46.6536],
    [-123.9156, 46.6786],
    [-123.8649, 46.6987],
    [-123.8366, 46.7020],
    [-123.8292, 46.7090],
    [-123.8403, 46.7182],
    [-123.8549, 46.7254],
    [-123.8767, 46.7307],
    [-123.8853, 46.7486],
    [-123.8931, 46.7502],
    [-123.9164, 46.7413],
    [-123.9151, 46.7332],
    [-123.9135, 46.7267],
    [-123.9214, 46.7262],
    [-123.9686, 46.7361],
    [-123.9786, 46.7223],
    [-123.9669, 46.7052],
    [-123.9942, 46.7079],
    [-124.0058, 46.7103],
    [-124.0138, 46.7176],
    [-124.0291, 46.7177],
    [-124.0435, 46.7241],
    [-124.0631, 46.7337],
    [-124.0965, 46.7462],
    [-124.0983, 46.7941],
    [-124.1085, 46.8373],
    [-124.1216, 46.8700],
    [-124.1328, 46.8964],
    [-124.1293, 46.9051],
    [-124.1158, 46.9132],
    [-124.0930, 46.9017],
    [-124.0904, 46.8955],
    [-124.0951, 46.8827],
    [-124.0893, 46.8677],
    [-124.0682, 46.8630],
    [-124.0611, 46.8651],
    [-124.0463, 46.8940],
    [-124.0095, 46.9103],
    [-123.9959, 46.9144],
    [-123.9794, 46.9230],
    [-123.9575, 46.9213],
    [-123.8829, 46.9399],
    [-123.8702, 46.9432],
    [-123.8513, 46.9517],
    [-123.8415, 46.9571],
    [-123.8591, 46.9676],
    [-123.8790, 46.9696],
    [-123.9019, 46.9719],
    [-123.9392, 46.9697],
    [-123.9545, 46.9765],
    [-123.9916, 46.9802],
    [-124.0137, 46.9876],
    [-124.0190, 46.9896],
    [-124.0147, 46.9947],
    [-124.0056, 47.0022],
    [-124.0106, 47.0078],
    [-124.0171, 47.0086],
    [-124.0170, 47.0117],
    [-124.0319, 47.0306],
    [-124.0472, 47.0361],
    [-124.0545, 47.0410],
    [-124.0641, 47.0429],
    [-124.1064, 47.0426],
    [-124.1490, 47.0293],
    [-124.1479, 47.0130],
    [-124.1392, 47.0029],
    [-124.1383, 46.9741],
    [-124.1309, 46.9649],
    [-124.1274, 46.9455],
    [-124.1097, 46.9472],
    [-124.1062, 46.9355],
    [-124.1112, 46.9344],
    [-124.1255, 46.9415],
    [-124.1394, 46.9418],
    [-124.1521, 46.9328],
    [-124.1586, 46.9294],
    [-124.1745, 46.9416],
    [-124.1691, 46.9945],
    [-124.1721, 47.0438],
    [-124.1767, 47.0930],
    [-124.1838, 47.1248],
    [-124.1840, 47.1353],
    [-124.1924, 47.1584],
    [-124.2057, 47.2071],
    [-124.2104, 47.2217],
    [-124.2206, 47.2474],
    [-124.2363, 47.2873],
    [-124.2522, 47.3008],
    [-124.2744, 47.3019],
    [-124.2781, 47.3064],
    [-124.2992, 47.3473],
    [-124.3075, 47.3523],
    [-124.3196, 47.3596],
    [-124.3267, 47.3888],
    [-124.3378, 47.4119],
    [-124.3395, 47.4377],
    [-124.3411, 47.4589],
    [-124.3444, 47.4617],
    [-124.3460, 47.4634],
    [-124.3421, 47.4667],
    [-124.3456, 47.4910],
    [-124.3528, 47.5252],
    [-124.3581, 47.5465],
    [-124.3597, 47.5536],
    [-124.3717, 47.5996],
    [-124.3960, 47.6655],
    [-124.4202, 47.7253],
    [-124.4305, 47.7462],
    [-124.4474, 47.7555],
    [-124.4539, 47.7653],
    [-124.4622, 47.7647],
    [-124.4717, 47.7669],
    [-124.4800, 47.7690],
    [-124.4719, 47.7721],
    [-124.4814, 47.7887],
    [-124.4897, 47.8170],
    [-124.5128, 47.8225],
    [-124.5329, 47.8334],
    [-124.5396, 47.8419],
    [-124.5508, 47.8495],
    [-124.5583, 47.8560],
    [-124.5661, 47.8676],
    [-124.5755, 47.8690],
    [-124.5966, 47.8786],
    [-124.6048, 47.8728],
    [-124.6095, 47.8800],
    [-124.6255, 47.8880],
    [-124.6297, 47.8968],
    [-124.6410, 47.9077],
    [-124.6415, 47.9113],
    [-124.6392, 47.9181],
    [-124.6401, 47.9223],
    [-124.6520, 47.9432],
    [-124.6616, 47.9466],
    [-124.6619, 47.9544],
    [-124.6638, 47.9634],
    [-124.6718, 47.9645],
    [-124.6717, 47.9675],
    [-124.6714, 47.9765],
    [-124.6780, 47.9923],
    [-124.6774, 48.0093],
    [-124.6810, 48.0187],
    [-124.6825, 48.0279],
    [-124.6833, 48.0405],
    [-124.6868, 48.0519],
    [-124.6937, 48.0587],
    [-124.6939, 48.0669],
    [-124.6953, 48.0847],
    [-124.6886, 48.0925],
    [-124.6871, 48.0987],
    [-124.6928, 48.1047],
    [-124.6951, 48.1149],
    [-124.7049, 48.1233],
    [-124.7073, 48.1316],
    [-124.7168, 48.1426],
    [-124.7217, 48.1532],
    [-124.7317, 48.1604],
    [-124.7328, 48.1653]
    ]
  },
  "New Mexico": {
    coordinates: [
      [-109.0502, 31.4800],
    [-109.0495, 31.5525],
    [-109.0488, 31.8108],
    [-109.0491, 31.8437],
    [-109.0486, 31.8708],
    [-109.0486, 32.0137],
    [-109.0483, 32.0841],
    [-109.0476, 32.6470],
    [-109.0476, 32.6900],
    [-109.0471, 32.7778],
    [-109.0475, 33.0684],
    [-109.0470, 33.0929],
    [-109.0471, 33.1380],
    [-109.0474, 33.2404],
    [-109.0469, 33.3656],
    [-109.0466, 33.3751],
    [-109.0471, 33.7400],
    [-109.0466, 33.9080],
    [-109.0469, 34.0785],
    [-109.0467, 34.1669],
    [-109.0462, 34.5224],
    [-109.0461, 34.6965],
    [-109.0461, 34.8000],
    [-109.0460, 34.8579],
    [-109.0459, 34.9597],
    [-109.0460, 35.1755],
    [-109.0461, 35.2144],
    [-109.0461, 35.2488],
    [-109.0463, 35.2774],
    [-109.0465, 35.3171],
    [-109.0466, 35.3363],
    [-109.0468, 35.3626],
    [-109.0468, 35.3636],
    [-109.0467, 35.4068],
    [-109.0467, 35.4375],
    [-109.0466, 35.4795],
    [-109.0465, 35.5364],
    [-109.0465, 35.5527],
    [-109.0464, 35.5677],
    [-109.0463, 35.6100],
    [-109.0463, 35.6395],
    [-109.0462, 35.6622],
    [-109.0462, 35.7093],
    [-109.0462, 35.7566],
    [-109.0461, 35.8215],
    [-109.0460, 35.8798],
    [-109.0461, 35.8930],
    [-109.0461, 35.9259],
    [-109.0460, 35.9732],
    [-109.0457, 36.1170],
    [-109.0459, 36.1416],
    [-109.0460, 36.2571],
    [-109.0460, 36.2801],
    [-109.0459, 36.3111],
    [-109.0458, 36.3633],
    [-109.0455, 36.4656],
    [-109.0454, 36.5000],
    [-109.0454, 36.7738],
    [-109.0454, 36.8569],
    [-109.0454, 36.8710],
    [-109.0454, 36.8752],
    [-109.0453, 36.9689],
    [-109.0051, 36.9990],
    [-108.9544, 36.9989],
    [-108.6197, 36.9992],
    [-108.3207, 36.9995],
    [-108.2881, 36.9996],
    [-108.2494, 36.9990],
    [-108.0378, 36.9999],
    [-107.8691, 37.0000],
    [-107.7806, 37.0000],
    [-107.6011, 37.0000],
    [-107.4817, 37.0000],
    [-107.4209, 37.0000],
    [-107.2550, 37.0000],
    [-106.9560, 37.0001],
    [-106.7819, 36.9925],
    [-106.6756, 36.9931],
    [-106.6287, 36.9932],
    [-106.5006, 36.9938],
    [-106.4755, 36.9938],
    [-106.2933, 36.9939],
    [-106.2015, 36.9941],
    [-106.0063, 36.9953],
    [-105.7185, 36.9958],
    [-105.6647, 36.9959],
    [-105.5339, 36.9959],
    [-105.5088, 36.9959],
    [-105.4425, 36.9960],
    [-105.2513, 36.9956],
    [-105.1550, 36.9953],
    [-105.0292, 36.9927],
    [-104.7321, 36.9935],
    [-104.6450, 36.9934],
    [-104.6246, 36.9944],
    [-104.4804, 36.9937],
    [-104.4340, 36.9937],
    [-104.2505, 36.9946],
    [-104.0079, 36.9962],
    [-103.4718, 36.9990],
    [-103.1559, 37.0002],
    [-103.0022, 36.9116],
    [-103.0022, 36.7194],
    [-103.0022, 36.6027],
    [-103.0419, 36.5004],
    [-103.0417, 36.3175],
    [-103.0413, 35.8377],
    [-103.0419, 35.7964],
    [-103.0415, 35.6511],
    [-103.0421, 35.3947],
    [-103.0425, 35.2119],
    [-103.0423, 35.1819],
    [-103.0427, 35.1447],
    [-103.0433, 35.1251],
    [-103.0426, 35.0595],
    [-103.0428, 34.8502],
    [-103.0428, 34.7474],
    [-103.0433, 34.6518],
    [-103.0431, 34.6198],
    [-103.0436, 34.4598],
    [-103.0436, 34.4483],
    [-103.0436, 34.4007],
    [-103.0436, 34.3937],
    [-103.0436, 34.3904],
    [-103.0436, 34.3847],
    [-103.0439, 34.3809],
    [-103.0439, 34.3766],
    [-103.0440, 34.3128],
    [-103.0439, 34.3026],
    [-103.0436, 34.2144],
    [-103.0436, 34.0879],
    [-103.0437, 34.0631],
    [-103.0437, 34.0423],
    [-103.0436, 34.0327],
    [-103.0436, 34.0036],
    [-103.0457, 33.9063],
    [-103.0473, 33.8247],
    [-103.0496, 33.7378],
    [-103.0505, 33.6724],
    [-103.0514, 33.6420],
    [-103.0526, 33.5706],
    [-103.0575, 33.3295],
    [-103.0597, 33.2563],
    [-103.0618, 33.1409],
    [-103.0639, 33.0421],
    [-103.0645, 33.0103],
    [-103.0647, 32.9591],
    [-103.0647, 32.8794],
    [-103.0649, 32.8573],
    [-103.0647, 32.8275],
    [-103.0647, 32.7836],
    [-103.0648, 32.7270],
    [-103.0648, 32.7138],
    [-103.0649, 32.6826],
    [-103.0648, 32.6019],
    [-103.0647, 32.5622],
    [-103.0646, 32.3347],
    [-103.0643, 32.1230],
    [-103.0859, 32.0005],
    [-103.2156, 32.0005],
    [-103.2704, 32.0003],
    [-103.7229, 32.0002],
    [-103.9802, 32.0001],
    [-104.5318, 32.0001],
    [-104.6435, 32.0004],
    [-104.9184, 32.0005],
    [-105.1180, 32.0005],
    [-105.1482, 32.0005],
    [-105.3398, 32.0006],
    [-105.4286, 32.0006],
    [-105.7314, 32.0016],
    [-105.8862, 32.0020],
    [-106.0505, 32.0024],
    [-106.1818, 32.0020],
    [-106.2059, 32.0018],
    [-106.3234, 32.0015],
    [-106.3274, 32.0014],
    [-106.3943, 32.0015],
    [-106.4111, 32.0013],
    [-106.4767, 32.0011],
    [-106.5622, 32.0007],
    [-106.5704, 32.0008],
    [-106.5827, 32.0008],
    [-106.5953, 32.0008],
    [-106.5991, 32.0007],
    [-106.6185, 32.0005],
    [-106.6269, 31.9905],
    [-106.6312, 31.9898],
    [-106.6382, 31.9768],
    [-106.6232, 31.9729],
    [-106.6187, 31.9670],
    [-106.6243, 31.9611],
    [-106.6251, 31.9545],
    [-106.6147, 31.9560],
    [-106.6224, 31.9409],
    [-106.6241, 31.9322],
    [-106.6297, 31.9266],
    [-106.6164, 31.9220],
    [-106.6148, 31.9178],
    [-106.6259, 31.9122],
    [-106.6455, 31.8987],
    [-106.6429, 31.8929],
    [-106.6307, 31.8864],
    [-106.6292, 31.8837],
    [-106.6314, 31.8789],
    [-106.6359, 31.8662],
    [-106.6278, 31.8606],
    [-106.6146, 31.8465],
    [-106.6057, 31.8462],
    [-106.6019, 31.8396],
    [-106.6052, 31.8278],
    [-106.5938, 31.8249],
    [-106.5821, 31.8155],
    [-106.5709, 31.8102],
    [-106.5634, 31.8126],
    [-106.5508, 31.8083],
    [-106.5453, 31.8050],
    [-106.5421, 31.8021],
    [-106.5353, 31.7975],
    [-106.5330, 31.7919],
    [-106.5305, 31.7921],
    [-106.5276, 31.7891],
    [-106.5280, 31.7840],
    [-106.5693, 31.7839],
    [-106.7505, 31.7839],
    [-107.0006, 31.7837],
    [-107.2968, 31.7838],
    [-107.6206, 31.7836],
    [-107.8659, 31.7836],
    [-108.2085, 31.4998],
    [-108.7077, 31.3332],
    [-108.8610, 31.3323],
    [-109.0502, 31.4800]
    ]
  },
  "South Dakota": {
    coordinates: [
      [-104.0579, 44.9976],
    [-104.0398, 45.0112],
    [-104.0396, 45.1240],
    [-104.0404, 45.3359],
    [-104.0404, 45.3935],
    [-104.0418, 45.4908],
    [-104.0417, 45.5391],
    [-104.0416, 45.5507],
    [-104.0438, 45.8684],
    [-104.0454, 45.9453],
    [-103.6608, 45.9452],
    [-103.5771, 45.9453],
    [-103.4349, 45.9453],
    [-103.4113, 45.9453],
    [-103.3690, 45.9452],
    [-103.2527, 45.9452],
    [-103.2106, 45.9452],
    [-103.1252, 45.9453],
    [-103.0478, 45.9453],
    [-102.9953, 45.9452],
    [-102.9421, 45.9451],
    [-102.8706, 45.9451],
    [-102.7049, 45.9451],
    [-102.6725, 45.9452],
    [-102.6516, 45.9455],
    [-102.5694, 45.9452],
    [-102.4974, 45.9451],
    [-102.4596, 45.9451],
    [-102.4254, 45.9450],
    [-102.4103, 45.9451],
    [-102.3964, 45.9449],
    [-102.3731, 45.9449],
    [-102.3282, 45.9448],
    [-102.2179, 45.9447],
    [-102.1769, 45.9446],
    [-102.1594, 45.9446],
    [-102.1455, 45.9447],
    [-102.1254, 45.9447],
    [-102.1142, 45.9448],
    [-102.0609, 45.9446],
    [-102.0004, 45.9446],
    [-101.9922, 45.9445],
    [-101.9895, 45.9445],
    [-101.8868, 45.9446],
    [-101.8330, 45.9445],
    [-101.7901, 45.9444],
    [-101.7643, 45.9444],
    [-101.7234, 45.9442],
    [-101.7003, 45.9444],
    [-101.6576, 45.9444],
    [-101.5622, 45.9442],
    [-101.4199, 45.9438],
    [-101.3653, 45.9441],
    [-101.3133, 45.9442],
    [-101.2240, 45.9440],
    [-101.1791, 45.9439],
    [-101.1632, 45.9439],
    [-101.1068, 45.9440],
    [-100.9807, 45.9441],
    [-100.9644, 45.9438],
    [-100.9356, 45.9438],
    [-100.8111, 45.9438],
    [-100.7621, 45.9438],
    [-100.7209, 45.9440],
    [-100.6280, 45.9436],
    [-100.5118, 45.9437],
    [-100.4628, 45.9436],
    [-100.4202, 45.9435],
    [-100.2853, 45.9431],
    [-100.2748, 45.9429],
    [-100.1417, 45.9425],
    [-100.0879, 45.9423],
    [-100.0690, 45.9422],
    [-99.9840, 45.9419],
    [-99.8801, 45.9417],
    [-99.7495, 45.9410],
    [-99.7389, 45.9409],
    [-99.6719, 45.9411],
    [-99.5888, 45.9411],
    [-99.4487, 45.9404],
    [-99.3856, 45.9404],
    [-99.3448, 45.9403],
    [-99.2840, 45.9402],
    [-99.2223, 45.9401],
    [-99.2126, 45.9401],
    [-99.0929, 45.9402],
    [-98.9735, 45.9398],
    [-98.8803, 45.9394],
    [-98.7770, 45.9389],
    [-98.6318, 45.9383],
    [-98.5070, 45.9373],
    [-98.3823, 45.9365],
    [-98.2575, 45.9363],
    [-98.1743, 45.9362],
    [-98.0082, 45.9361],
    [-97.9788, 45.9359],
    [-97.8548, 45.9355],
    [-97.7587, 45.9354],
    [-97.6341, 45.9353],
    [-97.5326, 45.9353],
    [-97.5095, 45.9352],
    [-97.4804, 45.9351],
    [-97.4797, 45.9351],
    [-97.3189, 45.9351],
    [-97.2283, 45.9351],
    [-97.1450, 45.9353],
    [-97.1031, 45.9360],
    [-97.0194, 45.9354],
    [-96.9776, 45.9357],
    [-96.8523, 45.9355],
    [-96.8052, 45.9354],
    [-96.7915, 45.9359],
    [-96.7222, 45.9358],
    [-96.6599, 45.9356],
    [-96.6183, 45.9354],
    [-96.5873, 45.9352],
    [-96.5645, 45.9263],
    [-96.5654, 45.9189],
    [-96.5698, 45.9137],
    [-96.5693, 45.9114],
    [-96.5655, 45.9109],
    [-96.5664, 45.9067],
    [-96.5683, 45.9029],
    [-96.5683, 45.8912],
    [-96.5727, 45.8765],
    [-96.5744, 45.8650],
    [-96.5745, 45.8431],
    [-96.5775, 45.8331],
    [-96.5842, 45.8190],
    [-96.5967, 45.8118],
    [-96.6125, 45.7944],
    [-96.6278, 45.7862],
    [-96.6366, 45.7737],
    [-96.6397, 45.7654],
    [-96.6522, 45.7468],
    [-96.6720, 45.7327],
    [-96.6990, 45.7218],
    [-96.7503, 45.6988],
    [-96.7899, 45.6734],
    [-96.8267, 45.6537],
    [-96.8358, 45.6496],
    [-96.8484, 45.6282],
    [-96.8524, 45.6148],
    [-96.8569, 45.6052],
    [-96.8468, 45.5966],
    [-96.8412, 45.5914],
    [-96.7991, 45.5542],
    [-96.7810, 45.5360],
    [-96.7606, 45.5149],
    [-96.7455, 45.4887],
    [-96.7425, 45.4787],
    [-96.7327, 45.4587],
    [-96.7108, 45.4369],
    [-96.6925, 45.4173],
    [-96.6805, 45.4105],
    [-96.6703, 45.4105],
    [-96.6406, 45.4092],
    [-96.6163, 45.4077],
    [-96.5848, 45.3957],
    [-96.5714, 45.3899],
    [-96.5460, 45.3810],
    [-96.5218, 45.3756],
    [-96.4925, 45.3593],
    [-96.4793, 45.3396],
    [-96.4692, 45.3249],
    [-96.4666, 45.3172],
    [-96.4569, 45.3037],
    [-96.4531, 45.2981],
    [-96.4528, 45.2843],
    [-96.4529, 45.2691],
    [-96.4523, 45.2090],
    [-96.4523, 45.1786],
    [-96.4524, 45.1241],
    [-96.4522, 45.0938],
    [-96.4522, 45.0661],
    [-96.4522, 45.0502],
    [-96.4521, 44.9775],
    [-96.4520, 44.9107],
    [-96.4520, 44.8901],
    [-96.4516, 44.8056],
    [-96.4518, 44.7977],
    [-96.4517, 44.7832],
    [-96.4516, 44.7605],
    [-96.4512, 44.7180],
    [-96.4518, 44.6313],
    [-96.4517, 44.6307],
    [-96.4520, 44.5436],
    [-96.4520, 44.5169],
    [-96.4522, 44.4709],
    [-96.4519, 44.4415],
    [-96.4521, 44.3837],
    [-96.4522, 44.3601],
    [-96.4522, 44.3423],
    [-96.4523, 44.3281],
    [-96.4523, 44.3123],
    [-96.4523, 44.2970],
    [-96.4526, 44.2827],
    [-96.4524, 44.2690],
    [-96.4528, 44.1969],
    [-96.4530, 44.1112],
    [-96.4534, 44.0254],
    [-96.4533, 44.0219],
    [-96.4531, 44.0070],
    [-96.4533, 43.9929],
    [-96.4534, 43.9781],
    [-96.4532, 43.9636],
    [-96.4533, 43.9367],
    [-96.4533, 43.9135],
    [-96.4533, 43.8786],
    [-96.4533, 43.8495],
    [-96.4533, 43.7914],
    [-96.4534, 43.6824],
    [-96.4534, 43.6750],
    [-96.4534, 43.6075],
    [-96.4534, 43.5877],
    [-96.4533, 43.5798],
    [-96.5317, 43.5005],
    [-96.5989, 43.5004],
    [-96.5984, 43.4951],
    [-96.5905, 43.4943],
    [-96.5850, 43.4899],
    [-96.5862, 43.4858],
    [-96.5833, 43.4832],
    [-96.5865, 43.4785],
    [-96.5837, 43.4743],
    [-96.5825, 43.4671],
    [-96.5942, 43.4608],
    [-96.6029, 43.4509],
    [-96.5943, 43.4342],
    [-96.5896, 43.4322],
    [-96.5752, 43.4318],
    [-96.5708, 43.4238],
    [-96.5627, 43.4128],
    [-96.5371, 43.3951],
    [-96.5301, 43.3976],
    [-96.5240, 43.3948],
    [-96.5213, 43.3746],
    [-96.5273, 43.3681],
    [-96.5255, 43.3483],
    [-96.5246, 43.3469],
    [-96.5349, 43.3365],
    [-96.5256, 43.3125],
    [-96.5304, 43.3000],
    [-96.5531, 43.2929],
    [-96.5643, 43.2948],
    [-96.5716, 43.2982],
    [-96.5829, 43.2981],
    [-96.5889, 43.2937],
    [-96.5841, 43.2930],
    [-96.5807, 43.2890],
    [-96.5786, 43.2776],
    [-96.5829, 43.2765],
    [-96.5852, 43.2689],
    [-96.5686, 43.2627],
    [-96.5570, 43.2591],
    [-96.5526, 43.2578],
    [-96.5530, 43.2473],
    [-96.5712, 43.2390],
    [-96.5604, 43.2242],
    [-96.5563, 43.2261],
    [-96.5449, 43.2259],
    [-96.5269, 43.2241],
    [-96.5193, 43.2177],
    [-96.4965, 43.2237],
    [-96.4850, 43.2241],
    [-96.4749, 43.2174],
    [-96.4708, 43.2051],
    [-96.4724, 43.1856],
    [-96.4671, 43.1845],
    [-96.4664, 43.1708],
    [-96.4673, 43.1624],
    [-96.4651, 43.1475],
    [-96.4555, 43.1442],
    [-96.4427, 43.1288],
    [-96.4396, 43.1220],
    [-96.4481, 43.1045],
    [-96.4629, 43.0914],
    [-96.4545, 43.0868],
    [-96.4542, 43.0834],
    [-96.4608, 43.0640],
    [-96.4700, 43.0621],
    [-96.4867, 43.0555],
    [-96.4893, 43.0513],
    [-96.5052, 43.0487],
    [-96.5184, 43.0421],
    [-96.5139, 43.0398],
    [-96.5091, 43.0367],
    [-96.5131, 43.0284],
    [-96.5032, 43.0198],
    [-96.4944, 43.0146],
    [-96.4927, 43.0051],
    [-96.4978, 42.9981],
    [-96.5002, 42.9976],
    [-96.5073, 42.9965],
    [-96.5122, 42.9888],
    [-96.5167, 42.9815],
    [-96.5159, 42.9729],
    [-96.5050, 42.9708],
    [-96.5049, 42.9547],
    [-96.5107, 42.9444],
    [-96.5201, 42.9382],
    [-96.5169, 42.9325],
    [-96.5206, 42.9328],
    [-96.5255, 42.9355],
    [-96.5416, 42.9207],
    [-96.5374, 42.9090],
    [-96.5386, 42.9046],
    [-96.5428, 42.9037],
    [-96.5360, 42.9009],
    [-96.5264, 42.8919],
    [-96.5401, 42.8897],
    [-96.5379, 42.8785],
    [-96.5473, 42.8737],
    [-96.5504, 42.8632],
    [-96.5438, 42.8583],
    [-96.5417, 42.8589],
    [-96.5455, 42.8500],
    [-96.5547, 42.8461],
    [-96.5500, 42.8407],
    [-96.5513, 42.8366],
    [-96.5562, 42.8367],
    [-96.5619, 42.8376],
    [-96.5656, 42.8304],
    [-96.5798, 42.8381],
    [-96.5778, 42.8287],
    [-96.5845, 42.8190],
    [-96.5950, 42.8158],
    [-96.5922, 42.8099],
    [-96.5925, 42.8011],
    [-96.6038, 42.7837],
    [-96.6195, 42.7840],
    [-96.6266, 42.7734],
    [-96.6332, 42.7683],
    [-96.6287, 42.7575],
    [-96.6212, 42.7581],
    [-96.6205, 42.7535],
    [-96.6323, 42.7456],
    [-96.6397, 42.7370],
    [-96.6319, 42.7251],
    [-96.6244, 42.7143],
    [-96.6306, 42.7059],
    [-96.6153, 42.6986],
    [-96.6134, 42.6987],
    [-96.6122, 42.6982],
    [-96.6121, 42.6966],
    [-96.6061, 42.6947],
    [-96.6008, 42.6977],
    [-96.5955, 42.6912],
    [-96.5856, 42.6871],
    [-96.5743, 42.6770],
    [-96.5786, 42.6721],
    [-96.5707, 42.6717],
    [-96.5681, 42.6762],
    [-96.5562, 42.6644],
    [-96.5599, 42.6628],
    [-96.5562, 42.6579],
    [-96.5424, 42.6607],
    [-96.5383, 42.6491],
    [-96.5379, 42.6464],
    [-96.5163, 42.6304],
    [-96.5159, 42.6250],
    [-96.5212, 42.6192],
    [-96.5309, 42.6171],
    [-96.5279, 42.6090],
    [-96.5195, 42.6144],
    [-96.5095, 42.6127],
    [-96.5002, 42.5927],
    [-96.5010, 42.5892],
    [-96.4948, 42.5857],
    [-96.4961, 42.5809],
    [-96.4866, 42.5761],
    [-96.4879, 42.5714],
    [-96.4985, 42.5581],
    [-96.4917, 42.5565],
    [-96.4785, 42.5564],
    [-96.4777, 42.5356],
    [-96.4790, 42.5264],
    [-96.4801, 42.5241],
    [-96.4908, 42.5203],
    [-96.4836, 42.5103],
    [-96.4733, 42.5035],
    [-96.4769, 42.4978],
    [-96.4772, 42.4910],
    [-96.4707, 42.4895],
    [-96.4664, 42.4908],
    [-96.4501, 42.4909],
    [-96.4597, 42.4860],
    [-96.4788, 42.4796],
    [-96.5013, 42.4827],
    [-96.5065, 42.4853],
    [-96.5176, 42.4969],
    [-96.5251, 42.5102],
    [-96.5380, 42.5181],
    [-96.5488, 42.5205],
    [-96.5725, 42.5157],
    [-96.5960, 42.5046],
    [-96.6062, 42.5048],
    [-96.6125, 42.5066],
    [-96.6293, 42.5194],
    [-96.6333, 42.5320],
    [-96.6333, 42.5402],
    [-96.6436, 42.5576],
    [-96.6502, 42.5619],
    [-96.6814, 42.5745],
    [-96.7064, 42.5994],
    [-96.7115, 42.6148],
    [-96.7073, 42.6253],
    [-96.6891, 42.6441],
    [-96.6870, 42.6498],
    [-96.6913, 42.6562],
    [-96.7355, 42.6672],
    [-96.7494, 42.6657],
    [-96.7782, 42.6630],
    [-96.7932, 42.6660],
    [-96.8022, 42.6722],
    [-96.8017, 42.6988],
    [-96.8195, 42.7078],
    [-96.8434, 42.7120],
    [-96.8728, 42.7241],
    [-96.8996, 42.7307],
    [-96.9205, 42.7314],
    [-96.9368, 42.7234],
    [-96.9559, 42.7192],
    [-96.9648, 42.7225],
    [-96.9622, 42.7347],
    [-96.9609, 42.7391],
    [-96.9753, 42.7583],
    [-96.9928, 42.7595],
    [-97.0249, 42.7624],
    [-97.0522, 42.7702],
    [-97.0794, 42.7714],
    [-97.1011, 42.7697],
    [-97.1313, 42.7719],
    [-97.1371, 42.7789],
    [-97.1382, 42.7834],
    [-97.1508, 42.7956],
    [-97.1670, 42.8021],
    [-97.1876, 42.8048],
    [-97.2101, 42.8093],
    [-97.2131, 42.8130],
    [-97.2178, 42.8278],
    [-97.2182, 42.8312],
    [-97.2319, 42.8513],
    [-97.2496, 42.8554],
    [-97.2568, 42.8539],
    [-97.2679, 42.8526],
    [-97.2786, 42.8540],
    [-97.2899, 42.8555],
    [-97.3067, 42.8676],
    [-97.3111, 42.8658],
    [-97.3263, 42.8613],
    [-97.3287, 42.8594],
    [-97.3412, 42.8559],
    [-97.3670, 42.8576],
    [-97.3767, 42.8652],
    [-97.3993, 42.8648],
    [-97.4134, 42.8674],
    [-97.4251, 42.8582],
    [-97.4391, 42.8471],
    [-97.4564, 42.8469],
    [-97.4705, 42.8505],
    [-97.4915, 42.8516],
    [-97.5003, 42.8572],
    [-97.5266, 42.8513],
    [-97.5619, 42.8476],
    [-97.5993, 42.8562],
    [-97.6118, 42.8584],
    [-97.6467, 42.8476],
    [-97.6865, 42.8424],
    [-97.7207, 42.8475],
    [-97.7647, 42.8491],
    [-97.7885, 42.8534],
    [-97.8171, 42.8618],
    [-97.8342, 42.8688],
    [-97.8657, 42.8629],
    [-97.8770, 42.8544],
    [-97.8758, 42.8477],
    [-97.8849, 42.8262],
    [-97.8944, 42.8117],
    [-97.9090, 42.7949],
    [-97.9234, 42.7866],
    [-97.9501, 42.7696],
    [-97.9620, 42.7687],
    [-98.0003, 42.7633],
    [-98.0130, 42.7623],
    [-98.0371, 42.7657],
    [-98.0475, 42.7683],
    [-98.0598, 42.7728],
    [-98.0674, 42.7848],
    [-98.0946, 42.7993],
    [-98.1275, 42.8201],
    [-98.1379, 42.8327],
    [-98.1531, 42.8391],
    [-98.1711, 42.8371],
    [-98.1898, 42.8416],
    [-98.2198, 42.8532],
    [-98.2305, 42.8602],
    [-98.2498, 42.8718],
    [-98.2684, 42.8742],
    [-98.3098, 42.8826],
    [-98.3297, 42.8884],
    [-98.3358, 42.8957],
    [-98.3462, 42.9027],
    [-98.3728, 42.9123],
    [-98.3993, 42.9225],
    [-98.4263, 42.9321],
    [-98.4345, 42.9292],
    [-98.4441, 42.9292],
    [-98.4483, 42.9364],
    [-98.4617, 42.9444],
    [-98.4789, 42.9635],
    [-98.4985, 42.9986],
    [-98.5689, 42.9985],
    [-98.6643, 42.9985],
    [-98.7424, 42.9983],
    [-98.8013, 42.9982],
    [-98.8606, 42.9982],
    [-98.9032, 42.9983],
    [-98.9426, 42.9983],
    [-99.0180, 42.9983],
    [-99.0605, 42.9983],
    [-99.0984, 42.9983],
    [-99.1511, 42.9983],
    [-99.1952, 42.9981],
    [-99.2543, 42.9981],
    [-99.2880, 42.9982],
    [-99.3686, 42.9981],
    [-99.3956, 42.9982],
    [-99.4908, 42.9981],
    [-99.5354, 42.9980],
    [-99.6700, 42.9979],
    [-99.7192, 42.9979],
    [-99.7685, 42.9981],
    [-99.8003, 42.9980],
    [-99.8219, 42.9980],
    [-99.8508, 42.9982],
    [-99.8777, 42.9981],
    [-99.9276, 42.9981],
    [-99.9612, 42.9983],
    [-100.0085, 42.9984],
    [-100.1193, 42.9987],
    [-100.1269, 42.9987],
    [-100.1984, 42.9985],
    [-100.3495, 42.9987],
    [-100.4727, 42.9993],
    [-100.5531, 42.9987],
    [-100.6713, 42.9981],
    [-100.8474, 42.9983],
    [-100.9067, 42.9979],
    [-100.9584, 42.9978],
    [-101.0004, 42.9975],
    [-101.2265, 42.9979],
    [-101.2292, 42.9979],
    [-101.4956, 42.9971],
    [-101.6254, 42.9962],
    [-101.7139, 42.9966],
    [-102.0825, 42.9994],
    [-102.3588, 42.9996],
    [-102.4405, 42.9996],
    [-102.5545, 42.9997],
    [-102.5760, 42.9997],
    [-102.7428, 42.9999],
    [-103.0006, 43.0005],
    [-103.3246, 43.0009],
    [-103.4046, 43.0007],
    [-103.5062, 43.0008],
    [-103.5763, 43.0008],
    [-103.6529, 43.0014],
    [-103.8156, 43.0013],
    [-103.9663, 43.0017],
    [-104.0532, 43.0306],
    [-104.0539, 43.2388],
    [-104.0546, 43.3911],
    [-104.0548, 43.4955],
    [-104.0549, 43.5841],
    [-104.0553, 43.7617],
    [-104.0550, 43.9377],
    [-104.0547, 44.1411],
    [-104.0555, 44.3160],
    [-104.0557, 44.4143],
    [-104.0558, 44.5710],
    [-104.0560, 44.6860],
    [-104.0559, 44.7757],
    [-104.0566, 44.9339],
    [-104.0579, 44.9976]
    ]
  },
  "Texas": {
    coordinates: [
      [-106.6455, 31.8987],
    [-106.6259, 31.9122],
    [-106.6148, 31.9178],
    [-106.6164, 31.9220],
    [-106.6297, 31.9266],
    [-106.6241, 31.9322],
    [-106.6224, 31.9409],
    [-106.6147, 31.9560],
    [-106.6251, 31.9545],
    [-106.6243, 31.9611],
    [-106.6187, 31.9670],
    [-106.6232, 31.9729],
    [-106.6382, 31.9768],
    [-106.6312, 31.9898],
    [-106.6269, 31.9905],
    [-106.6185, 32.0005],
    [-106.5991, 32.0007],
    [-106.5953, 32.0008],
    [-106.5827, 32.0008],
    [-106.5704, 32.0008],
    [-106.5622, 32.0007],
    [-106.4767, 32.0011],
    [-106.4111, 32.0013],
    [-106.3943, 32.0015],
    [-106.3274, 32.0014],
    [-106.3234, 32.0015],
    [-106.2059, 32.0018],
    [-106.1818, 32.0020],
    [-106.0505, 32.0024],
    [-105.8862, 32.0020],
    [-105.7314, 32.0016],
    [-105.4286, 32.0006],
    [-105.3398, 32.0006],
    [-105.1482, 32.0005],
    [-105.1180, 32.0005],
    [-104.9184, 32.0005],
    [-104.6435, 32.0004],
    [-104.5318, 32.0001],
    [-103.9802, 32.0001],
    [-103.7229, 32.0002],
    [-103.2704, 32.0003],
    [-103.2156, 32.0005],
    [-103.0859, 32.0005],
    [-103.0643, 32.1230],
    [-103.0646, 32.3347],
    [-103.0647, 32.5622],
    [-103.0648, 32.6019],
    [-103.0649, 32.6826],
    [-103.0648, 32.7138],
    [-103.0648, 32.7270],
    [-103.0647, 32.7836],
    [-103.0647, 32.8275],
    [-103.0649, 32.8573],
    [-103.0647, 32.8794],
    [-103.0647, 32.9591],
    [-103.0645, 33.0103],
    [-103.0639, 33.0421],
    [-103.0618, 33.1409],
    [-103.0597, 33.2563],
    [-103.0575, 33.3295],
    [-103.0526, 33.5706],
    [-103.0514, 33.6420],
    [-103.0505, 33.6724],
    [-103.0496, 33.7378],
    [-103.0473, 33.8247],
    [-103.0457, 33.9063],
    [-103.0436, 34.0036],
    [-103.0436, 34.0327],
    [-103.0437, 34.0423],
    [-103.0437, 34.0631],
    [-103.0436, 34.0879],
    [-103.0436, 34.2144],
    [-103.0439, 34.3026],
    [-103.0440, 34.3128],
    [-103.0439, 34.3766],
    [-103.0439, 34.3809],
    [-103.0436, 34.3847],
    [-103.0436, 34.3904],
    [-103.0436, 34.3937],
    [-103.0436, 34.4007],
    [-103.0436, 34.4483],
    [-103.0436, 34.4598],
    [-103.0431, 34.6198],
    [-103.0433, 34.6518],
    [-103.0428, 34.7474],
    [-103.0428, 34.8502],
    [-103.0426, 35.0595],
    [-103.0433, 35.1251],
    [-103.0427, 35.1447],
    [-103.0423, 35.1819],
    [-103.0425, 35.2119],
    [-103.0421, 35.3947],
    [-103.0415, 35.6511],
    [-103.0419, 35.7964],
    [-103.0413, 35.8377],
    [-103.0417, 36.3175],
    [-103.0419, 36.5004],
    [-102.5707, 36.5004],
    [-102.2450, 36.5007],
    [-102.1255, 36.5003],
    [-101.9316, 36.5005],
    [-101.8266, 36.4997],
    [-101.7881, 36.4997],
    [-101.7820, 36.4997],
    [-101.7781, 36.4997],
    [-101.7093, 36.4997],
    [-101.6728, 36.4995],
    [-101.6239, 36.4995],
    [-101.2048, 36.4993],
    [-101.0453, 36.4995],
    [-100.9361, 36.4996],
    [-100.8841, 36.4997],
    [-100.8242, 36.4996],
    [-100.8062, 36.4996],
    [-100.8029, 36.4996],
    [-100.7244, 36.4996],
    [-100.7086, 36.4995],
    [-100.6483, 36.4995],
    [-100.5926, 36.4995],
    [-100.5835, 36.4995],
    [-100.5781, 36.4994],
    [-100.5312, 36.4993],
    [-100.5222, 36.4993],
    [-100.4866, 36.4994],
    [-100.4411, 36.4995],
    [-100.4213, 36.4994],
    [-100.4136, 36.4995],
    [-100.3519, 36.4995],
    [-100.3344, 36.4994],
    [-100.3110, 36.4997],
    [-100.2582, 36.4996],
    [-100.0900, 36.4996],
    [-100.0004, 36.4997],
    [-100.0004, 36.2602],
    [-100.0004, 36.0557],
    [-100.0004, 35.7462],
    [-100.0004, 35.5525],
    [-100.0004, 35.3002],
    [-100.0004, 35.1393],
    [-100.0004, 34.7465],
    [-100.0004, 34.5704],
    [-99.9858, 34.5601],
    [-99.9656, 34.5658],
    [-99.9576, 34.5742],
    [-99.9546, 34.5782],
    [-99.9232, 34.5746],
    [-99.8989, 34.5558],
    [-99.8871, 34.5490],
    [-99.8733, 34.5354],
    [-99.8531, 34.5116],
    [-99.8253, 34.4976],
    [-99.8167, 34.4897],
    [-99.8145, 34.4766],
    [-99.7916, 34.4525],
    [-99.7866, 34.4515],
    [-99.7830, 34.4444],
    [-99.7731, 34.4416],
    [-99.7649, 34.4353],
    [-99.7542, 34.4213],
    [-99.7203, 34.4063],
    [-99.7142, 34.3978],
    [-99.7079, 34.3875],
    [-99.7040, 34.3860],
    [-99.6984, 34.3831],
    [-99.6950, 34.3783],
    [-99.6844, 34.3795],
    [-99.6748, 34.3790],
    [-99.6627, 34.3737],
    [-99.6497, 34.3799],
    [-99.6465, 34.3825],
    [-99.6428, 34.3816],
    [-99.6353, 34.3792],
    [-99.6312, 34.3771],
    [-99.6215, 34.3737],
    [-99.6116, 34.3756],
    [-99.6048, 34.3763],
    [-99.5962, 34.3790],
    [-99.5876, 34.3859],
    [-99.5845, 34.3912],
    [-99.5801, 34.4167],
    [-99.5622, 34.4173],
    [-99.5298, 34.4115],
    [-99.5143, 34.4140],
    [-99.5076, 34.4099],
    [-99.4999, 34.4096],
    [-99.4941, 34.4048],
    [-99.4775, 34.3964],
    [-99.4738, 34.3954],
    [-99.4703, 34.3967],
    [-99.4640, 34.3936],
    [-99.4620, 34.3844],
    [-99.4594, 34.3801],
    [-99.4550, 34.3818],
    [-99.4542, 34.3888],
    [-99.4437, 34.3765],
    [-99.4411, 34.3740],
    [-99.4376, 34.3713],
    [-99.4335, 34.3702],
    [-99.4311, 34.3740],
    [-99.4303, 34.3788],
    [-99.4275, 34.3851],
    [-99.4219, 34.3842],
    [-99.4072, 34.3726],
    [-99.3959, 34.3957],
    [-99.3939, 34.4153],
    [-99.3967, 34.4212],
    [-99.3933, 34.4276],
    [-99.3946, 34.4327],
    [-99.3950, 34.4421],
    [-99.3696, 34.4587],
    [-99.3558, 34.4490],
    [-99.3504, 34.4371],
    [-99.3287, 34.4224],
    [-99.3164, 34.4082],
    [-99.2991, 34.4142],
    [-99.2879, 34.4140],
    [-99.2828, 34.4075],
    [-99.2815, 34.4015],
    [-99.2696, 34.4019],
    [-99.2642, 34.4051],
    [-99.2618, 34.3987],
    [-99.2590, 34.3912],
    [-99.2717, 34.3877],
    [-99.2749, 34.3849],
    [-99.2650, 34.3788],
    [-99.2593, 34.3736],
    [-99.2546, 34.3724],
    [-99.2476, 34.3756],
    [-99.2430, 34.3711],
    [-99.2479, 34.3685],
    [-99.2470, 34.3648],
    [-99.2415, 34.3645],
    [-99.2364, 34.3636],
    [-99.2354, 34.3571],
    [-99.2343, 34.3535],
    [-99.2292, 34.3365],
    [-99.2131, 34.3404],
    [-99.2107, 34.3363],
    [-99.2058, 34.3201],
    [-99.2117, 34.3054],
    [-99.2078, 34.2838],
    [-99.1945, 34.2719],
    [-99.1918, 34.2564],
    [-99.1911, 34.2323],
    [-99.1921, 34.2222],
    [-99.1895, 34.2143],
    [-99.1513, 34.2076],
    [-99.1440, 34.2148],
    [-99.1392, 34.2176],
    [-99.1306, 34.2194],
    [-99.1268, 34.2171],
    [-99.1301, 34.2122],
    [-99.1312, 34.2057],
    [-99.1200, 34.2019],
    [-99.1128, 34.2058],
    [-99.1022, 34.2055],
    [-99.0953, 34.2118],
    [-99.0889, 34.2085],
    [-99.0760, 34.2112],
    [-99.0592, 34.2029],
    [-99.0488, 34.1982],
    [-99.0390, 34.2047],
    [-99.0279, 34.2056],
    [-99.0029, 34.2088],
    [-98.9909, 34.2216],
    [-98.9787, 34.2102],
    [-98.9690, 34.2013],
    [-98.9621, 34.2064],
    [-98.9585, 34.2139],
    [-98.9504, 34.2117],
    [-98.9275, 34.1912],
    [-98.9207, 34.1834],
    [-98.8921, 34.1723],
    [-98.8813, 34.1673],
    [-98.8729, 34.1666],
    [-98.8722, 34.1604],
    [-98.8733, 34.1536],
    [-98.8601, 34.1499],
    [-98.8573, 34.1611],
    [-98.8517, 34.1603],
    [-98.8470, 34.1597],
    [-98.8422, 34.1581],
    [-98.8333, 34.1591],
    [-98.8153, 34.1581],
    [-98.8044, 34.1539],
    [-98.7920, 34.1437],
    [-98.7656, 34.1364],
    [-98.7595, 34.1289],
    [-98.7537, 34.1245],
    [-98.7420, 34.1255],
    [-98.7368, 34.1334],
    [-98.7304, 34.1359],
    [-98.7236, 34.1352],
    [-98.7175, 34.1364],
    [-98.7142, 34.1334],
    [-98.7100, 34.1315],
    [-98.7002, 34.1360],
    [-98.6906, 34.1330],
    [-98.6787, 34.1421],
    [-98.6506, 34.1631],
    [-98.6357, 34.1616],
    [-98.6167, 34.1564],
    [-98.6089, 34.1575],
    [-98.5855, 34.1523],
    [-98.5672, 34.1381],
    [-98.5520, 34.1330],
    [-98.5510, 34.1278],
    [-98.5563, 34.1277],
    [-98.5610, 34.1246],
    [-98.5580, 34.1229],
    [-98.5509, 34.1193],
    [-98.5282, 34.0950],
    [-98.4820, 34.0623],
    [-98.4490, 34.0735],
    [-98.4428, 34.0831],
    [-98.4252, 34.0848],
    [-98.4172, 34.0837],
    [-98.4096, 34.0941],
    [-98.4093, 34.1013],
    [-98.4005, 34.0990],
    [-98.3982, 34.1214],
    [-98.3950, 34.1313],
    [-98.3830, 34.1295],
    [-98.3799, 34.1323],
    [-98.3862, 34.1377],
    [-98.3845, 34.1460],
    [-98.3745, 34.1508],
    [-98.3656, 34.1570],
    [-98.3254, 34.1510],
    [-98.3002, 34.1346],
    [-98.2769, 34.1310],
    [-98.2690, 34.1316],
    [-98.2673, 34.1320],
    [-98.2580, 34.1298],
    [-98.2410, 34.1331],
    [-98.2165, 34.1218],
    [-98.1915, 34.1158],
    [-98.1544, 34.1227],
    [-98.1368, 34.1450],
    [-98.1145, 34.1547],
    [-98.1006, 34.1421],
    [-98.0977, 34.1316],
    [-98.0898, 34.1282],
    [-98.0951, 34.1112],
    [-98.1121, 34.0911],
    [-98.1209, 34.0798],
    [-98.1146, 34.0623],
    [-98.0838, 34.0412],
    [-98.0980, 34.0382],
    [-98.0984, 34.0239],
    [-98.0882, 34.0055],
    [-98.0552, 33.9958],
    [-98.0195, 33.9938],
    [-97.9874, 33.9998],
    [-97.9742, 34.0067],
    [-97.9630, 33.9942],
    [-97.9527, 33.9901],
    [-97.9457, 33.9898],
    [-97.9604, 33.9519],
    [-97.9733, 33.9438],
    [-97.9725, 33.9379],
    [-97.9634, 33.9362],
    [-97.9534, 33.9364],
    [-97.9572, 33.9145],
    [-97.9699, 33.9060],
    [-97.9788, 33.9125],
    [-97.9845, 33.9007],
    [-97.9838, 33.8972],
    [-97.9778, 33.8899],
    [-97.9584, 33.8792],
    [-97.9427, 33.8798],
    [-97.9055, 33.8635],
    [-97.8832, 33.8544],
    [-97.8658, 33.8494],
    [-97.8495, 33.8543],
    [-97.8388, 33.8569],
    [-97.8262, 33.8645],
    [-97.8192, 33.8722],
    [-97.8140, 33.8818],
    [-97.8075, 33.8764],
    [-97.8014, 33.8863],
    [-97.8011, 33.8966],
    [-97.7908, 33.8983],
    [-97.7847, 33.8906],
    [-97.7797, 33.8992],
    [-97.7861, 33.9149],
    [-97.7797, 33.9197],
    [-97.7638, 33.9142],
    [-97.7598, 33.9252],
    [-97.7530, 33.9370],
    [-97.7337, 33.9364],
    [-97.7253, 33.9410],
    [-97.7097, 33.9550],
    [-97.6931, 33.9837],
    [-97.6718, 33.9914],
    [-97.6338, 33.9813],
    [-97.6230, 33.9739],
    [-97.6060, 33.9650],
    [-97.6010, 33.9607],
    [-97.5962, 33.9545],
    [-97.5914, 33.9481],
    [-97.5954, 33.9414],
    [-97.5912, 33.9312],
    [-97.5962, 33.9221],
    [-97.5963, 33.9138],
    [-97.5909, 33.9096],
    [-97.5893, 33.9039],
    [-97.5858, 33.9018],
    [-97.5811, 33.8997],
    [-97.5724, 33.8993],
    [-97.5628, 33.9009],
    [-97.5599, 33.8976],
    [-97.5515, 33.8979],
    [-97.5253, 33.9118],
    [-97.5099, 33.9167],
    [-97.4865, 33.9170],
    [-97.4581, 33.9016],
    [-97.4515, 33.8709],
    [-97.4629, 33.8418],
    [-97.4442, 33.8238],
    [-97.4033, 33.8190],
    [-97.3585, 33.8300],
    [-97.3359, 33.8792],
    [-97.3234, 33.8785],
    [-97.3298, 33.8558],
    [-97.3182, 33.8651],
    [-97.3099, 33.8744],
    [-97.3056, 33.8864],
    [-97.2791, 33.8646],
    [-97.2703, 33.8582],
    [-97.2542, 33.8653],
    [-97.2449, 33.9031],
    [-97.2265, 33.9146],
    [-97.2061, 33.9143],
    [-97.1899, 33.9036],
    [-97.1796, 33.8922],
    [-97.1668, 33.8404],
    [-97.1863, 33.8309],
    [-97.2035, 33.8218],
    [-97.2005, 33.7932],
    [-97.1928, 33.7612],
    [-97.1722, 33.7375],
    [-97.1551, 33.7244],
    [-97.1261, 33.7169],
    [-97.1089, 33.7203],
    [-97.0972, 33.7278],
    [-97.0862, 33.7439],
    [-97.0846, 33.7600],
    [-97.0939, 33.7891],
    [-97.0921, 33.8041],
    [-97.0680, 33.8145],
    [-97.0527, 33.8168],
    [-97.0530, 33.8339],
    [-97.0834, 33.8405],
    [-97.0895, 33.8498],
    [-97.0756, 33.8587],
    [-97.0558, 33.8557],
    [-97.0412, 33.8378],
    [-97.0239, 33.8442],
    [-96.9849, 33.8889],
    [-96.9887, 33.9185],
    [-96.9962, 33.9417],
    [-96.9908, 33.9527],
    [-96.9794, 33.9562],
    [-96.9810, 33.9492],
    [-96.9738, 33.9357],
    [-96.9446, 33.9492],
    [-96.9243, 33.9592],
    [-96.9163, 33.9578],
    [-96.9074, 33.9500],
    [-96.8994, 33.9337],
    [-96.8957, 33.8964],
    [-96.8753, 33.8605],
    [-96.8506, 33.8472],
    [-96.8408, 33.8636],
    [-96.8339, 33.8737],
    [-96.7984, 33.8697],
    [-96.7835, 33.8635],
    [-96.7772, 33.8482],
    [-96.7707, 33.8296],
    [-96.7662, 33.8255],
    [-96.7460, 33.8257],
    [-96.7045, 33.8350],
    [-96.6931, 33.8470],
    [-96.6882, 33.8546],
    [-96.6821, 33.8766],
    [-96.6783, 33.9023],
    [-96.6706, 33.9149],
    [-96.6599, 33.9167],
    [-96.6301, 33.8954],
    [-96.6076, 33.8947],
    [-96.5879, 33.8948],
    [-96.5873, 33.8846],
    [-96.5973, 33.8751],
    [-96.6147, 33.8665],
    [-96.6297, 33.8509],
    [-96.6232, 33.8415],
    [-96.5871, 33.8280],
    [-96.5512, 33.8191],
    [-96.5329, 33.8230],
    [-96.5292, 33.8221],
    [-96.5199, 33.8113],
    [-96.5159, 33.7964],
    [-96.5119, 33.7815],
    [-96.4861, 33.7730],
    [-96.4592, 33.7752],
    [-96.4505, 33.7806],
    [-96.4412, 33.7803],
    [-96.4226, 33.7760],
    [-96.4176, 33.7690],
    [-96.4119, 33.7557],
    [-96.3841, 33.7301],
    [-96.3669, 33.7112],
    [-96.3622, 33.6918],
    [-96.3427, 33.6870],
    [-96.3319, 33.6934],
    [-96.3169, 33.6990],
    [-96.3070, 33.7200],
    [-96.3074, 33.7350],
    [-96.3017, 33.7538],
    [-96.2883, 33.7712],
    [-96.2679, 33.7678],
    [-96.2556, 33.7621],
    [-96.2205, 33.7474],
    [-96.1964, 33.7532],
    [-96.1781, 33.7605],
    [-96.1628, 33.7888],
    [-96.1592, 33.8102],
    [-96.1670, 33.8111],
    [-96.1688, 33.8026],
    [-96.1773, 33.8051],
    [-96.1648, 33.8178],
    [-96.1488, 33.8192],
    [-96.1481, 33.8378],
    [-96.1182, 33.8379],
    [-96.0994, 33.8305],
    [-96.0992, 33.8424],
    [-96.1015, 33.8467],
    [-96.0951, 33.8475],
    [-96.0592, 33.8397],
    [-96.0372, 33.8412],
    [-96.0294, 33.8563],
    [-96.0212, 33.8555],
    [-96.0232, 33.8425],
    [-96.0053, 33.8455],
    [-95.9977, 33.8522],
    [-95.9945, 33.8615],
    [-96.0030, 33.8668],
    [-96.0012, 33.8723],
    [-95.9843, 33.8644],
    [-95.9855, 33.8557],
    [-95.9722, 33.8564],
    [-95.9413, 33.8616],
    [-95.9336, 33.8794],
    [-95.9296, 33.8850],
    [-95.9186, 33.8808],
    [-95.8867, 33.8648],
    [-95.8749, 33.8559],
    [-95.8588, 33.8507],
    [-95.8464, 33.8400],
    [-95.8375, 33.8356],
    [-95.8228, 33.8388],
    [-95.8190, 33.8445],
    [-95.8217, 33.8554],
    [-95.8051, 33.8613],
    [-95.7879, 33.8563],
    [-95.7759, 33.8473],
    [-95.7575, 33.8500],
    [-95.7513, 33.8589],
    [-95.7568, 33.8682],
    [-95.7619, 33.8834],
    [-95.7377, 33.8965],
    [-95.7284, 33.8937],
    [-95.7105, 33.8850],
    [-95.6769, 33.8972],
    [-95.6601, 33.9101],
    [-95.6497, 33.9074],
    [-95.6359, 33.9052],
    [-95.6268, 33.9079],
    [-95.6224, 33.9183],
    [-95.6120, 33.9287],
    [-95.6007, 33.9313],
    [-95.5970, 33.9412],
    [-95.5896, 33.9416],
    [-95.5809, 33.9338],
    [-95.5694, 33.9332],
    [-95.5574, 33.9305],
    [-95.5525, 33.9230],
    [-95.5485, 33.9085],
    [-95.5509, 33.8930],
    [-95.5452, 33.8803],
    [-95.5253, 33.8855],
    [-95.5150, 33.8947],
    [-95.5076, 33.8972],
    [-95.5045, 33.8837],
    [-95.5026, 33.8750],
    [-95.4920, 33.8748],
    [-95.4726, 33.8803],
    [-95.4661, 33.8866],
    [-95.4595, 33.8863],
    [-95.4641, 33.8761],
    [-95.4586, 33.8717],
    [-95.4273, 33.8704],
    [-95.3846, 33.8684],
    [-95.3656, 33.8667],
    [-95.3434, 33.8725],
    [-95.3319, 33.8798],
    [-95.3222, 33.8848],
    [-95.3104, 33.8774],
    [-95.2809, 33.8754],
    [-95.2779, 33.8875],
    [-95.2856, 33.9034],
    [-95.2707, 33.9115],
    [-95.2659, 33.8954],
    [-95.2527, 33.8942],
    [-95.2502, 33.9385],
    [-95.2357, 33.9483],
    [-95.2304, 33.9558],
    [-95.2276, 33.9608],
    [-95.2240, 33.9622],
    [-95.2141, 33.9621],
    [-95.2026, 33.9569],
    [-95.1898, 33.9514],
    [-95.1797, 33.9487],
    [-95.1675, 33.9447],
    [-95.1559, 33.9369],
    [-95.1401, 33.9348],
    [-95.1247, 33.9347],
    [-95.1228, 33.9247],
    [-95.1312, 33.9122],
    [-95.1171, 33.9036],
    [-95.0927, 33.9128],
    [-95.0838, 33.9211],
    [-95.0764, 33.9154],
    [-95.0868, 33.9038],
    [-95.1002, 33.8961],
    [-95.0956, 33.8880],
    [-95.0824, 33.8799],
    [-95.0794, 33.8946],
    [-95.0751, 33.9089],
    [-95.0687, 33.9176],
    [-95.0633, 33.9109],
    [-95.0705, 33.9084],
    [-95.0702, 33.9024],
    [-95.0601, 33.9019],
    [-95.0508, 33.8694],
    [-95.0372, 33.8603],
    [-95.0173, 33.8580],
    [-95.0047, 33.8617],
    [-94.9975, 33.8605],
    [-94.9885, 33.8510],
    [-94.9762, 33.8598],
    [-94.9689, 33.8609],
    [-94.9644, 33.8370],
    [-94.9438, 33.8293],
    [-94.9400, 33.8057],
    [-94.9231, 33.8114],
    [-94.9263, 33.8226],
    [-94.9220, 33.8288],
    [-94.9121, 33.8205],
    [-94.9126, 33.8087],
    [-94.9217, 33.7959],
    [-94.9175, 33.7865],
    [-94.9075, 33.7781],
    [-94.8960, 33.7685],
    [-94.8814, 33.7612],
    [-94.8739, 33.7606],
    [-94.8743, 33.7709],
    [-94.8667, 33.7672],
    [-94.8755, 33.7555],
    [-94.8693, 33.7459],
    [-94.8314, 33.7401],
    [-94.8250, 33.7334],
    [-94.8230, 33.7475],
    [-94.8253, 33.7685],
    [-94.8162, 33.7634],
    [-94.8122, 33.7509],
    [-94.8161, 33.7392],
    [-94.8001, 33.7334],
    [-94.7810, 33.7448],
    [-94.7762, 33.7563],
    [-94.7644, 33.7602],
    [-94.7578, 33.7501],
    [-94.7738, 33.7465],
    [-94.7882, 33.7363],
    [-94.7725, 33.7261],
    [-94.7588, 33.7293],
    [-94.7518, 33.7343],
    [-94.7481, 33.7253],
    [-94.7565, 33.7176],
    [-94.7490, 33.7153],
    [-94.7444, 33.7236],
    [-94.7350, 33.7261],
    [-94.7364, 33.7160],
    [-94.7496, 33.7103],
    [-94.7471, 33.7030],
    [-94.7386, 33.6968],
    [-94.7193, 33.6892],
    [-94.7214, 33.7046],
    [-94.7331, 33.7101],
    [-94.7279, 33.7156],
    [-94.7017, 33.7034],
    [-94.7077, 33.6968],
    [-94.7134, 33.6874],
    [-94.6779, 33.6878],
    [-94.6617, 33.6931],
    [-94.6485, 33.6903],
    [-94.6474, 33.7011],
    [-94.6375, 33.6961],
    [-94.6449, 33.6864],
    [-94.6458, 33.6777],
    [-94.6508, 33.6713],
    [-94.6628, 33.6754],
    [-94.6703, 33.6649],
    [-94.6526, 33.6604],
    [-94.6334, 33.6692],
    [-94.6224, 33.6824],
    [-94.6128, 33.6740],
    [-94.6030, 33.6631],
    [-94.5914, 33.6689],
    [-94.5920, 33.6800],
    [-94.5883, 33.6858],
    [-94.5803, 33.6784],
    [-94.5796, 33.6690],
    [-94.5767, 33.6659],
    [-94.5649, 33.6690],
    [-94.5604, 33.6654],
    [-94.5826, 33.6548],
    [-94.5908, 33.6456],
    [-94.5820, 33.6440],
    [-94.5647, 33.6558],
    [-94.5464, 33.6592],
    [-94.5432, 33.6502],
    [-94.5585, 33.6420],
    [-94.5695, 33.6344],
    [-94.5643, 33.6266],
    [-94.5480, 33.6312],
    [-94.5324, 33.6404],
    [-94.5200, 33.6388],
    [-94.5342, 33.6271],
    [-94.5319, 33.6186],
    [-94.5180, 33.6233],
    [-94.5140, 33.6307],
    [-94.4980, 33.6232],
    [-94.4890, 33.6333],
    [-94.4813, 33.6388],
    [-94.4642, 33.6377],
    [-94.4548, 33.6449],
    [-94.4475, 33.6363],
    [-94.4627, 33.6309],
    [-94.4553, 33.6229],
    [-94.4530, 33.6170],
    [-94.4695, 33.6073],
    [-94.4712, 33.6016],
    [-94.4582, 33.5983],
    [-94.4491, 33.5909],
    [-94.4395, 33.5942],
    [-94.4260, 33.5864],
    [-94.4122, 33.5687],
    [-94.3973, 33.5716],
    [-94.3796, 33.5806],
    [-94.3786, 33.5713],
    [-94.3881, 33.5655],
    [-94.3977, 33.5649],
    [-94.3999, 33.5571],
    [-94.3895, 33.5468],
    [-94.3734, 33.5445],
    [-94.3614, 33.5446],
    [-94.3555, 33.5435],
    [-94.3473, 33.5522],
    [-94.3455, 33.5673],
    [-94.3384, 33.5671],
    [-94.3339, 33.5575],
    [-94.3318, 33.5533],
    [-94.3237, 33.5498],
    [-94.3084, 33.5531],
    [-94.3072, 33.5598],
    [-94.2984, 33.5762],
    [-94.2870, 33.5824],
    [-94.2808, 33.5772],
    [-94.2904, 33.5679],
    [-94.2894, 33.5576],
    [-94.2756, 33.5580],
    [-94.2710, 33.5632],
    [-94.2628, 33.5774],
    [-94.2459, 33.5891],
    [-94.2370, 33.5874],
    [-94.2380, 33.5778],
    [-94.2511, 33.5653],
    [-94.2516, 33.5582],
    [-94.2334, 33.5522],
    [-94.2229, 33.5541],
    [-94.2136, 33.5631],
    [-94.2036, 33.5665],
    [-94.1978, 33.5552],
    [-94.1913, 33.5577],
    [-94.1944, 33.5737],
    [-94.2043, 33.5750],
    [-94.2113, 33.5738],
    [-94.2172, 33.5807],
    [-94.2110, 33.5831],
    [-94.1998, 33.5811],
    [-94.1909, 33.5875],
    [-94.1809, 33.5926],
    [-94.1611, 33.5880],
    [-94.1568, 33.5757],
    [-94.1460, 33.5820],
    [-94.1419, 33.5796],
    [-94.1495, 33.5736],
    [-94.1515, 33.5684],
    [-94.1434, 33.5655],
    [-94.1351, 33.5710],
    [-94.1314, 33.5529],
    [-94.1239, 33.5521],
    [-94.1204, 33.5655],
    [-94.1032, 33.5703],
    [-94.0889, 33.5753],
    [-94.0722, 33.5726],
    [-94.0717, 33.5746],
    [-94.0695, 33.5742],
    [-94.0678, 33.5701],
    [-94.0613, 33.5688],
    [-94.0557, 33.5619],
    [-94.0612, 33.5592],
    [-94.0717, 33.5597],
    [-94.0722, 33.5539],
    [-94.0619, 33.5498],
    [-94.0502, 33.5511],
    [-94.0434, 33.5523],
    [-94.0433, 33.5283],
    [-94.0430, 33.4930],
    [-94.0433, 33.4895],
    [-94.0432, 33.4703],
    [-94.0431, 33.4529],
    [-94.0430, 33.4457],
    [-94.0430, 33.4358],
    [-94.0430, 33.4284],
    [-94.0429, 33.4131],
    [-94.0430, 33.3996],
    [-94.0430, 33.3805],
    [-94.0431, 33.3588],
    [-94.0431, 33.3521],
    [-94.0431, 33.3438],
    [-94.0430, 33.2712],
    [-94.0430, 33.2609],
    [-94.0430, 33.2501],
    [-94.0429, 33.2027],
    [-94.0427, 33.1603],
    [-94.0431, 33.1382],
    [-94.0429, 33.0927],
    [-94.0430, 33.0192],
    [-94.0431, 32.9556],
    [-94.0429, 32.8989],
    [-94.0429, 32.8810],
    [-94.0430, 32.8190],
    [-94.0428, 32.7853],
    [-94.0429, 32.7680],
    [-94.0431, 32.6930],
    [-94.0428, 32.6435],
    [-94.0429, 32.6183],
    [-94.0431, 32.5643],
    [-94.0431, 32.5165],
    [-94.0431, 32.5136],
    [-94.0431, 32.4866],
    [-94.0430, 32.4780],
    [-94.0429, 32.4704],
    [-94.0429, 32.4399],
    [-94.0429, 32.4007],
    [-94.0428, 32.3734],
    [-94.0427, 32.3480],
    [-94.0427, 32.2697],
    [-94.0427, 32.2250],
    [-94.0426, 32.1669],
    [-94.0427, 32.1380],
    [-94.0423, 32.1199],
    [-94.0427, 31.9993],
    [-94.0384, 31.9924],
    [-94.0252, 31.9944],
    [-94.0173, 31.9893],
    [-94.0164, 31.9808],
    [-94.0074, 31.9738],
    [-93.9987, 31.9591],
    [-93.9904, 31.9486],
    [-93.9813, 31.9395],
    [-93.9793, 31.9307],
    [-93.9717, 31.9204],
    [-93.9618, 31.9240],
    [-93.9535, 31.9106],
    [-93.9332, 31.9109],
    [-93.9233, 31.9078],
    [-93.9309, 31.8965],
    [-93.9267, 31.8883],
    [-93.9196, 31.8907],
    [-93.9032, 31.8962],
    [-93.8981, 31.8949],
    [-93.8966, 31.8873],
    [-93.9025, 31.8753],
    [-93.8974, 31.8744],
    [-93.8915, 31.8749],
    [-93.8850, 31.8659],
    [-93.8825, 31.8619],
    [-93.8890, 31.8557],
    [-93.8818, 31.8522],
    [-93.8810, 31.8448],
    [-93.8748, 31.8406],
    [-93.8771, 31.8322],
    [-93.8748, 31.8217],
    [-93.8734, 31.8158],
    [-93.8708, 31.8138],
    [-93.8614, 31.8123],
    [-93.8585, 31.8085],
    [-93.8534, 31.8055],
    [-93.8515, 31.8001],
    [-93.8471, 31.7999],
    [-93.8429, 31.8007],
    [-93.8384, 31.7981],
    [-93.8356, 31.7945],
    [-93.8312, 31.7802],
    [-93.8226, 31.7736],
    [-93.8288, 31.7656],
    [-93.8262, 31.7623],
    [-93.8326, 31.7542],
    [-93.8330, 31.7464],
    [-93.8246, 31.7344],
    [-93.8150, 31.7287],
    [-93.8128, 31.7168],
    [-93.8163, 31.7075],
    [-93.8111, 31.7037],
    [-93.7976, 31.7056],
    [-93.7955, 31.7005],
    [-93.8139, 31.6759],
    [-93.8152, 31.6680],
    [-93.8189, 31.6738],
    [-93.8257, 31.6610],
    [-93.8180, 31.6479],
    [-93.8206, 31.6297],
    [-93.8172, 31.6256],
    [-93.8207, 31.6214],
    [-93.8269, 31.6210],
    [-93.8222, 31.6185],
    [-93.8196, 31.6141],
    [-93.8304, 31.6136],
    [-93.8349, 31.5862],
    [-93.8184, 31.5709],
    [-93.8222, 31.5688],
    [-93.8216, 31.5637],
    [-93.8170, 31.5616],
    [-93.8208, 31.5582],
    [-93.8102, 31.5499],
    [-93.8033, 31.5436],
    [-93.7999, 31.5419],
    [-93.7992, 31.5381],
    [-93.7877, 31.5273],
    [-93.7549, 31.5248],
    [-93.7581, 31.5299],
    [-93.7519, 31.5275],
    [-93.7473, 31.5284],
    [-93.7406, 31.5185],
    [-93.7439, 31.5181],
    [-93.7439, 31.5165],
    [-93.7334, 31.5132],
    [-93.7134, 31.5148],
    [-93.7116, 31.5101],
    [-93.7215, 31.4997],
    [-93.7276, 31.4889],
    [-93.7452, 31.4856],
    [-93.7530, 31.4817],
    [-93.7480, 31.4816],
    [-93.7454, 31.4781],
    [-93.7495, 31.4687],
    [-93.7418, 31.4659],
    [-93.7177, 31.4571],
    [-93.7117, 31.4530],
    [-93.7091, 31.4567],
    [-93.7042, 31.4530],
    [-93.7059, 31.4403],
    [-93.6925, 31.4382],
    [-93.7047, 31.4181],
    [-93.6959, 31.4094],
    [-93.6702, 31.3872],
    [-93.6700, 31.3705],
    [-93.6703, 31.3661],
    [-93.6488, 31.3706],
    [-93.6403, 31.3687],
    [-93.6459, 31.3590],
    [-93.6655, 31.3544],
    [-93.6686, 31.3411],
    [-93.6773, 31.3305],
    [-93.6752, 31.3220],
    [-93.6879, 31.3098],
    [-93.6754, 31.3010],
    [-93.6599, 31.2820],
    [-93.6509, 31.2843],
    [-93.6452, 31.2763],
    [-93.6415, 31.2699],
    [-93.6203, 31.2710],
    [-93.6146, 31.2614],
    [-93.6154, 31.2542],
    [-93.6212, 31.2496],
    [-93.6163, 31.2446],
    [-93.6183, 31.2331],
    [-93.6132, 31.2324],
    [-93.6098, 31.2297],
    [-93.6017, 31.2295],
    [-93.5966, 31.2297],
    [-93.5992, 31.2253],
    [-93.5950, 31.2210],
    [-93.6038, 31.2158],
    [-93.6019, 31.1994],
    [-93.6003, 31.1762],
    [-93.5792, 31.1674],
    [-93.5671, 31.1790],
    [-93.5525, 31.1856],
    [-93.5418, 31.1832],
    [-93.5333, 31.1845],
    [-93.5328, 31.1743],
    [-93.5431, 31.1707],
    [-93.5364, 31.1604],
    [-93.5464, 31.1566],
    [-93.5489, 31.1484],
    [-93.5403, 31.1289],
    [-93.5487, 31.1060],
    [-93.5493, 31.1001],
    [-93.5635, 31.0940],
    [-93.5546, 31.0869],
    [-93.5401, 31.0780],
    [-93.5272, 31.0732],
    [-93.5207, 31.0661],
    [-93.5189, 31.0619],
    [-93.5321, 31.0553],
    [-93.5235, 31.0462],
    [-93.5199, 31.0419],
    [-93.5249, 31.0399],
    [-93.5150, 31.0349],
    [-93.5149, 31.0257],
    [-93.5316, 31.0202],
    [-93.5404, 31.0078],
    [-93.5485, 31.0103],
    [-93.5559, 31.0037],
    [-93.5675, 31.0127],
    [-93.5730, 31.0047],
    [-93.5751, 30.9946],
    [-93.5662, 30.9907],
    [-93.5659, 30.9852],
    [-93.5693, 30.9762],
    [-93.5740, 30.9722],
    [-93.5648, 30.9695],
    [-93.5535, 30.9674],
    [-93.5463, 30.9578],
    [-93.5346, 30.9580],
    [-93.5305, 30.9557],
    [-93.5326, 30.9507],
    [-93.5264, 30.9394],
    [-93.5278, 30.9328],
    [-93.5432, 30.9201],
    [-93.5495, 30.9238],
    [-93.5549, 30.9157],
    [-93.5553, 30.9093],
    [-93.5540, 30.9028],
    [-93.5486, 30.8999],
    [-93.5525, 30.8967],
    [-93.5663, 30.8948],
    [-93.5699, 30.8906],
    [-93.5735, 30.8827],
    [-93.5629, 30.8728],
    [-93.5588, 30.8688],
    [-93.5619, 30.8583],
    [-93.5573, 30.8521],
    [-93.5680, 30.8430],
    [-93.5536, 30.8351],
    [-93.5562, 30.8264],
    [-93.5578, 30.8210],
    [-93.5638, 30.8136],
    [-93.5632, 30.8062],
    [-93.5784, 30.8020],
    [-93.5843, 30.7967],
    [-93.5814, 30.7916],
    [-93.5872, 30.7879],
    [-93.5870, 30.7829],
    [-93.5832, 30.7786],
    [-93.5899, 30.7778],
    [-93.5935, 30.7723],
    [-93.6008, 30.7622],
    [-93.6062, 30.7594],
    [-93.6101, 30.7575],
    [-93.6135, 30.7608],
    [-93.6148, 30.7561],
    [-93.6083, 30.7478],
    [-93.6090, 30.7455],
    [-93.6178, 30.7433],
    [-93.6177, 30.7385],
    [-93.6097, 30.7292],
    [-93.6128, 30.7166],
    [-93.6172, 30.7186],
    [-93.6197, 30.7089],
    [-93.6245, 30.7011],
    [-93.6228, 30.6971],
    [-93.6204, 30.6942],
    [-93.6272, 30.6874],
    [-93.6362, 30.6761],
    [-93.6466, 30.6714],
    [-93.6532, 30.6704],
    [-93.6613, 30.6612],
    [-93.6704, 30.6580],
    [-93.6701, 30.6538],
    [-93.6741, 30.6487],
    [-93.6831, 30.6408],
    [-93.6805, 30.6352],
    [-93.6838, 30.6326],
    [-93.6851, 30.6252],
    [-93.6820, 30.6186],
    [-93.6891, 30.6114],
    [-93.6844, 30.6092],
    [-93.6792, 30.5998],
    [-93.6828, 30.5937],
    [-93.6881, 30.5857],
    [-93.6894, 30.5891],
    [-93.6929, 30.5944],
    [-93.7060, 30.5880],
    [-93.7136, 30.5874],
    [-93.7179, 30.5778],
    [-93.7278, 30.5741],
    [-93.7264, 30.5681],
    [-93.7239, 30.5592],
    [-93.7314, 30.5514],
    [-93.7348, 30.5417],
    [-93.7395, 30.5380],
    [-93.7322, 30.5358],
    [-93.7277, 30.5257],
    [-93.7190, 30.5211],
    [-93.7108, 30.5177],
    [-93.7116, 30.5120],
    [-93.7073, 30.5114],
    [-93.7097, 30.5065],
    [-93.7085, 30.5004],
    [-93.7145, 30.4977],
    [-93.7120, 30.4876],
    [-93.7098, 30.4826],
    [-93.7148, 30.4852],
    [-93.7168, 30.4819],
    [-93.7112, 30.4727],
    [-93.7064, 30.4669],
    [-93.6994, 30.4579],
    [-93.7021, 30.4498],
    [-93.7069, 30.4440],
    [-93.6983, 30.4449],
    [-93.6993, 30.4374],
    [-93.7024, 30.4309],
    [-93.7083, 30.4303],
    [-93.7140, 30.4297],
    [-93.7171, 30.4231],
    [-93.7230, 30.4321],
    [-93.7223, 30.4207],
    [-93.7275, 30.4187],
    [-93.7280, 30.4147],
    [-93.7320, 30.4139],
    [-93.7349, 30.4128],
    [-93.7356, 30.4069],
    [-93.7418, 30.4014],
    [-93.7455, 30.3987],
    [-93.7486, 30.3968],
    [-93.7522, 30.3934],
    [-93.7577, 30.3904],
    [-93.7584, 30.3837],
    [-93.7573, 30.3643],
    [-93.7615, 30.3522],
    [-93.7589, 30.3385],
    [-93.7643, 30.3302],
    [-93.7510, 30.3209],
    [-93.7439, 30.3040],
    [-93.7242, 30.2951],
    [-93.7129, 30.2879],
    [-93.7046, 30.2897],
    [-93.7072, 30.2755],
    [-93.7032, 30.2600],
    [-93.7054, 30.2470],
    [-93.7031, 30.2392],
    [-93.7093, 30.2339],
    [-93.7192, 30.2185],
    [-93.7150, 30.1973],
    [-93.7085, 30.1968],
    [-93.7097, 30.1833],
    [-93.7020, 30.1678],
    [-93.7039, 30.1611],
    [-93.7076, 30.1498],
    [-93.7002, 30.1527],
    [-93.6937, 30.1425],
    [-93.6886, 30.1404],
    [-93.6983, 30.1386],
    [-93.7020, 30.1307],
    [-93.7013, 30.1274],
    [-93.7065, 30.1217],
    [-93.7034, 30.1172],
    [-93.7037, 30.1111],
    [-93.7130, 30.1079],
    [-93.7238, 30.0941],
    [-93.7258, 30.0820],
    [-93.7299, 30.0883],
    [-93.7341, 30.0861],
    [-93.7287, 30.0802],
    [-93.7164, 30.0691],
    [-93.7006, 30.0637],
    [-93.7039, 30.0543],
    [-93.7119, 30.0570],
    [-93.7173, 30.0657],
    [-93.7208, 30.0530],
    [-93.7374, 30.0373],
    [-93.7421, 30.0208],
    [-93.7551, 30.0153],
    [-93.7684, 30.0017],
    [-93.7716, 29.9959],
    [-93.7822, 29.9937],
    [-93.7901, 29.9866],
    [-93.7944, 29.9748],
    [-93.8034, 29.9626],
    [-93.8165, 29.9207],
    [-93.8384, 29.8829],
    [-93.8636, 29.8572],
    [-93.9007, 29.8370],
    [-93.9227, 29.8188],
    [-93.9288, 29.7971],
    [-93.9224, 29.7850],
    [-93.8908, 29.7617],
    [-93.8888, 29.7422],
    [-93.8632, 29.7241],
    [-93.8406, 29.6858],
    [-93.8395, 29.6785],
    [-93.8521, 29.6792],
    [-93.8969, 29.6811],
    [-93.9554, 29.6828],
    [-93.9848, 29.6824],
    [-94.0390, 29.6750],
    [-94.1195, 29.6524],
    [-94.2180, 29.6154],
    [-94.3541, 29.5626],
    [-94.4986, 29.5071],
    [-94.5356, 29.4929],
    [-94.5962, 29.4679],
    [-94.6683, 29.4326],
    [-94.7085, 29.4030],
    [-94.7286, 29.3723],
    [-94.7361, 29.3660],
    [-94.7448, 29.3692],
    [-94.7508, 29.3697],
    [-94.7581, 29.3633],
    [-94.7622, 29.3646],
    [-94.7700, 29.3649],
    [-94.7794, 29.3627],
    [-94.7773, 29.3711],
    [-94.7778, 29.3758],
    [-94.7844, 29.3757],
    [-94.7711, 29.3868],
    [-94.7668, 29.3935],
    [-94.7743, 29.3992],
    [-94.7477, 29.4094],
    [-94.7402, 29.4140],
    [-94.7270, 29.4246],
    [-94.7135, 29.4314],
    [-94.7064, 29.4345],
    [-94.7035, 29.4404],
    [-94.6978, 29.4490],
    [-94.6947, 29.4545],
    [-94.6922, 29.4601],
    [-94.6806, 29.4710],
    [-94.6736, 29.4755],
    [-94.6610, 29.4775],
    [-94.6459, 29.4738],
    [-94.6282, 29.4760],
    [-94.6033, 29.4859],
    [-94.5942, 29.4921],
    [-94.5954, 29.5011],
    [-94.5936, 29.5092],
    [-94.5796, 29.5237],
    [-94.5716, 29.5275],
    [-94.5662, 29.5306],
    [-94.5540, 29.5283],
    [-94.5423, 29.5214],
    [-94.5301, 29.5168],
    [-94.5187, 29.5171],
    [-94.5141, 29.5183],
    [-94.5081, 29.5116],
    [-94.5010, 29.5115],
    [-94.4933, 29.5136],
    [-94.4914, 29.5220],
    [-94.4959, 29.5268],
    [-94.4884, 29.5299],
    [-94.4828, 29.5409],
    [-94.4739, 29.5504],
    [-94.4707, 29.5566],
    [-94.4745, 29.5587],
    [-94.4838, 29.5539],
    [-94.4960, 29.5498],
    [-94.5111, 29.5429],
    [-94.5228, 29.5447],
    [-94.5249, 29.5508],
    [-94.5287, 29.5561],
    [-94.5338, 29.5586],
    [-94.5398, 29.5641],
    [-94.5482, 29.5731],
    [-94.5610, 29.5744],
    [-94.5700, 29.5722],
    [-94.5826, 29.5662],
    [-94.5976, 29.5621],
    [-94.6233, 29.5536],
    [-94.6327, 29.5521],
    [-94.6569, 29.5477],
    [-94.6812, 29.5403],
    [-94.6997, 29.5379],
    [-94.7113, 29.5369],
    [-94.7201, 29.5343],
    [-94.7407, 29.5269],
    [-94.7577, 29.5246],
    [-94.7790, 29.5302],
    [-94.7845, 29.5395],
    [-94.7888, 29.5469],
    [-94.7819, 29.5499],
    [-94.7756, 29.5456],
    [-94.7718, 29.5396],
    [-94.7616, 29.5418],
    [-94.7566, 29.5461],
    [-94.7520, 29.5553],
    [-94.7477, 29.5667],
    [-94.7367, 29.5749],
    [-94.7325, 29.5822],
    [-94.7256, 29.5933],
    [-94.7206, 29.6025],
    [-94.7131, 29.6138],
    [-94.7101, 29.6199],
    [-94.7032, 29.6342],
    [-94.7005, 29.6428],
    [-94.6985, 29.6524],
    [-94.6983, 29.6543],
    [-94.6977, 29.6612],
    [-94.6976, 29.6644],
    [-94.6968, 29.6698],
    [-94.6964, 29.6813],
    [-94.6894, 29.6933],
    [-94.6898, 29.7056],
    [-94.6925, 29.7239],
    [-94.6984, 29.7354],
    [-94.6964, 29.7462],
    [-94.7060, 29.7390],
    [-94.7056, 29.7470],
    [-94.7010, 29.7507],
    [-94.6980, 29.7579],
    [-94.7055, 29.7557],
    [-94.7100, 29.7599],
    [-94.7184, 29.7637],
    [-94.7207, 29.7665],
    [-94.7280, 29.7629],
    [-94.7381, 29.7648],
    [-94.7470, 29.7709],
    [-94.7538, 29.7795],
    [-94.7565, 29.7814],
    [-94.7721, 29.7746],
    [-94.7925, 29.7683],
    [-94.7998, 29.7656],
    [-94.8201, 29.7538],
    [-94.8322, 29.7408],
    [-94.8364, 29.7352],
    [-94.8445, 29.7282],
    [-94.8511, 29.7214],
    [-94.8538, 29.7136],
    [-94.8586, 29.7064],
    [-94.8650, 29.6945],
    [-94.8674, 29.6788],
    [-94.8788, 29.6680],
    [-94.9010, 29.6576],
    [-94.9160, 29.6566],
    [-94.9255, 29.6617],
    [-94.9280, 29.6675],
    [-94.9310, 29.6738],
    [-94.9369, 29.6800],
    [-94.9361, 29.6927],
    [-94.9508, 29.6987],
    [-94.9700, 29.7013],
    [-94.9762, 29.7069],
    [-94.9832, 29.7096],
    [-94.9896, 29.7088],
    [-94.9953, 29.7083],
    [-95.0050, 29.7041],
    [-94.9940, 29.6901],
    [-94.9877, 29.6814],
    [-94.9822, 29.6769],
    [-94.9978, 29.6668],
    [-95.0023, 29.6629],
    [-95.0110, 29.6508],
    [-95.0156, 29.6395],
    [-95.0135, 29.6292],
    [-95.0086, 29.6236],
    [-94.9990, 29.6210],
    [-94.9983, 29.6200],
    [-94.9971, 29.6153],
    [-94.9931, 29.6127],
    [-94.9859, 29.6053],
    [-94.9846, 29.5988],
    [-94.9879, 29.5940],
    [-94.9936, 29.5898],
    [-94.9973, 29.5856],
    [-95.0025, 29.5801],
    [-95.0072, 29.5748],
    [-95.0115, 29.5686],
    [-95.0168, 29.5572],
    [-95.0210, 29.5515],
    [-95.0169, 29.5483],
    [-95.0152, 29.5400],
    [-95.0092, 29.5331],
    [-94.9947, 29.5198],
    [-94.9895, 29.5168],
    [-94.9804, 29.5126],
    [-94.9606, 29.5072],
    [-94.9514, 29.5050],
    [-94.9339, 29.5015],
    [-94.9277, 29.4992],
    [-94.9095, 29.4968],
    [-94.9138, 29.4873],
    [-94.9254, 29.4709],
    [-94.9277, 29.4774],
    [-94.9315, 29.4812],
    [-94.9470, 29.4765],
    [-94.9526, 29.4729],
    [-94.9525, 29.4698],
    [-94.9488, 29.4652],
    [-94.9381, 29.4564],
    [-94.9305, 29.4574],
    [-94.9224, 29.4487],
    [-94.9170, 29.4459],
    [-94.8914, 29.4313],
    [-94.8888, 29.4224],
    [-94.8888, 29.4133],
    [-94.8870, 29.3866],
    [-94.8891, 29.3810],
    [-94.8841, 29.3772],
    [-94.8650, 29.3728],
    [-94.8854, 29.3588],
    [-94.8918, 29.3529],
    [-94.8947, 29.3366],
    [-94.8990, 29.3345],
    [-94.8960, 29.3284],
    [-94.8949, 29.3115],
    [-94.8975, 29.3048],
    [-94.8999, 29.3025],
    [-94.9040, 29.3001],
    [-94.9070, 29.2974],
    [-94.9099, 29.2950],
    [-94.9169, 29.2928],
    [-94.9229, 29.2920],
    [-94.9205, 29.2883],
    [-94.9216, 29.2816],
    [-94.9344, 29.2844],
    [-94.9724, 29.2800],
    [-94.9870, 29.2670],
    [-95.0058, 29.2421],
    [-95.0264, 29.2280],
    [-95.0419, 29.2050],
    [-95.0587, 29.1967],
    [-95.0718, 29.1941],
    [-95.0992, 29.1764],
    [-95.1097, 29.1715],
    [-95.1131, 29.1747],
    [-95.1174, 29.1769],
    [-95.1080, 29.1827],
    [-95.1119, 29.1948],
    [-95.1212, 29.1973],
    [-95.1327, 29.1922],
    [-95.1380, 29.1948],
    [-95.1505, 29.1966],
    [-95.1585, 29.1891],
    [-95.1522, 29.1865],
    [-95.1540, 29.1718],
    [-95.1546, 29.1541],
    [-95.1599, 29.1448],
    [-95.1673, 29.1212],
    [-95.1622, 29.1073],
    [-95.1607, 29.1023],
    [-95.1503, 29.0977],
    [-95.1409, 29.0879],
    [-95.1350, 29.0813],
    [-95.1232, 29.0724],
    [-95.1901, 29.0249],
    [-95.2461, 28.9832],
    [-95.2723, 28.9615],
    [-95.2949, 28.9372],
    [-95.2977, 28.9349],
    [-95.3098, 28.9283],
    [-95.3185, 28.9235],
    [-95.3307, 28.9153],
    [-95.3535, 28.8981],
    [-95.3807, 28.8772],
    [-95.3918, 28.8677],
    [-95.4339, 28.8548],
    [-95.4645, 28.8462],
    [-95.5072, 28.8256],
    [-95.6133, 28.7710],
    [-95.6481, 28.7545],
    [-95.6600, 28.7481],
    [-95.6984, 28.7265],
    [-95.8126, 28.6661],
    [-95.8903, 28.6312],
    [-95.9574, 28.6046],
    [-95.9786, 28.5957],
    [-95.9836, 28.5928],
    [-96.0245, 28.5792],
    [-96.0833, 28.5548],
    [-96.1450, 28.5267],
    [-96.2237, 28.4881],
    [-96.2962, 28.4448],
    [-96.3200, 28.4240],
    [-96.3546, 28.4101],
    [-96.3783, 28.3908],
    [-96.3897, 28.3793],
    [-96.4005, 28.3571],
    [-96.4265, 28.3308],
    [-96.4680, 28.3057],
    [-96.5429, 28.2727],
    [-96.6048, 28.2390],
    [-96.6722, 28.1970],
    [-96.7522, 28.1411],
    [-96.8514, 28.0624],
    [-96.8980, 28.0198],
    [-96.9619, 27.9559],
    [-97.0072, 27.9037],
    [-97.0252, 27.8798],
    [-97.0419, 27.8508],
    [-97.0461, 27.8395],
    [-97.0536, 27.8521],
    [-97.0451, 27.8689],
    [-97.0431, 27.8796],
    [-97.0457, 27.8900],
    [-97.0426, 27.8925],
    [-97.0380, 27.9023],
    [-97.0262, 27.9146],
    [-97.0205, 27.9170],
    [-97.0088, 27.9256],
    [-97.0025, 27.9361],
    [-97.0089, 27.9423],
    [-97.0248, 27.9385],
    [-97.0419, 27.9287],
    [-97.0458, 27.9285],
    [-97.0426, 27.9355],
    [-97.0172, 27.9457],
    [-96.9968, 27.9489],
    [-96.9869, 27.9547],
    [-96.9861, 27.9705],
    [-96.9804, 27.9923],
    [-96.9636, 28.0231],
    [-96.9560, 28.0322],
    [-96.9479, 28.0429],
    [-96.9471, 28.0535],
    [-96.9388, 28.0518],
    [-96.9333, 28.0587],
    [-96.9319, 28.0723],
    [-96.9255, 28.0884],
    [-96.9057, 28.1007],
    [-96.8805, 28.1060],
    [-96.8845, 28.1113],
    [-96.8924, 28.1136],
    [-96.8928, 28.1161],
    [-96.8826, 28.1247],
    [-96.8799, 28.1288],
    [-96.8767, 28.1314],
    [-96.8739, 28.1335],
    [-96.8632, 28.1247],
    [-96.8484, 28.1108],
    [-96.8391, 28.1115],
    [-96.8318, 28.1149],
    [-96.8284, 28.1130],
    [-96.8123, 28.1228],
    [-96.8101, 28.1291],
    [-96.8032, 28.1356],
    [-96.8056, 28.1445],
    [-96.8159, 28.1416],
    [-96.8197, 28.1447],
    [-96.8176, 28.1505],
    [-96.8167, 28.1585],
    [-96.8214, 28.1657],
    [-96.8195, 28.1681],
    [-96.8170, 28.1751],
    [-96.8057, 28.1783],
    [-96.7941, 28.1881],
    [-96.7729, 28.1896],
    [-96.7265, 28.1922],
    [-96.7018, 28.1997],
    [-96.6997, 28.2054],
    [-96.7026, 28.2155],
    [-96.6820, 28.2208],
    [-96.6627, 28.2260],
    [-96.6604, 28.2310],
    [-96.6579, 28.2408],
    [-96.6499, 28.2513],
    [-96.6291, 28.2620],
    [-96.6107, 28.2816],
    [-96.6036, 28.2926],
    [-96.5912, 28.2976],
    [-96.5714, 28.3020],
    [-96.5538, 28.3027],
    [-96.5452, 28.3121],
    [-96.5252, 28.3230],
    [-96.4679, 28.3329],
    [-96.4411, 28.3494],
    [-96.4387, 28.3688],
    [-96.4714, 28.3652],
    [-96.4614, 28.3752],
    [-96.4475, 28.3923],
    [-96.4206, 28.4044],
    [-96.4200, 28.4169],
    [-96.4530, 28.4187],
    [-96.4792, 28.4028],
    [-96.5347, 28.3741],
    [-96.5731, 28.3588],
    [-96.6016, 28.3370],
    [-96.6236, 28.3136],
    [-96.6169, 28.3078],
    [-96.6204, 28.3040],
    [-96.6255, 28.3098],
    [-96.6518, 28.3177],
    [-96.6639, 28.3104],
    [-96.6854, 28.3158],
    [-96.6999, 28.3421],
    [-96.7069, 28.3568],
    [-96.7007, 28.3606],
    [-96.6994, 28.3808],
    [-96.7058, 28.3879],
    [-96.7068, 28.3927],
    [-96.7102, 28.3962],
    [-96.7064, 28.4028],
    [-96.7085, 28.4067],
    [-96.7225, 28.4089],
    [-96.7347, 28.4092],
    [-96.7485, 28.4127],
    [-96.7540, 28.4368],
    [-96.7837, 28.4555],
    [-96.7932, 28.4761],
    [-96.8000, 28.4819],
    [-96.8231, 28.4703],
    [-96.8287, 28.4600],
    [-96.8230, 28.4570],
    [-96.8168, 28.4580],
    [-96.8107, 28.4557],
    [-96.8059, 28.4573],
    [-96.8003, 28.4618],
    [-96.7924, 28.4568],
    [-96.7842, 28.4468],
    [-96.7791, 28.4384],
    [-96.7707, 28.4286],
    [-96.7656, 28.4223],
    [-96.7654, 28.4169],
    [-96.7729, 28.4083],
    [-96.7809, 28.4011],
    [-96.8027, 28.4133],
    [-96.8187, 28.4265],
    [-96.8293, 28.4284],
    [-96.8512, 28.4259],
    [-96.8539, 28.4232],
    [-96.8596, 28.4133],
    [-96.8578, 28.4086],
    [-96.8463, 28.4001],
    [-96.8401, 28.3923],
    [-96.8359, 28.3877],
    [-96.8241, 28.3791],
    [-96.8120, 28.3713],
    [-96.7945, 28.3646],
    [-96.7915, 28.3575],
    [-96.7947, 28.3479],
    [-96.7930, 28.3457],
    [-96.7947, 28.3430],
    [-96.7901, 28.3227],
    [-96.7913, 28.3175],
    [-96.7959, 28.3078],
    [-96.8092, 28.2934],
    [-96.8003, 28.2778],
    [-96.7976, 28.2690],
    [-96.7881, 28.2555],
    [-96.7858, 28.2456],
    [-96.7768, 28.2448],
    [-96.7833, 28.2327],
    [-96.7958, 28.2241],
    [-96.8094, 28.2206],
    [-96.8117, 28.2135],
    [-96.8205, 28.2100],
    [-96.8240, 28.2015],
    [-96.8402, 28.1847],
    [-96.8438, 28.1769],
    [-96.8581, 28.1729],
    [-96.8703, 28.1666],
    [-96.8845, 28.1566],
    [-96.8869, 28.1500],
    [-96.8836, 28.1478],
    [-96.8973, 28.1457],
    [-96.9056, 28.1339],
    [-96.9085, 28.1288],
    [-96.9123, 28.1245],
    [-96.9261, 28.1143],
    [-96.9161, 28.1273],
    [-96.9121, 28.1356],
    [-96.9188, 28.1350],
    [-96.9072, 28.1469],
    [-96.9316, 28.1239],
    [-96.9607, 28.1231],
    [-96.9674, 28.1232],
    [-96.9590, 28.1262],
    [-96.9583, 28.1287],
    [-96.9597, 28.1316],
    [-96.9647, 28.1307],
    [-96.9617, 28.1334],
    [-96.9537, 28.1363],
    [-96.9449, 28.1490],
    [-96.9430, 28.1637],
    [-96.9364, 28.1728],
    [-96.9317, 28.1818],
    [-96.9251, 28.1966],
    [-96.9288, 28.2070],
    [-96.9403, 28.2145],
    [-96.9368, 28.2265],
    [-96.9319, 28.2350],
    [-96.9266, 28.2427],
    [-96.9212, 28.2534],
    [-96.9124, 28.2639],
    [-96.9180, 28.2694],
    [-96.9286, 28.2616],
    [-96.9393, 28.2509],
    [-96.9507, 28.2448],
    [-96.9526, 28.2322],
    [-96.9685, 28.2200],
    [-96.9615, 28.2107],
    [-96.9459, 28.1965],
    [-96.9521, 28.1840],
    [-96.9629, 28.1756],
    [-96.9685, 28.1679],
    [-96.9699, 28.1592],
    [-96.9735, 28.1518],
    [-96.9777, 28.1393],
    [-96.9755, 28.1326],
    [-96.9854, 28.1281],
    [-96.9834, 28.1249],
    [-96.9949, 28.1355],
    [-97.0096, 28.1347],
    [-97.0107, 28.1356],
    [-97.0112, 28.1410],
    [-97.0244, 28.1490],
    [-97.0219, 28.1515],
    [-97.0187, 28.1509],
    [-97.0152, 28.1549],
    [-97.0150, 28.1592],
    [-97.0192, 28.1624],
    [-97.0193, 28.1642],
    [-97.0185, 28.1756],
    [-97.0177, 28.1786],
    [-97.0183, 28.1835],
    [-97.0089, 28.1877],
    [-97.0073, 28.1905],
    [-97.0114, 28.1984],
    [-97.0087, 28.2020],
    [-97.0107, 28.2031],
    [-97.0161, 28.2027],
    [-97.0212, 28.1989],
    [-97.0465, 28.1850],
    [-97.0951, 28.1657],
    [-97.1385, 28.1434],
    [-97.1539, 28.1367],
    [-97.1858, 28.1140],
    [-97.1994, 28.1036],
    [-97.2123, 28.0922],
    [-97.2228, 28.0773],
    [-97.2200, 28.0727],
    [-97.1790, 28.0585],
    [-97.1720, 28.0428],
    [-97.1639, 28.0470],
    [-97.1607, 28.0437],
    [-97.1541, 28.0331],
    [-97.1289, 28.0292],
    [-97.1199, 28.0216],
    [-97.1085, 28.0331],
    [-97.1087, 28.0394],
    [-97.1124, 28.0420],
    [-97.1261, 28.0394],
    [-97.1291, 28.0430],
    [-97.1326, 28.0500],
    [-97.1251, 28.0504],
    [-97.1198, 28.0559],
    [-97.1118, 28.0594],
    [-97.1128, 28.0639],
    [-97.1076, 28.0708],
    [-97.0954, 28.0787],
    [-97.0867, 28.0790],
    [-97.0770, 28.0835],
    [-97.0623, 28.0883],
    [-97.0542, 28.0928],
    [-97.0469, 28.1020],
    [-97.0471, 28.1147],
    [-97.0534, 28.1183],
    [-97.0296, 28.1128],
    [-97.0248, 28.1129],
    [-97.0228, 28.1076],
    [-97.0291, 28.0993],
    [-97.0346, 28.0870],
    [-97.0360, 28.0817],
    [-97.0354, 28.0673],
    [-97.0329, 28.0642],
    [-97.0331, 28.0603],
    [-97.0332, 28.0542],
    [-97.0324, 28.0529],
    [-97.0309, 28.0505],
    [-97.0252, 28.0321],
    [-97.0406, 28.0287],
    [-97.0488, 28.0221],
    [-97.0620, 27.9961],
    [-97.0644, 27.9922],
    [-97.0681, 27.9740],
    [-97.0709, 27.9532],
    [-97.0721, 27.9473],
    [-97.0759, 27.9330],
    [-97.0756, 27.9228],
    [-97.0787, 27.9186],
    [-97.0806, 27.9320],
    [-97.0768, 27.9437],
    [-97.0757, 27.9512],
    [-97.0749, 27.9638],
    [-97.0790, 27.9675],
    [-97.0749, 27.9749],
    [-97.0854, 27.9719],
    [-97.0886, 27.9689],
    [-97.1215, 27.9228],
    [-97.1314, 27.9166],
    [-97.1314, 27.9070],
    [-97.1339, 27.9011],
    [-97.1356, 27.8970],
    [-97.1413, 27.8867],
    [-97.1488, 27.8852],
    [-97.1547, 27.8768],
    [-97.1584, 27.8720],
    [-97.1618, 27.8690],
    [-97.1712, 27.8539],
    [-97.1857, 27.8307],
    [-97.1876, 27.8272],
    [-97.1899, 27.8236],
    [-97.1951, 27.8219],
    [-97.2113, 27.8210],
    [-97.2163, 27.8226],
    [-97.2249, 27.8267],
    [-97.2241, 27.8318],
    [-97.2214, 27.8374],
    [-97.2214, 27.8389],
    [-97.2257, 27.8436],
    [-97.2278, 27.8470],
    [-97.2309, 27.8478],
    [-97.2385, 27.8576],
    [-97.2429, 27.8643],
    [-97.2441, 27.8677],
    [-97.2486, 27.8753],
    [-97.2573, 27.8781],
    [-97.2630, 27.8801],
    [-97.2731, 27.8814],
    [-97.2870, 27.8791],
    [-97.2981, 27.8770],
    [-97.3251, 27.8679],
    [-97.3566, 27.8523],
    [-97.3600, 27.8525],
    [-97.3474, 27.8614],
    [-97.3359, 27.8704],
    [-97.3317, 27.8756],
    [-97.3378, 27.8836],
    [-97.3454, 27.8834],
    [-97.3576, 27.8811],
    [-97.3612, 27.8760],
    [-97.3707, 27.8762],
    [-97.3732, 27.8759],
    [-97.3778, 27.8749],
    [-97.3872, 27.8754],
    [-97.4022, 27.8764],
    [-97.4184, 27.8704],
    [-97.4328, 27.8717],
    [-97.4466, 27.8689],
    [-97.4550, 27.8720],
    [-97.4549, 27.8750],
    [-97.4598, 27.8785],
    [-97.4582, 27.8703],
    [-97.4629, 27.8630],
    [-97.4682, 27.8703],
    [-97.4704, 27.8692],
    [-97.4698, 27.8658],
    [-97.4735, 27.8619],
    [-97.4776, 27.8607],
    [-97.4855, 27.8614],
    [-97.4831, 27.8728],
    [-97.4910, 27.8798],
    [-97.4966, 27.8815],
    [-97.5069, 27.8783],
    [-97.5087, 27.8742],
    [-97.5169, 27.8708],
    [-97.5151, 27.8512],
    [-97.4903, 27.8454],
    [-97.4903, 27.8409],
    [-97.4910, 27.8392],
    [-97.4851, 27.8308],
    [-97.4721, 27.8242],
    [-97.4569, 27.8251],
    [-97.4479, 27.8304],
    [-97.4356, 27.8324],
    [-97.4292, 27.8284],
    [-97.4192, 27.8230],
    [-97.4136, 27.8276],
    [-97.4098, 27.8334],
    [-97.3930, 27.8368],
    [-97.3900, 27.8383],
    [-97.3862, 27.8400],
    [-97.3789, 27.8359],
    [-97.3898, 27.8167],
    [-97.3927, 27.8107],
    [-97.3911, 27.8005],
    [-97.3910, 27.7952],
    [-97.3931, 27.7868],
    [-97.3933, 27.7837],
    [-97.3910, 27.7763],
    [-97.3886, 27.7735],
    [-97.3886, 27.7715],
    [-97.3799, 27.7637],
    [-97.3762, 27.7571],
    [-97.3741, 27.7481],
    [-97.3656, 27.7388],
    [-97.3592, 27.7337],
    [-97.3523, 27.7294],
    [-97.3476, 27.7268],
    [-97.3422, 27.7234],
    [-97.3313, 27.7189],
    [-97.3081, 27.7103],
    [-97.2914, 27.7056],
    [-97.2857, 27.7050],
    [-97.2540, 27.6967],
    [-97.2449, 27.6929],
    [-97.2461, 27.6896],
    [-97.2560, 27.6917],
    [-97.2661, 27.6786],
    [-97.2730, 27.6638],
    [-97.2771, 27.6552],
    [-97.2911, 27.6255],
    [-97.2938, 27.6199],
    [-97.2966, 27.6116],
    [-97.2965, 27.6099],
    [-97.2993, 27.6060],
    [-97.2973, 27.5969],
    [-97.2941, 27.5941],
    [-97.3022, 27.5860],
    [-97.3222, 27.5691],
    [-97.3289, 27.5501],
    [-97.3329, 27.5386],
    [-97.3388, 27.5245],
    [-97.3447, 27.5130],
    [-97.3499, 27.4912],
    [-97.3511, 27.4818],
    [-97.3586, 27.4677],
    [-97.3643, 27.4508],
    [-97.3674, 27.4357],
    [-97.3683, 27.4178],
    [-97.3763, 27.3955],
    [-97.3833, 27.3814],
    [-97.3888, 27.3689],
    [-97.4019, 27.3356],
    [-97.4210, 27.3184],
    [-97.4395, 27.3137],
    [-97.4905, 27.2919],
    [-97.5107, 27.2771],
    [-97.5174, 27.2787],
    [-97.5322, 27.2786],
    [-97.5472, 27.2895],
    [-97.5437, 27.2910],
    [-97.5340, 27.2870],
    [-97.5259, 27.2906],
    [-97.5227, 27.2998],
    [-97.5183, 27.3042],
    [-97.5006, 27.3066],
    [-97.4978, 27.3143],
    [-97.5006, 27.3207],
    [-97.5012, 27.3282],
    [-97.4901, 27.3342],
    [-97.4825, 27.3431],
    [-97.4829, 27.3491],
    [-97.4878, 27.3523],
    [-97.4823, 27.3608],
    [-97.4826, 27.3688],
    [-97.4815, 27.3749],
    [-97.4861, 27.3853],
    [-97.4967, 27.3872],
    [-97.4974, 27.3741],
    [-97.5096, 27.3681],
    [-97.5145, 27.3602],
    [-97.5277, 27.3495],
    [-97.5337, 27.3400],
    [-97.5496, 27.3297],
    [-97.5838, 27.3091],
    [-97.6130, 27.2852],
    [-97.6242, 27.2906],
    [-97.6306, 27.2974],
    [-97.6320, 27.3044],
    [-97.6314, 27.3106],
    [-97.6326, 27.3139],
    [-97.6325, 27.3206],
    [-97.6363, 27.3245],
    [-97.6514, 27.3246],
    [-97.6597, 27.3334],
    [-97.6669, 27.3439],
    [-97.6644, 27.3523],
    [-97.6601, 27.3577],
    [-97.6684, 27.3640],
    [-97.6780, 27.3683],
    [-97.6798, 27.3762],
    [-97.6931, 27.3810],
    [-97.7088, 27.3856],
    [-97.7117, 27.3768],
    [-97.7049, 27.3679],
    [-97.6977, 27.3586],
    [-97.6972, 27.3537],
    [-97.6935, 27.3470],
    [-97.6917, 27.3384],
    [-97.6895, 27.3318],
    [-97.6837, 27.3258],
    [-97.6818, 27.3195],
    [-97.6751, 27.3109],
    [-97.6699, 27.3098],
    [-97.6549, 27.3051],
    [-97.6613, 27.2889],
    [-97.6759, 27.2830],
    [-97.6929, 27.2801],
    [-97.7049, 27.2755],
    [-97.7154, 27.2757],
    [-97.7267, 27.2714],
    [-97.7351, 27.2736],
    [-97.7400, 27.2712],
    [-97.7337, 27.2641],
    [-97.7237, 27.2629],
    [-97.7098, 27.2628],
    [-97.6999, 27.2684],
    [-97.6916, 27.2673],
    [-97.6776, 27.2701],
    [-97.6548, 27.2752],
    [-97.6401, 27.2709],
    [-97.6352, 27.2453],
    [-97.6171, 27.2417],
    [-97.5826, 27.2404],
    [-97.5566, 27.2319],
    [-97.5200, 27.2312],
    [-97.5002, 27.2445],
    [-97.4792, 27.2506],
    [-97.4654, 27.2559],
    [-97.4479, 27.2627],
    [-97.4226, 27.2620],
    [-97.4416, 27.1638],
    [-97.4344, 27.1451],
    [-97.4394, 27.0765],
    [-97.4179, 27.0709],
    [-97.4441, 26.9872],
    [-97.4450, 26.9797],
    [-97.4533, 26.9173],
    [-97.4373, 26.9131],
    [-97.4532, 26.9105],
    [-97.4495, 26.8820],
    [-97.4124, 26.8781],
    [-97.4542, 26.8744],
    [-97.4603, 26.8473],
    [-97.4329, 26.8295],
    [-97.4127, 26.8174],
    [-97.4338, 26.8215],
    [-97.4471, 26.8223],
    [-97.4648, 26.8240],
    [-97.4786, 26.8067],
    [-97.4717, 26.7587],
    [-97.4669, 26.7222],
    [-97.4654, 26.7136],
    [-97.4670, 26.7089],
    [-97.4646, 26.6981],
    [-97.4623, 26.6891],
    [-97.4601, 26.6824],
    [-97.4566, 26.6672],
    [-97.4483, 26.6450],
    [-97.4470, 26.6249],
    [-97.4457, 26.6094],
    [-97.4406, 26.5999],
    [-97.4333, 26.5884],
    [-97.4328, 26.5821],
    [-97.4282, 26.5725],
    [-97.4252, 26.5582],
    [-97.4208, 26.5544],
    [-97.4154, 26.5528],
    [-97.4184, 26.5446],
    [-97.4192, 26.5272],
    [-97.4145, 26.5153],
    [-97.4068, 26.4995],
    [-97.4131, 26.4812],
    [-97.3757, 26.4696],
    [-97.3470, 26.4078],
    [-97.3298, 26.3681],
    [-97.3234, 26.3524],
    [-97.2957, 26.2955],
    [-97.2812, 26.2805],
    [-97.2862, 26.2675],
    [-97.2766, 26.2383],
    [-97.2703, 26.2131],
    [-97.2906, 26.2711],
    [-97.3065, 26.2836],
    [-97.3098, 26.2883],
    [-97.3243, 26.2773],
    [-97.3160, 26.2709],
    [-97.3062, 26.2740],
    [-97.2988, 26.2607],
    [-97.3003, 26.2531],
    [-97.3072, 26.2397],
    [-97.3107, 26.2276],
    [-97.3167, 26.2240],
    [-97.3045, 26.2025],
    [-97.2988, 26.2032],
    [-97.2961, 26.1824],
    [-97.3036, 26.1662],
    [-97.2993, 26.1597],
    [-97.2959, 26.1515],
    [-97.2966, 26.1424],
    [-97.2831, 26.1178],
    [-97.2941, 26.1139],
    [-97.2945, 26.1113],
    [-97.2943, 26.1058],
    [-97.2876, 26.1013],
    [-97.2810, 26.0934],
    [-97.2662, 26.0853],
    [-97.2470, 26.0804],
    [-97.2197, 26.0791],
    [-97.2047, 26.0778],
    [-97.1979, 26.0745],
    [-97.1917, 26.0715],
    [-97.1983, 26.0667],
    [-97.1827, 26.0531],
    [-97.1586, 26.0609],
    [-97.1497, 26.0641],
    [-97.1532, 26.0389],
    [-97.1469, 25.9698],
    [-97.1473, 25.9533],
    [-97.1590, 25.9491],
    [-97.1582, 25.9604],
    [-97.1632, 25.9610],
    [-97.1719, 25.9623],
    [-97.1773, 25.9650],
    [-97.1831, 25.9598],
    [-97.1871, 25.9556],
    [-97.1945, 25.9552],
    [-97.2006, 25.9583],
    [-97.2066, 25.9619],
    [-97.2110, 25.9627],
    [-97.2209, 25.9573],
    [-97.2254, 25.9591],
    [-97.2370, 25.9560],
    [-97.2447, 25.9514],
    [-97.2496, 25.9483],
    [-97.2573, 25.9501],
    [-97.2767, 25.9521],
    [-97.2828, 25.9592],
    [-97.2894, 25.9538],
    [-97.2818, 25.9482],
    [-97.2804, 25.9454],
    [-97.2769, 25.9382],
    [-97.2800, 25.9351],
    [-97.2937, 25.9353],
    [-97.2978, 25.9338],
    [-97.3030, 25.9370],
    [-97.3048, 25.9284],
    [-97.3115, 25.9275],
    [-97.3184, 25.9311],
    [-97.3247, 25.9186],
    [-97.3296, 25.9177],
    [-97.3351, 25.9198],
    [-97.3365, 25.9292],
    [-97.3407, 25.9290],
    [-97.3483, 25.9311],
    [-97.3554, 25.9194],
    [-97.3668, 25.9157],
    [-97.3691, 25.9146],
    [-97.3684, 25.9099],
    [-97.3749, 25.9085],
    [-97.3724, 25.9050],
    [-97.3672, 25.8943],
    [-97.3634, 25.8897],
    [-97.3566, 25.8877],
    [-97.3669, 25.8850],
    [-97.3733, 25.8785],
    [-97.3599, 25.8799],
    [-97.3591, 25.8720],
    [-97.3601, 25.8696],
    [-97.3673, 25.8615],
    [-97.3762, 25.8557],
    [-97.3706, 25.8544],
    [-97.3641, 25.8500],
    [-97.3706, 25.8498],
    [-97.3729, 25.8401],
    [-97.3826, 25.8398],
    [-97.3884, 25.8421],
    [-97.3964, 25.8377],
    [-97.4036, 25.8377],
    [-97.4065, 25.8403],
    [-97.4004, 25.8420],
    [-97.3991, 25.8496],
    [-97.4008, 25.8523],
    [-97.4053, 25.8476],
    [-97.4082, 25.8456],
    [-97.4085, 25.8543],
    [-97.4086, 25.8595],
    [-97.4100, 25.8621],
    [-97.4131, 25.8587],
    [-97.4134, 25.8524],
    [-97.4136, 25.8440],
    [-97.4167, 25.8413],
    [-97.4278, 25.8422],
    [-97.4353, 25.8494],
    [-97.4430, 25.8481],
    [-97.4453, 25.8528],
    [-97.4463, 25.8564],
    [-97.4541, 25.8548],
    [-97.4507, 25.8593],
    [-97.4476, 25.8633],
    [-97.4455, 25.8692],
    [-97.4500, 25.8719],
    [-97.4562, 25.8678],
    [-97.4562, 25.8733],
    [-97.4557, 25.8840],
    [-97.4674, 25.8780],
    [-97.4741, 25.8765],
    [-97.4721, 25.8813],
    [-97.4687, 25.8886],
    [-97.4818, 25.8800],
    [-97.4876, 25.8790],
    [-97.4885, 25.8854],
    [-97.4911, 25.8826],
    [-97.4967, 25.8797],
    [-97.4975, 25.8882],
    [-97.4989, 25.8987],
    [-97.5048, 25.8920],
    [-97.5112, 25.8874],
    [-97.5198, 25.8860],
    [-97.5230, 25.8935],
    [-97.5249, 25.9001],
    [-97.5284, 25.9063],
    [-97.5329, 25.9076],
    [-97.5304, 25.9163],
    [-97.5377, 25.9197],
    [-97.5409, 25.9244],
    [-97.5464, 25.9341],
    [-97.5554, 25.9371],
    [-97.5665, 25.9340],
    [-97.5809, 25.9394],
    [-97.5708, 25.9424],
    [-97.5660, 25.9467],
    [-97.5666, 25.9493],
    [-97.5737, 25.9539],
    [-97.5730, 25.9486],
    [-97.5774, 25.9430],
    [-97.5805, 25.9466],
    [-97.5822, 25.9590],
    [-97.5838, 25.9623],
    [-97.5947, 25.9612],
    [-97.6021, 25.9574],
    [-97.6081, 25.9713],
    [-97.6104, 25.9776],
    [-97.6189, 25.9819],
    [-97.6217, 25.9891],
    [-97.6316, 25.9882],
    [-97.6338, 25.9933],
    [-97.6268, 25.9948],
    [-97.6219, 25.9917],
    [-97.6184, 25.9961],
    [-97.6193, 26.0029],
    [-97.6223, 25.9983],
    [-97.6283, 25.9976],
    [-97.6265, 26.0056],
    [-97.6315, 26.0039],
    [-97.6396, 26.0042],
    [-97.6477, 26.0085],
    [-97.6460, 26.0125],
    [-97.6384, 26.0131],
    [-97.6375, 26.0206],
    [-97.6445, 26.0273],
    [-97.6497, 26.0244],
    [-97.6508, 26.0197],
    [-97.6528, 26.0163],
    [-97.6605, 26.0201],
    [-97.6683, 26.0198],
    [-97.6633, 26.0278],
    [-97.6617, 26.0360],
    [-97.6642, 26.0339],
    [-97.6680, 26.0289],
    [-97.6712, 26.0340],
    [-97.6745, 26.0330],
    [-97.6745, 26.0288],
    [-97.6782, 26.0259],
    [-97.6887, 26.0282],
    [-97.6939, 26.0313],
    [-97.6925, 26.0246],
    [-97.6914, 26.0190],
    [-97.6971, 26.0235],
    [-97.6994, 26.0312],
    [-97.7047, 26.0361],
    [-97.7095, 26.0331],
    [-97.7148, 26.0253],
    [-97.7206, 26.0257],
    [-97.7199, 26.0308],
    [-97.7329, 26.0316],
    [-97.7331, 26.0274],
    [-97.7254, 26.0244],
    [-97.7317, 26.0233],
    [-97.7380, 26.0239],
    [-97.7374, 26.0285],
    [-97.7447, 26.0290],
    [-97.7494, 26.0273],
    [-97.7516, 26.0315],
    [-97.7585, 26.0266],
    [-97.7640, 26.0295],
    [-97.7652, 26.0449],
    [-97.7717, 26.0463],
    [-97.7765, 26.0407],
    [-97.7694, 26.0356],
    [-97.7762, 26.0301],
    [-97.7831, 26.0340],
    [-97.7976, 26.0402],
    [-97.7898, 26.0474],
    [-97.7922, 26.0529],
    [-97.7991, 26.0533],
    [-97.8013, 26.0602],
    [-97.8082, 26.0579],
    [-97.8124, 26.0484],
    [-97.8129, 26.0443],
    [-97.8165, 26.0471],
    [-97.8156, 26.0547],
    [-97.8242, 26.0561],
    [-97.8283, 26.0516],
    [-97.8347, 26.0460],
    [-97.8374, 26.0524],
    [-97.8496, 26.0521],
    [-97.8605, 26.0529],
    [-97.8599, 26.0646],
    [-97.8613, 26.0699],
    [-97.8657, 26.0640],
    [-97.8722, 26.0597],
    [-97.8813, 26.0656],
    [-97.8884, 26.0649],
    [-97.8937, 26.0602],
    [-97.9099, 26.0569],
    [-97.9197, 26.0578],
    [-97.9280, 26.0559],
    [-97.9322, 26.0645],
    [-97.9370, 26.0619],
    [-97.9318, 26.0559],
    [-97.9388, 26.0543],
    [-97.9501, 26.0618],
    [-97.9590, 26.0573],
    [-97.9718, 26.0548],
    [-97.9800, 26.0639],
    [-97.9843, 26.0665],
    [-97.9895, 26.0604],
    [-97.9947, 26.0607],
    [-98.0013, 26.0650],
    [-98.0079, 26.0608],
    [-98.0130, 26.0564],
    [-98.0109, 26.0630],
    [-98.0155, 26.0624],
    [-98.0223, 26.0598],
    [-98.0264, 26.0665],
    [-98.0321, 26.0632],
    [-98.0344, 26.0543],
    [-98.0376, 26.0453],
    [-98.0441, 26.0435],
    [-98.0619, 26.0465],
    [-98.0732, 26.0365],
    [-98.0800, 26.0420],
    [-98.0700, 26.0480],
    [-98.0751, 26.0599],
    [-98.0848, 26.0708],
    [-98.0819, 26.0637],
    [-98.0976, 26.0603],
    [-98.1198, 26.0644],
    [-98.1308, 26.0637],
    [-98.1284, 26.0724],
    [-98.1315, 26.0742],
    [-98.1368, 26.0679],
    [-98.1448, 26.0496],
    [-98.1495, 26.0558],
    [-98.1556, 26.0566],
    [-98.1619, 26.0545],
    [-98.1584, 26.0627],
    [-98.1688, 26.0630],
    [-98.1740, 26.0731],
    [-98.1794, 26.0738],
    [-98.1798, 26.0650],
    [-98.1779, 26.0600],
    [-98.1843, 26.0639],
    [-98.1900, 26.0581],
    [-98.1940, 26.0533],
    [-98.2035, 26.0639],
    [-98.2114, 26.0685],
    [-98.2168, 26.0744],
    [-98.2437, 26.0737],
    [-98.2510, 26.0741],
    [-98.2608, 26.0834],
    [-98.2661, 26.0899],
    [-98.2719, 26.0954],
    [-98.2836, 26.1009],
    [-98.2882, 26.1048],
    [-98.2848, 26.1073],
    [-98.2758, 26.1067],
    [-98.2704, 26.1080],
    [-98.2712, 26.1142],
    [-98.2654, 26.1187],
    [-98.2702, 26.1194],
    [-98.2746, 26.1159],
    [-98.2921, 26.1206],
    [-98.2995, 26.1175],
    [-98.3021, 26.1117],
    [-98.3004, 26.1056],
    [-98.2988, 26.1026],
    [-98.3090, 26.1116],
    [-98.3110, 26.1152],
    [-98.3180, 26.1169],
    [-98.3352, 26.1376],
    [-98.3274, 26.1421],
    [-98.3321, 26.1454],
    [-98.3384, 26.1513],
    [-98.3333, 26.1588],
    [-98.3368, 26.1664],
    [-98.3458, 26.1660],
    [-98.3487, 26.1549],
    [-98.3523, 26.1511],
    [-98.3585, 26.1610],
    [-98.3581, 26.1701],
    [-98.3649, 26.1699],
    [-98.3661, 26.1650],
    [-98.3650, 26.1592],
    [-98.3710, 26.1573],
    [-98.3791, 26.1571],
    [-98.3872, 26.1583],
    [-98.3943, 26.1686],
    [-98.4027, 26.1733],
    [-98.4075, 26.1834],
    [-98.4243, 26.1909],
    [-98.4425, 26.1992],
    [-98.4436, 26.2057],
    [-98.4403, 26.2194],
    [-98.4493, 26.2233],
    [-98.4564, 26.2184],
    [-98.4607, 26.2261],
    [-98.4704, 26.2207],
    [-98.4833, 26.2164],
    [-98.4790, 26.2094],
    [-98.4784, 26.2023],
    [-98.4828, 26.2040],
    [-98.4838, 26.2116],
    [-98.4951, 26.2121],
    [-98.5061, 26.2090],
    [-98.5039, 26.2175],
    [-98.5029, 26.2235],
    [-98.5087, 26.2255],
    [-98.5191, 26.2249],
    [-98.5248, 26.2219],
    [-98.5260, 26.2287],
    [-98.5245, 26.2356],
    [-98.5316, 26.2265],
    [-98.5371, 26.2277],
    [-98.5435, 26.2424],
    [-98.5524, 26.2465],
    [-98.5588, 26.2459],
    [-98.5498, 26.2412],
    [-98.5460, 26.2369],
    [-98.5512, 26.2333],
    [-98.5592, 26.2263],
    [-98.5650, 26.2269],
    [-98.5650, 26.2386],
    [-98.5676, 26.2416],
    [-98.5766, 26.2338],
    [-98.5811, 26.2379],
    [-98.5847, 26.2454],
    [-98.5801, 26.2536],
    [-98.5875, 26.2578],
    [-98.6000, 26.2573],
    [-98.6096, 26.2533],
    [-98.6161, 26.2468],
    [-98.6183, 26.2478],
    [-98.6217, 26.2588],
    [-98.6277, 26.2558],
    [-98.6331, 26.2487],
    [-98.6363, 26.2419],
    [-98.6485, 26.2395],
    [-98.6620, 26.2352],
    [-98.6790, 26.2456],
    [-98.6785, 26.2584],
    [-98.6838, 26.2644],
    [-98.6989, 26.2656],
    [-98.7199, 26.2727],
    [-98.7178, 26.2776],
    [-98.7012, 26.2780],
    [-98.7018, 26.2862],
    [-98.7094, 26.2892],
    [-98.7199, 26.2911],
    [-98.7278, 26.2988],
    [-98.7361, 26.2979],
    [-98.7440, 26.2943],
    [-98.7548, 26.3017],
    [-98.7542, 26.3079],
    [-98.7404, 26.3028],
    [-98.7363, 26.3102],
    [-98.7406, 26.3148],
    [-98.7482, 26.3206],
    [-98.7495, 26.3300],
    [-98.7566, 26.3310],
    [-98.7682, 26.3253],
    [-98.7749, 26.3253],
    [-98.7898, 26.3316],
    [-98.7901, 26.3405],
    [-98.7976, 26.3542],
    [-98.8022, 26.3655],
    [-98.8073, 26.3694],
    [-98.8166, 26.3677],
    [-98.8246, 26.3707],
    [-98.8329, 26.3633],
    [-98.8468, 26.3595],
    [-98.8532, 26.3649],
    [-98.8614, 26.3660],
    [-98.8729, 26.3617],
    [-98.8967, 26.3533],
    [-98.9010, 26.3614],
    [-98.9010, 26.3707],
    [-98.9032, 26.3720],
    [-98.9193, 26.3767],
    [-98.9237, 26.3863],
    [-98.9247, 26.3933],
    [-98.9287, 26.3937],
    [-98.9358, 26.3843],
    [-98.9347, 26.3741],
    [-98.9422, 26.3697],
    [-98.9561, 26.3776],
    [-98.9533, 26.3847],
    [-98.9541, 26.3939],
    [-98.9614, 26.3980],
    [-98.9732, 26.4008],
    [-98.9792, 26.3999],
    [-98.9833, 26.3957],
    [-98.9886, 26.3918],
    [-99.0008, 26.3924],
    [-99.0095, 26.3922],
    [-99.0146, 26.3964],
    [-99.0175, 26.4023],
    [-99.0242, 26.4094],
    [-99.0317, 26.4130],
    [-99.0412, 26.4123],
    [-99.0500, 26.4053],
    [-99.0642, 26.3972],
    [-99.0762, 26.3968],
    [-99.0851, 26.3988],
    [-99.0948, 26.4110],
    [-99.1013, 26.4188],
    [-99.1084, 26.4251],
    [-99.1138, 26.4340],
    [-99.1067, 26.4380],
    [-99.1024, 26.4438],
    [-99.1006, 26.4519],
    [-99.0991, 26.4619],
    [-99.0920, 26.4724],
    [-99.0966, 26.4844],
    [-99.1131, 26.5095],
    [-99.1215, 26.5183],
    [-99.1386, 26.5276],
    [-99.1667, 26.5361],
    [-99.1714, 26.5498],
    [-99.1680, 26.5578],
    [-99.1781, 26.6205],
    [-99.2099, 26.6939],
    [-99.2424, 26.7883],
    [-99.2686, 26.8432],
    [-99.2951, 26.8654],
    [-99.3209, 26.8706],
    [-99.3257, 26.8772],
    [-99.3265, 26.8855],
    [-99.3230, 26.9125],
    [-99.3373, 26.9228],
    [-99.3611, 26.9289],
    [-99.3791, 26.9345],
    [-99.3905, 26.9517],
    [-99.3931, 26.9640],
    [-99.3773, 26.9738],
    [-99.3843, 26.9810],
    [-99.3922, 26.9875],
    [-99.4070, 27.0066],
    [-99.4121, 27.0131],
    [-99.4294, 27.0108],
    [-99.4387, 27.0146],
    [-99.4461, 27.0233],
    [-99.4440, 27.0362],
    [-99.4481, 27.0497],
    [-99.4520, 27.0601],
    [-99.4452, 27.0716],
    [-99.4292, 27.0931],
    [-99.4418, 27.1054],
    [-99.4411, 27.1100],
    [-99.4314, 27.1376],
    [-99.4400, 27.1511],
    [-99.4349, 27.1559],
    [-99.4277, 27.1678],
    [-99.4277, 27.1823],
    [-99.4331, 27.2038],
    [-99.4333, 27.2113],
    [-99.4452, 27.2233],
    [-99.4414, 27.2368],
    [-99.4431, 27.2527],
    [-99.4524, 27.2640],
    [-99.4562, 27.2663],
    [-99.4633, 27.2684],
    [-99.4730, 27.2634],
    [-99.4847, 27.2594],
    [-99.4957, 27.2691],
    [-99.4938, 27.2794],
    [-99.4879, 27.2949],
    [-99.5020, 27.3061],
    [-99.5237, 27.3041],
    [-99.5378, 27.3161],
    [-99.5314, 27.3238],
    [-99.5150, 27.3289],
    [-99.5072, 27.3354],
    [-99.5071, 27.3461],
    [-99.5053, 27.3597],
    [-99.5039, 27.3630],
    [-99.4991, 27.3731],
    [-99.4921, 27.3805],
    [-99.4926, 27.3923],
    [-99.4879, 27.4099],
    [-99.4902, 27.4211],
    [-99.4954, 27.4462],
    [-99.4951, 27.4515],
    [-99.4853, 27.4645],
    [-99.4793, 27.4786],
    [-99.4815, 27.4887],
    [-99.4915, 27.4970],
    [-99.4990, 27.4992],
    [-99.5097, 27.4989],
    [-99.5164, 27.4984],
    [-99.5283, 27.4989],
    [-99.5254, 27.5163],
    [-99.5233, 27.5303],
    [-99.5219, 27.5441],
    [-99.5111, 27.5645],
    [-99.5160, 27.5721],
    [-99.5287, 27.5791],
    [-99.5362, 27.5917],
    [-99.5397, 27.6033],
    [-99.5544, 27.6140],
    [-99.5586, 27.6111],
    [-99.5629, 27.6073],
    [-99.5788, 27.6026],
    [-99.5844, 27.6062],
    [-99.5774, 27.6109],
    [-99.5779, 27.6188],
    [-99.5808, 27.6203],
    [-99.5924, 27.6286],
    [-99.5962, 27.6399],
    [-99.6123, 27.6392],
    [-99.6191, 27.6401],
    [-99.6243, 27.6440],
    [-99.6271, 27.6384],
    [-99.6253, 27.6311],
    [-99.6389, 27.6268],
    [-99.6543, 27.6296],
    [-99.6659, 27.6360],
    [-99.6617, 27.6427],
    [-99.6583, 27.6502],
    [-99.6618, 27.6558],
    [-99.6716, 27.6602],
    [-99.6883, 27.6628],
    [-99.6913, 27.6687],
    [-99.6987, 27.6574],
    [-99.7115, 27.6584],
    [-99.7237, 27.6733],
    [-99.7378, 27.6923],
    [-99.7585, 27.7171],
    [-99.7707, 27.7321],
    [-99.7888, 27.7307],
    [-99.8017, 27.7418],
    [-99.8101, 27.7695],
    [-99.8172, 27.7762],
    [-99.8258, 27.7644],
    [-99.8417, 27.7665],
    [-99.8447, 27.7788],
    [-99.8509, 27.7940],
    [-99.8555, 27.7941],
    [-99.8630, 27.7943],
    [-99.8766, 27.7974],
    [-99.8746, 27.8093],
    [-99.8753, 27.8182],
    [-99.8778, 27.8244],
    [-99.8760, 27.8380],
    [-99.8840, 27.8510],
    [-99.8957, 27.8577],
    [-99.9044, 27.8753],
    [-99.8969, 27.8884],
    [-99.8958, 27.9042],
    [-99.9175, 27.9180],
    [-99.9262, 27.9273],
    [-99.9265, 27.9356],
    [-99.9346, 27.9382],
    [-99.9385, 27.9541],
    [-99.9313, 27.9791],
    [-99.9408, 27.9824],
    [-99.9628, 27.9835],
    [-99.9784, 27.9893],
    [-99.9914, 27.9946],
    [-100.0040, 28.0152],
    [-100.0128, 28.0372],
    [-100.0150, 28.0489],
    [-100.0179, 28.0648],
    [-100.0287, 28.0731],
    [-100.0531, 28.0847],
    [-100.0556, 28.1011],
    [-100.0601, 28.1082],
    [-100.0726, 28.1222],
    [-100.0778, 28.1287],
    [-100.0827, 28.1404],
    [-100.0903, 28.1483],
    [-100.1153, 28.1549],
    [-100.1579, 28.1674],
    [-100.1713, 28.1762],
    [-100.1965, 28.1902],
    [-100.2121, 28.1965],
    [-100.2135, 28.2075],
    [-100.2162, 28.2215],
    [-100.2236, 28.2352],
    [-100.2349, 28.2353],
    [-100.2516, 28.2362],
    [-100.2676, 28.2503],
    [-100.2830, 28.2704],
    [-100.2914, 28.2754],
    [-100.2943, 28.2844],
    [-100.2865, 28.3123],
    [-100.3041, 28.3344],
    [-100.3107, 28.3435],
    [-100.3160, 28.3500],
    [-100.3293, 28.3723],
    [-100.3419, 28.3850],
    [-100.3481, 28.3981],
    [-100.3470, 28.4072],
    [-100.3371, 28.4272],
    [-100.3378, 28.4430],
    [-100.3484, 28.4560],
    [-100.3627, 28.4699],
    [-100.3681, 28.4790],
    [-100.3572, 28.4821],
    [-100.3371, 28.4917],
    [-100.3338, 28.4993],
    [-100.3444, 28.5034],
    [-100.3597, 28.5073],
    [-100.3791, 28.5116],
    [-100.3950, 28.5284],
    [-100.4005, 28.5313],
    [-100.4114, 28.5519],
    [-100.4043, 28.5638],
    [-100.3984, 28.5849],
    [-100.4062, 28.5887],
    [-100.4232, 28.5942],
    [-100.4321, 28.5990],
    [-100.4353, 28.6070],
    [-100.4473, 28.6093],
    [-100.4470, 28.6332],
    [-100.4457, 28.6406],
    [-100.4503, 28.6430],
    [-100.4629, 28.6414],
    [-100.4796, 28.6552],
    [-100.4893, 28.6580],
    [-100.4981, 28.6596],
    [-100.5019, 28.6676],
    [-100.5101, 28.6907],
    [-100.5120, 28.7054],
    [-100.5091, 28.7111],
    [-100.5067, 28.7167],
    [-100.5077, 28.7255],
    [-100.5068, 28.7320],
    [-100.5077, 28.7407],
    [-100.5142, 28.7421],
    [-100.5144, 28.7503],
    [-100.5216, 28.7576],
    [-100.5294, 28.7564],
    [-100.5330, 28.7633],
    [-100.5303, 28.7713],
    [-100.5378, 28.7808],
    [-100.5338, 28.7874],
    [-100.5358, 28.8059],
    [-100.5455, 28.8126],
    [-100.5473, 28.8258],
    [-100.5614, 28.8292],
    [-100.5705, 28.8263],
    [-100.5768, 28.8362],
    [-100.5882, 28.8602],
    [-100.5908, 28.8706],
    [-100.5976, 28.8738],
    [-100.5961, 28.8816],
    [-100.5912, 28.8889],
    [-100.5973, 28.8878],
    [-100.6038, 28.8884],
    [-100.6013, 28.8991],
    [-100.6074, 28.9023],
    [-100.6170, 28.9071],
    [-100.6235, 28.9096],
    [-100.6272, 28.9037],
    [-100.6338, 28.9060],
    [-100.6373, 28.9118],
    [-100.6407, 28.9152],
    [-100.6324, 28.9164],
    [-100.6307, 28.9240],
    [-100.6389, 28.9276],
    [-100.6444, 28.9383],
    [-100.6507, 28.9420],
    [-100.6489, 28.9526],
    [-100.6474, 28.9589],
    [-100.6503, 28.9620],
    [-100.6466, 28.9669],
    [-100.6487, 28.9774],
    [-100.6459, 28.9864],
    [-100.6491, 28.9965],
    [-100.6509, 29.0083],
    [-100.6602, 29.0315],
    [-100.6632, 29.0480],
    [-100.6659, 29.0768],
    [-100.6698, 29.0901],
    [-100.6845, 29.1107],
    [-100.7275, 29.1291],
    [-100.7391, 29.1417],
    [-100.7380, 29.1488],
    [-100.7566, 29.1560],
    [-100.7636, 29.1613],
    [-100.7686, 29.1660],
    [-100.7749, 29.1753],
    [-100.7660, 29.1858],
    [-100.7671, 29.1953],
    [-100.7753, 29.1997],
    [-100.7759, 29.2070],
    [-100.7771, 29.2135],
    [-100.7831, 29.2245],
    [-100.7914, 29.2259],
    [-100.7968, 29.2310],
    [-100.7947, 29.2399],
    [-100.7977, 29.2469],
    [-100.8138, 29.2535],
    [-100.8163, 29.2567],
    [-100.8133, 29.2622],
    [-100.8210, 29.2629],
    [-100.8390, 29.2633],
    [-100.8522, 29.2721],
    [-100.8565, 29.2757],
    [-100.8781, 29.2809],
    [-100.8804, 29.2904],
    [-100.8863, 29.3068],
    [-100.8949, 29.3104],
    [-100.9068, 29.3135],
    [-100.9122, 29.3176],
    [-100.9173, 29.3205],
    [-100.9213, 29.3262],
    [-100.9285, 29.3270],
    [-100.9432, 29.3420],
    [-100.9490, 29.3472],
    [-100.9608, 29.3469],
    [-100.9729, 29.3545],
    [-101.0027, 29.3653],
    [-101.0143, 29.3741],
    [-101.0145, 29.3821],
    [-101.0214, 29.3930],
    [-101.0386, 29.4107],
    [-101.0407, 29.4229],
    [-101.0570, 29.4408],
    [-101.0602, 29.4587],
    [-101.0871, 29.4694],
    [-101.1231, 29.4733],
    [-101.1329, 29.4774],
    [-101.1519, 29.4770],
    [-101.1717, 29.5039],
    [-101.1927, 29.5203],
    [-101.2498, 29.5209],
    [-101.2612, 29.5368],
    [-101.2504, 29.5566],
    [-101.2488, 29.5907],
    [-101.2474, 29.6182],
    [-101.2523, 29.6256],
    [-101.2660, 29.6310],
    [-101.2777, 29.6210],
    [-101.2776, 29.6071],
    [-101.2779, 29.5909],
    [-101.2910, 29.5715],
    [-101.3055, 29.5779],
    [-101.3133, 29.6055],
    [-101.3109, 29.6168],
    [-101.3013, 29.6350],
    [-101.3024, 29.6500],
    [-101.3104, 29.6577],
    [-101.3318, 29.6607],
    [-101.3487, 29.6619],
    [-101.3552, 29.6514],
    [-101.3613, 29.6501],
    [-101.3657, 29.6672],
    [-101.3725, 29.6778],
    [-101.3719, 29.6940],
    [-101.3787, 29.7035],
    [-101.3969, 29.7139],
    [-101.3963, 29.7271],
    [-101.4100, 29.7415],
    [-101.4157, 29.7502],
    [-101.4039, 29.7576],
    [-101.3987, 29.7675],
    [-101.4060, 29.7717],
    [-101.4242, 29.7613],
    [-101.4455, 29.7494],
    [-101.4514, 29.7571],
    [-101.4525, 29.7828],
    [-101.4586, 29.7893],
    [-101.4752, 29.7859],
    [-101.4860, 29.7749],
    [-101.5072, 29.7638],
    [-101.5279, 29.7606],
    [-101.5380, 29.7600],
    [-101.5381, 29.7864],
    [-101.5350, 29.7977],
    [-101.5419, 29.8108],
    [-101.5525, 29.8042],
    [-101.5738, 29.7890],
    [-101.5729, 29.7814],
    [-101.5749, 29.7699],
    [-101.5863, 29.7710],
    [-101.5989, 29.7738],
    [-101.6130, 29.7715],
    [-101.6260, 29.7711],
    [-101.6325, 29.7647],
    [-101.6411, 29.7564],
    [-101.6496, 29.7562],
    [-101.6546, 29.7652],
    [-101.6661, 29.7699],
    [-101.6750, 29.7650],
    [-101.6778, 29.7603],
    [-101.6856, 29.7674],
    [-101.6939, 29.7689],
    [-101.7089, 29.7616],
    [-101.7169, 29.7717],
    [-101.7238, 29.7764],
    [-101.7298, 29.7718],
    [-101.7392, 29.7735],
    [-101.7425, 29.7787],
    [-101.7543, 29.7777],
    [-101.7603, 29.7817],
    [-101.7711, 29.7875],
    [-101.7819, 29.7896],
    [-101.7881, 29.7795],
    [-101.8075, 29.7814],
    [-101.8145, 29.7919],
    [-101.8070, 29.7990],
    [-101.8106, 29.8078],
    [-101.8183, 29.8116],
    [-101.8258, 29.8052],
    [-101.8190, 29.7936],
    [-101.8241, 29.7872],
    [-101.8391, 29.7947],
    [-101.8472, 29.8042],
    [-101.8533, 29.8077],
    [-101.8624, 29.8014],
    [-101.8775, 29.7944],
    [-101.8829, 29.7935],
    [-101.8927, 29.7979],
    [-101.9124, 29.7979],
    [-101.9214, 29.7875],
    [-101.9335, 29.7852],
    [-101.9327, 29.7918],
    [-101.9419, 29.8008],
    [-101.9555, 29.7953],
    [-101.9634, 29.8001],
    [-101.9647, 29.8091],
    [-101.9694, 29.8138],
    [-101.9736, 29.8156],
    [-101.9812, 29.8154],
    [-101.9820, 29.8059],
    [-101.9886, 29.7967],
    [-101.9975, 29.8064],
    [-102.0109, 29.7999],
    [-102.0197, 29.8015],
    [-102.0253, 29.8027],
    [-102.0348, 29.8040],
    [-102.0398, 29.7953],
    [-102.0417, 29.7897],
    [-102.0476, 29.7890],
    [-102.0522, 29.7851],
    [-102.0736, 29.7869],
    [-102.0773, 29.7924],
    [-102.0825, 29.7934],
    [-102.0918, 29.7929],
    [-102.1018, 29.7936],
    [-102.1113, 29.7930],
    [-102.1179, 29.7962],
    [-102.1205, 29.8023],
    [-102.1276, 29.7988],
    [-102.1378, 29.8021],
    [-102.1492, 29.8101],
    [-102.1596, 29.8144],
    [-102.1661, 29.8248],
    [-102.1801, 29.8266],
    [-102.1784, 29.8381],
    [-102.1836, 29.8469],
    [-102.1917, 29.8466],
    [-102.1971, 29.8364],
    [-102.2099, 29.8444],
    [-102.2235, 29.8405],
    [-102.2309, 29.8479],
    [-102.2414, 29.8477],
    [-102.2450, 29.8521],
    [-102.2456, 29.8635],
    [-102.2498, 29.8633],
    [-102.2523, 29.8540],
    [-102.2614, 29.8533],
    [-102.2643, 29.8578],
    [-102.2618, 29.8640],
    [-102.2688, 29.8680],
    [-102.2833, 29.8643],
    [-102.2880, 29.8716],
    [-102.2973, 29.8752],
    [-102.3115, 29.8770],
    [-102.3207, 29.8789],
    [-102.3235, 29.8639],
    [-102.3316, 29.8628],
    [-102.3410, 29.8693],
    [-102.3446, 29.8647],
    [-102.3520, 29.8531],
    [-102.3612, 29.8491],
    [-102.3651, 29.8270],
    [-102.3743, 29.8064],
    [-102.3794, 29.7878],
    [-102.3886, 29.7836],
    [-102.3873, 29.7785],
    [-102.3855, 29.7692],
    [-102.3883, 29.7613],
    [-102.3918, 29.7661],
    [-102.3997, 29.7690],
    [-102.4082, 29.7650],
    [-102.4117, 29.7677],
    [-102.4175, 29.7696],
    [-102.4253, 29.7726],
    [-102.4333, 29.7766],
    [-102.4377, 29.7739],
    [-102.4501, 29.7772],
    [-102.4593, 29.7760],
    [-102.4664, 29.7836],
    [-102.4713, 29.7771],
    [-102.4803, 29.7760],
    [-102.4843, 29.7851],
    [-102.4947, 29.7831],
    [-102.5060, 29.7824],
    [-102.5182, 29.7823],
    [-102.5148, 29.7755],
    [-102.5113, 29.7703],
    [-102.5200, 29.7610],
    [-102.5357, 29.7536],
    [-102.5471, 29.7454],
    [-102.5534, 29.7481],
    [-102.5544, 29.7538],
    [-102.5593, 29.7604],
    [-102.5655, 29.7707],
    [-102.5710, 29.7705],
    [-102.5740, 29.7650],
    [-102.5741, 29.7548],
    [-102.5826, 29.7535],
    [-102.5935, 29.7495],
    [-102.6039, 29.7503],
    [-102.6103, 29.7478],
    [-102.6166, 29.7437],
    [-102.6391, 29.7335],
    [-102.6656, 29.7377],
    [-102.6674, 29.7447],
    [-102.6740, 29.7446],
    [-102.6772, 29.7383],
    [-102.6832, 29.7269],
    [-102.6905, 29.7227],
    [-102.6902, 29.7075],
    [-102.6969, 29.6988],
    [-102.6964, 29.6826],
    [-102.7010, 29.6725],
    [-102.7113, 29.6605],
    [-102.7213, 29.6526],
    [-102.7252, 29.6497],
    [-102.7272, 29.6422],
    [-102.7369, 29.6415],
    [-102.7414, 29.6293],
    [-102.7388, 29.6132],
    [-102.7404, 29.6051],
    [-102.7419, 29.5960],
    [-102.7497, 29.5951],
    [-102.7658, 29.5975],
    [-102.7658, 29.5889],
    [-102.7661, 29.5723],
    [-102.7723, 29.5739],
    [-102.7736, 29.5666],
    [-102.7777, 29.5597],
    [-102.7714, 29.5485],
    [-102.7773, 29.5463],
    [-102.7833, 29.5419],
    [-102.7930, 29.5399],
    [-102.7926, 29.5324],
    [-102.7984, 29.5267],
    [-102.8084, 29.5190],
    [-102.8068, 29.5099],
    [-102.8064, 29.5029],
    [-102.8056, 29.4972],
    [-102.8049, 29.4904],
    [-102.8035, 29.4841],
    [-102.8140, 29.4828],
    [-102.8154, 29.4744],
    [-102.8170, 29.4689],
    [-102.8231, 29.4633],
    [-102.8253, 29.4569],
    [-102.8237, 29.4520],
    [-102.8196, 29.4509],
    [-102.8276, 29.4468],
    [-102.8309, 29.4416],
    [-102.8312, 29.4338],
    [-102.8296, 29.4263],
    [-102.8281, 29.4160],
    [-102.8333, 29.4110],
    [-102.8279, 29.4077],
    [-102.8257, 29.4042],
    [-102.8234, 29.4033],
    [-102.8137, 29.4023],
    [-102.8145, 29.3980],
    [-102.8221, 29.3979],
    [-102.8325, 29.3889],
    [-102.8340, 29.3798],
    [-102.8416, 29.3772],
    [-102.8450, 29.3692],
    [-102.8418, 29.3628],
    [-102.8430, 29.3580],
    [-102.8567, 29.3536],
    [-102.8748, 29.3530],
    [-102.8795, 29.3533],
    [-102.8839, 29.3460],
    [-102.8849, 29.3251],
    [-102.8852, 29.3201],
    [-102.8875, 29.3132],
    [-102.8905, 29.3095],
    [-102.8901, 29.3024],
    [-102.8910, 29.2871],
    [-102.8975, 29.2820],
    [-102.9026, 29.2794],
    [-102.9001, 29.2723],
    [-102.9048, 29.2639],
    [-102.9055, 29.2571],
    [-102.8985, 29.2544],
    [-102.8913, 29.2480],
    [-102.8744, 29.2436],
    [-102.8715, 29.2327],
    [-102.8668, 29.2277],
    [-102.8742, 29.2186],
    [-102.8849, 29.2116],
    [-102.8992, 29.2089],
    [-102.9088, 29.2193],
    [-102.9162, 29.2150],
    [-102.9136, 29.2044],
    [-102.9175, 29.1993],
    [-102.9173, 29.1926],
    [-102.9255, 29.1937],
    [-102.9377, 29.1885],
    [-102.9438, 29.1912],
    [-102.9472, 29.1808],
    [-102.9506, 29.1737],
    [-102.9556, 29.1781],
    [-102.9707, 29.1841],
    [-102.9816, 29.1856],
    [-102.9947, 29.1796],
    [-102.9981, 29.1727],
    [-102.9957, 29.1612],
    [-103.0084, 29.1483],
    [-103.0139, 29.1359],
    [-103.0122, 29.1287],
    [-103.0150, 29.1258],
    [-103.0240, 29.1198],
    [-103.0360, 29.1140],
    [-103.0322, 29.1070],
    [-103.0360, 29.0987],
    [-103.0473, 29.0959],
    [-103.0547, 29.1006],
    [-103.0664, 29.0916],
    [-103.0720, 29.0927],
    [-103.0766, 29.0798],
    [-103.0852, 29.0695],
    [-103.0859, 29.0537],
    [-103.0916, 29.0631],
    [-103.0955, 29.0647],
    [-103.1003, 29.0577],
    [-103.1040, 29.0464],
    [-103.1035, 29.0327],
    [-103.1016, 29.0181],
    [-103.1160, 28.9946],
    [-103.1188, 28.9837],
    [-103.1314, 28.9839],
    [-103.1514, 28.9751],
    [-103.1566, 28.9728],
    [-103.1659, 28.9740],
    [-103.1708, 28.9806],
    [-103.1768, 28.9781],
    [-103.1993, 28.9861],
    [-103.2114, 28.9874],
    [-103.2190, 28.9857],
    [-103.2239, 28.9878],
    [-103.2303, 28.9885],
    [-103.2376, 28.9819],
    [-103.2510, 28.9813],
    [-103.2613, 28.9927],
    [-103.2695, 28.9930],
    [-103.2714, 28.9854],
    [-103.2793, 28.9770],
    [-103.2883, 28.9814],
    [-103.2816, 28.9877],
    [-103.2862, 29.0003],
    [-103.2955, 29.0063],
    [-103.3030, 29.0077],
    [-103.3145, 29.0078],
    [-103.3127, 29.0130],
    [-103.3068, 29.0222],
    [-103.3152, 29.0256],
    [-103.3225, 29.0183],
    [-103.3351, 29.0175],
    [-103.3420, 29.0282],
    [-103.3365, 29.0275],
    [-103.3286, 29.0304],
    [-103.3294, 29.0422],
    [-103.3351, 29.0436],
    [-103.3423, 29.0462],
    [-103.3449, 29.0452],
    [-103.3508, 29.0286],
    [-103.3603, 29.0185],
    [-103.3773, 29.0232],
    [-103.3865, 29.0216],
    [-103.3872, 29.0282],
    [-103.3896, 29.0344],
    [-103.4008, 29.0310],
    [-103.4047, 29.0393],
    [-103.4154, 29.0379],
    [-103.4236, 29.0435],
    [-103.4308, 29.0453],
    [-103.4335, 29.0520],
    [-103.4366, 29.0580],
    [-103.4484, 29.0638],
    [-103.4506, 29.0703],
    [-103.4585, 29.0726],
    [-103.4595, 29.0687],
    [-103.4663, 29.0664],
    [-103.4736, 29.0711],
    [-103.4748, 29.0867],
    [-103.4756, 29.0910],
    [-103.4807, 29.0917],
    [-103.4974, 29.1085],
    [-103.4995, 29.1129],
    [-103.5042, 29.1159],
    [-103.5110, 29.1206],
    [-103.5215, 29.1200],
    [-103.5238, 29.1328],
    [-103.5240, 29.1364],
    [-103.5396, 29.1461],
    [-103.5480, 29.1423],
    [-103.5524, 29.1509],
    [-103.5526, 29.1573],
    [-103.5614, 29.1553],
    [-103.5695, 29.1554],
    [-103.5781, 29.1501],
    [-103.5924, 29.1503],
    [-103.6032, 29.1581],
    [-103.6105, 29.1658],
    [-103.6292, 29.1627],
    [-103.6340, 29.1586],
    [-103.6418, 29.1607],
    [-103.6499, 29.1564],
    [-103.6532, 29.1629],
    [-103.6643, 29.1709],
    [-103.6713, 29.1733],
    [-103.6863, 29.1763],
    [-103.6940, 29.1769],
    [-103.7002, 29.1794],
    [-103.7073, 29.1837],
    [-103.7155, 29.1813],
    [-103.7198, 29.1833],
    [-103.7284, 29.1927],
    [-103.7305, 29.1979],
    [-103.7422, 29.2086],
    [-103.7409, 29.2194],
    [-103.7438, 29.2219],
    [-103.7574, 29.2207],
    [-103.7545, 29.2275],
    [-103.7628, 29.2327],
    [-103.7685, 29.2273],
    [-103.7710, 29.2195],
    [-103.7774, 29.2218],
    [-103.7810, 29.2333],
    [-103.7807, 29.2438],
    [-103.7751, 29.2480],
    [-103.7816, 29.2611],
    [-103.7926, 29.2626],
    [-103.7999, 29.2586],
    [-103.8076, 29.2702],
    [-103.8153, 29.2733],
    [-103.8262, 29.2692],
    [-103.8338, 29.2725],
    [-103.8367, 29.2770],
    [-103.8633, 29.2792],
    [-103.8711, 29.2816],
    [-103.8849, 29.2842],
    [-103.8930, 29.2815],
    [-103.9036, 29.2870],
    [-103.9171, 29.2842],
    [-103.9178, 29.2879],
    [-103.9234, 29.2934],
    [-103.9323, 29.2935],
    [-103.9506, 29.2959],
    [-103.9614, 29.2987],
    [-103.9676, 29.3000],
    [-103.9752, 29.2960],
    [-103.9932, 29.3043],
    [-104.0086, 29.3084],
    [-104.0383, 29.3202],
    [-104.0476, 29.3259],
    [-104.0562, 29.3357],
    [-104.0663, 29.3408],
    [-104.0743, 29.3464],
    [-104.0865, 29.3506],
    [-104.0897, 29.3576],
    [-104.0945, 29.3612],
    [-104.0980, 29.3663],
    [-104.1065, 29.3731],
    [-104.1151, 29.3729],
    [-104.1217, 29.3774],
    [-104.1280, 29.3782],
    [-104.1328, 29.3833],
    [-104.1380, 29.3821],
    [-104.1399, 29.3780],
    [-104.1432, 29.3833],
    [-104.1434, 29.3879],
    [-104.1464, 29.3854],
    [-104.1520, 29.3889],
    [-104.1535, 29.3933],
    [-104.1563, 29.3908],
    [-104.1623, 29.3916],
    [-104.1684, 29.3965],
    [-104.1653, 29.4019],
    [-104.1694, 29.4019],
    [-104.1694, 29.4078],
    [-104.1749, 29.4095],
    [-104.1801, 29.4128],
    [-104.1833, 29.4162],
    [-104.1821, 29.4213],
    [-104.1815, 29.4270],
    [-104.1873, 29.4297],
    [-104.1929, 29.4353],
    [-104.1938, 29.4413],
    [-104.2112, 29.4498],
    [-104.2181, 29.4577],
    [-104.2124, 29.4653],
    [-104.2109, 29.4770],
    [-104.2111, 29.4825],
    [-104.2190, 29.4834],
    [-104.2272, 29.4803],
    [-104.2338, 29.4865],
    [-104.2388, 29.4983],
    [-104.2471, 29.5029],
    [-104.2583, 29.5061],
    [-104.2615, 29.5077],
    [-104.2617, 29.5135],
    [-104.2683, 29.5135],
    [-104.2753, 29.5168],
    [-104.2926, 29.5219],
    [-104.3043, 29.5240],
    [-104.3106, 29.5271],
    [-104.3155, 29.5328],
    [-104.3207, 29.5276],
    [-104.3259, 29.5232],
    [-104.3362, 29.5193],
    [-104.3575, 29.5324],
    [-104.3720, 29.5439],
    [-104.3810, 29.5434],
    [-104.3944, 29.5569],
    [-104.3957, 29.5636],
    [-104.3968, 29.5690],
    [-104.4523, 29.6037],
    [-104.4607, 29.6089],
    [-104.4674, 29.6119],
    [-104.4656, 29.6170],
    [-104.4698, 29.6188],
    [-104.4740, 29.6188],
    [-104.4763, 29.6253],
    [-104.4785, 29.6284],
    [-104.4864, 29.6292],
    [-104.4878, 29.6340],
    [-104.4948, 29.6337],
    [-104.4962, 29.6388],
    [-104.5024, 29.6375],
    [-104.5056, 29.6340],
    [-104.5104, 29.6354],
    [-104.5129, 29.6428],
    [-104.5123, 29.6466],
    [-104.5185, 29.6491],
    [-104.5163, 29.6524],
    [-104.5215, 29.6567],
    [-104.5252, 29.6618],
    [-104.5259, 29.6680],
    [-104.5286, 29.6698],
    [-104.5333, 29.6689],
    [-104.5363, 29.6673],
    [-104.5395, 29.6786],
    [-104.5435, 29.6827],
    [-104.5338, 29.6856],
    [-104.5361, 29.6930],
    [-104.5459, 29.6996],
    [-104.5443, 29.7099],
    [-104.5478, 29.7144],
    [-104.5456, 29.7170],
    [-104.5522, 29.7171],
    [-104.5491, 29.7208],
    [-104.5491, 29.7272],
    [-104.5524, 29.7319],
    [-104.5557, 29.7348],
    [-104.5605, 29.7354],
    [-104.5557, 29.7381],
    [-104.5503, 29.7381],
    [-104.5539, 29.7431],
    [-104.5600, 29.7472],
    [-104.5701, 29.7529],
    [-104.5660, 29.7588],
    [-104.5681, 29.7659],
    [-104.5657, 29.7705],
    [-104.5741, 29.7814],
    [-104.5798, 29.7888],
    [-104.5812, 29.7935],
    [-104.5864, 29.7962],
    [-104.5905, 29.7997],
    [-104.5863, 29.8032],
    [-104.5925, 29.8103],
    [-104.5932, 29.8061],
    [-104.5991, 29.8110],
    [-104.6041, 29.8156],
    [-104.6101, 29.8194],
    [-104.6136, 29.8279],
    [-104.6195, 29.8301],
    [-104.6105, 29.8363],
    [-104.6138, 29.8460],
    [-104.6192, 29.8422],
    [-104.6243, 29.8452],
    [-104.6224, 29.8510],
    [-104.6301, 29.8533],
    [-104.6333, 29.8705],
    [-104.6398, 29.8734],
    [-104.6461, 29.8785],
    [-104.6508, 29.8865],
    [-104.6533, 29.8923],
    [-104.6586, 29.8916],
    [-104.6590, 29.9014],
    [-104.6559, 29.9062],
    [-104.6616, 29.9026],
    [-104.6660, 29.9045],
    [-104.6723, 29.9111],
    [-104.6762, 29.9160],
    [-104.6798, 29.9247],
    [-104.6832, 29.9295],
    [-104.6799, 29.9337],
    [-104.6813, 29.9382],
    [-104.6779, 29.9410],
    [-104.6807, 29.9470],
    [-104.6773, 29.9502],
    [-104.6733, 29.9543],
    [-104.6803, 29.9570],
    [-104.6839, 29.9600],
    [-104.6819, 29.9694],
    [-104.6824, 29.9736],
    [-104.6826, 29.9770],
    [-104.6919, 29.9739],
    [-104.6883, 29.9802],
    [-104.6862, 29.9848],
    [-104.6918, 29.9915],
    [-104.6872, 29.9968],
    [-104.6902, 30.0037],
    [-104.6933, 30.0061],
    [-104.6896, 30.0105],
    [-104.6976, 30.0194],
    [-104.7005, 30.0337],
    [-104.6972, 30.0403],
    [-104.7063, 30.0492],
    [-104.7053, 30.0586],
    [-104.6982, 30.0653],
    [-104.6911, 30.0706],
    [-104.6926, 30.0742],
    [-104.6900, 30.0759],
    [-104.6867, 30.0837],
    [-104.6880, 30.0859],
    [-104.6902, 30.0897],
    [-104.6857, 30.0960],
    [-104.6878, 30.0968],
    [-104.6922, 30.0961],
    [-104.6932, 30.1033],
    [-104.6900, 30.1079],
    [-104.6861, 30.1069],
    [-104.6916, 30.1158],
    [-104.6932, 30.1184],
    [-104.6943, 30.1200],
    [-104.6950, 30.1297],
    [-104.6964, 30.1350],
    [-104.6921, 30.1387],
    [-104.6897, 30.1406],
    [-104.6864, 30.1424],
    [-104.6857, 30.1456],
    [-104.6883, 30.1475],
    [-104.6873, 30.1511],
    [-104.6877, 30.1590],
    [-104.6882, 30.1672],
    [-104.6880, 30.1764],
    [-104.6908, 30.1830],
    [-104.6960, 30.1902],
    [-104.6970, 30.1978],
    [-104.7019, 30.2064],
    [-104.7028, 30.2117],
    [-104.7079, 30.2185],
    [-104.7081, 30.2261],
    [-104.7132, 30.2380],
    [-104.7189, 30.2469],
    [-104.7240, 30.2516],
    [-104.7290, 30.2570],
    [-104.7374, 30.2614],
    [-104.7360, 30.2570],
    [-104.7404, 30.2595],
    [-104.7502, 30.2660],
    [-104.7504, 30.2717],
    [-104.7540, 30.2722],
    [-104.7579, 30.2740],
    [-104.7606, 30.2723],
    [-104.7625, 30.2744],
    [-104.7579, 30.2824],
    [-104.7593, 30.2937],
    [-104.7669, 30.3036],
    [-104.7733, 30.3027],
    [-104.7786, 30.3034],
    [-104.7770, 30.3068],
    [-104.7792, 30.3129],
    [-104.7863, 30.3160],
    [-104.7912, 30.3220],
    [-104.7973, 30.3303],
    [-104.8094, 30.3334],
    [-104.8111, 30.3351],
    [-104.8100, 30.3414],
    [-104.8186, 30.3474],
    [-104.8226, 30.3513],
    [-104.8144, 30.3535],
    [-104.8107, 30.3627],
    [-104.8147, 30.3663],
    [-104.8192, 30.3711],
    [-104.8176, 30.3757],
    [-104.8375, 30.3739],
    [-104.8456, 30.3792],
    [-104.8595, 30.3904],
    [-104.8553, 30.4014],
    [-104.8521, 30.4122],
    [-104.8489, 30.4177],
    [-104.8498, 30.4197],
    [-104.8555, 30.4209],
    [-104.8592, 30.4262],
    [-104.8611, 30.4289],
    [-104.8589, 30.4348],
    [-104.8620, 30.4402],
    [-104.8676, 30.4439],
    [-104.8645, 30.4500],
    [-104.8699, 30.4586],
    [-104.8661, 30.4674],
    [-104.8692, 30.4782],
    [-104.8721, 30.4804],
    [-104.8674, 30.4883],
    [-104.8699, 30.4941],
    [-104.8722, 30.5017],
    [-104.8719, 30.5109],
    [-104.8768, 30.5110],
    [-104.8857, 30.5185],
    [-104.8810, 30.5205],
    [-104.8859, 30.5246],
    [-104.8813, 30.5237],
    [-104.8894, 30.5351],
    [-104.8874, 30.5440],
    [-104.8901, 30.5460],
    [-104.8917, 30.5503],
    [-104.8930, 30.5530],
    [-104.8961, 30.5622],
    [-104.8990, 30.5704],
    [-104.9051, 30.5764],
    [-104.9096, 30.5852],
    [-104.9188, 30.5855],
    [-104.9188, 30.5946],
    [-104.9198, 30.5974],
    [-104.9218, 30.6023],
    [-104.9266, 30.6051],
    [-104.9343, 30.5999],
    [-104.9385, 30.6036],
    [-104.9415, 30.6040],
    [-104.9454, 30.6031],
    [-104.9508, 30.6041],
    [-104.9538, 30.6077],
    [-104.9635, 30.6088],
    [-104.9755, 30.6142],
    [-104.9765, 30.6175],
    [-104.9803, 30.6220],
    [-104.9800, 30.6292],
    [-104.9840, 30.6352],
    [-104.9855, 30.6501],
    [-104.9863, 30.6611],
    [-104.9913, 30.6652],
    [-104.9931, 30.6669],
    [-104.9991, 30.6710],
    [-105.0044, 30.6831],
    [-105.0074, 30.6865],
    [-105.0130, 30.6825],
    [-105.0179, 30.6852],
    [-105.0246, 30.6815],
    [-105.0288, 30.6803],
    [-105.0359, 30.6866],
    [-105.0427, 30.6874],
    [-105.0457, 30.6889],
    [-105.0456, 30.6857],
    [-105.0452, 30.6806],
    [-105.0475, 30.6817],
    [-105.0517, 30.6815],
    [-105.0547, 30.6839],
    [-105.0567, 30.6879],
    [-105.0600, 30.6862],
    [-105.0635, 30.6887],
    [-105.0617, 30.6960],
    [-105.0626, 30.6986],
    [-105.0671, 30.6995],
    [-105.0682, 30.7036],
    [-105.0692, 30.7022],
    [-105.0735, 30.7015],
    [-105.0768, 30.7013],
    [-105.0784, 30.6997],
    [-105.0810, 30.6999],
    [-105.0809, 30.7015],
    [-105.0826, 30.7019],
    [-105.0809, 30.7030],
    [-105.0793, 30.7048],
    [-105.0802, 30.7072],
    [-105.0824, 30.7086],
    [-105.0850, 30.7099],
    [-105.0878, 30.7107],
    [-105.0870, 30.7143],
    [-105.0890, 30.7159],
    [-105.0930, 30.7172],
    [-105.0950, 30.7171],
    [-105.0968, 30.7162],
    [-105.0987, 30.7178],
    [-105.0987, 30.7205],
    [-105.1000, 30.7222],
    [-105.1043, 30.7230],
    [-105.1050, 30.7249],
    [-105.1034, 30.7271],
    [-105.1038, 30.7295],
    [-105.1069, 30.7304],
    [-105.1102, 30.7313],
    [-105.1118, 30.7333],
    [-105.1109, 30.7387],
    [-105.1104, 30.7403],
    [-105.1116, 30.7419],
    [-105.1138, 30.7460],
    [-105.1159, 30.7436],
    [-105.1199, 30.7432],
    [-105.1206, 30.7463],
    [-105.1191, 30.7486],
    [-105.1193, 30.7500],
    [-105.1233, 30.7495],
    [-105.1272, 30.7478],
    [-105.1302, 30.7506],
    [-105.1372, 30.7517],
    [-105.1406, 30.7522],
    [-105.1426, 30.7550],
    [-105.1472, 30.7536],
    [-105.1546, 30.7528],
    [-105.1582, 30.7529],
    [-105.1619, 30.7535],
    [-105.1605, 30.7577],
    [-105.1576, 30.7666],
    [-105.1590, 30.7710],
    [-105.1648, 30.7725],
    [-105.1667, 30.7766],
    [-105.1707, 30.7717],
    [-105.1739, 30.7676],
    [-105.1776, 30.7693],
    [-105.1823, 30.7764],
    [-105.1851, 30.7777],
    [-105.1852, 30.7820],
    [-105.1874, 30.7848],
    [-105.1923, 30.7889],
    [-105.1951, 30.7921],
    [-105.2005, 30.7874],
    [-105.2069, 30.7859],
    [-105.2100, 30.7827],
    [-105.2143, 30.7833],
    [-105.2198, 30.7864],
    [-105.2184, 30.7917],
    [-105.2132, 30.7931],
    [-105.2107, 30.7969],
    [-105.2103, 30.7984],
    [-105.2138, 30.8017],
    [-105.2138, 30.8028],
    [-105.2150, 30.8059],
    [-105.2184, 30.8057],
    [-105.2248, 30.8006],
    [-105.2290, 30.8003],
    [-105.2300, 30.8038],
    [-105.2339, 30.8030],
    [-105.2363, 30.8032],
    [-105.2389, 30.8026],
    [-105.2430, 30.8015],
    [-105.2456, 30.8004],
    [-105.2512, 30.7976],
    [-105.2555, 30.7952],
    [-105.2592, 30.7965],
    [-105.2655, 30.8025],
    [-105.2667, 30.8084],
    [-105.2728, 30.8083],
    [-105.2766, 30.8082],
    [-105.2792, 30.8129],
    [-105.2822, 30.8182],
    [-105.2880, 30.8179],
    [-105.2894, 30.8211],
    [-105.2904, 30.8251],
    [-105.2988, 30.8257],
    [-105.3010, 30.8206],
    [-105.3060, 30.8100],
    [-105.3089, 30.8111],
    [-105.3085, 30.8151],
    [-105.3108, 30.8153],
    [-105.3144, 30.8123],
    [-105.3170, 30.8110],
    [-105.3178, 30.8155],
    [-105.3164, 30.8201],
    [-105.3182, 30.8265],
    [-105.3196, 30.8291],
    [-105.3224, 30.8277],
    [-105.3268, 30.8262],
    [-105.3298, 30.8254],
    [-105.3283, 30.8315],
    [-105.3355, 30.8334],
    [-105.3379, 30.8379],
    [-105.3417, 30.8405],
    [-105.3474, 30.8395],
    [-105.3518, 30.8356],
    [-105.3537, 30.8391],
    [-105.3562, 30.8442],
    [-105.3599, 30.8463],
    [-105.3616, 30.8505],
    [-105.3676, 30.8477],
    [-105.3747, 30.8489],
    [-105.3769, 30.8486],
    [-105.3772, 30.8513],
    [-105.3819, 30.8512],
    [-105.3841, 30.8507],
    [-105.3859, 30.8521],
    [-105.3890, 30.8524],
    [-105.3920, 30.8506],
    [-105.3945, 30.8502],
    [-105.3954, 30.8491],
    [-105.4005, 30.8526],
    [-105.3991, 30.8579],
    [-105.3950, 30.8621],
    [-105.3960, 30.8641],
    [-105.3940, 30.8681],
    [-105.3950, 30.8711],
    [-105.3913, 30.8739],
    [-105.3940, 30.8764],
    [-105.4004, 30.8769],
    [-105.4039, 30.8806],
    [-105.3993, 30.8840],
    [-105.4000, 30.8876],
    [-105.4013, 30.8902],
    [-105.4044, 30.8919],
    [-105.4104, 30.8890],
    [-105.4121, 30.8894],
    [-105.4108, 30.8914],
    [-105.4121, 30.8937],
    [-105.4138, 30.8996],
    [-105.4217, 30.9005],
    [-105.4263, 30.9008],
    [-105.4324, 30.9060],
    [-105.4395, 30.9087],
    [-105.4446, 30.9130],
    [-105.4443, 30.9173],
    [-105.4481, 30.9188],
    [-105.4511, 30.9159],
    [-105.4534, 30.9174],
    [-105.4524, 30.9199],
    [-105.4512, 30.9240],
    [-105.4565, 30.9245],
    [-105.4608, 30.9254],
    [-105.4655, 30.9246],
    [-105.4672, 30.9271],
    [-105.4698, 30.9312],
    [-105.4709, 30.9338],
    [-105.4759, 30.9338],
    [-105.4819, 30.9407],
    [-105.4880, 30.9433],
    [-105.4937, 30.9495],
    [-105.4984, 30.9501],
    [-105.4975, 30.9531],
    [-105.4958, 30.9558],
    [-105.4941, 30.9573],
    [-105.4990, 30.9634],
    [-105.5028, 30.9679],
    [-105.5082, 30.9663],
    [-105.5142, 30.9661],
    [-105.5169, 30.9672],
    [-105.5179, 30.9711],
    [-105.5213, 30.9747],
    [-105.5221, 30.9766],
    [-105.5263, 30.9777],
    [-105.5331, 30.9849],
    [-105.5406, 30.9850],
    [-105.5540, 30.9881],
    [-105.5637, 30.9975],
    [-105.5702, 31.0090],
    [-105.5690, 31.0154],
    [-105.5720, 31.0189],
    [-105.5791, 31.0216],
    [-105.5799, 31.0304],
    [-105.5799, 31.0367],
    [-105.5872, 31.0594],
    [-105.5959, 31.0648],
    [-105.6045, 31.0837],
    [-105.6285, 31.0987],
    [-105.6419, 31.0983],
    [-105.6476, 31.1150],
    [-105.6599, 31.1197],
    [-105.6635, 31.1211],
    [-105.6794, 31.1260],
    [-105.7162, 31.1406],
    [-105.7177, 31.1434],
    [-105.7188, 31.1483],
    [-105.7427, 31.1649],
    [-105.7635, 31.1641],
    [-105.7733, 31.1669],
    [-105.7754, 31.1746],
    [-105.7800, 31.1827],
    [-105.7796, 31.1876],
    [-105.7808, 31.1936],
    [-105.7847, 31.1990],
    [-105.7932, 31.2015],
    [-105.8257, 31.2373],
    [-105.8517, 31.2679],
    [-105.8573, 31.2750],
    [-105.8705, 31.2898],
    [-105.8781, 31.2915],
    [-105.8946, 31.2910],
    [-105.9021, 31.3037],
    [-105.9070, 31.3113],
    [-105.9088, 31.3128],
    [-105.9181, 31.3126],
    [-105.9326, 31.3131],
    [-105.9478, 31.3412],
    [-105.9459, 31.3532],
    [-105.9556, 31.3653],
    [-105.9820, 31.3759],
    [-106.0049, 31.3925],
    [-106.0273, 31.3941],
    [-106.0769, 31.3979],
    [-106.0850, 31.4014],
    [-106.1026, 31.4180],
    [-106.1086, 31.4224],
    [-106.1150, 31.4237],
    [-106.1257, 31.4239],
    [-106.1310, 31.4248],
    [-106.1542, 31.4357],
    [-106.1630, 31.4435],
    [-106.1718, 31.4526],
    [-106.1784, 31.4565],
    [-106.1944, 31.4610],
    [-106.2050, 31.4650],
    [-106.2132, 31.4732],
    [-106.2196, 31.4816],
    [-106.2254, 31.5018],
    [-106.2375, 31.5145],
    [-106.2462, 31.5412],
    [-106.2548, 31.5480],
    [-106.2805, 31.5617],
    [-106.2878, 31.5844],
    [-106.2887, 31.5872],
    [-106.2967, 31.6035],
    [-106.3008, 31.6114],
    [-106.3028, 31.6202],
    [-106.3036, 31.6225],
    [-106.3121, 31.6346],
    [-106.3273, 31.6544],
    [-106.3380, 31.6712],
    [-106.3570, 31.7022],
    [-106.3724, 31.7126],
    [-106.3794, 31.7303],
    [-106.3946, 31.7394],
    [-106.4218, 31.7529],
    [-106.4384, 31.7568],
    [-106.4512, 31.7643],
    [-106.4553, 31.7641],
    [-106.4702, 31.7538],
    [-106.4733, 31.7507],
    [-106.4846, 31.7478],
    [-106.4947, 31.7518],
    [-106.5014, 31.7570],
    [-106.5073, 31.7612],
    [-106.5110, 31.7633],
    [-106.5137, 31.7707],
    [-106.5178, 31.7718],
    [-106.5286, 31.7818],
    [-106.5282, 31.7831],
    [-106.5280, 31.7869],
    [-106.5279, 31.7905],
    [-106.5330, 31.7918],
    [-106.5352, 31.7971],
    [-106.5406, 31.8013],
    [-106.5447, 31.8043],
    [-106.5471, 31.8073],
    [-106.5629, 31.8111],
    [-106.5690, 31.8117],
    [-106.5813, 31.8139],
    [-106.5890, 31.8227],
    [-106.6027, 31.8250],
    [-106.6034, 31.8344],
    [-106.6052, 31.8459],
    [-106.6128, 31.8465],
    [-106.6258, 31.8563],
    [-106.6325, 31.8639],
    [-106.6349, 31.8745],
    [-106.6303, 31.8811],
    [-106.6304, 31.8858],
    [-106.6382, 31.8917],
    [-106.6456, 31.8956],
    [-106.6455, 31.8987]
    ]
  },
  "California": {
    coordinates: [
      [-124.4086, 40.4432],
    [-124.3885, 40.4815],
    [-124.3861, 40.5024],
    [-124.3842, 40.5142],
    [-124.3723, 40.5323],
    [-124.3348, 40.6057],
    [-124.3196, 40.6323],
    [-124.3122, 40.6419],
    [-124.2850, 40.6852],
    [-124.2487, 40.7347],
    [-124.2352, 40.7576],
    [-124.2282, 40.7694],
    [-124.1954, 40.8151],
    [-124.1810, 40.8370],
    [-124.1583, 40.8761],
    [-124.1371, 40.9257],
    [-124.1274, 40.9582],
    [-124.1223, 40.9752],
    [-124.1164, 40.9997],
    [-124.1138, 41.0316],
    [-124.1211, 41.0394],
    [-124.1229, 41.0447],
    [-124.1291, 41.0511],
    [-124.1361, 41.0552],
    [-124.1453, 41.0576],
    [-124.1475, 41.0547],
    [-124.1513, 41.0511],
    [-124.1487, 41.0616],
    [-124.1526, 41.0678],
    [-124.1593, 41.0724],
    [-124.1555, 41.0834],
    [-124.1558, 41.0896],
    [-124.1639, 41.1007],
    [-124.1618, 41.1087],
    [-124.1591, 41.1220],
    [-124.1609, 41.1328],
    [-124.1583, 41.1430],
    [-124.1458, 41.1417],
    [-124.1400, 41.1529],
    [-124.1227, 41.1897],
    [-124.1098, 41.2225],
    [-124.1068, 41.2335],
    [-124.0992, 41.2647],
    [-124.0790, 41.3471],
    [-124.0642, 41.4314],
    [-124.0662, 41.4512],
    [-124.0661, 41.4703],
    [-124.0747, 41.4979],
    [-124.0816, 41.5241],
    [-124.0879, 41.5511],
    [-124.1011, 41.5692],
    [-124.1051, 41.5943],
    [-124.1144, 41.6168],
    [-124.1193, 41.6367],
    [-124.1275, 41.6508],
    [-124.1381, 41.6668],
    [-124.1385, 41.6759],
    [-124.1402, 41.6846],
    [-124.1439, 41.6912],
    [-124.1420, 41.6969],
    [-124.1474, 41.7180],
    [-124.1557, 41.7303],
    [-124.1701, 41.7433],
    [-124.1828, 41.7406],
    [-124.1899, 41.7367],
    [-124.1950, 41.7368],
    [-124.2096, 41.7482],
    [-124.2227, 41.7563],
    [-124.2397, 41.7708],
    [-124.2456, 41.7704],
    [-124.2560, 41.7830],
    [-124.2450, 41.7923],
    [-124.2270, 41.8279],
    [-124.2046, 41.9185],
    [-124.2048, 41.9464],
    [-124.2084, 41.9465],
    [-124.2085, 41.9545],
    [-124.2049, 41.9834],
    [-124.1214, 41.9970],
    [-123.9992, 41.9961],
    [-123.8220, 41.9956],
    [-123.7282, 41.9971],
    [-123.6315, 41.9987],
    [-123.5300, 42.0007],
    [-123.4750, 42.0007],
    [-123.3424, 41.9995],
    [-123.1839, 42.0058],
    [-123.1030, 42.0066],
    [-123.0440, 42.0031],
    [-122.9617, 42.0035],
    [-122.8840, 42.0038],
    [-122.8673, 42.0039],
    [-122.7131, 42.0042],
    [-122.6154, 42.0056],
    [-122.4166, 42.0084],
    [-122.3681, 42.0093],
    [-122.2848, 42.0080],
    [-122.1886, 42.0074],
    [-122.1441, 42.0066],
    [-121.9574, 42.0035],
    [-121.8251, 42.0024],
    [-121.6891, 42.0005],
    [-121.6002, 41.9993],
    [-121.5190, 41.9983],
    [-121.3566, 41.9965],
    [-121.3165, 41.9970],
    [-121.1742, 41.9972],
    [-121.0810, 41.9953],
    [-120.9402, 41.9935],
    [-120.8192, 41.9938],
    [-120.6159, 41.9930],
    [-120.4890, 41.9936],
    [-120.3284, 41.9926],
    [-120.2840, 41.9928],
    [-120.1880, 41.9945],
    [-120.0882, 41.9948],
    [-119.9993, 41.8753],
    [-119.9983, 41.6188],
    [-119.9999, 41.1840],
    [-119.9992, 40.8675],
    [-119.9985, 40.7499],
    [-119.9961, 40.4023],
    [-119.9962, 40.2635],
    [-119.9971, 40.1264],
    [-119.9972, 40.0772],
    [-119.9983, 39.9235],
    [-120.0005, 39.7800],
    [-120.0014, 39.6743],
    [-120.0015, 39.6358],
    [-120.0017, 39.5389],
    [-120.0022, 39.5054],
    [-120.0024, 39.4958],
    [-120.0025, 39.4871],
    [-120.0031, 39.4450],
    [-120.0044, 39.3749],
    [-120.0053, 39.3163],
    [-120.0051, 39.2913],
    [-120.0053, 39.2729],
    [-120.0057, 39.2287],
    [-120.0057, 39.2218],
    [-120.0045, 39.1656],
    [-120.0010, 38.9996],
    [-119.9513, 38.9655],
    [-119.9388, 38.9569],
    [-119.9056, 38.9342],
    [-119.8439, 38.8916],
    [-119.6911, 38.7861],
    [-119.6822, 38.7800],
    [-119.6614, 38.7656],
    [-119.6349, 38.7474],
    [-119.6193, 38.7366],
    [-119.5854, 38.7132],
    [-119.5485, 38.6876],
    [-119.5463, 38.6860],
    [-119.5118, 38.6621],
    [-119.4539, 38.6222],
    [-119.3760, 38.5668],
    [-119.3300, 38.5359],
    [-119.2510, 38.4808],
    [-119.1260, 38.3932],
    [-119.0301, 38.3252],
    [-118.9497, 38.2689],
    [-118.7977, 38.1605],
    [-118.7466, 38.1249],
    [-118.5720, 37.9999],
    [-118.2509, 37.7686],
    [-118.0522, 37.6249],
    [-117.9833, 37.5747],
    [-117.9046, 37.5158],
    [-117.8327, 37.4649],
    [-117.5814, 37.2789],
    [-117.5001, 37.2204],
    [-117.2860, 37.0598],
    [-117.1660, 36.9712],
    [-117.0645, 36.8947],
    [-116.8894, 36.7632],
    [-116.5009, 36.4682],
    [-116.3759, 36.3726],
    [-116.1086, 36.1671],
    [-115.9789, 36.0666],
    [-115.9129, 36.0154],
    [-115.8529, 35.9697],
    [-115.7508, 35.8893],
    [-115.6690, 35.8265],
    [-115.6472, 35.8090],
    [-115.6211, 35.7883],
    [-115.4129, 35.6250],
    [-115.3940, 35.6093],
    [-115.3668, 35.5878],
    [-115.2253, 35.4759],
    [-115.1468, 35.4137],
    [-115.1029, 35.3794],
    [-114.9422, 35.2500],
    [-114.8493, 35.1759],
    [-114.8042, 35.1397],
    [-114.6540, 35.0184],
    [-114.6299, 34.9947],
    [-114.6298, 34.9817],
    [-114.6352, 34.9651],
    [-114.6317, 34.9513],
    [-114.6298, 34.9387],
    [-114.6328, 34.9274],
    [-114.6333, 34.9243],
    [-114.6332, 34.9212],
    [-114.6309, 34.9073],
    [-114.6368, 34.8857],
    [-114.6344, 34.8729],
    [-114.6239, 34.8597],
    [-114.6007, 34.8474],
    [-114.5811, 34.8261],
    [-114.5746, 34.8057],
    [-114.5615, 34.7786],
    [-114.5469, 34.7618],
    [-114.5256, 34.7470],
    [-114.5166, 34.7367],
    [-114.4959, 34.7280],
    [-114.4868, 34.7191],
    [-114.4820, 34.7160],
    [-114.4737, 34.7140],
    [-114.4686, 34.7076],
    [-114.4622, 34.6858],
    [-114.4549, 34.6731],
    [-114.4505, 34.6668],
    [-114.4582, 34.6579],
    [-114.4495, 34.6514],
    [-114.4403, 34.6382],
    [-114.4390, 34.6223],
    [-114.4242, 34.6105],
    [-114.4275, 34.5992],
    [-114.4344, 34.5926],
    [-114.3996, 34.5601],
    [-114.3808, 34.5297],
    [-114.3781, 34.5073],
    [-114.3824, 34.4958],
    [-114.3817, 34.4763],
    [-114.3872, 34.4620],
    [-114.3789, 34.4504],
    [-114.3634, 34.4478],
    [-114.3396, 34.4514],
    [-114.3307, 34.4453],
    [-114.3191, 34.4358],
    [-114.2948, 34.4214],
    [-114.2902, 34.4083],
    [-114.2801, 34.4031],
    [-114.2527, 34.3901],
    [-114.2343, 34.3767],
    [-114.2138, 34.3625],
    [-114.1911, 34.3561],
    [-114.1769, 34.3493],
    [-114.1572, 34.3179],
    [-114.1382, 34.3009],
    [-114.1384, 34.2886],
    [-114.1370, 34.2770],
    [-114.1312, 34.2627],
    [-114.1354, 34.2579],
    [-114.1533, 34.2583],
    [-114.1618, 34.2570],
    [-114.1645, 34.2517],
    [-114.1731, 34.2472],
    [-114.1764, 34.2415],
    [-114.1909, 34.2309],
    [-114.2155, 34.2090],
    [-114.2259, 34.2018],
    [-114.2290, 34.1874],
    [-114.2442, 34.1796],
    [-114.2753, 34.1721],
    [-114.2990, 34.1597],
    [-114.3022, 34.1561],
    [-114.3246, 34.1368],
    [-114.3481, 34.1345],
    [-114.3604, 34.1236],
    [-114.3792, 34.1160],
    [-114.4059, 34.1115],
    [-114.4159, 34.1076],
    [-114.4280, 34.0928],
    [-114.4343, 34.0865],
    [-114.4393, 34.0579],
    [-114.4355, 34.0426],
    [-114.4383, 34.0226],
    [-114.4502, 34.0126],
    [-114.4645, 34.0120],
    [-114.4673, 34.0052],
    [-114.4592, 34.0000],
    [-114.4586, 33.9956],
    [-114.4662, 33.9935],
    [-114.4759, 33.9844],
    [-114.4831, 33.9777],
    [-114.4999, 33.9618],
    [-114.5159, 33.9581],
    [-114.5355, 33.9347],
    [-114.5337, 33.9261],
    [-114.5254, 33.9223],
    [-114.5086, 33.9061],
    [-114.5087, 33.9006],
    [-114.5163, 33.8979],
    [-114.5259, 33.9010],
    [-114.5161, 33.8861],
    [-114.5034, 33.8750],
    [-114.5056, 33.8643],
    [-114.5245, 33.8585],
    [-114.5285, 33.8549],
    [-114.5296, 33.8481],
    [-114.5205, 33.8278],
    [-114.5227, 33.8190],
    [-114.5201, 33.7995],
    [-114.5049, 33.7605],
    [-114.5045, 33.7510],
    [-114.5119, 33.7350],
    [-114.5068, 33.7305],
    [-114.5008, 33.7222],
    [-114.4942, 33.7079],
    [-114.5050, 33.6930],
    [-114.5191, 33.6885],
    [-114.5303, 33.6792],
    [-114.5321, 33.6697],
    [-114.5207, 33.6627],
    [-114.5141, 33.6602],
    [-114.5252, 33.6559],
    [-114.5332, 33.6484],
    [-114.5254, 33.6407],
    [-114.5264, 33.6303],
    [-114.5312, 33.6239],
    [-114.5224, 33.6142],
    [-114.5292, 33.6067],
    [-114.5327, 33.6020],
    [-114.5360, 33.5692],
    [-114.5244, 33.5537],
    [-114.5589, 33.5318],
    [-114.5606, 33.5183],
    [-114.5738, 33.5075],
    [-114.5916, 33.4994],
    [-114.5997, 33.4843],
    [-114.6125, 33.4708],
    [-114.6223, 33.4476],
    [-114.6352, 33.4227],
    [-114.6495, 33.4136],
    [-114.6739, 33.4183],
    [-114.6965, 33.4141],
    [-114.7017, 33.4084],
    [-114.7238, 33.4065],
    [-114.7253, 33.4023],
    [-114.7084, 33.3841],
    [-114.7073, 33.3766],
    [-114.6980, 33.3524],
    [-114.7080, 33.3234],
    [-114.7299, 33.3057],
    [-114.7233, 33.2881],
    [-114.7112, 33.2833],
    [-114.6844, 33.2760],
    [-114.6724, 33.2605],
    [-114.6882, 33.2480],
    [-114.6827, 33.2349],
    [-114.6736, 33.2231],
    [-114.6787, 33.2034],
    [-114.6754, 33.1855],
    [-114.6802, 33.1697],
    [-114.6823, 33.1552],
    [-114.6900, 33.1379],
    [-114.7062, 33.1053],
    [-114.7065, 33.0882],
    [-114.6946, 33.0862],
    [-114.6886, 33.0829],
    [-114.6870, 33.0710],
    [-114.6737, 33.0419],
    [-114.6623, 33.0327],
    [-114.6550, 33.0371],
    [-114.6416, 33.0469],
    [-114.6283, 33.0311],
    [-114.6010, 33.0254],
    [-114.5848, 33.0282],
    [-114.5752, 33.0365],
    [-114.5385, 33.0334],
    [-114.5165, 33.0276],
    [-114.5061, 33.0170],
    [-114.4973, 32.9915],
    [-114.4929, 32.9718],
    [-114.4813, 32.9721],
    [-114.4710, 32.9741],
    [-114.4677, 32.9669],
    [-114.4677, 32.9563],
    [-114.4740, 32.9451],
    [-114.4809, 32.9353],
    [-114.4737, 32.9206],
    [-114.4629, 32.9079],
    [-114.4657, 32.8794],
    [-114.4690, 32.8452],
    [-114.4828, 32.8329],
    [-114.4941, 32.8233],
    [-114.5016, 32.8201],
    [-114.5198, 32.8057],
    [-114.5288, 32.7963],
    [-114.5317, 32.7825],
    [-114.5284, 32.7673],
    [-114.5391, 32.7569],
    [-114.5515, 32.7497],
    [-114.5817, 32.7423],
    [-114.5832, 32.7349],
    [-114.6157, 32.7294],
    [-114.6184, 32.7282],
    [-114.6245, 32.7294],
    [-114.6460, 32.7324],
    [-114.6583, 32.7338],
    [-114.6675, 32.7342],
    [-114.6843, 32.7375],
    [-114.7007, 32.7456],
    [-114.7136, 32.7316],
    [-114.7152, 32.7289],
    [-114.7196, 32.7188],
    [-114.9809, 32.7010],
    [-115.3356, 32.6762],
    [-115.4736, 32.6665],
    [-115.4904, 32.6652],
    [-115.5311, 32.6621],
    [-115.6920, 32.6500],
    [-116.1062, 32.6186],
    [-116.1574, 32.6143],
    [-116.2710, 32.6055],
    [-116.4394, 32.5919],
    [-116.6270, 32.5763],
    [-116.8222, 32.5603],
    [-116.8928, 32.5541],
    [-117.0264, 32.5425],
    [-117.0626, 32.5399],
    [-117.1189, 32.5347],
    [-117.1257, 32.5427],
    [-117.1292, 32.5543],
    [-117.1330, 32.5718],
    [-117.1332, 32.5856],
    [-117.1367, 32.6188],
    [-117.1453, 32.6367],
    [-117.1599, 32.6607],
    [-117.1722, 32.6741],
    [-117.1782, 32.6780],
    [-117.1939, 32.6861],
    [-117.2175, 32.6858],
    [-117.2239, 32.6831],
    [-117.2431, 32.6645],
    [-117.2559, 32.7075],
    [-117.2566, 32.7152],
    [-117.2576, 32.7261],
    [-117.2563, 32.7373],
    [-117.2556, 32.7434],
    [-117.2546, 32.7474],
    [-117.2528, 32.7541],
    [-117.2541, 32.7675],
    [-117.2549, 32.7865],
    [-117.2583, 32.7958],
    [-117.2611, 32.8031],
    [-117.2672, 32.8076],
    [-117.2699, 32.8112],
    [-117.2740, 32.8158],
    [-117.2810, 32.8223],
    [-117.2820, 32.8367],
    [-117.2739, 32.8514],
    [-117.2674, 32.8496],
    [-117.2607, 32.8526],
    [-117.2525, 32.8716],
    [-117.2528, 32.8844],
    [-117.2578, 32.9129],
    [-117.2601, 32.9283],
    [-117.2628, 32.9394],
    [-117.2665, 32.9519],
    [-117.2697, 32.9682],
    [-117.2728, 32.9805],
    [-117.2794, 33.0070],
    [-117.2895, 33.0294],
    [-117.2943, 33.0358],
    [-117.2989, 33.0481],
    [-117.3098, 33.0745],
    [-117.3137, 33.0869],
    [-117.3213, 33.1058],
    [-117.3387, 33.1359],
    [-117.3452, 33.1447],
    [-117.3594, 33.1641],
    [-117.3694, 33.1766],
    [-117.3812, 33.1906],
    [-117.3915, 33.2028],
    [-117.3995, 33.2068],
    [-117.4024, 33.2056],
    [-117.4058, 33.2092],
    [-117.4062, 33.2183],
    [-117.4698, 33.2964],
    [-117.5604, 33.3705],
    [-117.5752, 33.3805],
    [-117.5884, 33.3827],
    [-117.5961, 33.3872],
    [-117.6079, 33.4063],
    [-117.6173, 33.4162],
    [-117.6259, 33.4246],
    [-117.6338, 33.4322],
    [-117.6456, 33.4407],
    [-117.6527, 33.4462],
    [-117.6683, 33.4549],
    [-117.6843, 33.4619],
    [-117.6899, 33.4578],
    [-117.6914, 33.4540],
    [-117.7071, 33.4603],
    [-117.7134, 33.4600],
    [-117.7157, 33.4617],
    [-117.7151, 33.4645],
    [-117.7256, 33.4815],
    [-117.7320, 33.4847],
    [-117.7369, 33.4886],
    [-117.7395, 33.4949],
    [-117.7536, 33.5105],
    [-117.7614, 33.5163],
    [-117.7692, 33.5251],
    [-117.7796, 33.5352],
    [-117.7886, 33.5426],
    [-117.7929, 33.5439],
    [-117.8049, 33.5478],
    [-117.8075, 33.5510],
    [-117.8148, 33.5519],
    [-117.8201, 33.5567],
    [-117.8290, 33.5642],
    [-117.8367, 33.5697],
    [-117.8403, 33.5735],
    [-117.8586, 33.5826],
    [-117.8661, 33.5873],
    [-117.8768, 33.5923],
    [-117.8936, 33.5983],
    [-117.9266, 33.6069],
    [-117.9573, 33.6296],
    [-117.9579, 33.6299],
    [-117.9879, 33.6471],
    [-118.0055, 33.6580],
    [-118.0188, 33.6681],
    [-118.0402, 33.6855],
    [-118.0654, 33.7115],
    [-118.0870, 33.7296],
    [-118.1136, 33.7423],
    [-118.1327, 33.7532],
    [-118.1564, 33.7607],
    [-118.1665, 33.7631],
    [-118.1762, 33.7636],
    [-118.1796, 33.7592],
    [-118.1877, 33.7514],
    [-118.1858, 33.7383],
    [-118.1974, 33.7231],
    [-118.2329, 33.7145],
    [-118.2623, 33.7050],
    [-118.2772, 33.7071],
    [-118.2835, 33.7086],
    [-118.2859, 33.7075],
    [-118.2929, 33.7052],
    [-118.2965, 33.7088],
    [-118.3141, 33.7145],
    [-118.3212, 33.7175],
    [-118.3329, 33.7221],
    [-118.3547, 33.7323],
    [-118.3679, 33.7381],
    [-118.3736, 33.7373],
    [-118.3765, 33.7404],
    [-118.3898, 33.7396],
    [-118.4029, 33.7394],
    [-118.4114, 33.7423],
    [-118.4143, 33.7478],
    [-118.4220, 33.7634],
    [-118.4239, 33.7662],
    [-118.4219, 33.7694],
    [-118.4271, 33.7723],
    [-118.4270, 33.7767],
    [-118.4227, 33.7828],
    [-118.4174, 33.7879],
    [-118.4083, 33.7970],
    [-118.3944, 33.8043],
    [-118.3915, 33.8154],
    [-118.3908, 33.8288],
    [-118.3920, 33.8387],
    [-118.3997, 33.8435],
    [-118.4016, 33.8494],
    [-118.3995, 33.8517],
    [-118.4029, 33.8616],
    [-118.4096, 33.8769],
    [-118.4147, 33.8876],
    [-118.4175, 33.8931],
    [-118.4211, 33.8998],
    [-118.4237, 33.9047],
    [-118.4352, 33.9266],
    [-118.4482, 33.9511],
    [-118.4606, 33.9691],
    [-118.4766, 33.9875],
    [-118.4876, 33.9998],
    [-118.5028, 34.0155],
    [-118.5195, 34.0275],
    [-118.5431, 34.0385],
    [-118.5559, 34.0382],
    [-118.5674, 34.0414],
    [-118.5697, 34.0415],
    [-118.5793, 34.0398],
    [-118.5844, 34.0376],
    [-118.6097, 34.0364],
    [-118.6235, 34.0382],
    [-118.6353, 34.0363],
    [-118.6365, 34.0363],
    [-118.6574, 34.0386],
    [-118.6777, 34.0361],
    [-118.6902, 34.0322],
    [-118.7142, 34.0313],
    [-118.7324, 34.0327],
    [-118.7482, 34.0312],
    [-118.7564, 34.0257],
    [-118.7834, 34.0215],
    [-118.7871, 34.0195],
    [-118.7943, 34.0074],
    [-118.8051, 34.0012],
    [-118.8104, 34.0031],
    [-118.8216, 34.0140],
    [-118.8404, 34.0275],
    [-118.8547, 34.0342],
    [-118.8749, 34.0376],
    [-118.8962, 34.0392],
    [-118.9213, 34.0445],
    [-118.9348, 34.0435],
    [-118.9468, 34.0460],
    [-118.9645, 34.0522],
    [-118.9833, 34.0603],
    [-119.0046, 34.0662],
    [-119.0375, 34.0831],
    [-119.0563, 34.0856],
    [-119.0700, 34.0905],
    [-119.1088, 34.0959],
    [-119.1427, 34.1084],
    [-119.1780, 34.1319],
    [-119.2112, 34.1449],
    [-119.2164, 34.1461],
    [-119.2261, 34.1594],
    [-119.2371, 34.1758],
    [-119.2643, 34.2275],
    [-119.2661, 34.2361],
    [-119.2701, 34.2529],
    [-119.2856, 34.2714],
    [-119.3021, 34.2728],
    [-119.3170, 34.2803],
    [-119.3375, 34.2906],
    [-119.3758, 34.3211],
    [-119.4055, 34.3342],
    [-119.4311, 34.3553],
    [-119.4513, 34.3655],
    [-119.4727, 34.3756],
    [-119.4834, 34.3800],
    [-119.4973, 34.3848],
    [-119.5042, 34.3845],
    [-119.5236, 34.3932],
    [-119.5369, 34.3959],
    [-119.5595, 34.4134],
    [-119.5685, 34.4142],
    [-119.5766, 34.4126],
    [-119.5934, 34.4185],
    [-119.6122, 34.4207],
    [-119.6169, 34.4210],
    [-119.6209, 34.4186],
    [-119.6389, 34.4157],
    [-119.6719, 34.4161],
    [-119.6882, 34.4125],
    [-119.6917, 34.4032],
    [-119.7016, 34.3987],
    [-119.7193, 34.3961],
    [-119.7277, 34.3959],
    [-119.7411, 34.4017],
    [-119.7504, 34.4037],
    [-119.7859, 34.4160],
    [-119.8024, 34.4180],
    [-119.8252, 34.4171],
    [-119.8363, 34.4156],
    [-119.8419, 34.4093],
    [-119.8539, 34.4080],
    [-119.8729, 34.4088],
    [-119.8812, 34.4096],
    [-119.8889, 34.4167],
    [-119.8992, 34.4208],
    [-119.9155, 34.4304],
    [-119.9252, 34.4339],
    [-119.9497, 34.4345],
    [-119.9849, 34.4508],
    [-120.0081, 34.4604],
    [-120.0225, 34.4584],
    [-120.0388, 34.4634],
    [-120.0711, 34.4626],
    [-120.0972, 34.4618],
    [-120.1412, 34.4734],
    [-120.1688, 34.4697],
    [-120.2255, 34.4706],
    [-120.2380, 34.4681],
    [-120.2951, 34.4706],
    [-120.3222, 34.4634],
    [-120.3414, 34.4588],
    [-120.3655, 34.4571],
    [-120.4173, 34.4530],
    [-120.4420, 34.4515],
    [-120.4592, 34.4453],
    [-120.4744, 34.4674],
    [-120.4863, 34.4854],
    [-120.4966, 34.4954],
    [-120.5114, 34.5230],
    [-120.5540, 34.5418],
    [-120.6084, 34.5567],
    [-120.6319, 34.5605],
    [-120.6391, 34.5680],
    [-120.6492, 34.5767],
    [-120.6453, 34.5882],
    [-120.6430, 34.6012],
    [-120.6251, 34.6345],
    [-120.6017, 34.7097],
    [-120.6128, 34.7238],
    [-120.6149, 34.7307],
    [-120.6295, 34.7456],
    [-120.6350, 34.7670],
    [-120.6230, 34.7933],
    [-120.6103, 34.8582],
    [-120.6277, 34.8735],
    [-120.6399, 34.8900],
    [-120.6473, 34.9011],
    [-120.6629, 34.9012],
    [-120.6708, 34.9041],
    [-120.6642, 34.9209],
    [-120.6667, 34.9298],
    [-120.6624, 34.9358],
    [-120.6493, 34.9747],
    [-120.6299, 35.0615],
    [-120.6310, 35.1019],
    [-120.6353, 35.1216],
    [-120.6362, 35.1245],
    [-120.6377, 35.1273],
    [-120.6511, 35.1478],
    [-120.6680, 35.1520],
    [-120.6802, 35.1583],
    [-120.6870, 35.1607],
    [-120.7042, 35.1732],
    [-120.7115, 35.1753],
    [-120.7175, 35.1742],
    [-120.7379, 35.1783],
    [-120.7569, 35.1692],
    [-120.7702, 35.1637],
    [-120.7902, 35.1798],
    [-120.8053, 35.1850],
    [-120.8560, 35.2065],
    [-120.8735, 35.2229],
    [-120.8864, 35.2364],
    [-120.8969, 35.2540],
    [-120.8956, 35.2588],
    [-120.8958, 35.2708],
    [-120.8894, 35.2778],
    [-120.8750, 35.3064],
    [-120.8627, 35.3468],
    [-120.8659, 35.3605],
    [-120.8698, 35.3678],
    [-120.8649, 35.3720],
    [-120.8661, 35.3930],
    [-120.8692, 35.4033],
    [-120.8724, 35.4089],
    [-120.8746, 35.4126],
    [-120.8969, 35.4422],
    [-120.9111, 35.4480],
    [-120.9277, 35.4470],
    [-120.9507, 35.4480],
    [-120.9761, 35.4590],
    [-120.9938, 35.4636],
    [-121.0085, 35.4654],
    [-121.0289, 35.4851],
    [-121.0392, 35.4941],
    [-121.0473, 35.5027],
    [-121.0531, 35.5075],
    [-121.0599, 35.5097],
    [-121.0858, 35.5340],
    [-121.0926, 35.5404],
    [-121.0983, 35.5457],
    [-121.1016, 35.5488],
    [-121.1055, 35.5554],
    [-121.1118, 35.5687],
    [-121.1156, 35.5771],
    [-121.1189, 35.5788],
    [-121.1227, 35.5849],
    [-121.1279, 35.5949],
    [-121.1436, 35.6060],
    [-121.1667, 35.6354],
    [-121.1889, 35.6431],
    [-121.1955, 35.6346],
    [-121.2087, 35.6419],
    [-121.2399, 35.6521],
    [-121.2651, 35.6633],
    [-121.2815, 35.6669],
    [-121.2867, 35.6770],
    [-121.3045, 35.7028],
    [-121.3132, 35.7216],
    [-121.3184, 35.7287],
    [-121.3180, 35.7446],
    [-121.3263, 35.7575],
    [-121.3249, 35.7693],
    [-121.3464, 35.7952],
    [-121.3699, 35.8115],
    [-121.3743, 35.8150],
    [-121.3920, 35.8279],
    [-121.4068, 35.8446],
    [-121.4131, 35.8553],
    [-121.4396, 35.8669],
    [-121.4623, 35.8862],
    [-121.4617, 35.8907],
    [-121.4612, 35.8969],
    [-121.4686, 35.9109],
    [-121.4745, 35.9196],
    [-121.4706, 35.9211],
    [-121.4702, 35.9282],
    [-121.4762, 35.9344],
    [-121.4816, 35.9489],
    [-121.4850, 35.9593],
    [-121.4862, 35.9703],
    [-121.5028, 35.9997],
    [-121.5245, 36.0099],
    [-121.5319, 36.0144],
    [-121.5515, 36.0190],
    [-121.5676, 36.0198],
    [-121.5894, 36.0477],
    [-121.5926, 36.0567],
    [-121.5976, 36.0683],
    [-121.6138, 36.0807],
    [-121.6187, 36.0878],
    [-121.6303, 36.1109],
    [-121.6319, 36.1133],
    [-121.6332, 36.1175],
    [-121.6489, 36.1333],
    [-121.6544, 36.1409],
    [-121.6743, 36.1611],
    [-121.6775, 36.1633],
    [-121.6998, 36.1769],
    [-121.7134, 36.1906],
    [-121.7396, 36.2057],
    [-121.7537, 36.2110],
    [-121.7673, 36.2209],
    [-121.7869, 36.2289],
    [-121.8013, 36.2346],
    [-121.8143, 36.2346],
    [-121.8212, 36.2413],
    [-121.8276, 36.2423],
    [-121.8297, 36.2471],
    [-121.8374, 36.2490],
    [-121.8389, 36.2592],
    [-121.8501, 36.2753],
    [-121.8581, 36.2810],
    [-121.8668, 36.2851],
    [-121.8768, 36.2910],
    [-121.8885, 36.3028],
    [-121.9027, 36.3064],
    [-121.8994, 36.3077],
    [-121.8961, 36.3237],
    [-121.8970, 36.3272],
    [-121.8929, 36.3404],
    [-121.9068, 36.3562],
    [-121.9059, 36.3595],
    [-121.9054, 36.3614],
    [-121.9034, 36.3714],
    [-121.9051, 36.3782],
    [-121.9031, 36.3849],
    [-121.9053, 36.3903],
    [-121.9116, 36.4006],
    [-121.9134, 36.4049],
    [-121.9153, 36.4075],
    [-121.9172, 36.4111],
    [-121.9159, 36.4133],
    [-121.9147, 36.4259],
    [-121.9194, 36.4328],
    [-121.9269, 36.4478],
    [-121.9288, 36.4476],
    [-121.9299, 36.4523],
    [-121.9261, 36.4589],
    [-121.9349, 36.4688],
    [-121.9384, 36.4814],
    [-121.9420, 36.4895],
    [-121.9462, 36.4909],
    [-121.9371, 36.4980],
    [-121.9390, 36.4991],
    [-121.9390, 36.5022],
    [-121.9403, 36.5066],
    [-121.9423, 36.5077],
    [-121.9424, 36.5099],
    [-121.9424, 36.5119],
    [-121.9504, 36.5157],
    [-121.9544, 36.5183],
    [-121.9534, 36.5196],
    [-121.9513, 36.5198],
    [-121.9541, 36.5215],
    [-121.9536, 36.5238],
    [-121.9507, 36.5225],
    [-121.9482, 36.5222],
    [-121.9448, 36.5219],
    [-121.9418, 36.5216],
    [-121.9385, 36.5188],
    [-121.9372, 36.5231],
    [-121.9265, 36.5277],
    [-121.9323, 36.5398],
    [-121.9320, 36.5455],
    [-121.9320, 36.5575],
    [-121.9497, 36.5676],
    [-121.9539, 36.5608],
    [-121.9710, 36.5699],
    [-121.9728, 36.5751],
    [-121.9787, 36.5815],
    [-121.9757, 36.5803],
    [-121.9744, 36.5824],
    [-121.9724, 36.5839],
    [-121.9642, 36.5901],
    [-121.9622, 36.5985],
    [-121.9590, 36.6094],
    [-121.9486, 36.6108],
    [-121.9413, 36.6227],
    [-121.9364, 36.6367],
    [-121.9236, 36.6341],
    [-121.9192, 36.6276],
    [-121.9109, 36.6227],
    [-121.9037, 36.6218],
    [-121.8992, 36.6166],
    [-121.8951, 36.6096],
    [-121.8896, 36.6082],
    [-121.8892, 36.6050],
    [-121.8783, 36.6024],
    [-121.8606, 36.6111],
    [-121.8580, 36.6136],
    [-121.8509, 36.6202],
    [-121.8251, 36.6572],
    [-121.8093, 36.7048],
    [-121.8071, 36.7142],
    [-121.8052, 36.7518],
    [-121.7981, 36.7757],
    [-121.7883, 36.8040],
    [-121.7915, 36.8152],
    [-121.8044, 36.8382],
    [-121.8277, 36.8794],
    [-121.8623, 36.9316],
    [-121.8671, 36.9365],
    [-121.8947, 36.9619],
    [-121.9066, 36.9690],
    [-121.9254, 36.9763],
    [-121.9332, 36.9781],
    [-121.9395, 36.9780],
    [-121.9560, 36.9679],
    [-121.9728, 36.9542],
    [-121.9839, 36.9587],
    [-122.0006, 36.9606],
    [-122.0127, 36.9632],
    [-122.0255, 36.9595],
    [-122.0272, 36.9511],
    [-122.0419, 36.9522],
    [-122.0469, 36.9499],
    [-122.0689, 36.9488],
    [-122.0782, 36.9526],
    [-122.1060, 36.9560],
    [-122.1267, 36.9644],
    [-122.1406, 36.9749],
    [-122.1628, 36.9881],
    [-122.1761, 36.9954],
    [-122.1855, 37.0014],
    [-122.1869, 37.0035],
    [-122.1963, 37.0094],
    [-122.2025, 37.0123],
    [-122.2062, 37.0139],
    [-122.2167, 37.0246],
    [-122.2288, 37.0386],
    [-122.2605, 37.0725],
    [-122.2930, 37.1073],
    [-122.3230, 37.1155],
    [-122.3371, 37.1174],
    [-122.3378, 37.1359],
    [-122.3522, 37.1459],
    [-122.3618, 37.1636],
    [-122.3793, 37.1811],
    [-122.3948, 37.1815],
    [-122.4051, 37.1958],
    [-122.4096, 37.2246],
    [-122.4185, 37.2485],
    [-122.4050, 37.3116],
    [-122.4013, 37.3370],
    [-122.4093, 37.3748],
    [-122.4242, 37.4012],
    [-122.4319, 37.4121],
    [-122.4386, 37.4251],
    [-122.4421, 37.4325],
    [-122.4453, 37.4542],
    [-122.4521, 37.4805],
    [-122.4596, 37.4927],
    [-122.4632, 37.4951],
    [-122.4724, 37.5005],
    [-122.4857, 37.4947],
    [-122.4871, 37.4943],
    [-122.4941, 37.4929],
    [-122.5007, 37.4980],
    [-122.5059, 37.5071],
    [-122.5167, 37.5216],
    [-122.5195, 37.5373],
    [-122.5148, 37.5461],
    [-122.5152, 37.5663],
    [-122.5204, 37.5753],
    [-122.5172, 37.5906],
    [-122.5147, 37.5983],
    [-122.5075, 37.5962],
    [-122.5013, 37.6002],
    [-122.5020, 37.6062],
    [-122.4984, 37.6083],
    [-122.4968, 37.6121],
    [-122.4981, 37.6196],
    [-122.4953, 37.6299],
    [-122.4946, 37.6382],
    [-122.4954, 37.6643],
    [-122.4966, 37.6834],
    [-122.5024, 37.7081],
    [-122.5100, 37.7488],
    [-122.5131, 37.7712],
    [-122.5053, 37.7883],
    [-122.4858, 37.7906],
    [-122.4781, 37.8108],
    [-122.4482, 37.8073],
    [-122.4250, 37.8110],
    [-122.3996, 37.8066],
    [-122.3897, 37.7958],
    [-122.3853, 37.7907],
    [-122.3805, 37.7675],
    [-122.3786, 37.7536],
    [-122.3734, 37.7458],
    [-122.3736, 37.7394],
    [-122.3673, 37.7385],
    [-122.3720, 37.7370],
    [-122.3749, 37.7343],
    [-122.3733, 37.7332],
    [-122.3698, 37.7327],
    [-122.3647, 37.7319],
    [-122.3641, 37.7157],
    [-122.3773, 37.7146],
    [-122.3907, 37.7086],
    [-122.3893, 37.6877],
    [-122.3810, 37.6724],
    [-122.3743, 37.6622],
    [-122.3872, 37.6473],
    [-122.3843, 37.6404],
    [-122.3651, 37.6281],
    [-122.3556, 37.6153],
    [-122.3733, 37.6138],
    [-122.3746, 37.6043],
    [-122.3596, 37.5925],
    [-122.3330, 37.5882],
    [-122.3149, 37.5912],
    [-122.3059, 37.5755],
    [-122.2884, 37.5754],
    [-122.2629, 37.5739],
    [-122.2490, 37.5641],
    [-122.2428, 37.5574],
    [-122.2269, 37.5485],
    [-122.2125, 37.5402],
    [-122.1956, 37.5348],
    [-122.1950, 37.5225],
    [-122.1795, 37.5118],
    [-122.1642, 37.5016],
    [-122.1496, 37.5027],
    [-122.1310, 37.5037],
    [-122.1241, 37.4859],
    [-122.1210, 37.4765],
    [-122.1152, 37.4663],
    [-122.0963, 37.4578],
    [-122.0854, 37.4519],
    [-122.0599, 37.4473],
    [-122.0457, 37.4492],
    [-122.0409, 37.4629],
    [-122.0545, 37.4873],
    [-122.0928, 37.5006],
    [-122.1113, 37.5076],
    [-122.1120, 37.5289],
    [-122.1339, 37.5629],
    [-122.1470, 37.5884],
    [-122.1464, 37.6074],
    [-122.1539, 37.6435],
    [-122.1630, 37.6679],
    [-122.1702, 37.6779],
    [-122.1774, 37.6811],
    [-122.1844, 37.6905],
    [-122.1936, 37.6944],
    [-122.2042, 37.7116],
    [-122.2118, 37.7020],
    [-122.2467, 37.7208],
    [-122.2485, 37.7279],
    [-122.2610, 37.7396],
    [-122.2485, 37.7490],
    [-122.2506, 37.7541],
    [-122.2719, 37.7615],
    [-122.2794, 37.7681],
    [-122.2890, 37.7646],
    [-122.3049, 37.7723],
    [-122.3189, 37.7790],
    [-122.3320, 37.7878],
    [-122.3367, 37.8003],
    [-122.3341, 37.8103],
    [-122.3232, 37.8103],
    [-122.3304, 37.8206],
    [-122.2966, 37.8285],
    [-122.3159, 37.8368],
    [-122.3010, 37.8457],
    [-122.3014, 37.8555],
    [-122.3187, 37.8664],
    [-122.3132, 37.8702],
    [-122.3128, 37.8813],
    [-122.3269, 37.8896],
    [-122.3111, 37.8904],
    [-122.3152, 37.8968],
    [-122.3223, 37.8954],
    [-122.3336, 37.9085],
    [-122.3523, 37.9076],
    [-122.3635, 37.9052],
    [-122.3859, 37.9081],
    [-122.3905, 37.9225],
    [-122.3977, 37.9294],
    [-122.4100, 37.9324],
    [-122.4141, 37.9453],
    [-122.4207, 37.9549],
    [-122.4298, 37.9654],
    [-122.4118, 37.9605],
    [-122.3955, 37.9599],
    [-122.4011, 37.9678],
    [-122.3816, 37.9718],
    [-122.3630, 37.9944],
    [-122.3679, 38.0125],
    [-122.3555, 38.0087],
    [-122.3304, 38.0026],
    [-122.3154, 38.0116],
    [-122.3133, 38.0115],
    [-122.2951, 38.0152],
    [-122.2856, 38.0225],
    [-122.2756, 38.0357],
    [-122.2670, 38.0411],
    [-122.2681, 38.0583],
    [-122.2697, 38.0604],
    [-122.3026, 38.1032],
    [-122.3568, 38.1311],
    [-122.3936, 38.1434],
    [-122.4000, 38.1386],
    [-122.4396, 38.1169],
    [-122.4504, 38.1163],
    [-122.4561, 38.1175],
    [-122.4907, 38.1098],
    [-122.4884, 38.1055],
    [-122.4859, 38.0992],
    [-122.4856, 38.0685],
    [-122.4923, 38.0564],
    [-122.4933, 38.0474],
    [-122.4978, 38.0194],
    [-122.4946, 38.0151],
    [-122.4756, 38.0063],
    [-122.4695, 38.0049],
    [-122.4659, 38.0041],
    [-122.4626, 38.0032],
    [-122.4553, 37.9965],
    [-122.4484, 37.9883],
    [-122.4637, 37.9815],
    [-122.4746, 37.9776],
    [-122.4773, 37.9716],
    [-122.4950, 37.9705],
    [-122.4965, 37.9677],
    [-122.4903, 37.9610],
    [-122.4805, 37.9454],
    [-122.4865, 37.9398],
    [-122.4986, 37.9415],
    [-122.5051, 37.9423],
    [-122.5031, 37.9288],
    [-122.4850, 37.9209],
    [-122.4810, 37.9178],
    [-122.4736, 37.9125],
    [-122.4761, 37.9077],
    [-122.4741, 37.9037],
    [-122.4714, 37.9021],
    [-122.4586, 37.8941],
    [-122.4437, 37.8867],
    [-122.4383, 37.8810],
    [-122.4432, 37.8797],
    [-122.4446, 37.8769],
    [-122.4506, 37.8717],
    [-122.4623, 37.8708],
    [-122.4685, 37.8681],
    [-122.4733, 37.8793],
    [-122.4733, 37.8834],
    [-122.4751, 37.8863],
    [-122.4894, 37.8952],
    [-122.4999, 37.8937],
    [-122.4985, 37.8758],
    [-122.4963, 37.8708],
    [-122.4784, 37.8595],
    [-122.4784, 37.8539],
    [-122.4794, 37.8507],
    [-122.4784, 37.8473],
    [-122.4723, 37.8368],
    [-122.4742, 37.8334],
    [-122.4782, 37.8314],
    [-122.4835, 37.8267],
    [-122.4976, 37.8224],
    [-122.5000, 37.8216],
    [-122.5054, 37.8221],
    [-122.5257, 37.8212],
    [-122.5274, 37.8149],
    [-122.5360, 37.8240],
    [-122.5373, 37.8303],
    [-122.5546, 37.8420],
    [-122.5615, 37.8518],
    [-122.5782, 37.8596],
    [-122.5843, 37.8592],
    [-122.6013, 37.8751],
    [-122.6211, 37.8788],
    [-122.6287, 37.8817],
    [-122.6420, 37.8975],
    [-122.6785, 37.9066],
    [-122.6997, 37.8971],
    [-122.7102, 37.8964],
    [-122.7218, 37.9013],
    [-122.7278, 37.9062],
    [-122.7369, 37.9258],
    [-122.7546, 37.9355],
    [-122.7682, 37.9417],
    [-122.7761, 37.9463],
    [-122.7832, 37.9513],
    [-122.8068, 37.9839],
    [-122.8214, 37.9967],
    [-122.9051, 38.0284],
    [-122.9568, 38.0287],
    [-122.9831, 38.0058],
    [-122.9740, 37.9943],
    [-122.9721, 37.9901],
    [-122.9915, 37.9945],
    [-123.0075, 37.9954],
    [-123.0241, 37.9949],
    [-123.0115, 38.0034],
    [-122.9521, 38.1386],
    [-122.9535, 38.1703],
    [-122.9609, 38.1794],
    [-122.9664, 38.1985],
    [-122.9804, 38.2210],
    [-122.9920, 38.2332],
    [-122.9953, 38.2408],
    [-122.9790, 38.2293],
    [-122.9721, 38.2327],
    [-122.9702, 38.2435],
    [-122.9735, 38.2609],
    [-122.9863, 38.2732],
    [-122.9971, 38.2895],
    [-123.0243, 38.3106],
    [-123.0511, 38.3107],
    [-123.0520, 38.3022],
    [-123.0637, 38.3022],
    [-123.0798, 38.3241],
    [-123.0688, 38.3344],
    [-123.0683, 38.3566],
    [-123.0786, 38.3744],
    [-123.0806, 38.3774],
    [-123.0856, 38.3905],
    [-123.0964, 38.3934],
    [-123.1026, 38.4136],
    [-123.1134, 38.4215],
    [-123.1217, 38.4300],
    [-123.1244, 38.4406],
    [-123.1268, 38.4445],
    [-123.1290, 38.4505],
    [-123.1377, 38.4549],
    [-123.1564, 38.4646],
    [-123.1616, 38.4682],
    [-123.1986, 38.4911],
    [-123.2152, 38.4995],
    [-123.2314, 38.5026],
    [-123.2421, 38.5100],
    [-123.2549, 38.5120],
    [-123.2660, 38.5229],
    [-123.2689, 38.5254],
    [-123.2742, 38.5327],
    [-123.2829, 38.5360],
    [-123.2905, 38.5406],
    [-123.2979, 38.5441],
    [-123.3063, 38.5493],
    [-123.3172, 38.5594],
    [-123.3306, 38.5669],
    [-123.3404, 38.5778],
    [-123.3496, 38.5968],
    [-123.3598, 38.5982],
    [-123.3719, 38.6072],
    [-123.3676, 38.6134],
    [-123.3793, 38.6220],
    [-123.3899, 38.6352],
    [-123.4009, 38.6466],
    [-123.4087, 38.6547],
    [-123.4094, 38.6622],
    [-123.4197, 38.6747],
    [-123.4322, 38.6834],
    [-123.4387, 38.6955],
    [-123.4453, 38.6999],
    [-123.4536, 38.7072],
    [-123.4558, 38.7121],
    [-123.4688, 38.7204],
    [-123.4790, 38.7245],
    [-123.4898, 38.7320],
    [-123.4988, 38.7379],
    [-123.5108, 38.7404],
    [-123.5176, 38.7452],
    [-123.5244, 38.7493],
    [-123.5272, 38.7572],
    [-123.5335, 38.7684],
    [-123.5418, 38.7768],
    [-123.5552, 38.7837],
    [-123.5625, 38.7862],
    [-123.5720, 38.7982],
    [-123.5787, 38.8019],
    [-123.5841, 38.8008],
    [-123.5908, 38.7987],
    [-123.5910, 38.8043],
    [-123.5927, 38.8071],
    [-123.6018, 38.8070],
    [-123.6000, 38.8091],
    [-123.6027, 38.8171],
    [-123.6053, 38.8228],
    [-123.6193, 38.8299],
    [-123.6346, 38.8394],
    [-123.6452, 38.8448],
    [-123.6547, 38.8656],
    [-123.6817, 38.8856],
    [-123.6922, 38.8959],
    [-123.7078, 38.9091],
    [-123.7105, 38.9132],
    [-123.7171, 38.9167],
    [-123.7232, 38.9184],
    [-123.7280, 38.9194],
    [-123.7263, 38.9364],
    [-123.7419, 38.9562],
    [-123.7329, 38.9550],
    [-123.7111, 38.9773],
    [-123.6926, 39.0252],
    [-123.6904, 39.0366],
    [-123.6939, 39.0419],
    [-123.6912, 39.0508],
    [-123.6940, 39.0574],
    [-123.7059, 39.0808],
    [-123.7062, 39.0909],
    [-123.7110, 39.0976],
    [-123.7095, 39.1046],
    [-123.7202, 39.1227],
    [-123.7204, 39.1301],
    [-123.7231, 39.1372],
    [-123.7322, 39.1413],
    [-123.7379, 39.1434],
    [-123.7379, 39.1627],
    [-123.7468, 39.1720],
    [-123.7562, 39.1819],
    [-123.7646, 39.1915],
    [-123.7730, 39.1983],
    [-123.7768, 39.2145],
    [-123.7700, 39.2161],
    [-123.7761, 39.2226],
    [-123.7787, 39.2308],
    [-123.7774, 39.2372],
    [-123.7869, 39.2597],
    [-123.7879, 39.2643],
    [-123.7921, 39.2736],
    [-123.8018, 39.2757],
    [-123.8018, 39.2835],
    [-123.8018, 39.2933],
    [-123.7952, 39.2934],
    [-123.7980, 39.3018],
    [-123.8095, 39.3028],
    [-123.8114, 39.3128],
    [-123.8009, 39.3183],
    [-123.8088, 39.3244],
    [-123.8078, 39.3289],
    [-123.8180, 39.3347],
    [-123.8277, 39.3484],
    [-123.8236, 39.3581],
    [-123.8239, 39.3616],
    [-123.8171, 39.3605],
    [-123.8261, 39.3689],
    [-123.8233, 39.3715],
    [-123.8223, 39.3800],
    [-123.8213, 39.3980],
    [-123.8196, 39.4086],
    [-123.8152, 39.4147],
    [-123.8159, 39.4212],
    [-123.8168, 39.4261],
    [-123.8094, 39.4268],
    [-123.8128, 39.4309],
    [-123.8178, 39.4327],
    [-123.8161, 39.4388],
    [-123.8161, 39.4446],
    [-123.8132, 39.4511],
    [-123.8114, 39.4558],
    [-123.8080, 39.4709],
    [-123.8026, 39.4830],
    [-123.8043, 39.4900],
    [-123.7956, 39.4922],
    [-123.7842, 39.5094],
    [-123.7665, 39.5528],
    [-123.7710, 39.5652],
    [-123.7778, 39.5761],
    [-123.7771, 39.5838],
    [-123.7863, 39.5956],
    [-123.7873, 39.6078],
    [-123.7823, 39.6215],
    [-123.7859, 39.6360],
    [-123.7857, 39.6540],
    [-123.7890, 39.6648],
    [-123.7919, 39.6812],
    [-123.7970, 39.6918],
    [-123.8042, 39.7038],
    [-123.8295, 39.7231],
    [-123.8292, 39.7361],
    [-123.8351, 39.7388],
    [-123.8354, 39.7506],
    [-123.8398, 39.7956],
    [-123.8455, 39.8083],
    [-123.8517, 39.8320],
    [-123.8883, 39.8504],
    [-123.8953, 39.8559],
    [-123.9020, 39.8604],
    [-123.9151, 39.8753],
    [-123.9372, 39.9133],
    [-123.9496, 39.9197],
    [-123.9588, 39.9280],
    [-123.9751, 39.9528],
    [-124.0063, 39.9856],
    [-124.0213, 39.9996],
    [-124.0359, 40.0133],
    [-124.0428, 40.0166],
    [-124.0618, 40.0253],
    [-124.0689, 40.0213],
    [-124.0771, 40.0283],
    [-124.0786, 40.0362],
    [-124.0803, 40.0474],
    [-124.0933, 40.0834],
    [-124.1073, 40.1002],
    [-124.1222, 40.1091],
    [-124.1337, 40.1132],
    [-124.1524, 40.1195],
    [-124.1764, 40.1274],
    [-124.1824, 40.1301],
    [-124.2002, 40.1444],
    [-124.2149, 40.1609],
    [-124.2311, 40.1716],
    [-124.2584, 40.1843],
    [-124.2893, 40.2032],
    [-124.3196, 40.2257],
    [-124.3328, 40.2403],
    [-124.3555, 40.2541],
    [-124.3624, 40.2650],
    [-124.3558, 40.2952],
    [-124.3499, 40.3096],
    [-124.3531, 40.3314],
    [-124.3623, 40.3428],
    [-124.3654, 40.3749],
    [-124.3791, 40.3988],
    [-124.3930, 40.4107],
    [-124.3992, 40.4178],
    [-124.4032, 40.4304],
    [-124.4096, 40.4381],
    [-124.4086, 40.4432]
    ]
  },
  "Alabama": {
    coordinates: [
      [-88.4732, 31.8939],
    [-88.4689, 31.9303],
    [-88.4550, 32.0406],
    [-88.4430, 32.1370],
    [-88.4387, 32.1721],
    [-88.4338, 32.2087],
    [-88.4279, 32.2530],
    [-88.4149, 32.3645],
    [-88.4138, 32.3739],
    [-88.4039, 32.4488],
    [-88.4038, 32.4499],
    [-88.4000, 32.4854],
    [-88.3856, 32.6055],
    [-88.3830, 32.6270],
    [-88.3683, 32.7477],
    [-88.3543, 32.8751],
    [-88.3310, 33.0725],
    [-88.3219, 33.1462],
    [-88.3125, 33.2209],
    [-88.3044, 33.2883],
    [-88.3005, 33.3208],
    [-88.2911, 33.3991],
    [-88.2783, 33.5047],
    [-88.2746, 33.5340],
    [-88.2708, 33.5649],
    [-88.2691, 33.5769],
    [-88.2670, 33.5942],
    [-88.2620, 33.6354],
    [-88.2546, 33.6958],
    [-88.2489, 33.7450],
    [-88.2430, 33.7957],
    [-88.2401, 33.8109],
    [-88.2295, 33.8904],
    [-88.2289, 33.8942],
    [-88.2264, 33.9129],
    [-88.2117, 34.0217],
    [-88.2060, 34.0684],
    [-88.1921, 34.1754],
    [-88.1867, 34.2210],
    [-88.1769, 34.2939],
    [-88.1659, 34.3809],
    [-88.1614, 34.4196],
    [-88.1568, 34.4593],
    [-88.1561, 34.4650],
    [-88.1392, 34.5878],
    [-88.1343, 34.6227],
    [-88.1208, 34.7089],
    [-88.1076, 34.8116],
    [-88.1000, 34.8941],
    [-88.1367, 34.9076],
    [-88.1546, 34.9224],
    [-88.1761, 34.9625],
    [-88.1988, 34.9912],
    [-88.2020, 35.0054],
    [-87.9849, 35.0059],
    [-87.8780, 35.0055],
    [-87.8535, 35.0055],
    [-87.8212, 35.0054],
    [-87.7676, 35.0048],
    [-87.7095, 35.0041],
    [-87.7005, 35.0040],
    [-87.6714, 35.0035],
    [-87.6193, 35.0037],
    [-87.5224, 35.0032],
    [-87.4929, 35.0031],
    [-87.4370, 35.0028],
    [-87.4174, 35.0027],
    [-87.3811, 35.0021],
    [-87.3493, 35.0017],
    [-87.2992, 35.0009],
    [-87.2241, 34.9993],
    [-87.2152, 34.9991],
    [-87.1396, 34.9976],
    [-87.1205, 34.9973],
    [-87.0301, 34.9955],
    [-86.9887, 34.9949],
    [-86.9702, 34.9945],
    [-86.8792, 34.9924],
    [-86.8616, 34.9920],
    [-86.8498, 34.9919],
    [-86.8363, 34.9918],
    [-86.7836, 34.9919],
    [-86.7217, 34.9920],
    [-86.6767, 34.9921],
    [-86.6596, 34.9918],
    [-86.6000, 34.9912],
    [-86.5712, 34.9910],
    [-86.5285, 34.9907],
    [-86.4733, 34.9907],
    [-86.4286, 34.9912],
    [-86.3188, 34.9911],
    [-86.1529, 34.9901],
    [-86.0616, 34.9896],
    [-85.8287, 34.9882],
    [-85.7961, 34.9877],
    [-85.7454, 34.9869],
    [-85.7223, 34.9865],
    [-85.7008, 34.9862],
    [-85.6115, 34.9848],
    [-85.5994, 34.9518],
    [-85.5952, 34.9243],
    [-85.5759, 34.8237],
    [-85.5581, 34.7344],
    [-85.5521, 34.7065],
    [-85.5413, 34.6567],
    [-85.5273, 34.5887],
    [-85.5139, 34.5252],
    [-85.5084, 34.5012],
    [-85.5023, 34.4740],
    [-85.4704, 34.3282],
    [-85.4621, 34.2864],
    [-85.4554, 34.2529],
    [-85.4447, 34.1999],
    [-85.4279, 34.1126],
    [-85.4067, 34.0023],
    [-85.3988, 33.9641],
    [-85.3865, 33.9017],
    [-85.3764, 33.8507],
    [-85.3605, 33.7680],
    [-85.3553, 33.7392],
    [-85.3226, 33.5742],
    [-85.3150, 33.5359],
    [-85.3140, 33.5298],
    [-85.2975, 33.4469],
    [-85.2814, 33.3631],
    [-85.2521, 33.2109],
    [-85.2284, 33.0884],
    [-85.2233, 33.0626],
    [-85.2041, 32.9667],
    [-85.1908, 32.9000],
    [-85.1871, 32.8817],
    [-85.1850, 32.8720],
    [-85.1847, 32.8695],
    [-85.1849, 32.8634],
    [-85.1844, 32.8613],
    [-85.1784, 32.8547],
    [-85.1701, 32.8525],
    [-85.1643, 32.8562],
    [-85.1598, 32.8549],
    [-85.1543, 32.8475],
    [-85.1535, 32.8428],
    [-85.1574, 32.8394],
    [-85.1655, 32.8334],
    [-85.1647, 32.8202],
    [-85.1679, 32.8117],
    [-85.1621, 32.8042],
    [-85.1506, 32.7935],
    [-85.1406, 32.7897],
    [-85.1347, 32.7839],
    [-85.1236, 32.7757],
    [-85.1344, 32.7706],
    [-85.1426, 32.7607],
    [-85.1348, 32.7468],
    [-85.1241, 32.7417],
    [-85.1133, 32.7358],
    [-85.1173, 32.7266],
    [-85.1215, 32.7204],
    [-85.1193, 32.7077],
    [-85.1153, 32.6873],
    [-85.1040, 32.6796],
    [-85.0897, 32.6556],
    [-85.1053, 32.6448],
    [-85.0966, 32.6347],
    [-85.0836, 32.6360],
    [-85.0849, 32.6303],
    [-85.0893, 32.6250],
    [-85.0854, 32.6185],
    [-85.0808, 32.6102],
    [-85.0764, 32.5947],
    [-85.0569, 32.5712],
    [-85.0350, 32.5521],
    [-85.0225, 32.5429],
    [-85.0163, 32.5312],
    [-85.0138, 32.5261],
    [-85.0029, 32.5170],
    [-85.0008, 32.5102],
    [-84.9998, 32.5043],
    [-84.9983, 32.4941],
    [-84.9948, 32.4860],
    [-84.9967, 32.4726],
    [-84.9980, 32.4619],
    [-84.9952, 32.4531],
    [-84.9838, 32.4456],
    [-84.9630, 32.4242],
    [-84.9634, 32.4225],
    [-84.9803, 32.4073],
    [-84.9739, 32.3952],
    [-84.9718, 32.3906],
    [-84.9834, 32.3918],
    [-84.9886, 32.3841],
    [-84.9738, 32.3799],
    [-84.9773, 32.3738],
    [-84.9863, 32.3697],
    [-84.9835, 32.3632],
    [-85.0046, 32.3452],
    [-85.0019, 32.3220],
    [-84.9387, 32.3007],
    [-84.9111, 32.2769],
    [-84.8918, 32.2634],
    [-84.8892, 32.2592],
    [-84.9015, 32.2574],
    [-84.9072, 32.2490],
    [-84.9230, 32.2508],
    [-84.9230, 32.2445],
    [-84.9139, 32.2451],
    [-84.9206, 32.2340],
    [-84.9235, 32.2298],
    [-84.9282, 32.2199],
    [-84.9495, 32.2185],
    [-84.9614, 32.2181],
    [-84.9787, 32.2126],
    [-84.9771, 32.2058],
    [-84.9694, 32.2045],
    [-84.9622, 32.2001],
    [-84.9668, 32.1940],
    [-85.0085, 32.1819],
    [-85.0146, 32.1769],
    [-85.0340, 32.1563],
    [-85.0587, 32.1360],
    [-85.0615, 32.1297],
    [-85.0538, 32.1077],
    [-85.0455, 32.0869],
    [-85.0532, 32.0806],
    [-85.0541, 32.0702],
    [-85.0568, 32.0598],
    [-85.0588, 32.0467],
    [-85.0548, 32.0388],
    [-85.0565, 32.0318],
    [-85.0544, 32.0267],
    [-85.0493, 32.0227],
    [-85.0548, 32.0174],
    [-85.0634, 32.0041],
    [-85.0681, 31.9919],
    [-85.0699, 31.9784],
    [-85.0659, 31.9712],
    [-85.0739, 31.9642],
    [-85.0867, 31.9592],
    [-85.0789, 31.9415],
    [-85.0864, 31.9360],
    [-85.0995, 31.9253],
    [-85.1024, 31.9174],
    [-85.1127, 31.9099],
    [-85.1116, 31.9013],
    [-85.1140, 31.8934],
    [-85.1329, 31.8931],
    [-85.1343, 31.8914],
    [-85.1298, 31.8833],
    [-85.1284, 31.8776],
    [-85.1337, 31.8701],
    [-85.1401, 31.8588],
    [-85.1380, 31.8513],
    [-85.1413, 31.8411],
    [-85.1359, 31.8305],
    [-85.1343, 31.8246],
    [-85.1313, 31.8176],
    [-85.1328, 31.8004],
    [-85.1329, 31.7924],
    [-85.1419, 31.7820],
    [-85.1307, 31.7723],
    [-85.1256, 31.7645],
    [-85.1266, 31.7525],
    [-85.1191, 31.7310],
    [-85.1265, 31.7168],
    [-85.1255, 31.6950],
    [-85.1126, 31.6852],
    [-85.0878, 31.6579],
    [-85.0799, 31.6553],
    [-85.0803, 31.6508],
    [-85.0852, 31.6441],
    [-85.0845, 31.6390],
    [-85.0738, 31.6296],
    [-85.0595, 31.6217],
    [-85.0575, 31.6176],
    [-85.0604, 31.6113],
    [-85.0573, 31.6067],
    [-85.0561, 31.6043],
    [-85.0583, 31.5866],
    [-85.0553, 31.5771],
    [-85.0529, 31.5629],
    [-85.0457, 31.5487],
    [-85.0413, 31.5410],
    [-85.0472, 31.5287],
    [-85.0446, 31.5209],
    [-85.0456, 31.5168],
    [-85.0530, 31.5065],
    [-85.0657, 31.4841],
    [-85.0667, 31.4473],
    [-85.0659, 31.4306],
    [-85.0727, 31.4283],
    [-85.0758, 31.4215],
    [-85.0800, 31.4105],
    [-85.0786, 31.3964],
    [-85.0869, 31.3745],
    [-85.0925, 31.3629],
    [-85.0910, 31.3544],
    [-85.0859, 31.3502],
    [-85.0878, 31.3380],
    [-85.0842, 31.3283],
    [-85.0874, 31.3112],
    [-85.0898, 31.2950],
    [-85.0998, 31.2840],
    [-85.1146, 31.2773],
    [-85.1119, 31.2725],
    [-85.1124, 31.2596],
    [-85.1062, 31.2481],
    [-85.1008, 31.2348],
    [-85.0987, 31.2195],
    [-85.1056, 31.2046],
    [-85.1077, 31.1899],
    [-85.1044, 31.1856],
    [-85.0984, 31.1778],
    [-85.0921, 31.1603],
    [-85.0778, 31.1579],
    [-85.0702, 31.1487],
    [-85.0611, 31.1342],
    [-85.0529, 31.1195],
    [-85.0405, 31.1116],
    [-85.0328, 31.1006],
    [-85.0283, 31.0769],
    [-85.0181, 31.0593],
    [-85.0088, 31.0456],
    [-85.0051, 31.0247],
    [-84.9994, 31.0138],
    [-85.0025, 31.0007],
    [-85.0301, 31.0007],
    [-85.0548, 31.0006],
    [-85.1458, 31.0007],
    [-85.1545, 31.0008],
    [-85.2132, 31.0009],
    [-85.3129, 30.9998],
    [-85.3817, 30.9987],
    [-85.4926, 30.9970],
    [-85.5795, 30.9964],
    [-85.6314, 30.9961],
    [-85.6922, 30.9957],
    [-85.7496, 30.9953],
    [-85.8311, 30.9941],
    [-85.9358, 30.9932],
    [-85.9973, 30.9929],
    [-86.0525, 30.9932],
    [-86.1327, 30.9932],
    [-86.1752, 30.9938],
    [-86.2383, 30.9944],
    [-86.2888, 30.9938],
    [-86.2971, 30.9939],
    [-86.3225, 30.9942],
    [-86.3502, 30.9944],
    [-86.3745, 30.9945],
    [-86.3919, 30.9942],
    [-86.4583, 30.9940],
    [-86.5199, 30.9932],
    [-86.5676, 30.9951],
    [-86.6784, 30.9945],
    [-86.7254, 30.9969],
    [-86.7452, 30.9963],
    [-86.8305, 30.9974],
    [-86.8881, 30.9976],
    [-86.9985, 30.9987],
    [-87.0271, 30.9993],
    [-87.0537, 30.9991],
    [-87.0710, 30.9992],
    [-87.1151, 30.9994],
    [-87.1408, 30.9995],
    [-87.1636, 30.9990],
    [-87.2247, 30.9972],
    [-87.2383, 30.9965],
    [-87.2550, 30.9983],
    [-87.2580, 30.9983],
    [-87.2656, 30.9983],
    [-87.2889, 30.9983],
    [-87.3016, 30.9984],
    [-87.3340, 30.9983],
    [-87.3639, 30.9982],
    [-87.4258, 30.9981],
    [-87.4557, 30.9983],
    [-87.4618, 30.9982],
    [-87.4778, 30.9982],
    [-87.4802, 30.9982],
    [-87.4984, 30.9979],
    [-87.5485, 30.9979],
    [-87.5992, 30.9957],
    [-87.5927, 30.9801],
    [-87.5941, 30.9763],
    [-87.5892, 30.9645],
    [-87.5983, 30.9388],
    [-87.6078, 30.9245],
    [-87.6118, 30.9145],
    [-87.6160, 30.9015],
    [-87.6225, 30.8937],
    [-87.6221, 30.8854],
    [-87.6300, 30.8777],
    [-87.6282, 30.8601],
    [-87.6265, 30.8519],
    [-87.6241, 30.8457],
    [-87.6159, 30.8347],
    [-87.6036, 30.8286],
    [-87.5943, 30.8170],
    [-87.5768, 30.8082],
    [-87.5642, 30.7962],
    [-87.5548, 30.7871],
    [-87.5450, 30.7787],
    [-87.5423, 30.7675],
    [-87.5354, 30.7548],
    [-87.5236, 30.7383],
    [-87.5023, 30.7216],
    [-87.4968, 30.7204],
    [-87.4798, 30.7149],
    [-87.4704, 30.7053],
    [-87.4569, 30.6976],
    [-87.4436, 30.6946],
    [-87.4398, 30.6905],
    [-87.4249, 30.6834],
    [-87.4070, 30.6752],
    [-87.4059, 30.6666],
    [-87.3973, 30.6544],
    [-87.3959, 30.6440],
    [-87.3938, 30.6274],
    [-87.3957, 30.6234],
    [-87.3951, 30.6159],
    [-87.3993, 30.6056],
    [-87.4066, 30.5999],
    [-87.4126, 30.5736],
    [-87.4163, 30.5724],
    [-87.4170, 30.5680],
    [-87.4209, 30.5607],
    [-87.4234, 30.5614],
    [-87.4314, 30.5503],
    [-87.4466, 30.5271],
    [-87.4449, 30.5149],
    [-87.4473, 30.5126],
    [-87.4447, 30.5075],
    [-87.4383, 30.5054],
    [-87.4330, 30.4849],
    [-87.4347, 30.4792],
    [-87.4296, 30.4706],
    [-87.4079, 30.4564],
    [-87.3969, 30.4506],
    [-87.3783, 30.4492],
    [-87.3669, 30.4405],
    [-87.3682, 30.4334],
    [-87.3844, 30.4216],
    [-87.3988, 30.4151],
    [-87.4048, 30.4099],
    [-87.4192, 30.4102],
    [-87.4296, 30.4065],
    [-87.4318, 30.4032],
    [-87.4384, 30.3945],
    [-87.4409, 30.3867],
    [-87.4418, 30.3763],
    [-87.4519, 30.3650],
    [-87.4523, 30.3441],
    [-87.4649, 30.3333],
    [-87.4919, 30.3309],
    [-87.5026, 30.3274],
    [-87.5058, 30.3151],
    [-87.5028, 30.3073],
    [-87.4837, 30.3048],
    [-87.4687, 30.3082],
    [-87.4596, 30.3083],
    [-87.4524, 30.3002],
    [-87.5184, 30.2839],
    [-87.5183, 30.2804],
    [-87.5488, 30.2736],
    [-87.5650, 30.2717],
    [-87.5822, 30.2690],
    [-87.6382, 30.2545],
    [-87.6866, 30.2463],
    [-87.7147, 30.2431],
    [-87.7365, 30.2405],
    [-87.8282, 30.2278],
    [-87.9261, 30.2304],
    [-88.0136, 30.2235],
    [-88.0286, 30.2268],
    [-87.9668, 30.2356],
    [-87.9182, 30.2533],
    [-87.8932, 30.2392],
    [-87.8229, 30.2526],
    [-87.7878, 30.2542],
    [-87.7716, 30.2609],
    [-87.7574, 30.2765],
    [-87.7553, 30.2819],
    [-87.7555, 30.2912],
    [-87.8093, 30.3327],
    [-87.8345, 30.3614],
    [-87.8374, 30.3718],
    [-87.8374, 30.3763],
    [-87.8494, 30.3781],
    [-87.9063, 30.4094],
    [-87.9141, 30.4461],
    [-87.9200, 30.4706],
    [-87.9252, 30.4774],
    [-87.9340, 30.4865],
    [-87.9253, 30.5018],
    [-87.9228, 30.5072],
    [-87.9215, 30.5114],
    [-87.9123, 30.5239],
    [-87.9044, 30.5411],
    [-87.9021, 30.5533],
    [-87.9028, 30.5576],
    [-87.9043, 30.5663],
    [-87.9126, 30.5794],
    [-87.9138, 30.6001],
    [-87.9140, 30.6201],
    [-87.9214, 30.6269],
    [-87.9193, 30.6361],
    [-87.9254, 30.6489],
    [-87.9317, 30.6544],
    [-87.9605, 30.6617],
    [-87.9861, 30.6776],
    [-87.9976, 30.6798],
    [-88.0089, 30.6834],
    [-88.0218, 30.6686],
    [-88.0292, 30.6590],
    [-88.0447, 30.6499],
    [-88.0581, 30.6455],
    [-88.0560, 30.6375],
    [-88.0603, 30.6266],
    [-88.0589, 30.6084],
    [-88.0605, 30.5990],
    [-88.0749, 30.5789],
    [-88.0873, 30.5654],
    [-88.0871, 30.5641],
    [-88.0849, 30.5608],
    [-88.0898, 30.5242],
    [-88.1009, 30.5098],
    [-88.1030, 30.4930],
    [-88.1006, 30.4612],
    [-88.1041, 30.4273],
    [-88.1246, 30.3416],
    [-88.1345, 30.3279],
    [-88.1386, 30.3120],
    [-88.1461, 30.3230],
    [-88.1915, 30.3170],
    [-88.1932, 30.3260],
    [-88.1966, 30.3374],
    [-88.1885, 30.3451],
    [-88.1880, 30.3562],
    [-88.1898, 30.3630],
    [-88.2001, 30.3624],
    [-88.2141, 30.3656],
    [-88.2309, 30.3716],
    [-88.2400, 30.3749],
    [-88.2656, 30.3811],
    [-88.2718, 30.3816],
    [-88.2874, 30.3843],
    [-88.2927, 30.3872],
    [-88.3033, 30.3732],
    [-88.3146, 30.3714],
    [-88.3151, 30.3916],
    [-88.3320, 30.4012],
    [-88.3500, 30.4051],
    [-88.3640, 30.3880],
    [-88.3996, 30.4582],
    [-88.4004, 30.4742],
    [-88.4035, 30.5331],
    [-88.4040, 30.5451],
    [-88.4060, 30.5898],
    [-88.4081, 30.6369],
    [-88.4113, 30.7063],
    [-88.4123, 30.7318],
    [-88.4181, 30.8559],
    [-88.4186, 30.8665],
    [-88.4256, 30.9983],
    [-88.4304, 31.0853],
    [-88.4381, 31.2301],
    [-88.4388, 31.2527],
    [-88.4404, 31.2786],
    [-88.4452, 31.3559],
    [-88.4487, 31.4213],
    [-88.4510, 31.4594],
    [-88.4533, 31.5054],
    [-88.4563, 31.5625],
    [-88.4597, 31.6240],
    [-88.4644, 31.6979],
    [-88.4682, 31.7817],
    [-88.4698, 31.8193],
    [-88.4726, 31.8752],
    [-88.4732, 31.8939]
    ]
  },
  "Georgia": {
    coordinates: [
      [-85.6052, 34.9847],
    [-85.4741, 34.9831],
    [-85.4323, 34.9830],
    [-85.4076, 34.9830],
    [-85.3652, 34.9834],
    [-85.3454, 34.9837],
    [-85.3425, 34.9838],
    [-85.3274, 34.9840],
    [-85.3055, 34.9845],
    [-85.3010, 34.9845],
    [-85.2869, 34.9848],
    [-85.2776, 34.9850],
    [-85.2730, 34.9850],
    [-85.2548, 34.9852],
    [-85.2356, 34.9855],
    [-85.2279, 34.9855],
    [-85.2179, 34.9857],
    [-85.2014, 34.9858],
    [-85.1806, 34.9861],
    [-85.1544, 34.9862],
    [-85.1388, 34.9863],
    [-85.0961, 34.9866],
    [-85.0452, 34.9869],
    [-84.9799, 34.9876],
    [-84.9444, 34.9879],
    [-84.9309, 34.9879],
    [-84.8915, 34.9878],
    [-84.8580, 34.9877],
    [-84.8205, 34.9879],
    [-84.8105, 34.9876],
    [-84.7761, 34.9878],
    [-84.7385, 34.9880],
    [-84.6823, 34.9880],
    [-84.5682, 34.9882],
    [-84.4554, 34.9880],
    [-84.3879, 34.9881],
    [-84.3557, 34.9882],
    [-84.2614, 34.9881],
    [-84.1784, 34.9877],
    [-84.0971, 34.9874],
    [-84.0214, 34.9874],
    [-83.9366, 34.9875],
    [-83.8920, 34.9874],
    [-83.8001, 34.9874],
    [-83.7499, 34.9877],
    [-83.6200, 34.9867],
    [-83.5494, 34.9925],
    [-83.3823, 34.9950],
    [-83.3678, 34.9952],
    [-83.3539, 34.9954],
    [-83.3229, 34.9959],
    [-83.2889, 34.9968],
    [-83.1086, 35.0007],
    [-83.1034, 34.9935],
    [-83.1007, 34.9899],
    [-83.1048, 34.9851],
    [-83.1079, 34.9797],
    [-83.1121, 34.9794],
    [-83.1160, 34.9759],
    [-83.1221, 34.9643],
    [-83.1164, 34.9590],
    [-83.1167, 34.9513],
    [-83.1268, 34.9487],
    [-83.1169, 34.9427],
    [-83.1181, 34.9360],
    [-83.1281, 34.9381],
    [-83.1299, 34.9324],
    [-83.1433, 34.9248],
    [-83.1577, 34.9235],
    [-83.1607, 34.9151],
    [-83.1708, 34.9142],
    [-83.1809, 34.9047],
    [-83.1949, 34.8987],
    [-83.1968, 34.8907],
    [-83.2031, 34.8939],
    [-83.2056, 34.8801],
    [-83.2133, 34.8872],
    [-83.2183, 34.8817],
    [-83.2292, 34.8799],
    [-83.2403, 34.8788],
    [-83.2347, 34.8707],
    [-83.2433, 34.8660],
    [-83.2463, 34.8600],
    [-83.2526, 34.8535],
    [-83.2505, 34.8445],
    [-83.2608, 34.8455],
    [-83.2688, 34.8445],
    [-83.2682, 34.8214],
    [-83.2832, 34.8213],
    [-83.2911, 34.8225],
    [-83.2946, 34.8136],
    [-83.2990, 34.8176],
    [-83.3067, 34.8148],
    [-83.2998, 34.8079],
    [-83.3138, 34.7999],
    [-83.3238, 34.7896],
    [-83.3208, 34.7584],
    [-83.3335, 34.7453],
    [-83.3529, 34.7294],
    [-83.3525, 34.7160],
    [-83.3498, 34.7083],
    [-83.3466, 34.7042],
    [-83.3539, 34.6992],
    [-83.3401, 34.6915],
    [-83.3384, 34.6869],
    [-83.3371, 34.6801],
    [-83.3215, 34.6775],
    [-83.3164, 34.6693],
    [-83.3046, 34.6696],
    [-83.2929, 34.6542],
    [-83.2799, 34.6469],
    [-83.2553, 34.6377],
    [-83.2423, 34.6258],
    [-83.2405, 34.6222],
    [-83.2415, 34.6163],
    [-83.2271, 34.6107],
    [-83.1998, 34.6084],
    [-83.1927, 34.6033],
    [-83.1794, 34.6080],
    [-83.1633, 34.6051],
    [-83.1602, 34.5992],
    [-83.1699, 34.5995],
    [-83.1703, 34.5924],
    [-83.1554, 34.5891],
    [-83.1552, 34.5863],
    [-83.1592, 34.5802],
    [-83.1542, 34.5780],
    [-83.1399, 34.5680],
    [-83.1334, 34.5595],
    [-83.1229, 34.5601],
    [-83.1219, 34.5523],
    [-83.1057, 34.5412],
    [-83.1022, 34.5322],
    [-83.0926, 34.5329],
    [-83.0794, 34.5261],
    [-83.0869, 34.5178],
    [-83.0798, 34.5145],
    [-83.0740, 34.5055],
    [-83.0578, 34.5037],
    [-83.0535, 34.4973],
    [-83.0510, 34.4935],
    [-83.0347, 34.4835],
    [-83.0286, 34.4838],
    [-82.9951, 34.4725],
    [-82.9922, 34.4792],
    [-82.9749, 34.4793],
    [-82.9632, 34.4844],
    [-82.9482, 34.4805],
    [-82.9409, 34.4861],
    [-82.9207, 34.4823],
    [-82.8926, 34.4812],
    [-82.8808, 34.4709],
    [-82.8718, 34.4612],
    [-82.8588, 34.4552],
    [-82.8558, 34.4440],
    [-82.8514, 34.4268],
    [-82.8478, 34.4206],
    [-82.8466, 34.4101],
    [-82.8413, 34.3973],
    [-82.8366, 34.3827],
    [-82.8350, 34.3664],
    [-82.8333, 34.3640],
    [-82.8099, 34.3500],
    [-82.7941, 34.3398],
    [-82.7912, 34.3249],
    [-82.7818, 34.3029],
    [-82.7709, 34.2854],
    [-82.7620, 34.2815],
    [-82.7467, 34.2664],
    [-82.7453, 34.2553],
    [-82.7450, 34.2449],
    [-82.7435, 34.2273],
    [-82.7405, 34.2184],
    [-82.7419, 34.2101],
    [-82.7324, 34.1806],
    [-82.7254, 34.1698],
    [-82.7175, 34.1505],
    [-82.6998, 34.1393],
    [-82.6904, 34.1383],
    [-82.6752, 34.1298],
    [-82.6619, 34.1078],
    [-82.6586, 34.1031],
    [-82.6482, 34.0986],
    [-82.6410, 34.0909],
    [-82.6402, 34.0876],
    [-82.6442, 34.0800],
    [-82.6457, 34.0760],
    [-82.6360, 34.0649],
    [-82.6270, 34.0635],
    [-82.6210, 34.0544],
    [-82.6097, 34.0399],
    [-82.5946, 34.0287],
    [-82.5957, 34.0161],
    [-82.5892, 34.0001],
    [-82.5777, 33.9937],
    [-82.5754, 33.9909],
    [-82.5800, 33.9870],
    [-82.5796, 33.9798],
    [-82.5699, 33.9707],
    [-82.5657, 33.9587],
    [-82.5568, 33.9454],
    [-82.5398, 33.9416],
    [-82.5245, 33.9434],
    [-82.5036, 33.9260],
    [-82.4801, 33.9019],
    [-82.4592, 33.8862],
    [-82.4405, 33.8751],
    [-82.4292, 33.8658],
    [-82.4143, 33.8653],
    [-82.4005, 33.8633],
    [-82.3850, 33.8544],
    [-82.3718, 33.8438],
    [-82.3563, 33.8380],
    [-82.3378, 33.8272],
    [-82.3147, 33.8115],
    [-82.3029, 33.8029],
    [-82.2989, 33.7958],
    [-82.2983, 33.7835],
    [-82.2898, 33.7820],
    [-82.2782, 33.7726],
    [-82.2677, 33.7677],
    [-82.2644, 33.7635],
    [-82.2580, 33.7604],
    [-82.2462, 33.7463],
    [-82.2391, 33.7309],
    [-82.2346, 33.7002],
    [-82.2186, 33.6863],
    [-82.2108, 33.6706],
    [-82.1998, 33.6618],
    [-82.2012, 33.6469],
    [-82.1799, 33.6159],
    [-82.1619, 33.6106],
    [-82.1534, 33.6063],
    [-82.1451, 33.5957],
    [-82.1335, 33.5905],
    [-82.1232, 33.5927],
    [-82.1153, 33.5965],
    [-82.0988, 33.5864],
    [-82.0875, 33.5806],
    [-82.0690, 33.5754],
    [-82.0549, 33.5654],
    [-82.0463, 33.5638],
    [-82.0349, 33.5492],
    [-82.0234, 33.5407],
    [-82.0120, 33.5319],
    [-82.0100, 33.5304],
    [-82.0043, 33.5219],
    [-81.9953, 33.5100],
    [-81.9906, 33.4981],
    [-81.9859, 33.4865],
    [-81.9736, 33.4827],
    [-81.9554, 33.4756],
    [-81.9464, 33.4717],
    [-81.9294, 33.4658],
    [-81.9248, 33.4599],
    [-81.9135, 33.4396],
    [-81.9162, 33.4331],
    [-81.9308, 33.4290],
    [-81.9211, 33.4174],
    [-81.9131, 33.4080],
    [-81.9374, 33.4075],
    [-81.9355, 33.3979],
    [-81.9257, 33.3711],
    [-81.9396, 33.3725],
    [-81.9464, 33.3704],
    [-81.9348, 33.3560],
    [-81.9398, 33.3477],
    [-81.9327, 33.3435],
    [-81.9156, 33.3437],
    [-81.9088, 33.3473],
    [-81.9105, 33.3423],
    [-81.9176, 33.3356],
    [-81.9133, 33.3295],
    [-81.9102, 33.3248],
    [-81.9109, 33.3193],
    [-81.9064, 33.3242],
    [-81.9036, 33.3348],
    [-81.8988, 33.3321],
    [-81.8993, 33.3254],
    [-81.8910, 33.3225],
    [-81.8927, 33.3167],
    [-81.8852, 33.3174],
    [-81.8841, 33.3104],
    [-81.8784, 33.3032],
    [-81.8665, 33.3137],
    [-81.8640, 33.3078],
    [-81.8591, 33.3060],
    [-81.8473, 33.3068],
    [-81.8496, 33.2980],
    [-81.8615, 33.2979],
    [-81.8518, 33.2835],
    [-81.8446, 33.2835],
    [-81.8404, 33.2737],
    [-81.8356, 33.2751],
    [-81.8317, 33.2733],
    [-81.8350, 33.2635],
    [-81.8279, 33.2637],
    [-81.8350, 33.2593],
    [-81.8425, 33.2666],
    [-81.8482, 33.2617],
    [-81.8396, 33.2552],
    [-81.8530, 33.2498],
    [-81.8465, 33.2417],
    [-81.8316, 33.2333],
    [-81.8117, 33.2238],
    [-81.8079, 33.2137],
    [-81.7902, 33.2084],
    [-81.7775, 33.2113],
    [-81.7801, 33.2211],
    [-81.7689, 33.2174],
    [-81.7616, 33.2017],
    [-81.7569, 33.1978],
    [-81.7662, 33.1874],
    [-81.7650, 33.1784],
    [-81.7735, 33.1805],
    [-81.7631, 33.1594],
    [-81.7243, 33.1295],
    [-81.7046, 33.1165],
    [-81.6969, 33.1166],
    [-81.6464, 33.0946],
    [-81.6322, 33.0940],
    [-81.6143, 33.0947],
    [-81.6095, 33.0899],
    [-81.6101, 33.0829],
    [-81.6068, 33.0817],
    [-81.6002, 33.0840],
    [-81.5994, 33.0769],
    [-81.5992, 33.0718],
    [-81.5907, 33.0712],
    [-81.5810, 33.0627],
    [-81.5689, 33.0535],
    [-81.5633, 33.0556],
    [-81.5613, 33.0556],
    [-81.5589, 33.0529],
    [-81.5650, 33.0497],
    [-81.5531, 33.0432],
    [-81.5438, 33.0486],
    [-81.5388, 33.0392],
    [-81.5291, 33.0408],
    [-81.5285, 33.0356],
    [-81.5132, 33.0285],
    [-81.5117, 33.0245],
    [-81.5191, 33.0232],
    [-81.5137, 33.0206],
    [-81.5082, 33.0175],
    [-81.5107, 33.0103],
    [-81.5067, 33.0151],
    [-81.5020, 33.0151],
    [-81.4923, 33.0093],
    [-81.4961, 33.0055],
    [-81.5002, 33.0035],
    [-81.4957, 32.9995],
    [-81.4912, 32.9977],
    [-81.4934, 32.9924],
    [-81.4964, 32.9896],
    [-81.4943, 32.9863],
    [-81.4955, 32.9835],
    [-81.4947, 32.9790],
    [-81.5014, 32.9629],
    [-81.5078, 32.9689],
    [-81.5113, 32.9667],
    [-81.5100, 32.9573],
    [-81.5040, 32.9481],
    [-81.5027, 32.9387],
    [-81.4951, 32.9316],
    [-81.4873, 32.9179],
    [-81.4800, 32.9134],
    [-81.4794, 32.9023],
    [-81.4755, 32.8967],
    [-81.4690, 32.9011],
    [-81.4647, 32.8960],
    [-81.4771, 32.8875],
    [-81.4704, 32.8763],
    [-81.4634, 32.8794],
    [-81.4529, 32.8730],
    [-81.4530, 32.8596],
    [-81.4555, 32.8470],
    [-81.4483, 32.8496],
    [-81.4427, 32.8501],
    [-81.4357, 32.8427],
    [-81.4216, 32.8352],
    [-81.4237, 32.8283],
    [-81.4295, 32.8271],
    [-81.4220, 32.8215],
    [-81.4269, 32.8197],
    [-81.4271, 32.8169],
    [-81.4186, 32.8187],
    [-81.4198, 32.8137],
    [-81.4263, 32.8099],
    [-81.4222, 32.8031],
    [-81.4269, 32.8022],
    [-81.4252, 32.7942],
    [-81.4197, 32.7932],
    [-81.4251, 32.7862],
    [-81.4300, 32.7852],
    [-81.4216, 32.7786],
    [-81.4163, 32.7755],
    [-81.4226, 32.7730],
    [-81.4315, 32.7715],
    [-81.4291, 32.7679],
    [-81.4180, 32.7670],
    [-81.4152, 32.7616],
    [-81.4130, 32.7548],
    [-81.4197, 32.7492],
    [-81.4053, 32.7488],
    [-81.4057, 32.7425],
    [-81.4117, 32.7392],
    [-81.4135, 32.7364],
    [-81.4147, 32.7321],
    [-81.4187, 32.7318],
    [-81.4168, 32.7288],
    [-81.4146, 32.7243],
    [-81.4098, 32.7225],
    [-81.4188, 32.7219],
    [-81.4193, 32.7184],
    [-81.4151, 32.7137],
    [-81.4200, 32.7124],
    [-81.4248, 32.7005],
    [-81.4134, 32.6947],
    [-81.4111, 32.6936],
    [-81.4095, 32.6956],
    [-81.4012, 32.6799],
    [-81.4005, 32.6641],
    [-81.4003, 32.6585],
    [-81.4065, 32.6625],
    [-81.4072, 32.6605],
    [-81.3938, 32.6535],
    [-81.4036, 32.6434],
    [-81.4126, 32.6415],
    [-81.4027, 32.6370],
    [-81.4093, 32.6311],
    [-81.4134, 32.6374],
    [-81.4184, 32.6347],
    [-81.4119, 32.6184],
    [-81.3939, 32.6023],
    [-81.3810, 32.5897],
    [-81.3732, 32.5921],
    [-81.3690, 32.5900],
    [-81.3684, 32.5842],
    [-81.3636, 32.5818],
    [-81.3670, 32.5771],
    [-81.3595, 32.5822],
    [-81.3583, 32.5745],
    [-81.3206, 32.5595],
    [-81.2980, 32.5630],
    [-81.2959, 32.5585],
    [-81.2967, 32.5534],
    [-81.2914, 32.5559],
    [-81.2934, 32.5613],
    [-81.2896, 32.5617],
    [-81.2899, 32.5524],
    [-81.2847, 32.5529],
    [-81.2833, 32.5568],
    [-81.2792, 32.5546],
    [-81.2810, 32.5497],
    [-81.2762, 32.5458],
    [-81.2748, 32.5411],
    [-81.2794, 32.5378],
    [-81.2750, 32.5343],
    [-81.2684, 32.5285],
    [-81.2529, 32.5183],
    [-81.2450, 32.5183],
    [-81.2340, 32.5138],
    [-81.2384, 32.5102],
    [-81.2336, 32.4985],
    [-81.2000, 32.4680],
    [-81.1892, 32.4656],
    [-81.1873, 32.4629],
    [-81.1946, 32.4578],
    [-81.1928, 32.4534],
    [-81.1975, 32.4548],
    [-81.2003, 32.4502],
    [-81.2066, 32.4475],
    [-81.2005, 32.4458],
    [-81.2026, 32.4398],
    [-81.2084, 32.4360],
    [-81.1949, 32.4115],
    [-81.1772, 32.3917],
    [-81.1803, 32.3796],
    [-81.1687, 32.3675],
    [-81.1709, 32.3627],
    [-81.1608, 32.3541],
    [-81.1550, 32.3501],
    [-81.1551, 32.3445],
    [-81.1605, 32.3417],
    [-81.1533, 32.3413],
    [-81.1452, 32.3453],
    [-81.1440, 32.3511],
    [-81.1409, 32.3494],
    [-81.1286, 32.3370],
    [-81.1376, 32.3282],
    [-81.1318, 32.3264],
    [-81.1298, 32.3133],
    [-81.1315, 32.3073],
    [-81.1239, 32.3087],
    [-81.1227, 32.2973],
    [-81.1196, 32.2877],
    [-81.1214, 32.2845],
    [-81.1264, 32.2807],
    [-81.1232, 32.2765],
    [-81.1273, 32.2759],
    [-81.1318, 32.2719],
    [-81.1357, 32.2722],
    [-81.1421, 32.2706],
    [-81.1369, 32.2661],
    [-81.1426, 32.2639],
    [-81.1467, 32.2616],
    [-81.1457, 32.2574],
    [-81.1473, 32.2534],
    [-81.1529, 32.2478],
    [-81.1560, 32.2415],
    [-81.1455, 32.2319],
    [-81.1448, 32.2260],
    [-81.1500, 32.2211],
    [-81.1367, 32.2163],
    [-81.1283, 32.2086],
    [-81.1198, 32.1956],
    [-81.1154, 32.1932],
    [-81.1204, 32.1908],
    [-81.1198, 32.1812],
    [-81.1146, 32.1769],
    [-81.1138, 32.1713],
    [-81.1245, 32.1721],
    [-81.1296, 32.1658],
    [-81.1231, 32.1629],
    [-81.1200, 32.1533],
    [-81.1122, 32.1508],
    [-81.1173, 32.1462],
    [-81.1199, 32.1340],
    [-81.1161, 32.1287],
    [-81.1172, 32.1176],
    [-81.1005, 32.1112],
    [-81.0909, 32.1070],
    [-81.0835, 32.1008],
    [-81.0502, 32.0853],
    [-81.0327, 32.0855],
    [-81.0160, 32.0974],
    [-81.0023, 32.1000],
    [-80.9917, 32.0912],
    [-80.9788, 32.0773],
    [-80.9432, 32.0578],
    [-80.9228, 32.0392],
    [-80.8930, 32.0349],
    [-80.8814, 32.0280],
    [-80.8767, 32.0177],
    [-80.8591, 32.0237],
    [-80.8519, 32.0301],
    [-80.8397, 32.0115],
    [-80.8445, 31.9954],
    [-80.8529, 31.9859],
    [-80.8628, 31.9693],
    [-80.9214, 31.9387],
    [-80.9303, 31.9567],
    [-80.9427, 31.9637],
    [-80.9485, 31.9572],
    [-80.9843, 31.9401],
    [-80.9757, 31.9236],
    [-80.9414, 31.9130],
    [-80.9714, 31.8779],
    [-81.0067, 31.8616],
    [-81.0314, 31.8729],
    [-81.0653, 31.8771],
    [-81.0591, 31.8501],
    [-81.0758, 31.8290],
    [-81.0523, 31.8190],
    [-81.0398, 31.8230],
    [-81.0359, 31.8104],
    [-81.0792, 31.7627],
    [-81.1306, 31.7227],
    [-81.1607, 31.7281],
    [-81.1984, 31.7261],
    [-81.1863, 31.7015],
    [-81.1519, 31.6984],
    [-81.1311, 31.6958],
    [-81.1345, 31.6620],
    [-81.1335, 31.6233],
    [-81.1719, 31.5590],
    [-81.1861, 31.5680],
    [-81.2032, 31.5697],
    [-81.2542, 31.5559],
    [-81.2626, 31.5379],
    [-81.2588, 31.5291],
    [-81.2345, 31.5300],
    [-81.2135, 31.5282],
    [-81.1859, 31.5296],
    [-81.1846, 31.5105],
    [-81.2469, 31.4228],
    [-81.2686, 31.3830],
    [-81.2943, 31.3686],
    [-81.2829, 31.3265],
    [-81.2829, 31.2906],
    [-81.2696, 31.2587],
    [-81.2891, 31.2255],
    [-81.3031, 31.2169],
    [-81.3311, 31.1970],
    [-81.3646, 31.1499],
    [-81.3670, 31.1470],
    [-81.3780, 31.1393],
    [-81.3990, 31.1341],
    [-81.4023, 31.1305],
    [-81.4037, 31.1071],
    [-81.4151, 31.0267],
    [-81.4325, 31.0130],
    [-81.4432, 31.0167],
    [-81.4592, 31.0057],
    [-81.4906, 30.9850],
    [-81.4870, 30.9696],
    [-81.4668, 30.9709],
    [-81.4474, 30.9567],
    [-81.4201, 30.9741],
    [-81.4034, 30.9579],
    [-81.4286, 30.8363],
    [-81.4469, 30.8104],
    [-81.4611, 30.7537],
    [-81.4441, 30.7097],
    [-81.4645, 30.7110],
    [-81.4758, 30.7148],
    [-81.4895, 30.7261],
    [-81.5214, 30.7225],
    [-81.5334, 30.7234],
    [-81.5340, 30.7147],
    [-81.5384, 30.7087],
    [-81.5461, 30.7170],
    [-81.5526, 30.7170],
    [-81.5635, 30.7134],
    [-81.5684, 30.7190],
    [-81.5737, 30.7223],
    [-81.5893, 30.7228],
    [-81.5961, 30.7246],
    [-81.6043, 30.7289],
    [-81.6076, 30.7164],
    [-81.6151, 30.7227],
    [-81.6211, 30.7288],
    [-81.6283, 30.7354],
    [-81.6333, 30.7296],
    [-81.6419, 30.7289],
    [-81.6504, 30.7297],
    [-81.6517, 30.7402],
    [-81.6546, 30.7437],
    [-81.6627, 30.7430],
    [-81.6633, 30.7544],
    [-81.6833, 30.7476],
    [-81.6691, 30.7450],
    [-81.6728, 30.7389],
    [-81.6910, 30.7428],
    [-81.6948, 30.7484],
    [-81.7271, 30.7469],
    [-81.7326, 30.7535],
    [-81.7406, 30.7580],
    [-81.7411, 30.7639],
    [-81.7477, 30.7669],
    [-81.7583, 30.7707],
    [-81.7633, 30.7758],
    [-81.7713, 30.7725],
    [-81.7716, 30.7641],
    [-81.7826, 30.7661],
    [-81.7884, 30.7794],
    [-81.7960, 30.7845],
    [-81.8067, 30.7897],
    [-81.8394, 30.7872],
    [-81.8418, 30.7914],
    [-81.8686, 30.7928],
    [-81.8815, 30.8008],
    [-81.8910, 30.8225],
    [-81.8962, 30.8257],
    [-81.9073, 30.8256],
    [-81.9041, 30.8204],
    [-81.9109, 30.8159],
    [-81.9346, 30.8236],
    [-81.9498, 30.8275],
    [-81.9622, 30.8180],
    [-81.9620, 30.8004],
    [-81.9689, 30.7908],
    [-81.9789, 30.7765],
    [-81.9813, 30.7768],
    [-81.9950, 30.7861],
    [-82.0167, 30.7917],
    [-82.0238, 30.7867],
    [-82.0116, 30.7631],
    [-82.0284, 30.7510],
    [-82.0390, 30.7493],
    [-82.0412, 30.7342],
    [-82.0392, 30.7232],
    [-82.0418, 30.6924],
    [-82.0470, 30.6659],
    [-82.0495, 30.6555],
    [-82.0396, 30.6433],
    [-82.0376, 30.6333],
    [-82.0265, 30.6133],
    [-82.0204, 30.6039],
    [-82.0121, 30.5938],
    [-82.0132, 30.5501],
    [-82.0189, 30.5238],
    [-82.0158, 30.5182],
    [-82.0182, 30.4921],
    [-82.0178, 30.4751],
    [-82.0282, 30.4474],
    [-82.0372, 30.4345],
    [-82.0400, 30.4143],
    [-82.0420, 30.4033],
    [-82.0368, 30.3779],
    [-82.0500, 30.3624],
    [-82.0685, 30.3592],
    [-82.1001, 30.3643],
    [-82.1025, 30.3678],
    [-82.1433, 30.3634],
    [-82.1652, 30.3580],
    [-82.1720, 30.3604],
    [-82.1846, 30.3772],
    [-82.1929, 30.3788],
    [-82.2042, 30.4013],
    [-82.2065, 30.4371],
    [-82.2060, 30.4555],
    [-82.2046, 30.4689],
    [-82.2064, 30.4919],
    [-82.2250, 30.5078],
    [-82.2303, 30.5175],
    [-82.2361, 30.5312],
    [-82.2344, 30.5490],
    [-82.2283, 30.5626],
    [-82.2144, 30.5670],
    [-82.2498, 30.5709],
    [-82.3748, 30.5790],
    [-82.4598, 30.5843],
    [-82.5451, 30.5894],
    [-82.5692, 30.5910],
    [-82.6895, 30.5977],
    [-82.8773, 30.6090],
    [-83.0557, 30.6192],
    [-83.1214, 30.6230],
    [-83.1562, 30.6255],
    [-83.1724, 30.6263],
    [-83.2659, 30.6319],
    [-83.3095, 30.6344],
    [-83.3409, 30.6363],
    [-83.3795, 30.6387],
    [-83.4296, 30.6415],
    [-83.4489, 30.6424],
    [-83.6117, 30.6513],
    [-83.6741, 30.6547],
    [-83.8088, 30.6618],
    [-83.8552, 30.6644],
    [-83.8803, 30.6658],
    [-84.0191, 30.6727],
    [-84.0418, 30.6739],
    [-84.0727, 30.6754],
    [-84.1077, 30.6768],
    [-84.2499, 30.6841],
    [-84.2826, 30.6853],
    [-84.3807, 30.6900],
    [-84.4744, 30.6928],
    [-84.5394, 30.6968],
    [-84.6064, 30.6999],
    [-84.6448, 30.7020],
    [-84.7252, 30.7056],
    [-84.8635, 30.7115],
    [-84.8754, 30.7275],
    [-84.8875, 30.7418],
    [-84.9002, 30.7519],
    [-84.9111, 30.7512],
    [-84.9150, 30.7612],
    [-84.9180, 30.7721],
    [-84.9267, 30.7902],
    [-84.9290, 30.7973],
    [-84.9309, 30.8105],
    [-84.9356, 30.8246],
    [-84.9320, 30.8375],
    [-84.9283, 30.8443],
    [-84.9332, 30.8515],
    [-84.9346, 30.8606],
    [-84.9357, 30.8675],
    [-84.9378, 30.8752],
    [-84.9354, 30.8825],
    [-84.9400, 30.8867],
    [-84.9496, 30.8974],
    [-84.9667, 30.9173],
    [-84.9752, 30.9308],
    [-84.9836, 30.9370],
    [-84.9796, 30.9547],
    [-84.9825, 30.9656],
    [-84.9976, 30.9712],
    [-85.0040, 30.9735],
    [-85.0059, 30.9774],
    [-85.0025, 30.9869],
    [-85.0025, 31.0007],
    [-84.9994, 31.0138],
    [-85.0051, 31.0247],
    [-85.0088, 31.0456],
    [-85.0181, 31.0593],
    [-85.0283, 31.0769],
    [-85.0328, 31.1006],
    [-85.0405, 31.1116],
    [-85.0529, 31.1195],
    [-85.0611, 31.1342],
    [-85.0702, 31.1487],
    [-85.0778, 31.1579],
    [-85.0921, 31.1603],
    [-85.0984, 31.1778],
    [-85.1044, 31.1856],
    [-85.1077, 31.1899],
    [-85.1056, 31.2046],
    [-85.0987, 31.2195],
    [-85.1008, 31.2348],
    [-85.1062, 31.2481],
    [-85.1124, 31.2596],
    [-85.1119, 31.2725],
    [-85.1146, 31.2773],
    [-85.0998, 31.2840],
    [-85.0898, 31.2950],
    [-85.0874, 31.3112],
    [-85.0842, 31.3283],
    [-85.0878, 31.3380],
    [-85.0859, 31.3502],
    [-85.0910, 31.3544],
    [-85.0925, 31.3629],
    [-85.0869, 31.3745],
    [-85.0786, 31.3964],
    [-85.0800, 31.4105],
    [-85.0758, 31.4215],
    [-85.0727, 31.4283],
    [-85.0659, 31.4306],
    [-85.0667, 31.4473],
    [-85.0657, 31.4841],
    [-85.0530, 31.5065],
    [-85.0456, 31.5168],
    [-85.0446, 31.5209],
    [-85.0472, 31.5287],
    [-85.0413, 31.5410],
    [-85.0457, 31.5487],
    [-85.0529, 31.5629],
    [-85.0553, 31.5771],
    [-85.0583, 31.5866],
    [-85.0561, 31.6043],
    [-85.0573, 31.6067],
    [-85.0604, 31.6113],
    [-85.0575, 31.6176],
    [-85.0595, 31.6217],
    [-85.0738, 31.6296],
    [-85.0845, 31.6390],
    [-85.0852, 31.6441],
    [-85.0803, 31.6508],
    [-85.0799, 31.6553],
    [-85.0878, 31.6579],
    [-85.1126, 31.6852],
    [-85.1255, 31.6950],
    [-85.1265, 31.7168],
    [-85.1191, 31.7310],
    [-85.1266, 31.7525],
    [-85.1256, 31.7645],
    [-85.1307, 31.7723],
    [-85.1419, 31.7820],
    [-85.1329, 31.7924],
    [-85.1328, 31.8004],
    [-85.1313, 31.8176],
    [-85.1343, 31.8246],
    [-85.1359, 31.8305],
    [-85.1413, 31.8411],
    [-85.1380, 31.8513],
    [-85.1401, 31.8588],
    [-85.1337, 31.8701],
    [-85.1284, 31.8776],
    [-85.1298, 31.8833],
    [-85.1343, 31.8914],
    [-85.1329, 31.8931],
    [-85.1140, 31.8934],
    [-85.1116, 31.9013],
    [-85.1127, 31.9099],
    [-85.1024, 31.9174],
    [-85.0995, 31.9253],
    [-85.0864, 31.9360],
    [-85.0789, 31.9415],
    [-85.0867, 31.9592],
    [-85.0739, 31.9642],
    [-85.0659, 31.9712],
    [-85.0699, 31.9784],
    [-85.0681, 31.9919],
    [-85.0634, 32.0041],
    [-85.0548, 32.0174],
    [-85.0493, 32.0227],
    [-85.0544, 32.0267],
    [-85.0565, 32.0318],
    [-85.0548, 32.0388],
    [-85.0588, 32.0467],
    [-85.0568, 32.0598],
    [-85.0541, 32.0702],
    [-85.0532, 32.0806],
    [-85.0455, 32.0869],
    [-85.0538, 32.1077],
    [-85.0615, 32.1297],
    [-85.0587, 32.1360],
    [-85.0340, 32.1563],
    [-85.0146, 32.1769],
    [-85.0085, 32.1819],
    [-84.9668, 32.1940],
    [-84.9622, 32.2001],
    [-84.9694, 32.2045],
    [-84.9771, 32.2058],
    [-84.9787, 32.2126],
    [-84.9614, 32.2181],
    [-84.9495, 32.2185],
    [-84.9282, 32.2199],
    [-84.9235, 32.2298],
    [-84.9206, 32.2340],
    [-84.9139, 32.2451],
    [-84.9230, 32.2445],
    [-84.9230, 32.2508],
    [-84.9072, 32.2490],
    [-84.9015, 32.2574],
    [-84.8892, 32.2592],
    [-84.8918, 32.2634],
    [-84.9111, 32.2769],
    [-84.9387, 32.3007],
    [-85.0019, 32.3220],
    [-85.0046, 32.3452],
    [-84.9835, 32.3632],
    [-84.9863, 32.3697],
    [-84.9773, 32.3738],
    [-84.9738, 32.3799],
    [-84.9886, 32.3841],
    [-84.9834, 32.3918],
    [-84.9718, 32.3906],
    [-84.9739, 32.3952],
    [-84.9803, 32.4073],
    [-84.9634, 32.4225],
    [-84.9630, 32.4242],
    [-84.9838, 32.4456],
    [-84.9952, 32.4531],
    [-84.9980, 32.4619],
    [-84.9967, 32.4726],
    [-84.9948, 32.4860],
    [-84.9983, 32.4941],
    [-84.9998, 32.5043],
    [-85.0008, 32.5102],
    [-85.0029, 32.5170],
    [-85.0138, 32.5261],
    [-85.0163, 32.5312],
    [-85.0225, 32.5429],
    [-85.0350, 32.5521],
    [-85.0569, 32.5712],
    [-85.0764, 32.5947],
    [-85.0808, 32.6102],
    [-85.0854, 32.6185],
    [-85.0893, 32.6250],
    [-85.0849, 32.6303],
    [-85.0836, 32.6360],
    [-85.0966, 32.6347],
    [-85.1053, 32.6448],
    [-85.0897, 32.6556],
    [-85.1040, 32.6796],
    [-85.1153, 32.6873],
    [-85.1193, 32.7077],
    [-85.1215, 32.7204],
    [-85.1173, 32.7266],
    [-85.1133, 32.7358],
    [-85.1241, 32.7417],
    [-85.1348, 32.7468],
    [-85.1426, 32.7607],
    [-85.1344, 32.7706],
    [-85.1236, 32.7757],
    [-85.1347, 32.7839],
    [-85.1406, 32.7897],
    [-85.1506, 32.7935],
    [-85.1621, 32.8042],
    [-85.1679, 32.8117],
    [-85.1647, 32.8202],
    [-85.1655, 32.8334],
    [-85.1574, 32.8394],
    [-85.1535, 32.8428],
    [-85.1543, 32.8475],
    [-85.1598, 32.8549],
    [-85.1643, 32.8562],
    [-85.1701, 32.8525],
    [-85.1784, 32.8547],
    [-85.1844, 32.8613],
    [-85.1849, 32.8634],
    [-85.1847, 32.8695],
    [-85.1850, 32.8720],
    [-85.1871, 32.8817],
    [-85.1908, 32.9000],
    [-85.2041, 32.9667],
    [-85.2233, 33.0626],
    [-85.2284, 33.0884],
    [-85.2521, 33.2109],
    [-85.2814, 33.3631],
    [-85.2975, 33.4469],
    [-85.3140, 33.5298],
    [-85.3150, 33.5359],
    [-85.3226, 33.5742],
    [-85.3553, 33.7392],
    [-85.3605, 33.7680],
    [-85.3764, 33.8507],
    [-85.3865, 33.9017],
    [-85.3988, 33.9641],
    [-85.4067, 34.0023],
    [-85.4279, 34.1126],
    [-85.4447, 34.1999],
    [-85.4554, 34.2529],
    [-85.4621, 34.2864],
    [-85.4704, 34.3282],
    [-85.5023, 34.4740],
    [-85.5084, 34.5012],
    [-85.5139, 34.5252],
    [-85.5273, 34.5887],
    [-85.5413, 34.6567],
    [-85.5521, 34.7065],
    [-85.5581, 34.7344],
    [-85.5759, 34.8237],
    [-85.5952, 34.9243],
    [-85.5994, 34.9518],
    [-85.6052, 34.9847]
    ]
  },
  "Pennsylvania": {
    coordinates: [
      [-80.5199, 40.9067],
    [-80.5190, 40.9534],
    [-80.5190, 40.9941],
    [-80.5189, 41.0240],
    [-80.5190, 41.0520],
    [-80.5190, 41.0719],
    [-80.5191, 41.0829],
    [-80.5191, 41.0994],
    [-80.5190, 41.1160],
    [-80.5190, 41.1251],
    [-80.5192, 41.1334],
    [-80.5191, 41.1712],
    [-80.5189, 41.2030],
    [-80.5188, 41.2099],
    [-80.5189, 41.2279],
    [-80.5189, 41.2328],
    [-80.5187, 41.2489],
    [-80.5190, 41.2682],
    [-80.5188, 41.3055],
    [-80.5191, 41.3124],
    [-80.5193, 41.3360],
    [-80.5193, 41.3391],
    [-80.5193, 41.3401],
    [-80.5192, 41.3610],
    [-80.5192, 41.3789],
    [-80.5190, 41.4164],
    [-80.5190, 41.4355],
    [-80.5192, 41.4890],
    [-80.5192, 41.5321],
    [-80.5193, 41.5710],
    [-80.5193, 41.6070],
    [-80.5194, 41.6610],
    [-80.5194, 41.6718],
    [-80.5194, 41.7147],
    [-80.5193, 41.7577],
    [-80.5193, 41.8496],
    [-80.5193, 41.8921],
    [-80.5193, 41.9372],
    [-80.5194, 41.9762],
    [-80.4988, 41.9859],
    [-80.4892, 41.9879],
    [-80.4649, 41.9954],
    [-80.4372, 42.0058],
    [-80.4200, 42.0099],
    [-80.4015, 42.0138],
    [-80.3857, 42.0195],
    [-80.3719, 42.0240],
    [-80.3633, 42.0280],
    [-80.3528, 42.0297],
    [-80.3451, 42.0315],
    [-80.3300, 42.0362],
    [-80.2968, 42.0491],
    [-80.2676, 42.0604],
    [-80.2474, 42.0705],
    [-80.2396, 42.0766],
    [-80.2305, 42.0780],
    [-80.2210, 42.0812],
    [-80.2118, 42.0843],
    [-80.2019, 42.0894],
    [-80.1881, 42.0943],
    [-80.1659, 42.1059],
    [-80.1559, 42.1130],
    [-80.1539, 42.1151],
    [-80.1356, 42.1493],
    [-80.1287, 42.1566],
    [-80.1147, 42.1663],
    [-80.0999, 42.1719],
    [-80.0867, 42.1730],
    [-80.0733, 42.1726],
    [-80.0704, 42.1682],
    [-80.0754, 42.1663],
    [-80.0800, 42.1636],
    [-80.0721, 42.1555],
    [-80.0747, 42.1530],
    [-80.0745, 42.1500],
    [-80.0739, 42.1467],
    [-80.0690, 42.1454],
    [-80.0624, 42.1449],
    [-80.0498, 42.1499],
    [-80.0414, 42.1537],
    [-80.0211, 42.1628],
    [-79.9946, 42.1745],
    [-79.9858, 42.1788],
    [-79.9806, 42.1830],
    [-79.9613, 42.1916],
    [-79.9313, 42.2067],
    [-79.9239, 42.2075],
    [-79.9142, 42.2114],
    [-79.9070, 42.2154],
    [-79.8960, 42.2195],
    [-79.8732, 42.2320],
    [-79.8350, 42.2398],
    [-79.8190, 42.2446],
    [-79.7990, 42.2557],
    [-79.7879, 42.2609],
    [-79.7738, 42.2639],
    [-79.7620, 42.2699],
    [-79.7622, 42.2431],
    [-79.7618, 42.1836],
    [-79.7618, 42.1627],
    [-79.7619, 42.1507],
    [-79.7617, 42.1188],
    [-79.7618, 42.0190],
    [-79.7612, 41.9991],
    [-79.6309, 41.9990],
    [-79.6108, 41.9990],
    [-79.5280, 41.9985],
    [-79.4725, 41.9983],
    [-79.3817, 41.9985],
    [-79.2498, 41.9988],
    [-79.1786, 41.9995],
    [-79.0613, 41.9993],
    [-78.9831, 41.9989],
    [-78.9445, 41.9985],
    [-78.8748, 41.9976],
    [-78.7498, 41.9981],
    [-78.6180, 41.9996],
    [-78.5331, 41.9998],
    [-78.4629, 41.9997],
    [-78.3502, 41.9995],
    [-78.3228, 41.9994],
    [-78.2840, 41.9991],
    [-78.2657, 41.9990],
    [-78.1247, 42.0005],
    [-78.0744, 41.9999],
    [-78.0312, 41.9994],
    [-77.9628, 41.9987],
    [-77.8632, 41.9986],
    [-77.8320, 41.9985],
    [-77.7287, 41.9989],
    [-77.5053, 42.0001],
    [-77.4566, 42.0000],
    [-77.3300, 41.9998],
    [-77.2912, 41.9997],
    [-77.1445, 41.9994],
    [-77.1147, 41.9996],
    [-77.0529, 42.0005],
    [-76.9657, 42.0013],
    [-76.9371, 42.0017],
    [-76.9208, 42.0018],
    [-76.8306, 42.0017],
    [-76.7497, 42.0017],
    [-76.7296, 42.0015],
    [-76.7017, 42.0013],
    [-76.5577, 42.0001],
    [-76.5351, 41.9999],
    [-76.5234, 41.9997],
    [-76.4730, 41.9991],
    [-76.3815, 41.9986],
    [-76.3437, 41.9983],
    [-76.2643, 41.9986],
    [-76.1312, 41.9990],
    [-76.1058, 41.9989],
    [-75.9888, 41.9990],
    [-75.9584, 41.9990],
    [-75.7733, 41.9981],
    [-75.6556, 41.9986],
    [-75.6076, 41.9990],
    [-75.4837, 41.9992],
    [-75.4362, 41.9994],
    [-75.3535, 41.9971],
    [-75.3411, 41.9928],
    [-75.3425, 41.9743],
    [-75.3358, 41.9703],
    [-75.3224, 41.9617],
    [-75.3128, 41.9502],
    [-75.3017, 41.9484],
    [-75.3016, 41.9528],
    [-75.2967, 41.9545],
    [-75.2918, 41.9471],
    [-75.2791, 41.9389],
    [-75.2765, 41.9267],
    [-75.2697, 41.9114],
    [-75.2728, 41.8971],
    [-75.2678, 41.8860],
    [-75.2576, 41.8771],
    [-75.2638, 41.8708],
    [-75.2605, 41.8638],
    [-75.2480, 41.8633],
    [-75.2387, 41.8657],
    [-75.2257, 41.8575],
    [-75.2201, 41.8605],
    [-75.2097, 41.8693],
    [-75.1944, 41.8673],
    [-75.1889, 41.8613],
    [-75.1839, 41.8605],
    [-75.1791, 41.8699],
    [-75.1706, 41.8716],
    [-75.1681, 41.8670],
    [-75.1642, 41.8516],
    [-75.1529, 41.8486],
    [-75.1402, 41.8521],
    [-75.1188, 41.8458],
    [-75.1134, 41.8407],
    [-75.1151, 41.8273],
    [-75.1000, 41.8183],
    [-75.0858, 41.8116],
    [-75.0744, 41.8151],
    [-75.0722, 41.8083],
    [-75.0769, 41.7985],
    [-75.0883, 41.7975],
    [-75.1023, 41.7865],
    [-75.1046, 41.7742],
    [-75.1010, 41.7691],
    [-75.0795, 41.7712],
    [-75.0735, 41.7697],
    [-75.0649, 41.7667],
    [-75.0534, 41.7525],
    [-75.0540, 41.7301],
    [-75.0499, 41.7133],
    [-75.0612, 41.7129],
    [-75.0688, 41.7082],
    [-75.0598, 41.6997],
    [-75.0512, 41.6824],
    [-75.0588, 41.6744],
    [-75.0584, 41.6697],
    [-75.0499, 41.6626],
    [-75.0493, 41.6419],
    [-75.0436, 41.6236],
    [-75.0473, 41.6158],
    [-75.0538, 41.6187],
    [-75.0617, 41.6155],
    [-75.0597, 41.6108],
    [-75.0709, 41.6096],
    [-75.0746, 41.6057],
    [-75.0637, 41.5947],
    [-75.0529, 41.5878],
    [-75.0405, 41.5697],
    [-75.0292, 41.5646],
    [-75.0163, 41.5465],
    [-75.0228, 41.5415],
    [-75.0248, 41.5351],
    [-75.0166, 41.5321],
    [-75.0038, 41.5241],
    [-75.0009, 41.5176],
    [-75.0037, 41.5111],
    [-75.0015, 41.5078],
    [-74.9939, 41.5088],
    [-74.9844, 41.5066],
    [-74.9822, 41.4985],
    [-74.9855, 41.4870],
    [-74.9844, 41.4827],
    [-74.9699, 41.4774],
    [-74.9564, 41.4767],
    [-74.9418, 41.4835],
    [-74.9241, 41.4771],
    [-74.9129, 41.4757],
    [-74.9081, 41.4681],
    [-74.9042, 41.4598],
    [-74.8921, 41.4570],
    [-74.8891, 41.4512],
    [-74.8960, 41.4400],
    [-74.8767, 41.4403],
    [-74.8542, 41.4432],
    [-74.8369, 41.4316],
    [-74.8286, 41.4307],
    [-74.8196, 41.4393],
    [-74.8121, 41.4430],
    [-74.8012, 41.4381],
    [-74.7995, 41.4313],
    [-74.7904, 41.4217],
    [-74.7732, 41.4264],
    [-74.7586, 41.4233],
    [-74.7507, 41.4280],
    [-74.7385, 41.4306],
    [-74.7355, 41.4275],
    [-74.7387, 41.4135],
    [-74.7410, 41.4051],
    [-74.7336, 41.3970],
    [-74.7160, 41.3926],
    [-74.7104, 41.3821],
    [-74.7033, 41.3751],
    [-74.6950, 41.3704],
    [-74.6898, 41.3616],
    [-74.6964, 41.3573],
    [-74.7044, 41.3540],
    [-74.7304, 41.3460],
    [-74.7560, 41.3450],
    [-74.7667, 41.3286],
    [-74.7749, 41.3243],
    [-74.7906, 41.3229],
    [-74.7958, 41.3185],
    [-74.7920, 41.3116],
    [-74.8120, 41.2982],
    [-74.8301, 41.2872],
    [-74.8384, 41.2773],
    [-74.8463, 41.2631],
    [-74.8459, 41.2549],
    [-74.8547, 41.2505],
    [-74.8617, 41.2416],
    [-74.8674, 41.2278],
    [-74.8593, 41.2205],
    [-74.8604, 41.2175],
    [-74.8740, 41.1985],
    [-74.8821, 41.1808],
    [-74.8997, 41.1662],
    [-74.9053, 41.1557],
    [-74.9451, 41.1291],
    [-74.9476, 41.1241],
    [-74.9663, 41.1137],
    [-74.9799, 41.1104],
    [-74.9918, 41.0891],
    [-74.9848, 41.0885],
    [-74.9720, 41.0956],
    [-74.9671, 41.0943],
    [-74.9710, 41.0853],
    [-74.9948, 41.0766],
    [-75.0109, 41.0677],
    [-75.0171, 41.0568],
    [-75.0261, 41.0419],
    [-75.0360, 41.0362],
    [-75.0525, 41.0272],
    [-75.0842, 41.0160],
    [-75.1007, 41.0067],
    [-75.1234, 40.9961],
    [-75.1315, 40.9892],
    [-75.1321, 40.9826],
    [-75.1355, 40.9738],
    [-75.1291, 40.9690],
    [-75.1196, 40.9664],
    [-75.1207, 40.9625],
    [-75.1178, 40.9530],
    [-75.1055, 40.9363],
    [-75.0977, 40.9267],
    [-75.0885, 40.9197],
    [-75.0770, 40.9099],
    [-75.0760, 40.8957],
    [-75.0739, 40.8922],
    [-75.0621, 40.8822],
    [-75.0515, 40.8702],
    [-75.0515, 40.8642],
    [-75.0589, 40.8604],
    [-75.0633, 40.8511],
    [-75.0708, 40.8474],
    [-75.0910, 40.8492],
    [-75.0976, 40.8430],
    [-75.0949, 40.8371],
    [-75.0841, 40.8282],
    [-75.0839, 40.8245],
    [-75.0905, 40.8159],
    [-75.1003, 40.8076],
    [-75.1003, 40.8012],
    [-75.1113, 40.7899],
    [-75.1168, 40.7893],
    [-75.1259, 40.7840],
    [-75.1333, 40.7741],
    [-75.1391, 40.7736],
    [-75.1636, 40.7784],
    [-75.1725, 40.7769],
    [-75.1750, 40.7738],
    [-75.1775, 40.7642],
    [-75.1830, 40.7593],
    [-75.1955, 40.7525],
    [-75.1963, 40.7471],
    [-75.1828, 40.7336],
    [-75.1856, 40.7264],
    [-75.1864, 40.7203],
    [-75.1944, 40.7140],
    [-75.2024, 40.6954],
    [-75.2039, 40.6915],
    [-75.2021, 40.6879],
    [-75.1906, 40.6794],
    [-75.1845, 40.6800],
    [-75.1768, 40.6757],
    [-75.1825, 40.6663],
    [-75.1909, 40.6619],
    [-75.2005, 40.6469],
    [-75.1941, 40.6400],
    [-75.1889, 40.6262],
    [-75.1907, 40.6200],
    [-75.2007, 40.6184],
    [-75.2013, 40.6146],
    [-75.1959, 40.6068],
    [-75.1901, 40.5904],
    [-75.1947, 40.5819],
    [-75.1940, 40.5763],
    [-75.1832, 40.5674],
    [-75.1669, 40.5641],
    [-75.1506, 40.5709],
    [-75.1367, 40.5757],
    [-75.1039, 40.5688],
    [-75.0872, 40.5565],
    [-75.0686, 40.5422],
    [-75.0664, 40.5365],
    [-75.0656, 40.5171],
    [-75.0633, 40.4994],
    [-75.0643, 40.4768],
    [-75.0670, 40.4653],
    [-75.0706, 40.4552],
    [-75.0615, 40.4228],
    [-75.0557, 40.4164],
    [-75.0431, 40.4116],
    [-75.0344, 40.4061],
    [-75.0067, 40.4076],
    [-74.9964, 40.4105],
    [-74.9852, 40.4058],
    [-74.9769, 40.4019],
    [-74.9640, 40.3952],
    [-74.9528, 40.3736],
    [-74.9460, 40.3559],
    [-74.9451, 40.3473],
    [-74.9423, 40.3409],
    [-74.9282, 40.3302],
    [-74.9174, 40.3224],
    [-74.9014, 40.3155],
    [-74.8871, 40.3103],
    [-74.8683, 40.2953],
    [-74.8605, 40.2846],
    [-74.8531, 40.2697],
    [-74.8467, 40.2590],
    [-74.8423, 40.2505],
    [-74.8241, 40.2416],
    [-74.8190, 40.2383],
    [-74.7835, 40.2228],
    [-74.7784, 40.2197],
    [-74.7685, 40.2102],
    [-74.7612, 40.1991],
    [-74.7556, 40.1867],
    [-74.7517, 40.1833],
    [-74.7338, 40.1745],
    [-74.7216, 40.1538],
    [-74.7244, 40.1464],
    [-74.7416, 40.1352],
    [-74.7589, 40.1340],
    [-74.7758, 40.1250],
    [-74.7851, 40.1203],
    [-74.8006, 40.1228],
    [-74.8128, 40.1269],
    [-74.8195, 40.1276],
    [-74.8286, 40.1206],
    [-74.8331, 40.1120],
    [-74.8380, 40.1009],
    [-74.8440, 40.0978],
    [-74.8546, 40.0933],
    [-74.8582, 40.0888],
    [-74.8613, 40.0838],
    [-74.8695, 40.0815],
    [-74.8885, 40.0762],
    [-74.9032, 40.0719],
    [-74.9134, 40.0704],
    [-74.9282, 40.0701],
    [-74.9623, 40.0549],
    [-74.9774, 40.0457],
    [-74.9889, 40.0373],
    [-75.0122, 40.0207],
    [-75.0196, 40.0184],
    [-75.0342, 40.0152],
    [-75.0432, 40.0119],
    [-75.0534, 40.0046],
    [-75.0596, 39.9921],
    [-75.0654, 39.9850],
    [-75.0688, 39.9822],
    [-75.0937, 39.9744],
    [-75.1127, 39.9681],
    [-75.1239, 39.9628],
    [-75.1301, 39.9587],
    [-75.1342, 39.9529],
    [-75.1361, 39.9339],
    [-75.1350, 39.9273],
    [-75.1323, 39.9217],
    [-75.1290, 39.9075],
    [-75.1354, 39.8930],
    [-75.1415, 39.8869],
    [-75.1489, 39.8837],
    [-75.1888, 39.8808],
    [-75.1952, 39.8773],
    [-75.2041, 39.8712],
    [-75.2262, 39.8595],
    [-75.2434, 39.8546],
    [-75.2721, 39.8491],
    [-75.3165, 39.8500],
    [-75.3304, 39.8490],
    [-75.3457, 39.8442],
    [-75.3898, 39.8158],
    [-75.3985, 39.8106],
    [-75.4234, 39.8066],
    [-75.4371, 39.8131],
    [-75.4537, 39.8203],
    [-75.4599, 39.8226],
    [-75.4725, 39.8265],
    [-75.4812, 39.8291],
    [-75.4990, 39.8333],
    [-75.5393, 39.8382],
    [-75.5513, 39.8385],
    [-75.5798, 39.8385],
    [-75.5937, 39.8375],
    [-75.6173, 39.8340],
    [-75.6415, 39.8284],
    [-75.6808, 39.8133],
    [-75.7012, 39.8026],
    [-75.7193, 39.7902],
    [-75.7270, 39.7841],
    [-75.7394, 39.7729],
    [-75.7531, 39.7576],
    [-75.7601, 39.7476],
    [-75.7661, 39.7378],
    [-75.7996, 39.7219],
    [-75.8215, 39.7219],
    [-75.9370, 39.7217],
    [-75.9810, 39.7216],
    [-76.0131, 39.7219],
    [-76.0680, 39.7217],
    [-76.1543, 39.7215],
    [-76.2333, 39.7213],
    [-76.3371, 39.7213],
    [-76.3806, 39.7213],
    [-76.4045, 39.7212],
    [-76.4389, 39.7212],
    [-76.4919, 39.7213],
    [-76.5434, 39.7213],
    [-76.5694, 39.7212],
    [-76.6550, 39.7211],
    [-76.6977, 39.7211],
    [-76.7156, 39.7211],
    [-76.7871, 39.7208],
    [-76.8082, 39.7207],
    [-76.8811, 39.7204],
    [-76.9160, 39.7205],
    [-76.9748, 39.7201],
    [-77.0054, 39.7199],
    [-77.0582, 39.7202],
    [-77.1075, 39.7201],
    [-77.2168, 39.7200],
    [-77.2398, 39.7200],
    [-77.2930, 39.7200],
    [-77.3506, 39.7200],
    [-77.3695, 39.7200],
    [-77.4594, 39.7200],
    [-77.4966, 39.7201],
    [-77.5069, 39.7201],
    [-77.5348, 39.7201],
    [-77.5744, 39.7203],
    [-77.6743, 39.7208],
    [-77.7217, 39.7209],
    [-77.7260, 39.7209],
    [-77.7329, 39.7211],
    [-77.7452, 39.7212],
    [-77.7896, 39.7215],
    [-77.8476, 39.7220],
    [-77.9374, 39.7222],
    [-77.9956, 39.7223],
    [-78.0737, 39.7223],
    [-78.1486, 39.7224],
    [-78.2044, 39.7225],
    [-78.2431, 39.7225],
    [-78.2817, 39.7226],
    [-78.3395, 39.7226],
    [-78.3428, 39.7225],
    [-78.4388, 39.7225],
    [-78.5377, 39.7225],
    [-78.6103, 39.7227],
    [-78.6592, 39.7228],
    [-78.7235, 39.7230],
    [-78.7695, 39.7230],
    [-78.8084, 39.7229],
    [-78.8453, 39.7229],
    [-78.8857, 39.7228],
    [-78.9284, 39.7228],
    [-79.0455, 39.7229],
    [-79.0874, 39.7227],
    [-79.2491, 39.7220],
    [-79.3350, 39.7217],
    [-79.5246, 39.7209],
    [-79.6106, 39.7212],
    [-79.7191, 39.7209],
    [-79.8529, 39.7207],
    [-79.8574, 39.7207],
    [-79.9162, 39.7209],
    [-80.0613, 39.7213],
    [-80.0759, 39.7214],
    [-80.1852, 39.7213],
    [-80.2413, 39.7213],
    [-80.2745, 39.7213],
    [-80.3095, 39.7213],
    [-80.4524, 39.7213],
    [-80.5194, 39.7803],
    [-80.5192, 39.8371],
    [-80.5189, 39.8910],
    [-80.5192, 39.9566],
    [-80.5192, 39.9624],
    [-80.5191, 40.0164],
    [-80.5190, 40.0781],
    [-80.5190, 40.1035],
    [-80.5190, 40.1176],
    [-80.5191, 40.1728],
    [-80.5190, 40.2570],
    [-80.5190, 40.3308],
    [-80.5180, 40.3675],
    [-80.5180, 40.3989],
    [-80.5180, 40.4045],
    [-80.5177, 40.4625],
    [-80.5190, 40.4737],
    [-80.5191, 40.5179],
    [-80.5191, 40.5902],
    [-80.5191, 40.6164],
    [-80.5190, 40.6388],
    [-80.5190, 40.6541],
    [-80.5190, 40.6886],
    [-80.5190, 40.7337],
    [-80.5191, 40.7894],
    [-80.5190, 40.8012],
    [-80.5191, 40.8492],
    [-80.5190, 40.8513],
    [-80.5198, 40.9003],
    [-80.5199, 40.9067]
    ]
  },
  "Missouri": {
    coordinates: [
      [-95.7735, 40.5782],
    [-95.7464, 40.5849],
    [-95.6522, 40.5843],
    [-95.6111, 40.5835],
    [-95.5550, 40.5826],
    [-95.5267, 40.5821],
    [-95.4881, 40.5817],
    [-95.4311, 40.5812],
    [-95.3739, 40.5805],
    [-95.2590, 40.5792],
    [-95.2215, 40.5788],
    [-95.2133, 40.5787],
    [-95.2114, 40.5786],
    [-95.1640, 40.5780],
    [-95.1208, 40.5774],
    [-95.1103, 40.5772],
    [-95.0797, 40.5770],
    [-95.0307, 40.5763],
    [-94.9917, 40.5757],
    [-94.9533, 40.5756],
    [-94.8968, 40.5747],
    [-94.8200, 40.5737],
    [-94.7999, 40.5734],
    [-94.7167, 40.5722],
    [-94.6884, 40.5719],
    [-94.6320, 40.5712],
    [-94.5474, 40.5708],
    [-94.5383, 40.5708],
    [-94.5339, 40.5707],
    [-94.4706, 40.5708],
    [-94.4432, 40.5710],
    [-94.3584, 40.5714],
    [-94.3367, 40.5715],
    [-94.3107, 40.5715],
    [-94.2431, 40.5718],
    [-94.1200, 40.5727],
    [-94.0892, 40.5728],
    [-94.0721, 40.5730],
    [-94.0033, 40.5741],
    [-93.9639, 40.5748],
    [-93.9371, 40.5754],
    [-93.9357, 40.5753],
    [-93.9009, 40.5759],
    [-93.8890, 40.5761],
    [-93.8248, 40.5770],
    [-93.8014, 40.5774],
    [-93.7702, 40.5776],
    [-93.7428, 40.5775],
    [-93.7284, 40.5775],
    [-93.6903, 40.5779],
    [-93.6691, 40.5782],
    [-93.6593, 40.5783],
    [-93.6232, 40.5790],
    [-93.5658, 40.5801],
    [-93.5589, 40.5802],
    [-93.5483, 40.5804],
    [-93.5276, 40.5804],
    [-93.5233, 40.5805],
    [-93.4891, 40.5802],
    [-93.4418, 40.5799],
    [-93.3454, 40.5805],
    [-93.2889, 40.5807],
    [-93.2041, 40.5817],
    [-93.0973, 40.5840],
    [-92.9868, 40.5867],
    [-92.9577, 40.5874],
    [-92.9416, 40.5877],
    [-92.8792, 40.5883],
    [-92.8615, 40.5882],
    [-92.8351, 40.5885],
    [-92.7574, 40.5889],
    [-92.7483, 40.5891],
    [-92.6899, 40.5899],
    [-92.6379, 40.5909],
    [-92.5593, 40.5928],
    [-92.4846, 40.5949],
    [-92.4730, 40.5951],
    [-92.4278, 40.5957],
    [-92.3508, 40.5973],
    [-92.3312, 40.5978],
    [-92.2460, 40.5994],
    [-92.2176, 40.5998],
    [-92.1798, 40.6005],
    [-92.0832, 40.6022],
    [-92.0679, 40.6026],
    [-92.0532, 40.6031],
    [-91.9710, 40.6051],
    [-91.9431, 40.6058],
    [-91.8719, 40.6080],
    [-91.8325, 40.6098],
    [-91.8242, 40.6102],
    [-91.7954, 40.6111],
    [-91.7201, 40.6015],
    [-91.6964, 40.5881],
    [-91.6854, 40.5789],
    [-91.6916, 40.5622],
    [-91.6887, 40.5574],
    [-91.6543, 40.5492],
    [-91.6230, 40.5427],
    [-91.6201, 40.5408],
    [-91.6188, 40.5263],
    [-91.6214, 40.5101],
    [-91.6128, 40.5024],
    [-91.5946, 40.4950],
    [-91.5833, 40.4791],
    [-91.5804, 40.4710],
    [-91.5677, 40.4623],
    [-91.5527, 40.4588],
    [-91.5286, 40.4590],
    [-91.5239, 40.4563],
    [-91.5231, 40.4516],
    [-91.5261, 40.4466],
    [-91.5336, 40.4383],
    [-91.5250, 40.4335],
    [-91.5190, 40.4313],
    [-91.5271, 40.4167],
    [-91.5223, 40.4096],
    [-91.5091, 40.4068],
    [-91.5053, 40.4035],
    [-91.4927, 40.4029],
    [-91.4878, 40.4039],
    [-91.4908, 40.3952],
    [-91.4823, 40.3821],
    [-91.4651, 40.3853],
    [-91.4650, 40.3762],
    [-91.4484, 40.3789],
    [-91.4257, 40.3825],
    [-91.4221, 40.3760],
    [-91.4331, 40.3690],
    [-91.4463, 40.3618],
    [-91.4567, 40.3486],
    [-91.4669, 40.3333],
    [-91.4861, 40.2934],
    [-91.4908, 40.2835],
    [-91.4931, 40.2753],
    [-91.4900, 40.2623],
    [-91.4973, 40.2488],
    [-91.5032, 40.2435],
    [-91.5060, 40.2343],
    [-91.5069, 40.2156],
    [-91.5050, 40.1999],
    [-91.5096, 40.1913],
    [-91.5131, 40.1785],
    [-91.5083, 40.1563],
    [-91.5113, 40.1411],
    [-91.5092, 40.1219],
    [-91.5060, 40.1081],
    [-91.4977, 40.0783],
    [-91.4910, 40.0608],
    [-91.4932, 40.0335],
    [-91.4874, 40.0232],
    [-91.4692, 39.9953],
    [-91.4653, 39.9840],
    [-91.4589, 39.9790],
    [-91.4472, 39.9595],
    [-91.4355, 39.9453],
    [-91.4241, 39.9357],
    [-91.4194, 39.9277],
    [-91.4209, 39.9149],
    [-91.4435, 39.8936],
    [-91.4464, 39.8704],
    [-91.4373, 39.8485],
    [-91.4329, 39.8406],
    [-91.4062, 39.8265],
    [-91.3780, 39.8113],
    [-91.3680, 39.8004],
    [-91.3617, 39.7851],
    [-91.3657, 39.7749],
    [-91.3651, 39.7587],
    [-91.3700, 39.7450],
    [-91.3678, 39.7290],
    [-91.3489, 39.7122],
    [-91.3307, 39.6999],
    [-91.3053, 39.6840],
    [-91.2833, 39.6701],
    [-91.2661, 39.6561],
    [-91.2488, 39.6409],
    [-91.2412, 39.6301],
    [-91.2166, 39.6151],
    [-91.1780, 39.5982],
    [-91.1716, 39.5819],
    [-91.1666, 39.5625],
    [-91.1536, 39.5482],
    [-91.1266, 39.5422],
    [-91.1003, 39.5387],
    [-91.0863, 39.5171],
    [-91.0753, 39.5028],
    [-91.0624, 39.4741],
    [-91.0503, 39.4596],
    [-91.0383, 39.4484],
    [-91.0275, 39.4413],
    [-91.0120, 39.4327],
    [-90.9830, 39.4205],
    [-90.9675, 39.4119],
    [-90.9483, 39.4075],
    [-90.9374, 39.4008],
    [-90.9340, 39.3921],
    [-90.9210, 39.3837],
    [-90.9127, 39.3816],
    [-90.9029, 39.3775],
    [-90.8938, 39.3673],
    [-90.8591, 39.3514],
    [-90.8213, 39.3237],
    [-90.7935, 39.3095],
    [-90.7907, 39.3029],
    [-90.7739, 39.2905],
    [-90.7489, 39.2641],
    [-90.7300, 39.2559],
    [-90.7216, 39.2327],
    [-90.7218, 39.2241],
    [-90.7166, 39.2104],
    [-90.7174, 39.1974],
    [-90.7105, 39.1764],
    [-90.7079, 39.1509],
    [-90.7005, 39.1354],
    [-90.6861, 39.1178],
    [-90.6811, 39.1006],
    [-90.7004, 39.0718],
    [-90.7013, 39.0699],
    [-90.7136, 39.0556],
    [-90.7079, 39.0423],
    [-90.6900, 39.0122],
    [-90.6877, 39.0054],
    [-90.6821, 38.9988],
    [-90.6764, 38.9841],
    [-90.6759, 38.9621],
    [-90.6692, 38.9482],
    [-90.6634, 38.9280],
    [-90.6532, 38.9161],
    [-90.6359, 38.9039],
    [-90.5954, 38.8751],
    [-90.5767, 38.8683],
    [-90.5557, 38.8708],
    [-90.5311, 38.8871],
    [-90.5001, 38.9104],
    [-90.4835, 38.9404],
    [-90.4721, 38.9588],
    [-90.4508, 38.9678],
    [-90.4337, 38.9655],
    [-90.4064, 38.9626],
    [-90.3831, 38.9555],
    [-90.3464, 38.9408],
    [-90.3236, 38.9297],
    [-90.3061, 38.9235],
    [-90.2837, 38.9240],
    [-90.2699, 38.9226],
    [-90.2540, 38.9205],
    [-90.2303, 38.9109],
    [-90.2092, 38.8970],
    [-90.1903, 38.8862],
    [-90.1515, 38.8671],
    [-90.1319, 38.8580],
    [-90.1094, 38.8435],
    [-90.1147, 38.8150],
    [-90.1467, 38.7830],
    [-90.1713, 38.7665],
    [-90.1754, 38.7590],
    [-90.1836, 38.7468],
    [-90.2099, 38.7261],
    [-90.2119, 38.7179],
    [-90.2023, 38.6935],
    [-90.1960, 38.6882],
    [-90.1868, 38.6753],
    [-90.1826, 38.6653],
    [-90.1811, 38.6595],
    [-90.1777, 38.6427],
    [-90.1780, 38.6338],
    [-90.1824, 38.6180],
    [-90.1866, 38.6079],
    [-90.2017, 38.5894],
    [-90.2055, 38.5868],
    [-90.2180, 38.5782],
    [-90.2231, 38.5758],
    [-90.2381, 38.5581],
    [-90.2503, 38.5428],
    [-90.2638, 38.5206],
    [-90.2688, 38.5062],
    [-90.2748, 38.4866],
    [-90.2777, 38.4757],
    [-90.2826, 38.4575],
    [-90.2875, 38.4402],
    [-90.2971, 38.4251],
    [-90.3223, 38.4018],
    [-90.3313, 38.3958],
    [-90.3435, 38.3850],
    [-90.3497, 38.3776],
    [-90.3682, 38.3403],
    [-90.3725, 38.3230],
    [-90.3739, 38.2895],
    [-90.3736, 38.2806],
    [-90.3709, 38.2674],
    [-90.3678, 38.2558],
    [-90.3639, 38.2364],
    [-90.3558, 38.2169],
    [-90.3343, 38.1899],
    [-90.3168, 38.1795],
    [-90.2908, 38.1705],
    [-90.2558, 38.1320],
    [-90.2501, 38.1251],
    [-90.2071, 38.0882],
    [-90.1634, 38.0743],
    [-90.1446, 38.0690],
    [-90.1264, 38.0549],
    [-90.1262, 38.0407],
    [-90.1105, 38.0265],
    [-90.0883, 38.0158],
    [-90.0650, 38.0169],
    [-90.0573, 38.0144],
    [-90.0529, 38.0059],
    [-90.0459, 38.0001],
    [-90.0172, 37.9794],
    [-89.9971, 37.9632],
    [-89.9789, 37.9628],
    [-89.9419, 37.9699],
    [-89.9359, 37.9596],
    [-89.9251, 37.9598],
    [-89.9325, 37.9475],
    [-89.9596, 37.9402],
    [-89.9749, 37.9267],
    [-89.9716, 37.9153],
    [-89.9525, 37.8832],
    [-89.9382, 37.8751],
    [-89.9133, 37.8696],
    [-89.8815, 37.8796],
    [-89.8670, 37.8935],
    [-89.8448, 37.9056],
    [-89.8372, 37.9023],
    [-89.8039, 37.8830],
    [-89.7977, 37.8742],
    [-89.7961, 37.8595],
    [-89.7820, 37.8551],
    [-89.7652, 37.8518],
    [-89.7541, 37.8464],
    [-89.7399, 37.8469],
    [-89.7294, 37.8351],
    [-89.7028, 37.8168],
    [-89.6829, 37.8078],
    [-89.6696, 37.7999],
    [-89.6604, 37.7863],
    [-89.6620, 37.7737],
    [-89.6680, 37.7595],
    [-89.6634, 37.7501],
    [-89.6454, 37.7461],
    [-89.6240, 37.7491],
    [-89.6159, 37.7482],
    [-89.6132, 37.7405],
    [-89.6024, 37.7365],
    [-89.5913, 37.7236],
    [-89.5833, 37.7133],
    [-89.5387, 37.7011],
    [-89.5219, 37.6965],
    [-89.5143, 37.6899],
    [-89.5139, 37.6766],
    [-89.5159, 37.6508],
    [-89.5177, 37.6412],
    [-89.5066, 37.6251],
    [-89.4858, 37.6072],
    [-89.4759, 37.5930],
    [-89.4811, 37.5830],
    [-89.5095, 37.5841],
    [-89.5198, 37.5827],
    [-89.5215, 37.5722],
    [-89.5211, 37.5538],
    [-89.5124, 37.5298],
    [-89.5002, 37.5130],
    [-89.4821, 37.4804],
    [-89.4546, 37.4530],
    [-89.4435, 37.4421],
    [-89.4259, 37.4075],
    [-89.4213, 37.3921],
    [-89.4282, 37.3562],
    [-89.4328, 37.3471],
    [-89.4547, 37.3393],
    [-89.4859, 37.3348],
    [-89.4893, 37.3331],
    [-89.4991, 37.3215],
    [-89.5106, 37.3129],
    [-89.5140, 37.3038],
    [-89.5157, 37.2954],
    [-89.5184, 37.2894],
    [-89.5139, 37.2772],
    [-89.4964, 37.2585],
    [-89.4792, 37.2531],
    [-89.4607, 37.2506],
    [-89.4582, 37.2471],
    [-89.4583, 37.2404],
    [-89.4675, 37.2218],
    [-89.4619, 37.1995],
    [-89.4553, 37.1869],
    [-89.4383, 37.1614],
    [-89.4256, 37.1382],
    [-89.4117, 37.1225],
    [-89.3903, 37.1090],
    [-89.3787, 37.0946],
    [-89.3766, 37.0777],
    [-89.3852, 37.0577],
    [-89.3839, 37.0464],
    [-89.3624, 37.0302],
    [-89.3230, 37.0161],
    [-89.2921, 36.9922],
    [-89.2696, 36.9934],
    [-89.2576, 37.0155],
    [-89.2777, 37.0361],
    [-89.3048, 37.0476],
    [-89.3108, 37.0579],
    [-89.2940, 37.0673],
    [-89.2804, 37.0652],
    [-89.2553, 37.0714],
    [-89.2383, 37.0429],
    [-89.2167, 37.0263],
    [-89.1985, 37.0117],
    [-89.1950, 36.9898],
    [-89.1772, 36.9709],
    [-89.1499, 36.9776],
    [-89.1327, 36.9822],
    [-89.1183, 36.9819],
    [-89.1029, 36.9697],
    [-89.0990, 36.9614],
    [-89.1008, 36.9440],
    [-89.1176, 36.8874],
    [-89.1249, 36.8749],
    [-89.1380, 36.8473],
    [-89.1573, 36.8433],
    [-89.1704, 36.8415],
    [-89.1782, 36.8346],
    [-89.1792, 36.8129],
    [-89.1763, 36.8057],
    [-89.1685, 36.7956],
    [-89.1442, 36.7884],
    [-89.1235, 36.7853],
    [-89.1168, 36.7756],
    [-89.1192, 36.7598],
    [-89.1304, 36.7517],
    [-89.1518, 36.7563],
    [-89.1691, 36.7595],
    [-89.1795, 36.7561],
    [-89.1978, 36.7394],
    [-89.2007, 36.7201],
    [-89.1844, 36.7012],
    [-89.1680, 36.6855],
    [-89.1719, 36.6725],
    [-89.1646, 36.6601],
    [-89.1747, 36.6504],
    [-89.1925, 36.6360],
    [-89.2009, 36.6182],
    [-89.2174, 36.5762],
    [-89.2365, 36.5668],
    [-89.2681, 36.5689],
    [-89.2946, 36.5937],
    [-89.3182, 36.6251],
    [-89.3340, 36.6322],
    [-89.3655, 36.6251],
    [-89.3764, 36.6139],
    [-89.3828, 36.5836],
    [-89.3968, 36.5520],
    [-89.4173, 36.4990],
    [-89.4293, 36.4819],
    [-89.4531, 36.4613],
    [-89.4717, 36.4570],
    [-89.4907, 36.4655],
    [-89.4942, 36.4760],
    [-89.4854, 36.4975],
    [-89.4725, 36.5137],
    [-89.4654, 36.5362],
    [-89.4791, 36.5682],
    [-89.4848, 36.5718],
    [-89.5182, 36.5786],
    [-89.5258, 36.5808],
    [-89.5461, 36.5800],
    [-89.5581, 36.5735],
    [-89.5698, 36.5581],
    [-89.5712, 36.5473],
    [-89.5640, 36.5333],
    [-89.5543, 36.5170],
    [-89.5385, 36.4969],
    [-89.5206, 36.4787],
    [-89.5197, 36.4670],
    [-89.5252, 36.4540],
    [-89.5434, 36.4388],
    [-89.5453, 36.4271],
    [-89.5253, 36.4004],
    [-89.5096, 36.3751],
    [-89.5132, 36.3599],
    [-89.5270, 36.3417],
    [-89.5450, 36.3368],
    [-89.6005, 36.3430],
    [-89.6158, 36.3361],
    [-89.6202, 36.3228],
    [-89.5898, 36.2968],
    [-89.5543, 36.2778],
    [-89.5448, 36.2805],
    [-89.5373, 36.2744],
    [-89.5347, 36.2526],
    [-89.5447, 36.2475],
    [-89.5580, 36.2510],
    [-89.5739, 36.2438],
    [-89.6024, 36.2381],
    [-89.6244, 36.2433],
    [-89.6525, 36.2507],
    [-89.6913, 36.2521],
    [-89.6986, 36.2506],
    [-89.7035, 36.2434],
    [-89.7052, 36.2366],
    [-89.6997, 36.2308],
    [-89.6795, 36.2159],
    [-89.6582, 36.2033],
    [-89.6369, 36.1890],
    [-89.6182, 36.1800],
    [-89.6009, 36.1646],
    [-89.5916, 36.1441],
    [-89.5940, 36.1272],
    [-89.6129, 36.1148],
    [-89.6251, 36.1081],
    [-89.6577, 36.0991],
    [-89.6788, 36.0846],
    [-89.6844, 36.0517],
    [-89.6886, 36.0292],
    [-89.7057, 36.0050],
    [-89.7376, 36.0005],
    [-89.7702, 36.0005],
    [-89.8050, 36.0002],
    [-89.8690, 35.9996],
    [-89.8751, 35.9996],
    [-89.9012, 35.9994],
    [-89.9459, 35.9991],
    [-89.9611, 35.9991],
    [-89.9955, 35.9988],
    [-90.1038, 35.9981],
    [-90.1264, 35.9976],
    [-90.1861, 35.9972],
    [-90.2483, 35.9967],
    [-90.2924, 35.9964],
    [-90.3687, 35.9958],
    [-90.3574, 36.0183],
    [-90.3518, 36.0284],
    [-90.3491, 36.0401],
    [-90.3393, 36.0471],
    [-90.3355, 36.0617],
    [-90.3185, 36.0755],
    [-90.3201, 36.0812],
    [-90.3124, 36.0945],
    [-90.2980, 36.1032],
    [-90.2945, 36.1129],
    [-90.2724, 36.1181],
    [-90.2588, 36.1276],
    [-90.2488, 36.1298],
    [-90.2443, 36.1365],
    [-90.2347, 36.1412],
    [-90.2354, 36.1592],
    [-90.2293, 36.1736],
    [-90.2135, 36.1832],
    [-90.2044, 36.1869],
    [-90.2017, 36.1961],
    [-90.1952, 36.2003],
    [-90.1904, 36.2014],
    [-90.1858, 36.2047],
    [-90.1733, 36.2103],
    [-90.1594, 36.2154],
    [-90.1525, 36.2156],
    [-90.1381, 36.2272],
    [-90.1264, 36.2294],
    [-90.1273, 36.2363],
    [-90.1306, 36.2421],
    [-90.1245, 36.2442],
    [-90.1149, 36.2656],
    [-90.1052, 36.2668],
    [-90.0879, 36.2714],
    [-90.0759, 36.2815],
    [-90.0717, 36.2934],
    [-90.0672, 36.3092],
    [-90.0773, 36.3193],
    [-90.0820, 36.3221],
    [-90.0770, 36.3308],
    [-90.0782, 36.3365],
    [-90.0741, 36.3429],
    [-90.0777, 36.3495],
    [-90.0663, 36.3593],
    [-90.0645, 36.3821],
    [-90.0742, 36.3933],
    [-90.0776, 36.3973],
    [-90.0944, 36.4040],
    [-90.1095, 36.4041],
    [-90.1199, 36.4102],
    [-90.1310, 36.4151],
    [-90.1387, 36.4145],
    [-90.1348, 36.4183],
    [-90.1356, 36.4229],
    [-90.1437, 36.4244],
    [-90.1427, 36.4312],
    [-90.1341, 36.4366],
    [-90.1369, 36.4509],
    [-90.1414, 36.4599],
    [-90.1411, 36.4618],
    [-90.1432, 36.4637],
    [-90.1558, 36.4636],
    [-90.1463, 36.4695],
    [-90.1437, 36.4760],
    [-90.1483, 36.4762],
    [-90.1594, 36.4801],
    [-90.1572, 36.4843],
    [-90.1595, 36.4876],
    [-90.1586, 36.4916],
    [-90.1574, 36.4942],
    [-90.1544, 36.4968],
    [-90.2173, 36.4978],
    [-90.2207, 36.4979],
    [-90.2655, 36.4979],
    [-90.3399, 36.4982],
    [-90.4263, 36.4983],
    [-90.4674, 36.4983],
    [-90.5002, 36.4984],
    [-90.5762, 36.4984],
    [-90.5943, 36.4985],
    [-90.6393, 36.4985],
    [-90.6930, 36.4985],
    [-90.7657, 36.4985],
    [-90.7844, 36.4985],
    [-90.8637, 36.4983],
    [-90.8766, 36.4983],
    [-90.9249, 36.4984],
    [-90.9629, 36.4984],
    [-90.9813, 36.4984],
    [-91.0180, 36.4981],
    [-91.1092, 36.4978],
    [-91.1724, 36.4976],
    [-91.2274, 36.4976],
    [-91.3275, 36.4973],
    [-91.4071, 36.4971],
    [-91.4333, 36.4973],
    [-91.4500, 36.4976],
    [-91.5274, 36.4990],
    [-91.5345, 36.4991],
    [-91.5442, 36.4991],
    [-91.5535, 36.4992],
    [-91.5648, 36.4992],
    [-91.6013, 36.4993],
    [-91.6314, 36.4992],
    [-91.6860, 36.4994],
    [-91.7085, 36.4993],
    [-91.7671, 36.4991],
    [-91.7995, 36.4990],
    [-91.8369, 36.4989],
    [-91.8660, 36.4988],
    [-91.9364, 36.4986],
    [-91.9858, 36.4984],
    [-92.0288, 36.4986],
    [-92.0572, 36.4987],
    [-92.1125, 36.4988],
    [-92.1377, 36.4987],
    [-92.2114, 36.4984],
    [-92.2164, 36.4984],
    [-92.3094, 36.4979],
    [-92.3702, 36.4973],
    [-92.4204, 36.4979],
    [-92.4347, 36.4983],
    [-92.5168, 36.4987],
    [-92.5642, 36.4982],
    [-92.6173, 36.4981],
    [-92.7723, 36.4978],
    [-92.8389, 36.4980],
    [-92.8943, 36.4979],
    [-92.9294, 36.4979],
    [-93.0137, 36.4981],
    [-93.0695, 36.4982],
    [-93.1260, 36.4979],
    [-93.2218, 36.4981],
    [-93.3153, 36.4984],
    [-93.3843, 36.4985],
    [-93.3947, 36.4985],
    [-93.3961, 36.4987],
    [-93.4001, 36.4987],
    [-93.4270, 36.4986],
    [-93.4398, 36.4986],
    [-93.4892, 36.4988],
    [-93.5145, 36.4989],
    [-93.6483, 36.4990],
    [-93.6799, 36.4991],
    [-93.7002, 36.4991],
    [-93.7189, 36.4992],
    [-93.7343, 36.4990],
    [-93.8340, 36.4988],
    [-93.9019, 36.4987],
    [-93.9266, 36.4987],
    [-93.9639, 36.4987],
    [-93.9760, 36.4987],
    [-94.0318, 36.4987],
    [-94.0945, 36.4987],
    [-94.1107, 36.4986],
    [-94.1145, 36.4986],
    [-94.1830, 36.4989],
    [-94.1964, 36.4989],
    [-94.2492, 36.4992],
    [-94.2694, 36.4992],
    [-94.2891, 36.4993],
    [-94.3160, 36.4994],
    [-94.3393, 36.4995],
    [-94.3838, 36.4995],
    [-94.4571, 36.4994],
    [-94.5195, 36.4992],
    [-94.6176, 36.4994],
    [-94.6179, 36.5063],
    [-94.6179, 36.5150],
    [-94.6180, 36.5343],
    [-94.6179, 36.5370],
    [-94.6178, 36.5777],
    [-94.6179, 36.5991],
    [-94.6178, 36.6126],
    [-94.6179, 36.6254],
    [-94.6180, 36.6694],
    [-94.6182, 36.7167],
    [-94.6183, 36.7666],
    [-94.6184, 36.8245],
    [-94.6184, 36.8437],
    [-94.6186, 36.8687],
    [-94.6187, 36.8800],
    [-94.6182, 36.8970],
    [-94.6182, 36.9200],
    [-94.6183, 36.9296],
    [-94.6180, 36.9502],
    [-94.6180, 36.9959],
    [-94.6180, 37.0059],
    [-94.6180, 37.0309],
    [-94.6180, 37.0405],
    [-94.6179, 37.0601],
    [-94.6180, 37.0788],
    [-94.6181, 37.0893],
    [-94.6181, 37.0967],
    [-94.6182, 37.1189],
    [-94.6181, 37.1323],
    [-94.6184, 37.1602],
    [-94.6185, 37.1811],
    [-94.6183, 37.1888],
    [-94.6183, 37.2073],
    [-94.6181, 37.2293],
    [-94.6180, 37.2619],
    [-94.6177, 37.3368],
    [-94.6175, 37.3644],
    [-94.6176, 37.3964],
    [-94.6173, 37.4255],
    [-94.6171, 37.4400],
    [-94.6172, 37.4605],
    [-94.6171, 37.4778],
    [-94.6169, 37.5069],
    [-94.6172, 37.5516],
    [-94.6172, 37.5536],
    [-94.6171, 37.5632],
    [-94.6173, 37.5707],
    [-94.6174, 37.6095],
    [-94.6175, 37.6372],
    [-94.6176, 37.6537],
    [-94.6179, 37.6822],
    [-94.6178, 37.6902],
    [-94.6178, 37.7555],
    [-94.6177, 37.7730],
    [-94.6165, 37.8376],
    [-94.6163, 37.8517],
    [-94.6158, 37.8725],
    [-94.6157, 37.8868],
    [-94.6154, 37.9064],
    [-94.6148, 37.9367],
    [-94.6146, 37.9444],
    [-94.6146, 37.9710],
    [-94.6145, 37.9878],
    [-94.6140, 38.0371],
    [-94.6141, 38.0659],
    [-94.6139, 38.1244],
    [-94.6134, 38.1679],
    [-94.6128, 38.2007],
    [-94.6127, 38.2176],
    [-94.6127, 38.2193],
    [-94.6126, 38.2378],
    [-94.6127, 38.2724],
    [-94.6128, 38.2914],
    [-94.6127, 38.3131],
    [-94.6128, 38.3244],
    [-94.6133, 38.3696],
    [-94.6133, 38.3999],
    [-94.6132, 38.4342],
    [-94.6129, 38.4776],
    [-94.6126, 38.4916],
    [-94.6125, 38.5063],
    [-94.6123, 38.5476],
    [-94.6122, 38.5655],
    [-94.6119, 38.5801],
    [-94.6119, 38.6093],
    [-94.6115, 38.6250],
    [-94.6108, 38.6726],
    [-94.6095, 38.7407],
    [-94.6089, 38.7672],
    [-94.6080, 38.8111],
    [-94.6079, 38.8164],
    [-94.6076, 38.8275],
    [-94.6077, 38.8317],
    [-94.6080, 38.8502],
    [-94.6080, 38.8612],
    [-94.6080, 38.8681],
    [-94.6080, 38.8838],
    [-94.6080, 38.8909],
    [-94.6080, 38.9067],
    [-94.6080, 38.9292],
    [-94.6080, 38.9368],
    [-94.6081, 38.9400],
    [-94.6082, 38.9493],
    [-94.6082, 38.9651],
    [-94.6083, 38.9787],
    [-94.6083, 38.9856],
    [-94.6081, 39.0001],
    [-94.6080, 39.0079],
    [-94.6079, 39.0152],
    [-94.6077, 39.0283],
    [-94.6076, 39.0342],
    [-94.6076, 39.0408],
    [-94.6075, 39.0446],
    [-94.6074, 39.0502],
    [-94.6072, 39.0657],
    [-94.6073, 39.0817],
    [-94.6072, 39.0897],
    [-94.6057, 39.1222],
    [-94.5899, 39.1390],
    [-94.5960, 39.1577],
    [-94.6158, 39.1600],
    [-94.6398, 39.1537],
    [-94.6558, 39.1557],
    [-94.6603, 39.1681],
    [-94.6638, 39.1791],
    [-94.6872, 39.1835],
    [-94.7141, 39.1704],
    [-94.7419, 39.1702],
    [-94.7631, 39.1799],
    [-94.7755, 39.2006],
    [-94.7838, 39.2072],
    [-94.7997, 39.2060],
    [-94.8238, 39.2099],
    [-94.8350, 39.2205],
    [-94.8278, 39.2340],
    [-94.8264, 39.2448],
    [-94.8315, 39.2563],
    [-94.8463, 39.2685],
    [-94.8578, 39.2741],
    [-94.8826, 39.2833],
    [-94.8899, 39.2892],
    [-94.9007, 39.3015],
    [-94.9031, 39.3063],
    [-94.9066, 39.3174],
    [-94.9087, 39.3297],
    [-94.9106, 39.3483],
    [-94.9094, 39.3543],
    [-94.8990, 39.3624],
    [-94.8852, 39.3669],
    [-94.8793, 39.3798],
    [-94.8850, 39.3898],
    [-94.8918, 39.3933],
    [-94.8951, 39.3935],
    [-94.9159, 39.3863],
    [-94.9337, 39.3855],
    [-94.9397, 39.3879],
    [-94.9462, 39.3956],
    [-94.9479, 39.4086],
    [-94.9661, 39.4173],
    [-94.9766, 39.4267],
    [-94.9902, 39.4462],
    [-95.0158, 39.4528],
    [-95.0375, 39.4637],
    [-95.0471, 39.4750],
    [-95.0506, 39.4975],
    [-95.0595, 39.5061],
    [-95.0927, 39.5242],
    [-95.1063, 39.5373],
    [-95.1136, 39.5539],
    [-95.1075, 39.5738],
    [-95.0991, 39.5797],
    [-95.0895, 39.5810],
    [-95.0693, 39.5762],
    [-95.0569, 39.5806],
    [-95.0472, 39.5951],
    [-95.0479, 39.6063],
    [-95.0543, 39.6186],
    [-95.0534, 39.6303],
    [-95.0400, 39.6488],
    [-95.0276, 39.6655],
    [-95.0183, 39.6729],
    [-95.0014, 39.6765],
    [-94.9918, 39.6768],
    [-94.9763, 39.6814],
    [-94.9690, 39.6930],
    [-94.9711, 39.7231],
    [-94.9653, 39.7391],
    [-94.9553, 39.7457],
    [-94.9487, 39.7456],
    [-94.9300, 39.7354],
    [-94.9026, 39.7242],
    [-94.8917, 39.7249],
    [-94.8756, 39.7305],
    [-94.8606, 39.7488],
    [-94.8595, 39.7535],
    [-94.8631, 39.7673],
    [-94.8696, 39.7729],
    [-94.8814, 39.7713],
    [-94.8936, 39.7642],
    [-94.8941, 39.7639],
    [-94.8992, 39.7613],
    [-94.9168, 39.7609],
    [-94.9343, 39.7736],
    [-94.9352, 39.7831],
    [-94.9297, 39.7883],
    [-94.8903, 39.7916],
    [-94.8807, 39.7979],
    [-94.8765, 39.8206],
    [-94.8787, 39.8265],
    [-94.8895, 39.8340],
    [-94.9099, 39.8344],
    [-94.9377, 39.8498],
    [-94.9424, 39.8611],
    [-94.9315, 39.8726],
    [-94.9274, 39.8840],
    [-94.9345, 39.8934],
    [-94.9593, 39.9017],
    [-94.9870, 39.8967],
    [-95.0038, 39.9004],
    [-95.0187, 39.8974],
    [-95.0252, 39.8897],
    [-95.0254, 39.8767],
    [-95.0378, 39.8655],
    [-95.0815, 39.8617],
    [-95.1059, 39.8692],
    [-95.1347, 39.8769],
    [-95.1427, 39.8859],
    [-95.1426, 39.8980],
    [-95.1497, 39.9059],
    [-95.1598, 39.9070],
    [-95.1814, 39.9000],
    [-95.1993, 39.9027],
    [-95.2062, 39.9096],
    [-95.2020, 39.9224],
    [-95.2044, 39.9389],
    [-95.2202, 39.9444],
    [-95.2414, 39.9449],
    [-95.2619, 39.9606],
    [-95.2897, 39.9777],
    [-95.3078, 39.9906],
    [-95.3083, 40.0000],
    [-95.3122, 40.0094],
    [-95.3285, 40.0157],
    [-95.3488, 40.0293],
    [-95.3830, 40.0271],
    [-95.3959, 40.0280],
    [-95.4136, 40.0384],
    [-95.4202, 40.0525],
    [-95.4183, 40.0665],
    [-95.4099, 40.0743],
    [-95.4106, 40.0915],
    [-95.3971, 40.1052],
    [-95.3930, 40.1127],
    [-95.3931, 40.1176],
    [-95.3987, 40.1264],
    [-95.4192, 40.1306],
    [-95.4310, 40.1384],
    [-95.4338, 40.1529],
    [-95.4407, 40.1623],
    [-95.4607, 40.1692],
    [-95.4763, 40.1820],
    [-95.4815, 40.1898],
    [-95.4823, 40.2007],
    [-95.4714, 40.2173],
    [-95.4703, 40.2308],
    [-95.4828, 40.2463],
    [-95.4934, 40.2496],
    [-95.5161, 40.2492],
    [-95.5346, 40.2570],
    [-95.5543, 40.2634],
    [-95.5563, 40.2708],
    [-95.5516, 40.2887],
    [-95.5622, 40.2974],
    [-95.5874, 40.3016],
    [-95.5978, 40.3092],
    [-95.6104, 40.3140],
    [-95.6232, 40.3125],
    [-95.6453, 40.3057],
    [-95.6573, 40.3109],
    [-95.6566, 40.3195],
    [-95.6338, 40.3293],
    [-95.6232, 40.3384],
    [-95.6248, 40.3492],
    [-95.6274, 40.3531],
    [-95.6390, 40.3638],
    [-95.6427, 40.3750],
    [-95.6494, 40.3961],
    [-95.6615, 40.4159],
    [-95.6563, 40.4288],
    [-95.6578, 40.4407],
    [-95.6717, 40.4567],
    [-95.6871, 40.4653],
    [-95.6964, 40.4759],
    [-95.6952, 40.4866],
    [-95.7000, 40.5053],
    [-95.6680, 40.5150],
    [-95.6548, 40.5273],
    [-95.6558, 40.5466],
    [-95.6718, 40.5626],
    [-95.6941, 40.5569],
    [-95.6973, 40.5370],
    [-95.7086, 40.5216],
    [-95.7224, 40.5281],
    [-95.7372, 40.5239],
    [-95.7629, 40.5284],
    [-95.7693, 40.5367],
    [-95.7636, 40.5483],
    [-95.7650, 40.5569],
    [-95.7735, 40.5782]
    ]
  },
  "Colorado": {
    coordinates: [
      [-109.0603, 38.5993],
    [-109.0542, 38.8750],
    [-109.0532, 38.9425],
    [-109.0523, 39.0196],
    [-109.0515, 39.1261],
    [-109.0514, 39.4977],
    [-109.0506, 39.8750],
    [-109.0509, 40.1731],
    [-109.0510, 40.2226],
    [-109.0507, 40.5000],
    [-109.0501, 40.5404],
    [-109.0484, 40.6626],
    [-109.0501, 41.0007],
    [-108.5267, 40.9996],
    [-108.3002, 41.0001],
    [-108.0465, 41.0021],
    [-107.6256, 41.0021],
    [-107.3029, 41.0029],
    [-107.0006, 41.0034],
    [-106.4396, 41.0020],
    [-106.3919, 41.0012],
    [-106.2176, 40.9977],
    [-105.7706, 40.9969],
    [-105.4127, 40.9978],
    [-105.2565, 40.9982],
    [-104.8553, 40.9980],
    [-104.6760, 41.0010],
    [-104.4971, 41.0018],
    [-104.3713, 41.0015],
    [-104.2115, 41.0016],
    [-104.0861, 41.0016],
    [-104.0392, 41.0015],
    [-104.0110, 41.0016],
    [-103.9535, 41.0016],
    [-103.8962, 41.0018],
    [-103.7633, 41.0020],
    [-103.5745, 41.0017],
    [-103.4974, 41.0016],
    [-103.4219, 41.0020],
    [-103.3653, 41.0018],
    [-103.0778, 41.0023],
    [-103.0580, 41.0024],
    [-103.0020, 41.0025],
    [-102.9815, 41.0021],
    [-102.9607, 41.0021],
    [-102.9431, 41.0021],
    [-102.9065, 41.0023],
    [-102.8874, 41.0022],
    [-102.8678, 41.0022],
    [-102.8465, 41.0023],
    [-102.7928, 41.0023],
    [-102.7546, 41.0024],
    [-102.6535, 41.0023],
    [-102.5757, 41.0023],
    [-102.5568, 41.0022],
    [-102.4705, 41.0024],
    [-102.3796, 41.0023],
    [-102.2928, 41.0022],
    [-102.2914, 41.0022],
    [-102.2678, 41.0024],
    [-102.2319, 41.0023],
    [-102.2091, 41.0024],
    [-102.0706, 41.0024],
    [-102.0516, 40.9596],
    [-102.0513, 40.7496],
    [-102.0517, 40.5378],
    [-102.0518, 40.3966],
    [-102.0518, 40.3601],
    [-102.0517, 40.2659],
    [-102.0519, 40.1627],
    [-102.0517, 40.0031],
    [-102.0516, 39.8498],
    [-102.0513, 39.8190],
    [-102.0501, 39.6538],
    [-102.0498, 39.5741],
    [-102.0497, 39.5367],
    [-102.0494, 39.4182],
    [-102.0490, 39.3737],
    [-102.0473, 39.1370],
    [-102.0468, 39.0756],
    [-102.0453, 38.7995],
    [-102.0453, 38.7555],
    [-102.0452, 38.6886],
    [-102.0451, 38.6749],
    [-102.0453, 38.6152],
    [-102.0452, 38.5438],
    [-102.0453, 38.5054],
    [-102.0444, 38.4158],
    [-102.0446, 38.2688],
    [-102.0444, 38.2500],
    [-102.0446, 38.1250],
    [-102.0445, 38.0302],
    [-102.0437, 37.9140],
    [-102.0430, 37.8035],
    [-102.0420, 37.7385],
    [-102.0417, 37.6657],
    [-102.0416, 37.6079],
    [-102.0420, 37.5353],
    [-102.0418, 37.4349],
    [-102.0416, 37.3892],
    [-102.0420, 37.3526],
    [-102.0420, 37.2582],
    [-102.0421, 37.1250],
    [-102.0420, 37.1066],
    [-102.0419, 37.0322],
    [-102.0421, 36.9930],
    [-102.1843, 36.9936],
    [-102.2608, 36.9944],
    [-102.3533, 36.9945],
    [-102.6981, 36.9951],
    [-102.8325, 36.9997],
    [-102.8867, 36.9995],
    [-102.9870, 36.9985],
    [-103.1559, 37.0002],
    [-103.4718, 36.9990],
    [-104.0079, 36.9962],
    [-104.2505, 36.9946],
    [-104.4340, 36.9937],
    [-104.4804, 36.9937],
    [-104.6246, 36.9944],
    [-104.6450, 36.9934],
    [-104.7321, 36.9935],
    [-105.0292, 36.9927],
    [-105.1550, 36.9953],
    [-105.2513, 36.9956],
    [-105.4425, 36.9960],
    [-105.5088, 36.9959],
    [-105.5339, 36.9959],
    [-105.6647, 36.9959],
    [-105.7185, 36.9958],
    [-106.0063, 36.9953],
    [-106.2015, 36.9941],
    [-106.2933, 36.9939],
    [-106.4755, 36.9938],
    [-106.5006, 36.9938],
    [-106.6287, 36.9932],
    [-106.6756, 36.9931],
    [-106.7819, 36.9925],
    [-106.9560, 37.0001],
    [-107.2550, 37.0000],
    [-107.4209, 37.0000],
    [-107.4817, 37.0000],
    [-107.6011, 37.0000],
    [-107.7806, 37.0000],
    [-107.8691, 37.0000],
    [-108.0378, 36.9999],
    [-108.2494, 36.9990],
    [-108.2881, 36.9996],
    [-108.3207, 36.9995],
    [-108.6197, 36.9992],
    [-108.9544, 36.9989],
    [-109.0051, 36.9990],
    [-109.0452, 37.0220],
    [-109.0450, 37.0864],
    [-109.0452, 37.1120],
    [-109.0460, 37.2018],
    [-109.0456, 37.2494],
    [-109.0458, 37.3597],
    [-109.0431, 37.5000],
    [-109.0418, 37.6042],
    [-109.0423, 37.6661],
    [-109.0416, 37.7402],
    [-109.0418, 37.8358],
    [-109.0417, 37.8811],
    [-109.0428, 37.9971],
    [-109.0418, 38.1647],
    [-109.0600, 38.5000],
    [-109.0603, 38.5993]
    ]
  },
  "Utah": {
    coordinates: [
      [-114.0530, 37.5928],
    [-114.0518, 37.7240],
    [-114.0517, 37.7470],
    [-114.0485, 37.8099],
    [-114.0497, 37.8814],
    [-114.0499, 38.1486],
    [-114.0494, 38.2647],
    [-114.0505, 38.5000],
    [-114.0502, 38.5729],
    [-114.0497, 38.7292],
    [-114.0485, 38.8762],
    [-114.0471, 39.4999],
    [-114.0473, 39.7594],
    [-114.0472, 39.8210],
    [-114.0467, 39.9806],
    [-114.0464, 40.0979],
    [-114.0462, 40.2320],
    [-114.0452, 40.4303],
    [-114.0453, 40.5066],
    [-114.0435, 40.7263],
    [-114.0437, 40.7477],
    [-114.0438, 40.7592],
    [-114.0424, 40.9420],
    [-114.0414, 41.2078],
    [-114.0402, 41.4917],
    [-114.0404, 41.6154],
    [-114.0412, 41.8506],
    [-114.0415, 41.9939],
    [-113.9016, 41.9886],
    [-113.7647, 41.9895],
    [-113.6012, 41.9918],
    [-113.3967, 41.9943],
    [-113.1868, 41.9965],
    [-113.0000, 41.9982],
    [-112.8823, 41.9991],
    [-112.7094, 42.0001],
    [-112.5086, 42.0008],
    [-112.2649, 42.0012],
    [-112.2268, 42.0012],
    [-112.1592, 41.9984],
    [-112.1039, 41.9978],
    [-112.0122, 41.9983],
    [-111.9450, 41.9986],
    [-111.9156, 41.9986],
    [-111.8368, 41.9987],
    [-111.7986, 41.9990],
    [-111.6134, 41.9993],
    [-111.4780, 41.9996],
    [-111.3000, 42.0012],
    [-111.0467, 42.0017],
    [-111.0458, 41.5798],
    [-111.0463, 41.3777],
    [-111.0466, 41.2517],
    [-111.0466, 41.2009],
    [-111.0338, 40.9979],
    [-110.7507, 40.9968],
    [-110.6068, 40.9963],
    [-110.5007, 40.9947],
    [-110.2507, 40.9961],
    [-110.1216, 40.9971],
    [-110.0007, 40.9974],
    [-109.8553, 40.9976],
    [-109.7325, 40.9981],
    [-109.7085, 40.9983],
    [-109.5861, 40.9982],
    [-109.5349, 40.9981],
    [-109.2320, 41.0021],
    [-109.0485, 40.8261],
    [-109.0482, 40.6536],
    [-109.0501, 40.5403],
    [-109.0503, 40.4951],
    [-109.0510, 40.1808],
    [-109.0508, 40.0596],
    [-109.0510, 39.6605],
    [-109.0512, 39.4620],
    [-109.0516, 39.1165],
    [-109.0524, 39.0000],
    [-109.0538, 38.9053],
    [-109.0574, 38.7955],
    [-109.0600, 38.5000],
    [-109.0418, 38.1647],
    [-109.0428, 37.9971],
    [-109.0417, 37.8811],
    [-109.0418, 37.8358],
    [-109.0416, 37.7402],
    [-109.0423, 37.6661],
    [-109.0418, 37.6042],
    [-109.0431, 37.5000],
    [-109.0458, 37.3597],
    [-109.0456, 37.2494],
    [-109.0460, 37.2018],
    [-109.0452, 37.1120],
    [-109.0450, 37.0864],
    [-109.0452, 37.0220],
    [-109.1812, 36.9993],
    [-109.2634, 36.9993],
    [-109.3198, 36.9992],
    [-109.3780, 36.9991],
    [-109.4716, 36.9991],
    [-109.6257, 36.9983],
    [-109.7098, 36.9984],
    [-109.9341, 36.9983],
    [-110.0009, 36.9985],
    [-110.1460, 36.9984],
    [-110.1757, 36.9984],
    [-110.2760, 36.9983],
    [-110.4702, 36.9980],
    [-110.5007, 37.0043],
    [-110.6257, 37.0037],
    [-111.0600, 37.0024],
    [-111.1337, 37.0008],
    [-111.1434, 37.0008],
    [-111.2350, 37.0010],
    [-111.2533, 37.0011],
    [-111.2783, 37.0005],
    [-111.3099, 37.0007],
    [-111.3161, 37.0008],
    [-111.3631, 37.0012],
    [-111.4014, 37.0015],
    [-111.4059, 37.0015],
    [-111.4128, 37.0015],
    [-111.5656, 37.0014],
    [-111.8654, 37.0013],
    [-112.3753, 37.0011],
    [-112.5044, 37.0008],
    [-112.5384, 37.0007],
    [-112.5405, 37.0007],
    [-112.5590, 37.0007],
    [-112.7246, 37.0006],
    [-112.9281, 37.0003],
    [-112.9534, 37.0002],
    [-113.0164, 37.0002],
    [-113.3064, 37.0001],
    [-113.4096, 37.0001],
    [-113.4949, 37.0001],
    [-113.6224, 37.0001],
    [-113.9659, 37.0000],
    [-114.0518, 37.0910],
    [-114.0522, 37.1471],
    [-114.0520, 37.2838],
    [-114.0518, 37.2935],
    [-114.0518, 37.4181],
    [-114.0526, 37.4723],
    [-114.0527, 37.5173],
    [-114.0530, 37.5928]
    ]
  },
  "Tennessee": {
    coordinates: [
      [-90.3103, 35.0043],
    [-90.3007, 35.0288],
    [-90.2945, 35.0406],
    [-90.2638, 35.0396],
    [-90.2565, 35.0345],
    [-90.2163, 35.0260],
    [-90.2008, 35.0324],
    [-90.1969, 35.0437],
    [-90.1951, 35.0618],
    [-90.1768, 35.1121],
    [-90.1679, 35.1230],
    [-90.1601, 35.1288],
    [-90.1428, 35.1351],
    [-90.1006, 35.1167],
    [-90.0834, 35.1217],
    [-90.0712, 35.1316],
    [-90.0652, 35.1382],
    [-90.0665, 35.1511],
    [-90.0687, 35.1531],
    [-90.0929, 35.1572],
    [-90.1032, 35.1680],
    [-90.1082, 35.1749],
    [-90.1142, 35.1817],
    [-90.1162, 35.1985],
    [-90.0965, 35.1948],
    [-90.0841, 35.2104],
    [-90.0745, 35.2112],
    [-90.0749, 35.2205],
    [-90.0829, 35.2318],
    [-90.0979, 35.2500],
    [-90.1101, 35.2555],
    [-90.1321, 35.2532],
    [-90.1521, 35.2560],
    [-90.1688, 35.2791],
    [-90.1638, 35.2961],
    [-90.1534, 35.3026],
    [-90.1324, 35.3005],
    [-90.1172, 35.3034],
    [-90.1039, 35.3324],
    [-90.1073, 35.3431],
    [-90.0935, 35.3605],
    [-90.0838, 35.3688],
    [-90.0799, 35.3853],
    [-90.0966, 35.3953],
    [-90.1105, 35.4086],
    [-90.1305, 35.4137],
    [-90.1417, 35.4086],
    [-90.1462, 35.3995],
    [-90.1355, 35.3767],
    [-90.1724, 35.3777],
    [-90.1707, 35.4101],
    [-90.1402, 35.4365],
    [-90.1206, 35.4657],
    [-90.1077, 35.4769],
    [-90.0901, 35.4787],
    [-90.0722, 35.4708],
    [-90.0672, 35.4610],
    [-90.0741, 35.4340],
    [-90.0693, 35.4083],
    [-90.0457, 35.3927],
    [-90.0451, 35.3973],
    [-90.0453, 35.4154],
    [-90.0406, 35.4229],
    [-90.0293, 35.4352],
    [-90.0269, 35.4449],
    [-90.0221, 35.4574],
    [-90.0190, 35.4678],
    [-90.0435, 35.4923],
    [-90.0503, 35.5153],
    [-90.0447, 35.5317],
    [-90.0376, 35.5503],
    [-90.0239, 35.5563],
    [-90.0113, 35.5591],
    [-89.9990, 35.5612],
    [-89.9763, 35.5539],
    [-89.9556, 35.5345],
    [-89.9577, 35.5272],
    [-89.9480, 35.5201],
    [-89.9336, 35.5185],
    [-89.9154, 35.5151],
    [-89.9077, 35.5229],
    [-89.9056, 35.5368],
    [-89.9098, 35.5378],
    [-89.9124, 35.5386],
    [-89.9097, 35.5420],
    [-89.9073, 35.5441],
    [-89.9093, 35.5480],
    [-89.9147, 35.5496],
    [-89.9241, 35.5506],
    [-89.9448, 35.5603],
    [-89.9567, 35.5814],
    [-89.9567, 35.5905],
    [-89.9454, 35.6016],
    [-89.9196, 35.6122],
    [-89.9060, 35.6161],
    [-89.8943, 35.6155],
    [-89.8566, 35.6344],
    [-89.8519, 35.6439],
    [-89.8512, 35.6574],
    [-89.8613, 35.6701],
    [-89.8772, 35.6661],
    [-89.8849, 35.6551],
    [-89.8989, 35.6509],
    [-89.9227, 35.6553],
    [-89.9374, 35.6657],
    [-89.9533, 35.6864],
    [-89.9566, 35.6955],
    [-89.9589, 35.7238],
    [-89.9540, 35.7362],
    [-89.9321, 35.7471],
    [-89.9155, 35.7549],
    [-89.9068, 35.7592],
    [-89.8835, 35.7450],
    [-89.8639, 35.7476],
    [-89.8329, 35.7549],
    [-89.8145, 35.7599],
    [-89.7992, 35.7754],
    [-89.7993, 35.7885],
    [-89.7655, 35.8095],
    [-89.7430, 35.8058],
    [-89.7207, 35.8111],
    [-89.7039, 35.8203],
    [-89.7010, 35.8282],
    [-89.7044, 35.8357],
    [-89.7494, 35.8530],
    [-89.7725, 35.8651],
    [-89.7729, 35.8762],
    [-89.7657, 35.8913],
    [-89.7412, 35.9067],
    [-89.6818, 35.8900],
    [-89.6660, 35.8829],
    [-89.6453, 35.8914],
    [-89.6448, 35.9044],
    [-89.6523, 35.9215],
    [-89.6766, 35.9405],
    [-89.7102, 35.9598],
    [-89.7197, 35.9709],
    [-89.7192, 35.9860],
    [-89.7331, 36.0006],
    [-89.7036, 36.0080],
    [-89.6873, 36.0340],
    [-89.6819, 36.0723],
    [-89.6725, 36.0918],
    [-89.6430, 36.1036],
    [-89.6212, 36.1103],
    [-89.6019, 36.1195],
    [-89.5931, 36.1297],
    [-89.5922, 36.1501],
    [-89.6070, 36.1712],
    [-89.6238, 36.1831],
    [-89.6448, 36.1941],
    [-89.6641, 36.2065],
    [-89.6851, 36.2197],
    [-89.7004, 36.2315],
    [-89.7055, 36.2381],
    [-89.7006, 36.2473],
    [-89.6952, 36.2528],
    [-89.6862, 36.2495],
    [-89.6422, 36.2495],
    [-89.6111, 36.2393],
    [-89.5873, 36.2395],
    [-89.5650, 36.2501],
    [-89.5536, 36.2503],
    [-89.5416, 36.2479],
    [-89.5345, 36.2618],
    [-89.5377, 36.2753],
    [-89.5466, 36.2804],
    [-89.5785, 36.2883],
    [-89.6118, 36.3091],
    [-89.6203, 36.3230],
    [-89.6107, 36.3404],
    [-89.5816, 36.3424],
    [-89.5381, 36.3375],
    [-89.5227, 36.3448],
    [-89.5112, 36.3678],
    [-89.5104, 36.3784],
    [-89.5423, 36.4201],
    [-89.5455, 36.4307],
    [-89.5409, 36.4416],
    [-89.5234, 36.4566],
    [-89.5197, 36.4687],
    [-89.5227, 36.4813],
    [-89.5392, 36.4979],
    [-89.4854, 36.4975],
    [-89.4942, 36.4760],
    [-89.4907, 36.4655],
    [-89.4717, 36.4570],
    [-89.4531, 36.4613],
    [-89.4293, 36.4819],
    [-89.4173, 36.4990],
    [-89.3818, 36.5001],
    [-89.3461, 36.5032],
    [-89.2791, 36.5065],
    [-89.1634, 36.5045],
    [-89.1200, 36.5037],
    [-89.0901, 36.5034],
    [-89.0589, 36.5032],
    [-89.0104, 36.5027],
    [-88.9645, 36.5022],
    [-88.8995, 36.5022],
    [-88.8893, 36.5019],
    [-88.8747, 36.5024],
    [-88.8593, 36.5026],
    [-88.8365, 36.5029],
    [-88.8273, 36.5029],
    [-88.7996, 36.5028],
    [-88.7153, 36.5027],
    [-88.5773, 36.5019],
    [-88.5164, 36.5014],
    [-88.5119, 36.5015],
    [-88.4726, 36.5010],
    [-88.4301, 36.5009],
    [-88.3304, 36.5005],
    [-88.3209, 36.5004],
    [-88.1761, 36.4990],
    [-88.0882, 36.4978],
    [-88.0505, 36.5001],
    [-88.0378, 36.5138],
    [-88.0373, 36.5238],
    [-88.0325, 36.5407],
    [-88.0396, 36.5728],
    [-88.0557, 36.6305],
    [-88.0570, 36.6405],
    [-88.0682, 36.6597],
    [-88.0118, 36.6770],
    [-87.9020, 36.6676],
    [-87.8532, 36.6332],
    [-87.7975, 36.6347],
    [-87.6411, 36.6380],
    [-87.4757, 36.6402],
    [-87.4516, 36.6406],
    [-87.4365, 36.6407],
    [-87.4262, 36.6410],
    [-87.4143, 36.6410],
    [-87.3984, 36.6411],
    [-87.3559, 36.6414],
    [-87.3360, 36.6415],
    [-87.2784, 36.6417],
    [-87.2310, 36.6419],
    [-87.1980, 36.6420],
    [-87.1510, 36.6423],
    [-87.0115, 36.6439],
    [-86.9198, 36.6460],
    [-86.8543, 36.6469],
    [-86.8332, 36.6472],
    [-86.8130, 36.6476],
    [-86.7138, 36.6493],
    [-86.6530, 36.6509],
    [-86.5899, 36.6525],
    [-86.5641, 36.6335],
    [-86.5551, 36.6367],
    [-86.5501, 36.6448],
    [-86.5434, 36.6439],
    [-86.5078, 36.6524],
    [-86.4734, 36.6517],
    [-86.4597, 36.6516],
    [-86.3750, 36.6498],
    [-86.3331, 36.6488],
    [-86.2644, 36.6435],
    [-86.2164, 36.6406],
    [-86.2049, 36.6397],
    [-86.1281, 36.6361],
    [-86.0807, 36.6339],
    [-86.0328, 36.6304],
    [-85.9764, 36.6286],
    [-85.9600, 36.6281],
    [-85.8739, 36.6236],
    [-85.8015, 36.6224],
    [-85.7452, 36.6208],
    [-85.6659, 36.6179],
    [-85.5520, 36.6158],
    [-85.5023, 36.6152],
    [-85.4301, 36.6190],
    [-85.3247, 36.6245],
    [-85.2959, 36.6258],
    [-85.2763, 36.6265],
    [-85.1954, 36.6255],
    [-85.0961, 36.6225],
    [-84.9864, 36.6167],
    [-84.9126, 36.6103],
    [-84.8431, 36.6051],
    [-84.7853, 36.6034],
    [-84.6249, 36.5996],
    [-84.5431, 36.5963],
    [-84.4501, 36.5962],
    [-84.4391, 36.5960],
    [-84.4180, 36.5955],
    [-84.2273, 36.5922],
    [-84.2013, 36.5920],
    [-84.1447, 36.5915],
    [-84.1046, 36.5911],
    [-84.0243, 36.5901],
    [-83.9876, 36.5896],
    [-83.8405, 36.5852],
    [-83.6907, 36.5826],
    [-83.6830, 36.5922],
    [-83.6761, 36.5979],
    [-83.6701, 36.6008],
    [-83.6497, 36.6001],
    [-83.6226, 36.5981],
    [-83.5952, 36.5978],
    [-83.4555, 36.5973],
    [-83.3083, 36.5979],
    [-83.2611, 36.5939],
    [-83.2489, 36.5938],
    [-83.2072, 36.5938],
    [-83.0284, 36.5939],
    [-82.9617, 36.5937],
    [-82.8283, 36.5938],
    [-82.6881, 36.5937],
    [-82.6509, 36.5939],
    [-82.6093, 36.5941],
    [-82.5878, 36.5944],
    [-82.5721, 36.5946],
    [-82.5598, 36.5948],
    [-82.5456, 36.5950],
    [-82.4872, 36.5958],
    [-82.4666, 36.5945],
    [-82.2970, 36.5957],
    [-82.2904, 36.5957],
    [-82.2441, 36.5957],
    [-82.2267, 36.5957],
    [-82.2217, 36.5958],
    [-82.2105, 36.5958],
    [-82.1916, 36.5953],
    [-82.1885, 36.5952],
    [-82.1801, 36.5949],
    [-82.1772, 36.5948],
    [-82.1584, 36.5947],
    [-82.1486, 36.5947],
    [-82.1078, 36.5946],
    [-82.0537, 36.5945],
    [-82.0142, 36.5944],
    [-81.9197, 36.6162],
    [-81.7705, 36.6131],
    [-81.6469, 36.6119],
    [-81.6794, 36.5811],
    [-81.6770, 36.5707],
    [-81.6902, 36.5687],
    [-81.6901, 36.5596],
    [-81.6938, 36.5491],
    [-81.7000, 36.5368],
    [-81.7076, 36.5261],
    [-81.7006, 36.5152],
    [-81.6994, 36.5115],
    [-81.6973, 36.5049],
    [-81.7002, 36.5005],
    [-81.6974, 36.4963],
    [-81.6959, 36.4916],
    [-81.6948, 36.4745],
    [-81.6954, 36.4678],
    [-81.6992, 36.4640],
    [-81.7149, 36.4572],
    [-81.7143, 36.4510],
    [-81.7172, 36.4439],
    [-81.7146, 36.4371],
    [-81.7179, 36.4288],
    [-81.7234, 36.4222],
    [-81.7275, 36.4184],
    [-81.7334, 36.4149],
    [-81.7354, 36.4123],
    [-81.7420, 36.4110],
    [-81.7413, 36.4043],
    [-81.7407, 36.4017],
    [-81.7392, 36.3983],
    [-81.7310, 36.3939],
    [-81.7302, 36.3888],
    [-81.7307, 36.3829],
    [-81.7324, 36.3779],
    [-81.7240, 36.3643],
    [-81.7232, 36.3548],
    [-81.7132, 36.3467],
    [-81.7053, 36.3419],
    [-81.7073, 36.3358],
    [-81.7172, 36.3362],
    [-81.7236, 36.3389],
    [-81.7281, 36.3414],
    [-81.7395, 36.3398],
    [-81.7478, 36.3374],
    [-81.7544, 36.3370],
    [-81.7620, 36.3402],
    [-81.7690, 36.3423],
    [-81.7748, 36.3445],
    [-81.7841, 36.3477],
    [-81.7905, 36.3508],
    [-81.7908, 36.3559],
    [-81.7957, 36.3612],
    [-81.8008, 36.3581],
    [-81.8225, 36.3488],
    [-81.8456, 36.3404],
    [-81.8627, 36.3306],
    [-81.8762, 36.3161],
    [-81.8946, 36.3072],
    [-81.9181, 36.2871],
    [-81.9389, 36.2561],
    [-81.9757, 36.2051],
    [-81.9994, 36.1702],
    [-82.0266, 36.1302],
    [-82.0331, 36.1204],
    [-82.0439, 36.1254],
    [-82.0542, 36.1267],
    [-82.0613, 36.1131],
    [-82.0801, 36.1057],
    [-82.0985, 36.1057],
    [-82.1091, 36.1072],
    [-82.1271, 36.1044],
    [-82.1380, 36.1196],
    [-82.1408, 36.1362],
    [-82.1479, 36.1495],
    [-82.1609, 36.1465],
    [-82.1738, 36.1453],
    [-82.1789, 36.1433],
    [-82.1837, 36.1444],
    [-82.1868, 36.1491],
    [-82.1903, 36.1501],
    [-82.1993, 36.1527],
    [-82.2113, 36.1590],
    [-82.2221, 36.1569],
    [-82.2283, 36.1466],
    [-82.2355, 36.1407],
    [-82.2416, 36.1371],
    [-82.2457, 36.1320],
    [-82.2533, 36.1337],
    [-82.2634, 36.1301],
    [-82.2710, 36.1276],
    [-82.2804, 36.1288],
    [-82.2973, 36.1336],
    [-82.3073, 36.1285],
    [-82.3214, 36.1196],
    [-82.3292, 36.1174],
    [-82.3469, 36.1152],
    [-82.3552, 36.1156],
    [-82.3610, 36.1106],
    [-82.3740, 36.1059],
    [-82.3805, 36.0993],
    [-82.4095, 36.0834],
    [-82.4606, 36.0080],
    [-82.4742, 36.0001],
    [-82.4837, 35.9939],
    [-82.4874, 35.9916],
    [-82.5054, 35.9777],
    [-82.5126, 35.9757],
    [-82.5227, 35.9734],
    [-82.5393, 35.9691],
    [-82.5497, 35.9643],
    [-82.5675, 35.9556],
    [-82.5777, 35.9642],
    [-82.5949, 35.9653],
    [-82.6094, 35.9668],
    [-82.6116, 35.9714],
    [-82.6042, 35.9873],
    [-82.6130, 35.9940],
    [-82.6139, 36.0047],
    [-82.6076, 36.0102],
    [-82.6070, 36.0163],
    [-82.6040, 36.0213],
    [-82.5949, 36.0296],
    [-82.5920, 36.0357],
    [-82.6018, 36.0360],
    [-82.6062, 36.0410],
    [-82.6182, 36.0470],
    [-82.6187, 36.0561],
    [-82.6372, 36.0658],
    [-82.6502, 36.0578],
    [-82.6627, 36.0550],
    [-82.6836, 36.0461],
    [-82.6889, 36.0386],
    [-82.7075, 36.0301],
    [-82.7154, 36.0243],
    [-82.7279, 36.0185],
    [-82.7545, 36.0043],
    [-82.7760, 36.0001],
    [-82.7794, 35.9925],
    [-82.7856, 35.9778],
    [-82.7786, 35.9748],
    [-82.7778, 35.9669],
    [-82.7854, 35.9625],
    [-82.7876, 35.9521],
    [-82.8059, 35.9379],
    [-82.8028, 35.9301],
    [-82.8090, 35.9272],
    [-82.8219, 35.9218],
    [-82.8289, 35.9329],
    [-82.8400, 35.9402],
    [-82.8526, 35.9491],
    [-82.8707, 35.9520],
    [-82.8927, 35.9452],
    [-82.8985, 35.9451],
    [-82.8990, 35.9304],
    [-82.9048, 35.9261],
    [-82.9200, 35.9284],
    [-82.9133, 35.9241],
    [-82.9119, 35.9179],
    [-82.9103, 35.9126],
    [-82.9060, 35.9032],
    [-82.9018, 35.8903],
    [-82.9036, 35.8804],
    [-82.8973, 35.8779],
    [-82.9123, 35.8685],
    [-82.9194, 35.8605],
    [-82.9166, 35.8415],
    [-82.9276, 35.8386],
    [-82.9374, 35.8273],
    [-82.9455, 35.8247],
    [-82.9561, 35.8079],
    [-82.9628, 35.7951],
    [-82.9641, 35.7900],
    [-82.9784, 35.7826],
    [-82.9958, 35.7731],
    [-83.0124, 35.7798],
    [-83.0395, 35.7868],
    [-83.0463, 35.7859],
    [-83.0583, 35.7882],
    [-83.0722, 35.7883],
    [-83.0852, 35.7858],
    [-83.0981, 35.7757],
    [-83.1002, 35.7748],
    [-83.1023, 35.7751],
    [-83.1105, 35.7709],
    [-83.1137, 35.7702],
    [-83.1470, 35.7651],
    [-83.1592, 35.7649],
    [-83.1654, 35.7587],
    [-83.1719, 35.7460],
    [-83.1821, 35.7355],
    [-83.1983, 35.7255],
    [-83.2145, 35.7244],
    [-83.2226, 35.7261],
    [-83.2421, 35.7236],
    [-83.2554, 35.7162],
    [-83.2545, 35.7124],
    [-83.2561, 35.7040],
    [-83.2581, 35.6919],
    [-83.2693, 35.6854],
    [-83.2812, 35.6778],
    [-83.2911, 35.6671],
    [-83.3023, 35.6561],
    [-83.3179, 35.6590],
    [-83.3377, 35.6631],
    [-83.3516, 35.6599],
    [-83.3554, 35.6523],
    [-83.3669, 35.6387],
    [-83.3722, 35.6393],
    [-83.3780, 35.6345],
    [-83.3886, 35.6324],
    [-83.4036, 35.6213],
    [-83.4204, 35.6135],
    [-83.4323, 35.6099],
    [-83.4471, 35.6087],
    [-83.4627, 35.5926],
    [-83.4727, 35.5866],
    [-83.4791, 35.5833],
    [-83.4806, 35.5766],
    [-83.4983, 35.5630],
    [-83.5342, 35.5647],
    [-83.5593, 35.5648],
    [-83.5763, 35.5640],
    [-83.5871, 35.5640],
    [-83.6019, 35.5782],
    [-83.6153, 35.5740],
    [-83.6358, 35.5682],
    [-83.6455, 35.5658],
    [-83.6609, 35.5682],
    [-83.6663, 35.5694],
    [-83.6842, 35.5688],
    [-83.7021, 35.5676],
    [-83.7208, 35.5633],
    [-83.7357, 35.5655],
    [-83.7597, 35.5625],
    [-83.7731, 35.5575],
    [-83.8024, 35.5416],
    [-83.8256, 35.5238],
    [-83.8402, 35.5216],
    [-83.8593, 35.5219],
    [-83.8801, 35.5187],
    [-83.8921, 35.5031],
    [-83.9014, 35.4966],
    [-83.9003, 35.4931],
    [-83.9080, 35.4844],
    [-83.9168, 35.4736],
    [-83.9209, 35.4735],
    [-83.9370, 35.4715],
    [-83.9494, 35.4612],
    [-83.9578, 35.4642],
    [-83.9611, 35.4637],
    [-83.9652, 35.4554],
    [-83.9714, 35.4551],
    [-83.9783, 35.4478],
    [-83.9966, 35.4338],
    [-83.9999, 35.4252],
    [-84.0117, 35.4154],
    [-84.0212, 35.4121],
    [-84.0218, 35.4074],
    [-84.0181, 35.3991],
    [-84.0082, 35.3904],
    [-84.0112, 35.3844],
    [-84.0083, 35.3789],
    [-84.0077, 35.3716],
    [-84.0202, 35.3575],
    [-84.0291, 35.3536],
    [-84.0343, 35.3509],
    [-84.0382, 35.3482],
    [-84.0356, 35.3415],
    [-84.0324, 35.3368],
    [-84.0304, 35.3305],
    [-84.0325, 35.3253],
    [-84.0350, 35.3120],
    [-84.0214, 35.3014],
    [-84.0291, 35.2922],
    [-84.0526, 35.2700],
    [-84.0706, 35.2638],
    [-84.0828, 35.2589],
    [-84.0981, 35.2472],
    [-84.1031, 35.2488],
    [-84.1067, 35.2515],
    [-84.1102, 35.2505],
    [-84.1144, 35.2491],
    [-84.1166, 35.2514],
    [-84.1212, 35.2506],
    [-84.1256, 35.2494],
    [-84.1264, 35.2414],
    [-84.1325, 35.2421],
    [-84.1431, 35.2469],
    [-84.1604, 35.2439],
    [-84.1704, 35.2458],
    [-84.1884, 35.2400],
    [-84.2001, 35.2447],
    [-84.2053, 35.2583],
    [-84.2163, 35.2680],
    [-84.2318, 35.2648],
    [-84.2528, 35.2495],
    [-84.2754, 35.2348],
    [-84.2880, 35.2245],
    [-84.2923, 35.2067],
    [-84.2978, 35.1683],
    [-84.3048, 35.1214],
    [-84.3086, 35.0927],
    [-84.3175, 35.0220],
    [-84.3405, 34.9883],
    [-84.3829, 34.9881],
    [-84.3949, 34.9880],
    [-84.5099, 34.9880],
    [-84.6249, 34.9880],
    [-84.7310, 34.9881],
    [-84.7761, 34.9878],
    [-84.8092, 34.9876],
    [-84.8173, 34.9878],
    [-84.8318, 34.9880],
    [-84.8865, 34.9878],
    [-84.9308, 34.9879],
    [-84.9439, 34.9879],
    [-84.9770, 34.9877],
    [-85.0451, 34.9869],
    [-85.0836, 34.9867],
    [-85.1269, 34.9864],
    [-85.1439, 34.9863],
    [-85.1805, 34.9861],
    [-85.1957, 34.9859],
    [-85.2166, 34.9857],
    [-85.2219, 34.9855],
    [-85.2304, 34.9855],
    [-85.2423, 34.9854],
    [-85.2651, 34.9851],
    [-85.2759, 34.9850],
    [-85.2811, 34.9849],
    [-85.2946, 34.9846],
    [-85.3055, 34.9845],
    [-85.3228, 34.9841],
    [-85.3333, 34.9839],
    [-85.3444, 34.9837],
    [-85.3648, 34.9834],
    [-85.3949, 34.9830],
    [-85.4220, 34.9830],
    [-85.4667, 34.9830],
    [-85.5526, 34.9840],
    [-85.6115, 34.9848],
    [-85.7008, 34.9862],
    [-85.7223, 34.9865],
    [-85.7454, 34.9869],
    [-85.7961, 34.9877],
    [-85.8287, 34.9882],
    [-86.0616, 34.9896],
    [-86.1529, 34.9901],
    [-86.3188, 34.9911],
    [-86.4286, 34.9912],
    [-86.4733, 34.9907],
    [-86.5285, 34.9907],
    [-86.5712, 34.9910],
    [-86.6000, 34.9912],
    [-86.6596, 34.9918],
    [-86.6767, 34.9921],
    [-86.7217, 34.9920],
    [-86.7836, 34.9919],
    [-86.8363, 34.9918],
    [-86.8498, 34.9919],
    [-86.8616, 34.9920],
    [-86.8792, 34.9924],
    [-86.9702, 34.9945],
    [-86.9887, 34.9949],
    [-87.0301, 34.9955],
    [-87.1205, 34.9973],
    [-87.1396, 34.9976],
    [-87.2152, 34.9991],
    [-87.2241, 34.9993],
    [-87.2992, 35.0009],
    [-87.3493, 35.0017],
    [-87.3811, 35.0021],
    [-87.4174, 35.0027],
    [-87.4370, 35.0028],
    [-87.4929, 35.0031],
    [-87.5224, 35.0032],
    [-87.6193, 35.0037],
    [-87.6714, 35.0035],
    [-87.7005, 35.0040],
    [-87.7095, 35.0041],
    [-87.7676, 35.0048],
    [-87.8212, 35.0054],
    [-87.8535, 35.0055],
    [-87.8780, 35.0055],
    [-87.9849, 35.0059],
    [-88.2020, 35.0054],
    [-88.2003, 34.9956],
    [-88.2538, 34.9956],
    [-88.3805, 34.9956],
    [-88.4699, 34.9960],
    [-88.5048, 34.9959],
    [-88.5142, 34.9959],
    [-88.5317, 34.9959],
    [-88.6059, 34.9957],
    [-88.7866, 34.9953],
    [-88.8582, 34.9952],
    [-88.9252, 34.9948],
    [-89.0171, 34.9949],
    [-89.1391, 34.9943],
    [-89.1983, 34.9945],
    [-89.3527, 34.9941],
    [-89.4350, 34.9938],
    [-89.4869, 34.9940],
    [-89.5112, 34.9948],
    [-89.5718, 34.9950],
    [-89.5910, 34.9951],
    [-89.6443, 34.9953],
    [-89.7418, 34.9952],
    [-89.7596, 34.9949],
    [-89.8131, 34.9943],
    [-89.8378, 34.9942],
    [-89.8618, 34.9942],
    [-89.8837, 34.9943],
    [-89.9015, 34.9944],
    [-89.9368, 34.9945],
    [-89.9899, 34.9947],
    [-90.0025, 34.9947],
    [-90.0250, 34.9948],
    [-90.0430, 34.9948],
    [-90.1269, 34.9951],
    [-90.3026, 34.9957],
    [-90.3103, 35.0043]
    ]
  },
  "Wyoming": {
    coordinates: [
      [-111.0546, 45.0010],
    [-110.7901, 45.0009],
    [-110.5770, 44.9925],
    [-110.4071, 44.9995],
    [-110.2279, 44.9968],
    [-110.1058, 45.0035],
    [-110.0015, 45.0034],
    [-109.8730, 45.0033],
    [-109.7985, 45.0023],
    [-109.6907, 45.0023],
    [-109.3618, 45.0050],
    [-109.1928, 45.0057],
    [-109.0629, 44.9995],
    [-108.9650, 44.9997],
    [-108.9029, 44.9999],
    [-108.6831, 45.0002],
    [-108.5150, 44.9997],
    [-108.2494, 44.9999],
    [-108.0051, 45.0005],
    [-107.8842, 45.0007],
    [-107.7507, 45.0008],
    [-107.6000, 45.0008],
    [-107.3682, 45.0009],
    [-107.1274, 44.9998],
    [-107.0849, 44.9966],
    [-107.0052, 44.9963],
    [-106.9876, 44.9962],
    [-106.5709, 44.9949],
    [-106.2636, 44.9938],
    [-105.9282, 44.9935],
    [-105.7754, 45.0003],
    [-105.3713, 45.0002],
    [-105.0999, 45.0001],
    [-105.0382, 45.0001],
    [-104.7675, 44.9995],
    [-104.6313, 44.9988],
    [-104.2630, 44.9981],
    [-104.0566, 44.9339],
    [-104.0559, 44.7757],
    [-104.0560, 44.6860],
    [-104.0558, 44.5710],
    [-104.0557, 44.4143],
    [-104.0555, 44.3160],
    [-104.0547, 44.1411],
    [-104.0550, 43.9377],
    [-104.0553, 43.7617],
    [-104.0549, 43.5841],
    [-104.0548, 43.4955],
    [-104.0546, 43.3911],
    [-104.0539, 43.2388],
    [-104.0532, 43.0306],
    [-104.0528, 42.7500],
    [-104.0526, 42.6309],
    [-104.0528, 42.6108],
    [-104.0528, 42.2582],
    [-104.0528, 42.1703],
    [-104.0527, 42.1338],
    [-104.0529, 42.0957],
    [-104.0530, 42.0751],
    [-104.0527, 42.0163],
    [-104.0527, 41.9987],
    [-104.0528, 41.9939],
    [-104.0529, 41.9760],
    [-104.0529, 41.9061],
    [-104.0529, 41.8093],
    [-104.0529, 41.6452],
    [-104.0527, 41.6137],
    [-104.0525, 41.5527],
    [-104.0527, 41.5391],
    [-104.0523, 41.4179],
    [-104.0523, 41.3932],
    [-104.0525, 41.3210],
    [-104.0526, 41.2780],
    [-104.0532, 41.1956],
    [-104.0531, 41.1145],
    [-104.0532, 41.0897],
    [-104.0532, 41.0014],
    [-104.1046, 41.0015],
    [-104.2142, 41.0016],
    [-104.4677, 41.0015],
    [-104.5995, 41.0013],
    [-104.7730, 40.9999],
    [-104.9434, 40.9981],
    [-105.2769, 40.9982],
    [-105.7248, 40.9969],
    [-106.0612, 40.9970],
    [-106.3212, 40.9991],
    [-106.4309, 41.0018],
    [-106.4539, 41.0021],
    [-107.1161, 41.0031],
    [-107.3178, 41.0030],
    [-107.6914, 41.0021],
    [-108.1812, 41.0005],
    [-108.4887, 41.0001],
    [-108.6311, 41.0002],
    [-109.1737, 41.0009],
    [-109.5007, 40.9991],
    [-109.5651, 40.9982],
    [-109.6766, 40.9984],
    [-109.7154, 40.9982],
    [-109.8543, 40.9977],
    [-109.9998, 40.9973],
    [-110.0485, 40.9976],
    [-110.2378, 40.9954],
    [-110.3757, 40.9949],
    [-110.5457, 40.9963],
    [-110.7298, 40.9966],
    [-110.8721, 40.9973],
    [-111.0466, 41.1560],
    [-111.0466, 41.2516],
    [-111.0466, 41.3607],
    [-111.0458, 41.5656],
    [-111.0462, 41.7797],
    [-111.0471, 42.1490],
    [-111.0471, 42.2808],
    [-111.0470, 42.4009],
    [-111.0460, 42.5827],
    [-111.0436, 42.7226],
    [-111.0440, 42.9535],
    [-111.0440, 42.9695],
    [-111.0441, 43.0022],
    [-111.0442, 43.0226],
    [-111.0440, 43.0264],
    [-111.0441, 43.0446],
    [-111.0441, 43.0603],
    [-111.0441, 43.0724],
    [-111.0442, 43.1771],
    [-111.0442, 43.1892],
    [-111.0446, 43.3157],
    [-111.0455, 43.5831],
    [-111.0459, 43.6810],
    [-111.0461, 43.6878],
    [-111.0464, 43.7265],
    [-111.0467, 43.8083],
    [-111.0469, 43.9750],
    [-111.0491, 44.0201],
    [-111.0486, 44.0629],
    [-111.0491, 44.1324],
    [-111.0492, 44.4358],
    [-111.0524, 44.4784],
    [-111.0540, 44.7262],
    [-111.0544, 44.8604],
    [-111.0546, 45.0010]
    ]
  },
  "New York": {
    coordinates: [
      [-79.7622, 42.2431],
    [-79.7620, 42.2699],
    [-79.7373, 42.2772],
    [-79.7115, 42.2872],
    [-79.6781, 42.3007],
    [-79.6447, 42.3159],
    [-79.6160, 42.3305],
    [-79.6071, 42.3377],
    [-79.6004, 42.3407],
    [-79.5946, 42.3426],
    [-79.5698, 42.3512],
    [-79.5524, 42.3622],
    [-79.5383, 42.3691],
    [-79.5118, 42.3819],
    [-79.4902, 42.3949],
    [-79.4748, 42.4043],
    [-79.4535, 42.4112],
    [-79.4316, 42.4267],
    [-79.4230, 42.4372],
    [-79.4200, 42.4476],
    [-79.4153, 42.4535],
    [-79.4087, 42.4517],
    [-79.4000, 42.4571],
    [-79.3826, 42.4662],
    [-79.3621, 42.4802],
    [-79.3567, 42.4915],
    [-79.3517, 42.4920],
    [-79.3427, 42.4911],
    [-79.3363, 42.4902],
    [-79.3291, 42.4900],
    [-79.3231, 42.4948],
    [-79.3179, 42.5023],
    [-79.3083, 42.5039],
    [-79.2945, 42.5096],
    [-79.2834, 42.5112],
    [-79.2753, 42.5145],
    [-79.2617, 42.5243],
    [-79.2497, 42.5317],
    [-79.2441, 42.5333],
    [-79.2364, 42.5323],
    [-79.2299, 42.5378],
    [-79.2231, 42.5359],
    [-79.1994, 42.5450],
    [-79.1871, 42.5463],
    [-79.1782, 42.5516],
    [-79.1761, 42.5489],
    [-79.1652, 42.5515],
    [-79.1535, 42.5517],
    [-79.1419, 42.5609],
    [-79.1386, 42.5645],
    [-79.1319, 42.5856],
    [-79.1305, 42.5902],
    [-79.1219, 42.5942],
    [-79.1147, 42.6037],
    [-79.1114, 42.6134],
    [-79.0982, 42.6220],
    [-79.0849, 42.6317],
    [-79.0765, 42.6405],
    [-79.0638, 42.6448],
    [-79.0632, 42.6595],
    [-79.0623, 42.6684],
    [-79.0541, 42.6757],
    [-79.0520, 42.6830],
    [-79.0429, 42.6914],
    [-79.0216, 42.6982],
    [-79.0062, 42.7046],
    [-78.9778, 42.7118],
    [-78.9677, 42.7205],
    [-78.9614, 42.7223],
    [-78.9450, 42.7314],
    [-78.9311, 42.7338],
    [-78.9182, 42.7373],
    [-78.9140, 42.7400],
    [-78.9034, 42.7473],
    [-78.8981, 42.7506],
    [-78.8839, 42.7600],
    [-78.8776, 42.7656],
    [-78.8686, 42.7703],
    [-78.8597, 42.7796],
    [-78.8536, 42.7931],
    [-78.8594, 42.8007],
    [-78.8718, 42.8227],
    [-78.8704, 42.8304],
    [-78.8692, 42.8337],
    [-78.8604, 42.8351],
    [-78.8656, 42.8524],
    [-78.8901, 42.8767],
    [-78.8917, 42.8848],
    [-78.9059, 42.9069],
    [-78.9057, 42.9234],
    [-78.9142, 42.9404],
    [-78.9618, 42.9578],
    [-79.0116, 42.9853],
    [-79.0118, 43.0290],
    [-79.0071, 43.0658],
    [-79.0456, 43.0727],
    [-79.0672, 43.0900],
    [-79.0580, 43.1070],
    [-79.0620, 43.1154],
    [-79.0568, 43.1269],
    [-79.0441, 43.1381],
    [-79.0445, 43.1531],
    [-79.0484, 43.1645],
    [-79.0531, 43.1737],
    [-79.0503, 43.1928],
    [-79.0542, 43.2184],
    [-79.0559, 43.2386],
    [-79.0705, 43.2625],
    [-79.0210, 43.2734],
    [-78.9986, 43.2770],
    [-78.9586, 43.2846],
    [-78.9080, 43.2989],
    [-78.8833, 43.3043],
    [-78.8363, 43.3185],
    [-78.8204, 43.3199],
    [-78.8062, 43.3234],
    [-78.7472, 43.3346],
    [-78.7247, 43.3393],
    [-78.6969, 43.3413],
    [-78.6867, 43.3434],
    [-78.6436, 43.3558],
    [-78.5991, 43.3614],
    [-78.5362, 43.3707],
    [-78.5069, 43.3723],
    [-78.4859, 43.3749],
    [-78.4731, 43.3708],
    [-78.4519, 43.3727],
    [-78.4290, 43.3731],
    [-78.3888, 43.3755],
    [-78.3648, 43.3741],
    [-78.3428, 43.3735],
    [-78.3111, 43.3737],
    [-78.3024, 43.3715],
    [-78.2821, 43.3719],
    [-78.2676, 43.3726],
    [-78.2523, 43.3716],
    [-78.2432, 43.3692],
    [-78.2222, 43.3699],
    [-78.2056, 43.3715],
    [-78.1894, 43.3716],
    [-78.1748, 43.3716],
    [-78.1590, 43.3748],
    [-78.1197, 43.3756],
    [-78.0942, 43.3745],
    [-78.0746, 43.3723],
    [-78.0581, 43.3700],
    [-78.0236, 43.3666],
    [-78.0048, 43.3682],
    [-77.9948, 43.3653],
    [-77.9697, 43.3672],
    [-77.9332, 43.3596],
    [-77.9217, 43.3570],
    [-77.8966, 43.3537],
    [-77.8753, 43.3497],
    [-77.8323, 43.3450],
    [-77.8089, 43.3421],
    [-77.7778, 43.3396],
    [-77.7602, 43.3412],
    [-77.7306, 43.3302],
    [-77.7124, 43.3215],
    [-77.7014, 43.3083],
    [-77.6823, 43.2979],
    [-77.6538, 43.2795],
    [-77.6222, 43.2679],
    [-77.5965, 43.2539],
    [-77.5772, 43.2433],
    [-77.5503, 43.2357],
    [-77.5340, 43.2359],
    [-77.5164, 43.2408],
    [-77.5073, 43.2477],
    [-77.4766, 43.2545],
    [-77.4543, 43.2611],
    [-77.4420, 43.2629],
    [-77.4324, 43.2683],
    [-77.4065, 43.2708],
    [-77.3884, 43.2755],
    [-77.3690, 43.2771],
    [-77.3551, 43.2781],
    [-77.3377, 43.2798],
    [-77.3221, 43.2806],
    [-77.3135, 43.2810],
    [-77.3040, 43.2781],
    [-77.2866, 43.2786],
    [-77.2628, 43.2775],
    [-77.2501, 43.2793],
    [-77.2141, 43.2841],
    [-77.1967, 43.2826],
    [-77.1907, 43.2852],
    [-77.1834, 43.2819],
    [-77.1731, 43.2815],
    [-77.1560, 43.2861],
    [-77.1434, 43.2876],
    [-77.1304, 43.2856],
    [-77.1142, 43.2866],
    [-77.1048, 43.2890],
    [-77.0952, 43.2849],
    [-77.0755, 43.2814],
    [-77.0643, 43.2795],
    [-77.0487, 43.2771],
    [-77.0422, 43.2708],
    [-77.0087, 43.2714],
    [-76.9884, 43.2745],
    [-76.9760, 43.2742],
    [-76.9676, 43.2726],
    [-76.9584, 43.2700],
    [-76.9395, 43.2763],
    [-76.9205, 43.2848],
    [-76.8962, 43.2960],
    [-76.8774, 43.2929],
    [-76.8574, 43.2976],
    [-76.8417, 43.3054],
    [-76.8311, 43.3060],
    [-76.8091, 43.3083],
    [-76.7879, 43.3113],
    [-76.7690, 43.3185],
    [-76.7558, 43.3254],
    [-76.7373, 43.3377],
    [-76.7310, 43.3434],
    [-76.7215, 43.3437],
    [-76.7124, 43.3457],
    [-76.7088, 43.3462],
    [-76.6984, 43.3444],
    [-76.6849, 43.3527],
    [-76.6696, 43.3665],
    [-76.6557, 43.3845],
    [-76.6386, 43.4054],
    [-76.6316, 43.4126],
    [-76.6220, 43.4137],
    [-76.6071, 43.4234],
    [-76.5950, 43.4303],
    [-76.5840, 43.4360],
    [-76.5671, 43.4447],
    [-76.5573, 43.4500],
    [-76.5496, 43.4520],
    [-76.5430, 43.4562],
    [-76.5318, 43.4603],
    [-76.5196, 43.4643],
    [-76.5135, 43.4661],
    [-76.5069, 43.4691],
    [-76.4917, 43.4749],
    [-76.4771, 43.4857],
    [-76.4501, 43.5039],
    [-76.4375, 43.5092],
    [-76.4222, 43.5160],
    [-76.4014, 43.5240],
    [-76.3831, 43.5236],
    [-76.3636, 43.5244],
    [-76.3455, 43.5134],
    [-76.3309, 43.5120],
    [-76.3097, 43.5150],
    [-76.2971, 43.5129],
    [-76.2781, 43.5207],
    [-76.2702, 43.5207],
    [-76.2465, 43.5271],
    [-76.2287, 43.5330],
    [-76.2180, 43.5452],
    [-76.1991, 43.6005],
    [-76.1966, 43.6498],
    [-76.2012, 43.6886],
    [-76.2050, 43.7166],
    [-76.2132, 43.7535],
    [-76.2293, 43.8041],
    [-76.2374, 43.8146],
    [-76.2340, 43.8199],
    [-76.2485, 43.8175],
    [-76.2502, 43.8255],
    [-76.2664, 43.8259],
    [-76.2671, 43.8338],
    [-76.2716, 43.8374],
    [-76.2837, 43.8389],
    [-76.2948, 43.8493],
    [-76.2974, 43.8559],
    [-76.2776, 43.8739],
    [-76.2649, 43.8799],
    [-76.2283, 43.8866],
    [-76.2214, 43.8908],
    [-76.2138, 43.9002],
    [-76.2169, 43.8903],
    [-76.2275, 43.8751],
    [-76.2259, 43.8656],
    [-76.2145, 43.8590],
    [-76.2071, 43.8540],
    [-76.2040, 43.8529],
    [-76.1996, 43.8571],
    [-76.1928, 43.8692],
    [-76.1691, 43.8814],
    [-76.1532, 43.8905],
    [-76.1328, 43.8934],
    [-76.1265, 43.9051],
    [-76.1282, 43.9168],
    [-76.1304, 43.9331],
    [-76.1367, 43.9346],
    [-76.1391, 43.9408],
    [-76.1249, 43.9503],
    [-76.1190, 43.9492],
    [-76.1117, 43.9541],
    [-76.1086, 43.9565],
    [-76.0830, 43.9770],
    [-76.0728, 43.9702],
    [-76.0612, 43.9773],
    [-76.0625, 43.9880],
    [-76.0722, 43.9905],
    [-76.0840, 43.9953],
    [-76.1242, 43.9698],
    [-76.1460, 43.9654],
    [-76.1612, 43.9603],
    [-76.1698, 43.9622],
    [-76.1746, 43.9652],
    [-76.1745, 43.9740],
    [-76.1849, 43.9711],
    [-76.2005, 43.9682],
    [-76.2009, 43.9743],
    [-76.2076, 43.9830],
    [-76.1800, 44.0006],
    [-76.1486, 44.0080],
    [-76.1212, 44.0342],
    [-76.1222, 44.0379],
    [-76.1403, 44.0384],
    [-76.1683, 44.0327],
    [-76.1469, 44.0546],
    [-76.1502, 44.0592],
    [-76.1551, 44.0644],
    [-76.1707, 44.0647],
    [-76.1845, 44.0587],
    [-76.2043, 44.0543],
    [-76.2140, 44.0594],
    [-76.2000, 44.0768],
    [-76.2019, 44.0788],
    [-76.2163, 44.0687],
    [-76.2264, 44.0649],
    [-76.2445, 44.0615],
    [-76.2475, 44.0640],
    [-76.2635, 44.0524],
    [-76.2727, 44.0408],
    [-76.2797, 44.0234],
    [-76.2811, 44.0180],
    [-76.2745, 44.0165],
    [-76.2532, 44.0227],
    [-76.2301, 44.0294],
    [-76.2042, 44.0299],
    [-76.2001, 44.0281],
    [-76.2040, 44.0194],
    [-76.2211, 43.9939],
    [-76.2546, 43.9662],
    [-76.2720, 43.9608],
    [-76.2841, 43.9669],
    [-76.2687, 43.9873],
    [-76.2742, 44.0020],
    [-76.2878, 44.0114],
    [-76.3025, 44.0136],
    [-76.3077, 44.0253],
    [-76.3005, 44.0338],
    [-76.2960, 44.0427],
    [-76.2951, 44.0476],
    [-76.2964, 44.0547],
    [-76.2997, 44.0592],
    [-76.3076, 44.0582],
    [-76.3350, 44.0691],
    [-76.3321, 44.0727],
    [-76.3603, 44.0709],
    [-76.3450, 44.0862],
    [-76.3497, 44.0925],
    [-76.3610, 44.0944],
    [-76.3670, 44.0994],
    [-76.3638, 44.1117],
    [-76.3478, 44.1248],
    [-76.3126, 44.1990],
    [-76.2455, 44.2037],
    [-76.1913, 44.2212],
    [-76.1309, 44.2966],
    [-76.1119, 44.2980],
    [-76.0452, 44.3317],
    [-75.9833, 44.3474],
    [-75.9802, 44.3471],
    [-75.9748, 44.3462],
    [-75.9702, 44.3428],
    [-75.9295, 44.3596],
    [-75.8715, 44.3948],
    [-75.8114, 44.4606],
    [-75.7382, 44.5351],
    [-75.6624, 44.5919],
    [-75.6103, 44.6258],
    [-75.5209, 44.6937],
    [-75.5001, 44.7082],
    [-75.4579, 44.7335],
    [-75.4138, 44.7725],
    [-75.3700, 44.7829],
    [-75.3337, 44.8064],
    [-75.3076, 44.8368],
    [-75.2555, 44.8577],
    [-75.2286, 44.8679],
    [-75.1941, 44.8826],
    [-75.1399, 44.8967],
    [-75.1176, 44.9213],
    [-75.0648, 44.9294],
    [-75.0154, 44.9529],
    [-74.9993, 44.9716],
    [-74.9467, 44.9847],
    [-74.9007, 44.9928],
    [-74.8666, 45.0005],
    [-74.8462, 45.0103],
    [-74.8266, 45.0159],
    [-74.8016, 45.0146],
    [-74.7634, 45.0056],
    [-74.7446, 44.9906],
    [-74.7226, 44.9981],
    [-74.6784, 45.0000],
    [-74.6615, 44.9996],
    [-74.5490, 44.9987],
    [-74.4248, 44.9957],
    [-74.3352, 44.9919],
    [-74.2023, 44.9919],
    [-74.0274, 44.9958],
    [-73.8153, 45.0023],
    [-73.6755, 45.0029],
    [-73.5602, 45.0057],
    [-73.4374, 45.0092],
    [-73.3431, 45.0108],
    [-73.3534, 44.9903],
    [-73.3541, 44.9841],
    [-73.3502, 44.9762],
    [-73.3382, 44.9647],
    [-73.3385, 44.9241],
    [-73.3411, 44.9146],
    [-73.3537, 44.9073],
    [-73.3603, 44.8972],
    [-73.3665, 44.8750],
    [-73.3757, 44.8607],
    [-73.3814, 44.8450],
    [-73.3753, 44.8363],
    [-73.3681, 44.8281],
    [-73.3549, 44.8215],
    [-73.3411, 44.8091],
    [-73.3339, 44.7992],
    [-73.3357, 44.7821],
    [-73.3487, 44.7682],
    [-73.3544, 44.7553],
    [-73.3656, 44.7418],
    [-73.3658, 44.6988],
    [-73.3613, 44.6954],
    [-73.3701, 44.6849],
    [-73.3672, 44.6785],
    [-73.3718, 44.6770],
    [-73.3718, 44.6751],
    [-73.3701, 44.6661],
    [-73.3731, 44.6627],
    [-73.3772, 44.6581],
    [-73.3780, 44.6538],
    [-73.3840, 44.6476],
    [-73.3786, 44.6415],
    [-73.3872, 44.6355],
    [-73.3865, 44.6269],
    [-73.3902, 44.6184],
    [-73.3807, 44.6052],
    [-73.3768, 44.5955],
    [-73.3818, 44.5893],
    [-73.3744, 44.5755],
    [-73.3615, 44.5635],
    [-73.3568, 44.5579],
    [-73.3429, 44.5519],
    [-73.3393, 44.5445],
    [-73.3309, 44.5343],
    [-73.3285, 44.5285],
    [-73.3212, 44.5203],
    [-73.3208, 44.5136],
    [-73.3067, 44.5003],
    [-73.2999, 44.4767],
    [-73.2987, 44.4640],
    [-73.2936, 44.4406],
    [-73.2960, 44.4283],
    [-73.3150, 44.3885],
    [-73.3304, 44.3760],
    [-73.3346, 44.3569],
    [-73.3251, 44.3385],
    [-73.3238, 44.3253],
    [-73.3223, 44.3015],
    [-73.3110, 44.2742],
    [-73.3166, 44.2578],
    [-73.3236, 44.2439],
    [-73.3305, 44.2443],
    [-73.3432, 44.2380],
    [-73.3499, 44.2304],
    [-73.3553, 44.2229],
    [-73.3615, 44.2104],
    [-73.3724, 44.2022],
    [-73.3823, 44.1972],
    [-73.3885, 44.1923],
    [-73.3904, 44.1862],
    [-73.3959, 44.1758],
    [-73.3967, 44.1688],
    [-73.3987, 44.1622],
    [-73.4024, 44.1459],
    [-73.4117, 44.1378],
    [-73.4138, 44.1261],
    [-73.4118, 44.1115],
    [-73.4206, 44.0929],
    [-73.4320, 44.0634],
    [-73.4308, 44.0387],
    [-73.4231, 44.0328],
    [-73.4108, 44.0269],
    [-73.4060, 44.0162],
    [-73.4126, 43.9827],
    [-73.4068, 43.9673],
    [-73.4077, 43.9299],
    [-73.3973, 43.9057],
    [-73.3763, 43.8803],
    [-73.3793, 43.8646],
    [-73.3819, 43.8546],
    [-73.3725, 43.8463],
    [-73.3737, 43.8426],
    [-73.3884, 43.8324],
    [-73.3925, 43.8208],
    [-73.3808, 43.8110],
    [-73.3783, 43.8060],
    [-73.3682, 43.7933],
    [-73.3555, 43.7785],
    [-73.3507, 43.7705],
    [-73.3697, 43.7443],
    [-73.3699, 43.7288],
    [-73.3830, 43.7141],
    [-73.3936, 43.6995],
    [-73.3983, 43.6946],
    [-73.4052, 43.6884],
    [-73.4074, 43.6734],
    [-73.4145, 43.6582],
    [-73.4235, 43.6457],
    [-73.4286, 43.6365],
    [-73.4177, 43.6217],
    [-73.4238, 43.6110],
    [-73.4250, 43.5988],
    [-73.4309, 43.5870],
    [-73.4267, 43.5830],
    [-73.4056, 43.5712],
    [-73.3958, 43.5681],
    [-73.3918, 43.5701],
    [-73.3914, 43.5736],
    [-73.3861, 43.5748],
    [-73.3825, 43.5792],
    [-73.3834, 43.5847],
    [-73.3843, 43.5873],
    [-73.3863, 43.5913],
    [-73.3817, 43.5930],
    [-73.3835, 43.5974],
    [-73.3803, 43.5979],
    [-73.3774, 43.6004],
    [-73.3724, 43.6060],
    [-73.3699, 43.6191],
    [-73.3719, 43.6245],
    [-73.3656, 43.6234],
    [-73.3476, 43.6225],
    [-73.3277, 43.6259],
    [-73.3128, 43.6246],
    [-73.3062, 43.6280],
    [-73.3021, 43.6244],
    [-73.2980, 43.6100],
    [-73.2922, 43.5982],
    [-73.2932, 43.5926],
    [-73.2921, 43.5845],
    [-73.2946, 43.5790],
    [-73.2849, 43.5793],
    [-73.2797, 43.5742],
    [-73.2586, 43.5649],
    [-73.2484, 43.5526],
    [-73.2478, 43.5428],
    [-73.2420, 43.5349],
    [-73.2419, 43.5294],
    [-73.2477, 43.5232],
    [-73.2471, 43.5149],
    [-73.2478, 43.4919],
    [-73.2498, 43.4380],
    [-73.2511, 43.4062],
    [-73.2527, 43.3703],
    [-73.2531, 43.3530],
    [-73.2558, 43.2791],
    [-73.2587, 43.2299],
    [-73.2618, 43.1696],
    [-73.2656, 43.0962],
    [-73.2700, 43.0307],
    [-73.2743, 42.9437],
    [-73.2746, 42.9344],
    [-73.2785, 42.8375],
    [-73.2854, 42.8341],
    [-73.2852, 42.8105],
    [-73.2909, 42.8019],
    [-73.2731, 42.7240],
    [-73.3125, 42.6177],
    [-73.3525, 42.5100],
    [-73.3887, 42.4115],
    [-73.4106, 42.3517],
    [-73.4311, 42.2961],
    [-73.4599, 42.2175],
    [-73.4972, 42.1161],
    [-73.4969, 42.0497],
    [-73.4896, 42.0001],
    [-73.4965, 41.9224],
    [-73.4995, 41.8819],
    [-73.5020, 41.8587],
    [-73.5050, 41.8238],
    [-73.5110, 41.7577],
    [-73.5119, 41.7409],
    [-73.5168, 41.6876],
    [-73.5200, 41.6412],
    [-73.5257, 41.5717],
    [-73.5306, 41.5203],
    [-73.5324, 41.4986],
    [-73.5341, 41.4789],
    [-73.5343, 41.4764],
    [-73.5353, 41.4635],
    [-73.5359, 41.4552],
    [-73.5361, 41.4513],
    [-73.5373, 41.4379],
    [-73.5412, 41.4060],
    [-73.5424, 41.3894],
    [-73.5436, 41.3751],
    [-73.5452, 41.3615],
    [-73.5496, 41.3159],
    [-73.5499, 41.3015],
    [-73.5405, 41.2830],
    [-73.5174, 41.2555],
    [-73.4849, 41.2118],
    [-73.5092, 41.2009],
    [-73.5128, 41.1993],
    [-73.5547, 41.1799],
    [-73.5862, 41.1656],
    [-73.6144, 41.1529],
    [-73.6340, 41.1441],
    [-73.6684, 41.1282],
    [-73.7278, 41.1007],
    [-73.7062, 41.0742],
    [-73.6872, 41.0507],
    [-73.6758, 41.0366],
    [-73.6667, 41.0255],
    [-73.6604, 41.0184],
    [-73.6557, 41.0127],
    [-73.6552, 41.0119],
    [-73.6579, 41.0052],
    [-73.6603, 41.0005],
    [-73.6596, 40.9943],
    [-73.6576, 40.9855],
    [-73.6560, 40.9796],
    [-73.6598, 40.9697],
    [-73.6645, 40.9672],
    [-73.6729, 40.9645],
    [-73.6833, 40.9490],
    [-73.6954, 40.9400],
    [-73.6953, 40.9517],
    [-73.7011, 40.9464],
    [-73.7087, 40.9444],
    [-73.7206, 40.9410],
    [-73.7272, 40.9274],
    [-73.7375, 40.9281],
    [-73.7431, 40.9255],
    [-73.7439, 40.9221],
    [-73.7476, 40.9163],
    [-73.7617, 40.9064],
    [-73.7780, 40.8881],
    [-73.7848, 40.8785],
    [-73.7860, 40.8695],
    [-73.7917, 40.8619],
    [-73.7881, 40.8541],
    [-73.7848, 40.8518],
    [-73.7822, 40.8474],
    [-73.7822, 40.8427],
    [-73.7826, 40.8376],
    [-73.7854, 40.8380],
    [-73.7910, 40.8466],
    [-73.7919, 40.8552],
    [-73.7938, 40.8556],
    [-73.7995, 40.8480],
    [-73.8017, 40.8485],
    [-73.8048, 40.8585],
    [-73.8077, 40.8588],
    [-73.8126, 40.8587],
    [-73.8166, 40.8535],
    [-73.8150, 40.8489],
    [-73.8135, 40.8438],
    [-73.8156, 40.8351],
    [-73.8131, 40.8275],
    [-73.8081, 40.8263],
    [-73.8045, 40.8185],
    [-73.7977, 40.8159],
    [-73.8026, 40.8123],
    [-73.7972, 40.8091],
    [-73.7909, 40.8072],
    [-73.7814, 40.7949],
    [-73.7703, 40.7884],
    [-73.7741, 40.7860],
    [-73.7674, 40.7796],
    [-73.7655, 40.7745],
    [-73.7616, 40.7713],
    [-73.7584, 40.7696],
    [-73.7537, 40.7734],
    [-73.7555, 40.7776],
    [-73.7543, 40.7800],
    [-73.7513, 40.7826],
    [-73.7537, 40.7901],
    [-73.7534, 40.7995],
    [-73.7646, 40.8085],
    [-73.7540, 40.8209],
    [-73.7572, 40.8339],
    [-73.7506, 40.8359],
    [-73.7389, 40.8283],
    [-73.7294, 40.8238],
    [-73.7171, 40.8157],
    [-73.7119, 40.8106],
    [-73.7074, 40.8145],
    [-73.7056, 40.8226],
    [-73.7090, 40.8330],
    [-73.7230, 40.8353],
    [-73.7285, 40.8330],
    [-73.7304, 40.8423],
    [-73.7308, 40.8528],
    [-73.7307, 40.8654],
    [-73.7195, 40.8668],
    [-73.6750, 40.8531],
    [-73.6674, 40.8435],
    [-73.6544, 40.8289],
    [-73.6486, 40.8288],
    [-73.6524, 40.8349],
    [-73.6538, 40.8471],
    [-73.6493, 40.8529],
    [-73.6515, 40.8557],
    [-73.6559, 40.8639],
    [-73.6480, 40.8836],
    [-73.6398, 40.8966],
    [-73.6331, 40.9027],
    [-73.6176, 40.8979],
    [-73.6096, 40.9030],
    [-73.6019, 40.9028],
    [-73.5955, 40.9079],
    [-73.5823, 40.9096],
    [-73.5662, 40.9158],
    [-73.5488, 40.9089],
    [-73.5388, 40.9121],
    [-73.5275, 40.9166],
    [-73.5155, 40.9130],
    [-73.5110, 40.9090],
    [-73.5084, 40.9015],
    [-73.5193, 40.8967],
    [-73.5203, 40.8867],
    [-73.5331, 40.8853],
    [-73.5236, 40.8979],
    [-73.5236, 40.9096],
    [-73.5287, 40.9105],
    [-73.5340, 40.9074],
    [-73.5403, 40.9043],
    [-73.5478, 40.9036],
    [-73.5490, 40.8948],
    [-73.5454, 40.8828],
    [-73.5419, 40.8769],
    [-73.5219, 40.8740],
    [-73.5107, 40.8756],
    [-73.5055, 40.8756],
    [-73.5072, 40.8794],
    [-73.5088, 40.8937],
    [-73.4915, 40.8906],
    [-73.4895, 40.8797],
    [-73.4834, 40.8742],
    [-73.4652, 40.8680],
    [-73.4708, 40.8751],
    [-73.4730, 40.8813],
    [-73.4753, 40.8975],
    [-73.4886, 40.9160],
    [-73.4976, 40.9228],
    [-73.4936, 40.9382],
    [-73.4784, 40.9423],
    [-73.4606, 40.9374],
    [-73.4450, 40.9358],
    [-73.4306, 40.9298],
    [-73.4288, 40.9215],
    [-73.4340, 40.9090],
    [-73.4162, 40.9043],
    [-73.4026, 40.9058],
    [-73.3888, 40.9058],
    [-73.3810, 40.9027],
    [-73.3772, 40.9108],
    [-73.3747, 40.9135],
    [-73.3672, 40.9070],
    [-73.3584, 40.9114],
    [-73.3536, 40.9164],
    [-73.3532, 40.9239],
    [-73.3762, 40.9291],
    [-73.3883, 40.9257],
    [-73.3924, 40.9243],
    [-73.4014, 40.9237],
    [-73.4047, 40.9162],
    [-73.4074, 40.9162],
    [-73.4030, 40.9251],
    [-73.4026, 40.9459],
    [-73.3954, 40.9553],
    [-73.3745, 40.9376],
    [-73.3486, 40.9259],
    [-73.3314, 40.9296],
    [-73.3122, 40.9269],
    [-73.2901, 40.9227],
    [-73.2572, 40.9128],
    [-73.2371, 40.9091],
    [-73.1738, 40.9211],
    [-73.1489, 40.9290],
    [-73.1462, 40.9351],
    [-73.1455, 40.9448],
    [-73.1480, 40.9596],
    [-73.1596, 40.9684],
    [-73.1375, 40.9668],
    [-73.1107, 40.9722],
    [-73.0948, 40.9692],
    [-73.0936, 40.9705],
    [-73.0816, 40.9731],
    [-73.0592, 40.9666],
    [-73.0501, 40.9640],
    [-73.0476, 40.9638],
    [-73.0434, 40.9643],
    [-73.0209, 40.9654],
    [-72.9951, 40.9665],
    [-72.9742, 40.9663],
    [-72.9552, 40.9661],
    [-72.9378, 40.9646],
    [-72.9138, 40.9625],
    [-72.8882, 40.9630],
    [-72.8669, 40.9653],
    [-72.8638, 40.9657],
    [-72.8395, 40.9692],
    [-72.8109, 40.9678],
    [-72.7795, 40.9656],
    [-72.7209, 40.9739],
    [-72.7081, 40.9779],
    [-72.6592, 40.9802],
    [-72.6356, 40.9820],
    [-72.5917, 40.9955],
    [-72.5662, 41.0091],
    [-72.5610, 41.0154],
    [-72.5574, 41.0144],
    [-72.5215, 41.0377],
    [-72.5165, 41.0403],
    [-72.4943, 41.0463],
    [-72.4897, 41.0491],
    [-72.4745, 41.0544],
    [-72.4394, 41.0865],
    [-72.4130, 41.0899],
    [-72.3951, 41.0980],
    [-72.3826, 41.1145],
    [-72.3623, 41.1260],
    [-72.3561, 41.1336],
    [-72.3412, 41.1409],
    [-72.3334, 41.1380],
    [-72.3194, 41.1407],
    [-72.3075, 41.1470],
    [-72.2788, 41.1587],
    [-72.2456, 41.1611],
    [-72.2320, 41.1612],
    [-72.2518, 41.1420],
    [-72.2547, 41.1340],
    [-72.2651, 41.1285],
    [-72.2798, 41.1218],
    [-72.2948, 41.1133],
    [-72.3004, 41.1123],
    [-72.2855, 41.1253],
    [-72.3000, 41.1321],
    [-72.3088, 41.1398],
    [-72.3171, 41.1394],
    [-72.3181, 41.1371],
    [-72.3297, 41.1260],
    [-72.3383, 41.1149],
    [-72.3352, 41.1069],
    [-72.3242, 41.1017],
    [-72.3173, 41.0888],
    [-72.3018, 41.0824],
    [-72.2922, 41.0816],
    [-72.2804, 41.0804],
    [-72.2768, 41.0758],
    [-72.2806, 41.0703],
    [-72.2819, 41.0658],
    [-72.2605, 41.0421],
    [-72.2413, 41.0448],
    [-72.2175, 41.0406],
    [-72.2013, 41.0323],
    [-72.1876, 41.0338],
    [-72.1795, 41.0384],
    [-72.1679, 41.0502],
    [-72.1539, 41.0519],
    [-72.1458, 41.0452],
    [-72.1374, 41.0239],
    [-72.1191, 41.0039],
    [-72.1090, 40.9941],
    [-72.0922, 40.9927],
    [-72.0800, 41.0034],
    [-72.0650, 41.0107],
    [-72.0608, 41.0178],
    [-72.0565, 41.0178],
    [-72.0556, 41.0210],
    [-72.0475, 41.0226],
    [-72.0255, 41.0205],
    [-71.9993, 41.0397],
    [-71.9928, 41.0472],
    [-71.9800, 41.0445],
    [-71.9573, 41.0483],
    [-71.9581, 41.0531],
    [-71.9615, 41.0639],
    [-71.9596, 41.0712],
    [-71.9382, 41.0774],
    [-71.9194, 41.0805],
    [-71.8993, 41.0808],
    [-71.8798, 41.0768],
    [-71.8575, 41.0736],
    [-71.8598, 41.0664],
    [-71.8672, 41.0592],
    [-71.8762, 41.0511],
    [-71.8986, 41.0436],
    [-71.9037, 41.0402],
    [-71.9357, 41.0342],
    [-71.9588, 41.0267],
    [-72.0294, 40.9999],
    [-72.1144, 40.9721],
    [-72.1550, 40.9572],
    [-72.2292, 40.9300],
    [-72.2428, 40.9247],
    [-72.2587, 40.9181],
    [-72.2829, 40.9088],
    [-72.3165, 40.8960],
    [-72.3281, 40.8916],
    [-72.3518, 40.8828],
    [-72.4090, 40.8624],
    [-72.4741, 40.8408],
    [-72.4843, 40.8387],
    [-72.5476, 40.8206],
    [-72.5734, 40.8133],
    [-72.6142, 40.8020],
    [-72.6309, 40.7974],
    [-72.6782, 40.7846],
    [-72.6954, 40.7801],
    [-72.7531, 40.7636],
    [-72.7839, 40.7568],
    [-72.8729, 40.7298],
    [-73.0187, 40.6777],
    [-73.0855, 40.6587],
    [-73.1567, 40.6430],
    [-73.2084, 40.6309],
    [-73.2645, 40.6219],
    [-73.3168, 40.6261],
    [-73.3515, 40.6305],
    [-73.4238, 40.6096],
    [-73.4849, 40.5974],
    [-73.5115, 40.5928],
    [-73.5491, 40.5848],
    [-73.5744, 40.5850],
    [-73.5835, 40.5855],
    [-73.6109, 40.5877],
    [-73.6409, 40.5828],
    [-73.6525, 40.5829],
    [-73.6667, 40.5831],
    [-73.6783, 40.5833],
    [-73.6903, 40.5834],
    [-73.7011, 40.5836],
    [-73.7178, 40.5848],
    [-73.7401, 40.5866],
    [-73.7549, 40.5859],
    [-73.7560, 40.5909],
    [-73.7675, 40.5908],
    [-73.7853, 40.5888],
    [-73.7885, 40.5881],
    [-73.8014, 40.5857],
    [-73.8155, 40.5823],
    [-73.8344, 40.5772],
    [-73.8389, 40.5756],
    [-73.8470, 40.5728],
    [-73.8726, 40.5639],
    [-73.8793, 40.5616],
    [-73.9010, 40.5569],
    [-73.9406, 40.5429],
    [-73.9371, 40.5573],
    [-73.9343, 40.5668],
    [-73.9316, 40.5760],
    [-73.9525, 40.5748],
    [-73.9821, 40.5714],
    [-74.0021, 40.5706],
    [-74.0057, 40.5725],
    [-74.0120, 40.5745],
    [-74.0120, 40.5791],
    [-74.0040, 40.5822],
    [-74.0016, 40.5820],
    [-74.0006, 40.5871],
    [-74.0014, 40.5923],
    [-74.0032, 40.5956],
    [-74.0057, 40.5974],
    [-74.0079, 40.5988],
    [-74.0093, 40.5997],
    [-74.0106, 40.6006],
    [-74.0114, 40.6009],
    [-74.0138, 40.6018],
    [-74.0147, 40.6021],
    [-74.0190, 40.6025],
    [-74.0196, 40.6027],
    [-74.0275, 40.6044],
    [-74.0358, 40.6094],
    [-74.0393, 40.6126],
    [-74.0396, 40.6130],
    [-74.0402, 40.6157],
    [-74.0410, 40.6189],
    [-74.0416, 40.6215],
    [-74.0419, 40.6225],
    [-74.0420, 40.6261],
    [-74.0412, 40.6284],
    [-74.0396, 40.6334],
    [-74.0388, 40.6357],
    [-74.0374, 40.6385],
    [-74.0321, 40.6465],
    [-74.0187, 40.6625],
    [-74.0153, 40.6821],
    [-74.0087, 40.6864],
    [-74.0065, 40.6887],
    [-74.0047, 40.6917],
    [-74.0034, 40.6940],
    [-74.0006, 40.6951],
    [-73.9994, 40.6963],
    [-74.0005, 40.6988],
    [-73.9995, 40.7003],
    [-73.9981, 40.7015],
    [-74.0068, 40.7020],
    [-74.0110, 40.7004],
    [-74.0168, 40.7018],
    [-74.0195, 40.7069],
    [-74.0239, 40.7130],
    [-74.0219, 40.7236],
    [-74.0211, 40.7274],
    [-74.0204, 40.7303],
    [-74.0178, 40.7407],
    [-74.0138, 40.7566],
    [-74.0083, 40.7649],
    [-74.0002, 40.7760],
    [-73.9956, 40.7825],
    [-73.9916, 40.7881],
    [-73.9881, 40.7930],
    [-73.9843, 40.7982],
    [-73.9789, 40.8057],
    [-73.9712, 40.8163],
    [-73.9660, 40.8234],
    [-73.9637, 40.8263],
    [-73.9615, 40.8309],
    [-73.9576, 40.8396],
    [-73.9521, 40.8514],
    [-73.9457, 40.8625],
    [-73.9334, 40.8821],
    [-73.9197, 40.9135],
    [-73.9184, 40.9175],
    [-73.9156, 40.9249],
    [-73.9073, 40.9515],
    [-73.8989, 40.9749],
    [-73.9027, 40.9973],
    [-73.9119, 41.0013],
    [-73.9391, 41.0135],
    [-73.9519, 41.0192],
    [-73.9667, 41.0258],
    [-73.9939, 41.0380],
    [-74.0246, 41.0517],
    [-74.0373, 41.0574],
    [-74.0509, 41.0634],
    [-74.0679, 41.0710],
    [-74.0817, 41.0771],
    [-74.0924, 41.0819],
    [-74.0968, 41.0838],
    [-74.1208, 41.0944],
    [-74.1424, 41.1039],
    [-74.1499, 41.1073],
    [-74.1824, 41.1216],
    [-74.2114, 41.1334],
    [-74.2429, 41.1466],
    [-74.2801, 41.1630],
    [-74.3210, 41.1824],
    [-74.3330, 41.1879],
    [-74.3657, 41.2029],
    [-74.3832, 41.2111],
    [-74.4398, 41.2394],
    [-74.4684, 41.2531],
    [-74.5255, 41.2794],
    [-74.5562, 41.2938],
    [-74.5693, 41.3000],
    [-74.6415, 41.3329],
    [-74.6739, 41.3478],
    [-74.6949, 41.3574],
    [-74.6911, 41.3603],
    [-74.6911, 41.3673],
    [-74.6972, 41.3717],
    [-74.7085, 41.3789],
    [-74.7134, 41.3898],
    [-74.7304, 41.3957],
    [-74.7386, 41.4012],
    [-74.7411, 41.4114],
    [-74.7349, 41.4258],
    [-74.7369, 41.4294],
    [-74.7438, 41.4306],
    [-74.7547, 41.4250],
    [-74.7707, 41.4262],
    [-74.7843, 41.4224],
    [-74.7954, 41.4240],
    [-74.8004, 41.4361],
    [-74.8076, 41.4428],
    [-74.8180, 41.4405],
    [-74.8260, 41.4317],
    [-74.8346, 41.4308],
    [-74.8486, 41.4402],
    [-74.8647, 41.4440],
    [-74.8939, 41.4389],
    [-74.8949, 41.4461],
    [-74.8904, 41.4553],
    [-74.9042, 41.4598],
    [-74.9081, 41.4646],
    [-74.9125, 41.4756],
    [-74.9233, 41.4771],
    [-74.9326, 41.4823],
    [-74.9481, 41.4806],
    [-74.9659, 41.4771],
    [-74.9833, 41.4809],
    [-74.9856, 41.4859],
    [-74.9825, 41.4965],
    [-74.9839, 41.5053],
    [-74.9876, 41.5087],
    [-75.0013, 41.5077],
    [-75.0037, 41.5093],
    [-75.0026, 41.5146],
    [-75.0013, 41.5206],
    [-75.0149, 41.5314],
    [-75.0242, 41.5340],
    [-75.0248, 41.5398],
    [-75.0161, 41.5442],
    [-75.0273, 41.5635],
    [-75.0370, 41.5670],
    [-75.0468, 41.5833],
    [-75.0611, 41.5919],
    [-75.0697, 41.6017],
    [-75.0717, 41.6095],
    [-75.0627, 41.6096],
    [-75.0608, 41.6138],
    [-75.0601, 41.6175],
    [-75.0484, 41.6160],
    [-75.0442, 41.6180],
    [-75.0487, 41.6338],
    [-75.0487, 41.6563],
    [-75.0573, 41.6689],
    [-75.0593, 41.6723],
    [-75.0513, 41.6800],
    [-75.0567, 41.6957],
    [-75.0673, 41.7054],
    [-75.0666, 41.7126],
    [-75.0507, 41.7120],
    [-75.0535, 41.7271],
    [-75.0528, 41.7447],
    [-75.0608, 41.7646],
    [-75.0727, 41.7688],
    [-75.0759, 41.7715],
    [-75.0955, 41.7684],
    [-75.1043, 41.7727],
    [-75.1035, 41.7820],
    [-75.0929, 41.7964],
    [-75.0783, 41.7975],
    [-75.0739, 41.8036],
    [-75.0722, 41.8137],
    [-75.0798, 41.8148],
    [-75.0935, 41.8134],
    [-75.1148, 41.8257],
    [-75.1134, 41.8363],
    [-75.1156, 41.8446],
    [-75.1310, 41.8451],
    [-75.1464, 41.8509],
    [-75.1615, 41.8498],
    [-75.1687, 41.8593],
    [-75.1693, 41.8704],
    [-75.1766, 41.8724],
    [-75.1823, 41.8622],
    [-75.1870, 41.8601],
    [-75.1914, 41.8651],
    [-75.2040, 41.8699],
    [-75.2150, 41.8674],
    [-75.2251, 41.8575],
    [-75.2346, 41.8616],
    [-75.2433, 41.8669],
    [-75.2578, 41.8622],
    [-75.2637, 41.8681],
    [-75.2584, 41.8751],
    [-75.2630, 41.8851],
    [-75.2726, 41.8932],
    [-75.2676, 41.9071],
    [-75.2766, 41.9222],
    [-75.2772, 41.9336],
    [-75.2910, 41.9450],
    [-75.2937, 41.9546],
    [-75.3004, 41.9539],
    [-75.3012, 41.9489],
    [-75.3104, 41.9490],
    [-75.3200, 41.9609],
    [-75.3348, 41.9700],
    [-75.3422, 41.9729],
    [-75.3376, 41.9867],
    [-75.3466, 41.9953],
    [-75.4320, 41.9994],
    [-75.4832, 41.9993],
    [-75.5531, 41.9991],
    [-75.6103, 41.9990],
    [-75.7625, 41.9980],
    [-75.8906, 41.9989],
    [-75.9831, 41.9990],
    [-76.0601, 41.9989],
    [-76.1237, 41.9990],
    [-76.2049, 41.9987],
    [-76.2950, 41.9985],
    [-76.3500, 41.9984],
    [-76.4665, 41.9990],
    [-76.5119, 41.9996],
    [-76.5321, 41.9998],
    [-76.5576, 42.0001],
    [-76.6381, 42.0008],
    [-76.7284, 42.0015],
    [-76.7473, 42.0017],
    [-76.8159, 42.0017],
    [-76.9014, 42.0018],
    [-76.9271, 42.0017],
    [-76.9657, 42.0013],
    [-77.0076, 42.0008],
    [-77.0833, 42.0001],
    [-77.1247, 41.9994],
    [-77.2199, 41.9996],
    [-77.3163, 41.9997],
    [-77.4397, 42.0000],
    [-77.5040, 42.0001],
    [-77.6357, 41.9994],
    [-77.8228, 41.9985],
    [-77.8455, 41.9985],
    [-77.9572, 41.9987],
    [-78.0310, 41.9994],
    [-78.0726, 41.9999],
    [-78.1215, 42.0004],
    [-78.2066, 41.9996],
    [-78.2712, 41.9990],
    [-78.3081, 41.9994],
    [-78.3488, 41.9995],
    [-78.4442, 41.9996],
    [-78.5198, 41.9998],
    [-78.5966, 41.9999],
    [-78.7147, 41.9985],
    [-78.8274, 41.9978],
    [-78.9189, 41.9981],
    [-78.9776, 41.9989],
    [-79.0525, 41.9992],
    [-79.1450, 41.9994],
    [-79.2344, 41.9989],
    [-79.3804, 41.9985],
    [-79.4112, 41.9984],
    [-79.5110, 41.9984],
    [-79.5514, 41.9987],
    [-79.6253, 41.9990],
    [-79.6701, 41.9993],
    [-79.7614, 41.9991],
    [-79.7617, 42.0863],
    [-79.7621, 42.1312],
    [-79.7618, 42.1627],
    [-79.7619, 42.1797],
    [-79.7621, 42.2414],
    [-79.7622, 42.2431]
    ]
  },
  "Kansas": {
    coordinates: [
      [-102.0517, 40.0031],
    [-101.8617, 40.0029],
    [-101.8128, 40.0028],
    [-101.7834, 40.0027],
    [-101.6258, 40.0027],
    [-101.5423, 40.0026],
    [-101.4110, 40.0024],
    [-101.3429, 40.0026],
    [-101.2940, 40.0026],
    [-101.2150, 40.0026],
    [-101.1869, 40.0025],
    [-101.1309, 40.0024],
    [-101.0277, 40.0023],
    [-100.9374, 40.0021],
    [-100.7522, 40.0021],
    [-100.7333, 40.0023],
    [-100.7027, 40.0021],
    [-100.6651, 40.0022],
    [-100.6454, 40.0019],
    [-100.6089, 40.0019],
    [-100.5948, 40.0020],
    [-100.5337, 40.0019],
    [-100.5111, 40.0018],
    [-100.4759, 40.0018],
    [-100.4575, 40.0018],
    [-100.4200, 40.0018],
    [-100.3072, 40.0017],
    [-100.2295, 40.0017],
    [-100.1936, 40.0016],
    [-100.1778, 40.0016],
    [-100.1373, 40.0016],
    [-100.0992, 40.0016],
    [-100.0322, 40.0015],
    [-99.9577, 40.0017],
    [-99.9304, 40.0015],
    [-99.8501, 40.0014],
    [-99.7756, 40.0016],
    [-99.7568, 40.0013],
    [-99.7320, 40.0018],
    [-99.6283, 40.0019],
    [-99.6094, 40.0019],
    [-99.5153, 40.0020],
    [-99.4977, 40.0019],
    [-99.4236, 40.0023],
    [-99.4047, 40.0020],
    [-99.3668, 40.0020],
    [-99.2907, 40.0019],
    [-99.2540, 40.0021],
    [-99.2166, 40.0020],
    [-99.1976, 40.0020],
    [-99.1792, 40.0020],
    [-99.1698, 40.0019],
    [-99.0856, 40.0021],
    [-99.0203, 40.0023],
    [-98.9723, 40.0022],
    [-98.9609, 40.0023],
    [-98.9348, 40.0022],
    [-98.8345, 40.0024],
    [-98.7749, 40.0023],
    [-98.7263, 40.0022],
    [-98.6914, 40.0025],
    [-98.6697, 40.0024],
    [-98.6407, 40.0025],
    [-98.5933, 40.0025],
    [-98.5432, 40.0023],
    [-98.4996, 40.0023],
    [-98.3919, 40.0024],
    [-98.2500, 40.0023],
    [-98.1793, 40.0025],
    [-98.1420, 40.0025],
    [-98.0760, 40.0023],
    [-98.0477, 40.0022],
    [-98.0144, 40.0022],
    [-97.9884, 40.0021],
    [-97.9318, 40.0020],
    [-97.8575, 40.0021],
    [-97.8328, 40.0019],
    [-97.8194, 40.0020],
    [-97.7708, 40.0020],
    [-97.7677, 40.0020],
    [-97.6707, 40.0020],
    [-97.6118, 40.0019],
    [-97.5114, 40.0019],
    [-97.4966, 40.0019],
    [-97.4447, 40.0020],
    [-97.4178, 40.0020],
    [-97.3692, 40.0021],
    [-97.3509, 40.0019],
    [-97.2559, 40.0016],
    [-97.2023, 40.0014],
    [-97.1442, 40.0015],
    [-97.1379, 40.0018],
    [-97.0308, 40.0013],
    [-97.0102, 40.0015],
    [-96.9307, 40.0015],
    [-96.9164, 40.0015],
    [-96.8783, 40.0015],
    [-96.8058, 40.0014],
    [-96.6934, 40.0012],
    [-96.6637, 40.0012],
    [-96.6224, 40.0012],
    [-96.6049, 40.0009],
    [-96.5858, 40.0010],
    [-96.5768, 40.0010],
    [-96.5579, 40.0010],
    [-96.5540, 40.0009],
    [-96.5271, 40.0010],
    [-96.4699, 40.0010],
    [-96.4637, 40.0010],
    [-96.3518, 40.0007],
    [-96.3046, 40.0006],
    [-96.2392, 40.0007],
    [-96.2202, 40.0007],
    [-96.1544, 40.0005],
    [-96.1261, 40.0004],
    [-96.1239, 40.0005],
    [-96.0517, 40.0007],
    [-96.0107, 40.0006],
    [-95.9016, 40.0005],
    [-95.8825, 40.0005],
    [-95.7880, 40.0005],
    [-95.6730, 40.0003],
    [-95.5654, 40.0002],
    [-95.4637, 40.0001],
    [-95.4553, 40.0001],
    [-95.4386, 40.0001],
    [-95.4360, 40.0001],
    [-95.4213, 40.0001],
    [-95.4147, 40.0000],
    [-95.3399, 40.0000],
    [-95.3083, 39.9990],
    [-95.3071, 39.9891],
    [-95.2748, 39.9721],
    [-95.2577, 39.9549],
    [-95.2368, 39.9439],
    [-95.2164, 39.9440],
    [-95.2013, 39.9342],
    [-95.2057, 39.9152],
    [-95.2057, 39.9083],
    [-95.1938, 39.9007],
    [-95.1795, 39.9001],
    [-95.1560, 39.9072],
    [-95.1461, 39.9042],
    [-95.1424, 39.8954],
    [-95.1406, 39.8817],
    [-95.1339, 39.8765],
    [-95.0902, 39.8631],
    [-95.0525, 39.8644],
    [-95.0321, 39.8683],
    [-95.0251, 39.8788],
    [-95.0244, 39.8912],
    [-95.0132, 39.9000],
    [-94.9934, 39.8978],
    [-94.9777, 39.8975],
    [-94.9515, 39.9005],
    [-94.9296, 39.8888],
    [-94.9273, 39.8803],
    [-94.9388, 39.8670],
    [-94.9426, 39.8566],
    [-94.9261, 39.8413],
    [-94.9032, 39.8338],
    [-94.8869, 39.8331],
    [-94.8770, 39.8238],
    [-94.8759, 39.8133],
    [-94.8809, 39.7973],
    [-94.8930, 39.7911],
    [-94.9305, 39.7877],
    [-94.9358, 39.7789],
    [-94.9297, 39.7691],
    [-94.9123, 39.7593],
    [-94.8953, 39.7632],
    [-94.8939, 39.7640],
    [-94.8839, 39.7702],
    [-94.8712, 39.7730],
    [-94.8671, 39.7717],
    [-94.8607, 39.7631],
    [-94.8604, 39.7495],
    [-94.8629, 39.7430],
    [-94.8814, 39.7280],
    [-94.8983, 39.7242],
    [-94.9101, 39.7258],
    [-94.9392, 39.7416],
    [-94.9487, 39.7456],
    [-94.9601, 39.7431],
    [-94.9704, 39.7321],
    [-94.9685, 39.7074],
    [-94.9699, 39.6891],
    [-94.9816, 39.6786],
    [-94.9920, 39.6768],
    [-95.0090, 39.6758],
    [-95.0215, 39.6706],
    [-95.0375, 39.6529],
    [-95.0446, 39.6444],
    [-95.0549, 39.6250],
    [-95.0534, 39.6153],
    [-95.0464, 39.6016],
    [-95.0493, 39.5896],
    [-95.0595, 39.5791],
    [-95.0722, 39.5761],
    [-95.0957, 39.5806],
    [-95.1032, 39.5778],
    [-95.1129, 39.5596],
    [-95.1093, 39.5423],
    [-95.1029, 39.5333],
    [-95.0827, 39.5167],
    [-95.0564, 39.5040],
    [-95.0498, 39.4944],
    [-95.0457, 39.4725],
    [-95.0334, 39.4609],
    [-95.0004, 39.4492],
    [-94.9821, 39.4406],
    [-94.9730, 39.4217],
    [-94.9548, 39.4138],
    [-94.9463, 39.4056],
    [-94.9456, 39.3939],
    [-94.9382, 39.3871],
    [-94.9231, 39.3845],
    [-94.9096, 39.3889],
    [-94.8950, 39.3936],
    [-94.8890, 39.3924],
    [-94.8810, 39.3839],
    [-94.8791, 39.3757],
    [-94.8909, 39.3640],
    [-94.9025, 39.3604],
    [-94.9100, 39.3525],
    [-94.9101, 39.3427],
    [-94.9082, 39.3251],
    [-94.9060, 39.3148],
    [-94.9018, 39.3037],
    [-94.9000, 39.3002],
    [-94.8895, 39.2888],
    [-94.8783, 39.2811],
    [-94.8571, 39.2738],
    [-94.8379, 39.2624],
    [-94.8275, 39.2499],
    [-94.8257, 39.2417],
    [-94.8349, 39.2238],
    [-94.8336, 39.2178],
    [-94.8207, 39.2086],
    [-94.7891, 39.2074],
    [-94.7815, 39.2061],
    [-94.7711, 39.1915],
    [-94.7523, 39.1732],
    [-94.7365, 39.1692],
    [-94.6963, 39.1786],
    [-94.6803, 39.1843],
    [-94.6596, 39.1746],
    [-94.6614, 39.1627],
    [-94.6507, 39.1541],
    [-94.6239, 39.1566],
    [-94.6087, 39.1610],
    [-94.5907, 39.1548],
    [-94.5925, 39.1359],
    [-94.6083, 39.1179],
    [-94.6072, 39.0896],
    [-94.6073, 39.0725],
    [-94.6073, 39.0573],
    [-94.6074, 39.0502],
    [-94.6075, 39.0441],
    [-94.6076, 39.0370],
    [-94.6077, 39.0334],
    [-94.6078, 39.0211],
    [-94.6079, 39.0139],
    [-94.6081, 39.0006],
    [-94.6082, 38.9930],
    [-94.6083, 38.9844],
    [-94.6083, 38.9747],
    [-94.6082, 38.9567],
    [-94.6081, 38.9421],
    [-94.6079, 38.9374],
    [-94.6080, 38.9368],
    [-94.6080, 38.9203],
    [-94.6080, 38.9056],
    [-94.6080, 38.8886],
    [-94.6080, 38.8697],
    [-94.6080, 38.8673],
    [-94.6080, 38.8599],
    [-94.6080, 38.8472],
    [-94.6077, 38.8298],
    [-94.6077, 38.8258],
    [-94.6080, 38.8111],
    [-94.6085, 38.7898],
    [-94.6090, 38.7606],
    [-94.6095, 38.7381],
    [-94.6116, 38.6354],
    [-94.6119, 38.6205],
    [-94.6119, 38.6059],
    [-94.6119, 38.5801],
    [-94.6122, 38.5498],
    [-94.6125, 38.5205],
    [-94.6126, 38.4958],
    [-94.6127, 38.4844],
    [-94.6129, 38.4776],
    [-94.6133, 38.4069],
    [-94.6133, 38.3924],
    [-94.6133, 38.3644],
    [-94.6128, 38.3201],
    [-94.6127, 38.3025],
    [-94.6128, 38.2899],
    [-94.6127, 38.2704],
    [-94.6126, 38.2377],
    [-94.6127, 38.2186],
    [-94.6127, 38.2122],
    [-94.6131, 38.1906],
    [-94.6137, 38.1606],
    [-94.6139, 38.1180],
    [-94.6141, 38.0601],
    [-94.6140, 38.0369],
    [-94.6145, 37.9875],
    [-94.6146, 37.9515],
    [-94.6146, 37.9441],
    [-94.6148, 37.9342],
    [-94.6154, 37.9064],
    [-94.6159, 37.8783],
    [-94.6160, 37.8631],
    [-94.6164, 37.8453],
    [-94.6169, 37.8195],
    [-94.6177, 37.7719],
    [-94.6178, 37.7297],
    [-94.6177, 37.6877],
    [-94.6177, 37.6731],
    [-94.6176, 37.6536],
    [-94.6175, 37.6367],
    [-94.6173, 37.5719],
    [-94.6171, 37.5671],
    [-94.6171, 37.5610],
    [-94.6172, 37.5535],
    [-94.6169, 37.5278],
    [-94.6170, 37.4916],
    [-94.6172, 37.4697],
    [-94.6172, 37.4604],
    [-94.6171, 37.4398],
    [-94.6175, 37.4110],
    [-94.6176, 37.3676],
    [-94.6175, 37.3642],
    [-94.6176, 37.3236],
    [-94.6181, 37.2404],
    [-94.6181, 37.2281],
    [-94.6183, 37.2072],
    [-94.6185, 37.1812],
    [-94.6185, 37.1748],
    [-94.6183, 37.1531],
    [-94.6181, 37.1298],
    [-94.6182, 37.1132],
    [-94.6181, 37.0937],
    [-94.6181, 37.0864],
    [-94.6180, 37.0751],
    [-94.6179, 37.0568],
    [-94.6180, 37.0328],
    [-94.6180, 37.0121],
    [-94.6180, 36.9989],
    [-94.7018, 36.9988],
    [-94.7224, 36.9987],
    [-94.7372, 36.9987],
    [-94.7497, 36.9987],
    [-94.8090, 36.9988],
    [-94.8409, 36.9988],
    [-94.8532, 36.9989],
    [-94.9406, 36.9993],
    [-95.0114, 36.9995],
    [-95.0379, 36.9995],
    [-95.1221, 36.9995],
    [-95.1554, 36.9995],
    [-95.1953, 36.9996],
    [-95.3226, 36.9994],
    [-95.3312, 36.9994],
    [-95.4077, 36.9992],
    [-95.5344, 36.9993],
    [-95.6015, 36.9993],
    [-95.6159, 36.9994],
    [-95.6287, 36.9993],
    [-95.6424, 36.9993],
    [-95.6740, 36.9993],
    [-95.7104, 36.9994],
    [-95.7181, 36.9993],
    [-95.7548, 36.9993],
    [-95.7687, 36.9992],
    [-95.8194, 36.9992],
    [-95.8739, 36.9993],
    [-95.9102, 36.9993],
    [-95.9643, 36.9991],
    [-96.0913, 36.9989],
    [-96.1471, 36.9990],
    [-96.1540, 36.9992],
    [-96.2000, 36.9990],
    [-96.2764, 36.9993],
    [-96.3453, 36.9992],
    [-96.3943, 36.9992],
    [-96.5003, 36.9986],
    [-96.6245, 36.9990],
    [-96.7106, 36.9993],
    [-96.7413, 36.9992],
    [-96.7952, 36.9989],
    [-96.8675, 36.9992],
    [-96.9021, 36.9992],
    [-96.9171, 36.9992],
    [-96.9346, 36.9991],
    [-97.0301, 36.9989],
    [-97.1007, 36.9990],
    [-97.1203, 36.9990],
    [-97.1562, 36.9991],
    [-97.2558, 36.9990],
    [-97.3428, 36.9989],
    [-97.3849, 36.9988],
    [-97.4623, 36.9987],
    [-97.5273, 36.9988],
    [-97.5645, 36.9987],
    [-97.6148, 36.9988],
    [-97.6505, 36.9990],
    [-97.7687, 36.9988],
    [-97.8023, 36.9987],
    [-97.9653, 36.9985],
    [-98.0387, 36.9984],
    [-98.1120, 36.9981],
    [-98.1475, 36.9982],
    [-98.1904, 36.9980],
    [-98.2377, 36.9980],
    [-98.3471, 36.9980],
    [-98.4183, 36.9985],
    [-98.5447, 36.9990],
    [-98.7145, 36.9991],
    [-98.7919, 36.9993],
    [-98.8118, 36.9992],
    [-98.8806, 36.9993],
    [-99.0003, 36.9995],
    [-99.0497, 36.9992],
    [-99.2154, 36.9995],
    [-99.3754, 37.0002],
    [-99.4562, 36.9995],
    [-99.5004, 36.9996],
    [-99.5086, 36.9997],
    [-99.6254, 36.9997],
    [-99.7226, 37.0006],
    [-99.7748, 37.0008],
    [-99.8754, 37.0017],
    [-100.0013, 37.0017],
    [-100.0895, 37.0021],
    [-100.1875, 37.0021],
    [-100.2017, 37.0021],
    [-100.4343, 37.0011],
    [-100.5527, 37.0007],
    [-100.6298, 37.0000],
    [-100.6756, 36.9997],
    [-100.7569, 36.9994],
    [-100.8061, 36.9991],
    [-100.8556, 36.9986],
    [-100.9042, 36.9987],
    [-100.9455, 36.9982],
    [-100.9965, 36.9980],
    [-101.0536, 36.9980],
    [-101.0901, 36.9978],
    [-101.2149, 36.9970],
    [-101.3597, 36.9962],
    [-101.3970, 36.9961],
    [-101.4853, 36.9956],
    [-101.5553, 36.9954],
    [-101.6016, 36.9951],
    [-101.7183, 36.9946],
    [-101.8809, 36.9938],
    [-101.9081, 36.9937],
    [-102.0004, 36.9933],
    [-102.0420, 37.0247],
    [-102.0417, 37.0344],
    [-102.0418, 37.1120],
    [-102.0421, 37.1267],
    [-102.0417, 37.2976],
    [-102.0421, 37.3528],
    [-102.0417, 37.4099],
    [-102.0418, 37.4695],
    [-102.0419, 37.5412],
    [-102.0416, 37.6443],
    [-102.0416, 37.6804],
    [-102.0422, 37.7602],
    [-102.0430, 37.8241],
    [-102.0438, 37.9261],
    [-102.0446, 38.0455],
    [-102.0443, 38.1418],
    [-102.0445, 38.2624],
    [-102.0446, 38.3123],
    [-102.0449, 38.4197],
    [-102.0453, 38.5055],
    [-102.0452, 38.5587],
    [-102.0453, 38.6152],
    [-102.0452, 38.6752],
    [-102.0452, 38.6976],
    [-102.0454, 38.7701],
    [-102.0454, 38.8134],
    [-102.0471, 39.1297],
    [-102.0479, 39.2203],
    [-102.0491, 39.3941],
    [-102.0494, 39.4233],
    [-102.0496, 39.5389],
    [-102.0500, 39.5923],
    [-102.0506, 39.6756],
    [-102.0513, 39.8333],
    [-102.0516, 39.8595],
    [-102.0517, 40.0031]
    ]
  },
  "Alaska": {
    coordinates: [
      [-168.1202, 65.6479],
    [-168.1140, 65.6646],
    [-168.0954, 65.6840],
    [-168.0610, 65.6983],
    [-167.9843, 65.7243],
    [-167.9326, 65.7376],
    [-167.8703, 65.7511],
    [-167.8279, 65.7587],
    [-167.7448, 65.7745],
    [-167.7175, 65.7795],
    [-167.6680, 65.7908],
    [-167.5493, 65.8171],
    [-167.5250, 65.8194],
    [-167.4716, 65.8387],
    [-167.3738, 65.8662],
    [-167.2733, 65.8991],
    [-167.2565, 65.9010],
    [-167.2248, 65.9171],
    [-167.1365, 65.9474],
    [-167.0703, 65.9688],
    [-166.9973, 65.9914],
    [-166.9467, 66.0084],
    [-166.8813, 66.0293],
    [-166.8060, 66.0531],
    [-166.7720, 66.0641],
    [-166.6809, 66.0923],
    [-166.5975, 66.1175],
    [-166.4540, 66.1574],
    [-166.3348, 66.1868],
    [-166.2751, 66.2012],
    [-166.2234, 66.2119],
    [-166.1677, 66.2164],
    [-166.1537, 66.2268],
    [-166.1475, 66.2326],
    [-166.1055, 66.2472],
    [-166.0742, 66.2566],
    [-166.0498, 66.2611],
    [-166.0398, 66.2605],
    [-166.0233, 66.2674],
    [-165.9882, 66.2795],
    [-165.8948, 66.3056],
    [-165.8316, 66.3209],
    [-165.7067, 66.3523],
    [-165.6169, 66.3734],
    [-165.4526, 66.4091],
    [-165.3484, 66.4308],
    [-165.2245, 66.4554],
    [-165.1337, 66.4720],
    [-165.0657, 66.4837],
    [-164.9689, 66.4990],
    [-164.8565, 66.5173],
    [-164.7637, 66.5331],
    [-164.6572, 66.5482],
    [-164.5751, 66.5591],
    [-164.4862, 66.5708],
    [-164.4165, 66.5799],
    [-164.3959, 66.5816],
    [-164.3847, 66.5816],
    [-164.3446, 66.5811],
    [-164.2777, 66.5845],
    [-164.1941, 66.5883],
    [-164.1332, 66.5909],
    [-163.9757, 66.5939],
    [-163.9615, 66.5936],
    [-163.9149, 66.5939],
    [-163.8747, 66.5931],
    [-163.8366, 66.5923],
    [-163.7956, 66.5902],
    [-163.7475, 66.5867],
    [-163.6963, 66.5802],
    [-163.6553, 66.5728],
    [-163.6119, 66.5611],
    [-163.6105, 66.5569],
    [-163.6330, 66.5546],
    [-163.6490, 66.5543],
    [-163.6684, 66.5583],
    [-163.6904, 66.5608],
    [-163.7529, 66.5694],
    [-163.7790, 66.5729],
    [-163.7980, 66.5743],
    [-163.8172, 66.5760],
    [-163.8381, 66.5771],
    [-163.8402, 66.5727],
    [-163.8589, 66.5715],
    [-163.8661, 66.5688],
    [-163.8791, 66.5671],
    [-163.8850, 66.5712],
    [-163.8959, 66.5712],
    [-163.9058, 66.5723],
    [-163.9184, 66.5716],
    [-163.9276, 66.5740],
    [-163.9292, 66.5694],
    [-163.9265, 66.5646],
    [-163.9203, 66.5605],
    [-163.9165, 66.5585],
    [-163.9118, 66.5572],
    [-163.9036, 66.5566],
    [-163.8950, 66.5570],
    [-163.8889, 66.5597],
    [-163.8855, 66.5605],
    [-163.8723, 66.5582],
    [-163.8662, 66.5565],
    [-163.8560, 66.5606],
    [-163.8492, 66.5639],
    [-163.8355, 66.5609],
    [-163.8169, 66.5569],
    [-163.8059, 66.5542],
    [-163.7968, 66.5531],
    [-163.7937, 66.5559],
    [-163.7803, 66.5559],
    [-163.7532, 66.5523],
    [-163.7530, 66.5486],
    [-163.7549, 66.5403],
    [-163.7532, 66.5313],
    [-163.7485, 66.5253],
    [-163.7349, 66.5225],
    [-163.7272, 66.5164],
    [-163.7263, 66.5051],
    [-163.7283, 66.4986],
    [-163.7570, 66.4637],
    [-163.7655, 66.4525],
    [-163.7993, 66.4373],
    [-163.8442, 66.4190],
    [-163.8587, 66.4052],
    [-163.8706, 66.3881],
    [-163.8707, 66.3771],
    [-163.8661, 66.3686],
    [-163.8597, 66.3659],
    [-163.8552, 66.3641],
    [-163.8607, 66.3598],
    [-163.8671, 66.3501],
    [-163.8656, 66.3412],
    [-163.8680, 66.3326],
    [-163.8754, 66.3280],
    [-163.8793, 66.3218],
    [-163.8757, 66.3173],
    [-163.8685, 66.3148],
    [-163.8608, 66.3106],
    [-163.8420, 66.3067],
    [-163.8344, 66.3031],
    [-163.8381, 66.2990],
    [-163.8364, 66.2922],
    [-163.8321, 66.2857],
    [-163.8271, 66.2778],
    [-163.8283, 66.2704],
    [-163.8363, 66.2614],
    [-163.8525, 66.2557],
    [-163.8700, 66.2491],
    [-163.9048, 66.2303],
    [-163.9363, 66.2155],
    [-163.9486, 66.2155],
    [-163.9667, 66.2158],
    [-163.9914, 66.2144],
    [-164.0109, 66.2122],
    [-164.0314, 66.2099],
    [-164.0330, 66.2074],
    [-164.0394, 66.2037],
    [-164.0355, 66.2004],
    [-164.0227, 66.2009],
    [-164.0122, 66.2039],
    [-164.0006, 66.2025],
    [-164.0005, 66.1975],
    [-164.0040, 66.1940],
    [-164.0105, 66.1956],
    [-164.0262, 66.1975],
    [-164.0309, 66.1862],
    [-164.0191, 66.1827],
    [-164.0079, 66.1790],
    [-163.9926, 66.1822],
    [-163.9812, 66.1901],
    [-163.9724, 66.1959],
    [-163.9610, 66.1945],
    [-163.9605, 66.1882],
    [-163.9630, 66.1854],
    [-163.9682, 66.1862],
    [-163.9737, 66.1779],
    [-163.9738, 66.1713],
    [-163.9665, 66.1718],
    [-163.9558, 66.1743],
    [-163.9486, 66.1765],
    [-163.9411, 66.1759],
    [-163.9375, 66.1803],
    [-163.9270, 66.1809],
    [-163.9283, 66.1857],
    [-163.9272, 66.1888],
    [-163.9287, 66.1920],
    [-163.9297, 66.1951],
    [-163.9165, 66.1949],
    [-163.9090, 66.1968],
    [-163.8953, 66.1892],
    [-163.8769, 66.1608],
    [-163.8565, 66.1345],
    [-163.8416, 66.1217],
    [-163.8238, 66.1121],
    [-163.7995, 66.0987],
    [-163.7771, 66.0833],
    [-163.7683, 66.0793],
    [-163.7612, 66.0770],
    [-163.7519, 66.0767],
    [-163.7430, 66.0728],
    [-163.7318, 66.0730],
    [-163.7232, 66.0701],
    [-163.7122, 66.0671],
    [-163.7059, 66.0691],
    [-163.6926, 66.0678],
    [-163.6796, 66.0654],
    [-163.6355, 66.0574],
    [-163.6141, 66.0587],
    [-163.6079, 66.0639],
    [-163.5943, 66.0641],
    [-163.5922, 66.0665],
    [-163.5831, 66.0689],
    [-163.5546, 66.0680],
    [-163.5354, 66.0700],
    [-163.5197, 66.0737],
    [-163.5125, 66.0777],
    [-163.4987, 66.0815],
    [-163.5006, 66.0845],
    [-163.4968, 66.0861],
    [-163.4899, 66.0835],
    [-163.4714, 66.0830],
    [-163.4660, 66.0844],
    [-163.4604, 66.0828],
    [-163.4544, 66.0842],
    [-163.4435, 66.0818],
    [-163.4363, 66.0802],
    [-163.4152, 66.0802],
    [-163.4114, 66.0828],
    [-163.3994, 66.0844],
    [-163.3924, 66.0836],
    [-163.3870, 66.0826],
    [-163.3710, 66.0810],
    [-163.3591, 66.0830],
    [-163.3505, 66.0830],
    [-163.3387, 66.0850],
    [-163.3378, 66.0882],
    [-163.3342, 66.0858],
    [-163.3287, 66.0856],
    [-163.3231, 66.0849],
    [-163.3234, 66.0832],
    [-163.3265, 66.0804],
    [-163.3171, 66.0752],
    [-163.2855, 66.0682],
    [-163.2606, 66.0659],
    [-163.2403, 66.0660],
    [-163.2362, 66.0654],
    [-163.2199, 66.0642],
    [-163.2066, 66.0642],
    [-163.1901, 66.0646],
    [-163.1808, 66.0617],
    [-163.1647, 66.0584],
    [-163.1245, 66.0597],
    [-163.0723, 66.0648],
    [-163.0309, 66.0699],
    [-162.9931, 66.0769],
    [-162.9749, 66.0837],
    [-162.9567, 66.0884],
    [-162.9555, 66.0923],
    [-162.9541, 66.0952],
    [-162.9486, 66.0911],
    [-162.9381, 66.0897],
    [-162.9243, 66.0906],
    [-162.9045, 66.0861],
    [-162.8842, 66.0832],
    [-162.8661, 66.0816],
    [-162.8374, 66.0852],
    [-162.8290, 66.0857],
    [-162.8058, 66.0899],
    [-162.7912, 66.0891],
    [-162.7671, 66.0938],
    [-162.7569, 66.0981],
    [-162.7461, 66.1012],
    [-162.7392, 66.0980],
    [-162.7456, 66.0962],
    [-162.7523, 66.0933],
    [-162.7467, 66.0858],
    [-162.7238, 66.0765],
    [-162.6932, 66.0722],
    [-162.6843, 66.0697],
    [-162.6783, 66.0604],
    [-162.6787, 66.0586],
    [-162.6736, 66.0537],
    [-162.6488, 66.0444],
    [-162.6335, 66.0391],
    [-162.6178, 66.0389],
    [-162.5934, 66.0403],
    [-162.5489, 66.0428],
    [-162.5000, 66.0486],
    [-162.4678, 66.0549],
    [-162.4542, 66.0594],
    [-162.4496, 66.0575],
    [-162.4467, 66.0532],
    [-162.4329, 66.0508],
    [-162.4212, 66.0496],
    [-162.4236, 66.0475],
    [-162.4179, 66.0444],
    [-162.4197, 66.0416],
    [-162.4143, 66.0375],
    [-162.4043, 66.0313],
    [-162.3825, 66.0280],
    [-162.3497, 66.0287],
    [-162.3119, 66.0340],
    [-162.2912, 66.0371],
    [-162.2725, 66.0399],
    [-162.2385, 66.0484],
    [-162.2248, 66.0495],
    [-162.1752, 66.0650],
    [-162.1348, 66.0787],
    [-162.1302, 66.0715],
    [-162.1209, 66.0664],
    [-162.0981, 66.0657],
    [-162.0860, 66.0658],
    [-162.0736, 66.0653],
    [-162.0552, 66.0667],
    [-162.0357, 66.0707],
    [-162.0293, 66.0700],
    [-162.0253, 66.0651],
    [-162.0172, 66.0602],
    [-161.9929, 66.0556],
    [-161.9762, 66.0487],
    [-161.9500, 66.0403],
    [-161.9133, 66.0336],
    [-161.8776, 66.0293],
    [-161.8703, 66.0272],
    [-161.8562, 66.0251],
    [-161.8454, 66.0232],
    [-161.8538, 66.0217],
    [-161.8659, 66.0242],
    [-161.8784, 66.0256],
    [-161.8874, 66.0265],
    [-161.8954, 66.0268],
    [-161.8986, 66.0296],
    [-161.9117, 66.0303],
    [-161.9211, 66.0322],
    [-161.9286, 66.0341],
    [-161.9297, 66.0304],
    [-161.9215, 66.0261],
    [-161.9117, 66.0244],
    [-161.8949, 66.0192],
    [-161.8817, 66.0150],
    [-161.8820, 66.0116],
    [-161.8816, 66.0069],
    [-161.8712, 66.0022],
    [-161.8690, 65.9990],
    [-161.8739, 65.9980],
    [-161.8775, 65.9951],
    [-161.8795, 65.9902],
    [-161.8861, 65.9872],
    [-161.8950, 65.9822],
    [-161.8959, 65.9768],
    [-161.8931, 65.9757],
    [-161.9004, 65.9712],
    [-161.8879, 65.9707],
    [-161.8834, 65.9701],
    [-161.8755, 65.9713],
    [-161.8665, 65.9739],
    [-161.8581, 65.9712],
    [-161.8518, 65.9708],
    [-161.8464, 65.9714],
    [-161.8360, 65.9690],
    [-161.8279, 65.9698],
    [-161.8167, 65.9687],
    [-161.8068, 65.9696],
    [-161.7966, 65.9717],
    [-161.7939, 65.9739],
    [-161.7849, 65.9752],
    [-161.7805, 65.9774],
    [-161.7777, 65.9797],
    [-161.7799, 65.9816],
    [-161.7864, 65.9830],
    [-161.7897, 65.9874],
    [-161.7951, 65.9875],
    [-161.8016, 65.9882],
    [-161.8128, 65.9882],
    [-161.8148, 65.9905],
    [-161.8215, 65.9953],
    [-161.8246, 65.9973],
    [-161.8296, 65.9988],
    [-161.8231, 66.0054],
    [-161.8152, 66.0120],
    [-161.8001, 66.0211],
    [-161.7949, 66.0275],
    [-161.7924, 66.0323],
    [-161.8085, 66.0307],
    [-161.8171, 66.0331],
    [-161.8249, 66.0372],
    [-161.8244, 66.0433],
    [-161.8133, 66.0501],
    [-161.7995, 66.0557],
    [-161.7852, 66.0555],
    [-161.7754, 66.0552],
    [-161.7743, 66.0593],
    [-161.7788, 66.0614],
    [-161.7719, 66.0674],
    [-161.6985, 66.1062],
    [-161.6757, 66.1199],
    [-161.6594, 66.1314],
    [-161.6351, 66.1531],
    [-161.6257, 66.1665],
    [-161.6184, 66.1785],
    [-161.6096, 66.1864],
    [-161.6029, 66.1877],
    [-161.5866, 66.2051],
    [-161.5703, 66.2181],
    [-161.5559, 66.2398],
    [-161.5461, 66.2437],
    [-161.5333, 66.2449],
    [-161.5210, 66.2484],
    [-161.5015, 66.2582],
    [-161.4922, 66.2612],
    [-161.4815, 66.2614],
    [-161.4672, 66.2609],
    [-161.4525, 66.2606],
    [-161.4444, 66.2587],
    [-161.4285, 66.2579],
    [-161.4144, 66.2573],
    [-161.4001, 66.2588],
    [-161.3941, 66.2569],
    [-161.3700, 66.2572],
    [-161.3525, 66.2588],
    [-161.3305, 66.2592],
    [-161.3301, 66.2578],
    [-161.3364, 66.2581],
    [-161.3477, 66.2564],
    [-161.3464, 66.2512],
    [-161.3417, 66.2467],
    [-161.3404, 66.2420],
    [-161.3337, 66.2352],
    [-161.3219, 66.2254],
    [-161.3195, 66.2234],
    [-161.3164, 66.2207],
    [-161.2947, 66.2174],
    [-161.2509, 66.2125],
    [-161.2315, 66.2107],
    [-161.2207, 66.2101],
    [-161.1916, 66.2103],
    [-161.1806, 66.2108],
    [-161.1677, 66.2137],
    [-161.1573, 66.2164],
    [-161.1455, 66.2188],
    [-161.1234, 66.2228],
    [-161.1031, 66.2292],
    [-161.0867, 66.2314],
    [-161.0660, 66.2300],
    [-161.0579, 66.2267],
    [-161.0668, 66.2189],
    [-161.0799, 66.2162],
    [-161.0874, 66.2118],
    [-161.0825, 66.2055],
    [-161.0828, 66.1992],
    [-161.0773, 66.1953],
    [-161.0869, 66.1903],
    [-161.0989, 66.1863],
    [-161.0928, 66.1834],
    [-161.0565, 66.1811],
    [-161.0315, 66.1836],
    [-161.0205, 66.1866],
    [-161.0200, 66.1889],
    [-161.0138, 66.1925],
    [-161.0135, 66.1967],
    [-161.0165, 66.2027],
    [-161.0157, 66.2085],
    [-161.0149, 66.2133],
    [-160.9971, 66.2175],
    [-160.9989, 66.2235],
    [-160.9911, 66.2246],
    [-160.9911, 66.2278],
    [-160.9921, 66.2326],
    [-160.9998, 66.2376],
    [-161.0118, 66.2490],
    [-161.0093, 66.2517],
    [-161.0144, 66.2555],
    [-161.0428, 66.2686],
    [-161.0521, 66.2753],
    [-161.0625, 66.2801],
    [-161.0708, 66.2871],
    [-161.0736, 66.2936],
    [-161.0822, 66.3024],
    [-161.0833, 66.3065],
    [-161.0940, 66.3143],
    [-161.1086, 66.3223],
    [-161.1123, 66.3274],
    [-161.1218, 66.3299],
    [-161.1304, 66.3342],
    [-161.1410, 66.3380],
    [-161.1739, 66.3418],
    [-161.2193, 66.3480],
    [-161.2386, 66.3512],
    [-161.2803, 66.3618],
    [-161.3137, 66.3669],
    [-161.3546, 66.3749],
    [-161.3777, 66.3765],
    [-161.3989, 66.3767],
    [-161.4409, 66.3818],
    [-161.4799, 66.3904],
    [-161.5166, 66.3965],
    [-161.5529, 66.3979],
    [-161.5936, 66.3957],
    [-161.6319, 66.3974],
    [-161.6769, 66.3982],
    [-161.7046, 66.3946],
    [-161.7410, 66.3834],
    [-161.8075, 66.3681],
    [-161.8470, 66.3604],
    [-161.8627, 66.3617],
    [-161.8812, 66.3600],
    [-161.8994, 66.3563],
    [-161.9142, 66.3493],
    [-161.9097, 66.3426],
    [-161.8947, 66.3391],
    [-161.9007, 66.3373],
    [-161.9161, 66.3267],
    [-161.9117, 66.3193],
    [-161.8983, 66.3121],
    [-161.8898, 66.3126],
    [-161.8693, 66.3168],
    [-161.8639, 66.3168],
    [-161.8588, 66.3167],
    [-161.8647, 66.3140],
    [-161.8698, 66.3118],
    [-161.8756, 66.3053],
    [-161.8743, 66.3016],
    [-161.8779, 66.2998],
    [-161.8754, 66.2882],
    [-161.8705, 66.2862],
    [-161.8555, 66.2855],
    [-161.8456, 66.2802],
    [-161.8378, 66.2725],
    [-161.8254, 66.2712],
    [-161.8365, 66.2659],
    [-161.8461, 66.2658],
    [-161.8612, 66.2628],
    [-161.8924, 66.2650],
    [-161.9045, 66.2649],
    [-161.9006, 66.2745],
    [-161.8979, 66.2857],
    [-161.8991, 66.2949],
    [-161.9022, 66.3016],
    [-161.9069, 66.3138],
    [-161.9271, 66.3225],
    [-161.9357, 66.3204],
    [-161.9428, 66.3222],
    [-161.9334, 66.3364],
    [-161.9254, 66.3446],
    [-161.9011, 66.3791],
    [-161.8819, 66.4125],
    [-161.8743, 66.4349],
    [-161.8696, 66.4532],
    [-161.8678, 66.4736],
    [-161.8699, 66.4918],
    [-161.8799, 66.5101],
    [-161.8914, 66.5217],
    [-161.9083, 66.5328],
    [-161.9334, 66.5464],
    [-161.9577, 66.5592],
    [-161.9811, 66.5712],
    [-162.0285, 66.5871],
    [-162.0862, 66.6032],
    [-162.1032, 66.6205],
    [-162.1243, 66.6513],
    [-162.1469, 66.6684],
    [-162.1823, 66.6892],
    [-162.2279, 66.7063],
    [-162.2586, 66.7133],
    [-162.2874, 66.7170],
    [-162.3286, 66.7227],
    [-162.3570, 66.7251],
    [-162.3809, 66.7261],
    [-162.4262, 66.7298],
    [-162.4646, 66.7302],
    [-162.4889, 66.7310],
    [-162.5033, 66.7364],
    [-162.5005, 66.7498],
    [-162.5131, 66.7769],
    [-162.5359, 66.7963],
    [-162.5597, 66.8172],
    [-162.5722, 66.8246],
    [-162.6014, 66.8393],
    [-162.6171, 66.8494],
    [-162.6232, 66.8613],
    [-162.6146, 66.8859],
    [-162.6011, 66.8985],
    [-162.5829, 66.9043],
    [-162.5711, 66.9036],
    [-162.5528, 66.9019],
    [-162.5379, 66.9048],
    [-162.5232, 66.9048],
    [-162.5169, 66.9066],
    [-162.5057, 66.9105],
    [-162.5043, 66.9162],
    [-162.4974, 66.9199],
    [-162.4998, 66.9280],
    [-162.4945, 66.9369],
    [-162.4915, 66.9432],
    [-162.4735, 66.9488],
    [-162.4616, 66.9493],
    [-162.4627, 66.9457],
    [-162.4568, 66.9389],
    [-162.4538, 66.9352],
    [-162.4449, 66.9251],
    [-162.4249, 66.9196],
    [-162.4090, 66.9189],
    [-162.3845, 66.9249],
    [-162.3590, 66.9312],
    [-162.3379, 66.9371],
    [-162.3299, 66.9448],
    [-162.3341, 66.9482],
    [-162.3230, 66.9432],
    [-162.3076, 66.9390],
    [-162.2901, 66.9313],
    [-162.2825, 66.9237],
    [-162.2790, 66.9132],
    [-162.2665, 66.9008],
    [-162.2527, 66.8901],
    [-162.2433, 66.8796],
    [-162.2181, 66.8621],
    [-162.1939, 66.8489],
    [-162.1860, 66.8446],
    [-162.1807, 66.8411],
    [-162.1756, 66.8384],
    [-162.1576, 66.8312],
    [-162.1334, 66.8110],
    [-162.0925, 66.7879],
    [-162.0665, 66.7829],
    [-162.0290, 66.7813],
    [-162.0103, 66.7792],
    [-162.0109, 66.7670],
    [-162.0212, 66.7466],
    [-162.0291, 66.7327],
    [-162.0405, 66.7213],
    [-162.0685, 66.7073],
    [-162.0785, 66.6961],
    [-162.0763, 66.6862],
    [-162.0657, 66.6797],
    [-162.0698, 66.6737],
    [-162.0741, 66.6612],
    [-162.0704, 66.6481],
    [-162.0386, 66.6356],
    [-162.0312, 66.6309],
    [-162.0119, 66.6185],
    [-161.9762, 66.6002],
    [-161.9561, 66.5867],
    [-161.9483, 66.5756],
    [-161.9376, 66.5655],
    [-161.9274, 66.5542],
    [-161.9070, 66.5438],
    [-161.8943, 66.5408],
    [-161.8485, 66.5258],
    [-161.8246, 66.5154],
    [-161.7862, 66.5026],
    [-161.7654, 66.4969],
    [-161.7177, 66.4815],
    [-161.6792, 66.4763],
    [-161.6566, 66.4646],
    [-161.6284, 66.4531],
    [-161.6039, 66.4474],
    [-161.5873, 66.4426],
    [-161.5745, 66.4395],
    [-161.5505, 66.4407],
    [-161.5375, 66.4414],
    [-161.5260, 66.4434],
    [-161.5050, 66.4460],
    [-161.4631, 66.4531],
    [-161.4184, 66.4600],
    [-161.3782, 66.4729],
    [-161.3471, 66.4767],
    [-161.3382, 66.4780],
    [-161.3296, 66.4776],
    [-161.3207, 66.4840],
    [-161.3136, 66.4887],
    [-161.2955, 66.4993],
    [-161.2935, 66.5220],
    [-161.3088, 66.5210],
    [-161.3216, 66.5229],
    [-161.3391, 66.5239],
    [-161.3682, 66.5240],
    [-161.3934, 66.5238],
    [-161.4102, 66.5260],
    [-161.4118, 66.5296],
    [-161.4216, 66.5313],
    [-161.4416, 66.5259],
    [-161.4618, 66.5225],
    [-161.4836, 66.5256],
    [-161.4950, 66.5344],
    [-161.5013, 66.5382],
    [-161.5106, 66.5440],
    [-161.5298, 66.5477],
    [-161.5444, 66.5511],
    [-161.5451, 66.5556],
    [-161.5529, 66.5605],
    [-161.5528, 66.5628],
    [-161.5425, 66.5660],
    [-161.5377, 66.5695],
    [-161.5336, 66.5765],
    [-161.5385, 66.5826],
    [-161.5620, 66.5846],
    [-161.5913, 66.5878],
    [-161.5953, 66.5917],
    [-161.6034, 66.5953],
    [-161.6193, 66.6028],
    [-161.6451, 66.6103],
    [-161.6631, 66.6123],
    [-161.6696, 66.6158],
    [-161.6859, 66.6186],
    [-161.6881, 66.6225],
    [-161.6963, 66.6251],
    [-161.7066, 66.6305],
    [-161.7120, 66.6357],
    [-161.7194, 66.6387],
    [-161.7277, 66.6417],
    [-161.7303, 66.6483],
    [-161.7422, 66.6511],
    [-161.7692, 66.6591],
    [-161.7763, 66.6664],
    [-161.7859, 66.6664],
    [-161.7953, 66.6743],
    [-161.8061, 66.6783],
    [-161.8132, 66.6808],
    [-161.8143, 66.6825],
    [-161.8198, 66.6863],
    [-161.8384, 66.6896],
    [-161.8431, 66.6953],
    [-161.8668, 66.7040],
    [-161.8679, 66.7103],
    [-161.8824, 66.7147],
    [-161.8845, 66.7201],
    [-161.8700, 66.7318],
    [-161.8647, 66.7403],
    [-161.8500, 66.7565],
    [-161.8461, 66.7616],
    [-161.8473, 66.7668],
    [-161.8517, 66.7713],
    [-161.8554, 66.7750],
    [-161.8640, 66.7794],
    [-161.8618, 66.7834],
    [-161.8569, 66.7849],
    [-161.8615, 66.7879],
    [-161.8633, 66.7962],
    [-161.8638, 66.8003],
    [-161.8599, 66.8040],
    [-161.8534, 66.8017],
    [-161.8476, 66.8004],
    [-161.8488, 66.8042],
    [-161.8534, 66.8105],
    [-161.8496, 66.8135],
    [-161.8367, 66.8159],
    [-161.8217, 66.8194],
    [-161.8162, 66.8216],
    [-161.8027, 66.8323],
    [-161.7973, 66.8354],
    [-161.7947, 66.8384],
    [-161.7927, 66.8439],
    [-161.7873, 66.8496],
    [-161.7863, 66.8537],
    [-161.7814, 66.8524],
    [-161.7823, 66.8535],
    [-161.7809, 66.8552],
    [-161.7807, 66.8578],
    [-161.7817, 66.8595],
    [-161.7796, 66.8606],
    [-161.7813, 66.8618],
    [-161.7809, 66.8644],
    [-161.7805, 66.8668],
    [-161.7894, 66.8729],
    [-161.7944, 66.8819],
    [-161.7803, 66.8930],
    [-161.7583, 66.9013],
    [-161.7505, 66.9023],
    [-161.7341, 66.9069],
    [-161.7294, 66.9093],
    [-161.7238, 66.9139],
    [-161.7174, 66.9151],
    [-161.7180, 66.9195],
    [-161.7153, 66.9273],
    [-161.7147, 66.9346],
    [-161.7025, 66.9418],
    [-161.6929, 66.9443],
    [-161.6823, 66.9460],
    [-161.6719, 66.9425],
    [-161.6519, 66.9456],
    [-161.6446, 66.9545],
    [-161.6350, 66.9539],
    [-161.6149, 66.9509],
    [-161.5982, 66.9464],
    [-161.5795, 66.9426],
    [-161.5714, 66.9387],
    [-161.5442, 66.9384],
    [-161.5233, 66.9396],
    [-161.5029, 66.9399],
    [-161.4833, 66.9447],
    [-161.4793, 66.9496],
    [-161.4817, 66.9549],
    [-161.4833, 66.9579],
    [-161.4897, 66.9607],
    [-161.4906, 66.9649],
    [-161.4904, 66.9711],
    [-161.4997, 66.9731],
    [-161.5038, 66.9793],
    [-161.5101, 66.9802],
    [-161.5157, 66.9841],
    [-161.5312, 66.9881],
    [-161.5435, 66.9893],
    [-161.5695, 66.9859],
    [-161.5830, 66.9845],
    [-161.5941, 66.9872],
    [-161.6003, 66.9914],
    [-161.6102, 67.0010],
    [-161.6176, 67.0049],
    [-161.6215, 67.0096],
    [-161.6351, 67.0103],
    [-161.6476, 67.0085],
    [-161.6564, 67.0074],
    [-161.6665, 67.0087],
    [-161.6595, 67.0134],
    [-161.6601, 67.0180],
    [-161.6543, 67.0213],
    [-161.6583, 67.0211],
    [-161.6654, 67.0177],
    [-161.6744, 67.0166],
    [-161.6815, 67.0196],
    [-161.6917, 67.0247],
    [-161.6995, 67.0255],
    [-161.7053, 67.0235],
    [-161.7101, 67.0211],
    [-161.7106, 67.0158],
    [-161.7028, 67.0134],
    [-161.7055, 67.0079],
    [-161.7107, 67.0036],
    [-161.7126, 66.9994],
    [-161.7167, 66.9960],
    [-161.7231, 66.9994],
    [-161.7260, 67.0035],
    [-161.7294, 67.0074],
    [-161.7337, 67.0122],
    [-161.7444, 67.0190],
    [-161.7598, 67.0298],
    [-161.7654, 67.0297],
    [-161.7678, 67.0268],
    [-161.7724, 67.0297],
    [-161.7880, 67.0375],
    [-161.7868, 67.0417],
    [-161.7922, 67.0435],
    [-161.7983, 67.0415],
    [-161.8051, 67.0439],
    [-161.8046, 67.0457],
    [-161.8193, 67.0484],
    [-161.8332, 67.0486],
    [-161.8448, 67.0495],
    [-161.8521, 67.0487],
    [-161.8661, 67.0497],
    [-161.8802, 67.0481],
    [-161.8930, 67.0470],
    [-161.8984, 67.0444],
    [-161.9040, 67.0432],
    [-161.9192, 67.0415],
    [-161.9461, 67.0419],
    [-161.9677, 67.0409],
    [-161.9763, 67.0392],
    [-162.0035, 67.0360],
    [-162.0188, 67.0339],
    [-162.0506, 67.0303],
    [-162.0797, 67.0274],
    [-162.1027, 67.0252],
    [-162.1346, 67.0201],
    [-162.1462, 67.0186],
    [-162.1643, 67.0149],
    [-162.1743, 67.0125],
    [-162.1850, 67.0105],
    [-162.2228, 66.9999],
    [-162.2303, 66.9969],
    [-162.2324, 66.9933],
    [-162.2517, 66.9943],
    [-162.3010, 66.9941],
    [-162.3514, 66.9943],
    [-162.3853, 66.9904],
    [-162.4181, 66.9839],
    [-162.4342, 66.9813],
    [-162.4684, 66.9806],
    [-162.5017, 66.9772],
    [-162.5785, 66.9864],
    [-162.6227, 66.9922],
    [-162.6286, 67.0025],
    [-162.6496, 67.0074],
    [-162.6674, 67.0161],
    [-162.6864, 67.0254],
    [-162.7041, 67.0335],
    [-162.7261, 67.0308],
    [-162.7256, 67.0433],
    [-162.7092, 67.0471],
    [-162.7168, 67.0504],
    [-162.7361, 67.0481],
    [-162.7382, 67.0348],
    [-162.7551, 67.0152],
    [-162.7755, 67.0184],
    [-162.7660, 67.0199],
    [-162.7494, 67.0314],
    [-162.7491, 67.0469],
    [-162.8044, 67.0381],
    [-162.8314, 67.0349],
    [-162.8447, 67.0353],
    [-162.8349, 67.0388],
    [-162.8235, 67.0428],
    [-162.8468, 67.0413],
    [-162.8944, 67.0348],
    [-162.9106, 67.0375],
    [-162.9319, 67.0359],
    [-162.9323, 67.0272],
    [-162.9396, 67.0211],
    [-162.9356, 67.0173],
    [-162.9212, 67.0140],
    [-162.9048, 67.0139],
    [-162.8977, 67.0188],
    [-162.8967, 67.0211],
    [-162.8979, 67.0159],
    [-162.8937, 67.0118],
    [-162.8849, 67.0099],
    [-162.8762, 67.0085],
    [-162.8678, 67.0074],
    [-162.8629, 67.0110],
    [-162.8540, 67.0138],
    [-162.8461, 67.0068],
    [-162.8337, 67.0093],
    [-162.8168, 66.9995],
    [-162.8192, 66.9947],
    [-162.8265, 66.9926],
    [-162.8394, 66.9911],
    [-162.8474, 66.9924],
    [-162.8794, 66.9993],
    [-162.9341, 67.0155],
    [-162.9905, 67.0272],
    [-163.0466, 67.0354],
    [-163.1083, 67.0405],
    [-163.1482, 67.0455],
    [-163.1938, 67.0518],
    [-163.2588, 67.0576],
    [-163.3105, 67.0625],
    [-163.3471, 67.0667],
    [-163.3814, 67.0723],
    [-163.4423, 67.0810],
    [-163.5028, 67.0859],
    [-163.5566, 67.0897],
    [-163.6135, 67.0943],
    [-163.6500, 67.0977],
    [-163.6899, 67.1060],
    [-163.7256, 67.1169],
    [-163.7447, 67.1264],
    [-163.7459, 67.1371],
    [-163.7392, 67.1701],
    [-163.7409, 67.1888],
    [-163.7433, 67.2024],
    [-163.7485, 67.2187],
    [-163.7589, 67.2485],
    [-163.7696, 67.2694],
    [-163.7862, 67.2994],
    [-163.7936, 67.3029],
    [-163.8115, 67.3337],
    [-163.8234, 67.3489],
    [-163.8374, 67.3709],
    [-163.8589, 67.3989],
    [-163.8717, 67.4135],
    [-163.8912, 67.4326],
    [-163.9076, 67.4465],
    [-163.9136, 67.4514],
    [-163.9545, 67.4904],
    [-163.9737, 67.5078],
    [-163.9914, 67.5234],
    [-164.0130, 67.5419],
    [-164.0334, 67.5575],
    [-164.0597, 67.5756],
    [-164.0788, 67.5869],
    [-164.1001, 67.5972],
    [-164.1327, 67.6124],
    [-164.1653, 67.6257],
    [-164.1946, 67.6352],
    [-164.2435, 67.6494],
    [-164.2790, 67.6582],
    [-164.3535, 67.6776],
    [-164.4302, 67.6971],
    [-164.4631, 67.7070],
    [-164.4840, 67.7130],
    [-164.5023, 67.7177],
    [-164.5303, 67.7234],
    [-164.5510, 67.7305],
    [-164.5751, 67.7402],
    [-164.5877, 67.7454],
    [-164.6151, 67.7575],
    [-164.6505, 67.7715],
    [-164.6721, 67.7790],
    [-164.6838, 67.7825],
    [-164.7197, 67.7982],
    [-164.7710, 67.8184],
    [-164.8313, 67.8418],
    [-164.8717, 67.8571],
    [-164.8908, 67.8631],
    [-164.9143, 67.8697],
    [-164.9354, 67.8771],
    [-164.9511, 67.8827],
    [-164.9659, 67.8880],
    [-165.0005, 67.9006],
    [-165.0378, 67.9152],
    [-165.0715, 67.9275],
    [-165.0825, 67.9314],
    [-165.1128, 67.9412],
    [-165.1337, 67.9469],
    [-165.1615, 67.9545],
    [-165.1883, 67.9650],
    [-165.2036, 67.9748],
    [-165.2257, 67.9851],
    [-165.2645, 68.0003],
    [-165.3007, 68.0126],
    [-165.3361, 68.0241],
    [-165.3761, 68.0348],
    [-165.4207, 68.0452],
    [-165.4751, 68.0562],
    [-165.5484, 68.0682],
    [-165.6608, 68.0867],
    [-165.7096, 68.0932],
    [-165.7619, 68.0974],
    [-165.8046, 68.0999],
    [-165.8480, 68.1067],
    [-165.8794, 68.1118],
    [-165.8910, 68.1153],
    [-165.8982, 68.1183],
    [-165.9287, 68.1265],
    [-165.9542, 68.1328],
    [-165.9687, 68.1380],
    [-165.9817, 68.1434],
    [-165.9881, 68.1516],
    [-165.9933, 68.1581],
    [-165.9964, 68.1627],
    [-166.0152, 68.1817],
    [-166.0305, 68.1921],
    [-166.0765, 68.2178],
    [-166.1202, 68.2362],
    [-166.1789, 68.2562],
    [-166.2292, 68.2706],
    [-166.2985, 68.2879],
    [-166.3533, 68.2992],
    [-166.4095, 68.3089],
    [-166.4689, 68.3180],
    [-166.5079, 68.3234],
    [-166.5280, 68.3263],
    [-166.5538, 68.3292],
    [-166.5703, 68.3315],
    [-166.6066, 68.3355],
    [-166.6475, 68.3390],
    [-166.6668, 68.3403],
    [-166.7030, 68.3431],
    [-166.7545, 68.3442],
    [-166.8054, 68.3426],
    [-166.8379, 68.3387],
    [-166.8404, 68.3372],
    [-166.8322, 68.3440],
    [-166.8079, 68.3518],
    [-166.7426, 68.3641],
    [-166.7078, 68.3697],
    [-166.6325, 68.3819],
    [-166.4939, 68.4022],
    [-166.4421, 68.4114],
    [-166.4205, 68.4166],
    [-166.3919, 68.4218],
    [-166.3410, 68.4364],
    [-166.3312, 68.4413],
    [-166.3276, 68.4443],
    [-166.3254, 68.4481],
    [-166.3273, 68.4509],
    [-166.3189, 68.4557],
    [-166.3061, 68.4641],
    [-166.3054, 68.4669],
    [-166.3035, 68.4732],
    [-166.3053, 68.4787],
    [-166.3057, 68.4823],
    [-166.3106, 68.4840],
    [-166.3094, 68.4862],
    [-166.3077, 68.4890],
    [-166.3054, 68.4934],
    [-166.2991, 68.4993],
    [-166.2956, 68.5030],
    [-166.2953, 68.5077],
    [-166.2973, 68.5122],
    [-166.3034, 68.5167],
    [-166.2956, 68.5208],
    [-166.2841, 68.5261],
    [-166.2633, 68.5395],
    [-166.2570, 68.5459],
    [-166.2429, 68.5562],
    [-166.2281, 68.5739],
    [-166.2267, 68.5810],
    [-166.2311, 68.5903],
    [-166.2366, 68.5959],
    [-166.2360, 68.5978],
    [-166.2349, 68.6019],
    [-166.2309, 68.6124],
    [-166.2297, 68.6204],
    [-166.2181, 68.6429],
    [-166.2239, 68.6465],
    [-166.2273, 68.6483],
    [-166.2340, 68.6513],
    [-166.2190, 68.6633],
    [-166.1996, 68.6877],
    [-166.1960, 68.7001],
    [-166.1990, 68.7055],
    [-166.2005, 68.7109],
    [-166.2038, 68.7154],
    [-166.1999, 68.7265],
    [-166.1971, 68.7392],
    [-166.1970, 68.7534],
    [-166.1948, 68.7623],
    [-166.1911, 68.7731],
    [-166.1936, 68.7957],
    [-166.1998, 68.8088],
    [-166.2050, 68.8181],
    [-166.2105, 68.8345],
    [-166.2132, 68.8410],
    [-166.2158, 68.8474],
    [-166.2194, 68.8586],
    [-166.2244, 68.8623],
    [-166.2248, 68.8664],
    [-166.2286, 68.8727],
    [-166.2242, 68.8771],
    [-166.2189, 68.8798],
    [-166.2081, 68.8820],
    [-166.1983, 68.8819],
    [-166.1560, 68.8779],
    [-166.0744, 68.8731],
    [-166.0044, 68.8690],
    [-165.8816, 68.8634],
    [-165.8159, 68.8611],
    [-165.7719, 68.8595],
    [-165.7161, 68.8562],
    [-165.6407, 68.8523],
    [-165.5668, 68.8510],
    [-165.5296, 68.8539],
    [-165.4634, 68.8548],
    [-165.3542, 68.8574],
    [-165.3081, 68.8601],
    [-165.2825, 68.8613],
    [-165.2577, 68.8632],
    [-165.2323, 68.8650],
    [-165.1898, 68.8672],
    [-165.1492, 68.8696],
    [-165.1203, 68.8736],
    [-165.0963, 68.8759],
    [-165.0428, 68.8789],
    [-165.0167, 68.8808],
    [-164.9656, 68.8845],
    [-164.9064, 68.8896],
    [-164.8539, 68.8937],
    [-164.8163, 68.8946],
    [-164.7662, 68.8979],
    [-164.7115, 68.9027],
    [-164.6545, 68.9106],
    [-164.6157, 68.9152],
    [-164.5887, 68.9158],
    [-164.5086, 68.9155],
    [-164.4359, 68.9184],
    [-164.3798, 68.9212],
    [-164.3369, 68.9235],
    [-164.2994, 68.9263],
    [-164.2393, 68.9316],
    [-164.2132, 68.9348],
    [-164.1615, 68.9433],
    [-164.1338, 68.9501],
    [-164.1134, 68.9565],
    [-164.0642, 68.9702],
    [-163.9818, 68.9844],
    [-163.9487, 68.9909],
    [-163.9046, 69.0026],
    [-163.8751, 69.0154],
    [-163.8492, 69.0293],
    [-163.8127, 69.0410],
    [-163.7381, 69.0607],
    [-163.6941, 69.0711],
    [-163.6532, 69.0889],
    [-163.6242, 69.1011],
    [-163.5578, 69.1287],
    [-163.5261, 69.1457],
    [-163.5014, 69.1639],
    [-163.4864, 69.1764],
    [-163.4687, 69.1895],
    [-163.4514, 69.1982],
    [-163.4200, 69.2123],
    [-163.3938, 69.2233],
    [-163.2947, 69.2751],
    [-163.2571, 69.2974],
    [-163.2264, 69.3203],
    [-163.2024, 69.3438],
    [-163.1758, 69.3752],
    [-163.1591, 69.4034],
    [-163.1541, 69.4157],
    [-163.1509, 69.4236],
    [-163.1469, 69.4503],
    [-163.1457, 69.4566],
    [-163.1494, 69.4724],
    [-163.1460, 69.5076],
    [-163.1447, 69.5310],
    [-163.1460, 69.5529],
    [-163.1477, 69.5700],
    [-163.1508, 69.5958],
    [-163.1497, 69.6200],
    [-163.1445, 69.6327],
    [-163.1336, 69.6510],
    [-163.1221, 69.6634],
    [-163.1110, 69.6724],
    [-163.1028, 69.6734],
    [-163.1075, 69.6759],
    [-163.1076, 69.6793],
    [-163.0997, 69.6939],
    [-163.0948, 69.7034],
    [-163.0896, 69.7119],
    [-163.0760, 69.7313],
    [-163.0649, 69.7461],
    [-163.0653, 69.7503],
    [-163.0539, 69.7623],
    [-163.0349, 69.7881],
    [-163.0097, 69.8127],
    [-162.9839, 69.8284],
    [-162.9559, 69.8434],
    [-162.9328, 69.8553],
    [-162.8985, 69.8721],
    [-162.8528, 69.8946],
    [-162.8343, 69.9012],
    [-162.8158, 69.9111],
    [-162.7575, 69.9456],
    [-162.6785, 69.9873],
    [-162.6415, 70.0128],
    [-162.6135, 70.0312],
    [-162.5868, 70.0531],
    [-162.5587, 70.0726],
    [-162.5316, 70.0850],
    [-162.5158, 70.0941],
    [-162.4988, 70.1037],
    [-162.4753, 70.1240],
    [-162.4458, 70.1400],
    [-162.4064, 70.1573],
    [-162.3560, 70.1839],
    [-162.3190, 70.1986],
    [-162.2724, 70.2138],
    [-162.2070, 70.2328],
    [-162.1364, 70.2521],
    [-162.0744, 70.2708],
    [-162.0578, 70.2740],
    [-162.0463, 70.2807],
    [-161.9935, 70.2948],
    [-161.9488, 70.3057],
    [-161.9287, 70.3138],
    [-161.8829, 70.3281],
    [-161.8441, 70.3256],
    [-161.6242, 70.3058],
    [-161.5341, 70.2990],
    [-161.4453, 70.2948],
    [-161.3836, 70.2960],
    [-161.3328, 70.2956],
    [-161.2882, 70.2968],
    [-161.2121, 70.3081],
    [-161.1515, 70.3178],
    [-161.0712, 70.3281],
    [-161.0344, 70.3328],
    [-160.9651, 70.3456],
    [-160.8833, 70.3627],
    [-160.8188, 70.3750],
    [-160.8002, 70.3791],
    [-160.7731, 70.3847],
    [-160.7191, 70.3998],
    [-160.6734, 70.4104],
    [-160.6285, 70.4225],
    [-160.5740, 70.4373],
    [-160.5230, 70.4522],
    [-160.4823, 70.4656],
    [-160.4098, 70.4907],
    [-160.3490, 70.5120],
    [-160.3056, 70.5273],
    [-160.2519, 70.5476],
    [-160.2077, 70.5645],
    [-160.1810, 70.5769],
    [-160.1558, 70.5894],
    [-160.1422, 70.5989],
    [-160.1275, 70.6061],
    [-160.1151, 70.6102],
    [-160.1019, 70.6127],
    [-160.1031, 70.6183],
    [-160.0959, 70.6202],
    [-160.0651, 70.6276],
    [-160.0296, 70.6431],
    [-159.9757, 70.6667],
    [-159.9358, 70.6837],
    [-159.8917, 70.7013],
    [-159.8111, 70.7282],
    [-159.7985, 70.7312],
    [-159.7195, 70.7638],
    [-159.6627, 70.7898],
    [-159.6383, 70.7979],
    [-159.5901, 70.8079],
    [-159.5460, 70.8171],
    [-159.4799, 70.8278],
    [-159.3455, 70.8484],
    [-159.2861, 70.8580],
    [-159.2541, 70.8628],
    [-159.1718, 70.8751],
    [-159.0951, 70.8807],
    [-159.0430, 70.8836],
    [-158.9936, 70.8897],
    [-158.9118, 70.9003],
    [-158.8498, 70.9069],
    [-158.7827, 70.9082],
    [-158.7757, 70.9029],
    [-158.8020, 70.9064],
    [-158.8553, 70.9027],
    [-158.8854, 70.8985],
    [-158.9380, 70.8934],
    [-158.9786, 70.8853],
    [-159.0136, 70.8818],
    [-159.0439, 70.8810],
    [-159.0722, 70.8806],
    [-159.1049, 70.8747],
    [-159.1188, 70.8764],
    [-159.1281, 70.8721],
    [-159.1349, 70.8690],
    [-159.1586, 70.8697],
    [-159.1737, 70.8658],
    [-159.1978, 70.8648],
    [-159.2117, 70.8648],
    [-159.2248, 70.8622],
    [-159.2332, 70.8615],
    [-159.2529, 70.8600],
    [-159.2808, 70.8564],
    [-159.3073, 70.8525],
    [-159.3182, 70.8481],
    [-159.3115, 70.8442],
    [-159.2941, 70.8440],
    [-159.2778, 70.8448],
    [-159.2552, 70.8439],
    [-159.2398, 70.8465],
    [-159.2283, 70.8455],
    [-159.2140, 70.8471],
    [-159.2024, 70.8475],
    [-159.1911, 70.8518],
    [-159.1831, 70.8546],
    [-159.1675, 70.8591],
    [-159.1605, 70.8481],
    [-159.1593, 70.8393],
    [-159.1650, 70.8364],
    [-159.1462, 70.8351],
    [-159.1150, 70.8174],
    [-159.1887, 70.8175],
    [-159.2253, 70.8149],
    [-159.2379, 70.8135],
    [-159.2529, 70.8134],
    [-159.2708, 70.8087],
    [-159.2996, 70.8107],
    [-159.3281, 70.8042],
    [-159.3448, 70.8047],
    [-159.3450, 70.7972],
    [-159.3427, 70.7867],
    [-159.3433, 70.7793],
    [-159.3219, 70.7762],
    [-159.2997, 70.7581],
    [-159.2657, 70.7636],
    [-159.2584, 70.7748],
    [-159.1981, 70.7601],
    [-159.1721, 70.7617],
    [-159.1482, 70.7591],
    [-159.1099, 70.7598],
    [-159.0833, 70.7651],
    [-159.0658, 70.7671],
    [-159.0523, 70.7733],
    [-159.0461, 70.7732],
    [-159.0317, 70.7654],
    [-159.0091, 70.7640],
    [-158.9772, 70.7667],
    [-158.9586, 70.7736],
    [-158.9494, 70.7834],
    [-158.9686, 70.7920],
    [-158.9845, 70.7932],
    [-159.0373, 70.8003],
    [-159.0497, 70.7968],
    [-159.0633, 70.8016],
    [-159.0689, 70.8161],
    [-159.0169, 70.8084],
    [-158.9696, 70.7995],
    [-158.9156, 70.7940],
    [-158.8554, 70.7913],
    [-158.7804, 70.7888],
    [-158.7353, 70.7872],
    [-158.6841, 70.7856],
    [-158.6452, 70.7871],
    [-158.5739, 70.7950],
    [-158.5536, 70.7962],
    [-158.5226, 70.7925],
    [-158.4841, 70.8004],
    [-158.4624, 70.8029],
    [-158.4501, 70.8022],
    [-158.4158, 70.7980],
    [-158.3890, 70.8013],
    [-158.3629, 70.8147],
    [-158.3714, 70.8212],
    [-158.3969, 70.8225],
    [-158.4382, 70.8261],
    [-158.4887, 70.8333],
    [-158.5447, 70.8377],
    [-158.5633, 70.8402],
    [-158.5118, 70.8373],
    [-158.3694, 70.8222],
    [-158.2511, 70.8170],
    [-158.1598, 70.8200],
    [-158.0303, 70.8312],
    [-157.9450, 70.8431],
    [-157.7685, 70.8758],
    [-157.6231, 70.9155],
    [-157.5463, 70.9370],
    [-157.4597, 70.9626],
    [-157.3320, 71.0122],
    [-157.2446, 71.0519],
    [-157.1805, 71.0890],
    [-157.1498, 71.1073],
    [-157.1229, 71.1246],
    [-157.0863, 71.1437],
    [-157.0656, 71.1539],
    [-157.0017, 71.1915],
    [-156.8493, 71.2666],
    [-156.7947, 71.2922],
    [-156.6456, 71.3380],
    [-156.6201, 71.3442],
    [-156.5654, 71.3268],
    [-156.5603, 71.3133],
    [-156.5495, 71.3093],
    [-156.5335, 71.2972],
    [-156.5199, 71.2935],
    [-156.4963, 71.2892],
    [-156.4836, 71.2876],
    [-156.4664, 71.2862],
    [-156.4540, 71.2866],
    [-156.4456, 71.2897],
    [-156.4386, 71.2878],
    [-156.4343, 71.2862],
    [-156.4290, 71.2821],
    [-156.4211, 71.2772],
    [-156.4130, 71.2723],
    [-156.4098, 71.2700],
    [-156.4073, 71.2676],
    [-156.3885, 71.2662],
    [-156.3767, 71.2633],
    [-156.3611, 71.2612],
    [-156.3430, 71.2597],
    [-156.3214, 71.2598],
    [-156.3083, 71.2604],
    [-156.2974, 71.2608],
    [-156.2932, 71.2646],
    [-156.2672, 71.2626],
    [-156.2559, 71.2619],
    [-156.2450, 71.2605],
    [-156.2253, 71.2590],
    [-156.2155, 71.2581],
    [-156.2046, 71.2569],
    [-156.1932, 71.2551],
    [-156.1764, 71.2537],
    [-156.1643, 71.2491],
    [-156.1582, 71.2480],
    [-156.1511, 71.2460],
    [-156.1458, 71.2448],
    [-156.1371, 71.2439],
    [-156.1285, 71.2426],
    [-156.1200, 71.2432],
    [-156.1124, 71.2423],
    [-156.0998, 71.2415],
    [-156.0897, 71.2400],
    [-156.0793, 71.2389],
    [-156.0823, 71.2340],
    [-156.0869, 71.2285],
    [-156.0943, 71.2253],
    [-156.0899, 71.2222],
    [-156.0764, 71.2215],
    [-156.0653, 71.2164],
    [-156.0545, 71.2141],
    [-156.0487, 71.2116],
    [-156.0356, 71.2036],
    [-156.0292, 71.2015],
    [-156.0333, 71.1990],
    [-156.0419, 71.1957],
    [-156.0453, 71.1934],
    [-156.0481, 71.1878],
    [-156.0539, 71.1832],
    [-156.0654, 71.1816],
    [-156.0695, 71.1781],
    [-156.0859, 71.1791],
    [-156.0919, 71.1756],
    [-156.0805, 71.1686],
    [-156.0682, 71.1680],
    [-156.0508, 71.1695],
    [-156.0466, 71.1723],
    [-156.0343, 71.1707],
    [-156.0244, 71.1713],
    [-156.0102, 71.1736],
    [-156.0001, 71.1754],
    [-155.9933, 71.1771],
    [-155.9873, 71.1822],
    [-155.9758, 71.1824],
    [-155.9619, 71.1842],
    [-155.9519, 71.1885],
    [-155.9455, 71.1981],
    [-155.9434, 71.2081],
    [-155.9468, 71.2100],
    [-155.9377, 71.2118],
    [-155.9210, 71.2096],
    [-155.9146, 71.2009],
    [-155.9070, 71.1944],
    [-155.8875, 71.1860],
    [-155.8763, 71.1857],
    [-155.8655, 71.1866],
    [-155.8521, 71.1865],
    [-155.8343, 71.1882],
    [-155.8053, 71.1936],
    [-155.7891, 71.1924],
    [-155.7822, 71.1911],
    [-155.7695, 71.1897],
    [-155.7599, 71.1895],
    [-155.7494, 71.1918],
    [-155.7443, 71.1928],
    [-155.7341, 71.1908],
    [-155.7207, 71.1819],
    [-155.7072, 71.1787],
    [-155.6913, 71.1793],
    [-155.6743, 71.1811],
    [-155.6528, 71.1810],
    [-155.6395, 71.1778],
    [-155.6300, 71.1766],
    [-155.6192, 71.1724],
    [-155.6069, 71.1707],
    [-155.5965, 71.1693],
    [-155.5876, 71.1702],
    [-155.5794, 71.1661],
    [-155.5686, 71.1628],
    [-155.5693, 71.1585],
    [-155.5701, 71.1512],
    [-155.5721, 71.1461],
    [-155.5697, 71.1365],
    [-155.5653, 71.1327],
    [-155.5612, 71.1285],
    [-155.5504, 71.1224],
    [-155.5323, 71.1105],
    [-155.5232, 71.1031],
    [-155.5150, 71.0962],
    [-155.5120, 71.0824],
    [-155.5171, 71.0770],
    [-155.5276, 71.0718],
    [-155.5339, 71.0669],
    [-155.5467, 71.0603],
    [-155.5636, 71.0583],
    [-155.5713, 71.0570],
    [-155.5776, 71.0556],
    [-155.5844, 71.0532],
    [-155.5895, 71.0503],
    [-155.5932, 71.0434],
    [-155.6010, 71.0411],
    [-155.6173, 71.0448],
    [-155.6279, 71.0433],
    [-155.6376, 71.0399],
    [-155.6464, 71.0343],
    [-155.6566, 71.0289],
    [-155.6573, 71.0263],
    [-155.6567, 71.0223],
    [-155.6680, 71.0216],
    [-155.6870, 71.0222],
    [-155.6958, 71.0207],
    [-155.7069, 71.0149],
    [-155.7144, 71.0008],
    [-155.7127, 70.9940],
    [-155.7188, 70.9898],
    [-155.7252, 70.9847],
    [-155.7364, 70.9841],
    [-155.7621, 70.9861],
    [-155.7795, 70.9845],
    [-155.7954, 70.9778],
    [-155.8121, 70.9646],
    [-155.8237, 70.9596],
    [-155.8260, 70.9635],
    [-155.8384, 70.9683],
    [-155.8569, 70.9706],
    [-155.8771, 70.9685],
    [-155.8894, 70.9684],
    [-155.9076, 70.9670],
    [-155.9306, 70.9657],
    [-155.9497, 70.9665],
    [-155.9586, 70.9657],
    [-155.9713, 70.9636],
    [-155.9870, 70.9650],
    [-155.9974, 70.9637],
    [-156.0051, 70.9620],
    [-156.0123, 70.9599],
    [-156.0152, 70.9564],
    [-156.0127, 70.9506],
    [-155.9948, 70.9419],
    [-155.9910, 70.9384],
    [-155.9853, 70.9326],
    [-155.9800, 70.9222],
    [-155.9793, 70.9185],
    [-155.9738, 70.9153],
    [-155.9749, 70.9073],
    [-155.9900, 70.9067],
    [-156.0077, 70.9033],
    [-155.9977, 70.8949],
    [-155.9706, 70.8951],
    [-155.9548, 70.8946],
    [-155.9498, 70.8888],
    [-155.9424, 70.8832],
    [-155.9357, 70.8746],
    [-155.9320, 70.8648],
    [-155.9250, 70.8527],
    [-155.9418, 70.8431],
    [-155.8768, 70.8292],
    [-155.8585, 70.8287],
    [-155.8409, 70.8286],
    [-155.8209, 70.8309],
    [-155.8003, 70.8325],
    [-155.7707, 70.8296],
    [-155.7431, 70.8321],
    [-155.7145, 70.8340],
    [-155.6943, 70.8402],
    [-155.6883, 70.8436],
    [-155.6792, 70.8426],
    [-155.6691, 70.8437],
    [-155.6610, 70.8397],
    [-155.6584, 70.8311],
    [-155.6390, 70.8266],
    [-155.6080, 70.8241],
    [-155.6056, 70.8314],
    [-155.6063, 70.8384],
    [-155.6059, 70.8497],
    [-155.6115, 70.8523],
    [-155.6123, 70.8580],
    [-155.6140, 70.8601],
    [-155.6011, 70.8561],
    [-155.5880, 70.8495],
    [-155.5617, 70.8445],
    [-155.5507, 70.8457],
    [-155.5386, 70.8477],
    [-155.5215, 70.8536],
    [-155.5129, 70.8576],
    [-155.5090, 70.8613],
    [-155.5034, 70.8572],
    [-155.4887, 70.8570],
    [-155.4848, 70.8599],
    [-155.4812, 70.8646],
    [-155.4862, 70.8696],
    [-155.4831, 70.8773],
    [-155.4839, 70.8882],
    [-155.4902, 70.9092],
    [-155.5065, 70.9281],
    [-155.5133, 70.9406],
    [-155.5022, 70.9440],
    [-155.4760, 70.9441],
    [-155.4528, 70.9487],
    [-155.4182, 70.9636],
    [-155.4030, 70.9715],
    [-155.3857, 70.9769],
    [-155.3743, 70.9845],
    [-155.3687, 70.9928],
    [-155.3582, 70.9978],
    [-155.3331, 71.0009],
    [-155.3121, 71.0052],
    [-155.2851, 71.0113],
    [-155.2667, 71.0137],
    [-155.2579, 71.0156],
    [-155.2492, 71.0071],
    [-155.2303, 70.9929],
    [-155.2024, 70.9774],
    [-155.1827, 70.9781],
    [-155.1652, 70.9866],
    [-155.1578, 70.9992],
    [-155.1596, 71.0131],
    [-155.1682, 71.0221],
    [-155.1914, 71.0362],
    [-155.2069, 71.0398],
    [-155.2241, 71.0506],
    [-155.2423, 71.0576],
    [-155.2653, 71.0639],
    [-155.2596, 71.0730],
    [-155.2464, 71.0816],
    [-155.2130, 71.0904],
    [-155.1998, 71.0920],
    [-155.1754, 71.0985],
    [-155.1577, 71.1037],
    [-155.1473, 71.1064],
    [-155.1277, 71.1096],
    [-155.1239, 71.1080],
    [-155.1438, 71.1009],
    [-155.1299, 71.0824],
    [-155.1126, 71.0713],
    [-155.0990, 71.0695],
    [-155.0700, 71.0740],
    [-155.0659, 71.0932],
    [-155.0732, 71.1141],
    [-155.0820, 71.1192],
    [-155.1122, 71.1267],
    [-155.0964, 71.1292],
    [-155.0778, 71.1332],
    [-155.0962, 71.1442],
    [-155.0795, 71.1514],
    [-155.0330, 71.1434],
    [-154.9993, 71.1360],
    [-154.9428, 71.1219],
    [-154.9099, 71.1145],
    [-154.8775, 71.1059],
    [-154.8327, 71.0913],
    [-154.7797, 71.0763],
    [-154.7472, 71.0660],
    [-154.7039, 71.0502],
    [-154.6452, 71.0284],
    [-154.6093, 71.0157],
    [-154.5772, 70.9987],
    [-154.5599, 70.9797],
    [-154.5658, 70.9774],
    [-154.5777, 70.9867],
    [-154.5981, 70.9792],
    [-154.6145, 70.9517],
    [-154.6095, 70.9256],
    [-154.6095, 70.9054],
    [-154.5974, 70.8826],
    [-154.6017, 70.8744],
    [-154.6067, 70.8659],
    [-154.5986, 70.8549],
    [-154.5843, 70.8414],
    [-154.5725, 70.8259],
    [-154.5496, 70.8220],
    [-154.5092, 70.8260],
    [-154.4931, 70.8252],
    [-154.4842, 70.8237],
    [-154.4748, 70.8239],
    [-154.4574, 70.8236],
    [-154.4394, 70.8280],
    [-154.4165, 70.8295],
    [-154.3981, 70.8294],
    [-154.3802, 70.8305],
    [-154.3545, 70.8309],
    [-154.3443, 70.8332],
    [-154.3334, 70.8284],
    [-154.3244, 70.8278],
    [-154.3162, 70.8249],
    [-154.3059, 70.8226],
    [-154.2979, 70.8213],
    [-154.2689, 70.8187],
    [-154.2418, 70.8117],
    [-154.2231, 70.7991],
    [-154.2319, 70.7899],
    [-154.2466, 70.7837],
    [-154.2375, 70.7771],
    [-154.2185, 70.7739],
    [-154.1982, 70.7725],
    [-154.1749, 70.7680],
    [-154.1471, 70.7717],
    [-154.1183, 70.7789],
    [-154.1038, 70.7826],
    [-154.0846, 70.7870],
    [-154.0564, 70.7972],
    [-154.0312, 70.8089],
    [-154.0045, 70.8172],
    [-153.9891, 70.8251],
    [-153.9721, 70.8408],
    [-153.9500, 70.8581],
    [-153.9398, 70.8636],
    [-153.9367, 70.8704],
    [-153.9410, 70.8745],
    [-153.9215, 70.8788],
    [-153.8806, 70.8828],
    [-153.8371, 70.8848],
    [-153.8050, 70.8860],
    [-153.7753, 70.8869],
    [-153.7494, 70.8887],
    [-153.7215, 70.8886],
    [-153.6970, 70.8877],
    [-153.6664, 70.8834],
    [-153.6388, 70.8833],
    [-153.6304, 70.8857],
    [-153.5935, 70.8845],
    [-153.5486, 70.8836],
    [-153.4944, 70.8841],
    [-153.4583, 70.8858],
    [-153.4057, 70.8910],
    [-153.3392, 70.9013],
    [-153.2782, 70.9150],
    [-153.2360, 70.9198],
    [-153.2060, 70.9206],
    [-153.1807, 70.9190],
    [-153.1647, 70.9193],
    [-153.1476, 70.9186],
    [-153.1142, 70.9166],
    [-153.0763, 70.9134],
    [-153.0418, 70.9109],
    [-153.0444, 70.9078],
    [-153.0263, 70.8991],
    [-153.0078, 70.8955],
    [-152.9910, 70.8935],
    [-152.9797, 70.8925],
    [-152.9621, 70.8927],
    [-152.9581, 70.8924],
    [-152.9311, 70.8909],
    [-152.9115, 70.8860],
    [-152.9003, 70.8819],
    [-152.9073, 70.8793],
    [-152.9008, 70.8691],
    [-152.8793, 70.8567],
    [-152.8681, 70.8510],
    [-152.8612, 70.8499],
    [-152.8492, 70.8482],
    [-152.8371, 70.8473],
    [-152.8216, 70.8481],
    [-152.8152, 70.8480],
    [-152.8056, 70.8574],
    [-152.7967, 70.8663],
    [-152.7902, 70.8695],
    [-152.7860, 70.8725],
    [-152.7827, 70.8761],
    [-152.7829, 70.8802],
    [-152.7774, 70.8812],
    [-152.7676, 70.8799],
    [-152.7435, 70.8782],
    [-152.7299, 70.8732],
    [-152.7191, 70.8778],
    [-152.7010, 70.8828],
    [-152.6877, 70.8804],
    [-152.6584, 70.8778],
    [-152.6340, 70.8777],
    [-152.6087, 70.8795],
    [-152.5884, 70.8818],
    [-152.5545, 70.8756],
    [-152.5354, 70.8719],
    [-152.5217, 70.8705],
    [-152.5064, 70.8688],
    [-152.4917, 70.8656],
    [-152.4707, 70.8637],
    [-152.4352, 70.8605],
    [-152.4001, 70.8573],
    [-152.3728, 70.8506],
    [-152.3693, 70.8473],
    [-152.3459, 70.8430],
    [-152.3222, 70.8416],
    [-152.2998, 70.8379],
    [-152.2814, 70.8326],
    [-152.2725, 70.8321],
    [-152.2574, 70.8297],
    [-152.2370, 70.8271],
    [-152.2231, 70.8246],
    [-152.2029, 70.8160],
    [-152.1937, 70.8087],
    [-152.1929, 70.8015],
    [-152.2076, 70.7969],
    [-152.2194, 70.7960],
    [-152.2416, 70.7953],
    [-152.2583, 70.7940],
    [-152.2799, 70.7897],
    [-152.2964, 70.7836],
    [-152.3049, 70.7795],
    [-152.3123, 70.7733],
    [-152.3164, 70.7708],
    [-152.3247, 70.7634],
    [-152.3434, 70.7503],
    [-152.3521, 70.7411],
    [-152.3590, 70.7346],
    [-152.3690, 70.7264],
    [-152.3723, 70.7290],
    [-152.3741, 70.7350],
    [-152.3798, 70.7367],
    [-152.3947, 70.7334],
    [-152.4130, 70.7306],
    [-152.4189, 70.7274],
    [-152.4089, 70.7247],
    [-152.3991, 70.7237],
    [-152.3932, 70.7241],
    [-152.3871, 70.7183],
    [-152.3816, 70.7160],
    [-152.3901, 70.7120],
    [-152.3991, 70.7105],
    [-152.4019, 70.7066],
    [-152.4149, 70.7044],
    [-152.4242, 70.6932],
    [-152.4286, 70.6883],
    [-152.4298, 70.6908],
    [-152.4327, 70.6941],
    [-152.4411, 70.6917],
    [-152.4506, 70.6921],
    [-152.4631, 70.6930],
    [-152.4710, 70.6928],
    [-152.4788, 70.6823],
    [-152.4721, 70.6710],
    [-152.4705, 70.6665],
    [-152.4678, 70.6593],
    [-152.4651, 70.6444],
    [-152.4561, 70.6347],
    [-152.4451, 70.6293],
    [-152.4221, 70.6088],
    [-152.4115, 70.6073],
    [-152.4025, 70.6078],
    [-152.3907, 70.6073],
    [-152.3754, 70.6037],
    [-152.3641, 70.6007],
    [-152.3532, 70.5973],
    [-152.3344, 70.5979],
    [-152.3188, 70.6024],
    [-152.3215, 70.6071],
    [-152.3087, 70.6058],
    [-152.2871, 70.5987],
    [-152.2635, 70.5933],
    [-152.2243, 70.5885],
    [-152.2094, 70.5870],
    [-152.1830, 70.5849],
    [-152.1464, 70.5892],
    [-152.1273, 70.5905],
    [-152.1009, 70.5873],
    [-152.0787, 70.5845],
    [-152.0602, 70.5795],
    [-152.0662, 70.5731],
    [-152.0688, 70.5646],
    [-152.0770, 70.5668],
    [-152.0898, 70.5657],
    [-152.0999, 70.5624],
    [-152.1037, 70.5675],
    [-152.1167, 70.5696],
    [-152.1218, 70.5699],
    [-152.1257, 70.5694],
    [-152.1326, 70.5678],
    [-152.1382, 70.5709],
    [-152.1426, 70.5717],
    [-152.1523, 70.5744],
    [-152.1629, 70.5757],
    [-152.1746, 70.5767],
    [-152.1899, 70.5800],
    [-152.2133, 70.5827],
    [-152.2238, 70.5802],
    [-152.2351, 70.5763],
    [-152.2422, 70.5736],
    [-152.2560, 70.5695],
    [-152.2690, 70.5736],
    [-152.2843, 70.5751],
    [-152.3021, 70.5743],
    [-152.3191, 70.5722],
    [-152.3280, 70.5685],
    [-152.3342, 70.5735],
    [-152.3400, 70.5747],
    [-152.3512, 70.5757],
    [-152.3702, 70.5764],
    [-152.3827, 70.5752],
    [-152.3926, 70.5757],
    [-152.4006, 70.5747],
    [-152.4093, 70.5734],
    [-152.4229, 70.5714],
    [-152.4354, 70.5766],
    [-152.4478, 70.5771],
    [-152.4534, 70.5749],
    [-152.4680, 70.5765],
    [-152.5023, 70.5815],
    [-152.5181, 70.5808],
    [-152.5341, 70.5771],
    [-152.5424, 70.5740],
    [-152.5553, 70.5655],
    [-152.5619, 70.5611],
    [-152.5455, 70.5495],
    [-152.5369, 70.5451],
    [-152.5262, 70.5415],
    [-152.5228, 70.5399],
    [-152.5153, 70.5387],
    [-152.5068, 70.5392],
    [-152.4953, 70.5395],
    [-152.4796, 70.5411],
    [-152.4668, 70.5423],
    [-152.4572, 70.5442],
    [-152.4453, 70.5498],
    [-152.4334, 70.5533],
    [-152.4257, 70.5521],
    [-152.4175, 70.5503],
    [-152.4067, 70.5519],
    [-152.4001, 70.5507],
    [-152.3887, 70.5507],
    [-152.3707, 70.5514],
    [-152.3575, 70.5508],
    [-152.3440, 70.5512],
    [-152.3433, 70.5488],
    [-152.3532, 70.5439],
    [-152.3513, 70.5420],
    [-152.3427, 70.5414],
    [-152.3346, 70.5407],
    [-152.3247, 70.5400],
    [-152.3154, 70.5429],
    [-152.3108, 70.5456],
    [-152.2892, 70.5444],
    [-152.2759, 70.5437],
    [-152.2485, 70.5404],
    [-152.2393, 70.5408],
    [-152.2302, 70.5397],
    [-152.2163, 70.5412],
    [-152.2059, 70.5458],
    [-152.1982, 70.5481],
    [-152.1873, 70.5482],
    [-152.1780, 70.5516],
    [-152.1678, 70.5506],
    [-152.1596, 70.5513],
    [-152.1553, 70.5520],
    [-152.1415, 70.5507],
    [-152.1323, 70.5506],
    [-152.1242, 70.5514],
    [-152.1010, 70.5450],
    [-152.0940, 70.5454],
    [-152.0859, 70.5486],
    [-152.0709, 70.5469],
    [-152.0480, 70.5462],
    [-152.0337, 70.5547],
    [-152.0104, 70.5613],
    [-151.9988, 70.5622],
    [-151.9834, 70.5647],
    [-151.9668, 70.5622],
    [-151.9518, 70.5623],
    [-151.9333, 70.5562],
    [-151.9088, 70.5543],
    [-151.8996, 70.5552],
    [-151.8899, 70.5576],
    [-151.8723, 70.5535],
    [-151.8582, 70.5536],
    [-151.8481, 70.5523],
    [-151.8366, 70.5490],
    [-151.8159, 70.5474],
    [-151.8049, 70.5480],
    [-151.7872, 70.5492],
    [-151.7705, 70.5500],
    [-151.7567, 70.5535],
    [-151.7386, 70.5551],
    [-151.7115, 70.5553],
    [-151.7021, 70.5518],
    [-151.7160, 70.5476],
    [-151.7213, 70.5466],
    [-151.7315, 70.5433],
    [-151.7339, 70.5366],
    [-151.7391, 70.5371],
    [-151.7483, 70.5322],
    [-151.7489, 70.5288],
    [-151.7587, 70.5244],
    [-151.7633, 70.5225],
    [-151.7642, 70.5188],
    [-151.7668, 70.5175],
    [-151.7734, 70.5166],
    [-151.7807, 70.5119],
    [-151.7854, 70.5096],
    [-151.7885, 70.5067],
    [-151.7942, 70.5049],
    [-151.7928, 70.5007],
    [-151.7872, 70.4977],
    [-151.7751, 70.4936],
    [-151.7621, 70.4945],
    [-151.7533, 70.4989],
    [-151.7454, 70.5013],
    [-151.7404, 70.5045],
    [-151.7375, 70.5064],
    [-151.7339, 70.5064],
    [-151.7392, 70.5031],
    [-151.7328, 70.4991],
    [-151.7310, 70.4961],
    [-151.7423, 70.4948],
    [-151.7571, 70.4909],
    [-151.7740, 70.4875],
    [-151.7908, 70.4874],
    [-151.8010, 70.4864],
    [-151.8138, 70.4851],
    [-151.8308, 70.4856],
    [-151.8396, 70.4838],
    [-151.8478, 70.4811],
    [-151.8603, 70.4766],
    [-151.8681, 70.4789],
    [-151.8790, 70.4788],
    [-151.8938, 70.4762],
    [-151.8994, 70.4773],
    [-151.9163, 70.4753],
    [-151.9217, 70.4725],
    [-151.9293, 70.4679],
    [-151.9401, 70.4636],
    [-151.9491, 70.4558],
    [-151.9441, 70.4516],
    [-151.9249, 70.4452],
    [-151.9164, 70.4431],
    [-151.9100, 70.4408],
    [-151.9012, 70.4346],
    [-151.8936, 70.4332],
    [-151.8821, 70.4316],
    [-151.8638, 70.4325],
    [-151.8413, 70.4352],
    [-151.8251, 70.4348],
    [-151.8124, 70.4360],
    [-151.7918, 70.4361],
    [-151.7640, 70.4361],
    [-151.7525, 70.4343],
    [-151.7351, 70.4331],
    [-151.7262, 70.4334],
    [-151.7129, 70.4325],
    [-151.7025, 70.4313],
    [-151.6890, 70.4332],
    [-151.6736, 70.4358],
    [-151.6640, 70.4360],
    [-151.6465, 70.4334],
    [-151.6333, 70.4336],
    [-151.6149, 70.4350],
    [-151.5962, 70.4390],
    [-151.5721, 70.4393],
    [-151.5546, 70.4359],
    [-151.5418, 70.4337],
    [-151.5312, 70.4351],
    [-151.5092, 70.4294],
    [-151.4805, 70.4253],
    [-151.4496, 70.4219],
    [-151.2462, 70.3725],
    [-151.1464, 70.3776],
    [-151.0858, 70.4024],
    [-151.0467, 70.4279],
    [-150.9879, 70.4501],
    [-150.9038, 70.4609],
    [-150.8244, 70.4537],
    [-150.6984, 70.4478],
    [-150.6188, 70.4811],
    [-150.4964, 70.4712],
    [-150.3754, 70.4385],
    [-150.3062, 70.4155],
    [-150.1816, 70.4332],
    [-150.1439, 70.4340],
    [-150.1095, 70.4293],
    [-150.0548, 70.4454],
    [-150.0296, 70.4527],
    [-149.9398, 70.4842],
    [-149.8689, 70.5069],
    [-149.8404, 70.5002],
    [-149.8197, 70.4914],
    [-149.7904, 70.4912],
    [-149.7729, 70.4873],
    [-149.7607, 70.4953],
    [-149.7161, 70.5050],
    [-149.6913, 70.5014],
    [-149.6612, 70.5092],
    [-149.6173, 70.5008],
    [-149.5653, 70.4964],
    [-149.5369, 70.4994],
    [-149.5242, 70.5021],
    [-149.4865, 70.5110],
    [-149.4672, 70.5163],
    [-149.4447, 70.5074],
    [-149.4207, 70.4909],
    [-149.3873, 70.4872],
    [-149.3660, 70.4903],
    [-149.3429, 70.4984],
    [-149.3262, 70.5027],
    [-149.3135, 70.4929],
    [-149.2911, 70.4894],
    [-149.2808, 70.4885],
    [-149.2500, 70.4914],
    [-149.2367, 70.4899],
    [-149.2176, 70.4869],
    [-149.1899, 70.4854],
    [-149.1638, 70.4875],
    [-149.1565, 70.4831],
    [-149.1335, 70.4725],
    [-149.1056, 70.4679],
    [-149.0749, 70.4641],
    [-149.0540, 70.4627],
    [-149.0369, 70.4572],
    [-149.0230, 70.4509],
    [-148.9971, 70.4368],
    [-148.9745, 70.4330],
    [-148.9496, 70.4224],
    [-148.9145, 70.4274],
    [-148.8824, 70.4311],
    [-148.8851, 70.4237],
    [-148.8442, 70.4200],
    [-148.8356, 70.4140],
    [-148.8344, 70.4088],
    [-148.8028, 70.4079],
    [-148.7794, 70.4033],
    [-148.7409, 70.4108],
    [-148.7108, 70.4095],
    [-148.6732, 70.4052],
    [-148.6395, 70.3993],
    [-148.6062, 70.3958],
    [-148.5748, 70.3907],
    [-148.5601, 70.3836],
    [-148.5473, 70.3751],
    [-148.5373, 70.3774],
    [-148.5199, 70.3875],
    [-148.5319, 70.4032],
    [-148.5353, 70.4126],
    [-148.5281, 70.4133],
    [-148.5206, 70.3996],
    [-148.5245, 70.3958],
    [-148.5138, 70.3871],
    [-148.5215, 70.3834],
    [-148.5240, 70.3768],
    [-148.4937, 70.3697],
    [-148.4685, 70.3522],
    [-148.4609, 70.3389],
    [-148.4668, 70.3322],
    [-148.4700, 70.3271],
    [-148.4815, 70.3234],
    [-148.4854, 70.3196],
    [-148.4833, 70.3154],
    [-148.4849, 70.3115],
    [-148.4831, 70.3085],
    [-148.4735, 70.3104],
    [-148.4614, 70.3131],
    [-148.4501, 70.3119],
    [-148.4405, 70.3083],
    [-148.4319, 70.3080],
    [-148.4226, 70.3073],
    [-148.4093, 70.3042],
    [-148.3991, 70.3024],
    [-148.3911, 70.3026],
    [-148.3821, 70.3027],
    [-148.3698, 70.3026],
    [-148.3544, 70.3027],
    [-148.3397, 70.3063],
    [-148.3177, 70.3119],
    [-148.3048, 70.3169],
    [-148.2848, 70.3230],
    [-148.2603, 70.3314],
    [-148.2523, 70.3364],
    [-148.2353, 70.3380],
    [-148.2194, 70.3419],
    [-148.2035, 70.3482],
    [-148.2004, 70.3465],
    [-148.2305, 70.3305],
    [-148.2286, 70.3133],
    [-148.2279, 70.3029],
    [-148.2055, 70.2955],
    [-148.1996, 70.2973],
    [-148.1861, 70.2998],
    [-148.1666, 70.3049],
    [-148.1511, 70.3147],
    [-148.1457, 70.3200],
    [-148.1366, 70.3238],
    [-148.1286, 70.3316],
    [-148.1323, 70.3376],
    [-148.1209, 70.3399],
    [-148.1124, 70.3404],
    [-148.1068, 70.3416],
    [-148.0990, 70.3385],
    [-148.0901, 70.3360],
    [-148.0954, 70.3312],
    [-148.0904, 70.3300],
    [-148.0837, 70.3292],
    [-148.0742, 70.3269],
    [-148.0681, 70.3267],
    [-148.0600, 70.3251],
    [-148.0499, 70.3232],
    [-148.0398, 70.3212],
    [-148.0251, 70.3150],
    [-148.0187, 70.3085],
    [-148.0036, 70.3078],
    [-147.9959, 70.3076],
    [-147.9840, 70.3056],
    [-147.9724, 70.3045],
    [-147.9484, 70.3018],
    [-147.9378, 70.3033],
    [-147.9340, 70.3001],
    [-147.9465, 70.2969],
    [-147.9479, 70.2924],
    [-147.9308, 70.2930],
    [-147.9171, 70.2940],
    [-147.9088, 70.2968],
    [-147.8963, 70.3000],
    [-147.8857, 70.3031],
    [-147.8838, 70.3106],
    [-147.8936, 70.3228],
    [-147.9264, 70.3336],
    [-147.9585, 70.3475],
    [-147.9663, 70.3515],
    [-147.9612, 70.3574],
    [-147.9545, 70.3540],
    [-147.9576, 70.3496],
    [-147.9392, 70.3406],
    [-147.9096, 70.3281],
    [-147.8842, 70.3232],
    [-147.8647, 70.3232],
    [-147.8602, 70.3191],
    [-147.8691, 70.3205],
    [-147.8717, 70.3218],
    [-147.8829, 70.3213],
    [-147.8821, 70.3044],
    [-147.8962, 70.2980],
    [-147.9011, 70.2939],
    [-147.8994, 70.2904],
    [-147.8918, 70.2866],
    [-147.8986, 70.2831],
    [-147.8854, 70.2803],
    [-147.8656, 70.2777],
    [-147.8437, 70.2773],
    [-147.8175, 70.2758],
    [-147.7990, 70.2805],
    [-147.7935, 70.2855],
    [-147.7979, 70.2892],
    [-147.8005, 70.2921],
    [-147.7871, 70.2891],
    [-147.7826, 70.2831],
    [-147.7889, 70.2811],
    [-147.7922, 70.2785],
    [-147.7914, 70.2658],
    [-147.7897, 70.2607],
    [-147.7980, 70.2545],
    [-147.8039, 70.2503],
    [-147.8071, 70.2448],
    [-147.8147, 70.2436],
    [-147.8290, 70.2421],
    [-147.8471, 70.2366],
    [-147.8379, 70.2342],
    [-147.8280, 70.2311],
    [-147.8276, 70.2282],
    [-147.8280, 70.2261],
    [-147.8208, 70.2259],
    [-147.8151, 70.2251],
    [-147.8074, 70.2253],
    [-147.7952, 70.2264],
    [-147.7893, 70.2253],
    [-147.7899, 70.2237],
    [-147.7842, 70.2181],
    [-147.7727, 70.2168],
    [-147.7627, 70.2189],
    [-147.7533, 70.2191],
    [-147.7471, 70.2198],
    [-147.7488, 70.2228],
    [-147.7176, 70.2085],
    [-147.6783, 70.1993],
    [-147.6715, 70.2016],
    [-147.6680, 70.2036],
    [-147.6595, 70.2040],
    [-147.6526, 70.2042],
    [-147.6456, 70.2029],
    [-147.6373, 70.2032],
    [-147.6217, 70.2018],
    [-147.6160, 70.2024],
    [-147.6021, 70.2001],
    [-147.5946, 70.2006],
    [-147.5895, 70.2015],
    [-147.5861, 70.2036],
    [-147.5792, 70.2023],
    [-147.5713, 70.2011],
    [-147.5652, 70.1993],
    [-147.5580, 70.1991],
    [-147.5481, 70.2009],
    [-147.5382, 70.2025],
    [-147.5256, 70.2032],
    [-147.5021, 70.1999],
    [-147.4890, 70.1993],
    [-147.4601, 70.1950],
    [-147.4317, 70.1892],
    [-147.4163, 70.1872],
    [-147.3962, 70.1856],
    [-147.3740, 70.1869],
    [-147.3641, 70.1867],
    [-147.3527, 70.1864],
    [-147.3404, 70.1862],
    [-147.3299, 70.1894],
    [-147.3189, 70.1882],
    [-147.3100, 70.1835],
    [-147.3073, 70.1791],
    [-147.2929, 70.1795],
    [-147.2916, 70.1844],
    [-147.2867, 70.1879],
    [-147.2859, 70.1932],
    [-147.2788, 70.1973],
    [-147.2742, 70.1993],
    [-147.2717, 70.2024],
    [-147.2609, 70.2015],
    [-147.2517, 70.1970],
    [-147.2422, 70.1925],
    [-147.2351, 70.1873],
    [-147.2335, 70.1831],
    [-147.2315, 70.1805],
    [-147.2368, 70.1779],
    [-147.2325, 70.1748],
    [-147.2335, 70.1706],
    [-147.2280, 70.1659],
    [-147.2236, 70.1645],
    [-147.2195, 70.1670],
    [-147.2234, 70.1697],
    [-147.2196, 70.1732],
    [-147.2203, 70.1776],
    [-147.2113, 70.1725],
    [-147.2031, 70.1689],
    [-147.1971, 70.1652],
    [-147.1856, 70.1603],
    [-147.1795, 70.1566],
    [-147.1741, 70.1536],
    [-147.1672, 70.1538],
    [-147.1485, 70.1555],
    [-147.1345, 70.1578],
    [-147.1182, 70.1558],
    [-147.1044, 70.1538],
    [-147.0903, 70.1531],
    [-147.0803, 70.1524],
    [-147.0701, 70.1500],
    [-147.0629, 70.1465],
    [-147.0540, 70.1467],
    [-147.0524, 70.1499],
    [-147.0549, 70.1530],
    [-147.0400, 70.1526],
    [-147.0269, 70.1540],
    [-147.0132, 70.1537],
    [-146.9915, 70.1534],
    [-146.9865, 70.1519],
    [-146.9719, 70.1504],
    [-146.9591, 70.1534],
    [-146.9394, 70.1597],
    [-146.9048, 70.1689],
    [-146.8959, 70.1689],
    [-146.8829, 70.1653],
    [-146.8742, 70.1665],
    [-146.8748, 70.1686],
    [-146.8646, 70.1682],
    [-146.8583, 70.1688],
    [-146.8619, 70.1716],
    [-146.8685, 70.1719],
    [-146.8581, 70.1758],
    [-146.8492, 70.1812],
    [-146.8358, 70.1787],
    [-146.8098, 70.1773],
    [-146.7847, 70.1784],
    [-146.7607, 70.1788],
    [-146.7298, 70.1744],
    [-146.6867, 70.1746],
    [-146.6657, 70.1756],
    [-146.6497, 70.1751],
    [-146.6437, 70.1765],
    [-146.6335, 70.1769],
    [-146.6283, 70.1787],
    [-146.6238, 70.1813],
    [-146.6129, 70.1800],
    [-146.6065, 70.1801],
    [-146.5963, 70.1802],
    [-146.5973, 70.1787],
    [-146.5853, 70.1779],
    [-146.5705, 70.1800],
    [-146.5576, 70.1827],
    [-146.5459, 70.1828],
    [-146.5421, 70.1845],
    [-146.5298, 70.1850],
    [-146.5175, 70.1892],
    [-146.5150, 70.1853],
    [-146.5053, 70.1848],
    [-146.4928, 70.1835],
    [-146.4806, 70.1807],
    [-146.4714, 70.1807],
    [-146.4692, 70.1830],
    [-146.4594, 70.1804],
    [-146.4487, 70.1816],
    [-146.4359, 70.1836],
    [-146.4299, 70.1851],
    [-146.4216, 70.1807],
    [-146.4137, 70.1791],
    [-146.4047, 70.1791],
    [-146.3947, 70.1820],
    [-146.3899, 70.1792],
    [-146.3840, 70.1785],
    [-146.3719, 70.1779],
    [-146.3607, 70.1787],
    [-146.3469, 70.1776],
    [-146.3375, 70.1773],
    [-146.3316, 70.1767],
    [-146.3232, 70.1767],
    [-146.3115, 70.1761],
    [-146.3045, 70.1757],
    [-146.2969, 70.1763],
    [-146.2894, 70.1771],
    [-146.2645, 70.1743],
    [-146.2517, 70.1718],
    [-146.2432, 70.1691],
    [-146.2419, 70.1665],
    [-146.2308, 70.1642],
    [-146.2229, 70.1650],
    [-146.2148, 70.1647],
    [-146.2116, 70.1654],
    [-146.2061, 70.1657],
    [-146.1976, 70.1646],
    [-146.1932, 70.1612],
    [-146.1877, 70.1611],
    [-146.1753, 70.1641],
    [-146.1696, 70.1640],
    [-146.1631, 70.1600],
    [-146.1560, 70.1583],
    [-146.1446, 70.1581],
    [-146.1372, 70.1598],
    [-146.1258, 70.1545],
    [-146.1156, 70.1553],
    [-146.1057, 70.1485],
    [-146.0975, 70.1443],
    [-146.0839, 70.1442],
    [-146.0748, 70.1455],
    [-146.0679, 70.1452],
    [-146.0616, 70.1456],
    [-146.0567, 70.1488],
    [-146.0480, 70.1461],
    [-146.0430, 70.1452],
    [-146.0378, 70.1431],
    [-146.0284, 70.1439],
    [-146.0210, 70.1433],
    [-146.0302, 70.1425],
    [-146.0314, 70.1394],
    [-146.0229, 70.1402],
    [-146.0150, 70.1412],
    [-146.0117, 70.1395],
    [-146.0041, 70.1375],
    [-146.0027, 70.1323],
    [-145.9953, 70.1335],
    [-145.9912, 70.1391],
    [-145.9848, 70.1432],
    [-145.9724, 70.1437],
    [-145.9658, 70.1395],
    [-145.9569, 70.1372],
    [-145.9507, 70.1385],
    [-145.9440, 70.1357],
    [-145.9350, 70.1334],
    [-145.9232, 70.1313],
    [-145.9114, 70.1304],
    [-145.9041, 70.1322],
    [-145.8945, 70.1324],
    [-145.9103, 70.1370],
    [-145.9097, 70.1402],
    [-145.9027, 70.1391],
    [-145.8943, 70.1346],
    [-145.8863, 70.1331],
    [-145.8756, 70.1305],
    [-145.8671, 70.1307],
    [-145.8589, 70.1320],
    [-145.8579, 70.1353],
    [-145.8642, 70.1430],
    [-145.8721, 70.1461],
    [-145.8725, 70.1500],
    [-145.8705, 70.1549],
    [-145.8545, 70.1623],
    [-145.8417, 70.1596],
    [-145.8275, 70.1538],
    [-145.8280, 70.1503],
    [-145.8219, 70.1483],
    [-145.8106, 70.1453],
    [-145.8002, 70.1406],
    [-145.7896, 70.1387],
    [-145.7829, 70.1354],
    [-145.7738, 70.1324],
    [-145.7702, 70.1289],
    [-145.7604, 70.1261],
    [-145.7485, 70.1229],
    [-145.7378, 70.1228],
    [-145.7347, 70.1218],
    [-145.7306, 70.1193],
    [-145.7227, 70.1156],
    [-145.7136, 70.1126],
    [-145.7070, 70.1118],
    [-145.7013, 70.1100],
    [-145.6970, 70.1078],
    [-145.6896, 70.1037],
    [-145.6737, 70.0994],
    [-145.6634, 70.0997],
    [-145.6572, 70.0957],
    [-145.6509, 70.0920],
    [-145.6391, 70.0904],
    [-145.6312, 70.0879],
    [-145.6233, 70.0844],
    [-145.6087, 70.0835],
    [-145.5995, 70.0819],
    [-145.5871, 70.0777],
    [-145.5602, 70.0795],
    [-145.5457, 70.0742],
    [-145.5158, 70.0716],
    [-145.4856, 70.0604],
    [-145.4687, 70.0523],
    [-145.4513, 70.0425],
    [-145.4428, 70.0369],
    [-145.4332, 70.0339],
    [-145.4220, 70.0313],
    [-145.4107, 70.0302],
    [-145.4033, 70.0307],
    [-145.3982, 70.0314],
    [-145.3861, 70.0290],
    [-145.3786, 70.0290],
    [-145.3553, 70.0233],
    [-145.3322, 70.0208],
    [-145.3109, 70.0172],
    [-145.3046, 70.0130],
    [-145.2922, 70.0121],
    [-145.2824, 70.0131],
    [-145.2746, 70.0124],
    [-145.2543, 70.0165],
    [-145.2518, 70.0186],
    [-145.2434, 70.0253],
    [-145.2032, 70.0285],
    [-145.1796, 70.0239],
    [-145.1839, 70.0221],
    [-145.1975, 70.0224],
    [-145.2090, 70.0238],
    [-145.2161, 70.0222],
    [-145.2180, 70.0196],
    [-145.2206, 70.0165],
    [-145.2238, 70.0125],
    [-145.2251, 70.0034],
    [-145.1973, 69.9950],
    [-145.1750, 69.9908],
    [-145.1527, 69.9896],
    [-145.1317, 69.9871],
    [-145.1064, 69.9849],
    [-145.0859, 69.9843],
    [-145.0710, 69.9817],
    [-145.0575, 69.9811],
    [-145.0440, 69.9819],
    [-145.0247, 69.9811],
    [-145.0122, 69.9793],
    [-144.9923, 69.9738],
    [-144.9793, 69.9692],
    [-144.9712, 69.9633],
    [-144.9601, 69.9580],
    [-144.9536, 69.9593],
    [-144.9458, 69.9623],
    [-144.9393, 69.9623],
    [-144.9139, 69.9623],
    [-144.8843, 69.9677],
    [-144.8676, 69.9723],
    [-144.8540, 69.9732],
    [-144.8406, 69.9749],
    [-144.8373, 69.9807],
    [-144.8553, 69.9837],
    [-144.8754, 69.9844],
    [-144.8885, 69.9838],
    [-144.8942, 69.9839],
    [-144.8938, 69.9856],
    [-144.8759, 69.9856],
    [-144.8337, 69.9825],
    [-144.7916, 69.9789],
    [-144.7412, 69.9703],
    [-144.7114, 69.9675],
    [-144.6769, 69.9654],
    [-144.6483, 69.9657],
    [-144.6182, 69.9691],
    [-144.5775, 69.9791],
    [-144.5446, 69.9927],
    [-144.5133, 70.0072],
    [-144.4897, 70.0181],
    [-144.4822, 70.0272],
    [-144.4668, 70.0317],
    [-144.4577, 70.0346],
    [-144.4224, 70.0385],
    [-144.3867, 70.0410],
    [-144.3352, 70.0410],
    [-144.2934, 70.0402],
    [-144.2728, 70.0434],
    [-144.2712, 70.0509],
    [-144.2426, 70.0588],
    [-144.2076, 70.0599],
    [-144.1807, 70.0623],
    [-144.1400, 70.0768],
    [-144.1135, 70.0823],
    [-144.0903, 70.0851],
    [-144.0636, 70.0880],
    [-144.0318, 70.0888],
    [-144.0060, 70.0909],
    [-143.9815, 70.0956],
    [-143.9576, 70.0987],
    [-143.9471, 70.1012],
    [-143.9313, 70.1074],
    [-143.9140, 70.1156],
    [-143.9010, 70.1208],
    [-143.8796, 70.1197],
    [-143.8483, 70.1134],
    [-143.8386, 70.1097],
    [-143.8211, 70.1076],
    [-143.7917, 70.1095],
    [-143.7738, 70.1142],
    [-143.7809, 70.1185],
    [-143.7791, 70.1215],
    [-143.7736, 70.1247],
    [-143.7525, 70.1284],
    [-143.7125, 70.1318],
    [-143.6612, 70.1343],
    [-143.6292, 70.1337],
    [-143.6106, 70.1349],
    [-143.6086, 70.1418],
    [-143.6037, 70.1446],
    [-143.5777, 70.1463],
    [-143.5495, 70.1444],
    [-143.5260, 70.1402],
    [-143.5023, 70.1359],
    [-143.4563, 70.1278],
    [-143.4483, 70.1259],
    [-143.4201, 70.1252],
    [-143.3919, 70.1274],
    [-143.3582, 70.1324],
    [-143.3266, 70.1429],
    [-143.3142, 70.1451],
    [-143.3047, 70.1474],
    [-143.2819, 70.1511],
    [-143.2696, 70.1538],
    [-143.2491, 70.1511],
    [-143.2367, 70.1444],
    [-143.2213, 70.1368],
    [-143.1963, 70.1323],
    [-143.1599, 70.1267],
    [-143.1361, 70.1185],
    [-143.1024, 70.1110],
    [-143.0669, 70.1032],
    [-143.0348, 70.0964],
    [-143.0195, 70.0919],
    [-142.9980, 70.0846],
    [-142.9754, 70.0835],
    [-142.9510, 70.0771],
    [-142.9381, 70.0752],
    [-142.8946, 70.0687],
    [-142.8619, 70.0604],
    [-142.8426, 70.0575],
    [-142.7942, 70.0497],
    [-142.7485, 70.0421],
    [-142.7080, 70.0318],
    [-142.6517, 70.0182],
    [-142.6160, 70.0081],
    [-142.5680, 69.9910],
    [-142.5472, 69.9831],
    [-142.5133, 69.9749],
    [-142.4896, 69.9697],
    [-142.4553, 69.9598],
    [-142.4518, 69.9569],
    [-142.4712, 69.9633],
    [-142.4975, 69.9682],
    [-142.5089, 69.9639],
    [-142.5104, 69.9546],
    [-142.4996, 69.9517],
    [-142.4885, 69.9491],
    [-142.4801, 69.9475],
    [-142.4656, 69.9466],
    [-142.4542, 69.9399],
    [-142.4411, 69.9363],
    [-142.4284, 69.9367],
    [-142.4116, 69.9329],
    [-142.4042, 69.9297],
    [-142.3977, 69.9308],
    [-142.3783, 69.9320],
    [-142.3949, 69.9363],
    [-142.4149, 69.9418],
    [-142.4237, 69.9435],
    [-142.4032, 69.9408],
    [-142.3685, 69.9306],
    [-142.3542, 69.9234],
    [-142.3578, 69.9241],
    [-142.3679, 69.9288],
    [-142.3789, 69.9282],
    [-142.3818, 69.9234],
    [-142.3897, 69.9219],
    [-142.3951, 69.9190],
    [-142.3978, 69.9172],
    [-142.4029, 69.9172],
    [-142.4084, 69.9156],
    [-142.4027, 69.9109],
    [-142.3931, 69.9094],
    [-142.3855, 69.9106],
    [-142.3718, 69.9115],
    [-142.3691, 69.9132],
    [-142.3531, 69.9103],
    [-142.3388, 69.9180],
    [-142.3241, 69.9171],
    [-142.3080, 69.9132],
    [-142.2758, 69.9028],
    [-142.2276, 69.8896],
    [-142.1990, 69.8807],
    [-142.1642, 69.8708],
    [-142.1327, 69.8629],
    [-142.0945, 69.8552],
    [-142.0505, 69.8467],
    [-142.0291, 69.8424],
    [-142.0165, 69.8380],
    [-141.9959, 69.8346],
    [-141.9725, 69.8272],
    [-141.9556, 69.8234],
    [-141.9271, 69.8209],
    [-141.8818, 69.8165],
    [-141.8186, 69.8055],
    [-141.7731, 69.7979],
    [-141.7046, 69.7850],
    [-141.6268, 69.7656],
    [-141.5586, 69.7440],
    [-141.5042, 69.7224],
    [-141.4529, 69.7020],
    [-141.4225, 69.6988],
    [-141.4073, 69.6974],
    [-141.3734, 69.6884],
    [-141.3517, 69.6787],
    [-141.3617, 69.6828],
    [-141.4012, 69.6952],
    [-141.4058, 69.6916],
    [-141.4167, 69.6937],
    [-141.4665, 69.7052],
    [-141.4708, 69.6961],
    [-141.4588, 69.6825],
    [-141.4529, 69.6767],
    [-141.4361, 69.6775],
    [-141.4273, 69.6646],
    [-141.4249, 69.6564],
    [-141.4174, 69.6577],
    [-141.4077, 69.6490],
    [-141.3894, 69.6393],
    [-141.3470, 69.6315],
    [-141.2848, 69.6309],
    [-141.2497, 69.6302],
    [-141.2440, 69.6401],
    [-141.2243, 69.6576],
    [-141.2084, 69.6805],
    [-141.2357, 69.6769],
    [-141.2712, 69.6824],
    [-141.2854, 69.6845],
    [-141.3005, 69.6847],
    [-141.3171, 69.6829],
    [-141.3214, 69.6840],
    [-141.2932, 69.6878],
    [-141.2426, 69.6781],
    [-141.1373, 69.6767],
    [-141.0552, 69.6582],
    [-141.0007, 69.2864],
    [-141.0008, 68.5381],
    [-141.0027, 68.1916],
    [-141.0026, 66.5143],
    [-141.0013, 65.8381],
    [-141.0013, 65.0001],
    [-141.0014, 63.0924],
    [-141.0015, 62.5217],
    [-141.0016, 61.9997],
    [-141.0022, 61.9040],
    [-141.0021, 61.7497],
    [-141.0020, 61.6102],
    [-141.0020, 60.3917],
    [-140.9307, 60.2934],
    [-140.4582, 60.3081],
    [-139.8007, 60.2779],
    [-139.0721, 60.3194],
    [-139.0727, 60.0071],
    [-139.0030, 59.9809],
    [-138.6795, 59.8454],
    [-138.6262, 59.7686],
    [-138.0087, 59.4534],
    [-137.5418, 59.1054],
    [-137.5252, 58.9091],
    [-137.4474, 58.9095],
    [-136.9259, 59.1174],
    [-136.5815, 59.1649],
    [-136.4958, 59.2751],
    [-136.4772, 59.4658],
    [-136.3619, 59.4505],
    [-136.2391, 59.5397],
    [-136.3539, 59.5998],
    [-136.0540, 59.6529],
    [-135.7173, 59.7300],
    [-135.3601, 59.7376],
    [-135.2337, 59.6961],
    [-135.1576, 59.6257],
    [-135.0289, 59.5637],
    [-135.0773, 59.4518],
    [-134.9897, 59.3871],
    [-135.0028, 59.3207],
    [-134.6791, 59.1923],
    [-134.4471, 59.0892],
    [-134.3215, 58.9636],
    [-134.3365, 58.9234],
    [-133.9722, 58.7673],
    [-133.7071, 58.6123],
    [-133.5578, 58.5231],
    [-133.4615, 58.3877],
    [-133.3454, 58.2763],
    [-133.1723, 58.1537],
    [-133.1488, 58.1095],
    [-132.7568, 57.7051],
    [-132.6278, 57.5797],
    [-132.3896, 57.3656],
    [-132.2479, 57.2113],
    [-132.0768, 56.9759],
    [-132.0054, 56.8417],
    [-131.9011, 56.7537],
    [-131.8451, 56.6393],
    [-131.5811, 56.6122],
    [-131.3638, 56.5153],
    [-131.1735, 56.4495],
    [-131.0677, 56.4035],
    [-130.8565, 56.3764],
    [-130.7410, 56.3410],
    [-130.5405, 56.2475],
    [-130.3501, 56.1285],
    [-130.1038, 56.1228],
    [-130.0380, 56.0475],
    [-130.0035, 56.0081],
    [-130.0154, 55.9276],
    [-130.0038, 55.9119],
    [-130.1248, 55.8056],
    [-130.1524, 55.7663],
    [-130.1301, 55.6993],
    [-130.1244, 55.6028],
    [-130.0899, 55.4980],
    [-130.0372, 55.4290],
    [-130.0211, 55.3379],
    [-129.9766, 55.3004],
    [-129.9788, 55.2787],
    [-130.0633, 55.2200],
    [-130.1028, 55.1926],
    [-130.1461, 55.1428],
    [-130.1690, 55.1052],
    [-130.1876, 55.0628],
    [-130.2357, 55.0129],
    [-130.2733, 54.9740],
    [-130.3824, 54.8968],
    [-130.4742, 54.8408],
    [-130.6289, 54.7827],
    [-130.6445, 54.7369],
    [-130.6475, 54.7261],
    [-130.6611, 54.7265],
    [-130.6753, 54.7294],
    [-130.6893, 54.7305],
    [-130.6851, 54.7216],
    [-130.6948, 54.7204],
    [-130.7290, 54.7455],
    [-130.7481, 54.7678],
    [-130.7450, 54.7765],
    [-130.7416, 54.7916],
    [-130.7378, 54.8074],
    [-130.7547, 54.8129],
    [-130.7656, 54.8103],
    [-130.7874, 54.8229],
    [-130.7987, 54.7835],
    [-130.8144, 54.7740],
    [-130.8353, 54.7677],
    [-130.8555, 54.7606],
    [-130.8620, 54.7663],
    [-130.8906, 54.7771],
    [-130.9194, 54.7959],
    [-130.9365, 54.8099],
    [-130.9471, 54.8260],
    [-130.9410, 54.8416],
    [-130.9377, 54.8495],
    [-130.9534, 54.8571],
    [-130.9534, 54.8905],
    [-130.9669, 54.9126],
    [-130.9754, 54.9214],
    [-130.9604, 54.9337],
    [-130.9463, 54.9476],
    [-130.9754, 54.9696],
    [-130.9921, 54.9928],
    [-131.0078, 54.9913],
    [-131.0146, 54.9996],
    [-131.0091, 55.0117],
    [-131.0058, 55.0228],
    [-131.0030, 55.0313],
    [-131.0037, 55.0368],
    [-131.0062, 55.0435],
    [-131.0126, 55.0467],
    [-131.0036, 55.0444],
    [-130.9961, 55.0426],
    [-130.9944, 55.0495],
    [-130.9981, 55.0547],
    [-130.9994, 55.0600],
    [-130.9915, 55.0641],
    [-130.9862, 55.0683],
    [-130.9769, 55.0705],
    [-130.9670, 55.0741],
    [-130.9544, 55.0753],
    [-130.9358, 55.0785],
    [-130.9286, 55.0788],
    [-130.9107, 55.0842],
    [-130.8939, 55.0918],
    [-130.8778, 55.0969],
    [-130.8713, 55.1009],
    [-130.8617, 55.1069],
    [-130.8553, 55.1177],
    [-130.8407, 55.1185],
    [-130.8300, 55.1179],
    [-130.8252, 55.1088],
    [-130.8211, 55.1033],
    [-130.8243, 55.0980],
    [-130.8215, 55.0941],
    [-130.8148, 55.0881],
    [-130.8100, 55.0821],
    [-130.7942, 55.0731],
    [-130.7680, 55.0771],
    [-130.7398, 55.0884],
    [-130.7187, 55.0969],
    [-130.7156, 55.1088],
    [-130.7062, 55.1240],
    [-130.7181, 55.1330],
    [-130.7261, 55.1313],
    [-130.7337, 55.1268],
    [-130.7347, 55.1188],
    [-130.7426, 55.1150],
    [-130.7400, 55.1109],
    [-130.7391, 55.1060],
    [-130.7569, 55.0961],
    [-130.7734, 55.0927],
    [-130.7849, 55.0981],
    [-130.7937, 55.1018],
    [-130.7996, 55.1120],
    [-130.8024, 55.1209],
    [-130.8058, 55.1278],
    [-130.8161, 55.1448],
    [-130.8302, 55.1429],
    [-130.8362, 55.1336],
    [-130.8608, 55.1287],
    [-130.8722, 55.1259],
    [-130.8778, 55.1160],
    [-130.8857, 55.1110],
    [-130.9066, 55.1016],
    [-130.9251, 55.0962],
    [-130.9576, 55.0899],
    [-130.9816, 55.0857],
    [-131.0078, 55.0893],
    [-131.0158, 55.0894],
    [-131.0302, 55.0966],
    [-131.0349, 55.1080],
    [-131.0442, 55.1071],
    [-131.0514, 55.1139],
    [-131.0556, 55.1190],
    [-131.0625, 55.1202],
    [-131.0739, 55.1281],
    [-131.0772, 55.1342],
    [-131.0714, 55.1374],
    [-131.0752, 55.1439],
    [-131.0807, 55.1480],
    [-131.0827, 55.1522],
    [-131.0876, 55.1596],
    [-131.0853, 55.1659],
    [-131.0896, 55.1753],
    [-131.0898, 55.1832],
    [-131.0928, 55.1869],
    [-131.0929, 55.1906],
    [-131.0856, 55.1976],
    [-131.0753, 55.1994],
    [-131.0548, 55.2120],
    [-131.0410, 55.2228],
    [-131.0292, 55.2268],
    [-131.0242, 55.2309],
    [-131.0182, 55.2333],
    [-131.0037, 55.2432],
    [-130.9929, 55.2440],
    [-130.9857, 55.2471],
    [-130.9790, 55.2549],
    [-130.9708, 55.2616],
    [-130.9636, 55.2655],
    [-130.9616, 55.2699],
    [-130.9513, 55.2740],
    [-130.9502, 55.2777],
    [-130.9528, 55.2885],
    [-130.9440, 55.2953],
    [-130.9350, 55.2957],
    [-130.9204, 55.3008],
    [-130.9088, 55.3009],
    [-130.8986, 55.2961],
    [-130.8870, 55.2999],
    [-130.8775, 55.2936],
    [-130.8669, 55.2945],
    [-130.8505, 55.3026],
    [-130.8554, 55.3081],
    [-130.8632, 55.3116],
    [-130.8734, 55.3186],
    [-130.8750, 55.3265],
    [-130.8790, 55.3417],
    [-130.8766, 55.3483],
    [-130.8811, 55.3541],
    [-130.8835, 55.3657],
    [-130.8807, 55.3710],
    [-130.8811, 55.3772],
    [-130.8765, 55.3831],
    [-130.8798, 55.3901],
    [-130.8830, 55.3960],
    [-130.8834, 55.4028],
    [-130.8897, 55.4111],
    [-130.8961, 55.4042],
    [-130.8941, 55.3931],
    [-130.8997, 55.3985],
    [-130.9074, 55.4079],
    [-130.9095, 55.4144],
    [-130.9150, 55.4258],
    [-130.9192, 55.4285],
    [-130.9238, 55.4281],
    [-130.9236, 55.4338],
    [-130.9185, 55.4476],
    [-130.9136, 55.4507],
    [-130.9145, 55.4538],
    [-130.9057, 55.4629],
    [-130.8975, 55.4703],
    [-130.8907, 55.4826],
    [-130.8766, 55.4866],
    [-130.8750, 55.4895],
    [-130.8813, 55.4956],
    [-130.8720, 55.5030],
    [-130.8762, 55.5102],
    [-130.8791, 55.5224],
    [-130.8722, 55.5318],
    [-130.8732, 55.5407],
    [-130.8647, 55.5426],
    [-130.8420, 55.5432],
    [-130.8151, 55.5454],
    [-130.8205, 55.5538],
    [-130.8256, 55.5508],
    [-130.8422, 55.5512],
    [-130.8653, 55.5553],
    [-130.8761, 55.5651],
    [-130.8806, 55.5972],
    [-130.8838, 55.6081],
    [-130.8879, 55.6138],
    [-130.8891, 55.6277],
    [-130.8927, 55.6376],
    [-130.8974, 55.6547],
    [-130.9027, 55.6768],
    [-130.9000, 55.7007],
    [-130.8949, 55.7068],
    [-130.9067, 55.7152],
    [-130.9106, 55.7214],
    [-130.9195, 55.7298],
    [-130.9252, 55.7381],
    [-130.9390, 55.7548],
    [-130.9539, 55.7679],
    [-130.9627, 55.7750],
    [-130.9693, 55.7817],
    [-130.9544, 55.7910],
    [-130.9500, 55.8007],
    [-130.9539, 55.8036],
    [-130.9457, 55.8110],
    [-130.9559, 55.8078],
    [-130.9910, 55.7995],
    [-130.9986, 55.8040],
    [-131.0073, 55.8097],
    [-131.0226, 55.8277],
    [-131.0400, 55.8456],
    [-131.0524, 55.8566],
    [-131.0599, 55.8649],
    [-131.0724, 55.8762],
    [-131.0777, 55.8854],
    [-131.0854, 55.8847],
    [-131.0967, 55.8958],
    [-131.1072, 55.8997],
    [-131.1368, 55.9232],
    [-131.1677, 55.9395],
    [-131.1887, 55.9571],
    [-131.2019, 55.9750],
    [-131.2133, 55.9890],
    [-131.1655, 56.0073],
    [-131.1449, 56.0160],
    [-131.1159, 56.0305],
    [-131.1030, 56.0356],
    [-131.0933, 56.0433],
    [-131.1038, 56.0497],
    [-131.1294, 56.0545],
    [-131.1544, 56.0360],
    [-131.1786, 56.0309],
    [-131.1936, 56.0251],
    [-131.2124, 56.0131],
    [-131.2347, 56.0060],
    [-131.2606, 56.0009],
    [-131.2810, 55.9988],
    [-131.2869, 55.9961],
    [-131.2978, 55.9957],
    [-131.3041, 55.9918],
    [-131.3116, 55.9873],
    [-131.3243, 55.9776],
    [-131.3342, 55.9734],
    [-131.3447, 55.9676],
    [-131.3558, 55.9560],
    [-131.3318, 55.9566],
    [-131.3132, 55.9629],
    [-131.3043, 55.9662],
    [-131.2886, 55.9688],
    [-131.2822, 55.9715],
    [-131.2654, 55.9730],
    [-131.2471, 55.9645],
    [-131.2367, 55.9498],
    [-131.2000, 55.9259],
    [-131.1913, 55.9210],
    [-131.1567, 55.8999],
    [-131.1442, 55.8884],
    [-131.1261, 55.8728],
    [-131.1167, 55.8624],
    [-131.1026, 55.8536],
    [-131.0906, 55.8449],
    [-131.0865, 55.8387],
    [-131.0705, 55.8263],
    [-131.0649, 55.8173],
    [-131.0604, 55.8127],
    [-131.0552, 55.8091],
    [-131.0587, 55.8070],
    [-131.0562, 55.8042],
    [-131.0507, 55.7999],
    [-131.0493, 55.7969],
    [-131.0506, 55.7895],
    [-131.0450, 55.7838],
    [-131.0447, 55.7773],
    [-131.0525, 55.7728],
    [-131.0417, 55.7673],
    [-131.0350, 55.7587],
    [-131.0289, 55.7506],
    [-131.0109, 55.7372],
    [-130.9970, 55.7227],
    [-130.9856, 55.7168],
    [-130.9781, 55.7096],
    [-130.9673, 55.6942],
    [-130.9590, 55.6909],
    [-130.9636, 55.6874],
    [-130.9683, 55.6853],
    [-130.9710, 55.6803],
    [-130.9659, 55.6702],
    [-130.9605, 55.6666],
    [-130.9535, 55.6607],
    [-130.9511, 55.6427],
    [-130.9443, 55.6322],
    [-130.9406, 55.6239],
    [-130.9425, 55.6166],
    [-130.9453, 55.6112],
    [-130.9555, 55.6049],
    [-130.9545, 55.5993],
    [-130.9595, 55.5886],
    [-130.9470, 55.5864],
    [-130.9404, 55.5869],
    [-130.9332, 55.5858],
    [-130.9296, 55.5803],
    [-130.9295, 55.5736],
    [-130.9362, 55.5692],
    [-130.9410, 55.5616],
    [-130.9476, 55.5536],
    [-130.9517, 55.5561],
    [-130.9629, 55.5625],
    [-130.9709, 55.5728],
    [-130.9773, 55.5751],
    [-130.9818, 55.5695],
    [-130.9826, 55.5601],
    [-130.9809, 55.5535],
    [-130.9816, 55.5445],
    [-130.9877, 55.5341],
    [-130.9774, 55.5265],
    [-130.9754, 55.5209],
    [-130.9803, 55.5145],
    [-130.9837, 55.5080],
    [-130.9906, 55.5006],
    [-130.9872, 55.4976],
    [-130.9830, 55.4888],
    [-130.9869, 55.4832],
    [-130.9944, 55.4724],
    [-130.9823, 55.4646],
    [-130.9887, 55.4622],
    [-130.9854, 55.4592],
    [-130.9867, 55.4562],
    [-130.9822, 55.4398],
    [-130.9808, 55.4333],
    [-130.9900, 55.4282],
    [-130.9877, 55.4248],
    [-130.9817, 55.4276],
    [-130.9758, 55.4160],
    [-130.9728, 55.4070],
    [-130.9699, 55.3944],
    [-130.9753, 55.3857],
    [-130.9825, 55.3823],
    [-130.9910, 55.3785],
    [-131.0005, 55.3850],
    [-131.0017, 55.3918],
    [-131.0028, 55.3997],
    [-131.0087, 55.4048],
    [-131.0253, 55.4095],
    [-131.0316, 55.4038],
    [-131.0360, 55.3994],
    [-131.0325, 55.3864],
    [-131.0305, 55.3769],
    [-131.0273, 55.3714],
    [-131.0285, 55.3617],
    [-131.0243, 55.3565],
    [-131.0223, 55.3446],
    [-131.0278, 55.3476],
    [-131.0345, 55.3381],
    [-131.0437, 55.3279],
    [-131.0507, 55.3294],
    [-131.0518, 55.3260],
    [-131.0504, 55.3200],
    [-131.0501, 55.3087],
    [-131.0518, 55.2984],
    [-131.0585, 55.2938],
    [-131.0583, 55.2857],
    [-131.0583, 55.2785],
    [-131.0627, 55.2683],
    [-131.0636, 55.2601],
    [-131.0759, 55.2514],
    [-131.0831, 55.2524],
    [-131.0894, 55.2476],
    [-131.0993, 55.2423],
    [-131.0993, 55.2380],
    [-131.1040, 55.2326],
    [-131.1166, 55.2242],
    [-131.1339, 55.2235],
    [-131.1346, 55.2145],
    [-131.1506, 55.2063],
    [-131.1527, 55.2004],
    [-131.1634, 55.1967],
    [-131.1677, 55.2009],
    [-131.1768, 55.1969],
    [-131.1816, 55.1921],
    [-131.1976, 55.1914],
    [-131.2150, 55.1917],
    [-131.2251, 55.1966],
    [-131.2306, 55.1953],
    [-131.2400, 55.1991],
    [-131.2523, 55.2046],
    [-131.2602, 55.2051],
    [-131.2673, 55.2082],
    [-131.2684, 55.2137],
    [-131.2740, 55.2231],
    [-131.2837, 55.2268],
    [-131.2941, 55.2289],
    [-131.2974, 55.2343],
    [-131.3099, 55.2399],
    [-131.3225, 55.2410],
    [-131.3274, 55.2452],
    [-131.3159, 55.2492],
    [-131.2930, 55.2549],
    [-131.2746, 55.2615],
    [-131.2712, 55.2645],
    [-131.2557, 55.2762],
    [-131.2357, 55.2921],
    [-131.2282, 55.3057],
    [-131.2267, 55.3110],
    [-131.2249, 55.3173],
    [-131.2190, 55.3223],
    [-131.2131, 55.3306],
    [-131.2144, 55.3375],
    [-131.2024, 55.3513],
    [-131.1957, 55.3589],
    [-131.1891, 55.3623],
    [-131.1952, 55.3644],
    [-131.1969, 55.3723],
    [-131.1987, 55.3915],
    [-131.2066, 55.3914],
    [-131.2167, 55.3918],
    [-131.2246, 55.3997],
    [-131.2333, 55.4068],
    [-131.2379, 55.4068],
    [-131.2364, 55.4026],
    [-131.2314, 55.3962],
    [-131.2301, 55.3868],
    [-131.2340, 55.3886],
    [-131.2370, 55.3865],
    [-131.2406, 55.3814],
    [-131.2442, 55.3873],
    [-131.2476, 55.3935],
    [-131.2620, 55.3890],
    [-131.2635, 55.3835],
    [-131.2725, 55.3866],
    [-131.2824, 55.3851],
    [-131.2908, 55.3845],
    [-131.2882, 55.3775],
    [-131.2889, 55.3731],
    [-131.2809, 55.3683],
    [-131.2856, 55.3669],
    [-131.2853, 55.3628],
    [-131.2764, 55.3535],
    [-131.2721, 55.3483],
    [-131.2614, 55.3431],
    [-131.2576, 55.3371],
    [-131.2555, 55.3250],
    [-131.2564, 55.3204],
    [-131.2585, 55.3164],
    [-131.2651, 55.3145],
    [-131.2713, 55.3158],
    [-131.2733, 55.3101],
    [-131.2766, 55.3028],
    [-131.2800, 55.2982],
    [-131.2856, 55.2866],
    [-131.3021, 55.2758],
    [-131.3043, 55.2783],
    [-131.3119, 55.2767],
    [-131.3181, 55.2718],
    [-131.3230, 55.2677],
    [-131.3281, 55.2672],
    [-131.3294, 55.2710],
    [-131.3374, 55.2654],
    [-131.3489, 55.2607],
    [-131.3569, 55.2606],
    [-131.3638, 55.2639],
    [-131.3678, 55.2685],
    [-131.3711, 55.2725],
    [-131.3785, 55.2647],
    [-131.4038, 55.2619],
    [-131.4235, 55.2675],
    [-131.4380, 55.2717],
    [-131.4536, 55.2755],
    [-131.4635, 55.2791],
    [-131.4757, 55.2847],
    [-131.4690, 55.2914],
    [-131.4807, 55.2951],
    [-131.4834, 55.3000],
    [-131.4753, 55.3026],
    [-131.4707, 55.3050],
    [-131.4599, 55.3164],
    [-131.4418, 55.3209],
    [-131.4302, 55.3267],
    [-131.3994, 55.3371],
    [-131.3851, 55.3419],
    [-131.3850, 55.3477],
    [-131.3884, 55.3543],
    [-131.4012, 55.3517],
    [-131.4064, 55.3479],
    [-131.4191, 55.3463],
    [-131.4313, 55.3454],
    [-131.4368, 55.3405],
    [-131.4484, 55.3375],
    [-131.4519, 55.3415],
    [-131.4574, 55.3443],
    [-131.4644, 55.3365],
    [-131.4822, 55.3263],
    [-131.4941, 55.3323],
    [-131.5112, 55.3316],
    [-131.5155, 55.3294],
    [-131.5185, 55.3267],
    [-131.5226, 55.3240],
    [-131.5215, 55.3210],
    [-131.5224, 55.3134],
    [-131.5307, 55.2955],
    [-131.5386, 55.2930],
    [-131.5464, 55.2936],
    [-131.5691, 55.3058],
    [-131.5848, 55.3096],
    [-131.5916, 55.3139],
    [-131.5993, 55.3185],
    [-131.6111, 55.3228],
    [-131.6204, 55.3289],
    [-131.6277, 55.3331],
    [-131.6433, 55.3378],
    [-131.6517, 55.3427],
    [-131.6670, 55.3473],
    [-131.6773, 55.3474],
    [-131.6863, 55.3504],
    [-131.6963, 55.3538],
    [-131.6992, 55.3515],
    [-131.6907, 55.3446],
    [-131.6777, 55.3334],
    [-131.6691, 55.3305],
    [-131.6636, 55.3237],
    [-131.6480, 55.3162],
    [-131.6275, 55.3039],
    [-131.6136, 55.2871],
    [-131.6306, 55.2849],
    [-131.6310, 55.2823],
    [-131.6360, 55.2722],
    [-131.6393, 55.2658],
    [-131.6442, 55.2707],
    [-131.6507, 55.2797],
    [-131.6490, 55.2895],
    [-131.6557, 55.2905],
    [-131.6588, 55.2943],
    [-131.6683, 55.3016],
    [-131.6780, 55.3019],
    [-131.6839, 55.3054],
    [-131.6860, 55.3037],
    [-131.6927, 55.3044],
    [-131.6902, 55.2980],
    [-131.6831, 55.2924],
    [-131.6832, 55.2879],
    [-131.6872, 55.2806],
    [-131.6851, 55.2751],
    [-131.6817, 55.2693],
    [-131.6762, 55.2643],
    [-131.6705, 55.2517],
    [-131.6750, 55.2523],
    [-131.6813, 55.2540],
    [-131.6859, 55.2527],
    [-131.6858, 55.2410],
    [-131.6839, 55.2346],
    [-131.6863, 55.2252],
    [-131.6982, 55.2234],
    [-131.7071, 55.2272],
    [-131.7209, 55.2292],
    [-131.7269, 55.2326],
    [-131.7341, 55.2387],
    [-131.7400, 55.2426],
    [-131.7493, 55.2504],
    [-131.7588, 55.2519],
    [-131.7585, 55.2442],
    [-131.7533, 55.2374],
    [-131.7454, 55.2313],
    [-131.7459, 55.2259],
    [-131.7443, 55.2198],
    [-131.7366, 55.2196],
    [-131.7392, 55.2166],
    [-131.7335, 55.2108],
    [-131.7278, 55.2074],
    [-131.7140, 55.1967],
    [-131.7123, 55.1900],
    [-131.7215, 55.1709],
    [-131.7412, 55.1613],
    [-131.7461, 55.1584],
    [-131.7411, 55.1546],
    [-131.7400, 55.1501],
    [-131.7193, 55.1505],
    [-131.7230, 55.1402],
    [-131.7431, 55.1335],
    [-131.7589, 55.1277],
    [-131.7666, 55.1328],
    [-131.7789, 55.1385],
    [-131.7773, 55.1421],
    [-131.7817, 55.1485],
    [-131.7939, 55.1543],
    [-131.7944, 55.1611],
    [-131.8077, 55.1725],
    [-131.8193, 55.1799],
    [-131.8315, 55.1936],
    [-131.8298, 55.2014],
    [-131.8347, 55.2164],
    [-131.8414, 55.2360],
    [-131.8430, 55.2575],
    [-131.8451, 55.2662],
    [-131.8484, 55.2723],
    [-131.8578, 55.2816],
    [-131.8642, 55.2973],
    [-131.8678, 55.3083],
    [-131.8703, 55.3183],
    [-131.8642, 55.3287],
    [-131.8661, 55.3391],
    [-131.8667, 55.3472],
    [-131.8604, 55.3504],
    [-131.8559, 55.3545],
    [-131.8655, 55.3602],
    [-131.8725, 55.3655],
    [-131.8802, 55.3739],
    [-131.8782, 55.3822],
    [-131.8609, 55.3824],
    [-131.8465, 55.3810],
    [-131.8342, 55.3777],
    [-131.8380, 55.3849],
    [-131.8464, 55.3911],
    [-131.8517, 55.4081],
    [-131.8547, 55.4192],
    [-131.8449, 55.4251],
    [-131.8301, 55.4218],
    [-131.8177, 55.4176],
    [-131.8083, 55.4113],
    [-131.8052, 55.4063],
    [-131.7874, 55.3978],
    [-131.7704, 55.3920],
    [-131.7716, 55.3852],
    [-131.7606, 55.3832],
    [-131.7520, 55.3779],
    [-131.7300, 55.3677],
    [-131.7199, 55.3683],
    [-131.7267, 55.3737],
    [-131.7382, 55.3819],
    [-131.7378, 55.3883],
    [-131.7362, 55.3927],
    [-131.7413, 55.3978],
    [-131.7437, 55.3995],
    [-131.7590, 55.4074],
    [-131.7673, 55.4148],
    [-131.7747, 55.4202],
    [-131.7840, 55.4238],
    [-131.7974, 55.4337],
    [-131.8074, 55.4373],
    [-131.8222, 55.4450],
    [-131.8308, 55.4476],
    [-131.8339, 55.4551],
    [-131.8308, 55.4612],
    [-131.8309, 55.4670],
    [-131.8210, 55.4726],
    [-131.8087, 55.4734],
    [-131.7984, 55.4737],
    [-131.7941, 55.4735],
    [-131.7891, 55.4763],
    [-131.7801, 55.4787],
    [-131.7667, 55.4872],
    [-131.7183, 55.5179],
    [-131.7030, 55.5372],
    [-131.7032, 55.5427],
    [-131.6991, 55.5517],
    [-131.6902, 55.5567],
    [-131.6865, 55.5643],
    [-131.6997, 55.5656],
    [-131.6870, 55.5748],
    [-131.6817, 55.5830],
    [-131.6604, 55.5820],
    [-131.6449, 55.5845],
    [-131.6499, 55.5876],
    [-131.6475, 55.5931],
    [-131.6376, 55.5948],
    [-131.6318, 55.6006],
    [-131.6422, 55.6037],
    [-131.6584, 55.6050],
    [-131.6799, 55.6101],
    [-131.6941, 55.6125],
    [-131.7109, 55.6246],
    [-131.7236, 55.6396],
    [-131.7147, 55.6529],
    [-131.7046, 55.6595],
    [-131.7080, 55.6733],
    [-131.6986, 55.6966],
    [-131.7067, 55.7064],
    [-131.7192, 55.7134],
    [-131.7273, 55.7234],
    [-131.7327, 55.7320],
    [-131.7255, 55.7287],
    [-131.7256, 55.7357],
    [-131.7193, 55.7491],
    [-131.7073, 55.7542],
    [-131.6953, 55.7555],
    [-131.6874, 55.7525],
    [-131.6820, 55.7606],
    [-131.6793, 55.7647],
    [-131.6749, 55.7688],
    [-131.6658, 55.7698],
    [-131.6450, 55.7713],
    [-131.6368, 55.7654],
    [-131.6203, 55.7632],
    [-131.5873, 55.7772],
    [-131.5707, 55.7804],
    [-131.5526, 55.7754],
    [-131.5398, 55.7761],
    [-131.5197, 55.7814],
    [-131.5008, 55.7843],
    [-131.4903, 55.7884],
    [-131.5024, 55.7945],
    [-131.5202, 55.7974],
    [-131.5405, 55.8057],
    [-131.5499, 55.8020],
    [-131.5469, 55.7965],
    [-131.5611, 55.7919],
    [-131.5690, 55.7939],
    [-131.5821, 55.7945],
    [-131.6074, 55.7867],
    [-131.6291, 55.7832],
    [-131.6402, 55.7883],
    [-131.6563, 55.7955],
    [-131.6826, 55.7981],
    [-131.6988, 55.7889],
    [-131.7036, 55.7994],
    [-131.7078, 55.8076],
    [-131.7086, 55.8207],
    [-131.7086, 55.8382],
    [-131.6857, 55.8387],
    [-131.6352, 55.8361],
    [-131.5499, 55.8355],
    [-131.5394, 55.8347],
    [-131.5317, 55.8355],
    [-131.5250, 55.8379],
    [-131.5110, 55.8401],
    [-131.5042, 55.8408],
    [-131.4917, 55.8441],
    [-131.4872, 55.8463],
    [-131.4978, 55.8466],
    [-131.5254, 55.8477],
    [-131.5365, 55.8502],
    [-131.5482, 55.8481],
    [-131.5557, 55.8496],
    [-131.5587, 55.8524],
    [-131.5582, 55.8578],
    [-131.5582, 55.8670],
    [-131.5697, 55.8751],
    [-131.5729, 55.8803],
    [-131.5935, 55.8932],
    [-131.5993, 55.9000],
    [-131.5874, 55.9131],
    [-131.5783, 55.9130],
    [-131.5726, 55.9131],
    [-131.5669, 55.9194],
    [-131.5664, 55.9241],
    [-131.5746, 55.9243],
    [-131.5748, 55.9291],
    [-131.6044, 55.9212],
    [-131.6146, 55.9257],
    [-131.6124, 55.9387],
    [-131.6291, 55.9362],
    [-131.6441, 55.9297],
    [-131.6592, 55.9251],
    [-131.6755, 55.9193],
    [-131.6847, 55.9148],
    [-131.7150, 55.8980],
    [-131.7461, 55.8838],
    [-131.7632, 55.8782],
    [-131.7805, 55.8814],
    [-131.7915, 55.8834],
    [-131.7973, 55.8830],
    [-131.7976, 55.8767],
    [-131.8110, 55.8760],
    [-131.8177, 55.8828],
    [-131.8184, 55.8898],
    [-131.8304, 55.8884],
    [-131.8290, 55.8850],
    [-131.8263, 55.8773],
    [-131.8348, 55.8745],
    [-131.8484, 55.8735],
    [-131.8645, 55.8724],
    [-131.8817, 55.8703],
    [-131.8964, 55.8688],
    [-131.9051, 55.8697],
    [-131.9174, 55.8639],
    [-131.9124, 55.8556],
    [-131.8962, 55.8485],
    [-131.8846, 55.8441],
    [-131.8573, 55.8445],
    [-131.8293, 55.8398],
    [-131.8169, 55.8380],
    [-131.7978, 55.8342],
    [-131.7847, 55.8246],
    [-131.7751, 55.8235],
    [-131.7621, 55.8137],
    [-131.7672, 55.8068],
    [-131.7682, 55.7938],
    [-131.7773, 55.7872],
    [-131.7793, 55.7757],
    [-131.7884, 55.7704],
    [-131.7930, 55.7675],
    [-131.7993, 55.7690],
    [-131.8014, 55.7617],
    [-131.8010, 55.7562],
    [-131.7984, 55.7515],
    [-131.8054, 55.7472],
    [-131.8106, 55.7412],
    [-131.8140, 55.7314],
    [-131.8252, 55.7180],
    [-131.8366, 55.7180],
    [-131.8415, 55.7197],
    [-131.8467, 55.7199],
    [-131.8517, 55.7213],
    [-131.8613, 55.7288],
    [-131.8664, 55.7376],
    [-131.8725, 55.7381],
    [-131.8707, 55.7290],
    [-131.8685, 55.7247],
    [-131.8616, 55.7158],
    [-131.8497, 55.7034],
    [-131.8418, 55.6943],
    [-131.8342, 55.6917],
    [-131.8265, 55.6773],
    [-131.8213, 55.6718],
    [-131.8177, 55.6696],
    [-131.8262, 55.6679],
    [-131.8296, 55.6710],
    [-131.8364, 55.6709],
    [-131.8344, 55.6634],
    [-131.8373, 55.6576],
    [-131.8472, 55.6558],
    [-131.8515, 55.6510],
    [-131.8523, 55.6454],
    [-131.8544, 55.6388],
    [-131.8571, 55.6319],
    [-131.8662, 55.6339],
    [-131.8739, 55.6336],
    [-131.8788, 55.6230],
    [-131.8890, 55.6230],
    [-131.8906, 55.6131],
    [-131.8857, 55.6007],
    [-131.8959, 55.5997],
    [-131.9114, 55.6089],
    [-131.9187, 55.6109],
    [-131.9171, 55.6068],
    [-131.9329, 55.6155],
    [-131.9437, 55.6157],
    [-131.9475, 55.6238],
    [-131.9647, 55.6343],
    [-131.9689, 55.6429],
    [-131.9771, 55.6481],
    [-131.9841, 55.6562],
    [-132.0018, 55.6662],
    [-132.0113, 55.6730],
    [-132.0171, 55.6752],
    [-132.0276, 55.6795],
    [-132.0283, 55.6746],
    [-132.0162, 55.6681],
    [-132.0098, 55.6604],
    [-131.9986, 55.6534],
    [-131.9940, 55.6472],
    [-131.9903, 55.6439],
    [-131.9828, 55.6359],
    [-131.9704, 55.6286],
    [-131.9690, 55.6207],
    [-131.9626, 55.6087],
    [-131.9494, 55.5992],
    [-131.9437, 55.5934],
    [-131.9355, 55.5890],
    [-131.9330, 55.5810],
    [-131.9427, 55.5847],
    [-131.9461, 55.5820],
    [-131.9487, 55.5783],
    [-131.9386, 55.5679],
    [-131.9449, 55.5610],
    [-131.9407, 55.5558],
    [-131.9419, 55.5472],
    [-131.9390, 55.5450],
    [-131.9419, 55.5306],
    [-131.9441, 55.5253],
    [-131.9539, 55.5318],
    [-131.9622, 55.5242],
    [-131.9640, 55.5090],
    [-131.9545, 55.5018],
    [-131.9690, 55.5054],
    [-131.9706, 55.5034],
    [-131.9710, 55.4969],
    [-131.9807, 55.4977],
    [-131.9986, 55.5077],
    [-132.0058, 55.5122],
    [-132.0221, 55.5150],
    [-132.0268, 55.5190],
    [-132.0394, 55.5286],
    [-132.0524, 55.5352],
    [-132.0653, 55.5415],
    [-132.0726, 55.5441],
    [-132.0781, 55.5427],
    [-132.0768, 55.5377],
    [-132.0870, 55.5381],
    [-132.0958, 55.5463],
    [-132.1122, 55.5493],
    [-132.1201, 55.5497],
    [-132.1311, 55.5548],
    [-132.1431, 55.5591],
    [-132.1539, 55.5676],
    [-132.1628, 55.5736],
    [-132.1640, 55.5797],
    [-132.1710, 55.5828],
    [-132.1802, 55.5862],
    [-132.1914, 55.5984],
    [-132.2002, 55.6146],
    [-132.1990, 55.6215],
    [-132.2028, 55.6280],
    [-132.1990, 55.6343],
    [-132.2038, 55.6414],
    [-132.2037, 55.6498],
    [-132.2084, 55.6547],
    [-132.2150, 55.6620],
    [-132.2168, 55.6698],
    [-132.2194, 55.6769],
    [-132.2201, 55.6831],
    [-132.2246, 55.6897],
    [-132.2208, 55.6903],
    [-132.2284, 55.6997],
    [-132.2267, 55.7040],
    [-132.2359, 55.7096],
    [-132.2541, 55.7260],
    [-132.2643, 55.7363],
    [-132.2667, 55.7431],
    [-132.2644, 55.7473],
    [-132.2744, 55.7486],
    [-132.2787, 55.7472],
    [-132.2832, 55.7580],
    [-132.2856, 55.7646],
    [-132.2756, 55.7666],
    [-132.2643, 55.7621],
    [-132.2543, 55.7593],
    [-132.2496, 55.7538],
    [-132.2438, 55.7516],
    [-132.2351, 55.7439],
    [-132.2254, 55.7403],
    [-132.2156, 55.7364],
    [-132.2098, 55.7350],
    [-132.2029, 55.7395],
    [-132.1928, 55.7417],
    [-132.1884, 55.7482],
    [-132.1854, 55.7577],
    [-132.1879, 55.7610],
    [-132.1835, 55.7640],
    [-132.1852, 55.7688],
    [-132.1853, 55.7719],
    [-132.1864, 55.7811],
    [-132.1899, 55.7913],
    [-132.1834, 55.7952],
    [-132.1823, 55.7994],
    [-132.1860, 55.8033],
    [-132.1754, 55.8043],
    [-132.1698, 55.8023],
    [-132.1567, 55.8022],
    [-132.1474, 55.8044],
    [-132.1418, 55.8084],
    [-132.1281, 55.8116],
    [-132.1120, 55.8116],
    [-132.0962, 55.8110],
    [-132.0875, 55.8089],
    [-132.0745, 55.8100],
    [-132.0638, 55.8048],
    [-132.0547, 55.8010],
    [-132.0436, 55.8006],
    [-132.0288, 55.7977],
    [-132.0364, 55.8039],
    [-132.0473, 55.8092],
    [-132.0552, 55.8137],
    [-132.0611, 55.8158],
    [-132.0583, 55.8219],
    [-132.0575, 55.8245],
    [-132.0618, 55.8277],
    [-132.0713, 55.8284],
    [-132.0918, 55.8351],
    [-132.0873, 55.8418],
    [-132.0945, 55.8452],
    [-132.0924, 55.8532],
    [-132.0857, 55.8526],
    [-132.0849, 55.8612],
    [-132.0724, 55.8677],
    [-132.0627, 55.8762],
    [-132.0520, 55.8821],
    [-132.0493, 55.8853],
    [-132.0446, 55.8874],
    [-132.0391, 55.8877],
    [-132.0501, 55.8993],
    [-132.0545, 55.9072],
    [-132.0577, 55.9134],
    [-132.0673, 55.9202],
    [-132.0695, 55.9277],
    [-132.0704, 55.9387],
    [-132.0561, 55.9476],
    [-132.0408, 55.9520],
    [-132.0398, 55.9604],
    [-132.0339, 55.9616],
    [-132.0212, 55.9621],
    [-132.0073, 55.9636],
    [-132.0068, 55.9701],
    [-131.9969, 55.9644],
    [-131.9837, 55.9660],
    [-131.9659, 55.9698],
    [-131.9583, 55.9739],
    [-131.9691, 55.9780],
    [-131.9733, 55.9873],
    [-131.9570, 55.9979],
    [-131.9600, 56.0119],
    [-131.9652, 56.0190],
    [-131.9696, 56.0336],
    [-131.9730, 56.0386],
    [-131.9761, 56.0471],
    [-131.9817, 56.0621],
    [-131.9789, 56.0719],
    [-131.9794, 56.0822],
    [-131.9720, 56.1113],
    [-131.9713, 56.1387],
    [-131.9732, 56.1731],
    [-131.9357, 56.1772],
    [-131.8990, 56.1819],
    [-131.8919, 56.1849],
    [-131.8711, 56.2033],
    [-131.8449, 56.1990],
    [-131.8295, 56.1923],
    [-131.8221, 56.1916],
    [-131.8192, 56.1955],
    [-131.8108, 56.1966],
    [-131.7929, 56.1981],
    [-131.7796, 56.2016],
    [-131.7601, 56.2032],
    [-131.7386, 56.1968],
    [-131.7160, 56.1899],
    [-131.7011, 56.1875],
    [-131.6824, 56.1934],
    [-131.6626, 56.1871],
    [-131.6473, 56.1840],
    [-131.6541, 56.1990],
    [-131.6668, 56.2035],
    [-131.6776, 56.2098],
    [-131.6922, 56.2143],
    [-131.7021, 56.2155],
    [-131.7231, 56.2170],
    [-131.7343, 56.2152],
    [-131.7615, 56.2238],
    [-131.7754, 56.2240],
    [-131.7865, 56.2190],
    [-131.8063, 56.2165],
    [-131.8203, 56.2188],
    [-131.8377, 56.2208],
    [-131.8535, 56.2232],
    [-131.8712, 56.2288],
    [-131.8819, 56.2291],
    [-131.8979, 56.2256],
    [-131.9050, 56.2295],
    [-131.9204, 56.2339],
    [-131.9299, 56.2355],
    [-131.9281, 56.2290],
    [-131.9214, 56.2253],
    [-131.9151, 56.2189],
    [-131.9156, 56.2138],
    [-131.9218, 56.2096],
    [-131.9209, 56.2035],
    [-131.9368, 56.1971],
    [-131.9432, 56.1934],
    [-131.9502, 56.1946],
    [-131.9620, 56.1943],
    [-131.9719, 56.1923],
    [-131.9840, 56.1908],
    [-131.9917, 56.1937],
    [-131.9982, 56.1940],
    [-132.0010, 56.1891],
    [-132.0163, 56.1816],
    [-132.0150, 56.1682],
    [-132.0171, 56.1608],
    [-132.0241, 56.1443],
    [-132.0248, 56.1363],
    [-132.0316, 56.1330],
    [-132.0370, 56.1343],
    [-132.0457, 56.1392],
    [-132.0536, 56.1451],
    [-132.0617, 56.1463],
    [-132.0580, 56.1390],
    [-132.0558, 56.1339],
    [-132.0590, 56.1298],
    [-132.0613, 56.1251],
    [-132.0625, 56.1202],
    [-132.0758, 56.1180],
    [-132.0826, 56.1226],
    [-132.0965, 56.1335],
    [-132.0994, 56.1408],
    [-132.1028, 56.1490],
    [-132.1120, 56.1584],
    [-132.1167, 56.1633],
    [-132.1280, 56.1610],
    [-132.1419, 56.1569],
    [-132.1485, 56.1558],
    [-132.1523, 56.1627],
    [-132.1605, 56.1668],
    [-132.1714, 56.1711],
    [-132.1859, 56.1646],
    [-132.1822, 56.1584],
    [-132.1734, 56.1533],
    [-132.1608, 56.1460],
    [-132.1602, 56.1406],
    [-132.1551, 56.1395],
    [-132.1501, 56.1331],
    [-132.1449, 56.1345],
    [-132.1398, 56.1317],
    [-132.1327, 56.1280],
    [-132.1236, 56.1234],
    [-132.1176, 56.1191],
    [-132.1233, 56.1155],
    [-132.1266, 56.1114],
    [-132.1167, 56.1116],
    [-132.1084, 56.1131],
    [-132.1050, 56.1065],
    [-132.0994, 56.1018],
    [-132.1088, 56.0986],
    [-132.1061, 56.0942],
    [-132.0991, 56.0890],
    [-132.1061, 56.0876],
    [-132.1117, 56.0899],
    [-132.1218, 56.0901],
    [-132.1261, 56.0874],
    [-132.1228, 56.0858],
    [-132.1241, 56.0792],
    [-132.1348, 56.0813],
    [-132.1341, 56.0864],
    [-132.1323, 56.0903],
    [-132.1312, 56.0968],
    [-132.1353, 56.0977],
    [-132.1409, 56.0991],
    [-132.1475, 56.0948],
    [-132.1502, 56.0909],
    [-132.1487, 56.0886],
    [-132.1527, 56.0849],
    [-132.1512, 56.0804],
    [-132.1463, 56.0759],
    [-132.1490, 56.0728],
    [-132.1576, 56.0734],
    [-132.1704, 56.0741],
    [-132.1816, 56.0739],
    [-132.1862, 56.0763],
    [-132.1892, 56.0818],
    [-132.1923, 56.0871],
    [-132.1987, 56.0866],
    [-132.2063, 56.0838],
    [-132.2152, 56.0812],
    [-132.2221, 56.0720],
    [-132.2213, 56.0677],
    [-132.2114, 56.0669],
    [-132.2030, 56.0625],
    [-132.1885, 56.0588],
    [-132.1804, 56.0582],
    [-132.1739, 56.0509],
    [-132.1679, 56.0456],
    [-132.1788, 56.0460],
    [-132.1887, 56.0476],
    [-132.1999, 56.0472],
    [-132.1987, 56.0399],
    [-132.1912, 56.0398],
    [-132.1789, 56.0364],
    [-132.1738, 56.0291],
    [-132.1721, 56.0222],
    [-132.1664, 56.0169],
    [-132.1580, 56.0108],
    [-132.1567, 56.0051],
    [-132.1569, 55.9996],
    [-132.1669, 55.9942],
    [-132.1670, 55.9904],
    [-132.1639, 55.9874],
    [-132.1649, 55.9837],
    [-132.1563, 55.9842],
    [-132.1511, 55.9820],
    [-132.1455, 55.9778],
    [-132.1432, 55.9741],
    [-132.1356, 55.9700],
    [-132.1344, 55.9630],
    [-132.1306, 55.9533],
    [-132.1241, 55.9507],
    [-132.1368, 55.9389],
    [-132.1444, 55.9349],
    [-132.1552, 55.9274],
    [-132.1602, 55.9212],
    [-132.1688, 55.9171],
    [-132.1753, 55.9212],
    [-132.1874, 55.9194],
    [-132.1931, 55.9209],
    [-132.1841, 55.9229],
    [-132.1809, 55.9266],
    [-132.1849, 55.9319],
    [-132.1933, 55.9374],
    [-132.1986, 55.9491],
    [-132.2029, 55.9592],
    [-132.2107, 55.9539],
    [-132.2108, 55.9449],
    [-132.2171, 55.9405],
    [-132.2217, 55.9374],
    [-132.2168, 55.9352],
    [-132.2255, 55.9308],
    [-132.2318, 55.9298],
    [-132.2397, 55.9225],
    [-132.2375, 55.9270],
    [-132.2453, 55.9250],
    [-132.2523, 55.9260],
    [-132.2532, 55.9312],
    [-132.2617, 55.9338],
    [-132.2693, 55.9359],
    [-132.2745, 55.9362],
    [-132.2810, 55.9330],
    [-132.2807, 55.9283],
    [-132.2845, 55.9235],
    [-132.2943, 55.9199],
    [-132.3024, 55.9220],
    [-132.3088, 55.9136],
    [-132.2940, 55.9099],
    [-132.2918, 55.9043],
    [-132.2904, 55.9013],
    [-132.3058, 55.9001],
    [-132.3039, 55.8967],
    [-132.3146, 55.8913],
    [-132.3195, 55.8885],
    [-132.3330, 55.8902],
    [-132.3409, 55.8833],
    [-132.3346, 55.8776],
    [-132.3270, 55.8781],
    [-132.3208, 55.8751],
    [-132.3117, 55.8693],
    [-132.3145, 55.8611],
    [-132.3214, 55.8525],
    [-132.3125, 55.8416],
    [-132.3294, 55.8632],
    [-132.3359, 55.8571],
    [-132.3511, 55.8553],
    [-132.3637, 55.8531],
    [-132.3723, 55.8504],
    [-132.3767, 55.8563],
    [-132.3801, 55.8631],
    [-132.3910, 55.8734],
    [-132.4008, 55.8839],
    [-132.3967, 55.8879],
    [-132.3933, 55.8919],
    [-132.3950, 55.8972],
    [-132.3971, 55.9055],
    [-132.3860, 55.9055],
    [-132.3800, 55.9091],
    [-132.3840, 55.9146],
    [-132.3822, 55.9186],
    [-132.3733, 55.9177],
    [-132.3643, 55.9269],
    [-132.3691, 55.9293],
    [-132.3877, 55.9382],
    [-132.3929, 55.9462],
    [-132.4017, 55.9509],
    [-132.4149, 55.9473],
    [-132.4273, 55.9478],
    [-132.4351, 55.9501],
    [-132.4390, 55.9549],
    [-132.4522, 55.9610],
    [-132.4442, 55.9614],
    [-132.4360, 55.9640],
    [-132.4351, 55.9708],
    [-132.4596, 55.9741],
    [-132.4618, 55.9763],
    [-132.4511, 55.9812],
    [-132.4432, 55.9847],
    [-132.4375, 55.9888],
    [-132.4649, 55.9929],
    [-132.4452, 55.9982],
    [-132.4214, 56.0043],
    [-132.4111, 56.0032],
    [-132.4040, 56.0041],
    [-132.3924, 56.0102],
    [-132.3828, 56.0160],
    [-132.3779, 56.0248],
    [-132.3798, 56.0343],
    [-132.3908, 56.0322],
    [-132.3902, 56.0227],
    [-132.3983, 56.0171],
    [-132.4067, 56.0157],
    [-132.4239, 56.0161],
    [-132.4397, 56.0190],
    [-132.4517, 56.0164],
    [-132.4677, 56.0165],
    [-132.4750, 56.0183],
    [-132.4713, 56.0239],
    [-132.4772, 56.0273],
    [-132.4860, 56.0255],
    [-132.4849, 56.0341],
    [-132.4792, 56.0411],
    [-132.4751, 56.0519],
    [-132.4621, 56.0589],
    [-132.4643, 56.0657],
    [-132.4616, 56.0701],
    [-132.4666, 56.0760],
    [-132.4791, 56.0708],
    [-132.4825, 56.0653],
    [-132.4952, 56.0638],
    [-132.5125, 56.0711],
    [-132.5198, 56.0741],
    [-132.5386, 56.0702],
    [-132.5407, 56.0578],
    [-132.5416, 56.0529],
    [-132.5562, 56.0600],
    [-132.5741, 56.0696],
    [-132.5832, 56.0758],
    [-132.5943, 56.0740],
    [-132.5955, 56.0685],
    [-132.6085, 56.0700],
    [-132.6097, 56.0603],
    [-132.6087, 56.0521],
    [-132.6149, 56.0468],
    [-132.6035, 56.0378],
    [-132.5936, 56.0233],
    [-132.5981, 56.0192],
    [-132.6077, 56.0108],
    [-132.6117, 56.0210],
    [-132.6197, 56.0274],
    [-132.6218, 56.0353],
    [-132.6367, 56.0312],
    [-132.6438, 56.0394],
    [-132.6504, 56.0454],
    [-132.6584, 56.0497],
    [-132.6711, 56.0675],
    [-132.6721, 56.0771],
    [-132.6847, 56.0876],
    [-132.7006, 56.0998],
    [-132.6968, 56.1056],
    [-132.7069, 56.1099],
    [-132.7021, 56.1169],
    [-132.7069, 56.1229],
    [-132.7203, 56.1388],
    [-132.7162, 56.1471],
    [-132.7167, 56.1589],
    [-132.7198, 56.1627],
    [-132.7252, 56.1613],
    [-132.7265, 56.1712],
    [-132.7135, 56.1663],
    [-132.7039, 56.1588],
    [-132.6961, 56.1580],
    [-132.6937, 56.1633],
    [-132.6921, 56.1674],
    [-132.6914, 56.1707],
    [-132.6973, 56.1731],
    [-132.7049, 56.1838],
    [-132.7077, 56.1955],
    [-132.6933, 56.2032],
    [-132.6941, 56.2075],
    [-132.7040, 56.2109],
    [-132.7164, 56.2148],
    [-132.7141, 56.2221],
    [-132.7063, 56.2256],
    [-132.7000, 56.2300],
    [-132.6975, 56.2349],
    [-132.6933, 56.2393],
    [-132.6693, 56.2390],
    [-132.6605, 56.2365],
    [-132.6515, 56.2341],
    [-132.6408, 56.2344],
    [-132.6327, 56.2362],
    [-132.6265, 56.2383],
    [-132.6156, 56.2366],
    [-132.6014, 56.2392],
    [-132.5960, 56.2452],
    [-132.5924, 56.2554],
    [-132.5842, 56.2728],
    [-132.5793, 56.2863],
    [-132.5744, 56.2935],
    [-132.5587, 56.3055],
    [-132.5443, 56.3132],
    [-132.5485, 56.3226],
    [-132.5386, 56.3336],
    [-132.5214, 56.3387],
    [-132.5059, 56.3363],
    [-132.4737, 56.3419],
    [-132.4494, 56.3515],
    [-132.4270, 56.3498],
    [-132.4148, 56.3394],
    [-132.3918, 56.3187],
    [-132.3795, 56.3054],
    [-132.3915, 56.2866],
    [-132.3885, 56.2729],
    [-132.3820, 56.2556],
    [-132.3965, 56.2434],
    [-132.3644, 56.2245],
    [-132.3483, 56.2119],
    [-132.3062, 56.1915],
    [-132.2726, 56.1928],
    [-132.2494, 56.1938],
    [-132.2389, 56.2000],
    [-132.2650, 56.2045],
    [-132.2931, 56.2183],
    [-132.3121, 56.2301],
    [-132.3427, 56.2562],
    [-132.3654, 56.2830],
    [-132.3491, 56.3045],
    [-132.3556, 56.3468],
    [-132.3617, 56.3660],
    [-132.3544, 56.3885],
    [-132.3356, 56.3966],
    [-132.3416, 56.4132],
    [-132.3814, 56.4449],
    [-132.3872, 56.4647],
    [-132.3914, 56.4745],
    [-132.3900, 56.4884],
    [-132.3827, 56.4895],
    [-132.3606, 56.4848],
    [-132.3480, 56.4754],
    [-132.3401, 56.4723],
    [-132.3083, 56.4635],
    [-132.2781, 56.4616],
    [-132.2534, 56.4495],
    [-132.2432, 56.4285],
    [-132.2337, 56.4139],
    [-132.2360, 56.4072],
    [-132.2379, 56.3976],
    [-132.2189, 56.3805],
    [-132.1876, 56.3669],
    [-132.1745, 56.3786],
    [-132.1792, 56.3993],
    [-132.1956, 56.4137],
    [-132.2106, 56.4568],
    [-132.2370, 56.4726],
    [-132.2629, 56.4866],
    [-132.2995, 56.4910],
    [-132.3111, 56.5045],
    [-132.3451, 56.5183],
    [-132.3658, 56.5405],
    [-132.3618, 56.5557],
    [-132.3672, 56.5797],
    [-132.3665, 56.5949],
    [-132.3409, 56.6135],
    [-132.3394, 56.6405],
    [-132.3848, 56.6265],
    [-132.4416, 56.6067],
    [-132.5022, 56.6095],
    [-132.5453, 56.6205],
    [-132.5671, 56.6299],
    [-132.5697, 56.6424],
    [-132.5552, 56.6542],
    [-132.5752, 56.6643],
    [-132.5851, 56.6592],
    [-132.5921, 56.6767],
    [-132.5776, 56.6810],
    [-132.5631, 56.6744],
    [-132.5429, 56.6832],
    [-132.5341, 56.6972],
    [-132.5454, 56.7076],
    [-132.5576, 56.7155],
    [-132.5602, 56.7332],
    [-132.5503, 56.7370],
    [-132.5322, 56.7508],
    [-132.5400, 56.7565],
    [-132.5823, 56.7636],
    [-132.6094, 56.7713],
    [-132.6218, 56.7787],
    [-132.6624, 56.7899],
    [-132.7282, 56.8195],
    [-132.7437, 56.8272],
    [-132.7768, 56.8371],
    [-132.8027, 56.8640],
    [-132.7993, 56.8745],
    [-132.8039, 56.8806],
    [-132.8088, 56.8847],
    [-132.8276, 56.8965],
    [-132.8573, 56.9054],
    [-132.8866, 56.9254],
    [-132.9053, 56.9559],
    [-132.9398, 56.9773],
    [-132.9531, 56.9936],
    [-132.9282, 56.9943],
    [-132.8924, 56.9930],
    [-132.8730, 57.0008],
    [-132.8526, 57.0082],
    [-132.8509, 57.0217],
    [-132.8313, 57.0135],
    [-132.8212, 57.0029],
    [-132.8269, 56.9911],
    [-132.8136, 56.9815],
    [-132.8160, 56.9736],
    [-132.8029, 56.9739],
    [-132.7879, 56.9756],
    [-132.7915, 56.9918],
    [-132.7905, 57.0070],
    [-132.8364, 57.0614],
    [-132.8267, 57.0707],
    [-132.8131, 57.0763],
    [-132.8124, 57.0902],
    [-132.8248, 57.1075],
    [-132.8352, 57.0973],
    [-132.8438, 57.0878],
    [-132.8585, 57.0756],
    [-132.8721, 57.0752],
    [-132.8709, 57.0678],
    [-132.8733, 57.0592],
    [-132.8687, 57.0448],
    [-132.8699, 57.0359],
    [-132.8856, 57.0269],
    [-132.9139, 57.0314],
    [-132.9246, 57.0408],
    [-132.9389, 57.0446],
    [-132.9534, 57.0475],
    [-132.9859, 57.0535],
    [-132.9809, 57.0442],
    [-132.9926, 57.0368],
    [-132.9969, 57.0233],
    [-133.0022, 57.0204],
    [-133.0054, 57.0502],
    [-133.0201, 57.0571],
    [-133.0370, 57.0597],
    [-133.0915, 57.0832],
    [-133.1014, 57.0828],
    [-133.1373, 57.0894],
    [-133.1651, 57.0859],
    [-133.1960, 57.0991],
    [-133.1991, 57.1084],
    [-133.2086, 57.1168],
    [-133.1982, 57.1270],
    [-133.2017, 57.1382],
    [-133.2167, 57.1375],
    [-133.2300, 57.1389],
    [-133.2616, 57.1355],
    [-133.2842, 57.1104],
    [-133.3153, 57.1062],
    [-133.3189, 57.1109],
    [-133.3434, 57.1164],
    [-133.3622, 57.1207],
    [-133.3629, 57.1251],
    [-133.3776, 57.1306],
    [-133.4202, 57.1377],
    [-133.4254, 57.1449],
    [-133.4644, 57.1501],
    [-133.4696, 57.1598],
    [-133.4960, 57.1645],
    [-133.5081, 57.1746],
    [-133.5270, 57.1788],
    [-133.5454, 57.1808],
    [-133.5638, 57.1828],
    [-133.5711, 57.1867],
    [-133.5457, 57.1935],
    [-133.5219, 57.1979],
    [-133.5040, 57.2104],
    [-133.5031, 57.2186],
    [-133.4981, 57.2257],
    [-133.5132, 57.2470],
    [-133.5262, 57.2635],
    [-133.5124, 57.2622],
    [-133.5190, 57.2680],
    [-133.5302, 57.2753],
    [-133.5072, 57.2809],
    [-133.4898, 57.2797],
    [-133.4929, 57.2866],
    [-133.4984, 57.2919],
    [-133.4969, 57.2983],
    [-133.5219, 57.3041],
    [-133.4988, 57.3028],
    [-133.4759, 57.3080],
    [-133.4480, 57.2982],
    [-133.4259, 57.2860],
    [-133.3981, 57.2887],
    [-133.3683, 57.2845],
    [-133.3565, 57.2888],
    [-133.3500, 57.2910],
    [-133.3301, 57.2996],
    [-133.3096, 57.2911],
    [-133.2940, 57.2904],
    [-133.2711, 57.2887],
    [-133.2545, 57.2931],
    [-133.2400, 57.3024],
    [-133.2115, 57.3065],
    [-133.1896, 57.3113],
    [-133.1903, 57.3253],
    [-133.2089, 57.3271],
    [-133.2136, 57.3240],
    [-133.2386, 57.3213],
    [-133.2512, 57.3258],
    [-133.2668, 57.3285],
    [-133.2849, 57.3341],
    [-133.2947, 57.3348],
    [-133.3044, 57.3362],
    [-133.3123, 57.3329],
    [-133.3244, 57.3323],
    [-133.3377, 57.3350],
    [-133.3472, 57.3341],
    [-133.3612, 57.3336],
    [-133.3828, 57.3365],
    [-133.3933, 57.3395],
    [-133.4023, 57.3416],
    [-133.4323, 57.3513],
    [-133.4525, 57.3545],
    [-133.4760, 57.3804],
    [-133.4646, 57.3907],
    [-133.4492, 57.3985],
    [-133.4373, 57.3989],
    [-133.4290, 57.4014],
    [-133.4206, 57.4037],
    [-133.4221, 57.4124],
    [-133.4427, 57.4099],
    [-133.4442, 57.4165],
    [-133.4489, 57.4266],
    [-133.4551, 57.4205],
    [-133.4715, 57.4266],
    [-133.4831, 57.4391],
    [-133.4924, 57.4430],
    [-133.5060, 57.4518],
    [-133.5069, 57.4590],
    [-133.5151, 57.4665],
    [-133.5217, 57.4723],
    [-133.5159, 57.4780],
    [-133.5262, 57.4884],
    [-133.5235, 57.5128],
    [-133.5156, 57.5281],
    [-133.5167, 57.5439],
    [-133.4912, 57.5525],
    [-133.4789, 57.5642],
    [-133.4812, 57.5715],
    [-133.4622, 57.5769],
    [-133.4772, 57.5847],
    [-133.4938, 57.5791],
    [-133.5137, 57.5744],
    [-133.5283, 57.5732],
    [-133.5462, 57.5655],
    [-133.5699, 57.5622],
    [-133.5949, 57.5717],
    [-133.6187, 57.5782],
    [-133.6222, 57.5903],
    [-133.6350, 57.5996],
    [-133.6498, 57.6080],
    [-133.6664, 57.6181],
    [-133.6745, 57.6281],
    [-133.6750, 57.6430],
    [-133.6650, 57.6615],
    [-133.6578, 57.6738],
    [-133.6559, 57.6810],
    [-133.6550, 57.6902],
    [-133.6505, 57.6953],
    [-133.6550, 57.7085],
    [-133.6457, 57.7164],
    [-133.6291, 57.7083],
    [-133.6210, 57.7152],
    [-133.6041, 57.7136],
    [-133.5908, 57.7120],
    [-133.5796, 57.7167],
    [-133.5839, 57.7251],
    [-133.5811, 57.7364],
    [-133.5763, 57.7320],
    [-133.5777, 57.7233],
    [-133.5542, 57.7071],
    [-133.5342, 57.6934],
    [-133.5119, 57.6809],
    [-133.4993, 57.6798],
    [-133.4867, 57.6757],
    [-133.4729, 57.6756],
    [-133.4694, 57.6776],
    [-133.4342, 57.6692],
    [-133.4099, 57.6624],
    [-133.3849, 57.6573],
    [-133.3510, 57.6442],
    [-133.3175, 57.6319],
    [-133.2854, 57.6213],
    [-133.2400, 57.6071],
    [-133.2058, 57.5938],
    [-133.1849, 57.5852],
    [-133.1502, 57.5597],
    [-133.1283, 57.5400],
    [-133.0917, 57.5203],
    [-133.0617, 57.5088],
    [-133.0594, 57.5252],
    [-133.0781, 57.5329],
    [-133.1266, 57.5641],
    [-133.1597, 57.5943],
    [-133.1789, 57.6078],
    [-133.2324, 57.6318],
    [-133.2566, 57.6505],
    [-133.2814, 57.6615],
    [-133.3222, 57.6620],
    [-133.3769, 57.6866],
    [-133.4069, 57.7094],
    [-133.4213, 57.7194],
    [-133.4351, 57.7240],
    [-133.4695, 57.7316],
    [-133.5005, 57.7435],
    [-133.5224, 57.7595],
    [-133.5333, 57.7628],
    [-133.5599, 57.7581],
    [-133.5749, 57.7614],
    [-133.5962, 57.7723],
    [-133.5851, 57.7725],
    [-133.5668, 57.7776],
    [-133.5573, 57.7809],
    [-133.5547, 57.7993],
    [-133.5656, 57.8084],
    [-133.5792, 57.8309],
    [-133.5723, 57.8424],
    [-133.5716, 57.8675],
    [-133.5704, 57.8843],
    [-133.5804, 57.9074],
    [-133.5832, 57.9270],
    [-133.5970, 57.9193],
    [-133.6020, 57.9008],
    [-133.6056, 57.8796],
    [-133.6004, 57.8667],
    [-133.6079, 57.8591],
    [-133.6277, 57.8684],
    [-133.6479, 57.8850],
    [-133.6526, 57.8733],
    [-133.6460, 57.8601],
    [-133.6281, 57.8455],
    [-133.6272, 57.8329],
    [-133.6348, 57.8227],
    [-133.6253, 57.8081],
    [-133.6329, 57.8128],
    [-133.6403, 57.8086],
    [-133.6305, 57.8000],
    [-133.6374, 57.7881],
    [-133.6752, 57.7866],
    [-133.6935, 57.7922],
    [-133.7035, 57.7929],
    [-133.7251, 57.8048],
    [-133.7406, 57.8250],
    [-133.7441, 57.8357],
    [-133.7572, 57.8493],
    [-133.7608, 57.8565],
    [-133.7767, 57.8677],
    [-133.7912, 57.8823],
    [-133.7964, 57.8914],
    [-133.8069, 57.9011],
    [-133.8261, 57.9126],
    [-133.8425, 57.9305],
    [-133.8504, 57.9420],
    [-133.8530, 57.9472],
    [-133.8385, 57.9585],
    [-133.8329, 57.9675],
    [-133.8088, 57.9789],
    [-133.7731, 57.9919],
    [-133.7586, 57.9920],
    [-133.7541, 57.9841],
    [-133.7479, 57.9702],
    [-133.7379, 57.9639],
    [-133.7258, 57.9490],
    [-133.7118, 57.9455],
    [-133.6916, 57.9468],
    [-133.6911, 57.9581],
    [-133.6999, 57.9691],
    [-133.7066, 57.9777],
    [-133.7127, 57.9956],
    [-133.7239, 58.0041],
    [-133.7346, 58.0167],
    [-133.7496, 58.0223],
    [-133.7601, 58.0288],
    [-133.7603, 58.0469],
    [-133.7693, 58.0569],
    [-133.8026, 58.0460],
    [-133.8081, 58.0429],
    [-133.8066, 58.0283],
    [-133.8021, 58.0195],
    [-133.7855, 58.0099],
    [-133.8283, 57.9957],
    [-133.8458, 57.9876],
    [-133.8558, 57.9891],
    [-133.8815, 57.9764],
    [-133.9093, 57.9769],
    [-133.9478, 57.9987],
    [-133.9683, 58.0163],
    [-133.9899, 58.0272],
    [-134.0027, 58.0343],
    [-134.0160, 58.0448],
    [-134.0248, 58.0528],
    [-134.0355, 58.0609],
    [-134.0526, 58.0618],
    [-134.0564, 58.0785],
    [-134.0647, 58.0913],
    [-134.0697, 58.1080],
    [-134.0707, 58.1168],
    [-134.0826, 58.1254],
    [-134.0714, 58.1298],
    [-134.0643, 58.1350],
    [-134.0783, 58.1508],
    [-134.0797, 58.1676],
    [-134.0885, 58.1869],
    [-134.0831, 58.1945],
    [-134.0816, 58.2088],
    [-134.0747, 58.2161],
    [-134.0598, 58.2237],
    [-134.0574, 58.2342],
    [-134.0574, 58.2492],
    [-134.0588, 58.2626],
    [-134.0731, 58.2741],
    [-134.0785, 58.2815],
    [-134.0607, 58.2825],
    [-134.0274, 58.2904],
    [-134.0075, 58.2922],
    [-133.9953, 58.2985],
    [-133.9889, 58.3078],
    [-133.9766, 58.3128],
    [-133.9723, 58.3217],
    [-133.9808, 58.3292],
    [-134.0008, 58.3397],
    [-133.9982, 58.3503],
    [-133.9970, 58.3550],
    [-133.9949, 58.3632],
    [-134.0044, 58.3695],
    [-134.0174, 58.3940],
    [-134.0246, 58.4066],
    [-134.0419, 58.3955],
    [-134.0460, 58.3783],
    [-134.0514, 58.3646],
    [-134.0550, 58.3518],
    [-134.0579, 58.3332],
    [-134.0757, 58.3282],
    [-134.0991, 58.3167],
    [-134.1342, 58.3050],
    [-134.1434, 58.3016],
    [-134.1394, 58.2947],
    [-134.1448, 58.2851],
    [-134.1477, 58.2806],
    [-134.1456, 58.2711],
    [-134.1322, 58.2670],
    [-134.1028, 58.2487],
    [-134.1016, 58.2366],
    [-134.1258, 58.2326],
    [-134.1377, 58.2268],
    [-134.1434, 58.2111],
    [-134.1510, 58.2010],
    [-134.1674, 58.2044],
    [-134.1993, 58.2056],
    [-134.2401, 58.2003],
    [-134.2646, 58.1917],
    [-134.2943, 58.1934],
    [-134.3017, 58.1941],
    [-134.3224, 58.1945],
    [-134.3383, 58.1970],
    [-134.3736, 58.2080],
    [-134.4049, 58.2191],
    [-134.4243, 58.2195],
    [-134.4373, 58.2245],
    [-134.4457, 58.2267],
    [-134.4574, 58.2271],
    [-134.4824, 58.2298],
    [-134.4957, 58.2218],
    [-134.5061, 58.2197],
    [-134.5151, 58.2179],
    [-134.5319, 58.2218],
    [-134.5511, 58.2238],
    [-134.5958, 58.2350],
    [-134.6103, 58.2421],
    [-134.6248, 58.2464],
    [-134.6323, 58.2529],
    [-134.6421, 58.2603],
    [-134.6558, 58.2731],
    [-134.6608, 58.2740],
    [-134.6750, 58.2856],
    [-134.6830, 58.2965],
    [-134.6898, 58.3011],
    [-134.6715, 58.3125],
    [-134.6580, 58.3158],
    [-134.6283, 58.3226],
    [-134.6036, 58.3257],
    [-134.6065, 58.3343],
    [-134.6085, 58.3411],
    [-134.6283, 58.3410],
    [-134.6395, 58.3418],
    [-134.6542, 58.3378],
    [-134.6625, 58.3321],
    [-134.6677, 58.3361],
    [-134.6637, 58.3379],
    [-134.6658, 58.3419],
    [-134.6611, 58.3526],
    [-134.6479, 58.3607],
    [-134.6430, 58.3650],
    [-134.6447, 58.3737],
    [-134.6449, 58.3811],
    [-134.6585, 58.3827],
    [-134.6792, 58.3818],
    [-134.6925, 58.3730],
    [-134.7017, 58.3777],
    [-134.7120, 58.3776],
    [-134.7260, 58.3762],
    [-134.7445, 58.3819],
    [-134.7593, 58.3839],
    [-134.7767, 58.3960],
    [-134.7714, 58.3956],
    [-134.7641, 58.3960],
    [-134.7543, 58.3925],
    [-134.7495, 58.3943],
    [-134.7590, 58.4021],
    [-134.7698, 58.4116],
    [-134.7634, 58.4190],
    [-134.7576, 58.4121],
    [-134.7590, 58.4240],
    [-134.7680, 58.4278],
    [-134.7745, 58.4441],
    [-134.7883, 58.4737],
    [-134.7842, 58.4787],
    [-134.7963, 58.4914],
    [-134.7954, 58.4976],
    [-134.8058, 58.5010],
    [-134.8232, 58.5123],
    [-134.8384, 58.5122],
    [-134.8319, 58.5253],
    [-134.8333, 58.5346],
    [-134.8554, 58.5421],
    [-134.8637, 58.5522],
    [-134.8842, 58.5719],
    [-134.9053, 58.5889],
    [-134.9139, 58.5969],
    [-134.9231, 58.6038],
    [-134.9326, 58.6085],
    [-134.9453, 58.6169],
    [-134.9543, 58.6287],
    [-134.9685, 58.6474],
    [-134.9806, 58.6811],
    [-134.9683, 58.6773],
    [-134.9569, 58.6800],
    [-134.9474, 58.6786],
    [-134.9205, 58.6805],
    [-134.9407, 58.6979],
    [-134.9421, 58.7210],
    [-134.9310, 58.7313],
    [-134.9355, 58.7385],
    [-134.9338, 58.7474],
    [-134.9317, 58.7567],
    [-134.9356, 58.7780],
    [-134.9547, 58.7838],
    [-134.9635, 58.7949],
    [-134.9811, 58.8041],
    [-134.9849, 58.8153],
    [-134.9659, 58.8245],
    [-134.9638, 58.8327],
    [-134.9921, 58.8280],
    [-135.0001, 58.8147],
    [-135.0009, 58.8056],
    [-134.9992, 58.7971],
    [-135.0009, 58.7913],
    [-135.0056, 58.7838],
    [-135.0175, 58.7833],
    [-135.0291, 58.7870],
    [-135.0246, 58.7752],
    [-135.0156, 58.7600],
    [-135.0253, 58.7526],
    [-135.0322, 58.7496],
    [-135.0258, 58.7314],
    [-135.0405, 58.7439],
    [-135.0515, 58.7524],
    [-135.0605, 58.7602],
    [-135.0674, 58.7700],
    [-135.0797, 58.7828],
    [-135.0809, 58.7897],
    [-135.0922, 58.7959],
    [-135.1080, 58.8103],
    [-135.1204, 58.8208],
    [-135.1374, 58.8298],
    [-135.1496, 58.8510],
    [-135.1473, 58.8595],
    [-135.1430, 58.8694],
    [-135.1430, 58.8829],
    [-135.1489, 58.8977],
    [-135.1558, 58.9063],
    [-135.1672, 58.9255],
    [-135.1767, 58.9470],
    [-135.1749, 58.9643],
    [-135.1751, 58.9787],
    [-135.1770, 58.9988],
    [-135.1866, 59.0054],
    [-135.1976, 59.0173],
    [-135.2024, 59.0459],
    [-135.2048, 59.0625],
    [-135.2062, 59.0768],
    [-135.2225, 59.1018],
    [-135.2383, 59.1301],
    [-135.2518, 59.1508],
    [-135.2775, 59.1745],
    [-135.2832, 59.1893],
    [-135.2920, 59.2018],
    [-135.3182, 59.1966],
    [-135.3334, 59.2048],
    [-135.3288, 59.2234],
    [-135.3372, 59.2340],
    [-135.3488, 59.2445],
    [-135.3571, 59.2552],
    [-135.3731, 59.2682],
    [-135.3669, 59.2895],
    [-135.3690, 59.3133],
    [-135.3597, 59.3372],
    [-135.3622, 59.3502],
    [-135.3594, 59.3624],
    [-135.3543, 59.3761],
    [-135.3483, 59.3857],
    [-135.3424, 59.4012],
    [-135.3407, 59.4242],
    [-135.3303, 59.4413],
    [-135.3215, 59.4475],
    [-135.3287, 59.4499],
    [-135.3352, 59.4524],
    [-135.3372, 59.4546],
    [-135.3361, 59.4581],
    [-135.3500, 59.4642],
    [-135.3476, 59.4786],
    [-135.3624, 59.4816],
    [-135.3676, 59.4673],
    [-135.3627, 59.4517],
    [-135.3662, 59.4366],
    [-135.3709, 59.4268],
    [-135.3741, 59.3967],
    [-135.3775, 59.3816],
    [-135.3851, 59.3618],
    [-135.3899, 59.3554],
    [-135.3904, 59.3492],
    [-135.3937, 59.3416],
    [-135.3937, 59.3318],
    [-135.3961, 59.3199],
    [-135.3992, 59.3093],
    [-135.3931, 59.2999],
    [-135.4002, 59.2908],
    [-135.4106, 59.2934],
    [-135.4275, 59.2950],
    [-135.4372, 59.2973],
    [-135.4738, 59.3006],
    [-135.4905, 59.3064],
    [-135.5156, 59.3166],
    [-135.5325, 59.3246],
    [-135.5428, 59.3183],
    [-135.5444, 59.3100],
    [-135.5268, 59.3024],
    [-135.5121, 59.2989],
    [-135.4895, 59.2903],
    [-135.4696, 59.2833],
    [-135.4384, 59.2722],
    [-135.4429, 59.2632],
    [-135.4334, 59.2552],
    [-135.4263, 59.2425],
    [-135.4394, 59.2354],
    [-135.4377, 59.2282],
    [-135.4264, 59.2266],
    [-135.4085, 59.2245],
    [-135.3974, 59.2217],
    [-135.3916, 59.2200],
    [-135.3811, 59.2143],
    [-135.3731, 59.2138],
    [-135.3631, 59.2079],
    [-135.3662, 59.2077],
    [-135.3671, 59.2040],
    [-135.3600, 59.2000],
    [-135.3524, 59.1881],
    [-135.3483, 59.1818],
    [-135.3439, 59.1770],
    [-135.3436, 59.1707],
    [-135.3398, 59.1651],
    [-135.3305, 59.1544],
    [-135.3335, 59.1504],
    [-135.3407, 59.1467],
    [-135.3410, 59.1411],
    [-135.3284, 59.1335],
    [-135.3236, 59.1295],
    [-135.3243, 59.1213],
    [-135.3178, 59.1169],
    [-135.3120, 59.1066],
    [-135.3048, 59.0993],
    [-135.2956, 59.0937],
    [-135.2972, 59.0878],
    [-135.3009, 59.0851],
    [-135.3072, 59.0821],
    [-135.3129, 59.0854],
    [-135.3201, 59.0937],
    [-135.3261, 59.0983],
    [-135.3279, 59.1008],
    [-135.3313, 59.1048],
    [-135.3394, 59.1033],
    [-135.3538, 59.1081],
    [-135.3689, 59.1122],
    [-135.3754, 59.1209],
    [-135.3785, 59.1290],
    [-135.3719, 59.1352],
    [-135.3750, 59.1403],
    [-135.3790, 59.1428],
    [-135.3792, 59.1514],
    [-135.3813, 59.1546],
    [-135.3785, 59.1582],
    [-135.3933, 59.1645],
    [-135.3988, 59.1704],
    [-135.3935, 59.1738],
    [-135.3849, 59.1735],
    [-135.4026, 59.1822],
    [-135.4094, 59.1891],
    [-135.4263, 59.1965],
    [-135.4363, 59.2035],
    [-135.4503, 59.2113],
    [-135.4558, 59.2194],
    [-135.4734, 59.2260],
    [-135.4843, 59.2301],
    [-135.4921, 59.2357],
    [-135.5169, 59.2424],
    [-135.5321, 59.2455],
    [-135.5413, 59.2485],
    [-135.5530, 59.2569],
    [-135.5896, 59.2648],
    [-135.6324, 59.2660],
    [-135.6153, 59.2583],
    [-135.6014, 59.2551],
    [-135.5722, 59.2447],
    [-135.5470, 59.2317],
    [-135.5459, 59.2223],
    [-135.5278, 59.2120],
    [-135.5097, 59.2015],
    [-135.4871, 59.1841],
    [-135.4793, 59.1774],
    [-135.4690, 59.1725],
    [-135.4729, 59.1640],
    [-135.4724, 59.1540],
    [-135.4610, 59.1385],
    [-135.4479, 59.1283],
    [-135.4465, 59.1219],
    [-135.4296, 59.1115],
    [-135.3880, 59.1050],
    [-135.3800, 59.0944],
    [-135.3773, 59.0855],
    [-135.3816, 59.0777],
    [-135.3868, 59.0664],
    [-135.3920, 59.0541],
    [-135.3966, 59.0421],
    [-135.3868, 59.0345],
    [-135.3757, 59.0262],
    [-135.3842, 59.0172],
    [-135.3994, 59.0139],
    [-135.3997, 59.0003],
    [-135.3893, 58.9883],
    [-135.4011, 58.9733],
    [-135.3935, 58.9613],
    [-135.3790, 58.9505],
    [-135.3700, 58.9348],
    [-135.3757, 58.9258],
    [-135.3559, 58.9211],
    [-135.3341, 58.9177],
    [-135.3236, 58.9096],
    [-135.3255, 58.8967],
    [-135.3391, 58.8897],
    [-135.3239, 58.8710],
    [-135.3167, 58.8585],
    [-135.3189, 58.8518],
    [-135.3020, 58.8461],
    [-135.2937, 58.8325],
    [-135.2842, 58.8190],
    [-135.2718, 58.8132],
    [-135.2585, 58.7975],
    [-135.2414, 58.7822],
    [-135.2471, 58.7749],
    [-135.2400, 58.7622],
    [-135.2371, 58.7473],
    [-135.2339, 58.7355],
    [-135.2392, 58.7267],
    [-135.2440, 58.7146],
    [-135.2388, 58.7076],
    [-135.2343, 58.7160],
    [-135.2238, 58.7161],
    [-135.2000, 58.6977],
    [-135.1874, 58.6790],
    [-135.1843, 58.6698],
    [-135.1668, 58.6587],
    [-135.1608, 58.6491],
    [-135.1599, 58.6418],
    [-135.1472, 58.6265],
    [-135.1404, 58.6165],
    [-135.1468, 58.6109],
    [-135.1408, 58.6031],
    [-135.1351, 58.5813],
    [-135.1446, 58.5772],
    [-135.1589, 58.5969],
    [-135.1582, 58.6033],
    [-135.1634, 58.6146],
    [-135.1860, 58.6171],
    [-135.1986, 58.6222],
    [-135.2133, 58.6218],
    [-135.2022, 58.6100],
    [-135.1862, 58.6012],
    [-135.1927, 58.5953],
    [-135.1860, 58.5823],
    [-135.1839, 58.5721],
    [-135.1646, 58.5631],
    [-135.1651, 58.5509],
    [-135.1591, 58.5390],
    [-135.1401, 58.5214],
    [-135.1351, 58.5123],
    [-135.1313, 58.5071],
    [-135.1299, 58.5001],
    [-135.1202, 58.4915],
    [-135.1335, 58.4906],
    [-135.1266, 58.4763],
    [-135.1202, 58.4605],
    [-135.1126, 58.4554],
    [-135.1038, 58.4491],
    [-135.0928, 58.4354],
    [-135.0886, 58.4220],
    [-135.0845, 58.4083],
    [-135.0790, 58.3973],
    [-135.0774, 58.3803],
    [-135.0729, 58.3709],
    [-135.0624, 58.3598],
    [-135.0521, 58.3425],
    [-135.0512, 58.3300],
    [-135.0515, 58.3175],
    [-135.0477, 58.3033],
    [-135.0543, 58.2972],
    [-135.0567, 58.2898],
    [-135.0691, 58.3032],
    [-135.0926, 58.2972],
    [-135.0985, 58.2894],
    [-135.0946, 58.2819],
    [-135.0924, 58.2734],
    [-135.1050, 58.2742],
    [-135.1077, 58.2650],
    [-135.0952, 58.2442],
    [-135.0890, 58.2324],
    [-135.0767, 58.2143],
    [-135.0693, 58.2054],
    [-135.0669, 58.1987],
    [-135.0643, 58.1923],
    [-135.0560, 58.1893],
    [-135.0733, 58.1906],
    [-135.0916, 58.2017],
    [-135.1009, 58.1962],
    [-135.1159, 58.2039],
    [-135.1330, 58.2124],
    [-135.1439, 58.2108],
    [-135.1556, 58.2096],
    [-135.1703, 58.2121],
    [-135.1815, 58.2165],
    [-135.1965, 58.2234],
    [-135.2167, 58.2294],
    [-135.2362, 58.2350],
    [-135.2630, 58.2334],
    [-135.2770, 58.2330],
    [-135.2996, 58.2390],
    [-135.3186, 58.2527],
    [-135.3307, 58.2607],
    [-135.3392, 58.2661],
    [-135.3457, 58.2764],
    [-135.3538, 58.2890],
    [-135.3643, 58.3012],
    [-135.3804, 58.3114],
    [-135.3983, 58.3277],
    [-135.3992, 58.3346],
    [-135.4185, 58.3697],
    [-135.4215, 58.3790],
    [-135.4251, 58.3823],
    [-135.4286, 58.3867],
    [-135.4316, 58.3987],
    [-135.4341, 58.4089],
    [-135.4417, 58.4135],
    [-135.4482, 58.4240],
    [-135.4553, 58.4440],
    [-135.4572, 58.4507],
    [-135.4516, 58.4531],
    [-135.4593, 58.4602],
    [-135.4681, 58.4768],
    [-135.4769, 58.4825],
    [-135.4895, 58.4896],
    [-135.4871, 58.4945],
    [-135.4947, 58.5018],
    [-135.5119, 58.4986],
    [-135.5081, 58.4911],
    [-135.4950, 58.4829],
    [-135.4836, 58.4715],
    [-135.4800, 58.4670],
    [-135.4819, 58.4597],
    [-135.4871, 58.4536],
    [-135.4990, 58.4671],
    [-135.4955, 58.4721],
    [-135.5059, 58.4771],
    [-135.5152, 58.4752],
    [-135.5088, 58.4654],
    [-135.4974, 58.4464],
    [-135.4900, 58.4395],
    [-135.4805, 58.4284],
    [-135.4643, 58.4130],
    [-135.4591, 58.3993],
    [-135.4684, 58.3823],
    [-135.4841, 58.3750],
    [-135.5040, 58.3784],
    [-135.5266, 58.3943],
    [-135.5380, 58.3993],
    [-135.5547, 58.4071],
    [-135.5651, 58.4068],
    [-135.5826, 58.4103],
    [-135.6112, 58.4234],
    [-135.6321, 58.4231],
    [-135.6628, 58.4054],
    [-135.6889, 58.3976],
    [-135.7343, 58.3928],
    [-135.7659, 58.3958],
    [-135.8156, 58.3890],
    [-135.8567, 58.3844],
    [-135.8746, 58.3840],
    [-135.9162, 58.3789],
    [-135.9203, 58.3891],
    [-135.9024, 58.4116],
    [-135.9055, 58.4266],
    [-135.8974, 58.4332],
    [-135.8972, 58.4435],
    [-135.8826, 58.4557],
    [-135.8727, 58.4630],
    [-135.8910, 58.4645],
    [-135.9062, 58.4653],
    [-135.9202, 58.4614],
    [-135.9397, 58.4498],
    [-135.9466, 58.4542],
    [-135.9723, 58.4604],
    [-135.9965, 58.4692],
    [-135.9985, 58.4740],
    [-135.9999, 58.4818],
    [-135.9867, 58.4876],
    [-135.9708, 58.4878],
    [-135.9675, 58.4968],
    [-135.9473, 58.5017],
    [-135.9311, 58.5094],
    [-135.9573, 58.5261],
    [-135.9722, 58.5497],
    [-135.9713, 58.5573],
    [-135.9837, 58.5778],
    [-135.9958, 58.5923],
    [-135.9863, 58.5911],
    [-135.9775, 58.5830],
    [-135.9639, 58.5813],
    [-135.9375, 58.5951],
    [-135.9204, 58.5840],
    [-135.9088, 58.5760],
    [-135.8988, 58.5791],
    [-135.8824, 58.5858],
    [-135.8664, 58.5871],
    [-135.8544, 58.5937],
    [-135.8460, 58.6022],
    [-135.8572, 58.6025],
    [-135.8769, 58.6011],
    [-135.9024, 58.6104],
    [-135.9097, 58.6213],
    [-135.9211, 58.6271],
    [-135.9230, 58.6350],
    [-135.9197, 58.6418],
    [-135.9283, 58.6464],
    [-135.9478, 58.6627],
    [-135.9577, 58.6858],
    [-135.9554, 58.6988],
    [-135.9711, 58.6986],
    [-135.9853, 58.6924],
    [-135.9903, 58.6947],
    [-136.0015, 58.7092],
    [-136.0155, 58.7192],
    [-136.0141, 58.7307],
    [-135.9953, 58.7289],
    [-136.0012, 58.7418],
    [-136.0169, 58.7448],
    [-136.0364, 58.7642],
    [-136.0433, 58.7798],
    [-136.0550, 58.7865],
    [-136.0685, 58.8002],
    [-136.0863, 58.8106],
    [-136.0868, 58.8245],
    [-136.0818, 58.8275],
    [-136.0595, 58.8336],
    [-136.0485, 58.8406],
    [-136.0155, 58.8437],
    [-136.0312, 58.8541],
    [-136.0463, 58.8514],
    [-136.0569, 58.8526],
    [-136.0519, 58.8622],
    [-136.0657, 58.8754],
    [-136.0683, 58.8869],
    [-136.0592, 58.8945],
    [-136.0638, 58.9048],
    [-136.0528, 58.9117],
    [-136.0559, 58.9201],
    [-136.0600, 58.9282],
    [-136.0818, 58.9352],
    [-136.0875, 58.9469],
    [-136.1049, 58.9569],
    [-136.1233, 58.9583],
    [-136.1177, 58.9612],
    [-136.1203, 58.9684],
    [-136.1106, 58.9743],
    [-136.1410, 58.9787],
    [-136.1619, 58.9739],
    [-136.1603, 58.9620],
    [-136.1477, 58.9493],
    [-136.1256, 58.9355],
    [-136.1187, 58.9210],
    [-136.1184, 58.9131],
    [-136.1310, 58.9126],
    [-136.1324, 58.9071],
    [-136.1303, 58.9004],
    [-136.1165, 58.8878],
    [-136.1187, 58.8816],
    [-136.1080, 58.8668],
    [-136.1077, 58.8569],
    [-136.1149, 58.8429],
    [-136.1189, 58.8362],
    [-136.1220, 58.8237],
    [-136.1284, 58.8150],
    [-136.1389, 58.8075],
    [-136.1468, 58.8012],
    [-136.1522, 58.7968],
    [-136.1448, 58.7840],
    [-136.1460, 58.7787],
    [-136.1576, 58.7768],
    [-136.1522, 58.7659],
    [-136.1508, 58.7573],
    [-136.1569, 58.7493],
    [-136.1907, 58.7554],
    [-136.2140, 58.7501],
    [-136.2496, 58.7528],
    [-136.2596, 58.7587],
    [-136.2850, 58.7730],
    [-136.3221, 58.7795],
    [-136.3482, 58.7934],
    [-136.3657, 58.8004],
    [-136.3907, 58.8104],
    [-136.3982, 58.8189],
    [-136.4136, 58.8256],
    [-136.4203, 58.8183],
    [-136.4319, 58.8243],
    [-136.4493, 58.8263],
    [-136.4673, 58.8275],
    [-136.4821, 58.8347],
    [-136.5058, 58.8571],
    [-136.5094, 58.8660],
    [-136.5107, 58.8862],
    [-136.5196, 58.8972],
    [-136.5243, 58.9077],
    [-136.5315, 58.9226],
    [-136.5289, 58.9334],
    [-136.5346, 58.9491],
    [-136.5586, 58.9599],
    [-136.5705, 58.9560],
    [-136.5755, 58.9414],
    [-136.5717, 58.9261],
    [-136.5845, 58.9080],
    [-136.6004, 58.9153],
    [-136.6052, 58.9290],
    [-136.6323, 58.9445],
    [-136.6454, 58.9635],
    [-136.6587, 58.9765],
    [-136.6805, 58.9908],
    [-136.6986, 59.0030],
    [-136.7112, 59.0019],
    [-136.7017, 58.9903],
    [-136.6953, 58.9801],
    [-136.6840, 58.9731],
    [-136.6563, 58.9419],
    [-136.6299, 58.9197],
    [-136.6223, 58.8999],
    [-136.6366, 58.8911],
    [-136.6580, 58.8963],
    [-136.6647, 58.8928],
    [-136.6794, 58.8962],
    [-136.6898, 58.9063],
    [-136.7131, 58.9193],
    [-136.7411, 58.9279],
    [-136.7641, 58.9326],
    [-136.7908, 58.9370],
    [-136.8103, 58.9459],
    [-136.8315, 58.9549],
    [-136.8545, 58.9560],
    [-136.8678, 58.9616],
    [-136.9025, 58.9866],
    [-136.9318, 58.9991],
    [-136.9539, 59.0054],
    [-136.9617, 59.0134],
    [-136.9741, 59.0219],
    [-136.9767, 59.0301],
    [-136.9945, 59.0374],
    [-137.0138, 59.0465],
    [-137.0280, 59.0593],
    [-137.0587, 59.0592],
    [-137.0675, 59.0455],
    [-137.0516, 59.0310],
    [-137.0397, 59.0196],
    [-137.0245, 59.0153],
    [-137.0069, 59.0171],
    [-137.0040, 59.0077],
    [-136.9993, 58.9992],
    [-136.9826, 58.9837],
    [-136.9591, 58.9740],
    [-136.9436, 58.9701],
    [-136.9175, 58.9486],
    [-136.9165, 58.9344],
    [-136.9308, 58.9260],
    [-136.9311, 58.9180],
    [-136.9465, 58.9194],
    [-136.9710, 58.9246],
    [-136.9914, 58.9244],
    [-137.0045, 58.9225],
    [-137.0185, 58.9235],
    [-137.0347, 58.9192],
    [-137.0499, 58.9089],
    [-137.0575, 58.8998],
    [-137.0606, 58.8890],
    [-137.0725, 58.8834],
    [-137.0936, 58.8655],
    [-137.1079, 58.8576],
    [-137.1186, 58.8561],
    [-137.1202, 58.8481],
    [-137.1191, 58.8400],
    [-137.1065, 58.8325],
    [-137.0941, 58.8395],
    [-137.0879, 58.8454],
    [-137.0729, 58.8563],
    [-137.0507, 58.8735],
    [-137.0349, 58.8788],
    [-137.0221, 58.8905],
    [-137.0078, 58.9026],
    [-136.9898, 58.9031],
    [-136.9779, 58.9007],
    [-136.9562, 58.8967],
    [-136.9415, 58.8939],
    [-136.9282, 58.8958],
    [-136.9144, 58.8971],
    [-136.8961, 58.8894],
    [-136.8838, 58.8878],
    [-136.8621, 58.8865],
    [-136.8450, 58.8826],
    [-136.8258, 58.8739],
    [-136.8101, 58.8712],
    [-136.7918, 58.8778],
    [-136.7742, 58.8765],
    [-136.7556, 58.8757],
    [-136.7383, 58.8750],
    [-136.7219, 58.8685],
    [-136.7069, 58.8614],
    [-136.6938, 58.8589],
    [-136.6777, 58.8583],
    [-136.6651, 58.8471],
    [-136.6515, 58.8437],
    [-136.6180, 58.8456],
    [-136.6038, 58.8417],
    [-136.5850, 58.8403],
    [-136.5693, 58.8345],
    [-136.5503, 58.8263],
    [-136.5382, 58.8182],
    [-136.5172, 58.8075],
    [-136.5020, 58.7999],
    [-136.4880, 58.7939],
    [-136.5004, 58.7875],
    [-136.5061, 58.7808],
    [-136.4854, 58.7749],
    [-136.4780, 58.7777],
    [-136.4730, 58.7836],
    [-136.4519, 58.7777],
    [-136.4433, 58.7651],
    [-136.4381, 58.7598],
    [-136.4528, 58.7631],
    [-136.4716, 58.7678],
    [-136.4711, 58.7582],
    [-136.4859, 58.7613],
    [-136.5151, 58.7716],
    [-136.5344, 58.7680],
    [-136.5087, 58.7585],
    [-136.4897, 58.7503],
    [-136.4669, 58.7407],
    [-136.4215, 58.7268],
    [-136.3894, 58.7128],
    [-136.3750, 58.7058],
    [-136.3602, 58.6954],
    [-136.3490, 58.6870],
    [-136.3604, 58.6798],
    [-136.3750, 58.6670],
    [-136.3828, 58.6640],
    [-136.3937, 58.6565],
    [-136.4008, 58.6524],
    [-136.4234, 58.6455],
    [-136.4352, 58.6428],
    [-136.4416, 58.6407],
    [-136.4484, 58.6356],
    [-136.4560, 58.6342],
    [-136.4761, 58.6229],
    [-136.4820, 58.6189],
    [-136.4905, 58.6083],
    [-136.5008, 58.6047],
    [-136.5119, 58.6059],
    [-136.5207, 58.6077],
    [-136.5292, 58.6059],
    [-136.5319, 58.6000],
    [-136.5235, 58.5974],
    [-136.5132, 58.5928],
    [-136.4892, 58.5909],
    [-136.4791, 58.5899],
    [-136.4713, 58.5870],
    [-136.4677, 58.5899],
    [-136.4644, 58.5980],
    [-136.4646, 58.6049],
    [-136.4591, 58.6092],
    [-136.4568, 58.6125],
    [-136.4475, 58.6159],
    [-136.4316, 58.6206],
    [-136.4136, 58.6227],
    [-136.3998, 58.6190],
    [-136.3855, 58.6226],
    [-136.3860, 58.6286],
    [-136.3739, 58.6370],
    [-136.3511, 58.6472],
    [-136.3403, 58.6526],
    [-136.3423, 58.6484],
    [-136.3420, 58.6438],
    [-136.3335, 58.6348],
    [-136.3258, 58.6307],
    [-136.3120, 58.6230],
    [-136.3108, 58.6269],
    [-136.3152, 58.6322],
    [-136.3252, 58.6387],
    [-136.3260, 58.6440],
    [-136.3300, 58.6643],
    [-136.3139, 58.6713],
    [-136.2982, 58.6640],
    [-136.2671, 58.6486],
    [-136.2428, 58.6318],
    [-136.2113, 58.6180],
    [-136.1936, 58.5977],
    [-136.1922, 58.5928],
    [-136.2062, 58.5986],
    [-136.2172, 58.6019],
    [-136.2257, 58.6006],
    [-136.2141, 58.5908],
    [-136.2096, 58.5825],
    [-136.1965, 58.5877],
    [-136.1903, 58.5774],
    [-136.2051, 58.5814],
    [-136.1955, 58.5723],
    [-136.1825, 58.5636],
    [-136.1763, 58.5623],
    [-136.1794, 58.5741],
    [-136.1721, 58.5683],
    [-136.1554, 58.5641],
    [-136.1432, 58.5530],
    [-136.1398, 58.5464],
    [-136.1379, 58.5387],
    [-136.1412, 58.5348],
    [-136.1379, 58.5307],
    [-136.1253, 58.5260],
    [-136.1168, 58.5155],
    [-136.1025, 58.5136],
    [-136.0957, 58.5081],
    [-136.0996, 58.4991],
    [-136.1021, 58.4884],
    [-136.0983, 58.4828],
    [-136.0892, 58.4785],
    [-136.0914, 58.4746],
    [-136.0842, 58.4704],
    [-136.0725, 58.4685],
    [-136.0722, 58.4622],
    [-136.0853, 58.4552],
    [-136.0859, 58.4466],
    [-136.0714, 58.4419],
    [-136.0633, 58.4345],
    [-136.0608, 58.4278],
    [-136.0567, 58.4201],
    [-136.0527, 58.4124],
    [-136.0540, 58.4074],
    [-136.0541, 58.4000],
    [-136.0542, 58.3926],
    [-136.0361, 58.3828],
    [-136.0373, 58.3716],
    [-136.0671, 58.3676],
    [-136.0794, 58.3597],
    [-136.0937, 58.3486],
    [-136.1233, 58.3411],
    [-136.1374, 58.3449],
    [-136.1461, 58.3433],
    [-136.1584, 58.3448],
    [-136.1713, 58.3405],
    [-136.1848, 58.3386],
    [-136.1957, 58.3403],
    [-136.2093, 58.3308],
    [-136.2268, 58.3253],
    [-136.2459, 58.3219],
    [-136.2600, 58.3177],
    [-136.2728, 58.3166],
    [-136.2856, 58.3167],
    [-136.2982, 58.3204],
    [-136.3051, 58.3287],
    [-136.3008, 58.3429],
    [-136.2937, 58.3510],
    [-136.2881, 58.3537],
    [-136.2798, 58.3599],
    [-136.2826, 58.3673],
    [-136.3095, 58.3774],
    [-136.3313, 58.3690],
    [-136.3571, 58.3695],
    [-136.3790, 58.3603],
    [-136.3679, 58.3514],
    [-136.3651, 58.3467],
    [-136.3597, 58.3407],
    [-136.3653, 58.3370],
    [-136.3583, 58.3304],
    [-136.3636, 58.3229],
    [-136.3679, 58.3155],
    [-136.3718, 58.3131],
    [-136.3689, 58.3070],
    [-136.3690, 58.3031],
    [-136.3754, 58.3013],
    [-136.4025, 58.3006],
    [-136.4117, 58.3109],
    [-136.4362, 58.3147],
    [-136.4495, 58.3116],
    [-136.4546, 58.3050],
    [-136.4657, 58.3065],
    [-136.4793, 58.3056],
    [-136.4854, 58.3000],
    [-136.4922, 58.3051],
    [-136.4986, 58.3057],
    [-136.5048, 58.3086],
    [-136.5041, 58.3028],
    [-136.4868, 58.2940],
    [-136.4801, 58.2843],
    [-136.4865, 58.2840],
    [-136.4986, 58.2937],
    [-136.5120, 58.3032],
    [-136.5254, 58.3138],
    [-136.5391, 58.3181],
    [-136.5689, 58.3253],
    [-136.5767, 58.3403],
    [-136.5864, 58.3495],
    [-136.6139, 58.3424],
    [-136.6363, 58.3295],
    [-136.6271, 58.3229],
    [-136.6050, 58.3144],
    [-136.5882, 58.3020],
    [-136.5888, 58.2885],
    [-136.5773, 58.2825],
    [-136.5714, 58.2755],
    [-136.5647, 58.2540],
    [-136.5704, 58.2440],
    [-136.5800, 58.2427],
    [-136.5827, 58.2373],
    [-136.5871, 58.2332],
    [-136.5818, 58.2262],
    [-136.6023, 58.2159],
    [-136.6230, 58.2105],
    [-136.6433, 58.2093],
    [-136.6660, 58.2081],
    [-136.6852, 58.2108],
    [-136.6893, 58.2189],
    [-136.7014, 58.2245],
    [-136.7107, 58.2326],
    [-136.7309, 58.2565],
    [-136.7316, 58.2704],
    [-136.7209, 58.2764],
    [-136.7039, 58.2818],
    [-136.6833, 58.2818],
    [-136.6855, 58.2892],
    [-136.6859, 58.2966],
    [-136.7061, 58.2956],
    [-136.7275, 58.2880],
    [-136.7350, 58.2898],
    [-136.7390, 58.2963],
    [-136.7359, 58.3014],
    [-136.7447, 58.3043],
    [-136.7510, 58.2968],
    [-136.7714, 58.2844],
    [-136.7801, 58.2916],
    [-136.7934, 58.2981],
    [-136.7886, 58.3176],
    [-136.7794, 58.3225],
    [-136.7722, 58.3250],
    [-136.7786, 58.3292],
    [-136.7940, 58.3294],
    [-136.8076, 58.3396],
    [-136.8052, 58.3446],
    [-136.8073, 58.3489],
    [-136.8154, 58.3448],
    [-136.8172, 58.3344],
    [-136.8071, 58.3262],
    [-136.8013, 58.3217],
    [-136.8091, 58.3166],
    [-136.8233, 58.3065],
    [-136.8423, 58.3122],
    [-136.8538, 58.3123],
    [-136.8678, 58.3086],
    [-136.8671, 58.3227],
    [-136.8518, 58.3197],
    [-136.8557, 58.3279],
    [-136.8507, 58.3319],
    [-136.8462, 58.3351],
    [-136.8447, 58.3441],
    [-136.8487, 58.3491],
    [-136.8426, 58.3595],
    [-136.8492, 58.3635],
    [-136.8716, 58.3645],
    [-136.8675, 58.3570],
    [-136.8710, 58.3473],
    [-136.8811, 58.3460],
    [-136.8922, 58.3414],
    [-136.9105, 58.3449],
    [-136.9062, 58.3548],
    [-136.9052, 58.3659],
    [-136.8910, 58.3844],
    [-136.9029, 58.3858],
    [-136.9111, 58.3792],
    [-136.9299, 58.3792],
    [-136.9165, 58.3856],
    [-136.9120, 58.3914],
    [-136.9215, 58.3970],
    [-136.9428, 58.3951],
    [-136.9599, 58.3998],
    [-136.9969, 58.4081],
    [-137.0183, 58.4083],
    [-137.0262, 58.4048],
    [-137.0416, 58.4048],
    [-137.0695, 58.4006],
    [-137.0746, 58.3918],
    [-137.0788, 58.3828],
    [-137.0933, 58.3814],
    [-137.1104, 58.3942],
    [-137.1185, 58.3992],
    [-137.1341, 58.4085],
    [-137.1535, 58.4196],
    [-137.1737, 58.4267],
    [-137.1828, 58.4311],
    [-137.2091, 58.4421],
    [-137.2530, 58.4557],
    [-137.2958, 58.4662],
    [-137.3113, 58.4781],
    [-137.3641, 58.4960],
    [-137.4003, 58.5075],
    [-137.4084, 58.5162],
    [-137.4267, 58.5257],
    [-137.4595, 58.5433],
    [-137.5344, 58.5712],
    [-137.5609, 58.5831],
    [-137.5932, 58.5961],
    [-137.6196, 58.5990],
    [-137.6558, 58.6092],
    [-137.6670, 58.6145],
    [-137.6783, 58.6242],
    [-137.6761, 58.6423],
    [-137.6831, 58.6563],
    [-137.6876, 58.6650],
    [-137.7223, 58.6835],
    [-137.7954, 58.7243],
    [-137.8535, 58.7490],
    [-137.8971, 58.7700],
    [-137.9300, 58.7843],
    [-137.9445, 58.7988],
    [-137.9450, 58.8085],
    [-137.9297, 58.8191],
    [-137.9282, 58.8294],
    [-137.9237, 58.8415],
    [-137.9293, 58.8508],
    [-137.9394, 58.8629],
    [-137.9337, 58.8652],
    [-137.9379, 58.8758],
    [-137.9817, 58.9071],
    [-138.0292, 58.9359],
    [-138.1004, 58.9723],
    [-138.1690, 59.0009],
    [-138.1853, 59.0163],
    [-138.2670, 59.0472],
    [-138.3867, 59.0776],
    [-138.5110, 59.1035],
    [-138.5567, 59.1128],
    [-138.6103, 59.1230],
    [-138.6518, 59.1386],
    [-138.7634, 59.1877],
    [-138.8866, 59.2369],
    [-139.0446, 59.2803],
    [-139.3140, 59.3450],
    [-139.3920, 59.3698],
    [-139.5295, 59.4166],
    [-139.6090, 59.4457],
    [-139.6475, 59.4616],
    [-139.6760, 59.4728],
    [-139.7502, 59.4990],
    [-139.8170, 59.5210],
    [-139.8570, 59.5347],
    [-139.8625, 59.5443],
    [-139.8414, 59.5588],
    [-139.8225, 59.5543],
    [-139.8048, 59.5503],
    [-139.7981, 59.5454],
    [-139.7920, 59.5438],
    [-139.7745, 59.5433],
    [-139.7642, 59.5446],
    [-139.7617, 59.5451],
    [-139.7433, 59.5447],
    [-139.7320, 59.5465],
    [-139.7333, 59.5489],
    [-139.7462, 59.5522],
    [-139.7534, 59.5569],
    [-139.7504, 59.5629],
    [-139.7467, 59.5683],
    [-139.7421, 59.5642],
    [-139.7384, 59.5678],
    [-139.7380, 59.5717],
    [-139.7244, 59.5719],
    [-139.7230, 59.5650],
    [-139.7152, 59.5636],
    [-139.7133, 59.5707],
    [-139.7112, 59.5741],
    [-139.7020, 59.5837],
    [-139.7037, 59.5887],
    [-139.7111, 59.5948],
    [-139.7216, 59.6038],
    [-139.7182, 59.6079],
    [-139.7176, 59.6096],
    [-139.7157, 59.6126],
    [-139.7129, 59.6182],
    [-139.7045, 59.6180],
    [-139.6918, 59.6186],
    [-139.6849, 59.6187],
    [-139.6767, 59.6143],
    [-139.6748, 59.6100],
    [-139.6776, 59.6044],
    [-139.6729, 59.5952],
    [-139.6741, 59.5895],
    [-139.6795, 59.5852],
    [-139.6766, 59.5822],
    [-139.6786, 59.5768],
    [-139.6765, 59.5717],
    [-139.6708, 59.5702],
    [-139.6660, 59.5663],
    [-139.6637, 59.5684],
    [-139.6538, 59.5681],
    [-139.6380, 59.5689],
    [-139.6407, 59.5704],
    [-139.6492, 59.5727],
    [-139.6513, 59.5776],
    [-139.6417, 59.5798],
    [-139.6317, 59.5842],
    [-139.6314, 59.5911],
    [-139.6232, 59.5967],
    [-139.6009, 59.6003],
    [-139.5872, 59.6047],
    [-139.5797, 59.6121],
    [-139.5948, 59.6136],
    [-139.6020, 59.6184],
    [-139.5928, 59.6289],
    [-139.5870, 59.6368],
    [-139.5868, 59.6465],
    [-139.5812, 59.6447],
    [-139.5754, 59.6468],
    [-139.5688, 59.6467],
    [-139.5601, 59.6508],
    [-139.5579, 59.6577],
    [-139.5555, 59.6634],
    [-139.5478, 59.6667],
    [-139.5407, 59.6697],
    [-139.5326, 59.6734],
    [-139.5275, 59.6770],
    [-139.5231, 59.6822],
    [-139.5210, 59.6860],
    [-139.5143, 59.6878],
    [-139.5112, 59.6903],
    [-139.5071, 59.6940],
    [-139.4926, 59.6951],
    [-139.4865, 59.6946],
    [-139.4829, 59.6962],
    [-139.4833, 59.6984],
    [-139.4861, 59.7005],
    [-139.4844, 59.7074],
    [-139.4982, 59.7139],
    [-139.5010, 59.7174],
    [-139.5049, 59.7207],
    [-139.5213, 59.7259],
    [-139.5409, 59.7366],
    [-139.5479, 59.7462],
    [-139.5637, 59.7620],
    [-139.5759, 59.7740],
    [-139.5957, 59.7962],
    [-139.5972, 59.8133],
    [-139.6063, 59.8295],
    [-139.6216, 59.8393],
    [-139.6286, 59.8548],
    [-139.6312, 59.8878],
    [-139.6224, 59.9036],
    [-139.5948, 59.9095],
    [-139.5828, 59.9152],
    [-139.5548, 59.9268],
    [-139.5359, 59.9352],
    [-139.5330, 59.9408],
    [-139.5229, 59.9497],
    [-139.5214, 59.9600],
    [-139.5140, 59.9656],
    [-139.5052, 59.9736],
    [-139.5044, 59.9803],
    [-139.5050, 59.9865],
    [-139.4894, 59.9921],
    [-139.4979, 60.0045],
    [-139.5226, 60.0203],
    [-139.5311, 60.0412],
    [-139.5547, 60.0464],
    [-139.5551, 60.0408],
    [-139.5547, 60.0326],
    [-139.5706, 60.0207],
    [-139.5853, 60.0046],
    [-139.6051, 59.9996],
    [-139.6092, 59.9878],
    [-139.6091, 59.9827],
    [-139.6079, 59.9744],
    [-139.6072, 59.9683],
    [-139.6104, 59.9618],
    [-139.6109, 59.9562],
    [-139.6293, 59.9447],
    [-139.6449, 59.9424],
    [-139.6552, 59.9361],
    [-139.6953, 59.9286],
    [-139.7235, 59.9126],
    [-139.7420, 59.8996],
    [-139.7553, 59.8879],
    [-139.7760, 59.8704],
    [-139.7779, 59.8612],
    [-139.7714, 59.8455],
    [-139.7802, 59.8265],
    [-139.8235, 59.8126],
    [-139.8741, 59.8028],
    [-139.9255, 59.7921],
    [-139.9604, 59.7851],
    [-140.0160, 59.7723],
    [-140.0602, 59.7611],
    [-140.1173, 59.7497],
    [-140.1627, 59.7406],
    [-140.1902, 59.7271],
    [-140.2240, 59.7089],
    [-140.2551, 59.7023],
    [-140.2955, 59.6943],
    [-140.3250, 59.6934],
    [-140.4158, 59.6994],
    [-140.5028, 59.7052],
    [-140.6000, 59.7113],
    [-140.6340, 59.7101],
    [-140.7220, 59.7186],
    [-140.8213, 59.7316],
    [-140.8750, 59.7388],
    [-140.9278, 59.7532],
    [-140.9819, 59.7696],
    [-141.0295, 59.7811],
    [-141.1524, 59.8115],
    [-141.2558, 59.8367],
    [-141.3387, 59.8571],
    [-141.4397, 59.8825],
    [-141.4681, 59.8984],
    [-141.4872, 59.9222],
    [-141.4716, 59.9283],
    [-141.4597, 59.9175],
    [-141.4487, 59.9111],
    [-141.4568, 59.9102],
    [-141.4544, 59.8985],
    [-141.4423, 59.8878],
    [-141.4314, 59.9001],
    [-141.4105, 59.9083],
    [-141.3888, 59.9248],
    [-141.3741, 59.9275],
    [-141.3551, 59.9329],
    [-141.3268, 59.9318],
    [-141.3114, 59.9328],
    [-141.3000, 59.9362],
    [-141.2883, 59.9328],
    [-141.2940, 59.9482],
    [-141.2840, 59.9578],
    [-141.2900, 59.9726],
    [-141.2664, 59.9811],
    [-141.2636, 59.9916],
    [-141.2593, 59.9984],
    [-141.2779, 60.0123],
    [-141.2895, 60.0260],
    [-141.3019, 60.0446],
    [-141.3253, 60.0545],
    [-141.3225, 60.0621],
    [-141.3078, 60.0580],
    [-141.2888, 60.0596],
    [-141.2817, 60.0707],
    [-141.2386, 60.0894],
    [-141.2332, 60.1007],
    [-141.2213, 60.1062],
    [-141.2001, 60.1087],
    [-141.1856, 60.1148],
    [-141.1635, 60.1164],
    [-141.1476, 60.1320],
    [-141.1424, 60.1492],
    [-141.1450, 60.1614],
    [-141.1540, 60.1724],
    [-141.1721, 60.1732],
    [-141.1628, 60.1623],
    [-141.1612, 60.1518],
    [-141.1721, 60.1364],
    [-141.1906, 60.1230],
    [-141.2106, 60.1188],
    [-141.2372, 60.1111],
    [-141.2555, 60.1046],
    [-141.2695, 60.0976],
    [-141.3032, 60.0907],
    [-141.3275, 60.0901],
    [-141.3408, 60.0896],
    [-141.3527, 60.0860],
    [-141.3708, 60.1061],
    [-141.3744, 60.1281],
    [-141.3667, 60.1472],
    [-141.3801, 60.1589],
    [-141.3966, 60.1573],
    [-141.4169, 60.1427],
    [-141.4312, 60.1328],
    [-141.4616, 60.1400],
    [-141.5006, 60.1551],
    [-141.5184, 60.1669],
    [-141.5343, 60.1701],
    [-141.5548, 60.1672],
    [-141.5526, 60.1536],
    [-141.5384, 60.1444],
    [-141.5286, 60.1332],
    [-141.5086, 60.1197],
    [-141.4901, 60.1191],
    [-141.4723, 60.1084],
    [-141.4542, 60.0900],
    [-141.4609, 60.0854],
    [-141.4540, 60.0697],
    [-141.4171, 60.0652],
    [-141.3908, 60.0456],
    [-141.3681, 60.0288],
    [-141.3858, 60.0217],
    [-141.3974, 60.0099],
    [-141.4259, 60.0038],
    [-141.4777, 59.9948],
    [-141.5079, 59.9877],
    [-141.5376, 59.9765],
    [-141.6829, 59.9601],
    [-141.7784, 59.9716],
    [-141.9177, 60.0065],
    [-142.0296, 60.0223],
    [-142.1268, 60.0310],
    [-142.2452, 60.0498],
    [-142.3843, 60.0632],
    [-142.4358, 60.0672],
    [-142.5375, 60.0840],
    [-142.8099, 60.0952],
    [-142.9167, 60.0876],
    [-143.0676, 60.0715],
    [-143.4134, 60.0519],
    [-143.5696, 60.0426],
    [-143.6568, 60.0340],
    [-143.8103, 60.0030],
    [-143.8812, 59.9866],
    [-143.9272, 59.9927],
    [-143.9660, 60.0011],
    [-143.9810, 60.0099],
    [-144.0368, 60.0190],
    [-144.0991, 60.0169],
    [-144.1695, 60.0198],
    [-144.2061, 60.0218],
    [-144.2553, 60.0238],
    [-144.2168, 60.0402],
    [-144.1479, 60.0427],
    [-144.1122, 60.0367],
    [-144.0917, 60.0448],
    [-144.0525, 60.0418],
    [-144.0500, 60.0535],
    [-144.0677, 60.0685],
    [-144.0884, 60.0817],
    [-144.1055, 60.0958],
    [-144.1515, 60.1066],
    [-144.2049, 60.1175],
    [-144.2310, 60.1285],
    [-144.2959, 60.1421],
    [-144.2935, 60.1504],
    [-144.2947, 60.1581],
    [-144.3040, 60.1664],
    [-144.2557, 60.1742],
    [-144.2251, 60.1764],
    [-144.2529, 60.1814],
    [-144.2729, 60.1808],
    [-144.3147, 60.1763],
    [-144.3520, 60.1724],
    [-144.3791, 60.1673],
    [-144.4259, 60.1687],
    [-144.4539, 60.1667],
    [-144.4891, 60.1684],
    [-144.5291, 60.1835],
    [-144.5524, 60.1799],
    [-144.5654, 60.1768],
    [-144.5837, 60.1782],
    [-144.5963, 60.1817],
    [-144.6850, 60.2056],
    [-144.7679, 60.2149],
    [-144.8060, 60.2135],
    [-144.8464, 60.2179],
    [-144.9089, 60.2213],
    [-144.9293, 60.2283],
    [-144.9106, 60.2358],
    [-144.8452, 60.2489],
    [-144.8053, 60.2497],
    [-144.7601, 60.2581],
    [-144.7318, 60.2640],
    [-144.7627, 60.2724],
    [-144.7903, 60.2805],
    [-144.8276, 60.2807],
    [-144.8469, 60.2844],
    [-144.8813, 60.2906],
    [-144.8892, 60.2843],
    [-144.9113, 60.2804],
    [-144.9367, 60.2839],
    [-144.9631, 60.2996],
    [-144.9631, 60.3119],
    [-144.9500, 60.3261],
    [-144.9153, 60.3538],
    [-144.9032, 60.3670],
    [-144.8919, 60.3801],
    [-144.8811, 60.3890],
    [-144.8790, 60.3992],
    [-144.8555, 60.4169],
    [-144.8416, 60.4327],
    [-144.8247, 60.4482],
    [-144.8072, 60.4619],
    [-144.8564, 60.4592],
    [-144.8873, 60.4560],
    [-144.9000, 60.4468],
    [-144.9121, 60.4421],
    [-144.9108, 60.4372],
    [-144.9160, 60.4282],
    [-144.9293, 60.4260],
    [-144.9530, 60.4248],
    [-144.9734, 60.4181],
    [-145.0160, 60.4128],
    [-145.0532, 60.4004],
    [-145.0823, 60.3777],
    [-145.1076, 60.3446],
    [-145.1090, 60.3310],
    [-145.1095, 60.3143],
    [-145.1115, 60.3041],
    [-145.1327, 60.2958],
    [-145.1551, 60.2995],
    [-145.1681, 60.3068],
    [-145.1886, 60.3053],
    [-145.2087, 60.3034],
    [-145.2155, 60.3023],
    [-145.2344, 60.3056],
    [-145.2549, 60.3124],
    [-145.2717, 60.3203],
    [-145.2925, 60.3251],
    [-145.3123, 60.3372],
    [-145.3278, 60.3383],
    [-145.3408, 60.3411],
    [-145.3498, 60.3458],
    [-145.3645, 60.3460],
    [-145.3730, 60.3493],
    [-145.3884, 60.3537],
    [-145.3962, 60.3593],
    [-145.4077, 60.3645],
    [-145.4210, 60.3688],
    [-145.4268, 60.3721],
    [-145.4400, 60.3766],
    [-145.4503, 60.3814],
    [-145.4572, 60.3807],
    [-145.4647, 60.3812],
    [-145.4816, 60.3859],
    [-145.5055, 60.3943],
    [-145.5030, 60.4013],
    [-145.5045, 60.4096],
    [-145.4944, 60.4175],
    [-145.5177, 60.4217],
    [-145.5349, 60.4283],
    [-145.5602, 60.4312],
    [-145.5857, 60.4399],
    [-145.6056, 60.4492],
    [-145.6496, 60.4544],
    [-145.6894, 60.4515],
    [-145.6938, 60.4593],
    [-145.7329, 60.4570],
    [-145.7557, 60.4646],
    [-145.7777, 60.4550],
    [-145.8380, 60.4501],
    [-145.8775, 60.4452],
    [-145.8978, 60.4485],
    [-145.9174, 60.4535],
    [-145.9336, 60.4554],
    [-145.9390, 60.4535],
    [-145.9574, 60.4611],
    [-145.9609, 60.4692],
    [-145.9466, 60.4751],
    [-145.9353, 60.4799],
    [-145.9183, 60.4890],
    [-145.9081, 60.4944],
    [-145.9019, 60.4928],
    [-145.8961, 60.4885],
    [-145.8825, 60.4926],
    [-145.8679, 60.4999],
    [-145.8641, 60.5034],
    [-145.8532, 60.5074],
    [-145.8420, 60.5122],
    [-145.8329, 60.5143],
    [-145.8093, 60.5194],
    [-145.7997, 60.5217],
    [-145.7922, 60.5310],
    [-145.7726, 60.5362],
    [-145.7628, 60.5374],
    [-145.7625, 60.5395],
    [-145.7711, 60.5451],
    [-145.7734, 60.5499],
    [-145.7636, 60.5518],
    [-145.7543, 60.5586],
    [-145.7503, 60.5589],
    [-145.7443, 60.5607],
    [-145.7447, 60.5672],
    [-145.7372, 60.5714],
    [-145.7250, 60.5777],
    [-145.7194, 60.5800],
    [-145.7155, 60.5808],
    [-145.7077, 60.5863],
    [-145.6998, 60.5930],
    [-145.6970, 60.6010],
    [-145.6949, 60.6064],
    [-145.6917, 60.6092],
    [-145.6832, 60.6132],
    [-145.6813, 60.6179],
    [-145.6798, 60.6221],
    [-145.6780, 60.6258],
    [-145.6730, 60.6312],
    [-145.6663, 60.6339],
    [-145.6604, 60.6361],
    [-145.6480, 60.6402],
    [-145.6357, 60.6449],
    [-145.6261, 60.6504],
    [-145.6209, 60.6544],
    [-145.6225, 60.6597],
    [-145.6373, 60.6659],
    [-145.6531, 60.6660],
    [-145.6628, 60.6623],
    [-145.6714, 60.6551],
    [-145.6961, 60.6481],
    [-145.7212, 60.6394],
    [-145.7517, 60.6325],
    [-145.7667, 60.6287],
    [-145.7980, 60.6234],
    [-145.8334, 60.6147],
    [-145.8604, 60.6119],
    [-145.8724, 60.6111],
    [-145.8849, 60.6115],
    [-145.8991, 60.6120],
    [-145.8943, 60.6150],
    [-145.8985, 60.6174],
    [-145.8894, 60.6212],
    [-145.8748, 60.6227],
    [-145.8594, 60.6247],
    [-145.8367, 60.6331],
    [-145.8238, 60.6382],
    [-145.8127, 60.6411],
    [-145.8184, 60.6434],
    [-145.8322, 60.6434],
    [-145.8388, 60.6474],
    [-145.8562, 60.6429],
    [-145.8708, 60.6379],
    [-145.8875, 60.6284],
    [-145.8998, 60.6297],
    [-145.8854, 60.6373],
    [-145.8827, 60.6403],
    [-145.8876, 60.6429],
    [-145.8784, 60.6474],
    [-145.8774, 60.6497],
    [-145.8852, 60.6516],
    [-145.8918, 60.6513],
    [-145.8953, 60.6520],
    [-145.9019, 60.6527],
    [-145.8891, 60.6571],
    [-145.8723, 60.6630],
    [-145.8668, 60.6697],
    [-145.8617, 60.6735],
    [-145.8543, 60.6784],
    [-145.8629, 60.6782],
    [-145.8556, 60.6821],
    [-145.8374, 60.6873],
    [-145.8445, 60.6902],
    [-145.8615, 60.6850],
    [-145.8653, 60.6871],
    [-145.8779, 60.6808],
    [-145.8951, 60.6744],
    [-145.8989, 60.6713],
    [-145.9008, 60.6667],
    [-145.8836, 60.6720],
    [-145.9081, 60.6584],
    [-145.9221, 60.6526],
    [-145.9259, 60.6466],
    [-145.9310, 60.6431],
    [-145.9270, 60.6382],
    [-145.9350, 60.6347],
    [-145.9383, 60.6311],
    [-145.9414, 60.6238],
    [-145.9508, 60.6224],
    [-145.9562, 60.6221],
    [-145.9613, 60.6210],
    [-145.9667, 60.6206],
    [-145.9779, 60.6202],
    [-145.9875, 60.6229],
    [-145.9994, 60.6179],
    [-146.0070, 60.6158],
    [-146.0111, 60.6219],
    [-146.0032, 60.6250],
    [-146.0107, 60.6259],
    [-146.0055, 60.6293],
    [-145.9966, 60.6338],
    [-146.0013, 60.6365],
    [-146.0004, 60.6418],
    [-146.0005, 60.6439],
    [-145.9853, 60.6499],
    [-145.9830, 60.6539],
    [-145.9838, 60.6581],
    [-145.9691, 60.6586],
    [-145.9635, 60.6625],
    [-145.9701, 60.6684],
    [-145.9786, 60.6688],
    [-145.9695, 60.6724],
    [-145.9556, 60.6772],
    [-145.9494, 60.6815],
    [-145.9370, 60.6828],
    [-145.9418, 60.6854],
    [-145.9470, 60.6877],
    [-145.9307, 60.6923],
    [-145.9171, 60.6935],
    [-145.9200, 60.6978],
    [-145.9296, 60.7012],
    [-145.9403, 60.6988],
    [-145.9506, 60.6971],
    [-145.9740, 60.6877],
    [-145.9964, 60.6798],
    [-146.0196, 60.6738],
    [-146.0179, 60.6689],
    [-146.0266, 60.6660],
    [-146.0374, 60.6648],
    [-146.0569, 60.6604],
    [-146.0891, 60.6521],
    [-146.1071, 60.6473],
    [-146.1275, 60.6409],
    [-146.1464, 60.6331],
    [-146.1536, 60.6321],
    [-146.1597, 60.6324],
    [-146.1717, 60.6300],
    [-146.1922, 60.6260],
    [-146.2007, 60.6286],
    [-146.2286, 60.6267],
    [-146.2532, 60.6224],
    [-146.2628, 60.6325],
    [-146.2703, 60.6449],
    [-146.2656, 60.6516],
    [-146.2547, 60.6556],
    [-146.2437, 60.6553],
    [-146.2378, 60.6611],
    [-146.2312, 60.6642],
    [-146.2173, 60.6660],
    [-146.2139, 60.6711],
    [-146.2083, 60.6755],
    [-146.2028, 60.6780],
    [-146.1933, 60.6858],
    [-146.1798, 60.6923],
    [-146.1628, 60.6968],
    [-146.1534, 60.6987],
    [-146.1542, 60.7017],
    [-146.1414, 60.7079],
    [-146.1375, 60.7098],
    [-146.1331, 60.7092],
    [-146.1291, 60.7128],
    [-146.1067, 60.7162],
    [-146.1020, 60.7195],
    [-146.0932, 60.7230],
    [-146.0891, 60.7257],
    [-146.0827, 60.7294],
    [-146.0743, 60.7300],
    [-146.0595, 60.7359],
    [-146.0589, 60.7401],
    [-146.0665, 60.7407],
    [-146.0817, 60.7364],
    [-146.0853, 60.7370],
    [-146.0730, 60.7426],
    [-146.0768, 60.7445],
    [-146.0743, 60.7474],
    [-146.0634, 60.7512],
    [-146.0492, 60.7487],
    [-146.0423, 60.7459],
    [-146.0329, 60.7463],
    [-146.0229, 60.7458],
    [-146.0278, 60.7484],
    [-146.0304, 60.7514],
    [-146.0374, 60.7540],
    [-146.0423, 60.7560],
    [-146.0541, 60.7574],
    [-146.0602, 60.7577],
    [-146.0563, 60.7634],
    [-146.0502, 60.7668],
    [-146.0486, 60.7711],
    [-146.0444, 60.7750],
    [-146.0464, 60.7784],
    [-146.0444, 60.7851],
    [-146.0576, 60.7892],
    [-146.0633, 60.7862],
    [-146.0675, 60.7829],
    [-146.0688, 60.7786],
    [-146.0708, 60.7762],
    [-146.0751, 60.7728],
    [-146.0812, 60.7692],
    [-146.0860, 60.7646],
    [-146.0919, 60.7599],
    [-146.0981, 60.7561],
    [-146.1033, 60.7545],
    [-146.1041, 60.7501],
    [-146.1101, 60.7473],
    [-146.1142, 60.7438],
    [-146.1157, 60.7426],
    [-146.1208, 60.7377],
    [-146.1274, 60.7325],
    [-146.1314, 60.7312],
    [-146.1376, 60.7321],
    [-146.1348, 60.7359],
    [-146.1340, 60.7390],
    [-146.1301, 60.7406],
    [-146.1244, 60.7419],
    [-146.1233, 60.7436],
    [-146.1370, 60.7442],
    [-146.1409, 60.7432],
    [-146.1440, 60.7416],
    [-146.1489, 60.7382],
    [-146.1537, 60.7333],
    [-146.1571, 60.7311],
    [-146.1591, 60.7279],
    [-146.1596, 60.7240],
    [-146.1626, 60.7246],
    [-146.1718, 60.7235],
    [-146.1725, 60.7296],
    [-146.1714, 60.7318],
    [-146.1765, 60.7297],
    [-146.1804, 60.7289],
    [-146.1807, 60.7318],
    [-146.1850, 60.7310],
    [-146.1929, 60.7325],
    [-146.2032, 60.7355],
    [-146.2011, 60.7432],
    [-146.1968, 60.7462],
    [-146.1888, 60.7476],
    [-146.1819, 60.7509],
    [-146.1779, 60.7546],
    [-146.1820, 60.7566],
    [-146.1886, 60.7560],
    [-146.1902, 60.7543],
    [-146.1940, 60.7519],
    [-146.2038, 60.7493],
    [-146.2154, 60.7460],
    [-146.2212, 60.7461],
    [-146.2250, 60.7452],
    [-146.2255, 60.7415],
    [-146.2286, 60.7286],
    [-146.2326, 60.7215],
    [-146.2400, 60.7172],
    [-146.2627, 60.7139],
    [-146.2834, 60.7131],
    [-146.2953, 60.7139],
    [-146.3057, 60.7159],
    [-146.3130, 60.7185],
    [-146.3164, 60.7229],
    [-146.3120, 60.7317],
    [-146.3098, 60.7380],
    [-146.3123, 60.7443],
    [-146.3140, 60.7476],
    [-146.3087, 60.7521],
    [-146.3063, 60.7556],
    [-146.3065, 60.7588],
    [-146.3015, 60.7613],
    [-146.2913, 60.7639],
    [-146.2835, 60.7670],
    [-146.2772, 60.7706],
    [-146.2777, 60.7742],
    [-146.2759, 60.7757],
    [-146.2763, 60.7771],
    [-146.2823, 60.7750],
    [-146.2854, 60.7727],
    [-146.2910, 60.7693],
    [-146.2958, 60.7675],
    [-146.3034, 60.7691],
    [-146.3124, 60.7682],
    [-146.3198, 60.7668],
    [-146.3221, 60.7621],
    [-146.3280, 60.7596],
    [-146.3320, 60.7539],
    [-146.3312, 60.7499],
    [-146.3304, 60.7438],
    [-146.3320, 60.7411],
    [-146.3299, 60.7379],
    [-146.3423, 60.7367],
    [-146.3484, 60.7314],
    [-146.3536, 60.7284],
    [-146.3583, 60.7244],
    [-146.3579, 60.7205],
    [-146.3672, 60.7169],
    [-146.3736, 60.7183],
    [-146.3817, 60.7165],
    [-146.3858, 60.7115],
    [-146.3791, 60.7039],
    [-146.3925, 60.6993],
    [-146.3997, 60.6933],
    [-146.4211, 60.6875],
    [-146.4307, 60.6847],
    [-146.4418, 60.6862],
    [-146.4575, 60.6849],
    [-146.4731, 60.6801],
    [-146.4792, 60.6748],
    [-146.4915, 60.6704],
    [-146.5016, 60.6691],
    [-146.5037, 60.6727],
    [-146.5013, 60.6747],
    [-146.5004, 60.6780],
    [-146.4977, 60.6806],
    [-146.5106, 60.6861],
    [-146.5307, 60.6896],
    [-146.5371, 60.6905],
    [-146.5474, 60.6884],
    [-146.5597, 60.6900],
    [-146.5726, 60.6905],
    [-146.5788, 60.6902],
    [-146.5855, 60.6916],
    [-146.5860, 60.6944],
    [-146.5961, 60.6951],
    [-146.6010, 60.6928],
    [-146.6037, 60.6880],
    [-146.6170, 60.6827],
    [-146.6316, 60.6827],
    [-146.6422, 60.6849],
    [-146.6519, 60.6845],
    [-146.6548, 60.6880],
    [-146.6626, 60.6918],
    [-146.6639, 60.6982],
    [-146.6562, 60.7057],
    [-146.6617, 60.7121],
    [-146.6744, 60.7176],
    [-146.6790, 60.7220],
    [-146.6884, 60.7262],
    [-146.6958, 60.7323],
    [-146.6993, 60.7385],
    [-146.7010, 60.7434],
    [-146.6892, 60.7435],
    [-146.6730, 60.7409],
    [-146.6609, 60.7335],
    [-146.6558, 60.7281],
    [-146.6424, 60.7263],
    [-146.6346, 60.7208],
    [-146.6264, 60.7187],
    [-146.6228, 60.7235],
    [-146.6228, 60.7284],
    [-146.6262, 60.7325],
    [-146.6297, 60.7323],
    [-146.6348, 60.7312],
    [-146.6311, 60.7379],
    [-146.6322, 60.7405],
    [-146.6290, 60.7443],
    [-146.6230, 60.7490],
    [-146.6139, 60.7510],
    [-146.6075, 60.7585],
    [-146.6037, 60.7607],
    [-146.5931, 60.7596],
    [-146.5772, 60.7538],
    [-146.5772, 60.7473],
    [-146.5822, 60.7437],
    [-146.5850, 60.7376],
    [-146.5755, 60.7299],
    [-146.5723, 60.7330],
    [-146.5740, 60.7377],
    [-146.5647, 60.7434],
    [-146.5477, 60.7467],
    [-146.5331, 60.7481],
    [-146.5268, 60.7463],
    [-146.5196, 60.7453],
    [-146.5139, 60.7432],
    [-146.5192, 60.7426],
    [-146.5208, 60.7408],
    [-146.5261, 60.7362],
    [-146.5217, 60.7340],
    [-146.5092, 60.7377],
    [-146.5048, 60.7412],
    [-146.5012, 60.7448],
    [-146.5042, 60.7480],
    [-146.5091, 60.7512],
    [-146.5164, 60.7563],
    [-146.5277, 60.7600],
    [-146.5352, 60.7618],
    [-146.5514, 60.7675],
    [-146.5451, 60.7723],
    [-146.5331, 60.7733],
    [-146.5246, 60.7764],
    [-146.5186, 60.7750],
    [-146.5156, 60.7727],
    [-146.5085, 60.7742],
    [-146.5057, 60.7772],
    [-146.5050, 60.7755],
    [-146.5049, 60.7724],
    [-146.4950, 60.7722],
    [-146.4795, 60.7706],
    [-146.4708, 60.7716],
    [-146.4632, 60.7710],
    [-146.4537, 60.7705],
    [-146.4475, 60.7690],
    [-146.4418, 60.7720],
    [-146.4416, 60.7757],
    [-146.4401, 60.7791],
    [-146.4235, 60.7788],
    [-146.4009, 60.7813],
    [-146.3839, 60.7824],
    [-146.3636, 60.7866],
    [-146.3550, 60.7851],
    [-146.3425, 60.7894],
    [-146.3297, 60.7889],
    [-146.3044, 60.7980],
    [-146.2889, 60.8053],
    [-146.2722, 60.8097],
    [-146.2602, 60.8104],
    [-146.2556, 60.8122],
    [-146.2501, 60.8130],
    [-146.2414, 60.8127],
    [-146.2345, 60.8116],
    [-146.2262, 60.8135],
    [-146.2121, 60.8162],
    [-146.2007, 60.8176],
    [-146.1930, 60.8212],
    [-146.2052, 60.8195],
    [-146.2118, 60.8206],
    [-146.2265, 60.8194],
    [-146.2427, 60.8183],
    [-146.2514, 60.8183],
    [-146.2493, 60.8230],
    [-146.2483, 60.8298],
    [-146.2438, 60.8340],
    [-146.2448, 60.8390],
    [-146.2509, 60.8389],
    [-146.2493, 60.8409],
    [-146.2160, 60.8450],
    [-146.1697, 60.8461],
    [-146.1624, 60.8427],
    [-146.1436, 60.8406],
    [-146.1124, 60.8359],
    [-146.0979, 60.8351],
    [-146.0942, 60.8380],
    [-146.1076, 60.8402],
    [-146.1162, 60.8470],
    [-146.1328, 60.8489],
    [-146.1428, 60.8495],
    [-146.1428, 60.8526],
    [-146.1470, 60.8548],
    [-146.1531, 60.8578],
    [-146.1710, 60.8629],
    [-146.1732, 60.8678],
    [-146.1829, 60.8693],
    [-146.1946, 60.8750],
    [-146.2046, 60.8761],
    [-146.2096, 60.8753],
    [-146.2197, 60.8713],
    [-146.2107, 60.8686],
    [-146.2134, 60.8644],
    [-146.2337, 60.8610],
    [-146.2470, 60.8586],
    [-146.2404, 60.8641],
    [-146.2304, 60.8650],
    [-146.2328, 60.8677],
    [-146.2243, 60.8721],
    [-146.2268, 60.8773],
    [-146.2354, 60.8811],
    [-146.2454, 60.8789],
    [-146.2550, 60.8722],
    [-146.2626, 60.8678],
    [-146.2695, 60.8621],
    [-146.2684, 60.8589],
    [-146.2697, 60.8568],
    [-146.2713, 60.8553],
    [-146.2822, 60.8514],
    [-146.2811, 60.8489],
    [-146.2853, 60.8460],
    [-146.2904, 60.8436],
    [-146.2896, 60.8378],
    [-146.2987, 60.8385],
    [-146.3023, 60.8374],
    [-146.3117, 60.8344],
    [-146.3119, 60.8319],
    [-146.3180, 60.8274],
    [-146.3251, 60.8275],
    [-146.3312, 60.8251],
    [-146.3344, 60.8223],
    [-146.3518, 60.8185],
    [-146.3594, 60.8186],
    [-146.3675, 60.8192],
    [-146.3823, 60.8153],
    [-146.3913, 60.8141],
    [-146.4000, 60.8126],
    [-146.4056, 60.8132],
    [-146.4109, 60.8145],
    [-146.4154, 60.8143],
    [-146.4182, 60.8201],
    [-146.4033, 60.8241],
    [-146.3955, 60.8292],
    [-146.3996, 60.8308],
    [-146.3875, 60.8339],
    [-146.3846, 60.8378],
    [-146.3884, 60.8420],
    [-146.3946, 60.8417],
    [-146.3993, 60.8395],
    [-146.4051, 60.8364],
    [-146.4140, 60.8348],
    [-146.4234, 60.8305],
    [-146.4305, 60.8260],
    [-146.4342, 60.8233],
    [-146.4476, 60.8206],
    [-146.4561, 60.8184],
    [-146.4480, 60.8137],
    [-146.4524, 60.8143],
    [-146.4575, 60.8121],
    [-146.4675, 60.8131],
    [-146.4739, 60.8106],
    [-146.4840, 60.8132],
    [-146.4975, 60.8140],
    [-146.5141, 60.8139],
    [-146.5378, 60.8123],
    [-146.5466, 60.8104],
    [-146.5585, 60.8082],
    [-146.5530, 60.8118],
    [-146.5467, 60.8141],
    [-146.5509, 60.8172],
    [-146.5637, 60.8178],
    [-146.5644, 60.8213],
    [-146.5778, 60.8204],
    [-146.5770, 60.8226],
    [-146.5681, 60.8229],
    [-146.5667, 60.8252],
    [-146.5732, 60.8329],
    [-146.5581, 60.8321],
    [-146.5539, 60.8393],
    [-146.5624, 60.8417],
    [-146.5740, 60.8457],
    [-146.5724, 60.8516],
    [-146.5799, 60.8546],
    [-146.5904, 60.8513],
    [-146.5977, 60.8456],
    [-146.6097, 60.8358],
    [-146.6142, 60.8284],
    [-146.6204, 60.8200],
    [-146.6350, 60.8179],
    [-146.6420, 60.8220],
    [-146.6368, 60.8257],
    [-146.6346, 60.8337],
    [-146.6341, 60.8446],
    [-146.6384, 60.8470],
    [-146.6303, 60.8479],
    [-146.6213, 60.8520],
    [-146.6172, 60.8587],
    [-146.6140, 60.8659],
    [-146.6214, 60.8687],
    [-146.6275, 60.8762],
    [-146.6305, 60.8797],
    [-146.6327, 60.8844],
    [-146.6357, 60.8870],
    [-146.6423, 60.8863],
    [-146.6407, 60.8778],
    [-146.6519, 60.8740],
    [-146.6596, 60.8706],
    [-146.6651, 60.8673],
    [-146.6620, 60.8619],
    [-146.6701, 60.8619],
    [-146.6797, 60.8616],
    [-146.6853, 60.8647],
    [-146.6937, 60.8707],
    [-146.7017, 60.8731],
    [-146.7069, 60.8759],
    [-146.7010, 60.8750],
    [-146.7005, 60.8795],
    [-146.7069, 60.8875],
    [-146.7054, 60.8895],
    [-146.6990, 60.8883],
    [-146.6974, 60.8925],
    [-146.7022, 60.8965],
    [-146.7072, 60.8983],
    [-146.7142, 60.8985],
    [-146.7313, 60.9068],
    [-146.7378, 60.9106],
    [-146.7293, 60.9114],
    [-146.7295, 60.9147],
    [-146.7340, 60.9205],
    [-146.7377, 60.9260],
    [-146.7350, 60.9304],
    [-146.7446, 60.9326],
    [-146.7516, 60.9392],
    [-146.7595, 60.9436],
    [-146.7591, 60.9574],
    [-146.7481, 60.9591],
    [-146.7372, 60.9587],
    [-146.7327, 60.9577],
    [-146.7288, 60.9492],
    [-146.7254, 60.9453],
    [-146.7270, 60.9416],
    [-146.7122, 60.9349],
    [-146.7042, 60.9316],
    [-146.6899, 60.9321],
    [-146.6797, 60.9337],
    [-146.6740, 60.9320],
    [-146.6676, 60.9349],
    [-146.6596, 60.9389],
    [-146.6588, 60.9417],
    [-146.6507, 60.9390],
    [-146.6523, 60.9312],
    [-146.6451, 60.9297],
    [-146.6379, 60.9280],
    [-146.6323, 60.9247],
    [-146.6178, 60.9259],
    [-146.6052, 60.9227],
    [-146.5993, 60.9226],
    [-146.5964, 60.9268],
    [-146.5913, 60.9286],
    [-146.5940, 60.9324],
    [-146.5950, 60.9367],
    [-146.6051, 60.9406],
    [-146.6063, 60.9454],
    [-146.6199, 60.9508],
    [-146.6287, 60.9514],
    [-146.6351, 60.9533],
    [-146.6447, 60.9523],
    [-146.6596, 60.9486],
    [-146.6712, 60.9475],
    [-146.6814, 60.9468],
    [-146.6897, 60.9490],
    [-146.6953, 60.9534],
    [-146.6990, 60.9578],
    [-146.7044, 60.9615],
    [-146.7120, 60.9625],
    [-146.7201, 60.9667],
    [-146.7217, 60.9756],
    [-146.7149, 60.9781],
    [-146.7084, 60.9753],
    [-146.6993, 60.9784],
    [-146.7016, 60.9813],
    [-146.7013, 60.9844],
    [-146.6985, 60.9885],
    [-146.6959, 60.9918],
    [-146.6966, 60.9979],
    [-146.6958, 61.0020],
    [-146.6916, 61.0062],
    [-146.6878, 61.0099],
    [-146.6826, 61.0169],
    [-146.6804, 61.0230],
    [-146.6747, 61.0295],
    [-146.6671, 61.0351],
    [-146.6602, 61.0333],
    [-146.6551, 61.0308],
    [-146.6518, 61.0270],
    [-146.6454, 61.0241],
    [-146.6405, 61.0277],
    [-146.6377, 61.0320],
    [-146.6283, 61.0273],
    [-146.6194, 61.0230],
    [-146.6114, 61.0214],
    [-146.6073, 61.0184],
    [-146.6073, 61.0214],
    [-146.6088, 61.0245],
    [-146.5880, 61.0230],
    [-146.5753, 61.0197],
    [-146.5634, 61.0222],
    [-146.5668, 61.0269],
    [-146.5902, 61.0309],
    [-146.6138, 61.0370],
    [-146.5994, 61.0344],
    [-146.5742, 61.0345],
    [-146.5843, 61.0387],
    [-146.5912, 61.0411],
    [-146.6038, 61.0433],
    [-146.6329, 61.0455],
    [-146.6518, 61.0480],
    [-146.6561, 61.0520],
    [-146.6615, 61.0608],
    [-146.6511, 61.0706],
    [-146.6444, 61.0739],
    [-146.6304, 61.0788],
    [-146.6110, 61.0853],
    [-146.5775, 61.0832],
    [-146.5730, 61.0789],
    [-146.5674, 61.0785],
    [-146.5518, 61.0786],
    [-146.5373, 61.0801],
    [-146.5390, 61.0819],
    [-146.5175, 61.0831],
    [-146.4999, 61.0789],
    [-146.4929, 61.0795],
    [-146.4833, 61.0800],
    [-146.4720, 61.0802],
    [-146.4646, 61.0793],
    [-146.4471, 61.0812],
    [-146.4338, 61.0819],
    [-146.4220, 61.0851],
    [-146.4095, 61.0905],
    [-146.3963, 61.0891],
    [-146.3696, 61.0902],
    [-146.3639, 61.0871],
    [-146.3543, 61.0857],
    [-146.3449, 61.0869],
    [-146.3302, 61.0831],
    [-146.3052, 61.0839],
    [-146.2972, 61.0860],
    [-146.2665, 61.0850],
    [-146.2675, 61.0888],
    [-146.2622, 61.0954],
    [-146.2585, 61.1019],
    [-146.2659, 61.1107],
    [-146.2801, 61.1186],
    [-146.2826, 61.1216],
    [-146.2968, 61.1269],
    [-146.3053, 61.1247],
    [-146.3105, 61.1229],
    [-146.3321, 61.1271],
    [-146.3369, 61.1260],
    [-146.3420, 61.1244],
    [-146.3568, 61.1233],
    [-146.3674, 61.1236],
    [-146.3983, 61.1243],
    [-146.4102, 61.1284],
    [-146.4191, 61.1353],
    [-146.4468, 61.1339],
    [-146.4557, 61.1336],
    [-146.4702, 61.1305],
    [-146.4887, 61.1296],
    [-146.5079, 61.1234],
    [-146.5368, 61.1245],
    [-146.5673, 61.1222],
    [-146.5791, 61.1171],
    [-146.5845, 61.1172],
    [-146.5763, 61.1216],
    [-146.5778, 61.1244],
    [-146.5722, 61.1308],
    [-146.5701, 61.1345],
    [-146.5736, 61.1374],
    [-146.5842, 61.1378],
    [-146.5873, 61.1435],
    [-146.6019, 61.1434],
    [-146.6071, 61.1392],
    [-146.5951, 61.1377],
    [-146.5967, 61.1335],
    [-146.5981, 61.1300],
    [-146.6109, 61.1206],
    [-146.6211, 61.1192],
    [-146.6298, 61.1138],
    [-146.6384, 61.1116],
    [-146.6472, 61.1078],
    [-146.6502, 61.1027],
    [-146.6611, 61.0955],
    [-146.6656, 61.0917],
    [-146.6722, 61.0858],
    [-146.6728, 61.0796],
    [-146.6791, 61.0746],
    [-146.6848, 61.0702],
    [-146.6889, 61.0645],
    [-146.6958, 61.0608],
    [-146.7018, 61.0558],
    [-146.7139, 61.0555],
    [-146.7248, 61.0524],
    [-146.7362, 61.0473],
    [-146.7565, 61.0450],
    [-146.7700, 61.0443],
    [-146.7785, 61.0531],
    [-146.7763, 61.0618],
    [-146.7843, 61.0668],
    [-146.7960, 61.0641],
    [-146.7960, 61.0584],
    [-146.7976, 61.0526],
    [-146.7992, 61.0469],
    [-146.7942, 61.0432],
    [-146.7842, 61.0436],
    [-146.7908, 61.0374],
    [-146.7913, 61.0336],
    [-146.8003, 61.0266],
    [-146.8058, 61.0257],
    [-146.8142, 61.0218],
    [-146.8260, 61.0101],
    [-146.8422, 61.0017],
    [-146.8503, 60.9953],
    [-146.8571, 60.9882],
    [-146.8596, 60.9836],
    [-146.8615, 60.9782],
    [-146.8623, 60.9744],
    [-146.8723, 60.9687],
    [-146.8833, 60.9609],
    [-146.8930, 60.9565],
    [-146.9004, 60.9543],
    [-146.9204, 60.9457],
    [-146.9352, 60.9397],
    [-146.9506, 60.9361],
    [-146.9648, 60.9327],
    [-146.9716, 60.9305],
    [-146.9831, 60.9334],
    [-146.9848, 60.9361],
    [-146.9963, 60.9382],
    [-147.0090, 60.9390],
    [-147.0203, 60.9386],
    [-147.0309, 60.9405],
    [-147.0422, 60.9417],
    [-147.0492, 60.9414],
    [-147.0543, 60.9440],
    [-147.0575, 60.9445],
    [-147.0492, 60.9471],
    [-147.0438, 60.9500],
    [-147.0383, 60.9513],
    [-147.0203, 60.9497],
    [-147.0216, 60.9527],
    [-147.0266, 60.9533],
    [-147.0301, 60.9551],
    [-147.0255, 60.9592],
    [-147.0209, 60.9597],
    [-147.0158, 60.9591],
    [-147.0114, 60.9600],
    [-147.0072, 60.9633],
    [-146.9982, 60.9667],
    [-146.9865, 60.9688],
    [-146.9714, 60.9704],
    [-146.9786, 60.9726],
    [-146.9790, 60.9755],
    [-146.9839, 60.9775],
    [-146.9878, 60.9802],
    [-146.9843, 60.9833],
    [-146.9766, 60.9861],
    [-146.9754, 60.9906],
    [-146.9743, 60.9942],
    [-146.9825, 60.9976],
    [-146.9904, 60.9970],
    [-146.9990, 60.9970],
    [-146.9990, 61.0014],
    [-146.9984, 61.0057],
    [-147.0153, 60.9996],
    [-147.0208, 60.9904],
    [-147.0177, 60.9862],
    [-147.0192, 60.9781],
    [-147.0247, 60.9776],
    [-147.0255, 60.9721],
    [-147.0324, 60.9732],
    [-147.0359, 60.9711],
    [-147.0462, 60.9623],
    [-147.0507, 60.9610],
    [-147.0588, 60.9563],
    [-147.0636, 60.9549],
    [-147.0683, 60.9599],
    [-147.0682, 60.9653],
    [-147.0568, 60.9801],
    [-147.0461, 60.9881],
    [-147.0473, 60.9909],
    [-147.0361, 60.9922],
    [-147.0270, 60.9944],
    [-147.0196, 61.0002],
    [-147.0141, 61.0043],
    [-147.0064, 61.0092],
    [-147.0021, 61.0139],
    [-146.9935, 61.0129],
    [-146.9931, 61.0185],
    [-146.9981, 61.0193],
    [-147.0012, 61.0219],
    [-146.9981, 61.0239],
    [-146.9946, 61.0290],
    [-146.9957, 61.0333],
    [-146.9902, 61.0363],
    [-147.0001, 61.0411],
    [-147.0026, 61.0470],
    [-147.0083, 61.0567],
    [-147.0077, 61.0592],
    [-147.0107, 61.0626],
    [-147.0154, 61.0691],
    [-147.0270, 61.0774],
    [-147.0284, 61.0833],
    [-147.0391, 61.0893],
    [-147.0466, 61.0909],
    [-147.0447, 61.0980],
    [-147.0484, 61.1082],
    [-147.0554, 61.1147],
    [-147.0618, 61.1203],
    [-147.0555, 61.1218],
    [-147.0511, 61.1245],
    [-147.0235, 61.1283],
    [-147.0090, 61.1350],
    [-146.9988, 61.1430],
    [-146.9984, 61.1470],
    [-147.0166, 61.1500],
    [-147.0235, 61.1500],
    [-147.0417, 61.1539],
    [-147.0674, 61.1512],
    [-147.0842, 61.1558],
    [-147.0965, 61.1517],
    [-147.1178, 61.1448],
    [-147.1279, 61.1329],
    [-147.1137, 61.1285],
    [-147.1130, 61.1218],
    [-147.1069, 61.1152],
    [-147.0964, 61.1135],
    [-147.0965, 61.1063],
    [-147.1060, 61.1015],
    [-147.1056, 61.0981],
    [-147.1159, 61.0971],
    [-147.1235, 61.0970],
    [-147.1321, 61.0917],
    [-147.1294, 61.0874],
    [-147.1228, 61.0823],
    [-147.1110, 61.0785],
    [-147.1055, 61.0757],
    [-147.1052, 61.0693],
    [-147.0954, 61.0615],
    [-147.0974, 61.0523],
    [-147.0920, 61.0493],
    [-147.1041, 61.0414],
    [-147.1098, 61.0366],
    [-147.1042, 61.0347],
    [-147.0985, 61.0369],
    [-147.0911, 61.0394],
    [-147.0872, 61.0355],
    [-147.0903, 61.0313],
    [-147.0857, 61.0199],
    [-147.0914, 61.0152],
    [-147.0948, 61.0087],
    [-147.1052, 61.0072],
    [-147.1108, 61.0020],
    [-147.1206, 60.9969],
    [-147.1339, 60.9843],
    [-147.1408, 60.9791],
    [-147.1451, 60.9717],
    [-147.1500, 60.9659],
    [-147.1394, 60.9504],
    [-147.1377, 60.9437],
    [-147.1478, 60.9392],
    [-147.1584, 60.9398],
    [-147.1633, 60.9393],
    [-147.1702, 60.9322],
    [-147.1739, 60.9318],
    [-147.1849, 60.9321],
    [-147.1861, 60.9353],
    [-147.1873, 60.9380],
    [-147.1846, 60.9415],
    [-147.1861, 60.9457],
    [-147.1956, 60.9451],
    [-147.1970, 60.9423],
    [-147.2070, 60.9426],
    [-147.2201, 60.9529],
    [-147.2181, 60.9590],
    [-147.2276, 60.9618],
    [-147.2196, 60.9695],
    [-147.2203, 60.9817],
    [-147.2168, 60.9867],
    [-147.2150, 60.9941],
    [-147.2132, 60.9996],
    [-147.2177, 61.0055],
    [-147.2221, 61.0082],
    [-147.2263, 61.0048],
    [-147.2279, 61.0013],
    [-147.2273, 60.9933],
    [-147.2352, 60.9882],
    [-147.2474, 60.9837],
    [-147.2516, 60.9781],
    [-147.2629, 60.9773],
    [-147.2736, 60.9746],
    [-147.2787, 60.9751],
    [-147.2821, 60.9731],
    [-147.2793, 60.9657],
    [-147.2781, 60.9618],
    [-147.2740, 60.9558],
    [-147.2689, 60.9504],
    [-147.2574, 60.9503],
    [-147.2572, 60.9411],
    [-147.2529, 60.9356],
    [-147.2518, 60.9289],
    [-147.2555, 60.9267],
    [-147.2601, 60.9231],
    [-147.2574, 60.9191],
    [-147.2616, 60.9202],
    [-147.2654, 60.9232],
    [-147.2673, 60.9272],
    [-147.2705, 60.9275],
    [-147.2723, 60.9233],
    [-147.2761, 60.9176],
    [-147.2890, 60.9195],
    [-147.2989, 60.9228],
    [-147.3079, 60.9236],
    [-147.3128, 60.9263],
    [-147.3217, 60.9301],
    [-147.3322, 60.9300],
    [-147.3280, 60.9266],
    [-147.3188, 60.9176],
    [-147.3051, 60.9150],
    [-147.3023, 60.9078],
    [-147.3136, 60.9064],
    [-147.3178, 60.9094],
    [-147.3250, 60.9087],
    [-147.3291, 60.9076],
    [-147.3305, 60.9044],
    [-147.3297, 60.8981],
    [-147.3339, 60.8957],
    [-147.3483, 60.8893],
    [-147.3604, 60.8855],
    [-147.3666, 60.8802],
    [-147.3669, 60.8755],
    [-147.3730, 60.8747],
    [-147.3771, 60.8729],
    [-147.3844, 60.8727],
    [-147.3765, 60.8772],
    [-147.3707, 60.8823],
    [-147.3710, 60.8857],
    [-147.3764, 60.8861],
    [-147.3844, 60.8876],
    [-147.3884, 60.8937],
    [-147.3843, 60.8963],
    [-147.3917, 60.8993],
    [-147.4050, 60.9017],
    [-147.4064, 60.8947],
    [-147.4140, 60.8928],
    [-147.4212, 60.8928],
    [-147.4443, 60.8919],
    [-147.4532, 60.8949],
    [-147.4479, 60.9041],
    [-147.4411, 60.9118],
    [-147.4392, 60.9133],
    [-147.4347, 60.9163],
    [-147.4181, 60.9182],
    [-147.4027, 60.9223],
    [-147.4109, 60.9237],
    [-147.4145, 60.9258],
    [-147.4214, 60.9252],
    [-147.4342, 60.9229],
    [-147.4424, 60.9227],
    [-147.4504, 60.9168],
    [-147.4474, 60.9275],
    [-147.4286, 60.9410],
    [-147.4212, 60.9439],
    [-147.4127, 60.9477],
    [-147.4070, 60.9536],
    [-147.4026, 60.9580],
    [-147.3957, 60.9612],
    [-147.3913, 60.9646],
    [-147.3962, 60.9656],
    [-147.4032, 60.9682],
    [-147.4016, 60.9731],
    [-147.4087, 60.9706],
    [-147.4114, 60.9655],
    [-147.4193, 60.9596],
    [-147.4232, 60.9561],
    [-147.4308, 60.9522],
    [-147.4342, 60.9499],
    [-147.4434, 60.9483],
    [-147.4459, 60.9418],
    [-147.4590, 60.9435],
    [-147.4689, 60.9512],
    [-147.4669, 60.9620],
    [-147.4613, 60.9630],
    [-147.4595, 60.9692],
    [-147.4580, 60.9789],
    [-147.4551, 60.9849],
    [-147.4537, 60.9888],
    [-147.4541, 60.9924],
    [-147.4378, 61.0017],
    [-147.4202, 61.0026],
    [-147.4105, 61.0015],
    [-147.4059, 61.0081],
    [-147.4171, 61.0115],
    [-147.4238, 61.0104],
    [-147.4315, 61.0101],
    [-147.4446, 61.0081],
    [-147.4511, 61.0055],
    [-147.4582, 60.9986],
    [-147.4638, 60.9930],
    [-147.4735, 60.9871],
    [-147.4771, 60.9829],
    [-147.4846, 60.9723],
    [-147.4840, 60.9666],
    [-147.4894, 60.9625],
    [-147.4978, 60.9544],
    [-147.4982, 60.9484],
    [-147.5010, 60.9445],
    [-147.5043, 60.9428],
    [-147.5035, 60.9325],
    [-147.5092, 60.9258],
    [-147.5024, 60.9204],
    [-147.4959, 60.9143],
    [-147.4904, 60.9103],
    [-147.4989, 60.9063],
    [-147.5064, 60.9099],
    [-147.5099, 60.9124],
    [-147.5117, 60.9085],
    [-147.5135, 60.9044],
    [-147.5159, 60.9000],
    [-147.5149, 60.8966],
    [-147.5221, 60.8942],
    [-147.5291, 60.8979],
    [-147.5437, 60.9000],
    [-147.5520, 60.9009],
    [-147.5499, 60.9068],
    [-147.5451, 60.9154],
    [-147.5362, 60.9230],
    [-147.5322, 60.9258],
    [-147.5412, 60.9268],
    [-147.5350, 60.9296],
    [-147.5330, 60.9323],
    [-147.5328, 60.9401],
    [-147.5387, 60.9419],
    [-147.5344, 60.9500],
    [-147.5316, 60.9544],
    [-147.5376, 60.9570],
    [-147.5389, 60.9619],
    [-147.5440, 60.9664],
    [-147.5442, 60.9731],
    [-147.5503, 60.9794],
    [-147.5410, 60.9822],
    [-147.5448, 60.9860],
    [-147.5376, 60.9961],
    [-147.5318, 60.9924],
    [-147.5276, 60.9930],
    [-147.5242, 60.9984],
    [-147.5250, 61.0074],
    [-147.5221, 61.0138],
    [-147.5318, 61.0153],
    [-147.5448, 61.0165],
    [-147.5358, 61.0207],
    [-147.5281, 61.0240],
    [-147.5253, 61.0276],
    [-147.5310, 61.0302],
    [-147.5266, 61.0337],
    [-147.5238, 61.0376],
    [-147.5411, 61.0396],
    [-147.5290, 61.0442],
    [-147.5259, 61.0496],
    [-147.5417, 61.0503],
    [-147.5287, 61.0553],
    [-147.5188, 61.0628],
    [-147.5049, 61.0639],
    [-147.4901, 61.0659],
    [-147.4817, 61.0683],
    [-147.4844, 61.0720],
    [-147.4965, 61.0708],
    [-147.5027, 61.0761],
    [-147.5116, 61.0789],
    [-147.5086, 61.0873],
    [-147.5130, 61.0974],
    [-147.5223, 61.0999],
    [-147.5203, 61.1036],
    [-147.5197, 61.1089],
    [-147.5224, 61.1133],
    [-147.5287, 61.1197],
    [-147.5344, 61.1261],
    [-147.5438, 61.1357],
    [-147.5294, 61.1406],
    [-147.5168, 61.1438],
    [-147.5280, 61.1510],
    [-147.5410, 61.1497],
    [-147.5483, 61.1497],
    [-147.5572, 61.1468],
    [-147.5597, 61.1417],
    [-147.5692, 61.1338],
    [-147.5691, 61.1286],
    [-147.5651, 61.1234],
    [-147.5572, 61.1188],
    [-147.5571, 61.1096],
    [-147.5547, 61.1030],
    [-147.5508, 61.0991],
    [-147.5518, 61.0926],
    [-147.5543, 61.0828],
    [-147.5628, 61.0787],
    [-147.5696, 61.0705],
    [-147.5684, 61.0638],
    [-147.5792, 61.0553],
    [-147.5851, 61.0467],
    [-147.5887, 61.0402],
    [-147.5994, 61.0329],
    [-147.6018, 61.0284],
    [-147.6006, 61.0264],
    [-147.5903, 61.0208],
    [-147.5852, 61.0172],
    [-147.5978, 61.0118],
    [-147.5972, 61.0052],
    [-147.5993, 60.9978],
    [-147.6105, 60.9821],
    [-147.6221, 60.9663],
    [-147.6357, 60.9617],
    [-147.6414, 60.9593],
    [-147.6515, 60.9589],
    [-147.6630, 60.9582],
    [-147.6732, 60.9565],
    [-147.6692, 60.9494],
    [-147.6584, 60.9502],
    [-147.6499, 60.9522],
    [-147.6405, 60.9543],
    [-147.6313, 60.9558],
    [-147.6200, 60.9582],
    [-147.6141, 60.9618],
    [-147.6046, 60.9565],
    [-147.5947, 60.9546],
    [-147.5965, 60.9454],
    [-147.5922, 60.9422],
    [-147.5974, 60.9354],
    [-147.6041, 60.9311],
    [-147.6081, 60.9248],
    [-147.6039, 60.9206],
    [-147.6125, 60.9191],
    [-147.6039, 60.9145],
    [-147.5987, 60.9091],
    [-147.6003, 60.9050],
    [-147.5970, 60.9027],
    [-147.5978, 60.8991],
    [-147.5994, 60.8942],
    [-147.6070, 60.8922],
    [-147.6132, 60.8900],
    [-147.6233, 60.8911],
    [-147.6364, 60.8931],
    [-147.6360, 60.8910],
    [-147.6171, 60.8861],
    [-147.6075, 60.8866],
    [-147.5972, 60.8831],
    [-147.5906, 60.8830],
    [-147.5897, 60.8712],
    [-147.5992, 60.8703],
    [-147.5942, 60.8678],
    [-147.5927, 60.8659],
    [-147.5974, 60.8641],
    [-147.5979, 60.8612],
    [-147.5973, 60.8574],
    [-147.5972, 60.8542],
    [-147.6023, 60.8520],
    [-147.6062, 60.8490],
    [-147.6158, 60.8474],
    [-147.6293, 60.8451],
    [-147.6244, 60.8481],
    [-147.6256, 60.8488],
    [-147.6288, 60.8472],
    [-147.6361, 60.8444],
    [-147.6415, 60.8432],
    [-147.6454, 60.8424],
    [-147.6449, 60.8415],
    [-147.6472, 60.8420],
    [-147.6476, 60.8435],
    [-147.6465, 60.8446],
    [-147.6509, 60.8438],
    [-147.6565, 60.8417],
    [-147.6607, 60.8401],
    [-147.6650, 60.8385],
    [-147.6669, 60.8401],
    [-147.6686, 60.8423],
    [-147.6731, 60.8421],
    [-147.6723, 60.8439],
    [-147.6641, 60.8514],
    [-147.6656, 60.8533],
    [-147.6687, 60.8532],
    [-147.6774, 60.8553],
    [-147.6753, 60.8593],
    [-147.6779, 60.8627],
    [-147.6768, 60.8641],
    [-147.6731, 60.8651],
    [-147.6777, 60.8679],
    [-147.6824, 60.8711],
    [-147.6710, 60.8772],
    [-147.6628, 60.8746],
    [-147.6651, 60.8795],
    [-147.6665, 60.8838],
    [-147.6650, 60.8869],
    [-147.6599, 60.8909],
    [-147.6666, 60.8923],
    [-147.6684, 60.8920],
    [-147.6769, 60.8904],
    [-147.6796, 60.8888],
    [-147.6920, 60.8842],
    [-147.6984, 60.8771],
    [-147.7152, 60.8806],
    [-147.7388, 60.8893],
    [-147.7311, 60.8943],
    [-147.7206, 60.8993],
    [-147.7260, 60.9010],
    [-147.7318, 60.9084],
    [-147.7237, 60.9155],
    [-147.7286, 60.9190],
    [-147.7224, 60.9267],
    [-147.7165, 60.9334],
    [-147.7225, 60.9370],
    [-147.7291, 60.9340],
    [-147.7304, 60.9385],
    [-147.7374, 60.9382],
    [-147.7436, 60.9357],
    [-147.7539, 60.9311],
    [-147.7532, 60.9252],
    [-147.7530, 60.9190],
    [-147.7622, 60.9128],
    [-147.7676, 60.9175],
    [-147.7784, 60.9166],
    [-147.7971, 60.9158],
    [-147.7986, 60.9197],
    [-147.8094, 60.9165],
    [-147.8091, 60.9123],
    [-147.7961, 60.9113],
    [-147.7841, 60.9100],
    [-147.7765, 60.9065],
    [-147.7657, 60.9039],
    [-147.7741, 60.8904],
    [-147.7796, 60.8815],
    [-147.7904, 60.8713],
    [-147.8063, 60.8694],
    [-147.8111, 60.8660],
    [-147.8005, 60.8623],
    [-147.7976, 60.8568],
    [-147.7853, 60.8594],
    [-147.7723, 60.8576],
    [-147.7685, 60.8528],
    [-147.7578, 60.8475],
    [-147.7511, 60.8495],
    [-147.7448, 60.8483],
    [-147.7469, 60.8362],
    [-147.7468, 60.8329],
    [-147.7487, 60.8288],
    [-147.7376, 60.8284],
    [-147.7313, 60.8288],
    [-147.7322, 60.8234],
    [-147.7294, 60.8183],
    [-147.7471, 60.8118],
    [-147.7500, 60.8159],
    [-147.7480, 60.8219],
    [-147.7518, 60.8242],
    [-147.7541, 60.8277],
    [-147.7635, 60.8242],
    [-147.7602, 60.8207],
    [-147.7640, 60.8200],
    [-147.7675, 60.8150],
    [-147.7707, 60.8118],
    [-147.7722, 60.8109],
    [-147.7735, 60.8100],
    [-147.7768, 60.8090],
    [-147.7826, 60.8096],
    [-147.7846, 60.8110],
    [-147.7868, 60.8120],
    [-147.7906, 60.8114],
    [-147.7965, 60.8121],
    [-147.7952, 60.8130],
    [-147.7925, 60.8172],
    [-147.7958, 60.8180],
    [-147.8008, 60.8181],
    [-147.8035, 60.8174],
    [-147.8042, 60.8163],
    [-147.8065, 60.8167],
    [-147.8092, 60.8166],
    [-147.8094, 60.8170],
    [-147.8101, 60.8180],
    [-147.8126, 60.8183],
    [-147.8148, 60.8190],
    [-147.8169, 60.8179],
    [-147.8150, 60.8176],
    [-147.8171, 60.8162],
    [-147.8161, 60.8139],
    [-147.8178, 60.8134],
    [-147.8216, 60.8135],
    [-147.8235, 60.8127],
    [-147.8253, 60.8126],
    [-147.8258, 60.8132],
    [-147.8282, 60.8137],
    [-147.8283, 60.8145],
    [-147.8270, 60.8150],
    [-147.8277, 60.8154],
    [-147.8277, 60.8161],
    [-147.8314, 60.8155],
    [-147.8337, 60.8171],
    [-147.8330, 60.8191],
    [-147.8360, 60.8199],
    [-147.8364, 60.8226],
    [-147.8216, 60.8330],
    [-147.8182, 60.8376],
    [-147.8064, 60.8376],
    [-147.8076, 60.8410],
    [-147.8005, 60.8457],
    [-147.8110, 60.8468],
    [-147.8158, 60.8445],
    [-147.8376, 60.8381],
    [-147.8369, 60.8355],
    [-147.8445, 60.8279],
    [-147.8559, 60.8209],
    [-147.8654, 60.8231],
    [-147.8685, 60.8243],
    [-147.8673, 60.8258],
    [-147.8734, 60.8246],
    [-147.8774, 60.8251],
    [-147.8905, 60.8354],
    [-147.9119, 60.8509],
    [-147.9096, 60.8701],
    [-147.9187, 60.8829],
    [-147.9250, 60.8887],
    [-147.9369, 60.8879],
    [-147.9295, 60.8752],
    [-147.9343, 60.8674],
    [-147.9476, 60.8521],
    [-147.9338, 60.8426],
    [-147.9140, 60.8231],
    [-147.9179, 60.8105],
    [-147.9288, 60.8075],
    [-147.9500, 60.8035],
    [-147.9647, 60.8026],
    [-147.9681, 60.8089],
    [-147.9828, 60.8210],
    [-147.9866, 60.8062],
    [-147.9907, 60.7920],
    [-148.0165, 60.7871],
    [-148.0322, 60.7823],
    [-148.0443, 60.7840],
    [-148.0565, 60.7862],
    [-148.0700, 60.7887],
    [-148.0838, 60.7858],
    [-148.0990, 60.7854],
    [-148.1294, 60.7897],
    [-148.1444, 60.7971],
    [-148.1411, 60.8130],
    [-148.1516, 60.8181],
    [-148.1347, 60.8343],
    [-148.1242, 60.8476],
    [-148.1268, 60.8585],
    [-148.1199, 60.8743],
    [-148.1045, 60.8876],
    [-148.1069, 60.9005],
    [-148.1054, 60.9076],
    [-148.0935, 60.9154],
    [-148.0776, 60.9228],
    [-148.0712, 60.9280],
    [-148.0648, 60.9369],
    [-148.0453, 60.9508],
    [-148.0156, 60.9716],
    [-147.9978, 60.9784],
    [-147.9899, 60.9882],
    [-147.9714, 60.9967],
    [-147.9512, 61.0114],
    [-147.9498, 61.0202],
    [-147.9445, 61.0336],
    [-147.9342, 61.0502],
    [-147.9120, 61.0619],
    [-147.9091, 61.0690],
    [-147.9224, 61.0727],
    [-147.9341, 61.0721],
    [-147.9498, 61.0679],
    [-147.9329, 61.0793],
    [-147.9079, 61.0895],
    [-147.8901, 61.1032],
    [-147.8597, 61.1199],
    [-147.8364, 61.1389],
    [-147.8167, 61.1518],
    [-147.7953, 61.1618],
    [-147.7779, 61.1737],
    [-147.7635, 61.1855],
    [-147.7225, 61.1951],
    [-147.6859, 61.2012],
    [-147.6648, 61.2112],
    [-147.6222, 61.2262],
    [-147.6282, 61.2331],
    [-147.6584, 61.2238],
    [-147.6783, 61.2224],
    [-147.6942, 61.2255],
    [-147.7240, 61.2176],
    [-147.7520, 61.2069],
    [-147.7608, 61.2116],
    [-147.7404, 61.2251],
    [-147.7330, 61.2370],
    [-147.7158, 61.2497],
    [-147.6971, 61.2634],
    [-147.7125, 61.2696],
    [-147.7306, 61.2738],
    [-147.7413, 61.2665],
    [-147.7544, 61.2578],
    [-147.7686, 61.2473],
    [-147.7848, 61.2408],
    [-147.8117, 61.2265],
    [-147.8114, 61.2186],
    [-147.8192, 61.2055],
    [-147.8464, 61.1916],
    [-147.8566, 61.1844],
    [-147.8742, 61.1738],
    [-147.8865, 61.1592],
    [-147.9051, 61.1512],
    [-147.9138, 61.1402],
    [-147.9324, 61.1346],
    [-147.9474, 61.1252],
    [-147.9759, 61.1088],
    [-147.9828, 61.0978],
    [-147.9980, 61.0901],
    [-147.9980, 61.0817],
    [-148.0003, 61.0751],
    [-148.0013, 61.0641],
    [-148.0046, 61.0528],
    [-148.0223, 61.0401],
    [-148.0498, 61.0224],
    [-148.0681, 61.0088],
    [-148.0726, 61.0061],
    [-148.0924, 61.0111],
    [-148.0997, 61.0205],
    [-148.1083, 61.0368],
    [-148.1211, 61.0440],
    [-148.1223, 61.0579],
    [-148.1251, 61.0707],
    [-148.1418, 61.0789],
    [-148.1475, 61.0916],
    [-148.1368, 61.1138],
    [-148.1361, 61.1224],
    [-148.1454, 61.1252],
    [-148.1663, 61.1140],
    [-148.1786, 61.1151],
    [-148.1810, 61.1021],
    [-148.1910, 61.0917],
    [-148.2031, 61.0833],
    [-148.2293, 61.0899],
    [-148.2647, 61.0840],
    [-148.2808, 61.0788],
    [-148.2984, 61.0794],
    [-148.3010, 61.0718],
    [-148.3039, 61.0645],
    [-148.3250, 61.0663],
    [-148.3355, 61.0571],
    [-148.3631, 61.0584],
    [-148.3914, 61.0579],
    [-148.4089, 61.0511],
    [-148.3911, 61.0456],
    [-148.3733, 61.0433],
    [-148.3575, 61.0351],
    [-148.3655, 61.0324],
    [-148.3754, 61.0222],
    [-148.3773, 61.0141],
    [-148.4218, 60.9914],
    [-148.4413, 60.9837],
    [-148.4363, 60.9746],
    [-148.4187, 60.9705],
    [-148.4035, 60.9769],
    [-148.3742, 60.9858],
    [-148.3597, 60.9978],
    [-148.3450, 61.0084],
    [-148.3329, 61.0186],
    [-148.3272, 61.0266],
    [-148.3041, 61.0392],
    [-148.2869, 61.0469],
    [-148.2675, 61.0502],
    [-148.2508, 61.0560],
    [-148.2345, 61.0587],
    [-148.1965, 61.0637],
    [-148.1649, 61.0702],
    [-148.1736, 61.0588],
    [-148.1670, 61.0547],
    [-148.1668, 61.0459],
    [-148.1653, 61.0408],
    [-148.1720, 61.0260],
    [-148.1829, 61.0098],
    [-148.1776, 60.9996],
    [-148.1839, 60.9914],
    [-148.1958, 60.9857],
    [-148.2000, 60.9740],
    [-148.1955, 60.9679],
    [-148.2186, 60.9519],
    [-148.2219, 60.9593],
    [-148.2343, 60.9602],
    [-148.2364, 60.9525],
    [-148.2338, 60.9418],
    [-148.2518, 60.9354],
    [-148.2680, 60.9432],
    [-148.2851, 60.9497],
    [-148.3013, 60.9558],
    [-148.3146, 60.9541],
    [-148.3163, 60.9474],
    [-148.3003, 60.9408],
    [-148.2953, 60.9344],
    [-148.2932, 60.9228],
    [-148.2797, 60.9182],
    [-148.2654, 60.9143],
    [-148.2735, 60.9035],
    [-148.2818, 60.8952],
    [-148.2894, 60.8897],
    [-148.2932, 60.8761],
    [-148.3044, 60.8703],
    [-148.3027, 60.8638],
    [-148.2901, 60.8631],
    [-148.3063, 60.8350],
    [-148.3252, 60.8367],
    [-148.3322, 60.8409],
    [-148.3374, 60.8463],
    [-148.3569, 60.8520],
    [-148.3689, 60.8520],
    [-148.3733, 60.8588],
    [-148.3864, 60.8559],
    [-148.3987, 60.8485],
    [-148.3937, 60.8387],
    [-148.3410, 60.8216],
    [-148.3384, 60.8131],
    [-148.3472, 60.8030],
    [-148.3596, 60.8035],
    [-148.3589, 60.8059],
    [-148.3620, 60.8065],
    [-148.3672, 60.8033],
    [-148.3800, 60.8040],
    [-148.3940, 60.8118],
    [-148.4052, 60.8168],
    [-148.4224, 60.8252],
    [-148.4368, 60.8298],
    [-148.4591, 60.8316],
    [-148.4819, 60.8283],
    [-148.5045, 60.8336],
    [-148.5150, 60.8328],
    [-148.5145, 60.8256],
    [-148.5516, 60.8213],
    [-148.5701, 60.8251],
    [-148.6003, 60.8260],
    [-148.6162, 60.8196],
    [-148.6219, 60.8134],
    [-148.6407, 60.8098],
    [-148.6604, 60.8037],
    [-148.7046, 60.7904],
    [-148.7184, 60.7861],
    [-148.7146, 60.7752],
    [-148.6854, 60.7781],
    [-148.6659, 60.7778],
    [-148.6397, 60.7856],
    [-148.6105, 60.7926],
    [-148.5825, 60.8030],
    [-148.5522, 60.8057],
    [-148.5623, 60.7930],
    [-148.5668, 60.7833],
    [-148.5532, 60.7905],
    [-148.5378, 60.7936],
    [-148.5290, 60.8000],
    [-148.5081, 60.8038],
    [-148.4881, 60.8057],
    [-148.4804, 60.8073],
    [-148.4622, 60.8068],
    [-148.4524, 60.7998],
    [-148.4551, 60.7955],
    [-148.4511, 60.7920],
    [-148.4571, 60.7867],
    [-148.4853, 60.7806],
    [-148.4961, 60.7800],
    [-148.5111, 60.7808],
    [-148.5249, 60.7838],
    [-148.5485, 60.7782],
    [-148.5672, 60.7715],
    [-148.5920, 60.7626],
    [-148.6114, 60.7554],
    [-148.6260, 60.7470],
    [-148.6385, 60.7379],
    [-148.6571, 60.7248],
    [-148.6737, 60.7163],
    [-148.6792, 60.7019],
    [-148.6830, 60.6902],
    [-148.6787, 60.6831],
    [-148.6571, 60.6933],
    [-148.6538, 60.7024],
    [-148.6407, 60.7140],
    [-148.6243, 60.7232],
    [-148.6217, 60.7153],
    [-148.6300, 60.7057],
    [-148.6514, 60.6876],
    [-148.6571, 60.6803],
    [-148.6621, 60.6805],
    [-148.6742, 60.6818],
    [-148.6989, 60.6714],
    [-148.7118, 60.6602],
    [-148.7041, 60.6587],
    [-148.6799, 60.6681],
    [-148.6801, 60.6584],
    [-148.6870, 60.6466],
    [-148.6773, 60.6517],
    [-148.6609, 60.6636],
    [-148.5913, 60.7113],
    [-148.5816, 60.7254],
    [-148.5731, 60.7363],
    [-148.5636, 60.7398],
    [-148.5537, 60.7427],
    [-148.5398, 60.7499],
    [-148.5254, 60.7561],
    [-148.5240, 60.7642],
    [-148.5056, 60.7685],
    [-148.4816, 60.7649],
    [-148.4721, 60.7600],
    [-148.4681, 60.7544],
    [-148.4496, 60.7525],
    [-148.4439, 60.7584],
    [-148.4458, 60.7617],
    [-148.4403, 60.7654],
    [-148.4359, 60.7693],
    [-148.4233, 60.7725],
    [-148.4006, 60.7786],
    [-148.3931, 60.7772],
    [-148.3820, 60.7758],
    [-148.3757, 60.7713],
    [-148.3665, 60.7666],
    [-148.3659, 60.7640],
    [-148.3765, 60.7576],
    [-148.3703, 60.7511],
    [-148.3660, 60.7452],
    [-148.3645, 60.7424],
    [-148.3646, 60.7369],
    [-148.3735, 60.7287],
    [-148.3923, 60.7210],
    [-148.4002, 60.7166],
    [-148.4006, 60.7093],
    [-148.3947, 60.7073],
    [-148.3936, 60.7004],
    [-148.3999, 60.6963],
    [-148.3983, 60.6933],
    [-148.3924, 60.6919],
    [-148.3848, 60.6912],
    [-148.3867, 60.6859],
    [-148.3840, 60.6839],
    [-148.3858, 60.6802],
    [-148.3901, 60.6784],
    [-148.3984, 60.6766],
    [-148.3952, 60.6721],
    [-148.4041, 60.6664],
    [-148.4141, 60.6618],
    [-148.4381, 60.6538],
    [-148.4494, 60.6517],
    [-148.4387, 60.6459],
    [-148.4300, 60.6414],
    [-148.4225, 60.6382],
    [-148.4292, 60.6304],
    [-148.4300, 60.6271],
    [-148.4257, 60.6272],
    [-148.4295, 60.6209],
    [-148.4318, 60.6160],
    [-148.4266, 60.6157],
    [-148.4181, 60.6219],
    [-148.4137, 60.6265],
    [-148.4105, 60.6357],
    [-148.3975, 60.6453],
    [-148.3828, 60.6539],
    [-148.3656, 60.6538],
    [-148.3525, 60.6601],
    [-148.3619, 60.6709],
    [-148.3513, 60.6823],
    [-148.3428, 60.6940],
    [-148.3264, 60.7095],
    [-148.3182, 60.7168],
    [-148.3000, 60.7231],
    [-148.2915, 60.7382],
    [-148.2801, 60.7533],
    [-148.2593, 60.7580],
    [-148.2528, 60.7578],
    [-148.2298, 60.7641],
    [-148.2155, 60.7560],
    [-148.1935, 60.7600],
    [-148.1760, 60.7581],
    [-148.1462, 60.7573],
    [-148.1359, 60.7510],
    [-148.1286, 60.7471],
    [-148.1123, 60.7468],
    [-148.1078, 60.7414],
    [-148.1013, 60.7245],
    [-148.0994, 60.7149],
    [-148.1085, 60.7116],
    [-148.1054, 60.7033],
    [-148.0976, 60.6962],
    [-148.0988, 60.6863],
    [-148.0908, 60.6801],
    [-148.0899, 60.6720],
    [-148.0889, 60.6649],
    [-148.1075, 60.6530],
    [-148.1173, 60.6450],
    [-148.1312, 60.6382],
    [-148.1546, 60.6356],
    [-148.1386, 60.6302],
    [-148.1385, 60.6221],
    [-148.1532, 60.6164],
    [-148.1959, 60.6065],
    [-148.2077, 60.6011],
    [-148.2171, 60.5993],
    [-148.2293, 60.5938],
    [-148.2451, 60.5883],
    [-148.2549, 60.5827],
    [-148.2678, 60.5839],
    [-148.2780, 60.5703],
    [-148.2905, 60.5644],
    [-148.2926, 60.5673],
    [-148.2984, 60.5641],
    [-148.2990, 60.5531],
    [-148.3088, 60.5459],
    [-148.3127, 60.5433],
    [-148.3167, 60.5360],
    [-148.3250, 60.5338],
    [-148.3228, 60.5313],
    [-148.3286, 60.5260],
    [-148.3329, 60.5299],
    [-148.3391, 60.5305],
    [-148.3594, 60.5339],
    [-148.3603, 60.5390],
    [-148.3739, 60.5440],
    [-148.3828, 60.5404],
    [-148.4085, 60.5458],
    [-148.4151, 60.5530],
    [-148.4225, 60.5559],
    [-148.4281, 60.5582],
    [-148.4366, 60.5605],
    [-148.4377, 60.5680],
    [-148.4284, 60.5723],
    [-148.4340, 60.5769],
    [-148.4450, 60.5731],
    [-148.4494, 60.5691],
    [-148.4571, 60.5690],
    [-148.4762, 60.5714],
    [-148.4917, 60.5707],
    [-148.5151, 60.5661],
    [-148.5291, 60.5612],
    [-148.5382, 60.5588],
    [-148.5457, 60.5546],
    [-148.5544, 60.5526],
    [-148.5608, 60.5490],
    [-148.5708, 60.5432],
    [-148.5978, 60.5318],
    [-148.6362, 60.5115],
    [-148.6407, 60.5049],
    [-148.6497, 60.5033],
    [-148.6571, 60.4964],
    [-148.6671, 60.4855],
    [-148.6860, 60.4762],
    [-148.6973, 60.4689],
    [-148.7069, 60.4645],
    [-148.7159, 60.4596],
    [-148.7121, 60.4543],
    [-148.7030, 60.4462],
    [-148.7060, 60.4433],
    [-148.6950, 60.4416],
    [-148.6861, 60.4412],
    [-148.6723, 60.4454],
    [-148.6675, 60.4499],
    [-148.6649, 60.4559],
    [-148.6642, 60.4588],
    [-148.6563, 60.4619],
    [-148.6542, 60.4589],
    [-148.6435, 60.4592],
    [-148.6351, 60.4625],
    [-148.6280, 60.4659],
    [-148.6242, 60.4697],
    [-148.6192, 60.4731],
    [-148.6153, 60.4772],
    [-148.6027, 60.4837],
    [-148.5948, 60.4888],
    [-148.5853, 60.4909],
    [-148.5813, 60.4935],
    [-148.5768, 60.4995],
    [-148.5625, 60.5082],
    [-148.5561, 60.5069],
    [-148.5405, 60.5106],
    [-148.5249, 60.5146],
    [-148.5129, 60.5186],
    [-148.5050, 60.5234],
    [-148.4933, 60.5274],
    [-148.4795, 60.5334],
    [-148.4661, 60.5389],
    [-148.4541, 60.5457],
    [-148.4464, 60.5415],
    [-148.4379, 60.5353],
    [-148.4302, 60.5291],
    [-148.4416, 60.5235],
    [-148.4343, 60.5214],
    [-148.4393, 60.5172],
    [-148.4218, 60.5181],
    [-148.4073, 60.5208],
    [-148.3841, 60.5191],
    [-148.3826, 60.5119],
    [-148.3675, 60.5118],
    [-148.3740, 60.5069],
    [-148.3750, 60.5028],
    [-148.3807, 60.5008],
    [-148.3898, 60.4981],
    [-148.4054, 60.4981],
    [-148.4007, 60.4950],
    [-148.3937, 60.4911],
    [-148.3738, 60.4931],
    [-148.3643, 60.4909],
    [-148.3634, 60.4954],
    [-148.3567, 60.4945],
    [-148.3578, 60.4980],
    [-148.3586, 60.5025],
    [-148.3493, 60.5044],
    [-148.3267, 60.4984],
    [-148.3324, 60.4927],
    [-148.3462, 60.4861],
    [-148.3564, 60.4852],
    [-148.3601, 60.4821],
    [-148.3533, 60.4805],
    [-148.3592, 60.4781],
    [-148.3549, 60.4742],
    [-148.3414, 60.4737],
    [-148.3269, 60.4769],
    [-148.3102, 60.4804],
    [-148.3026, 60.4839],
    [-148.2900, 60.4825],
    [-148.2851, 60.4826],
    [-148.2736, 60.4894],
    [-148.2672, 60.4858],
    [-148.2669, 60.4781],
    [-148.2667, 60.4690],
    [-148.2617, 60.4648],
    [-148.2646, 60.4525],
    [-148.2732, 60.4437],
    [-148.2843, 60.4376],
    [-148.2892, 60.4339],
    [-148.2786, 60.4317],
    [-148.2706, 60.4367],
    [-148.2594, 60.4411],
    [-148.2507, 60.4452],
    [-148.2423, 60.4502],
    [-148.2379, 60.4573],
    [-148.2351, 60.4652],
    [-148.2309, 60.4693],
    [-148.2350, 60.4733],
    [-148.2348, 60.4810],
    [-148.2392, 60.4872],
    [-148.2485, 60.4923],
    [-148.2470, 60.5014],
    [-148.2523, 60.5077],
    [-148.2444, 60.5190],
    [-148.2306, 60.5203],
    [-148.2276, 60.5269],
    [-148.2221, 60.5287],
    [-148.2148, 60.5344],
    [-148.2036, 60.5425],
    [-148.1968, 60.5549],
    [-148.1873, 60.5597],
    [-148.1862, 60.5454],
    [-148.1822, 60.5359],
    [-148.1816, 60.5215],
    [-148.1821, 60.5122],
    [-148.1841, 60.5077],
    [-148.1796, 60.5015],
    [-148.1763, 60.4981],
    [-148.1669, 60.5017],
    [-148.1622, 60.4991],
    [-148.1580, 60.5019],
    [-148.1605, 60.5072],
    [-148.1640, 60.5145],
    [-148.1669, 60.5229],
    [-148.1682, 60.5280],
    [-148.1675, 60.5364],
    [-148.1684, 60.5455],
    [-148.1641, 60.5528],
    [-148.1650, 60.5565],
    [-148.1633, 60.5637],
    [-148.1584, 60.5702],
    [-148.1495, 60.5808],
    [-148.1355, 60.5838],
    [-148.1230, 60.5809],
    [-148.1218, 60.5858],
    [-148.1147, 60.5859],
    [-148.1165, 60.5873],
    [-148.1142, 60.5923],
    [-148.1027, 60.5980],
    [-148.0931, 60.5944],
    [-148.0865, 60.5974],
    [-148.0787, 60.5884],
    [-148.0785, 60.5822],
    [-148.0729, 60.5807],
    [-148.0706, 60.5752],
    [-148.0728, 60.5724],
    [-148.0691, 60.5669],
    [-148.0719, 60.5629],
    [-148.0646, 60.5657],
    [-148.0543, 60.5701],
    [-148.0454, 60.5671],
    [-148.0389, 60.5590],
    [-148.0390, 60.5559],
    [-148.0414, 60.5585],
    [-148.0482, 60.5565],
    [-148.0561, 60.5539],
    [-148.0660, 60.5484],
    [-148.0716, 60.5460],
    [-148.0792, 60.5452],
    [-148.0781, 60.5393],
    [-148.0862, 60.5345],
    [-148.0932, 60.5274],
    [-148.0951, 60.5214],
    [-148.0914, 60.5226],
    [-148.0832, 60.5265],
    [-148.0719, 60.5287],
    [-148.0673, 60.5322],
    [-148.0651, 60.5274],
    [-148.0531, 60.5338],
    [-148.0457, 60.5421],
    [-148.0310, 60.5464],
    [-148.0252, 60.5416],
    [-148.0209, 60.5390],
    [-148.0089, 60.5374],
    [-148.0010, 60.5348],
    [-147.9997, 60.5283],
    [-148.0085, 60.5284],
    [-148.0120, 60.5268],
    [-148.0148, 60.5236],
    [-148.0129, 60.5170],
    [-147.9954, 60.5150],
    [-147.9831, 60.5184],
    [-147.9778, 60.5180],
    [-147.9715, 60.5112],
    [-147.9627, 60.5045],
    [-147.9628, 60.5001],
    [-147.9669, 60.4962],
    [-147.9734, 60.4906],
    [-147.9738, 60.4878],
    [-147.9729, 60.4821],
    [-147.9816, 60.4792],
    [-147.9842, 60.4748],
    [-147.9941, 60.4746],
    [-147.9988, 60.4709],
    [-148.0064, 60.4693],
    [-148.0082, 60.4634],
    [-148.0050, 60.4577],
    [-147.9937, 60.4588],
    [-147.9873, 60.4595],
    [-147.9879, 60.4552],
    [-147.9943, 60.4530],
    [-147.9995, 60.4500],
    [-148.0016, 60.4434],
    [-147.9971, 60.4453],
    [-147.9727, 60.4495],
    [-147.9681, 60.4514],
    [-147.9691, 60.4527],
    [-147.9741, 60.4561],
    [-147.9695, 60.4625],
    [-147.9647, 60.4665],
    [-147.9556, 60.4628],
    [-147.9451, 60.4493],
    [-147.9380, 60.4434],
    [-147.9371, 60.4368],
    [-147.9463, 60.4351],
    [-147.9477, 60.4310],
    [-147.9519, 60.4278],
    [-147.9532, 60.4234],
    [-147.9593, 60.4182],
    [-147.9654, 60.4155],
    [-147.9678, 60.4205],
    [-147.9713, 60.4186],
    [-147.9869, 60.4169],
    [-147.9862, 60.4106],
    [-147.9957, 60.4111],
    [-148.0041, 60.4048],
    [-148.0183, 60.3986],
    [-148.0250, 60.3956],
    [-148.0314, 60.3923],
    [-148.0429, 60.3921],
    [-148.0533, 60.3899],
    [-148.0674, 60.3838],
    [-148.0659, 60.3890],
    [-148.0779, 60.3907],
    [-148.0827, 60.3811],
    [-148.0982, 60.3716],
    [-148.1040, 60.3762],
    [-148.1114, 60.3784],
    [-148.1229, 60.3814],
    [-148.1254, 60.3853],
    [-148.1318, 60.3892],
    [-148.1387, 60.3926],
    [-148.1493, 60.3888],
    [-148.1553, 60.3892],
    [-148.1533, 60.3855],
    [-148.1455, 60.3799],
    [-148.1379, 60.3762],
    [-148.1362, 60.3686],
    [-148.1281, 60.3627],
    [-148.1274, 60.3560],
    [-148.1367, 60.3479],
    [-148.1501, 60.3437],
    [-148.1628, 60.3387],
    [-148.1692, 60.3357],
    [-148.1812, 60.3359],
    [-148.1922, 60.3365],
    [-148.1960, 60.3434],
    [-148.2045, 60.3440],
    [-148.2195, 60.3453],
    [-148.2187, 60.3373],
    [-148.2111, 60.3274],
    [-148.2117, 60.3141],
    [-148.2093, 60.3003],
    [-148.2219, 60.2958],
    [-148.2314, 60.2920],
    [-148.2394, 60.2868],
    [-148.2422, 60.2838],
    [-148.2554, 60.2799],
    [-148.2695, 60.2751],
    [-148.2807, 60.2707],
    [-148.2896, 60.2717],
    [-148.2905, 60.2675],
    [-148.3021, 60.2603],
    [-148.3107, 60.2621],
    [-148.3151, 60.2631],
    [-148.3224, 60.2611],
    [-148.3264, 60.2581],
    [-148.3146, 60.2526],
    [-148.3106, 60.2485],
    [-148.3304, 60.2456],
    [-148.3397, 60.2506],
    [-148.3447, 60.2569],
    [-148.3399, 60.2683],
    [-148.3411, 60.2782],
    [-148.3451, 60.2865],
    [-148.3549, 60.2848],
    [-148.3748, 60.2851],
    [-148.3929, 60.2799],
    [-148.4148, 60.2675],
    [-148.3972, 60.2614],
    [-148.3782, 60.2611],
    [-148.3641, 60.2525],
    [-148.3573, 60.2385],
    [-148.3454, 60.2344],
    [-148.3429, 60.2314],
    [-148.3521, 60.2263],
    [-148.3624, 60.2190],
    [-148.3748, 60.2132],
    [-148.3861, 60.2066],
    [-148.4022, 60.2004],
    [-148.4128, 60.1959],
    [-148.4219, 60.1927],
    [-148.4245, 60.1899],
    [-148.4488, 60.1840],
    [-148.4541, 60.1795],
    [-148.4467, 60.1777],
    [-148.4255, 60.1818],
    [-148.4084, 60.1861],
    [-148.3999, 60.1910],
    [-148.3872, 60.1963],
    [-148.3777, 60.2026],
    [-148.3685, 60.2062],
    [-148.3646, 60.2006],
    [-148.3570, 60.1970],
    [-148.3539, 60.1945],
    [-148.3454, 60.1990],
    [-148.3456, 60.2021],
    [-148.3456, 60.2054],
    [-148.3394, 60.2070],
    [-148.3362, 60.2129],
    [-148.3324, 60.2178],
    [-148.3331, 60.2129],
    [-148.3275, 60.2133],
    [-148.3221, 60.2158],
    [-148.3178, 60.2208],
    [-148.3119, 60.2224],
    [-148.3021, 60.2292],
    [-148.2933, 60.2338],
    [-148.2888, 60.2361],
    [-148.2843, 60.2411],
    [-148.2787, 60.2473],
    [-148.2644, 60.2506],
    [-148.2567, 60.2508],
    [-148.2539, 60.2519],
    [-148.2470, 60.2522],
    [-148.2387, 60.2538],
    [-148.2341, 60.2569],
    [-148.2306, 60.2579],
    [-148.2208, 60.2577],
    [-148.2118, 60.2603],
    [-148.1885, 60.2519],
    [-148.1830, 60.2475],
    [-148.1880, 60.2425],
    [-148.1933, 60.2379],
    [-148.2050, 60.2348],
    [-148.2105, 60.2364],
    [-148.2198, 60.2350],
    [-148.2289, 60.2358],
    [-148.2397, 60.2351],
    [-148.2466, 60.2371],
    [-148.2539, 60.2376],
    [-148.2608, 60.2336],
    [-148.2523, 60.2325],
    [-148.2454, 60.2325],
    [-148.2497, 60.2267],
    [-148.2586, 60.2275],
    [-148.2619, 60.2257],
    [-148.2684, 60.2211],
    [-148.2766, 60.2175],
    [-148.2845, 60.2155],
    [-148.2921, 60.2119],
    [-148.2926, 60.2075],
    [-148.2877, 60.2041],
    [-148.2835, 60.2093],
    [-148.2758, 60.2089],
    [-148.2623, 60.2153],
    [-148.2480, 60.2220],
    [-148.2342, 60.2237],
    [-148.2175, 60.2196],
    [-148.2070, 60.2190],
    [-148.2095, 60.2145],
    [-148.2026, 60.2114],
    [-148.1955, 60.2125],
    [-148.1877, 60.2137],
    [-148.1870, 60.2053],
    [-148.1923, 60.1971],
    [-148.1968, 60.1862],
    [-148.2010, 60.1777],
    [-148.2064, 60.1696],
    [-148.2114, 60.1627],
    [-148.2173, 60.1591],
    [-148.2150, 60.1530],
    [-148.2163, 60.1472],
    [-148.2075, 60.1453],
    [-148.2015, 60.1489],
    [-148.1958, 60.1534],
    [-148.1933, 60.1595],
    [-148.1837, 60.1667],
    [-148.1759, 60.1717],
    [-148.1721, 60.1741],
    [-148.1807, 60.1764],
    [-148.1732, 60.1868],
    [-148.1640, 60.1965],
    [-148.1643, 60.2016],
    [-148.1609, 60.2040],
    [-148.1511, 60.2060],
    [-148.1511, 60.2093],
    [-148.1526, 60.2114],
    [-148.1542, 60.2203],
    [-148.1501, 60.2338],
    [-148.1378, 60.2401],
    [-148.1217, 60.2301],
    [-148.1222, 60.2223],
    [-148.1160, 60.2240],
    [-148.1166, 60.2200],
    [-148.1072, 60.2213],
    [-148.0970, 60.2192],
    [-148.0937, 60.2087],
    [-148.0985, 60.2081],
    [-148.1032, 60.2057],
    [-148.1075, 60.2043],
    [-148.1080, 60.1997],
    [-148.1125, 60.1953],
    [-148.1143, 60.1910],
    [-148.1287, 60.1872],
    [-148.1298, 60.1835],
    [-148.1230, 60.1771],
    [-148.1291, 60.1703],
    [-148.1259, 60.1696],
    [-148.1208, 60.1673],
    [-148.1324, 60.1650],
    [-148.1381, 60.1616],
    [-148.1284, 60.1533],
    [-148.1189, 60.1540],
    [-148.1138, 60.1514],
    [-148.1215, 60.1372],
    [-148.1160, 60.1318],
    [-148.1079, 60.1381],
    [-148.1051, 60.1436],
    [-148.1014, 60.1366],
    [-148.0932, 60.1375],
    [-148.0909, 60.1410],
    [-148.0883, 60.1529],
    [-148.0899, 60.1573],
    [-148.0863, 60.1618],
    [-148.0819, 60.1694],
    [-148.0829, 60.1753],
    [-148.0815, 60.1849],
    [-148.0775, 60.1911],
    [-148.0666, 60.1928],
    [-148.0655, 60.1968],
    [-148.0613, 60.1992],
    [-148.0506, 60.2013],
    [-148.0439, 60.1927],
    [-148.0425, 60.1820],
    [-148.0475, 60.1780],
    [-148.0494, 60.1731],
    [-148.0525, 60.1701],
    [-148.0541, 60.1657],
    [-148.0589, 60.1622],
    [-148.0662, 60.1551],
    [-148.0617, 60.1497],
    [-148.0684, 60.1455],
    [-148.0744, 60.1433],
    [-148.0755, 60.1372],
    [-148.0866, 60.1282],
    [-148.0960, 60.1183],
    [-148.0970, 60.1123],
    [-148.0894, 60.1098],
    [-148.0848, 60.1105],
    [-148.0880, 60.1055],
    [-148.0910, 60.0999],
    [-148.1017, 60.0932],
    [-148.1091, 60.0850],
    [-148.1098, 60.0823],
    [-148.1173, 60.0779],
    [-148.1193, 60.0742],
    [-148.1315, 60.0654],
    [-148.1371, 60.0600],
    [-148.1427, 60.0558],
    [-148.1427, 60.0517],
    [-148.1385, 60.0463],
    [-148.1443, 60.0397],
    [-148.1504, 60.0353],
    [-148.1611, 60.0312],
    [-148.1743, 60.0261],
    [-148.1809, 60.0225],
    [-148.1866, 60.0214],
    [-148.1949, 60.0223],
    [-148.1962, 60.0188],
    [-148.2065, 60.0171],
    [-148.2128, 60.0162],
    [-148.2229, 60.0153],
    [-148.2371, 60.0124],
    [-148.2485, 60.0150],
    [-148.2586, 60.0129],
    [-148.2657, 60.0112],
    [-148.2743, 60.0179],
    [-148.2878, 60.0197],
    [-148.2963, 60.0193],
    [-148.2979, 60.0226],
    [-148.3050, 60.0252],
    [-148.3138, 60.0265],
    [-148.3140, 60.0339],
    [-148.3002, 60.0310],
    [-148.2801, 60.0302],
    [-148.2693, 60.0298],
    [-148.2592, 60.0295],
    [-148.2397, 60.0316],
    [-148.2213, 60.0347],
    [-148.1996, 60.0356],
    [-148.1898, 60.0365],
    [-148.1886, 60.0388],
    [-148.1922, 60.0404],
    [-148.2075, 60.0413],
    [-148.2171, 60.0420],
    [-148.2210, 60.0447],
    [-148.2347, 60.0438],
    [-148.2490, 60.0432],
    [-148.2550, 60.0440],
    [-148.2681, 60.0406],
    [-148.2744, 60.0415],
    [-148.2832, 60.0419],
    [-148.2869, 60.0423],
    [-148.2952, 60.0442],
    [-148.3029, 60.0475],
    [-148.3018, 60.0539],
    [-148.2896, 60.0578],
    [-148.2838, 60.0601],
    [-148.2739, 60.0586],
    [-148.2654, 60.0622],
    [-148.2602, 60.0651],
    [-148.2375, 60.0624],
    [-148.2152, 60.0619],
    [-148.2034, 60.0645],
    [-148.1949, 60.0654],
    [-148.1868, 60.0686],
    [-148.1854, 60.0712],
    [-148.1939, 60.0727],
    [-148.1995, 60.0734],
    [-148.1936, 60.0763],
    [-148.1980, 60.0816],
    [-148.2093, 60.0796],
    [-148.2238, 60.0769],
    [-148.2320, 60.0790],
    [-148.2374, 60.0846],
    [-148.2446, 60.0869],
    [-148.2475, 60.0833],
    [-148.2626, 60.0854],
    [-148.2740, 60.0848],
    [-148.2878, 60.0862],
    [-148.2942, 60.0922],
    [-148.2925, 60.1028],
    [-148.2956, 60.1123],
    [-148.3016, 60.1156],
    [-148.3031, 60.1214],
    [-148.2933, 60.1294],
    [-148.2919, 60.1335],
    [-148.2948, 60.1353],
    [-148.2925, 60.1401],
    [-148.2921, 60.1525],
    [-148.2885, 60.1599],
    [-148.2802, 60.1643],
    [-148.2856, 60.1672],
    [-148.3004, 60.1627],
    [-148.3128, 60.1602],
    [-148.3134, 60.1644],
    [-148.3216, 60.1650],
    [-148.3339, 60.1628],
    [-148.3308, 60.1700],
    [-148.3364, 60.1749],
    [-148.3463, 60.1684],
    [-148.3481, 60.1636],
    [-148.3418, 60.1618],
    [-148.3469, 60.1550],
    [-148.3472, 60.1501],
    [-148.3512, 60.1530],
    [-148.3548, 60.1570],
    [-148.3597, 60.1527],
    [-148.3564, 60.1480],
    [-148.3488, 60.1396],
    [-148.3469, 60.1369],
    [-148.3547, 60.1366],
    [-148.3613, 60.1332],
    [-148.3728, 60.1282],
    [-148.3642, 60.1189],
    [-148.3774, 60.1167],
    [-148.3867, 60.1089],
    [-148.3848, 60.0995],
    [-148.3815, 60.0964],
    [-148.3702, 60.0907],
    [-148.3661, 60.0848],
    [-148.3784, 60.0840],
    [-148.3821, 60.0808],
    [-148.3800, 60.0783],
    [-148.3713, 60.0773],
    [-148.3742, 60.0740],
    [-148.3773, 60.0695],
    [-148.3797, 60.0627],
    [-148.3880, 60.0608],
    [-148.3979, 60.0588],
    [-148.3996, 60.0538],
    [-148.3944, 60.0500],
    [-148.3996, 60.0456],
    [-148.3974, 60.0403],
    [-148.4032, 60.0340],
    [-148.4020, 60.0300],
    [-148.4100, 60.0284],
    [-148.4248, 60.0280],
    [-148.4330, 60.0282],
    [-148.4378, 60.0283],
    [-148.4418, 60.0277],
    [-148.4479, 60.0266],
    [-148.4430, 60.0230],
    [-148.4238, 60.0184],
    [-148.4146, 60.0150],
    [-148.4133, 60.0100],
    [-148.4008, 60.0093],
    [-148.3996, 60.0058],
    [-148.4080, 59.9992],
    [-148.4070, 59.9948],
    [-148.4097, 59.9907],
    [-148.4067, 59.9863],
    [-148.4011, 59.9836],
    [-148.4053, 59.9756],
    [-148.4097, 59.9701],
    [-148.4203, 59.9667],
    [-148.4238, 59.9620],
    [-148.4242, 59.9537],
    [-148.4333, 59.9482],
    [-148.4425, 59.9436],
    [-148.4492, 59.9476],
    [-148.4553, 59.9523],
    [-148.4716, 59.9535],
    [-148.4805, 59.9581],
    [-148.4784, 59.9668],
    [-148.4748, 59.9731],
    [-148.4864, 59.9775],
    [-148.4939, 59.9815],
    [-148.4909, 59.9898],
    [-148.4929, 59.9938],
    [-148.4835, 59.9987],
    [-148.4742, 60.0037],
    [-148.4828, 60.0042],
    [-148.5078, 60.0012],
    [-148.5205, 60.0096],
    [-148.5263, 60.0159],
    [-148.5225, 60.0208],
    [-148.5244, 60.0232],
    [-148.5333, 60.0217],
    [-148.5382, 60.0281],
    [-148.5494, 60.0319],
    [-148.5559, 60.0278],
    [-148.5519, 60.0233],
    [-148.5484, 60.0157],
    [-148.5452, 60.0119],
    [-148.5444, 60.0007],
    [-148.5429, 59.9880],
    [-148.5441, 59.9804],
    [-148.5465, 59.9705],
    [-148.5524, 59.9662],
    [-148.5544, 59.9589],
    [-148.5612, 59.9491],
    [-148.5901, 59.9353],
    [-148.6044, 59.9268],
    [-148.6229, 59.9202],
    [-148.6348, 59.9157],
    [-148.6553, 59.9178],
    [-148.6757, 59.9226],
    [-148.6738, 59.9321],
    [-148.6679, 59.9378],
    [-148.6764, 59.9426],
    [-148.6895, 59.9447],
    [-148.7073, 59.9392],
    [-148.7161, 59.9381],
    [-148.7283, 59.9405],
    [-148.7228, 59.9448],
    [-148.7255, 59.9488],
    [-148.7324, 59.9504],
    [-148.7389, 59.9548],
    [-148.7513, 59.9580],
    [-148.7719, 59.9586],
    [-148.7919, 59.9556],
    [-148.8030, 59.9507],
    [-148.8073, 59.9433],
    [-148.8151, 59.9369],
    [-148.8207, 59.9315],
    [-148.8288, 59.9304],
    [-148.8334, 59.9266],
    [-148.8424, 59.9260],
    [-148.8690, 59.9249],
    [-148.8800, 59.9286],
    [-148.8832, 59.9341],
    [-148.8844, 59.9405],
    [-148.8893, 59.9423],
    [-148.9010, 59.9478],
    [-148.9035, 59.9545],
    [-148.9083, 59.9557],
    [-148.9137, 59.9627],
    [-148.9146, 59.9689],
    [-148.9271, 59.9724],
    [-148.9576, 59.9737],
    [-148.9603, 59.9696],
    [-148.9713, 59.9679],
    [-148.9780, 59.9649],
    [-148.9868, 59.9593],
    [-148.9955, 59.9531],
    [-149.0118, 59.9508],
    [-149.0250, 59.9493],
    [-149.0293, 59.9598],
    [-149.0327, 59.9668],
    [-149.0495, 59.9680],
    [-149.0611, 59.9598],
    [-149.0763, 59.9551],
    [-149.0852, 59.9554],
    [-149.0937, 59.9551],
    [-149.1007, 59.9597],
    [-149.1013, 59.9643],
    [-149.1167, 59.9655],
    [-149.1233, 59.9686],
    [-149.1209, 59.9755],
    [-149.1223, 59.9822],
    [-149.1159, 59.9878],
    [-149.1027, 59.9952],
    [-149.0941, 59.9935],
    [-149.0864, 59.9897],
    [-149.0886, 59.9940],
    [-149.0932, 60.0035],
    [-149.0756, 60.0187],
    [-149.0703, 60.0137],
    [-149.0629, 60.0140],
    [-149.0632, 60.0242],
    [-149.0430, 60.0321],
    [-149.0435, 60.0357],
    [-149.0372, 60.0428],
    [-149.0521, 60.0511],
    [-149.0640, 60.0556],
    [-149.0845, 60.0500],
    [-149.1034, 60.0438],
    [-149.1278, 60.0437],
    [-149.1319, 60.0401],
    [-149.1357, 60.0340],
    [-149.1411, 60.0311],
    [-149.1530, 60.0320],
    [-149.1663, 60.0288],
    [-149.1658, 60.0220],
    [-149.1697, 60.0157],
    [-149.1770, 60.0086],
    [-149.1887, 60.0026],
    [-149.1963, 60.0052],
    [-149.2018, 60.0094],
    [-149.2085, 60.0065],
    [-149.2066, 60.0005],
    [-149.2063, 59.9950],
    [-149.2089, 59.9864],
    [-149.2230, 59.9851],
    [-149.2272, 59.9813],
    [-149.2252, 59.9778],
    [-149.2166, 59.9797],
    [-149.2074, 59.9790],
    [-149.2127, 59.9714],
    [-149.2209, 59.9681],
    [-149.2256, 59.9658],
    [-149.2262, 59.9600],
    [-149.2312, 59.9549],
    [-149.2362, 59.9518],
    [-149.2471, 59.9498],
    [-149.2431, 59.9464],
    [-149.2303, 59.9480],
    [-149.2217, 59.9499],
    [-149.2193, 59.9429],
    [-149.2218, 59.9370],
    [-149.2262, 59.9394],
    [-149.2338, 59.9378],
    [-149.2365, 59.9334],
    [-149.2431, 59.9284],
    [-149.2477, 59.9252],
    [-149.2536, 59.9202],
    [-149.2650, 59.9171],
    [-149.2730, 59.9158],
    [-149.2699, 59.9115],
    [-149.2602, 59.9084],
    [-149.2533, 59.9073],
    [-149.2517, 59.9102],
    [-149.2460, 59.9127],
    [-149.2347, 59.9094],
    [-149.2454, 59.9066],
    [-149.2474, 59.9043],
    [-149.2529, 59.9018],
    [-149.2504, 59.8973],
    [-149.2541, 59.8943],
    [-149.2604, 59.8899],
    [-149.2650, 59.8883],
    [-149.2763, 59.8855],
    [-149.2774, 59.8777],
    [-149.2704, 59.8733],
    [-149.2862, 59.8672],
    [-149.2938, 59.8723],
    [-149.2877, 59.8744],
    [-149.2895, 59.8777],
    [-149.2959, 59.8852],
    [-149.2928, 59.8875],
    [-149.2988, 59.8901],
    [-149.2988, 59.8937],
    [-149.2946, 59.8959],
    [-149.2946, 59.8988],
    [-149.2931, 59.9024],
    [-149.2894, 59.9050],
    [-149.2940, 59.9076],
    [-149.2955, 59.9096],
    [-149.2950, 59.9139],
    [-149.3003, 59.9136],
    [-149.2980, 59.9190],
    [-149.3037, 59.9237],
    [-149.3028, 59.9292],
    [-149.2971, 59.9346],
    [-149.3013, 59.9392],
    [-149.3024, 59.9422],
    [-149.2921, 59.9421],
    [-149.2993, 59.9467],
    [-149.3009, 59.9508],
    [-149.3015, 59.9555],
    [-149.3006, 59.9614],
    [-149.2955, 59.9653],
    [-149.2852, 59.9656],
    [-149.2931, 59.9689],
    [-149.2943, 59.9741],
    [-149.2961, 59.9786],
    [-149.3031, 59.9777],
    [-149.3107, 59.9724],
    [-149.3235, 59.9727],
    [-149.3195, 59.9853],
    [-149.3231, 59.9915],
    [-149.3003, 60.0034],
    [-149.2901, 60.0100],
    [-149.2914, 60.0137],
    [-149.3081, 60.0130],
    [-149.3147, 60.0121],
    [-149.3327, 60.0071],
    [-149.3348, 60.0136],
    [-149.3368, 60.0270],
    [-149.3385, 60.0461],
    [-149.3432, 60.0568],
    [-149.3435, 60.0613],
    [-149.3419, 60.0708],
    [-149.3429, 60.0766],
    [-149.3518, 60.0829],
    [-149.3576, 60.0885],
    [-149.3685, 60.0952],
    [-149.3647, 60.1051],
    [-149.3618, 60.1153],
    [-149.3701, 60.1215],
    [-149.3753, 60.1201],
    [-149.4065, 60.1181],
    [-149.4194, 60.1232],
    [-149.4242, 60.1188],
    [-149.4381, 60.1144],
    [-149.4334, 60.1081],
    [-149.4390, 60.0996],
    [-149.4439, 60.0925],
    [-149.4429, 60.0829],
    [-149.4419, 60.0774],
    [-149.4349, 60.0707],
    [-149.4423, 60.0649],
    [-149.4428, 60.0636],
    [-149.4442, 60.0561],
    [-149.4426, 60.0524],
    [-149.4391, 60.0454],
    [-149.4456, 60.0378],
    [-149.4372, 60.0292],
    [-149.4261, 60.0224],
    [-149.4155, 60.0140],
    [-149.4063, 60.0098],
    [-149.4020, 60.0062],
    [-149.3876, 59.9950],
    [-149.3865, 59.9838],
    [-149.3992, 59.9848],
    [-149.4044, 59.9867],
    [-149.4170, 59.9838],
    [-149.4305, 59.9790],
    [-149.4283, 59.9750],
    [-149.4321, 59.9719],
    [-149.4389, 59.9601],
    [-149.4444, 59.9531],
    [-149.4472, 59.9432],
    [-149.4555, 59.9317],
    [-149.4573, 59.9279],
    [-149.4642, 59.9186],
    [-149.4772, 59.9251],
    [-149.4838, 59.9311],
    [-149.5008, 59.9318],
    [-149.5231, 59.9276],
    [-149.5412, 59.9171],
    [-149.5583, 59.9071],
    [-149.5659, 59.9034],
    [-149.5669, 59.8952],
    [-149.5568, 59.8919],
    [-149.5537, 59.8921],
    [-149.5551, 59.8784],
    [-149.5656, 59.8794],
    [-149.5735, 59.8798],
    [-149.5831, 59.8762],
    [-149.5804, 59.8734],
    [-149.5813, 59.8680],
    [-149.5839, 59.8646],
    [-149.5775, 59.8618],
    [-149.5706, 59.8607],
    [-149.5716, 59.8555],
    [-149.5743, 59.8502],
    [-149.5797, 59.8546],
    [-149.5865, 59.8566],
    [-149.5949, 59.8526],
    [-149.5920, 59.8470],
    [-149.5955, 59.8431],
    [-149.6041, 59.8413],
    [-149.6101, 59.8378],
    [-149.6166, 59.8330],
    [-149.6201, 59.8326],
    [-149.6210, 59.8278],
    [-149.6224, 59.8240],
    [-149.6262, 59.8182],
    [-149.6168, 59.8109],
    [-149.6031, 59.8093],
    [-149.5999, 59.8028],
    [-149.6012, 59.8001],
    [-149.5955, 59.7977],
    [-149.5921, 59.7920],
    [-149.5937, 59.7876],
    [-149.5962, 59.7838],
    [-149.5877, 59.7818],
    [-149.5883, 59.7786],
    [-149.5885, 59.7730],
    [-149.5916, 59.7699],
    [-149.5835, 59.7656],
    [-149.5697, 59.7676],
    [-149.5659, 59.7711],
    [-149.5680, 59.7750],
    [-149.5516, 59.7810],
    [-149.5390, 59.7812],
    [-149.5341, 59.7739],
    [-149.5419, 59.7741],
    [-149.5484, 59.7761],
    [-149.5544, 59.7736],
    [-149.5506, 59.7699],
    [-149.5437, 59.7612],
    [-149.5353, 59.7578],
    [-149.5443, 59.7548],
    [-149.5551, 59.7538],
    [-149.5626, 59.7542],
    [-149.5657, 59.7511],
    [-149.5570, 59.7458],
    [-149.5464, 59.7469],
    [-149.5417, 59.7441],
    [-149.5422, 59.7420],
    [-149.5469, 59.7369],
    [-149.5460, 59.7300],
    [-149.5379, 59.7308],
    [-149.5245, 59.7339],
    [-149.5157, 59.7382],
    [-149.5195, 59.7335],
    [-149.5251, 59.7281],
    [-149.5296, 59.7211],
    [-149.5255, 59.7137],
    [-149.5303, 59.7083],
    [-149.5348, 59.7079],
    [-149.5423, 59.7081],
    [-149.5372, 59.7130],
    [-149.5440, 59.7169],
    [-149.5522, 59.7146],
    [-149.5447, 59.7195],
    [-149.5391, 59.7248],
    [-149.5418, 59.7267],
    [-149.5511, 59.7285],
    [-149.5593, 59.7265],
    [-149.5720, 59.7224],
    [-149.5758, 59.7176],
    [-149.5855, 59.7196],
    [-149.5816, 59.7234],
    [-149.5724, 59.7304],
    [-149.5747, 59.7346],
    [-149.5808, 59.7378],
    [-149.5776, 59.7436],
    [-149.5847, 59.7469],
    [-149.5942, 59.7476],
    [-149.5959, 59.7454],
    [-149.5983, 59.7442],
    [-149.6059, 59.7393],
    [-149.6018, 59.7341],
    [-149.6100, 59.7292],
    [-149.6189, 59.7281],
    [-149.6175, 59.7346],
    [-149.6287, 59.7350],
    [-149.6343, 59.7365],
    [-149.6375, 59.7415],
    [-149.6252, 59.7434],
    [-149.6124, 59.7445],
    [-149.6075, 59.7493],
    [-149.6155, 59.7517],
    [-149.6201, 59.7548],
    [-149.6122, 59.7554],
    [-149.5987, 59.7506],
    [-149.5890, 59.7508],
    [-149.5785, 59.7532],
    [-149.5734, 59.7587],
    [-149.5834, 59.7625],
    [-149.5935, 59.7620],
    [-149.5993, 59.7603],
    [-149.6040, 59.7657],
    [-149.6091, 59.7646],
    [-149.6116, 59.7700],
    [-149.6067, 59.7753],
    [-149.6062, 59.7780],
    [-149.5996, 59.7821],
    [-149.6063, 59.7861],
    [-149.6126, 59.7855],
    [-149.6231, 59.7809],
    [-149.6282, 59.7744],
    [-149.6321, 59.7675],
    [-149.6382, 59.7627],
    [-149.6452, 59.7622],
    [-149.6421, 59.7666],
    [-149.6472, 59.7697],
    [-149.6535, 59.7738],
    [-149.6462, 59.7801],
    [-149.6320, 59.7800],
    [-149.6178, 59.7893],
    [-149.6237, 59.7928],
    [-149.6087, 59.7946],
    [-149.6098, 59.7997],
    [-149.6155, 59.8036],
    [-149.6199, 59.8050],
    [-149.6255, 59.8006],
    [-149.6372, 59.8005],
    [-149.6440, 59.7978],
    [-149.6503, 59.7927],
    [-149.6574, 59.7950],
    [-149.6589, 59.7981],
    [-149.6643, 59.8023],
    [-149.6525, 59.8053],
    [-149.6453, 59.8077],
    [-149.6566, 59.8100],
    [-149.6697, 59.8125],
    [-149.6550, 59.8162],
    [-149.6448, 59.8170],
    [-149.6552, 59.8198],
    [-149.6723, 59.8209],
    [-149.6693, 59.8242],
    [-149.6678, 59.8272],
    [-149.6553, 59.8265],
    [-149.6371, 59.8274],
    [-149.6399, 59.8327],
    [-149.6528, 59.8333],
    [-149.6682, 59.8358],
    [-149.6687, 59.8435],
    [-149.6655, 59.8488],
    [-149.6574, 59.8508],
    [-149.6612, 59.8523],
    [-149.6611, 59.8540],
    [-149.6528, 59.8612],
    [-149.6421, 59.8586],
    [-149.6320, 59.8558],
    [-149.6283, 59.8591],
    [-149.6377, 59.8660],
    [-149.6309, 59.8684],
    [-149.6210, 59.8739],
    [-149.6164, 59.8787],
    [-149.6217, 59.8795],
    [-149.6306, 59.8765],
    [-149.6433, 59.8745],
    [-149.6569, 59.8722],
    [-149.6667, 59.8694],
    [-149.6628, 59.8771],
    [-149.6574, 59.8817],
    [-149.6552, 59.8889],
    [-149.6576, 59.8922],
    [-149.6471, 59.8944],
    [-149.6378, 59.8963],
    [-149.6459, 59.8988],
    [-149.6513, 59.9005],
    [-149.6595, 59.9034],
    [-149.6643, 59.9097],
    [-149.6561, 59.9107],
    [-149.6607, 59.9153],
    [-149.6670, 59.9212],
    [-149.6652, 59.9279],
    [-149.6704, 59.9332],
    [-149.6769, 59.9412],
    [-149.6823, 59.9470],
    [-149.6921, 59.9521],
    [-149.7091, 59.9531],
    [-149.7228, 59.9551],
    [-149.7356, 59.9522],
    [-149.7406, 59.9411],
    [-149.7359, 59.9339],
    [-149.7310, 59.9250],
    [-149.7261, 59.9103],
    [-149.7263, 59.9055],
    [-149.7210, 59.9013],
    [-149.7247, 59.8944],
    [-149.7265, 59.8878],
    [-149.7158, 59.8851],
    [-149.7235, 59.8795],
    [-149.7368, 59.8787],
    [-149.7437, 59.8742],
    [-149.7530, 59.8641],
    [-149.7510, 59.8595],
    [-149.7467, 59.8547],
    [-149.7456, 59.8457],
    [-149.7427, 59.8363],
    [-149.7453, 59.8262],
    [-149.7613, 59.8217],
    [-149.7648, 59.8253],
    [-149.7702, 59.8296],
    [-149.7690, 59.8330],
    [-149.7747, 59.8382],
    [-149.7853, 59.8422],
    [-149.7920, 59.8477],
    [-149.8062, 59.8519],
    [-149.8254, 59.8505],
    [-149.8383, 59.8511],
    [-149.8493, 59.8533],
    [-149.8558, 59.8540],
    [-149.8647, 59.8554],
    [-149.8722, 59.8535],
    [-149.8623, 59.8471],
    [-149.8542, 59.8462],
    [-149.8441, 59.8445],
    [-149.8310, 59.8391],
    [-149.8167, 59.8334],
    [-149.8109, 59.8277],
    [-149.8094, 59.8216],
    [-149.8071, 59.8175],
    [-149.8030, 59.8130],
    [-149.7920, 59.8057],
    [-149.7638, 59.7962],
    [-149.7618, 59.7901],
    [-149.7692, 59.7922],
    [-149.7758, 59.7919],
    [-149.7865, 59.7891],
    [-149.7879, 59.7824],
    [-149.7718, 59.7787],
    [-149.7674, 59.7742],
    [-149.7734, 59.7715],
    [-149.7806, 59.7676],
    [-149.7833, 59.7631],
    [-149.7769, 59.7607],
    [-149.7678, 59.7615],
    [-149.7642, 59.7664],
    [-149.7560, 59.7639],
    [-149.7566, 59.7552],
    [-149.7613, 59.7533],
    [-149.7650, 59.7503],
    [-149.7686, 59.7469],
    [-149.7676, 59.7445],
    [-149.7583, 59.7379],
    [-149.7549, 59.7338],
    [-149.7567, 59.7318],
    [-149.7491, 59.7313],
    [-149.7447, 59.7303],
    [-149.7466, 59.7254],
    [-149.7424, 59.7204],
    [-149.7350, 59.7219],
    [-149.7315, 59.7166],
    [-149.7373, 59.7149],
    [-149.7408, 59.7102],
    [-149.7487, 59.7082],
    [-149.7490, 59.7046],
    [-149.7500, 59.6982],
    [-149.7467, 59.6935],
    [-149.7399, 59.6959],
    [-149.7326, 59.6995],
    [-149.7304, 59.7001],
    [-149.7232, 59.6980],
    [-149.7286, 59.6927],
    [-149.7361, 59.6872],
    [-149.7415, 59.6851],
    [-149.7486, 59.6906],
    [-149.7529, 59.6916],
    [-149.7633, 59.6904],
    [-149.7633, 59.6844],
    [-149.7519, 59.6809],
    [-149.7525, 59.6769],
    [-149.7593, 59.6721],
    [-149.7492, 59.6671],
    [-149.7402, 59.6606],
    [-149.7455, 59.6563],
    [-149.7465, 59.6523],
    [-149.7387, 59.6519],
    [-149.7393, 59.6399],
    [-149.7457, 59.6400],
    [-149.7530, 59.6438],
    [-149.7588, 59.6458],
    [-149.7564, 59.6501],
    [-149.7643, 59.6489],
    [-149.7693, 59.6499],
    [-149.7756, 59.6501],
    [-149.7819, 59.6514],
    [-149.7692, 59.6542],
    [-149.7630, 59.6598],
    [-149.7662, 59.6642],
    [-149.7734, 59.6589],
    [-149.7803, 59.6594],
    [-149.7857, 59.6586],
    [-149.7947, 59.6575],
    [-149.7983, 59.6635],
    [-149.7915, 59.6642],
    [-149.7837, 59.6702],
    [-149.7821, 59.6764],
    [-149.7858, 59.6809],
    [-149.7947, 59.6772],
    [-149.8045, 59.6734],
    [-149.8078, 59.6783],
    [-149.8059, 59.6806],
    [-149.7946, 59.6855],
    [-149.8020, 59.6866],
    [-149.8138, 59.6854],
    [-149.8211, 59.6824],
    [-149.8248, 59.6857],
    [-149.8201, 59.6891],
    [-149.8067, 59.6911],
    [-149.7954, 59.6919],
    [-149.7972, 59.6944],
    [-149.7938, 59.6972],
    [-149.7845, 59.6920],
    [-149.7744, 59.6967],
    [-149.7655, 59.7026],
    [-149.7692, 59.7062],
    [-149.7758, 59.7049],
    [-149.7819, 59.7049],
    [-149.7802, 59.7096],
    [-149.7870, 59.7132],
    [-149.7944, 59.7130],
    [-149.7982, 59.7083],
    [-149.8074, 59.7078],
    [-149.8147, 59.7026],
    [-149.8298, 59.7015],
    [-149.8213, 59.7076],
    [-149.8154, 59.7089],
    [-149.8166, 59.7129],
    [-149.8116, 59.7175],
    [-149.8162, 59.7200],
    [-149.8213, 59.7201],
    [-149.8287, 59.7139],
    [-149.8401, 59.7148],
    [-149.8370, 59.7188],
    [-149.8352, 59.7242],
    [-149.8413, 59.7246],
    [-149.8502, 59.7269],
    [-149.8406, 59.7294],
    [-149.8495, 59.7314],
    [-149.8422, 59.7334],
    [-149.8503, 59.7407],
    [-149.8696, 59.7424],
    [-149.8867, 59.7403],
    [-149.8958, 59.7463],
    [-149.8936, 59.7530],
    [-149.8948, 59.7570],
    [-149.9005, 59.7605],
    [-149.9041, 59.7633],
    [-149.9093, 59.7673],
    [-149.9107, 59.7703],
    [-149.9172, 59.7708],
    [-149.9240, 59.7675],
    [-149.9293, 59.7693],
    [-149.9400, 59.7687],
    [-149.9448, 59.7725],
    [-149.9474, 59.7764],
    [-149.9586, 59.7719],
    [-149.9737, 59.7714],
    [-149.9856, 59.7765],
    [-149.9898, 59.7809],
    [-149.9965, 59.7832],
    [-150.0040, 59.7920],
    [-150.0138, 59.7976],
    [-150.0130, 59.8009],
    [-150.0209, 59.7997],
    [-150.0324, 59.7926],
    [-150.0354, 59.7904],
    [-150.0480, 59.7902],
    [-150.0515, 59.7956],
    [-150.0466, 59.8018],
    [-150.0428, 59.8097],
    [-150.0411, 59.8158],
    [-150.0478, 59.8231],
    [-150.0532, 59.8292],
    [-150.0585, 59.8357],
    [-150.0621, 59.8410],
    [-150.0680, 59.8470],
    [-150.0761, 59.8454],
    [-150.0775, 59.8409],
    [-150.0742, 59.8357],
    [-150.0676, 59.8287],
    [-150.0652, 59.8217],
    [-150.0616, 59.8115],
    [-150.0613, 59.8062],
    [-150.0632, 59.7996],
    [-150.0711, 59.7920],
    [-150.0756, 59.7885],
    [-150.0751, 59.7841],
    [-150.0660, 59.7800],
    [-150.0671, 59.7779],
    [-150.0677, 59.7746],
    [-150.0728, 59.7700],
    [-150.0778, 59.7642],
    [-150.0718, 59.7600],
    [-150.0619, 59.7643],
    [-150.0578, 59.7696],
    [-150.0442, 59.7713],
    [-150.0423, 59.7768],
    [-150.0370, 59.7739],
    [-150.0285, 59.7680],
    [-150.0123, 59.7613],
    [-149.9958, 59.7552],
    [-149.9824, 59.7504],
    [-149.9747, 59.7520],
    [-149.9682, 59.7497],
    [-149.9623, 59.7440],
    [-149.9597, 59.7359],
    [-149.9607, 59.7307],
    [-149.9671, 59.7293],
    [-149.9740, 59.7282],
    [-149.9769, 59.7231],
    [-149.9717, 59.7170],
    [-149.9575, 59.7195],
    [-149.9424, 59.7231],
    [-149.9349, 59.7237],
    [-149.9303, 59.7300],
    [-149.9271, 59.7279],
    [-149.9252, 59.7210],
    [-149.9233, 59.7131],
    [-149.9220, 59.7070],
    [-149.9240, 59.6977],
    [-149.9212, 59.6911],
    [-149.9302, 59.6761],
    [-149.9411, 59.6652],
    [-149.9461, 59.6652],
    [-149.9499, 59.6650],
    [-149.9519, 59.6615],
    [-149.9423, 59.6586],
    [-149.9477, 59.6556],
    [-149.9610, 59.6592],
    [-149.9675, 59.6608],
    [-149.9829, 59.6577],
    [-150.0004, 59.6612],
    [-150.0075, 59.6633],
    [-150.0119, 59.6596],
    [-150.0070, 59.6527],
    [-150.0007, 59.6450],
    [-149.9992, 59.6376],
    [-150.0078, 59.6358],
    [-150.0093, 59.6317],
    [-150.0142, 59.6294],
    [-150.0171, 59.6252],
    [-150.0287, 59.6250],
    [-150.0269, 59.6189],
    [-150.0344, 59.6125],
    [-150.0468, 59.6225],
    [-150.0478, 59.6282],
    [-150.0512, 59.6370],
    [-150.0419, 59.6380],
    [-150.0470, 59.6442],
    [-150.0463, 59.6489],
    [-150.0578, 59.6599],
    [-150.0644, 59.6617],
    [-150.0851, 59.6657],
    [-150.0926, 59.6719],
    [-150.1094, 59.6784],
    [-150.1111, 59.6811],
    [-150.1138, 59.6858],
    [-150.1309, 59.6944],
    [-150.1358, 59.6910],
    [-150.1303, 59.6822],
    [-150.1302, 59.6764],
    [-150.1169, 59.6724],
    [-150.1101, 59.6594],
    [-150.0986, 59.6556],
    [-150.0869, 59.6504],
    [-150.0880, 59.6444],
    [-150.0907, 59.6380],
    [-150.0967, 59.6304],
    [-150.0995, 59.6224],
    [-150.0989, 59.6134],
    [-150.1094, 59.6040],
    [-150.1232, 59.6082],
    [-150.1392, 59.6190],
    [-150.1401, 59.6230],
    [-150.1631, 59.6224],
    [-150.1649, 59.6194],
    [-150.1536, 59.6180],
    [-150.1538, 59.6090],
    [-150.1465, 59.6066],
    [-150.1344, 59.5961],
    [-150.1242, 59.5919],
    [-150.1128, 59.5887],
    [-150.0987, 59.5847],
    [-150.0843, 59.5805],
    [-150.0912, 59.5782],
    [-150.0963, 59.5755],
    [-150.1002, 59.5744],
    [-150.1084, 59.5729],
    [-150.1119, 59.5673],
    [-150.1202, 59.5676],
    [-150.1379, 59.5645],
    [-150.1442, 59.5709],
    [-150.1536, 59.5689],
    [-150.1581, 59.5633],
    [-150.1650, 59.5618],
    [-150.1777, 59.5653],
    [-150.1837, 59.5689],
    [-150.1851, 59.5748],
    [-150.1778, 59.5782],
    [-150.1754, 59.5817],
    [-150.1827, 59.5848],
    [-150.1899, 59.5811],
    [-150.2011, 59.5810],
    [-150.2142, 59.5767],
    [-150.2082, 59.5724],
    [-150.2041, 59.5613],
    [-150.1967, 59.5545],
    [-150.1862, 59.5475],
    [-150.1771, 59.5344],
    [-150.2023, 59.5232],
    [-150.2174, 59.5190],
    [-150.2099, 59.5251],
    [-150.2082, 59.5328],
    [-150.2077, 59.5381],
    [-150.2165, 59.5431],
    [-150.2213, 59.5397],
    [-150.2217, 59.5322],
    [-150.2225, 59.5288],
    [-150.2313, 59.5285],
    [-150.2373, 59.5261],
    [-150.2471, 59.5286],
    [-150.2560, 59.5270],
    [-150.2594, 59.5311],
    [-150.2614, 59.5338],
    [-150.2654, 59.5335],
    [-150.2667, 59.5262],
    [-150.2543, 59.5200],
    [-150.2443, 59.5115],
    [-150.2433, 59.5065],
    [-150.2357, 59.5006],
    [-150.2410, 59.4953],
    [-150.2516, 59.4919],
    [-150.2566, 59.4846],
    [-150.2703, 59.4936],
    [-150.2736, 59.4975],
    [-150.2824, 59.4991],
    [-150.2892, 59.4975],
    [-150.2980, 59.4949],
    [-150.2901, 59.4887],
    [-150.2879, 59.4777],
    [-150.2985, 59.4771],
    [-150.3013, 59.4824],
    [-150.3115, 59.4856],
    [-150.3130, 59.4788],
    [-150.3111, 59.4700],
    [-150.3159, 59.4623],
    [-150.3207, 59.4554],
    [-150.3268, 59.4492],
    [-150.3164, 59.4474],
    [-150.3092, 59.4535],
    [-150.2964, 59.4558],
    [-150.2850, 59.4599],
    [-150.2929, 59.4530],
    [-150.3054, 59.4443],
    [-150.3067, 59.4355],
    [-150.2993, 59.4315],
    [-150.2961, 59.4258],
    [-150.3004, 59.4156],
    [-150.3096, 59.4153],
    [-150.3137, 59.4171],
    [-150.3121, 59.4203],
    [-150.3029, 59.4225],
    [-150.3082, 59.4251],
    [-150.3156, 59.4298],
    [-150.3232, 59.4277],
    [-150.3253, 59.4307],
    [-150.3222, 59.4366],
    [-150.3277, 59.4413],
    [-150.3357, 59.4386],
    [-150.3420, 59.4358],
    [-150.3451, 59.4304],
    [-150.3415, 59.4240],
    [-150.3430, 59.4188],
    [-150.3490, 59.4153],
    [-150.3534, 59.4187],
    [-150.3643, 59.4217],
    [-150.3704, 59.4247],
    [-150.3637, 59.4287],
    [-150.3600, 59.4307],
    [-150.3591, 59.4338],
    [-150.3637, 59.4361],
    [-150.3742, 59.4325],
    [-150.3839, 59.4286],
    [-150.3920, 59.4281],
    [-150.3859, 59.4208],
    [-150.3780, 59.4105],
    [-150.3826, 59.4021],
    [-150.3943, 59.3990],
    [-150.3889, 59.3918],
    [-150.3957, 59.3839],
    [-150.4048, 59.3885],
    [-150.4237, 59.3907],
    [-150.4322, 59.3954],
    [-150.4297, 59.4008],
    [-150.4148, 59.3992],
    [-150.4107, 59.4046],
    [-150.4039, 59.4083],
    [-150.4084, 59.4110],
    [-150.4146, 59.4093],
    [-150.4267, 59.4116],
    [-150.4266, 59.4150],
    [-150.4211, 59.4160],
    [-150.4199, 59.4221],
    [-150.4219, 59.4249],
    [-150.4074, 59.4217],
    [-150.3987, 59.4229],
    [-150.4057, 59.4298],
    [-150.4154, 59.4331],
    [-150.4151, 59.4392],
    [-150.3956, 59.4315],
    [-150.3953, 59.4354],
    [-150.4023, 59.4416],
    [-150.4026, 59.4457],
    [-150.3891, 59.4414],
    [-150.3788, 59.4393],
    [-150.3769, 59.4420],
    [-150.3823, 59.4457],
    [-150.3723, 59.4472],
    [-150.3693, 59.4507],
    [-150.3634, 59.4474],
    [-150.3550, 59.4387],
    [-150.3447, 59.4384],
    [-150.3466, 59.4467],
    [-150.3493, 59.4519],
    [-150.3512, 59.4616],
    [-150.3650, 59.4593],
    [-150.3700, 59.4610],
    [-150.3780, 59.4624],
    [-150.3823, 59.4587],
    [-150.3878, 59.4594],
    [-150.3944, 59.4594],
    [-150.4034, 59.4624],
    [-150.3943, 59.4663],
    [-150.3922, 59.4721],
    [-150.3771, 59.4745],
    [-150.3662, 59.4752],
    [-150.3550, 59.4720],
    [-150.3446, 59.4786],
    [-150.3407, 59.4830],
    [-150.3413, 59.4870],
    [-150.3524, 59.4884],
    [-150.3613, 59.4896],
    [-150.3660, 59.4919],
    [-150.3741, 59.4890],
    [-150.3788, 59.4922],
    [-150.3757, 59.5016],
    [-150.3617, 59.5028],
    [-150.3453, 59.4989],
    [-150.3315, 59.5019],
    [-150.3386, 59.5074],
    [-150.3460, 59.5105],
    [-150.3554, 59.5114],
    [-150.3632, 59.5137],
    [-150.3687, 59.5177],
    [-150.3618, 59.5233],
    [-150.3476, 59.5208],
    [-150.3508, 59.5252],
    [-150.3522, 59.5299],
    [-150.3490, 59.5342],
    [-150.3466, 59.5373],
    [-150.3389, 59.5448],
    [-150.3231, 59.5497],
    [-150.3187, 59.5557],
    [-150.3266, 59.5606],
    [-150.3205, 59.5665],
    [-150.3114, 59.5684],
    [-150.3117, 59.5712],
    [-150.2995, 59.5784],
    [-150.2898, 59.5799],
    [-150.2989, 59.5842],
    [-150.3050, 59.5881],
    [-150.3177, 59.5921],
    [-150.3019, 59.6050],
    [-150.2931, 59.6098],
    [-150.2863, 59.6163],
    [-150.2762, 59.6205],
    [-150.2635, 59.6288],
    [-150.2695, 59.6345],
    [-150.2786, 59.6393],
    [-150.2827, 59.6458],
    [-150.2554, 59.6605],
    [-150.2462, 59.6750],
    [-150.2458, 59.6834],
    [-150.2493, 59.6872],
    [-150.2405, 59.6954],
    [-150.2292, 59.7034],
    [-150.2232, 59.7089],
    [-150.2199, 59.7150],
    [-150.2194, 59.7201],
    [-150.2188, 59.7241],
    [-150.2183, 59.7306],
    [-150.2181, 59.7341],
    [-150.2214, 59.7389],
    [-150.2202, 59.7434],
    [-150.2301, 59.7402],
    [-150.2333, 59.7341],
    [-150.2395, 59.7306],
    [-150.2477, 59.7208],
    [-150.2535, 59.7155],
    [-150.2566, 59.7108],
    [-150.2621, 59.7062],
    [-150.2697, 59.7006],
    [-150.2759, 59.6952],
    [-150.2798, 59.6903],
    [-150.2830, 59.6858],
    [-150.2834, 59.6790],
    [-150.2898, 59.6749],
    [-150.3010, 59.6625],
    [-150.3082, 59.6562],
    [-150.3067, 59.6500],
    [-150.3113, 59.6430],
    [-150.3194, 59.6343],
    [-150.3216, 59.6308],
    [-150.3189, 59.6264],
    [-150.3260, 59.6244],
    [-150.3301, 59.6200],
    [-150.3391, 59.6148],
    [-150.3477, 59.6091],
    [-150.3509, 59.6048],
    [-150.3496, 59.5997],
    [-150.3632, 59.5915],
    [-150.3775, 59.5729],
    [-150.3886, 59.5677],
    [-150.3940, 59.5645],
    [-150.4029, 59.5605],
    [-150.4124, 59.5546],
    [-150.4186, 59.5440],
    [-150.4222, 59.5378],
    [-150.4296, 59.5245],
    [-150.4315, 59.5143],
    [-150.4375, 59.5102],
    [-150.4469, 59.4992],
    [-150.4526, 59.4951],
    [-150.4618, 59.4801],
    [-150.4659, 59.4739],
    [-150.4696, 59.4712],
    [-150.4772, 59.4683],
    [-150.4755, 59.4608],
    [-150.4849, 59.4599],
    [-150.4953, 59.4579],
    [-150.5014, 59.4578],
    [-150.5053, 59.4642],
    [-150.5120, 59.4646],
    [-150.5177, 59.4621],
    [-150.5233, 59.4751],
    [-150.5213, 59.4820],
    [-150.4999, 59.4840],
    [-150.4885, 59.4870],
    [-150.4856, 59.4923],
    [-150.4852, 59.4997],
    [-150.4816, 59.5071],
    [-150.4815, 59.5132],
    [-150.4917, 59.5126],
    [-150.4934, 59.5089],
    [-150.4975, 59.4999],
    [-150.5053, 59.4969],
    [-150.5248, 59.4953],
    [-150.5461, 59.5004],
    [-150.5624, 59.5112],
    [-150.5542, 59.5087],
    [-150.5372, 59.5144],
    [-150.5285, 59.5159],
    [-150.5212, 59.5164],
    [-150.5196, 59.5203],
    [-150.5260, 59.5219],
    [-150.5408, 59.5183],
    [-150.5514, 59.5175],
    [-150.5640, 59.5231],
    [-150.5676, 59.5330],
    [-150.5509, 59.5429],
    [-150.5410, 59.5478],
    [-150.5383, 59.5551],
    [-150.5263, 59.5621],
    [-150.5199, 59.5638],
    [-150.5125, 59.5662],
    [-150.5133, 59.5704],
    [-150.5128, 59.5728],
    [-150.5033, 59.5758],
    [-150.4915, 59.5798],
    [-150.4988, 59.5847],
    [-150.5088, 59.5904],
    [-150.5061, 59.5935],
    [-150.5054, 59.5985],
    [-150.5183, 59.6022],
    [-150.5212, 59.6064],
    [-150.5314, 59.6015],
    [-150.5388, 59.5924],
    [-150.5509, 59.5974],
    [-150.5597, 59.5935],
    [-150.5559, 59.5895],
    [-150.5641, 59.5825],
    [-150.5756, 59.5766],
    [-150.5825, 59.5681],
    [-150.5881, 59.5656],
    [-150.5865, 59.5615],
    [-150.5931, 59.5507],
    [-150.5998, 59.5456],
    [-150.6063, 59.5418],
    [-150.6053, 59.5374],
    [-150.6159, 59.5382],
    [-150.6250, 59.5424],
    [-150.6325, 59.5452],
    [-150.6413, 59.5453],
    [-150.6584, 59.5452],
    [-150.6644, 59.5415],
    [-150.6569, 59.5384],
    [-150.6508, 59.5337],
    [-150.6462, 59.5310],
    [-150.6424, 59.5292],
    [-150.6417, 59.5230],
    [-150.6337, 59.5251],
    [-150.6273, 59.5269],
    [-150.6223, 59.5228],
    [-150.6266, 59.5203],
    [-150.6199, 59.5202],
    [-150.6129, 59.5154],
    [-150.6082, 59.5057],
    [-150.5896, 59.5005],
    [-150.5808, 59.4931],
    [-150.5799, 59.4868],
    [-150.5796, 59.4795],
    [-150.5808, 59.4682],
    [-150.5890, 59.4696],
    [-150.5983, 59.4737],
    [-150.6031, 59.4715],
    [-150.6028, 59.4664],
    [-150.6101, 59.4687],
    [-150.6218, 59.4714],
    [-150.6433, 59.4686],
    [-150.6577, 59.4710],
    [-150.6550, 59.4684],
    [-150.6456, 59.4628],
    [-150.6335, 59.4599],
    [-150.6145, 59.4552],
    [-150.5981, 59.4537],
    [-150.5922, 59.4509],
    [-150.5887, 59.4491],
    [-150.5844, 59.4476],
    [-150.5823, 59.4463],
    [-150.5876, 59.4386],
    [-150.5927, 59.4383],
    [-150.5959, 59.4318],
    [-150.6030, 59.4245],
    [-150.6080, 59.4258],
    [-150.6155, 59.4250],
    [-150.6258, 59.4243],
    [-150.6382, 59.4211],
    [-150.6382, 59.4182],
    [-150.6505, 59.4199],
    [-150.6605, 59.4162],
    [-150.6753, 59.4233],
    [-150.6840, 59.4274],
    [-150.6930, 59.4282],
    [-150.7009, 59.4330],
    [-150.7084, 59.4307],
    [-150.7324, 59.4243],
    [-150.7394, 59.4228],
    [-150.7409, 59.4164],
    [-150.7493, 59.3990],
    [-150.7609, 59.3905],
    [-150.7698, 59.3795],
    [-150.7731, 59.3739],
    [-150.7861, 59.3721],
    [-150.7962, 59.3653],
    [-150.8072, 59.3608],
    [-150.8165, 59.3607],
    [-150.8438, 59.3575],
    [-150.8463, 59.3527],
    [-150.8453, 59.3502],
    [-150.8407, 59.3483],
    [-150.8513, 59.3411],
    [-150.8706, 59.3247],
    [-150.8766, 59.3214],
    [-150.8771, 59.3170],
    [-150.8941, 59.3180],
    [-150.9010, 59.3169],
    [-150.9105, 59.3151],
    [-150.9168, 59.3113],
    [-150.9225, 59.3085],
    [-150.9299, 59.3095],
    [-150.9397, 59.3099],
    [-150.9486, 59.3086],
    [-150.9495, 59.3058],
    [-150.9423, 59.3039],
    [-150.9282, 59.3011],
    [-150.9119, 59.3017],
    [-150.9114, 59.2969],
    [-150.9062, 59.2937],
    [-150.9015, 59.2897],
    [-150.8959, 59.2884],
    [-150.8941, 59.2856],
    [-150.8947, 59.2768],
    [-150.8898, 59.2727],
    [-150.8863, 59.2691],
    [-150.8870, 59.2660],
    [-150.8892, 59.2638],
    [-150.8978, 59.2556],
    [-150.9027, 59.2549],
    [-150.9115, 59.2482],
    [-150.9214, 59.2428],
    [-150.9340, 59.2369],
    [-150.9422, 59.2331],
    [-150.9614, 59.2324],
    [-150.9715, 59.2344],
    [-150.9741, 59.2371],
    [-150.9860, 59.2350],
    [-150.9905, 59.2302],
    [-150.9893, 59.2254],
    [-150.9975, 59.2233],
    [-150.9984, 59.2171],
    [-150.9879, 59.2122],
    [-150.9702, 59.2026],
    [-150.9621, 59.1979],
    [-150.9782, 59.1996],
    [-151.0017, 59.2069],
    [-151.0128, 59.2103],
    [-151.0211, 59.2202],
    [-151.0082, 59.2222],
    [-151.0066, 59.2289],
    [-151.0165, 59.2353],
    [-151.0222, 59.2389],
    [-151.0182, 59.2423],
    [-151.0218, 59.2492],
    [-150.9968, 59.2577],
    [-150.9798, 59.2564],
    [-150.9757, 59.2590],
    [-150.9830, 59.2623],
    [-150.9904, 59.2638],
    [-151.0014, 59.2657],
    [-150.9926, 59.2707],
    [-150.9836, 59.2745],
    [-150.9755, 59.2772],
    [-150.9788, 59.2799],
    [-150.9875, 59.2767],
    [-150.9959, 59.2758],
    [-151.0058, 59.2725],
    [-151.0226, 59.2701],
    [-151.0340, 59.2781],
    [-151.0255, 59.2838],
    [-151.0309, 59.2884],
    [-151.0413, 59.2931],
    [-151.0436, 59.3021],
    [-151.0354, 59.3086],
    [-151.0334, 59.3123],
    [-151.0234, 59.3135],
    [-151.0214, 59.3205],
    [-151.0251, 59.3242],
    [-151.0365, 59.3240],
    [-151.0412, 59.3168],
    [-151.0456, 59.3082],
    [-151.0556, 59.3036],
    [-151.0680, 59.2924],
    [-151.0682, 59.2841],
    [-151.0809, 59.2764],
    [-151.0853, 59.2702],
    [-151.0979, 59.2725],
    [-151.1031, 59.2773],
    [-151.1198, 59.2836],
    [-151.1324, 59.2832],
    [-151.1403, 59.2887],
    [-151.1475, 59.2841],
    [-151.1659, 59.2888],
    [-151.1913, 59.2976],
    [-151.2060, 59.3038],
    [-151.2186, 59.3015],
    [-151.2410, 59.3007],
    [-151.2567, 59.3067],
    [-151.2847, 59.3100],
    [-151.3130, 59.3103],
    [-151.2964, 59.3046],
    [-151.2842, 59.2994],
    [-151.2645, 59.2948],
    [-151.2441, 59.2864],
    [-151.2327, 59.2842],
    [-151.1973, 59.2818],
    [-151.1752, 59.2789],
    [-151.1538, 59.2674],
    [-151.1532, 59.2634],
    [-151.1404, 59.2615],
    [-151.1361, 59.2589],
    [-151.1281, 59.2598],
    [-151.1207, 59.2620],
    [-151.1188, 59.2556],
    [-151.1021, 59.2549],
    [-151.0990, 59.2416],
    [-151.1046, 59.2388],
    [-151.1017, 59.2362],
    [-151.1023, 59.2331],
    [-151.1044, 59.2288],
    [-151.0994, 59.2253],
    [-151.1017, 59.2240],
    [-151.1084, 59.2234],
    [-151.1100, 59.2174],
    [-151.1167, 59.2150],
    [-151.1226, 59.2146],
    [-151.1265, 59.2109],
    [-151.1424, 59.2084],
    [-151.1635, 59.2034],
    [-151.1719, 59.2031],
    [-151.1757, 59.2055],
    [-151.1841, 59.2036],
    [-151.1868, 59.2066],
    [-151.1951, 59.2068],
    [-151.1910, 59.2106],
    [-151.2013, 59.2131],
    [-151.2057, 59.2188],
    [-151.2149, 59.2218],
    [-151.2278, 59.2205],
    [-151.2182, 59.2146],
    [-151.2230, 59.2115],
    [-151.2277, 59.2107],
    [-151.2368, 59.2062],
    [-151.2450, 59.2023],
    [-151.2549, 59.2078],
    [-151.2600, 59.2223],
    [-151.2675, 59.2281],
    [-151.2828, 59.2312],
    [-151.2897, 59.2349],
    [-151.2935, 59.2398],
    [-151.3016, 59.2416],
    [-151.3030, 59.2362],
    [-151.2989, 59.2303],
    [-151.2884, 59.2268],
    [-151.2876, 59.2185],
    [-151.3072, 59.2104],
    [-151.3166, 59.2139],
    [-151.3258, 59.2170],
    [-151.3305, 59.2202],
    [-151.3427, 59.2230],
    [-151.3551, 59.2292],
    [-151.3672, 59.2366],
    [-151.3722, 59.2390],
    [-151.3775, 59.2426],
    [-151.3829, 59.2448],
    [-151.3862, 59.2472],
    [-151.3956, 59.2516],
    [-151.4145, 59.2585],
    [-151.4217, 59.2564],
    [-151.4179, 59.2491],
    [-151.4282, 59.2521],
    [-151.4361, 59.2540],
    [-151.4425, 59.2518],
    [-151.4423, 59.2482],
    [-151.4485, 59.2484],
    [-151.4412, 59.2400],
    [-151.4562, 59.2328],
    [-151.4633, 59.2369],
    [-151.4677, 59.2406],
    [-151.4750, 59.2374],
    [-151.4810, 59.2364],
    [-151.4885, 59.2349],
    [-151.4939, 59.2330],
    [-151.4947, 59.2292],
    [-151.5105, 59.2252],
    [-151.5206, 59.2278],
    [-151.5339, 59.2280],
    [-151.5461, 59.2288],
    [-151.5529, 59.2266],
    [-151.5447, 59.2240],
    [-151.5275, 59.2217],
    [-151.5165, 59.2173],
    [-151.5030, 59.2150],
    [-151.4913, 59.2135],
    [-151.4859, 59.2155],
    [-151.4665, 59.2147],
    [-151.4600, 59.2069],
    [-151.4664, 59.2031],
    [-151.4770, 59.2037],
    [-151.4844, 59.2042],
    [-151.4891, 59.2037],
    [-151.4913, 59.2054],
    [-151.4982, 59.2029],
    [-151.5017, 59.2002],
    [-151.4973, 59.1967],
    [-151.5027, 59.1951],
    [-151.5121, 59.1943],
    [-151.5211, 59.1958],
    [-151.5419, 59.1986],
    [-151.5488, 59.1986],
    [-151.5516, 59.2007],
    [-151.5589, 59.2018],
    [-151.5581, 59.2062],
    [-151.5639, 59.2073],
    [-151.5736, 59.2046],
    [-151.5811, 59.1993],
    [-151.5868, 59.1941],
    [-151.5919, 59.1914],
    [-151.5999, 59.1897],
    [-151.6101, 59.1894],
    [-151.6290, 59.1885],
    [-151.6332, 59.1862],
    [-151.6239, 59.1843],
    [-151.6166, 59.1813],
    [-151.6093, 59.1806],
    [-151.6018, 59.1807],
    [-151.5913, 59.1777],
    [-151.5882, 59.1768],
    [-151.5825, 59.1759],
    [-151.5771, 59.1737],
    [-151.5724, 59.1740],
    [-151.5802, 59.1673],
    [-151.5867, 59.1644],
    [-151.5945, 59.1633],
    [-151.6080, 59.1648],
    [-151.6256, 59.1643],
    [-151.6384, 59.1631],
    [-151.6461, 59.1643],
    [-151.6594, 59.1645],
    [-151.6723, 59.1627],
    [-151.6818, 59.1611],
    [-151.6917, 59.1623],
    [-151.7001, 59.1635],
    [-151.7073, 59.1604],
    [-151.7175, 59.1578],
    [-151.7248, 59.1556],
    [-151.7390, 59.1575],
    [-151.7499, 59.1612],
    [-151.7533, 59.1654],
    [-151.7570, 59.1686],
    [-151.7610, 59.1741],
    [-151.7616, 59.1833],
    [-151.7625, 59.1923],
    [-151.7560, 59.2020],
    [-151.7585, 59.2051],
    [-151.7603, 59.2093],
    [-151.7585, 59.2157],
    [-151.7533, 59.2144],
    [-151.7456, 59.2150],
    [-151.7393, 59.2112],
    [-151.7291, 59.2108],
    [-151.7209, 59.2064],
    [-151.7178, 59.2104],
    [-151.7148, 59.2125],
    [-151.7212, 59.2150],
    [-151.7206, 59.2169],
    [-151.7158, 59.2196],
    [-151.7073, 59.2200],
    [-151.7023, 59.2226],
    [-151.7087, 59.2242],
    [-151.7154, 59.2220],
    [-151.7221, 59.2218],
    [-151.7351, 59.2236],
    [-151.7386, 59.2198],
    [-151.7462, 59.2231],
    [-151.7585, 59.2248],
    [-151.7692, 59.2217],
    [-151.7766, 59.2180],
    [-151.7863, 59.2154],
    [-151.7932, 59.2126],
    [-151.8004, 59.2094],
    [-151.8067, 59.2108],
    [-151.8109, 59.2135],
    [-151.8158, 59.2146],
    [-151.8246, 59.2113],
    [-151.8228, 59.2087],
    [-151.8155, 59.2073],
    [-151.8150, 59.2051],
    [-151.8212, 59.2030],
    [-151.8287, 59.2043],
    [-151.8344, 59.2071],
    [-151.8420, 59.2112],
    [-151.8491, 59.2108],
    [-151.8625, 59.2104],
    [-151.8775, 59.2144],
    [-151.8931, 59.2202],
    [-151.9078, 59.2263],
    [-151.9143, 59.2277],
    [-151.9162, 59.2338],
    [-151.9062, 59.2380],
    [-151.8882, 59.2372],
    [-151.8808, 59.2379],
    [-151.8770, 59.2399],
    [-151.8800, 59.2444],
    [-151.8906, 59.2512],
    [-151.9083, 59.2516],
    [-151.9227, 59.2544],
    [-151.9325, 59.2538],
    [-151.9497, 59.2512],
    [-151.9593, 59.2476],
    [-151.9663, 59.2511],
    [-151.9792, 59.2587],
    [-151.9778, 59.2646],
    [-151.9797, 59.2711],
    [-151.9832, 59.2744],
    [-151.9797, 59.2789],
    [-151.9808, 59.2878],
    [-151.9844, 59.2976],
    [-151.9893, 59.3031],
    [-151.9914, 59.3127],
    [-151.9710, 59.3195],
    [-151.9639, 59.3273],
    [-151.9667, 59.3320],
    [-151.9613, 59.3335],
    [-151.9638, 59.3370],
    [-151.9643, 59.3412],
    [-151.9603, 59.3462],
    [-151.9527, 59.3494],
    [-151.9282, 59.3519],
    [-151.9247, 59.3572],
    [-151.9229, 59.3594],
    [-151.9128, 59.3608],
    [-151.9040, 59.3602],
    [-151.8914, 59.3596],
    [-151.8806, 59.3602],
    [-151.8714, 59.3585],
    [-151.8581, 59.3551],
    [-151.8516, 59.3548],
    [-151.8354, 59.3537],
    [-151.8269, 59.3510],
    [-151.8228, 59.3471],
    [-151.8218, 59.3445],
    [-151.8194, 59.3425],
    [-151.8156, 59.3410],
    [-151.8112, 59.3424],
    [-151.8112, 59.3465],
    [-151.8033, 59.3464],
    [-151.8044, 59.3427],
    [-151.7981, 59.3410],
    [-151.7934, 59.3385],
    [-151.7951, 59.3353],
    [-151.7943, 59.3305],
    [-151.7886, 59.3300],
    [-151.7797, 59.3267],
    [-151.7766, 59.3234],
    [-151.7734, 59.3208],
    [-151.7638, 59.3248],
    [-151.7685, 59.3262],
    [-151.7707, 59.3306],
    [-151.7767, 59.3336],
    [-151.7812, 59.3382],
    [-151.7840, 59.3446],
    [-151.7872, 59.3502],
    [-151.7932, 59.3537],
    [-151.8027, 59.3582],
    [-151.8140, 59.3605],
    [-151.8196, 59.3628],
    [-151.8256, 59.3647],
    [-151.8346, 59.3648],
    [-151.8402, 59.3664],
    [-151.8556, 59.3694],
    [-151.8676, 59.3712],
    [-151.8689, 59.3740],
    [-151.8639, 59.3763],
    [-151.8699, 59.3806],
    [-151.8767, 59.3840],
    [-151.8834, 59.3825],
    [-151.8914, 59.3851],
    [-151.8965, 59.3889],
    [-151.8941, 59.3919],
    [-151.8994, 59.3961],
    [-151.9054, 59.3947],
    [-151.9052, 59.4010],
    [-151.8963, 59.4031],
    [-151.8894, 59.4091],
    [-151.8864, 59.4154],
    [-151.8878, 59.4248],
    [-151.8762, 59.4228],
    [-151.8711, 59.4266],
    [-151.8580, 59.4262],
    [-151.8499, 59.4295],
    [-151.8430, 59.4327],
    [-151.8330, 59.4342],
    [-151.8256, 59.4386],
    [-151.8134, 59.4364],
    [-151.7983, 59.4391],
    [-151.7865, 59.4454],
    [-151.7628, 59.4447],
    [-151.7529, 59.4473],
    [-151.7424, 59.4536],
    [-151.7427, 59.4475],
    [-151.7370, 59.4442],
    [-151.7427, 59.4363],
    [-151.7420, 59.4321],
    [-151.7433, 59.4287],
    [-151.7355, 59.4235],
    [-151.7285, 59.4164],
    [-151.7168, 59.4141],
    [-151.7197, 59.4119],
    [-151.7080, 59.4055],
    [-151.7028, 59.4021],
    [-151.6954, 59.3986],
    [-151.6916, 59.3950],
    [-151.6851, 59.3961],
    [-151.6818, 59.4005],
    [-151.6891, 59.4028],
    [-151.6920, 59.4061],
    [-151.6973, 59.4094],
    [-151.6940, 59.4131],
    [-151.6966, 59.4141],
    [-151.7068, 59.4180],
    [-151.7111, 59.4208],
    [-151.7179, 59.4226],
    [-151.7096, 59.4251],
    [-151.7141, 59.4267],
    [-151.7162, 59.4291],
    [-151.7163, 59.4320],
    [-151.7200, 59.4333],
    [-151.7217, 59.4409],
    [-151.7169, 59.4454],
    [-151.7177, 59.4545],
    [-151.7109, 59.4555],
    [-151.7101, 59.4658],
    [-151.7050, 59.4700],
    [-151.6866, 59.4713],
    [-151.6639, 59.4761],
    [-151.6516, 59.4849],
    [-151.6345, 59.4824],
    [-151.6219, 59.4800],
    [-151.6102, 59.4773],
    [-151.5848, 59.4791],
    [-151.5704, 59.4861],
    [-151.5589, 59.4826],
    [-151.5648, 59.4811],
    [-151.5743, 59.4751],
    [-151.5594, 59.4681],
    [-151.5448, 59.4716],
    [-151.5285, 59.4723],
    [-151.5237, 59.4852],
    [-151.4983, 59.4820],
    [-151.4710, 59.4722],
    [-151.4443, 59.4661],
    [-151.4346, 59.4679],
    [-151.4429, 59.4745],
    [-151.4600, 59.4847],
    [-151.4728, 59.4957],
    [-151.4726, 59.5031],
    [-151.4422, 59.5313],
    [-151.4346, 59.5440],
    [-151.4153, 59.5471],
    [-151.3994, 59.5413],
    [-151.3737, 59.5481],
    [-151.3590, 59.5593],
    [-151.3241, 59.5699],
    [-151.3201, 59.5777],
    [-151.3065, 59.5786],
    [-151.3012, 59.5800],
    [-151.2912, 59.5761],
    [-151.2841, 59.5746],
    [-151.2776, 59.5721],
    [-151.2717, 59.5765],
    [-151.2669, 59.5795],
    [-151.2701, 59.5824],
    [-151.2763, 59.5917],
    [-151.2748, 59.5970],
    [-151.2461, 59.5995],
    [-151.2380, 59.5978],
    [-151.2278, 59.5990],
    [-151.2150, 59.6002],
    [-151.2017, 59.5915],
    [-151.1736, 59.5893],
    [-151.1643, 59.5870],
    [-151.1583, 59.5941],
    [-151.1654, 59.6013],
    [-151.1717, 59.6021],
    [-151.1867, 59.6038],
    [-151.1910, 59.6143],
    [-151.2047, 59.6411],
    [-151.1856, 59.6495],
    [-151.1685, 59.6541],
    [-151.1445, 59.6644],
    [-151.1344, 59.6687],
    [-151.1151, 59.6682],
    [-151.1073, 59.6725],
    [-151.1214, 59.6747],
    [-151.1154, 59.6853],
    [-151.1099, 59.7015],
    [-151.0983, 59.7094],
    [-151.0785, 59.7154],
    [-151.0709, 59.7247],
    [-151.0581, 59.7291],
    [-151.0450, 59.7243],
    [-151.0460, 59.7330],
    [-151.0507, 59.7455],
    [-151.0415, 59.7454],
    [-151.0172, 59.7469],
    [-151.0170, 59.7605],
    [-150.9933, 59.7669],
    [-150.9780, 59.7666],
    [-150.9631, 59.7796],
    [-150.9374, 59.7880],
    [-150.9273, 59.7934],
    [-150.9559, 59.7920],
    [-150.9835, 59.7896],
    [-150.9938, 59.7917],
    [-150.9946, 59.7980],
    [-151.0265, 59.7963],
    [-151.0664, 59.7914],
    [-151.0788, 59.7864],
    [-151.0930, 59.7849],
    [-151.1066, 59.7813],
    [-151.1370, 59.7675],
    [-151.1625, 59.7550],
    [-151.1945, 59.7398],
    [-151.2216, 59.7283],
    [-151.2459, 59.7168],
    [-151.2837, 59.7041],
    [-151.3269, 59.6867],
    [-151.3683, 59.6819],
    [-151.3771, 59.6813],
    [-151.4015, 59.6758],
    [-151.4286, 59.6692],
    [-151.4379, 59.6651],
    [-151.4487, 59.6482],
    [-151.4859, 59.6381],
    [-151.4795, 59.6293],
    [-151.4579, 59.6226],
    [-151.4322, 59.6086],
    [-151.4179, 59.6054],
    [-151.4089, 59.6002],
    [-151.4313, 59.6043],
    [-151.4607, 59.6197],
    [-151.4978, 59.6318],
    [-151.5287, 59.6339],
    [-151.5387, 59.6366],
    [-151.5813, 59.6418],
    [-151.6152, 59.6453],
    [-151.6357, 59.6494],
    [-151.6499, 59.6515],
    [-151.6799, 59.6597],
    [-151.7007, 59.6683],
    [-151.7146, 59.6740],
    [-151.7604, 59.6912],
    [-151.8043, 59.7084],
    [-151.8448, 59.7358],
    [-151.8679, 59.7661],
    [-151.8719, 59.7725],
    [-151.8626, 59.7803],
    [-151.8589, 59.7865],
    [-151.8462, 59.8018],
    [-151.8176, 59.8383],
    [-151.8043, 59.8687],
    [-151.7897, 59.8872],
    [-151.7819, 59.8942],
    [-151.7609, 59.9114],
    [-151.7483, 59.9320],
    [-151.7319, 59.9655],
    [-151.7211, 60.0011],
    [-151.7029, 60.0323],
    [-151.6787, 60.0434],
    [-151.6614, 60.0571],
    [-151.6271, 60.0855],
    [-151.6069, 60.0996],
    [-151.5247, 60.1412],
    [-151.4894, 60.1671],
    [-151.4066, 60.2282],
    [-151.3951, 60.2495],
    [-151.3839, 60.2887],
    [-151.3821, 60.3446],
    [-151.3773, 60.3655],
    [-151.3691, 60.3715],
    [-151.3536, 60.3758],
    [-151.3279, 60.3806],
    [-151.3169, 60.3874],
    [-151.3061, 60.3872],
    [-151.2993, 60.3864],
    [-151.2941, 60.4083],
    [-151.2840, 60.4522],
    [-151.2810, 60.4850],
    [-151.2782, 60.5214],
    [-151.2699, 60.5387],
    [-151.2639, 60.5468],
    [-151.2712, 60.5500],
    [-151.3240, 60.5741],
    [-151.3367, 60.5876],
    [-151.3386, 60.5930],
    [-151.3459, 60.6122],
    [-151.3512, 60.6338],
    [-151.3580, 60.6467],
    [-151.3749, 60.6644],
    [-151.3976, 60.6865],
    [-151.3996, 60.6918],
    [-151.4103, 60.7110],
    [-151.4042, 60.7232],
    [-151.3898, 60.7283],
    [-151.3735, 60.7332],
    [-151.3240, 60.7395],
    [-151.3083, 60.7416],
    [-151.2796, 60.7477],
    [-151.2630, 60.7577],
    [-151.2611, 60.7724],
    [-151.2459, 60.7764],
    [-151.1612, 60.7815],
    [-151.1097, 60.7835],
    [-151.0813, 60.7860],
    [-151.0567, 60.7895],
    [-151.0258, 60.7963],
    [-151.0220, 60.8029],
    [-150.9985, 60.8141],
    [-150.9419, 60.8365],
    [-150.8962, 60.8543],
    [-150.8865, 60.8610],
    [-150.8678, 60.8684],
    [-150.8656, 60.8712],
    [-150.8107, 60.8920],
    [-150.7553, 60.9180],
    [-150.7259, 60.9298],
    [-150.7078, 60.9384],
    [-150.6954, 60.9462],
    [-150.6906, 60.9535],
    [-150.6784, 60.9583],
    [-150.6586, 60.9607],
    [-150.5849, 60.9800],
    [-150.5479, 60.9914],
    [-150.5116, 61.0045],
    [-150.4720, 61.0123],
    [-150.4319, 61.0239],
    [-150.3899, 61.0384],
    [-150.3537, 61.0318],
    [-150.3296, 61.0112],
    [-150.2897, 60.9661],
    [-150.2336, 60.9305],
    [-150.2089, 60.9136],
    [-150.1863, 60.9013],
    [-150.1399, 60.9019],
    [-150.0912, 60.8858],
    [-150.0653, 60.8912],
    [-150.0442, 60.8846],
    [-150.0194, 60.8740],
    [-150.0211, 60.8650],
    [-149.9995, 60.8640],
    [-149.9900, 60.8890],
    [-149.9759, 60.8931],
    [-149.9660, 60.8990],
    [-149.9487, 60.8986],
    [-149.9377, 60.9114],
    [-149.9195, 60.9255],
    [-149.9046, 60.9329],
    [-149.8924, 60.9482],
    [-149.8722, 60.9603],
    [-149.8537, 60.9674],
    [-149.8268, 60.9668],
    [-149.8014, 60.9681],
    [-149.7790, 60.9668],
    [-149.7655, 60.9659],
    [-149.7531, 60.9621],
    [-149.7327, 60.9570],
    [-149.7243, 60.9578],
    [-149.7068, 60.9552],
    [-149.6956, 60.9504],
    [-149.6762, 60.9456],
    [-149.6693, 60.9449],
    [-149.6684, 60.9390],
    [-149.6621, 60.9321],
    [-149.6459, 60.9238],
    [-149.6308, 60.9243],
    [-149.6077, 60.9265],
    [-149.5790, 60.9338],
    [-149.5658, 60.9354],
    [-149.5434, 60.9301],
    [-149.5326, 60.9275],
    [-149.5253, 60.9245],
    [-149.5107, 60.9246],
    [-149.4892, 60.9202],
    [-149.4706, 60.9179],
    [-149.4600, 60.9132],
    [-149.4560, 60.9087],
    [-149.4440, 60.9086],
    [-149.4389, 60.9057],
    [-149.4308, 60.9020],
    [-149.4237, 60.9028],
    [-149.4195, 60.9079],
    [-149.4024, 60.9043],
    [-149.3920, 60.8996],
    [-149.3769, 60.8967],
    [-149.3354, 60.8950],
    [-149.2932, 60.8960],
    [-149.2616, 60.8950],
    [-149.2507, 60.8956],
    [-149.2417, 60.8901],
    [-149.2267, 60.8879],
    [-149.2150, 60.8890],
    [-149.2043, 60.8877],
    [-149.1900, 60.8895],
    [-149.1587, 60.8810],
    [-149.1466, 60.8771],
    [-149.1151, 60.8776],
    [-149.0900, 60.8672],
    [-149.0621, 60.8590],
    [-149.0507, 60.8487],
    [-149.0337, 60.8459],
    [-149.0129, 60.8354],
    [-149.0036, 60.8474],
    [-149.0316, 60.8667],
    [-149.0529, 60.8879],
    [-149.0779, 60.9039],
    [-149.0989, 60.9137],
    [-149.1376, 60.9215],
    [-149.1658, 60.9327],
    [-149.1833, 60.9407],
    [-149.1909, 60.9445],
    [-149.2253, 60.9399],
    [-149.2540, 60.9376],
    [-149.2844, 60.9365],
    [-149.3103, 60.9344],
    [-149.3366, 60.9299],
    [-149.3555, 60.9253],
    [-149.3649, 60.9278],
    [-149.3645, 60.9355],
    [-149.3769, 60.9453],
    [-149.4114, 60.9519],
    [-149.4317, 60.9609],
    [-149.4409, 60.9622],
    [-149.4444, 60.9656],
    [-149.4607, 60.9716],
    [-149.4685, 60.9728],
    [-149.4833, 60.9776],
    [-149.5028, 60.9853],
    [-149.5192, 60.9867],
    [-149.5329, 60.9838],
    [-149.5537, 60.9830],
    [-149.5733, 60.9843],
    [-149.5920, 60.9824],
    [-149.6083, 60.9845],
    [-149.6271, 60.9934],
    [-149.6445, 60.9997],
    [-149.6539, 61.0012],
    [-149.6769, 61.0046],
    [-149.6957, 61.0073],
    [-149.7109, 61.0125],
    [-149.7240, 61.0150],
    [-149.7421, 61.0188],
    [-149.7532, 61.0271],
    [-149.7664, 61.0315],
    [-149.7835, 61.0388],
    [-149.7955, 61.0497],
    [-149.8155, 61.0642],
    [-149.8298, 61.0748],
    [-149.8319, 61.0762],
    [-149.8406, 61.0813],
    [-149.8516, 61.0872],
    [-149.8805, 61.0960],
    [-149.9009, 61.0991],
    [-149.9393, 61.1148],
    [-149.9631, 61.1290],
    [-149.9834, 61.1354],
    [-150.0250, 61.1426],
    [-150.0720, 61.1536],
    [-150.0691, 61.1637],
    [-150.0401, 61.1775],
    [-150.0292, 61.1863],
    [-150.0258, 61.1989],
    [-150.0196, 61.2037],
    [-149.9920, 61.1996],
    [-149.9706, 61.1992],
    [-149.9540, 61.2018],
    [-149.9342, 61.2060],
    [-149.9280, 61.2069],
    [-149.9240, 61.2093],
    [-149.9129, 61.2158],
    [-149.9041, 61.2205],
    [-149.9074, 61.2256],
    [-149.8860, 61.2440],
    [-149.8825, 61.2515],
    [-149.8796, 61.2578],
    [-149.8638, 61.2670],
    [-149.8464, 61.2826],
    [-149.8293, 61.3010],
    [-149.8090, 61.3162],
    [-149.7797, 61.3269],
    [-149.7693, 61.3276],
    [-149.7476, 61.3277],
    [-149.7307, 61.3300],
    [-149.7170, 61.3369],
    [-149.7139, 61.3496],
    [-149.7138, 61.3645],
    [-149.7214, 61.3725],
    [-149.7101, 61.3791],
    [-149.6895, 61.3839],
    [-149.6693, 61.3887],
    [-149.6413, 61.3872],
    [-149.6207, 61.3919],
    [-149.6033, 61.3981],
    [-149.5857, 61.4039],
    [-149.5688, 61.4093],
    [-149.5516, 61.4083],
    [-149.5277, 61.4111],
    [-149.5177, 61.4191],
    [-149.4968, 61.4274],
    [-149.4666, 61.4369],
    [-149.4505, 61.4425],
    [-149.4366, 61.4506],
    [-149.4248, 61.4624],
    [-149.4790, 61.4681],
    [-149.5234, 61.4814],
    [-149.5381, 61.4972],
    [-149.5507, 61.4945],
    [-149.5785, 61.4913],
    [-149.5997, 61.4947],
    [-149.6061, 61.4936],
    [-149.6161, 61.4929],
    [-149.6553, 61.4835],
    [-149.6691, 61.4789],
    [-149.6812, 61.4719],
    [-149.7066, 61.4654],
    [-149.7188, 61.4574],
    [-149.7341, 61.4551],
    [-149.7574, 61.4468],
    [-149.7719, 61.4349],
    [-149.7775, 61.4239],
    [-149.7949, 61.4126],
    [-149.8074, 61.4010],
    [-149.8281, 61.3941],
    [-149.8537, 61.3923],
    [-149.8750, 61.3866],
    [-149.8875, 61.3763],
    [-149.8892, 61.3675],
    [-149.8982, 61.3527],
    [-149.9146, 61.3355],
    [-149.9183, 61.3235],
    [-149.9118, 61.3109],
    [-149.9165, 61.2956],
    [-149.9207, 61.2843],
    [-149.9217, 61.2772],
    [-149.9188, 61.2699],
    [-149.9174, 61.2674],
    [-149.9253, 61.2620],
    [-149.9497, 61.2541],
    [-149.9609, 61.2504],
    [-149.9739, 61.2448],
    [-149.9859, 61.2375],
    [-150.0082, 61.2418],
    [-150.0748, 61.2535],
    [-150.2301, 61.2570],
    [-150.2729, 61.2555],
    [-150.3036, 61.2559],
    [-150.3887, 61.2459],
    [-150.4844, 61.2473],
    [-150.5293, 61.2722],
    [-150.5343, 61.2798],
    [-150.5384, 61.2836],
    [-150.5424, 61.2859],
    [-150.5517, 61.2947],
    [-150.5928, 61.2856],
    [-150.6070, 61.2777],
    [-150.6271, 61.2824],
    [-150.6559, 61.2936],
    [-150.6654, 61.2866],
    [-150.6847, 61.2643],
    [-150.7075, 61.2542],
    [-150.7408, 61.2463],
    [-150.7965, 61.2340],
    [-150.8460, 61.2199],
    [-150.8742, 61.2109],
    [-150.9174, 61.2079],
    [-150.9421, 61.2093],
    [-150.9521, 61.2011],
    [-150.9635, 61.1926],
    [-150.9994, 61.1842],
    [-151.0172, 61.1784],
    [-151.0348, 61.1708],
    [-151.0651, 61.1483],
    [-151.0723, 61.1420],
    [-151.0795, 61.1307],
    [-151.1012, 61.1079],
    [-151.1151, 61.0968],
    [-151.1191, 61.0890],
    [-151.1381, 61.0661],
    [-151.1698, 61.0456],
    [-151.1903, 61.0427],
    [-151.2196, 61.0407],
    [-151.2796, 61.0376],
    [-151.3098, 61.0308],
    [-151.3180, 61.0242],
    [-151.3413, 61.0116],
    [-151.3622, 61.0094],
    [-151.4233, 61.0136],
    [-151.4679, 61.0124],
    [-151.4935, 61.0111],
    [-151.5214, 61.0000],
    [-151.5737, 60.9759],
    [-151.6221, 60.9582],
    [-151.6403, 60.9462],
    [-151.6926, 60.9177],
    [-151.7208, 60.9043],
    [-151.7442, 60.8889],
    [-151.7917, 60.8631],
    [-151.8003, 60.8496],
    [-151.7961, 60.8341],
    [-151.7849, 60.8170],
    [-151.7690, 60.8006],
    [-151.7540, 60.7887],
    [-151.7310, 60.7634],
    [-151.7060, 60.7324],
    [-151.7062, 60.7192],
    [-151.7164, 60.7104],
    [-151.7322, 60.7118],
    [-151.7500, 60.7139],
    [-151.7547, 60.7169],
    [-151.7603, 60.7214],
    [-151.7674, 60.7243],
    [-151.8090, 60.7303],
    [-151.8226, 60.7424],
    [-151.8456, 60.7545],
    [-151.8733, 60.7602],
    [-151.8956, 60.7716],
    [-151.9052, 60.7800],
    [-151.9154, 60.7705],
    [-151.9011, 60.7585],
    [-151.8843, 60.7555],
    [-151.8596, 60.7462],
    [-151.8525, 60.7339],
    [-151.8830, 60.7252],
    [-151.9047, 60.7216],
    [-151.9190, 60.7155],
    [-151.9808, 60.6908],
    [-152.0052, 60.6792],
    [-152.0331, 60.6634],
    [-152.0481, 60.6532],
    [-152.0610, 60.6429],
    [-152.0717, 60.6357],
    [-152.0792, 60.6247],
    [-152.0922, 60.6030],
    [-152.1239, 60.5838],
    [-152.1458, 60.5782],
    [-152.1803, 60.5740],
    [-152.2199, 60.5581],
    [-152.2659, 60.5369],
    [-152.2810, 60.5268],
    [-152.3091, 60.5072],
    [-152.3216, 60.4905],
    [-152.3173, 60.4864],
    [-152.3269, 60.4784],
    [-152.3328, 60.4646],
    [-152.3303, 60.4431],
    [-152.3182, 60.4246],
    [-152.3020, 60.4143],
    [-152.2736, 60.4089],
    [-152.2521, 60.3997],
    [-152.2373, 60.3964],
    [-152.2408, 60.3926],
    [-152.2768, 60.3798],
    [-152.3006, 60.3705],
    [-152.3073, 60.3644],
    [-152.3119, 60.3598],
    [-152.3420, 60.3586],
    [-152.3720, 60.3514],
    [-152.3763, 60.3431],
    [-152.3831, 60.3339],
    [-152.3874, 60.3246],
    [-152.3874, 60.3182],
    [-152.3935, 60.3077],
    [-152.3939, 60.3033],
    [-152.4080, 60.2940],
    [-152.4141, 60.2890],
    [-152.4269, 60.2862],
    [-152.4372, 60.2856],
    [-152.4538, 60.2836],
    [-152.4799, 60.2769],
    [-152.5106, 60.2644],
    [-152.5329, 60.2505],
    [-152.5430, 60.2416],
    [-152.5487, 60.2325],
    [-152.5556, 60.2273],
    [-152.5576, 60.2223],
    [-152.5664, 60.2236],
    [-152.6103, 60.2216],
    [-152.6269, 60.2194],
    [-152.6248, 60.2223],
    [-152.6269, 60.2254],
    [-152.6426, 60.2253],
    [-152.6448, 60.2326],
    [-152.6593, 60.2407],
    [-152.6772, 60.2443],
    [-152.6794, 60.2393],
    [-152.6759, 60.2349],
    [-152.6877, 60.2354],
    [-152.6977, 60.2395],
    [-152.7046, 60.2354],
    [-152.7129, 60.2346],
    [-152.7209, 60.2423],
    [-152.7378, 60.2320],
    [-152.7367, 60.2278],
    [-152.7394, 60.2234],
    [-152.7571, 60.2293],
    [-152.7642, 60.2282],
    [-152.7783, 60.2270],
    [-152.8151, 60.2330],
    [-152.8503, 60.2362],
    [-152.8777, 60.2459],
    [-152.8760, 60.2349],
    [-152.8368, 60.2119],
    [-152.7945, 60.1989],
    [-152.7645, 60.1947],
    [-152.7495, 60.1896],
    [-152.7460, 60.1848],
    [-152.7343, 60.1748],
    [-152.7120, 60.1670],
    [-152.6930, 60.1649],
    [-152.6782, 60.1644],
    [-152.6845, 60.1622],
    [-152.6818, 60.1580],
    [-152.6751, 60.1500],
    [-152.6864, 60.1377],
    [-152.6637, 60.1277],
    [-152.6586, 60.1228],
    [-152.6467, 60.1177],
    [-152.6387, 60.1159],
    [-152.6331, 60.1122],
    [-152.6120, 60.1068],
    [-152.5975, 60.1018],
    [-152.5892, 60.0906],
    [-152.5835, 60.0858],
    [-152.5730, 60.0785],
    [-152.5718, 60.0681],
    [-152.5752, 60.0632],
    [-152.5757, 60.0571],
    [-152.5798, 60.0450],
    [-152.5856, 60.0397],
    [-152.5973, 60.0316],
    [-152.5992, 60.0210],
    [-152.6066, 60.0127],
    [-152.6117, 60.0085],
    [-152.6465, 59.9891],
    [-152.6576, 59.9805],
    [-152.6773, 59.9688],
    [-152.6875, 59.9517],
    [-152.6906, 59.9344],
    [-152.6988, 59.9204],
    [-152.7085, 59.9127],
    [-152.7618, 59.9007],
    [-152.7918, 59.8954],
    [-152.8072, 59.8861],
    [-152.8107, 59.8816],
    [-152.8084, 59.8795],
    [-152.8084, 59.8777],
    [-152.8220, 59.8765],
    [-152.8313, 59.8786],
    [-152.8433, 59.8783],
    [-152.8662, 59.8746],
    [-152.8765, 59.8774],
    [-152.8807, 59.8824],
    [-152.8943, 59.8823],
    [-152.9213, 59.8779],
    [-152.9466, 59.8759],
    [-152.9474, 59.8781],
    [-152.9524, 59.8813],
    [-152.9606, 59.8833],
    [-152.9726, 59.8837],
    [-152.9991, 59.8862],
    [-153.0304, 59.8836],
    [-153.0609, 59.8767],
    [-153.0937, 59.8695],
    [-153.1303, 59.8616],
    [-153.1428, 59.8596],
    [-153.1641, 59.8640],
    [-153.1843, 59.8569],
    [-153.1973, 59.8579],
    [-153.1959, 59.8526],
    [-153.2078, 59.8441],
    [-153.2283, 59.8330],
    [-153.2352, 59.8275],
    [-153.2136, 59.8258],
    [-153.1723, 59.8179],
    [-153.1580, 59.8151],
    [-153.1462, 59.8075],
    [-153.1239, 59.8122],
    [-153.1090, 59.8151],
    [-153.0978, 59.8255],
    [-153.0897, 59.8336],
    [-153.0702, 59.8320],
    [-153.0566, 59.8314],
    [-153.0408, 59.8337],
    [-153.0248, 59.8344],
    [-153.0102, 59.8302],
    [-153.0023, 59.8258],
    [-152.9993, 59.8212],
    [-152.9967, 59.8170],
    [-152.9934, 59.8117],
    [-152.9933, 59.8060],
    [-152.9942, 59.7938],
    [-152.9985, 59.7854],
    [-153.0062, 59.7735],
    [-153.0131, 59.7648],
    [-153.0147, 59.7579],
    [-153.0199, 59.7451],
    [-153.0281, 59.7371],
    [-153.0331, 59.7272],
    [-153.0331, 59.7235],
    [-153.0353, 59.7174],
    [-153.0421, 59.7100],
    [-153.0478, 59.7028],
    [-153.0488, 59.6985],
    [-153.0553, 59.6925],
    [-153.0623, 59.6958],
    [-153.0802, 59.6896],
    [-153.0911, 59.6850],
    [-153.0976, 59.6833],
    [-153.1088, 59.6803],
    [-153.1147, 59.6805],
    [-153.1304, 59.6811],
    [-153.1473, 59.6725],
    [-153.1480, 59.6655],
    [-153.1532, 59.6586],
    [-153.1786, 59.6494],
    [-153.2041, 59.6401],
    [-153.2226, 59.6368],
    [-153.2400, 59.6341],
    [-153.2471, 59.6333],
    [-153.2487, 59.6365],
    [-153.2611, 59.6398],
    [-153.2670, 59.6426],
    [-153.2690, 59.6510],
    [-153.2742, 59.6584],
    [-153.2751, 59.6625],
    [-153.2814, 59.6703],
    [-153.3069, 59.6690],
    [-153.3196, 59.6640],
    [-153.3099, 59.6586],
    [-153.3077, 59.6522],
    [-153.3064, 59.6464],
    [-153.3020, 59.6372],
    [-153.3058, 59.6313],
    [-153.3161, 59.6258],
    [-153.3279, 59.6250],
    [-153.3417, 59.6220],
    [-153.3643, 59.6301],
    [-153.3720, 59.6345],
    [-153.3838, 59.6374],
    [-153.3986, 59.6392],
    [-153.4103, 59.6374],
    [-153.4216, 59.6405],
    [-153.4263, 59.6423],
    [-153.4193, 59.6496],
    [-153.4224, 59.6508],
    [-153.4004, 59.6591],
    [-153.3890, 59.6644],
    [-153.3893, 59.6715],
    [-153.3878, 59.6799],
    [-153.3879, 59.6854],
    [-153.3746, 59.6917],
    [-153.3720, 59.6984],
    [-153.3838, 59.7058],
    [-153.3735, 59.7162],
    [-153.3668, 59.7153],
    [-153.3603, 59.7217],
    [-153.3485, 59.7229],
    [-153.3392, 59.7213],
    [-153.3373, 59.7225],
    [-153.3428, 59.7269],
    [-153.3460, 59.7293],
    [-153.3483, 59.7330],
    [-153.3536, 59.7348],
    [-153.3565, 59.7357],
    [-153.3611, 59.7355],
    [-153.3708, 59.7318],
    [-153.3847, 59.7357],
    [-153.4014, 59.7460],
    [-153.4171, 59.7516],
    [-153.4189, 59.7655],
    [-153.4351, 59.7749],
    [-153.4553, 59.7699],
    [-153.4601, 59.7602],
    [-153.4546, 59.7485],
    [-153.4552, 59.7363],
    [-153.4526, 59.7318],
    [-153.4521, 59.7289],
    [-153.4481, 59.7214],
    [-153.4456, 59.7157],
    [-153.4459, 59.7124],
    [-153.4442, 59.7052],
    [-153.4467, 59.6931],
    [-153.4558, 59.6855],
    [-153.4615, 59.6781],
    [-153.4622, 59.6722],
    [-153.4633, 59.6647],
    [-153.4672, 59.6521],
    [-153.4773, 59.6438],
    [-153.4874, 59.6390],
    [-153.5007, 59.6375],
    [-153.5125, 59.6342],
    [-153.5215, 59.6365],
    [-153.5301, 59.6335],
    [-153.5342, 59.6289],
    [-153.5477, 59.6278],
    [-153.5558, 59.6237],
    [-153.5625, 59.6297],
    [-153.5669, 59.6331],
    [-153.5707, 59.6395],
    [-153.5765, 59.6435],
    [-153.5802, 59.6458],
    [-153.5866, 59.6497],
    [-153.5985, 59.6539],
    [-153.5996, 59.6617],
    [-153.6010, 59.6666],
    [-153.6059, 59.6724],
    [-153.6090, 59.6743],
    [-153.6086, 59.6776],
    [-153.6058, 59.6815],
    [-153.5972, 59.6868],
    [-153.5948, 59.6892],
    [-153.5938, 59.6947],
    [-153.5997, 59.6971],
    [-153.6082, 59.6904],
    [-153.6141, 59.6854],
    [-153.6300, 59.6847],
    [-153.6254, 59.6811],
    [-153.6212, 59.6782],
    [-153.6255, 59.6783],
    [-153.6242, 59.6760],
    [-153.6268, 59.6722],
    [-153.6288, 59.6654],
    [-153.6299, 59.6600],
    [-153.6299, 59.6551],
    [-153.6299, 59.6500],
    [-153.6267, 59.6453],
    [-153.6417, 59.6422],
    [-153.6559, 59.6389],
    [-153.6607, 59.6420],
    [-153.6796, 59.6387],
    [-153.6994, 59.6402],
    [-153.7031, 59.6350],
    [-153.6998, 59.6304],
    [-153.7005, 59.6255],
    [-153.6868, 59.6249],
    [-153.6747, 59.6225],
    [-153.6518, 59.6287],
    [-153.6426, 59.6277],
    [-153.6344, 59.6301],
    [-153.6149, 59.6278],
    [-153.6141, 59.6211],
    [-153.6091, 59.6185],
    [-153.6039, 59.6128],
    [-153.5931, 59.6103],
    [-153.5837, 59.6083],
    [-153.5679, 59.6072],
    [-153.5612, 59.6062],
    [-153.5599, 59.6002],
    [-153.5562, 59.5938],
    [-153.5601, 59.5868],
    [-153.5708, 59.5761],
    [-153.5818, 59.5581],
    [-153.5965, 59.5519],
    [-153.6129, 59.5530],
    [-153.6259, 59.5519],
    [-153.6358, 59.5546],
    [-153.6509, 59.5554],
    [-153.6711, 59.5534],
    [-153.7060, 59.5501],
    [-153.7321, 59.5486],
    [-153.7483, 59.5442],
    [-153.7584, 59.5437],
    [-153.7723, 59.5308],
    [-153.7729, 59.5228],
    [-153.7600, 59.5183],
    [-153.7493, 59.5091],
    [-153.7339, 59.5058],
    [-153.7209, 59.4894],
    [-153.7115, 59.4775],
    [-153.7035, 59.4643],
    [-153.7139, 59.4594],
    [-153.7237, 59.4579],
    [-153.7290, 59.4550],
    [-153.7414, 59.4491],
    [-153.7390, 59.4407],
    [-153.7301, 59.4400],
    [-153.7371, 59.4326],
    [-153.7568, 59.4299],
    [-153.7657, 59.4302],
    [-153.7902, 59.4243],
    [-153.8085, 59.4199],
    [-153.8322, 59.4182],
    [-153.8445, 59.4192],
    [-153.8559, 59.4234],
    [-153.8741, 59.4233],
    [-153.8903, 59.4197],
    [-153.9028, 59.4176],
    [-153.9177, 59.4096],
    [-153.9305, 59.4003],
    [-153.9394, 59.3897],
    [-153.9510, 59.3841],
    [-153.9565, 59.3948],
    [-153.9672, 59.3988],
    [-153.9824, 59.3975],
    [-153.9971, 59.3957],
    [-153.9915, 59.3931],
    [-153.9799, 59.3913],
    [-153.9875, 59.3863],
    [-153.9964, 59.3852],
    [-154.0031, 59.3851],
    [-154.0096, 59.3834],
    [-154.0125, 59.3804],
    [-154.0134, 59.3759],
    [-154.0249, 59.3772],
    [-154.0360, 59.3864],
    [-154.0454, 59.3896],
    [-154.0530, 59.3873],
    [-154.0592, 59.3848],
    [-154.0728, 59.3775],
    [-154.0883, 59.3690],
    [-154.0994, 59.3673],
    [-154.1050, 59.3678],
    [-154.1145, 59.3698],
    [-154.1267, 59.3729],
    [-154.1408, 59.3710],
    [-154.1358, 59.3662],
    [-154.1280, 59.3624],
    [-154.1201, 59.3578],
    [-154.1166, 59.3541],
    [-154.1092, 59.3461],
    [-154.0916, 59.3442],
    [-154.0759, 59.3492],
    [-154.0583, 59.3483],
    [-154.0469, 59.3531],
    [-154.0321, 59.3547],
    [-154.0109, 59.3534],
    [-153.9913, 59.3557],
    [-153.9835, 59.3602],
    [-153.9928, 59.3636],
    [-153.9889, 59.3720],
    [-153.9781, 59.3623],
    [-153.9690, 59.3619],
    [-153.9592, 59.3604],
    [-153.9502, 59.3606],
    [-153.9501, 59.3575],
    [-153.9630, 59.3541],
    [-153.9734, 59.3546],
    [-154.0053, 59.3411],
    [-154.0192, 59.3312],
    [-154.0505, 59.3213],
    [-154.0706, 59.3181],
    [-154.0899, 59.3104],
    [-154.1110, 59.3027],
    [-154.1242, 59.2873],
    [-154.1297, 59.2764],
    [-154.1368, 59.2627],
    [-154.1391, 59.2387],
    [-154.1429, 59.2286],
    [-154.1405, 59.2244],
    [-154.1428, 59.2196],
    [-154.1401, 59.2148],
    [-154.1269, 59.2162],
    [-154.1207, 59.2130],
    [-154.1189, 59.2084],
    [-154.1249, 59.2051],
    [-154.1284, 59.1990],
    [-154.1300, 59.1966],
    [-154.1454, 59.1996],
    [-154.1573, 59.1962],
    [-154.1744, 59.1925],
    [-154.1824, 59.1886],
    [-154.1779, 59.1831],
    [-154.1711, 59.1800],
    [-154.1721, 59.1751],
    [-154.2049, 59.1678],
    [-154.2151, 59.1685],
    [-154.2284, 59.1658],
    [-154.2380, 59.1648],
    [-154.2418, 59.1583],
    [-154.2387, 59.1552],
    [-154.2286, 59.1587],
    [-154.2259, 59.1604],
    [-154.2128, 59.1585],
    [-154.2148, 59.1530],
    [-154.2185, 59.1525],
    [-154.2276, 59.1496],
    [-154.2387, 59.1485],
    [-154.2388, 59.1473],
    [-154.2422, 59.1467],
    [-154.2488, 59.1426],
    [-154.2612, 59.1432],
    [-154.2655, 59.1368],
    [-154.2620, 59.1292],
    [-154.2564, 59.1298],
    [-154.2526, 59.1313],
    [-154.2491, 59.1285],
    [-154.2513, 59.1216],
    [-154.2548, 59.1172],
    [-154.2486, 59.1169],
    [-154.2392, 59.1224],
    [-154.2254, 59.1269],
    [-154.2180, 59.1262],
    [-154.2031, 59.1250],
    [-154.1902, 59.1230],
    [-154.1744, 59.1210],
    [-154.1776, 59.1145],
    [-154.1719, 59.1040],
    [-154.1740, 59.0997],
    [-154.1882, 59.0950],
    [-154.1971, 59.0933],
    [-154.1933, 59.0867],
    [-154.1826, 59.0878],
    [-154.1766, 59.0896],
    [-154.1664, 59.0919],
    [-154.1781, 59.0792],
    [-154.1888, 59.0745],
    [-154.1939, 59.0739],
    [-154.2008, 59.0673],
    [-154.2008, 59.0620],
    [-154.1877, 59.0652],
    [-154.1812, 59.0690],
    [-154.1803, 59.0666],
    [-154.1863, 59.0584],
    [-154.1899, 59.0528],
    [-154.1926, 59.0480],
    [-154.1896, 59.0442],
    [-154.1805, 59.0407],
    [-154.1652, 59.0285],
    [-154.1641, 59.0218],
    [-154.1564, 59.0232],
    [-154.1418, 59.0219],
    [-154.1345, 59.0280],
    [-154.1218, 59.0377],
    [-154.1133, 59.0405],
    [-154.1049, 59.0460],
    [-154.0766, 59.0661],
    [-154.0636, 59.0727],
    [-154.0356, 59.0748],
    [-154.0183, 59.0750],
    [-154.0084, 59.0735],
    [-153.9767, 59.0700],
    [-153.9328, 59.0627],
    [-153.9186, 59.0604],
    [-153.8998, 59.0604],
    [-153.8726, 59.0570],
    [-153.8537, 59.0543],
    [-153.8343, 59.0584],
    [-153.8209, 59.0648],
    [-153.8073, 59.0732],
    [-153.7940, 59.0714],
    [-153.7906, 59.0777],
    [-153.7662, 59.0758],
    [-153.7550, 59.0748],
    [-153.7486, 59.0738],
    [-153.7550, 59.0683],
    [-153.7307, 59.0677],
    [-153.7198, 59.0717],
    [-153.7159, 59.0792],
    [-153.7287, 59.0809],
    [-153.7243, 59.0859],
    [-153.7101, 59.0854],
    [-153.7041, 59.0759],
    [-153.6910, 59.0647],
    [-153.6693, 59.0491],
    [-153.6344, 59.0202],
    [-153.5998, 59.0033],
    [-153.5639, 58.9901],
    [-153.5277, 58.9835],
    [-153.5159, 58.9856],
    [-153.5104, 58.9893],
    [-153.4932, 58.9978],
    [-153.4863, 58.9995],
    [-153.4682, 58.9894],
    [-153.4494, 58.9766],
    [-153.4330, 58.9747],
    [-153.4224, 58.9712],
    [-153.4049, 58.9731],
    [-153.4064, 58.9663],
    [-153.4045, 58.9610],
    [-153.3958, 58.9471],
    [-153.3852, 58.9443],
    [-153.3789, 58.9356],
    [-153.3635, 58.9256],
    [-153.3542, 58.9263],
    [-153.3378, 58.9241],
    [-153.3257, 58.9184],
    [-153.3234, 58.9136],
    [-153.3309, 58.9119],
    [-153.3325, 58.9059],
    [-153.3285, 58.8930],
    [-153.3219, 58.8836],
    [-153.3118, 58.8786],
    [-153.3018, 58.8797],
    [-153.2953, 58.8785],
    [-153.2899, 58.8765],
    [-153.2862, 58.8747],
    [-153.2926, 58.8733],
    [-153.3071, 58.8756],
    [-153.3143, 58.8760],
    [-153.3303, 58.8728],
    [-153.3396, 58.8736],
    [-153.3411, 58.8665],
    [-153.3254, 58.8591],
    [-153.3146, 58.8550],
    [-153.3052, 58.8550],
    [-153.2976, 58.8574],
    [-153.2897, 58.8590],
    [-153.2828, 58.8616],
    [-153.2743, 58.8641],
    [-153.2644, 58.8659],
    [-153.2573, 58.8615],
    [-153.2525, 58.8604],
    [-153.2540, 58.8588],
    [-153.2523, 58.8558],
    [-153.2515, 58.8502],
    [-153.2625, 58.8516],
    [-153.2685, 58.8494],
    [-153.2689, 58.8462],
    [-153.2637, 58.8410],
    [-153.2752, 58.8412],
    [-153.2819, 58.8401],
    [-153.2874, 58.8373],
    [-153.2933, 58.8383],
    [-153.2991, 58.8392],
    [-153.3174, 58.8404],
    [-153.3155, 58.8448],
    [-153.3253, 58.8491],
    [-153.3368, 58.8489],
    [-153.3511, 58.8434],
    [-153.3618, 58.8302],
    [-153.3672, 58.8216],
    [-153.3707, 58.8003],
    [-153.3792, 58.7822],
    [-153.3802, 58.7747],
    [-153.3868, 58.7597],
    [-153.3947, 58.7496],
    [-153.4197, 58.7305],
    [-153.4266, 58.7211],
    [-153.4450, 58.7093],
    [-153.4588, 58.7086],
    [-153.4686, 58.7106],
    [-153.4740, 58.7125],
    [-153.4844, 58.7117],
    [-153.4980, 58.7041],
    [-153.5083, 58.6924],
    [-153.5226, 58.6924],
    [-153.5386, 58.6915],
    [-153.5562, 58.6858],
    [-153.5757, 58.6705],
    [-153.5878, 58.6517],
    [-153.5927, 58.6338],
    [-153.6017, 58.6351],
    [-153.6261, 58.6330],
    [-153.6474, 58.6241],
    [-153.6616, 58.6145],
    [-153.6776, 58.6116],
    [-153.6959, 58.6122],
    [-153.7183, 58.6099],
    [-153.7448, 58.6088],
    [-153.7623, 58.6052],
    [-153.7712, 58.6043],
    [-153.7775, 58.6061],
    [-153.7867, 58.6056],
    [-153.8141, 58.6081],
    [-153.8445, 58.6118],
    [-153.8670, 58.6112],
    [-153.8891, 58.6078],
    [-153.8972, 58.6062],
    [-153.9036, 58.5973],
    [-153.9045, 58.5828],
    [-153.8977, 58.5781],
    [-153.8916, 58.5771],
    [-153.8808, 58.5768],
    [-153.8771, 58.5728],
    [-153.8804, 58.5732],
    [-153.8898, 58.5726],
    [-153.8998, 58.5655],
    [-153.9074, 58.5572],
    [-153.9117, 58.5526],
    [-153.9208, 58.5317],
    [-153.9188, 58.5204],
    [-153.9138, 58.5167],
    [-153.9086, 58.5167],
    [-153.9230, 58.5054],
    [-153.9275, 58.4999],
    [-153.9322, 58.4953],
    [-153.9490, 58.4927],
    [-153.9624, 58.4882],
    [-153.9760, 58.4881],
    [-153.9877, 58.4885],
    [-154.0019, 58.4923],
    [-154.0235, 58.4899],
    [-154.0341, 58.4870],
    [-154.0514, 58.4904],
    [-154.0658, 58.4846],
    [-154.0735, 58.4764],
    [-154.0760, 58.4711],
    [-154.0735, 58.4569],
    [-154.0700, 58.4421],
    [-154.0662, 58.4365],
    [-154.0558, 58.4188],
    [-154.0413, 58.4063],
    [-154.0313, 58.4023],
    [-154.0117, 58.4035],
    [-153.9988, 58.3984],
    [-153.9734, 58.3921],
    [-153.9845, 58.3912],
    [-153.9919, 58.3895],
    [-153.9997, 58.3858],
    [-154.0014, 58.3787],
    [-154.0003, 58.3753],
    [-154.0059, 58.3755],
    [-154.0135, 58.3747],
    [-154.0245, 58.3724],
    [-154.0379, 58.3675],
    [-154.0425, 58.3631],
    [-154.0449, 58.3558],
    [-154.0607, 58.3558],
    [-154.0754, 58.3569],
    [-154.0887, 58.3578],
    [-154.1003, 58.3581],
    [-154.1029, 58.3549],
    [-154.1037, 58.3493],
    [-154.0973, 58.3476],
    [-154.0957, 58.3435],
    [-154.1048, 58.3469],
    [-154.1153, 58.3479],
    [-154.1271, 58.3456],
    [-154.1339, 58.3490],
    [-154.1338, 58.3516],
    [-154.1356, 58.3540],
    [-154.1451, 58.3545],
    [-154.1614, 58.3578],
    [-154.1779, 58.3587],
    [-154.1881, 58.3541],
    [-154.1987, 58.3546],
    [-154.2051, 58.3507],
    [-154.2039, 58.3490],
    [-154.2006, 58.3466],
    [-154.1913, 58.3472],
    [-154.1812, 58.3466],
    [-154.1625, 58.3421],
    [-154.1608, 58.3371],
    [-154.1661, 58.3346],
    [-154.1741, 58.3346],
    [-154.1771, 58.3351],
    [-154.1841, 58.3331],
    [-154.1908, 58.3319],
    [-154.2018, 58.3315],
    [-154.2065, 58.3298],
    [-154.2145, 58.3279],
    [-154.2220, 58.3305],
    [-154.2297, 58.3304],
    [-154.2344, 58.3281],
    [-154.2448, 58.3252],
    [-154.2718, 58.3165],
    [-154.2827, 58.3112],
    [-154.2948, 58.3074],
    [-154.3155, 58.2984],
    [-154.3119, 58.2925],
    [-154.3163, 58.2932],
    [-154.3241, 58.2932],
    [-154.3264, 58.2909],
    [-154.3305, 58.2856],
    [-154.3361, 58.2886],
    [-154.3497, 58.2863],
    [-154.3519, 58.2817],
    [-154.3439, 58.2765],
    [-154.3342, 58.2669],
    [-154.3176, 58.2624],
    [-154.2998, 58.2654],
    [-154.2954, 58.2668],
    [-154.2929, 58.2624],
    [-154.2869, 58.2605],
    [-154.2813, 58.2640],
    [-154.2724, 58.2637],
    [-154.2667, 58.2656],
    [-154.2567, 58.2706],
    [-154.2586, 58.2753],
    [-154.2631, 58.2804],
    [-154.2667, 58.2835],
    [-154.2836, 58.2857],
    [-154.2937, 58.2852],
    [-154.2951, 58.2874],
    [-154.2869, 58.2930],
    [-154.2741, 58.2961],
    [-154.2693, 58.2952],
    [-154.2631, 58.2941],
    [-154.2503, 58.2977],
    [-154.2413, 58.2992],
    [-154.2234, 58.3014],
    [-154.2195, 58.3013],
    [-154.2019, 58.2952],
    [-154.1990, 58.2970],
    [-154.1932, 58.3038],
    [-154.1923, 58.3062],
    [-154.2005, 58.3086],
    [-154.2104, 58.3078],
    [-154.2027, 58.3206],
    [-154.1889, 58.3178],
    [-154.1876, 58.3203],
    [-154.1857, 58.3218],
    [-154.1772, 58.3215],
    [-154.1666, 58.3206],
    [-154.1491, 58.3145],
    [-154.1509, 58.3093],
    [-154.1429, 58.3060],
    [-154.1412, 58.3026],
    [-154.1389, 58.2986],
    [-154.1369, 58.2947],
    [-154.1372, 58.2923],
    [-154.1249, 58.2880],
    [-154.1167, 58.2844],
    [-154.1111, 58.2829],
    [-154.1066, 58.2839],
    [-154.1034, 58.2755],
    [-154.1068, 58.2745],
    [-154.1143, 58.2706],
    [-154.1286, 58.2663],
    [-154.1395, 58.2674],
    [-154.1481, 58.2666],
    [-154.1669, 58.2645],
    [-154.1742, 58.2612],
    [-154.1806, 58.2631],
    [-154.1886, 58.2621],
    [-154.1940, 58.2594],
    [-154.1987, 58.2567],
    [-154.2000, 58.2499],
    [-154.1953, 58.2511],
    [-154.1934, 58.2502],
    [-154.1885, 58.2462],
    [-154.1806, 58.2471],
    [-154.1751, 58.2450],
    [-154.1685, 58.2388],
    [-154.1608, 58.2382],
    [-154.1559, 58.2366],
    [-154.1528, 58.2362],
    [-154.1497, 58.2355],
    [-154.1460, 58.2308],
    [-154.1497, 58.2297],
    [-154.1551, 58.2269],
    [-154.1532, 58.2236],
    [-154.1429, 58.2179],
    [-154.1446, 58.2146],
    [-154.1479, 58.2106],
    [-154.1539, 58.2119],
    [-154.1648, 58.2129],
    [-154.1747, 58.2138],
    [-154.1791, 58.2113],
    [-154.1705, 58.2029],
    [-154.1643, 58.1972],
    [-154.1686, 58.1933],
    [-154.1763, 58.1908],
    [-154.1851, 58.1912],
    [-154.1945, 58.1910],
    [-154.2063, 58.1866],
    [-154.2146, 58.1856],
    [-154.2267, 58.1844],
    [-154.2379, 58.1857],
    [-154.2542, 58.1893],
    [-154.2568, 58.1902],
    [-154.2621, 58.1886],
    [-154.2596, 58.1844],
    [-154.2605, 58.1787],
    [-154.2678, 58.1803],
    [-154.2741, 58.1854],
    [-154.2896, 58.1918],
    [-154.2954, 58.1920],
    [-154.2964, 58.1906],
    [-154.2886, 58.1818],
    [-154.2834, 58.1762],
    [-154.2763, 58.1688],
    [-154.2659, 58.1604],
    [-154.2518, 58.1578],
    [-154.2449, 58.1567],
    [-154.2396, 58.1507],
    [-154.2342, 58.1483],
    [-154.2258, 58.1470],
    [-154.2163, 58.1428],
    [-154.2130, 58.1347],
    [-154.2283, 58.1317],
    [-154.2522, 58.1301],
    [-154.2735, 58.1291],
    [-154.2826, 58.1327],
    [-154.2945, 58.1363],
    [-154.2958, 58.1428],
    [-154.3052, 58.1484],
    [-154.3233, 58.1557],
    [-154.3374, 58.1571],
    [-154.3343, 58.1522],
    [-154.3306, 58.1379],
    [-154.3353, 58.1286],
    [-154.3311, 58.1189],
    [-154.3237, 58.1133],
    [-154.3157, 58.1056],
    [-154.3107, 58.0963],
    [-154.3103, 58.0903],
    [-154.3101, 58.0883],
    [-154.3138, 58.0861],
    [-154.3155, 58.0831],
    [-154.3214, 58.0816],
    [-154.3303, 58.0819],
    [-154.3366, 58.0811],
    [-154.3410, 58.0838],
    [-154.3393, 58.0911],
    [-154.3431, 58.0957],
    [-154.3617, 58.0984],
    [-154.3703, 58.0939],
    [-154.3787, 58.0955],
    [-154.3823, 58.0974],
    [-154.3661, 58.1015],
    [-154.3693, 58.1085],
    [-154.3879, 58.1222],
    [-154.4024, 58.1269],
    [-154.4121, 58.1290],
    [-154.4170, 58.1327],
    [-154.4229, 58.1369],
    [-154.4263, 58.1409],
    [-154.4362, 58.1473],
    [-154.4413, 58.1557],
    [-154.4372, 58.1618],
    [-154.4423, 58.1642],
    [-154.4427, 58.1687],
    [-154.4372, 58.1682],
    [-154.4396, 58.1733],
    [-154.4441, 58.1724],
    [-154.4512, 58.1819],
    [-154.4613, 58.1854],
    [-154.4643, 58.1854],
    [-154.4725, 58.1915],
    [-154.4787, 58.1926],
    [-154.4844, 58.1915],
    [-154.4822, 58.1873],
    [-154.4840, 58.1866],
    [-154.4790, 58.1823],
    [-154.4755, 58.1809],
    [-154.4709, 58.1790],
    [-154.4687, 58.1714],
    [-154.4704, 58.1701],
    [-154.4668, 58.1656],
    [-154.4611, 58.1618],
    [-154.4604, 58.1551],
    [-154.4569, 58.1468],
    [-154.4627, 58.1458],
    [-154.4677, 58.1476],
    [-154.4684, 58.1445],
    [-154.4659, 58.1389],
    [-154.4611, 58.1328],
    [-154.4613, 58.1286],
    [-154.4590, 58.1243],
    [-154.4531, 58.1226],
    [-154.4527, 58.1210],
    [-154.4510, 58.1161],
    [-154.4529, 58.1098],
    [-154.4469, 58.0953],
    [-154.4537, 58.0882],
    [-154.4602, 58.0823],
    [-154.4634, 58.0790],
    [-154.4682, 58.0800],
    [-154.4719, 58.0815],
    [-154.4795, 58.0809],
    [-154.4831, 58.0822],
    [-154.4857, 58.0827],
    [-154.4895, 58.0812],
    [-154.4991, 58.0887],
    [-154.5084, 58.0871],
    [-154.5109, 58.0827],
    [-154.5149, 58.0787],
    [-154.5424, 58.0856],
    [-154.5490, 58.0854],
    [-154.5582, 58.0858],
    [-154.5540, 58.0783],
    [-154.5370, 58.0640],
    [-154.5395, 58.0547],
    [-154.5505, 58.0475],
    [-154.5553, 58.0439],
    [-154.5579, 58.0378],
    [-154.5649, 58.0306],
    [-154.5665, 58.0237],
    [-154.5815, 58.0193],
    [-154.5829, 58.0236],
    [-154.5927, 58.0273],
    [-154.6000, 58.0258],
    [-154.6187, 58.0287],
    [-154.6411, 58.0316],
    [-154.6483, 58.0394],
    [-154.6486, 58.0452],
    [-154.6476, 58.0511],
    [-154.6433, 58.0579],
    [-154.6567, 58.0634],
    [-154.6795, 58.0638],
    [-154.7108, 58.0557],
    [-154.7290, 58.0385],
    [-154.7305, 58.0313],
    [-154.7327, 58.0240],
    [-154.7305, 58.0199],
    [-154.7268, 58.0185],
    [-154.7324, 58.0138],
    [-154.7413, 58.0120],
    [-154.7545, 58.0108],
    [-154.7653, 58.0037],
    [-154.7792, 58.0007],
    [-154.7939, 57.9999],
    [-154.8106, 58.0005],
    [-154.8233, 58.0076],
    [-154.8258, 58.0143],
    [-154.8403, 58.0195],
    [-154.8553, 58.0197],
    [-154.8794, 58.0255],
    [-154.8983, 58.0235],
    [-154.9192, 58.0185],
    [-154.9388, 58.0080],
    [-154.9493, 58.0017],
    [-154.9554, 58.0014],
    [-154.9726, 58.0017],
    [-154.9905, 57.9987],
    [-155.0025, 57.9953],
    [-155.0199, 57.9898],
    [-155.0152, 57.9952],
    [-155.0203, 58.0026],
    [-155.0277, 58.0031],
    [-155.0270, 57.9974],
    [-155.0306, 57.9896],
    [-155.0346, 57.9812],
    [-155.0308, 57.9763],
    [-155.0301, 57.9705],
    [-155.0420, 57.9550],
    [-155.0492, 57.9522],
    [-155.0592, 57.9509],
    [-155.0716, 57.9534],
    [-155.0758, 57.9540],
    [-155.0877, 57.9475],
    [-155.0915, 57.9480],
    [-155.0991, 57.9480],
    [-155.1076, 57.9449],
    [-155.1167, 57.9460],
    [-155.1146, 57.9368],
    [-155.1044, 57.9298],
    [-155.1003, 57.9275],
    [-155.0945, 57.9212],
    [-155.0885, 57.9156],
    [-155.0815, 57.9134],
    [-155.0743, 57.9076],
    [-155.0679, 57.9073],
    [-155.0618, 57.9043],
    [-155.0684, 57.8879],
    [-155.0746, 57.8809],
    [-155.0884, 57.8722],
    [-155.0986, 57.8675],
    [-155.1101, 57.8672],
    [-155.1286, 57.8641],
    [-155.1406, 57.8591],
    [-155.1506, 57.8579],
    [-155.1471, 57.8551],
    [-155.1468, 57.8505],
    [-155.1535, 57.8555],
    [-155.1601, 57.8567],
    [-155.1690, 57.8596],
    [-155.1774, 57.8594],
    [-155.1917, 57.8517],
    [-155.1986, 57.8474],
    [-155.2014, 57.8502],
    [-155.2032, 57.8569],
    [-155.2143, 57.8591],
    [-155.2212, 57.8622],
    [-155.2289, 57.8640],
    [-155.2443, 57.8675],
    [-155.2483, 57.8675],
    [-155.2540, 57.8632],
    [-155.2481, 57.8604],
    [-155.2446, 57.8565],
    [-155.2407, 57.8545],
    [-155.2281, 57.8515],
    [-155.2227, 57.8492],
    [-155.2177, 57.8447],
    [-155.2167, 57.8390],
    [-155.2259, 57.8331],
    [-155.2379, 57.8271],
    [-155.2530, 57.8254],
    [-155.2635, 57.8245],
    [-155.2755, 57.8231],
    [-155.2830, 57.8233],
    [-155.2975, 57.8246],
    [-155.3066, 57.8270],
    [-155.3164, 57.8278],
    [-155.3255, 57.8285],
    [-155.3317, 57.8291],
    [-155.3380, 57.8250],
    [-155.3405, 57.8188],
    [-155.3327, 57.8156],
    [-155.3268, 57.8095],
    [-155.3342, 57.8062],
    [-155.3262, 57.7967],
    [-155.3200, 57.7946],
    [-155.3095, 57.7978],
    [-155.2931, 57.8005],
    [-155.2881, 57.8016],
    [-155.2900, 57.7982],
    [-155.2971, 57.7950],
    [-155.3053, 57.7924],
    [-155.3115, 57.7938],
    [-155.3164, 57.7900],
    [-155.3215, 57.7917],
    [-155.3278, 57.7917],
    [-155.3336, 57.7907],
    [-155.3320, 57.7943],
    [-155.3376, 57.7978],
    [-155.3433, 57.7961],
    [-155.3506, 57.7959],
    [-155.3584, 57.7955],
    [-155.3605, 57.7927],
    [-155.3544, 57.7912],
    [-155.3480, 57.7888],
    [-155.3449, 57.7846],
    [-155.3358, 57.7857],
    [-155.3217, 57.7647],
    [-155.3111, 57.7602],
    [-155.3023, 57.7590],
    [-155.2935, 57.7595],
    [-155.2863, 57.7567],
    [-155.2914, 57.7522],
    [-155.2950, 57.7490],
    [-155.2911, 57.7417],
    [-155.2954, 57.7393],
    [-155.2973, 57.7376],
    [-155.3025, 57.7280],
    [-155.3014, 57.7248],
    [-155.3114, 57.7254],
    [-155.3269, 57.7243],
    [-155.3430, 57.7240],
    [-155.3556, 57.7205],
    [-155.3621, 57.7155],
    [-155.3637, 57.7133],
    [-155.3689, 57.7144],
    [-155.3770, 57.7114],
    [-155.3895, 57.7061],
    [-155.3919, 57.7079],
    [-155.3914, 57.7140],
    [-155.3937, 57.7176],
    [-155.3933, 57.7223],
    [-155.4004, 57.7293],
    [-155.4007, 57.7359],
    [-155.4081, 57.7401],
    [-155.4265, 57.7468],
    [-155.4398, 57.7463],
    [-155.4644, 57.7470],
    [-155.4705, 57.7465],
    [-155.4813, 57.7532],
    [-155.4922, 57.7550],
    [-155.4990, 57.7547],
    [-155.5019, 57.7547],
    [-155.5070, 57.7614],
    [-155.5104, 57.7617],
    [-155.5197, 57.7676],
    [-155.5254, 57.7698],
    [-155.5376, 57.7767],
    [-155.5384, 57.7816],
    [-155.5431, 57.7842],
    [-155.5455, 57.7881],
    [-155.5527, 57.7872],
    [-155.5700, 57.7903],
    [-155.5872, 57.7876],
    [-155.6067, 57.7799],
    [-155.6130, 57.7759],
    [-155.6187, 57.7699],
    [-155.6184, 57.7609],
    [-155.6164, 57.7552],
    [-155.6142, 57.7449],
    [-155.6304, 57.7274],
    [-155.6345, 57.7061],
    [-155.6305, 57.6992],
    [-155.6236, 57.6941],
    [-155.6137, 57.6894],
    [-155.6010, 57.6874],
    [-155.5872, 57.6875],
    [-155.5832, 57.6836],
    [-155.5805, 57.6786],
    [-155.5811, 57.6751],
    [-155.5832, 57.6707],
    [-155.5877, 57.6641],
    [-155.5980, 57.6588],
    [-155.6162, 57.6567],
    [-155.6271, 57.6567],
    [-155.6489, 57.6531],
    [-155.6660, 57.6498],
    [-155.6764, 57.6473],
    [-155.6852, 57.6442],
    [-155.6938, 57.6452],
    [-155.7047, 57.6401],
    [-155.7051, 57.6376],
    [-155.7137, 57.6359],
    [-155.7272, 57.6353],
    [-155.7348, 57.6317],
    [-155.7434, 57.6340],
    [-155.7625, 57.6410],
    [-155.7722, 57.6412],
    [-155.7764, 57.6369],
    [-155.7719, 57.6316],
    [-155.7626, 57.6261],
    [-155.7462, 57.6234],
    [-155.7255, 57.6169],
    [-155.7265, 57.6146],
    [-155.7323, 57.6088],
    [-155.7355, 57.6032],
    [-155.7413, 57.6014],
    [-155.7397, 57.5955],
    [-155.7309, 57.5912],
    [-155.7258, 57.5798],
    [-155.7306, 57.5734],
    [-155.7363, 57.5662],
    [-155.7367, 57.5613],
    [-155.7386, 57.5577],
    [-155.7314, 57.5547],
    [-155.7324, 57.5514],
    [-155.7334, 57.5492],
    [-155.7315, 57.5443],
    [-155.7511, 57.5442],
    [-155.7637, 57.5453],
    [-155.7738, 57.5450],
    [-155.7839, 57.5466],
    [-155.7972, 57.5447],
    [-155.7978, 57.5519],
    [-155.8082, 57.5565],
    [-155.8211, 57.5556],
    [-155.8181, 57.5604],
    [-155.8141, 57.5660],
    [-155.8154, 57.5738],
    [-155.8265, 57.5767],
    [-155.8350, 57.5720],
    [-155.8319, 57.5691],
    [-155.8471, 57.5686],
    [-155.8530, 57.5638],
    [-155.8574, 57.5600],
    [-155.8603, 57.5552],
    [-155.8755, 57.5471],
    [-155.8806, 57.5463],
    [-155.8977, 57.5471],
    [-155.9040, 57.5492],
    [-155.9039, 57.5461],
    [-155.9116, 57.5427],
    [-155.9072, 57.5388],
    [-155.9079, 57.5366],
    [-155.9078, 57.5346],
    [-155.9399, 57.5352],
    [-155.9539, 57.5380],
    [-155.9651, 57.5395],
    [-155.9722, 57.5438],
    [-155.9813, 57.5490],
    [-155.9868, 57.5528],
    [-155.9893, 57.5566],
    [-155.9954, 57.5597],
    [-156.0084, 57.5611],
    [-156.0061, 57.5670],
    [-156.0207, 57.5690],
    [-156.0390, 57.5666],
    [-156.0423, 57.5602],
    [-156.0425, 57.5529],
    [-156.0371, 57.5413],
    [-156.0274, 57.5267],
    [-156.0340, 57.5201],
    [-156.0453, 57.5177],
    [-156.0413, 57.5105],
    [-156.0456, 57.4980],
    [-156.0407, 57.4874],
    [-156.0362, 57.4757],
    [-156.0312, 57.4679],
    [-156.0274, 57.4593],
    [-156.0193, 57.4547],
    [-156.0133, 57.4508],
    [-156.0153, 57.4420],
    [-156.0194, 57.4369],
    [-156.0318, 57.4345],
    [-156.0439, 57.4348],
    [-156.0559, 57.4375],
    [-156.0645, 57.4355],
    [-156.0829, 57.4392],
    [-156.0937, 57.4379],
    [-156.0964, 57.4425],
    [-156.1048, 57.4399],
    [-156.1052, 57.4444],
    [-156.1075, 57.4499],
    [-156.1146, 57.4541],
    [-156.1221, 57.4589],
    [-156.1362, 57.4621],
    [-156.1383, 57.4704],
    [-156.1583, 57.4731],
    [-156.1777, 57.4793],
    [-156.1855, 57.4818],
    [-156.2053, 57.4731],
    [-156.2137, 57.4641],
    [-156.2129, 57.4556],
    [-156.2174, 57.4497],
    [-156.2132, 57.4380],
    [-156.2174, 57.4394],
    [-156.2336, 57.4413],
    [-156.2542, 57.4401],
    [-156.2664, 57.4329],
    [-156.2765, 57.4312],
    [-156.2862, 57.4305],
    [-156.2919, 57.4317],
    [-156.3019, 57.4287],
    [-156.3133, 57.4247],
    [-156.3279, 57.4229],
    [-156.3427, 57.4139],
    [-156.3671, 57.3967],
    [-156.4017, 57.3720],
    [-156.4428, 57.3593],
    [-156.4658, 57.3428],
    [-156.4857, 57.3275],
    [-156.4969, 57.3183],
    [-156.5005, 57.3350],
    [-156.5055, 57.3351],
    [-156.5106, 57.3334],
    [-156.5195, 57.3300],
    [-156.5385, 57.3256],
    [-156.5412, 57.3108],
    [-156.5482, 57.3059],
    [-156.5450, 57.2922],
    [-156.5433, 57.2848],
    [-156.5251, 57.2850],
    [-156.5195, 57.2900],
    [-156.5101, 57.2878],
    [-156.4969, 57.2884],
    [-156.4916, 57.2947],
    [-156.4589, 57.3026],
    [-156.4369, 57.3070],
    [-156.4214, 57.3080],
    [-156.3930, 57.3180],
    [-156.3715, 57.3188],
    [-156.3584, 57.3234],
    [-156.3455, 57.3212],
    [-156.3376, 57.3186],
    [-156.3305, 57.3187],
    [-156.3257, 57.3143],
    [-156.3342, 57.3106],
    [-156.3400, 57.3119],
    [-156.3446, 57.3058],
    [-156.3352, 57.2987],
    [-156.3248, 57.2983],
    [-156.3151, 57.2937],
    [-156.3206, 57.2883],
    [-156.3191, 57.2816],
    [-156.3290, 57.2672],
    [-156.3346, 57.2568],
    [-156.3526, 57.2483],
    [-156.3512, 57.2427],
    [-156.3617, 57.2428],
    [-156.3782, 57.2466],
    [-156.3940, 57.2390],
    [-156.3945, 57.2313],
    [-156.3912, 57.2271],
    [-156.3989, 57.2267],
    [-156.4037, 57.2231],
    [-156.3942, 57.2175],
    [-156.3879, 57.2108],
    [-156.3833, 57.2047],
    [-156.3814, 57.1991],
    [-156.3739, 57.1974],
    [-156.3617, 57.1966],
    [-156.3517, 57.1885],
    [-156.3371, 57.1878],
    [-156.3178, 57.1873],
    [-156.3319, 57.1779],
    [-156.3376, 57.1726],
    [-156.3454, 57.1677],
    [-156.3512, 57.1647],
    [-156.3517, 57.1565],
    [-156.3611, 57.1497],
    [-156.3658, 57.1460],
    [-156.3770, 57.1422],
    [-156.3910, 57.1390],
    [-156.4010, 57.1386],
    [-156.4054, 57.1395],
    [-156.4071, 57.1366],
    [-156.4049, 57.1291],
    [-156.4094, 57.1223],
    [-156.4163, 57.1205],
    [-156.4268, 57.1198],
    [-156.4317, 57.1258],
    [-156.4381, 57.1252],
    [-156.4484, 57.1257],
    [-156.4579, 57.1249],
    [-156.4657, 57.1249],
    [-156.4635, 57.1204],
    [-156.4667, 57.1150],
    [-156.4588, 57.1113],
    [-156.4461, 57.1090],
    [-156.4344, 57.1076],
    [-156.4337, 57.1047],
    [-156.4489, 57.1013],
    [-156.4416, 57.0947],
    [-156.4434, 57.0815],
    [-156.4598, 57.0787],
    [-156.4721, 57.0768],
    [-156.4833, 57.0732],
    [-156.4875, 57.0685],
    [-156.4876, 57.0656],
    [-156.4966, 57.0595],
    [-156.5010, 57.0574],
    [-156.5075, 57.0526],
    [-156.5219, 57.0482],
    [-156.5376, 57.0468],
    [-156.5499, 57.0457],
    [-156.5597, 57.0456],
    [-156.5702, 57.0469],
    [-156.5806, 57.0441],
    [-156.5926, 57.0480],
    [-156.6059, 57.0474],
    [-156.6133, 57.0444],
    [-156.6047, 57.0402],
    [-156.5839, 57.0319],
    [-156.5808, 57.0287],
    [-156.5711, 57.0245],
    [-156.5714, 57.0200],
    [-156.5605, 57.0163],
    [-156.5534, 57.0081],
    [-156.5508, 56.9997],
    [-156.5561, 56.9914],
    [-156.5542, 56.9865],
    [-156.5486, 56.9835],
    [-156.5548, 56.9798],
    [-156.5616, 56.9813],
    [-156.5695, 56.9806],
    [-156.5745, 56.9843],
    [-156.5851, 56.9884],
    [-156.5908, 56.9854],
    [-156.5989, 56.9918],
    [-156.6085, 56.9909],
    [-156.6114, 56.9908],
    [-156.6257, 56.9951],
    [-156.6343, 56.9925],
    [-156.6436, 56.9949],
    [-156.6511, 57.0030],
    [-156.6625, 57.0050],
    [-156.6640, 57.0007],
    [-156.6676, 56.9955],
    [-156.6790, 57.0020],
    [-156.6838, 57.0122],
    [-156.6880, 57.0157],
    [-156.6952, 57.0262],
    [-156.6985, 57.0299],
    [-156.7127, 57.0342],
    [-156.7203, 57.0385],
    [-156.7401, 57.0354],
    [-156.7541, 57.0268],
    [-156.7723, 57.0343],
    [-156.7801, 57.0283],
    [-156.7764, 57.0198],
    [-156.7690, 57.0125],
    [-156.7615, 57.0089],
    [-156.7566, 57.0022],
    [-156.7513, 56.9991],
    [-156.7487, 56.9964],
    [-156.7536, 56.9917],
    [-156.7633, 56.9871],
    [-156.7666, 56.9816],
    [-156.7726, 56.9774],
    [-156.7854, 56.9697],
    [-156.7903, 56.9579],
    [-156.7888, 56.9420],
    [-156.7909, 56.9366],
    [-156.7957, 56.9289],
    [-156.7973, 56.9204],
    [-156.8006, 56.9163],
    [-156.8003, 56.9132],
    [-156.8011, 56.9091],
    [-156.8100, 56.9040],
    [-156.8140, 56.9075],
    [-156.8170, 56.9056],
    [-156.8192, 56.9021],
    [-156.8218, 56.8987],
    [-156.8295, 56.8971],
    [-156.8335, 56.9013],
    [-156.8387, 56.9004],
    [-156.8444, 56.9064],
    [-156.8484, 56.9141],
    [-156.8491, 56.9231],
    [-156.8523, 56.9285],
    [-156.8668, 56.9364],
    [-156.8789, 56.9445],
    [-156.8869, 56.9575],
    [-156.8857, 56.9606],
    [-156.8863, 56.9640],
    [-156.9002, 56.9666],
    [-156.9183, 56.9642],
    [-156.9310, 56.9578],
    [-156.9353, 56.9510],
    [-156.9369, 56.9472],
    [-156.9363, 56.9421],
    [-156.9355, 56.9366],
    [-156.9403, 56.9316],
    [-156.9424, 56.9246],
    [-156.9392, 56.9224],
    [-156.9329, 56.9190],
    [-156.9372, 56.9175],
    [-156.9468, 56.9160],
    [-156.9469, 56.9111],
    [-156.9520, 56.9126],
    [-156.9755, 56.9134],
    [-156.9928, 56.9101],
    [-157.0157, 56.8985],
    [-157.0476, 56.8701],
    [-157.0693, 56.8433],
    [-157.0764, 56.8332],
    [-157.0784, 56.8237],
    [-157.0856, 56.8193],
    [-157.0937, 56.8266],
    [-157.1071, 56.8341],
    [-157.1334, 56.8327],
    [-157.1469, 56.8260],
    [-157.1544, 56.8189],
    [-157.1500, 56.8150],
    [-157.1471, 56.8116],
    [-157.1387, 56.8077],
    [-157.1393, 56.8034],
    [-157.1480, 56.8009],
    [-157.1466, 56.7946],
    [-157.1436, 56.7853],
    [-157.1511, 56.7839],
    [-157.1571, 56.7793],
    [-157.1614, 56.7741],
    [-157.1706, 56.7754],
    [-157.1780, 56.7744],
    [-157.1782, 56.7709],
    [-157.1872, 56.7699],
    [-157.1979, 56.7664],
    [-157.2047, 56.7696],
    [-157.2114, 56.7722],
    [-157.2179, 56.7752],
    [-157.2264, 56.7780],
    [-157.2362, 56.7848],
    [-157.2422, 56.7868],
    [-157.2489, 56.7923],
    [-157.2673, 56.7931],
    [-157.2734, 56.7966],
    [-157.2905, 56.8047],
    [-157.2912, 56.8111],
    [-157.2974, 56.8161],
    [-157.3145, 56.8237],
    [-157.3228, 56.8298],
    [-157.3310, 56.8352],
    [-157.3461, 56.8417],
    [-157.3579, 56.8507],
    [-157.3691, 56.8530],
    [-157.3778, 56.8599],
    [-157.3985, 56.8639],
    [-157.4369, 56.8585],
    [-157.4576, 56.8482],
    [-157.4610, 56.8420],
    [-157.4714, 56.8312],
    [-157.4624, 56.8096],
    [-157.4509, 56.8022],
    [-157.4389, 56.8043],
    [-157.4269, 56.8015],
    [-157.4211, 56.8017],
    [-157.4198, 56.7909],
    [-157.4173, 56.7816],
    [-157.4093, 56.7773],
    [-157.4010, 56.7707],
    [-157.4050, 56.7627],
    [-157.4090, 56.7647],
    [-157.4120, 56.7681],
    [-157.4182, 56.7704],
    [-157.4311, 56.7689],
    [-157.4457, 56.7630],
    [-157.4597, 56.7556],
    [-157.4703, 56.7571],
    [-157.4760, 56.7614],
    [-157.4816, 56.7645],
    [-157.4937, 56.7622],
    [-157.4997, 56.7640],
    [-157.5070, 56.7654],
    [-157.5167, 56.7602],
    [-157.5356, 56.7482],
    [-157.5497, 56.7275],
    [-157.5583, 56.7086],
    [-157.5577, 56.7001],
    [-157.5440, 56.6754],
    [-157.5353, 56.6758],
    [-157.5141, 56.6687],
    [-157.4982, 56.6661],
    [-157.4909, 56.6693],
    [-157.4766, 56.6662],
    [-157.4711, 56.6559],
    [-157.4553, 56.6482],
    [-157.4508, 56.6389],
    [-157.4597, 56.6274],
    [-157.4668, 56.6228],
    [-157.4744, 56.6234],
    [-157.4847, 56.6202],
    [-157.4993, 56.6157],
    [-157.5055, 56.6159],
    [-157.5189, 56.6153],
    [-157.5306, 56.6139],
    [-157.5378, 56.6157],
    [-157.5475, 56.6186],
    [-157.5619, 56.6190],
    [-157.5742, 56.6204],
    [-157.6050, 56.6205],
    [-157.6134, 56.6190],
    [-157.6188, 56.6169],
    [-157.6262, 56.6123],
    [-157.6330, 56.6101],
    [-157.6418, 56.6123],
    [-157.6471, 56.6135],
    [-157.6529, 56.6114],
    [-157.6636, 56.6125],
    [-157.6680, 56.6101],
    [-157.6729, 56.6112],
    [-157.6778, 56.6082],
    [-157.6754, 56.6131],
    [-157.6841, 56.6205],
    [-157.7031, 56.6251],
    [-157.7088, 56.6343],
    [-157.7149, 56.6378],
    [-157.7141, 56.6416],
    [-157.7180, 56.6530],
    [-157.7252, 56.6595],
    [-157.7316, 56.6656],
    [-157.7541, 56.6795],
    [-157.8168, 56.6669],
    [-157.8344, 56.6550],
    [-157.8354, 56.6501],
    [-157.8411, 56.6438],
    [-157.8532, 56.6454],
    [-157.8644, 56.6450],
    [-157.8743, 56.6498],
    [-157.9005, 56.6446],
    [-157.9095, 56.6441],
    [-157.9288, 56.6390],
    [-157.9484, 56.6268],
    [-157.9575, 56.6104],
    [-157.9641, 56.6102],
    [-157.9704, 56.6061],
    [-157.9740, 56.6040],
    [-157.9798, 56.6037],
    [-157.9846, 56.5972],
    [-158.0001, 56.6031],
    [-158.0082, 56.6044],
    [-158.0197, 56.6021],
    [-158.0274, 56.6026],
    [-158.0380, 56.5984],
    [-158.0472, 56.5902],
    [-158.0597, 56.5838],
    [-158.0591, 56.5754],
    [-158.0596, 56.5733],
    [-158.0697, 56.5763],
    [-158.0857, 56.5733],
    [-158.0917, 56.5714],
    [-158.1067, 56.5640],
    [-158.1209, 56.5538],
    [-158.1269, 56.5505],
    [-158.1248, 56.5432],
    [-158.1330, 56.5420],
    [-158.1309, 56.5378],
    [-158.1342, 56.5339],
    [-158.1308, 56.5307],
    [-158.1254, 56.5285],
    [-158.1184, 56.5301],
    [-158.1090, 56.5315],
    [-158.0958, 56.5354],
    [-158.0847, 56.5375],
    [-158.0689, 56.5413],
    [-158.0573, 56.5414],
    [-158.0421, 56.5445],
    [-158.0351, 56.5457],
    [-158.0177, 56.5502],
    [-158.0055, 56.5534],
    [-157.9973, 56.5527],
    [-157.9795, 56.5553],
    [-157.9675, 56.5592],
    [-157.9639, 56.5634],
    [-157.9607, 56.5652],
    [-157.9515, 56.5635],
    [-157.9362, 56.5675],
    [-157.9286, 56.5686],
    [-157.9171, 56.5705],
    [-157.9078, 56.5745],
    [-157.8998, 56.5696],
    [-157.8904, 56.5671],
    [-157.8837, 56.5669],
    [-157.8701, 56.5621],
    [-157.8569, 56.5632],
    [-157.8501, 56.5614],
    [-157.8434, 56.5636],
    [-157.8356, 56.5641],
    [-157.8281, 56.5582],
    [-157.8224, 56.5558],
    [-157.8186, 56.5487],
    [-157.8305, 56.5451],
    [-157.8315, 56.5352],
    [-157.8298, 56.5263],
    [-157.8242, 56.5194],
    [-157.8160, 56.5143],
    [-157.8228, 56.5154],
    [-157.8261, 56.5166],
    [-157.8291, 56.5110],
    [-157.8234, 56.5066],
    [-157.8195, 56.5040],
    [-157.8269, 56.5019],
    [-157.8342, 56.4979],
    [-157.8500, 56.4953],
    [-157.8577, 56.4819],
    [-157.8604, 56.4740],
    [-157.8699, 56.4733],
    [-157.8781, 56.4729],
    [-157.8876, 56.4724],
    [-157.8933, 56.4760],
    [-157.9019, 56.4788],
    [-157.9074, 56.4810],
    [-157.9153, 56.4829],
    [-157.9244, 56.4862],
    [-157.9346, 56.4858],
    [-157.9460, 56.4865],
    [-157.9560, 56.4878],
    [-157.9647, 56.4913],
    [-157.9688, 56.4972],
    [-157.9788, 56.5010],
    [-157.9864, 56.4991],
    [-158.0017, 56.4978],
    [-158.0095, 56.5010],
    [-158.0231, 56.5100],
    [-158.0306, 56.5116],
    [-158.0368, 56.5093],
    [-158.0442, 56.5102],
    [-158.0540, 56.5095],
    [-158.0604, 56.5130],
    [-158.0702, 56.5112],
    [-158.0815, 56.5097],
    [-158.0862, 56.5125],
    [-158.0979, 56.5126],
    [-158.1052, 56.5171],
    [-158.1156, 56.5188],
    [-158.1216, 56.5184],
    [-158.1296, 56.5219],
    [-158.1427, 56.5201],
    [-158.1532, 56.5108],
    [-158.1516, 56.5018],
    [-158.1458, 56.4974],
    [-158.1327, 56.4956],
    [-158.1257, 56.4960],
    [-158.1161, 56.4923],
    [-158.1161, 56.4842],
    [-158.1193, 56.4779],
    [-158.1216, 56.4714],
    [-158.1265, 56.4620],
    [-158.1467, 56.4625],
    [-158.1586, 56.4652],
    [-158.1675, 56.4656],
    [-158.1780, 56.4590],
    [-158.1859, 56.4578],
    [-158.1957, 56.4610],
    [-158.2051, 56.4624],
    [-158.2150, 56.4626],
    [-158.2345, 56.4630],
    [-158.2455, 56.4604],
    [-158.2509, 56.4668],
    [-158.2606, 56.4704],
    [-158.2761, 56.4760],
    [-158.2847, 56.4797],
    [-158.3118, 56.4811],
    [-158.3313, 56.4822],
    [-158.3554, 56.4696],
    [-158.3813, 56.4582],
    [-158.3943, 56.4572],
    [-158.4053, 56.4537],
    [-158.4183, 56.4422],
    [-158.4285, 56.4310],
    [-158.4418, 56.4187],
    [-158.4493, 56.4097],
    [-158.4608, 56.4038],
    [-158.4676, 56.3974],
    [-158.4814, 56.3919],
    [-158.4960, 56.3816],
    [-158.4999, 56.3806],
    [-158.5072, 56.3744],
    [-158.5034, 56.3635],
    [-158.4947, 56.3491],
    [-158.4892, 56.3386],
    [-158.4893, 56.3337],
    [-158.4761, 56.3379],
    [-158.4606, 56.3427],
    [-158.4319, 56.3423],
    [-158.4334, 56.3365],
    [-158.4361, 56.3337],
    [-158.4291, 56.3262],
    [-158.4190, 56.3239],
    [-158.4218, 56.3293],
    [-158.4170, 56.3312],
    [-158.4132, 56.3300],
    [-158.4058, 56.3271],
    [-158.3973, 56.3289],
    [-158.3995, 56.3220],
    [-158.4019, 56.3177],
    [-158.4105, 56.3103],
    [-158.4096, 56.3046],
    [-158.4082, 56.2988],
    [-158.3909, 56.2946],
    [-158.3830, 56.2979],
    [-158.3774, 56.3032],
    [-158.3776, 56.3093],
    [-158.3833, 56.3089],
    [-158.3764, 56.3127],
    [-158.3578, 56.3180],
    [-158.3440, 56.3219],
    [-158.3285, 56.3247],
    [-158.3195, 56.3216],
    [-158.3174, 56.3158],
    [-158.3055, 56.3153],
    [-158.2957, 56.3163],
    [-158.2922, 56.3137],
    [-158.2885, 56.3075],
    [-158.2789, 56.3025],
    [-158.2684, 56.3038],
    [-158.2499, 56.3034],
    [-158.2424, 56.2951],
    [-158.2310, 56.2930],
    [-158.2188, 56.2939],
    [-158.2018, 56.2913],
    [-158.2003, 56.2844],
    [-158.2098, 56.2820],
    [-158.2120, 56.2759],
    [-158.2112, 56.2735],
    [-158.2167, 56.2740],
    [-158.2186, 56.2708],
    [-158.2218, 56.2676],
    [-158.2286, 56.2663],
    [-158.2371, 56.2639],
    [-158.2407, 56.2602],
    [-158.2463, 56.2623],
    [-158.2551, 56.2568],
    [-158.2646, 56.2520],
    [-158.2780, 56.2484],
    [-158.2837, 56.2490],
    [-158.2910, 56.2445],
    [-158.2978, 56.2422],
    [-158.3073, 56.2390],
    [-158.3162, 56.2360],
    [-158.3258, 56.2354],
    [-158.3340, 56.2336],
    [-158.3490, 56.2304],
    [-158.3548, 56.2328],
    [-158.3642, 56.2359],
    [-158.3719, 56.2390],
    [-158.3811, 56.2384],
    [-158.3966, 56.2410],
    [-158.4059, 56.2414],
    [-158.4026, 56.2371],
    [-158.3943, 56.2348],
    [-158.3785, 56.2272],
    [-158.3838, 56.2224],
    [-158.3884, 56.2177],
    [-158.3920, 56.2142],
    [-158.3952, 56.2069],
    [-158.3971, 56.2031],
    [-158.3886, 56.2039],
    [-158.3717, 56.2181],
    [-158.3522, 56.2196],
    [-158.3333, 56.2136],
    [-158.2980, 56.2121],
    [-158.2992, 56.2056],
    [-158.3087, 56.1954],
    [-158.3162, 56.1898],
    [-158.3298, 56.1845],
    [-158.3378, 56.1825],
    [-158.3336, 56.1768],
    [-158.3187, 56.1784],
    [-158.3107, 56.1791],
    [-158.3001, 56.1822],
    [-158.2886, 56.1865],
    [-158.2762, 56.1925],
    [-158.2579, 56.1952],
    [-158.2396, 56.2032],
    [-158.2115, 56.2147],
    [-158.1749, 56.2362],
    [-158.1490, 56.2375],
    [-158.1359, 56.2387],
    [-158.1286, 56.2395],
    [-158.1153, 56.2421],
    [-158.1159, 56.2381],
    [-158.1294, 56.2348],
    [-158.1370, 56.2330],
    [-158.1435, 56.2300],
    [-158.1544, 56.2282],
    [-158.1597, 56.2249],
    [-158.1601, 56.2171],
    [-158.1497, 56.2162],
    [-158.1584, 56.2124],
    [-158.1660, 56.2130],
    [-158.1702, 56.2143],
    [-158.1769, 56.2130],
    [-158.1830, 56.2077],
    [-158.1838, 56.2015],
    [-158.1894, 56.1915],
    [-158.2067, 56.1913],
    [-158.2165, 56.1928],
    [-158.2260, 56.1892],
    [-158.2326, 56.1868],
    [-158.2401, 56.1847],
    [-158.2526, 56.1848],
    [-158.2594, 56.1776],
    [-158.2494, 56.1737],
    [-158.2478, 56.1727],
    [-158.2661, 56.1665],
    [-158.2780, 56.1710],
    [-158.2839, 56.1696],
    [-158.3038, 56.1660],
    [-158.3132, 56.1628],
    [-158.3297, 56.1561],
    [-158.3370, 56.1583],
    [-158.3430, 56.1556],
    [-158.3498, 56.1498],
    [-158.3426, 56.1471],
    [-158.3366, 56.1364],
    [-158.3402, 56.1303],
    [-158.3474, 56.1256],
    [-158.3553, 56.1256],
    [-158.3755, 56.1334],
    [-158.3803, 56.1463],
    [-158.3812, 56.1536],
    [-158.3773, 56.1570],
    [-158.3763, 56.1634],
    [-158.3758, 56.1758],
    [-158.3811, 56.1872],
    [-158.3875, 56.1858],
    [-158.3916, 56.1801],
    [-158.3965, 56.1729],
    [-158.3936, 56.1665],
    [-158.4019, 56.1604],
    [-158.4063, 56.1522],
    [-158.4051, 56.1360],
    [-158.4082, 56.1267],
    [-158.4262, 56.1367],
    [-158.4371, 56.1405],
    [-158.4404, 56.1365],
    [-158.4289, 56.1272],
    [-158.4177, 56.1161],
    [-158.4135, 56.1090],
    [-158.4031, 56.1002],
    [-158.3944, 56.0901],
    [-158.3969, 56.0703],
    [-158.4003, 56.0619],
    [-158.4179, 56.0676],
    [-158.4260, 56.0722],
    [-158.4234, 56.0781],
    [-158.4236, 56.0836],
    [-158.4341, 56.0858],
    [-158.4358, 56.0920],
    [-158.4406, 56.0941],
    [-158.4404, 56.0988],
    [-158.4347, 56.1035],
    [-158.4424, 56.1079],
    [-158.4478, 56.1172],
    [-158.4541, 56.1169],
    [-158.4542, 56.1105],
    [-158.4650, 56.1047],
    [-158.4812, 56.1108],
    [-158.4893, 56.1147],
    [-158.4911, 56.1100],
    [-158.4906, 56.1027],
    [-158.5003, 56.0970],
    [-158.5002, 56.0932],
    [-158.4921, 56.0944],
    [-158.4776, 56.0931],
    [-158.4739, 56.0862],
    [-158.4648, 56.0808],
    [-158.4603, 56.0687],
    [-158.4729, 56.0645],
    [-158.4837, 56.0567],
    [-158.4914, 56.0516],
    [-158.4919, 56.0478],
    [-158.4816, 56.0480],
    [-158.4613, 56.0324],
    [-158.4441, 56.0292],
    [-158.4433, 56.0355],
    [-158.4609, 56.0490],
    [-158.4581, 56.0550],
    [-158.4461, 56.0551],
    [-158.4369, 56.0486],
    [-158.4256, 56.0450],
    [-158.4106, 56.0452],
    [-158.4137, 56.0292],
    [-158.4190, 56.0210],
    [-158.4105, 56.0151],
    [-158.4146, 56.0082],
    [-158.4209, 56.0025],
    [-158.4314, 55.9928],
    [-158.4390, 55.9952],
    [-158.4440, 55.9997],
    [-158.4523, 56.0050],
    [-158.4527, 56.0110],
    [-158.4609, 56.0154],
    [-158.4681, 56.0246],
    [-158.4775, 56.0281],
    [-158.4855, 56.0361],
    [-158.4933, 56.0383],
    [-158.5039, 56.0379],
    [-158.5064, 56.0318],
    [-158.5021, 56.0198],
    [-158.5059, 56.0169],
    [-158.4970, 56.0120],
    [-158.4959, 56.0005],
    [-158.4951, 55.9892],
    [-158.4999, 55.9810],
    [-158.5134, 55.9821],
    [-158.5262, 55.9981],
    [-158.5429, 56.0097],
    [-158.5410, 56.0151],
    [-158.5514, 56.0195],
    [-158.5584, 56.0321],
    [-158.5489, 56.0440],
    [-158.5444, 56.0402],
    [-158.5367, 56.0381],
    [-158.5288, 56.0418],
    [-158.5148, 56.0474],
    [-158.5039, 56.0553],
    [-158.4936, 56.0653],
    [-158.4925, 56.0703],
    [-158.5007, 56.0685],
    [-158.5147, 56.0621],
    [-158.5274, 56.0541],
    [-158.5379, 56.0522],
    [-158.5508, 56.0513],
    [-158.5657, 56.0458],
    [-158.5770, 56.0450],
    [-158.5832, 56.0389],
    [-158.5883, 56.0405],
    [-158.5984, 56.0488],
    [-158.5931, 56.0596],
    [-158.5889, 56.0634],
    [-158.5885, 56.0712],
    [-158.5689, 56.0746],
    [-158.5600, 56.0759],
    [-158.5492, 56.0785],
    [-158.5513, 56.0827],
    [-158.5615, 56.0827],
    [-158.5805, 56.0816],
    [-158.5936, 56.0821],
    [-158.5930, 56.0986],
    [-158.5854, 56.1025],
    [-158.5890, 56.1086],
    [-158.5932, 56.1113],
    [-158.5824, 56.1174],
    [-158.5746, 56.1226],
    [-158.5602, 56.1205],
    [-158.5519, 56.1153],
    [-158.5445, 56.1130],
    [-158.5455, 56.1160],
    [-158.5515, 56.1250],
    [-158.5492, 56.1290],
    [-158.5504, 56.1340],
    [-158.5534, 56.1355],
    [-158.5492, 56.1428],
    [-158.5417, 56.1491],
    [-158.5269, 56.1591],
    [-158.5170, 56.1612],
    [-158.4988, 56.1593],
    [-158.4919, 56.1565],
    [-158.4881, 56.1624],
    [-158.4932, 56.1692],
    [-158.5025, 56.1746],
    [-158.5149, 56.1772],
    [-158.5105, 56.1801],
    [-158.4963, 56.1813],
    [-158.4993, 56.1842],
    [-158.5199, 56.1859],
    [-158.5141, 56.1874],
    [-158.4849, 56.1872],
    [-158.4772, 56.1883],
    [-158.4701, 56.1831],
    [-158.4627, 56.1836],
    [-158.4559, 56.1868],
    [-158.4571, 56.1909],
    [-158.4685, 56.1940],
    [-158.4774, 56.1941],
    [-158.4875, 56.1953],
    [-158.5012, 56.1965],
    [-158.5128, 56.1960],
    [-158.5168, 56.1981],
    [-158.5264, 56.1972],
    [-158.5423, 56.1955],
    [-158.5495, 56.1949],
    [-158.5645, 56.1908],
    [-158.5744, 56.1891],
    [-158.5771, 56.1921],
    [-158.5898, 56.1930],
    [-158.6110, 56.2003],
    [-158.6154, 56.2008],
    [-158.6234, 56.2005],
    [-158.6208, 56.1967],
    [-158.6154, 56.1916],
    [-158.6108, 56.1891],
    [-158.5961, 56.1859],
    [-158.5840, 56.1780],
    [-158.5788, 56.1761],
    [-158.5694, 56.1763],
    [-158.5590, 56.1773],
    [-158.5498, 56.1774],
    [-158.5502, 56.1716],
    [-158.5555, 56.1681],
    [-158.5644, 56.1649],
    [-158.5714, 56.1612],
    [-158.5756, 56.1581],
    [-158.5833, 56.1568],
    [-158.5839, 56.1498],
    [-158.5840, 56.1441],
    [-158.5880, 56.1384],
    [-158.5943, 56.1353],
    [-158.5998, 56.1312],
    [-158.6056, 56.1267],
    [-158.6173, 56.1229],
    [-158.6267, 56.1202],
    [-158.6330, 56.1151],
    [-158.6446, 56.1151],
    [-158.6499, 56.1160],
    [-158.6576, 56.1133],
    [-158.6634, 56.1182],
    [-158.6593, 56.1208],
    [-158.6469, 56.1306],
    [-158.6414, 56.1395],
    [-158.6454, 56.1405],
    [-158.6486, 56.1465],
    [-158.6529, 56.1486],
    [-158.6598, 56.1484],
    [-158.6703, 56.1498],
    [-158.6729, 56.1520],
    [-158.6818, 56.1525],
    [-158.6999, 56.1545],
    [-158.7127, 56.1554],
    [-158.7241, 56.1558],
    [-158.7185, 56.1520],
    [-158.7098, 56.1526],
    [-158.7044, 56.1486],
    [-158.6936, 56.1468],
    [-158.6835, 56.1436],
    [-158.6767, 56.1424],
    [-158.6691, 56.1369],
    [-158.6692, 56.1288],
    [-158.6723, 56.1246],
    [-158.6838, 56.1188],
    [-158.6885, 56.1111],
    [-158.6968, 56.1084],
    [-158.6926, 56.1037],
    [-158.6863, 56.1061],
    [-158.6775, 56.1064],
    [-158.6684, 56.1000],
    [-158.6586, 56.0966],
    [-158.6484, 56.0886],
    [-158.6579, 56.0848],
    [-158.6675, 56.0773],
    [-158.6603, 56.0735],
    [-158.6599, 56.0606],
    [-158.6682, 56.0539],
    [-158.6812, 56.0533],
    [-158.6845, 56.0492],
    [-158.6975, 56.0480],
    [-158.7154, 56.0526],
    [-158.7223, 56.0515],
    [-158.7249, 56.0436],
    [-158.7213, 56.0367],
    [-158.7151, 56.0330],
    [-158.6986, 56.0341],
    [-158.6846, 56.0313],
    [-158.6792, 56.0343],
    [-158.6609, 56.0349],
    [-158.6540, 56.0288],
    [-158.6463, 56.0219],
    [-158.6398, 56.0177],
    [-158.6395, 56.0079],
    [-158.6401, 55.9973],
    [-158.6439, 55.9908],
    [-158.6383, 55.9858],
    [-158.6441, 55.9832],
    [-158.6486, 55.9860],
    [-158.6522, 55.9841],
    [-158.6600, 55.9819],
    [-158.6661, 55.9867],
    [-158.6761, 55.9860],
    [-158.6858, 55.9839],
    [-158.6934, 55.9823],
    [-158.6925, 55.9749],
    [-158.6803, 55.9742],
    [-158.6669, 55.9703],
    [-158.6553, 55.9646],
    [-158.6529, 55.9573],
    [-158.6679, 55.9507],
    [-158.6812, 55.9513],
    [-158.6900, 55.9572],
    [-158.6968, 55.9657],
    [-158.7073, 55.9671],
    [-158.7153, 55.9622],
    [-158.7205, 55.9549],
    [-158.7291, 55.9551],
    [-158.7348, 55.9521],
    [-158.7469, 55.9594],
    [-158.7512, 55.9638],
    [-158.7463, 55.9682],
    [-158.7348, 55.9754],
    [-158.7233, 55.9767],
    [-158.7142, 55.9784],
    [-158.7189, 55.9831],
    [-158.7230, 55.9835],
    [-158.7308, 55.9863],
    [-158.7328, 55.9937],
    [-158.7309, 55.9993],
    [-158.7240, 55.9989],
    [-158.7191, 56.0033],
    [-158.7259, 56.0097],
    [-158.7327, 56.0152],
    [-158.7404, 56.0159],
    [-158.7437, 56.0106],
    [-158.7507, 56.0097],
    [-158.7579, 56.0146],
    [-158.7636, 56.0177],
    [-158.7715, 56.0193],
    [-158.7763, 56.0136],
    [-158.7707, 56.0015],
    [-158.7771, 55.9960],
    [-158.7798, 55.9914],
    [-158.7885, 55.9878],
    [-158.7962, 55.9853],
    [-158.8092, 55.9862],
    [-158.8112, 55.9898],
    [-158.8126, 55.9920],
    [-158.8134, 55.9966],
    [-158.8256, 56.0022],
    [-158.8244, 56.0077],
    [-158.8245, 56.0131],
    [-158.8281, 56.0154],
    [-158.8391, 56.0161],
    [-158.8490, 56.0121],
    [-158.8584, 56.0057],
    [-158.8573, 56.0013],
    [-158.8589, 55.9952],
    [-158.8635, 55.9891],
    [-158.8778, 55.9763],
    [-158.8876, 55.9650],
    [-158.9050, 55.9441],
    [-158.9112, 55.9283],
    [-158.9089, 55.9233],
    [-158.9106, 55.9180],
    [-158.9158, 55.9143],
    [-158.9196, 55.9166],
    [-158.9188, 55.9236],
    [-158.9189, 55.9300],
    [-158.9315, 55.9316],
    [-158.9388, 55.9334],
    [-158.9688, 55.9344],
    [-158.9966, 55.9303],
    [-159.0060, 55.9246],
    [-159.0115, 55.9178],
    [-159.0025, 55.9088],
    [-159.0024, 55.8993],
    [-159.0060, 55.8910],
    [-159.0144, 55.8926],
    [-159.0243, 55.8918],
    [-159.0372, 55.8964],
    [-159.0454, 55.9047],
    [-159.0564, 55.9137],
    [-159.0660, 55.9221],
    [-159.0809, 55.9246],
    [-159.0993, 55.9208],
    [-159.1239, 55.9118],
    [-159.1442, 55.9099],
    [-159.1498, 55.9100],
    [-159.1662, 55.9000],
    [-159.1679, 55.8925],
    [-159.1744, 55.8888],
    [-159.1770, 55.8920],
    [-159.1889, 55.8967],
    [-159.2059, 55.8996],
    [-159.2349, 55.8985],
    [-159.2611, 55.8942],
    [-159.2806, 55.8892],
    [-159.2865, 55.8826],
    [-159.2875, 55.8737],
    [-159.2884, 55.8682],
    [-159.2925, 55.8641],
    [-159.2973, 55.8633],
    [-159.3039, 55.8615],
    [-159.3115, 55.8587],
    [-159.3190, 55.8593],
    [-159.3217, 55.8658],
    [-159.3156, 55.8719],
    [-159.3259, 55.8771],
    [-159.3471, 55.8785],
    [-159.3623, 55.8739],
    [-159.3676, 55.8713],
    [-159.3714, 55.8713],
    [-159.3772, 55.8682],
    [-159.3846, 55.8627],
    [-159.3926, 55.8594],
    [-159.4011, 55.8567],
    [-159.4016, 55.8483],
    [-159.4034, 55.8337],
    [-159.4078, 55.8258],
    [-159.4059, 55.8168],
    [-159.4080, 55.8082],
    [-159.4021, 55.7989],
    [-159.4009, 55.7976],
    [-159.4064, 55.7961],
    [-159.4103, 55.7902],
    [-159.4137, 55.7874],
    [-159.4237, 55.7882],
    [-159.4316, 55.7918],
    [-159.4387, 55.7979],
    [-159.4420, 55.8063],
    [-159.4468, 55.8108],
    [-159.4524, 55.8127],
    [-159.4570, 55.8124],
    [-159.4554, 55.8154],
    [-159.4634, 55.8190],
    [-159.4674, 55.8220],
    [-159.4727, 55.8306],
    [-159.4740, 55.8397],
    [-159.4680, 55.8493],
    [-159.4666, 55.8559],
    [-159.4639, 55.8638],
    [-159.4709, 55.8723],
    [-159.4640, 55.8795],
    [-159.4600, 55.8863],
    [-159.4541, 55.8962],
    [-159.4609, 55.8969],
    [-159.4669, 55.8992],
    [-159.4796, 55.9009],
    [-159.4928, 55.9003],
    [-159.5142, 55.8921],
    [-159.5303, 55.8875],
    [-159.5321, 55.8828],
    [-159.5374, 55.8791],
    [-159.5427, 55.8707],
    [-159.5449, 55.8637],
    [-159.5391, 55.8605],
    [-159.5270, 55.8681],
    [-159.5202, 55.8726],
    [-159.5209, 55.8667],
    [-159.5298, 55.8581],
    [-159.5315, 55.8486],
    [-159.5219, 55.8433],
    [-159.5165, 55.8453],
    [-159.5161, 55.8499],
    [-159.5122, 55.8417],
    [-159.5088, 55.8306],
    [-159.5035, 55.8154],
    [-159.5004, 55.8082],
    [-159.5057, 55.8020],
    [-159.5021, 55.7955],
    [-159.4975, 55.7832],
    [-159.4944, 55.7658],
    [-159.5011, 55.7562],
    [-159.5072, 55.7456],
    [-159.5203, 55.7389],
    [-159.5223, 55.7338],
    [-159.5360, 55.7305],
    [-159.5410, 55.7275],
    [-159.5535, 55.7132],
    [-159.5548, 55.7068],
    [-159.5475, 55.7019],
    [-159.5335, 55.6976],
    [-159.5345, 55.6923],
    [-159.5370, 55.6853],
    [-159.5372, 55.6790],
    [-159.5394, 55.6724],
    [-159.5351, 55.6673],
    [-159.5288, 55.6664],
    [-159.5215, 55.6675],
    [-159.5317, 55.6649],
    [-159.5380, 55.6581],
    [-159.5424, 55.6473],
    [-159.5531, 55.6417],
    [-159.5611, 55.6387],
    [-159.5664, 55.6398],
    [-159.5736, 55.6435],
    [-159.5832, 55.6396],
    [-159.5912, 55.6310],
    [-159.5992, 55.6267],
    [-159.6002, 55.6211],
    [-159.6042, 55.6143],
    [-159.6118, 55.6109],
    [-159.6097, 55.6071],
    [-159.6114, 55.6021],
    [-159.6218, 55.5923],
    [-159.6206, 55.5863],
    [-159.6217, 55.5815],
    [-159.6187, 55.5805],
    [-159.6148, 55.5763],
    [-159.6029, 55.5713],
    [-159.5954, 55.5664],
    [-159.6048, 55.5650],
    [-159.6128, 55.5709],
    [-159.6259, 55.5767],
    [-159.6317, 55.5816],
    [-159.6419, 55.5822],
    [-159.6490, 55.5793],
    [-159.6603, 55.5832],
    [-159.6692, 55.5836],
    [-159.6791, 55.5777],
    [-159.6880, 55.5730],
    [-159.6979, 55.5733],
    [-159.7089, 55.5701],
    [-159.7241, 55.5699],
    [-159.7352, 55.5699],
    [-159.7226, 55.5789],
    [-159.7180, 55.5873],
    [-159.7221, 55.5897],
    [-159.7164, 55.5943],
    [-159.6969, 55.5999],
    [-159.7006, 55.6065],
    [-159.7088, 55.6078],
    [-159.7271, 55.6039],
    [-159.7380, 55.6000],
    [-159.7471, 55.6000],
    [-159.7407, 55.6071],
    [-159.7309, 55.6135],
    [-159.7002, 55.6159],
    [-159.6873, 55.6163],
    [-159.6765, 55.6189],
    [-159.6705, 55.6155],
    [-159.6581, 55.6183],
    [-159.6493, 55.6139],
    [-159.6399, 55.6108],
    [-159.6331, 55.6083],
    [-159.6292, 55.6096],
    [-159.6318, 55.6147],
    [-159.6385, 55.6181],
    [-159.6377, 55.6228],
    [-159.6392, 55.6269],
    [-159.6295, 55.6294],
    [-159.6232, 55.6318],
    [-159.6135, 55.6349],
    [-159.6167, 55.6457],
    [-159.6359, 55.6444],
    [-159.6393, 55.6484],
    [-159.6473, 55.6549],
    [-159.6612, 55.6534],
    [-159.6661, 55.6554],
    [-159.6755, 55.6578],
    [-159.6918, 55.6541],
    [-159.6970, 55.6566],
    [-159.7040, 55.6574],
    [-159.7076, 55.6589],
    [-159.6943, 55.6666],
    [-159.6885, 55.6668],
    [-159.6863, 55.6731],
    [-159.6934, 55.6741],
    [-159.6844, 55.6784],
    [-159.6785, 55.6825],
    [-159.6710, 55.6818],
    [-159.6691, 55.6859],
    [-159.6717, 55.6889],
    [-159.6538, 55.6922],
    [-159.6434, 55.6983],
    [-159.6347, 55.6983],
    [-159.6285, 55.6998],
    [-159.6285, 55.7089],
    [-159.6366, 55.7080],
    [-159.6434, 55.7129],
    [-159.6506, 55.7138],
    [-159.6556, 55.7122],
    [-159.6585, 55.7177],
    [-159.6667, 55.7177],
    [-159.6652, 55.7216],
    [-159.6684, 55.7313],
    [-159.6754, 55.7347],
    [-159.6770, 55.7408],
    [-159.6732, 55.7459],
    [-159.6614, 55.7617],
    [-159.6560, 55.7676],
    [-159.6497, 55.7707],
    [-159.6437, 55.7770],
    [-159.6407, 55.7844],
    [-159.6357, 55.7929],
    [-159.6279, 55.8000],
    [-159.6226, 55.8048],
    [-159.6092, 55.8043],
    [-159.6057, 55.8095],
    [-159.6155, 55.8123],
    [-159.6228, 55.8154],
    [-159.6419, 55.8280],
    [-159.6724, 55.8370],
    [-159.7128, 55.8464],
    [-159.7378, 55.8501],
    [-159.7640, 55.8520],
    [-159.7762, 55.8516],
    [-159.7800, 55.8517],
    [-159.7893, 55.8535],
    [-159.7953, 55.8535],
    [-159.8210, 55.8562],
    [-159.8450, 55.8489],
    [-159.8591, 55.8443],
    [-159.8565, 55.8368],
    [-159.8484, 55.8319],
    [-159.8463, 55.8283],
    [-159.8495, 55.8240],
    [-159.8530, 55.8186],
    [-159.8460, 55.8048],
    [-159.8484, 55.7987],
    [-159.8576, 55.7934],
    [-159.8598, 55.7903],
    [-159.8657, 55.7875],
    [-159.8732, 55.7838],
    [-159.8845, 55.7852],
    [-159.9012, 55.7868],
    [-159.9048, 55.7902],
    [-159.9140, 55.7959],
    [-159.9206, 55.7996],
    [-159.9261, 55.8027],
    [-159.9362, 55.8069],
    [-159.9406, 55.8087],
    [-159.9466, 55.8142],
    [-159.9546, 55.8194],
    [-159.9687, 55.8177],
    [-159.9704, 55.8111],
    [-159.9686, 55.8057],
    [-159.9617, 55.7962],
    [-159.9644, 55.7860],
    [-159.9679, 55.7763],
    [-159.9754, 55.7759],
    [-159.9832, 55.7851],
    [-159.9907, 55.7914],
    [-160.0091, 55.7965],
    [-160.0267, 55.7900],
    [-160.0334, 55.7855],
    [-160.0287, 55.7794],
    [-160.0444, 55.7739],
    [-160.0510, 55.7668],
    [-160.0448, 55.7568],
    [-160.0283, 55.7513],
    [-160.0210, 55.7425],
    [-160.0171, 55.7213],
    [-160.0275, 55.7181],
    [-160.0366, 55.7202],
    [-160.0477, 55.7206],
    [-160.0702, 55.7241],
    [-160.0814, 55.7289],
    [-160.0930, 55.7222],
    [-160.0851, 55.7127],
    [-160.0779, 55.7076],
    [-160.0584, 55.7015],
    [-160.0555, 55.6964],
    [-160.0716, 55.6994],
    [-160.0937, 55.7044],
    [-160.1062, 55.7045],
    [-160.1119, 55.7058],
    [-160.1156, 55.7165],
    [-160.1189, 55.7200],
    [-160.1183, 55.7233],
    [-160.1281, 55.7319],
    [-160.1451, 55.7400],
    [-160.1529, 55.7387],
    [-160.1472, 55.7325],
    [-160.1377, 55.7276],
    [-160.1338, 55.7242],
    [-160.1363, 55.7196],
    [-160.1379, 55.7118],
    [-160.1406, 55.6984],
    [-160.1358, 55.6906],
    [-160.1310, 55.6849],
    [-160.1246, 55.6731],
    [-160.1269, 55.6647],
    [-160.1562, 55.6617],
    [-160.1687, 55.6671],
    [-160.1768, 55.6633],
    [-160.1818, 55.6606],
    [-160.2029, 55.6569],
    [-160.2134, 55.6552],
    [-160.2217, 55.6592],
    [-160.2343, 55.6632],
    [-160.2392, 55.6665],
    [-160.2554, 55.6598],
    [-160.2581, 55.6500],
    [-160.2455, 55.6477],
    [-160.2425, 55.6431],
    [-160.2533, 55.6442],
    [-160.2663, 55.6481],
    [-160.2798, 55.6414],
    [-160.2923, 55.6402],
    [-160.3032, 55.6418],
    [-160.3187, 55.6417],
    [-160.3326, 55.6426],
    [-160.3444, 55.6459],
    [-160.3602, 55.6511],
    [-160.3684, 55.6549],
    [-160.3800, 55.6551],
    [-160.3870, 55.6577],
    [-160.4035, 55.6615],
    [-160.4093, 55.6644],
    [-160.4216, 55.6611],
    [-160.4324, 55.6475],
    [-160.4330, 55.6400],
    [-160.4210, 55.6364],
    [-160.4063, 55.6324],
    [-160.3971, 55.6306],
    [-160.3876, 55.6281],
    [-160.3781, 55.6215],
    [-160.3697, 55.6190],
    [-160.3568, 55.6126],
    [-160.3623, 55.6055],
    [-160.3670, 55.6033],
    [-160.3753, 55.6045],
    [-160.3856, 55.6056],
    [-160.3934, 55.6032],
    [-160.3992, 55.5985],
    [-160.4008, 55.5936],
    [-160.4088, 55.5866],
    [-160.4159, 55.5804],
    [-160.4248, 55.5775],
    [-160.4386, 55.5737],
    [-160.4464, 55.5732],
    [-160.4430, 55.5681],
    [-160.4327, 55.5668],
    [-160.4463, 55.5665],
    [-160.4465, 55.5563],
    [-160.4505, 55.5449],
    [-160.4519, 55.5399],
    [-160.4638, 55.5323],
    [-160.4631, 55.5192],
    [-160.4587, 55.5106],
    [-160.4656, 55.5013],
    [-160.4766, 55.4893],
    [-160.4896, 55.4871],
    [-160.4983, 55.4824],
    [-160.5034, 55.4764],
    [-160.5192, 55.4742],
    [-160.5332, 55.4737],
    [-160.5363, 55.4799],
    [-160.5421, 55.4903],
    [-160.5463, 55.5019],
    [-160.5534, 55.5193],
    [-160.5717, 55.5364],
    [-160.5831, 55.5499],
    [-160.5800, 55.5547],
    [-160.5919, 55.5712],
    [-160.5945, 55.5790],
    [-160.5895, 55.5931],
    [-160.5912, 55.6008],
    [-160.5781, 55.6040],
    [-160.5765, 55.6086],
    [-160.5952, 55.6087],
    [-160.6071, 55.6036],
    [-160.6085, 55.5911],
    [-160.6204, 55.5868],
    [-160.6112, 55.5786],
    [-160.6247, 55.5671],
    [-160.6333, 55.5589],
    [-160.6486, 55.5493],
    [-160.6615, 55.5467],
    [-160.6705, 55.5455],
    [-160.6744, 55.5472],
    [-160.6881, 55.5510],
    [-160.7031, 55.5524],
    [-160.7127, 55.5575],
    [-160.7295, 55.5556],
    [-160.7579, 55.5519],
    [-160.7692, 55.5458],
    [-160.7722, 55.5341],
    [-160.7657, 55.5292],
    [-160.7552, 55.5280],
    [-160.7471, 55.5250],
    [-160.7298, 55.5250],
    [-160.7174, 55.5268],
    [-160.7081, 55.5244],
    [-160.6917, 55.5199],
    [-160.6779, 55.5188],
    [-160.6621, 55.5192],
    [-160.6543, 55.5116],
    [-160.6493, 55.5041],
    [-160.6503, 55.4947],
    [-160.6518, 55.4786],
    [-160.6602, 55.4692],
    [-160.6655, 55.4639],
    [-160.6743, 55.4601],
    [-160.6882, 55.4580],
    [-160.7117, 55.4582],
    [-160.7220, 55.4585],
    [-160.7386, 55.4574],
    [-160.7504, 55.4571],
    [-160.7599, 55.4551],
    [-160.7716, 55.4540],
    [-160.7879, 55.4553],
    [-160.8044, 55.4583],
    [-160.8154, 55.4649],
    [-160.8360, 55.4706],
    [-160.8403, 55.4809],
    [-160.8414, 55.4940],
    [-160.8240, 55.5074],
    [-160.8340, 55.5174],
    [-160.8544, 55.5239],
    [-160.8806, 55.5260],
    [-160.9079, 55.5248],
    [-160.9299, 55.5170],
    [-160.9465, 55.5076],
    [-160.9489, 55.5014],
    [-160.9567, 55.4945],
    [-160.9572, 55.4896],
    [-160.9665, 55.4815],
    [-160.9766, 55.4727],
    [-160.9827, 55.4609],
    [-160.9913, 55.4461],
    [-161.0144, 55.4342],
    [-161.0385, 55.4274],
    [-161.0601, 55.4184],
    [-161.0737, 55.4113],
    [-161.1285, 55.3947],
    [-161.1368, 55.3927],
    [-161.1462, 55.3902],
    [-161.1773, 55.3847],
    [-161.1926, 55.3779],
    [-161.2080, 55.3704],
    [-161.2241, 55.3649],
    [-161.2371, 55.3572],
    [-161.2493, 55.3576],
    [-161.2591, 55.3549],
    [-161.2685, 55.3551],
    [-161.2707, 55.3560],
    [-161.2755, 55.3565],
    [-161.2853, 55.3555],
    [-161.2965, 55.3576],
    [-161.3011, 55.3588],
    [-161.3086, 55.3595],
    [-161.3154, 55.3600],
    [-161.3203, 55.3597],
    [-161.3325, 55.3588],
    [-161.3185, 55.3636],
    [-161.3154, 55.3678],
    [-161.3140, 55.3729],
    [-161.3285, 55.3824],
    [-161.3593, 55.3836],
    [-161.4048, 55.3748],
    [-161.4173, 55.3705],
    [-161.4184, 55.3666],
    [-161.4256, 55.3643],
    [-161.4369, 55.3659],
    [-161.4457, 55.3617],
    [-161.4510, 55.3604],
    [-161.4603, 55.3588],
    [-161.4723, 55.3579],
    [-161.4868, 55.3590],
    [-161.4919, 55.3586],
    [-161.4964, 55.3614],
    [-161.5111, 55.3695],
    [-161.5155, 55.3884],
    [-161.4941, 55.4001],
    [-161.4924, 55.4037],
    [-161.4920, 55.4067],
    [-161.4887, 55.4105],
    [-161.4824, 55.4185],
    [-161.4831, 55.4255],
    [-161.4804, 55.4344],
    [-161.4769, 55.4421],
    [-161.4802, 55.4462],
    [-161.4781, 55.4536],
    [-161.4729, 55.4600],
    [-161.4737, 55.4656],
    [-161.4758, 55.4691],
    [-161.4743, 55.4754],
    [-161.4720, 55.4817],
    [-161.4806, 55.4877],
    [-161.4861, 55.4857],
    [-161.4922, 55.4868],
    [-161.4834, 55.4900],
    [-161.4680, 55.4966],
    [-161.4586, 55.5020],
    [-161.4392, 55.5167],
    [-161.4263, 55.5245],
    [-161.4246, 55.5299],
    [-161.4186, 55.5359],
    [-161.4167, 55.5415],
    [-161.4088, 55.5477],
    [-161.4029, 55.5536],
    [-161.3965, 55.5596],
    [-161.3811, 55.5683],
    [-161.3651, 55.5845],
    [-161.3626, 55.5944],
    [-161.3664, 55.6044],
    [-161.3589, 55.6061],
    [-161.3635, 55.6160],
    [-161.3878, 55.6271],
    [-161.4548, 55.6336],
    [-161.5177, 55.6316],
    [-161.5494, 55.6269],
    [-161.5876, 55.6198],
    [-161.6034, 55.6128],
    [-161.6136, 55.6075],
    [-161.6135, 55.6024],
    [-161.6097, 55.5980],
    [-161.6089, 55.5952],
    [-161.6281, 55.5870],
    [-161.6313, 55.5832],
    [-161.6325, 55.5786],
    [-161.6389, 55.5744],
    [-161.6400, 55.5687],
    [-161.6311, 55.5656],
    [-161.6509, 55.5587],
    [-161.6542, 55.5558],
    [-161.6693, 55.5455],
    [-161.6766, 55.5383],
    [-161.6739, 55.5316],
    [-161.6896, 55.5246],
    [-161.7006, 55.5183],
    [-161.6875, 55.5059],
    [-161.6949, 55.4876],
    [-161.6917, 55.4757],
    [-161.6943, 55.4581],
    [-161.6995, 55.4370],
    [-161.7004, 55.4288],
    [-161.6969, 55.4224],
    [-161.6905, 55.4154],
    [-161.6869, 55.4064],
    [-161.7195, 55.3766],
    [-161.7511, 55.3530],
    [-161.7921, 55.3217],
    [-161.8179, 55.2999],
    [-161.8372, 55.2847],
    [-161.8561, 55.2748],
    [-161.8735, 55.2529],
    [-161.8778, 55.2295],
    [-161.8803, 55.2221],
    [-161.8857, 55.2177],
    [-161.8994, 55.2180],
    [-161.9030, 55.2121],
    [-161.8972, 55.2091],
    [-161.9081, 55.2051],
    [-161.9197, 55.2075],
    [-161.9325, 55.2142],
    [-161.9432, 55.2198],
    [-161.9571, 55.2270],
    [-161.9716, 55.2319],
    [-161.9765, 55.2351],
    [-161.9861, 55.2370],
    [-162.0014, 55.2362],
    [-162.0161, 55.2376],
    [-162.0308, 55.2353],
    [-162.0333, 55.2310],
    [-162.0393, 55.2270],
    [-162.0334, 55.2204],
    [-162.0230, 55.2222],
    [-162.0189, 55.2160],
    [-162.0147, 55.2165],
    [-162.0140, 55.2075],
    [-162.0131, 55.2042],
    [-162.0087, 55.1980],
    [-162.0028, 55.1909],
    [-161.9973, 55.1880],
    [-161.9997, 55.1813],
    [-162.0057, 55.1781],
    [-162.0137, 55.1792],
    [-162.0187, 55.1750],
    [-162.0136, 55.1696],
    [-161.9952, 55.1671],
    [-161.9845, 55.1649],
    [-161.9710, 55.1650],
    [-161.9639, 55.1552],
    [-161.9589, 55.1437],
    [-161.9626, 55.1371],
    [-161.9499, 55.1282],
    [-161.9498, 55.1214],
    [-161.9523, 55.1132],
    [-161.9640, 55.1041],
    [-161.9759, 55.1017],
    [-161.9879, 55.0956],
    [-162.0059, 55.0936],
    [-162.0204, 55.0913],
    [-162.0299, 55.0860],
    [-162.0388, 55.0792],
    [-162.0471, 55.0742],
    [-162.0558, 55.0718],
    [-162.0621, 55.0784],
    [-162.0672, 55.0820],
    [-162.0727, 55.0849],
    [-162.0801, 55.0892],
    [-162.0917, 55.0939],
    [-162.1187, 55.1029],
    [-162.1328, 55.1096],
    [-162.1371, 55.1142],
    [-162.1148, 55.1247],
    [-162.1046, 55.1291],
    [-162.1150, 55.1326],
    [-162.1175, 55.1403],
    [-162.1279, 55.1526],
    [-162.1629, 55.1560],
    [-162.1790, 55.1509],
    [-162.1917, 55.1344],
    [-162.2174, 55.1211],
    [-162.2258, 55.1103],
    [-162.2281, 55.1043],
    [-162.2229, 55.0989],
    [-162.2141, 55.0905],
    [-162.2017, 55.0879],
    [-162.2081, 55.0783],
    [-162.2036, 55.0718],
    [-162.1921, 55.0673],
    [-162.1921, 55.0574],
    [-162.2043, 55.0450],
    [-162.2175, 55.0316],
    [-162.2206, 55.0286],
    [-162.2287, 55.0253],
    [-162.2516, 55.0183],
    [-162.2778, 55.0217],
    [-162.2911, 55.0290],
    [-162.2958, 55.0342],
    [-162.3025, 55.0385],
    [-162.3064, 55.0480],
    [-162.3121, 55.0583],
    [-162.3200, 55.0598],
    [-162.3280, 55.0543],
    [-162.3304, 55.0436],
    [-162.3349, 55.0393],
    [-162.3419, 55.0371],
    [-162.3648, 55.0414],
    [-162.3774, 55.0411],
    [-162.3969, 55.0377],
    [-162.4055, 55.0332],
    [-162.4133, 55.0323],
    [-162.4182, 55.0365],
    [-162.4507, 55.0458],
    [-162.4647, 55.0513],
    [-162.4674, 55.0522],
    [-162.4777, 55.0550],
    [-162.4875, 55.0618],
    [-162.4956, 55.0684],
    [-162.5007, 55.0728],
    [-162.4995, 55.0771],
    [-162.5055, 55.0806],
    [-162.5087, 55.0849],
    [-162.5093, 55.0940],
    [-162.5109, 55.0973],
    [-162.5199, 55.1032],
    [-162.5199, 55.1080],
    [-162.5197, 55.1131],
    [-162.5156, 55.1163],
    [-162.5068, 55.1173],
    [-162.4906, 55.1203],
    [-162.4723, 55.1226],
    [-162.4570, 55.1236],
    [-162.4405, 55.1134],
    [-162.4360, 55.1060],
    [-162.4266, 55.1029],
    [-162.4111, 55.1003],
    [-162.4089, 55.1045],
    [-162.4020, 55.0984],
    [-162.3910, 55.0994],
    [-162.3844, 55.0996],
    [-162.3739, 55.1032],
    [-162.3667, 55.1018],
    [-162.3567, 55.1026],
    [-162.3497, 55.1077],
    [-162.3526, 55.1114],
    [-162.3643, 55.1153],
    [-162.3761, 55.1175],
    [-162.3872, 55.1158],
    [-162.3984, 55.1170],
    [-162.4058, 55.1172],
    [-162.4136, 55.1227],
    [-162.4201, 55.1277],
    [-162.4308, 55.1358],
    [-162.4346, 55.1407],
    [-162.4436, 55.1465],
    [-162.4489, 55.1520],
    [-162.4699, 55.1555],
    [-162.4868, 55.1638],
    [-162.4911, 55.1722],
    [-162.4948, 55.1777],
    [-162.4989, 55.1845],
    [-162.4985, 55.1900],
    [-162.4999, 55.1935],
    [-162.5029, 55.1986],
    [-162.5039, 55.2083],
    [-162.5049, 55.2183],
    [-162.5078, 55.2303],
    [-162.5117, 55.2397],
    [-162.5147, 55.2450],
    [-162.5154, 55.2516],
    [-162.5401, 55.2590],
    [-162.5761, 55.2681],
    [-162.6071, 55.2719],
    [-162.6349, 55.2739],
    [-162.6268, 55.2795],
    [-162.6206, 55.2801],
    [-162.6140, 55.2782],
    [-162.6057, 55.2772],
    [-162.5960, 55.2796],
    [-162.5872, 55.2802],
    [-162.5788, 55.2789],
    [-162.5734, 55.2792],
    [-162.5765, 55.2823],
    [-162.5799, 55.2880],
    [-162.5815, 55.2910],
    [-162.5686, 55.2896],
    [-162.5638, 55.2865],
    [-162.5613, 55.2865],
    [-162.5612, 55.2896],
    [-162.5632, 55.2926],
    [-162.5638, 55.2953],
    [-162.5616, 55.2979],
    [-162.5654, 55.2995],
    [-162.5727, 55.2994],
    [-162.5765, 55.2972],
    [-162.5806, 55.2980],
    [-162.5869, 55.2993],
    [-162.5885, 55.2955],
    [-162.5935, 55.3003],
    [-162.6038, 55.3026],
    [-162.6128, 55.3001],
    [-162.6247, 55.3005],
    [-162.6288, 55.3017],
    [-162.6329, 55.3055],
    [-162.6398, 55.3047],
    [-162.6477, 55.3025],
    [-162.6633, 55.2979],
    [-162.6709, 55.2930],
    [-162.6776, 55.2867],
    [-162.6830, 55.2823],
    [-162.6622, 55.2778],
    [-162.6659, 55.2751],
    [-162.6796, 55.2728],
    [-162.6964, 55.2653],
    [-162.7157, 55.2424],
    [-162.7194, 55.2345],
    [-162.7249, 55.2209],
    [-162.7191, 55.2106],
    [-162.7109, 55.2093],
    [-162.7046, 55.2065],
    [-162.6973, 55.1958],
    [-162.6789, 55.1966],
    [-162.6609, 55.1959],
    [-162.6471, 55.1964],
    [-162.6414, 55.1886],
    [-162.6363, 55.1818],
    [-162.6257, 55.1765],
    [-162.6215, 55.1731],
    [-162.6171, 55.1704],
    [-162.6148, 55.1620],
    [-162.6105, 55.1543],
    [-162.5982, 55.1502],
    [-162.5934, 55.1433],
    [-162.5885, 55.1385],
    [-162.5959, 55.1265],
    [-162.6106, 55.1282],
    [-162.6236, 55.1215],
    [-162.6269, 55.1148],
    [-162.6256, 55.1063],
    [-162.6211, 55.0984],
    [-162.6023, 55.0871],
    [-162.6010, 55.0745],
    [-162.6016, 55.0687],
    [-162.5955, 55.0648],
    [-162.5973, 55.0557],
    [-162.5902, 55.0505],
    [-162.5877, 55.0436],
    [-162.5839, 55.0400],
    [-162.5816, 55.0331],
    [-162.5759, 55.0243],
    [-162.5693, 55.0159],
    [-162.5704, 54.9966],
    [-162.5700, 54.9747],
    [-162.5623, 54.9665],
    [-162.5516, 54.9640],
    [-162.5527, 54.9594],
    [-162.5592, 54.9556],
    [-162.5736, 54.9593],
    [-162.5836, 54.9642],
    [-162.5878, 54.9734],
    [-162.6070, 54.9812],
    [-162.6165, 54.9895],
    [-162.6398, 54.9961],
    [-162.6585, 54.9982],
    [-162.6886, 54.9965],
    [-162.7086, 54.9893],
    [-162.7178, 54.9827],
    [-162.7113, 54.9773],
    [-162.7058, 54.9717],
    [-162.7076, 54.9657],
    [-162.7050, 54.9612],
    [-162.7124, 54.9602],
    [-162.7164, 54.9552],
    [-162.7284, 54.9538],
    [-162.7420, 54.9504],
    [-162.7419, 54.9463],
    [-162.7502, 54.9406],
    [-162.7632, 54.9380],
    [-162.7735, 54.9348],
    [-162.7929, 54.9386],
    [-162.8090, 54.9423],
    [-162.8240, 54.9389],
    [-162.8298, 54.9326],
    [-162.8342, 54.9286],
    [-162.8530, 54.9294],
    [-162.8637, 54.9304],
    [-162.8811, 54.9337],
    [-162.8898, 54.9415],
    [-162.8988, 54.9475],
    [-162.9192, 54.9520],
    [-162.9149, 54.9563],
    [-162.9215, 54.9638],
    [-162.9188, 54.9687],
    [-162.9240, 54.9716],
    [-162.9416, 54.9773],
    [-162.9562, 54.9889],
    [-162.9630, 54.9965],
    [-162.9641, 55.0045],
    [-162.9643, 55.0120],
    [-162.9546, 55.0186],
    [-162.9446, 55.0208],
    [-162.9499, 55.0273],
    [-162.9613, 55.0357],
    [-162.9669, 55.0448],
    [-162.9821, 55.0496],
    [-162.9971, 55.0673],
    [-163.0157, 55.0833],
    [-163.0489, 55.0991],
    [-163.0941, 55.1080],
    [-163.1433, 55.0942],
    [-163.1630, 55.0957],
    [-163.1846, 55.0977],
    [-163.1923, 55.0795],
    [-163.2058, 55.0610],
    [-163.2196, 55.0354],
    [-163.2133, 55.0261],
    [-163.1792, 55.0133],
    [-163.1486, 55.0140],
    [-163.1003, 54.9909],
    [-163.0713, 54.9826],
    [-163.0504, 54.9708],
    [-163.0451, 54.9508],
    [-163.0305, 54.9482],
    [-163.0389, 54.9410],
    [-163.0556, 54.9317],
    [-163.0698, 54.9249],
    [-163.0984, 54.9159],
    [-163.1357, 54.9006],
    [-163.1496, 54.8859],
    [-163.1756, 54.8705],
    [-163.1977, 54.8690],
    [-163.2160, 54.8483],
    [-163.2246, 54.8404],
    [-163.2405, 54.8368],
    [-163.2590, 54.8322],
    [-163.2781, 54.8311],
    [-163.2998, 54.8292],
    [-163.3028, 54.8174],
    [-163.3108, 54.8121],
    [-163.3337, 54.8092],
    [-163.3572, 54.8108],
    [-163.3620, 54.8242],
    [-163.3755, 54.8439],
    [-163.3848, 54.8535],
    [-163.3781, 54.8583],
    [-163.3508, 54.8679],
    [-163.3399, 54.8712],
    [-163.3189, 54.8801],
    [-163.3191, 54.8972],
    [-163.3207, 54.9037],
    [-163.3367, 54.9175],
    [-163.3457, 54.9330],
    [-163.3414, 54.9498],
    [-163.3323, 54.9541],
    [-163.3100, 54.9517],
    [-163.3019, 54.9387],
    [-163.2843, 54.9423],
    [-163.2725, 54.9391],
    [-163.2487, 54.9389],
    [-163.2297, 54.9309],
    [-163.2216, 54.9369],
    [-163.2349, 54.9450],
    [-163.2570, 54.9521],
    [-163.2916, 54.9662],
    [-163.2946, 54.9768],
    [-163.2887, 54.9867],
    [-163.2840, 54.9993],
    [-163.2827, 55.0222],
    [-163.2820, 55.0395],
    [-163.2922, 55.0618],
    [-163.3138, 55.0772],
    [-163.3079, 55.0931],
    [-163.2991, 55.1052],
    [-163.3055, 55.1085],
    [-163.3281, 55.0980],
    [-163.3414, 55.0865],
    [-163.3830, 55.0727],
    [-163.4110, 55.0595],
    [-163.4058, 55.0524],
    [-163.3689, 55.0617],
    [-163.3663, 55.0583],
    [-163.4063, 55.0475],
    [-163.4189, 55.0564],
    [-163.4208, 55.0675],
    [-163.3704, 55.0829],
    [-163.3262, 55.1039],
    [-163.2869, 55.1222],
    [-163.2511, 55.1373],
    [-163.2137, 55.1562],
    [-163.1786, 55.1679],
    [-163.1455, 55.1759],
    [-163.1146, 55.1772],
    [-163.0531, 55.2118],
    [-163.0070, 55.2462],
    [-162.9915, 55.2445],
    [-162.9956, 55.2406],
    [-163.0015, 55.2327],
    [-163.0234, 55.2286],
    [-163.0091, 55.2239],
    [-163.0295, 55.2109],
    [-163.0497, 55.2022],
    [-163.0699, 55.1855],
    [-163.0809, 55.1737],
    [-163.0638, 55.1707],
    [-163.0452, 55.1689],
    [-163.0248, 55.1700],
    [-163.0032, 55.1738],
    [-162.9887, 55.1770],
    [-162.9742, 55.1755],
    [-162.9556, 55.1624],
    [-162.9338, 55.1622],
    [-162.9335, 55.1767],
    [-162.8824, 55.1813],
    [-162.8684, 55.1837],
    [-162.8639, 55.2014],
    [-162.8589, 55.2153],
    [-162.8511, 55.2196],
    [-162.8463, 55.2309],
    [-162.8572, 55.2454],
    [-162.8732, 55.2453],
    [-162.8836, 55.2345],
    [-162.8907, 55.2384],
    [-162.9012, 55.2433],
    [-162.9107, 55.2495],
    [-162.8924, 55.2593],
    [-162.8922, 55.2666],
    [-162.8881, 55.2736],
    [-162.8698, 55.2752],
    [-162.8477, 55.2746],
    [-162.8468, 55.2675],
    [-162.8373, 55.2682],
    [-162.8232, 55.2790],
    [-162.8201, 55.2881],
    [-162.8066, 55.2959],
    [-162.8133, 55.2995],
    [-162.7980, 55.3110],
    [-162.7622, 55.3096],
    [-162.7436, 55.3087],
    [-162.7291, 55.3123],
    [-162.7103, 55.3227],
    [-162.7084, 55.3292],
    [-162.6928, 55.3356],
    [-162.6885, 55.3472],
    [-162.6889, 55.3527],
    [-162.6756, 55.3572],
    [-162.6604, 55.3654],
    [-162.6416, 55.3926],
    [-162.6452, 55.3827],
    [-162.6405, 55.3683],
    [-162.6198, 55.3637],
    [-162.5870, 55.3526],
    [-162.5501, 55.3525],
    [-162.5359, 55.3585],
    [-162.5126, 55.3742],
    [-162.5111, 55.3805],
    [-162.5109, 55.3860],
    [-162.5066, 55.3895],
    [-162.5010, 55.3928],
    [-162.5034, 55.4028],
    [-162.5047, 55.4117],
    [-162.5169, 55.4174],
    [-162.5181, 55.4324],
    [-162.5071, 55.4519],
    [-162.5090, 55.4589],
    [-162.5157, 55.4604],
    [-162.5235, 55.4612],
    [-162.5390, 55.4589],
    [-162.5459, 55.4564],
    [-162.5521, 55.4539],
    [-162.5700, 55.4497],
    [-162.5818, 55.4443],
    [-162.5903, 55.4492],
    [-162.5720, 55.4615],
    [-162.4926, 55.5117],
    [-162.4646, 55.5351],
    [-162.4118, 55.5725],
    [-162.3434, 55.6214],
    [-162.2830, 55.6736],
    [-162.2142, 55.7134],
    [-162.0975, 55.7633],
    [-162.0634, 55.7861],
    [-161.9945, 55.7978],
    [-161.9120, 55.8305],
    [-161.8602, 55.8609],
    [-161.8188, 55.8861],
    [-161.8035, 55.8942],
    [-161.7734, 55.8973],
    [-161.7358, 55.9043],
    [-161.7133, 55.9074],
    [-161.6864, 55.9110],
    [-161.6436, 55.9201],
    [-161.5826, 55.9365],
    [-161.4763, 55.9530],
    [-161.3995, 55.9643],
    [-161.3651, 55.9699],
    [-161.2914, 55.9839],
    [-161.2257, 56.0004],
    [-161.1766, 56.0105],
    [-161.0863, 56.0136],
    [-161.0907, 56.0097],
    [-161.1141, 56.0094],
    [-161.1281, 56.0084],
    [-161.1402, 56.0077],
    [-161.1726, 56.0057],
    [-161.1973, 56.0016],
    [-161.2093, 55.9979],
    [-161.2750, 55.9846],
    [-161.2839, 55.9724],
    [-161.2800, 55.9587],
    [-161.2588, 55.9574],
    [-161.2463, 55.9581],
    [-161.2310, 55.9546],
    [-161.2231, 55.9534],
    [-161.2056, 55.9572],
    [-161.1886, 55.9611],
    [-161.1403, 55.9531],
    [-161.1308, 55.9599],
    [-161.1354, 55.9645],
    [-161.1270, 55.9628],
    [-161.1172, 55.9605],
    [-161.1010, 55.9644],
    [-161.1007, 55.9549],
    [-161.0927, 55.9495],
    [-161.0770, 55.9435],
    [-161.0594, 55.9442],
    [-161.0397, 55.9494],
    [-161.0234, 55.9595],
    [-161.0245, 55.9641],
    [-161.0109, 55.9636],
    [-160.9872, 55.9701],
    [-160.9674, 55.9700],
    [-160.9502, 55.9815],
    [-160.9465, 55.9911],
    [-160.9449, 55.9955],
    [-160.9403, 55.9900],
    [-160.9408, 55.9879],
    [-160.9368, 55.9853],
    [-160.9201, 55.9871],
    [-160.9102, 55.9920],
    [-160.8912, 55.9940],
    [-160.8957, 55.9955],
    [-160.9019, 55.9954],
    [-160.9074, 55.9960],
    [-160.8935, 55.9995],
    [-160.8780, 55.9995],
    [-160.8681, 55.9971],
    [-160.8610, 55.9812],
    [-160.8620, 55.9642],
    [-160.8528, 55.9468],
    [-160.8538, 55.9384],
    [-160.8545, 55.9303],
    [-160.8683, 55.9350],
    [-160.8870, 55.9484],
    [-160.9002, 55.9535],
    [-160.9118, 55.9527],
    [-160.9208, 55.9506],
    [-160.9416, 55.9465],
    [-160.9579, 55.9428],
    [-160.9786, 55.9367],
    [-161.0138, 55.9151],
    [-161.0214, 55.8949],
    [-160.9993, 55.8718],
    [-160.9805, 55.8696],
    [-160.9513, 55.8684],
    [-160.9342, 55.8821],
    [-160.9315, 55.8725],
    [-160.9544, 55.8488],
    [-160.9548, 55.8342],
    [-160.9394, 55.8116],
    [-160.9075, 55.8026],
    [-160.9002, 55.8094],
    [-160.8907, 55.7960],
    [-160.8758, 55.7886],
    [-160.8626, 55.7734],
    [-160.8498, 55.7626],
    [-160.8329, 55.7552],
    [-160.8236, 55.7486],
    [-160.8141, 55.7404],
    [-160.7999, 55.7287],
    [-160.7835, 55.7273],
    [-160.7809, 55.7369],
    [-160.7774, 55.7515],
    [-160.7573, 55.7510],
    [-160.7216, 55.7438],
    [-160.6996, 55.7270],
    [-160.6996, 55.7163],
    [-160.6896, 55.7036],
    [-160.6699, 55.6974],
    [-160.6649, 55.7111],
    [-160.6739, 55.7144],
    [-160.6805, 55.7313],
    [-160.6661, 55.7242],
    [-160.6556, 55.7300],
    [-160.6630, 55.7455],
    [-160.6903, 55.7507],
    [-160.6901, 55.7572],
    [-160.6886, 55.7674],
    [-160.7077, 55.7705],
    [-160.7160, 55.7745],
    [-160.7380, 55.7746],
    [-160.7549, 55.7777],
    [-160.7621, 55.7861],
    [-160.7548, 55.8000],
    [-160.7579, 55.8106],
    [-160.7530, 55.8239],
    [-160.7602, 55.8308],
    [-160.7668, 55.8546],
    [-160.7823, 55.8678],
    [-160.7932, 55.8860],
    [-160.7566, 55.8813],
    [-160.6976, 55.8624],
    [-160.6391, 55.8583],
    [-160.5957, 55.8590],
    [-160.5803, 55.8605],
    [-160.5403, 55.8646],
    [-160.5320, 55.8656],
    [-160.5189, 55.8672],
    [-160.5158, 55.8604],
    [-160.4792, 55.8469],
    [-160.4662, 55.8391],
    [-160.4695, 55.8287],
    [-160.4754, 55.8047],
    [-160.4685, 55.7907],
    [-160.4387, 55.7896],
    [-160.4327, 55.8024],
    [-160.4096, 55.8085],
    [-160.3859, 55.7964],
    [-160.3818, 55.7825],
    [-160.3652, 55.7770],
    [-160.3400, 55.7774],
    [-160.3162, 55.7781],
    [-160.2860, 55.7687],
    [-160.2717, 55.7654],
    [-160.2485, 55.7750],
    [-160.2494, 55.7818],
    [-160.2596, 55.7761],
    [-160.2917, 55.7965],
    [-160.3088, 55.8117],
    [-160.3169, 55.8231],
    [-160.2948, 55.8238],
    [-160.2661, 55.8325],
    [-160.2387, 55.8298],
    [-160.2216, 55.8345],
    [-160.2420, 55.8435],
    [-160.2480, 55.8517],
    [-160.2660, 55.8573],
    [-160.2822, 55.8557],
    [-160.2978, 55.8589],
    [-160.3093, 55.8624],
    [-160.3411, 55.8708],
    [-160.3552, 55.8769],
    [-160.3644, 55.8854],
    [-160.3806, 55.8895],
    [-160.3977, 55.8965],
    [-160.4148, 55.9061],
    [-160.4626, 55.9169],
    [-160.4859, 55.9269],
    [-160.5013, 55.9351],
    [-160.5073, 55.9415],
    [-160.5256, 55.9464],
    [-160.5408, 55.9460],
    [-160.5271, 55.9730],
    [-160.5301, 55.9846],
    [-160.5520, 55.9918],
    [-160.5744, 55.9866],
    [-160.5824, 55.9766],
    [-160.5684, 56.0041],
    [-160.5330, 56.0330],
    [-160.4999, 56.0635],
    [-160.4735, 56.0927],
    [-160.4502, 56.1242],
    [-160.4457, 56.1458],
    [-160.4324, 56.1675],
    [-160.4043, 56.2118],
    [-160.3827, 56.2484],
    [-160.3504, 56.2835],
    [-160.2746, 56.3172],
    [-160.2285, 56.3421],
    [-160.1963, 56.3725],
    [-160.1496, 56.3963],
    [-160.1213, 56.4026],
    [-160.0780, 56.4114],
    [-160.0065, 56.4417],
    [-159.9428, 56.4733],
    [-159.8808, 56.5084],
    [-159.8287, 56.5418],
    [-159.7534, 56.5631],
    [-159.6383, 56.5947],
    [-159.5485, 56.6212],
    [-159.4888, 56.6452],
    [-159.3888, 56.6905],
    [-159.3377, 56.6990],
    [-159.2631, 56.7233],
    [-159.2256, 56.7345],
    [-159.1847, 56.7527],
    [-159.1418, 56.7688],
    [-159.0814, 56.7901],
    [-159.0331, 56.8079],
    [-158.9974, 56.8270],
    [-158.9637, 56.8462],
    [-158.9228, 56.8682],
    [-158.8935, 56.8803],
    [-158.8565, 56.8905],
    [-158.8388, 56.8900],
    [-158.8553, 56.8880],
    [-158.8706, 56.8841],
    [-158.8935, 56.8723],
    [-158.9020, 56.8702],
    [-158.9191, 56.8657],
    [-158.9473, 56.8489],
    [-158.9476, 56.8414],
    [-158.9395, 56.8334],
    [-158.9266, 56.8207],
    [-158.9119, 56.8137],
    [-158.8931, 56.8073],
    [-158.8762, 56.8022],
    [-158.8489, 56.7958],
    [-158.8156, 56.7887],
    [-158.7963, 56.7866],
    [-158.7677, 56.7881],
    [-158.7445, 56.7951],
    [-158.7258, 56.7963],
    [-158.7105, 56.7978],
    [-158.6889, 56.7956],
    [-158.6742, 56.7971],
    [-158.6564, 56.8100],
    [-158.6567, 56.8235],
    [-158.6530, 56.8404],
    [-158.6593, 56.8544],
    [-158.6720, 56.8592],
    [-158.6748, 56.8727],
    [-158.6780, 56.8794],
    [-158.6926, 56.8968],
    [-158.6907, 56.9006],
    [-158.6867, 56.9071],
    [-158.6849, 56.9180],
    [-158.6822, 56.9215],
    [-158.6816, 56.9229],
    [-158.6967, 56.9435],
    [-158.6912, 56.9630],
    [-158.6836, 56.9838],
    [-158.6719, 57.0001],
    [-158.6531, 57.0225],
    [-158.6348, 57.0417],
    [-158.6083, 57.0645],
    [-158.5753, 57.0912],
    [-158.5628, 57.1039],
    [-158.5402, 57.1251],
    [-158.5070, 57.1513],
    [-158.4887, 57.1660],
    [-158.4700, 57.1776],
    [-158.4553, 57.1926],
    [-158.4356, 57.2070],
    [-158.4099, 57.2261],
    [-158.3796, 57.2465],
    [-158.3405, 57.2706],
    [-158.3071, 57.2896],
    [-158.2748, 57.3001],
    [-158.2515, 57.3093],
    [-158.2174, 57.3240],
    [-158.1702, 57.3389],
    [-158.1377, 57.3456],
    [-158.1137, 57.3508],
    [-158.0847, 57.3637],
    [-158.0748, 57.3743],
    [-158.0528, 57.3872],
    [-158.0124, 57.4013],
    [-157.9876, 57.4179],
    [-157.9571, 57.4459],
    [-157.9351, 57.4698],
    [-157.9150, 57.4797],
    [-157.8703, 57.4936],
    [-157.8266, 57.5186],
    [-157.7880, 57.5422],
    [-157.7475, 57.5562],
    [-157.7055, 57.5639],
    [-157.6878, 57.5658],
    [-157.6807, 57.5635],
    [-157.6840, 57.5615],
    [-157.6885, 57.5562],
    [-157.6915, 57.5517],
    [-157.6860, 57.5478],
    [-157.6804, 57.5377],
    [-157.6607, 57.5220],
    [-157.6524, 57.5082],
    [-157.6514, 57.4979],
    [-157.6243, 57.4926],
    [-157.5877, 57.4938],
    [-157.5849, 57.5022],
    [-157.5782, 57.5091],
    [-157.5704, 57.5239],
    [-157.5779, 57.5418],
    [-157.5832, 57.5601],
    [-157.5844, 57.5622],
    [-157.5939, 57.5948],
    [-157.6013, 57.6096],
    [-157.6107, 57.6097],
    [-157.6278, 57.6139],
    [-157.6562, 57.6128],
    [-157.6735, 57.6144],
    [-157.6909, 57.6122],
    [-157.7008, 57.6165],
    [-157.7053, 57.6271],
    [-157.7112, 57.6377],
    [-157.7065, 57.6896],
    [-157.7043, 57.7154],
    [-157.6955, 57.7332],
    [-157.6714, 57.7700],
    [-157.6613, 57.7921],
    [-157.6550, 57.8117],
    [-157.6486, 57.8368],
    [-157.6432, 57.8654],
    [-157.6387, 57.8854],
    [-157.6298, 57.9261],
    [-157.6255, 57.9603],
    [-157.6177, 57.9953],
    [-157.6096, 58.0291],
    [-157.6039, 58.0503],
    [-157.5959, 58.0781],
    [-157.5899, 58.1017],
    [-157.5806, 58.1233],
    [-157.5674, 58.1394],
    [-157.5547, 58.1542],
    [-157.5410, 58.1775],
    [-157.5273, 58.1909],
    [-157.5288, 58.1807],
    [-157.5295, 58.1706],
    [-157.5151, 58.1611],
    [-157.4917, 58.1620],
    [-157.4633, 58.1637],
    [-157.4230, 58.1673],
    [-157.4069, 58.1738],
    [-157.3915, 58.1947],
    [-157.4342, 58.2070],
    [-157.4459, 58.2092],
    [-157.4691, 58.2261],
    [-157.4948, 58.2421],
    [-157.5362, 58.2716],
    [-157.5396, 58.2823],
    [-157.5302, 58.2908],
    [-157.5399, 58.2928],
    [-157.5473, 58.3113],
    [-157.5466, 58.3341],
    [-157.5387, 58.3696],
    [-157.5319, 58.3950],
    [-157.5202, 58.4160],
    [-157.5069, 58.4358],
    [-157.4898, 58.4565],
    [-157.4815, 58.4761],
    [-157.4626, 58.4954],
    [-157.4477, 58.5073],
    [-157.4214, 58.5131],
    [-157.4075, 58.5232],
    [-157.3889, 58.5264],
    [-157.3586, 58.5345],
    [-157.3359, 58.5474],
    [-157.3096, 58.5697],
    [-157.2600, 58.6166],
    [-157.2504, 58.6214],
    [-157.2311, 58.6326],
    [-157.2115, 58.6417],
    [-157.1995, 58.6463],
    [-157.1785, 58.6626],
    [-157.1565, 58.6749],
    [-157.1358, 58.6838],
    [-157.1143, 58.6906],
    [-157.0972, 58.7004],
    [-157.0633, 58.7099],
    [-157.0518, 58.7119],
    [-157.0476, 58.7217],
    [-157.0640, 58.7308],
    [-157.0653, 58.7435],
    [-157.0633, 58.7501],
    [-157.0640, 58.7618],
    [-157.0626, 58.7697],
    [-157.0533, 58.7793],
    [-157.0464, 58.7823],
    [-157.0354, 58.7851],
    [-157.0231, 58.7977],
    [-157.0126, 58.8051],
    [-156.9968, 58.8165],
    [-156.9931, 58.8235],
    [-156.9925, 58.8294],
    [-156.9913, 58.8399],
    [-156.9882, 58.8503],
    [-157.0028, 58.8608],
    [-157.0109, 58.8645],
    [-157.0162, 58.8688],
    [-157.0096, 58.8845],
    [-156.9903, 58.8929],
    [-156.9777, 58.9050],
    [-156.9766, 58.9217],
    [-156.9730, 58.9482],
    [-156.9559, 58.9670],
    [-156.9293, 58.9738],
    [-156.9713, 58.9831],
    [-157.0237, 58.9633],
    [-157.0360, 58.9521],
    [-157.0451, 58.9382],
    [-157.0401, 58.9305],
    [-157.0435, 58.9133],
    [-157.0630, 58.9034],
    [-157.0704, 58.8931],
    [-157.0790, 58.8779],
    [-157.1059, 58.8677],
    [-157.1158, 58.8659],
    [-157.1491, 58.8612],
    [-157.1693, 58.8563],
    [-157.1963, 58.8511],
    [-157.2050, 58.8473],
    [-157.2113, 58.8439],
    [-157.2455, 58.8405],
    [-157.2759, 58.8375],
    [-157.2969, 58.8376],
    [-157.3345, 58.8316],
    [-157.3515, 58.8223],
    [-157.3749, 58.8151],
    [-157.4003, 58.8087],
    [-157.4095, 58.8015],
    [-157.4298, 58.7930],
    [-157.4883, 58.7834],
    [-157.5415, 58.7690],
    [-157.5484, 58.7606],
    [-157.5735, 58.7521],
    [-157.6215, 58.7451],
    [-157.7263, 58.7238],
    [-157.7752, 58.7070],
    [-157.8086, 58.6930],
    [-157.8516, 58.6808],
    [-157.9282, 58.6621],
    [-158.0220, 58.6388],
    [-158.0776, 58.6255],
    [-158.1723, 58.6134],
    [-158.2139, 58.6158],
    [-158.2557, 58.6287],
    [-158.3111, 58.6502],
    [-158.3310, 58.6632],
    [-158.3330, 58.6711],
    [-158.3396, 58.7064],
    [-158.3454, 58.7220],
    [-158.3708, 58.7464],
    [-158.4070, 58.7650],
    [-158.4550, 58.7784],
    [-158.4905, 58.7824],
    [-158.5248, 58.7883],
    [-158.5526, 58.7974],
    [-158.5645, 58.8078],
    [-158.5638, 58.8146],
    [-158.5627, 58.8171],
    [-158.5547, 58.8189],
    [-158.5512, 58.8212],
    [-158.5575, 58.8319],
    [-158.5549, 58.8430],
    [-158.5425, 58.8439],
    [-158.5274, 58.8429],
    [-158.5172, 58.8477],
    [-158.5146, 58.8524],
    [-158.5057, 58.8545],
    [-158.5082, 58.8620],
    [-158.5061, 58.8681],
    [-158.5041, 58.8740],
    [-158.5053, 58.8802],
    [-158.5055, 58.8878],
    [-158.5011, 58.8994],
    [-158.5008, 58.9072],
    [-158.5004, 58.9101],
    [-158.4968, 58.9187],
    [-158.4964, 58.9243],
    [-158.4949, 58.9431],
    [-158.4869, 58.9503],
    [-158.4889, 58.9647],
    [-158.4840, 58.9892],
    [-158.5069, 59.0012],
    [-158.5318, 58.9967],
    [-158.5416, 58.9889],
    [-158.5929, 58.9404],
    [-158.6066, 58.9311],
    [-158.6127, 58.9167],
    [-158.6167, 58.9125],
    [-158.6375, 58.9047],
    [-158.6705, 58.8926],
    [-158.6946, 58.8842],
    [-158.7223, 58.8728],
    [-158.7361, 58.8728],
    [-158.7629, 58.8789],
    [-158.7735, 58.8736],
    [-158.7682, 58.8652],
    [-158.7727, 58.8556],
    [-158.7746, 58.8468],
    [-158.7825, 58.8305],
    [-158.7939, 58.8141],
    [-158.7954, 58.8063],
    [-158.7862, 58.7909],
    [-158.7779, 58.7819],
    [-158.7759, 58.7711],
    [-158.7939, 58.7452],
    [-158.8245, 58.7272],
    [-158.8555, 58.7252],
    [-158.8857, 58.7217],
    [-158.8778, 58.7033],
    [-158.8627, 58.6932],
    [-158.8545, 58.6786],
    [-158.8477, 58.6649],
    [-158.8393, 58.6518],
    [-158.8337, 58.6356],
    [-158.8306, 58.6223],
    [-158.8123, 58.5951],
    [-158.8019, 58.5826],
    [-158.7933, 58.5823],
    [-158.7879, 58.5865],
    [-158.7836, 58.5895],
    [-158.7740, 58.5800],
    [-158.7752, 58.5645],
    [-158.7749, 58.5515],
    [-158.7682, 58.5328],
    [-158.7614, 58.5157],
    [-158.7498, 58.5078],
    [-158.7218, 58.4986],
    [-158.6981, 58.4936],
    [-158.7014, 58.4867],
    [-158.7225, 58.4736],
    [-158.7408, 58.4530],
    [-158.7725, 58.4310],
    [-158.7941, 58.4125],
    [-158.8321, 58.3993],
    [-158.8717, 58.3960],
    [-158.9101, 58.3934],
    [-159.0137, 58.4119],
    [-159.0644, 58.4245],
    [-159.0914, 58.4535],
    [-159.1046, 58.4710],
    [-159.1535, 58.5218],
    [-159.2295, 58.6020],
    [-159.2659, 58.6417],
    [-159.3422, 58.7178],
    [-159.3810, 58.7510],
    [-159.4244, 58.7822],
    [-159.4840, 58.8148],
    [-159.5173, 58.8261],
    [-159.5368, 58.8310],
    [-159.5519, 58.8328],
    [-159.5723, 58.8377],
    [-159.5900, 58.8379],
    [-159.5947, 58.8349],
    [-159.5979, 58.8305],
    [-159.6055, 58.8335],
    [-159.6152, 58.8353],
    [-159.6210, 58.8381],
    [-159.6266, 58.8363],
    [-159.6349, 58.8361],
    [-159.6413, 58.8374],
    [-159.6510, 58.8397],
    [-159.6386, 58.8453],
    [-159.6360, 58.8501],
    [-159.6305, 58.8570],
    [-159.6225, 58.8622],
    [-159.6066, 58.8769],
    [-159.5948, 58.8865],
    [-159.5888, 58.8894],
    [-159.5851, 58.8984],
    [-159.5948, 58.9124],
    [-159.6134, 58.9295],
    [-159.6226, 58.9341],
    [-159.6425, 58.9370],
    [-159.6640, 58.9352],
    [-159.6880, 58.9317],
    [-159.7054, 58.9289],
    [-159.7187, 58.9307],
    [-159.7408, 58.9261],
    [-159.7387, 58.9206],
    [-159.7328, 58.9174],
    [-159.7275, 58.9132],
    [-159.7349, 58.9063],
    [-159.7360, 58.8970],
    [-159.7423, 58.8919],
    [-159.7468, 58.8869],
    [-159.7555, 58.8809],
    [-159.7691, 58.8713],
    [-159.7664, 58.8634],
    [-159.7563, 58.8634],
    [-159.7515, 58.8587],
    [-159.7460, 58.8559],
    [-159.7519, 58.8502],
    [-159.7512, 58.8431],
    [-159.7604, 58.8363],
    [-159.7657, 58.8314],
    [-159.7719, 58.8340],
    [-159.7716, 58.8385],
    [-159.7712, 58.8460],
    [-159.7752, 58.8494],
    [-159.7860, 58.8501],
    [-159.7921, 58.8487],
    [-159.7985, 58.8512],
    [-159.8121, 58.8421],
    [-159.8047, 58.8353],
    [-159.8036, 58.8314],
    [-159.8000, 58.8289],
    [-159.8009, 58.8219],
    [-159.7932, 58.8202],
    [-159.7925, 58.8154],
    [-159.7953, 58.8080],
    [-159.7965, 58.8033],
    [-159.8073, 58.7979],
    [-159.8140, 58.7956],
    [-159.8236, 58.7957],
    [-159.8275, 58.7908],
    [-159.8305, 58.7940],
    [-159.8349, 58.7956],
    [-159.8449, 58.7969],
    [-159.8568, 58.7914],
    [-159.8558, 58.7859],
    [-159.8560, 58.7841],
    [-159.8673, 58.7808],
    [-159.8753, 58.7768],
    [-159.8825, 58.7753],
    [-159.8967, 58.7733],
    [-159.9024, 58.7696],
    [-159.9099, 58.7683],
    [-159.9152, 58.7725],
    [-159.9089, 58.7727],
    [-159.9086, 58.7765],
    [-159.9113, 58.7786],
    [-159.9138, 58.7813],
    [-159.9143, 58.7848],
    [-159.9225, 58.7860],
    [-159.9237, 58.7897],
    [-159.9265, 58.7918],
    [-159.9362, 58.7953],
    [-159.9407, 58.8015],
    [-159.9530, 58.8069],
    [-159.9508, 58.8121],
    [-159.9556, 58.8171],
    [-159.9654, 58.8188],
    [-159.9726, 58.8185],
    [-159.9718, 58.8223],
    [-159.9720, 58.8266],
    [-159.9699, 58.8289],
    [-159.9790, 58.8342],
    [-159.9889, 58.8337],
    [-159.9919, 58.8389],
    [-159.9870, 58.8413],
    [-159.9853, 58.8472],
    [-159.9821, 58.8548],
    [-159.9823, 58.8594],
    [-159.9831, 58.8634],
    [-159.9910, 58.8679],
    [-159.9971, 58.8709],
    [-160.0066, 58.8791],
    [-160.0429, 58.8837],
    [-160.0748, 58.8809],
    [-160.0929, 58.8730],
    [-160.0911, 58.8661],
    [-160.0931, 58.8608],
    [-160.0942, 58.8584],
    [-160.1005, 58.8582],
    [-160.1155, 58.8613],
    [-160.1241, 58.8643],
    [-160.1430, 58.8618],
    [-160.1527, 58.8620],
    [-160.1650, 58.8660],
    [-160.1610, 58.8714],
    [-160.1534, 58.8776],
    [-160.1565, 58.8959],
    [-160.1566, 58.9059],
    [-160.1549, 58.9103],
    [-160.1537, 58.9166],
    [-160.1542, 58.9200],
    [-160.1650, 58.9190],
    [-160.1680, 58.9136],
    [-160.1790, 58.9114],
    [-160.1971, 58.9117],
    [-160.2025, 58.9084],
    [-160.2110, 58.9068],
    [-160.2250, 58.9019],
    [-160.2283, 58.8954],
    [-160.2306, 58.8907],
    [-160.2373, 58.8886],
    [-160.2452, 58.8876],
    [-160.2509, 58.8955],
    [-160.2508, 58.8993],
    [-160.2481, 58.9030],
    [-160.2556, 58.9134],
    [-160.2531, 58.9178],
    [-160.2479, 58.9259],
    [-160.2533, 58.9307],
    [-160.2595, 58.9354],
    [-160.2583, 58.9428],
    [-160.2666, 58.9453],
    [-160.2729, 58.9470],
    [-160.2785, 58.9436],
    [-160.2765, 58.9365],
    [-160.2859, 58.9302],
    [-160.2864, 58.9341],
    [-160.2858, 58.9420],
    [-160.2916, 58.9446],
    [-160.2953, 58.9416],
    [-160.2955, 58.9454],
    [-160.2960, 58.9490],
    [-160.3044, 58.9479],
    [-160.3215, 58.9422],
    [-160.3272, 58.9436],
    [-160.3282, 58.9468],
    [-160.3212, 58.9522],
    [-160.3176, 58.9557],
    [-160.3135, 58.9602],
    [-160.3063, 58.9623],
    [-160.2971, 58.9693],
    [-160.2948, 58.9740],
    [-160.2772, 58.9755],
    [-160.2626, 58.9756],
    [-160.2572, 58.9801],
    [-160.2541, 58.9852],
    [-160.2641, 59.0051],
    [-160.2744, 59.0185],
    [-160.2828, 59.0268],
    [-160.3153, 59.0422],
    [-160.3360, 59.0521],
    [-160.3370, 59.0550],
    [-160.3300, 59.0542],
    [-160.3162, 59.0564],
    [-160.3080, 59.0579],
    [-160.3039, 59.0628],
    [-160.3105, 59.0630],
    [-160.3145, 59.0673],
    [-160.3173, 59.0687],
    [-160.3234, 59.0689],
    [-160.3306, 59.0701],
    [-160.3317, 59.0734],
    [-160.3328, 59.0722],
    [-160.3400, 59.0727],
    [-160.3600, 59.0720],
    [-160.3631, 59.0662],
    [-160.3799, 59.0576],
    [-160.4516, 59.0336],
    [-160.4740, 59.0274],
    [-160.4825, 59.0228],
    [-160.4963, 59.0176],
    [-160.5180, 59.0105],
    [-160.5211, 59.0072],
    [-160.5299, 59.0026],
    [-160.5345, 58.9996],
    [-160.5416, 58.9956],
    [-160.5398, 58.9926],
    [-160.5640, 58.9873],
    [-160.5712, 58.9839],
    [-160.5849, 58.9771],
    [-160.5972, 58.9726],
    [-160.6341, 58.9611],
    [-160.6575, 58.9507],
    [-160.6856, 58.9387],
    [-160.7038, 58.9249],
    [-160.7107, 58.9243],
    [-160.7358, 58.9119],
    [-160.7769, 58.8884],
    [-160.8158, 58.8410],
    [-160.8235, 58.8382],
    [-160.8402, 58.8635],
    [-160.8690, 58.8793],
    [-160.8951, 58.8849],
    [-160.9079, 58.8819],
    [-160.9161, 58.8749],
    [-160.9275, 58.8740],
    [-160.9426, 58.8731],
    [-160.9592, 58.8745],
    [-160.9684, 58.8723],
    [-160.9674, 58.8688],
    [-160.9779, 58.8651],
    [-160.9906, 58.8540],
    [-161.0011, 58.8497],
    [-161.0144, 58.8450],
    [-161.0346, 58.8386],
    [-161.0425, 58.8357],
    [-161.0539, 58.8304],
    [-161.0612, 58.8267],
    [-161.0712, 58.8220],
    [-161.0930, 58.8158],
    [-161.1061, 58.8135],
    [-161.1173, 58.8088],
    [-161.1248, 58.8046],
    [-161.1338, 58.7974],
    [-161.1373, 58.8013],
    [-161.1476, 58.8023],
    [-161.1605, 58.7996],
    [-161.1678, 58.7983],
    [-161.1792, 58.7919],
    [-161.1792, 58.7851],
    [-161.1828, 58.7808],
    [-161.1952, 58.7834],
    [-161.2257, 58.7826],
    [-161.2580, 58.7780],
    [-161.2885, 58.7711],
    [-161.3026, 58.7635],
    [-161.2985, 58.7574],
    [-161.3046, 58.7523],
    [-161.3140, 58.7499],
    [-161.3313, 58.7393],
    [-161.3386, 58.7354],
    [-161.3533, 58.7275],
    [-161.3674, 58.7133],
    [-161.3742, 58.7027],
    [-161.3762, 58.6775],
    [-161.3727, 58.6684],
    [-161.3531, 58.6696],
    [-161.3241, 58.6774],
    [-161.3123, 58.6816],
    [-161.3025, 58.6854],
    [-161.3051, 58.6792],
    [-161.3451, 58.6680],
    [-161.3856, 58.6587],
    [-161.4161, 58.6536],
    [-161.4498, 58.6468],
    [-161.5034, 58.6364],
    [-161.5355, 58.6251],
    [-161.5456, 58.6192],
    [-161.5457, 58.6100],
    [-161.5600, 58.6019],
    [-161.5692, 58.6047],
    [-161.5925, 58.6054],
    [-161.6054, 58.6005],
    [-161.6213, 58.6010],
    [-161.6395, 58.5943],
    [-161.6500, 58.5891],
    [-161.6624, 58.5860],
    [-161.6802, 58.5750],
    [-161.6814, 58.5680],
    [-161.6845, 58.5643],
    [-161.6870, 58.5602],
    [-161.6953, 58.5595],
    [-161.7071, 58.5606],
    [-161.7116, 58.5562],
    [-161.7152, 58.5555],
    [-161.7262, 58.5574],
    [-161.7362, 58.5567],
    [-161.7425, 58.5536],
    [-161.7520, 58.5518],
    [-161.7593, 58.5503],
    [-161.7711, 58.5523],
    [-161.7596, 58.5676],
    [-161.7561, 58.5775],
    [-161.7637, 58.5840],
    [-161.7736, 58.6017],
    [-161.7967, 58.6195],
    [-161.8209, 58.6287],
    [-161.8351, 58.6283],
    [-161.8383, 58.6216],
    [-161.8523, 58.6283],
    [-161.8707, 58.6275],
    [-161.8894, 58.6289],
    [-161.8963, 58.6296],
    [-161.9057, 58.6309],
    [-161.9130, 58.6339],
    [-161.9214, 58.6319],
    [-161.9387, 58.6305],
    [-161.9488, 58.6263],
    [-161.9679, 58.6253],
    [-161.9746, 58.6318],
    [-161.9865, 58.6289],
    [-161.9969, 58.6276],
    [-162.0097, 58.6174],
    [-162.0138, 58.6237],
    [-162.0302, 58.6255],
    [-162.0460, 58.6262],
    [-162.0633, 58.6214],
    [-162.0936, 58.6254],
    [-162.1041, 58.6315],
    [-162.1220, 58.6325],
    [-162.1314, 58.6343],
    [-162.1368, 58.6352],
    [-162.1543, 58.6401],
    [-162.1699, 58.6461],
    [-162.1716, 58.6516],
    [-162.1476, 58.6558],
    [-162.1417, 58.6576],
    [-162.1316, 58.6574],
    [-162.1202, 58.6630],
    [-162.1174, 58.6686],
    [-162.1026, 58.6681],
    [-162.0841, 58.6675],
    [-162.0770, 58.6599],
    [-162.0652, 58.6602],
    [-162.0489, 58.6712],
    [-162.0565, 58.6744],
    [-162.0579, 58.6775],
    [-162.0356, 58.6738],
    [-162.0210, 58.6712],
    [-162.0057, 58.6754],
    [-161.9898, 58.6807],
    [-161.9841, 58.6806],
    [-161.9751, 58.6770],
    [-161.9704, 58.6695],
    [-161.9538, 58.6682],
    [-161.9477, 58.6756],
    [-161.9385, 58.6749],
    [-161.9424, 58.6706],
    [-161.9432, 58.6668],
    [-161.9438, 58.6617],
    [-161.9466, 58.6558],
    [-161.9455, 58.6495],
    [-161.9176, 58.6494],
    [-161.8892, 58.6545],
    [-161.8687, 58.6638],
    [-161.8472, 58.6779],
    [-161.8390, 58.6927],
    [-161.8474, 58.6977],
    [-161.8579, 58.7006],
    [-161.8640, 58.7061],
    [-161.8656, 58.7132],
    [-161.8531, 58.7165],
    [-161.8458, 58.7230],
    [-161.8325, 58.7288],
    [-161.8161, 58.7320],
    [-161.8019, 58.7400],
    [-161.7923, 58.7525],
    [-161.7843, 58.7592],
    [-161.7747, 58.7691],
    [-161.7696, 58.7804],
    [-161.7589, 58.7933],
    [-161.7530, 58.8101],
    [-161.7565, 58.8329],
    [-161.7704, 58.8597],
    [-161.7834, 58.8834],
    [-161.7871, 58.9097],
    [-161.7875, 58.9274],
    [-161.7829, 58.9418],
    [-161.7824, 58.9485],
    [-161.7874, 58.9686],
    [-161.7997, 58.9891],
    [-161.8306, 59.0153],
    [-161.8413, 59.0291],
    [-161.8351, 59.0421],
    [-161.8229, 59.0500],
    [-161.8411, 59.0582],
    [-161.8637, 59.0630],
    [-161.8829, 59.0712],
    [-161.9278, 59.1047],
    [-161.9647, 59.1339],
    [-161.9839, 59.1522],
    [-162.0287, 59.2215],
    [-162.0564, 59.2710],
    [-162.0085, 59.3217],
    [-161.9571, 59.3611],
    [-161.9549, 59.3789],
    [-161.9432, 59.3818],
    [-161.9271, 59.3837],
    [-161.9094, 59.3921],
    [-161.8842, 59.3950],
    [-161.8742, 59.4047],
    [-161.8604, 59.4260],
    [-161.8446, 59.4334],
    [-161.8193, 59.4309],
    [-161.8102, 59.4469],
    [-161.7947, 59.4704],
    [-161.7853, 59.4807],
    [-161.7748, 59.4812],
    [-161.7788, 59.4758],
    [-161.7879, 59.4730],
    [-161.7858, 59.4671],
    [-161.7637, 59.4684],
    [-161.7481, 59.4670],
    [-161.7349, 59.4717],
    [-161.7195, 59.4774],
    [-161.7118, 59.4789],
    [-161.7091, 59.4859],
    [-161.7012, 59.4984],
    [-161.7061, 59.5053],
    [-161.7168, 59.5102],
    [-161.7322, 59.5222],
    [-161.7574, 59.5496],
    [-161.7975, 59.5752],
    [-161.8205, 59.5950],
    [-161.8425, 59.6177],
    [-161.8739, 59.6495],
    [-161.8800, 59.6695],
    [-161.8751, 59.6745],
    [-161.8895, 59.6869],
    [-161.8883, 59.6939],
    [-161.8816, 59.7023],
    [-161.9060, 59.7198],
    [-161.9253, 59.7349],
    [-161.9315, 59.7449],
    [-161.9366, 59.7546],
    [-161.9387, 59.7622],
    [-161.9481, 59.7716],
    [-161.9506, 59.7774],
    [-161.9688, 59.7892],
    [-161.9688, 59.7940],
    [-161.9740, 59.8015],
    [-161.9933, 59.8147],
    [-162.0145, 59.8265],
    [-162.0176, 59.8314],
    [-162.0513, 59.8520],
    [-162.0849, 59.8829],
    [-162.0963, 59.8978],
    [-162.1088, 59.9201],
    [-162.1059, 59.9313],
    [-162.1025, 59.9380],
    [-162.1063, 59.9475],
    [-162.1086, 59.9539],
    [-162.1211, 59.9615],
    [-162.1418, 59.9679],
    [-162.1570, 59.9775],
    [-162.1650, 59.9833],
    [-162.1823, 59.9961],
    [-162.2018, 60.0165],
    [-162.2124, 60.0384],
    [-162.2193, 60.0482],
    [-162.2251, 60.0563],
    [-162.2621, 60.0636],
    [-162.2735, 60.0883],
    [-162.3217, 60.1126],
    [-162.3368, 60.1288],
    [-162.3598, 60.1502],
    [-162.4062, 60.1714],
    [-162.4699, 60.1567],
    [-162.4829, 60.1499],
    [-162.4910, 60.1427],
    [-162.4977, 60.1305],
    [-162.4996, 60.1204],
    [-162.4962, 60.1079],
    [-162.4958, 60.0910],
    [-162.4937, 60.0704],
    [-162.4823, 60.0466],
    [-162.4798, 60.0329],
    [-162.4994, 60.0129],
    [-162.5114, 59.9975],
    [-162.5434, 59.9817],
    [-162.5620, 59.9777],
    [-162.5771, 59.9781],
    [-162.5983, 59.9772],
    [-162.6372, 59.9738],
    [-162.6783, 59.9814],
    [-162.7126, 59.9903],
    [-162.7427, 59.9847],
    [-162.7374, 59.9723],
    [-162.7528, 59.9568],
    [-162.7920, 59.9402],
    [-162.8593, 59.9250],
    [-162.9042, 59.9191],
    [-162.9447, 59.9030],
    [-163.0247, 59.8794],
    [-163.0504, 59.8732],
    [-163.0832, 59.8620],
    [-163.0981, 59.8578],
    [-163.1103, 59.8563],
    [-163.1189, 59.8556],
    [-163.1339, 59.8521],
    [-163.1719, 59.8430],
    [-163.2328, 59.8349],
    [-163.2575, 59.8335],
    [-163.2886, 59.8261],
    [-163.3749, 59.8144],
    [-163.4741, 59.8063],
    [-163.5647, 59.8004],
    [-163.7698, 59.7946],
    [-163.8127, 59.7973],
    [-163.8307, 59.7976],
    [-163.8693, 59.7980],
    [-163.8971, 59.8013],
    [-163.9158, 59.8031],
    [-163.9466, 59.8055],
    [-163.9715, 59.8100],
    [-163.9969, 59.8125],
    [-164.0171, 59.8172],
    [-164.0658, 59.8247],
    [-164.1153, 59.8350],
    [-164.1414, 59.8452],
    [-164.1653, 59.8621],
    [-164.1806, 59.8844],
    [-164.2024, 59.9137],
    [-164.2128, 59.9257],
    [-164.2202, 59.9378],
    [-164.2128, 59.9469],
    [-164.1916, 59.9593],
    [-164.1851, 59.9616],
    [-164.1748, 59.9654],
    [-164.1611, 59.9657],
    [-164.1494, 59.9627],
    [-164.1382, 59.9654],
    [-164.1245, 59.9684],
    [-164.1149, 59.9744],
    [-164.1275, 59.9777],
    [-164.1270, 59.9827],
    [-164.1259, 59.9926],
    [-164.1487, 59.9975],
    [-164.1647, 60.0075],
    [-164.1865, 60.0198],
    [-164.2048, 60.0289],
    [-164.2430, 60.0362],
    [-164.3129, 60.0537],
    [-164.3248, 60.0569],
    [-164.3412, 60.0569],
    [-164.3543, 60.0666],
    [-164.3597, 60.0756],
    [-164.3818, 60.0772],
    [-164.3875, 60.0802],
    [-164.4183, 60.1057],
    [-164.4612, 60.1378],
    [-164.4951, 60.1756],
    [-164.4943, 60.1848],
    [-164.5176, 60.1995],
    [-164.5583, 60.2070],
    [-164.6205, 60.2348],
    [-164.6375, 60.2432],
    [-164.6511, 60.2572],
    [-164.6509, 60.2705],
    [-164.6474, 60.2812],
    [-164.6617, 60.2833],
    [-164.6685, 60.2959],
    [-164.6701, 60.3033],
    [-164.6836, 60.3072],
    [-164.7012, 60.2969],
    [-164.7335, 60.2926],
    [-164.7750, 60.2947],
    [-164.8078, 60.2973],
    [-164.8504, 60.3036],
    [-164.8993, 60.3168],
    [-164.9390, 60.3297],
    [-164.9462, 60.3337],
    [-164.9844, 60.3494],
    [-165.0049, 60.3590],
    [-165.0239, 60.3676],
    [-165.0401, 60.3764],
    [-165.0564, 60.3869],
    [-165.1022, 60.4147],
    [-165.1294, 60.4337],
    [-165.1379, 60.4414],
    [-165.1393, 60.4507],
    [-165.1264, 60.4490],
    [-165.1185, 60.4504],
    [-165.1059, 60.4510],
    [-165.0967, 60.4547],
    [-165.0868, 60.4544],
    [-165.0630, 60.4593],
    [-165.0478, 60.4605],
    [-165.0152, 60.4714],
    [-164.9986, 60.4814],
    [-164.9933, 60.4903],
    [-164.9898, 60.4971],
    [-164.9899, 60.5029],
    [-164.9802, 60.5062],
    [-164.9688, 60.5075],
    [-164.9646, 60.5176],
    [-164.9614, 60.5266],
    [-164.9627, 60.5334],
    [-164.9789, 60.5414],
    [-164.9902, 60.5429],
    [-164.9984, 60.5417],
    [-165.0079, 60.5402],
    [-165.0186, 60.5408],
    [-165.0355, 60.5433],
    [-165.0587, 60.5442],
    [-165.0636, 60.5427],
    [-165.0668, 60.5403],
    [-165.0722, 60.5363],
    [-165.0784, 60.5333],
    [-165.0883, 60.5341],
    [-165.1027, 60.5319],
    [-165.1072, 60.5247],
    [-165.1209, 60.5219],
    [-165.1253, 60.5199],
    [-165.1374, 60.5198],
    [-165.1412, 60.5176],
    [-165.1475, 60.5155],
    [-165.1599, 60.5142],
    [-165.1653, 60.5075],
    [-165.1812, 60.5034],
    [-165.1904, 60.4980],
    [-165.2004, 60.4966],
    [-165.2128, 60.4972],
    [-165.2317, 60.4964],
    [-165.2444, 60.4963],
    [-165.2598, 60.4926],
    [-165.2675, 60.4930],
    [-165.2860, 60.4979],
    [-165.3018, 60.5021],
    [-165.3081, 60.5036],
    [-165.3304, 60.5061],
    [-165.3534, 60.5052],
    [-165.3630, 60.5069],
    [-165.3731, 60.5090],
    [-165.3779, 60.5108],
    [-165.3852, 60.5192],
    [-165.3866, 60.5214],
    [-165.3888, 60.5233],
    [-165.3916, 60.5305],
    [-165.3979, 60.5334],
    [-165.4049, 60.5333],
    [-165.4089, 60.5387],
    [-165.4102, 60.5414],
    [-165.4130, 60.5461],
    [-165.4201, 60.5486],
    [-165.4186, 60.5518],
    [-165.4169, 60.5561],
    [-165.4089, 60.5574],
    [-165.4047, 60.5587],
    [-165.3957, 60.5611],
    [-165.3822, 60.5754],
    [-165.3766, 60.5782],
    [-165.3722, 60.5796],
    [-165.3635, 60.5792],
    [-165.3472, 60.5792],
    [-165.3397, 60.5766],
    [-165.3270, 60.5768],
    [-165.2968, 60.5745],
    [-165.2776, 60.5763],
    [-165.2716, 60.5784],
    [-165.2526, 60.5890],
    [-165.2490, 60.5949],
    [-165.2552, 60.5992],
    [-165.2534, 60.6037],
    [-165.2479, 60.6086],
    [-165.2446, 60.6118],
    [-165.2311, 60.6172],
    [-165.2181, 60.6156],
    [-165.2058, 60.6162],
    [-165.1843, 60.6194],
    [-165.1688, 60.6285],
    [-165.1577, 60.6411],
    [-165.1472, 60.6512],
    [-165.1271, 60.6533],
    [-165.1152, 60.6524],
    [-165.0999, 60.6542],
    [-165.0978, 60.6614],
    [-165.0898, 60.6714],
    [-165.0774, 60.6772],
    [-165.0673, 60.6854],
    [-165.0433, 60.6875],
    [-165.0212, 60.6883],
    [-165.0080, 60.6930],
    [-164.9815, 60.7074],
    [-164.9745, 60.7133],
    [-164.9689, 60.7258],
    [-164.9864, 60.7350],
    [-165.0254, 60.7573],
    [-165.0288, 60.7701],
    [-165.0276, 60.7760],
    [-165.0344, 60.7840],
    [-165.0203, 60.7855],
    [-164.9972, 60.7869],
    [-164.9633, 60.7933],
    [-164.9411, 60.8043],
    [-164.8871, 60.8193],
    [-164.8685, 60.8332],
    [-164.8693, 60.8485],
    [-164.9027, 60.8634],
    [-164.9393, 60.8773],
    [-164.9588, 60.8968],
    [-164.9485, 60.9139],
    [-164.9317, 60.9263],
    [-164.9262, 60.9483],
    [-164.9507, 60.9483],
    [-164.9688, 60.9437],
    [-164.9758, 60.9351],
    [-164.9928, 60.9274],
    [-165.0119, 60.9186],
    [-165.0341, 60.9091],
    [-165.0522, 60.9092],
    [-165.0713, 60.9105],
    [-165.0850, 60.9139],
    [-165.1008, 60.9166],
    [-165.1195, 60.9183],
    [-165.1324, 60.9225],
    [-165.1562, 60.9288],
    [-165.1658, 60.9351],
    [-165.1754, 60.9437],
    [-165.1817, 60.9486],
    [-165.1827, 60.9535],
    [-165.1884, 60.9598],
    [-165.1949, 60.9739],
    [-165.1915, 60.9831],
    [-165.1804, 60.9886],
    [-165.1703, 60.9941],
    [-165.1570, 61.0011],
    [-165.1336, 61.0119],
    [-165.1115, 61.0157],
    [-165.0848, 61.0161],
    [-165.0686, 61.0120],
    [-165.0623, 61.0157],
    [-165.0491, 61.0113],
    [-165.0214, 61.0106],
    [-164.9634, 61.0236],
    [-164.9500, 61.0310],
    [-164.9468, 61.0457],
    [-164.9522, 61.0569],
    [-164.9740, 61.0716],
    [-164.9935, 61.0724],
    [-164.9995, 61.0638],
    [-165.0025, 61.0561],
    [-165.0201, 61.0537],
    [-165.0395, 61.0584],
    [-165.0578, 61.0597],
    [-165.0705, 61.0629],
    [-165.1121, 61.0750],
    [-165.1262, 61.0863],
    [-165.1465, 61.1029],
    [-165.1613, 61.1079],
    [-165.1796, 61.1159],
    [-165.1872, 61.1249],
    [-165.1778, 61.1320],
    [-165.1712, 61.1395],
    [-165.1831, 61.1458],
    [-165.2050, 61.1485],
    [-165.2129, 61.1496],
    [-165.2260, 61.1513],
    [-165.2469, 61.1537],
    [-165.2592, 61.1606],
    [-165.2697, 61.1689],
    [-165.2905, 61.1770],
    [-165.3051, 61.1803],
    [-165.3304, 61.1679],
    [-165.3324, 61.1579],
    [-165.3398, 61.1475],
    [-165.3460, 61.1374],
    [-165.3558, 61.1290],
    [-165.3611, 61.1227],
    [-165.3615, 61.1148],
    [-165.3678, 61.1061],
    [-165.3671, 61.1024],
    [-165.3683, 61.0960],
    [-165.3727, 61.0939],
    [-165.3701, 61.0855],
    [-165.3747, 61.0819],
    [-165.4062, 61.0788],
    [-165.4300, 61.0808],
    [-165.4440, 61.0839],
    [-165.4705, 61.0832],
    [-165.5028, 61.0857],
    [-165.5140, 61.0870],
    [-165.5286, 61.0885],
    [-165.5551, 61.0927],
    [-165.5692, 61.0963],
    [-165.5835, 61.1005],
    [-165.6002, 61.1119],
    [-165.6012, 61.1235],
    [-165.6081, 61.1298],
    [-165.6132, 61.1420],
    [-165.6155, 61.1507],
    [-165.6249, 61.1586],
    [-165.6270, 61.1672],
    [-165.6262, 61.1818],
    [-165.6224, 61.1888],
    [-165.6180, 61.1976],
    [-165.6240, 61.1995],
    [-165.6319, 61.2076],
    [-165.6352, 61.2137],
    [-165.6382, 61.2182],
    [-165.6408, 61.2269],
    [-165.6405, 61.2352],
    [-165.6286, 61.2448],
    [-165.6185, 61.2499],
    [-165.6033, 61.2568],
    [-165.5976, 61.2661],
    [-165.5952, 61.2764],
    [-165.5956, 61.2826],
    [-165.5974, 61.2899],
    [-165.6217, 61.2838],
    [-165.6282, 61.2795],
    [-165.6387, 61.2826],
    [-165.6450, 61.2898],
    [-165.6541, 61.2926],
    [-165.6678, 61.2911],
    [-165.6755, 61.2928],
    [-165.6881, 61.2923],
    [-165.7049, 61.2953],
    [-165.7278, 61.3003],
    [-165.7546, 61.3047],
    [-165.7870, 61.3128],
    [-165.8112, 61.3107],
    [-165.8378, 61.3092],
    [-165.8639, 61.3180],
    [-165.8788, 61.3282],
    [-165.8870, 61.3396],
    [-165.8961, 61.3504],
    [-165.9076, 61.3693],
    [-165.9183, 61.3825],
    [-165.9270, 61.4029],
    [-165.9225, 61.4182],
    [-165.8826, 61.4274],
    [-165.8669, 61.4326],
    [-165.8412, 61.4401],
    [-165.8140, 61.4481],
    [-165.7911, 61.4499],
    [-165.7736, 61.4599],
    [-165.7681, 61.4623],
    [-165.7599, 61.4740],
    [-165.7533, 61.4790],
    [-165.7542, 61.4851],
    [-165.7625, 61.4941],
    [-165.7675, 61.4981],
    [-165.7667, 61.5008],
    [-165.7727, 61.5046],
    [-165.7874, 61.5102],
    [-165.7839, 61.5149],
    [-165.8005, 61.5145],
    [-165.7966, 61.5188],
    [-165.7995, 61.5217],
    [-165.8123, 61.5228],
    [-165.8169, 61.5307],
    [-165.8270, 61.5322],
    [-165.8333, 61.5293],
    [-165.8374, 61.5299],
    [-165.8414, 61.5323],
    [-165.8513, 61.5301],
    [-165.8587, 61.5342],
    [-165.8657, 61.5350],
    [-165.8820, 61.5413],
    [-165.8926, 61.5443],
    [-165.9061, 61.5486],
    [-165.9175, 61.5528],
    [-165.9277, 61.5519],
    [-165.9341, 61.5535],
    [-165.9516, 61.5543],
    [-165.9593, 61.5539],
    [-165.9746, 61.5521],
    [-165.9871, 61.5498],
    [-165.9977, 61.5436],
    [-166.0021, 61.5392],
    [-166.0385, 61.5337],
    [-166.0672, 61.5319],
    [-166.0755, 61.5310],
    [-166.0853, 61.5284],
    [-166.0883, 61.5272],
    [-166.0888, 61.5255],
    [-166.0940, 61.5190],
    [-166.1027, 61.5167],
    [-166.1079, 61.5131],
    [-166.1017, 61.5097],
    [-166.0828, 61.5046],
    [-166.0816, 61.4987],
    [-166.0910, 61.4925],
    [-166.1342, 61.5043],
    [-166.1496, 61.5133],
    [-166.1517, 61.5257],
    [-166.1653, 61.5462],
    [-166.1772, 61.5653],
    [-166.1858, 61.5867],
    [-166.1846, 61.6069],
    [-166.1721, 61.6359],
    [-166.1641, 61.6804],
    [-166.1496, 61.7042],
    [-166.1395, 61.7079],
    [-166.1508, 61.6906],
    [-166.1625, 61.6610],
    [-166.1606, 61.6452],
    [-166.1510, 61.6327],
    [-166.1185, 61.6356],
    [-166.0540, 61.6382],
    [-166.0163, 61.6459],
    [-165.9449, 61.6547],
    [-165.8632, 61.6651],
    [-165.7954, 61.6751],
    [-165.7660, 61.6748],
    [-165.7579, 61.6819],
    [-165.7791, 61.6861],
    [-165.8285, 61.6873],
    [-165.8475, 61.6870],
    [-165.8630, 61.6863],
    [-165.8568, 61.6907],
    [-165.8558, 61.6939],
    [-165.8632, 61.6994],
    [-165.8862, 61.6962],
    [-165.9051, 61.6984],
    [-165.9312, 61.7014],
    [-165.9604, 61.7115],
    [-165.9580, 61.7199],
    [-165.9635, 61.7229],
    [-165.9773, 61.7195],
    [-165.9979, 61.7214],
    [-166.0067, 61.7203],
    [-166.0139, 61.7282],
    [-166.0296, 61.7430],
    [-166.0477, 61.7595],
    [-166.0607, 61.7674],
    [-166.0755, 61.7807],
    [-166.0904, 61.7948],
    [-166.1006, 61.8007],
    [-166.0961, 61.8150],
    [-166.0761, 61.8138],
    [-166.0549, 61.8160],
    [-166.0203, 61.8205],
    [-166.0047, 61.8220],
    [-165.9820, 61.8237],
    [-165.9394, 61.8280],
    [-165.9255, 61.8287],
    [-165.9188, 61.8280],
    [-165.9051, 61.8257],
    [-165.8941, 61.8258],
    [-165.8803, 61.8260],
    [-165.8762, 61.8235],
    [-165.8640, 61.8228],
    [-165.8334, 61.8265],
    [-165.8154, 61.8269],
    [-165.7985, 61.8253],
    [-165.7919, 61.8176],
    [-165.7736, 61.8174],
    [-165.7494, 61.8278],
    [-165.7428, 61.8380],
    [-165.7231, 61.8429],
    [-165.6903, 61.8461],
    [-165.6640, 61.8454],
    [-165.6234, 61.8447],
    [-165.6293, 61.8614],
    [-165.6834, 61.9045],
    [-165.7306, 61.9436],
    [-165.7598, 62.0019],
    [-165.7558, 62.0297],
    [-165.7555, 62.0483],
    [-165.7479, 62.0736],
    [-165.7239, 62.0942],
    [-165.7158, 62.0994],
    [-165.7048, 62.1143],
    [-165.6922, 62.1253],
    [-165.6769, 62.1394],
    [-165.6721, 62.1512],
    [-165.6470, 62.1640],
    [-165.6337, 62.1664],
    [-165.6124, 62.1786],
    [-165.6115, 62.1835],
    [-165.5820, 62.2001],
    [-165.5572, 62.2188],
    [-165.5506, 62.2235],
    [-165.5393, 62.2330],
    [-165.5311, 62.2391],
    [-165.5171, 62.2478],
    [-165.5082, 62.2545],
    [-165.4809, 62.2701],
    [-165.4653, 62.2805],
    [-165.4116, 62.3159],
    [-165.3736, 62.3467],
    [-165.3553, 62.3576],
    [-165.3453, 62.3572],
    [-165.3251, 62.3602],
    [-165.3205, 62.3660],
    [-165.3158, 62.3775],
    [-165.3072, 62.3928],
    [-165.2862, 62.4146],
    [-165.2677, 62.4291],
    [-165.2504, 62.4418],
    [-165.2415, 62.4467],
    [-165.2143, 62.4636],
    [-165.2016, 62.4712],
    [-165.1831, 62.4811],
    [-165.1174, 62.5108],
    [-165.0860, 62.5250],
    [-165.0593, 62.5352],
    [-165.0375, 62.5396],
    [-164.9862, 62.5555],
    [-164.9786, 62.5574],
    [-164.9747, 62.5635],
    [-164.9482, 62.5642],
    [-164.9192, 62.5685],
    [-164.8804, 62.5674],
    [-164.8455, 62.5733],
    [-164.8305, 62.5785],
    [-164.8175, 62.5814],
    [-164.7905, 62.5882],
    [-164.7738, 62.6087],
    [-164.7890, 62.6099],
    [-164.8019, 62.6163],
    [-164.8209, 62.6384],
    [-164.8270, 62.6487],
    [-164.8287, 62.6591],
    [-164.8309, 62.6666],
    [-164.8366, 62.6676],
    [-164.8415, 62.6724],
    [-164.8401, 62.6927],
    [-164.8414, 62.6999],
    [-164.8529, 62.6998],
    [-164.8625, 62.7083],
    [-164.8697, 62.7183],
    [-164.8725, 62.7337],
    [-164.8624, 62.7361],
    [-164.8650, 62.7457],
    [-164.8549, 62.7473],
    [-164.8567, 62.7542],
    [-164.8611, 62.7635],
    [-164.8682, 62.7735],
    [-164.8712, 62.7860],
    [-164.8583, 62.7919],
    [-164.8356, 62.7951],
    [-164.8187, 62.8005],
    [-164.8321, 62.8061],
    [-164.8467, 62.8127],
    [-164.8590, 62.8162],
    [-164.8579, 62.8226],
    [-164.8526, 62.8269],
    [-164.8535, 62.8375],
    [-164.8453, 62.8472],
    [-164.8376, 62.8496],
    [-164.8381, 62.8561],
    [-164.8317, 62.8626],
    [-164.8293, 62.8702],
    [-164.8237, 62.8761],
    [-164.8224, 62.8819],
    [-164.8194, 62.8903],
    [-164.8166, 62.8968],
    [-164.8120, 62.9031],
    [-164.8083, 62.9152],
    [-164.7996, 62.9264],
    [-164.7982, 62.9302],
    [-164.7912, 62.9384],
    [-164.7818, 62.9495],
    [-164.7670, 62.9585],
    [-164.7613, 62.9680],
    [-164.7505, 62.9773],
    [-164.7356, 62.9871],
    [-164.7319, 62.9901],
    [-164.7143, 63.0052],
    [-164.7079, 63.0090],
    [-164.6959, 63.0146],
    [-164.6763, 63.0210],
    [-164.6662, 63.0247],
    [-164.6524, 63.0293],
    [-164.6363, 63.0266],
    [-164.6083, 63.0240],
    [-164.5923, 63.0255],
    [-164.5613, 63.0258],
    [-164.5532, 63.0255],
    [-164.5437, 63.0294],
    [-164.5267, 63.0407],
    [-164.5348, 63.0482],
    [-164.5190, 63.0525],
    [-164.5374, 63.0572],
    [-164.5468, 63.0594],
    [-164.5647, 63.0644],
    [-164.5763, 63.0744],
    [-164.5569, 63.0806],
    [-164.5600, 63.0911],
    [-164.5496, 63.0941],
    [-164.5589, 63.0991],
    [-164.5711, 63.1022],
    [-164.5751, 63.1092],
    [-164.5793, 63.1130],
    [-164.5859, 63.1202],
    [-164.5837, 63.1257],
    [-164.5744, 63.1307],
    [-164.5728, 63.1346],
    [-164.5716, 63.1402],
    [-164.5559, 63.1445],
    [-164.5497, 63.1443],
    [-164.5412, 63.1480],
    [-164.5287, 63.1559],
    [-164.5041, 63.1690],
    [-164.4802, 63.1822],
    [-164.4730, 63.1856],
    [-164.4484, 63.1984],
    [-164.4249, 63.2094],
    [-164.4007, 63.2184],
    [-164.3906, 63.2224],
    [-164.3669, 63.2313],
    [-164.3499, 63.2353],
    [-164.3270, 63.2405],
    [-164.3111, 63.2423],
    [-164.2935, 63.2443],
    [-164.2756, 63.2455],
    [-164.2515, 63.2467],
    [-164.2305, 63.2487],
    [-164.2108, 63.2519],
    [-164.1939, 63.2547],
    [-164.1736, 63.2572],
    [-164.1547, 63.2563],
    [-164.1412, 63.2571],
    [-164.1257, 63.2590],
    [-164.1098, 63.2594],
    [-164.0970, 63.2596],
    [-164.0886, 63.2604],
    [-164.0744, 63.2609],
    [-164.0588, 63.2605],
    [-164.0474, 63.2616],
    [-164.0354, 63.2596],
    [-164.0235, 63.2581],
    [-164.0057, 63.2540],
    [-163.9972, 63.2520],
    [-163.9848, 63.2496],
    [-163.9733, 63.2481],
    [-163.9652, 63.2450],
    [-163.9494, 63.2401],
    [-163.9377, 63.2369],
    [-163.9225, 63.2315],
    [-163.9133, 63.2322],
    [-163.8879, 63.2218],
    [-163.8802, 63.2212],
    [-163.8722, 63.2199],
    [-163.8650, 63.2190],
    [-163.8518, 63.2204],
    [-163.8368, 63.2215],
    [-163.8261, 63.2166],
    [-163.8326, 63.2137],
    [-163.8154, 63.2098],
    [-163.8089, 63.2117],
    [-163.8006, 63.2128],
    [-163.7955, 63.2156],
    [-163.7851, 63.2156],
    [-163.7698, 63.2143],
    [-163.7566, 63.2152],
    [-163.7424, 63.2126],
    [-163.7305, 63.2100],
    [-163.7262, 63.2045],
    [-163.7333, 63.1967],
    [-163.7254, 63.1939],
    [-163.7188, 63.1878],
    [-163.7090, 63.1873],
    [-163.6954, 63.1830],
    [-163.6860, 63.1763],
    [-163.6810, 63.1723],
    [-163.6825, 63.1684],
    [-163.6775, 63.1652],
    [-163.6734, 63.1613],
    [-163.6572, 63.1590],
    [-163.6516, 63.1563],
    [-163.6436, 63.1520],
    [-163.6306, 63.1448],
    [-163.6189, 63.1393],
    [-163.6246, 63.1352],
    [-163.6248, 63.1198],
    [-163.6177, 63.1179],
    [-163.6103, 63.1268],
    [-163.6020, 63.1302],
    [-163.5933, 63.1375],
    [-163.5922, 63.1444],
    [-163.5877, 63.1488],
    [-163.5829, 63.1460],
    [-163.5786, 63.1410],
    [-163.5687, 63.1310],
    [-163.5588, 63.1358],
    [-163.5436, 63.1350],
    [-163.5261, 63.1322],
    [-163.5221, 63.1221],
    [-163.5423, 63.1114],
    [-163.5135, 63.1086],
    [-163.4968, 63.1115],
    [-163.4845, 63.1094],
    [-163.4776, 63.1070],
    [-163.4908, 63.1022],
    [-163.4824, 63.0988],
    [-163.4632, 63.0943],
    [-163.4500, 63.0884],
    [-163.4390, 63.0879],
    [-163.4324, 63.0881],
    [-163.4245, 63.0846],
    [-163.4243, 63.0779],
    [-163.4095, 63.0748],
    [-163.3984, 63.0717],
    [-163.3901, 63.0676],
    [-163.3803, 63.0602],
    [-163.3751, 63.0589],
    [-163.3641, 63.0512],
    [-163.3691, 63.0445],
    [-163.3700, 63.0392],
    [-163.3573, 63.0369],
    [-163.3533, 63.0331],
    [-163.3475, 63.0281],
    [-163.3294, 63.0325],
    [-163.3244, 63.0354],
    [-163.3160, 63.0364],
    [-163.3043, 63.0380],
    [-163.2961, 63.0385],
    [-163.2802, 63.0383],
    [-163.2657, 63.0386],
    [-163.2512, 63.0399],
    [-163.2370, 63.0377],
    [-163.2255, 63.0417],
    [-163.1831, 63.0467],
    [-163.1490, 63.0469],
    [-163.1184, 63.0492],
    [-163.0934, 63.0518],
    [-163.0603, 63.0567],
    [-163.0393, 63.0640],
    [-163.0347, 63.0695],
    [-163.0283, 63.0742],
    [-163.0083, 63.0854],
    [-162.9916, 63.0956],
    [-162.9722, 63.1091],
    [-162.9560, 63.1146],
    [-162.9298, 63.1187],
    [-162.9061, 63.1263],
    [-162.8829, 63.1380],
    [-162.8667, 63.1449],
    [-162.8435, 63.1574],
    [-162.8392, 63.1701],
    [-162.8436, 63.1857],
    [-162.8380, 63.1966],
    [-162.8211, 63.2056],
    [-162.7695, 63.2171],
    [-162.7580, 63.2145],
    [-162.7496, 63.2122],
    [-162.7263, 63.2112],
    [-162.7073, 63.2144],
    [-162.6906, 63.2179],
    [-162.6761, 63.2220],
    [-162.6617, 63.2280],
    [-162.6515, 63.2343],
    [-162.6375, 63.2435],
    [-162.6060, 63.2623],
    [-162.5967, 63.2666],
    [-162.5865, 63.2718],
    [-162.5844, 63.2743],
    [-162.5775, 63.2778],
    [-162.5664, 63.2876],
    [-162.5544, 63.2988],
    [-162.5313, 63.3148],
    [-162.5175, 63.3244],
    [-162.5033, 63.3328],
    [-162.4821, 63.3473],
    [-162.4716, 63.3574],
    [-162.4582, 63.3673],
    [-162.4487, 63.3726],
    [-162.4412, 63.3750],
    [-162.4348, 63.3786],
    [-162.4269, 63.3856],
    [-162.4220, 63.3941],
    [-162.4130, 63.3989],
    [-162.4234, 63.4025],
    [-162.4181, 63.4059],
    [-162.4119, 63.4102],
    [-162.4087, 63.4129],
    [-162.4075, 63.4162],
    [-162.4001, 63.4217],
    [-162.3871, 63.4283],
    [-162.3774, 63.4376],
    [-162.3661, 63.4448],
    [-162.3550, 63.4502],
    [-162.3471, 63.4541],
    [-162.3348, 63.4594],
    [-162.3266, 63.4618],
    [-162.3024, 63.4709],
    [-162.2888, 63.4775],
    [-162.2790, 63.4824],
    [-162.2709, 63.4871],
    [-162.2715, 63.4973],
    [-162.2820, 63.5064],
    [-162.2889, 63.5069],
    [-162.2960, 63.5108],
    [-162.2891, 63.5124],
    [-162.2916, 63.5218],
    [-162.3005, 63.5298],
    [-162.3116, 63.5391],
    [-162.3145, 63.5411],
    [-162.3019, 63.5391],
    [-162.2855, 63.5397],
    [-162.2806, 63.5393],
    [-162.2664, 63.5378],
    [-162.2649, 63.5405],
    [-162.2602, 63.5410],
    [-162.2488, 63.5396],
    [-162.2442, 63.5390],
    [-162.2393, 63.5376],
    [-162.2338, 63.5359],
    [-162.2342, 63.5323],
    [-162.2261, 63.5277],
    [-162.2225, 63.5262],
    [-162.2159, 63.5220],
    [-162.2028, 63.5224],
    [-162.2002, 63.5258],
    [-162.1910, 63.5286],
    [-162.1842, 63.5298],
    [-162.1805, 63.5309],
    [-162.1745, 63.5275],
    [-162.1659, 63.5271],
    [-162.1614, 63.5282],
    [-162.1594, 63.5236],
    [-162.1635, 63.5196],
    [-162.1413, 63.5138],
    [-162.1245, 63.5117],
    [-162.1101, 63.5124],
    [-162.1088, 63.5112],
    [-162.1019, 63.5088],
    [-162.0951, 63.5132],
    [-162.0820, 63.5118],
    [-162.0753, 63.5129],
    [-162.0763, 63.5085],
    [-162.0717, 63.5065],
    [-162.0790, 63.5067],
    [-162.0888, 63.5047],
    [-162.0850, 63.4991],
    [-162.0774, 63.4985],
    [-162.0705, 63.5004],
    [-162.0612, 63.4967],
    [-162.0590, 63.4931],
    [-162.0400, 63.4875],
    [-162.0234, 63.4857],
    [-162.0144, 63.4870],
    [-162.0061, 63.4843],
    [-162.0128, 63.4848],
    [-162.0163, 63.4814],
    [-162.0203, 63.4796],
    [-162.0251, 63.4805],
    [-162.0262, 63.4774],
    [-162.0314, 63.4763],
    [-162.0346, 63.4773],
    [-162.0429, 63.4769],
    [-162.0487, 63.4742],
    [-162.0487, 63.4683],
    [-162.0434, 63.4668],
    [-162.0460, 63.4636],
    [-162.0456, 63.4585],
    [-162.0427, 63.4581],
    [-162.0424, 63.4546],
    [-162.0523, 63.4539],
    [-162.0522, 63.4589],
    [-162.0723, 63.4668],
    [-162.0851, 63.4647],
    [-162.0856, 63.4592],
    [-162.0803, 63.4519],
    [-162.0811, 63.4477],
    [-162.0901, 63.4436],
    [-162.0965, 63.4422],
    [-162.1145, 63.4417],
    [-162.1207, 63.4414],
    [-162.1279, 63.4378],
    [-162.1362, 63.4353],
    [-162.1547, 63.4341],
    [-162.1441, 63.4293],
    [-162.1314, 63.4292],
    [-162.1140, 63.4289],
    [-162.0990, 63.4297],
    [-162.0879, 63.4310],
    [-162.0829, 63.4334],
    [-162.0760, 63.4329],
    [-162.0654, 63.4347],
    [-162.0583, 63.4372],
    [-162.0494, 63.4350],
    [-162.0424, 63.4347],
    [-162.0280, 63.4346],
    [-162.0264, 63.4373],
    [-162.0216, 63.4414],
    [-162.0242, 63.4470],
    [-162.0165, 63.4476],
    [-162.0087, 63.4460],
    [-162.0034, 63.4478],
    [-161.9972, 63.4436],
    [-161.9910, 63.4462],
    [-161.9892, 63.4433],
    [-161.9917, 63.4392],
    [-161.9844, 63.4360],
    [-161.9738, 63.4331],
    [-161.9661, 63.4345],
    [-161.9661, 63.4398],
    [-161.9628, 63.4447],
    [-161.9599, 63.4485],
    [-161.9550, 63.4504],
    [-161.9461, 63.4484],
    [-161.9396, 63.4476],
    [-161.9371, 63.4439],
    [-161.9333, 63.4434],
    [-161.9282, 63.4453],
    [-161.9224, 63.4425],
    [-161.9139, 63.4427],
    [-161.9040, 63.4445],
    [-161.8968, 63.4489],
    [-161.8978, 63.4515],
    [-161.8929, 63.4496],
    [-161.8826, 63.4490],
    [-161.8751, 63.4504],
    [-161.8715, 63.4478],
    [-161.8613, 63.4484],
    [-161.8532, 63.4455],
    [-161.8367, 63.4472],
    [-161.8264, 63.4454],
    [-161.8223, 63.4418],
    [-161.8188, 63.4443],
    [-161.8135, 63.4390],
    [-161.8063, 63.4413],
    [-161.7995, 63.4453],
    [-161.7957, 63.4468],
    [-161.7877, 63.4468],
    [-161.7816, 63.4474],
    [-161.7749, 63.4495],
    [-161.7694, 63.4497],
    [-161.7623, 63.4535],
    [-161.7552, 63.4554],
    [-161.7509, 63.4562],
    [-161.7421, 63.4548],
    [-161.7359, 63.4569],
    [-161.7293, 63.4541],
    [-161.7228, 63.4584],
    [-161.7139, 63.4607],
    [-161.7058, 63.4634],
    [-161.6956, 63.4638],
    [-161.6855, 63.4634],
    [-161.6771, 63.4634],
    [-161.6768, 63.4668],
    [-161.6692, 63.4621],
    [-161.6582, 63.4619],
    [-161.6476, 63.4600],
    [-161.6271, 63.4586],
    [-161.6117, 63.4555],
    [-161.6016, 63.4547],
    [-161.5891, 63.4514],
    [-161.5839, 63.4472],
    [-161.5748, 63.4481],
    [-161.5669, 63.4503],
    [-161.5593, 63.4481],
    [-161.5436, 63.4518],
    [-161.5319, 63.4522],
    [-161.5226, 63.4547],
    [-161.5165, 63.4567],
    [-161.5184, 63.4605],
    [-161.5147, 63.4627],
    [-161.5179, 63.4658],
    [-161.5147, 63.4648],
    [-161.5073, 63.4694],
    [-161.4930, 63.4674],
    [-161.4822, 63.4661],
    [-161.4763, 63.4692],
    [-161.4647, 63.4721],
    [-161.4705, 63.4655],
    [-161.4651, 63.4621],
    [-161.4664, 63.4595],
    [-161.4552, 63.4563],
    [-161.4310, 63.4566],
    [-161.4206, 63.4602],
    [-161.4071, 63.4653],
    [-161.3902, 63.4687],
    [-161.3692, 63.4699],
    [-161.3470, 63.4732],
    [-161.3349, 63.4718],
    [-161.3233, 63.4711],
    [-161.2974, 63.4718],
    [-161.2693, 63.4772],
    [-161.2494, 63.4818],
    [-161.2221, 63.4870],
    [-161.2118, 63.4881],
    [-161.2024, 63.4904],
    [-161.1860, 63.4927],
    [-161.1710, 63.4974],
    [-161.1637, 63.5019],
    [-161.1575, 63.5019],
    [-161.1521, 63.5030],
    [-161.1413, 63.5015],
    [-161.1395, 63.5044],
    [-161.1342, 63.5067],
    [-161.1393, 63.5127],
    [-161.1341, 63.5170],
    [-161.1383, 63.5184],
    [-161.1308, 63.5202],
    [-161.1317, 63.5235],
    [-161.1354, 63.5275],
    [-161.1279, 63.5292],
    [-161.1171, 63.5320],
    [-161.1099, 63.5338],
    [-161.1019, 63.5371],
    [-161.1033, 63.5391],
    [-161.1041, 63.5441],
    [-161.1069, 63.5477],
    [-161.1165, 63.5456],
    [-161.1146, 63.5511],
    [-161.1078, 63.5526],
    [-161.0950, 63.5554],
    [-161.0824, 63.5591],
    [-161.0758, 63.5605],
    [-161.0618, 63.5647],
    [-161.0479, 63.5734],
    [-161.0385, 63.5796],
    [-161.0333, 63.5874],
    [-161.0337, 63.5913],
    [-161.0302, 63.5966],
    [-161.0240, 63.6063],
    [-161.0226, 63.6098],
    [-161.0171, 63.6139],
    [-161.0179, 63.6205],
    [-161.0101, 63.6228],
    [-160.9964, 63.6178],
    [-160.9866, 63.6138],
    [-160.9635, 63.6212],
    [-160.9280, 63.6410],
    [-160.8836, 63.6765],
    [-160.8574, 63.6985],
    [-160.8137, 63.7272],
    [-160.7833, 63.7529],
    [-160.7645, 63.7794],
    [-160.7634, 63.7960],
    [-160.7680, 63.8353],
    [-160.7820, 63.8577],
    [-160.7884, 63.8663],
    [-160.7883, 63.8711],
    [-160.7983, 63.8772],
    [-160.8096, 63.9015],
    [-160.8340, 63.9336],
    [-160.8520, 63.9544],
    [-160.8812, 63.9808],
    [-160.8904, 63.9856],
    [-160.9169, 64.0266],
    [-160.9326, 64.0467],
    [-160.9411, 64.0610],
    [-160.9482, 64.0804],
    [-160.9499, 64.0932],
    [-160.9484, 64.1011],
    [-160.9442, 64.1155],
    [-160.9549, 64.1350],
    [-160.9539, 64.1419],
    [-160.9572, 64.1503],
    [-160.9534, 64.1562],
    [-160.9550, 64.1683],
    [-160.9549, 64.1785],
    [-160.9545, 64.1920],
    [-160.9498, 64.2010],
    [-160.9549, 64.2132],
    [-160.9784, 64.2353],
    [-161.0566, 64.2792],
    [-161.1056, 64.3037],
    [-161.1440, 64.3247],
    [-161.1814, 64.3459],
    [-161.2080, 64.3596],
    [-161.2298, 64.3706],
    [-161.2371, 64.3795],
    [-161.2414, 64.3821],
    [-161.2538, 64.3834],
    [-161.2639, 64.3901],
    [-161.2658, 64.3979],
    [-161.2923, 64.3949],
    [-161.3219, 64.4009],
    [-161.3849, 64.4148],
    [-161.3895, 64.4226],
    [-161.3996, 64.4231],
    [-161.4260, 64.4211],
    [-161.4625, 64.4196],
    [-161.4741, 64.4150],
    [-161.4828, 64.4122],
    [-161.4984, 64.4055],
    [-161.5068, 64.4000],
    [-161.5088, 64.3972],
    [-161.5106, 64.3930],
    [-161.5170, 64.3888],
    [-161.5187, 64.3856],
    [-161.5223, 64.3813],
    [-161.5278, 64.3784],
    [-161.5328, 64.3796],
    [-161.5303, 64.3869],
    [-161.5195, 64.3926],
    [-161.5231, 64.3990],
    [-161.5267, 64.4032],
    [-161.5295, 64.4075],
    [-161.5315, 64.4172],
    [-161.5201, 64.4210],
    [-161.5081, 64.4215],
    [-161.4988, 64.4252],
    [-161.4930, 64.4322],
    [-161.4844, 64.4346],
    [-161.4831, 64.4395],
    [-161.4777, 64.4430],
    [-161.4745, 64.4484],
    [-161.4753, 64.4549],
    [-161.4776, 64.4649],
    [-161.4723, 64.4705],
    [-161.4805, 64.4801],
    [-161.4739, 64.4898],
    [-161.4659, 64.4900],
    [-161.4663, 64.4972],
    [-161.4669, 64.5012],
    [-161.4691, 64.5036],
    [-161.4621, 64.5080],
    [-161.4394, 64.5109],
    [-161.4300, 64.5140],
    [-161.4232, 64.5202],
    [-161.4153, 64.5204],
    [-161.4115, 64.5213],
    [-161.4085, 64.5245],
    [-161.3983, 64.5279],
    [-161.3882, 64.5320],
    [-161.3800, 64.5337],
    [-161.3702, 64.5324],
    [-161.3613, 64.5248],
    [-161.3456, 64.5182],
    [-161.3226, 64.5138],
    [-161.3052, 64.5106],
    [-161.2705, 64.5081],
    [-161.2656, 64.5047],
    [-161.2552, 64.5019],
    [-161.2218, 64.4973],
    [-161.1936, 64.4954],
    [-161.1506, 64.4942],
    [-161.1193, 64.4949],
    [-161.1043, 64.4943],
    [-161.0857, 64.4935],
    [-161.0720, 64.4936],
    [-161.0573, 64.4953],
    [-161.0447, 64.4965],
    [-161.0347, 64.4986],
    [-161.0289, 64.4998],
    [-161.0226, 64.4995],
    [-161.0165, 64.5003],
    [-161.0090, 64.5054],
    [-161.0080, 64.5098],
    [-161.0024, 64.5114],
    [-161.0077, 64.5146],
    [-161.0112, 64.5202],
    [-161.0286, 64.5238],
    [-161.0446, 64.5275],
    [-161.0557, 64.5282],
    [-161.0565, 64.5245],
    [-161.0556, 64.5210],
    [-161.0671, 64.5236],
    [-161.0798, 64.5317],
    [-161.0892, 64.5390],
    [-161.0876, 64.5413],
    [-161.0674, 64.5416],
    [-161.0210, 64.5394],
    [-160.9914, 64.5402],
    [-160.9613, 64.5434],
    [-160.9461, 64.5472],
    [-160.9378, 64.5498],
    [-160.9318, 64.5542],
    [-160.9279, 64.5533],
    [-160.9254, 64.5570],
    [-160.9267, 64.5591],
    [-160.9153, 64.5708],
    [-160.8948, 64.5821],
    [-160.8626, 64.5891],
    [-160.8387, 64.5965],
    [-160.8288, 64.6011],
    [-160.8177, 64.6053],
    [-160.8033, 64.6106],
    [-160.7974, 64.6162],
    [-160.7913, 64.6212],
    [-160.7883, 64.6256],
    [-160.7875, 64.6310],
    [-160.7896, 64.6407],
    [-160.7894, 64.6459],
    [-160.7904, 64.6558],
    [-160.7930, 64.6646],
    [-160.7857, 64.6706],
    [-160.7831, 64.6762],
    [-160.7849, 64.6880],
    [-160.7822, 64.6951],
    [-160.7875, 64.7011],
    [-160.7815, 64.7050],
    [-160.7816, 64.7155],
    [-160.7892, 64.7234],
    [-160.8094, 64.7392],
    [-160.8251, 64.7498],
    [-160.8354, 64.7558],
    [-160.8414, 64.7633],
    [-160.8429, 64.7689],
    [-160.8590, 64.7770],
    [-160.8671, 64.7852],
    [-160.8696, 64.7893],
    [-160.8722, 64.7947],
    [-160.8720, 64.8021],
    [-160.8763, 64.8044],
    [-160.8823, 64.8099],
    [-160.8872, 64.8132],
    [-160.8973, 64.8195],
    [-160.9022, 64.8212],
    [-160.9134, 64.8217],
    [-160.9290, 64.8212],
    [-160.9510, 64.8251],
    [-160.9653, 64.8291],
    [-160.9788, 64.8322],
    [-160.9885, 64.8348],
    [-160.9911, 64.8417],
    [-160.9967, 64.8468],
    [-161.0054, 64.8475],
    [-161.0165, 64.8462],
    [-161.0463, 64.8576],
    [-161.0650, 64.8639],
    [-161.0797, 64.8695],
    [-161.0985, 64.8771],
    [-161.1160, 64.8868],
    [-161.1331, 64.8982],
    [-161.1397, 64.9034],
    [-161.1466, 64.9108],
    [-161.1525, 64.9158],
    [-161.1472, 64.9233],
    [-161.1406, 64.9306],
    [-161.1510, 64.9311],
    [-161.1626, 64.9290],
    [-161.1749, 64.9281],
    [-161.1860, 64.9244],
    [-161.1923, 64.9217],
    [-161.1960, 64.9162],
    [-161.2013, 64.9065],
    [-161.2007, 64.8950],
    [-161.2065, 64.8886],
    [-161.2144, 64.8825],
    [-161.2272, 64.8791],
    [-161.2437, 64.8712],
    [-161.2573, 64.8656],
    [-161.2624, 64.8639],
    [-161.2660, 64.8614],
    [-161.2718, 64.8610],
    [-161.2798, 64.8587],
    [-161.2933, 64.8518],
    [-161.2986, 64.8470],
    [-161.2923, 64.8441],
    [-161.2991, 64.8407],
    [-161.3121, 64.8391],
    [-161.3164, 64.8369],
    [-161.3264, 64.8324],
    [-161.3348, 64.8259],
    [-161.3351, 64.8201],
    [-161.3411, 64.8162],
    [-161.3534, 64.8114],
    [-161.3562, 64.8078],
    [-161.3598, 64.8021],
    [-161.3659, 64.7976],
    [-161.3663, 64.7949],
    [-161.3667, 64.7871],
    [-161.3657, 64.7809],
    [-161.3719, 64.7776],
    [-161.3770, 64.7730],
    [-161.3957, 64.7712],
    [-161.4148, 64.7681],
    [-161.4182, 64.7614],
    [-161.4241, 64.7596],
    [-161.4346, 64.7592],
    [-161.4562, 64.7605],
    [-161.4647, 64.7593],
    [-161.4766, 64.7582],
    [-161.4910, 64.7577],
    [-161.4966, 64.7552],
    [-161.5170, 64.7536],
    [-161.5243, 64.7500],
    [-161.5250, 64.7475],
    [-161.5237, 64.7431],
    [-161.5272, 64.7403],
    [-161.5330, 64.7380],
    [-161.5383, 64.7399],
    [-161.5478, 64.7424],
    [-161.5460, 64.7480],
    [-161.5418, 64.7535],
    [-161.5493, 64.7580],
    [-161.5743, 64.7642],
    [-161.5954, 64.7673],
    [-161.6281, 64.7718],
    [-161.6628, 64.7833],
    [-161.6693, 64.7885],
    [-161.6733, 64.7858],
    [-161.7129, 64.7743],
    [-161.7665, 64.7670],
    [-161.8126, 64.7603],
    [-161.8345, 64.7569],
    [-161.8452, 64.7528],
    [-161.8524, 64.7480],
    [-161.8606, 64.7416],
    [-161.8865, 64.7417],
    [-161.8908, 64.7362],
    [-161.9031, 64.7316],
    [-161.9111, 64.7290],
    [-161.9170, 64.7273],
    [-161.9205, 64.7256],
    [-161.9245, 64.7225],
    [-161.9278, 64.7172],
    [-161.9070, 64.7139],
    [-161.8934, 64.7124],
    [-161.8892, 64.7148],
    [-161.8792, 64.7166],
    [-161.8721, 64.7201],
    [-161.8637, 64.7249],
    [-161.8517, 64.7270],
    [-161.8430, 64.7300],
    [-161.8372, 64.7322],
    [-161.8337, 64.7334],
    [-161.8291, 64.7347],
    [-161.8198, 64.7378],
    [-161.8101, 64.7402],
    [-161.7957, 64.7432],
    [-161.7882, 64.7460],
    [-161.7829, 64.7498],
    [-161.7711, 64.7498],
    [-161.7583, 64.7530],
    [-161.7682, 64.7488],
    [-161.7923, 64.7430],
    [-161.8261, 64.7347],
    [-161.8475, 64.7268],
    [-161.8539, 64.7210],
    [-161.8765, 64.7095],
    [-161.9101, 64.7025],
    [-161.9453, 64.6998],
    [-161.9761, 64.6985],
    [-162.0138, 64.6963],
    [-162.0333, 64.6946],
    [-162.1059, 64.6907],
    [-162.1591, 64.6830],
    [-162.1851, 64.6762],
    [-162.1905, 64.6707],
    [-162.1939, 64.6652],
    [-162.2166, 64.6562],
    [-162.2170, 64.6515],
    [-162.2182, 64.6473],
    [-162.2206, 64.6419],
    [-162.2264, 64.6350],
    [-162.2312, 64.6289],
    [-162.2337, 64.6221],
    [-162.2385, 64.6185],
    [-162.2548, 64.6163],
    [-162.2701, 64.6127],
    [-162.2704, 64.6081],
    [-162.2922, 64.6062],
    [-162.3065, 64.6047],
    [-162.3134, 64.6019],
    [-162.3243, 64.5998],
    [-162.3393, 64.5945],
    [-162.3507, 64.5886],
    [-162.3619, 64.5845],
    [-162.3747, 64.5813],
    [-162.4040, 64.5756],
    [-162.4119, 64.5704],
    [-162.4162, 64.5680],
    [-162.4355, 64.5646],
    [-162.4549, 64.5594],
    [-162.4588, 64.5554],
    [-162.4739, 64.5504],
    [-162.4819, 64.5465],
    [-162.4946, 64.5426],
    [-162.5080, 64.5384],
    [-162.5381, 64.5329],
    [-162.5464, 64.5277],
    [-162.5493, 64.5235],
    [-162.5582, 64.5181],
    [-162.5613, 64.5123],
    [-162.5722, 64.5076],
    [-162.5772, 64.5014],
    [-162.5830, 64.4948],
    [-162.5882, 64.4898],
    [-162.5930, 64.4848],
    [-162.5964, 64.4824],
    [-162.5990, 64.4801],
    [-162.6071, 64.4762],
    [-162.6163, 64.4684],
    [-162.6119, 64.4643],
    [-162.6084, 64.4599],
    [-162.6050, 64.4577],
    [-162.6030, 64.4553],
    [-162.6054, 64.4529],
    [-162.6022, 64.4499],
    [-162.6058, 64.4449],
    [-162.6074, 64.4399],
    [-162.6122, 64.4382],
    [-162.6130, 64.4348],
    [-162.6131, 64.4301],
    [-162.6131, 64.4285],
    [-162.6178, 64.4264],
    [-162.6186, 64.4194],
    [-162.6283, 64.4160],
    [-162.6293, 64.4115],
    [-162.6353, 64.4099],
    [-162.6390, 64.4081],
    [-162.6417, 64.4039],
    [-162.6393, 64.4004],
    [-162.6323, 64.3975],
    [-162.6347, 64.3953],
    [-162.6310, 64.3906],
    [-162.6314, 64.3854],
    [-162.6412, 64.3821],
    [-162.6497, 64.3789],
    [-162.6677, 64.3754],
    [-162.6727, 64.3779],
    [-162.6812, 64.3772],
    [-162.6881, 64.3735],
    [-162.6969, 64.3674],
    [-162.7108, 64.3642],
    [-162.7225, 64.3609],
    [-162.7328, 64.3601],
    [-162.7394, 64.3557],
    [-162.7463, 64.3486],
    [-162.7562, 64.3411],
    [-162.7768, 64.3284],
    [-162.7901, 64.3248],
    [-162.8013, 64.3307],
    [-162.8049, 64.3379],
    [-162.8091, 64.3532],
    [-162.8090, 64.3627],
    [-162.8046, 64.3693],
    [-162.8001, 64.3827],
    [-162.8023, 64.3898],
    [-162.8043, 64.3978],
    [-162.8034, 64.4015],
    [-162.8066, 64.4056],
    [-162.8073, 64.4083],
    [-162.8240, 64.4164],
    [-162.8210, 64.4187],
    [-162.8252, 64.4232],
    [-162.8339, 64.4265],
    [-162.8367, 64.4286],
    [-162.8325, 64.4281],
    [-162.8284, 64.4310],
    [-162.8306, 64.4337],
    [-162.8328, 64.4366],
    [-162.8364, 64.4395],
    [-162.8538, 64.4454],
    [-162.8617, 64.4458],
    [-162.8698, 64.4476],
    [-162.8702, 64.4487],
    [-162.8646, 64.4493],
    [-162.8584, 64.4498],
    [-162.8556, 64.4552],
    [-162.8538, 64.4607],
    [-162.8631, 64.4693],
    [-162.8640, 64.4721],
    [-162.8586, 64.4749],
    [-162.8498, 64.4754],
    [-162.8470, 64.4780],
    [-162.8398, 64.4781],
    [-162.8325, 64.4803],
    [-162.8370, 64.4894],
    [-162.8525, 64.4980],
    [-162.8664, 64.5031],
    [-162.8863, 64.5071],
    [-162.8938, 64.5112],
    [-162.9084, 64.5151],
    [-162.9114, 64.5175],
    [-162.9201, 64.5216],
    [-162.9197, 64.5242],
    [-162.9252, 64.5289],
    [-162.9286, 64.5350],
    [-162.9379, 64.5428],
    [-162.9599, 64.5460],
    [-162.9769, 64.5463],
    [-163.0307, 64.5424],
    [-163.0458, 64.5415],
    [-163.0405, 64.5441],
    [-163.0353, 64.5463],
    [-163.0260, 64.5468],
    [-163.0158, 64.5523],
    [-163.0164, 64.5626],
    [-163.0200, 64.5688],
    [-163.0279, 64.5754],
    [-163.0309, 64.5798],
    [-163.0355, 64.5825],
    [-163.0382, 64.5856],
    [-163.0531, 64.5909],
    [-163.0689, 64.5949],
    [-163.0787, 64.5978],
    [-163.0877, 64.6012],
    [-163.1082, 64.6014],
    [-163.1153, 64.6025],
    [-163.1213, 64.6061],
    [-163.1342, 64.6090],
    [-163.1461, 64.6176],
    [-163.1536, 64.6247],
    [-163.1503, 64.6237],
    [-163.1445, 64.6209],
    [-163.1420, 64.6328],
    [-163.1351, 64.6336],
    [-163.1282, 64.6390],
    [-163.1257, 64.6434],
    [-163.1300, 64.6447],
    [-163.1344, 64.6484],
    [-163.1411, 64.6455],
    [-163.1564, 64.6469],
    [-163.1614, 64.6448],
    [-163.1698, 64.6462],
    [-163.1888, 64.6464],
    [-163.1898, 64.6432],
    [-163.1979, 64.6456],
    [-163.2043, 64.6412],
    [-163.2138, 64.6396],
    [-163.2257, 64.6328],
    [-163.2503, 64.6244],
    [-163.2584, 64.6185],
    [-163.2676, 64.6169],
    [-163.2711, 64.6120],
    [-163.2801, 64.6068],
    [-163.2894, 64.6043],
    [-163.3020, 64.5967],
    [-163.3121, 64.5920],
    [-163.3242, 64.5907],
    [-163.3363, 64.5899],
    [-163.3446, 64.5907],
    [-163.3523, 64.5876],
    [-163.3500, 64.5833],
    [-163.3336, 64.5835],
    [-163.3376, 64.5801],
    [-163.3402, 64.5760],
    [-163.3329, 64.5717],
    [-163.3170, 64.5685],
    [-163.3084, 64.5662],
    [-163.3022, 64.5622],
    [-163.2836, 64.5568],
    [-163.2794, 64.5533],
    [-163.2750, 64.5469],
    [-163.2624, 64.5438],
    [-163.2502, 64.5425],
    [-163.2369, 64.5411],
    [-163.2170, 64.5404],
    [-163.2106, 64.5380],
    [-163.1940, 64.5367],
    [-163.1825, 64.5398],
    [-163.1776, 64.5369],
    [-163.1657, 64.5179],
    [-163.1405, 64.5068],
    [-163.1238, 64.5049],
    [-163.1057, 64.5070],
    [-163.0940, 64.5122],
    [-163.0755, 64.5155],
    [-163.0668, 64.5103],
    [-163.0511, 64.5079],
    [-163.0335, 64.5133],
    [-163.0309, 64.5120],
    [-163.0321, 64.5041],
    [-163.0446, 64.4866],
    [-163.0367, 64.4813],
    [-163.0272, 64.4779],
    [-163.0617, 64.4724],
    [-163.0903, 64.4643],
    [-163.1018, 64.4569],
    [-163.1045, 64.4512],
    [-163.0972, 64.4464],
    [-163.0926, 64.4404],
    [-163.0932, 64.4344],
    [-163.0997, 64.4282],
    [-163.1018, 64.4234],
    [-163.1075, 64.4186],
    [-163.1073, 64.4146],
    [-163.1073, 64.4097],
    [-163.1130, 64.4078],
    [-163.1167, 64.4059],
    [-163.1201, 64.4033],
    [-163.1304, 64.4030],
    [-163.1459, 64.4001],
    [-163.1551, 64.3985],
    [-163.1623, 64.3990],
    [-163.1762, 64.3995],
    [-163.1757, 64.4046],
    [-163.1842, 64.4070],
    [-163.1931, 64.4072],
    [-163.1964, 64.4115],
    [-163.1934, 64.4164],
    [-163.1953, 64.4183],
    [-163.2041, 64.4229],
    [-163.2171, 64.4242],
    [-163.2264, 64.4278],
    [-163.2277, 64.4322],
    [-163.2259, 64.4365],
    [-163.2370, 64.4437],
    [-163.2427, 64.4504],
    [-163.2488, 64.4528],
    [-163.2485, 64.4574],
    [-163.2517, 64.4629],
    [-163.2550, 64.4652],
    [-163.2530, 64.4695],
    [-163.2652, 64.4763],
    [-163.2759, 64.4792],
    [-163.2805, 64.4809],
    [-163.2922, 64.4867],
    [-163.3136, 64.4903],
    [-163.3270, 64.4918],
    [-163.3372, 64.4920],
    [-163.3419, 64.4938],
    [-163.3419, 64.4985],
    [-163.3509, 64.5059],
    [-163.4129, 64.5250],
    [-163.5475, 64.5552],
    [-163.6039, 64.5642],
    [-163.6168, 64.5637],
    [-163.6491, 64.5680],
    [-163.6606, 64.5682],
    [-163.6707, 64.5671],
    [-163.6807, 64.5658],
    [-163.6889, 64.5656],
    [-163.6981, 64.5666],
    [-163.7093, 64.5665],
    [-163.7224, 64.5655],
    [-163.7327, 64.5663],
    [-163.7380, 64.5664],
    [-163.7460, 64.5689],
    [-163.7754, 64.5726],
    [-163.7955, 64.5748],
    [-163.8407, 64.5751],
    [-163.8526, 64.5745],
    [-163.8751, 64.5735],
    [-163.8833, 64.5701],
    [-163.8856, 64.5679],
    [-163.8940, 64.5646],
    [-163.8993, 64.5603],
    [-163.9050, 64.5598],
    [-163.9268, 64.5641],
    [-163.9486, 64.5616],
    [-163.9480, 64.5588],
    [-163.9540, 64.5585],
    [-163.9691, 64.5534],
    [-163.9823, 64.5526],
    [-163.9945, 64.5517],
    [-164.0068, 64.5551],
    [-164.0299, 64.5580],
    [-164.0384, 64.5592],
    [-164.0714, 64.5618],
    [-164.1239, 64.5641],
    [-164.1896, 64.5654],
    [-164.3073, 64.5615],
    [-164.4020, 64.5488],
    [-164.4539, 64.5392],
    [-164.4989, 64.5290],
    [-164.5405, 64.5195],
    [-164.5803, 64.5092],
    [-164.6462, 64.4929],
    [-164.6947, 64.4815],
    [-164.7182, 64.4739],
    [-164.7269, 64.4723],
    [-164.7409, 64.4680],
    [-164.7630, 64.4612],
    [-164.8181, 64.4489],
    [-164.8540, 64.4436],
    [-164.8839, 64.4422],
    [-164.9359, 64.4406],
    [-164.9807, 64.4422],
    [-164.9924, 64.4389],
    [-165.0124, 64.4349],
    [-165.0484, 64.4416],
    [-165.0956, 64.4501],
    [-165.1495, 64.4596],
    [-165.1986, 64.4675],
    [-165.2430, 64.4742],
    [-165.3072, 64.4829],
    [-165.3322, 64.4870],
    [-165.3887, 64.4944],
    [-165.4120, 64.4973],
    [-165.4200, 64.4981],
    [-165.4276, 64.4994],
    [-165.4344, 64.4998],
    [-165.4635, 64.5030],
    [-165.5014, 64.5072],
    [-165.5268, 64.5108],
    [-165.5841, 64.5178],
    [-165.6296, 64.5235],
    [-165.6907, 64.5306],
    [-165.7282, 64.5344],
    [-165.7438, 64.5357],
    [-165.8011, 64.5397],
    [-165.8196, 64.5402],
    [-165.8542, 64.5414],
    [-165.8813, 64.5457],
    [-165.9146, 64.5500],
    [-165.9281, 64.5508],
    [-165.9460, 64.5533],
    [-165.9759, 64.5562],
    [-165.9851, 64.5572],
    [-166.0140, 64.5602],
    [-166.0493, 64.5645],
    [-166.0995, 64.5687],
    [-166.1381, 64.5732],
    [-166.1703, 64.5764],
    [-166.1905, 64.5779],
    [-166.2235, 64.5829],
    [-166.2508, 64.5897],
    [-166.2698, 64.5956],
    [-166.3149, 64.6141],
    [-166.3673, 64.6320],
    [-166.3961, 64.6423],
    [-166.4100, 64.6544],
    [-166.4239, 64.6715],
    [-166.4424, 64.6882],
    [-166.4593, 64.7094],
    [-166.4776, 64.7338],
    [-166.4758, 64.7384],
    [-166.4684, 64.7475],
    [-166.4674, 64.7583],
    [-166.4676, 64.7691],
    [-166.4714, 64.7778],
    [-166.4760, 64.7872],
    [-166.4752, 64.7960],
    [-166.4708, 64.7972],
    [-166.4639, 64.7978],
    [-166.4548, 64.8020],
    [-166.4491, 64.8041],
    [-166.4391, 64.8048],
    [-166.4323, 64.8062],
    [-166.4168, 64.8137],
    [-166.4064, 64.8270],
    [-166.4036, 64.8321],
    [-166.4025, 64.8449],
    [-166.4076, 64.8644],
    [-166.4203, 64.8796],
    [-166.4531, 64.9026],
    [-166.4852, 64.9198],
    [-166.5204, 64.9344],
    [-166.5646, 64.9492],
    [-166.6059, 64.9616],
    [-166.6396, 64.9696],
    [-166.6724, 64.9789],
    [-166.6857, 64.9871],
    [-166.6964, 64.9931],
    [-166.7028, 64.9969],
    [-166.7004, 64.9998],
    [-166.6938, 65.0014],
    [-166.6903, 65.0061],
    [-166.6895, 65.0094],
    [-166.6876, 65.0130],
    [-166.6848, 65.0166],
    [-166.6892, 65.0278],
    [-166.6965, 65.0359],
    [-166.7219, 65.0500],
    [-166.7552, 65.0609],
    [-166.8019, 65.0735],
    [-166.8366, 65.0833],
    [-166.8831, 65.1072],
    [-166.9101, 65.1275],
    [-166.9450, 65.1507],
    [-166.9512, 65.1659],
    [-166.9419, 65.1811],
    [-166.9311, 65.1973],
    [-166.9224, 65.2182],
    [-166.9075, 65.2388],
    [-166.8906, 65.2586],
    [-166.8644, 65.2774],
    [-166.8426, 65.2788],
    [-166.8423, 65.2764],
    [-166.8480, 65.2694],
    [-166.8430, 65.2652],
    [-166.8404, 65.2611],
    [-166.8495, 65.2516],
    [-166.8535, 65.2439],
    [-166.8860, 65.2352],
    [-166.9063, 65.2279],
    [-166.9167, 65.2160],
    [-166.9265, 65.1999],
    [-166.9366, 65.1855],
    [-166.9393, 65.1721],
    [-166.9244, 65.1619],
    [-166.9144, 65.1541],
    [-166.9213, 65.1522],
    [-166.9123, 65.1442],
    [-166.8977, 65.1390],
    [-166.8867, 65.1388],
    [-166.8532, 65.1316],
    [-166.8327, 65.1273],
    [-166.8326, 65.1238],
    [-166.8248, 65.1198],
    [-166.8166, 65.1178],
    [-166.7928, 65.1172],
    [-166.7809, 65.1156],
    [-166.7613, 65.1141],
    [-166.7499, 65.1126],
    [-166.7182, 65.1087],
    [-166.6867, 65.1078],
    [-166.6606, 65.1100],
    [-166.6303, 65.1135],
    [-166.6132, 65.1150],
    [-166.5989, 65.1181],
    [-166.5816, 65.1211],
    [-166.5581, 65.1227],
    [-166.5444, 65.1194],
    [-166.5438, 65.1248],
    [-166.5464, 65.1339],
    [-166.5706, 65.1369],
    [-166.6226, 65.1263],
    [-166.6302, 65.1265],
    [-166.5927, 65.1365],
    [-166.5403, 65.1445],
    [-166.5044, 65.1532],
    [-166.4918, 65.1606],
    [-166.4760, 65.1693],
    [-166.4604, 65.1801],
    [-166.4594, 65.1907],
    [-166.4653, 65.1948],
    [-166.4678, 65.2030],
    [-166.4742, 65.2149],
    [-166.4761, 65.2240],
    [-166.4626, 65.2301],
    [-166.4570, 65.2328],
    [-166.4511, 65.2371],
    [-166.4426, 65.2374],
    [-166.4360, 65.2389],
    [-166.4276, 65.2415],
    [-166.4214, 65.2436],
    [-166.4124, 65.2480],
    [-166.3978, 65.2496],
    [-166.3890, 65.2521],
    [-166.3739, 65.2605],
    [-166.3617, 65.2677],
    [-166.3541, 65.2736],
    [-166.3539, 65.2836],
    [-166.3900, 65.3040],
    [-166.4338, 65.3190],
    [-166.4639, 65.3265],
    [-166.5050, 65.3336],
    [-166.5311, 65.3366],
    [-166.5470, 65.3376],
    [-166.5779, 65.3377],
    [-166.5943, 65.3360],
    [-166.6055, 65.3321],
    [-166.6215, 65.3268],
    [-166.6444, 65.3257],
    [-166.6792, 65.3281],
    [-166.7262, 65.3332],
    [-166.7776, 65.3379],
    [-166.8145, 65.3420],
    [-166.8577, 65.3522],
    [-166.8835, 65.3589],
    [-166.9185, 65.3663],
    [-166.9665, 65.3743],
    [-167.0233, 65.3829],
    [-167.0825, 65.3876],
    [-167.1189, 65.3889],
    [-167.1471, 65.3886],
    [-167.1709, 65.3918],
    [-167.2014, 65.3957],
    [-167.2169, 65.3965],
    [-167.2230, 65.3950],
    [-167.2419, 65.3955],
    [-167.2577, 65.3954],
    [-167.2781, 65.3971],
    [-167.3273, 65.3999],
    [-167.3380, 65.3989],
    [-167.3657, 65.4013],
    [-167.3893, 65.4020],
    [-167.4034, 65.4026],
    [-167.4273, 65.4074],
    [-167.4568, 65.4128],
    [-167.4650, 65.4135],
    [-167.4803, 65.4191],
    [-167.4998, 65.4263],
    [-167.5236, 65.4326],
    [-167.5286, 65.4355],
    [-167.5526, 65.4421],
    [-167.5953, 65.4529],
    [-167.6108, 65.4571],
    [-167.6130, 65.4641],
    [-167.6197, 65.4694],
    [-167.6316, 65.4745],
    [-167.6413, 65.4784],
    [-167.6566, 65.4836],
    [-167.6756, 65.4883],
    [-167.6976, 65.4967],
    [-167.7390, 65.5080],
    [-167.7891, 65.5174],
    [-167.8206, 65.5228],
    [-167.8339, 65.5272],
    [-167.8355, 65.5313],
    [-167.8431, 65.5349],
    [-167.8419, 65.5373],
    [-167.8550, 65.5422],
    [-167.8819, 65.5470],
    [-167.9248, 65.5544],
    [-167.9478, 65.5569],
    [-167.9733, 65.5605],
    [-167.9818, 65.5585],
    [-167.9912, 65.5590],
    [-168.0143, 65.5639],
    [-168.0397, 65.5693],
    [-168.0572, 65.5730],
    [-168.0697, 65.5770],
    [-168.0744, 65.5810],
    [-168.0833, 65.5877],
    [-168.0907, 65.5934],
    [-168.0914, 65.5976],
    [-168.0863, 65.6004],
    [-168.0880, 65.6055],
    [-168.1068, 65.6201],
    [-168.1179, 65.6298],
    [-168.1202, 65.6479]
    ]
  },
  "Nevada": {
    coordinates: [
      [-120.0057, 39.2287],
    [-120.0053, 39.2729],
    [-120.0051, 39.2913],
    [-120.0053, 39.3163],
    [-120.0044, 39.3749],
    [-120.0031, 39.4450],
    [-120.0025, 39.4871],
    [-120.0024, 39.4958],
    [-120.0022, 39.5054],
    [-120.0017, 39.5389],
    [-120.0015, 39.6358],
    [-120.0014, 39.6743],
    [-120.0005, 39.7800],
    [-119.9983, 39.9235],
    [-119.9972, 40.0772],
    [-119.9971, 40.1264],
    [-119.9962, 40.2635],
    [-119.9961, 40.4023],
    [-119.9985, 40.7499],
    [-119.9992, 40.8675],
    [-119.9999, 41.1840],
    [-119.9983, 41.6188],
    [-119.9993, 41.8753],
    [-119.8761, 41.9972],
    [-119.7901, 41.9975],
    [-119.3602, 41.9944],
    [-119.2510, 41.9938],
    [-119.0010, 41.9938],
    [-118.7772, 41.9927],
    [-118.6447, 41.9929],
    [-118.5010, 41.9954],
    [-118.1239, 41.9973],
    [-117.6621, 41.9981],
    [-117.6237, 41.9985],
    [-117.5302, 41.9991],
    [-117.4036, 41.9993],
    [-117.0686, 42.0000],
    [-117.0409, 41.9999],
    [-117.0182, 41.9993],
    [-116.8623, 41.9986],
    [-116.5869, 41.9974],
    [-116.5017, 41.9973],
    [-116.4671, 41.9970],
    [-116.3782, 41.9964],
    [-116.1639, 41.9976],
    [-116.0386, 41.9974],
    [-116.0190, 41.9978],
    [-116.0122, 41.9980],
    [-115.8876, 41.9980],
    [-115.7332, 41.9971],
    [-115.5868, 41.9969],
    [-115.2543, 41.9967],
    [-115.0318, 41.9960],
    [-114.8992, 41.9999],
    [-114.8064, 42.0018],
    [-114.6748, 41.9968],
    [-114.5983, 41.9945],
    [-114.4676, 41.9955],
    [-114.1074, 41.9940],
    [-114.0618, 41.9938],
    [-114.0396, 41.8848],
    [-114.0399, 41.7538],
    [-114.0404, 41.6148],
    [-114.0414, 41.2200],
    [-114.0421, 40.9999],
    [-114.0431, 40.7803],
    [-114.0438, 40.7587],
    [-114.0436, 40.7403],
    [-114.0435, 40.7260],
    [-114.0456, 40.4958],
    [-114.0458, 40.4248],
    [-114.0467, 40.1169],
    [-114.0468, 40.0301],
    [-114.0471, 39.9061],
    [-114.0478, 39.7942],
    [-114.0473, 39.7248],
    [-114.0491, 39.0055],
    [-114.0495, 38.8749],
    [-114.0499, 38.6774],
    [-114.0499, 38.5478],
    [-114.0501, 38.4047],
    [-114.0501, 38.2500],
    [-114.0504, 38.0000],
    [-114.0499, 37.8525],
    [-114.0499, 37.7656],
    [-114.0518, 37.7462],
    [-114.0523, 37.6363],
    [-114.0527, 37.5310],
    [-114.0527, 37.5025],
    [-114.0526, 37.4723],
    [-114.0519, 37.3707],
    [-114.0518, 37.2930],
    [-114.0514, 37.2339],
    [-114.0519, 37.1343],
    [-114.0517, 37.0884],
    [-114.0506, 36.8431],
    [-114.0504, 36.8178],
    [-114.0503, 36.7997],
    [-114.0494, 36.6889],
    [-114.0449, 36.4961],
    [-114.0432, 36.3794],
    [-114.0455, 36.2917],
    [-114.0440, 36.2470],
    [-114.0682, 36.1777],
    [-114.1022, 36.1197],
    [-114.1222, 36.1090],
    [-114.1122, 36.0950],
    [-114.1351, 36.0464],
    [-114.1476, 36.0252],
    [-114.1801, 36.0249],
    [-114.2333, 36.0143],
    [-114.2614, 36.0255],
    [-114.2689, 36.0409],
    [-114.2782, 36.0458],
    [-114.2934, 36.0545],
    [-114.3085, 36.0570],
    [-114.3144, 36.0605],
    [-114.3075, 36.0697],
    [-114.3288, 36.1055],
    [-114.3450, 36.1185],
    [-114.3721, 36.1431],
    [-114.3815, 36.1413],
    [-114.4153, 36.1451],
    [-114.4471, 36.1260],
    [-114.4636, 36.1397],
    [-114.4988, 36.1266],
    [-114.5092, 36.1332],
    [-114.5003, 36.1407],
    [-114.5081, 36.1497],
    [-114.5323, 36.1480],
    [-114.5432, 36.1519],
    [-114.5612, 36.1509],
    [-114.6083, 36.1339],
    [-114.6279, 36.1410],
    [-114.6621, 36.1177],
    [-114.6751, 36.1141],
    [-114.6851, 36.1098],
    [-114.6937, 36.1125],
    [-114.7098, 36.1077],
    [-114.7471, 36.0970],
    [-114.7548, 36.0847],
    [-114.7406, 36.0658],
    [-114.7404, 36.0493],
    [-114.7400, 36.0375],
    [-114.7276, 36.0331],
    [-114.7229, 36.0272],
    [-114.7405, 36.0133],
    [-114.7399, 35.9921],
    [-114.7299, 35.9622],
    [-114.7125, 35.9319],
    [-114.7003, 35.9018],
    [-114.6672, 35.8748],
    [-114.6626, 35.8692],
    [-114.6915, 35.8587],
    [-114.7036, 35.8526],
    [-114.6964, 35.8338],
    [-114.7037, 35.8146],
    [-114.6989, 35.7902],
    [-114.6973, 35.7337],
    [-114.7012, 35.7012],
    [-114.6806, 35.6855],
    [-114.6900, 35.6647],
    [-114.6734, 35.6355],
    [-114.6654, 35.6216],
    [-114.6595, 35.6196],
    [-114.6543, 35.5976],
    [-114.6642, 35.5859],
    [-114.6750, 35.5807],
    [-114.6749, 35.5784],
    [-114.6684, 35.5743],
    [-114.6630, 35.5637],
    [-114.6574, 35.5364],
    [-114.6631, 35.5245],
    [-114.6789, 35.5017],
    [-114.6776, 35.4897],
    [-114.6645, 35.4495],
    [-114.6271, 35.4095],
    [-114.5959, 35.3252],
    [-114.5831, 35.2381],
    [-114.5748, 35.2059],
    [-114.5719, 35.1995],
    [-114.5696, 35.1631],
    [-114.5727, 35.1387],
    [-114.5877, 35.1237],
    [-114.6040, 35.1212],
    [-114.6237, 35.1204],
    [-114.6444, 35.1059],
    [-114.6428, 35.0965],
    [-114.6131, 35.0831],
    [-114.6029, 35.0686],
    [-114.6173, 35.0516],
    [-114.6305, 35.0402],
    [-114.6380, 35.0206],
    [-114.6335, 35.0019],
    [-114.6755, 35.0357],
    [-114.8050, 35.1403],
    [-114.9254, 35.2370],
    [-115.0438, 35.3320],
    [-115.1258, 35.3969],
    [-115.1601, 35.4241],
    [-115.2713, 35.5127],
    [-115.3912, 35.6070],
    [-115.4045, 35.6176],
    [-115.5008, 35.6934],
    [-115.6258, 35.7920],
    [-115.6477, 35.8094],
    [-115.6893, 35.8420],
    [-115.7583, 35.8951],
    [-115.8930, 36.0000],
    [-115.9625, 36.0539],
    [-116.0936, 36.1558],
    [-116.1897, 36.2298],
    [-116.3803, 36.3750],
    [-116.5420, 36.5000],
    [-116.9280, 36.7925],
    [-117.0667, 36.8964],
    [-117.2449, 37.0302],
    [-117.3759, 37.1268],
    [-117.5009, 37.2203],
    [-117.6806, 37.3534],
    [-117.8661, 37.4899],
    [-117.9754, 37.5690],
    [-118.0398, 37.6152],
    [-118.0724, 37.6396],
    [-118.4278, 37.8962],
    [-118.6216, 38.0344],
    [-118.7719, 38.1419],
    [-118.8591, 38.2048],
    [-118.9497, 38.2690],
    [-119.0824, 38.3613],
    [-119.1570, 38.4147],
    [-119.2793, 38.4999],
    [-119.3334, 38.5383],
    [-119.4506, 38.6200],
    [-119.4940, 38.6497],
    [-119.5409, 38.6823],
    [-119.5477, 38.6870],
    [-119.5516, 38.6897],
    [-119.5871, 38.7143],
    [-119.6259, 38.7411],
    [-119.6350, 38.7474],
    [-119.6771, 38.7765],
    [-119.6825, 38.7802],
    [-119.7540, 38.8296],
    [-119.9006, 38.9308],
    [-119.9146, 38.9404],
    [-119.9421, 38.9592],
    [-119.9514, 38.9656],
    [-120.0025, 39.0675],
    [-120.0056, 39.2180],
    [-120.0057, 39.2226],
    [-120.0057, 39.2287]
    ]
  },
  "Illinois": {
    coordinates: [
      [-91.5130, 40.1811],
    [-91.5055, 40.1956],
    [-91.5067, 40.2048],
    [-91.5043, 40.2243],
    [-91.5065, 40.2363],
    [-91.5009, 40.2457],
    [-91.4962, 40.2505],
    [-91.4905, 40.2648],
    [-91.4927, 40.2782],
    [-91.4899, 40.2860],
    [-91.4718, 40.3173],
    [-91.4666, 40.3345],
    [-91.4522, 40.3537],
    [-91.4448, 40.3632],
    [-91.4294, 40.3704],
    [-91.4194, 40.3783],
    [-91.3970, 40.3831],
    [-91.3884, 40.3849],
    [-91.3768, 40.3910],
    [-91.3729, 40.3991],
    [-91.3725, 40.4073],
    [-91.3776, 40.4263],
    [-91.3810, 40.4354],
    [-91.3815, 40.4460],
    [-91.3740, 40.4640],
    [-91.3675, 40.4762],
    [-91.3637, 40.4931],
    [-91.3669, 40.5077],
    [-91.3691, 40.5125],
    [-91.3845, 40.5309],
    [-91.4007, 40.5368],
    [-91.4069, 40.5476],
    [-91.4052, 40.5546],
    [-91.3821, 40.5729],
    [-91.3696, 40.5888],
    [-91.3548, 40.6059],
    [-91.3413, 40.6128],
    [-91.2972, 40.6281],
    [-91.2582, 40.6367],
    [-91.2479, 40.6384],
    [-91.1979, 40.6361],
    [-91.1854, 40.6381],
    [-91.1381, 40.6609],
    [-91.1208, 40.6728],
    [-91.1124, 40.6963],
    [-91.1111, 40.7083],
    [-91.1152, 40.7219],
    [-91.1104, 40.7455],
    [-91.1025, 40.7571],
    [-91.0936, 40.7743],
    [-91.0912, 40.7867],
    [-91.0947, 40.7978],
    [-91.0972, 40.8089],
    [-91.0935, 40.8198],
    [-91.0901, 40.8246],
    [-91.0672, 40.8420],
    [-91.0502, 40.8585],
    [-91.0391, 40.8736],
    [-91.0275, 40.8792],
    [-91.0139, 40.8956],
    [-91.0095, 40.9006],
    [-90.9855, 40.9121],
    [-90.9653, 40.9216],
    [-90.9538, 40.9507],
    [-90.9527, 40.9621],
    [-90.9581, 40.9798],
    [-90.9496, 40.9952],
    [-90.9453, 41.0193],
    [-90.9423, 41.0347],
    [-90.9446, 41.0523],
    [-90.9491, 41.0706],
    [-90.9481, 41.0852],
    [-90.9510, 41.1026],
    [-90.9659, 41.1196],
    [-90.9846, 41.1478],
    [-90.9950, 41.1606],
    [-91.0096, 41.1661],
    [-91.0272, 41.1634],
    [-91.0551, 41.1858],
    [-91.0659, 41.1995],
    [-91.0930, 41.2226],
    [-91.1104, 41.2373],
    [-91.1139, 41.2457],
    [-91.1045, 41.2621],
    [-91.0869, 41.2944],
    [-91.0732, 41.3134],
    [-91.0716, 41.3397],
    [-91.0637, 41.3707],
    [-91.0510, 41.3876],
    [-91.0492, 41.4048],
    [-91.0451, 41.4149],
    [-91.0371, 41.4200],
    [-91.0212, 41.4242],
    [-91.0058, 41.4261],
    [-90.9752, 41.4340],
    [-90.9498, 41.4242],
    [-90.9194, 41.4256],
    [-90.8915, 41.4351],
    [-90.8798, 41.4411],
    [-90.8576, 41.4528],
    [-90.8374, 41.4556],
    [-90.7863, 41.4529],
    [-90.7717, 41.4508],
    [-90.7235, 41.4522],
    [-90.6910, 41.4566],
    [-90.6689, 41.4607],
    [-90.6502, 41.4650],
    [-90.6307, 41.4796],
    [-90.6059, 41.4942],
    [-90.6021, 41.5060],
    [-90.5910, 41.5128],
    [-90.5816, 41.5152],
    [-90.5672, 41.5175],
    [-90.5549, 41.5244],
    [-90.5372, 41.5256],
    [-90.5131, 41.5195],
    [-90.4999, 41.5180],
    [-90.4884, 41.5184],
    [-90.4452, 41.5361],
    [-90.4339, 41.5484],
    [-90.4252, 41.5526],
    [-90.4199, 41.5574],
    [-90.4128, 41.5653],
    [-90.3813, 41.5766],
    [-90.3641, 41.5796],
    [-90.3432, 41.5878],
    [-90.3399, 41.5972],
    [-90.3409, 41.6143],
    [-90.3401, 41.6556],
    [-90.3367, 41.6645],
    [-90.3345, 41.6796],
    [-90.3302, 41.6840],
    [-90.3147, 41.6948],
    [-90.3128, 41.7024],
    [-90.3174, 41.7183],
    [-90.3152, 41.7343],
    [-90.2804, 41.7661],
    [-90.2586, 41.7753],
    [-90.2424, 41.7830],
    [-90.2095, 41.7973],
    [-90.1820, 41.8071],
    [-90.1817, 41.8226],
    [-90.1833, 41.8378],
    [-90.1818, 41.8435],
    [-90.1791, 41.8480],
    [-90.1728, 41.8646],
    [-90.1724, 41.8675],
    [-90.1700, 41.8764],
    [-90.1651, 41.8838],
    [-90.1536, 41.9066],
    [-90.1518, 41.9289],
    [-90.1550, 41.9359],
    [-90.1638, 41.9449],
    [-90.1641, 41.9562],
    [-90.1538, 41.9741],
    [-90.1462, 41.9813],
    [-90.1401, 42.0033],
    [-90.1438, 42.0149],
    [-90.1491, 42.0227],
    [-90.1516, 42.0306],
    [-90.1634, 42.0404],
    [-90.1654, 42.0547],
    [-90.1684, 42.0758],
    [-90.1615, 42.0989],
    [-90.1619, 42.1138],
    [-90.1675, 42.1225],
    [-90.1905, 42.1258],
    [-90.2014, 42.1309],
    [-90.2074, 42.1491],
    [-90.2242, 42.1600],
    [-90.2555, 42.1718],
    [-90.2962, 42.1863],
    [-90.3178, 42.1938],
    [-90.3382, 42.2033],
    [-90.3651, 42.2105],
    [-90.3947, 42.2291],
    [-90.4007, 42.2393],
    [-90.4163, 42.2517],
    [-90.4222, 42.2599],
    [-90.4257, 42.2692],
    [-90.4306, 42.2844],
    [-90.4240, 42.2945],
    [-90.4210, 42.3161],
    [-90.4162, 42.3213],
    [-90.4184, 42.3276],
    [-90.4254, 42.3326],
    [-90.4439, 42.3552],
    [-90.4626, 42.3673],
    [-90.4703, 42.3784],
    [-90.4773, 42.3838],
    [-90.4872, 42.3851],
    [-90.5001, 42.3955],
    [-90.5175, 42.4030],
    [-90.5550, 42.4161],
    [-90.5588, 42.4285],
    [-90.5680, 42.4404],
    [-90.5853, 42.4456],
    [-90.6243, 42.4589],
    [-90.6467, 42.4719],
    [-90.6565, 42.4892],
    [-90.6486, 42.4981],
    [-90.6348, 42.5084],
    [-90.6177, 42.5081],
    [-90.6107, 42.5080],
    [-90.5899, 42.5078],
    [-90.5654, 42.5076],
    [-90.5448, 42.5077],
    [-90.5306, 42.5076],
    [-90.4794, 42.5074],
    [-90.4370, 42.5071],
    [-90.4017, 42.5069],
    [-90.3680, 42.5071],
    [-90.3091, 42.5074],
    [-90.2729, 42.5075],
    [-90.2531, 42.5073],
    [-90.2209, 42.5078],
    [-90.2028, 42.5078],
    [-90.1816, 42.5081],
    [-90.1040, 42.5079],
    [-90.0856, 42.5082],
    [-90.0187, 42.5073],
    [-89.9993, 42.5069],
    [-89.9851, 42.5065],
    [-89.9556, 42.5056],
    [-89.9270, 42.5058],
    [-89.9066, 42.5057],
    [-89.7997, 42.5054],
    [-89.7696, 42.5053],
    [-89.7424, 42.5054],
    [-89.6935, 42.5051],
    [-89.6676, 42.5050],
    [-89.6442, 42.5045],
    [-89.6014, 42.5036],
    [-89.5816, 42.5031],
    [-89.5644, 42.5026],
    [-89.4932, 42.5015],
    [-89.4836, 42.5014],
    [-89.4252, 42.5007],
    [-89.4210, 42.5006],
    [-89.4014, 42.5004],
    [-89.3658, 42.5003],
    [-89.2627, 42.4982],
    [-89.2479, 42.4981],
    [-89.2263, 42.4980],
    [-89.1649, 42.4973],
    [-89.1251, 42.4970],
    [-89.1202, 42.4970],
    [-89.0989, 42.4965],
    [-89.0708, 42.4962],
    [-89.0564, 42.4962],
    [-89.0429, 42.4963],
    [-89.0366, 42.4962],
    [-89.0138, 42.4961],
    [-89.0117, 42.4961],
    [-89.0013, 42.4961],
    [-88.9926, 42.4960],
    [-88.9856, 42.4959],
    [-88.9519, 42.4953],
    [-88.8946, 42.4941],
    [-88.7765, 42.4920],
    [-88.7365, 42.4928],
    [-88.7074, 42.4936],
    [-88.6387, 42.4950],
    [-88.5598, 42.4949],
    [-88.5069, 42.4949],
    [-88.4469, 42.4946],
    [-88.4184, 42.4946],
    [-88.3550, 42.4947],
    [-88.3348, 42.4947],
    [-88.3176, 42.4948],
    [-88.3121, 42.4948],
    [-88.3026, 42.4948],
    [-88.2774, 42.4948],
    [-88.2710, 42.4948],
    [-88.2501, 42.4958],
    [-88.2237, 42.4959],
    [-88.2141, 42.4959],
    [-88.2002, 42.4960],
    [-88.1985, 42.4960],
    [-88.1501, 42.4961],
    [-88.1181, 42.4962],
    [-88.1096, 42.4961],
    [-88.1015, 42.4960],
    [-88.0777, 42.4957],
    [-88.0498, 42.4953],
    [-87.9716, 42.4948],
    [-87.9175, 42.4941],
    [-87.8868, 42.4937],
    [-87.8706, 42.4935],
    [-87.8529, 42.4933],
    [-87.8446, 42.4931],
    [-87.8166, 42.4928],
    [-87.8021, 42.4926],
    [-87.7981, 42.4717],
    [-87.8000, 42.4530],
    [-87.8019, 42.4421],
    [-87.8028, 42.4398],
    [-87.8046, 42.4312],
    [-87.8034, 42.3986],
    [-87.8055, 42.3846],
    [-87.8100, 42.3774],
    [-87.8156, 42.3667],
    [-87.8207, 42.3615],
    [-87.8222, 42.3645],
    [-87.8239, 42.3619],
    [-87.8240, 42.3598],
    [-87.8240, 42.3569],
    [-87.8267, 42.3437],
    [-87.8308, 42.3313],
    [-87.8318, 42.3239],
    [-87.8318, 42.3100],
    [-87.8328, 42.3079],
    [-87.8348, 42.3015],
    [-87.8335, 42.2949],
    [-87.8280, 42.2687],
    [-87.8196, 42.2518],
    [-87.8120, 42.2305],
    [-87.8083, 42.2242],
    [-87.8050, 42.2177],
    [-87.8018, 42.2106],
    [-87.7968, 42.2037],
    [-87.7873, 42.1899],
    [-87.7770, 42.1761],
    [-87.7682, 42.1662],
    [-87.7592, 42.1524],
    [-87.7496, 42.1391],
    [-87.7411, 42.1275],
    [-87.7306, 42.1147],
    [-87.7172, 42.1009],
    [-87.7110, 42.0953],
    [-87.7027, 42.0898],
    [-87.6997, 42.0878],
    [-87.6815, 42.0784],
    [-87.6735, 42.0615],
    [-87.6709, 42.0523],
    [-87.6732, 42.0480],
    [-87.6711, 42.0427],
    [-87.6690, 42.0291],
    [-87.6643, 42.0193],
    [-87.6613, 42.0129],
    [-87.6577, 42.0070],
    [-87.6563, 42.0020],
    [-87.6553, 41.9964],
    [-87.6547, 41.9928],
    [-87.6542, 41.9902],
    [-87.6540, 41.9890],
    [-87.6527, 41.9858],
    [-87.6503, 41.9796],
    [-87.6490, 41.9770],
    [-87.6440, 41.9701],
    [-87.6324, 41.9653],
    [-87.6360, 41.9614],
    [-87.6408, 41.9549],
    [-87.6374, 41.9487],
    [-87.6333, 41.9424],
    [-87.6319, 41.9369],
    [-87.6294, 41.9265],
    [-87.6271, 41.9171],
    [-87.6240, 41.9113],
    [-87.6255, 41.9105],
    [-87.6247, 41.9068],
    [-87.6241, 41.9046],
    [-87.6234, 41.9030],
    [-87.6226, 41.9020],
    [-87.6189, 41.9001],
    [-87.6143, 41.8936],
    [-87.6120, 41.8937],
    [-87.6024, 41.8963],
    [-87.6095, 41.8896],
    [-87.6132, 41.8906],
    [-87.6138, 41.8883],
    [-87.6128, 41.8879],
    [-87.6165, 41.8824],
    [-87.6163, 41.8719],
    [-87.6139, 41.8685],
    [-87.6105, 41.8519],
    [-87.6094, 41.8452],
    [-87.6027, 41.8313],
    [-87.5994, 41.8255],
    [-87.5870, 41.8102],
    [-87.5820, 41.8040],
    [-87.5808, 41.8006],
    [-87.5769, 41.7969],
    [-87.5763, 41.7950],
    [-87.5773, 41.7883],
    [-87.5742, 41.7827],
    [-87.5725, 41.7804],
    [-87.5663, 41.7738],
    [-87.5604, 41.7685],
    [-87.5605, 41.7655],
    [-87.5594, 41.7647],
    [-87.5562, 41.7622],
    [-87.5542, 41.7606],
    [-87.5439, 41.7600],
    [-87.5444, 41.7547],
    [-87.5293, 41.7329],
    [-87.5252, 41.7176],
    [-87.5282, 41.7109],
    [-87.5245, 41.7009],
    [-87.5248, 41.6754],
    [-87.5250, 41.6502],
    [-87.5250, 41.6393],
    [-87.5251, 41.6302],
    [-87.5251, 41.6226],
    [-87.5252, 41.6138],
    [-87.5252, 41.6077],
    [-87.5253, 41.5956],
    [-87.5254, 41.5874],
    [-87.5254, 41.5815],
    [-87.5254, 41.5771],
    [-87.5254, 41.5703],
    [-87.5253, 41.5575],
    [-87.5254, 41.5490],
    [-87.5254, 41.5475],
    [-87.5256, 41.5174],
    [-87.5256, 41.4946],
    [-87.5256, 41.4789],
    [-87.5257, 41.4703],
    [-87.5258, 41.4537],
    [-87.5259, 41.4356],
    [-87.5259, 41.4262],
    [-87.5262, 41.3853],
    [-87.5267, 41.2982],
    [-87.5266, 41.2091],
    [-87.5266, 41.1661],
    [-87.5266, 41.1215],
    [-87.5265, 41.0668],
    [-87.5263, 41.0103],
    [-87.5263, 40.9998],
    [-87.5261, 40.9119],
    [-87.5260, 40.8944],
    [-87.5258, 40.8536],
    [-87.5258, 40.8173],
    [-87.5259, 40.7777],
    [-87.5260, 40.7363],
    [-87.5262, 40.6498],
    [-87.5262, 40.5782],
    [-87.5264, 40.5202],
    [-87.5266, 40.4769],
    [-87.5279, 40.3890],
    [-87.5288, 40.3306],
    [-87.5295, 40.2866],
    [-87.5302, 40.2360],
    [-87.5307, 40.1994],
    [-87.5308, 40.1904],
    [-87.5315, 40.1483],
    [-87.5315, 40.1428],
    [-87.5317, 40.1176],
    [-87.5319, 40.0889],
    [-87.5323, 40.0266],
    [-87.5324, 39.9916],
    [-87.5327, 39.9561],
    [-87.5327, 39.9450],
    [-87.5332, 39.8830],
    [-87.5331, 39.8326],
    [-87.5331, 39.7963],
    [-87.5329, 39.7134],
    [-87.5328, 39.6945],
    [-87.5327, 39.6649],
    [-87.5321, 39.5930],
    [-87.5320, 39.5454],
    [-87.5319, 39.5204],
    [-87.5317, 39.4771],
    [-87.5314, 39.4106],
    [-87.5317, 39.3597],
    [-87.5324, 39.3479],
    [-87.5440, 39.3529],
    [-87.5497, 39.3466],
    [-87.5607, 39.3389],
    [-87.5877, 39.3350],
    [-87.5967, 39.3220],
    [-87.6126, 39.3086],
    [-87.6190, 39.3017],
    [-87.5984, 39.3001],
    [-87.6088, 39.2867],
    [-87.6073, 39.2762],
    [-87.6056, 39.2624],
    [-87.6041, 39.2595],
    [-87.5911, 39.2473],
    [-87.5807, 39.2552],
    [-87.5731, 39.2467],
    [-87.5776, 39.2392],
    [-87.5850, 39.2053],
    [-87.6001, 39.1934],
    [-87.6110, 39.1841],
    [-87.6204, 39.1850],
    [-87.6194, 39.1721],
    [-87.6250, 39.1693],
    [-87.6421, 39.1625],
    [-87.6304, 39.1583],
    [-87.6287, 39.1539],
    [-87.6374, 39.1568],
    [-87.6517, 39.1506],
    [-87.6582, 39.1384],
    [-87.6515, 39.1308],
    [-87.6421, 39.1250],
    [-87.6380, 39.1234],
    [-87.6359, 39.1183],
    [-87.6542, 39.1134],
    [-87.6528, 39.1068],
    [-87.6386, 39.1059],
    [-87.6149, 39.1027],
    [-87.6204, 39.0915],
    [-87.6160, 39.0826],
    [-87.5956, 39.0790],
    [-87.5835, 39.0679],
    [-87.5726, 39.0501],
    [-87.5750, 39.0341],
    [-87.5738, 39.0087],
    [-87.5754, 38.9965],
    [-87.5604, 38.9924],
    [-87.5734, 38.9914],
    [-87.5765, 38.9867],
    [-87.5424, 38.9756],
    [-87.5250, 38.9638],
    [-87.5133, 38.9560],
    [-87.5163, 38.9456],
    [-87.5213, 38.9418],
    [-87.5166, 38.9330],
    [-87.5188, 38.9232],
    [-87.5277, 38.9184],
    [-87.5273, 38.9072],
    [-87.5167, 38.9041],
    [-87.5313, 38.9018],
    [-87.5364, 38.8946],
    [-87.5352, 38.8879],
    [-87.5376, 38.8896],
    [-87.5386, 38.8955],
    [-87.5441, 38.8951],
    [-87.5443, 38.8890],
    [-87.5349, 38.8789],
    [-87.5474, 38.8756],
    [-87.5432, 38.8642],
    [-87.5534, 38.8624],
    [-87.5321, 38.8525],
    [-87.5267, 38.8386],
    [-87.5217, 38.8266],
    [-87.5273, 38.8181],
    [-87.5031, 38.7929],
    [-87.4974, 38.7774],
    [-87.5145, 38.7718],
    [-87.5082, 38.7673],
    [-87.4979, 38.7675],
    [-87.4989, 38.7578],
    [-87.4961, 38.7421],
    [-87.5053, 38.7350],
    [-87.5167, 38.7163],
    [-87.5211, 38.6952],
    [-87.5312, 38.6840],
    [-87.5401, 38.6791],
    [-87.5794, 38.6725],
    [-87.6002, 38.6625],
    [-87.6058, 38.6465],
    [-87.6173, 38.6422],
    [-87.6189, 38.6314],
    [-87.6218, 38.6196],
    [-87.6205, 38.6122],
    [-87.6273, 38.6053],
    [-87.6135, 38.5950],
    [-87.6120, 38.5892],
    [-87.6282, 38.5881],
    [-87.6378, 38.5925],
    [-87.6398, 38.5820],
    [-87.6429, 38.5723],
    [-87.6515, 38.5682],
    [-87.6507, 38.5562],
    [-87.6654, 38.5499],
    [-87.6692, 38.5417],
    [-87.6553, 38.5208],
    [-87.6453, 38.5102],
    [-87.6637, 38.5029],
    [-87.6784, 38.4984],
    [-87.7346, 38.4801],
    [-87.7538, 38.4658],
    [-87.7559, 38.4559],
    [-87.7320, 38.4508],
    [-87.7398, 38.4380],
    [-87.7437, 38.4144],
    [-87.7498, 38.4037],
    [-87.7594, 38.3927],
    [-87.7831, 38.3689],
    [-87.8067, 38.3624],
    [-87.8234, 38.3460],
    [-87.8334, 38.3166],
    [-87.8339, 38.2906],
    [-87.8511, 38.2751],
    [-87.8662, 38.2900],
    [-87.8611, 38.3078],
    [-87.8757, 38.3099],
    [-87.8878, 38.2853],
    [-87.9068, 38.2696],
    [-87.9195, 38.2745],
    [-87.9095, 38.2961],
    [-87.9336, 38.2959],
    [-87.9423, 38.2794],
    [-87.9507, 38.2668],
    [-87.9430, 38.2578],
    [-87.9576, 38.2500],
    [-87.9602, 38.2371],
    [-87.9706, 38.2406],
    [-87.9819, 38.2564],
    [-87.9877, 38.2569],
    [-87.9824, 38.2487],
    [-87.9837, 38.2304],
    [-87.9852, 38.2155],
    [-87.9699, 38.1918],
    [-87.9364, 38.1714],
    [-87.9343, 38.1565],
    [-87.9245, 38.1620],
    [-87.9229, 38.1733],
    [-87.9157, 38.1733],
    [-87.9114, 38.1617],
    [-87.9237, 38.1531],
    [-87.9269, 38.1492],
    [-87.9294, 38.1407],
    [-87.9404, 38.1337],
    [-87.9507, 38.1302],
    [-87.9658, 38.1326],
    [-87.9743, 38.1220],
    [-87.9831, 38.1071],
    [-88.0167, 38.0973],
    [-88.0047, 38.0840],
    [-87.9605, 38.0991],
    [-87.9575, 38.0889],
    [-87.9672, 38.0671],
    [-88.0206, 38.0518],
    [-88.0421, 38.0463],
    [-88.0402, 38.0356],
    [-88.0176, 38.0347],
    [-88.0076, 38.0291],
    [-88.0209, 38.0190],
    [-88.0252, 38.0106],
    [-88.0126, 37.9771],
    [-88.0209, 37.9594],
    [-88.0361, 37.9427],
    [-88.0413, 37.9243],
    [-88.0548, 37.9335],
    [-88.0696, 37.9268],
    [-88.0519, 37.9159],
    [-88.0225, 37.9148],
    [-88.0178, 37.9027],
    [-88.0152, 37.8908],
    [-88.0291, 37.8926],
    [-88.0554, 37.8912],
    [-88.0862, 37.9057],
    [-88.0979, 37.9015],
    [-88.0918, 37.8907],
    [-88.0685, 37.8580],
    [-88.0482, 37.8448],
    [-88.0259, 37.8327],
    [-88.0438, 37.8215],
    [-88.0764, 37.8302],
    [-88.0901, 37.8256],
    [-88.0772, 37.8054],
    [-88.0597, 37.8012],
    [-88.0330, 37.8087],
    [-88.0280, 37.7992],
    [-88.0388, 37.7843],
    [-88.0426, 37.7671],
    [-88.0596, 37.7426],
    [-88.0819, 37.7304],
    [-88.1018, 37.7180],
    [-88.1224, 37.7097],
    [-88.1323, 37.6971],
    [-88.1376, 37.6889],
    [-88.1582, 37.6645],
    [-88.1601, 37.6543],
    [-88.1568, 37.6328],
    [-88.1408, 37.5992],
    [-88.1400, 37.5865],
    [-88.1316, 37.5730],
    [-88.1059, 37.5564],
    [-88.0928, 37.5396],
    [-88.0780, 37.5320],
    [-88.0633, 37.5158],
    [-88.0613, 37.5053],
    [-88.0641, 37.4920],
    [-88.0678, 37.4859],
    [-88.0735, 37.4853],
    [-88.0766, 37.4798],
    [-88.0852, 37.4715],
    [-88.0926, 37.4737],
    [-88.1280, 37.4705],
    [-88.1523, 37.4679],
    [-88.1718, 37.4656],
    [-88.2069, 37.4602],
    [-88.2378, 37.4568],
    [-88.2978, 37.4468],
    [-88.3175, 37.4362],
    [-88.3306, 37.4293],
    [-88.3422, 37.4175],
    [-88.3585, 37.4048],
    [-88.3655, 37.4017],
    [-88.3775, 37.4098],
    [-88.3973, 37.4216],
    [-88.4131, 37.4245],
    [-88.4260, 37.4194],
    [-88.4501, 37.4117],
    [-88.4702, 37.3963],
    [-88.4801, 37.3706],
    [-88.4823, 37.3611],
    [-88.4829, 37.3534],
    [-88.4903, 37.3350],
    [-88.5051, 37.3079],
    [-88.5147, 37.2909],
    [-88.5069, 37.2667],
    [-88.5008, 37.2536],
    [-88.4850, 37.2408],
    [-88.4718, 37.2202],
    [-88.4507, 37.2070],
    [-88.4395, 37.1817],
    [-88.4338, 37.1641],
    [-88.4281, 37.1578],
    [-88.4248, 37.1499],
    [-88.4435, 37.1092],
    [-88.4446, 37.0986],
    [-88.4761, 37.0682],
    [-88.4903, 37.0678],
    [-88.5214, 37.0656],
    [-88.5600, 37.0760],
    [-88.5732, 37.0800],
    [-88.5813, 37.0933],
    [-88.5939, 37.1018],
    [-88.6056, 37.1095],
    [-88.6259, 37.1195],
    [-88.6306, 37.1210],
    [-88.6449, 37.1228],
    [-88.6878, 37.1394],
    [-88.7137, 37.1414],
    [-88.7234, 37.1412],
    [-88.7338, 37.1447],
    [-88.7402, 37.1479],
    [-88.7461, 37.1516],
    [-88.7654, 37.1627],
    [-88.7837, 37.1759],
    [-88.7974, 37.1849],
    [-88.8216, 37.1924],
    [-88.8401, 37.1984],
    [-88.9028, 37.2193],
    [-88.9280, 37.2266],
    [-88.9334, 37.2252],
    [-88.9724, 37.2283],
    [-88.9923, 37.2265],
    [-89.0059, 37.2212],
    [-89.0376, 37.2039],
    [-89.0580, 37.1888],
    [-89.0852, 37.1668],
    [-89.0929, 37.1564],
    [-89.0973, 37.1447],
    [-89.1156, 37.1158],
    [-89.1220, 37.1113],
    [-89.1358, 37.1022],
    [-89.1466, 37.0907],
    [-89.1543, 37.0890],
    [-89.1681, 37.0742],
    [-89.1794, 37.0530],
    [-89.1808, 37.0268],
    [-89.1790, 37.0209],
    [-89.1705, 37.0075],
    [-89.1607, 37.0001],
    [-89.1327, 36.9822],
    [-89.1499, 36.9776],
    [-89.1772, 36.9709],
    [-89.1950, 36.9898],
    [-89.1985, 37.0117],
    [-89.2167, 37.0263],
    [-89.2383, 37.0429],
    [-89.2553, 37.0714],
    [-89.2804, 37.0652],
    [-89.2940, 37.0673],
    [-89.3108, 37.0579],
    [-89.3048, 37.0476],
    [-89.2777, 37.0361],
    [-89.2576, 37.0155],
    [-89.2696, 36.9934],
    [-89.2921, 36.9922],
    [-89.3230, 37.0161],
    [-89.3624, 37.0302],
    [-89.3839, 37.0464],
    [-89.3852, 37.0577],
    [-89.3766, 37.0777],
    [-89.3787, 37.0946],
    [-89.3903, 37.1090],
    [-89.4117, 37.1225],
    [-89.4256, 37.1382],
    [-89.4383, 37.1614],
    [-89.4553, 37.1869],
    [-89.4619, 37.1995],
    [-89.4675, 37.2218],
    [-89.4583, 37.2404],
    [-89.4582, 37.2471],
    [-89.4607, 37.2506],
    [-89.4792, 37.2531],
    [-89.4964, 37.2585],
    [-89.5139, 37.2772],
    [-89.5184, 37.2894],
    [-89.5157, 37.2954],
    [-89.5140, 37.3038],
    [-89.5106, 37.3129],
    [-89.4991, 37.3215],
    [-89.4893, 37.3331],
    [-89.4859, 37.3348],
    [-89.4547, 37.3393],
    [-89.4328, 37.3471],
    [-89.4282, 37.3562],
    [-89.4213, 37.3921],
    [-89.4259, 37.4075],
    [-89.4435, 37.4421],
    [-89.4546, 37.4530],
    [-89.4821, 37.4804],
    [-89.5002, 37.5130],
    [-89.5124, 37.5298],
    [-89.5211, 37.5538],
    [-89.5215, 37.5722],
    [-89.5198, 37.5827],
    [-89.5095, 37.5841],
    [-89.4811, 37.5830],
    [-89.4759, 37.5930],
    [-89.4858, 37.6072],
    [-89.5066, 37.6251],
    [-89.5177, 37.6412],
    [-89.5159, 37.6508],
    [-89.5139, 37.6766],
    [-89.5143, 37.6899],
    [-89.5219, 37.6965],
    [-89.5387, 37.7011],
    [-89.5833, 37.7133],
    [-89.5913, 37.7236],
    [-89.6024, 37.7365],
    [-89.6132, 37.7405],
    [-89.6159, 37.7482],
    [-89.6240, 37.7491],
    [-89.6454, 37.7461],
    [-89.6634, 37.7501],
    [-89.6680, 37.7595],
    [-89.6620, 37.7737],
    [-89.6604, 37.7863],
    [-89.6696, 37.7999],
    [-89.6829, 37.8078],
    [-89.7028, 37.8168],
    [-89.7294, 37.8351],
    [-89.7399, 37.8469],
    [-89.7541, 37.8464],
    [-89.7652, 37.8518],
    [-89.7820, 37.8551],
    [-89.7961, 37.8595],
    [-89.7977, 37.8742],
    [-89.8039, 37.8830],
    [-89.8372, 37.9023],
    [-89.8448, 37.9056],
    [-89.8670, 37.8935],
    [-89.8815, 37.8796],
    [-89.9133, 37.8696],
    [-89.9382, 37.8751],
    [-89.9525, 37.8832],
    [-89.9716, 37.9153],
    [-89.9749, 37.9267],
    [-89.9596, 37.9402],
    [-89.9325, 37.9475],
    [-89.9251, 37.9598],
    [-89.9359, 37.9596],
    [-89.9419, 37.9699],
    [-89.9789, 37.9628],
    [-89.9971, 37.9632],
    [-90.0172, 37.9794],
    [-90.0459, 38.0001],
    [-90.0529, 38.0059],
    [-90.0573, 38.0144],
    [-90.0650, 38.0169],
    [-90.0883, 38.0158],
    [-90.1105, 38.0265],
    [-90.1262, 38.0407],
    [-90.1264, 38.0549],
    [-90.1446, 38.0690],
    [-90.1634, 38.0743],
    [-90.2071, 38.0882],
    [-90.2501, 38.1251],
    [-90.2558, 38.1320],
    [-90.2908, 38.1705],
    [-90.3168, 38.1795],
    [-90.3343, 38.1899],
    [-90.3558, 38.2169],
    [-90.3639, 38.2364],
    [-90.3678, 38.2558],
    [-90.3709, 38.2674],
    [-90.3736, 38.2806],
    [-90.3739, 38.2895],
    [-90.3725, 38.3230],
    [-90.3682, 38.3403],
    [-90.3497, 38.3776],
    [-90.3435, 38.3850],
    [-90.3313, 38.3958],
    [-90.3223, 38.4018],
    [-90.2971, 38.4251],
    [-90.2875, 38.4402],
    [-90.2826, 38.4575],
    [-90.2777, 38.4757],
    [-90.2748, 38.4866],
    [-90.2688, 38.5062],
    [-90.2638, 38.5206],
    [-90.2503, 38.5428],
    [-90.2381, 38.5581],
    [-90.2231, 38.5758],
    [-90.2180, 38.5782],
    [-90.2055, 38.5868],
    [-90.2017, 38.5894],
    [-90.1866, 38.6079],
    [-90.1824, 38.6180],
    [-90.1780, 38.6338],
    [-90.1777, 38.6427],
    [-90.1811, 38.6595],
    [-90.1826, 38.6653],
    [-90.1868, 38.6753],
    [-90.1960, 38.6882],
    [-90.2023, 38.6935],
    [-90.2119, 38.7179],
    [-90.2099, 38.7261],
    [-90.1836, 38.7468],
    [-90.1754, 38.7590],
    [-90.1713, 38.7665],
    [-90.1467, 38.7830],
    [-90.1147, 38.8150],
    [-90.1094, 38.8435],
    [-90.1319, 38.8580],
    [-90.1515, 38.8671],
    [-90.1903, 38.8862],
    [-90.2092, 38.8970],
    [-90.2303, 38.9109],
    [-90.2540, 38.9205],
    [-90.2699, 38.9226],
    [-90.2837, 38.9240],
    [-90.3061, 38.9235],
    [-90.3236, 38.9297],
    [-90.3464, 38.9408],
    [-90.3831, 38.9555],
    [-90.4064, 38.9626],
    [-90.4337, 38.9655],
    [-90.4508, 38.9678],
    [-90.4721, 38.9588],
    [-90.4835, 38.9404],
    [-90.5001, 38.9104],
    [-90.5311, 38.8871],
    [-90.5557, 38.8708],
    [-90.5767, 38.8683],
    [-90.5954, 38.8751],
    [-90.6359, 38.9039],
    [-90.6532, 38.9161],
    [-90.6634, 38.9280],
    [-90.6692, 38.9482],
    [-90.6759, 38.9621],
    [-90.6764, 38.9841],
    [-90.6821, 38.9988],
    [-90.6877, 39.0054],
    [-90.6900, 39.0122],
    [-90.7079, 39.0423],
    [-90.7136, 39.0556],
    [-90.7013, 39.0699],
    [-90.7004, 39.0718],
    [-90.6811, 39.1006],
    [-90.6861, 39.1178],
    [-90.7005, 39.1354],
    [-90.7079, 39.1509],
    [-90.7105, 39.1764],
    [-90.7174, 39.1974],
    [-90.7166, 39.2104],
    [-90.7218, 39.2241],
    [-90.7216, 39.2327],
    [-90.7300, 39.2559],
    [-90.7489, 39.2641],
    [-90.7739, 39.2905],
    [-90.7907, 39.3029],
    [-90.7935, 39.3095],
    [-90.8213, 39.3237],
    [-90.8591, 39.3514],
    [-90.8938, 39.3673],
    [-90.9029, 39.3775],
    [-90.9127, 39.3816],
    [-90.9210, 39.3837],
    [-90.9340, 39.3921],
    [-90.9374, 39.4008],
    [-90.9483, 39.4075],
    [-90.9675, 39.4119],
    [-90.9830, 39.4205],
    [-91.0120, 39.4327],
    [-91.0275, 39.4413],
    [-91.0383, 39.4484],
    [-91.0503, 39.4596],
    [-91.0624, 39.4741],
    [-91.0753, 39.5028],
    [-91.0863, 39.5171],
    [-91.1003, 39.5387],
    [-91.1266, 39.5422],
    [-91.1536, 39.5482],
    [-91.1666, 39.5625],
    [-91.1716, 39.5819],
    [-91.1780, 39.5982],
    [-91.2166, 39.6151],
    [-91.2412, 39.6301],
    [-91.2488, 39.6409],
    [-91.2661, 39.6561],
    [-91.2833, 39.6701],
    [-91.3053, 39.6840],
    [-91.3307, 39.6999],
    [-91.3489, 39.7122],
    [-91.3678, 39.7290],
    [-91.3700, 39.7450],
    [-91.3651, 39.7587],
    [-91.3657, 39.7749],
    [-91.3617, 39.7851],
    [-91.3680, 39.8004],
    [-91.3780, 39.8113],
    [-91.4062, 39.8265],
    [-91.4329, 39.8406],
    [-91.4373, 39.8485],
    [-91.4464, 39.8704],
    [-91.4435, 39.8936],
    [-91.4209, 39.9149],
    [-91.4194, 39.9277],
    [-91.4241, 39.9357],
    [-91.4355, 39.9453],
    [-91.4472, 39.9595],
    [-91.4589, 39.9790],
    [-91.4653, 39.9840],
    [-91.4692, 39.9953],
    [-91.4874, 40.0232],
    [-91.4932, 40.0335],
    [-91.4910, 40.0608],
    [-91.4977, 40.0783],
    [-91.5060, 40.1081],
    [-91.5092, 40.1219],
    [-91.5113, 40.1411],
    [-91.5083, 40.1563],
    [-91.5131, 40.1785],
    [-91.5130, 40.1811]
    ]
  },
  "Vermont": {
    coordinates: [
      [-73.4377, 44.0450],
    [-73.4292, 44.0794],
    [-73.4131, 44.1079],
    [-73.4117, 44.1175],
    [-73.4158, 44.1328],
    [-73.4033, 44.1443],
    [-73.3996, 44.1553],
    [-73.3954, 44.1669],
    [-73.3969, 44.1738],
    [-73.3897, 44.1812],
    [-73.3906, 44.1909],
    [-73.3840, 44.1932],
    [-73.3753, 44.1999],
    [-73.3620, 44.2085],
    [-73.3553, 44.2196],
    [-73.3508, 44.2259],
    [-73.3423, 44.2345],
    [-73.3340, 44.2410],
    [-73.3247, 44.2436],
    [-73.3166, 44.2577],
    [-73.3129, 44.2653],
    [-73.3168, 44.2877],
    [-73.3245, 44.3192],
    [-73.3240, 44.3338],
    [-73.3273, 44.3444],
    [-73.3336, 44.3723],
    [-73.3170, 44.3860],
    [-73.3105, 44.4026],
    [-73.2938, 44.4382],
    [-73.3001, 44.4547],
    [-73.2993, 44.4736],
    [-73.3049, 44.4922],
    [-73.3193, 44.5120],
    [-73.3211, 44.5199],
    [-73.3239, 44.5271],
    [-73.3306, 44.5310],
    [-73.3390, 44.5433],
    [-73.3388, 44.5480],
    [-73.3552, 44.5569],
    [-73.3601, 44.5625],
    [-73.3673, 44.5675],
    [-73.3778, 44.5851],
    [-73.3779, 44.5938],
    [-73.3768, 44.5996],
    [-73.3898, 44.6172],
    [-73.3873, 44.6237],
    [-73.3864, 44.6329],
    [-73.3797, 44.6404],
    [-73.3845, 44.6467],
    [-73.3780, 44.6529],
    [-73.3791, 44.6568],
    [-73.3741, 44.6623],
    [-73.3697, 44.6635],
    [-73.3710, 44.6728],
    [-73.3719, 44.6760],
    [-73.3704, 44.6777],
    [-73.3697, 44.6838],
    [-73.3613, 44.6945],
    [-73.3660, 44.6976],
    [-73.3651, 44.7256],
    [-73.3577, 44.7510],
    [-73.3520, 44.7607],
    [-73.3443, 44.7763],
    [-73.3332, 44.7888],
    [-73.3354, 44.8046],
    [-73.3535, 44.8204],
    [-73.3657, 44.8265],
    [-73.3713, 44.8307],
    [-73.3795, 44.8380],
    [-73.3798, 44.8570],
    [-73.3691, 44.8667],
    [-73.3622, 44.8915],
    [-73.3562, 44.9045],
    [-73.3428, 44.9138],
    [-73.3390, 44.9177],
    [-73.3379, 44.9605],
    [-73.3447, 44.9705],
    [-73.3537, 44.9830],
    [-73.3534, 44.9902],
    [-73.3482, 44.9989],
    [-73.2411, 45.0128],
    [-73.0860, 45.0155],
    [-73.0597, 45.0159],
    [-73.0484, 45.0148],
    [-72.9933, 45.0146],
    [-72.9364, 45.0147],
    [-72.8326, 45.0165],
    [-72.6748, 45.0155],
    [-72.5864, 45.0128],
    [-72.5544, 45.0083],
    [-72.4489, 45.0085],
    [-72.4013, 45.0066],
    [-72.3292, 45.0047],
    [-72.2709, 45.0042],
    [-72.1419, 45.0060],
    [-72.0883, 45.0058],
    [-72.0297, 45.0068],
    [-71.9472, 45.0084],
    [-71.7675, 45.0114],
    [-71.6098, 45.0127],
    [-71.5188, 45.0131],
    [-71.4646, 45.0136],
    [-71.4762, 45.0091],
    [-71.4876, 45.0009],
    [-71.5011, 45.0067],
    [-71.5138, 45.0045],
    [-71.5250, 45.0019],
    [-71.5363, 44.9942],
    [-71.5327, 44.9911],
    [-71.5386, 44.9882],
    [-71.5411, 44.9849],
    [-71.5331, 44.9780],
    [-71.5231, 44.9663],
    [-71.5234, 44.9640],
    [-71.5177, 44.9644],
    [-71.5168, 44.9476],
    [-71.5161, 44.9408],
    [-71.5213, 44.9388],
    [-71.5163, 44.9352],
    [-71.5045, 44.9191],
    [-71.5005, 44.9120],
    [-71.4953, 44.9118],
    [-71.4933, 44.9112],
    [-71.4958, 44.9091],
    [-71.4948, 44.9059],
    [-71.4958, 44.9037],
    [-71.4995, 44.9048],
    [-71.5050, 44.9007],
    [-71.5143, 44.8940],
    [-71.5123, 44.8902],
    [-71.5283, 44.8778],
    [-71.5346, 44.8697],
    [-71.5495, 44.8626],
    [-71.5484, 44.8570],
    [-71.5556, 44.8505],
    [-71.5550, 44.8457],
    [-71.5522, 44.8378],
    [-71.5620, 44.8251],
    [-71.5648, 44.8239],
    [-71.5743, 44.8181],
    [-71.5729, 44.8104],
    [-71.5704, 44.8053],
    [-71.5732, 44.7919],
    [-71.5844, 44.7857],
    [-71.5967, 44.7774],
    [-71.6015, 44.7721],
    [-71.6082, 44.7657],
    [-71.6142, 44.7587],
    [-71.6313, 44.7533],
    [-71.6318, 44.7501],
    [-71.6252, 44.7440],
    [-71.6256, 44.7303],
    [-71.6226, 44.7278],
    [-71.6174, 44.7280],
    [-71.6131, 44.7189],
    [-71.5992, 44.7039],
    [-71.6002, 44.6989],
    [-71.5944, 44.6960],
    [-71.5964, 44.6871],
    [-71.5964, 44.6797],
    [-71.5874, 44.6749],
    [-71.5825, 44.6723],
    [-71.5856, 44.6676],
    [-71.5863, 44.6615],
    [-71.5848, 44.6578],
    [-71.5757, 44.6546],
    [-71.5751, 44.6506],
    [-71.5687, 44.6515],
    [-71.5644, 44.6528],
    [-71.5581, 44.6419],
    [-71.5626, 44.6395],
    [-71.5558, 44.6320],
    [-71.5472, 44.6304],
    [-71.5557, 44.6298],
    [-71.5525, 44.6265],
    [-71.5460, 44.6231],
    [-71.5540, 44.6251],
    [-71.5566, 44.6170],
    [-71.5542, 44.6044],
    [-71.5618, 44.6027],
    [-71.5569, 44.5997],
    [-71.5506, 44.5996],
    [-71.5549, 44.5938],
    [-71.5479, 44.5968],
    [-71.5449, 44.5953],
    [-71.5472, 44.5916],
    [-71.5396, 44.5943],
    [-71.5376, 44.5918],
    [-71.5378, 44.5877],
    [-71.5345, 44.5882],
    [-71.5372, 44.5831],
    [-71.5456, 44.5776],
    [-71.5525, 44.5808],
    [-71.5538, 44.5784],
    [-71.5487, 44.5719],
    [-71.5526, 44.5695],
    [-71.5580, 44.5705],
    [-71.5598, 44.5641],
    [-71.5755, 44.5648],
    [-71.5939, 44.5638],
    [-71.5981, 44.5554],
    [-71.5752, 44.5409],
    [-71.5745, 44.5337],
    [-71.5857, 44.5227],
    [-71.5943, 44.5217],
    [-71.5869, 44.5147],
    [-71.5832, 44.5083],
    [-71.5776, 44.5027],
    [-71.5839, 44.5032],
    [-71.5870, 44.4985],
    [-71.5903, 44.5001],
    [-71.5950, 44.4987],
    [-71.5979, 44.4884],
    [-71.6096, 44.4843],
    [-71.6198, 44.4830],
    [-71.6354, 44.4762],
    [-71.6250, 44.4818],
    [-71.6310, 44.4843],
    [-71.6431, 44.4766],
    [-71.6482, 44.4720],
    [-71.6408, 44.4659],
    [-71.6451, 44.4605],
    [-71.6573, 44.4540],
    [-71.6618, 44.4403],
    [-71.6774, 44.4357],
    [-71.6774, 44.4315],
    [-71.6781, 44.4266],
    [-71.6839, 44.4240],
    [-71.7080, 44.4120],
    [-71.7315, 44.4110],
    [-71.7385, 44.4082],
    [-71.7431, 44.4017],
    [-71.7543, 44.4056],
    [-71.7650, 44.4066],
    [-71.7728, 44.4031],
    [-71.7907, 44.4003],
    [-71.8035, 44.3919],
    [-71.8003, 44.3843],
    [-71.8131, 44.3828],
    [-71.8153, 44.3746],
    [-71.8128, 44.3704],
    [-71.8150, 44.3637],
    [-71.8129, 44.3555],
    [-71.8262, 44.3520],
    [-71.8443, 44.3442],
    [-71.8619, 44.3401],
    [-71.8759, 44.3374],
    [-71.9069, 44.3483],
    [-71.9291, 44.3376],
    [-71.9452, 44.3377],
    [-71.9811, 44.3375],
    [-71.9865, 44.3312],
    [-72.0100, 44.3220],
    [-72.0258, 44.3221],
    [-72.0338, 44.3173],
    [-72.0325, 44.3038],
    [-72.0370, 44.2978],
    [-72.0532, 44.2905],
    [-72.0589, 44.2862],
    [-72.0665, 44.2683],
    [-72.0587, 44.2700],
    [-72.0598, 44.2650],
    [-72.0598, 44.2560],
    [-72.0501, 44.2440],
    [-72.0507, 44.2336],
    [-72.0527, 44.2188],
    [-72.0586, 44.2082],
    [-72.0601, 44.2004],
    [-72.0662, 44.1898],
    [-72.0530, 44.1679],
    [-72.0476, 44.1618],
    [-72.0424, 44.1617],
    [-72.0435, 44.1569],
    [-72.0402, 44.1570],
    [-72.0396, 44.1554],
    [-72.0427, 44.1523],
    [-72.0420, 44.1372],
    [-72.0337, 44.1315],
    [-72.0407, 44.1257],
    [-72.0523, 44.1199],
    [-72.0548, 44.1101],
    [-72.0510, 44.0988],
    [-72.0440, 44.0970],
    [-72.0413, 44.1030],
    [-72.0320, 44.1017],
    [-72.0301, 44.0983],
    [-72.0337, 44.0896],
    [-72.0434, 44.0882],
    [-72.0411, 44.0852],
    [-72.0302, 44.0797],
    [-72.0315, 44.0781],
    [-72.0362, 44.0766],
    [-72.0412, 44.0791],
    [-72.0511, 44.0773],
    [-72.0506, 44.0744],
    [-72.0483, 44.0691],
    [-72.0572, 44.0586],
    [-72.0676, 44.0580],
    [-72.0684, 44.0540],
    [-72.0664, 44.0493],
    [-72.0790, 44.0429],
    [-72.0755, 44.0346],
    [-72.0793, 44.0301],
    [-72.0814, 44.0285],
    [-72.0824, 44.0222],
    [-72.0920, 44.0245],
    [-72.0957, 44.0197],
    [-72.0898, 44.0113],
    [-72.0933, 44.0094],
    [-72.0989, 44.0155],
    [-72.1049, 44.0094],
    [-72.1090, 44.0005],
    [-72.1128, 43.9880],
    [-72.1125, 43.9757],
    [-72.1147, 43.9683],
    [-72.1070, 43.9695],
    [-72.0911, 43.9664],
    [-72.0986, 43.9638],
    [-72.0990, 43.9589],
    [-72.0990, 43.9573],
    [-72.1109, 43.9477],
    [-72.1187, 43.9454],
    [-72.1168, 43.9339],
    [-72.1210, 43.9190],
    [-72.1450, 43.9053],
    [-72.1586, 43.8928],
    [-72.1672, 43.8861],
    [-72.1716, 43.8854],
    [-72.1719, 43.8761],
    [-72.1686, 43.8713],
    [-72.1794, 43.8662],
    [-72.1879, 43.8561],
    [-72.1822, 43.8340],
    [-72.1883, 43.8229],
    [-72.1842, 43.8125],
    [-72.1848, 43.8047],
    [-72.1956, 43.7915],
    [-72.2053, 43.7845],
    [-72.2050, 43.7711],
    [-72.2108, 43.7677],
    [-72.2201, 43.7636],
    [-72.2327, 43.7483],
    [-72.2642, 43.7342],
    [-72.2799, 43.7246],
    [-72.2869, 43.7173],
    [-72.2997, 43.7066],
    [-72.3053, 43.6958],
    [-72.3060, 43.6835],
    [-72.3031, 43.6781],
    [-72.3058, 43.6665],
    [-72.3129, 43.6584],
    [-72.3147, 43.6487],
    [-72.3152, 43.6412],
    [-72.3291, 43.6356],
    [-72.3297, 43.6346],
    [-72.3272, 43.6305],
    [-72.3344, 43.6193],
    [-72.3295, 43.6084],
    [-72.3277, 43.6027],
    [-72.3297, 43.6002],
    [-72.3499, 43.5877],
    [-72.3731, 43.5794],
    [-72.3828, 43.5625],
    [-72.3833, 43.5352],
    [-72.3942, 43.5274],
    [-72.3961, 43.5198],
    [-72.3984, 43.5108],
    [-72.3848, 43.5003],
    [-72.3804, 43.4885],
    [-72.3822, 43.4786],
    [-72.3847, 43.4740],
    [-72.3925, 43.4674],
    [-72.3912, 43.4493],
    [-72.3959, 43.4310],
    [-72.4000, 43.4152],
    [-72.4016, 43.4033],
    [-72.4111, 43.3858],
    [-72.4160, 43.3765],
    [-72.4134, 43.3627],
    [-72.3922, 43.3579],
    [-72.3909, 43.3550],
    [-72.4010, 43.3458],
    [-72.4090, 43.3344],
    [-72.4087, 43.3277],
    [-72.3958, 43.3146],
    [-72.4078, 43.2829],
    [-72.4277, 43.2612],
    [-72.4364, 43.2575],
    [-72.4367, 43.2383],
    [-72.4337, 43.2334],
    [-72.4351, 43.2294],
    [-72.4405, 43.2190],
    [-72.4377, 43.2027],
    [-72.4494, 43.1892],
    [-72.4449, 43.1780],
    [-72.4519, 43.1702],
    [-72.4516, 43.1552],
    [-72.4565, 43.1495],
    [-72.4520, 43.1389],
    [-72.4419, 43.1366],
    [-72.4406, 43.1322],
    [-72.4429, 43.1302],
    [-72.4380, 43.1251],
    [-72.4327, 43.1141],
    [-72.4406, 43.1061],
    [-72.4392, 43.0949],
    [-72.4353, 43.0835],
    [-72.4452, 43.0714],
    [-72.4615, 43.0590],
    [-72.4674, 43.0526],
    [-72.4622, 43.0442],
    [-72.4630, 43.0285],
    [-72.4596, 43.0205],
    [-72.4530, 43.0157],
    [-72.4438, 43.0062],
    [-72.4518, 43.0006],
    [-72.4629, 42.9969],
    [-72.4640, 42.9861],
    [-72.4660, 42.9785],
    [-72.4792, 42.9736],
    [-72.4926, 42.9676],
    [-72.5184, 42.9632],
    [-72.5341, 42.9521],
    [-72.5317, 42.9465],
    [-72.5274, 42.9431],
    [-72.5265, 42.9343],
    [-72.5244, 42.9156],
    [-72.5302, 42.9116],
    [-72.5328, 42.8961],
    [-72.5407, 42.8894],
    [-72.5528, 42.8850],
    [-72.5562, 42.8669],
    [-72.5551, 42.8657],
    [-72.5563, 42.8553],
    [-72.5563, 42.8514],
    [-72.5474, 42.8376],
    [-72.5457, 42.8258],
    [-72.5438, 42.8190],
    [-72.5396, 42.8048],
    [-72.5158, 42.7886],
    [-72.5089, 42.7799],
    [-72.5102, 42.7732],
    [-72.5161, 42.7659],
    [-72.5080, 42.7644],
    [-72.4988, 42.7720],
    [-72.4911, 42.7725],
    [-72.4849, 42.7655],
    [-72.4759, 42.7577],
    [-72.4678, 42.7412],
    [-72.4585, 42.7269],
    [-72.5700, 42.7299],
    [-72.6747, 42.7329],
    [-72.7911, 42.7361],
    [-72.8643, 42.7378],
    [-72.9303, 42.7392],
    [-73.0230, 42.7411],
    [-73.1425, 42.7435],
    [-73.2650, 42.7459],
    [-73.2893, 42.8041],
    [-73.2837, 42.8139],
    [-73.2843, 42.8350],
    [-73.2785, 42.8376],
    [-73.2745, 42.9404],
    [-73.2733, 42.9631],
    [-73.2698, 43.0359],
    [-73.2651, 43.1062],
    [-73.2608, 43.1894],
    [-73.2587, 43.2306],
    [-73.2545, 43.3147],
    [-73.2531, 43.3547],
    [-73.2526, 43.3710],
    [-73.2510, 43.4087],
    [-73.2488, 43.4618],
    [-73.2471, 43.5124],
    [-73.2467, 43.5189],
    [-73.2468, 43.5258],
    [-73.2414, 43.5323],
    [-73.2456, 43.5403],
    [-73.2501, 43.5434],
    [-73.2486, 43.5539],
    [-73.2641, 43.5689],
    [-73.2810, 43.5754],
    [-73.2899, 43.5788],
    [-73.2953, 43.5802],
    [-73.2924, 43.5851],
    [-73.2928, 43.5939],
    [-73.2922, 43.6026],
    [-73.3003, 43.6108],
    [-73.3026, 43.6257],
    [-73.3077, 43.6275],
    [-73.3176, 43.6274],
    [-73.3281, 43.6259],
    [-73.3586, 43.6251],
    [-73.3672, 43.6236],
    [-73.3725, 43.6228],
    [-73.3746, 43.6147],
    [-73.3725, 43.6048],
    [-73.3777, 43.5997],
    [-73.3807, 43.5982],
    [-73.3834, 43.5968],
    [-73.3824, 43.5916],
    [-73.3870, 43.5895],
    [-73.3829, 43.5871],
    [-73.3853, 43.5833],
    [-73.3834, 43.5768],
    [-73.3880, 43.5747],
    [-73.3919, 43.5727],
    [-73.3920, 43.5699],
    [-73.3981, 43.5681],
    [-73.4170, 43.5777],
    [-73.4267, 43.5830],
    [-73.4312, 43.5883],
    [-73.4216, 43.6030],
    [-73.4237, 43.6124],
    [-73.4183, 43.6233],
    [-73.4265, 43.6426],
    [-73.4188, 43.6479],
    [-73.4081, 43.6694],
    [-73.4041, 43.6813],
    [-73.4047, 43.6902],
    [-73.3955, 43.6968],
    [-73.3918, 43.7035],
    [-73.3778, 43.7177],
    [-73.3707, 43.7356],
    [-73.3630, 43.7532],
    [-73.3506, 43.7719],
    [-73.3575, 43.7859],
    [-73.3764, 43.7988],
    [-73.3793, 43.8084],
    [-73.3833, 43.8133],
    [-73.3928, 43.8222],
    [-73.3819, 43.8373],
    [-73.3736, 43.8429],
    [-73.3737, 43.8477],
    [-73.3820, 43.8550],
    [-73.3742, 43.8742],
    [-73.3835, 43.8910],
    [-73.4009, 43.9170],
    [-73.4086, 43.9329],
    [-73.4112, 43.9756],
    [-73.4112, 43.9862],
    [-73.4074, 44.0203],
    [-73.4144, 44.0295],
    [-73.4274, 44.0372],
    [-73.4369, 44.0426],
    [-73.4377, 44.0450]
    ]
  },
  "Montana": {
    coordinates: [
      [-116.0491, 48.5020],
    [-116.0491, 48.6115],
    [-116.0491, 49.0008],
    [-115.9645, 49.0009],
    [-115.4123, 49.0003],
    [-115.1923, 48.9993],
    [-114.7270, 49.0006],
    [-114.4759, 49.0012],
    [-114.2249, 48.9997],
    [-114.0682, 48.9989],
    [-113.8641, 48.9983],
    [-113.5761, 48.9985],
    [-113.2410, 48.9987],
    [-113.1102, 48.9985],
    [-113.0981, 48.9985],
    [-113.0879, 48.9986],
    [-113.0099, 48.9986],
    [-112.1934, 48.9989],
    [-112.0009, 48.9989],
    [-111.8541, 48.9981],
    [-111.7616, 48.9977],
    [-111.0039, 48.9975],
    [-110.8867, 48.9981],
    [-110.5925, 48.9990],
    [-110.4794, 48.9988],
    [-110.2155, 48.9992],
    [-109.8193, 48.9999],
    [-109.4540, 49.0011],
    [-109.3841, 49.0004],
    [-109.1598, 48.9998],
    [-109.0603, 48.9996],
    [-108.8081, 48.9993],
    [-108.4881, 48.9994],
    [-107.9174, 48.9997],
    [-107.8843, 48.9998],
    [-107.3636, 49.0000],
    [-106.8316, 48.9997],
    [-106.6175, 48.9996],
    [-106.5006, 48.9994],
    [-106.3746, 48.9996],
    [-106.2462, 48.9993],
    [-106.1121, 48.9993],
    [-105.8342, 48.9997],
    [-105.6126, 48.9997],
    [-105.5226, 48.9996],
    [-105.3914, 48.9995],
    [-105.2775, 48.9995],
    [-104.8755, 48.9990],
    [-104.4721, 48.9996],
    [-104.0487, 48.9999],
    [-104.0486, 48.9638],
    [-104.0487, 48.9518],
    [-104.0487, 48.9403],
    [-104.0487, 48.9069],
    [-104.0487, 48.8799],
    [-104.0489, 48.8740],
    [-104.0487, 48.8638],
    [-104.0486, 48.7971],
    [-104.0485, 48.7514],
    [-104.0480, 48.6772],
    [-104.0478, 48.6632],
    [-104.0479, 48.6499],
    [-104.0476, 48.6340],
    [-104.0479, 48.6210],
    [-104.0482, 48.5976],
    [-104.0478, 48.5628],
    [-104.0478, 48.5396],
    [-104.0479, 48.5308],
    [-104.0481, 48.5000],
    [-104.0473, 48.4600],
    [-104.0472, 48.4473],
    [-104.0471, 48.4111],
    [-104.0469, 48.3893],
    [-104.0468, 48.3808],
    [-104.0464, 48.3732],
    [-104.0463, 48.3211],
    [-104.0462, 48.2994],
    [-104.0460, 48.2568],
    [-104.0456, 48.2462],
    [-104.0456, 48.1981],
    [-104.0455, 48.1762],
    [-104.0452, 48.1373],
    [-104.0443, 48.0248],
    [-104.0439, 47.9715],
    [-104.0422, 47.8910],
    [-104.0417, 47.8583],
    [-104.0419, 47.8417],
    [-104.0425, 47.8067],
    [-104.0432, 47.7473],
    [-104.0437, 47.6250],
    [-104.0439, 47.5904],
    [-104.0448, 47.4384],
    [-104.0449, 47.3750],
    [-104.0453, 47.3301],
    [-104.0451, 47.2714],
    [-104.0452, 47.2639],
    [-104.0448, 47.1274],
    [-104.0454, 47.0786],
    [-104.0452, 47.0575],
    [-104.0451, 47.0376],
    [-104.0455, 46.9340],
    [-104.0456, 46.9186],
    [-104.0454, 46.7254],
    [-104.0456, 46.7139],
    [-104.0453, 46.6414],
    [-104.0450, 46.5098],
    [-104.0455, 46.3419],
    [-104.0453, 46.2059],
    [-104.0458, 46.1191],
    [-104.0440, 45.8820],
    [-104.0426, 45.7500],
    [-104.0417, 45.5483],
    [-104.0411, 45.5034],
    [-104.0414, 45.4805],
    [-104.0401, 45.3742],
    [-104.0401, 45.2129],
    [-104.0397, 45.0911],
    [-104.0397, 44.9981],
    [-104.1291, 44.9980],
    [-104.5068, 44.9985],
    [-104.7266, 44.9993],
    [-104.9865, 45.0001],
    [-105.0766, 45.0001],
    [-105.1692, 45.0001],
    [-105.6282, 45.0004],
    [-105.9131, 45.0002],
    [-106.0859, 44.9935],
    [-106.5667, 44.9948],
    [-106.9016, 44.9960],
    [-107.0000, 44.9963],
    [-107.0746, 44.9971],
    [-107.1054, 44.9985],
    [-107.2979, 45.0007],
    [-107.5683, 45.0010],
    [-107.7373, 45.0008],
    [-107.8801, 45.0007],
    [-107.9115, 45.0007],
    [-108.2279, 45.0004],
    [-108.2714, 45.0002],
    [-108.6213, 45.0003],
    [-108.8430, 45.0000],
    [-108.9616, 44.9995],
    [-109.0624, 44.9995],
    [-109.1032, 45.0058],
    [-109.3014, 45.0053],
    [-109.5981, 45.0029],
    [-109.7883, 45.0019],
    [-109.8553, 45.0033],
    [-109.9715, 45.0034],
    [-110.0262, 45.0035],
    [-110.2215, 44.9968],
    [-110.3252, 44.9997],
    [-110.4881, 44.9929],
    [-110.7527, 44.9971],
    [-111.0451, 45.0009],
    [-111.0545, 44.9394],
    [-111.0541, 44.7527],
    [-111.0526, 44.4997],
    [-111.0647, 44.4786],
    [-111.0773, 44.4833],
    [-111.0971, 44.4865],
    [-111.1072, 44.4869],
    [-111.1197, 44.4943],
    [-111.1307, 44.5001],
    [-111.1314, 44.5324],
    [-111.1551, 44.5424],
    [-111.1807, 44.5549],
    [-111.1937, 44.5731],
    [-111.2190, 44.5754],
    [-111.2275, 44.5772],
    [-111.2321, 44.5850],
    [-111.2323, 44.5975],
    [-111.2351, 44.6054],
    [-111.2272, 44.6183],
    [-111.2240, 44.6249],
    [-111.2430, 44.6434],
    [-111.2513, 44.6486],
    [-111.2532, 44.6512],
    [-111.2713, 44.6473],
    [-111.2805, 44.6548],
    [-111.2756, 44.6567],
    [-111.2668, 44.6675],
    [-111.2762, 44.6783],
    [-111.2905, 44.6860],
    [-111.2951, 44.6976],
    [-111.3003, 44.7039],
    [-111.3179, 44.7145],
    [-111.3237, 44.7246],
    [-111.3288, 44.7315],
    [-111.3416, 44.7294],
    [-111.3619, 44.7349],
    [-111.3751, 44.7485],
    [-111.3851, 44.7549],
    [-111.3974, 44.7468],
    [-111.3994, 44.7343],
    [-111.3984, 44.7259],
    [-111.4038, 44.7213],
    [-111.4143, 44.7107],
    [-111.4250, 44.7147],
    [-111.4427, 44.7202],
    [-111.4661, 44.7135],
    [-111.4795, 44.7068],
    [-111.4899, 44.7006],
    [-111.4838, 44.6945],
    [-111.4815, 44.6854],
    [-111.4761, 44.6813],
    [-111.4703, 44.6800],
    [-111.4705, 44.6770],
    [-111.4759, 44.6695],
    [-111.4733, 44.6650],
    [-111.4822, 44.6558],
    [-111.4880, 44.6511],
    [-111.4914, 44.6438],
    [-111.5002, 44.6488],
    [-111.5025, 44.6464],
    [-111.5081, 44.6455],
    [-111.5165, 44.6409],
    [-111.5076, 44.6325],
    [-111.5046, 44.6253],
    [-111.5159, 44.6204],
    [-111.5224, 44.6131],
    [-111.5249, 44.6041],
    [-111.5205, 44.6003],
    [-111.5226, 44.5902],
    [-111.5178, 44.5822],
    [-111.5009, 44.5713],
    [-111.5084, 44.5675],
    [-111.5048, 44.5620],
    [-111.4858, 44.5575],
    [-111.4758, 44.5546],
    [-111.4680, 44.5549],
    [-111.4669, 44.5470],
    [-111.4666, 44.5406],
    [-111.4797, 44.5421],
    [-111.4892, 44.5408],
    [-111.4996, 44.5420],
    [-111.5153, 44.5370],
    [-111.5364, 44.5506],
    [-111.5471, 44.5572],
    [-111.5628, 44.5552],
    [-111.5801, 44.5597],
    [-111.5926, 44.5609],
    [-111.6047, 44.5530],
    [-111.6146, 44.5488],
    [-111.6240, 44.5513],
    [-111.6459, 44.5547],
    [-111.6593, 44.5527],
    [-111.6667, 44.5561],
    [-111.6824, 44.5609],
    [-111.6912, 44.5566],
    [-111.7052, 44.5568],
    [-111.7156, 44.5434],
    [-111.7311, 44.5427],
    [-111.7464, 44.5408],
    [-111.7640, 44.5267],
    [-111.7776, 44.5251],
    [-111.7855, 44.5236],
    [-111.8011, 44.5260],
    [-111.8083, 44.5184],
    [-111.8092, 44.5131],
    [-111.8114, 44.5113],
    [-111.8309, 44.5168],
    [-111.8423, 44.5262],
    [-111.8518, 44.5428],
    [-111.8572, 44.5491],
    [-111.8676, 44.5596],
    [-111.8696, 44.5658],
    [-111.8795, 44.5604],
    [-111.8897, 44.5646],
    [-111.8949, 44.5600],
    [-111.9166, 44.5563],
    [-111.9350, 44.5580],
    [-111.9489, 44.5563],
    [-111.9598, 44.5495],
    [-111.9641, 44.5441],
    [-111.9716, 44.5376],
    [-111.9886, 44.5372],
    [-111.9964, 44.5356],
    [-112.0054, 44.5384],
    [-112.0132, 44.5426],
    [-112.0266, 44.5459],
    [-112.0341, 44.5377],
    [-112.0343, 44.5284],
    [-112.0388, 44.5328],
    [-112.0508, 44.5344],
    [-112.0696, 44.5369],
    [-112.0933, 44.5300],
    [-112.1068, 44.5208],
    [-112.1262, 44.5288],
    [-112.1352, 44.5371],
    [-112.1489, 44.5368],
    [-112.1776, 44.5352],
    [-112.1940, 44.5369],
    [-112.2289, 44.5532],
    [-112.2304, 44.5581],
    [-112.2292, 44.5636],
    [-112.2406, 44.5667],
    [-112.2508, 44.5677],
    [-112.2663, 44.5659],
    [-112.2887, 44.5679],
    [-112.2973, 44.5607],
    [-112.3076, 44.5577],
    [-112.3150, 44.5500],
    [-112.3307, 44.5384],
    [-112.3518, 44.5379],
    [-112.3567, 44.5246],
    [-112.3583, 44.5079],
    [-112.3583, 44.4960],
    [-112.3609, 44.4851],
    [-112.3667, 44.4671],
    [-112.3830, 44.4518],
    [-112.3908, 44.4507],
    [-112.4067, 44.4573],
    [-112.4229, 44.4547],
    [-112.4345, 44.4557],
    [-112.4409, 44.4648],
    [-112.4528, 44.4665],
    [-112.4604, 44.4751],
    [-112.4720, 44.4791],
    [-112.4799, 44.4750],
    [-112.4912, 44.4703],
    [-112.5002, 44.4630],
    [-112.5118, 44.4710],
    [-112.5347, 44.4783],
    [-112.5493, 44.4845],
    [-112.5772, 44.4804],
    [-112.6020, 44.4907],
    [-112.6285, 44.4828],
    [-112.6425, 44.4899],
    [-112.6720, 44.4914],
    [-112.6876, 44.4955],
    [-112.6980, 44.4999],
    [-112.7339, 44.4998],
    [-112.7489, 44.4901],
    [-112.7722, 44.4836],
    [-112.7855, 44.4791],
    [-112.7976, 44.4619],
    [-112.8077, 44.4531],
    [-112.8127, 44.4545],
    [-112.8259, 44.4440],
    [-112.8281, 44.4315],
    [-112.8394, 44.4251],
    [-112.8307, 44.4159],
    [-112.8199, 44.4002],
    [-112.8130, 44.3977],
    [-112.8119, 44.3879],
    [-112.8138, 44.3762],
    [-112.8419, 44.3608],
    [-112.8635, 44.3695],
    [-112.8767, 44.3775],
    [-112.8842, 44.3937],
    [-112.8847, 44.4021],
    [-112.8913, 44.4055],
    [-112.9126, 44.4021],
    [-112.9229, 44.4108],
    [-112.9396, 44.4125],
    [-112.9522, 44.4243],
    [-112.9794, 44.4336],
    [-113.0020, 44.4499],
    [-113.0088, 44.4659],
    [-113.0200, 44.4837],
    [-113.0170, 44.5040],
    [-113.0156, 44.5162],
    [-113.0132, 44.5282],
    [-113.0309, 44.5370],
    [-113.0478, 44.5483],
    [-113.0378, 44.5651],
    [-113.0672, 44.5791],
    [-113.0627, 44.5864],
    [-113.0798, 44.5965],
    [-113.0839, 44.6036],
    [-113.0704, 44.6163],
    [-113.0571, 44.6186],
    [-113.0515, 44.6369],
    [-113.0646, 44.6528],
    [-113.0697, 44.6690],
    [-113.0763, 44.6806],
    [-113.0799, 44.6872],
    [-113.0940, 44.6953],
    [-113.1013, 44.7062],
    [-113.1023, 44.7258],
    [-113.1160, 44.7323],
    [-113.1215, 44.7472],
    [-113.1343, 44.7523],
    [-113.1314, 44.7653],
    [-113.1406, 44.7767],
    [-113.1594, 44.7809],
    [-113.1795, 44.7872],
    [-113.1953, 44.8023],
    [-113.2217, 44.8106],
    [-113.2393, 44.8146],
    [-113.2476, 44.8229],
    [-113.2727, 44.8144],
    [-113.2994, 44.8026],
    [-113.3295, 44.7886],
    [-113.3464, 44.7885],
    [-113.3544, 44.7954],
    [-113.3561, 44.8198],
    [-113.3771, 44.8348],
    [-113.3943, 44.8369],
    [-113.4216, 44.8376],
    [-113.4260, 44.8484],
    [-113.4394, 44.8555],
    [-113.4551, 44.8654],
    [-113.4626, 44.8819],
    [-113.4729, 44.8924],
    [-113.4758, 44.8986],
    [-113.4767, 44.9118],
    [-113.4915, 44.9245],
    [-113.4950, 44.9314],
    [-113.4974, 44.9455],
    [-113.4877, 44.9469],
    [-113.4725, 44.9482],
    [-113.4523, 44.9522],
    [-113.4439, 44.9602],
    [-113.4452, 44.9726],
    [-113.4468, 44.9869],
    [-113.4462, 44.9993],
    [-113.4390, 45.0098],
    [-113.4462, 45.0335],
    [-113.4498, 45.0455],
    [-113.4506, 45.0537],
    [-113.4618, 45.0647],
    [-113.4853, 45.0635],
    [-113.4871, 45.0747],
    [-113.5071, 45.0834],
    [-113.5225, 45.0917],
    [-113.5069, 45.1069],
    [-113.5103, 45.1155],
    [-113.5296, 45.1164],
    [-113.5545, 45.1187],
    [-113.5766, 45.1315],
    [-113.5668, 45.1439],
    [-113.5708, 45.1480],
    [-113.5837, 45.1534],
    [-113.5909, 45.1618],
    [-113.5896, 45.1776],
    [-113.5972, 45.1865],
    [-113.6107, 45.1973],
    [-113.6370, 45.2129],
    [-113.6477, 45.2266],
    [-113.6719, 45.2488],
    [-113.6846, 45.2531],
    [-113.6910, 45.2722],
    [-113.6793, 45.2755],
    [-113.7006, 45.2925],
    [-113.7100, 45.3010],
    [-113.7185, 45.3134],
    [-113.7291, 45.3205],
    [-113.7381, 45.3284],
    [-113.7345, 45.3486],
    [-113.7334, 45.3631],
    [-113.7342, 45.3777],
    [-113.7344, 45.3924],
    [-113.7527, 45.4028],
    [-113.7760, 45.4085],
    [-113.7642, 45.4223],
    [-113.7650, 45.4311],
    [-113.7753, 45.4393],
    [-113.7836, 45.4557],
    [-113.7764, 45.4704],
    [-113.7649, 45.4766],
    [-113.7634, 45.4915],
    [-113.7710, 45.5078],
    [-113.7722, 45.5122],
    [-113.7666, 45.5209],
    [-113.7915, 45.5222],
    [-113.8091, 45.5199],
    [-113.8254, 45.5213],
    [-113.8331, 45.5242],
    [-113.8294, 45.5371],
    [-113.8179, 45.5567],
    [-113.8210, 45.5654],
    [-113.8110, 45.5746],
    [-113.7974, 45.5817],
    [-113.8045, 45.5942],
    [-113.8182, 45.6079],
    [-113.8290, 45.6126],
    [-113.8430, 45.6124],
    [-113.8551, 45.6222],
    [-113.8628, 45.6235],
    [-113.8742, 45.6201],
    [-113.8895, 45.6179],
    [-113.9037, 45.6216],
    [-113.9001, 45.6283],
    [-113.9022, 45.6377],
    [-113.8973, 45.6467],
    [-113.9084, 45.6531],
    [-113.9195, 45.6579],
    [-113.9291, 45.6704],
    [-113.9342, 45.6822],
    [-113.9382, 45.6954],
    [-113.9483, 45.6930],
    [-113.9619, 45.6897],
    [-113.9708, 45.6990],
    [-113.9813, 45.7027],
    [-113.9940, 45.7032],
    [-114.0013, 45.6964],
    [-114.0155, 45.6959],
    [-114.0148, 45.6835],
    [-114.0274, 45.6745],
    [-114.0153, 45.6634],
    [-114.0216, 45.6480],
    [-114.0432, 45.6405],
    [-114.0585, 45.6317],
    [-114.0718, 45.6177],
    [-114.0831, 45.6031],
    [-114.0907, 45.5911],
    [-114.1290, 45.5774],
    [-114.1290, 45.5654],
    [-114.1504, 45.5578],
    [-114.1655, 45.5523],
    [-114.1807, 45.5507],
    [-114.2037, 45.5356],
    [-114.2272, 45.5459],
    [-114.2516, 45.5375],
    [-114.2471, 45.5252],
    [-114.2607, 45.4967],
    [-114.2704, 45.4844],
    [-114.2863, 45.4794],
    [-114.3012, 45.4734],
    [-114.3187, 45.4661],
    [-114.3296, 45.4600],
    [-114.3400, 45.4597],
    [-114.3511, 45.4705],
    [-114.3603, 45.4782],
    [-114.3764, 45.4951],
    [-114.4180, 45.5097],
    [-114.4291, 45.5215],
    [-114.4370, 45.5308],
    [-114.4503, 45.5422],
    [-114.4639, 45.5454],
    [-114.4563, 45.5610],
    [-114.4719, 45.5652],
    [-114.4853, 45.5618],
    [-114.5035, 45.5592],
    [-114.5163, 45.5680],
    [-114.5330, 45.5658],
    [-114.5526, 45.5570],
    [-114.5655, 45.5626],
    [-114.5562, 45.5734],
    [-114.5583, 45.5843],
    [-114.5541, 45.5912],
    [-114.5432, 45.6015],
    [-114.5450, 45.6171],
    [-114.5635, 45.6323],
    [-114.5460, 45.6430],
    [-114.5413, 45.6486],
    [-114.5280, 45.6519],
    [-114.5127, 45.6560],
    [-114.5020, 45.6735],
    [-114.5009, 45.6823],
    [-114.5086, 45.6895],
    [-114.4968, 45.6993],
    [-114.5025, 45.7175],
    [-114.5152, 45.7274],
    [-114.5308, 45.7333],
    [-114.5475, 45.7443],
    [-114.5441, 45.7584],
    [-114.5665, 45.7733],
    [-114.5444, 45.7900],
    [-114.5376, 45.8028],
    [-114.5302, 45.8131],
    [-114.5144, 45.8271],
    [-114.5152, 45.8398],
    [-114.4990, 45.8507],
    [-114.4749, 45.8466],
    [-114.4650, 45.8521],
    [-114.4487, 45.8591],
    [-114.4215, 45.8552],
    [-114.4050, 45.8671],
    [-114.3966, 45.8710],
    [-114.3873, 45.8877],
    [-114.3937, 45.8930],
    [-114.3960, 45.9014],
    [-114.4162, 45.9187],
    [-114.4314, 45.9360],
    [-114.4249, 45.9436],
    [-114.4069, 45.9542],
    [-114.4061, 45.9700],
    [-114.4191, 45.9809],
    [-114.4476, 45.9874],
    [-114.4643, 45.9975],
    [-114.4850, 45.9969],
    [-114.4735, 46.0131],
    [-114.4862, 46.0299],
    [-114.5054, 46.0300],
    [-114.5062, 46.0389],
    [-114.4929, 46.0502],
    [-114.4747, 46.0584],
    [-114.4671, 46.0655],
    [-114.4713, 46.0771],
    [-114.4609, 46.0853],
    [-114.4651, 46.1022],
    [-114.4710, 46.1059],
    [-114.4862, 46.1134],
    [-114.5017, 46.1191],
    [-114.5205, 46.1249],
    [-114.5188, 46.1357],
    [-114.5271, 46.1462],
    [-114.5143, 46.1543],
    [-114.5156, 46.1661],
    [-114.5068, 46.1646],
    [-114.4944, 46.1680],
    [-114.4760, 46.1606],
    [-114.4629, 46.1681],
    [-114.4452, 46.1679],
    [-114.4450, 46.1859],
    [-114.4432, 46.2029],
    [-114.4513, 46.2155],
    [-114.4519, 46.2407],
    [-114.4681, 46.2487],
    [-114.4690, 46.2596],
    [-114.4669, 46.2720],
    [-114.4537, 46.2709],
    [-114.4273, 46.2836],
    [-114.4286, 46.2925],
    [-114.4328, 46.3061],
    [-114.4225, 46.3241],
    [-114.4177, 46.3321],
    [-114.4136, 46.3467],
    [-114.4222, 46.3873],
    [-114.4098, 46.3994],
    [-114.3991, 46.4051],
    [-114.3850, 46.4112],
    [-114.3814, 46.4339],
    [-114.3685, 46.4380],
    [-114.3740, 46.4432],
    [-114.3845, 46.4478],
    [-114.3798, 46.4607],
    [-114.3831, 46.4662],
    [-114.3961, 46.4734],
    [-114.4014, 46.4889],
    [-114.3999, 46.5022],
    [-114.3831, 46.5049],
    [-114.3683, 46.5050],
    [-114.3519, 46.5077],
    [-114.3428, 46.5183],
    [-114.3475, 46.5260],
    [-114.3462, 46.5361],
    [-114.3475, 46.5510],
    [-114.3395, 46.5640],
    [-114.3308, 46.5738],
    [-114.3337, 46.5790],
    [-114.3437, 46.5905],
    [-114.3303, 46.5995],
    [-114.3271, 46.6172],
    [-114.3222, 46.6267],
    [-114.3203, 46.6385],
    [-114.3249, 46.6536],
    [-114.3327, 46.6606],
    [-114.3444, 46.6620],
    [-114.3579, 46.6706],
    [-114.3781, 46.6671],
    [-114.3903, 46.6650],
    [-114.4043, 46.6595],
    [-114.4110, 46.6574],
    [-114.4368, 46.6557],
    [-114.4535, 46.6492],
    [-114.4671, 46.6318],
    [-114.4926, 46.6362],
    [-114.5012, 46.6413],
    [-114.5285, 46.6423],
    [-114.5413, 46.6497],
    [-114.5556, 46.6446],
    [-114.5698, 46.6433],
    [-114.5797, 46.6354],
    [-114.5923, 46.6328],
    [-114.6053, 46.6358],
    [-114.6117, 46.6475],
    [-114.6145, 46.6547],
    [-114.6346, 46.6592],
    [-114.6398, 46.6660],
    [-114.6331, 46.6700],
    [-114.6379, 46.6724],
    [-114.6402, 46.6754],
    [-114.6264, 46.6880],
    [-114.6242, 46.6955],
    [-114.6215, 46.7079],
    [-114.6305, 46.7146],
    [-114.6382, 46.7202],
    [-114.6446, 46.7228],
    [-114.6468, 46.7309],
    [-114.6610, 46.7357],
    [-114.6712, 46.7368],
    [-114.6820, 46.7389],
    [-114.6965, 46.7405],
    [-114.7012, 46.7349],
    [-114.7086, 46.7272],
    [-114.7108, 46.7173],
    [-114.7261, 46.7146],
    [-114.7417, 46.7086],
    [-114.7480, 46.6990],
    [-114.7639, 46.6977],
    [-114.7695, 46.6999],
    [-114.7788, 46.7067],
    [-114.7881, 46.7121],
    [-114.7823, 46.7193],
    [-114.7828, 46.7263],
    [-114.7779, 46.7315],
    [-114.7728, 46.7332],
    [-114.7656, 46.7456],
    [-114.7658, 46.7512],
    [-114.7652, 46.7583],
    [-114.7790, 46.7670],
    [-114.7864, 46.7779],
    [-114.7879, 46.7818],
    [-114.8034, 46.7779],
    [-114.8236, 46.7828],
    [-114.8368, 46.7926],
    [-114.8508, 46.7988],
    [-114.8606, 46.8057],
    [-114.8749, 46.8119],
    [-114.8952, 46.8016],
    [-114.8951, 46.8174],
    [-114.8996, 46.8226],
    [-114.9153, 46.8254],
    [-114.9252, 46.8337],
    [-114.9268, 46.8389],
    [-114.9243, 46.8475],
    [-114.9268, 46.8510],
    [-114.9421, 46.8565],
    [-114.9438, 46.8682],
    [-114.9311, 46.8821],
    [-114.9351, 46.8949],
    [-114.9310, 46.9041],
    [-114.9253, 46.9187],
    [-114.9419, 46.9241],
    [-114.9610, 46.9304],
    [-114.9643, 46.9375],
    [-114.9763, 46.9430],
    [-114.9864, 46.9542],
    [-115.0009, 46.9677],
    [-115.0170, 46.9739],
    [-115.0297, 46.9725],
    [-115.0484, 46.9698],
    [-115.0567, 46.9848],
    [-115.0674, 46.9955],
    [-115.0728, 47.0134],
    [-115.0694, 47.0151],
    [-115.0717, 47.0259],
    [-115.0810, 47.0298],
    [-115.0884, 47.0411],
    [-115.1026, 47.0474],
    [-115.1168, 47.0579],
    [-115.1220, 47.0633],
    [-115.1263, 47.0660],
    [-115.1378, 47.0775],
    [-115.1417, 47.0857],
    [-115.1443, 47.1020],
    [-115.1580, 47.1028],
    [-115.1735, 47.1097],
    [-115.1793, 47.1202],
    [-115.1865, 47.1247],
    [-115.1929, 47.1331],
    [-115.1991, 47.1396],
    [-115.2046, 47.1405],
    [-115.2163, 47.1454],
    [-115.2254, 47.1488],
    [-115.2453, 47.1518],
    [-115.2505, 47.1599],
    [-115.2568, 47.1698],
    [-115.2624, 47.1817],
    [-115.2726, 47.1827],
    [-115.2868, 47.1835],
    [-115.3005, 47.1881],
    [-115.2916, 47.2100],
    [-115.2988, 47.2255],
    [-115.3111, 47.2297],
    [-115.3244, 47.2447],
    [-115.3197, 47.2563],
    [-115.3404, 47.2629],
    [-115.3538, 47.2621],
    [-115.3713, 47.2653],
    [-115.3921, 47.2654],
    [-115.4121, 47.2646],
    [-115.4210, 47.2776],
    [-115.4358, 47.2803],
    [-115.4447, 47.2770],
    [-115.4573, 47.2783],
    [-115.4667, 47.2872],
    [-115.4804, 47.2816],
    [-115.4908, 47.2895],
    [-115.5153, 47.2968],
    [-115.5314, 47.3112],
    [-115.5410, 47.3258],
    [-115.5491, 47.3472],
    [-115.5603, 47.3522],
    [-115.5750, 47.3559],
    [-115.5776, 47.3674],
    [-115.5910, 47.3701],
    [-115.6021, 47.3775],
    [-115.6154, 47.3819],
    [-115.6301, 47.3793],
    [-115.6484, 47.3827],
    [-115.6506, 47.3926],
    [-115.6573, 47.4002],
    [-115.6730, 47.4024],
    [-115.6753, 47.4089],
    [-115.6921, 47.4153],
    [-115.7004, 47.4166],
    [-115.7167, 47.4186],
    [-115.7214, 47.4257],
    [-115.7427, 47.4236],
    [-115.7588, 47.4236],
    [-115.7524, 47.4322],
    [-115.7457, 47.4423],
    [-115.7254, 47.4476],
    [-115.7021, 47.4525],
    [-115.6823, 47.4569],
    [-115.6642, 47.4539],
    [-115.6401, 47.4597],
    [-115.6343, 47.4815],
    [-115.6473, 47.4780],
    [-115.6620, 47.4831],
    [-115.6767, 47.4865],
    [-115.6863, 47.4849],
    [-115.6986, 47.5023],
    [-115.7114, 47.5168],
    [-115.7005, 47.5257],
    [-115.7023, 47.5342],
    [-115.7167, 47.5337],
    [-115.7345, 47.5393],
    [-115.7444, 47.5392],
    [-115.7543, 47.5526],
    [-115.7443, 47.5590],
    [-115.7312, 47.5693],
    [-115.7220, 47.5754],
    [-115.7067, 47.5775],
    [-115.7051, 47.5844],
    [-115.6918, 47.5933],
    [-115.6920, 47.5978],
    [-115.6988, 47.6118],
    [-115.6925, 47.6175],
    [-115.7079, 47.6348],
    [-115.7304, 47.6423],
    [-115.7312, 47.6661],
    [-115.7265, 47.6732],
    [-115.7256, 47.6884],
    [-115.7317, 47.7052],
    [-115.7448, 47.7119],
    [-115.7592, 47.7192],
    [-115.7740, 47.7179],
    [-115.7842, 47.7320],
    [-115.7809, 47.7425],
    [-115.7973, 47.7571],
    [-115.8147, 47.7561],
    [-115.8354, 47.7617],
    [-115.8407, 47.7786],
    [-115.8458, 47.7932],
    [-115.8486, 47.8107],
    [-115.8506, 47.8253],
    [-115.8593, 47.8310],
    [-115.8753, 47.8433],
    [-115.8979, 47.8445],
    [-115.9068, 47.8464],
    [-115.9188, 47.8537],
    [-115.9252, 47.8669],
    [-115.9355, 47.8742],
    [-115.9456, 47.8858],
    [-115.9534, 47.8941],
    [-115.9664, 47.8983],
    [-115.9654, 47.9109],
    [-115.9823, 47.9156],
    [-115.9848, 47.9227],
    [-115.9934, 47.9291],
    [-116.0033, 47.9408],
    [-116.0075, 47.9508],
    [-116.0222, 47.9649],
    [-116.0304, 47.9726],
    [-116.0491, 47.9773],
    [-116.0491, 48.0795],
    [-116.0489, 48.1249],
    [-116.0490, 48.2164],
    [-116.0490, 48.3937],
    [-116.0491, 48.5020]
    ]
  },
  "Iowa": {
    coordinates: [
      [-96.6397, 42.7371],
    [-96.6305, 42.7504],
    [-96.6195, 42.7548],
    [-96.6225, 42.7584],
    [-96.6322, 42.7615],
    [-96.6321, 42.7709],
    [-96.6264, 42.7735],
    [-96.6156, 42.7850],
    [-96.6026, 42.7878],
    [-96.5908, 42.8083],
    [-96.5957, 42.8104],
    [-96.5910, 42.8154],
    [-96.5835, 42.8203],
    [-96.5824, 42.8337],
    [-96.5714, 42.8372],
    [-96.5631, 42.8311],
    [-96.5606, 42.8394],
    [-96.5540, 42.8360],
    [-96.5511, 42.8369],
    [-96.5522, 42.8419],
    [-96.5538, 42.8475],
    [-96.5443, 42.8513],
    [-96.5427, 42.8597],
    [-96.5453, 42.8572],
    [-96.5505, 42.8637],
    [-96.5464, 42.8745],
    [-96.5384, 42.8861],
    [-96.5344, 42.8907],
    [-96.5266, 42.8938],
    [-96.5394, 42.9000],
    [-96.5430, 42.9046],
    [-96.5366, 42.9057],
    [-96.5378, 42.9107],
    [-96.5417, 42.9226],
    [-96.5235, 42.9358],
    [-96.5194, 42.9320],
    [-96.5162, 42.9338],
    [-96.5200, 42.9398],
    [-96.5095, 42.9452],
    [-96.5003, 42.9594],
    [-96.5061, 42.9713],
    [-96.5202, 42.9776],
    [-96.5165, 42.9817],
    [-96.5129, 42.9914],
    [-96.5027, 42.9971],
    [-96.4985, 42.9980],
    [-96.4967, 42.9988],
    [-96.4917, 43.0097],
    [-96.4956, 43.0157],
    [-96.5110, 43.0247],
    [-96.5129, 43.0300],
    [-96.5091, 43.0373],
    [-96.5158, 43.0394],
    [-96.5103, 43.0499],
    [-96.5017, 43.0486],
    [-96.4888, 43.0515],
    [-96.4769, 43.0624],
    [-96.4682, 43.0619],
    [-96.4582, 43.0676],
    [-96.4541, 43.0839],
    [-96.4553, 43.0881],
    [-96.4605, 43.0949],
    [-96.4393, 43.1139],
    [-96.4408, 43.1231],
    [-96.4434, 43.1338],
    [-96.4589, 43.1434],
    [-96.4665, 43.1503],
    [-96.4673, 43.1641],
    [-96.4649, 43.1820],
    [-96.4688, 43.1845],
    [-96.4738, 43.1898],
    [-96.4706, 43.2072],
    [-96.4756, 43.2211],
    [-96.4853, 43.2242],
    [-96.5008, 43.2208],
    [-96.5210, 43.2182],
    [-96.5357, 43.2276],
    [-96.5482, 43.2269],
    [-96.5573, 43.2248],
    [-96.5685, 43.2316],
    [-96.5653, 43.2442],
    [-96.5520, 43.2511],
    [-96.5532, 43.2591],
    [-96.5601, 43.2593],
    [-96.5768, 43.2683],
    [-96.5863, 43.2743],
    [-96.5829, 43.2746],
    [-96.5778, 43.2799],
    [-96.5796, 43.2934],
    [-96.5870, 43.2918],
    [-96.5885, 43.2963],
    [-96.5803, 43.2982],
    [-96.5707, 43.2967],
    [-96.5635, 43.2948],
    [-96.5493, 43.2937],
    [-96.5274, 43.3069],
    [-96.5288, 43.3166],
    [-96.5319, 43.3387],
    [-96.5243, 43.3472],
    [-96.5266, 43.3518],
    [-96.5265, 43.3683],
    [-96.5213, 43.3759],
    [-96.5255, 43.3963],
    [-96.5301, 43.3964],
    [-96.5530, 43.4041],
    [-96.5685, 43.4172],
    [-96.5696, 43.4275],
    [-96.5820, 43.4322],
    [-96.5896, 43.4322],
    [-96.6005, 43.4456],
    [-96.6018, 43.4531],
    [-96.5879, 43.4649],
    [-96.5846, 43.4696],
    [-96.5841, 43.4756],
    [-96.5810, 43.4814],
    [-96.5863, 43.4835],
    [-96.5869, 43.4877],
    [-96.5863, 43.4911],
    [-96.5917, 43.4944],
    [-96.5992, 43.4960],
    [-96.5989, 43.5005],
    [-96.4533, 43.5004],
    [-96.3321, 43.5004],
    [-96.2737, 43.5004],
    [-96.2088, 43.5004],
    [-96.1927, 43.5003],
    [-96.0962, 43.5002],
    [-95.9337, 43.5000],
    [-95.8344, 43.5000],
    [-95.8156, 43.5000],
    [-95.7414, 43.4999],
    [-95.6841, 43.4999],
    [-95.6233, 43.4999],
    [-95.5148, 43.4999],
    [-95.4868, 43.5002],
    [-95.4547, 43.5006],
    [-95.4343, 43.5004],
    [-95.3879, 43.5002],
    [-95.3753, 43.5003],
    [-95.3248, 43.5004],
    [-95.2508, 43.5004],
    [-95.2013, 43.5008],
    [-95.1679, 43.5009],
    [-95.1513, 43.5005],
    [-95.0940, 43.5007],
    [-95.0340, 43.5008],
    [-94.9945, 43.5005],
    [-94.9545, 43.5005],
    [-94.9150, 43.5005],
    [-94.9145, 43.5005],
    [-94.8727, 43.5006],
    [-94.8546, 43.5006],
    [-94.7342, 43.5006],
    [-94.6142, 43.5005],
    [-94.5608, 43.5004],
    [-94.4470, 43.5006],
    [-94.4375, 43.5006],
    [-94.3775, 43.5004],
    [-94.2480, 43.5003],
    [-94.1281, 43.5003],
    [-94.1069, 43.5003],
    [-94.0929, 43.5003],
    [-94.0683, 43.5002],
    [-93.8884, 43.4996],
    [-93.7943, 43.4995],
    [-93.7162, 43.4996],
    [-93.7049, 43.4996],
    [-93.6485, 43.4996],
    [-93.6046, 43.4995],
    [-93.5322, 43.4995],
    [-93.4974, 43.4995],
    [-93.4820, 43.4995],
    [-93.4686, 43.4995],
    [-93.3990, 43.4995],
    [-93.3537, 43.4994],
    [-93.2718, 43.4994],
    [-93.2289, 43.4996],
    [-93.1692, 43.4996],
    [-93.0643, 43.4996],
    [-93.0243, 43.4996],
    [-92.9469, 43.4996],
    [-92.9055, 43.4996],
    [-92.8358, 43.4996],
    [-92.7903, 43.4996],
    [-92.7073, 43.5001],
    [-92.6890, 43.5001],
    [-92.6533, 43.5000],
    [-92.5689, 43.5003],
    [-92.5388, 43.5003],
    [-92.4455, 43.5004],
    [-92.4061, 43.5005],
    [-92.3762, 43.5005],
    [-92.3294, 43.5004],
    [-92.2894, 43.5004],
    [-92.2090, 43.5005],
    [-92.1979, 43.5005],
    [-92.0900, 43.5007],
    [-92.0798, 43.5006],
    [-91.9697, 43.5005],
    [-91.9418, 43.5006],
    [-91.8497, 43.5007],
    [-91.8072, 43.5006],
    [-91.7906, 43.5008],
    [-91.7614, 43.5006],
    [-91.7333, 43.5006],
    [-91.7302, 43.5007],
    [-91.6584, 43.5005],
    [-91.6398, 43.5006],
    [-91.6342, 43.5005],
    [-91.6174, 43.5007],
    [-91.6109, 43.5005],
    [-91.5911, 43.5005],
    [-91.5338, 43.5006],
    [-91.4655, 43.5006],
    [-91.4616, 43.5006],
    [-91.4418, 43.5004],
    [-91.3769, 43.5005],
    [-91.3693, 43.5008],
    [-91.2618, 43.5010],
    [-91.2183, 43.4972],
    [-91.2153, 43.4848],
    [-91.2246, 43.4655],
    [-91.2322, 43.4600],
    [-91.2323, 43.4510],
    [-91.2071, 43.4250],
    [-91.2012, 43.4159],
    [-91.1994, 43.4030],
    [-91.1990, 43.3898],
    [-91.2061, 43.3750],
    [-91.2150, 43.3680],
    [-91.2067, 43.3526],
    [-91.2023, 43.3493],
    [-91.1811, 43.3459],
    [-91.1548, 43.3348],
    [-91.1291, 43.3263],
    [-91.1072, 43.3136],
    [-91.0737, 43.2747],
    [-91.0728, 43.2644],
    [-91.0699, 43.2603],
    [-91.0586, 43.2577],
    [-91.0597, 43.2486],
    [-91.0664, 43.2393],
    [-91.0796, 43.2280],
    [-91.1079, 43.2066],
    [-91.1191, 43.2004],
    [-91.1244, 43.1879],
    [-91.1386, 43.1700],
    [-91.1433, 43.1564],
    [-91.1559, 43.1433],
    [-91.1704, 43.1374],
    [-91.1779, 43.1289],
    [-91.1752, 43.1038],
    [-91.1788, 43.0706],
    [-91.1781, 43.0620],
    [-91.1753, 43.0430],
    [-91.1743, 43.0376],
    [-91.1680, 43.0187],
    [-91.1567, 42.9878],
    [-91.1509, 42.9705],
    [-91.1465, 42.9633],
    [-91.1491, 42.9466],
    [-91.1455, 42.9304],
    [-91.1439, 42.9207],
    [-91.1462, 42.9123],
    [-91.1447, 42.9060],
    [-91.1303, 42.9008],
    [-91.1122, 42.8911],
    [-91.0982, 42.8758],
    [-91.0953, 42.8553],
    [-91.0917, 42.8487],
    [-91.0951, 42.8350],
    [-91.0828, 42.8300],
    [-91.0788, 42.8150],
    [-91.0755, 42.7955],
    [-91.0707, 42.7755],
    [-91.0633, 42.7639],
    [-91.0614, 42.7580],
    [-91.0658, 42.7534],
    [-91.0581, 42.7492],
    [-91.0548, 42.7405],
    [-91.0500, 42.7369],
    [-91.0394, 42.7385],
    [-91.0310, 42.7325],
    [-91.0297, 42.7268],
    [-91.0172, 42.7196],
    [-91.0096, 42.7201],
    [-90.9888, 42.7087],
    [-90.9742, 42.6952],
    [-90.9524, 42.6868],
    [-90.9370, 42.6834],
    [-90.9212, 42.6854],
    [-90.8989, 42.6759],
    [-90.8812, 42.6713],
    [-90.8439, 42.6631],
    [-90.8054, 42.6572],
    [-90.7809, 42.6532],
    [-90.7695, 42.6514],
    [-90.7437, 42.6456],
    [-90.7092, 42.6361],
    [-90.7009, 42.6264],
    [-90.6920, 42.6104],
    [-90.6878, 42.5946],
    [-90.6794, 42.5815],
    [-90.6727, 42.5766],
    [-90.6614, 42.5676],
    [-90.6467, 42.5448],
    [-90.6422, 42.5336],
    [-90.6369, 42.5132],
    [-90.6559, 42.4917],
    [-90.6563, 42.4836],
    [-90.6431, 42.4698],
    [-90.6063, 42.4515],
    [-90.5821, 42.4444],
    [-90.5652, 42.4387],
    [-90.5582, 42.4210],
    [-90.5481, 42.4131],
    [-90.5068, 42.3988],
    [-90.4958, 42.3924],
    [-90.4846, 42.3845],
    [-90.4741, 42.3817],
    [-90.4677, 42.3741],
    [-90.4527, 42.3593],
    [-90.4305, 42.3369],
    [-90.4213, 42.3305],
    [-90.4165, 42.3251],
    [-90.4171, 42.3199],
    [-90.4203, 42.3117],
    [-90.4243, 42.2933],
    [-90.4307, 42.2842],
    [-90.4241, 42.2664],
    [-90.4193, 42.2545],
    [-90.4152, 42.2509],
    [-90.3959, 42.2331],
    [-90.3911, 42.2255],
    [-90.3604, 42.2076],
    [-90.3283, 42.2010],
    [-90.3069, 42.1903],
    [-90.2822, 42.1788],
    [-90.2501, 42.1715],
    [-90.2161, 42.1567],
    [-90.2064, 42.1455],
    [-90.1973, 42.1282],
    [-90.1875, 42.1254],
    [-90.1668, 42.1216],
    [-90.1615, 42.1097],
    [-90.1634, 42.0876],
    [-90.1659, 42.0642],
    [-90.1653, 42.0510],
    [-90.1588, 42.0378],
    [-90.1509, 42.0294],
    [-90.1486, 42.0214],
    [-90.1412, 42.0089],
    [-90.1406, 41.9960],
    [-90.1468, 41.9806],
    [-90.1546, 41.9730],
    [-90.1649, 41.9495],
    [-90.1606, 41.9408],
    [-90.1527, 41.9331],
    [-90.1534, 41.9156],
    [-90.1540, 41.9056],
    [-90.1664, 41.8818],
    [-90.1715, 41.8709],
    [-90.1725, 41.8673],
    [-90.1730, 41.8574],
    [-90.1804, 41.8461],
    [-90.1819, 41.8432],
    [-90.1838, 41.8362],
    [-90.1806, 41.8120],
    [-90.1880, 41.8032],
    [-90.2169, 41.7953],
    [-90.2486, 41.7798],
    [-90.2633, 41.7721],
    [-90.3028, 41.7500],
    [-90.3164, 41.7289],
    [-90.3133, 41.7095],
    [-90.3132, 41.6997],
    [-90.3173, 41.6917],
    [-90.3325, 41.6821],
    [-90.3359, 41.6705],
    [-90.3398, 41.6566],
    [-90.3435, 41.6470],
    [-90.3407, 41.6114],
    [-90.3411, 41.5925],
    [-90.3519, 41.5844],
    [-90.3647, 41.5795],
    [-90.3979, 41.5722],
    [-90.4130, 41.5652],
    [-90.4222, 41.5542],
    [-90.4272, 41.5515],
    [-90.4384, 41.5441],
    [-90.4614, 41.5235],
    [-90.4895, 41.5183],
    [-90.5006, 41.5180],
    [-90.5132, 41.5195],
    [-90.5409, 41.5261],
    [-90.5562, 41.5242],
    [-90.5711, 41.5163],
    [-90.5816, 41.5152],
    [-90.5945, 41.5113],
    [-90.6042, 41.4970],
    [-90.6086, 41.4923],
    [-90.6325, 41.4787],
    [-90.6558, 41.4621],
    [-90.6764, 41.4608],
    [-90.7012, 41.4547],
    [-90.7375, 41.4501],
    [-90.7776, 41.4513],
    [-90.8073, 41.4545],
    [-90.8466, 41.4551],
    [-90.8673, 41.4482],
    [-90.8905, 41.4356],
    [-90.8996, 41.4315],
    [-90.9243, 41.4229],
    [-90.9532, 41.4251],
    [-90.9798, 41.4343],
    [-91.0096, 41.4255],
    [-91.0278, 41.4236],
    [-91.0399, 41.4185],
    [-91.0459, 41.4141],
    [-91.0503, 41.4000],
    [-91.0516, 41.3853],
    [-91.0651, 41.3691],
    [-91.0719, 41.3336],
    [-91.0748, 41.3056],
    [-91.0920, 41.2869],
    [-91.1103, 41.2561],
    [-91.1136, 41.2414],
    [-91.1096, 41.2366],
    [-91.0814, 41.2144],
    [-91.0602, 41.1923],
    [-91.0415, 41.1661],
    [-91.0144, 41.1656],
    [-91.0076, 41.1662],
    [-90.9926, 41.1584],
    [-90.9813, 41.1427],
    [-90.9609, 41.1147],
    [-90.9466, 41.0966],
    [-90.9482, 41.0844],
    [-90.9490, 41.0702],
    [-90.9437, 41.0486],
    [-90.9433, 41.0296],
    [-90.9451, 41.0119],
    [-90.9552, 40.9868],
    [-90.9581, 40.9766],
    [-90.9520, 40.9582],
    [-90.9605, 40.9364],
    [-90.9690, 40.9191],
    [-90.9985, 40.9081],
    [-91.0118, 40.8982],
    [-91.0216, 40.8840],
    [-91.0279, 40.8790],
    [-91.0447, 40.8684],
    [-91.0564, 40.8484],
    [-91.0775, 40.8334],
    [-91.0916, 40.8228],
    [-91.0967, 40.8121],
    [-91.0976, 40.8056],
    [-91.0923, 40.7929],
    [-91.0917, 40.7803],
    [-91.0961, 40.7671],
    [-91.1055, 40.7538],
    [-91.1142, 40.7309],
    [-91.1145, 40.7206],
    [-91.1109, 40.7033],
    [-91.1154, 40.6918],
    [-91.1224, 40.6707],
    [-91.1543, 40.6536],
    [-91.1870, 40.6373],
    [-91.2184, 40.6384],
    [-91.2531, 40.6380],
    [-91.2650, 40.6339],
    [-91.3065, 40.6262],
    [-91.3487, 40.6097],
    [-91.3599, 40.6018],
    [-91.3743, 40.5826],
    [-91.3882, 40.5686],
    [-91.4063, 40.5519],
    [-91.4062, 40.5427],
    [-91.3945, 40.5345],
    [-91.3819, 40.5282],
    [-91.3685, 40.5116],
    [-91.3642, 40.5000],
    [-91.3639, 40.4901],
    [-91.3681, 40.4746],
    [-91.3781, 40.4564],
    [-91.3818, 40.4426],
    [-91.3795, 40.4315],
    [-91.3737, 40.4179],
    [-91.3725, 40.4044],
    [-91.3757, 40.3919],
    [-91.3784, 40.3897],
    [-91.3901, 40.3846],
    [-91.4130, 40.3823],
    [-91.4223, 40.3809],
    [-91.4412, 40.3863],
    [-91.4639, 40.3757],
    [-91.4647, 40.3809],
    [-91.4803, 40.3818],
    [-91.4910, 40.3935],
    [-91.4880, 40.4025],
    [-91.4898, 40.4043],
    [-91.4981, 40.4019],
    [-91.5074, 40.4055],
    [-91.5184, 40.4087],
    [-91.5264, 40.4134],
    [-91.5214, 40.4265],
    [-91.5199, 40.4337],
    [-91.5328, 40.4368],
    [-91.5319, 40.4427],
    [-91.5233, 40.4501],
    [-91.5237, 40.4556],
    [-91.5262, 40.4586],
    [-91.5438, 40.4581],
    [-91.5638, 40.4610],
    [-91.5760, 40.4668],
    [-91.5824, 40.4747],
    [-91.5908, 40.4923],
    [-91.6083, 40.5000],
    [-91.6195, 40.5071],
    [-91.6222, 40.5170],
    [-91.6190, 40.5391],
    [-91.6219, 40.5423],
    [-91.6381, 40.5455],
    [-91.6817, 40.5530],
    [-91.6908, 40.5599],
    [-91.6857, 40.5768],
    [-91.6888, 40.5834],
    [-91.7168, 40.5985],
    [-91.7859, 40.6115],
    [-91.8140, 40.6105],
    [-91.8324, 40.6098],
    [-91.8684, 40.6081],
    [-91.9393, 40.6061],
    [-91.9487, 40.6055],
    [-92.0296, 40.6037],
    [-92.0639, 40.6028],
    [-92.0823, 40.6022],
    [-92.0964, 40.6018],
    [-92.2017, 40.6000],
    [-92.2365, 40.5995],
    [-92.2988, 40.5985],
    [-92.3508, 40.5973],
    [-92.4090, 40.5960],
    [-92.4616, 40.5954],
    [-92.4824, 40.5949],
    [-92.5237, 40.5938],
    [-92.6184, 40.5913],
    [-92.6867, 40.5898],
    [-92.7422, 40.5892],
    [-92.7537, 40.5890],
    [-92.8280, 40.5885],
    [-92.8574, 40.5884],
    [-92.8673, 40.5882],
    [-92.9035, 40.5879],
    [-92.9566, 40.5875],
    [-92.9824, 40.5868],
    [-93.0898, 40.5843],
    [-93.1358, 40.5829],
    [-93.2606, 40.5808],
    [-93.3278, 40.5806],
    [-93.4416, 40.5799],
    [-93.4669, 40.5801],
    [-93.5205, 40.5805],
    [-93.5271, 40.5804],
    [-93.5328, 40.5804],
    [-93.5569, 40.5802],
    [-93.5652, 40.5801],
    [-93.5974, 40.5795],
    [-93.6562, 40.5784],
    [-93.6688, 40.5782],
    [-93.6771, 40.5781],
    [-93.7224, 40.5776],
    [-93.7382, 40.5775],
    [-93.7502, 40.5777],
    [-93.7869, 40.5775],
    [-93.8187, 40.5771],
    [-93.8537, 40.5766],
    [-93.8993, 40.5759],
    [-93.9140, 40.5757],
    [-93.9369, 40.5754],
    [-93.9399, 40.5752],
    [-93.9874, 40.5744],
    [-94.0341, 40.5736],
    [-94.0805, 40.5729],
    [-94.1185, 40.5727],
    [-94.2322, 40.5719],
    [-94.2948, 40.5713],
    [-94.3366, 40.5715],
    [-94.3583, 40.5714],
    [-94.4297, 40.5710],
    [-94.4607, 40.5709],
    [-94.4893, 40.5707],
    [-94.5378, 40.5708],
    [-94.5422, 40.5708],
    [-94.5940, 40.5710],
    [-94.6826, 40.5718],
    [-94.7149, 40.5722],
    [-94.7740, 40.5730],
    [-94.8112, 40.5735],
    [-94.8968, 40.5747],
    [-94.9149, 40.5751],
    [-94.9665, 40.5758],
    [-95.0228, 40.5762],
    [-95.0689, 40.5769],
    [-95.1072, 40.5771],
    [-95.1122, 40.5772],
    [-95.1545, 40.5779],
    [-95.2023, 40.5785],
    [-95.2127, 40.5787],
    [-95.2188, 40.5788],
    [-95.2307, 40.5789],
    [-95.3578, 40.5801],
    [-95.4154, 40.5810],
    [-95.4693, 40.5815],
    [-95.5254, 40.5821],
    [-95.5453, 40.5825],
    [-95.6109, 40.5835],
    [-95.6418, 40.5842],
    [-95.6875, 40.5844],
    [-95.7589, 40.5890],
    [-95.7489, 40.6000],
    [-95.7513, 40.6091],
    [-95.7644, 40.6171],
    [-95.7701, 40.6244],
    [-95.7713, 40.6394],
    [-95.7763, 40.6475],
    [-95.7895, 40.6594],
    [-95.8141, 40.6656],
    [-95.8308, 40.6706],
    [-95.8373, 40.6743],
    [-95.8448, 40.6799],
    [-95.8460, 40.6826],
    [-95.8498, 40.6981],
    [-95.8594, 40.7081],
    [-95.8753, 40.7141],
    [-95.8853, 40.7211],
    [-95.8867, 40.7421],
    [-95.8733, 40.7576],
    [-95.8528, 40.7656],
    [-95.8389, 40.7745],
    [-95.8342, 40.7830],
    [-95.8358, 40.7906],
    [-95.8453, 40.8113],
    [-95.8439, 40.8177],
    [-95.8372, 40.8353],
    [-95.8481, 40.8573],
    [-95.8486, 40.8611],
    [-95.8441, 40.8692],
    [-95.8387, 40.8722],
    [-95.8159, 40.8798],
    [-95.8095, 40.8912],
    [-95.8135, 40.9017],
    [-95.8307, 40.9150],
    [-95.8378, 40.9247],
    [-95.8403, 40.9399],
    [-95.8330, 40.9587],
    [-95.8291, 40.9757],
    [-95.8389, 40.9865],
    [-95.8525, 40.9917],
    [-95.8659, 41.0001],
    [-95.8692, 41.0060],
    [-95.8659, 41.0174],
    [-95.8597, 41.0357],
    [-95.8698, 41.0452],
    [-95.8824, 41.0604],
    [-95.8734, 41.0731],
    [-95.8638, 41.0835],
    [-95.8633, 41.0938],
    [-95.8659, 41.1174],
    [-95.8699, 41.1263],
    [-95.8792, 41.1387],
    [-95.8835, 41.1549],
    [-95.8809, 41.1603],
    [-95.8696, 41.1688],
    [-95.8528, 41.1654],
    [-95.8413, 41.1749],
    [-95.8419, 41.1763],
    [-95.8568, 41.1871],
    [-95.9097, 41.1844],
    [-95.9208, 41.1889],
    [-95.9260, 41.1957],
    [-95.9250, 41.2110],
    [-95.9151, 41.2230],
    [-95.9109, 41.2319],
    [-95.9114, 41.2380],
    [-95.9171, 41.2498],
    [-95.9214, 41.2599],
    [-95.9188, 41.2697],
    [-95.9182, 41.2743],
    [-95.9296, 41.2904],
    [-95.9224, 41.3003],
    [-95.9043, 41.2996],
    [-95.9093, 41.2849],
    [-95.9039, 41.2742],
    [-95.8824, 41.2814],
    [-95.8729, 41.2895],
    [-95.8747, 41.3071],
    [-95.8887, 41.3191],
    [-95.9138, 41.3202],
    [-95.9269, 41.3228],
    [-95.9432, 41.3316],
    [-95.9567, 41.3455],
    [-95.9568, 41.3492],
    [-95.9410, 41.3575],
    [-95.9309, 41.3648],
    [-95.9352, 41.3844],
    [-95.9369, 41.3964],
    [-95.9299, 41.4152],
    [-95.9332, 41.4294],
    [-95.9239, 41.4397],
    [-95.9199, 41.4479],
    [-95.9257, 41.4594],
    [-95.9420, 41.4663],
    [-95.9623, 41.4628],
    [-95.9830, 41.4698],
    [-96.0088, 41.4740],
    [-96.0166, 41.4819],
    [-96.0192, 41.4893],
    [-95.9979, 41.5048],
    [-95.9928, 41.5120],
    [-95.9939, 41.5234],
    [-96.0139, 41.5453],
    [-96.0267, 41.5404],
    [-96.0317, 41.5222],
    [-96.0344, 41.5144],
    [-96.0381, 41.5080],
    [-96.0537, 41.5089],
    [-96.0686, 41.5191],
    [-96.0799, 41.5259],
    [-96.0920, 41.5339],
    [-96.0959, 41.5509],
    [-96.0918, 41.5611],
    [-96.0824, 41.5712],
    [-96.0818, 41.5804],
    [-96.0858, 41.5857],
    [-96.1045, 41.5932],
    [-96.1096, 41.5971],
    [-96.1158, 41.6058],
    [-96.1179, 41.6174],
    [-96.1007, 41.6355],
    [-96.0952, 41.6503],
    [-96.0998, 41.6610],
    [-96.1181, 41.6744],
    [-96.1217, 41.6830],
    [-96.1202, 41.6912],
    [-96.1051, 41.6999],
    [-96.0795, 41.6997],
    [-96.0723, 41.7069],
    [-96.0752, 41.7133],
    [-96.0930, 41.7243],
    [-96.1063, 41.7346],
    [-96.1028, 41.7463],
    [-96.0917, 41.7504],
    [-96.0783, 41.7616],
    [-96.0775, 41.7778],
    [-96.0645, 41.7930],
    [-96.0697, 41.8035],
    [-96.0938, 41.8128],
    [-96.1076, 41.8207],
    [-96.1109, 41.8294],
    [-96.1079, 41.8403],
    [-96.1140, 41.8531],
    [-96.1306, 41.8608],
    [-96.1420, 41.8689],
    [-96.1468, 41.8775],
    [-96.1522, 41.8921],
    [-96.1618, 41.9018],
    [-96.1591, 41.9101],
    [-96.1399, 41.9167],
    [-96.1361, 41.9235],
    [-96.1446, 41.9415],
    [-96.1370, 41.9508],
    [-96.1292, 41.9651],
    [-96.1325, 41.9746],
    [-96.1607, 41.9801],
    [-96.1772, 41.9763],
    [-96.1870, 41.9779],
    [-96.1921, 41.9845],
    [-96.1838, 41.9978],
    [-96.1881, 42.0063],
    [-96.2071, 42.0090],
    [-96.2218, 41.9974],
    [-96.2297, 41.9944],
    [-96.2407, 41.9994],
    [-96.2419, 42.0070],
    [-96.2279, 42.0187],
    [-96.2219, 42.0296],
    [-96.2321, 42.0391],
    [-96.2545, 42.0395],
    [-96.2622, 42.0393],
    [-96.2714, 42.0450],
    [-96.2755, 42.0520],
    [-96.2793, 42.0703],
    [-96.2745, 42.0853],
    [-96.2716, 42.0890],
    [-96.2667, 42.1039],
    [-96.2723, 42.1184],
    [-96.2857, 42.1256],
    [-96.3014, 42.1282],
    [-96.3138, 42.1363],
    [-96.3259, 42.1515],
    [-96.3424, 42.1605],
    [-96.3497, 42.1720],
    [-96.3477, 42.1913],
    [-96.3515, 42.2005],
    [-96.3581, 42.2141],
    [-96.3451, 42.2175],
    [-96.3363, 42.2189],
    [-96.3228, 42.2315],
    [-96.3300, 42.2402],
    [-96.3289, 42.2547],
    [-96.3414, 42.2691],
    [-96.3608, 42.2799],
    [-96.3685, 42.3011],
    [-96.3692, 42.3083],
    [-96.3753, 42.3183],
    [-96.4030, 42.3342],
    [-96.4139, 42.3434],
    [-96.4182, 42.3547],
    [-96.4151, 42.3644],
    [-96.4088, 42.3791],
    [-96.4115, 42.3863],
    [-96.4155, 42.4003],
    [-96.3988, 42.4225],
    [-96.3807, 42.4464],
    [-96.3801, 42.4515],
    [-96.3854, 42.4731],
    [-96.3860, 42.4745],
    [-96.4094, 42.4876],
    [-96.4217, 42.4888],
    [-96.4403, 42.4902],
    [-96.4501, 42.4909],
    [-96.4664, 42.4908],
    [-96.4707, 42.4895],
    [-96.4772, 42.4910],
    [-96.4769, 42.4978],
    [-96.4733, 42.5035],
    [-96.4836, 42.5103],
    [-96.4908, 42.5203],
    [-96.4801, 42.5241],
    [-96.4790, 42.5264],
    [-96.4777, 42.5356],
    [-96.4785, 42.5564],
    [-96.4917, 42.5565],
    [-96.4985, 42.5581],
    [-96.4879, 42.5714],
    [-96.4866, 42.5761],
    [-96.4961, 42.5809],
    [-96.4948, 42.5857],
    [-96.5010, 42.5892],
    [-96.5002, 42.5927],
    [-96.5095, 42.6127],
    [-96.5195, 42.6144],
    [-96.5279, 42.6090],
    [-96.5309, 42.6171],
    [-96.5212, 42.6192],
    [-96.5159, 42.6250],
    [-96.5163, 42.6304],
    [-96.5379, 42.6464],
    [-96.5383, 42.6491],
    [-96.5424, 42.6607],
    [-96.5562, 42.6579],
    [-96.5599, 42.6628],
    [-96.5562, 42.6644],
    [-96.5681, 42.6762],
    [-96.5707, 42.6717],
    [-96.5786, 42.6721],
    [-96.5743, 42.6770],
    [-96.5856, 42.6871],
    [-96.5955, 42.6912],
    [-96.6008, 42.6977],
    [-96.6061, 42.6947],
    [-96.6121, 42.6966],
    [-96.6122, 42.6982],
    [-96.6134, 42.6987],
    [-96.6153, 42.6986],
    [-96.6306, 42.7059],
    [-96.6244, 42.7143],
    [-96.6319, 42.7251],
    [-96.6397, 42.7370],
    [-96.6397, 42.7371]
    ]
  },
  "South Carolina": {
    coordinates: [
      [-83.3539, 34.6992],
    [-83.3466, 34.7042],
    [-83.3498, 34.7083],
    [-83.3525, 34.7160],
    [-83.3529, 34.7294],
    [-83.3335, 34.7453],
    [-83.3208, 34.7584],
    [-83.3238, 34.7896],
    [-83.3138, 34.7999],
    [-83.2998, 34.8079],
    [-83.3067, 34.8148],
    [-83.2990, 34.8176],
    [-83.2946, 34.8136],
    [-83.2911, 34.8225],
    [-83.2832, 34.8213],
    [-83.2682, 34.8214],
    [-83.2688, 34.8445],
    [-83.2608, 34.8455],
    [-83.2505, 34.8445],
    [-83.2526, 34.8535],
    [-83.2463, 34.8600],
    [-83.2433, 34.8660],
    [-83.2347, 34.8707],
    [-83.2403, 34.8788],
    [-83.2292, 34.8799],
    [-83.2183, 34.8817],
    [-83.2133, 34.8872],
    [-83.2056, 34.8801],
    [-83.2031, 34.8939],
    [-83.1968, 34.8907],
    [-83.1949, 34.8987],
    [-83.1809, 34.9047],
    [-83.1708, 34.9142],
    [-83.1607, 34.9151],
    [-83.1577, 34.9235],
    [-83.1433, 34.9248],
    [-83.1299, 34.9324],
    [-83.1281, 34.9381],
    [-83.1181, 34.9360],
    [-83.1169, 34.9427],
    [-83.1268, 34.9487],
    [-83.1167, 34.9513],
    [-83.1164, 34.9590],
    [-83.1221, 34.9643],
    [-83.1160, 34.9759],
    [-83.1121, 34.9794],
    [-83.1079, 34.9797],
    [-83.1048, 34.9851],
    [-83.1007, 34.9899],
    [-83.1034, 34.9935],
    [-83.1086, 35.0007],
    [-83.0190, 35.0248],
    [-82.8975, 35.0560],
    [-82.7833, 35.0856],
    [-82.7787, 35.0836],
    [-82.7777, 35.0763],
    [-82.7799, 35.0704],
    [-82.7774, 35.0641],
    [-82.7645, 35.0682],
    [-82.7513, 35.0735],
    [-82.7489, 35.0811],
    [-82.7359, 35.0827],
    [-82.7301, 35.0883],
    [-82.7270, 35.0941],
    [-82.7153, 35.0929],
    [-82.7022, 35.0991],
    [-82.6988, 35.0957],
    [-82.6896, 35.1041],
    [-82.6865, 35.1082],
    [-82.6907, 35.1115],
    [-82.6936, 35.1169],
    [-82.6867, 35.1198],
    [-82.6836, 35.1258],
    [-82.6766, 35.1268],
    [-82.6733, 35.1210],
    [-82.6700, 35.1199],
    [-82.6624, 35.1181],
    [-82.6518, 35.1234],
    [-82.6453, 35.1268],
    [-82.6402, 35.1300],
    [-82.6367, 35.1293],
    [-82.6326, 35.1258],
    [-82.6248, 35.1304],
    [-82.6144, 35.1367],
    [-82.6097, 35.1390],
    [-82.5924, 35.1390],
    [-82.5818, 35.1424],
    [-82.5742, 35.1436],
    [-82.5662, 35.1501],
    [-82.5586, 35.1509],
    [-82.5549, 35.1546],
    [-82.5533, 35.1617],
    [-82.5464, 35.1637],
    [-82.5406, 35.1613],
    [-82.5360, 35.1587],
    [-82.5351, 35.1548],
    [-82.5259, 35.1567],
    [-82.5192, 35.1610],
    [-82.5169, 35.1630],
    [-82.5115, 35.1633],
    [-82.5049, 35.1657],
    [-82.4950, 35.1645],
    [-82.4839, 35.1738],
    [-82.4680, 35.1746],
    [-82.4543, 35.1774],
    [-82.4523, 35.1737],
    [-82.4576, 35.1668],
    [-82.4481, 35.1652],
    [-82.4377, 35.1678],
    [-82.4352, 35.1699],
    [-82.4314, 35.1739],
    [-82.4283, 35.1787],
    [-82.4258, 35.1821],
    [-82.4197, 35.1986],
    [-82.4033, 35.2045],
    [-82.3904, 35.2154],
    [-82.3805, 35.2023],
    [-82.3814, 35.1940],
    [-82.3797, 35.1869],
    [-82.3713, 35.1814],
    [-82.3635, 35.1862],
    [-82.3615, 35.1908],
    [-82.3446, 35.1931],
    [-82.3395, 35.1889],
    [-82.3330, 35.1906],
    [-82.3269, 35.1851],
    [-82.3159, 35.1907],
    [-82.3072, 35.1930],
    [-82.2885, 35.1986],
    [-82.2786, 35.2000],
    [-82.2430, 35.1976],
    [-82.2305, 35.1968],
    [-82.2162, 35.1960],
    [-82.1955, 35.1950],
    [-82.1679, 35.1937],
    [-82.1389, 35.1931],
    [-82.0484, 35.1897],
    [-82.0176, 35.1889],
    [-81.9693, 35.1872],
    [-81.8747, 35.1841],
    [-81.8440, 35.1830],
    [-81.7724, 35.1805],
    [-81.7385, 35.1795],
    [-81.6467, 35.1759],
    [-81.6095, 35.1743],
    [-81.5728, 35.1728],
    [-81.5169, 35.1707],
    [-81.4700, 35.1690],
    [-81.4524, 35.1683],
    [-81.4427, 35.1679],
    [-81.3667, 35.1649],
    [-81.2907, 35.1620],
    [-81.2665, 35.1610],
    [-81.2417, 35.1601],
    [-81.2098, 35.1586],
    [-81.1382, 35.1554],
    [-81.1093, 35.1541],
    [-81.0773, 35.1520],
    [-81.0463, 35.1501],
    [-81.0434, 35.1484],
    [-81.0478, 35.1437],
    [-81.0504, 35.1310],
    [-81.0330, 35.1137],
    [-81.0350, 35.1041],
    [-81.0402, 35.1019],
    [-81.0521, 35.0963],
    [-81.0580, 35.0732],
    [-81.0574, 35.0622],
    [-81.0415, 35.0447],
    [-81.0162, 35.0592],
    [-80.9890, 35.0748],
    [-80.9579, 35.0926],
    [-80.9350, 35.1074],
    [-80.9066, 35.0768],
    [-80.8981, 35.0677],
    [-80.8814, 35.0495],
    [-80.8514, 35.0145],
    [-80.8404, 35.0016],
    [-80.8214, 34.9795],
    [-80.8144, 34.9718],
    [-80.8065, 34.9629],
    [-80.7950, 34.9502],
    [-80.7822, 34.9343],
    [-80.7865, 34.9023],
    [-80.7970, 34.8239],
    [-80.7718, 34.8196],
    [-80.6927, 34.8190],
    [-80.6646, 34.8187],
    [-80.6263, 34.8182],
    [-80.6212, 34.8182],
    [-80.5617, 34.8175],
    [-80.4918, 34.8168],
    [-80.4488, 34.8163],
    [-80.4259, 34.8158],
    [-80.4172, 34.8155],
    [-80.3999, 34.8151],
    [-80.3047, 34.8139],
    [-80.2340, 34.8129],
    [-80.1593, 34.8114],
    [-80.0990, 34.8101],
    [-80.0772, 34.8097],
    [-80.0431, 34.8091],
    [-80.0133, 34.8084],
    [-79.9851, 34.8078],
    [-79.9280, 34.8066],
    [-79.8914, 34.8058],
    [-79.7737, 34.8059],
    [-79.7631, 34.8059],
    [-79.7123, 34.8052],
    [-79.6881, 34.8049],
    [-79.6342, 34.7710],
    [-79.6098, 34.7511],
    [-79.5547, 34.7066],
    [-79.5203, 34.6783],
    [-79.4902, 34.6538],
    [-79.4716, 34.6372],
    [-79.4613, 34.6301],
    [-79.4196, 34.5959],
    [-79.3656, 34.5514],
    [-79.3313, 34.5219],
    [-79.3166, 34.5090],
    [-79.2867, 34.4827],
    [-79.2449, 34.4456],
    [-79.2153, 34.4205],
    [-79.1922, 34.4011],
    [-79.1515, 34.3668],
    [-79.1088, 34.3309],
    [-79.0712, 34.2992],
    [-78.9814, 34.2239],
    [-78.9217, 34.1738],
    [-78.8921, 34.1490],
    [-78.8747, 34.1344],
    [-78.8554, 34.1180],
    [-78.8117, 34.0810],
    [-78.7695, 34.0452],
    [-78.7101, 33.9947],
    [-78.6516, 33.9454],
    [-78.6503, 33.9443],
    [-78.6214, 33.9201],
    [-78.5949, 33.8974],
    [-78.5869, 33.8905],
    [-78.5733, 33.8788],
    [-78.5472, 33.8564],
    [-78.5498, 33.8490],
    [-78.5614, 33.8485],
    [-78.5848, 33.8443],
    [-78.6287, 33.8309],
    [-78.6623, 33.8206],
    [-78.6723, 33.8176],
    [-78.7102, 33.8018],
    [-78.7141, 33.8001],
    [-78.7290, 33.7921],
    [-78.7414, 33.7854],
    [-78.7714, 33.7692],
    [-78.7939, 33.7553],
    [-78.8129, 33.7435],
    [-78.8256, 33.7339],
    [-78.8629, 33.7057],
    [-78.8796, 33.6907],
    [-78.8924, 33.6792],
    [-78.9143, 33.6604],
    [-78.9381, 33.6398],
    [-78.9710, 33.6050],
    [-78.9881, 33.5869],
    [-78.9981, 33.5764],
    [-79.0226, 33.5426],
    [-79.0369, 33.5242],
    [-79.0649, 33.5014],
    [-79.0846, 33.4837],
    [-79.1014, 33.4610],
    [-79.1110, 33.4439],
    [-79.1139, 33.4398],
    [-79.1354, 33.4039],
    [-79.1403, 33.3934],
    [-79.1475, 33.3782],
    [-79.1629, 33.3286],
    [-79.1704, 33.3279],
    [-79.1636, 33.3197],
    [-79.1623, 33.3083],
    [-79.1682, 33.3031],
    [-79.1789, 33.2605],
    [-79.1806, 33.2380],
    [-79.1832, 33.1969],
    [-79.1915, 33.1733],
    [-79.2237, 33.1498],
    [-79.2464, 33.1260],
    [-79.2765, 33.1164],
    [-79.2916, 33.1098],
    [-79.3234, 33.0926],
    [-79.3319, 33.0810],
    [-79.3359, 33.0703],
    [-79.3598, 33.0196],
    [-79.3800, 33.0094],
    [-79.4165, 33.0068],
    [-79.4116, 33.0103],
    [-79.4006, 33.0175],
    [-79.4073, 33.0144],
    [-79.4706, 33.0101],
    [-79.4893, 33.0140],
    [-79.5069, 33.0328],
    [-79.5321, 33.0352],
    [-79.5350, 33.0285],
    [-79.5514, 33.0240],
    [-79.5632, 33.0177],
    [-79.5760, 33.0092],
    [-79.5813, 33.0027],
    [-79.5866, 32.9913],
    [-79.5987, 32.9796],
    [-79.6055, 32.9684],
    [-79.6176, 32.9527],
    [-79.6062, 32.9260],
    [-79.5861, 32.9295],
    [-79.5800, 32.9335],
    [-79.5741, 32.9325],
    [-79.5781, 32.9104],
    [-79.6270, 32.8901],
    [-79.6418, 32.8812],
    [-79.6559, 32.8759],
    [-79.6934, 32.8528],
    [-79.6992, 32.8476],
    [-79.7101, 32.8334],
    [-79.7199, 32.8258],
    [-79.7182, 32.8176],
    [-79.7264, 32.8060],
    [-79.7565, 32.7966],
    [-79.7916, 32.7823],
    [-79.8125, 32.7748],
    [-79.8182, 32.7664],
    [-79.8240, 32.7627],
    [-79.8400, 32.7570],
    [-79.8547, 32.7549],
    [-79.8653, 32.7679],
    [-79.8634, 32.7710],
    [-79.8780, 32.7857],
    [-79.8912, 32.7868],
    [-79.9172, 32.7829],
    [-79.9244, 32.7750],
    [-79.9288, 32.7691],
    [-79.9268, 32.7538],
    [-79.9180, 32.7544],
    [-79.9089, 32.7516],
    [-79.9051, 32.7513],
    [-79.8986, 32.7530],
    [-79.8964, 32.7497],
    [-79.8904, 32.7510],
    [-79.8709, 32.7424],
    [-79.8710, 32.7289],
    [-79.8836, 32.7093],
    [-79.8880, 32.6952],
    [-79.8880, 32.6902],
    [-79.8871, 32.6830],
    [-79.9181, 32.6638],
    [-79.9438, 32.6523],
    [-79.9743, 32.6410],
    [-79.9831, 32.6297],
    [-79.9884, 32.6215],
    [-79.9922, 32.6110],
    [-80.0105, 32.6089],
    [-80.0370, 32.6102],
    [-80.0678, 32.6049],
    [-80.0777, 32.6032],
    [-80.1001, 32.5976],
    [-80.1220, 32.5902],
    [-80.1399, 32.5803],
    [-80.1519, 32.5735],
    [-80.1673, 32.5597],
    [-80.1801, 32.5602],
    [-80.2052, 32.5555],
    [-80.2529, 32.5315],
    [-80.2804, 32.5143],
    [-80.2997, 32.5008],
    [-80.3384, 32.4787],
    [-80.3452, 32.4918],
    [-80.3545, 32.4975],
    [-80.3690, 32.4918],
    [-80.3760, 32.4880],
    [-80.3894, 32.4793],
    [-80.4135, 32.4707],
    [-80.4191, 32.4790],
    [-80.4205, 32.4929],
    [-80.4309, 32.5009],
    [-80.4479, 32.5035],
    [-80.4548, 32.5033],
    [-80.4721, 32.4970],
    [-80.4778, 32.4720],
    [-80.4823, 32.4618],
    [-80.4801, 32.4478],
    [-80.4696, 32.4338],
    [-80.4575, 32.4103],
    [-80.4407, 32.4134],
    [-80.4292, 32.4055],
    [-80.4223, 32.4015],
    [-80.4293, 32.3897],
    [-80.4442, 32.3549],
    [-80.4530, 32.3225],
    [-80.4694, 32.3162],
    [-80.5012, 32.3056],
    [-80.5200, 32.2994],
    [-80.5545, 32.2815],
    [-80.5861, 32.2753],
    [-80.5950, 32.2797],
    [-80.6090, 32.2679],
    [-80.6237, 32.2581],
    [-80.6454, 32.2609],
    [-80.6430, 32.2728],
    [-80.6448, 32.2915],
    [-80.6738, 32.2964],
    [-80.6885, 32.3028],
    [-80.7081, 32.3237],
    [-80.7222, 32.3247],
    [-80.7388, 32.3138],
    [-80.7397, 32.3052],
    [-80.7468, 32.3055],
    [-80.7660, 32.2926],
    [-80.7554, 32.2759],
    [-80.7438, 32.2661],
    [-80.7405, 32.2639],
    [-80.7318, 32.2688],
    [-80.7271, 32.2706],
    [-80.7178, 32.2670],
    [-80.6978, 32.2502],
    [-80.6823, 32.2405],
    [-80.6722, 32.2295],
    [-80.6692, 32.2168],
    [-80.6778, 32.2091],
    [-80.6884, 32.2008],
    [-80.7002, 32.1873],
    [-80.7169, 32.1643],
    [-80.7301, 32.1521],
    [-80.7468, 32.1418],
    [-80.7703, 32.1320],
    [-80.8057, 32.1136],
    [-80.8215, 32.1086],
    [-80.8332, 32.1148],
    [-80.8480, 32.1089],
    [-80.8646, 32.0927],
    [-80.8761, 32.0818],
    [-80.8857, 32.0761],
    [-80.8919, 32.0675],
    [-80.8966, 32.0600],
    [-80.9054, 32.0519],
    [-80.8974, 32.0455],
    [-80.8923, 32.0438],
    [-80.8872, 32.0387],
    [-80.8930, 32.0349],
    [-80.9228, 32.0392],
    [-80.9432, 32.0578],
    [-80.9788, 32.0773],
    [-80.9917, 32.0912],
    [-81.0023, 32.1000],
    [-81.0160, 32.0974],
    [-81.0327, 32.0855],
    [-81.0502, 32.0853],
    [-81.0835, 32.1008],
    [-81.0909, 32.1070],
    [-81.1005, 32.1112],
    [-81.1172, 32.1176],
    [-81.1161, 32.1287],
    [-81.1199, 32.1340],
    [-81.1173, 32.1462],
    [-81.1122, 32.1508],
    [-81.1200, 32.1533],
    [-81.1231, 32.1629],
    [-81.1296, 32.1658],
    [-81.1245, 32.1721],
    [-81.1138, 32.1713],
    [-81.1146, 32.1769],
    [-81.1198, 32.1812],
    [-81.1204, 32.1908],
    [-81.1154, 32.1932],
    [-81.1198, 32.1956],
    [-81.1283, 32.2086],
    [-81.1367, 32.2163],
    [-81.1500, 32.2211],
    [-81.1448, 32.2260],
    [-81.1455, 32.2319],
    [-81.1560, 32.2415],
    [-81.1529, 32.2478],
    [-81.1473, 32.2534],
    [-81.1457, 32.2574],
    [-81.1467, 32.2616],
    [-81.1426, 32.2639],
    [-81.1369, 32.2661],
    [-81.1421, 32.2706],
    [-81.1357, 32.2722],
    [-81.1318, 32.2719],
    [-81.1273, 32.2759],
    [-81.1232, 32.2765],
    [-81.1264, 32.2807],
    [-81.1214, 32.2845],
    [-81.1196, 32.2877],
    [-81.1227, 32.2973],
    [-81.1239, 32.3087],
    [-81.1315, 32.3073],
    [-81.1298, 32.3133],
    [-81.1318, 32.3264],
    [-81.1376, 32.3282],
    [-81.1286, 32.3370],
    [-81.1409, 32.3494],
    [-81.1440, 32.3511],
    [-81.1452, 32.3453],
    [-81.1533, 32.3413],
    [-81.1605, 32.3417],
    [-81.1551, 32.3445],
    [-81.1550, 32.3501],
    [-81.1608, 32.3541],
    [-81.1709, 32.3627],
    [-81.1687, 32.3675],
    [-81.1803, 32.3796],
    [-81.1772, 32.3917],
    [-81.1949, 32.4115],
    [-81.2084, 32.4360],
    [-81.2026, 32.4398],
    [-81.2005, 32.4458],
    [-81.2066, 32.4475],
    [-81.2003, 32.4502],
    [-81.1975, 32.4548],
    [-81.1928, 32.4534],
    [-81.1946, 32.4578],
    [-81.1873, 32.4629],
    [-81.1892, 32.4656],
    [-81.2000, 32.4680],
    [-81.2336, 32.4985],
    [-81.2384, 32.5102],
    [-81.2340, 32.5138],
    [-81.2450, 32.5183],
    [-81.2529, 32.5183],
    [-81.2684, 32.5285],
    [-81.2750, 32.5343],
    [-81.2794, 32.5378],
    [-81.2748, 32.5411],
    [-81.2762, 32.5458],
    [-81.2810, 32.5497],
    [-81.2792, 32.5546],
    [-81.2833, 32.5568],
    [-81.2847, 32.5529],
    [-81.2899, 32.5524],
    [-81.2896, 32.5617],
    [-81.2934, 32.5613],
    [-81.2914, 32.5559],
    [-81.2967, 32.5534],
    [-81.2959, 32.5585],
    [-81.2980, 32.5630],
    [-81.3206, 32.5595],
    [-81.3583, 32.5745],
    [-81.3595, 32.5822],
    [-81.3670, 32.5771],
    [-81.3636, 32.5818],
    [-81.3684, 32.5842],
    [-81.3690, 32.5900],
    [-81.3732, 32.5921],
    [-81.3810, 32.5897],
    [-81.3939, 32.6023],
    [-81.4119, 32.6184],
    [-81.4184, 32.6347],
    [-81.4134, 32.6374],
    [-81.4093, 32.6311],
    [-81.4027, 32.6370],
    [-81.4126, 32.6415],
    [-81.4036, 32.6434],
    [-81.3938, 32.6535],
    [-81.4072, 32.6605],
    [-81.4065, 32.6625],
    [-81.4003, 32.6585],
    [-81.4005, 32.6641],
    [-81.4012, 32.6799],
    [-81.4095, 32.6956],
    [-81.4111, 32.6936],
    [-81.4134, 32.6947],
    [-81.4248, 32.7005],
    [-81.4200, 32.7124],
    [-81.4151, 32.7137],
    [-81.4193, 32.7184],
    [-81.4188, 32.7219],
    [-81.4098, 32.7225],
    [-81.4146, 32.7243],
    [-81.4168, 32.7288],
    [-81.4187, 32.7318],
    [-81.4147, 32.7321],
    [-81.4135, 32.7364],
    [-81.4117, 32.7392],
    [-81.4057, 32.7425],
    [-81.4053, 32.7488],
    [-81.4197, 32.7492],
    [-81.4130, 32.7548],
    [-81.4152, 32.7616],
    [-81.4180, 32.7670],
    [-81.4291, 32.7679],
    [-81.4315, 32.7715],
    [-81.4226, 32.7730],
    [-81.4163, 32.7755],
    [-81.4216, 32.7786],
    [-81.4300, 32.7852],
    [-81.4251, 32.7862],
    [-81.4197, 32.7932],
    [-81.4252, 32.7942],
    [-81.4269, 32.8022],
    [-81.4222, 32.8031],
    [-81.4263, 32.8099],
    [-81.4198, 32.8137],
    [-81.4186, 32.8187],
    [-81.4271, 32.8169],
    [-81.4269, 32.8197],
    [-81.4220, 32.8215],
    [-81.4295, 32.8271],
    [-81.4237, 32.8283],
    [-81.4216, 32.8352],
    [-81.4357, 32.8427],
    [-81.4427, 32.8501],
    [-81.4483, 32.8496],
    [-81.4555, 32.8470],
    [-81.4530, 32.8596],
    [-81.4529, 32.8730],
    [-81.4634, 32.8794],
    [-81.4704, 32.8763],
    [-81.4771, 32.8875],
    [-81.4647, 32.8960],
    [-81.4690, 32.9011],
    [-81.4755, 32.8967],
    [-81.4794, 32.9023],
    [-81.4800, 32.9134],
    [-81.4873, 32.9179],
    [-81.4951, 32.9316],
    [-81.5027, 32.9387],
    [-81.5040, 32.9481],
    [-81.5100, 32.9573],
    [-81.5113, 32.9667],
    [-81.5078, 32.9689],
    [-81.5014, 32.9629],
    [-81.4947, 32.9790],
    [-81.4955, 32.9835],
    [-81.4943, 32.9863],
    [-81.4964, 32.9896],
    [-81.4934, 32.9924],
    [-81.4912, 32.9977],
    [-81.4957, 32.9995],
    [-81.5002, 33.0035],
    [-81.4961, 33.0055],
    [-81.4923, 33.0093],
    [-81.5020, 33.0151],
    [-81.5067, 33.0151],
    [-81.5107, 33.0103],
    [-81.5082, 33.0175],
    [-81.5137, 33.0206],
    [-81.5191, 33.0232],
    [-81.5117, 33.0245],
    [-81.5132, 33.0285],
    [-81.5285, 33.0356],
    [-81.5291, 33.0408],
    [-81.5388, 33.0392],
    [-81.5438, 33.0486],
    [-81.5531, 33.0432],
    [-81.5650, 33.0497],
    [-81.5589, 33.0529],
    [-81.5613, 33.0556],
    [-81.5633, 33.0556],
    [-81.5689, 33.0535],
    [-81.5810, 33.0627],
    [-81.5907, 33.0712],
    [-81.5992, 33.0718],
    [-81.5994, 33.0769],
    [-81.6002, 33.0840],
    [-81.6068, 33.0817],
    [-81.6101, 33.0829],
    [-81.6095, 33.0899],
    [-81.6143, 33.0947],
    [-81.6322, 33.0940],
    [-81.6464, 33.0946],
    [-81.6969, 33.1166],
    [-81.7046, 33.1165],
    [-81.7243, 33.1295],
    [-81.7631, 33.1594],
    [-81.7735, 33.1805],
    [-81.7650, 33.1784],
    [-81.7662, 33.1874],
    [-81.7569, 33.1978],
    [-81.7616, 33.2017],
    [-81.7689, 33.2174],
    [-81.7801, 33.2211],
    [-81.7775, 33.2113],
    [-81.7902, 33.2084],
    [-81.8079, 33.2137],
    [-81.8117, 33.2238],
    [-81.8316, 33.2333],
    [-81.8465, 33.2417],
    [-81.8530, 33.2498],
    [-81.8396, 33.2552],
    [-81.8482, 33.2617],
    [-81.8425, 33.2666],
    [-81.8350, 33.2593],
    [-81.8279, 33.2637],
    [-81.8350, 33.2635],
    [-81.8317, 33.2733],
    [-81.8356, 33.2751],
    [-81.8404, 33.2737],
    [-81.8446, 33.2835],
    [-81.8518, 33.2835],
    [-81.8615, 33.2979],
    [-81.8496, 33.2980],
    [-81.8473, 33.3068],
    [-81.8591, 33.3060],
    [-81.8640, 33.3078],
    [-81.8665, 33.3137],
    [-81.8784, 33.3032],
    [-81.8841, 33.3104],
    [-81.8852, 33.3174],
    [-81.8927, 33.3167],
    [-81.8910, 33.3225],
    [-81.8993, 33.3254],
    [-81.8988, 33.3321],
    [-81.9036, 33.3348],
    [-81.9064, 33.3242],
    [-81.9109, 33.3193],
    [-81.9102, 33.3248],
    [-81.9133, 33.3295],
    [-81.9176, 33.3356],
    [-81.9105, 33.3423],
    [-81.9088, 33.3473],
    [-81.9156, 33.3437],
    [-81.9327, 33.3435],
    [-81.9398, 33.3477],
    [-81.9348, 33.3560],
    [-81.9464, 33.3704],
    [-81.9396, 33.3725],
    [-81.9257, 33.3711],
    [-81.9355, 33.3979],
    [-81.9374, 33.4075],
    [-81.9131, 33.4080],
    [-81.9211, 33.4174],
    [-81.9308, 33.4290],
    [-81.9162, 33.4331],
    [-81.9135, 33.4396],
    [-81.9248, 33.4599],
    [-81.9294, 33.4658],
    [-81.9464, 33.4717],
    [-81.9554, 33.4756],
    [-81.9736, 33.4827],
    [-81.9859, 33.4865],
    [-81.9906, 33.4981],
    [-81.9953, 33.5100],
    [-82.0043, 33.5219],
    [-82.0100, 33.5304],
    [-82.0120, 33.5319],
    [-82.0234, 33.5407],
    [-82.0349, 33.5492],
    [-82.0463, 33.5638],
    [-82.0549, 33.5654],
    [-82.0690, 33.5754],
    [-82.0875, 33.5806],
    [-82.0988, 33.5864],
    [-82.1153, 33.5965],
    [-82.1232, 33.5927],
    [-82.1335, 33.5905],
    [-82.1451, 33.5957],
    [-82.1534, 33.6063],
    [-82.1619, 33.6106],
    [-82.1799, 33.6159],
    [-82.2012, 33.6469],
    [-82.1998, 33.6618],
    [-82.2108, 33.6706],
    [-82.2186, 33.6863],
    [-82.2346, 33.7002],
    [-82.2391, 33.7309],
    [-82.2462, 33.7463],
    [-82.2580, 33.7604],
    [-82.2644, 33.7635],
    [-82.2677, 33.7677],
    [-82.2782, 33.7726],
    [-82.2898, 33.7820],
    [-82.2983, 33.7835],
    [-82.2989, 33.7958],
    [-82.3029, 33.8029],
    [-82.3147, 33.8115],
    [-82.3378, 33.8272],
    [-82.3563, 33.8380],
    [-82.3718, 33.8438],
    [-82.3850, 33.8544],
    [-82.4005, 33.8633],
    [-82.4143, 33.8653],
    [-82.4292, 33.8658],
    [-82.4405, 33.8751],
    [-82.4592, 33.8862],
    [-82.4801, 33.9019],
    [-82.5036, 33.9260],
    [-82.5245, 33.9434],
    [-82.5398, 33.9416],
    [-82.5568, 33.9454],
    [-82.5657, 33.9587],
    [-82.5699, 33.9707],
    [-82.5796, 33.9798],
    [-82.5800, 33.9870],
    [-82.5754, 33.9909],
    [-82.5777, 33.9937],
    [-82.5892, 34.0001],
    [-82.5957, 34.0161],
    [-82.5946, 34.0287],
    [-82.6097, 34.0399],
    [-82.6210, 34.0544],
    [-82.6270, 34.0635],
    [-82.6360, 34.0649],
    [-82.6457, 34.0760],
    [-82.6442, 34.0800],
    [-82.6402, 34.0876],
    [-82.6410, 34.0909],
    [-82.6482, 34.0986],
    [-82.6586, 34.1031],
    [-82.6619, 34.1078],
    [-82.6752, 34.1298],
    [-82.6904, 34.1383],
    [-82.6998, 34.1393],
    [-82.7175, 34.1505],
    [-82.7254, 34.1698],
    [-82.7324, 34.1806],
    [-82.7419, 34.2101],
    [-82.7405, 34.2184],
    [-82.7435, 34.2273],
    [-82.7450, 34.2449],
    [-82.7453, 34.2553],
    [-82.7467, 34.2664],
    [-82.7620, 34.2815],
    [-82.7709, 34.2854],
    [-82.7818, 34.3029],
    [-82.7912, 34.3249],
    [-82.7941, 34.3398],
    [-82.8099, 34.3500],
    [-82.8333, 34.3640],
    [-82.8350, 34.3664],
    [-82.8366, 34.3827],
    [-82.8413, 34.3973],
    [-82.8466, 34.4101],
    [-82.8478, 34.4206],
    [-82.8514, 34.4268],
    [-82.8558, 34.4440],
    [-82.8588, 34.4552],
    [-82.8718, 34.4612],
    [-82.8808, 34.4709],
    [-82.8926, 34.4812],
    [-82.9207, 34.4823],
    [-82.9409, 34.4861],
    [-82.9482, 34.4805],
    [-82.9632, 34.4844],
    [-82.9749, 34.4793],
    [-82.9922, 34.4792],
    [-82.9951, 34.4725],
    [-83.0286, 34.4838],
    [-83.0347, 34.4835],
    [-83.0510, 34.4935],
    [-83.0535, 34.4973],
    [-83.0578, 34.5037],
    [-83.0740, 34.5055],
    [-83.0798, 34.5145],
    [-83.0869, 34.5178],
    [-83.0794, 34.5261],
    [-83.0926, 34.5329],
    [-83.1022, 34.5322],
    [-83.1057, 34.5412],
    [-83.1219, 34.5523],
    [-83.1229, 34.5601],
    [-83.1334, 34.5595],
    [-83.1399, 34.5680],
    [-83.1542, 34.5780],
    [-83.1592, 34.5802],
    [-83.1552, 34.5863],
    [-83.1554, 34.5891],
    [-83.1703, 34.5924],
    [-83.1699, 34.5995],
    [-83.1602, 34.5992],
    [-83.1633, 34.6051],
    [-83.1794, 34.6080],
    [-83.1927, 34.6033],
    [-83.1998, 34.6084],
    [-83.2271, 34.6107],
    [-83.2415, 34.6163],
    [-83.2405, 34.6222],
    [-83.2423, 34.6258],
    [-83.2553, 34.6377],
    [-83.2799, 34.6469],
    [-83.2929, 34.6542],
    [-83.3046, 34.6696],
    [-83.3164, 34.6693],
    [-83.3215, 34.6775],
    [-83.3371, 34.6801],
    [-83.3384, 34.6869],
    [-83.3401, 34.6915],
    [-83.3539, 34.6992]
    ]
  },
  "New Hampshire": {
    coordinates: [
      [-72.5572, 42.8530],
    [-72.5542, 42.8600],
    [-72.5562, 42.8667],
    [-72.5554, 42.8754],
    [-72.5465, 42.8871],
    [-72.5328, 42.8961],
    [-72.5316, 42.9072],
    [-72.5253, 42.9144],
    [-72.5271, 42.9286],
    [-72.5266, 42.9399],
    [-72.5298, 42.9461],
    [-72.5346, 42.9499],
    [-72.5209, 42.9617],
    [-72.5042, 42.9658],
    [-72.4817, 42.9740],
    [-72.4738, 42.9720],
    [-72.4616, 42.9840],
    [-72.4647, 42.9936],
    [-72.4569, 43.0013],
    [-72.4450, 43.0044],
    [-72.4446, 43.0106],
    [-72.4590, 43.0194],
    [-72.4624, 43.0256],
    [-72.4603, 43.0407],
    [-72.4668, 43.0492],
    [-72.4638, 43.0574],
    [-72.4507, 43.0668],
    [-72.4362, 43.0817],
    [-72.4352, 43.0866],
    [-72.4424, 43.1036],
    [-72.4331, 43.1126],
    [-72.4359, 43.1234],
    [-72.4410, 43.1276],
    [-72.4408, 43.1315],
    [-72.4409, 43.1358],
    [-72.4483, 43.1372],
    [-72.4571, 43.1485],
    [-72.4518, 43.1535],
    [-72.4521, 43.1614],
    [-72.4514, 43.1730],
    [-72.4437, 43.1822],
    [-72.4390, 43.2010],
    [-72.4406, 43.2153],
    [-72.4355, 43.2288],
    [-72.4338, 43.2331],
    [-72.4342, 43.2350],
    [-72.4387, 43.2529],
    [-72.4277, 43.2612],
    [-72.4154, 43.2714],
    [-72.3955, 43.3130],
    [-72.4025, 43.3204],
    [-72.4104, 43.3317],
    [-72.4066, 43.3378],
    [-72.3954, 43.3504],
    [-72.3901, 43.3569],
    [-72.4039, 43.3581],
    [-72.4151, 43.3659],
    [-72.4132, 43.3843],
    [-72.4038, 43.3919],
    [-72.4001, 43.4110],
    [-72.3964, 43.4289],
    [-72.3940, 43.4447],
    [-72.3926, 43.4651],
    [-72.3905, 43.4696],
    [-72.3830, 43.4760],
    [-72.3805, 43.4883],
    [-72.3809, 43.4934],
    [-72.3963, 43.5081],
    [-72.3964, 43.5191],
    [-72.3959, 43.5239],
    [-72.3891, 43.5283],
    [-72.3812, 43.5549],
    [-72.3794, 43.5741],
    [-72.3639, 43.5837],
    [-72.3324, 43.5994],
    [-72.3285, 43.6008],
    [-72.3282, 43.6068],
    [-72.3347, 43.6145],
    [-72.3290, 43.6270],
    [-72.3295, 43.6328],
    [-72.3295, 43.6349],
    [-72.3225, 43.6389],
    [-72.3139, 43.6466],
    [-72.3140, 43.6562],
    [-72.3091, 43.6620],
    [-72.3034, 43.6741],
    [-72.3060, 43.6831],
    [-72.3055, 43.6925],
    [-72.3012, 43.7047],
    [-72.2922, 43.7113],
    [-72.2825, 43.7223],
    [-72.2712, 43.7341],
    [-72.2451, 43.7431],
    [-72.2221, 43.7598],
    [-72.2165, 43.7665],
    [-72.2052, 43.7709],
    [-72.2055, 43.7823],
    [-72.1970, 43.7900],
    [-72.1908, 43.8008],
    [-72.1841, 43.8119],
    [-72.1886, 43.8212],
    [-72.1833, 43.8307],
    [-72.1874, 43.8536],
    [-72.1830, 43.8653],
    [-72.1675, 43.8691],
    [-72.1698, 43.8734],
    [-72.1728, 43.8837],
    [-72.1695, 43.8863],
    [-72.1592, 43.8883],
    [-72.1513, 43.9017],
    [-72.1315, 43.9123],
    [-72.1180, 43.9233],
    [-72.1190, 43.9432],
    [-72.1153, 43.9476],
    [-72.1044, 43.9505],
    [-72.0987, 43.9577],
    [-72.1005, 43.9625],
    [-72.0902, 43.9658],
    [-72.1050, 43.9699],
    [-72.1143, 43.9675],
    [-72.1131, 43.9728],
    [-72.1118, 43.9849],
    [-72.1170, 43.9945],
    [-72.1036, 44.0042],
    [-72.1025, 44.0149],
    [-72.0934, 44.0104],
    [-72.0901, 44.0099],
    [-72.0952, 44.0167],
    [-72.0941, 44.0232],
    [-72.0849, 44.0213],
    [-72.0819, 44.0270],
    [-72.0796, 44.0299],
    [-72.0750, 44.0328],
    [-72.0796, 44.0414],
    [-72.0749, 44.0459],
    [-72.0627, 44.0516],
    [-72.0676, 44.0580],
    [-72.0589, 44.0579],
    [-72.0535, 44.0647],
    [-72.0485, 44.0725],
    [-72.0525, 44.0767],
    [-72.0432, 44.0795],
    [-72.0385, 44.0769],
    [-72.0327, 44.0774],
    [-72.0304, 44.0793],
    [-72.0372, 44.0837],
    [-72.0441, 44.0876],
    [-72.0362, 44.0885],
    [-72.0313, 44.0922],
    [-72.0305, 44.1002],
    [-72.0392, 44.1039],
    [-72.0435, 44.0980],
    [-72.0483, 44.0969],
    [-72.0531, 44.1036],
    [-72.0526, 44.1191],
    [-72.0419, 44.1257],
    [-72.0375, 44.1247],
    [-72.0379, 44.1338],
    [-72.0429, 44.1513],
    [-72.0411, 44.1543],
    [-72.0386, 44.1561],
    [-72.0429, 44.1567],
    [-72.0424, 44.1608],
    [-72.0466, 44.1614],
    [-72.0515, 44.1662],
    [-72.0613, 44.1850],
    [-72.0636, 44.1985],
    [-72.0581, 44.2061],
    [-72.0529, 44.2179],
    [-72.0536, 44.2260],
    [-72.0485, 44.2412],
    [-72.0597, 44.2558],
    [-72.0604, 44.2650],
    [-72.0585, 44.2679],
    [-72.0645, 44.2680],
    [-72.0654, 44.2772],
    [-72.0534, 44.2905],
    [-72.0390, 44.2965],
    [-72.0335, 44.3019],
    [-72.0323, 44.3158],
    [-72.0291, 44.3224],
    [-72.0145, 44.3210],
    [-71.9883, 44.3298],
    [-71.9846, 44.3362],
    [-71.9581, 44.3375],
    [-71.9354, 44.3358],
    [-71.9174, 44.3465],
    [-71.8819, 44.3402],
    [-71.8699, 44.3370],
    [-71.8450, 44.3439],
    [-71.8333, 44.3501],
    [-71.8144, 44.3545],
    [-71.8125, 44.3585],
    [-71.8155, 44.3688],
    [-71.8124, 44.3725],
    [-71.8144, 44.3819],
    [-71.8035, 44.3833],
    [-71.8035, 44.3904],
    [-71.7939, 44.3993],
    [-71.7754, 44.4011],
    [-71.7657, 44.4063],
    [-71.7561, 44.4064],
    [-71.7450, 44.4014],
    [-71.7399, 44.4068],
    [-71.7359, 44.4101],
    [-71.7151, 44.4105],
    [-71.6888, 44.4217],
    [-71.6803, 44.4277],
    [-71.6760, 44.4287],
    [-71.6793, 44.4350],
    [-71.6642, 44.4384],
    [-71.6590, 44.4449],
    [-71.6523, 44.4611],
    [-71.6404, 44.4642],
    [-71.6479, 44.4700],
    [-71.6459, 44.4751],
    [-71.6328, 44.4839],
    [-71.6257, 44.4832],
    [-71.6332, 44.4789],
    [-71.6241, 44.4751],
    [-71.6159, 44.4859],
    [-71.5995, 44.4865],
    [-71.5955, 44.4944],
    [-71.5919, 44.5010],
    [-71.5896, 44.4985],
    [-71.5866, 44.5029],
    [-71.5788, 44.5019],
    [-71.5778, 44.5049],
    [-71.5859, 44.5134],
    [-71.5940, 44.5197],
    [-71.5871, 44.5224],
    [-71.5769, 44.5303],
    [-71.5731, 44.5380],
    [-71.5968, 44.5534],
    [-71.5961, 44.5609],
    [-71.5902, 44.5657],
    [-71.5634, 44.5632],
    [-71.5590, 44.5688],
    [-71.5565, 44.5708],
    [-71.5497, 44.5707],
    [-71.5533, 44.5769],
    [-71.5543, 44.5810],
    [-71.5479, 44.5773],
    [-71.5389, 44.5813],
    [-71.5346, 44.5874],
    [-71.5356, 44.5882],
    [-71.5397, 44.5899],
    [-71.5379, 44.5942],
    [-71.5458, 44.5909],
    [-71.5455, 44.5936],
    [-71.5461, 44.5974],
    [-71.5534, 44.5935],
    [-71.5535, 44.5983],
    [-71.5516, 44.6012],
    [-71.5615, 44.6008],
    [-71.5559, 44.6033],
    [-71.5539, 44.6107],
    [-71.5551, 44.6242],
    [-71.5469, 44.6219],
    [-71.5494, 44.6255],
    [-71.5573, 44.6284],
    [-71.5469, 44.6285],
    [-71.5521, 44.6301],
    [-71.5626, 44.6373],
    [-71.5580, 44.6418],
    [-71.5618, 44.6502],
    [-71.5676, 44.6536],
    [-71.5722, 44.6504],
    [-71.5763, 44.6532],
    [-71.5830, 44.6566],
    [-71.5866, 44.6611],
    [-71.5846, 44.6654],
    [-71.5845, 44.6702],
    [-71.5830, 44.6748],
    [-71.5963, 44.6791],
    [-71.5942, 44.6838],
    [-71.5969, 44.6949],
    [-71.5987, 44.6980],
    [-71.6008, 44.7008],
    [-71.6049, 44.7081],
    [-71.6185, 44.7239],
    [-71.6191, 44.7293],
    [-71.6249, 44.7290],
    [-71.6251, 44.7371],
    [-71.6311, 44.7487],
    [-71.6319, 44.7525],
    [-71.6179, 44.7559],
    [-71.6118, 44.7643],
    [-71.6022, 44.7710],
    [-71.5959, 44.7763],
    [-71.5930, 44.7828],
    [-71.5789, 44.7861],
    [-71.5731, 44.7979],
    [-71.5692, 44.8088],
    [-71.5755, 44.8161],
    [-71.5651, 44.8247],
    [-71.5623, 44.8246],
    [-71.5537, 44.8361],
    [-71.5527, 44.8420],
    [-71.5568, 44.8488],
    [-71.5483, 44.8555],
    [-71.5502, 44.8616],
    [-71.5401, 44.8686],
    [-71.5289, 44.8769],
    [-71.5224, 44.8808],
    [-71.5141, 44.8931],
    [-71.5086, 44.8977],
    [-71.5011, 44.9044],
    [-71.4966, 44.9036],
    [-71.4949, 44.9043],
    [-71.4960, 44.9089],
    [-71.4931, 44.9104],
    [-71.4944, 44.9118],
    [-71.4999, 44.9112],
    [-71.5008, 44.9145],
    [-71.5152, 44.9273],
    [-71.5218, 44.9381],
    [-71.5169, 44.9397],
    [-71.5155, 44.9435],
    [-71.5162, 44.9646],
    [-71.5202, 44.9635],
    [-71.5217, 44.9657],
    [-71.5316, 44.9760],
    [-71.5409, 44.9838],
    [-71.5384, 44.9873],
    [-71.5351, 44.9894],
    [-71.5368, 44.9928],
    [-71.5296, 44.9999],
    [-71.5146, 45.0040],
    [-71.5050, 45.0082],
    [-71.4883, 45.0012],
    [-71.4779, 45.0075],
    [-71.4662, 45.0120],
    [-71.5011, 45.0133],
    [-71.5010, 45.0160],
    [-71.4999, 45.0263],
    [-71.4911, 45.0437],
    [-71.4995, 45.0447],
    [-71.5051, 45.0515],
    [-71.5005, 45.0519],
    [-71.4967, 45.0613],
    [-71.4979, 45.0706],
    [-71.4927, 45.0714],
    [-71.4871, 45.0756],
    [-71.4802, 45.0813],
    [-71.4808, 45.0836],
    [-71.4714, 45.0842],
    [-71.4648, 45.0930],
    [-71.4583, 45.0988],
    [-71.4493, 45.1045],
    [-71.4504, 45.1100],
    [-71.4417, 45.1131],
    [-71.4324, 45.1205],
    [-71.4268, 45.1297],
    [-71.4289, 45.1357],
    [-71.4372, 45.1423],
    [-71.4305, 45.1501],
    [-71.4240, 45.1593],
    [-71.4220, 45.1675],
    [-71.4145, 45.1792],
    [-71.4106, 45.1862],
    [-71.4053, 45.1960],
    [-71.3978, 45.2036],
    [-71.4033, 45.2153],
    [-71.4156, 45.2180],
    [-71.4172, 45.2213],
    [-71.4282, 45.2271],
    [-71.4406, 45.2350],
    [-71.4439, 45.2371],
    [-71.4385, 45.2390],
    [-71.4293, 45.2342],
    [-71.4171, 45.2356],
    [-71.4070, 45.2415],
    [-71.3919, 45.2372],
    [-71.3849, 45.2334],
    [-71.3798, 45.2406],
    [-71.3719, 45.2463],
    [-71.3592, 45.2509],
    [-71.3568, 45.2572],
    [-71.3622, 45.2647],
    [-71.3607, 45.2698],
    [-71.3517, 45.2692],
    [-71.3364, 45.2731],
    [-71.3317, 45.2800],
    [-71.3184, 45.2847],
    [-71.3069, 45.2889],
    [-71.2965, 45.2992],
    [-71.2862, 45.3007],
    [-71.2826, 45.2993],
    [-71.2792, 45.2950],
    [-71.2649, 45.2934],
    [-71.2638, 45.2827],
    [-71.2595, 45.2724],
    [-71.2455, 45.2689],
    [-71.2363, 45.2611],
    [-71.2330, 45.2516],
    [-71.2258, 45.2517],
    [-71.2118, 45.2505],
    [-71.1983, 45.2543],
    [-71.1917, 45.2497],
    [-71.1875, 45.2450],
    [-71.1826, 45.2411],
    [-71.1786, 45.2414],
    [-71.1713, 45.2461],
    [-71.1582, 45.2487],
    [-71.1482, 45.2424],
    [-71.1394, 45.2430],
    [-71.1280, 45.2537],
    [-71.1199, 45.2623],
    [-71.1166, 45.2697],
    [-71.1132, 45.2749],
    [-71.1057, 45.2825],
    [-71.1107, 45.2846],
    [-71.1044, 45.2918],
    [-71.0895, 45.3046],
    [-71.0769, 45.2469],
    [-71.0597, 45.0146],
    [-71.0572, 44.9906],
    [-71.0494, 44.8960],
    [-71.0433, 44.8287],
    [-71.0367, 44.7365],
    [-71.0310, 44.6555],
    [-71.0230, 44.5001],
    [-71.0175, 44.4152],
    [-71.0128, 44.3409],
    [-71.0103, 44.2849],
    [-71.0088, 44.2584],
    [-71.0013, 44.0932],
    [-70.9984, 44.0411],
    [-70.9968, 44.0039],
    [-70.9947, 43.9574],
    [-70.9927, 43.8962],
    [-70.9899, 43.8392],
    [-70.9890, 43.7921],
    [-70.9821, 43.7150],
    [-70.9819, 43.7010],
    [-70.9757, 43.6251],
    [-70.9701, 43.5685],
    [-70.9572, 43.5614],
    [-70.9533, 43.5527],
    [-70.9534, 43.5444],
    [-70.9553, 43.5409],
    [-70.9588, 43.5406],
    [-70.9633, 43.5389],
    [-70.9626, 43.5343],
    [-70.9572, 43.5250],
    [-70.9540, 43.5188],
    [-70.9554, 43.5114],
    [-70.9580, 43.5080],
    [-70.9659, 43.4924],
    [-70.9690, 43.4840],
    [-70.9691, 43.4802],
    [-70.9709, 43.4739],
    [-70.9644, 43.4733],
    [-70.9640, 43.4568],
    [-70.9658, 43.4476],
    [-70.9612, 43.4383],
    [-70.9688, 43.4349],
    [-70.9710, 43.4256],
    [-70.9829, 43.4193],
    [-70.9868, 43.4143],
    [-70.9858, 43.4016],
    [-70.9829, 43.3948],
    [-70.9877, 43.3914],
    [-70.9860, 43.3842],
    [-70.9843, 43.3768],
    [-70.9815, 43.3734],
    [-70.9749, 43.3580],
    [-70.9708, 43.3505],
    [-70.9640, 43.3419],
    [-70.9572, 43.3363],
    [-70.9515, 43.3347],
    [-70.9322, 43.3346],
    [-70.9239, 43.3248],
    [-70.9154, 43.3199],
    [-70.9125, 43.3083],
    [-70.9066, 43.3049],
    [-70.9004, 43.3014],
    [-70.9074, 43.2936],
    [-70.8973, 43.2927],
    [-70.8992, 43.2875],
    [-70.8902, 43.2842],
    [-70.8837, 43.2775],
    [-70.8816, 43.2725],
    [-70.8726, 43.2702],
    [-70.8703, 43.2663],
    [-70.8646, 43.2655],
    [-70.8638, 43.2653],
    [-70.8632, 43.2651],
    [-70.8596, 43.2573],
    [-70.8520, 43.2568],
    [-70.8392, 43.2512],
    [-70.8413, 43.2487],
    [-70.8373, 43.2423],
    [-70.8267, 43.2413],
    [-70.8233, 43.2403],
    [-70.8178, 43.2377],
    [-70.8155, 43.2290],
    [-70.8112, 43.2274],
    [-70.8097, 43.2246],
    [-70.8160, 43.2157],
    [-70.8204, 43.1976],
    [-70.8193, 43.1930],
    [-70.8272, 43.1895],
    [-70.8248, 43.1797],
    [-70.8240, 43.1733],
    [-70.8283, 43.1690],
    [-70.8338, 43.1469],
    [-70.8293, 43.1325],
    [-70.8200, 43.1226],
    [-70.7939, 43.1067],
    [-70.7791, 43.0959],
    [-70.7664, 43.0927],
    [-70.7608, 43.0860],
    [-70.7526, 43.0793],
    [-70.7408, 43.0764],
    [-70.7203, 43.0747],
    [-70.7038, 43.0598],
    [-70.7118, 43.0503],
    [-70.7189, 43.0324],
    [-70.7304, 43.0254],
    [-70.7344, 43.0133],
    [-70.7438, 43.0080],
    [-70.7453, 42.9993],
    [-70.7500, 42.9917],
    [-70.7567, 42.9913],
    [-70.7619, 42.9858],
    [-70.7643, 42.9738],
    [-70.7718, 42.9681],
    [-70.7717, 42.9613],
    [-70.7804, 42.9558],
    [-70.7866, 42.9474],
    [-70.7912, 42.9424],
    [-70.7978, 42.9300],
    [-70.7982, 42.9209],
    [-70.8060, 42.9165],
    [-70.8101, 42.9095],
    [-70.8108, 42.9037],
    [-70.8110, 42.8924],
    [-70.8157, 42.8845],
    [-70.8218, 42.8719],
    [-70.8308, 42.8689],
    [-70.8489, 42.8611],
    [-70.8835, 42.8811],
    [-70.9145, 42.8866],
    [-70.9149, 42.8866],
    [-70.9308, 42.8846],
    [-70.9553, 42.8736],
    [-70.9972, 42.8643],
    [-71.0312, 42.8591],
    [-71.0475, 42.8441],
    [-71.0642, 42.8063],
    [-71.0997, 42.8141],
    [-71.1325, 42.8214],
    [-71.1656, 42.8087],
    [-71.1744, 42.8016],
    [-71.1847, 42.7920],
    [-71.1829, 42.7510],
    [-71.1978, 42.7410],
    [-71.2082, 42.7433],
    [-71.2136, 42.7445],
    [-71.2334, 42.7455],
    [-71.2552, 42.7366],
    [-71.2754, 42.7160],
    [-71.2888, 42.7020],
    [-71.3135, 42.6971],
    [-71.3516, 42.6981],
    [-71.3652, 42.6985],
    [-71.3869, 42.6990],
    [-71.4324, 42.7001],
    [-71.4577, 42.7007],
    [-71.4881, 42.7014],
    [-71.5427, 42.7027],
    [-71.6306, 42.7048],
    [-71.6519, 42.7052],
    [-71.7269, 42.7069],
    [-71.8054, 42.7089],
    [-71.9288, 42.7122],
    [-71.9814, 42.7133],
    [-72.0777, 42.7162],
    [-72.0893, 42.7166],
    [-72.1454, 42.7182],
    [-72.2860, 42.7216],
    [-72.4292, 42.7260],
    [-72.4585, 42.7269],
    [-72.4678, 42.7412],
    [-72.4759, 42.7577],
    [-72.4849, 42.7655],
    [-72.4911, 42.7725],
    [-72.4988, 42.7720],
    [-72.5080, 42.7644],
    [-72.5161, 42.7659],
    [-72.5102, 42.7732],
    [-72.5089, 42.7799],
    [-72.5158, 42.7886],
    [-72.5396, 42.8048],
    [-72.5438, 42.8190],
    [-72.5457, 42.8258],
    [-72.5474, 42.8376],
    [-72.5563, 42.8514],
    [-72.5572, 42.8530]
    ]
  },
  "Arizona": {
    coordinates: [
      [-114.8163, 32.5080],
    [-114.8077, 32.5087],
    [-114.8021, 32.5148],
    [-114.8104, 32.5184],
    [-114.8119, 32.5232],
    [-114.8064, 32.5312],
    [-114.8048, 32.5417],
    [-114.8039, 32.5480],
    [-114.7938, 32.5523],
    [-114.7920, 32.5607],
    [-114.7919, 32.5668],
    [-114.7942, 32.5691],
    [-114.7977, 32.5644],
    [-114.8089, 32.5585],
    [-114.8142, 32.5648],
    [-114.8044, 32.5729],
    [-114.8039, 32.5809],
    [-114.8004, 32.5881],
    [-114.7997, 32.5936],
    [-114.8059, 32.6007],
    [-114.8094, 32.6171],
    [-114.7976, 32.6246],
    [-114.7819, 32.6251],
    [-114.7813, 32.6315],
    [-114.7745, 32.6359],
    [-114.7633, 32.6446],
    [-114.7649, 32.6494],
    [-114.7480, 32.6642],
    [-114.7453, 32.6722],
    [-114.7300, 32.6997],
    [-114.7196, 32.7188],
    [-114.7152, 32.7289],
    [-114.7136, 32.7316],
    [-114.7007, 32.7456],
    [-114.6843, 32.7375],
    [-114.6675, 32.7342],
    [-114.6583, 32.7338],
    [-114.6460, 32.7324],
    [-114.6245, 32.7294],
    [-114.6184, 32.7282],
    [-114.6157, 32.7294],
    [-114.5832, 32.7349],
    [-114.5817, 32.7423],
    [-114.5515, 32.7497],
    [-114.5391, 32.7569],
    [-114.5284, 32.7673],
    [-114.5317, 32.7825],
    [-114.5288, 32.7963],
    [-114.5198, 32.8057],
    [-114.5016, 32.8201],
    [-114.4941, 32.8233],
    [-114.4828, 32.8329],
    [-114.4690, 32.8452],
    [-114.4657, 32.8794],
    [-114.4629, 32.9079],
    [-114.4737, 32.9206],
    [-114.4809, 32.9353],
    [-114.4740, 32.9451],
    [-114.4677, 32.9563],
    [-114.4677, 32.9669],
    [-114.4710, 32.9741],
    [-114.4813, 32.9721],
    [-114.4929, 32.9718],
    [-114.4973, 32.9915],
    [-114.5061, 33.0170],
    [-114.5165, 33.0276],
    [-114.5385, 33.0334],
    [-114.5752, 33.0365],
    [-114.5848, 33.0282],
    [-114.6010, 33.0254],
    [-114.6283, 33.0311],
    [-114.6416, 33.0469],
    [-114.6550, 33.0371],
    [-114.6623, 33.0327],
    [-114.6737, 33.0419],
    [-114.6870, 33.0710],
    [-114.6886, 33.0829],
    [-114.6946, 33.0862],
    [-114.7065, 33.0882],
    [-114.7062, 33.1053],
    [-114.6900, 33.1379],
    [-114.6823, 33.1552],
    [-114.6802, 33.1697],
    [-114.6754, 33.1855],
    [-114.6787, 33.2034],
    [-114.6736, 33.2231],
    [-114.6827, 33.2349],
    [-114.6882, 33.2480],
    [-114.6724, 33.2605],
    [-114.6844, 33.2760],
    [-114.7112, 33.2833],
    [-114.7233, 33.2881],
    [-114.7299, 33.3057],
    [-114.7080, 33.3234],
    [-114.6980, 33.3524],
    [-114.7073, 33.3766],
    [-114.7084, 33.3841],
    [-114.7253, 33.4023],
    [-114.7238, 33.4065],
    [-114.7017, 33.4084],
    [-114.6965, 33.4141],
    [-114.6739, 33.4183],
    [-114.6495, 33.4136],
    [-114.6352, 33.4227],
    [-114.6223, 33.4476],
    [-114.6125, 33.4708],
    [-114.5997, 33.4843],
    [-114.5916, 33.4994],
    [-114.5738, 33.5075],
    [-114.5606, 33.5183],
    [-114.5589, 33.5318],
    [-114.5244, 33.5537],
    [-114.5360, 33.5692],
    [-114.5327, 33.6020],
    [-114.5292, 33.6067],
    [-114.5224, 33.6142],
    [-114.5312, 33.6239],
    [-114.5264, 33.6303],
    [-114.5254, 33.6407],
    [-114.5332, 33.6484],
    [-114.5252, 33.6559],
    [-114.5141, 33.6602],
    [-114.5207, 33.6627],
    [-114.5321, 33.6697],
    [-114.5303, 33.6792],
    [-114.5191, 33.6885],
    [-114.5050, 33.6930],
    [-114.4942, 33.7079],
    [-114.5008, 33.7222],
    [-114.5068, 33.7305],
    [-114.5119, 33.7350],
    [-114.5045, 33.7510],
    [-114.5049, 33.7605],
    [-114.5201, 33.7995],
    [-114.5227, 33.8190],
    [-114.5205, 33.8278],
    [-114.5296, 33.8481],
    [-114.5285, 33.8549],
    [-114.5245, 33.8585],
    [-114.5056, 33.8643],
    [-114.5034, 33.8750],
    [-114.5161, 33.8861],
    [-114.5259, 33.9010],
    [-114.5163, 33.8979],
    [-114.5087, 33.9006],
    [-114.5086, 33.9061],
    [-114.5254, 33.9223],
    [-114.5337, 33.9261],
    [-114.5355, 33.9347],
    [-114.5159, 33.9581],
    [-114.4999, 33.9618],
    [-114.4831, 33.9777],
    [-114.4759, 33.9844],
    [-114.4662, 33.9935],
    [-114.4586, 33.9956],
    [-114.4592, 34.0000],
    [-114.4673, 34.0052],
    [-114.4645, 34.0120],
    [-114.4502, 34.0126],
    [-114.4383, 34.0226],
    [-114.4355, 34.0426],
    [-114.4393, 34.0579],
    [-114.4343, 34.0865],
    [-114.4280, 34.0928],
    [-114.4159, 34.1076],
    [-114.4059, 34.1115],
    [-114.3792, 34.1160],
    [-114.3604, 34.1236],
    [-114.3481, 34.1345],
    [-114.3246, 34.1368],
    [-114.3022, 34.1561],
    [-114.2990, 34.1597],
    [-114.2753, 34.1721],
    [-114.2442, 34.1796],
    [-114.2290, 34.1874],
    [-114.2259, 34.2018],
    [-114.2155, 34.2090],
    [-114.1909, 34.2309],
    [-114.1764, 34.2415],
    [-114.1731, 34.2472],
    [-114.1645, 34.2517],
    [-114.1618, 34.2570],
    [-114.1533, 34.2583],
    [-114.1354, 34.2579],
    [-114.1312, 34.2627],
    [-114.1370, 34.2770],
    [-114.1384, 34.2886],
    [-114.1382, 34.3009],
    [-114.1572, 34.3179],
    [-114.1769, 34.3493],
    [-114.1911, 34.3561],
    [-114.2138, 34.3625],
    [-114.2343, 34.3767],
    [-114.2527, 34.3901],
    [-114.2801, 34.4031],
    [-114.2902, 34.4083],
    [-114.2948, 34.4214],
    [-114.3191, 34.4358],
    [-114.3307, 34.4453],
    [-114.3396, 34.4514],
    [-114.3634, 34.4478],
    [-114.3789, 34.4504],
    [-114.3872, 34.4620],
    [-114.3817, 34.4763],
    [-114.3824, 34.4958],
    [-114.3781, 34.5073],
    [-114.3808, 34.5297],
    [-114.3996, 34.5601],
    [-114.4344, 34.5926],
    [-114.4275, 34.5992],
    [-114.4242, 34.6105],
    [-114.4390, 34.6223],
    [-114.4403, 34.6382],
    [-114.4495, 34.6514],
    [-114.4582, 34.6579],
    [-114.4505, 34.6668],
    [-114.4549, 34.6731],
    [-114.4622, 34.6858],
    [-114.4686, 34.7076],
    [-114.4737, 34.7140],
    [-114.4820, 34.7160],
    [-114.4868, 34.7191],
    [-114.4959, 34.7280],
    [-114.5166, 34.7367],
    [-114.5256, 34.7470],
    [-114.5469, 34.7618],
    [-114.5615, 34.7786],
    [-114.5746, 34.8057],
    [-114.5811, 34.8261],
    [-114.6007, 34.8474],
    [-114.6239, 34.8597],
    [-114.6344, 34.8729],
    [-114.6368, 34.8857],
    [-114.6309, 34.9073],
    [-114.6332, 34.9212],
    [-114.6333, 34.9243],
    [-114.6328, 34.9274],
    [-114.6298, 34.9387],
    [-114.6317, 34.9513],
    [-114.6352, 34.9651],
    [-114.6298, 34.9817],
    [-114.6299, 34.9947],
    [-114.6367, 35.0094],
    [-114.6324, 35.0376],
    [-114.6174, 35.0515],
    [-114.6036, 35.0642],
    [-114.6084, 35.0784],
    [-114.6356, 35.0937],
    [-114.6468, 35.1019],
    [-114.6299, 35.1183],
    [-114.6130, 35.1214],
    [-114.5991, 35.1210],
    [-114.5785, 35.1287],
    [-114.5722, 35.1426],
    [-114.5692, 35.1835],
    [-114.5721, 35.2006],
    [-114.5836, 35.2299],
    [-114.5975, 35.2970],
    [-114.6114, 35.3691],
    [-114.6621, 35.4442],
    [-114.6729, 35.4817],
    [-114.6792, 35.5000],
    [-114.6738, 35.5179],
    [-114.6569, 35.5344],
    [-114.6620, 35.5455],
    [-114.6662, 35.5716],
    [-114.6716, 35.5762],
    [-114.6757, 35.5800],
    [-114.6681, 35.5841],
    [-114.6596, 35.5871],
    [-114.6572, 35.6170],
    [-114.6636, 35.6208],
    [-114.6686, 35.6281],
    [-114.6894, 35.6514],
    [-114.6822, 35.6782],
    [-114.6941, 35.6952],
    [-114.7053, 35.7116],
    [-114.7014, 35.7691],
    [-114.7099, 35.8102],
    [-114.6952, 35.8323],
    [-114.7065, 35.8490],
    [-114.6944, 35.8545],
    [-114.6697, 35.8651],
    [-114.6632, 35.8737],
    [-114.6780, 35.8847],
    [-114.7075, 35.9281],
    [-114.7296, 35.9596],
    [-114.7438, 35.9851],
    [-114.7428, 36.0100],
    [-114.7291, 36.0213],
    [-114.7237, 36.0312],
    [-114.7357, 36.0380],
    [-114.7425, 36.0456],
    [-114.7363, 36.0585],
    [-114.7511, 36.0790],
    [-114.7495, 36.0930],
    [-114.7173, 36.1077],
    [-114.6965, 36.1105],
    [-114.6881, 36.1115],
    [-114.6798, 36.1099],
    [-114.6643, 36.1163],
    [-114.6317, 36.1423],
    [-114.6167, 36.1301],
    [-114.5711, 36.1511],
    [-114.5487, 36.1507],
    [-114.5329, 36.1493],
    [-114.5143, 36.1508],
    [-114.5002, 36.1432],
    [-114.5072, 36.1363],
    [-114.5047, 36.1272],
    [-114.4687, 36.1389],
    [-114.4521, 36.1310],
    [-114.4272, 36.1363],
    [-114.3984, 36.1458],
    [-114.3753, 36.1430],
    [-114.3590, 36.1278],
    [-114.3346, 36.1068],
    [-114.3042, 36.0756],
    [-114.3143, 36.0620],
    [-114.3119, 36.0577],
    [-114.2959, 36.0562],
    [-114.2802, 36.0464],
    [-114.2709, 36.0455],
    [-114.2650, 36.0288],
    [-114.2388, 36.0146],
    [-114.1963, 36.0198],
    [-114.1528, 36.0237],
    [-114.1384, 36.0380],
    [-114.1214, 36.0804],
    [-114.1222, 36.1042],
    [-114.1107, 36.1182],
    [-114.0833, 36.1486],
    [-114.0439, 36.1933],
    [-114.0455, 36.2733],
    [-114.0448, 36.3317],
    [-114.0431, 36.4697],
    [-114.0482, 36.6396],
    [-114.0503, 36.7995],
    [-114.0503, 36.8078],
    [-114.0506, 36.8431],
    [-114.0506, 37.0004],
    [-113.6224, 37.0001],
    [-113.5581, 37.0001],
    [-113.4578, 37.0001],
    [-113.3210, 37.0001],
    [-113.0799, 37.0002],
    [-112.9665, 37.0002],
    [-112.9376, 37.0003],
    [-112.8295, 37.0004],
    [-112.5660, 37.0007],
    [-112.5451, 37.0007],
    [-112.5386, 37.0007],
    [-112.5298, 37.0007],
    [-112.3754, 37.0011],
    [-112.3577, 37.0010],
    [-111.6220, 37.0014],
    [-111.5068, 37.0014],
    [-111.4061, 37.0015],
    [-111.4048, 37.0015],
    [-111.3640, 37.0012],
    [-111.3554, 37.0011],
    [-111.3128, 37.0007],
    [-111.2962, 37.0006],
    [-111.2533, 37.0011],
    [-111.2350, 37.0010],
    [-111.1434, 37.0008],
    [-111.1401, 37.0008],
    [-111.0601, 37.0024],
    [-110.7019, 37.0034],
    [-110.5995, 37.0034],
    [-110.4876, 37.0027],
    [-110.4673, 36.9980],
    [-110.1758, 36.9984],
    [-110.1466, 36.9984],
    [-110.0218, 36.9986],
    [-110.0007, 36.9980],
    [-109.8757, 36.9985],
    [-109.6992, 36.9984],
    [-109.4716, 36.9991],
    [-109.3812, 36.9991],
    [-109.3408, 36.9992],
    [-109.2682, 36.9992],
    [-109.2338, 36.9993],
    [-109.0452, 36.9695],
    [-109.0454, 36.8982],
    [-109.0454, 36.8746],
    [-109.0454, 36.8570],
    [-109.0454, 36.7739],
    [-109.0454, 36.5274],
    [-109.0455, 36.4731],
    [-109.0457, 36.3655],
    [-109.0459, 36.3149],
    [-109.0460, 36.2801],
    [-109.0460, 36.2590],
    [-109.0462, 36.1818],
    [-109.0459, 36.1410],
    [-109.0460, 36.0023],
    [-109.0460, 35.9259],
    [-109.0461, 35.9093],
    [-109.0460, 35.8866],
    [-109.0461, 35.8287],
    [-109.0461, 35.7775],
    [-109.0462, 35.7093],
    [-109.0462, 35.6655],
    [-109.0463, 35.6596],
    [-109.0463, 35.6143],
    [-109.0464, 35.5817],
    [-109.0465, 35.5530],
    [-109.0465, 35.5463],
    [-109.0466, 35.4941],
    [-109.0466, 35.4508],
    [-109.0467, 35.4237],
    [-109.0468, 35.3795],
    [-109.0468, 35.3630],
    [-109.0467, 35.3554],
    [-109.0466, 35.3270],
    [-109.0463, 35.2923],
    [-109.0461, 35.2500],
    [-109.0461, 35.2196],
    [-109.0460, 35.1901],
    [-109.0459, 34.9598],
    [-109.0460, 34.8706],
    [-109.0456, 34.8142],
    [-109.0461, 34.7710],
    [-109.0462, 34.5226],
    [-109.0464, 34.3873],
    [-109.0469, 34.0873],
    [-109.0468, 33.9568],
    [-109.0469, 33.7782],
    [-109.0473, 33.4098],
    [-109.0470, 33.3693],
    [-109.0475, 33.2501],
    [-109.0472, 33.2089],
    [-109.0470, 33.1074],
    [-109.0475, 33.0694],
    [-109.0472, 32.8287],
    [-109.0476, 32.6934],
    [-109.0477, 32.6814],
    [-109.0483, 32.0891],
    [-109.0487, 32.0282],
    [-109.0486, 31.9206],
    [-109.0488, 31.8614],
    [-109.0488, 31.8117],
    [-109.0491, 31.6366],
    [-109.0498, 31.4995],
    [-109.2785, 31.3340],
    [-109.4945, 31.3340],
    [-109.5369, 31.3340],
    [-109.5606, 31.3340],
    [-109.7927, 31.3341],
    [-109.9184, 31.3336],
    [-110.0031, 31.3332],
    [-110.2742, 31.3335],
    [-110.7610, 31.3335],
    [-110.8907, 31.3330],
    [-110.9317, 31.3327],
    [-110.9653, 31.3324],
    [-111.0748, 31.3322],
    [-111.4511, 31.4532],
    [-111.7702, 31.5545],
    [-112.3650, 31.7411],
    [-112.3994, 31.7518],
    [-113.1260, 31.9728],
    [-113.4932, 32.0889],
    [-113.9615, 32.2346],
    [-114.5638, 32.4190],
    [-114.6495, 32.4449],
    [-114.7522, 32.4758],
    [-114.7612, 32.4785],
    [-114.8136, 32.4943],
    [-114.8138, 32.5043],
    [-114.8163, 32.5080]
    ]
  },
  "New Jersey": {
    coordinates: [
      [-75.5591, 39.6291],
    [-75.5506, 39.6379],
    [-75.5443, 39.6436],
    [-75.5352, 39.6472],
    [-75.5267, 39.6551],
    [-75.5251, 39.6577],
    [-75.5146, 39.6686],
    [-75.5097, 39.6861],
    [-75.5040, 39.6983],
    [-75.4913, 39.7111],
    [-75.4831, 39.7155],
    [-75.4776, 39.7150],
    [-75.4774, 39.7206],
    [-75.4754, 39.7287],
    [-75.4742, 39.7355],
    [-75.4663, 39.7507],
    [-75.4650, 39.7536],
    [-75.4594, 39.7658],
    [-75.4502, 39.7748],
    [-75.4055, 39.7964],
    [-75.4037, 39.8075],
    [-75.3905, 39.8153],
    [-75.3544, 39.8399],
    [-75.3415, 39.8462],
    [-75.3185, 39.8499],
    [-75.2934, 39.8488],
    [-75.2568, 39.8520],
    [-75.2299, 39.8583],
    [-75.2115, 39.8671],
    [-75.1999, 39.8732],
    [-75.1893, 39.8807],
    [-75.1746, 39.8824],
    [-75.1437, 39.8850],
    [-75.1373, 39.8900],
    [-75.1308, 39.9002],
    [-75.1301, 39.9170],
    [-75.1350, 39.9273],
    [-75.1359, 39.9325],
    [-75.1342, 39.9528],
    [-75.1302, 39.9586],
    [-75.1254, 39.9620],
    [-75.1190, 39.9655],
    [-75.1023, 39.9724],
    [-75.0756, 39.9780],
    [-75.0677, 39.9832],
    [-75.0600, 39.9916],
    [-75.0537, 40.0041],
    [-75.0471, 40.0099],
    [-75.0429, 40.0120],
    [-75.0211, 40.0181],
    [-75.0138, 40.0202],
    [-74.9901, 40.0365],
    [-74.9828, 40.0418],
    [-74.9669, 40.0527],
    [-74.9326, 40.0688],
    [-74.9209, 40.0714],
    [-74.9090, 40.0702],
    [-74.8979, 40.0735],
    [-74.8746, 40.0807],
    [-74.8621, 40.0833],
    [-74.8598, 40.0849],
    [-74.8565, 40.0913],
    [-74.8479, 40.0963],
    [-74.8380, 40.1009],
    [-74.8341, 40.1079],
    [-74.8287, 40.1203],
    [-74.8225, 40.1268],
    [-74.8156, 40.1276],
    [-74.8053, 40.1244],
    [-74.7887, 40.1204],
    [-74.7820, 40.1209],
    [-74.7629, 40.1325],
    [-74.7444, 40.1344],
    [-74.7317, 40.1419],
    [-74.7221, 40.1503],
    [-74.7223, 40.1606],
    [-74.7441, 40.1810],
    [-74.7543, 40.1852],
    [-74.7595, 40.1969],
    [-74.7677, 40.2078],
    [-74.7717, 40.2153],
    [-74.7820, 40.2219],
    [-74.7953, 40.2294],
    [-74.8239, 40.2415],
    [-74.8363, 40.2462],
    [-74.8466, 40.2588],
    [-74.8531, 40.2697],
    [-74.8566, 40.2777],
    [-74.8682, 40.2952],
    [-74.8864, 40.3098],
    [-74.8964, 40.3151],
    [-74.9083, 40.3169],
    [-74.9269, 40.3295],
    [-74.9397, 40.3380],
    [-74.9438, 40.3426],
    [-74.9460, 40.3554],
    [-74.9488, 40.3649],
    [-74.9543, 40.3765],
    [-74.9681, 40.3991],
    [-74.9827, 40.4044],
    [-74.9889, 40.4088],
    [-75.0038, 40.4076],
    [-75.0283, 40.4039],
    [-75.0412, 40.4106],
    [-75.0462, 40.4140],
    [-75.0607, 40.4214],
    [-75.0665, 40.4472],
    [-75.0686, 40.4620],
    [-75.0677, 40.4737],
    [-75.0626, 40.4896],
    [-75.0649, 40.5107],
    [-75.0651, 40.5261],
    [-75.0673, 40.5396],
    [-75.0839, 40.5534],
    [-75.1003, 40.5678],
    [-75.1173, 40.5732],
    [-75.1474, 40.5732],
    [-75.1629, 40.5641],
    [-75.1753, 40.5650],
    [-75.1924, 40.5743],
    [-75.1951, 40.5797],
    [-75.1908, 40.5868],
    [-75.1923, 40.6027],
    [-75.1985, 40.6115],
    [-75.2011, 40.6179],
    [-75.1936, 40.6197],
    [-75.1886, 40.6246],
    [-75.1907, 40.6359],
    [-75.1974, 40.6446],
    [-75.1967, 40.6551],
    [-75.1828, 40.6660],
    [-75.1775, 40.6726],
    [-75.1806, 40.6794],
    [-75.1902, 40.6794],
    [-75.2009, 40.6855],
    [-75.2039, 40.6915],
    [-75.2028, 40.6945],
    [-75.1981, 40.7065],
    [-75.1926, 40.7159],
    [-75.1857, 40.7254],
    [-75.1821, 40.7315],
    [-75.1953, 40.7455],
    [-75.1965, 40.7516],
    [-75.1904, 40.7564],
    [-75.1790, 40.7619],
    [-75.1756, 40.7729],
    [-75.1733, 40.7761],
    [-75.1695, 40.7785],
    [-75.1413, 40.7739],
    [-75.1334, 40.7741],
    [-75.1300, 40.7781],
    [-75.1190, 40.7885],
    [-75.1113, 40.7899],
    [-75.1008, 40.7998],
    [-75.1007, 40.8055],
    [-75.0961, 40.8122],
    [-75.0840, 40.8244],
    [-75.0838, 40.8278],
    [-75.0884, 40.8323],
    [-75.0976, 40.8410],
    [-75.0958, 40.8471],
    [-75.0735, 40.8489],
    [-75.0635, 40.8495],
    [-75.0639, 40.8554],
    [-75.0516, 40.8640],
    [-75.0508, 40.8681],
    [-75.0587, 40.8777],
    [-75.0654, 40.8857],
    [-75.0753, 40.8942],
    [-75.0761, 40.9070],
    [-75.0873, 40.9189],
    [-75.0955, 40.9242],
    [-75.1006, 40.9302],
    [-75.1117, 40.9481],
    [-75.1191, 40.9589],
    [-75.1195, 40.9663],
    [-75.1226, 40.9702],
    [-75.1338, 40.9710],
    [-75.1331, 40.9802],
    [-75.1316, 40.9889],
    [-75.1272, 40.9940],
    [-75.1091, 41.0041],
    [-75.0853, 41.0149],
    [-75.0750, 41.0171],
    [-75.0418, 41.0317],
    [-75.0271, 41.0395],
    [-75.0264, 41.0464],
    [-75.0131, 41.0665],
    [-74.9996, 41.0739],
    [-74.9826, 41.0792],
    [-74.9668, 41.0934],
    [-74.9694, 41.0961],
    [-74.9813, 41.0899],
    [-74.9910, 41.0886],
    [-74.9822, 41.1082],
    [-74.9693, 41.1139],
    [-74.9479, 41.1236],
    [-74.9477, 41.1263],
    [-74.9232, 41.1381],
    [-74.9012, 41.1639],
    [-74.8823, 41.1807],
    [-74.8783, 41.1905],
    [-74.8673, 41.2088],
    [-74.8594, 41.2201],
    [-74.8668, 41.2269],
    [-74.8620, 41.2376],
    [-74.8560, 41.2501],
    [-74.8469, 41.2533],
    [-74.8465, 41.2616],
    [-74.8387, 41.2765],
    [-74.8341, 41.2811],
    [-74.8157, 41.2962],
    [-74.7926, 41.3106],
    [-74.7956, 41.3182],
    [-74.7921, 41.3225],
    [-74.7816, 41.3242],
    [-74.7706, 41.3258],
    [-74.7603, 41.3403],
    [-74.7356, 41.3465],
    [-74.7085, 41.3527],
    [-74.6949, 41.3574],
    [-74.6739, 41.3478],
    [-74.6415, 41.3329],
    [-74.5693, 41.3000],
    [-74.5562, 41.2938],
    [-74.5255, 41.2794],
    [-74.4684, 41.2531],
    [-74.4398, 41.2394],
    [-74.3832, 41.2111],
    [-74.3657, 41.2029],
    [-74.3330, 41.1879],
    [-74.3210, 41.1824],
    [-74.2801, 41.1630],
    [-74.2429, 41.1466],
    [-74.2114, 41.1334],
    [-74.1824, 41.1216],
    [-74.1499, 41.1073],
    [-74.1424, 41.1039],
    [-74.1208, 41.0944],
    [-74.0968, 41.0838],
    [-74.0924, 41.0819],
    [-74.0817, 41.0771],
    [-74.0679, 41.0710],
    [-74.0509, 41.0634],
    [-74.0373, 41.0574],
    [-74.0246, 41.0517],
    [-73.9939, 41.0380],
    [-73.9667, 41.0258],
    [-73.9519, 41.0192],
    [-73.9391, 41.0135],
    [-73.9119, 41.0013],
    [-73.9027, 40.9973],
    [-73.8989, 40.9749],
    [-73.9073, 40.9515],
    [-73.9156, 40.9249],
    [-73.9184, 40.9175],
    [-73.9197, 40.9135],
    [-73.9334, 40.8821],
    [-73.9457, 40.8625],
    [-73.9521, 40.8514],
    [-73.9576, 40.8396],
    [-73.9615, 40.8309],
    [-73.9637, 40.8263],
    [-73.9660, 40.8234],
    [-73.9712, 40.8163],
    [-73.9789, 40.8057],
    [-73.9843, 40.7982],
    [-73.9881, 40.7930],
    [-73.9916, 40.7881],
    [-73.9956, 40.7825],
    [-74.0002, 40.7760],
    [-74.0083, 40.7649],
    [-74.0138, 40.7566],
    [-74.0178, 40.7407],
    [-74.0204, 40.7303],
    [-74.0211, 40.7274],
    [-74.0219, 40.7236],
    [-74.0239, 40.7130],
    [-74.0338, 40.7061],
    [-74.0534, 40.6912],
    [-74.0670, 40.6652],
    [-74.0875, 40.6537],
    [-74.1206, 40.6457],
    [-74.1282, 40.6441],
    [-74.1415, 40.6436],
    [-74.1606, 40.6454],
    [-74.1860, 40.6461],
    [-74.1891, 40.6438],
    [-74.2045, 40.6202],
    [-74.2016, 40.5973],
    [-74.2069, 40.5928],
    [-74.2145, 40.5650],
    [-74.2281, 40.5614],
    [-74.2387, 40.5578],
    [-74.2546, 40.5486],
    [-74.2529, 40.5401],
    [-74.2501, 40.5208],
    [-74.2593, 40.5112],
    [-74.2623, 40.5035],
    [-74.2727, 40.4884],
    [-74.2677, 40.4804],
    [-74.2651, 40.4719],
    [-74.2568, 40.4633],
    [-74.2449, 40.4580],
    [-74.2367, 40.4578],
    [-74.2251, 40.4532],
    [-74.2223, 40.4522],
    [-74.2091, 40.4459],
    [-74.2051, 40.4393],
    [-74.1963, 40.4405],
    [-74.1878, 40.4474],
    [-74.1866, 40.4503],
    [-74.1807, 40.4580],
    [-74.1751, 40.4559],
    [-74.1651, 40.4486],
    [-74.1564, 40.4474],
    [-74.1512, 40.4485],
    [-74.1403, 40.4559],
    [-74.1308, 40.4551],
    [-74.1162, 40.4472],
    [-74.1034, 40.4425],
    [-74.0901, 40.4390],
    [-74.0814, 40.4358],
    [-74.0673, 40.4280],
    [-74.0604, 40.4236],
    [-74.0479, 40.4189],
    [-74.0013, 40.4115],
    [-73.9917, 40.4429],
    [-74.0037, 40.4485],
    [-74.0061, 40.4646],
    [-74.0208, 40.4752],
    [-74.0110, 40.4781],
    [-74.0051, 40.4830],
    [-73.9981, 40.4730],
    [-73.9865, 40.4555],
    [-73.9810, 40.4431],
    [-73.9756, 40.4059],
    [-73.9714, 40.3615],
    [-73.9738, 40.3319],
    [-73.9766, 40.3073],
    [-73.9785, 40.2943],
    [-73.9817, 40.2794],
    [-73.9933, 40.2377],
    [-73.9956, 40.2303],
    [-73.9995, 40.2181],
    [-74.0027, 40.2079],
    [-74.0092, 40.1875],
    [-74.0125, 40.1770],
    [-74.0204, 40.1523],
    [-74.0308, 40.1172],
    [-74.0313, 40.1008],
    [-74.0357, 40.0928],
    [-74.0382, 40.0853],
    [-74.0451, 40.0577],
    [-74.0525, 40.0266],
    [-74.0585, 40.0012],
    [-74.0615, 39.9885],
    [-74.0649, 39.9693],
    [-74.0665, 39.9550],
    [-74.0678, 39.9429],
    [-74.0687, 39.9395],
    [-74.0733, 39.9214],
    [-74.0756, 39.9124],
    [-74.0909, 39.8000],
    [-74.0963, 39.7680],
    [-74.0941, 39.7580],
    [-74.0992, 39.7544],
    [-74.1088, 39.7440],
    [-74.1278, 39.7139],
    [-74.1417, 39.6894],
    [-74.1553, 39.6718],
    [-74.1734, 39.6480],
    [-74.1836, 39.6348],
    [-74.1856, 39.6321],
    [-74.2130, 39.5939],
    [-74.2161, 39.5895],
    [-74.2395, 39.5564],
    [-74.2490, 39.5480],
    [-74.2879, 39.5083],
    [-74.3025, 39.5002],
    [-74.3112, 39.5083],
    [-74.3237, 39.5065],
    [-74.3122, 39.4836],
    [-74.3171, 39.4676],
    [-74.3260, 39.4499],
    [-74.3271, 39.4418],
    [-74.3352, 39.4329],
    [-74.3412, 39.4273],
    [-74.3476, 39.4204],
    [-74.3670, 39.4020],
    [-74.3823, 39.3908],
    [-74.3950, 39.3812],
    [-74.4056, 39.3728],
    [-74.4070, 39.3688],
    [-74.4140, 39.3602],
    [-74.4388, 39.3526],
    [-74.4529, 39.3475],
    [-74.4591, 39.3453],
    [-74.4642, 39.3430],
    [-74.4696, 39.3404],
    [-74.4822, 39.3345],
    [-74.5016, 39.3242],
    [-74.5073, 39.3209],
    [-74.5151, 39.3163],
    [-74.5265, 39.3088],
    [-74.5388, 39.3035],
    [-74.5487, 39.3011],
    [-74.5512, 39.2930],
    [-74.5605, 39.2778],
    [-74.5702, 39.2742],
    [-74.5770, 39.2718],
    [-74.5858, 39.2666],
    [-74.5945, 39.2605],
    [-74.6053, 39.2518],
    [-74.6304, 39.2260],
    [-74.6393, 39.2164],
    [-74.6473, 39.2080],
    [-74.6603, 39.1925],
    [-74.6832, 39.1638],
    [-74.7042, 39.1322],
    [-74.7143, 39.1198],
    [-74.7141, 39.1146],
    [-74.7044, 39.1079],
    [-74.7140, 39.0958],
    [-74.7469, 39.0622],
    [-74.7788, 39.0231],
    [-74.7868, 39.0079],
    [-74.7864, 39.0001],
    [-74.7927, 38.9920],
    [-74.8003, 38.9872],
    [-74.8128, 38.9798],
    [-74.8227, 38.9745],
    [-74.8507, 38.9546],
    [-74.8635, 38.9414],
    [-74.8685, 38.9427],
    [-74.8759, 38.9431],
    [-74.9070, 38.9320],
    [-74.9259, 38.9289],
    [-74.9365, 38.9307],
    [-74.9472, 38.9320],
    [-74.9598, 38.9309],
    [-74.9673, 38.9334],
    [-74.9704, 38.9442],
    [-74.9641, 38.9683],
    [-74.9602, 38.9835],
    [-74.9554, 39.0013],
    [-74.9411, 39.0303],
    [-74.9375, 39.0364],
    [-74.9354, 39.0397],
    [-74.9192, 39.0640],
    [-74.8925, 39.1132],
    [-74.8893, 39.1279],
    [-74.8864, 39.1500],
    [-74.8941, 39.1660],
    [-74.9148, 39.1776],
    [-74.9270, 39.1819],
    [-74.9632, 39.1920],
    [-74.9980, 39.1913],
    [-75.0073, 39.1924],
    [-75.0278, 39.1995],
    [-75.0240, 39.2080],
    [-75.0236, 39.2222],
    [-75.0319, 39.2204],
    [-75.0485, 39.2152],
    [-75.0637, 39.2149],
    [-75.0941, 39.2121],
    [-75.1001, 39.2170],
    [-75.1083, 39.2173],
    [-75.1205, 39.2085],
    [-75.1274, 39.2005],
    [-75.1285, 39.1956],
    [-75.1369, 39.1821],
    [-75.1425, 39.1867],
    [-75.1551, 39.1940],
    [-75.1633, 39.2004],
    [-75.1640, 39.2113],
    [-75.1666, 39.2189],
    [-75.1780, 39.2426],
    [-75.1919, 39.2457],
    [-75.1991, 39.2567],
    [-75.2416, 39.2741],
    [-75.2401, 39.2823],
    [-75.2393, 39.2854],
    [-75.2527, 39.2964],
    [-75.2720, 39.3041],
    [-75.2773, 39.3033],
    [-75.2796, 39.3055],
    [-75.2866, 39.3006],
    [-75.2883, 39.2916],
    [-75.3152, 39.3106],
    [-75.3261, 39.3325],
    [-75.3320, 39.3422],
    [-75.3420, 39.3487],
    [-75.3568, 39.3475],
    [-75.3576, 39.3417],
    [-75.3683, 39.3508],
    [-75.3900, 39.3583],
    [-75.3952, 39.3714],
    [-75.4021, 39.3813],
    [-75.4088, 39.3812],
    [-75.4125, 39.3809],
    [-75.4127, 39.3850],
    [-75.4168, 39.3874],
    [-75.4221, 39.3865],
    [-75.4424, 39.4023],
    [-75.4652, 39.4389],
    [-75.4836, 39.4408],
    [-75.4937, 39.4495],
    [-75.5084, 39.4591],
    [-75.5444, 39.4796],
    [-75.5280, 39.5004],
    [-75.5266, 39.5171],
    [-75.5277, 39.5353],
    [-75.5323, 39.5433],
    [-75.5148, 39.5626],
    [-75.5152, 39.5808],
    [-75.5262, 39.5854],
    [-75.5372, 39.5929],
    [-75.5440, 39.5960],
    [-75.5559, 39.6058],
    [-75.5569, 39.6121],
    [-75.5591, 39.6291]
    ]
  },
  "Maryland": {
    coordinates: [
      [-79.4876, 39.2800],
    [-79.4861, 39.3443],
    [-79.4843, 39.3512],
    [-79.4836, 39.4190],
    [-79.4833, 39.4511],
    [-79.4828, 39.5098],
    [-79.4824, 39.5247],
    [-79.4786, 39.5561],
    [-79.4778, 39.6423],
    [-79.4766, 39.6637],
    [-79.3350, 39.7217],
    [-79.2491, 39.7220],
    [-79.0874, 39.7227],
    [-79.0455, 39.7229],
    [-78.9284, 39.7228],
    [-78.8857, 39.7228],
    [-78.8453, 39.7229],
    [-78.8084, 39.7229],
    [-78.7695, 39.7230],
    [-78.7235, 39.7230],
    [-78.6592, 39.7228],
    [-78.6103, 39.7227],
    [-78.5377, 39.7225],
    [-78.4388, 39.7225],
    [-78.3428, 39.7225],
    [-78.3395, 39.7226],
    [-78.2817, 39.7226],
    [-78.2431, 39.7225],
    [-78.2044, 39.7225],
    [-78.1486, 39.7224],
    [-78.0737, 39.7223],
    [-77.9956, 39.7223],
    [-77.9374, 39.7222],
    [-77.8476, 39.7220],
    [-77.7896, 39.7215],
    [-77.7452, 39.7212],
    [-77.7329, 39.7211],
    [-77.7260, 39.7209],
    [-77.7217, 39.7209],
    [-77.6743, 39.7208],
    [-77.5744, 39.7203],
    [-77.5348, 39.7201],
    [-77.5069, 39.7201],
    [-77.4966, 39.7201],
    [-77.4594, 39.7200],
    [-77.3695, 39.7200],
    [-77.3506, 39.7200],
    [-77.2930, 39.7200],
    [-77.2398, 39.7200],
    [-77.2168, 39.7200],
    [-77.1075, 39.7201],
    [-77.0582, 39.7202],
    [-77.0054, 39.7199],
    [-76.9748, 39.7201],
    [-76.9160, 39.7205],
    [-76.8811, 39.7204],
    [-76.8082, 39.7207],
    [-76.7871, 39.7208],
    [-76.7156, 39.7211],
    [-76.6977, 39.7211],
    [-76.6550, 39.7211],
    [-76.5694, 39.7212],
    [-76.5434, 39.7213],
    [-76.4919, 39.7213],
    [-76.4389, 39.7212],
    [-76.4045, 39.7212],
    [-76.3806, 39.7213],
    [-76.3371, 39.7213],
    [-76.2333, 39.7213],
    [-76.1543, 39.7215],
    [-76.0680, 39.7217],
    [-76.0131, 39.7219],
    [-75.9810, 39.7216],
    [-75.9370, 39.7217],
    [-75.8215, 39.7219],
    [-75.7996, 39.7219],
    [-75.7884, 39.7003],
    [-75.7885, 39.6942],
    [-75.7886, 39.6807],
    [-75.7887, 39.6582],
    [-75.7881, 39.6491],
    [-75.7875, 39.6390],
    [-75.7872, 39.6344],
    [-75.7862, 39.6217],
    [-75.7851, 39.6064],
    [-75.7838, 39.5905],
    [-75.7825, 39.5723],
    [-75.7796, 39.5355],
    [-75.7762, 39.4943],
    [-75.7722, 39.4455],
    [-75.7667, 39.3772],
    [-75.7605, 39.3013],
    [-75.7569, 39.2581],
    [-75.7526, 39.1994],
    [-75.7510, 39.1778],
    [-75.7494, 39.1648],
    [-75.7461, 39.1203],
    [-75.7454, 39.1107],
    [-75.7426, 39.0798],
    [-75.7419, 39.0710],
    [-75.7386, 39.0297],
    [-75.7309, 38.9331],
    [-75.7256, 38.8682],
    [-75.7240, 38.8467],
    [-75.7226, 38.8300],
    [-75.7204, 38.8019],
    [-75.7129, 38.7056],
    [-75.7073, 38.6353],
    [-75.7059, 38.6163],
    [-75.7034, 38.5851],
    [-75.7002, 38.5426],
    [-75.6979, 38.5113],
    [-75.6937, 38.4601],
    [-75.6628, 38.4588],
    [-75.5981, 38.4569],
    [-75.5893, 38.4563],
    [-75.5825, 38.4564],
    [-75.5741, 38.4560],
    [-75.5632, 38.4557],
    [-75.5592, 38.4556],
    [-75.5553, 38.4555],
    [-75.5432, 38.4552],
    [-75.5338, 38.4550],
    [-75.5030, 38.4542],
    [-75.4775, 38.4537],
    [-75.4286, 38.4527],
    [-75.3948, 38.4522],
    [-75.3558, 38.4520],
    [-75.2731, 38.4516],
    [-75.2363, 38.4513],
    [-75.2185, 38.4512],
    [-75.1856, 38.4510],
    [-75.1420, 38.4512],
    [-75.0883, 38.4513],
    [-75.0786, 38.4513],
    [-75.0663, 38.4513],
    [-75.0647, 38.4513],
    [-75.0525, 38.4513],
    [-75.0533, 38.4231],
    [-75.0546, 38.4148],
    [-75.0562, 38.4088],
    [-75.0659, 38.3772],
    [-75.0676, 38.3701],
    [-75.0814, 38.3360],
    [-75.0858, 38.3240],
    [-75.0939, 38.3234],
    [-75.1127, 38.2896],
    [-75.1432, 38.2205],
    [-75.1741, 38.1413],
    [-75.2065, 38.0765],
    [-75.2423, 38.0272],
    [-75.2833, 38.0236],
    [-75.3779, 38.0151],
    [-75.3988, 38.0133],
    [-75.4360, 38.0103],
    [-75.4862, 38.0060],
    [-75.6243, 37.9942],
    [-75.6309, 37.9878],
    [-75.6337, 37.9831],
    [-75.6295, 37.9760],
    [-75.6342, 37.9777],
    [-75.6418, 37.9760],
    [-75.6482, 37.9668],
    [-75.6561, 37.9628],
    [-75.6567, 37.9562],
    [-75.6569, 37.9533],
    [-75.6631, 37.9612],
    [-75.6717, 37.9666],
    [-75.6795, 37.9675],
    [-75.6904, 37.9669],
    [-75.7071, 37.9746],
    [-75.7150, 37.9793],
    [-75.7131, 37.9855],
    [-75.7169, 37.9882],
    [-75.7224, 37.9855],
    [-75.7218, 37.9801],
    [-75.7280, 37.9673],
    [-75.7365, 37.9632],
    [-75.7400, 37.9684],
    [-75.7383, 37.9758],
    [-75.7371, 37.9788],
    [-75.7387, 37.9818],
    [-75.7392, 37.9839],
    [-75.7468, 37.9877],
    [-75.7481, 37.9860],
    [-75.7451, 37.9805],
    [-75.7512, 37.9772],
    [-75.7528, 37.9745],
    [-75.7465, 37.9718],
    [-75.7502, 37.9689],
    [-75.7758, 37.9720],
    [-75.7872, 37.9692],
    [-75.7915, 37.9649],
    [-75.8037, 37.9556],
    [-75.8093, 37.9552],
    [-75.8119, 37.9622],
    [-75.8132, 37.9664],
    [-75.8172, 37.9672],
    [-75.8203, 37.9661],
    [-75.8214, 37.9620],
    [-75.8250, 37.9560],
    [-75.8186, 37.9464],
    [-75.8188, 37.9408],
    [-75.8244, 37.9387],
    [-75.8302, 37.9380],
    [-75.8332, 37.9308],
    [-75.8460, 37.9257],
    [-75.8555, 37.9226],
    [-75.8653, 37.9180],
    [-75.8777, 37.9161],
    [-75.8850, 37.9117],
    [-75.8932, 37.9179],
    [-75.8973, 37.9263],
    [-75.8926, 37.9326],
    [-75.8910, 37.9448],
    [-75.8884, 37.9532],
    [-75.8805, 37.9516],
    [-75.8777, 37.9502],
    [-75.8724, 37.9498],
    [-75.8662, 37.9514],
    [-75.8612, 37.9553],
    [-75.8643, 37.9593],
    [-75.8639, 37.9685],
    [-75.8638, 37.9760],
    [-75.8705, 37.9767],
    [-75.8738, 37.9750],
    [-75.8782, 37.9703],
    [-75.8815, 37.9720],
    [-75.8868, 37.9742],
    [-75.8901, 37.9770],
    [-75.8933, 37.9745],
    [-75.8889, 37.9701],
    [-75.8974, 37.9744],
    [-75.8960, 37.9779],
    [-75.8870, 37.9928],
    [-75.8813, 38.0007],
    [-75.8735, 38.0131],
    [-75.8713, 38.0178],
    [-75.8697, 38.0207],
    [-75.8671, 38.0255],
    [-75.8730, 38.0268],
    [-75.8708, 38.0350],
    [-75.8575, 38.0388],
    [-75.8476, 38.0335],
    [-75.8443, 38.0278],
    [-75.8406, 38.0306],
    [-75.8343, 38.0330],
    [-75.8301, 38.0382],
    [-75.8294, 38.0433],
    [-75.8257, 38.0460],
    [-75.8204, 38.0451],
    [-75.8169, 38.0448],
    [-75.8080, 38.0510],
    [-75.8049, 38.0503],
    [-75.8015, 38.0525],
    [-75.7922, 38.0565],
    [-75.7897, 38.0609],
    [-75.7825, 38.0639],
    [-75.7802, 38.0677],
    [-75.7752, 38.0733],
    [-75.7752, 38.0781],
    [-75.7789, 38.0783],
    [-75.7819, 38.0791],
    [-75.7855, 38.0865],
    [-75.7900, 38.0838],
    [-75.7904, 38.0779],
    [-75.7881, 38.0747],
    [-75.7922, 38.0715],
    [-75.7951, 38.0706],
    [-75.8000, 38.0721],
    [-75.8029, 38.0728],
    [-75.8056, 38.0714],
    [-75.8042, 38.0687],
    [-75.7993, 38.0655],
    [-75.8057, 38.0627],
    [-75.8106, 38.0622],
    [-75.8114, 38.0599],
    [-75.8150, 38.0635],
    [-75.8184, 38.0685],
    [-75.8220, 38.0719],
    [-75.8248, 38.0702],
    [-75.8262, 38.0683],
    [-75.8343, 38.0679],
    [-75.8443, 38.0723],
    [-75.8495, 38.0681],
    [-75.8556, 38.0689],
    [-75.8596, 38.0664],
    [-75.8589, 38.0601],
    [-75.8710, 38.0592],
    [-75.8739, 38.0618],
    [-75.8712, 38.0692],
    [-75.8732, 38.0731],
    [-75.8782, 38.0761],
    [-75.8738, 38.0799],
    [-75.8689, 38.0806],
    [-75.8654, 38.0838],
    [-75.8676, 38.0888],
    [-75.8696, 38.0908],
    [-75.8643, 38.0901],
    [-75.8623, 38.0921],
    [-75.8656, 38.0949],
    [-75.8656, 38.0991],
    [-75.8626, 38.0970],
    [-75.8587, 38.0994],
    [-75.8566, 38.1031],
    [-75.8482, 38.1081],
    [-75.8395, 38.1135],
    [-75.8378, 38.1187],
    [-75.8383, 38.1262],
    [-75.8340, 38.1272],
    [-75.8292, 38.1329],
    [-75.8240, 38.1286],
    [-75.8207, 38.1256],
    [-75.8177, 38.1285],
    [-75.8185, 38.1314],
    [-75.8112, 38.1355],
    [-75.8080, 38.1346],
    [-75.8093, 38.1319],
    [-75.8054, 38.1284],
    [-75.7966, 38.1356],
    [-75.7878, 38.1375],
    [-75.7885, 38.1458],
    [-75.7974, 38.1443],
    [-75.7992, 38.1422],
    [-75.8097, 38.1416],
    [-75.8185, 38.1437],
    [-75.8218, 38.1438],
    [-75.8224, 38.1479],
    [-75.8313, 38.1503],
    [-75.8337, 38.1514],
    [-75.8365, 38.1506],
    [-75.8417, 38.1447],
    [-75.8499, 38.1444],
    [-75.8528, 38.1433],
    [-75.8595, 38.1405],
    [-75.8668, 38.1409],
    [-75.8717, 38.1420],
    [-75.8705, 38.1388],
    [-75.8660, 38.1349],
    [-75.8784, 38.1393],
    [-75.8806, 38.1457],
    [-75.8868, 38.1499],
    [-75.8879, 38.1485],
    [-75.8942, 38.1481],
    [-75.9024, 38.1442],
    [-75.9024, 38.1412],
    [-75.9016, 38.1398],
    [-75.9085, 38.1382],
    [-75.9081, 38.1426],
    [-75.9174, 38.1448],
    [-75.9190, 38.1471],
    [-75.9236, 38.1499],
    [-75.9257, 38.1510],
    [-75.9326, 38.1490],
    [-75.9304, 38.1446],
    [-75.9265, 38.1402],
    [-75.9207, 38.1319],
    [-75.9288, 38.1269],
    [-75.9354, 38.1255],
    [-75.9348, 38.1202],
    [-75.9376, 38.1137],
    [-75.9454, 38.1153],
    [-75.9456, 38.1209],
    [-75.9461, 38.1266],
    [-75.9503, 38.1273],
    [-75.9568, 38.1317],
    [-75.9596, 38.1371],
    [-75.9551, 38.1465],
    [-75.9541, 38.1530],
    [-75.9513, 38.1619],
    [-75.9477, 38.1693],
    [-75.9511, 38.1747],
    [-75.9424, 38.1871],
    [-75.9278, 38.1898],
    [-75.9227, 38.1908],
    [-75.9098, 38.1969],
    [-75.8959, 38.2003],
    [-75.8867, 38.2025],
    [-75.8822, 38.1992],
    [-75.8773, 38.1984],
    [-75.8675, 38.2002],
    [-75.8621, 38.2021],
    [-75.8467, 38.2103],
    [-75.8407, 38.2131],
    [-75.8372, 38.2182],
    [-75.8334, 38.2186],
    [-75.8301, 38.2171],
    [-75.8284, 38.2162],
    [-75.8263, 38.2187],
    [-75.8202, 38.2239],
    [-75.8191, 38.2300],
    [-75.8217, 38.2302],
    [-75.8254, 38.2291],
    [-75.8316, 38.2298],
    [-75.8382, 38.2304],
    [-75.8453, 38.2313],
    [-75.8554, 38.2290],
    [-75.8606, 38.2310],
    [-75.8569, 38.2359],
    [-75.8493, 38.2399],
    [-75.8353, 38.2491],
    [-75.8296, 38.2498],
    [-75.8234, 38.2528],
    [-75.8175, 38.2522],
    [-75.8099, 38.2514],
    [-75.8013, 38.2537],
    [-75.8014, 38.2559],
    [-75.8048, 38.2554],
    [-75.8160, 38.2603],
    [-75.8247, 38.2609],
    [-75.8342, 38.2574],
    [-75.8456, 38.2573],
    [-75.8563, 38.2474],
    [-75.8696, 38.2436],
    [-75.8731, 38.2461],
    [-75.8700, 38.2500],
    [-75.8717, 38.2531],
    [-75.8754, 38.2547],
    [-75.8800, 38.2525],
    [-75.8819, 38.2499],
    [-75.8834, 38.2444],
    [-75.8891, 38.2366],
    [-75.8838, 38.2290],
    [-75.8914, 38.2276],
    [-75.9022, 38.2363],
    [-75.9058, 38.2430],
    [-75.9071, 38.2489],
    [-75.9092, 38.2558],
    [-75.9136, 38.2607],
    [-75.9203, 38.2644],
    [-75.9061, 38.2772],
    [-75.9026, 38.2833],
    [-75.9014, 38.2860],
    [-75.9083, 38.2923],
    [-75.9032, 38.2979],
    [-75.8985, 38.3035],
    [-75.8928, 38.3101],
    [-75.8922, 38.3118],
    [-75.8825, 38.3291],
    [-75.8782, 38.3273],
    [-75.8713, 38.3313],
    [-75.8727, 38.3389],
    [-75.8618, 38.3476],
    [-75.8537, 38.3574],
    [-75.8503, 38.3664],
    [-75.8629, 38.3763],
    [-75.8654, 38.3812],
    [-75.8712, 38.3774],
    [-75.8693, 38.3727],
    [-75.8666, 38.3694],
    [-75.8635, 38.3599],
    [-75.8761, 38.3546],
    [-75.8820, 38.3531],
    [-75.8935, 38.3499],
    [-75.9032, 38.3465],
    [-75.9122, 38.3432],
    [-75.9143, 38.3378],
    [-75.9136, 38.3295],
    [-75.9197, 38.3259],
    [-75.9273, 38.3214],
    [-75.9357, 38.3114],
    [-75.9383, 38.3068],
    [-75.9408, 38.2984],
    [-75.9369, 38.2860],
    [-75.9379, 38.2762],
    [-75.9402, 38.2709],
    [-75.9471, 38.2673],
    [-75.9493, 38.2679],
    [-75.9535, 38.2659],
    [-75.9522, 38.2590],
    [-75.9546, 38.2546],
    [-75.9445, 38.2491],
    [-75.9452, 38.2419],
    [-75.9492, 38.2375],
    [-75.9703, 38.2338],
    [-75.9641, 38.2411],
    [-75.9621, 38.2487],
    [-75.9646, 38.2533],
    [-75.9779, 38.2619],
    [-75.9839, 38.2690],
    [-75.9814, 38.2705],
    [-75.9823, 38.2735],
    [-75.9829, 38.2770],
    [-75.9878, 38.2793],
    [-75.9987, 38.2918],
    [-76.0029, 38.2995],
    [-76.0074, 38.3043],
    [-76.0094, 38.3120],
    [-75.9912, 38.3141],
    [-75.9693, 38.3202],
    [-75.9627, 38.3280],
    [-75.9619, 38.3361],
    [-75.9620, 38.3430],
    [-75.9582, 38.3462],
    [-75.9574, 38.3475],
    [-75.9633, 38.3490],
    [-75.9669, 38.3516],
    [-75.9723, 38.3626],
    [-75.9745, 38.3664],
    [-75.9821, 38.3683],
    [-75.9950, 38.3706],
    [-76.0023, 38.3745],
    [-76.0090, 38.3756],
    [-76.0114, 38.3768],
    [-76.0108, 38.3711],
    [-76.0051, 38.3684],
    [-76.0119, 38.3606],
    [-76.0111, 38.3548],
    [-76.0087, 38.3553],
    [-76.0102, 38.3532],
    [-76.0137, 38.3470],
    [-76.0144, 38.3411],
    [-76.0210, 38.3317],
    [-76.0339, 38.3232],
    [-76.0456, 38.3182],
    [-76.0472, 38.3133],
    [-76.0622, 38.3053],
    [-76.0561, 38.3042],
    [-76.0477, 38.3018],
    [-76.0399, 38.2955],
    [-76.0354, 38.2897],
    [-76.0308, 38.2852],
    [-76.0275, 38.2801],
    [-76.0328, 38.2751],
    [-76.0329, 38.2687],
    [-76.0385, 38.2567],
    [-76.0406, 38.2503],
    [-76.0458, 38.2496],
    [-76.0504, 38.2502],
    [-76.0555, 38.2522],
    [-76.0583, 38.2501],
    [-76.0554, 38.2490],
    [-76.0499, 38.2460],
    [-76.0478, 38.2440],
    [-76.0441, 38.2434],
    [-76.0396, 38.2349],
    [-76.0364, 38.2322],
    [-76.0365, 38.2248],
    [-76.0334, 38.2202],
    [-76.0379, 38.2200],
    [-76.0408, 38.2250],
    [-76.0484, 38.2262],
    [-76.0526, 38.2269],
    [-76.0574, 38.2278],
    [-76.0597, 38.2307],
    [-76.0666, 38.2367],
    [-76.0691, 38.2389],
    [-76.0713, 38.2466],
    [-76.0749, 38.2522],
    [-76.0749, 38.2549],
    [-76.0809, 38.2527],
    [-76.0866, 38.2544],
    [-76.0944, 38.2525],
    [-76.0997, 38.2536],
    [-76.1076, 38.2625],
    [-76.1023, 38.2601],
    [-76.0965, 38.2570],
    [-76.0938, 38.2624],
    [-76.0875, 38.2624],
    [-76.0830, 38.2655],
    [-76.0813, 38.2664],
    [-76.0777, 38.2674],
    [-76.0788, 38.2707],
    [-76.0850, 38.2722],
    [-76.0873, 38.2733],
    [-76.0861, 38.2768],
    [-76.0939, 38.2788],
    [-76.0984, 38.2805],
    [-76.0986, 38.2840],
    [-76.0978, 38.2867],
    [-76.0990, 38.2904],
    [-76.1022, 38.2923],
    [-76.1087, 38.2888],
    [-76.1114, 38.2890],
    [-76.1149, 38.2927],
    [-76.1109, 38.2936],
    [-76.1054, 38.2981],
    [-76.1064, 38.3019],
    [-76.1093, 38.3007],
    [-76.1122, 38.2981],
    [-76.1150, 38.3029],
    [-76.1178, 38.3054],
    [-76.1206, 38.3003],
    [-76.1288, 38.3026],
    [-76.1297, 38.2964],
    [-76.1301, 38.2924],
    [-76.1323, 38.2895],
    [-76.1271, 38.2835],
    [-76.1235, 38.2811],
    [-76.1306, 38.2824],
    [-76.1372, 38.2817],
    [-76.1393, 38.2802],
    [-76.1428, 38.2767],
    [-76.1492, 38.2719],
    [-76.1490, 38.2761],
    [-76.1499, 38.2847],
    [-76.1427, 38.2897],
    [-76.1396, 38.2947],
    [-76.1397, 38.2976],
    [-76.1364, 38.2991],
    [-76.1334, 38.3042],
    [-76.1341, 38.3060],
    [-76.1339, 38.3097],
    [-76.1383, 38.3113],
    [-76.1425, 38.3136],
    [-76.1451, 38.3102],
    [-76.1596, 38.3158],
    [-76.1668, 38.3176],
    [-76.1729, 38.3224],
    [-76.1824, 38.3240],
    [-76.1846, 38.3233],
    [-76.1855, 38.3200],
    [-76.1932, 38.3164],
    [-76.1962, 38.3191],
    [-76.1973, 38.3239],
    [-76.1947, 38.3265],
    [-76.1878, 38.3249],
    [-76.1858, 38.3307],
    [-76.1892, 38.3316],
    [-76.1860, 38.3339],
    [-76.1779, 38.3341],
    [-76.1746, 38.3286],
    [-76.1723, 38.3272],
    [-76.1675, 38.3217],
    [-76.1606, 38.3204],
    [-76.1598, 38.3261],
    [-76.1618, 38.3304],
    [-76.1684, 38.3323],
    [-76.1723, 38.3372],
    [-76.1704, 38.3410],
    [-76.1721, 38.3460],
    [-76.1776, 38.3524],
    [-76.1824, 38.3596],
    [-76.1922, 38.3615],
    [-76.1970, 38.3640],
    [-76.1991, 38.3674],
    [-76.2046, 38.3710],
    [-76.2064, 38.3680],
    [-76.2105, 38.3661],
    [-76.2177, 38.3668],
    [-76.2188, 38.3698],
    [-76.2146, 38.3739],
    [-76.2138, 38.3783],
    [-76.2148, 38.3840],
    [-76.2156, 38.3896],
    [-76.2209, 38.3924],
    [-76.2253, 38.3951],
    [-76.2294, 38.3940],
    [-76.2323, 38.3890],
    [-76.2271, 38.3809],
    [-76.2328, 38.3749],
    [-76.2315, 38.3671],
    [-76.2339, 38.3653],
    [-76.2309, 38.3593],
    [-76.2274, 38.3512],
    [-76.2266, 38.3485],
    [-76.2205, 38.3424],
    [-76.2119, 38.3381],
    [-76.2119, 38.3316],
    [-76.2130, 38.3286],
    [-76.2188, 38.3270],
    [-76.2214, 38.3240],
    [-76.2195, 38.3203],
    [-76.2220, 38.3136],
    [-76.2203, 38.3102],
    [-76.2102, 38.3038],
    [-76.2011, 38.2916],
    [-76.1968, 38.2926],
    [-76.1892, 38.2947],
    [-76.1831, 38.2927],
    [-76.1772, 38.2940],
    [-76.1721, 38.2972],
    [-76.1664, 38.2927],
    [-76.1613, 38.2909],
    [-76.1686, 38.2914],
    [-76.1704, 38.2934],
    [-76.1748, 38.2916],
    [-76.1736, 38.2852],
    [-76.1818, 38.2807],
    [-76.1802, 38.2770],
    [-76.1747, 38.2703],
    [-76.1791, 38.2709],
    [-76.1800, 38.2679],
    [-76.1778, 38.2652],
    [-76.1697, 38.2570],
    [-76.1640, 38.2513],
    [-76.1521, 38.2486],
    [-76.1423, 38.2480],
    [-76.1338, 38.2460],
    [-76.1266, 38.2429],
    [-76.1300, 38.2346],
    [-76.1379, 38.2322],
    [-76.1462, 38.2333],
    [-76.1499, 38.2365],
    [-76.1567, 38.2430],
    [-76.1625, 38.2453],
    [-76.1670, 38.2449],
    [-76.1717, 38.2479],
    [-76.1786, 38.2570],
    [-76.1857, 38.2640],
    [-76.1905, 38.2771],
    [-76.1978, 38.2861],
    [-76.2010, 38.2886],
    [-76.2097, 38.3005],
    [-76.2176, 38.3057],
    [-76.2264, 38.3100],
    [-76.2290, 38.3137],
    [-76.2301, 38.3198],
    [-76.2334, 38.3231],
    [-76.2302, 38.3292],
    [-76.2329, 38.3452],
    [-76.2366, 38.3472],
    [-76.2406, 38.3523],
    [-76.2441, 38.3586],
    [-76.2500, 38.3623],
    [-76.2539, 38.3660],
    [-76.2586, 38.3689],
    [-76.2660, 38.3734],
    [-76.2702, 38.3746],
    [-76.2711, 38.3796],
    [-76.2781, 38.3824],
    [-76.2785, 38.3864],
    [-76.2814, 38.3913],
    [-76.2802, 38.3983],
    [-76.2815, 38.4112],
    [-76.2864, 38.4194],
    [-76.2932, 38.4256],
    [-76.2981, 38.4340],
    [-76.3024, 38.4414],
    [-76.3059, 38.4482],
    [-76.3118, 38.4504],
    [-76.3132, 38.4568],
    [-76.3258, 38.4674],
    [-76.3316, 38.4735],
    [-76.3314, 38.4793],
    [-76.3326, 38.4844],
    [-76.3296, 38.4861],
    [-76.3249, 38.4875],
    [-76.3267, 38.4898],
    [-76.3238, 38.4920],
    [-76.3277, 38.4969],
    [-76.3239, 38.4987],
    [-76.3198, 38.4974],
    [-76.3108, 38.4964],
    [-76.3040, 38.4993],
    [-76.2997, 38.5013],
    [-76.2876, 38.5035],
    [-76.2886, 38.5013],
    [-76.2852, 38.4978],
    [-76.2805, 38.4959],
    [-76.2682, 38.4972],
    [-76.2654, 38.4975],
    [-76.2631, 38.5027],
    [-76.2520, 38.5191],
    [-76.2445, 38.5240],
    [-76.2293, 38.5262],
    [-76.2203, 38.5318],
    [-76.2227, 38.5369],
    [-76.2290, 38.5405],
    [-76.2357, 38.5409],
    [-76.2504, 38.5390],
    [-76.2551, 38.5415],
    [-76.2674, 38.5426],
    [-76.2725, 38.5382],
    [-76.2738, 38.5339],
    [-76.2793, 38.5356],
    [-76.2772, 38.5425],
    [-76.2763, 38.5448],
    [-76.2756, 38.5525],
    [-76.2789, 38.5577],
    [-76.2837, 38.5622],
    [-76.2992, 38.5695],
    [-76.3050, 38.5725],
    [-76.2946, 38.5799],
    [-76.2901, 38.5826],
    [-76.2836, 38.5756],
    [-76.2774, 38.5778],
    [-76.2756, 38.5809],
    [-76.2662, 38.5861],
    [-76.2669, 38.5899],
    [-76.2718, 38.5909],
    [-76.2678, 38.5973],
    [-76.2654, 38.5971],
    [-76.2638, 38.6013],
    [-76.2639, 38.6038],
    [-76.2698, 38.6039],
    [-76.2715, 38.6019],
    [-76.2749, 38.6036],
    [-76.2789, 38.6115],
    [-76.2825, 38.6225],
    [-76.2843, 38.6263],
    [-76.2764, 38.6212],
    [-76.2732, 38.6178],
    [-76.2743, 38.6118],
    [-76.2651, 38.6112],
    [-76.2609, 38.6175],
    [-76.2571, 38.6145],
    [-76.2539, 38.6154],
    [-76.2499, 38.6153],
    [-76.2528, 38.6199],
    [-76.2497, 38.6248],
    [-76.2400, 38.6265],
    [-76.2346, 38.6257],
    [-76.2378, 38.6223],
    [-76.2382, 38.6167],
    [-76.2368, 38.6138],
    [-76.2351, 38.6118],
    [-76.2319, 38.6128],
    [-76.2232, 38.6114],
    [-76.2189, 38.6101],
    [-76.2124, 38.6067],
    [-76.2038, 38.6103],
    [-76.1981, 38.6148],
    [-76.1901, 38.6204],
    [-76.1766, 38.6276],
    [-76.1679, 38.6269],
    [-76.1647, 38.6187],
    [-76.1667, 38.6091],
    [-76.1680, 38.6036],
    [-76.1670, 38.6001],
    [-76.1614, 38.5952],
    [-76.1526, 38.5958],
    [-76.1497, 38.5982],
    [-76.1413, 38.6060],
    [-76.1389, 38.6037],
    [-76.1330, 38.5956],
    [-76.1270, 38.5915],
    [-76.1205, 38.5862],
    [-76.1147, 38.5832],
    [-76.1121, 38.5837],
    [-76.0901, 38.5929],
    [-76.0885, 38.5921],
    [-76.0825, 38.5848],
    [-76.0802, 38.5848],
    [-76.0782, 38.5837],
    [-76.0779, 38.5795],
    [-76.0726, 38.5787],
    [-76.0683, 38.5739],
    [-76.0629, 38.5717],
    [-76.0568, 38.5680],
    [-76.0472, 38.5628],
    [-76.0408, 38.5626],
    [-76.0387, 38.5630],
    [-76.0345, 38.5642],
    [-76.0285, 38.5723],
    [-76.0315, 38.5809],
    [-76.0347, 38.5839],
    [-76.0419, 38.5873],
    [-76.0477, 38.5918],
    [-76.0540, 38.5996],
    [-76.0568, 38.6060],
    [-76.0638, 38.6081],
    [-76.0803, 38.6147],
    [-76.0822, 38.6187],
    [-76.0852, 38.6246],
    [-76.0996, 38.6249],
    [-76.1092, 38.6201],
    [-76.1108, 38.6127],
    [-76.1131, 38.6153],
    [-76.1150, 38.6231],
    [-76.1235, 38.6290],
    [-76.1310, 38.6379],
    [-76.1396, 38.6385],
    [-76.1472, 38.6368],
    [-76.1556, 38.6581],
    [-76.1647, 38.6656],
    [-76.1687, 38.6681],
    [-76.1730, 38.6709],
    [-76.1752, 38.6732],
    [-76.1773, 38.6760],
    [-76.1728, 38.6801],
    [-76.1739, 38.6819],
    [-76.1730, 38.6874],
    [-76.1846, 38.6950],
    [-76.1896, 38.6883],
    [-76.1954, 38.6823],
    [-76.1995, 38.6735],
    [-76.1981, 38.6714],
    [-76.2042, 38.6755],
    [-76.2100, 38.6812],
    [-76.2139, 38.6868],
    [-76.2141, 38.6913],
    [-76.2196, 38.6972],
    [-76.2315, 38.7033],
    [-76.2383, 38.7123],
    [-76.2393, 38.7173],
    [-76.2340, 38.7239],
    [-76.2295, 38.7262],
    [-76.2318, 38.7315],
    [-76.2370, 38.7332],
    [-76.2346, 38.7372],
    [-76.2225, 38.7363],
    [-76.2125, 38.7310],
    [-76.2055, 38.7392],
    [-76.2133, 38.7427],
    [-76.2240, 38.7508],
    [-76.2226, 38.7576],
    [-76.2335, 38.7618],
    [-76.2410, 38.7607],
    [-76.2424, 38.7541],
    [-76.2441, 38.7500],
    [-76.2518, 38.7498],
    [-76.2548, 38.7395],
    [-76.2673, 38.7282],
    [-76.2716, 38.7132],
    [-76.2739, 38.7113],
    [-76.2820, 38.7181],
    [-76.2857, 38.7209],
    [-76.2888, 38.7198],
    [-76.2922, 38.7228],
    [-76.2937, 38.7182],
    [-76.2992, 38.7193],
    [-76.2982, 38.7263],
    [-76.2985, 38.7291],
    [-76.2947, 38.7310],
    [-76.2966, 38.7369],
    [-76.2957, 38.7410],
    [-76.2974, 38.7472],
    [-76.3032, 38.7502],
    [-76.3131, 38.7491],
    [-76.3128, 38.7458],
    [-76.3204, 38.7420],
    [-76.3236, 38.7383],
    [-76.3147, 38.7376],
    [-76.3128, 38.7307],
    [-76.3193, 38.7292],
    [-76.3229, 38.7224],
    [-76.3271, 38.7170],
    [-76.3292, 38.7148],
    [-76.3305, 38.7097],
    [-76.3303, 38.7081],
    [-76.3334, 38.7059],
    [-76.3267, 38.6915],
    [-76.3219, 38.6892],
    [-76.3241, 38.6791],
    [-76.3382, 38.6776],
    [-76.3401, 38.6759],
    [-76.3380, 38.6723],
    [-76.3437, 38.6817],
    [-76.3464, 38.6890],
    [-76.3438, 38.6955],
    [-76.3450, 38.7038],
    [-76.3413, 38.7144],
    [-76.3398, 38.7208],
    [-76.3388, 38.7270],
    [-76.3407, 38.7367],
    [-76.3425, 38.7490],
    [-76.3399, 38.7550],
    [-76.3373, 38.7607],
    [-76.3300, 38.7634],
    [-76.3294, 38.7688],
    [-76.3302, 38.7769],
    [-76.3243, 38.7751],
    [-76.3234, 38.7789],
    [-76.3188, 38.7878],
    [-76.3101, 38.7968],
    [-76.3033, 38.8209],
    [-76.2978, 38.8283],
    [-76.2921, 38.8277],
    [-76.2857, 38.8288],
    [-76.2814, 38.8317],
    [-76.2798, 38.8362],
    [-76.2794, 38.8412],
    [-76.2691, 38.8498],
    [-76.2564, 38.8604],
    [-76.2512, 38.8595],
    [-76.2558, 38.8569],
    [-76.2632, 38.8518],
    [-76.2658, 38.8476],
    [-76.2618, 38.8441],
    [-76.2564, 38.8362],
    [-76.2501, 38.8302],
    [-76.2503, 38.8253],
    [-76.2459, 38.8222],
    [-76.2394, 38.8201],
    [-76.2294, 38.8214],
    [-76.2229, 38.8152],
    [-76.2163, 38.8097],
    [-76.2156, 38.8011],
    [-76.2178, 38.8001],
    [-76.2148, 38.7944],
    [-76.2179, 38.7899],
    [-76.2164, 38.7868],
    [-76.2073, 38.7808],
    [-76.2037, 38.7771],
    [-76.1987, 38.7756],
    [-76.1938, 38.7698],
    [-76.1836, 38.7604],
    [-76.1785, 38.7558],
    [-76.1657, 38.7586],
    [-76.1656, 38.7619],
    [-76.1596, 38.7676],
    [-76.1563, 38.7712],
    [-76.1602, 38.7750],
    [-76.1652, 38.7743],
    [-76.1730, 38.7703],
    [-76.1793, 38.7758],
    [-76.1799, 38.7820],
    [-76.1864, 38.7861],
    [-76.1874, 38.7904],
    [-76.1885, 38.7922],
    [-76.1941, 38.7969],
    [-76.1982, 38.8083],
    [-76.1993, 38.8121],
    [-76.1930, 38.8252],
    [-76.1977, 38.8437],
    [-76.2056, 38.8524],
    [-76.2055, 38.8571],
    [-76.2001, 38.8829],
    [-76.1976, 38.8929],
    [-76.2013, 38.8962],
    [-76.2035, 38.8989],
    [-76.2047, 38.9154],
    [-76.2025, 38.9251],
    [-76.2075, 38.9312],
    [-76.2105, 38.9327],
    [-76.2123, 38.9390],
    [-76.2086, 38.9440],
    [-76.2113, 38.9439],
    [-76.2143, 38.9447],
    [-76.2187, 38.9467],
    [-76.2245, 38.9472],
    [-76.2320, 38.9425],
    [-76.2370, 38.9484],
    [-76.2365, 38.9542],
    [-76.2396, 38.9600],
    [-76.2413, 38.9627],
    [-76.2480, 38.9666],
    [-76.2526, 38.9652],
    [-76.2521, 38.9609],
    [-76.2523, 38.9580],
    [-76.2534, 38.9560],
    [-76.2523, 38.9497],
    [-76.2518, 38.9469],
    [-76.2536, 38.9449],
    [-76.2511, 38.9402],
    [-76.2543, 38.9386],
    [-76.2588, 38.9349],
    [-76.2600, 38.9313],
    [-76.2561, 38.9271],
    [-76.2480, 38.9238],
    [-76.2514, 38.9214],
    [-76.2558, 38.9190],
    [-76.2602, 38.9196],
    [-76.2647, 38.9246],
    [-76.2683, 38.9334],
    [-76.2707, 38.9421],
    [-76.2810, 38.9365],
    [-76.2882, 38.9332],
    [-76.2915, 38.9301],
    [-76.2956, 38.9288],
    [-76.2993, 38.9209],
    [-76.2940, 38.9103],
    [-76.2945, 38.9069],
    [-76.2996, 38.9027],
    [-76.3020, 38.9147],
    [-76.3065, 38.9245],
    [-76.3133, 38.9237],
    [-76.3170, 38.9203],
    [-76.3173, 38.9144],
    [-76.3241, 38.9131],
    [-76.3259, 38.9168],
    [-76.3298, 38.9185],
    [-76.3363, 38.9161],
    [-76.3400, 38.9112],
    [-76.3346, 38.9066],
    [-76.3362, 38.8969],
    [-76.3382, 38.8930],
    [-76.3354, 38.8860],
    [-76.3311, 38.8647],
    [-76.3379, 38.8576],
    [-76.3477, 38.8568],
    [-76.3577, 38.8534],
    [-76.3635, 38.8500],
    [-76.3657, 38.8442],
    [-76.3665, 38.8388],
    [-76.3727, 38.8375],
    [-76.3754, 38.8426],
    [-76.3760, 38.8484],
    [-76.3726, 38.8578],
    [-76.3692, 38.8630],
    [-76.3650, 38.8733],
    [-76.3652, 38.8924],
    [-76.3631, 38.9240],
    [-76.3623, 38.9293],
    [-76.3617, 38.9392],
    [-76.3538, 38.9572],
    [-76.3400, 38.9747],
    [-76.3350, 38.9797],
    [-76.3346, 38.9824],
    [-76.3245, 38.9957],
    [-76.3216, 39.0062],
    [-76.3222, 39.0147],
    [-76.3137, 39.0324],
    [-76.3018, 39.0397],
    [-76.3023, 39.0331],
    [-76.3029, 39.0318],
    [-76.3052, 39.0279],
    [-76.3028, 39.0258],
    [-76.3009, 39.0227],
    [-76.2970, 39.0135],
    [-76.2940, 39.0039],
    [-76.2892, 38.9977],
    [-76.2890, 38.9967],
    [-76.2815, 38.9893],
    [-76.2807, 38.9867],
    [-76.2710, 38.9834],
    [-76.2600, 38.9832],
    [-76.2622, 38.9806],
    [-76.2618, 38.9780],
    [-76.2566, 38.9754],
    [-76.2512, 38.9768],
    [-76.2528, 38.9805],
    [-76.2471, 38.9808],
    [-76.2439, 38.9802],
    [-76.2412, 38.9752],
    [-76.2381, 38.9735],
    [-76.2339, 38.9739],
    [-76.2305, 38.9796],
    [-76.2262, 38.9746],
    [-76.2189, 38.9705],
    [-76.2027, 38.9731],
    [-76.2016, 38.9735],
    [-76.1895, 38.9819],
    [-76.1789, 38.9903],
    [-76.1696, 38.9965],
    [-76.1635, 39.0025],
    [-76.1676, 39.0183],
    [-76.1704, 39.0237],
    [-76.1783, 39.0317],
    [-76.1771, 39.0442],
    [-76.1842, 39.0463],
    [-76.1799, 39.0532],
    [-76.1691, 39.0628],
    [-76.1590, 39.0655],
    [-76.1491, 39.0811],
    [-76.1450, 39.0902],
    [-76.1482, 39.0933],
    [-76.1649, 39.0960],
    [-76.1696, 39.0963],
    [-76.1839, 39.0963],
    [-76.1925, 39.0905],
    [-76.2050, 39.0830],
    [-76.2074, 39.0724],
    [-76.2122, 39.0656],
    [-76.2093, 39.0586],
    [-76.2100, 39.0454],
    [-76.2126, 39.0412],
    [-76.2110, 39.0373],
    [-76.2074, 39.0327],
    [-76.2085, 39.0248],
    [-76.2044, 39.0195],
    [-76.2015, 39.0135],
    [-76.2091, 39.0100],
    [-76.2139, 39.0095],
    [-76.2156, 39.0109],
    [-76.2221, 39.0146],
    [-76.2280, 39.0185],
    [-76.2344, 39.0216],
    [-76.2403, 39.0266],
    [-76.2409, 39.0349],
    [-76.2339, 39.0464],
    [-76.2312, 39.0472],
    [-76.2282, 39.0543],
    [-76.2314, 39.0717],
    [-76.2357, 39.0989],
    [-76.2387, 39.1039],
    [-76.2465, 39.1158],
    [-76.2473, 39.1187],
    [-76.2454, 39.1254],
    [-76.2449, 39.1306],
    [-76.2516, 39.1329],
    [-76.2613, 39.1399],
    [-76.2654, 39.1440],
    [-76.2774, 39.1516],
    [-76.2666, 39.1805],
    [-76.2510, 39.1992],
    [-76.2414, 39.2211],
    [-76.2321, 39.2333],
    [-76.2291, 39.2383],
    [-76.2256, 39.2497],
    [-76.2193, 39.2620],
    [-76.2074, 39.2686],
    [-76.2017, 39.2718],
    [-76.2001, 39.2800],
    [-76.1935, 39.2812],
    [-76.1831, 39.2910],
    [-76.1753, 39.2900],
    [-76.1689, 39.2903],
    [-76.1715, 39.2967],
    [-76.1777, 39.2987],
    [-76.1766, 39.3040],
    [-76.1833, 39.3110],
    [-76.1866, 39.3155],
    [-76.1781, 39.3230],
    [-76.1721, 39.3290],
    [-76.1597, 39.3359],
    [-76.1510, 39.3350],
    [-76.1455, 39.3344],
    [-76.1423, 39.3277],
    [-76.1399, 39.3292],
    [-76.1335, 39.3329],
    [-76.1332, 39.3405],
    [-76.1350, 39.3511],
    [-76.1164, 39.3609],
    [-76.1105, 39.3723],
    [-76.0798, 39.3707],
    [-76.0691, 39.3717],
    [-76.0623, 39.3720],
    [-76.0498, 39.3706],
    [-76.0281, 39.3650],
    [-76.0230, 39.3619],
    [-76.0106, 39.3663],
    [-76.0024, 39.3675],
    [-75.9932, 39.3721],
    [-75.9887, 39.3816],
    [-75.9939, 39.3834],
    [-76.0025, 39.3850],
    [-76.0128, 39.3856],
    [-76.0308, 39.3855],
    [-76.0399, 39.3881],
    [-76.0376, 39.3995],
    [-76.0221, 39.4071],
    [-76.0101, 39.4127],
    [-76.0035, 39.4190],
    [-75.9951, 39.4314],
    [-75.9826, 39.4353],
    [-75.9767, 39.4446],
    [-75.9762, 39.4481],
    [-75.9739, 39.4528],
    [-75.9691, 39.4585],
    [-75.9677, 39.4636],
    [-75.9822, 39.4702],
    [-75.9852, 39.4677],
    [-75.9884, 39.4602],
    [-75.9975, 39.4551],
    [-76.0052, 39.4494],
    [-76.0123, 39.4531],
    [-75.9994, 39.4659],
    [-75.9940, 39.4762],
    [-75.9948, 39.4897],
    [-75.9863, 39.5104],
    [-75.9843, 39.5142],
    [-75.9809, 39.5278],
    [-75.9761, 39.5300],
    [-75.9732, 39.5327],
    [-75.9663, 39.5322],
    [-75.9631, 39.5383],
    [-75.9692, 39.5416],
    [-75.9673, 39.5483],
    [-75.9703, 39.5576],
    [-75.9660, 39.5612],
    [-75.9592, 39.5646],
    [-75.9561, 39.5692],
    [-75.9562, 39.5738],
    [-75.9511, 39.5788],
    [-75.9484, 39.5821],
    [-75.9492, 39.5851],
    [-75.9491, 39.5890],
    [-75.9488, 39.5931],
    [-75.9512, 39.5934],
    [-75.9568, 39.5928],
    [-75.9597, 39.5910],
    [-75.9639, 39.5873],
    [-75.9653, 39.5789],
    [-75.9683, 39.5762],
    [-75.9730, 39.5705],
    [-75.9926, 39.5631],
    [-76.0026, 39.5552],
    [-76.0047, 39.5509],
    [-76.0064, 39.5462],
    [-76.0044, 39.5399],
    [-76.0129, 39.5401],
    [-76.0177, 39.5466],
    [-76.0303, 39.5486],
    [-76.0336, 39.5511],
    [-76.0367, 39.5526],
    [-76.0447, 39.5526],
    [-76.0460, 39.5502],
    [-76.0502, 39.5463],
    [-76.0629, 39.5466],
    [-76.0769, 39.5435],
    [-76.0845, 39.5407],
    [-76.0924, 39.5380],
    [-76.0981, 39.5303],
    [-76.0993, 39.5280],
    [-76.1030, 39.5236],
    [-76.1049, 39.5215],
    [-76.1112, 39.5060],
    [-76.1199, 39.4944],
    [-76.1245, 39.4883],
    [-76.1260, 39.4847],
    [-76.1191, 39.4812],
    [-76.1158, 39.4829],
    [-76.1154, 39.4869],
    [-76.1130, 39.4865],
    [-76.1047, 39.4788],
    [-76.0980, 39.4753],
    [-76.0946, 39.4755],
    [-76.0816, 39.4779],
    [-76.0760, 39.4744],
    [-76.0708, 39.4737],
    [-76.0668, 39.4624],
    [-76.0600, 39.4499],
    [-76.0710, 39.4436],
    [-76.0761, 39.4398],
    [-76.0814, 39.4369],
    [-76.0845, 39.4435],
    [-76.0977, 39.4440],
    [-76.1022, 39.4360],
    [-76.1168, 39.4276],
    [-76.1363, 39.4110],
    [-76.1464, 39.4053],
    [-76.1588, 39.4063],
    [-76.1711, 39.3926],
    [-76.1748, 39.3868],
    [-76.1867, 39.3809],
    [-76.1969, 39.3678],
    [-76.2119, 39.3603],
    [-76.2217, 39.3564],
    [-76.2270, 39.3499],
    [-76.2399, 39.3614],
    [-76.2501, 39.3613],
    [-76.2534, 39.3667],
    [-76.2485, 39.3688],
    [-76.2464, 39.3728],
    [-76.2517, 39.3768],
    [-76.2536, 39.3792],
    [-76.2473, 39.3843],
    [-76.2507, 39.3864],
    [-76.2416, 39.4040],
    [-76.2364, 39.4135],
    [-76.2259, 39.4238],
    [-76.2251, 39.4276],
    [-76.2285, 39.4302],
    [-76.2336, 39.4350],
    [-76.2395, 39.4386],
    [-76.2371, 39.4428],
    [-76.2327, 39.4516],
    [-76.2329, 39.4594],
    [-76.2440, 39.4579],
    [-76.2468, 39.4533],
    [-76.2536, 39.4426],
    [-76.2492, 39.4374],
    [-76.2474, 39.4350],
    [-76.2502, 39.4293],
    [-76.2517, 39.4218],
    [-76.2518, 39.4178],
    [-76.2548, 39.4119],
    [-76.2639, 39.4078],
    [-76.2689, 39.3999],
    [-76.2685, 39.3911],
    [-76.2688, 39.3887],
    [-76.2743, 39.3833],
    [-76.2739, 39.3794],
    [-76.2755, 39.3748],
    [-76.2812, 39.3719],
    [-76.2869, 39.3690],
    [-76.2836, 39.3651],
    [-76.2756, 39.3644],
    [-76.2669, 39.3561],
    [-76.2616, 39.3478],
    [-76.2566, 39.3389],
    [-76.2664, 39.3319],
    [-76.2761, 39.3229],
    [-76.2777, 39.3155],
    [-76.2806, 39.3061],
    [-76.2873, 39.2999],
    [-76.2965, 39.3026],
    [-76.2906, 39.3119],
    [-76.2911, 39.3181],
    [-76.2930, 39.3229],
    [-76.2988, 39.3292],
    [-76.2988, 39.3402],
    [-76.2957, 39.3500],
    [-76.3017, 39.3518],
    [-76.3237, 39.3572],
    [-76.3134, 39.3578],
    [-76.3059, 39.3645],
    [-76.3025, 39.3773],
    [-76.3071, 39.3854],
    [-76.3153, 39.3893],
    [-76.3230, 39.3899],
    [-76.3339, 39.3889],
    [-76.3389, 39.3905],
    [-76.3444, 39.3917],
    [-76.3460, 39.3941],
    [-76.3474, 39.3943],
    [-76.3509, 39.3926],
    [-76.3549, 39.3953],
    [-76.3576, 39.3900],
    [-76.3572, 39.3879],
    [-76.3589, 39.3813],
    [-76.3537, 39.3804],
    [-76.3501, 39.3752],
    [-76.3437, 39.3755],
    [-76.3378, 39.3733],
    [-76.3395, 39.3710],
    [-76.3394, 39.3622],
    [-76.3427, 39.3590],
    [-76.3437, 39.3560],
    [-76.3389, 39.3498],
    [-76.3356, 39.3423],
    [-76.3306, 39.3354],
    [-76.3369, 39.3388],
    [-76.3407, 39.3399],
    [-76.3471, 39.3401],
    [-76.3494, 39.3392],
    [-76.3495, 39.3339],
    [-76.3524, 39.3297],
    [-76.3492, 39.3264],
    [-76.3421, 39.3259],
    [-76.3343, 39.3223],
    [-76.3316, 39.3173],
    [-76.3326, 39.3151],
    [-76.3387, 39.3128],
    [-76.3400, 39.3112],
    [-76.3374, 39.3058],
    [-76.3400, 39.3045],
    [-76.3438, 39.3104],
    [-76.3462, 39.3136],
    [-76.3473, 39.3168],
    [-76.3506, 39.3165],
    [-76.3514, 39.3120],
    [-76.3553, 39.3126],
    [-76.3595, 39.3176],
    [-76.3636, 39.3209],
    [-76.3706, 39.3208],
    [-76.3703, 39.3199],
    [-76.3648, 39.3126],
    [-76.3711, 39.3042],
    [-76.3802, 39.2986],
    [-76.3846, 39.3000],
    [-76.3836, 39.3032],
    [-76.3838, 39.3083],
    [-76.3878, 39.3083],
    [-76.3921, 39.3074],
    [-76.3940, 39.3038],
    [-76.3957, 39.3040],
    [-76.4013, 39.3081],
    [-76.4029, 39.3083],
    [-76.4088, 39.3117],
    [-76.4110, 39.3082],
    [-76.4106, 39.3042],
    [-76.4056, 39.3001],
    [-76.3987, 39.2947],
    [-76.3990, 39.2922],
    [-76.3957, 39.2896],
    [-76.3952, 39.2875],
    [-76.3909, 39.2865],
    [-76.3820, 39.2852],
    [-76.3823, 39.2831],
    [-76.3827, 39.2788],
    [-76.3861, 39.2763],
    [-76.3886, 39.2779],
    [-76.3938, 39.2764],
    [-76.3954, 39.2756],
    [-76.3981, 39.2721],
    [-76.3991, 39.2702],
    [-76.3952, 39.2690],
    [-76.4020, 39.2587],
    [-76.4045, 39.2558],
    [-76.4011, 39.2492],
    [-76.4045, 39.2493],
    [-76.4063, 39.2480],
    [-76.4137, 39.2491],
    [-76.4227, 39.2529],
    [-76.4321, 39.2541],
    [-76.4400, 39.2463],
    [-76.4411, 39.2434],
    [-76.4335, 39.2393],
    [-76.4225, 39.2325],
    [-76.4139, 39.2320],
    [-76.4060, 39.2331],
    [-76.4005, 39.2382],
    [-76.3985, 39.2367],
    [-76.4011, 39.2327],
    [-76.3998, 39.2308],
    [-76.4154, 39.2218],
    [-76.4253, 39.2057],
    [-76.4388, 39.1993],
    [-76.4453, 39.1960],
    [-76.4496, 39.2038],
    [-76.4474, 39.2074],
    [-76.4441, 39.2104],
    [-76.4448, 39.2154],
    [-76.4534, 39.2182],
    [-76.4614, 39.2166],
    [-76.4615, 39.2041],
    [-76.4801, 39.2051],
    [-76.4864, 39.2030],
    [-76.4920, 39.2014],
    [-76.4991, 39.2060],
    [-76.5010, 39.2110],
    [-76.5009, 39.2137],
    [-76.4973, 39.2167],
    [-76.4978, 39.2224],
    [-76.4974, 39.2269],
    [-76.5032, 39.2321],
    [-76.5157, 39.2314],
    [-76.5172, 39.2416],
    [-76.5210, 39.2412],
    [-76.5296, 39.2403],
    [-76.5388, 39.2454],
    [-76.5404, 39.2505],
    [-76.5527, 39.2575],
    [-76.5599, 39.2571],
    [-76.5663, 39.2596],
    [-76.5715, 39.2607],
    [-76.5722, 39.2647],
    [-76.5776, 39.2644],
    [-76.5830, 39.2612],
    [-76.5865, 39.2613],
    [-76.5802, 39.2520],
    [-76.5785, 39.2508],
    [-76.5717, 39.2456],
    [-76.5656, 39.2412],
    [-76.5601, 39.2355],
    [-76.5600, 39.2312],
    [-76.5620, 39.2276],
    [-76.5595, 39.2204],
    [-76.5502, 39.2173],
    [-76.5421, 39.2123],
    [-76.5343, 39.2132],
    [-76.5324, 39.2100],
    [-76.5354, 39.2038],
    [-76.5309, 39.2010],
    [-76.5338, 39.1932],
    [-76.5300, 39.1870],
    [-76.5258, 39.1779],
    [-76.5189, 39.1743],
    [-76.5148, 39.1728],
    [-76.5124, 39.1725],
    [-76.5006, 39.1621],
    [-76.5018, 39.1581],
    [-76.5009, 39.1554],
    [-76.4939, 39.1552],
    [-76.4886, 39.1574],
    [-76.4862, 39.1624],
    [-76.4803, 39.1666],
    [-76.4769, 39.1642],
    [-76.4715, 39.1547],
    [-76.4401, 39.1375],
    [-76.4310, 39.1321],
    [-76.4320, 39.1196],
    [-76.4319, 39.1072],
    [-76.4222, 39.0838],
    [-76.4219, 39.0770],
    [-76.4246, 39.0709],
    [-76.4356, 39.0565],
    [-76.4356, 39.0501],
    [-76.4290, 39.0462],
    [-76.4051, 39.0332],
    [-76.4026, 39.0296],
    [-76.3964, 39.0184],
    [-76.4004, 39.0099],
    [-76.4061, 39.0067],
    [-76.4134, 39.0017],
    [-76.4138, 38.9989],
    [-76.4192, 38.9947],
    [-76.4218, 38.9916],
    [-76.4247, 38.9865],
    [-76.4266, 38.9906],
    [-76.4241, 38.9942],
    [-76.4258, 39.0005],
    [-76.4321, 38.9995],
    [-76.4345, 38.9967],
    [-76.4397, 38.9962],
    [-76.4493, 38.9937],
    [-76.4504, 38.9910],
    [-76.4490, 38.9828],
    [-76.4552, 38.9788],
    [-76.4545, 38.9823],
    [-76.4567, 38.9839],
    [-76.4585, 38.9847],
    [-76.4689, 38.9826],
    [-76.4762, 38.9815],
    [-76.4801, 38.9776],
    [-76.4786, 38.9756],
    [-76.4749, 38.9675],
    [-76.4732, 38.9624],
    [-76.4713, 38.9565],
    [-76.4631, 38.9486],
    [-76.4578, 38.9484],
    [-76.4597, 38.9339],
    [-76.4633, 38.9282],
    [-76.4632, 38.9248],
    [-76.4589, 38.9144],
    [-76.4607, 38.9072],
    [-76.4694, 38.9076],
    [-76.4765, 38.9150],
    [-76.4783, 38.9189],
    [-76.4835, 38.9236],
    [-76.4858, 38.9246],
    [-76.4933, 38.9265],
    [-76.5062, 38.9212],
    [-76.5089, 38.9158],
    [-76.5010, 38.9093],
    [-76.4945, 38.9093],
    [-76.4932, 38.9038],
    [-76.4939, 38.8996],
    [-76.4904, 38.8923],
    [-76.4907, 38.8848],
    [-76.5110, 38.8695],
    [-76.5194, 38.8631],
    [-76.5224, 38.8625],
    [-76.5306, 38.8629],
    [-76.5344, 38.8628],
    [-76.5375, 38.8585],
    [-76.5376, 38.8486],
    [-76.5280, 38.8510],
    [-76.5220, 38.8505],
    [-76.5169, 38.8512],
    [-76.5095, 38.8491],
    [-76.5071, 38.8473],
    [-76.5024, 38.8475],
    [-76.5001, 38.8498],
    [-76.4982, 38.8529],
    [-76.4935, 38.8482],
    [-76.4899, 38.8387],
    [-76.4920, 38.8342],
    [-76.4943, 38.8322],
    [-76.4955, 38.8305],
    [-76.4961, 38.8259],
    [-76.4969, 38.8217],
    [-76.4988, 38.8173],
    [-76.5004, 38.8139],
    [-76.5053, 38.8106],
    [-76.5063, 38.8055],
    [-76.5083, 38.8051],
    [-76.5101, 38.8012],
    [-76.5158, 38.7988],
    [-76.5263, 38.7931],
    [-76.5270, 38.7876],
    [-76.5281, 38.7858],
    [-76.5354, 38.7781],
    [-76.5381, 38.7757],
    [-76.5439, 38.7744],
    [-76.5553, 38.7701],
    [-76.5599, 38.7674],
    [-76.5571, 38.7569],
    [-76.5543, 38.7504],
    [-76.5575, 38.7447],
    [-76.5445, 38.7277],
    [-76.5355, 38.7282],
    [-76.5262, 38.7243],
    [-76.5288, 38.7109],
    [-76.5320, 38.7028],
    [-76.5325, 38.6982],
    [-76.5324, 38.6800],
    [-76.5300, 38.6684],
    [-76.5250, 38.6476],
    [-76.5241, 38.6450],
    [-76.5151, 38.6238],
    [-76.5129, 38.6195],
    [-76.5126, 38.6092],
    [-76.5163, 38.5902],
    [-76.5161, 38.5657],
    [-76.5175, 38.5391],
    [-76.5175, 38.5357],
    [-76.5110, 38.5160],
    [-76.4995, 38.4938],
    [-76.4927, 38.4828],
    [-76.4775, 38.4694],
    [-76.4713, 38.4645],
    [-76.4558, 38.4512],
    [-76.4540, 38.4485],
    [-76.4509, 38.4424],
    [-76.4357, 38.4329],
    [-76.4154, 38.4147],
    [-76.4135, 38.4093],
    [-76.4027, 38.3960],
    [-76.3948, 38.3894],
    [-76.3815, 38.3853],
    [-76.3909, 38.3751],
    [-76.3872, 38.3640],
    [-76.4015, 38.3449],
    [-76.4103, 38.3339],
    [-76.4172, 38.3254],
    [-76.4221, 38.3194],
    [-76.4329, 38.3245],
    [-76.4514, 38.3232],
    [-76.4518, 38.3211],
    [-76.4558, 38.3165],
    [-76.4671, 38.3278],
    [-76.4748, 38.3221],
    [-76.4768, 38.3161],
    [-76.4736, 38.3107],
    [-76.4638, 38.2993],
    [-76.4587, 38.2943],
    [-76.4528, 38.2932],
    [-76.4500, 38.2931],
    [-76.4483, 38.2928],
    [-76.4376, 38.2927],
    [-76.4293, 38.2944],
    [-76.4227, 38.3048],
    [-76.4089, 38.3045],
    [-76.4031, 38.3061],
    [-76.4001, 38.3095],
    [-76.3822, 38.3034],
    [-76.3753, 38.2973],
    [-76.3942, 38.2782],
    [-76.3984, 38.2657],
    [-76.3967, 38.2502],
    [-76.3916, 38.2366],
    [-76.3781, 38.2099],
    [-76.3619, 38.1920],
    [-76.3344, 38.1597],
    [-76.3284, 38.1490],
    [-76.3338, 38.1256],
    [-76.3398, 38.1206],
    [-76.3413, 38.1190],
    [-76.3319, 38.0996],
    [-76.3298, 38.0724],
    [-76.3218, 38.0497],
    [-76.3222, 38.0379],
    [-76.3302, 38.0512],
    [-76.3414, 38.0537],
    [-76.3528, 38.0532],
    [-76.3612, 38.0595],
    [-76.3717, 38.0807],
    [-76.3760, 38.0857],
    [-76.3831, 38.0908],
    [-76.3856, 38.0924],
    [-76.3907, 38.0941],
    [-76.3921, 38.1026],
    [-76.4054, 38.1070],
    [-76.4132, 38.1069],
    [-76.4166, 38.1045],
    [-76.4223, 38.1097],
    [-76.4290, 38.1223],
    [-76.4344, 38.1309],
    [-76.4378, 38.1378],
    [-76.4354, 38.1466],
    [-76.4395, 38.1491],
    [-76.4382, 38.1524],
    [-76.4379, 38.1598],
    [-76.4465, 38.1598],
    [-76.4524, 38.1584],
    [-76.4586, 38.1561],
    [-76.4696, 38.1534],
    [-76.4688, 38.1490],
    [-76.4643, 38.1409],
    [-76.4610, 38.1354],
    [-76.4650, 38.1275],
    [-76.4698, 38.1191],
    [-76.4661, 38.1097],
    [-76.4703, 38.1037],
    [-76.4756, 38.1060],
    [-76.4818, 38.1166],
    [-76.4983, 38.1342],
    [-76.5004, 38.1367],
    [-76.5021, 38.1389],
    [-76.5148, 38.1412],
    [-76.5290, 38.1347],
    [-76.5330, 38.1466],
    [-76.5402, 38.1528],
    [-76.5473, 38.1757],
    [-76.5491, 38.1769],
    [-76.5530, 38.1872],
    [-76.5617, 38.1951],
    [-76.5726, 38.2036],
    [-76.5906, 38.2142],
    [-76.6196, 38.2228],
    [-76.6439, 38.2251],
    [-76.6528, 38.2264],
    [-76.6658, 38.2328],
    [-76.6860, 38.2328],
    [-76.6876, 38.2394],
    [-76.6886, 38.2413],
    [-76.7025, 38.2384],
    [-76.7080, 38.2344],
    [-76.7199, 38.2332],
    [-76.7207, 38.2398],
    [-76.7231, 38.2415],
    [-76.7360, 38.2427],
    [-76.7412, 38.2346],
    [-76.7448, 38.2278],
    [-76.7593, 38.2242],
    [-76.7657, 38.2262],
    [-76.7786, 38.2285],
    [-76.7789, 38.2344],
    [-76.7760, 38.2381],
    [-76.7797, 38.2444],
    [-76.7836, 38.2451],
    [-76.7852, 38.2475],
    [-76.7890, 38.2512],
    [-76.7992, 38.2498],
    [-76.8052, 38.2536],
    [-76.8066, 38.2659],
    [-76.8041, 38.2736],
    [-76.8022, 38.2771],
    [-76.8071, 38.2854],
    [-76.8135, 38.2887],
    [-76.8182, 38.2957],
    [-76.8208, 38.2981],
    [-76.8217, 38.2999],
    [-76.8229, 38.3063],
    [-76.8252, 38.3114],
    [-76.8306, 38.3188],
    [-76.8310, 38.3201],
    [-76.8327, 38.3301],
    [-76.8382, 38.3359],
    [-76.8416, 38.3368],
    [-76.8298, 38.3419],
    [-76.8374, 38.3514],
    [-76.8479, 38.3554],
    [-76.8590, 38.3576],
    [-76.8585, 38.3526],
    [-76.8667, 38.3424],
    [-76.8694, 38.3334],
    [-76.8698, 38.3317],
    [-76.8587, 38.3248],
    [-76.8554, 38.3193],
    [-76.8544, 38.3130],
    [-76.8530, 38.3079],
    [-76.8530, 38.3048],
    [-76.8458, 38.2990],
    [-76.8462, 38.2920],
    [-76.8390, 38.2847],
    [-76.8348, 38.2740],
    [-76.8383, 38.2681],
    [-76.8378, 38.2616],
    [-76.8471, 38.2562],
    [-76.8643, 38.2689],
    [-76.8663, 38.2697],
    [-76.8805, 38.2753],
    [-76.9048, 38.2869],
    [-76.9209, 38.2916],
    [-76.9249, 38.2907],
    [-76.9244, 38.2988],
    [-76.9224, 38.3107],
    [-76.9236, 38.3149],
    [-76.9296, 38.3211],
    [-76.9421, 38.3296],
    [-76.9525, 38.3332],
    [-76.9672, 38.3416],
    [-76.9783, 38.3423],
    [-76.9770, 38.3537],
    [-76.9762, 38.3556],
    [-76.9801, 38.3605],
    [-76.9836, 38.3630],
    [-76.9843, 38.3747],
    [-76.9881, 38.3886],
    [-76.9883, 38.3950],
    [-76.9921, 38.3990],
    [-77.0016, 38.4220],
    [-77.0164, 38.4456],
    [-77.0285, 38.4451],
    [-77.0442, 38.4430],
    [-77.0647, 38.4310],
    [-77.0731, 38.4256],
    [-77.0835, 38.4176],
    [-77.0914, 38.4076],
    [-77.1066, 38.4062],
    [-77.1132, 38.4095],
    [-77.1250, 38.4085],
    [-77.1329, 38.3966],
    [-77.1512, 38.3854],
    [-77.1660, 38.3760],
    [-77.1753, 38.3724],
    [-77.1856, 38.3661],
    [-77.2035, 38.3616],
    [-77.2240, 38.3686],
    [-77.2469, 38.3802],
    [-77.2536, 38.3935],
    [-77.2576, 38.4023],
    [-77.2651, 38.4135],
    [-77.2580, 38.4278],
    [-77.2612, 38.4387],
    [-77.2629, 38.4494],
    [-77.2647, 38.4560],
    [-77.2695, 38.4665],
    [-77.2657, 38.4712],
    [-77.2718, 38.4777],
    [-77.2738, 38.4836],
    [-77.2670, 38.4986],
    [-77.2636, 38.5123],
    [-77.2576, 38.5218],
    [-77.2459, 38.5395],
    [-77.2361, 38.5527],
    [-77.2264, 38.5541],
    [-77.2149, 38.5624],
    [-77.2066, 38.5735],
    [-77.1919, 38.5862],
    [-77.1867, 38.5963],
    [-77.1697, 38.6069],
    [-77.1511, 38.6057],
    [-77.1478, 38.6061],
    [-77.1401, 38.6107],
    [-77.1291, 38.6144],
    [-77.1156, 38.6235],
    [-77.1062, 38.6341],
    [-77.1069, 38.6341],
    [-77.1144, 38.6338],
    [-77.1319, 38.6442],
    [-77.1325, 38.6738],
    [-77.1220, 38.6858],
    [-77.0990, 38.6986],
    [-77.0863, 38.7060],
    [-77.0807, 38.7113],
    [-77.0781, 38.7134],
    [-77.0742, 38.7126],
    [-77.0653, 38.7096],
    [-77.0462, 38.7144],
    [-77.0426, 38.7215],
    [-77.0415, 38.7298],
    [-77.0435, 38.7391],
    [-77.0421, 38.7467],
    [-77.0413, 38.7686],
    [-77.0401, 38.7899],
    [-77.0376, 38.7928],
    [-77.0015, 38.8214],
    [-77.0000, 38.8219],
    [-76.9959, 38.8254],
    [-76.9913, 38.8292],
    [-76.9850, 38.8338],
    [-76.9728, 38.8431],
    [-76.9708, 38.8448],
    [-76.9635, 38.8507],
    [-76.9581, 38.8549],
    [-76.9497, 38.8613],
    [-76.9436, 38.8661],
    [-76.9350, 38.8728],
    [-76.9299, 38.8768],
    [-76.9210, 38.8838],
    [-76.9193, 38.8851],
    [-76.9133, 38.8898],
    [-76.9108, 38.8917],
    [-76.9110, 38.8941],
    [-76.9199, 38.9012],
    [-76.9276, 38.9073],
    [-76.9317, 38.9106],
    [-76.9419, 38.9186],
    [-76.9561, 38.9295],
    [-76.9577, 38.9308],
    [-76.9634, 38.9352],
    [-76.9682, 38.9389],
    [-76.9778, 38.9463],
    [-76.9879, 38.9541],
    [-76.9974, 38.9614],
    [-77.0016, 38.9648],
    [-77.0026, 38.9655],
    [-77.0086, 38.9703],
    [-77.0156, 38.9759],
    [-77.0187, 38.9783],
    [-77.0266, 38.9843],
    [-77.0337, 38.9897],
    [-77.0368, 38.9921],
    [-77.0465, 38.9909],
    [-77.0529, 38.9861],
    [-77.0667, 38.9756],
    [-77.0716, 38.9718],
    [-77.0804, 38.9650],
    [-77.0838, 38.9624],
    [-77.0914, 38.9566],
    [-77.0939, 38.9546],
    [-77.1007, 38.9489],
    [-77.1125, 38.9401],
    [-77.1198, 38.9344],
    [-77.1377, 38.9553],
    [-77.1499, 38.9655],
    [-77.1669, 38.9681],
    [-77.1719, 38.9675],
    [-77.1830, 38.9688],
    [-77.2025, 38.9679],
    [-77.2115, 38.9694],
    [-77.2284, 38.9784],
    [-77.2323, 38.9795],
    [-77.2446, 38.9825],
    [-77.2492, 38.9937],
    [-77.2518, 39.0114],
    [-77.2449, 39.0212],
    [-77.2484, 39.0269],
    [-77.2660, 39.0319],
    [-77.2931, 39.0465],
    [-77.3149, 39.0522],
    [-77.3337, 39.0595],
    [-77.3355, 39.0618],
    [-77.3503, 39.0621],
    [-77.3675, 39.0611],
    [-77.3785, 39.0623],
    [-77.3992, 39.0648],
    [-77.4154, 39.0664],
    [-77.4232, 39.0669],
    [-77.4513, 39.0723],
    [-77.4582, 39.0737],
    [-77.4626, 39.0762],
    [-77.4694, 39.0864],
    [-77.4752, 39.0972],
    [-77.4778, 39.1013],
    [-77.4950, 39.1130],
    [-77.5153, 39.1186],
    [-77.5246, 39.1278],
    [-77.5272, 39.1447],
    [-77.5244, 39.1500],
    [-77.5106, 39.1785],
    [-77.4786, 39.1892],
    [-77.4759, 39.2020],
    [-77.4599, 39.2187],
    [-77.4577, 39.2250],
    [-77.4712, 39.2345],
    [-77.4847, 39.2461],
    [-77.5084, 39.2526],
    [-77.5225, 39.2591],
    [-77.5432, 39.2669],
    [-77.5466, 39.2721],
    [-77.5513, 39.2762],
    [-77.5628, 39.2945],
    [-77.5658, 39.3056],
    [-77.5785, 39.3052],
    [-77.5927, 39.3013],
    [-77.6054, 39.3035],
    [-77.6159, 39.3027],
    [-77.6361, 39.3078],
    [-77.6433, 39.3090],
    [-77.6510, 39.3108],
    [-77.6758, 39.3242],
    [-77.6871, 39.3199],
    [-77.7077, 39.3216],
    [-77.7269, 39.3216],
    [-77.7305, 39.3244],
    [-77.7507, 39.3322],
    [-77.7576, 39.3355],
    [-77.7611, 39.3398],
    [-77.7593, 39.3453],
    [-77.7439, 39.3599],
    [-77.7533, 39.3783],
    [-77.7522, 39.3833],
    [-77.7381, 39.3862],
    [-77.7359, 39.3897],
    [-77.7475, 39.4109],
    [-77.7547, 39.4247],
    [-77.7647, 39.4284],
    [-77.7928, 39.4306],
    [-77.7989, 39.4333],
    [-77.8032, 39.4371],
    [-77.7886, 39.4428],
    [-77.7861, 39.4472],
    [-77.7993, 39.4584],
    [-77.7932, 39.4620],
    [-77.7792, 39.4604],
    [-77.7785, 39.4637],
    [-77.7968, 39.4724],
    [-77.7967, 39.4805],
    [-77.7818, 39.4871],
    [-77.7680, 39.4908],
    [-77.7656, 39.4930],
    [-77.7660, 39.4957],
    [-77.7709, 39.4991],
    [-77.7844, 39.4981],
    [-77.7918, 39.4908],
    [-77.8018, 39.4894],
    [-77.8255, 39.4943],
    [-77.8476, 39.5007],
    [-77.8476, 39.5034],
    [-77.8256, 39.5169],
    [-77.8254, 39.5292],
    [-77.8369, 39.5322],
    [-77.8407, 39.5209],
    [-77.8602, 39.5143],
    [-77.8661, 39.5177],
    [-77.8651, 39.5282],
    [-77.8654, 39.5384],
    [-77.8889, 39.5559],
    [-77.8880, 39.5592],
    [-77.8785, 39.5635],
    [-77.8657, 39.5635],
    [-77.8363, 39.5664],
    [-77.8323, 39.5748],
    [-77.8302, 39.5846],
    [-77.8316, 39.6003],
    [-77.8380, 39.6061],
    [-77.8534, 39.6071],
    [-77.8668, 39.6106],
    [-77.8851, 39.6158],
    [-77.8819, 39.6081],
    [-77.8818, 39.6000],
    [-77.8885, 39.5973],
    [-77.9164, 39.6028],
    [-77.9259, 39.6076],
    [-77.9329, 39.6177],
    [-77.9426, 39.6183],
    [-77.9384, 39.6126],
    [-77.9364, 39.5945],
    [-77.9462, 39.5848],
    [-77.9522, 39.5973],
    [-77.9521, 39.6064],
    [-77.9662, 39.6074],
    [-77.9740, 39.6011],
    [-77.9914, 39.6002],
    [-78.0067, 39.6013],
    [-78.0224, 39.6196],
    [-78.0360, 39.6357],
    [-78.0477, 39.6431],
    [-78.0519, 39.6482],
    [-78.0775, 39.6689],
    [-78.0886, 39.6712],
    [-78.0998, 39.6794],
    [-78.1118, 39.6826],
    [-78.1352, 39.6883],
    [-78.1565, 39.6914],
    [-78.1766, 39.6960],
    [-78.1911, 39.6903],
    [-78.2011, 39.6779],
    [-78.2273, 39.6761],
    [-78.2330, 39.6705],
    [-78.2251, 39.6589],
    [-78.2403, 39.6502],
    [-78.2622, 39.6305],
    [-78.2651, 39.6193],
    [-78.2827, 39.6204],
    [-78.2926, 39.6239],
    [-78.3319, 39.6361],
    [-78.3552, 39.6406],
    [-78.3587, 39.6356],
    [-78.3535, 39.6289],
    [-78.3583, 39.6256],
    [-78.3680, 39.6289],
    [-78.3825, 39.6282],
    [-78.3830, 39.6222],
    [-78.3723, 39.6112],
    [-78.3782, 39.6082],
    [-78.3958, 39.6161],
    [-78.4259, 39.6245],
    [-78.4336, 39.6183],
    [-78.4256, 39.6076],
    [-78.4129, 39.5983],
    [-78.3955, 39.5874],
    [-78.4009, 39.5802],
    [-78.4201, 39.5817],
    [-78.4432, 39.5912],
    [-78.4545, 39.5890],
    [-78.4583, 39.5804],
    [-78.4427, 39.5669],
    [-78.4233, 39.5563],
    [-78.4176, 39.5472],
    [-78.4270, 39.5466],
    [-78.4319, 39.5525],
    [-78.4390, 39.5519],
    [-78.4348, 39.5440],
    [-78.4384, 39.5388],
    [-78.4511, 39.5502],
    [-78.4618, 39.5498],
    [-78.4562, 39.5445],
    [-78.4486, 39.5400],
    [-78.4550, 39.5382],
    [-78.4628, 39.5358],
    [-78.4610, 39.5269],
    [-78.4686, 39.5168],
    [-78.4807, 39.5190],
    [-78.4897, 39.5178],
    [-78.5136, 39.5225],
    [-78.5233, 39.5247],
    [-78.5501, 39.5207],
    [-78.5659, 39.5194],
    [-78.5782, 39.5266],
    [-78.5878, 39.5279],
    [-78.5901, 39.5354],
    [-78.5945, 39.5365],
    [-78.6023, 39.5321],
    [-78.6069, 39.5351],
    [-78.6230, 39.5395],
    [-78.6287, 39.5379],
    [-78.6574, 39.5351],
    [-78.6756, 39.5404],
    [-78.6915, 39.5476],
    [-78.6946, 39.5533],
    [-78.7133, 39.5620],
    [-78.7250, 39.5640],
    [-78.7320, 39.5754],
    [-78.7385, 39.5863],
    [-78.7464, 39.5795],
    [-78.7602, 39.5822],
    [-78.7685, 39.5916],
    [-78.7743, 39.5973],
    [-78.7781, 39.6021],
    [-78.7605, 39.6100],
    [-78.7492, 39.6065],
    [-78.7390, 39.6097],
    [-78.7362, 39.6217],
    [-78.7485, 39.6263],
    [-78.7696, 39.6194],
    [-78.7785, 39.6244],
    [-78.7711, 39.6384],
    [-78.7653, 39.6440],
    [-78.7657, 39.6480],
    [-78.7722, 39.6466],
    [-78.7813, 39.6368],
    [-78.7946, 39.6370],
    [-78.7941, 39.6346],
    [-78.7986, 39.6287],
    [-78.7960, 39.6142],
    [-78.7959, 39.6069],
    [-78.8018, 39.6068],
    [-78.8093, 39.6081],
    [-78.8122, 39.6004],
    [-78.8183, 39.5923],
    [-78.8248, 39.5902],
    [-78.8264, 39.5773],
    [-78.8135, 39.5677],
    [-78.8264, 39.5626],
    [-78.8400, 39.5663],
    [-78.8442, 39.5624],
    [-78.8512, 39.5599],
    [-78.8544, 39.5483],
    [-78.8669, 39.5398],
    [-78.8710, 39.5358],
    [-78.8747, 39.5226],
    [-78.8860, 39.5226],
    [-78.8933, 39.5238],
    [-78.8915, 39.5153],
    [-78.9038, 39.5126],
    [-78.9039, 39.5047],
    [-78.9122, 39.4953],
    [-78.9165, 39.4865],
    [-78.9270, 39.4870],
    [-78.9399, 39.4829],
    [-78.9426, 39.4796],
    [-78.9390, 39.4747],
    [-78.9466, 39.4661],
    [-78.9592, 39.4619],
    [-78.9543, 39.4547],
    [-78.9601, 39.4504],
    [-78.9568, 39.4403],
    [-78.9675, 39.4398],
    [-78.9788, 39.4487],
    [-79.0040, 39.4582],
    [-79.0171, 39.4670],
    [-79.0282, 39.4651],
    [-79.0357, 39.4713],
    [-79.0369, 39.4768],
    [-79.0444, 39.4798],
    [-79.0505, 39.4833],
    [-79.0539, 39.4801],
    [-79.0550, 39.4731],
    [-79.0608, 39.4717],
    [-79.0664, 39.4799],
    [-79.0679, 39.4791],
    [-79.0751, 39.4731],
    [-79.0949, 39.4747],
    [-79.1052, 39.4742],
    [-79.1005, 39.4688],
    [-79.0954, 39.4625],
    [-79.1086, 39.4587],
    [-79.1019, 39.4573],
    [-79.1034, 39.4497],
    [-79.1141, 39.4433],
    [-79.1135, 39.4367],
    [-79.1155, 39.4317],
    [-79.1290, 39.4295],
    [-79.1279, 39.4191],
    [-79.1320, 39.4179],
    [-79.1423, 39.4167],
    [-79.1416, 39.4075],
    [-79.1498, 39.4057],
    [-79.1512, 39.4170],
    [-79.1592, 39.4130],
    [-79.1603, 39.4081],
    [-79.1656, 39.3971],
    [-79.1652, 39.3871],
    [-79.1786, 39.3966],
    [-79.1770, 39.3890],
    [-79.1891, 39.3864],
    [-79.1971, 39.3886],
    [-79.2121, 39.3708],
    [-79.2204, 39.3632],
    [-79.2316, 39.3646],
    [-79.2375, 39.3585],
    [-79.2480, 39.3573],
    [-79.2563, 39.3572],
    [-79.2535, 39.3481],
    [-79.2574, 39.3425],
    [-79.2539, 39.3391],
    [-79.2598, 39.3342],
    [-79.2694, 39.3307],
    [-79.2743, 39.3277],
    [-79.2837, 39.3096],
    [-79.2927, 39.2987],
    [-79.3128, 39.3036],
    [-79.3200, 39.3017],
    [-79.3324, 39.2999],
    [-79.3405, 39.2938],
    [-79.3460, 39.2940],
    [-79.3472, 39.2924],
    [-79.3436, 39.2871],
    [-79.3510, 39.2852],
    [-79.3537, 39.2780],
    [-79.3577, 39.2764],
    [-79.3762, 39.2732],
    [-79.3819, 39.2669],
    [-79.3878, 39.2675],
    [-79.3909, 39.2612],
    [-79.3957, 39.2564],
    [-79.3984, 39.2529],
    [-79.4076, 39.2466],
    [-79.4203, 39.2389],
    [-79.4244, 39.2282],
    [-79.4307, 39.2245],
    [-79.4398, 39.2171],
    [-79.4527, 39.2117],
    [-79.4611, 39.2114],
    [-79.4698, 39.2037],
    [-79.4869, 39.2060],
    [-79.4873, 39.2652],
    [-79.4877, 39.2799],
    [-79.4876, 39.2800]
    ]
  },
  "Maine": {
    coordinates: [
      [-71.0800, 45.3070],
    [-71.0662, 45.3114],
    [-71.0557, 45.3129],
    [-71.0425, 45.3130],
    [-71.0325, 45.3101],
    [-71.0240, 45.3154],
    [-71.0091, 45.3190],
    [-71.0024, 45.3285],
    [-71.0106, 45.3336],
    [-71.0112, 45.3399],
    [-71.0108, 45.3472],
    [-70.9977, 45.3404],
    [-70.9902, 45.3363],
    [-70.9826, 45.3327],
    [-70.9759, 45.3335],
    [-70.9611, 45.3368],
    [-70.9508, 45.3345],
    [-70.9452, 45.3291],
    [-70.9406, 45.3232],
    [-70.9272, 45.3148],
    [-70.9200, 45.3077],
    [-70.9121, 45.2962],
    [-70.9200, 45.2850],
    [-70.9165, 45.2773],
    [-70.9080, 45.2693],
    [-70.8986, 45.2585],
    [-70.8951, 45.2523],
    [-70.8969, 45.2420],
    [-70.8850, 45.2349],
    [-70.8570, 45.2292],
    [-70.8398, 45.2342],
    [-70.8388, 45.2376],
    [-70.8465, 45.2530],
    [-70.8433, 45.2657],
    [-70.8365, 45.2756],
    [-70.8298, 45.2869],
    [-70.8355, 45.2938],
    [-70.8192, 45.2989],
    [-70.8123, 45.3020],
    [-70.8086, 45.3116],
    [-70.8071, 45.3225],
    [-70.8103, 45.3277],
    [-70.8181, 45.3326],
    [-70.8195, 45.3414],
    [-70.8101, 45.3485],
    [-70.8144, 45.3565],
    [-70.8076, 45.3634],
    [-70.8027, 45.3666],
    [-70.8124, 45.3833],
    [-70.8223, 45.3905],
    [-70.8242, 45.3964],
    [-70.8193, 45.4045],
    [-70.8114, 45.4162],
    [-70.7987, 45.4241],
    [-70.7918, 45.4282],
    [-70.7724, 45.4287],
    [-70.7587, 45.4280],
    [-70.7515, 45.4261],
    [-70.7448, 45.4172],
    [-70.7308, 45.4046],
    [-70.7227, 45.3953],
    [-70.7051, 45.3934],
    [-70.6925, 45.3926],
    [-70.6835, 45.3952],
    [-70.6608, 45.3782],
    [-70.6460, 45.3787],
    [-70.6389, 45.3889],
    [-70.6340, 45.3979],
    [-70.6215, 45.4027],
    [-70.6353, 45.4121],
    [-70.6305, 45.4187],
    [-70.6313, 45.4268],
    [-70.6437, 45.4347],
    [-70.6497, 45.4428],
    [-70.6630, 45.4465],
    [-70.6811, 45.4584],
    [-70.6904, 45.4636],
    [-70.6921, 45.4747],
    [-70.7079, 45.4809],
    [-70.7159, 45.4931],
    [-70.7161, 45.5045],
    [-70.7234, 45.5104],
    [-70.7166, 45.5185],
    [-70.7058, 45.5283],
    [-70.7006, 45.5315],
    [-70.6962, 45.5404],
    [-70.6839, 45.5512],
    [-70.6836, 45.5566],
    [-70.6882, 45.5640],
    [-70.6877, 45.5694],
    [-70.6718, 45.5763],
    [-70.6593, 45.5869],
    [-70.6496, 45.5981],
    [-70.6353, 45.6102],
    [-70.6172, 45.6164],
    [-70.6062, 45.6264],
    [-70.5923, 45.6299],
    [-70.5868, 45.6354],
    [-70.5798, 45.6434],
    [-70.5648, 45.6551],
    [-70.5637, 45.6619],
    [-70.5528, 45.6678],
    [-70.5414, 45.6667],
    [-70.5268, 45.6665],
    [-70.5189, 45.6723],
    [-70.5027, 45.6817],
    [-70.4966, 45.6870],
    [-70.4699, 45.7016],
    [-70.4660, 45.7063],
    [-70.4567, 45.7070],
    [-70.4469, 45.7040],
    [-70.4389, 45.7044],
    [-70.4296, 45.7102],
    [-70.4142, 45.7150],
    [-70.4004, 45.7198],
    [-70.3972, 45.7270],
    [-70.3904, 45.7285],
    [-70.3895, 45.7360],
    [-70.3919, 45.7459],
    [-70.3961, 45.7563],
    [-70.4056, 45.7703],
    [-70.4089, 45.7796],
    [-70.4157, 45.7862],
    [-70.4177, 45.7946],
    [-70.4063, 45.7975],
    [-70.3996, 45.7962],
    [-70.3982, 45.8041],
    [-70.3882, 45.8139],
    [-70.3758, 45.8277],
    [-70.3718, 45.8342],
    [-70.3639, 45.8348],
    [-70.3564, 45.8376],
    [-70.3529, 45.8423],
    [-70.3463, 45.8493],
    [-70.3297, 45.8538],
    [-70.3172, 45.8564],
    [-70.3030, 45.8633],
    [-70.2800, 45.8762],
    [-70.2738, 45.8797],
    [-70.2627, 45.8879],
    [-70.2658, 45.8935],
    [-70.2537, 45.9030],
    [-70.2590, 45.9094],
    [-70.2586, 45.9186],
    [-70.2633, 45.9202],
    [-70.2622, 45.9252],
    [-70.2550, 45.9300],
    [-70.2402, 45.9409],
    [-70.2428, 45.9463],
    [-70.2554, 45.9526],
    [-70.2602, 45.9575],
    [-70.2674, 45.9631],
    [-70.2743, 45.9643],
    [-70.2896, 45.9632],
    [-70.3053, 45.9649],
    [-70.3169, 45.9635],
    [-70.3121, 45.9715],
    [-70.3097, 45.9802],
    [-70.2960, 45.9860],
    [-70.2849, 45.9956],
    [-70.3030, 45.9990],
    [-70.3064, 46.0103],
    [-70.3176, 46.0191],
    [-70.3035, 46.0268],
    [-70.2992, 46.0385],
    [-70.2892, 46.0469],
    [-70.2783, 46.0570],
    [-70.2816, 46.0604],
    [-70.2928, 46.0607],
    [-70.3106, 46.0645],
    [-70.3020, 46.0739],
    [-70.3024, 46.0806],
    [-70.2898, 46.0943],
    [-70.2787, 46.0999],
    [-70.2540, 46.0996],
    [-70.2550, 46.1083],
    [-70.2436, 46.1288],
    [-70.2379, 46.1474],
    [-70.2504, 46.1561],
    [-70.2649, 46.1648],
    [-70.2736, 46.1725],
    [-70.2909, 46.1858],
    [-70.2855, 46.1970],
    [-70.2721, 46.2098],
    [-70.2682, 46.2187],
    [-70.2586, 46.2356],
    [-70.2519, 46.2525],
    [-70.2484, 46.2671],
    [-70.2399, 46.2791],
    [-70.2205, 46.2933],
    [-70.2057, 46.2999],
    [-70.2031, 46.3144],
    [-70.2074, 46.3215],
    [-70.2074, 46.3313],
    [-70.1957, 46.3431],
    [-70.1887, 46.3500],
    [-70.1747, 46.3585],
    [-70.1613, 46.3610],
    [-70.1485, 46.3589],
    [-70.1403, 46.3653],
    [-70.1297, 46.3694],
    [-70.1255, 46.3814],
    [-70.1104, 46.3861],
    [-70.1006, 46.3993],
    [-70.0963, 46.4094],
    [-70.0803, 46.4105],
    [-70.0642, 46.4137],
    [-70.0234, 46.5735],
    [-69.9942, 46.6986],
    [-69.8745, 46.8186],
    [-69.4392, 47.2500],
    [-69.2200, 47.4572],
    [-69.2039, 47.4522],
    [-69.1917, 47.4549],
    [-69.1820, 47.4556],
    [-69.1710, 47.4534],
    [-69.1616, 47.4474],
    [-69.1561, 47.4510],
    [-69.1464, 47.4489],
    [-69.1397, 47.4448],
    [-69.1247, 47.4421],
    [-69.1129, 47.4380],
    [-69.1073, 47.4312],
    [-69.1036, 47.4308],
    [-69.0968, 47.4270],
    [-69.0868, 47.4252],
    [-69.0756, 47.4267],
    [-69.0627, 47.4304],
    [-69.0555, 47.4323],
    [-69.0489, 47.4251],
    [-69.0464, 47.4247],
    [-69.0427, 47.4267],
    [-69.0394, 47.4201],
    [-69.0369, 47.4080],
    [-69.0325, 47.4022],
    [-69.0374, 47.4015],
    [-69.0386, 47.3969],
    [-69.0454, 47.3919],
    [-69.0398, 47.3863],
    [-69.0440, 47.3837],
    [-69.0501, 47.3786],
    [-69.0549, 47.3153],
    [-69.0513, 47.2998],
    [-69.0523, 47.2931],
    [-69.0494, 47.2847],
    [-69.0478, 47.2742],
    [-69.0471, 47.2671],
    [-69.0493, 47.2621],
    [-69.0503, 47.2559],
    [-69.0285, 47.2396],
    [-68.9915, 47.2248],
    [-68.9751, 47.2167],
    [-68.9611, 47.2056],
    [-68.9525, 47.2061],
    [-68.9489, 47.2028],
    [-68.9339, 47.2000],
    [-68.9279, 47.1970],
    [-68.9203, 47.1950],
    [-68.9139, 47.1881],
    [-68.9075, 47.1849],
    [-68.9001, 47.1777],
    [-68.8932, 47.1830],
    [-68.8779, 47.1866],
    [-68.8632, 47.1886],
    [-68.8485, 47.1976],
    [-68.8229, 47.2091],
    [-68.8037, 47.2155],
    [-68.7643, 47.2220],
    [-68.7348, 47.2354],
    [-68.7136, 47.2410],
    [-68.7053, 47.2381],
    [-68.6934, 47.2431],
    [-68.6845, 47.2429],
    [-68.6620, 47.2363],
    [-68.6480, 47.2397],
    [-68.6255, 47.2424],
    [-68.6124, 47.2448],
    [-68.6047, 47.2495],
    [-68.5933, 47.2595],
    [-68.5987, 47.2679],
    [-68.5925, 47.2747],
    [-68.5887, 47.2817],
    [-68.5711, 47.2870],
    [-68.5517, 47.2822],
    [-68.5291, 47.2926],
    [-68.5074, 47.2966],
    [-68.4904, 47.2938],
    [-68.4749, 47.2975],
    [-68.4640, 47.2923],
    [-68.4582, 47.2846],
    [-68.4326, 47.2819],
    [-68.4166, 47.2874],
    [-68.3899, 47.2867],
    [-68.3768, 47.2885],
    [-68.3763, 47.2943],
    [-68.3841, 47.3015],
    [-68.3817, 47.3078],
    [-68.3843, 47.3269],
    [-68.3786, 47.3431],
    [-68.3657, 47.3538],
    [-68.3535, 47.3572],
    [-68.3362, 47.3598],
    [-68.3215, 47.3586],
    [-68.3007, 47.3561],
    [-68.2893, 47.3602],
    [-68.2725, 47.3549],
    [-68.2480, 47.3525],
    [-68.2276, 47.3530],
    [-68.2241, 47.3467],
    [-68.2146, 47.3396],
    [-68.2023, 47.3394],
    [-68.1613, 47.3278],
    [-68.1525, 47.3215],
    [-68.1523, 47.3099],
    [-68.1282, 47.2942],
    [-68.1197, 47.2873],
    [-68.0802, 47.2699],
    [-68.0741, 47.2598],
    [-68.0373, 47.2457],
    [-68.0161, 47.2344],
    [-67.9919, 47.2120],
    [-67.9738, 47.2069],
    [-67.9568, 47.1992],
    [-67.9513, 47.1897],
    [-67.9447, 47.1770],
    [-67.9387, 47.1704],
    [-67.9275, 47.1550],
    [-67.9104, 47.1481],
    [-67.8933, 47.1299],
    [-67.8892, 47.1188],
    [-67.8856, 47.1073],
    [-67.8772, 47.1018],
    [-67.8490, 47.0935],
    [-67.8233, 47.0843],
    [-67.8107, 47.0761],
    [-67.7905, 47.0679],
    [-67.7898, 47.0000],
    [-67.7893, 46.8722],
    [-67.7893, 46.7582],
    [-67.7884, 46.5999],
    [-67.7845, 46.4376],
    [-67.7821, 46.2794],
    [-67.7814, 46.0962],
    [-67.7814, 45.9639],
    [-67.7800, 45.9382],
    [-67.7749, 45.9350],
    [-67.7688, 45.9322],
    [-67.7618, 45.9276],
    [-67.7504, 45.9179],
    [-67.7557, 45.9117],
    [-67.7637, 45.9104],
    [-67.7674, 45.9047],
    [-67.7687, 45.8980],
    [-67.7792, 45.8951],
    [-67.7969, 45.8880],
    [-67.8039, 45.8829],
    [-67.8023, 45.8676],
    [-67.7978, 45.8644],
    [-67.7897, 45.8518],
    [-67.7721, 45.8413],
    [-67.7640, 45.8300],
    [-67.7638, 45.8203],
    [-67.7728, 45.8194],
    [-67.7805, 45.8176],
    [-67.8066, 45.7947],
    [-67.8055, 45.7698],
    [-67.7931, 45.7506],
    [-67.8031, 45.6961],
    [-67.8033, 45.6779],
    [-67.7474, 45.6704],
    [-67.7357, 45.6669],
    [-67.7263, 45.6629],
    [-67.7197, 45.6628],
    [-67.7236, 45.6704],
    [-67.7337, 45.6842],
    [-67.7276, 45.6885],
    [-67.7130, 45.6812],
    [-67.7061, 45.6736],
    [-67.6912, 45.6535],
    [-67.6754, 45.6310],
    [-67.6458, 45.6136],
    [-67.6389, 45.6251],
    [-67.5898, 45.6068],
    [-67.5569, 45.5951],
    [-67.5345, 45.5946],
    [-67.4994, 45.5870],
    [-67.4890, 45.5969],
    [-67.4898, 45.6012],
    [-67.4724, 45.6006],
    [-67.4554, 45.6047],
    [-67.4297, 45.5838],
    [-67.4284, 45.5689],
    [-67.4227, 45.5542],
    [-67.4254, 45.5408],
    [-67.4307, 45.5414],
    [-67.4353, 45.5308],
    [-67.4322, 45.5200],
    [-67.4258, 45.5145],
    [-67.4165, 45.5021],
    [-67.4226, 45.5059],
    [-67.4257, 45.5029],
    [-67.4326, 45.5038],
    [-67.4416, 45.5050],
    [-67.4535, 45.5088],
    [-67.4489, 45.5021],
    [-67.4562, 45.5023],
    [-67.4709, 45.5043],
    [-67.4640, 45.4976],
    [-67.4713, 45.4972],
    [-67.4795, 45.4964],
    [-67.4880, 45.4938],
    [-67.4951, 45.4887],
    [-67.5038, 45.4885],
    [-67.4944, 45.4730],
    [-67.4824, 45.4608],
    [-67.4843, 45.4520],
    [-67.4780, 45.4464],
    [-67.4803, 45.4409],
    [-67.4726, 45.4233],
    [-67.4603, 45.4200],
    [-67.4561, 45.4141],
    [-67.4382, 45.3989],
    [-67.4262, 45.3852],
    [-67.4187, 45.3773],
    [-67.4238, 45.3735],
    [-67.4312, 45.3708],
    [-67.4260, 45.3577],
    [-67.4278, 45.3522],
    [-67.4289, 45.3442],
    [-67.4420, 45.3346],
    [-67.4535, 45.3282],
    [-67.4564, 45.3239],
    [-67.4533, 45.3143],
    [-67.4655, 45.2998],
    [-67.4661, 45.2942],
    [-67.4760, 45.2888],
    [-67.4823, 45.2914],
    [-67.4865, 45.2906],
    [-67.4893, 45.2813],
    [-67.4823, 45.2760],
    [-67.4748, 45.2635],
    [-67.4636, 45.2441],
    [-67.4535, 45.2411],
    [-67.4371, 45.2227],
    [-67.4278, 45.2017],
    [-67.4256, 45.1911],
    [-67.4103, 45.1815],
    [-67.3983, 45.1733],
    [-67.4047, 45.1669],
    [-67.4046, 45.1599],
    [-67.3836, 45.1523],
    [-67.3568, 45.1332],
    [-67.3490, 45.1295],
    [-67.3408, 45.1254],
    [-67.3216, 45.1314],
    [-67.3056, 45.1448],
    [-67.2962, 45.1480],
    [-67.2970, 45.1553],
    [-67.2992, 45.1689],
    [-67.2917, 45.1745],
    [-67.2908, 45.1817],
    [-67.2898, 45.1887],
    [-67.2696, 45.1906],
    [-67.2578, 45.1851],
    [-67.2440, 45.1783],
    [-67.2330, 45.1686],
    [-67.2232, 45.1637],
    [-67.1912, 45.1659],
    [-67.1594, 45.1622],
    [-67.1289, 45.1322],
    [-67.0947, 45.0755],
    [-67.1086, 45.0595],
    [-67.1024, 45.0467],
    [-67.0974, 45.0381],
    [-67.1017, 45.0333],
    [-67.0881, 45.0348],
    [-67.0728, 45.0083],
    [-67.0506, 44.9795],
    [-67.0568, 44.9702],
    [-67.0575, 44.9660],
    [-67.0506, 44.9659],
    [-67.0394, 44.9586],
    [-67.0326, 44.9444],
    [-67.0233, 44.9390],
    [-67.0104, 44.9353],
    [-67.0160, 44.9282],
    [-67.0038, 44.9208],
    [-66.9879, 44.9161],
    [-66.9836, 44.9033],
    [-66.9892, 44.8965],
    [-66.9904, 44.8826],
    [-66.9848, 44.8688],
    [-66.9820, 44.8603],
    [-66.9800, 44.8560],
    [-66.9930, 44.8492],
    [-66.9961, 44.8437],
    [-66.9886, 44.8373],
    [-66.9863, 44.8207],
    [-66.9750, 44.8155],
    [-66.9499, 44.8174],
    [-66.9700, 44.8057],
    [-66.9822, 44.8034],
    [-66.9952, 44.7911],
    [-67.0055, 44.7882],
    [-67.0121, 44.7783],
    [-67.0238, 44.7710],
    [-67.0262, 44.7682],
    [-67.0440, 44.7631],
    [-67.0490, 44.7644],
    [-67.0506, 44.7728],
    [-67.0566, 44.7717],
    [-67.0685, 44.7687],
    [-67.0611, 44.7597],
    [-67.0703, 44.7514],
    [-67.0835, 44.7399],
    [-67.1041, 44.7399],
    [-67.0983, 44.7305],
    [-67.1032, 44.7192],
    [-67.1094, 44.7114],
    [-67.1176, 44.7119],
    [-67.1198, 44.7050],
    [-67.1288, 44.6954],
    [-67.1551, 44.6694],
    [-67.1818, 44.6637],
    [-67.1914, 44.6477],
    [-67.2343, 44.6372],
    [-67.2422, 44.6399],
    [-67.2460, 44.6463],
    [-67.2408, 44.6658],
    [-67.2648, 44.6668],
    [-67.2679, 44.6505],
    [-67.2667, 44.6392],
    [-67.2548, 44.6326],
    [-67.2464, 44.6264],
    [-67.2652, 44.6308],
    [-67.2741, 44.6263],
    [-67.2873, 44.6240],
    [-67.2950, 44.6370],
    [-67.2959, 44.6493],
    [-67.2984, 44.6544],
    [-67.3188, 44.6597],
    [-67.3276, 44.6670],
    [-67.3189, 44.6718],
    [-67.3102, 44.6619],
    [-67.3064, 44.6661],
    [-67.3047, 44.6793],
    [-67.3087, 44.6893],
    [-67.3004, 44.6999],
    [-67.3085, 44.7075],
    [-67.3294, 44.7030],
    [-67.3389, 44.7006],
    [-67.3532, 44.7002],
    [-67.3598, 44.7018],
    [-67.3651, 44.6936],
    [-67.3525, 44.6903],
    [-67.3665, 44.6869],
    [-67.3834, 44.6889],
    [-67.3891, 44.6958],
    [-67.3948, 44.6903],
    [-67.4000, 44.6791],
    [-67.3872, 44.6764],
    [-67.3758, 44.6773],
    [-67.3886, 44.6708],
    [-67.3872, 44.6654],
    [-67.3734, 44.6597],
    [-67.3639, 44.6445],
    [-67.3683, 44.6247],
    [-67.3815, 44.6269],
    [-67.3914, 44.6254],
    [-67.3914, 44.6132],
    [-67.3967, 44.6045],
    [-67.4055, 44.5942],
    [-67.4189, 44.6035],
    [-67.4207, 44.6184],
    [-67.4290, 44.6291],
    [-67.4238, 44.6380],
    [-67.4321, 44.6374],
    [-67.4417, 44.6425],
    [-67.4466, 44.6374],
    [-67.4464, 44.6274],
    [-67.4376, 44.6196],
    [-67.4368, 44.6049],
    [-67.4485, 44.6003],
    [-67.4584, 44.5967],
    [-67.4670, 44.6033],
    [-67.4749, 44.6074],
    [-67.4910, 44.6072],
    [-67.4924, 44.6180],
    [-67.4977, 44.6330],
    [-67.5241, 44.6266],
    [-67.5326, 44.6144],
    [-67.5345, 44.6226],
    [-67.5417, 44.6264],
    [-67.5498, 44.6213],
    [-67.5528, 44.6115],
    [-67.5614, 44.6093],
    [-67.5579, 44.5957],
    [-67.5645, 44.5805],
    [-67.5706, 44.5722],
    [-67.5751, 44.5607],
    [-67.5628, 44.5455],
    [-67.5647, 44.5321],
    [-67.5783, 44.5299],
    [-67.5987, 44.5295],
    [-67.6156, 44.5273],
    [-67.6389, 44.5268],
    [-67.6458, 44.5283],
    [-67.6564, 44.5371],
    [-67.6731, 44.5395],
    [-67.6798, 44.5363],
    [-67.6907, 44.5347],
    [-67.7020, 44.5258],
    [-67.6952, 44.5193],
    [-67.6980, 44.5095],
    [-67.7049, 44.4998],
    [-67.7187, 44.4978],
    [-67.7434, 44.4974],
    [-67.7421, 44.5116],
    [-67.7446, 44.5269],
    [-67.7539, 44.5437],
    [-67.7622, 44.5484],
    [-67.7750, 44.5432],
    [-67.7798, 44.5227],
    [-67.7765, 44.5142],
    [-67.7936, 44.5191],
    [-67.8045, 44.5306],
    [-67.8095, 44.5426],
    [-67.8226, 44.5435],
    [-67.8290, 44.5545],
    [-67.8323, 44.5605],
    [-67.8478, 44.5630],
    [-67.8502, 44.5547],
    [-67.8421, 44.5440],
    [-67.8513, 44.5359],
    [-67.8570, 44.5266],
    [-67.8585, 44.5193],
    [-67.8525, 44.4976],
    [-67.8556, 44.4787],
    [-67.8668, 44.4718],
    [-67.8739, 44.4710],
    [-67.8873, 44.4835],
    [-67.8879, 44.4766],
    [-67.8841, 44.4640],
    [-67.8772, 44.4549],
    [-67.8884, 44.4421],
    [-67.8880, 44.4239],
    [-67.8934, 44.4124],
    [-67.8996, 44.3941],
    [-67.9124, 44.4174],
    [-67.9117, 44.4294],
    [-67.9116, 44.4411],
    [-67.9169, 44.4613],
    [-67.9238, 44.4484],
    [-67.9329, 44.4432],
    [-67.9281, 44.4352],
    [-67.9317, 44.4235],
    [-67.9324, 44.4172],
    [-67.9436, 44.4126],
    [-67.9571, 44.4404],
    [-67.9588, 44.4540],
    [-67.9690, 44.4678],
    [-67.9820, 44.4734],
    [-67.9928, 44.4608],
    [-68.0018, 44.4657],
    [-68.0130, 44.4689],
    [-68.0180, 44.4788],
    [-68.0241, 44.4825],
    [-68.0256, 44.4706],
    [-68.0248, 44.4623],
    [-68.0146, 44.4540],
    [-67.9982, 44.4516],
    [-67.9868, 44.4438],
    [-67.9806, 44.4467],
    [-67.9761, 44.4289],
    [-67.9707, 44.4131],
    [-67.9640, 44.4095],
    [-67.9647, 44.4028],
    [-67.9669, 44.3960],
    [-67.9789, 44.3870],
    [-67.9864, 44.3870],
    [-68.0006, 44.4066],
    [-68.0103, 44.4129],
    [-68.0115, 44.4033],
    [-68.0238, 44.4074],
    [-68.0196, 44.3988],
    [-68.0189, 44.3830],
    [-68.0251, 44.3720],
    [-68.0249, 44.3596],
    [-68.0306, 44.3598],
    [-68.0398, 44.3620],
    [-68.0460, 44.3554],
    [-68.0436, 44.3382],
    [-68.0513, 44.3320],
    [-68.0576, 44.3325],
    [-68.0709, 44.3420],
    [-68.0748, 44.3761],
    [-68.0849, 44.3866],
    [-68.0882, 44.3773],
    [-68.0900, 44.3714],
    [-68.0951, 44.3731],
    [-68.1038, 44.3851],
    [-68.1001, 44.3918],
    [-68.1057, 44.3956],
    [-68.1123, 44.4016],
    [-68.1103, 44.4155],
    [-68.1127, 44.4213],
    [-68.1198, 44.4457],
    [-68.1152, 44.4679],
    [-68.1268, 44.4772],
    [-68.1451, 44.4820],
    [-68.1399, 44.4871],
    [-68.1468, 44.4940],
    [-68.1618, 44.5012],
    [-68.1645, 44.4889],
    [-68.1656, 44.4813],
    [-68.1627, 44.4773],
    [-68.1710, 44.4702],
    [-68.1907, 44.4710],
    [-68.1805, 44.4750],
    [-68.1865, 44.4845],
    [-68.1969, 44.4934],
    [-68.1988, 44.5127],
    [-68.2017, 44.5200],
    [-68.2117, 44.5188],
    [-68.2143, 44.5106],
    [-68.2186, 44.4934],
    [-68.2262, 44.4822],
    [-68.2283, 44.4732],
    [-68.2294, 44.4635],
    [-68.2530, 44.4839],
    [-68.2644, 44.4873],
    [-68.2680, 44.4715],
    [-68.2849, 44.4737],
    [-68.2915, 44.4688],
    [-68.2815, 44.4593],
    [-68.2761, 44.4603],
    [-68.2735, 44.4644],
    [-68.2699, 44.4576],
    [-68.2858, 44.4520],
    [-68.3017, 44.4533],
    [-68.3143, 44.4581],
    [-68.3257, 44.4611],
    [-68.3293, 44.4498],
    [-68.3507, 44.4576],
    [-68.3559, 44.4559],
    [-68.3619, 44.4398],
    [-68.3673, 44.4311],
    [-68.3566, 44.4269],
    [-68.3474, 44.4223],
    [-68.3369, 44.4262],
    [-68.3322, 44.4350],
    [-68.3120, 44.4443],
    [-68.2991, 44.4379],
    [-68.2839, 44.4335],
    [-68.2685, 44.4398],
    [-68.2428, 44.4236],
    [-68.2500, 44.4148],
    [-68.2361, 44.4067],
    [-68.2254, 44.3985],
    [-68.2169, 44.3938],
    [-68.2151, 44.3906],
    [-68.2090, 44.3924],
    [-68.1969, 44.3864],
    [-68.1892, 44.3738],
    [-68.1820, 44.3625],
    [-68.1767, 44.3471],
    [-68.1741, 44.3377],
    [-68.1773, 44.3254],
    [-68.1827, 44.3287],
    [-68.1898, 44.3137],
    [-68.1919, 44.3067],
    [-68.1955, 44.3110],
    [-68.2007, 44.3055],
    [-68.2147, 44.2960],
    [-68.2243, 44.2902],
    [-68.2334, 44.2886],
    [-68.2426, 44.2955],
    [-68.2483, 44.2883],
    [-68.2668, 44.2884],
    [-68.2792, 44.2863],
    [-68.2987, 44.2924],
    [-68.3044, 44.2945],
    [-68.3134, 44.2960],
    [-68.3200, 44.2880],
    [-68.3146, 44.2835],
    [-68.3096, 44.2778],
    [-68.3117, 44.2742],
    [-68.3080, 44.2689],
    [-68.2976, 44.2630],
    [-68.2899, 44.2509],
    [-68.3010, 44.2364],
    [-68.3081, 44.2316],
    [-68.3176, 44.2251],
    [-68.3302, 44.2246],
    [-68.3431, 44.2295],
    [-68.3569, 44.2361],
    [-68.3612, 44.2308],
    [-68.3695, 44.2320],
    [-68.3780, 44.2476],
    [-68.3871, 44.2446],
    [-68.3947, 44.2501],
    [-68.4073, 44.2567],
    [-68.4196, 44.2746],
    [-68.4087, 44.2792],
    [-68.4158, 44.2860],
    [-68.4237, 44.2839],
    [-68.4309, 44.2986],
    [-68.4090, 44.3256],
    [-68.4070, 44.3372],
    [-68.4169, 44.3334],
    [-68.4170, 44.3397],
    [-68.4061, 44.3567],
    [-68.3972, 44.3739],
    [-68.3885, 44.3842],
    [-68.3816, 44.3808],
    [-68.3771, 44.3909],
    [-68.3676, 44.3907],
    [-68.3564, 44.3922],
    [-68.3543, 44.4005],
    [-68.3647, 44.4101],
    [-68.3685, 44.4206],
    [-68.3757, 44.4241],
    [-68.3928, 44.4353],
    [-68.3926, 44.4181],
    [-68.4132, 44.3995],
    [-68.4308, 44.3970],
    [-68.4295, 44.4094],
    [-68.4326, 44.4266],
    [-68.4270, 44.4415],
    [-68.4280, 44.4703],
    [-68.4256, 44.4786],
    [-68.4294, 44.4979],
    [-68.4349, 44.4925],
    [-68.4413, 44.4828],
    [-68.4593, 44.4895],
    [-68.4731, 44.4867],
    [-68.4672, 44.4647],
    [-68.4584, 44.4471],
    [-68.4712, 44.4403],
    [-68.4588, 44.4121],
    [-68.4633, 44.3946],
    [-68.4593, 44.3854],
    [-68.4662, 44.3798],
    [-68.4705, 44.3791],
    [-68.4829, 44.3936],
    [-68.4745, 44.4014],
    [-68.4805, 44.4306],
    [-68.4733, 44.4459],
    [-68.4826, 44.4520],
    [-68.4869, 44.4450],
    [-68.4936, 44.4321],
    [-68.4997, 44.4142],
    [-68.5166, 44.4126],
    [-68.5278, 44.3985],
    [-68.5610, 44.4028],
    [-68.5652, 44.3990],
    [-68.5664, 44.3945],
    [-68.5658, 44.3910],
    [-68.5647, 44.3852],
    [-68.5501, 44.3718],
    [-68.5494, 44.3497],
    [-68.5622, 44.3340],
    [-68.5669, 44.3176],
    [-68.5562, 44.3008],
    [-68.5408, 44.2911],
    [-68.5386, 44.2999],
    [-68.5282, 44.2941],
    [-68.5287, 44.2816],
    [-68.5190, 44.2652],
    [-68.5259, 44.2596],
    [-68.5437, 44.2659],
    [-68.5527, 44.2749],
    [-68.5565, 44.2678],
    [-68.5532, 44.2589],
    [-68.5330, 44.2543],
    [-68.5225, 44.2370],
    [-68.5270, 44.2279],
    [-68.5489, 44.2344],
    [-68.5487, 44.2436],
    [-68.5627, 44.2481],
    [-68.5858, 44.2596],
    [-68.6156, 44.2754],
    [-68.6284, 44.2850],
    [-68.6488, 44.2890],
    [-68.6652, 44.2926],
    [-68.6789, 44.3016],
    [-68.6849, 44.2962],
    [-68.6946, 44.3020],
    [-68.6970, 44.3088],
    [-68.7334, 44.3308],
    [-68.7507, 44.3294],
    [-68.7715, 44.3205],
    [-68.7878, 44.3182],
    [-68.7951, 44.3079],
    [-68.8200, 44.3109],
    [-68.8284, 44.3165],
    [-68.8196, 44.3267],
    [-68.8229, 44.3437],
    [-68.8216, 44.3520],
    [-68.8148, 44.3622],
    [-68.8103, 44.3728],
    [-68.8103, 44.3786],
    [-68.8149, 44.3816],
    [-68.8210, 44.3838],
    [-68.8180, 44.3959],
    [-68.8118, 44.3993],
    [-68.8218, 44.4071],
    [-68.8164, 44.4198],
    [-68.8120, 44.4303],
    [-68.8002, 44.4449],
    [-68.7912, 44.4532],
    [-68.7828, 44.4551],
    [-68.7837, 44.4739],
    [-68.7778, 44.4948],
    [-68.7811, 44.5029],
    [-68.7973, 44.5258],
    [-68.8066, 44.5151],
    [-68.8054, 44.5051],
    [-68.8099, 44.4960],
    [-68.8232, 44.4917],
    [-68.8346, 44.4850],
    [-68.8254, 44.4682],
    [-68.8111, 44.4661],
    [-68.8313, 44.4580],
    [-68.8590, 44.4449],
    [-68.8743, 44.4322],
    [-68.8843, 44.4281],
    [-68.8928, 44.4434],
    [-68.8971, 44.4506],
    [-68.9119, 44.4544],
    [-68.9238, 44.4527],
    [-68.9277, 44.4454],
    [-68.9387, 44.4342],
    [-68.9501, 44.4305],
    [-68.9615, 44.4283],
    [-68.9822, 44.4256],
    [-68.9957, 44.4270],
    [-68.9908, 44.4150],
    [-68.9877, 44.3935],
    [-68.9788, 44.3863],
    [-68.9556, 44.3685],
    [-68.9545, 44.3240],
    [-68.9802, 44.2948],
    [-68.9951, 44.2976],
    [-69.0011, 44.2907],
    [-69.0043, 44.2777],
    [-69.0284, 44.2490],
    [-69.0402, 44.2337],
    [-69.0434, 44.2230],
    [-69.0456, 44.2093],
    [-69.0500, 44.2115],
    [-69.0592, 44.2079],
    [-69.0547, 44.2033],
    [-69.0521, 44.1934],
    [-69.0555, 44.1892],
    [-69.0534, 44.1754],
    [-69.0626, 44.1725],
    [-69.0742, 44.1835],
    [-69.0778, 44.1650],
    [-69.0810, 44.1568],
    [-69.0823, 44.1392],
    [-69.0913, 44.1338],
    [-69.0787, 44.1344],
    [-69.0763, 44.1249],
    [-69.0859, 44.1141],
    [-69.1008, 44.1169],
    [-69.1037, 44.1080],
    [-69.1056, 44.1017],
    [-69.1011, 44.0936],
    [-69.1032, 44.0870],
    [-69.0920, 44.0857],
    [-69.0677, 44.0914],
    [-69.0563, 44.0952],
    [-69.0471, 44.0861],
    [-69.0533, 44.0773],
    [-69.0679, 44.0676],
    [-69.0743, 44.0589],
    [-69.0761, 44.0509],
    [-69.0811, 44.0413],
    [-69.1074, 44.0319],
    [-69.1153, 44.0248],
    [-69.1203, 44.0212],
    [-69.1253, 44.0135],
    [-69.1160, 44.0012],
    [-69.1132, 43.9946],
    [-69.1274, 44.0024],
    [-69.1360, 44.0005],
    [-69.1417, 43.9901],
    [-69.1363, 43.9853],
    [-69.1235, 43.9790],
    [-69.1441, 43.9795],
    [-69.1491, 43.9917],
    [-69.1607, 43.9892],
    [-69.1703, 43.9908],
    [-69.1750, 43.9769],
    [-69.1828, 43.9749],
    [-69.1851, 43.9677],
    [-69.1847, 43.9597],
    [-69.2037, 43.9418],
    [-69.2121, 43.9311],
    [-69.2299, 43.9316],
    [-69.2427, 43.9255],
    [-69.2683, 43.9167],
    [-69.2798, 43.9224],
    [-69.2701, 43.9397],
    [-69.2765, 43.9484],
    [-69.2840, 43.9586],
    [-69.2947, 43.9516],
    [-69.3175, 43.9405],
    [-69.3130, 43.9515],
    [-69.3065, 43.9631],
    [-69.3132, 43.9646],
    [-69.3253, 43.9709],
    [-69.3303, 43.9586],
    [-69.3277, 43.9458],
    [-69.3403, 43.9497],
    [-69.3493, 43.9374],
    [-69.3629, 43.9275],
    [-69.3743, 43.9284],
    [-69.3646, 43.9435],
    [-69.3560, 43.9545],
    [-69.3488, 43.9595],
    [-69.3301, 43.9718],
    [-69.3412, 43.9693],
    [-69.3429, 43.9797],
    [-69.3505, 43.9834],
    [-69.3541, 43.9749],
    [-69.3688, 43.9663],
    [-69.3662, 43.9877],
    [-69.3683, 43.9951],
    [-69.3800, 43.9911],
    [-69.3843, 43.9785],
    [-69.3942, 43.9694],
    [-69.3995, 43.9824],
    [-69.4194, 43.9682],
    [-69.4306, 43.9583],
    [-69.4268, 43.9783],
    [-69.4426, 43.9681],
    [-69.4416, 43.9643],
    [-69.4503, 43.9362],
    [-69.4625, 43.8980],
    [-69.4822, 43.8786],
    [-69.4929, 43.8598],
    [-69.4987, 43.8462],
    [-69.5090, 43.8360],
    [-69.5133, 43.8448],
    [-69.5216, 43.8607],
    [-69.5193, 43.8712],
    [-69.5259, 43.8771],
    [-69.5408, 43.8807],
    [-69.5494, 43.8800],
    [-69.5480, 43.8698],
    [-69.5489, 43.8446],
    [-69.5517, 43.8346],
    [-69.5647, 43.8422],
    [-69.5727, 43.8440],
    [-69.5789, 43.8288],
    [-69.5851, 43.8221],
    [-69.5929, 43.8114],
    [-69.6059, 43.8149],
    [-69.6046, 43.8258],
    [-69.5944, 43.8358],
    [-69.5913, 43.8520],
    [-69.6046, 43.8580],
    [-69.6151, 43.8465],
    [-69.6143, 43.8417],
    [-69.6167, 43.8290],
    [-69.6247, 43.8308],
    [-69.6310, 43.8401],
    [-69.6262, 43.8477],
    [-69.6363, 43.8478],
    [-69.6414, 43.8391],
    [-69.6499, 43.8357],
    [-69.6457, 43.8194],
    [-69.6531, 43.8172],
    [-69.6507, 43.8051],
    [-69.6522, 43.7843],
    [-69.6649, 43.7910],
    [-69.6785, 43.8070],
    [-69.6855, 43.8163],
    [-69.6904, 43.8254],
    [-69.6847, 43.8420],
    [-69.6852, 43.8539],
    [-69.6875, 43.8677],
    [-69.6849, 43.8806],
    [-69.6785, 43.9128],
    [-69.6729, 43.9245],
    [-69.6802, 43.9234],
    [-69.6916, 43.9172],
    [-69.6959, 43.8950],
    [-69.6989, 43.8759],
    [-69.7050, 43.8627],
    [-69.7024, 43.8461],
    [-69.7058, 43.8204],
    [-69.7171, 43.7924],
    [-69.7227, 43.7811],
    [-69.7410, 43.7693],
    [-69.7541, 43.7439],
    [-69.7675, 43.7431],
    [-69.7783, 43.7425],
    [-69.7935, 43.7356],
    [-69.7959, 43.7310],
    [-69.8130, 43.7274],
    [-69.8290, 43.7068],
    [-69.8382, 43.7012],
    [-69.8513, 43.7036],
    [-69.8503, 43.7178],
    [-69.8556, 43.7327],
    [-69.8546, 43.7446],
    [-69.8698, 43.7281],
    [-69.8717, 43.7336],
    [-69.8689, 43.7532],
    [-69.8622, 43.7605],
    [-69.8709, 43.7645],
    [-69.8694, 43.7774],
    [-69.8841, 43.7780],
    [-69.9018, 43.7716],
    [-69.9128, 43.7745],
    [-69.9209, 43.7774],
    [-69.9274, 43.7824],
    [-69.9440, 43.7633],
    [-69.9489, 43.7641],
    [-69.9523, 43.7689],
    [-69.9685, 43.7569],
    [-69.9837, 43.7444],
    [-69.9926, 43.7248],
    [-69.9987, 43.7114],
    [-70.0053, 43.7137],
    [-70.0032, 43.7218],
    [-69.9976, 43.7287],
    [-69.9972, 43.7307],
    [-70.0014, 43.7274],
    [-70.0053, 43.7244],
    [-69.9993, 43.7333],
    [-69.9985, 43.7326],
    [-69.9977, 43.7339],
    [-69.9986, 43.7347],
    [-69.9984, 43.7367],
    [-70.0115, 43.7434],
    [-70.0231, 43.7416],
    [-70.0305, 43.7435],
    [-70.0450, 43.7367],
    [-70.0400, 43.7510],
    [-70.0347, 43.7562],
    [-70.0277, 43.7656],
    [-70.0141, 43.7835],
    [-69.9982, 43.7987],
    [-69.9939, 43.8086],
    [-69.9894, 43.8094],
    [-69.9813, 43.8122],
    [-69.9762, 43.8204],
    [-69.9640, 43.8401],
    [-69.9544, 43.8482],
    [-69.9514, 43.8572],
    [-69.9480, 43.8621],
    [-69.9506, 43.8633],
    [-69.9599, 43.8552],
    [-69.9732, 43.8515],
    [-69.9765, 43.8520],
    [-69.9837, 43.8509],
    [-69.9898, 43.8488],
    [-69.9965, 43.8413],
    [-70.0084, 43.8360],
    [-70.0148, 43.8285],
    [-70.0272, 43.8240],
    [-70.0082, 43.8408],
    [-69.9956, 43.8521],
    [-69.9877, 43.8629],
    [-69.9946, 43.8670],
    [-70.0101, 43.8583],
    [-70.0233, 43.8560],
    [-70.0349, 43.8476],
    [-70.0419, 43.8417],
    [-70.0407, 43.8310],
    [-70.0536, 43.8302],
    [-70.0578, 43.8170],
    [-70.0664, 43.8197],
    [-70.0760, 43.8247],
    [-70.0814, 43.8235],
    [-70.0992, 43.8091],
    [-70.1106, 43.8034],
    [-70.1144, 43.7986],
    [-70.1258, 43.7899],
    [-70.1363, 43.7942],
    [-70.1444, 43.7931],
    [-70.1477, 43.7832],
    [-70.1622, 43.7708],
    [-70.1755, 43.7729],
    [-70.1869, 43.7734],
    [-70.1924, 43.7652],
    [-70.1926, 43.7483],
    [-70.2045, 43.7321],
    [-70.2170, 43.7177],
    [-70.2139, 43.7130],
    [-70.2168, 43.7048],
    [-70.2147, 43.6973],
    [-70.2243, 43.7016],
    [-70.2356, 43.6989],
    [-70.2280, 43.6918],
    [-70.2319, 43.6860],
    [-70.2375, 43.6882],
    [-70.2457, 43.6904],
    [-70.2447, 43.6893],
    [-70.2475, 43.6869],
    [-70.2503, 43.6863],
    [-70.2513, 43.6837],
    [-70.2512, 43.6816],
    [-70.2528, 43.6753],
    [-70.2423, 43.6709],
    [-70.2415, 43.6632],
    [-70.2410, 43.6591],
    [-70.2345, 43.6552],
    [-70.2252, 43.6502],
    [-70.2242, 43.6421],
    [-70.2214, 43.6329],
    [-70.2147, 43.6284],
    [-70.2100, 43.6132],
    [-70.2145, 43.6022],
    [-70.2142, 43.5954],
    [-70.2047, 43.5897],
    [-70.2078, 43.5782],
    [-70.2000, 43.5692],
    [-70.2061, 43.5576],
    [-70.2191, 43.5610],
    [-70.2279, 43.5635],
    [-70.2514, 43.5530],
    [-70.2699, 43.5577],
    [-70.2725, 43.5626],
    [-70.3109, 43.5395],
    [-70.3101, 43.5309],
    [-70.3211, 43.5273],
    [-70.3233, 43.5292],
    [-70.3181, 43.5348],
    [-70.3288, 43.5407],
    [-70.3534, 43.5354],
    [-70.3791, 43.5072],
    [-70.3856, 43.4870],
    [-70.3776, 43.4612],
    [-70.3635, 43.4521],
    [-70.3575, 43.4578],
    [-70.3273, 43.4585],
    [-70.3328, 43.4464],
    [-70.3438, 43.4401],
    [-70.3705, 43.4341],
    [-70.3832, 43.4190],
    [-70.3808, 43.4102],
    [-70.3902, 43.4011],
    [-70.3986, 43.3930],
    [-70.4017, 43.4013],
    [-70.4117, 43.3980],
    [-70.4277, 43.3893],
    [-70.4244, 43.3797],
    [-70.4242, 43.3578],
    [-70.4457, 43.3538],
    [-70.4542, 43.3462],
    [-70.4590, 43.3427],
    [-70.4666, 43.3405],
    [-70.4752, 43.3466],
    [-70.4838, 43.3473],
    [-70.4952, 43.3439],
    [-70.5097, 43.3441],
    [-70.5177, 43.3440],
    [-70.5539, 43.3219],
    [-70.5663, 43.3010],
    [-70.5710, 43.2904],
    [-70.5710, 43.2842],
    [-70.5863, 43.2676],
    [-70.5886, 43.2439],
    [-70.5815, 43.2294],
    [-70.5880, 43.2087],
    [-70.5878, 43.1999],
    [-70.5938, 43.1891],
    [-70.6002, 43.1845],
    [-70.6088, 43.1756],
    [-70.6031, 43.1739],
    [-70.5937, 43.1694],
    [-70.5919, 43.1647],
    [-70.5983, 43.1643],
    [-70.6186, 43.1639],
    [-70.6240, 43.1520],
    [-70.6260, 43.1474],
    [-70.6223, 43.1423],
    [-70.6225, 43.1346],
    [-70.6321, 43.1332],
    [-70.6338, 43.1251],
    [-70.6367, 43.1193],
    [-70.6384, 43.1142],
    [-70.6480, 43.1041],
    [-70.6549, 43.0992],
    [-70.6575, 43.0916],
    [-70.6601, 43.0857],
    [-70.6660, 43.0762],
    [-70.6866, 43.0654],
    [-70.7065, 43.0753],
    [-70.7381, 43.0738],
    [-70.7526, 43.0793],
    [-70.7576, 43.0809],
    [-70.7663, 43.0926],
    [-70.7680, 43.0936],
    [-70.7839, 43.1009],
    [-70.8087, 43.1171],
    [-70.8281, 43.1291],
    [-70.8329, 43.1433],
    [-70.8278, 43.1664],
    [-70.8250, 43.1727],
    [-70.8248, 43.1797],
    [-70.8279, 43.1887],
    [-70.8207, 43.1917],
    [-70.8200, 43.1968],
    [-70.8169, 43.2146],
    [-70.8125, 43.2185],
    [-70.8112, 43.2274],
    [-70.8140, 43.2291],
    [-70.8178, 43.2374],
    [-70.8230, 43.2402],
    [-70.8251, 43.2409],
    [-70.8336, 43.2429],
    [-70.8393, 43.2443],
    [-70.8397, 43.2504],
    [-70.8433, 43.2543],
    [-70.8582, 43.2563],
    [-70.8614, 43.2631],
    [-70.8638, 43.2653],
    [-70.8645, 43.2655],
    [-70.8684, 43.2657],
    [-70.8727, 43.2686],
    [-70.8768, 43.2725],
    [-70.8828, 43.2732],
    [-70.8865, 43.2828],
    [-70.8987, 43.2871],
    [-70.8963, 43.2921],
    [-70.9060, 43.2917],
    [-70.9014, 43.2988],
    [-70.9045, 43.3053],
    [-70.9098, 43.3067],
    [-70.9120, 43.3198],
    [-70.9236, 43.3246],
    [-70.9316, 43.3310],
    [-70.9371, 43.3374],
    [-70.9565, 43.3347],
    [-70.9604, 43.3410],
    [-70.9672, 43.3438],
    [-70.9733, 43.3550],
    [-70.9764, 43.3673],
    [-70.9843, 43.3761],
    [-70.9860, 43.3800],
    [-70.9876, 43.3895],
    [-70.9874, 43.3935],
    [-70.9828, 43.3993],
    [-70.9872, 43.4119],
    [-70.9846, 43.4171],
    [-70.9746, 43.4230],
    [-70.9694, 43.4327],
    [-70.9666, 43.4359],
    [-70.9616, 43.4430],
    [-70.9663, 43.4536],
    [-70.9614, 43.4697],
    [-70.9660, 43.4729],
    [-70.9742, 43.4774],
    [-70.9674, 43.4826],
    [-70.9667, 43.4913],
    [-70.9592, 43.4994],
    [-70.9548, 43.5098],
    [-70.9569, 43.5127],
    [-70.9568, 43.5242],
    [-70.9582, 43.5316],
    [-70.9635, 43.5368],
    [-70.9622, 43.5410],
    [-70.9553, 43.5410],
    [-70.9535, 43.5406],
    [-70.9519, 43.5522],
    [-70.9559, 43.5598],
    [-70.9685, 43.5689],
    [-70.9751, 43.6144],
    [-70.9806, 43.6843],
    [-70.9822, 43.7119],
    [-70.9852, 43.7559],
    [-70.9891, 43.7924],
    [-70.9922, 43.8863],
    [-70.9932, 43.9254],
    [-70.9966, 44.0003],
    [-70.9976, 44.0217],
    [-71.0014, 44.0929],
    [-71.0086, 44.2455],
    [-71.0096, 44.2733],
    [-71.0127, 44.3408],
    [-71.0154, 44.3781],
    [-71.0208, 44.4737],
    [-71.0290, 44.6112],
    [-71.0348, 44.7100],
    [-71.0393, 44.7779],
    [-71.0463, 44.8632],
    [-71.0559, 44.9731],
    [-71.0590, 45.0049],
    [-71.0726, 45.1809],
    [-71.0800, 45.3070]
    ]
  },
  "Hawaii": {
    coordinates: [
      [-156.0608, 19.7305],
    [-156.0545, 19.7477],
    [-156.0507, 19.7617],
    [-156.0464, 19.7774],
    [-156.0371, 19.7834],
    [-156.0281, 19.7920],
    [-156.0135, 19.8060],
    [-156.0012, 19.8151],
    [-155.9973, 19.8259],
    [-155.9899, 19.8310],
    [-155.9862, 19.8349],
    [-155.9730, 19.8480],
    [-155.9516, 19.8529],
    [-155.9425, 19.8503],
    [-155.9240, 19.8655],
    [-155.9153, 19.8786],
    [-155.9067, 19.8880],
    [-155.9069, 19.8963],
    [-155.8903, 19.9124],
    [-155.8907, 19.9286],
    [-155.8778, 19.9346],
    [-155.8712, 19.9472],
    [-155.8529, 19.9684],
    [-155.8367, 19.9735],
    [-155.8319, 19.9828],
    [-155.8272, 19.9958],
    [-155.8250, 20.0158],
    [-155.8292, 20.0293],
    [-155.8336, 20.0418],
    [-155.8433, 20.0532],
    [-155.8561, 20.0681],
    [-155.8669, 20.0787],
    [-155.8914, 20.1255],
    [-155.9014, 20.1729],
    [-155.9023, 20.2050],
    [-155.8994, 20.2301],
    [-155.8888, 20.2483],
    [-155.8883, 20.2521],
    [-155.8679, 20.2663],
    [-155.8382, 20.2686],
    [-155.8211, 20.2602],
    [-155.8004, 20.2538],
    [-155.7832, 20.2464],
    [-155.7762, 20.2430],
    [-155.7648, 20.2421],
    [-155.7572, 20.2388],
    [-155.7442, 20.2294],
    [-155.7314, 20.2149],
    [-155.7058, 20.1906],
    [-155.6645, 20.1710],
    [-155.6386, 20.1473],
    [-155.6208, 20.1426],
    [-155.6022, 20.1300],
    [-155.5856, 20.1197],
    [-155.5561, 20.1292],
    [-155.5168, 20.1152],
    [-155.4649, 20.1010],
    [-155.4126, 20.0812],
    [-155.3902, 20.0669],
    [-155.3622, 20.0553],
    [-155.3549, 20.0515],
    [-155.3455, 20.0491],
    [-155.2985, 20.0242],
    [-155.2703, 20.0145],
    [-155.2526, 20.0022],
    [-155.2480, 19.9951],
    [-155.2398, 19.9946],
    [-155.2135, 19.9747],
    [-155.1953, 19.9560],
    [-155.1613, 19.9354],
    [-155.1312, 19.9068],
    [-155.1183, 19.8889],
    [-155.1120, 19.8814],
    [-155.1075, 19.8725],
    [-155.0922, 19.8650],
    [-155.0832, 19.8526],
    [-155.0823, 19.8359],
    [-155.0899, 19.8053],
    [-155.0878, 19.7972],
    [-155.0861, 19.7835],
    [-155.0895, 19.7700],
    [-155.0902, 19.7565],
    [-155.0907, 19.7530],
    [-155.0899, 19.7344],
    [-155.0831, 19.7248],
    [-155.0705, 19.7243],
    [-155.0608, 19.7263],
    [-155.0444, 19.7347],
    [-155.0287, 19.7360],
    [-155.0158, 19.7354],
    [-155.0013, 19.7346],
    [-154.9930, 19.7235],
    [-154.9872, 19.7085],
    [-154.9781, 19.6890],
    [-154.9830, 19.6585],
    [-154.9814, 19.6462],
    [-154.9743, 19.6332],
    [-154.9544, 19.6244],
    [-154.9453, 19.6212],
    [-154.9480, 19.6104],
    [-154.9471, 19.6049],
    [-154.9328, 19.5957],
    [-154.9216, 19.5831],
    [-154.9026, 19.5684],
    [-154.8874, 19.5613],
    [-154.8768, 19.5560],
    [-154.8501, 19.5465],
    [-154.8250, 19.5349],
    [-154.8096, 19.5224],
    [-154.8068, 19.5160],
    [-154.8181, 19.4855],
    [-154.8268, 19.4712],
    [-154.8650, 19.4361],
    [-154.8795, 19.4256],
    [-154.9091, 19.4065],
    [-154.9340, 19.3842],
    [-154.9662, 19.3576],
    [-154.9891, 19.3412],
    [-155.0165, 19.3285],
    [-155.0486, 19.3143],
    [-155.0784, 19.3056],
    [-155.1123, 19.2859],
    [-155.1360, 19.2736],
    [-155.1571, 19.2653],
    [-155.1749, 19.2641],
    [-155.1919, 19.2561],
    [-155.2053, 19.2575],
    [-155.2247, 19.2602],
    [-155.2431, 19.2687],
    [-155.2588, 19.2693],
    [-155.2854, 19.2654],
    [-155.3022, 19.2571],
    [-155.3159, 19.2430],
    [-155.3382, 19.2295],
    [-155.3437, 19.2201],
    [-155.3458, 19.2150],
    [-155.3547, 19.2086],
    [-155.3861, 19.1986],
    [-155.3992, 19.1883],
    [-155.4147, 19.1847],
    [-155.4301, 19.1672],
    [-155.4501, 19.1491],
    [-155.4771, 19.1417],
    [-155.5013, 19.1349],
    [-155.5100, 19.1290],
    [-155.5174, 19.1133],
    [-155.5330, 19.1026],
    [-155.5492, 19.0854],
    [-155.5549, 19.0778],
    [-155.5518, 19.0517],
    [-155.5651, 19.0287],
    [-155.5800, 19.0180],
    [-155.5937, 18.9953],
    [-155.5992, 18.9684],
    [-155.6129, 18.9688],
    [-155.6224, 18.9576],
    [-155.6263, 18.9503],
    [-155.6318, 18.9455],
    [-155.6326, 18.9414],
    [-155.6434, 18.9351],
    [-155.6512, 18.9257],
    [-155.6576, 18.9209],
    [-155.6690, 18.9165],
    [-155.6774, 18.9111],
    [-155.6810, 18.9106],
    [-155.6840, 18.9179],
    [-155.6881, 18.9395],
    [-155.7057, 18.9502],
    [-155.7192, 18.9610],
    [-155.7348, 18.9700],
    [-155.7592, 18.9773],
    [-155.7859, 18.9980],
    [-155.8073, 19.0102],
    [-155.8439, 19.0196],
    [-155.8611, 19.0247],
    [-155.8816, 19.0366],
    [-155.8863, 19.0558],
    [-155.9036, 19.0776],
    [-155.9077, 19.0840],
    [-155.9169, 19.1276],
    [-155.9112, 19.1461],
    [-155.9164, 19.1566],
    [-155.9083, 19.1719],
    [-155.9080, 19.1867],
    [-155.9012, 19.2154],
    [-155.8973, 19.2402],
    [-155.8958, 19.2628],
    [-155.8887, 19.2890],
    [-155.8901, 19.3007],
    [-155.8907, 19.3185],
    [-155.8852, 19.3388],
    [-155.8988, 19.3780],
    [-155.9049, 19.4103],
    [-155.9144, 19.4204],
    [-155.9172, 19.4260],
    [-155.9202, 19.4458],
    [-155.9278, 19.4588],
    [-155.9198, 19.4753],
    [-155.9300, 19.4830],
    [-155.9338, 19.4791],
    [-155.9465, 19.4832],
    [-155.9518, 19.5049],
    [-155.9602, 19.5202],
    [-155.9569, 19.5345],
    [-155.9661, 19.5513],
    [-155.9660, 19.5627],
    [-155.9762, 19.5993],
    [-155.9775, 19.6048],
    [-155.9819, 19.6124],
    [-155.9866, 19.6244],
    [-155.9874, 19.6258],
    [-155.9929, 19.6372],
    [-156.0022, 19.6381],
    [-156.0240, 19.6474],
    [-156.0311, 19.6603],
    [-156.0278, 19.6689],
    [-156.0324, 19.6796],
    [-156.0361, 19.6903],
    [-156.0451, 19.6941],
    [-156.0486, 19.7021],
    [-156.0495, 19.7144],
    [-156.0615, 19.7280],
    [-156.0608, 19.7305]
    ]
  },
  "Delaware": {
    coordinates: [
      [-75.7887, 39.6593],
    [-75.7886, 39.6816],
    [-75.7885, 39.6951],
    [-75.7886, 39.7197],
    [-75.7661, 39.7378],
    [-75.7601, 39.7476],
    [-75.7531, 39.7576],
    [-75.7394, 39.7729],
    [-75.7270, 39.7841],
    [-75.7193, 39.7902],
    [-75.7012, 39.8026],
    [-75.6808, 39.8133],
    [-75.6415, 39.8284],
    [-75.6173, 39.8340],
    [-75.5937, 39.8375],
    [-75.5798, 39.8385],
    [-75.5513, 39.8385],
    [-75.5393, 39.8382],
    [-75.4990, 39.8333],
    [-75.4812, 39.8291],
    [-75.4725, 39.8265],
    [-75.4599, 39.8226],
    [-75.4537, 39.8203],
    [-75.4371, 39.8131],
    [-75.4234, 39.8066],
    [-75.4690, 39.7857],
    [-75.4898, 39.7555],
    [-75.5091, 39.7201],
    [-75.5319, 39.6929],
    [-75.5508, 39.6704],
    [-75.5566, 39.6635],
    [-75.5622, 39.6567],
    [-75.5871, 39.6510],
    [-75.6120, 39.6220],
    [-75.6141, 39.6183],
    [-75.6133, 39.6131],
    [-75.6132, 39.6074],
    [-75.6138, 39.6062],
    [-75.6046, 39.5899],
    [-75.5987, 39.5891],
    [-75.5920, 39.5832],
    [-75.5866, 39.5789],
    [-75.5858, 39.5783],
    [-75.5741, 39.5696],
    [-75.5630, 39.5622],
    [-75.5656, 39.5585],
    [-75.5704, 39.5272],
    [-75.5745, 39.5125],
    [-75.5866, 39.4977],
    [-75.5877, 39.4954],
    [-75.5931, 39.4780],
    [-75.5894, 39.4608],
    [-75.5789, 39.4479],
    [-75.5715, 39.4405],
    [-75.5385, 39.4165],
    [-75.5217, 39.3879],
    [-75.5130, 39.3662],
    [-75.5053, 39.3592],
    [-75.4942, 39.3546],
    [-75.4941, 39.3466],
    [-75.4917, 39.3440],
    [-75.4800, 39.3366],
    [-75.4554, 39.3247],
    [-75.4390, 39.3134],
    [-75.4371, 39.3060],
    [-75.4354, 39.2967],
    [-75.4340, 39.2897],
    [-75.4166, 39.2732],
    [-75.4047, 39.2578],
    [-75.4068, 39.2461],
    [-75.4057, 39.2238],
    [-75.3969, 39.2161],
    [-75.3958, 39.1916],
    [-75.4083, 39.1746],
    [-75.4102, 39.1594],
    [-75.4124, 39.1476],
    [-75.3998, 39.0991],
    [-75.4010, 39.0661],
    [-75.3960, 39.0586],
    [-75.3799, 39.0488],
    [-75.3601, 39.0328],
    [-75.3409, 39.0200],
    [-75.3116, 38.9676],
    [-75.3119, 38.9459],
    [-75.3159, 38.9397],
    [-75.3171, 38.9334],
    [-75.2928, 38.9033],
    [-75.2686, 38.8808],
    [-75.2272, 38.8405],
    [-75.1902, 38.8067],
    [-75.1340, 38.7822],
    [-75.1026, 38.7868],
    [-75.0933, 38.7976],
    [-75.0920, 38.8039],
    [-75.0802, 38.7501],
    [-75.0781, 38.7320],
    [-75.0750, 38.7144],
    [-75.0720, 38.6976],
    [-75.0652, 38.6324],
    [-75.0610, 38.6084],
    [-75.0600, 38.6068],
    [-75.0556, 38.5552],
    [-75.0543, 38.5403],
    [-75.0531, 38.5254],
    [-75.0526, 38.5197],
    [-75.0496, 38.4778],
    [-75.0489, 38.4513],
    [-75.0535, 38.4513],
    [-75.0654, 38.4513],
    [-75.0699, 38.4513],
    [-75.0858, 38.4513],
    [-75.0896, 38.4513],
    [-75.1850, 38.4510],
    [-75.2051, 38.4511],
    [-75.2272, 38.4513],
    [-75.2527, 38.4514],
    [-75.3315, 38.4519],
    [-75.3711, 38.4521],
    [-75.4109, 38.4524],
    [-75.4287, 38.4527],
    [-75.4791, 38.4537],
    [-75.5213, 38.4547],
    [-75.5395, 38.4551],
    [-75.5524, 38.4554],
    [-75.5581, 38.4555],
    [-75.5599, 38.4556],
    [-75.5641, 38.4557],
    [-75.5742, 38.4560],
    [-75.5831, 38.4564],
    [-75.5931, 38.4564],
    [-75.6305, 38.4579],
    [-75.6656, 38.4589],
    [-75.6964, 38.4924],
    [-75.6988, 38.5220],
    [-75.7002, 38.5427],
    [-75.7040, 38.5921],
    [-75.7062, 38.6213],
    [-75.7074, 38.6354],
    [-75.7176, 38.7656],
    [-75.7220, 38.8221],
    [-75.7229, 38.8332],
    [-75.7241, 38.8478],
    [-75.7258, 38.8693],
    [-75.7328, 38.9569],
    [-75.7395, 39.0412],
    [-75.7419, 39.0710],
    [-75.7438, 39.0947],
    [-75.7458, 39.1149],
    [-75.7477, 39.1433],
    [-75.7504, 39.1731],
    [-75.7515, 39.1836],
    [-75.7560, 39.2460],
    [-75.7601, 39.2968],
    [-75.7644, 39.3493],
    [-75.7667, 39.3775],
    [-75.7739, 39.4653],
    [-75.7795, 39.5347],
    [-75.7797, 39.5365],
    [-75.7825, 39.5723],
    [-75.7838, 39.5905],
    [-75.7851, 39.6064],
    [-75.7869, 39.6306],
    [-75.7874, 39.6375],
    [-75.7878, 39.6432],
    [-75.7884, 39.6543],
    [-75.7887, 39.6593]
    ]
  },
  "Rhode Island": {
    coordinates: [
      [-71.8627, 41.3109],
    [-71.8575, 41.3208],
    [-71.8447, 41.3306],
    [-71.8294, 41.3424],
    [-71.8357, 41.3536],
    [-71.8377, 41.3633],
    [-71.8356, 41.3671],
    [-71.8321, 41.3701],
    [-71.8321, 41.3730],
    [-71.8306, 41.3788],
    [-71.8330, 41.3853],
    [-71.8382, 41.3906],
    [-71.8422, 41.3958],
    [-71.8417, 41.4032],
    [-71.8428, 41.4087],
    [-71.8369, 41.4122],
    [-71.8246, 41.4152],
    [-71.8169, 41.4199],
    [-71.8037, 41.4174],
    [-71.7977, 41.4169],
    [-71.7965, 41.4423],
    [-71.7936, 41.5058],
    [-71.7905, 41.5720],
    [-71.7879, 41.6345],
    [-71.7870, 41.6561],
    [-71.7897, 41.7252],
    [-71.7913, 41.7745],
    [-71.7928, 41.8087],
    [-71.7945, 41.8492],
    [-71.7972, 41.9163],
    [-71.7979, 41.9354],
    [-71.7989, 41.9873],
    [-71.7551, 42.0100],
    [-71.6616, 42.0121],
    [-71.5941, 42.0137],
    [-71.5769, 42.0141],
    [-71.5534, 42.0145],
    [-71.5276, 42.0150],
    [-71.5116, 42.0163],
    [-71.5009, 42.0171],
    [-71.4914, 42.0173],
    [-71.4581, 42.0178],
    [-71.3814, 42.0188],
    [-71.3815, 41.9827],
    [-71.3815, 41.9529],
    [-71.3816, 41.9229],
    [-71.3817, 41.9148],
    [-71.3817, 41.8971],
    [-71.3815, 41.8932],
    [-71.3764, 41.8940],
    [-71.3710, 41.8946],
    [-71.3625, 41.8956],
    [-71.3527, 41.8967],
    [-71.3397, 41.8983],
    [-71.3392, 41.8946],
    [-71.3397, 41.8901],
    [-71.3389, 41.8761],
    [-71.3374, 41.8720],
    [-71.3417, 41.8459],
    [-71.3408, 41.8425],
    [-71.3376, 41.8337],
    [-71.3449, 41.8280],
    [-71.3392, 41.8090],
    [-71.3389, 41.8083],
    [-71.3393, 41.8044],
    [-71.3407, 41.7983],
    [-71.3339, 41.7945],
    [-71.3293, 41.7868],
    [-71.3179, 41.7762],
    [-71.2977, 41.7676],
    [-71.2614, 41.7523],
    [-71.2453, 41.7340],
    [-71.2258, 41.7117],
    [-71.2330, 41.7020],
    [-71.2437, 41.6984],
    [-71.2430, 41.6892],
    [-71.2346, 41.6775],
    [-71.2368, 41.6681],
    [-71.2444, 41.6691],
    [-71.2546, 41.6522],
    [-71.2596, 41.6426],
    [-71.2671, 41.6449],
    [-71.2677, 41.6574],
    [-71.2774, 41.6660],
    [-71.2804, 41.6726],
    [-71.2793, 41.6767],
    [-71.2822, 41.6796],
    [-71.2891, 41.6796],
    [-71.2933, 41.6602],
    [-71.2992, 41.6495],
    [-71.3050, 41.6593],
    [-71.2989, 41.6815],
    [-71.2912, 41.7027],
    [-71.2990, 41.7087],
    [-71.3055, 41.7085],
    [-71.3071, 41.7216],
    [-71.3148, 41.7238],
    [-71.3395, 41.7248],
    [-71.3411, 41.7348],
    [-71.3523, 41.7451],
    [-71.3559, 41.7451],
    [-71.3601, 41.7495],
    [-71.3613, 41.7576],
    [-71.3624, 41.7615],
    [-71.3665, 41.7704],
    [-71.3651, 41.7775],
    [-71.3706, 41.7809],
    [-71.3813, 41.7853],
    [-71.3917, 41.7811],
    [-71.3899, 41.7766],
    [-71.3855, 41.7687],
    [-71.3838, 41.7585],
    [-71.3802, 41.7498],
    [-71.3761, 41.7442],
    [-71.3808, 41.7389],
    [-71.3810, 41.7281],
    [-71.3765, 41.7216],
    [-71.3639, 41.7174],
    [-71.3643, 41.7125],
    [-71.3644, 41.7047],
    [-71.3656, 41.6937],
    [-71.3694, 41.6863],
    [-71.3730, 41.6726],
    [-71.3863, 41.6710],
    [-71.3898, 41.6827],
    [-71.3915, 41.6840],
    [-71.4181, 41.6842],
    [-71.4413, 41.6864],
    [-71.4452, 41.6909],
    [-71.4491, 41.6873],
    [-71.4472, 41.6772],
    [-71.4459, 41.6713],
    [-71.4423, 41.6656],
    [-71.4255, 41.6708],
    [-71.4089, 41.6578],
    [-71.4076, 41.6343],
    [-71.4034, 41.6255],
    [-71.4024, 41.6156],
    [-71.4069, 41.6111],
    [-71.4169, 41.6049],
    [-71.4034, 41.6006],
    [-71.4110, 41.5866],
    [-71.4296, 41.5835],
    [-71.4388, 41.5814],
    [-71.4443, 41.5789],
    [-71.4464, 41.5745],
    [-71.4381, 41.5706],
    [-71.4383, 41.5635],
    [-71.4330, 41.5608],
    [-71.4279, 41.5555],
    [-71.4248, 41.5494],
    [-71.4253, 41.5455],
    [-71.4177, 41.5363],
    [-71.4155, 41.5299],
    [-71.4149, 41.5163],
    [-71.4209, 41.4932],
    [-71.4203, 41.4836],
    [-71.4184, 41.4727],
    [-71.4230, 41.4727],
    [-71.4309, 41.4657],
    [-71.4258, 41.4560],
    [-71.4321, 41.4494],
    [-71.4381, 41.4417],
    [-71.4406, 41.4384],
    [-71.4489, 41.4385],
    [-71.4547, 41.4339],
    [-71.4558, 41.4330],
    [-71.4554, 41.4280],
    [-71.4526, 41.4178],
    [-71.4530, 41.4097],
    [-71.4592, 41.4031],
    [-71.4637, 41.3958],
    [-71.4704, 41.3918],
    [-71.4829, 41.3659],
    [-71.4809, 41.3602],
    [-71.4892, 41.3624],
    [-71.4973, 41.3713],
    [-71.5202, 41.3765],
    [-71.5264, 41.3769],
    [-71.5354, 41.3750],
    [-71.5453, 41.3740],
    [-71.5733, 41.3704],
    [-71.5981, 41.3651],
    [-71.6165, 41.3630],
    [-71.6270, 41.3603],
    [-71.6387, 41.3555],
    [-71.6929, 41.3418],
    [-71.7016, 41.3370],
    [-71.7180, 41.3313],
    [-71.7293, 41.3317],
    [-71.7489, 41.3269],
    [-71.7628, 41.3286],
    [-71.7737, 41.3280],
    [-71.8129, 41.3207],
    [-71.8338, 41.3156],
    [-71.8574, 41.3063],
    [-71.8628, 41.3098],
    [-71.8627, 41.3109]
    ]
  },
  "Kentucky": {
    coordinates: [
      [-89.4057, 36.5282],
    [-89.3966, 36.5564],
    [-89.3806, 36.5911],
    [-89.3755, 36.6157],
    [-89.3565, 36.6284],
    [-89.3276, 36.6322],
    [-89.3134, 36.6201],
    [-89.2789, 36.5777],
    [-89.2600, 36.5651],
    [-89.2273, 36.5694],
    [-89.2136, 36.5801],
    [-89.1991, 36.6256],
    [-89.1877, 36.6411],
    [-89.1747, 36.6505],
    [-89.1591, 36.6664],
    [-89.1695, 36.6746],
    [-89.1695, 36.6889],
    [-89.1960, 36.7120],
    [-89.2010, 36.7258],
    [-89.1916, 36.7472],
    [-89.1750, 36.7576],
    [-89.1669, 36.7596],
    [-89.1423, 36.7554],
    [-89.1261, 36.7517],
    [-89.1166, 36.7676],
    [-89.1204, 36.7821],
    [-89.1289, 36.7877],
    [-89.1559, 36.7891],
    [-89.1711, 36.7981],
    [-89.1774, 36.8073],
    [-89.1786, 36.8166],
    [-89.1772, 36.8358],
    [-89.1668, 36.8425],
    [-89.1535, 36.8466],
    [-89.1319, 36.8574],
    [-89.1222, 36.8790],
    [-89.1094, 36.9201],
    [-89.1008, 36.9440],
    [-89.0992, 36.9626],
    [-89.1095, 36.9766],
    [-89.1251, 36.9835],
    [-89.1384, 36.9851],
    [-89.1664, 37.0033],
    [-89.1711, 37.0081],
    [-89.1794, 37.0223],
    [-89.1825, 37.0373],
    [-89.1757, 37.0621],
    [-89.1670, 37.0754],
    [-89.1513, 37.0905],
    [-89.1413, 37.0939],
    [-89.1349, 37.1033],
    [-89.1210, 37.1127],
    [-89.1112, 37.1191],
    [-89.0967, 37.1462],
    [-89.0872, 37.1646],
    [-89.0762, 37.1751],
    [-89.0437, 37.2008],
    [-89.0300, 37.2111],
    [-89.0085, 37.2206],
    [-88.9833, 37.2287],
    [-88.9673, 37.2269],
    [-88.9329, 37.2252],
    [-88.9209, 37.2248],
    [-88.8695, 37.2097],
    [-88.8351, 37.1965],
    [-88.8209, 37.1922],
    [-88.7897, 37.1802],
    [-88.7795, 37.1725],
    [-88.7531, 37.1547],
    [-88.7453, 37.1511],
    [-88.7379, 37.1465],
    [-88.7321, 37.1440],
    [-88.7206, 37.1407],
    [-88.7026, 37.1426],
    [-88.6854, 37.1385],
    [-88.6380, 37.1213],
    [-88.6274, 37.1199],
    [-88.6214, 37.1174],
    [-88.6011, 37.1071],
    [-88.5892, 37.0997],
    [-88.5768, 37.0898],
    [-88.5661, 37.0752],
    [-88.5422, 37.0699],
    [-88.5144, 37.0652],
    [-88.4901, 37.0679],
    [-88.4589, 37.0738],
    [-88.4427, 37.1078],
    [-88.4358, 37.1251],
    [-88.4246, 37.1510],
    [-88.4299, 37.1587],
    [-88.4335, 37.1659],
    [-88.4420, 37.1890],
    [-88.4588, 37.2135],
    [-88.4782, 37.2273],
    [-88.4873, 37.2441],
    [-88.5080, 37.2603],
    [-88.5096, 37.2734],
    [-88.5115, 37.2985],
    [-88.5006, 37.3178],
    [-88.4869, 37.3396],
    [-88.4827, 37.3545],
    [-88.4821, 37.3646],
    [-88.4785, 37.3751],
    [-88.4659, 37.4005],
    [-88.4393, 37.4164],
    [-88.4186, 37.4220],
    [-88.4088, 37.4252],
    [-88.3965, 37.4212],
    [-88.3734, 37.4043],
    [-88.3616, 37.4029],
    [-88.3584, 37.4049],
    [-88.3349, 37.4254],
    [-88.3212, 37.4347],
    [-88.3146, 37.4388],
    [-88.2817, 37.4526],
    [-88.2250, 37.4574],
    [-88.1886, 37.4619],
    [-88.1600, 37.4667],
    [-88.1351, 37.4716],
    [-88.1094, 37.4724],
    [-88.0900, 37.4720],
    [-88.0818, 37.4730],
    [-88.0745, 37.4813],
    [-88.0715, 37.4859],
    [-88.0665, 37.4878],
    [-88.0626, 37.4960],
    [-88.0628, 37.5081],
    [-88.0690, 37.5253],
    [-88.0862, 37.5342],
    [-88.1012, 37.5513],
    [-88.1143, 37.5622],
    [-88.1334, 37.5742],
    [-88.1409, 37.5909],
    [-88.1422, 37.6037],
    [-88.1584, 37.6399],
    [-88.1602, 37.6576],
    [-88.1516, 37.6751],
    [-88.1343, 37.6915],
    [-88.1301, 37.7002],
    [-88.1178, 37.7126],
    [-88.0958, 37.7232],
    [-88.0725, 37.7333],
    [-88.0499, 37.7541],
    [-88.0409, 37.7721],
    [-88.0358, 37.7919],
    [-88.0210, 37.8014],
    [-87.9971, 37.7977],
    [-87.9872, 37.7922],
    [-87.9718, 37.7846],
    [-87.9526, 37.7717],
    [-87.9445, 37.7753],
    [-87.9359, 37.7897],
    [-87.9326, 37.7977],
    [-87.9111, 37.8052],
    [-87.9038, 37.8178],
    [-87.9149, 37.8496],
    [-87.9381, 37.8707],
    [-87.9408, 37.8833],
    [-87.9372, 37.8921],
    [-87.9278, 37.9009],
    [-87.9065, 37.9231],
    [-87.8944, 37.9278],
    [-87.8833, 37.9262],
    [-87.8656, 37.9151],
    [-87.8572, 37.9006],
    [-87.8417, 37.8877],
    [-87.8381, 37.8798],
    [-87.8157, 37.8756],
    [-87.7909, 37.8757],
    [-87.7836, 37.8778],
    [-87.7623, 37.8909],
    [-87.7333, 37.8943],
    [-87.7180, 37.8926],
    [-87.7007, 37.8974],
    [-87.6840, 37.9035],
    [-87.6710, 37.8997],
    [-87.6635, 37.8866],
    [-87.6686, 37.8745],
    [-87.6754, 37.8659],
    [-87.6807, 37.8406],
    [-87.6724, 37.8291],
    [-87.6459, 37.8259],
    [-87.6358, 37.8270],
    [-87.6150, 37.8322],
    [-87.6066, 37.8387],
    [-87.5979, 37.8477],
    [-87.5915, 37.8604],
    [-87.5880, 37.8690],
    [-87.5839, 37.8725],
    [-87.5871, 37.8849],
    [-87.6020, 37.8957],
    [-87.6208, 37.9077],
    [-87.6279, 37.9223],
    [-87.6271, 37.9285],
    [-87.6224, 37.9276],
    [-87.6182, 37.9350],
    [-87.6195, 37.9375],
    [-87.6108, 37.9446],
    [-87.6048, 37.9525],
    [-87.6033, 37.9673],
    [-87.5962, 37.9749],
    [-87.5845, 37.9747],
    [-87.5754, 37.9665],
    [-87.5765, 37.9521],
    [-87.5731, 37.9500],
    [-87.5621, 37.9333],
    [-87.5485, 37.9241],
    [-87.5203, 37.9126],
    [-87.5054, 37.9076],
    [-87.4807, 37.9235],
    [-87.4505, 37.9415],
    [-87.4283, 37.9450],
    [-87.4141, 37.9447],
    [-87.4022, 37.9427],
    [-87.3914, 37.9391],
    [-87.3735, 37.9322],
    [-87.3705, 37.9282],
    [-87.3578, 37.9204],
    [-87.3449, 37.9112],
    [-87.3198, 37.9055],
    [-87.2983, 37.8959],
    [-87.2690, 37.8780],
    [-87.2495, 37.8650],
    [-87.2118, 37.8466],
    [-87.1704, 37.8422],
    [-87.1563, 37.8359],
    [-87.1480, 37.8251],
    [-87.1371, 37.8073],
    [-87.1354, 37.7978],
    [-87.1296, 37.7866],
    [-87.1261, 37.7847],
    [-87.1110, 37.7824],
    [-87.0992, 37.7845],
    [-87.0893, 37.7879],
    [-87.0743, 37.7979],
    [-87.0676, 37.8049],
    [-87.0640, 37.8161],
    [-87.0545, 37.8353],
    [-87.0433, 37.8686],
    [-87.0431, 37.8755],
    [-87.0456, 37.8870],
    [-87.0461, 37.8915],
    [-87.0367, 37.9041],
    [-87.0124, 37.9187],
    [-86.9788, 37.9302],
    [-86.9446, 37.9335],
    [-86.9179, 37.9372],
    [-86.9073, 37.9433],
    [-86.8903, 37.9574],
    [-86.8759, 37.9708],
    [-86.8559, 37.9873],
    [-86.8235, 37.9989],
    [-86.8148, 37.9987],
    [-86.8051, 37.9936],
    [-86.8001, 37.9913],
    [-86.7905, 37.9800],
    [-86.7792, 37.9583],
    [-86.7772, 37.9517],
    [-86.7748, 37.9483],
    [-86.7647, 37.9324],
    [-86.7510, 37.9129],
    [-86.7377, 37.8995],
    [-86.7222, 37.8926],
    [-86.7161, 37.8941],
    [-86.7034, 37.9012],
    [-86.6809, 37.9150],
    [-86.6609, 37.9131],
    [-86.6455, 37.9065],
    [-86.6448, 37.8948],
    [-86.6612, 37.8628],
    [-86.6583, 37.8441],
    [-86.6480, 37.8414],
    [-86.6335, 37.8442],
    [-86.6092, 37.8554],
    [-86.5981, 37.8674],
    [-86.5994, 37.8748],
    [-86.6001, 37.9012],
    [-86.5961, 37.9143],
    [-86.5803, 37.9231],
    [-86.5407, 37.9169],
    [-86.5261, 37.9195],
    [-86.5078, 37.9288],
    [-86.5094, 37.9425],
    [-86.5205, 37.9544],
    [-86.5249, 37.9818],
    [-86.5247, 38.0129],
    [-86.5249, 38.0282],
    [-86.5194, 38.0412],
    [-86.5001, 38.0458],
    [-86.4719, 38.0462],
    [-86.4382, 38.0604],
    [-86.4301, 38.0786],
    [-86.4475, 38.0918],
    [-86.4639, 38.1012],
    [-86.4632, 38.1193],
    [-86.4498, 38.1272],
    [-86.4264, 38.1230],
    [-86.4051, 38.1058],
    [-86.3918, 38.1171],
    [-86.3753, 38.1306],
    [-86.3337, 38.1292],
    [-86.3212, 38.1470],
    [-86.3449, 38.1590],
    [-86.3717, 38.1642],
    [-86.3782, 38.1858],
    [-86.3675, 38.1973],
    [-86.3477, 38.1954],
    [-86.3297, 38.1817],
    [-86.2871, 38.1579],
    [-86.2706, 38.1358],
    [-86.2779, 38.1050],
    [-86.2777, 38.0825],
    [-86.2714, 38.0620],
    [-86.2527, 38.0478],
    [-86.2334, 38.0382],
    [-86.2061, 38.0224],
    [-86.1909, 38.0164],
    [-86.1694, 38.0100],
    [-86.1479, 38.0147],
    [-86.1175, 38.0154],
    [-86.0863, 38.0049],
    [-86.0759, 37.9955],
    [-86.0649, 37.9756],
    [-86.0467, 37.9590],
    [-86.0360, 37.9617],
    [-86.0336, 37.9702],
    [-86.0325, 37.9901],
    [-86.0256, 37.9945],
    [-85.9990, 38.0000],
    [-85.9546, 38.0047],
    [-85.9396, 38.0098],
    [-85.9213, 38.0303],
    [-85.9154, 38.0652],
    [-85.9077, 38.0833],
    [-85.9042, 38.0998],
    [-85.9061, 38.1169],
    [-85.9080, 38.1615],
    [-85.8949, 38.1870],
    [-85.8746, 38.2076],
    [-85.8562, 38.2195],
    [-85.8454, 38.2299],
    [-85.8391, 38.2397],
    [-85.8374, 38.2509],
    [-85.8366, 38.2634],
    [-85.8321, 38.2718],
    [-85.8237, 38.2802],
    [-85.8174, 38.2824],
    [-85.8024, 38.2848],
    [-85.7911, 38.2878],
    [-85.7795, 38.2877],
    [-85.7714, 38.2841],
    [-85.7672, 38.2773],
    [-85.7515, 38.2680],
    [-85.7448, 38.2672],
    [-85.7325, 38.2719],
    [-85.7051, 38.2851],
    [-85.6994, 38.2879],
    [-85.6836, 38.2955],
    [-85.6736, 38.3023],
    [-85.6599, 38.3194],
    [-85.6541, 38.3260],
    [-85.6463, 38.3417],
    [-85.6423, 38.3524],
    [-85.6387, 38.3639],
    [-85.6384, 38.3770],
    [-85.6369, 38.3832],
    [-85.6329, 38.3957],
    [-85.6241, 38.4123],
    [-85.6207, 38.4223],
    [-85.6097, 38.4348],
    [-85.5860, 38.4501],
    [-85.5625, 38.4533],
    [-85.5382, 38.4552],
    [-85.5094, 38.4635],
    [-85.4888, 38.4780],
    [-85.4795, 38.4945],
    [-85.4671, 38.5106],
    [-85.4384, 38.5219],
    [-85.4224, 38.5329],
    [-85.4158, 38.5628],
    [-85.4286, 38.5864],
    [-85.4393, 38.6074],
    [-85.4381, 38.6459],
    [-85.4387, 38.6593],
    [-85.4555, 38.6821],
    [-85.4565, 38.6933],
    [-85.4509, 38.7089],
    [-85.4423, 38.7199],
    [-85.4234, 38.7338],
    [-85.3978, 38.7356],
    [-85.3723, 38.7304],
    [-85.3670, 38.7310],
    [-85.3514, 38.7320],
    [-85.3364, 38.7349],
    [-85.3053, 38.7415],
    [-85.2788, 38.7416],
    [-85.2487, 38.7329],
    [-85.2351, 38.7180],
    [-85.2133, 38.6954],
    [-85.1921, 38.6891],
    [-85.1766, 38.6885],
    [-85.1367, 38.7002],
    [-85.1252, 38.7089],
    [-85.1070, 38.7216],
    [-85.0944, 38.7292],
    [-85.0637, 38.7441],
    [-85.0524, 38.7481],
    [-85.0236, 38.7620],
    [-84.9930, 38.7780],
    [-84.9800, 38.7796],
    [-84.9436, 38.7754],
    [-84.9152, 38.7841],
    [-84.8964, 38.7927],
    [-84.8772, 38.7925],
    [-84.8529, 38.7894],
    [-84.8214, 38.7831],
    [-84.8129, 38.7861],
    [-84.8165, 38.8053],
    [-84.8300, 38.8304],
    [-84.8234, 38.8392],
    [-84.8032, 38.8507],
    [-84.7937, 38.8578],
    [-84.7858, 38.8695],
    [-84.7864, 38.8822],
    [-84.8011, 38.8913],
    [-84.8286, 38.8970],
    [-84.8608, 38.8977],
    [-84.8706, 38.9010],
    [-84.8793, 38.9161],
    [-84.8708, 38.9292],
    [-84.8537, 38.9429],
    [-84.8442, 38.9510],
    [-84.8402, 38.9546],
    [-84.8329, 38.9611],
    [-84.8305, 38.9742],
    [-84.8371, 38.9881],
    [-84.8477, 38.9980],
    [-84.8718, 39.0278],
    [-84.8791, 39.0337],
    [-84.8932, 39.0490],
    [-84.8968, 39.0545],
    [-84.8968, 39.0576],
    [-84.8889, 39.0664],
    [-84.8701, 39.0735],
    [-84.8498, 39.0865],
    [-84.8373, 39.0971],
    [-84.8202, 39.1055],
    [-84.8108, 39.1091],
    [-84.7840, 39.1181],
    [-84.7544, 39.1467],
    [-84.7320, 39.1445],
    [-84.7185, 39.1371],
    [-84.7019, 39.1190],
    [-84.6897, 39.1042],
    [-84.6661, 39.0980],
    [-84.6358, 39.0795],
    [-84.6201, 39.0735],
    [-84.6017, 39.0741],
    [-84.5718, 39.0823],
    [-84.5639, 39.0874],
    [-84.5510, 39.0993],
    [-84.5415, 39.0992],
    [-84.5246, 39.0922],
    [-84.5195, 39.0921],
    [-84.5021, 39.0966],
    [-84.4965, 39.1003],
    [-84.4937, 39.1025],
    [-84.4877, 39.1108],
    [-84.4762, 39.1192],
    [-84.4705, 39.1215],
    [-84.4620, 39.1218],
    [-84.4457, 39.1148],
    [-84.4406, 39.1097],
    [-84.4355, 39.1023],
    [-84.4346, 39.0869],
    [-84.4326, 39.0783],
    [-84.4331, 39.0729],
    [-84.4295, 39.0576],
    [-84.4257, 39.0531],
    [-84.4216, 39.0510],
    [-84.4069, 39.0457],
    [-84.3967, 39.0457],
    [-84.3868, 39.0452],
    [-84.3614, 39.0415],
    [-84.3364, 39.0329],
    [-84.3294, 39.0291],
    [-84.3137, 39.0170],
    [-84.2994, 38.9960],
    [-84.2965, 38.9853],
    [-84.2951, 38.9683],
    [-84.2841, 38.9506],
    [-84.2749, 38.9415],
    [-84.2570, 38.9232],
    [-84.2402, 38.9009],
    [-84.2321, 38.8805],
    [-84.2319, 38.8719],
    [-84.2335, 38.8563],
    [-84.2337, 38.8536],
    [-84.2304, 38.8274],
    [-84.2253, 38.8177],
    [-84.2129, 38.8057],
    [-84.1984, 38.8009],
    [-84.1519, 38.7939],
    [-84.1318, 38.7883],
    [-84.1088, 38.7792],
    [-84.0634, 38.7712],
    [-84.0445, 38.7706],
    [-84.0231, 38.7751],
    [-83.9965, 38.7817],
    [-83.9751, 38.7872],
    [-83.9591, 38.7870],
    [-83.9285, 38.7746],
    [-83.9172, 38.7697],
    [-83.9040, 38.7682],
    [-83.8732, 38.7624],
    [-83.8538, 38.7528],
    [-83.8475, 38.7448],
    [-83.8427, 38.7304],
    [-83.8406, 38.7219],
    [-83.8340, 38.7160],
    [-83.8227, 38.7100],
    [-83.8063, 38.7066],
    [-83.7907, 38.7017],
    [-83.7836, 38.6956],
    [-83.7758, 38.6667],
    [-83.7693, 38.6552],
    [-83.7588, 38.6514],
    [-83.7496, 38.6496],
    [-83.7179, 38.6452],
    [-83.7134, 38.6416],
    [-83.7053, 38.6398],
    [-83.6795, 38.6300],
    [-83.6593, 38.6286],
    [-83.6497, 38.6328],
    [-83.6400, 38.6525],
    [-83.6362, 38.6706],
    [-83.6265, 38.6795],
    [-83.6141, 38.6840],
    [-83.6016, 38.6839],
    [-83.5912, 38.6889],
    [-83.5750, 38.6918],
    [-83.5493, 38.6988],
    [-83.5126, 38.7017],
    [-83.4865, 38.6901],
    [-83.4681, 38.6755],
    [-83.4567, 38.6738],
    [-83.4375, 38.6692],
    [-83.3849, 38.6632],
    [-83.3759, 38.6614],
    [-83.3400, 38.6457],
    [-83.3205, 38.6227],
    [-83.3177, 38.6095],
    [-83.3078, 38.6008],
    [-83.2942, 38.5966],
    [-83.2865, 38.5992],
    [-83.2676, 38.6184],
    [-83.2546, 38.6234],
    [-83.2395, 38.6286],
    [-83.2110, 38.6186],
    [-83.1914, 38.6176],
    [-83.1569, 38.6205],
    [-83.1386, 38.6283],
    [-83.1263, 38.6452],
    [-83.1124, 38.6717],
    [-83.0842, 38.6811],
    [-83.0531, 38.6958],
    [-83.0383, 38.7166],
    [-83.0309, 38.7256],
    [-83.0218, 38.7288],
    [-83.0116, 38.7300],
    [-82.9970, 38.7290],
    [-82.9794, 38.7260],
    [-82.9687, 38.7288],
    [-82.9581, 38.7354],
    [-82.9314, 38.7474],
    [-82.9176, 38.7514],
    [-82.8849, 38.7540],
    [-82.8743, 38.7454],
    [-82.8713, 38.7394],
    [-82.8699, 38.7278],
    [-82.8753, 38.7050],
    [-82.8749, 38.6828],
    [-82.8633, 38.6693],
    [-82.8563, 38.6461],
    [-82.8558, 38.6208],
    [-82.8513, 38.6043],
    [-82.8443, 38.5909],
    [-82.8202, 38.5727],
    [-82.8001, 38.5632],
    [-82.7637, 38.5604],
    [-82.7396, 38.5590],
    [-82.7197, 38.5537],
    [-82.7083, 38.5480],
    [-82.6966, 38.5421],
    [-82.6900, 38.5359],
    [-82.6816, 38.5240],
    [-82.6655, 38.5058],
    [-82.6602, 38.5001],
    [-82.6392, 38.4853],
    [-82.6241, 38.4797],
    [-82.6133, 38.4741],
    [-82.6105, 38.4715],
    [-82.6041, 38.4598],
    [-82.6009, 38.4386],
    [-82.5977, 38.4290],
    [-82.5960, 38.4180],
    [-82.5970, 38.4099],
    [-82.5949, 38.3995],
    [-82.5997, 38.3904],
    [-82.5942, 38.3813],
    [-82.5930, 38.3751],
    [-82.5967, 38.3673],
    [-82.5982, 38.3566],
    [-82.5965, 38.3428],
    [-82.5880, 38.3386],
    [-82.5761, 38.3261],
    [-82.5719, 38.3133],
    [-82.5815, 38.3004],
    [-82.5797, 38.2917],
    [-82.5767, 38.2775],
    [-82.5783, 38.2548],
    [-82.5861, 38.2456],
    [-82.6042, 38.2473],
    [-82.6071, 38.2460],
    [-82.6104, 38.2268],
    [-82.6043, 38.2206],
    [-82.5989, 38.2010],
    [-82.6042, 38.1876],
    [-82.6194, 38.1690],
    [-82.6430, 38.1696],
    [-82.6389, 38.1567],
    [-82.6373, 38.1390],
    [-82.6294, 38.1356],
    [-82.6212, 38.1320],
    [-82.6195, 38.1207],
    [-82.6134, 38.1204],
    [-82.6026, 38.1183],
    [-82.5980, 38.1159],
    [-82.5918, 38.1099],
    [-82.5851, 38.0981],
    [-82.5741, 38.0821],
    [-82.5513, 38.0708],
    [-82.5494, 38.0631],
    [-82.5448, 38.0543],
    [-82.5412, 38.0484],
    [-82.5391, 38.0398],
    [-82.5350, 38.0322],
    [-82.5258, 38.0264],
    [-82.5198, 38.0084],
    [-82.5156, 38.0047],
    [-82.5144, 37.9992],
    [-82.5098, 38.0012],
    [-82.5008, 37.9990],
    [-82.4860, 37.9957],
    [-82.4822, 37.9837],
    [-82.4655, 37.9847],
    [-82.4650, 37.9769],
    [-82.4843, 37.9714],
    [-82.4790, 37.9620],
    [-82.4716, 37.9591],
    [-82.4851, 37.9460],
    [-82.4967, 37.9464],
    [-82.4976, 37.9430],
    [-82.4895, 37.9379],
    [-82.4981, 37.9370],
    [-82.5022, 37.9331],
    [-82.4819, 37.9268],
    [-82.4881, 37.9196],
    [-82.4802, 37.9150],
    [-82.4747, 37.9104],
    [-82.4763, 37.9031],
    [-82.4724, 37.8990],
    [-82.4682, 37.9036],
    [-82.4643, 37.9150],
    [-82.4609, 37.9108],
    [-82.4570, 37.9090],
    [-82.4475, 37.9040],
    [-82.4381, 37.9002],
    [-82.4290, 37.8883],
    [-82.4192, 37.8821],
    [-82.4182, 37.8712],
    [-82.4097, 37.8689],
    [-82.4080, 37.8665],
    [-82.4224, 37.8639],
    [-82.4239, 37.8602],
    [-82.4148, 37.8555],
    [-82.4206, 37.8467],
    [-82.4136, 37.8450],
    [-82.4089, 37.8366],
    [-82.3997, 37.8299],
    [-82.4022, 37.8110],
    [-82.3970, 37.8090],
    [-82.3878, 37.8182],
    [-82.3796, 37.8109],
    [-82.3781, 37.8043],
    [-82.3700, 37.8017],
    [-82.3653, 37.7968],
    [-82.3561, 37.7939],
    [-82.3485, 37.7868],
    [-82.3384, 37.7804],
    [-82.3376, 37.7754],
    [-82.3297, 37.7757],
    [-82.3230, 37.7739],
    [-82.3341, 37.7666],
    [-82.3295, 37.7624],
    [-82.3152, 37.7655],
    [-82.3113, 37.7613],
    [-82.3183, 37.7596],
    [-82.3214, 37.7513],
    [-82.3338, 37.7416],
    [-82.3197, 37.7344],
    [-82.3179, 37.7277],
    [-82.3111, 37.7173],
    [-82.3062, 37.7070],
    [-82.2981, 37.7041],
    [-82.2970, 37.7011],
    [-82.3029, 37.6937],
    [-82.2963, 37.6871],
    [-82.3039, 37.6784],
    [-82.3035, 37.6757],
    [-82.3002, 37.6765],
    [-82.2944, 37.6780],
    [-82.2944, 37.6704],
    [-82.2864, 37.6701],
    [-82.2823, 37.6758],
    [-82.2769, 37.6689],
    [-82.2680, 37.6624],
    [-82.2495, 37.6580],
    [-82.2344, 37.6579],
    [-82.2310, 37.6553],
    [-82.2249, 37.6464],
    [-82.2168, 37.6416],
    [-82.2202, 37.6354],
    [-82.2160, 37.6262],
    [-82.2059, 37.6251],
    [-82.2012, 37.6279],
    [-82.1873, 37.6269],
    [-82.1880, 37.6395],
    [-82.1908, 37.6451],
    [-82.1827, 37.6489],
    [-82.1746, 37.6474],
    [-82.1758, 37.6446],
    [-82.1760, 37.6374],
    [-82.1735, 37.6311],
    [-82.1827, 37.6244],
    [-82.1773, 37.6187],
    [-82.1727, 37.6198],
    [-82.1649, 37.6206],
    [-82.1693, 37.6135],
    [-82.1685, 37.6087],
    [-82.1634, 37.6082],
    [-82.1561, 37.6049],
    [-82.1481, 37.5908],
    [-82.1323, 37.5933],
    [-82.1256, 37.5790],
    [-82.1273, 37.5727],
    [-82.1428, 37.5706],
    [-82.1446, 37.5669],
    [-82.1361, 37.5639],
    [-82.1346, 37.5586],
    [-82.1332, 37.5528],
    [-82.1238, 37.5514],
    [-82.1173, 37.5592],
    [-82.1023, 37.5595],
    [-82.1054, 37.5543],
    [-82.1031, 37.5528],
    [-82.0846, 37.5554],
    [-82.0658, 37.5462],
    [-82.0648, 37.5390],
    [-82.0613, 37.5360],
    [-82.0496, 37.5352],
    [-82.0467, 37.5282],
    [-82.0424, 37.5358],
    [-82.0448, 37.5467],
    [-82.0380, 37.5469],
    [-82.0253, 37.5383],
    [-82.0169, 37.5386],
    [-82.0092, 37.5332],
    [-81.9982, 37.5431],
    [-81.9940, 37.5376],
    [-81.9875, 37.5428],
    [-81.9764, 37.5454],
    [-81.9650, 37.5430],
    [-82.0509, 37.4805],
    [-82.1249, 37.4273],
    [-82.2017, 37.3751],
    [-82.2187, 37.3628],
    [-82.2865, 37.3154],
    [-82.3094, 37.3001],
    [-82.3160, 37.2949],
    [-82.3190, 37.2875],
    [-82.3369, 37.2797],
    [-82.3509, 37.2671],
    [-82.3766, 37.2599],
    [-82.3845, 37.2599],
    [-82.4310, 37.2468],
    [-82.4520, 37.2426],
    [-82.4733, 37.2356],
    [-82.4872, 37.2278],
    [-82.4952, 37.2256],
    [-82.5079, 37.2227],
    [-82.5081, 37.2210],
    [-82.5132, 37.2168],
    [-82.5287, 37.2137],
    [-82.5316, 37.2092],
    [-82.5413, 37.2065],
    [-82.5538, 37.2028],
    [-82.5653, 37.1961],
    [-82.5863, 37.1858],
    [-82.5932, 37.1821],
    [-82.6043, 37.1745],
    [-82.6249, 37.1629],
    [-82.6335, 37.1543],
    [-82.6533, 37.1513],
    [-82.6575, 37.1450],
    [-82.6715, 37.1384],
    [-82.6794, 37.1356],
    [-82.7079, 37.1255],
    [-82.7221, 37.1202],
    [-82.7264, 37.1148],
    [-82.7216, 37.1013],
    [-82.7250, 37.0919],
    [-82.7182, 37.0807],
    [-82.7184, 37.0757],
    [-82.7237, 37.0755],
    [-82.7263, 37.0669],
    [-82.7231, 37.0524],
    [-82.7247, 37.0428],
    [-82.7317, 37.0434],
    [-82.7437, 37.0414],
    [-82.7507, 37.0241],
    [-82.7592, 37.0273],
    [-82.7718, 37.0157],
    [-82.7784, 37.0125],
    [-82.7891, 37.0080],
    [-82.7905, 37.0073],
    [-82.7948, 37.0059],
    [-82.7975, 37.0097],
    [-82.8157, 37.0072],
    [-82.8218, 37.0044],
    [-82.8286, 37.0057],
    [-82.8291, 36.9975],
    [-82.8360, 36.9888],
    [-82.8413, 36.9869],
    [-82.8514, 36.9845],
    [-82.8564, 36.9822],
    [-82.8606, 36.9783],
    [-82.8660, 36.9783],
    [-82.8685, 36.9765],
    [-82.8703, 36.9660],
    [-82.8654, 36.9581],
    [-82.8605, 36.9560],
    [-82.8561, 36.9525],
    [-82.8613, 36.9448],
    [-82.8588, 36.9331],
    [-82.8586, 36.9278],
    [-82.8635, 36.9223],
    [-82.8721, 36.9135],
    [-82.8762, 36.9102],
    [-82.8701, 36.9017],
    [-82.8786, 36.8940],
    [-82.8786, 36.8896],
    [-82.8876, 36.8869],
    [-82.8954, 36.8821],
    [-82.9080, 36.8772],
    [-82.9103, 36.8741],
    [-82.9224, 36.8739],
    [-82.9517, 36.8662],
    [-82.9719, 36.8578],
    [-82.9887, 36.8591],
    [-83.0038, 36.8518],
    [-83.0126, 36.8473],
    [-83.0259, 36.8553],
    [-83.0443, 36.8530],
    [-83.0605, 36.8538],
    [-83.0693, 36.8536],
    [-83.0756, 36.8506],
    [-83.0797, 36.8406],
    [-83.0909, 36.8346],
    [-83.1018, 36.8291],
    [-83.1017, 36.8267],
    [-83.0985, 36.8143],
    [-83.1108, 36.8004],
    [-83.1233, 36.7867],
    [-83.1332, 36.7846],
    [-83.1312, 36.7788],
    [-83.1317, 36.7736],
    [-83.1289, 36.7699],
    [-83.1323, 36.7656],
    [-83.1263, 36.7617],
    [-83.1257, 36.7613],
    [-83.1283, 36.7564],
    [-83.1343, 36.7466],
    [-83.1461, 36.7418],
    [-83.1674, 36.7392],
    [-83.1959, 36.7390],
    [-83.2284, 36.7290],
    [-83.2463, 36.7253],
    [-83.2693, 36.7185],
    [-83.2857, 36.7152],
    [-83.2871, 36.7139],
    [-83.3114, 36.7103],
    [-83.3428, 36.7013],
    [-83.3505, 36.6977],
    [-83.3546, 36.6962],
    [-83.3602, 36.6936],
    [-83.3675, 36.6927],
    [-83.3953, 36.6795],
    [-83.3958, 36.6768],
    [-83.4237, 36.6674],
    [-83.4408, 36.6669],
    [-83.4580, 36.6658],
    [-83.4665, 36.6647],
    [-83.4939, 36.6701],
    [-83.5014, 36.6691],
    [-83.5160, 36.6676],
    [-83.5319, 36.6650],
    [-83.5418, 36.6566],
    [-83.5626, 36.6513],
    [-83.5747, 36.6442],
    [-83.5845, 36.6414],
    [-83.5899, 36.6414],
    [-83.6030, 36.6369],
    [-83.6079, 36.6371],
    [-83.6199, 36.6280],
    [-83.6350, 36.6229],
    [-83.6483, 36.6227],
    [-83.6636, 36.6068],
    [-83.6734, 36.6044],
    [-83.6754, 36.6008],
    [-83.6771, 36.5966],
    [-83.6875, 36.5872],
    [-83.6908, 36.5826],
    [-83.8944, 36.5865],
    [-83.9878, 36.5896],
    [-84.0509, 36.5904],
    [-84.1261, 36.5914],
    [-84.1491, 36.5916],
    [-84.2268, 36.5922],
    [-84.2613, 36.5920],
    [-84.4349, 36.5959],
    [-84.4391, 36.5960],
    [-84.4999, 36.5967],
    [-84.5624, 36.5971],
    [-84.6422, 36.6000],
    [-84.7854, 36.6034],
    [-84.8598, 36.6064],
    [-84.9439, 36.6126],
    [-85.0246, 36.6194],
    [-85.1701, 36.6247],
    [-85.2038, 36.6256],
    [-85.2764, 36.6265],
    [-85.2961, 36.6258],
    [-85.3341, 36.6230],
    [-85.4364, 36.6185],
    [-85.5086, 36.6152],
    [-85.5871, 36.6164],
    [-85.6778, 36.6182],
    [-85.7886, 36.6218],
    [-85.8320, 36.6220],
    [-85.9195, 36.6260],
    [-85.9729, 36.6285],
    [-85.9791, 36.6287],
    [-86.0331, 36.6304],
    [-86.0819, 36.6338],
    [-86.1650, 36.6378],
    [-86.2055, 36.6398],
    [-86.2191, 36.6408],
    [-86.2934, 36.6454],
    [-86.3591, 36.6498],
    [-86.4111, 36.6506],
    [-86.4685, 36.6518],
    [-86.4735, 36.6517],
    [-86.5363, 36.6430],
    [-86.5457, 36.6442],
    [-86.5503, 36.6434],
    [-86.5639, 36.6336],
    [-86.5712, 36.6387],
    [-86.6050, 36.6521],
    [-86.6791, 36.6502],
    [-86.7589, 36.6490],
    [-86.8162, 36.6477],
    [-86.8433, 36.6471],
    [-86.9060, 36.6463],
    [-86.9809, 36.6446],
    [-87.0608, 36.6432],
    [-87.1744, 36.6421],
    [-87.2036, 36.6420],
    [-87.2477, 36.6418],
    [-87.2815, 36.6418],
    [-87.3441, 36.6415],
    [-87.3564, 36.6414],
    [-87.4094, 36.6411],
    [-87.4143, 36.6410],
    [-87.4363, 36.6408],
    [-87.4453, 36.6406],
    [-87.4609, 36.6404],
    [-87.5631, 36.6391],
    [-87.6942, 36.6371],
    [-87.8018, 36.6346],
    [-87.8496, 36.6637],
    [-87.9119, 36.6685],
    [-88.0448, 36.6780],
    [-88.0644, 36.6509],
    [-88.0556, 36.6357],
    [-88.0451, 36.6029],
    [-88.0356, 36.5617],
    [-88.0341, 36.5311],
    [-88.0378, 36.5210],
    [-88.0395, 36.5104],
    [-88.0532, 36.4971],
    [-88.1274, 36.4985],
    [-88.3093, 36.5003],
    [-88.3259, 36.5005],
    [-88.3308, 36.5005],
    [-88.4502, 36.5011],
    [-88.4891, 36.5011],
    [-88.5123, 36.5015],
    [-88.5449, 36.5018],
    [-88.6611, 36.5022],
    [-88.7153, 36.5027],
    [-88.8168, 36.5028],
    [-88.8346, 36.5029],
    [-88.8436, 36.5028],
    [-88.8715, 36.5025],
    [-88.8758, 36.5024],
    [-88.8946, 36.5020],
    [-88.9198, 36.5022],
    [-89.0001, 36.5026],
    [-89.0106, 36.5027],
    [-89.0721, 36.5032],
    [-89.1175, 36.5036],
    [-89.1603, 36.5045],
    [-89.2114, 36.5056],
    [-89.2823, 36.5068],
    [-89.3566, 36.5022],
    [-89.3910, 36.4991],
    [-89.4057, 36.5282]
    ]
  },
  "Ohio": {
    coordinates: [
      [-84.8202, 39.2272],
    [-84.8198, 39.2478],
    [-84.8199, 39.2510],
    [-84.8198, 39.2552],
    [-84.8196, 39.2674],
    [-84.8196, 39.2765],
    [-84.8184, 39.3486],
    [-84.8175, 39.3918],
    [-84.8157, 39.4794],
    [-84.8156, 39.5111],
    [-84.8151, 39.5487],
    [-84.8150, 39.5663],
    [-84.8152, 39.5684],
    [-84.8150, 39.5957],
    [-84.8146, 39.6390],
    [-84.8143, 39.6558],
    [-84.8145, 39.6804],
    [-84.8141, 39.7436],
    [-84.8142, 39.7869],
    [-84.8142, 39.8142],
    [-84.8139, 39.8246],
    [-84.8138, 39.8305],
    [-84.8137, 39.8432],
    [-84.8135, 39.8508],
    [-84.8128, 39.8908],
    [-84.8126, 39.9022],
    [-84.8122, 39.9273],
    [-84.8112, 39.9953],
    [-84.8105, 40.0197],
    [-84.8091, 40.0857],
    [-84.8087, 40.1072],
    [-84.8083, 40.1290],
    [-84.8068, 40.1802],
    [-84.8063, 40.1923],
    [-84.8062, 40.1985],
    [-84.8059, 40.2116],
    [-84.8056, 40.2238],
    [-84.8039, 40.3101],
    [-84.8041, 40.3528],
    [-84.8044, 40.3970],
    [-84.8045, 40.4116],
    [-84.8039, 40.4626],
    [-84.8025, 40.5018],
    [-84.8024, 40.5529],
    [-84.8022, 40.5969],
    [-84.8022, 40.6576],
    [-84.8022, 40.6748],
    [-84.8021, 40.6914],
    [-84.8021, 40.7281],
    [-84.8023, 40.7472],
    [-84.8022, 40.8006],
    [-84.8028, 40.9022],
    [-84.8033, 40.9892],
    [-84.8034, 41.0775],
    [-84.8032, 41.1214],
    [-84.8035, 41.1616],
    [-84.8036, 41.1732],
    [-84.8035, 41.2525],
    [-84.8036, 41.2710],
    [-84.8038, 41.3249],
    [-84.8039, 41.3680],
    [-84.8040, 41.4084],
    [-84.8040, 41.4261],
    [-84.8042, 41.4651],
    [-84.8046, 41.5004],
    [-84.8047, 41.5301],
    [-84.8054, 41.5853],
    [-84.8058, 41.6192],
    [-84.8059, 41.6529],
    [-84.8060, 41.6961],
    [-84.7087, 41.6991],
    [-84.5803, 41.7019],
    [-84.4759, 41.7041],
    [-84.4381, 41.7049],
    [-84.3605, 41.7066],
    [-84.2497, 41.7097],
    [-84.2213, 41.7105],
    [-84.2022, 41.7110],
    [-84.1150, 41.7136],
    [-84.0194, 41.7167],
    [-83.9577, 41.7181],
    [-83.8804, 41.7201],
    [-83.8528, 41.7214],
    [-83.7814, 41.7231],
    [-83.7468, 41.7240],
    [-83.7093, 41.7251],
    [-83.6890, 41.7262],
    [-83.6662, 41.7269],
    [-83.6459, 41.7276],
    [-83.6400, 41.7277],
    [-83.6313, 41.7280],
    [-83.6148, 41.7285],
    [-83.5952, 41.7291],
    [-83.5855, 41.7293],
    [-83.5669, 41.7298],
    [-83.5345, 41.7307],
    [-83.5043, 41.7315],
    [-83.4977, 41.7318],
    [-83.4820, 41.7321],
    [-83.4640, 41.7325],
    [-83.4556, 41.7274],
    [-83.4622, 41.7256],
    [-83.4695, 41.7187],
    [-83.4706, 41.7159],
    [-83.4728, 41.7102],
    [-83.4746, 41.7044],
    [-83.4787, 41.7021],
    [-83.4742, 41.6982],
    [-83.4707, 41.6947],
    [-83.4667, 41.6913],
    [-83.4633, 41.6941],
    [-83.4586, 41.6970],
    [-83.4514, 41.7001],
    [-83.4476, 41.7013],
    [-83.4304, 41.7110],
    [-83.4199, 41.7029],
    [-83.4340, 41.6964],
    [-83.4307, 41.6911],
    [-83.4230, 41.6894],
    [-83.4126, 41.6892],
    [-83.4094, 41.6913],
    [-83.3981, 41.6903],
    [-83.3883, 41.6892],
    [-83.3757, 41.6866],
    [-83.3570, 41.6867],
    [-83.3509, 41.6895],
    [-83.3380, 41.7034],
    [-83.3212, 41.6977],
    [-83.3073, 41.6783],
    [-83.3000, 41.6756],
    [-83.2833, 41.6758],
    [-83.2594, 41.6625],
    [-83.2378, 41.6511],
    [-83.2352, 41.6477],
    [-83.2299, 41.6416],
    [-83.2148, 41.6383],
    [-83.1459, 41.6179],
    [-83.1281, 41.6167],
    [-83.1039, 41.6136],
    [-83.0749, 41.6007],
    [-83.0612, 41.5865],
    [-83.0489, 41.5743],
    [-83.0415, 41.5667],
    [-83.0180, 41.5500],
    [-82.9999, 41.5400],
    [-82.9696, 41.5242],
    [-82.9585, 41.5211],
    [-82.9429, 41.5179],
    [-82.9371, 41.5168],
    [-82.9123, 41.5159],
    [-82.8882, 41.5225],
    [-82.8752, 41.5297],
    [-82.8615, 41.5446],
    [-82.8562, 41.5535],
    [-82.8533, 41.5589],
    [-82.8552, 41.5641],
    [-82.8547, 41.5705],
    [-82.8560, 41.5733],
    [-82.8573, 41.5728],
    [-82.8530, 41.5833],
    [-82.8312, 41.5845],
    [-82.8202, 41.5707],
    [-82.8055, 41.5601],
    [-82.7843, 41.5407],
    [-82.7717, 41.5407],
    [-82.7499, 41.5465],
    [-82.7395, 41.5450],
    [-82.7152, 41.5382],
    [-82.7115, 41.5282],
    [-82.7148, 41.5234],
    [-82.7219, 41.5167],
    [-82.7139, 41.5017],
    [-82.7133, 41.4949],
    [-82.7125, 41.4871],
    [-82.7150, 41.4919],
    [-82.7205, 41.5015],
    [-82.7198, 41.5055],
    [-82.7223, 41.5095],
    [-82.7262, 41.5108],
    [-82.7289, 41.5115],
    [-82.7376, 41.5109],
    [-82.7464, 41.5120],
    [-82.7618, 41.5042],
    [-82.7742, 41.5020],
    [-82.7856, 41.5051],
    [-82.7929, 41.5065],
    [-82.8021, 41.5060],
    [-82.8153, 41.5024],
    [-82.8210, 41.4915],
    [-82.8265, 41.4921],
    [-82.8376, 41.4999],
    [-82.8509, 41.4994],
    [-82.8578, 41.4956],
    [-82.8647, 41.4927],
    [-82.8878, 41.4889],
    [-82.8968, 41.4883],
    [-82.9073, 41.4889],
    [-82.9231, 41.4882],
    [-82.9486, 41.4874],
    [-82.9538, 41.4883],
    [-82.9657, 41.4809],
    [-82.9721, 41.4707],
    [-82.9776, 41.4669],
    [-82.9892, 41.4637],
    [-82.9966, 41.4601],
    [-83.0045, 41.4626],
    [-83.0143, 41.4632],
    [-83.0288, 41.4643],
    [-83.0392, 41.4597],
    [-83.0351, 41.4538],
    [-83.0153, 41.4533],
    [-83.0068, 41.4517],
    [-83.0073, 41.4458],
    [-83.0092, 41.4460],
    [-83.0180, 41.4494],
    [-83.0245, 41.4491],
    [-83.0250, 41.4481],
    [-83.0158, 41.4456],
    [-83.0125, 41.4429],
    [-83.0099, 41.4425],
    [-83.0114, 41.4365],
    [-83.0071, 41.4285],
    [-83.0033, 41.4309],
    [-83.0032, 41.4280],
    [-82.9991, 41.4316],
    [-83.0032, 41.4372],
    [-82.9974, 41.4407],
    [-82.9875, 41.4462],
    [-82.9869, 41.4511],
    [-82.9767, 41.4536],
    [-82.9681, 41.4438],
    [-82.9607, 41.4347],
    [-82.9544, 41.4265],
    [-82.9422, 41.4198],
    [-82.9229, 41.4203],
    [-82.9156, 41.4233],
    [-82.9064, 41.4274],
    [-82.9046, 41.4290],
    [-82.9028, 41.4312],
    [-82.9015, 41.4317],
    [-82.8976, 41.4327],
    [-82.8961, 41.4342],
    [-82.8926, 41.4346],
    [-82.8915, 41.4344],
    [-82.8889, 41.4348],
    [-82.8811, 41.4431],
    [-82.8585, 41.4411],
    [-82.8532, 41.4444],
    [-82.8476, 41.4475],
    [-82.8452, 41.4492],
    [-82.8390, 41.4505],
    [-82.8314, 41.4543],
    [-82.8288, 41.4594],
    [-82.8290, 41.4607],
    [-82.8286, 41.4657],
    [-82.8300, 41.4728],
    [-82.8198, 41.4694],
    [-82.8121, 41.4732],
    [-82.8010, 41.4643],
    [-82.7683, 41.4468],
    [-82.7523, 41.4461],
    [-82.7446, 41.4506],
    [-82.7376, 41.4491],
    [-82.7307, 41.4620],
    [-82.7313, 41.4526],
    [-82.7285, 41.4541],
    [-82.7189, 41.4579],
    [-82.7140, 41.4596],
    [-82.7051, 41.4627],
    [-82.6968, 41.4608],
    [-82.6923, 41.4547],
    [-82.6877, 41.4557],
    [-82.6836, 41.4532],
    [-82.6796, 41.4548],
    [-82.6752, 41.4536],
    [-82.6714, 41.4545],
    [-82.6616, 41.4527],
    [-82.6672, 41.4488],
    [-82.6758, 41.4466],
    [-82.6777, 41.4446],
    [-82.6745, 41.4453],
    [-82.6698, 41.4463],
    [-82.6621, 41.4406],
    [-82.6597, 41.4347],
    [-82.6493, 41.4348],
    [-82.6416, 41.4320],
    [-82.6402, 41.4284],
    [-82.6372, 41.4273],
    [-82.6388, 41.4304],
    [-82.6281, 41.4284],
    [-82.6260, 41.4242],
    [-82.6235, 41.4233],
    [-82.6123, 41.4213],
    [-82.6063, 41.4190],
    [-82.6021, 41.4173],
    [-82.6018, 41.4214],
    [-82.5970, 41.4173],
    [-82.5916, 41.4145],
    [-82.5853, 41.4121],
    [-82.5695, 41.4070],
    [-82.5581, 41.4000],
    [-82.5530, 41.3982],
    [-82.5501, 41.3979],
    [-82.5393, 41.3942],
    [-82.5351, 41.3920],
    [-82.5260, 41.3887],
    [-82.5176, 41.3856],
    [-82.4999, 41.3817],
    [-82.4812, 41.3813],
    [-82.4686, 41.3844],
    [-82.4576, 41.3875],
    [-82.4422, 41.3932],
    [-82.4252, 41.3999],
    [-82.3943, 41.4151],
    [-82.3726, 41.4217],
    [-82.3643, 41.4274],
    [-82.3588, 41.4272],
    [-82.3441, 41.4298],
    [-82.3342, 41.4302],
    [-82.3105, 41.4296],
    [-82.2916, 41.4284],
    [-82.2655, 41.4317],
    [-82.2525, 41.4357],
    [-82.2523, 41.4366],
    [-82.2529, 41.4377],
    [-82.2526, 41.4379],
    [-82.2491, 41.4378],
    [-82.2336, 41.4443],
    [-82.2260, 41.4481],
    [-82.2224, 41.4501],
    [-82.2159, 41.4543],
    [-82.1934, 41.4645],
    [-82.1909, 41.4666],
    [-82.1898, 41.4678],
    [-82.1892, 41.4704],
    [-82.1864, 41.4718],
    [-82.1870, 41.4743],
    [-82.1820, 41.4733],
    [-82.1665, 41.4742],
    [-82.1644, 41.4747],
    [-82.1532, 41.4777],
    [-82.1332, 41.4845],
    [-82.1179, 41.4895],
    [-82.1070, 41.4921],
    [-82.0944, 41.4950],
    [-82.0746, 41.4998],
    [-82.0629, 41.5026],
    [-82.0395, 41.5089],
    [-82.0185, 41.5142],
    [-81.9971, 41.5146],
    [-81.9903, 41.5126],
    [-81.9673, 41.5049],
    [-81.9590, 41.4990],
    [-81.9523, 41.4953],
    [-81.9304, 41.4905],
    [-81.9226, 41.4898],
    [-81.9084, 41.4882],
    [-81.8985, 41.4867],
    [-81.8719, 41.4832],
    [-81.8520, 41.4855],
    [-81.8371, 41.4900],
    [-81.8108, 41.4956],
    [-81.8006, 41.4963],
    [-81.7944, 41.4962],
    [-81.7823, 41.4960],
    [-81.7689, 41.4916],
    [-81.7628, 41.4914],
    [-81.7448, 41.4871],
    [-81.7341, 41.4932],
    [-81.7306, 41.4925],
    [-81.7206, 41.4979],
    [-81.7160, 41.4981],
    [-81.7147, 41.4999],
    [-81.7111, 41.5016],
    [-81.7109, 41.5033],
    [-81.6983, 41.5105],
    [-81.6938, 41.5106],
    [-81.6923, 41.5095],
    [-81.6936, 41.5128],
    [-81.6928, 41.5146],
    [-81.6713, 41.5282],
    [-81.6643, 41.5276],
    [-81.6620, 41.5273],
    [-81.6585, 41.5289],
    [-81.6562, 41.5288],
    [-81.6546, 41.5312],
    [-81.6522, 41.5346],
    [-81.6468, 41.5347],
    [-81.6380, 41.5408],
    [-81.6347, 41.5410],
    [-81.6370, 41.5422],
    [-81.6357, 41.5465],
    [-81.6333, 41.5482],
    [-81.6265, 41.5446],
    [-81.5997, 41.5606],
    [-81.5906, 41.5687],
    [-81.5902, 41.5725],
    [-81.5832, 41.5737],
    [-81.5715, 41.5812],
    [-81.5655, 41.5868],
    [-81.5628, 41.5889],
    [-81.5505, 41.5984],
    [-81.5426, 41.6057],
    [-81.5343, 41.6114],
    [-81.5297, 41.6145],
    [-81.5153, 41.6182],
    [-81.5103, 41.6202],
    [-81.5020, 41.6239],
    [-81.4869, 41.6327],
    [-81.4626, 41.6527],
    [-81.4490, 41.6666],
    [-81.4471, 41.6735],
    [-81.4445, 41.6734],
    [-81.4372, 41.6768],
    [-81.4088, 41.6939],
    [-81.3886, 41.7071],
    [-81.3588, 41.7228],
    [-81.3497, 41.7287],
    [-81.3384, 41.7343],
    [-81.3190, 41.7435],
    [-81.2908, 41.7577],
    [-81.2803, 41.7603],
    [-81.2642, 41.7581],
    [-81.2475, 41.7617],
    [-81.2315, 41.7676],
    [-81.2253, 41.7687],
    [-81.2112, 41.7752],
    [-81.1911, 41.7842],
    [-81.1635, 41.7964],
    [-81.1517, 41.8013],
    [-81.1390, 41.8065],
    [-81.1129, 41.8176],
    [-81.1019, 41.8202],
    [-81.0951, 41.8223],
    [-81.0741, 41.8296],
    [-81.0633, 41.8324],
    [-81.0488, 41.8383],
    [-81.0347, 41.8425],
    [-81.0061, 41.8516],
    [-80.9980, 41.8541],
    [-80.9901, 41.8551],
    [-80.9781, 41.8567],
    [-80.9678, 41.8585],
    [-80.9497, 41.8620],
    [-80.9268, 41.8650],
    [-80.9167, 41.8659],
    [-80.8917, 41.8725],
    [-80.8777, 41.8776],
    [-80.8642, 41.8811],
    [-80.8485, 41.8872],
    [-80.8370, 41.8909],
    [-80.8231, 41.8941],
    [-80.8087, 41.9016],
    [-80.8021, 41.9091],
    [-80.7961, 41.9113],
    [-80.7944, 41.9104],
    [-80.7881, 41.9116],
    [-80.7851, 41.9118],
    [-80.7825, 41.9075],
    [-80.7731, 41.9082],
    [-80.7382, 41.9178],
    [-80.7129, 41.9223],
    [-80.6828, 41.9309],
    [-80.6534, 41.9406],
    [-80.6441, 41.9424],
    [-80.6270, 41.9445],
    [-80.6007, 41.9530],
    [-80.5819, 41.9576],
    [-80.5719, 41.9612],
    [-80.5651, 41.9635],
    [-80.5603, 41.9674],
    [-80.5595, 41.9701],
    [-80.5578, 41.9708],
    [-80.5566, 41.9675],
    [-80.5532, 41.9690],
    [-80.5526, 41.9717],
    [-80.5494, 41.9727],
    [-80.5476, 41.9713],
    [-80.5378, 41.9730],
    [-80.5194, 41.9762],
    [-80.5193, 41.9372],
    [-80.5193, 41.8921],
    [-80.5193, 41.8496],
    [-80.5193, 41.7577],
    [-80.5194, 41.7147],
    [-80.5194, 41.6718],
    [-80.5194, 41.6610],
    [-80.5193, 41.6070],
    [-80.5193, 41.5710],
    [-80.5192, 41.5321],
    [-80.5192, 41.4890],
    [-80.5190, 41.4355],
    [-80.5190, 41.4164],
    [-80.5192, 41.3789],
    [-80.5192, 41.3610],
    [-80.5193, 41.3401],
    [-80.5193, 41.3391],
    [-80.5193, 41.3360],
    [-80.5191, 41.3124],
    [-80.5188, 41.3055],
    [-80.5190, 41.2682],
    [-80.5187, 41.2489],
    [-80.5189, 41.2328],
    [-80.5189, 41.2279],
    [-80.5188, 41.2099],
    [-80.5189, 41.2030],
    [-80.5191, 41.1712],
    [-80.5192, 41.1334],
    [-80.5190, 41.1251],
    [-80.5190, 41.1160],
    [-80.5191, 41.0994],
    [-80.5191, 41.0829],
    [-80.5190, 41.0719],
    [-80.5190, 41.0520],
    [-80.5189, 41.0240],
    [-80.5190, 40.9941],
    [-80.5190, 40.9534],
    [-80.5199, 40.9067],
    [-80.5198, 40.9003],
    [-80.5190, 40.8513],
    [-80.5191, 40.8492],
    [-80.5190, 40.8012],
    [-80.5191, 40.7894],
    [-80.5190, 40.7337],
    [-80.5190, 40.6886],
    [-80.5190, 40.6541],
    [-80.5190, 40.6388],
    [-80.5301, 40.6363],
    [-80.5459, 40.6297],
    [-80.5607, 40.6237],
    [-80.5719, 40.6155],
    [-80.5799, 40.6143],
    [-80.5891, 40.6200],
    [-80.5941, 40.6237],
    [-80.6102, 40.6233],
    [-80.6325, 40.6171],
    [-80.6394, 40.6113],
    [-80.6517, 40.5977],
    [-80.6571, 40.5953],
    [-80.6680, 40.5825],
    [-80.6627, 40.5702],
    [-80.6414, 40.5484],
    [-80.6305, 40.5379],
    [-80.6233, 40.5236],
    [-80.6209, 40.5123],
    [-80.6091, 40.4895],
    [-80.5992, 40.4826],
    [-80.5948, 40.4714],
    [-80.5965, 40.4625],
    [-80.6029, 40.4519],
    [-80.6112, 40.4378],
    [-80.6130, 40.4294],
    [-80.6127, 40.4087],
    [-80.6118, 40.4039],
    [-80.6281, 40.3959],
    [-80.6336, 40.3905],
    [-80.6307, 40.3849],
    [-80.6117, 40.3766],
    [-80.6076, 40.3696],
    [-80.6118, 40.3552],
    [-80.6108, 40.3409],
    [-80.6029, 40.3279],
    [-80.6004, 40.3159],
    [-80.6066, 40.3039],
    [-80.6149, 40.2920],
    [-80.6165, 40.2788],
    [-80.6193, 40.2652],
    [-80.6371, 40.2543],
    [-80.6472, 40.2491],
    [-80.6532, 40.2432],
    [-80.6615, 40.2298],
    [-80.6663, 40.2063],
    [-80.6765, 40.1890],
    [-80.6818, 40.1856],
    [-80.6861, 40.1816],
    [-80.6999, 40.1616],
    [-80.7060, 40.1516],
    [-80.7080, 40.1433],
    [-80.7104, 40.1293],
    [-80.7088, 40.1181],
    [-80.7081, 40.1173],
    [-80.7067, 40.1109],
    [-80.7098, 40.1003],
    [-80.7170, 40.0945],
    [-80.7328, 40.0843],
    [-80.7386, 40.0757],
    [-80.7385, 40.0713],
    [-80.7343, 40.0597],
    [-80.7322, 40.0548],
    [-80.7311, 40.0498],
    [-80.7309, 40.0467],
    [-80.7333, 40.0334],
    [-80.7374, 40.0276],
    [-80.7383, 40.0197],
    [-80.7410, 40.0125],
    [-80.7413, 39.9987],
    [-80.7402, 39.9943],
    [-80.7387, 39.9851],
    [-80.7397, 39.9751],
    [-80.7432, 39.9691],
    [-80.7551, 39.9616],
    [-80.7585, 39.9592],
    [-80.7645, 39.9502],
    [-80.7613, 39.9291],
    [-80.7559, 39.9166],
    [-80.7593, 39.9095],
    [-80.7626, 39.9089],
    [-80.7828, 39.9172],
    [-80.8005, 39.9194],
    [-80.8076, 39.9149],
    [-80.8097, 39.9061],
    [-80.8023, 39.8916],
    [-80.7912, 39.8751],
    [-80.7931, 39.8638],
    [-80.8213, 39.8500],
    [-80.8270, 39.8417],
    [-80.8225, 39.8250],
    [-80.8245, 39.8030],
    [-80.8353, 39.7907],
    [-80.8663, 39.7717],
    [-80.8699, 39.7634],
    [-80.8653, 39.7533],
    [-80.8505, 39.7399],
    [-80.8346, 39.7216],
    [-80.8314, 39.7191],
    [-80.8300, 39.7111],
    [-80.8391, 39.7010],
    [-80.8546, 39.6975],
    [-80.8637, 39.6917],
    [-80.8663, 39.6832],
    [-80.8656, 39.6628],
    [-80.8698, 39.6469],
    [-80.8705, 39.6418],
    [-80.8718, 39.6371],
    [-80.8804, 39.6207],
    [-80.8965, 39.6168],
    [-80.9200, 39.6183],
    [-80.9369, 39.6126],
    [-80.9704, 39.5901],
    [-80.9787, 39.5835],
    [-80.9968, 39.5691],
    [-81.0201, 39.5554],
    [-81.0287, 39.5466],
    [-81.0443, 39.5367],
    [-81.0520, 39.5293],
    [-81.0706, 39.5160],
    [-81.0914, 39.4970],
    [-81.1151, 39.4663],
    [-81.1285, 39.4494],
    [-81.1381, 39.4438],
    [-81.1511, 39.4432],
    [-81.1706, 39.4392],
    [-81.1859, 39.4307],
    [-81.1998, 39.4159],
    [-81.2052, 39.4108],
    [-81.2108, 39.4036],
    [-81.2109, 39.3971],
    [-81.2131, 39.3907],
    [-81.2214, 39.3862],
    [-81.2418, 39.3903],
    [-81.2598, 39.3867],
    [-81.2757, 39.3838],
    [-81.2975, 39.3744],
    [-81.3196, 39.3613],
    [-81.3426, 39.3480],
    [-81.3644, 39.3426],
    [-81.3797, 39.3421],
    [-81.3938, 39.3517],
    [-81.4007, 39.3692],
    [-81.4067, 39.3881],
    [-81.4206, 39.4004],
    [-81.4288, 39.4054],
    [-81.4461, 39.4103],
    [-81.4561, 39.4093],
    [-81.4732, 39.4002],
    [-81.4834, 39.3892],
    [-81.5032, 39.3732],
    [-81.5261, 39.3610],
    [-81.5423, 39.3529],
    [-81.5596, 39.3308],
    [-81.5650, 39.2939],
    [-81.5652, 39.2834],
    [-81.5673, 39.2707],
    [-81.5792, 39.2683],
    [-81.5905, 39.2708],
    [-81.6034, 39.2755],
    [-81.6213, 39.2736],
    [-81.6632, 39.2767],
    [-81.6834, 39.2711],
    [-81.6921, 39.2632],
    [-81.6970, 39.2487],
    [-81.6922, 39.2361],
    [-81.6913, 39.2279],
    [-81.6946, 39.2241],
    [-81.7116, 39.2192],
    [-81.7256, 39.2158],
    [-81.7334, 39.2059],
    [-81.7388, 39.1922],
    [-81.7528, 39.1847],
    [-81.7558, 39.1805],
    [-81.7446, 39.1484],
    [-81.7448, 39.1309],
    [-81.7430, 39.1066],
    [-81.7473, 39.0954],
    [-81.7582, 39.0858],
    [-81.7756, 39.0784],
    [-81.7908, 39.0798],
    [-81.8079, 39.0840],
    [-81.8139, 39.0793],
    [-81.8127, 39.0633],
    [-81.8034, 39.0477],
    [-81.7866, 39.0366],
    [-81.7673, 39.0200],
    [-81.7652, 39.0026],
    [-81.7741, 38.9937],
    [-81.7765, 38.9820],
    [-81.7818, 38.9649],
    [-81.7800, 38.9578],
    [-81.7697, 38.9487],
    [-81.7626, 38.9409],
    [-81.7585, 38.9372],
    [-81.7568, 38.9365],
    [-81.7585, 38.9279],
    [-81.7662, 38.9229],
    [-81.7812, 38.9248],
    [-81.7964, 38.9325],
    [-81.8197, 38.9470],
    [-81.8250, 38.9466],
    [-81.8381, 38.9371],
    [-81.8454, 38.9103],
    [-81.8560, 38.8927],
    [-81.8749, 38.8812],
    [-81.8985, 38.8746],
    [-81.9159, 38.8843],
    [-81.9284, 38.8954],
    [-81.9178, 38.9106],
    [-81.9083, 38.9174],
    [-81.8985, 38.9296],
    [-81.9066, 38.9453],
    [-81.9146, 38.9588],
    [-81.9332, 38.9877],
    [-81.9418, 38.9933],
    [-81.9514, 38.9960],
    [-81.9641, 38.9937],
    [-81.9742, 38.9924],
    [-81.9812, 38.9944],
    [-81.9828, 39.0020],
    [-81.9861, 39.0101],
    [-81.9914, 39.0184],
    [-82.0006, 39.0266],
    [-82.0071, 39.0296],
    [-82.0219, 39.0293],
    [-82.0360, 39.0255],
    [-82.0428, 39.0136],
    [-82.0457, 39.0038],
    [-82.0559, 38.9918],
    [-82.0794, 38.9811],
    [-82.0916, 38.9738],
    [-82.0988, 38.9585],
    [-82.1043, 38.9512],
    [-82.1109, 38.9404],
    [-82.1117, 38.9326],
    [-82.1179, 38.9249],
    [-82.1348, 38.9056],
    [-82.1446, 38.8917],
    [-82.1422, 38.8771],
    [-82.1392, 38.8650],
    [-82.1408, 38.8561],
    [-82.1438, 38.8442],
    [-82.1477, 38.8370],
    [-82.1521, 38.8330],
    [-82.1795, 38.8174],
    [-82.1993, 38.8087],
    [-82.2171, 38.7959],
    [-82.2216, 38.7872],
    [-82.2204, 38.7737],
    [-82.2071, 38.7639],
    [-82.1956, 38.7524],
    [-82.1898, 38.7295],
    [-82.1846, 38.7159],
    [-82.1829, 38.7055],
    [-82.1902, 38.6874],
    [-82.1866, 38.6686],
    [-82.1856, 38.6596],
    [-82.1768, 38.6428],
    [-82.1721, 38.6260],
    [-82.1773, 38.6038],
    [-82.1938, 38.5931],
    [-82.2190, 38.5917],
    [-82.2525, 38.5988],
    [-82.2715, 38.5954],
    [-82.2871, 38.5826],
    [-82.2939, 38.5727],
    [-82.2978, 38.5333],
    [-82.3033, 38.5212],
    [-82.3037, 38.5130],
    [-82.3042, 38.4963],
    [-82.3115, 38.4800],
    [-82.3163, 38.4624],
    [-82.3240, 38.4493],
    [-82.3398, 38.4412],
    [-82.3479, 38.4401],
    [-82.3720, 38.4365],
    [-82.3820, 38.4348],
    [-82.3921, 38.4351],
    [-82.4102, 38.4377],
    [-82.4344, 38.4301],
    [-82.4516, 38.4261],
    [-82.4638, 38.4237],
    [-82.4866, 38.4181],
    [-82.5077, 38.4108],
    [-82.5296, 38.4052],
    [-82.5439, 38.4035],
    [-82.5716, 38.4051],
    [-82.5790, 38.4078],
    [-82.5935, 38.4183],
    [-82.5969, 38.4267],
    [-82.6008, 38.4374],
    [-82.6041, 38.4597],
    [-82.6093, 38.4697],
    [-82.6115, 38.4724],
    [-82.6185, 38.4771],
    [-82.6377, 38.4844],
    [-82.6571, 38.4968],
    [-82.6655, 38.5057],
    [-82.6757, 38.5155],
    [-82.6893, 38.5349],
    [-82.6965, 38.5420],
    [-82.7061, 38.5470],
    [-82.7168, 38.5520],
    [-82.7310, 38.5593],
    [-82.7511, 38.5597],
    [-82.7898, 38.5600],
    [-82.8160, 38.5707],
    [-82.8395, 38.5862],
    [-82.8472, 38.5952],
    [-82.8549, 38.6165],
    [-82.8564, 38.6433],
    [-82.8594, 38.6604],
    [-82.8747, 38.6826],
    [-82.8769, 38.6974],
    [-82.8704, 38.7221],
    [-82.8700, 38.7292],
    [-82.8739, 38.7448],
    [-82.8795, 38.7515],
    [-82.8942, 38.7566],
    [-82.9283, 38.7485],
    [-82.9479, 38.7408],
    [-82.9646, 38.7313],
    [-82.9749, 38.7272],
    [-82.9940, 38.7286],
    [-82.9993, 38.7294],
    [-83.0128, 38.7299],
    [-83.0307, 38.7257],
    [-83.0360, 38.7202],
    [-83.0423, 38.7083],
    [-83.0798, 38.6828],
    [-83.1074, 38.6752],
    [-83.1225, 38.6592],
    [-83.1350, 38.6317],
    [-83.1545, 38.6213],
    [-83.1726, 38.6203],
    [-83.2025, 38.6170],
    [-83.2324, 38.6276],
    [-83.2511, 38.6262],
    [-83.2640, 38.6215],
    [-83.2685, 38.6151],
    [-83.2889, 38.5980],
    [-83.3054, 38.5997],
    [-83.3175, 38.6092],
    [-83.3201, 38.6160],
    [-83.3276, 38.6375],
    [-83.3667, 38.6585],
    [-83.3848, 38.6632],
    [-83.4202, 38.6684],
    [-83.4470, 38.6701],
    [-83.4598, 38.6736],
    [-83.4764, 38.6823],
    [-83.5044, 38.6993],
    [-83.5333, 38.7021],
    [-83.5691, 38.6928],
    [-83.5880, 38.6895],
    [-83.5959, 38.6871],
    [-83.6091, 38.6850],
    [-83.6264, 38.6796],
    [-83.6340, 38.6734],
    [-83.6394, 38.6592],
    [-83.6459, 38.6370],
    [-83.6554, 38.6297],
    [-83.6681, 38.6281],
    [-83.7040, 38.6397],
    [-83.7122, 38.6412],
    [-83.7178, 38.6450],
    [-83.7382, 38.6479],
    [-83.7499, 38.6496],
    [-83.7651, 38.6529],
    [-83.7733, 38.6608],
    [-83.7800, 38.6849],
    [-83.7871, 38.6995],
    [-83.8058, 38.7065],
    [-83.8219, 38.7096],
    [-83.8333, 38.7156],
    [-83.8392, 38.7204],
    [-83.8425, 38.7270],
    [-83.8462, 38.7423],
    [-83.8521, 38.7514],
    [-83.8665, 38.7602],
    [-83.9039, 38.7682],
    [-83.9159, 38.7697],
    [-83.9286, 38.7722],
    [-83.9535, 38.7862],
    [-83.9621, 38.7874],
    [-83.9954, 38.7819],
    [-84.0204, 38.7759],
    [-84.0359, 38.7724],
    [-84.0527, 38.7714],
    [-84.0943, 38.7752],
    [-84.1157, 38.7827],
    [-84.1440, 38.7918],
    [-84.1886, 38.7995],
    [-84.2110, 38.8049],
    [-84.2221, 38.8138],
    [-84.2302, 38.8265],
    [-84.2333, 38.8427],
    [-84.2337, 38.8543],
    [-84.2325, 38.8662],
    [-84.2319, 38.8749],
    [-84.2345, 38.8932],
    [-84.2456, 38.9070],
    [-84.2619, 38.9278],
    [-84.2799, 38.9452],
    [-84.2929, 38.9644],
    [-84.2962, 38.9821],
    [-84.2977, 38.9911],
    [-84.3047, 39.0065],
    [-84.3265, 39.0275],
    [-84.3363, 39.0329],
    [-84.3604, 39.0414],
    [-84.3712, 39.0429],
    [-84.3941, 39.0453],
    [-84.4025, 39.0457],
    [-84.4215, 39.0509],
    [-84.4247, 39.0526],
    [-84.4287, 39.0564],
    [-84.4323, 39.0676],
    [-84.4327, 39.0779],
    [-84.4346, 39.0869],
    [-84.4328, 39.0943],
    [-84.4402, 39.1091],
    [-84.4452, 39.1145],
    [-84.4553, 39.1204],
    [-84.4631, 39.1217],
    [-84.4761, 39.1192],
    [-84.4848, 39.1133],
    [-84.4936, 39.1027],
    [-84.4958, 39.1008],
    [-84.5020, 39.0967],
    [-84.5097, 39.0937],
    [-84.5226, 39.0921],
    [-84.5413, 39.0992],
    [-84.5508, 39.0994],
    [-84.5575, 39.0949],
    [-84.5653, 39.0865],
    [-84.5924, 39.0781],
    [-84.6079, 39.0732],
    [-84.6324, 39.0768],
    [-84.6572, 39.0955],
    [-84.6848, 39.1005],
    [-84.6968, 39.1127],
    [-84.7140, 39.1327],
    [-84.7261, 39.1420],
    [-84.7507, 39.1474],
    [-84.7667, 39.1386],
    [-84.7938, 39.1129],
    [-84.8138, 39.1065],
    [-84.8201, 39.1185],
    [-84.8200, 39.1459],
    [-84.8198, 39.1580],
    [-84.8201, 39.2184],
    [-84.8202, 39.2272]
    ]
  },
  "Wisconsin": {
    coordinates: [
      [-92.8881, 45.6284],
    [-92.8879, 45.6390],
    [-92.8871, 45.6441],
    [-92.8840, 45.6549],
    [-92.8769, 45.6753],
    [-92.8700, 45.6973],
    [-92.8697, 45.7151],
    [-92.8626, 45.7222],
    [-92.8505, 45.7244],
    [-92.8431, 45.7292],
    [-92.8307, 45.7331],
    [-92.8166, 45.7420],
    [-92.8053, 45.7475],
    [-92.7986, 45.7537],
    [-92.7814, 45.7731],
    [-92.7774, 45.7878],
    [-92.7684, 45.7980],
    [-92.7578, 45.8066],
    [-92.7609, 45.8166],
    [-92.7649, 45.8249],
    [-92.7617, 45.8339],
    [-92.7456, 45.8415],
    [-92.7366, 45.8574],
    [-92.7340, 45.8681],
    [-92.7077, 45.8949],
    [-92.6862, 45.9028],
    [-92.6757, 45.9075],
    [-92.6704, 45.9162],
    [-92.6561, 45.9244],
    [-92.6401, 45.9325],
    [-92.6388, 45.9342],
    [-92.6277, 45.9327],
    [-92.6108, 45.9366],
    [-92.5901, 45.9418],
    [-92.5698, 45.9481],
    [-92.5519, 45.9517],
    [-92.5507, 45.9608],
    [-92.5457, 45.9701],
    [-92.5271, 45.9832],
    [-92.5195, 45.9839],
    [-92.4910, 45.9756],
    [-92.4728, 45.9730],
    [-92.4613, 45.9794],
    [-92.4642, 45.9824],
    [-92.4645, 45.9850],
    [-92.4534, 45.9929],
    [-92.4516, 46.0004],
    [-92.4444, 46.0118],
    [-92.4286, 46.0242],
    [-92.4106, 46.0273],
    [-92.3927, 46.0195],
    [-92.3649, 46.0134],
    [-92.3580, 46.0134],
    [-92.3500, 46.0170],
    [-92.3493, 46.0236],
    [-92.3437, 46.0285],
    [-92.3435, 46.0430],
    [-92.3382, 46.0521],
    [-92.3298, 46.0652],
    [-92.3166, 46.0700],
    [-92.2986, 46.0730],
    [-92.2935, 46.1138],
    [-92.2937, 46.1667],
    [-92.2936, 46.2246],
    [-92.2931, 46.2951],
    [-92.2928, 46.3071],
    [-92.2928, 46.3193],
    [-92.2930, 46.3322],
    [-92.2927, 46.4320],
    [-92.2920, 46.5040],
    [-92.2917, 46.5953],
    [-92.2917, 46.6341],
    [-92.2922, 46.6633],
    [-92.2874, 46.6673],
    [-92.2837, 46.6588],
    [-92.2728, 46.6528],
    [-92.2597, 46.6571],
    [-92.2356, 46.6500],
    [-92.2235, 46.6526],
    [-92.2071, 46.6519],
    [-92.2016, 46.6567],
    [-92.2055, 46.6647],
    [-92.1925, 46.6767],
    [-92.1814, 46.6802],
    [-92.1765, 46.6902],
    [-92.1985, 46.6961],
    [-92.2047, 46.7040],
    [-92.1933, 46.7112],
    [-92.1789, 46.7167],
    [-92.1673, 46.7199],
    [-92.1463, 46.7159],
    [-92.1434, 46.7281],
    [-92.1253, 46.7449],
    [-92.1074, 46.7491],
    [-92.0648, 46.7313],
    [-92.0247, 46.7056],
    [-92.0111, 46.7055],
    [-91.9762, 46.6877],
    [-91.9619, 46.6825],
    [-91.9318, 46.6813],
    [-91.9196, 46.6833],
    [-91.8667, 46.6915],
    [-91.8403, 46.6897],
    [-91.8147, 46.6910],
    [-91.7819, 46.6976],
    [-91.7489, 46.7093],
    [-91.6963, 46.7232],
    [-91.6455, 46.7347],
    [-91.6139, 46.7464],
    [-91.5743, 46.7575],
    [-91.5514, 46.7557],
    [-91.4997, 46.7612],
    [-91.4493, 46.7733],
    [-91.4334, 46.7805],
    [-91.4237, 46.7822],
    [-91.4094, 46.7938],
    [-91.4017, 46.7922],
    [-91.3910, 46.7903],
    [-91.3854, 46.7919],
    [-91.3688, 46.7938],
    [-91.3383, 46.8177],
    [-91.3148, 46.8268],
    [-91.3011, 46.8304],
    [-91.2887, 46.8334],
    [-91.2753, 46.8326],
    [-91.2508, 46.8411],
    [-91.2208, 46.8657],
    [-91.1927, 46.8799],
    [-91.1797, 46.8857],
    [-91.1896, 46.8763],
    [-91.2008, 46.8631],
    [-91.1903, 46.8484],
    [-91.1751, 46.8444],
    [-91.1660, 46.8482],
    [-91.1600, 46.8552],
    [-91.1479, 46.8628],
    [-91.1402, 46.8732],
    [-91.1349, 46.8658],
    [-91.1350, 46.8590],
    [-91.1347, 46.8589],
    [-91.1135, 46.8566],
    [-91.0937, 46.8799],
    [-91.0887, 46.8829],
    [-91.0739, 46.8815],
    [-91.0610, 46.8793],
    [-91.0399, 46.8892],
    [-91.0345, 46.9031],
    [-91.0191, 46.9115],
    [-91.0052, 46.9162],
    [-90.9940, 46.9185],
    [-90.9684, 46.9439],
    [-90.9546, 46.9385],
    [-90.9429, 46.9360],
    [-90.9218, 46.9313],
    [-90.9086, 46.9413],
    [-90.8833, 46.9498],
    [-90.8711, 46.9611],
    [-90.8508, 46.9603],
    [-90.8377, 46.9574],
    [-90.8306, 46.9415],
    [-90.8150, 46.9310],
    [-90.7998, 46.9374],
    [-90.7830, 46.9206],
    [-90.7727, 46.9079],
    [-90.7509, 46.8930],
    [-90.7616, 46.8832],
    [-90.7692, 46.8839],
    [-90.7702, 46.8763],
    [-90.7811, 46.8589],
    [-90.7859, 46.8544],
    [-90.7883, 46.8457],
    [-90.7894, 46.8386],
    [-90.7942, 46.8307],
    [-90.8014, 46.8214],
    [-90.8093, 46.8157],
    [-90.8214, 46.8070],
    [-90.8281, 46.7974],
    [-90.8507, 46.7902],
    [-90.8598, 46.7850],
    [-90.8597, 46.7744],
    [-90.8609, 46.7711],
    [-90.8666, 46.7644],
    [-90.8761, 46.7602],
    [-90.8853, 46.7523],
    [-90.8704, 46.7233],
    [-90.8527, 46.6996],
    [-90.8639, 46.6857],
    [-90.8726, 46.6780],
    [-90.8821, 46.6735],
    [-90.8859, 46.6704],
    [-90.8879, 46.6672],
    [-90.9050, 46.6652],
    [-90.9113, 46.6631],
    [-90.9152, 46.6584],
    [-90.9162, 46.6433],
    [-90.9218, 46.6285],
    [-90.9290, 46.6181],
    [-90.9496, 46.6030],
    [-90.9478, 46.5957],
    [-90.9451, 46.5890],
    [-90.9304, 46.5862],
    [-90.9183, 46.5831],
    [-90.9056, 46.5835],
    [-90.8951, 46.5921],
    [-90.8882, 46.5958],
    [-90.8833, 46.5982],
    [-90.8753, 46.6019],
    [-90.8682, 46.6024],
    [-90.8229, 46.6193],
    [-90.8024, 46.6234],
    [-90.7702, 46.6361],
    [-90.7553, 46.6463],
    [-90.7395, 46.6597],
    [-90.7617, 46.6617],
    [-90.7317, 46.6692],
    [-90.7201, 46.6764],
    [-90.7479, 46.6970],
    [-90.7619, 46.7052],
    [-90.7709, 46.7137],
    [-90.7883, 46.7262],
    [-90.8078, 46.7317],
    [-90.7844, 46.7294],
    [-90.7621, 46.7102],
    [-90.7500, 46.7015],
    [-90.7054, 46.6714],
    [-90.5862, 46.5999],
    [-90.5581, 46.5864],
    [-90.5385, 46.5812],
    [-90.5278, 46.5859],
    [-90.5128, 46.5900],
    [-90.4974, 46.5855],
    [-90.4738, 46.5742],
    [-90.4376, 46.5615],
    [-90.4156, 46.5632],
    [-90.4107, 46.5551],
    [-90.4078, 46.5522],
    [-90.4020, 46.5444],
    [-90.4000, 46.5444],
    [-90.3949, 46.5358],
    [-90.3921, 46.5348],
    [-90.3953, 46.5339],
    [-90.3913, 46.5334],
    [-90.3860, 46.5338],
    [-90.3803, 46.5367],
    [-90.3762, 46.5382],
    [-90.3700, 46.5405],
    [-90.3662, 46.5397],
    [-90.3624, 46.5412],
    [-90.3597, 46.5394],
    [-90.3555, 46.5394],
    [-90.3484, 46.5418],
    [-90.3458, 46.5451],
    [-90.3477, 46.5478],
    [-90.3436, 46.5481],
    [-90.3407, 46.5481],
    [-90.3417, 46.5503],
    [-90.3443, 46.5521],
    [-90.3369, 46.5541],
    [-90.3317, 46.5527],
    [-90.3293, 46.5506],
    [-90.3275, 46.5503],
    [-90.3247, 46.5456],
    [-90.3204, 46.5463],
    [-90.3172, 46.5451],
    [-90.3163, 46.5409],
    [-90.3104, 46.5371],
    [-90.3106, 46.5326],
    [-90.3119, 46.5287],
    [-90.3171, 46.5201],
    [-90.3138, 46.5162],
    [-90.3085, 46.5168],
    [-90.3066, 46.5185],
    [-90.2967, 46.5191],
    [-90.2943, 46.5199],
    [-90.2929, 46.5210],
    [-90.2817, 46.5206],
    [-90.2784, 46.5238],
    [-90.2720, 46.5198],
    [-90.2751, 46.5184],
    [-90.2768, 46.5145],
    [-90.2704, 46.5117],
    [-90.2726, 46.5091],
    [-90.2717, 46.5047],
    [-90.2666, 46.5079],
    [-90.2653, 46.5038],
    [-90.2587, 46.5035],
    [-90.2482, 46.5054],
    [-90.2363, 46.5071],
    [-90.2294, 46.5080],
    [-90.2303, 46.5017],
    [-90.2205, 46.5034],
    [-90.2148, 46.4982],
    [-90.2122, 46.4915],
    [-90.2086, 46.4866],
    [-90.2056, 46.4807],
    [-90.2017, 46.4761],
    [-90.1934, 46.4725],
    [-90.1907, 46.4686],
    [-90.1894, 46.4670],
    [-90.1921, 46.4655],
    [-90.1894, 46.4588],
    [-90.1828, 46.4574],
    [-90.1814, 46.4584],
    [-90.1781, 46.4558],
    [-90.1791, 46.4522],
    [-90.1769, 46.4486],
    [-90.1779, 46.4402],
    [-90.1746, 46.4397],
    [-90.1693, 46.4399],
    [-90.1669, 46.4399],
    [-90.1634, 46.4346],
    [-90.1624, 46.4304],
    [-90.1603, 46.4266],
    [-90.1586, 46.4227],
    [-90.1577, 46.4157],
    [-90.1588, 46.4133],
    [-90.1540, 46.4067],
    [-90.1541, 46.4031],
    [-90.1483, 46.3993],
    [-90.1476, 46.3965],
    [-90.1444, 46.3922],
    [-90.1439, 46.3897],
    [-90.1414, 46.3875],
    [-90.1375, 46.3842],
    [-90.1322, 46.3812],
    [-90.1336, 46.3778],
    [-90.1339, 46.3718],
    [-90.1310, 46.3692],
    [-90.1228, 46.3626],
    [-90.1210, 46.3597],
    [-90.1188, 46.3592],
    [-90.1167, 46.3507],
    [-90.1202, 46.3496],
    [-90.1235, 46.3465],
    [-90.1202, 46.3451],
    [-90.1180, 46.3414],
    [-90.1211, 46.3387],
    [-90.1205, 46.3369],
    [-89.9292, 46.2997],
    [-89.9082, 46.2960],
    [-89.7407, 46.2636],
    [-89.6676, 46.2498],
    [-89.5338, 46.2241],
    [-89.3860, 46.1952],
    [-89.2769, 46.1741],
    [-89.2182, 46.1630],
    [-89.2033, 46.1600],
    [-89.1799, 46.1553],
    [-89.1251, 46.1445],
    [-88.9909, 46.0973],
    [-88.9433, 46.0779],
    [-88.8485, 46.0389],
    [-88.8440, 46.0348],
    [-88.8415, 46.0324],
    [-88.8370, 46.0305],
    [-88.8270, 46.0281],
    [-88.8191, 46.0263],
    [-88.8154, 46.0230],
    [-88.8160, 46.0206],
    [-88.8097, 46.0221],
    [-88.8018, 46.0237],
    [-88.7958, 46.0249],
    [-88.7962, 46.0337],
    [-88.7896, 46.0289],
    [-88.7863, 46.0309],
    [-88.7786, 46.0313],
    [-88.7840, 46.0230],
    [-88.7802, 46.0154],
    [-88.7729, 46.0181],
    [-88.7688, 46.0219],
    [-88.7700, 46.0257],
    [-88.7648, 46.0227],
    [-88.7586, 46.0195],
    [-88.7522, 46.0236],
    [-88.7464, 46.0258],
    [-88.7400, 46.0273],
    [-88.7347, 46.0257],
    [-88.7307, 46.0265],
    [-88.7211, 46.0220],
    [-88.7200, 46.0161],
    [-88.7188, 46.0141],
    [-88.7123, 46.0162],
    [-88.7100, 46.0154],
    [-88.7074, 46.0164],
    [-88.6987, 46.0179],
    [-88.6948, 46.0163],
    [-88.6887, 46.0141],
    [-88.6833, 46.0141],
    [-88.6776, 46.0125],
    [-88.6746, 46.0106],
    [-88.6742, 46.0076],
    [-88.6712, 46.0047],
    [-88.6702, 46.0006],
    [-88.6697, 45.9979],
    [-88.6668, 45.9961],
    [-88.6666, 45.9935],
    [-88.6636, 45.9924],
    [-88.6708, 45.9885],
    [-88.6645, 45.9890],
    [-88.6634, 45.9877],
    [-88.6578, 45.9893],
    [-88.6524, 45.9877],
    [-88.6479, 45.9887],
    [-88.6449, 45.9869],
    [-88.6348, 45.9857],
    [-88.6278, 45.9884],
    [-88.6239, 45.9886],
    [-88.6142, 45.9888],
    [-88.6159, 45.9933],
    [-88.6148, 45.9958],
    [-88.6120, 46.0011],
    [-88.6113, 46.0057],
    [-88.6069, 46.0085],
    [-88.6040, 46.0162],
    [-88.5957, 46.0158],
    [-88.5929, 46.0116],
    [-88.5898, 46.0056],
    [-88.5785, 46.0098],
    [-88.5716, 46.0138],
    [-88.5607, 46.0143],
    [-88.5567, 46.0148],
    [-88.5486, 46.0132],
    [-88.5411, 46.0138],
    [-88.5349, 46.0181],
    [-88.5335, 46.0199],
    [-88.5301, 46.0205],
    [-88.5170, 46.0200],
    [-88.5072, 46.0183],
    [-88.5065, 46.0111],
    [-88.5024, 46.0055],
    [-88.4988, 46.0004],
    [-88.4969, 45.9983],
    [-88.4954, 45.9944],
    [-88.4929, 45.9931],
    [-88.4868, 45.9909],
    [-88.4804, 45.9916],
    [-88.4745, 45.9936],
    [-88.4752, 45.9966],
    [-88.4655, 46.0007],
    [-88.4613, 45.9996],
    [-88.4538, 45.9970],
    [-88.4503, 45.9902],
    [-88.4407, 45.9908],
    [-88.4388, 45.9887],
    [-88.4337, 45.9870],
    [-88.4322, 45.9853],
    [-88.4261, 45.9841],
    [-88.4230, 45.9785],
    [-88.4148, 45.9755],
    [-88.4028, 45.9812],
    [-88.3879, 45.9832],
    [-88.3852, 45.9902],
    [-88.3802, 45.9917],
    [-88.3737, 45.9886],
    [-88.3714, 45.9854],
    [-88.3593, 45.9815],
    [-88.3548, 45.9791],
    [-88.3509, 45.9772],
    [-88.3475, 45.9744],
    [-88.3426, 45.9699],
    [-88.3388, 45.9696],
    [-88.3301, 45.9660],
    [-88.3303, 45.9566],
    [-88.3255, 45.9564],
    [-88.3205, 45.9600],
    [-88.3197, 45.9636],
    [-88.3169, 45.9610],
    [-88.3057, 45.9575],
    [-88.2953, 45.9513],
    [-88.2863, 45.9547],
    [-88.2736, 45.9566],
    [-88.2617, 45.9593],
    [-88.2548, 45.9635],
    [-88.2463, 45.9634],
    [-88.2466, 45.9566],
    [-88.2425, 45.9504],
    [-88.2302, 45.9473],
    [-88.2222, 45.9485],
    [-88.2092, 45.9477],
    [-88.2021, 45.9498],
    [-88.1976, 45.9531],
    [-88.1920, 45.9527],
    [-88.1862, 45.9493],
    [-88.1780, 45.9471],
    [-88.1701, 45.9395],
    [-88.1632, 45.9400],
    [-88.1588, 45.9392],
    [-88.1517, 45.9369],
    [-88.1462, 45.9368],
    [-88.1459, 45.9336],
    [-88.1338, 45.9286],
    [-88.1264, 45.9256],
    [-88.1276, 45.9224],
    [-88.1219, 45.9207],
    [-88.1153, 45.9222],
    [-88.1029, 45.9219],
    [-88.0950, 45.9147],
    [-88.1020, 45.9106],
    [-88.1057, 45.9044],
    [-88.1060, 45.8971],
    [-88.1025, 45.8922],
    [-88.0983, 45.8803],
    [-88.0849, 45.8807],
    [-88.0782, 45.8774],
    [-88.0711, 45.8746],
    [-88.0720, 45.8721],
    [-88.0756, 45.8699],
    [-88.0744, 45.8660],
    [-88.0816, 45.8651],
    [-88.0874, 45.8575],
    [-88.1066, 45.8411],
    [-88.1136, 45.8377],
    [-88.1239, 45.8300],
    [-88.1336, 45.8231],
    [-88.1361, 45.8190],
    [-88.1318, 45.8113],
    [-88.1208, 45.8063],
    [-88.1095, 45.8036],
    [-88.1054, 45.8001],
    [-88.1057, 45.7964],
    [-88.1032, 45.7914],
    [-88.0940, 45.7857],
    [-88.0826, 45.7853],
    [-88.0784, 45.7842],
    [-88.0706, 45.7799],
    [-88.0506, 45.7810],
    [-88.0454, 45.7830],
    [-88.0405, 45.7851],
    [-88.0402, 45.7892],
    [-88.0311, 45.7892],
    [-88.0193, 45.7918],
    [-88.0059, 45.7926],
    [-87.9934, 45.7956],
    [-87.9885, 45.7936],
    [-87.9809, 45.7770],
    [-87.9834, 45.7747],
    [-87.9898, 45.7729],
    [-87.9864, 45.7696],
    [-87.9725, 45.7663],
    [-87.9647, 45.7595],
    [-87.9545, 45.7584],
    [-87.9455, 45.7567],
    [-87.9384, 45.7581],
    [-87.9266, 45.7596],
    [-87.9200, 45.7574],
    [-87.9154, 45.7592],
    [-87.9100, 45.7567],
    [-87.9059, 45.7594],
    [-87.9013, 45.7566],
    [-87.8960, 45.7523],
    [-87.8823, 45.7548],
    [-87.8758, 45.7539],
    [-87.8694, 45.7497],
    [-87.8641, 45.7457],
    [-87.8619, 45.7434],
    [-87.8635, 45.7416],
    [-87.8533, 45.7260],
    [-87.8433, 45.7202],
    [-87.8279, 45.7147],
    [-87.8224, 45.7127],
    [-87.8101, 45.7102],
    [-87.8051, 45.7036],
    [-87.8060, 45.6974],
    [-87.7877, 45.6872],
    [-87.7808, 45.6803],
    [-87.7816, 45.6733],
    [-87.7989, 45.6701],
    [-87.8033, 45.6665],
    [-87.8166, 45.6639],
    [-87.8239, 45.6619],
    [-87.8237, 45.6598],
    [-87.8247, 45.6532],
    [-87.8173, 45.6439],
    [-87.7996, 45.6258],
    [-87.7959, 45.6188],
    [-87.7829, 45.6153],
    [-87.7777, 45.6092],
    [-87.7776, 45.6040],
    [-87.7759, 45.6000],
    [-87.7775, 45.5938],
    [-87.7813, 45.5857],
    [-87.7875, 45.5814],
    [-87.7873, 45.5749],
    [-87.7888, 45.5659],
    [-87.7947, 45.5624],
    [-87.8082, 45.5637],
    [-87.8137, 45.5652],
    [-87.8293, 45.5688],
    [-87.8327, 45.5634],
    [-87.8323, 45.5588],
    [-87.8171, 45.5495],
    [-87.8072, 45.5435],
    [-87.8034, 45.5383],
    [-87.8047, 45.5312],
    [-87.8023, 45.5142],
    [-87.7932, 45.5050],
    [-87.7946, 45.4974],
    [-87.7982, 45.4933],
    [-87.7990, 45.4851],
    [-87.8059, 45.4744],
    [-87.8130, 45.4661],
    [-87.8156, 45.4628],
    [-87.8198, 45.4606],
    [-87.8255, 45.4580],
    [-87.8312, 45.4572],
    [-87.8330, 45.4536],
    [-87.8448, 45.4484],
    [-87.8566, 45.4400],
    [-87.8601, 45.4356],
    [-87.8601, 45.4296],
    [-87.8580, 45.4211],
    [-87.8572, 45.4179],
    [-87.8518, 45.4131],
    [-87.8493, 45.4039],
    [-87.8591, 45.3990],
    [-87.8568, 45.3931],
    [-87.8647, 45.3852],
    [-87.8754, 45.3794],
    [-87.8716, 45.3735],
    [-87.8769, 45.3685],
    [-87.8830, 45.3640],
    [-87.8878, 45.3581],
    [-87.8852, 45.3517],
    [-87.8775, 45.3528],
    [-87.8704, 45.3563],
    [-87.8712, 45.3601],
    [-87.8751, 45.3659],
    [-87.8682, 45.3654],
    [-87.8657, 45.3582],
    [-87.8635, 45.3530],
    [-87.8528, 45.3495],
    [-87.8515, 45.3423],
    [-87.8484, 45.3407],
    [-87.8353, 45.3510],
    [-87.8269, 45.3505],
    [-87.8230, 45.3526],
    [-87.8005, 45.3536],
    [-87.7831, 45.3497],
    [-87.7714, 45.3512],
    [-87.7541, 45.3494],
    [-87.7509, 45.3550],
    [-87.7385, 45.3572],
    [-87.7334, 45.3644],
    [-87.7083, 45.3812],
    [-87.6998, 45.3879],
    [-87.6903, 45.3898],
    [-87.6765, 45.3832],
    [-87.6744, 45.3781],
    [-87.6573, 45.3688],
    [-87.6558, 45.3627],
    [-87.6507, 45.3538],
    [-87.6481, 45.3479],
    [-87.6482, 45.3433],
    [-87.6490, 45.3382],
    [-87.6558, 45.3308],
    [-87.6620, 45.3264],
    [-87.6637, 45.3183],
    [-87.6694, 45.3134],
    [-87.6719, 45.3082],
    [-87.6791, 45.3058],
    [-87.6840, 45.3013],
    [-87.6902, 45.2906],
    [-87.6935, 45.2877],
    [-87.6982, 45.2815],
    [-87.6995, 45.2767],
    [-87.6988, 45.2694],
    [-87.7058, 45.2659],
    [-87.7104, 45.2593],
    [-87.7089, 45.2571],
    [-87.7112, 45.2511],
    [-87.7102, 45.2477],
    [-87.7122, 45.2390],
    [-87.7183, 45.2383],
    [-87.7252, 45.2315],
    [-87.7214, 45.2268],
    [-87.7273, 45.2161],
    [-87.7280, 45.2080],
    [-87.7395, 45.2021],
    [-87.7418, 45.1971],
    [-87.7391, 45.1924],
    [-87.7377, 45.1838],
    [-87.7365, 45.1734],
    [-87.7309, 45.1709],
    [-87.7231, 45.1651],
    [-87.7101, 45.1590],
    [-87.7074, 45.1547],
    [-87.6951, 45.1505],
    [-87.6839, 45.1441],
    [-87.6774, 45.1368],
    [-87.6785, 45.1312],
    [-87.6745, 45.1266],
    [-87.6710, 45.1201],
    [-87.6644, 45.1156],
    [-87.6612, 45.1091],
    [-87.6571, 45.1076],
    [-87.6482, 45.1064],
    [-87.6358, 45.1060],
    [-87.6315, 45.1062],
    [-87.6276, 45.1033],
    [-87.6192, 45.1016],
    [-87.5939, 45.0952],
    [-87.5913, 45.0925],
    [-87.5867, 45.0872],
    [-87.5806, 45.0793],
    [-87.5770, 45.0689],
    [-87.5898, 45.0759],
    [-87.5941, 45.0822],
    [-87.6020, 45.0822],
    [-87.6109, 45.0747],
    [-87.6196, 45.0574],
    [-87.6257, 45.0447],
    [-87.6302, 44.9775],
    [-87.6541, 44.9743],
    [-87.6556, 44.9718],
    [-87.6718, 44.9747],
    [-87.7116, 44.9723],
    [-87.7296, 44.9700],
    [-87.7448, 44.9681],
    [-87.7662, 44.9653],
    [-87.7711, 44.9642],
    [-87.8130, 44.9540],
    [-87.8236, 44.9448],
    [-87.8330, 44.9355],
    [-87.8434, 44.9244],
    [-87.8427, 44.9121],
    [-87.8396, 44.9056],
    [-87.8298, 44.8959],
    [-87.8278, 44.8912],
    [-87.8318, 44.8829],
    [-87.8338, 44.8806],
    [-87.8383, 44.8790],
    [-87.8384, 44.8740],
    [-87.8483, 44.8704],
    [-87.8547, 44.8578],
    [-87.8627, 44.8485],
    [-87.8658, 44.8415],
    [-87.8739, 44.8400],
    [-87.8804, 44.8379],
    [-87.8956, 44.8295],
    [-87.9018, 44.8222],
    [-87.9059, 44.8159],
    [-87.9125, 44.8034],
    [-87.9171, 44.7995],
    [-87.9268, 44.7786],
    [-87.9397, 44.7642],
    [-87.9412, 44.7613],
    [-87.9431, 44.7579],
    [-87.9558, 44.7500],
    [-87.9667, 44.7418],
    [-87.9759, 44.7275],
    [-87.9841, 44.7170],
    [-87.9865, 44.7042],
    [-87.9874, 44.6953],
    [-87.9896, 44.6861],
    [-87.9868, 44.6731],
    [-87.9824, 44.6630],
    [-87.9770, 44.6533],
    [-87.9863, 44.6630],
    [-87.9920, 44.6725],
    [-87.9954, 44.6733],
    [-88.0021, 44.6640],
    [-88.0048, 44.6451],
    [-88.0095, 44.6304],
    [-87.9831, 44.6001],
    [-87.9788, 44.5920],
    [-87.9805, 44.5864],
    [-87.9855, 44.5967],
    [-88.0038, 44.6099],
    [-88.0134, 44.6137],
    [-88.0164, 44.5921],
    [-88.0149, 44.5855],
    [-88.0271, 44.5790],
    [-88.0412, 44.5726],
    [-88.0424, 44.5666],
    [-88.0377, 44.5605],
    [-88.0313, 44.5595],
    [-88.0150, 44.5466],
    [-88.0001, 44.5403],
    [-87.9935, 44.5373],
    [-87.9816, 44.5391],
    [-87.9813, 44.5332],
    [-87.9438, 44.5297],
    [-87.9357, 44.5331],
    [-87.9231, 44.5436],
    [-87.9012, 44.5689],
    [-87.9042, 44.5783],
    [-87.9101, 44.5804],
    [-87.8941, 44.5876],
    [-87.8909, 44.5896],
    [-87.8817, 44.5978],
    [-87.8696, 44.6063],
    [-87.8578, 44.6190],
    [-87.8407, 44.6187],
    [-87.8088, 44.6363],
    [-87.7937, 44.6383],
    [-87.7624, 44.6445],
    [-87.7509, 44.6562],
    [-87.7484, 44.6671],
    [-87.7198, 44.6932],
    [-87.7218, 44.7190],
    [-87.7074, 44.7338],
    [-87.6863, 44.7615],
    [-87.6675, 44.7760],
    [-87.6611, 44.7885],
    [-87.6371, 44.8136],
    [-87.6149, 44.8350],
    [-87.5934, 44.8430],
    [-87.5813, 44.8518],
    [-87.5713, 44.8530],
    [-87.5500, 44.8499],
    [-87.5553, 44.8455],
    [-87.5598, 44.8441],
    [-87.5657, 44.8301],
    [-87.5574, 44.8296],
    [-87.5567, 44.8249],
    [-87.5419, 44.8323],
    [-87.5334, 44.8495],
    [-87.5310, 44.8574],
    [-87.5189, 44.8508],
    [-87.5041, 44.8562],
    [-87.5108, 44.8625],
    [-87.5188, 44.8720],
    [-87.5073, 44.8680],
    [-87.4984, 44.8623],
    [-87.4856, 44.8546],
    [-87.4785, 44.8636],
    [-87.4575, 44.8794],
    [-87.4424, 44.8899],
    [-87.4203, 44.8876],
    [-87.4364, 44.8876],
    [-87.4326, 44.8803],
    [-87.4200, 44.8759],
    [-87.4055, 44.8600],
    [-87.4000, 44.8500],
    [-87.3933, 44.8382],
    [-87.3822, 44.8343],
    [-87.3870, 44.8443],
    [-87.3834, 44.8530],
    [-87.3848, 44.8655],
    [-87.3836, 44.8851],
    [-87.4062, 44.9045],
    [-87.3952, 44.9207],
    [-87.3984, 44.9252],
    [-87.3873, 44.9394],
    [-87.3603, 44.9876],
    [-87.3450, 45.0033],
    [-87.3401, 45.0133],
    [-87.3266, 45.0258],
    [-87.3218, 45.0322],
    [-87.3190, 45.0395],
    [-87.3071, 45.0509],
    [-87.2988, 45.0537],
    [-87.2874, 45.0458],
    [-87.2824, 45.0576],
    [-87.2824, 45.0696],
    [-87.2771, 45.0773],
    [-87.2700, 45.0772],
    [-87.2617, 45.0863],
    [-87.2601, 45.1132],
    [-87.2482, 45.1328],
    [-87.2413, 45.1348],
    [-87.2429, 45.1494],
    [-87.2394, 45.1592],
    [-87.2346, 45.1651],
    [-87.2370, 45.1694],
    [-87.2208, 45.1725],
    [-87.2144, 45.1657],
    [-87.1990, 45.1639],
    [-87.1915, 45.1565],
    [-87.1726, 45.1513],
    [-87.1728, 45.1634],
    [-87.1632, 45.1853],
    [-87.1532, 45.1857],
    [-87.1512, 45.1849],
    [-87.1491, 45.1889],
    [-87.1433, 45.1921],
    [-87.1330, 45.1928],
    [-87.1200, 45.1911],
    [-87.1216, 45.2098],
    [-87.1164, 45.2415],
    [-87.1100, 45.2537],
    [-87.0997, 45.2596],
    [-87.0920, 45.2558],
    [-87.0787, 45.2528],
    [-87.0756, 45.2580],
    [-87.0737, 45.2721],
    [-87.0710, 45.2804],
    [-87.0674, 45.2958],
    [-87.0576, 45.2928],
    [-87.0439, 45.2848],
    [-87.0348, 45.2880],
    [-87.0221, 45.2875],
    [-87.0201, 45.2978],
    [-87.0122, 45.2959],
    [-87.0024, 45.2951],
    [-86.9941, 45.2981],
    [-86.9778, 45.2907],
    [-86.9745, 45.2718],
    [-86.9827, 45.2491],
    [-86.9734, 45.2433],
    [-86.9851, 45.2380],
    [-86.9788, 45.2273],
    [-86.9814, 45.2177],
    [-86.9960, 45.2127],
    [-87.0075, 45.2221],
    [-87.0243, 45.2328],
    [-87.0325, 45.2223],
    [-87.0409, 45.2115],
    [-87.0398, 45.1918],
    [-87.0430, 45.1604],
    [-87.0331, 45.1418],
    [-87.0509, 45.1364],
    [-87.0564, 45.1477],
    [-87.0709, 45.1530],
    [-87.0773, 45.1358],
    [-87.0706, 45.1267],
    [-87.0543, 45.1200],
    [-87.0488, 45.1057],
    [-87.0471, 45.0940],
    [-87.0523, 45.0896],
    [-87.0620, 45.0809],
    [-87.0680, 45.0796],
    [-87.0811, 45.0925],
    [-87.0963, 45.0871],
    [-87.0849, 45.0792],
    [-87.0796, 45.0708],
    [-87.0872, 45.0561],
    [-87.0980, 45.0603],
    [-87.1096, 45.0712],
    [-87.1229, 45.0662],
    [-87.1223, 45.0627],
    [-87.1212, 45.0583],
    [-87.1248, 45.0422],
    [-87.1325, 45.0259],
    [-87.1501, 45.0100],
    [-87.1685, 44.9983],
    [-87.1841, 44.9759],
    [-87.1884, 44.9481],
    [-87.1752, 44.9398],
    [-87.1717, 44.9315],
    [-87.1829, 44.9266],
    [-87.2124, 44.9111],
    [-87.2127, 44.8938],
    [-87.2045, 44.8756],
    [-87.2242, 44.8684],
    [-87.2497, 44.8551],
    [-87.2670, 44.8472],
    [-87.2751, 44.8352],
    [-87.2810, 44.8170],
    [-87.2919, 44.8116],
    [-87.3060, 44.7995],
    [-87.3131, 44.7937],
    [-87.3142, 44.7922],
    [-87.3211, 44.7813],
    [-87.3212, 44.7673],
    [-87.3352, 44.7497],
    [-87.3435, 44.7192],
    [-87.3538, 44.7019],
    [-87.3624, 44.6906],
    [-87.3750, 44.6755],
    [-87.3785, 44.6688],
    [-87.3822, 44.6586],
    [-87.3907, 44.6471],
    [-87.4016, 44.6312],
    [-87.4054, 44.6272],
    [-87.4187, 44.6195],
    [-87.4209, 44.6149],
    [-87.4331, 44.6082],
    [-87.4394, 44.6013],
    [-87.4470, 44.5863],
    [-87.4681, 44.5519],
    [-87.4732, 44.5395],
    [-87.4837, 44.5114],
    [-87.4875, 44.4912],
    [-87.4941, 44.4700],
    [-87.4945, 44.4638],
    [-87.4978, 44.4622],
    [-87.4982, 44.4595],
    [-87.5004, 44.4562],
    [-87.5023, 44.4427],
    [-87.5064, 44.4238],
    [-87.5116, 44.4140],
    [-87.5175, 44.3955],
    [-87.5176, 44.3757],
    [-87.5281, 44.3593],
    [-87.5351, 44.3464],
    [-87.5409, 44.3327],
    [-87.5454, 44.3214],
    [-87.5412, 44.2931],
    [-87.5363, 44.2839],
    [-87.5217, 44.2598],
    [-87.5084, 44.2297],
    [-87.5197, 44.1799],
    [-87.5496, 44.1536],
    [-87.5618, 44.1452],
    [-87.5628, 44.1445],
    [-87.5705, 44.1418],
    [-87.5970, 44.1330],
    [-87.6165, 44.1241],
    [-87.6315, 44.1156],
    [-87.6459, 44.1052],
    [-87.6467, 44.1045],
    [-87.6483, 44.1015],
    [-87.6511, 44.0964],
    [-87.6511, 44.0924],
    [-87.6498, 44.0888],
    [-87.6557, 44.0777],
    [-87.6535, 44.0672],
    [-87.6540, 44.0580],
    [-87.6593, 44.0487],
    [-87.6776, 44.0298],
    [-87.6834, 44.0201],
    [-87.6970, 43.9795],
    [-87.7015, 43.9606],
    [-87.7119, 43.9492],
    [-87.7190, 43.9378],
    [-87.7204, 43.9316],
    [-87.7240, 43.9151],
    [-87.7261, 43.9108],
    [-87.7337, 43.8863],
    [-87.7362, 43.8804],
    [-87.7360, 43.8737],
    [-87.7287, 43.8517],
    [-87.7290, 43.8376],
    [-87.7293, 43.8279],
    [-87.7262, 43.8166],
    [-87.7238, 43.8057],
    [-87.7153, 43.7905],
    [-87.7086, 43.7803],
    [-87.7003, 43.7674],
    [-87.6975, 43.7650],
    [-87.7001, 43.7614],
    [-87.7036, 43.7550],
    [-87.6983, 43.7527],
    [-87.7034, 43.7488],
    [-87.7063, 43.7443],
    [-87.7099, 43.7355],
    [-87.7096, 43.7297],
    [-87.7082, 43.7229],
    [-87.7030, 43.7064],
    [-87.7043, 43.6948],
    [-87.7062, 43.6795],
    [-87.7222, 43.6565],
    [-87.7421, 43.6295],
    [-87.7813, 43.5785],
    [-87.7901, 43.5631],
    [-87.7918, 43.5440],
    [-87.7941, 43.5247],
    [-87.7935, 43.5000],
    [-87.8009, 43.4744],
    [-87.8040, 43.4634],
    [-87.8119, 43.4546],
    [-87.8273, 43.4348],
    [-87.8650, 43.3936],
    [-87.8644, 43.3890],
    [-87.8659, 43.3844],
    [-87.8728, 43.3796],
    [-87.8775, 43.3689],
    [-87.8843, 43.3398],
    [-87.8862, 43.3208],
    [-87.8918, 43.3018],
    [-87.9031, 43.2800],
    [-87.9118, 43.2505],
    [-87.9118, 43.2502],
    [-87.9101, 43.2359],
    [-87.8994, 43.2180],
    [-87.8958, 43.2088],
    [-87.8963, 43.1971],
    [-87.8880, 43.1871],
    [-87.8815, 43.1697],
    [-87.8891, 43.1545],
    [-87.9003, 43.1373],
    [-87.9005, 43.1259],
    [-87.8945, 43.1157],
    [-87.8761, 43.0990],
    [-87.8708, 43.0867],
    [-87.8701, 43.0819],
    [-87.8687, 43.0781],
    [-87.8641, 43.0743],
    [-87.8755, 43.0585],
    [-87.8828, 43.0510],
    [-87.8867, 43.0520],
    [-87.8880, 43.0448],
    [-87.8860, 43.0442],
    [-87.8967, 43.0378],
    [-87.8970, 43.0366],
    [-87.8958, 43.0302],
    [-87.8939, 43.0315],
    [-87.8959, 43.0260],
    [-87.8987, 43.0257],
    [-87.8975, 43.0201],
    [-87.8845, 43.0048],
    [-87.8874, 43.0027],
    [-87.8870, 43.0012],
    [-87.8812, 42.9951],
    [-87.8713, 42.9881],
    [-87.8646, 42.9841],
    [-87.8500, 42.9707],
    [-87.8450, 42.9611],
    [-87.8434, 42.9488],
    [-87.8459, 42.9321],
    [-87.8440, 42.9218],
    [-87.8429, 42.9068],
    [-87.8478, 42.8963],
    [-87.8468, 42.8909],
    [-87.8437, 42.8853],
    [-87.8435, 42.8733],
    [-87.8389, 42.8652],
    [-87.8284, 42.8459],
    [-87.8124, 42.8223],
    [-87.7941, 42.8063],
    [-87.7790, 42.7968],
    [-87.7737, 42.7935],
    [-87.7579, 42.7821],
    [-87.7593, 42.7792],
    [-87.7646, 42.7774],
    [-87.7754, 42.7672],
    [-87.7782, 42.7628],
    [-87.7795, 42.7581],
    [-87.7817, 42.7501],
    [-87.7797, 42.7403],
    [-87.7785, 42.7370],
    [-87.7777, 42.7336],
    [-87.7777, 42.7335],
    [-87.7786, 42.7273],
    [-87.7780, 42.7189],
    [-87.7808, 42.7180],
    [-87.7826, 42.7075],
    [-87.7868, 42.7007],
    [-87.7900, 42.6950],
    [-87.7952, 42.6892],
    [-87.7976, 42.6834],
    [-87.8056, 42.6686],
    [-87.8112, 42.6533],
    [-87.8147, 42.6440],
    [-87.8179, 42.6292],
    [-87.8197, 42.6158],
    [-87.8165, 42.6020],
    [-87.8154, 42.5961],
    [-87.8151, 42.5941],
    [-87.8115, 42.5888],
    [-87.8100, 42.5884],
    [-87.8075, 42.5858],
    [-87.8109, 42.5829],
    [-87.8127, 42.5692],
    [-87.8126, 42.5592],
    [-87.8125, 42.5562],
    [-87.8137, 42.5427],
    [-87.8123, 42.5253],
    [-87.8107, 42.5153],
    [-87.8050, 42.5023],
    [-87.8031, 42.4951],
    [-87.8038, 42.4926],
    [-87.8252, 42.4929],
    [-87.8479, 42.4932],
    [-87.8626, 42.4934],
    [-87.8830, 42.4937],
    [-87.9001, 42.4939],
    [-87.9585, 42.4947],
    [-88.0031, 42.4950],
    [-88.0689, 42.4956],
    [-88.1010, 42.4960],
    [-88.1085, 42.4961],
    [-88.1153, 42.4962],
    [-88.1385, 42.4962],
    [-88.1871, 42.4960],
    [-88.1994, 42.4960],
    [-88.2114, 42.4960],
    [-88.2189, 42.4959],
    [-88.2379, 42.4959],
    [-88.2654, 42.4951],
    [-88.2746, 42.4948],
    [-88.2850, 42.4948],
    [-88.3114, 42.4948],
    [-88.3166, 42.4948],
    [-88.3219, 42.4947],
    [-88.3391, 42.4947],
    [-88.4174, 42.4946],
    [-88.4320, 42.4946],
    [-88.4706, 42.4947],
    [-88.5502, 42.4949],
    [-88.5994, 42.4950],
    [-88.6708, 42.4944],
    [-88.7274, 42.4931],
    [-88.7654, 42.4921],
    [-88.8199, 42.4926],
    [-88.9433, 42.4951],
    [-88.9785, 42.4958],
    [-88.9925, 42.4960],
    [-88.9930, 42.4960],
    [-89.0116, 42.4961],
    [-89.0137, 42.4961],
    [-89.0262, 42.4962],
    [-89.0421, 42.4963],
    [-89.0547, 42.4962],
    [-89.0674, 42.4962],
    [-89.0795, 42.4963],
    [-89.1169, 42.4969],
    [-89.1206, 42.4970],
    [-89.1571, 42.4973],
    [-89.1979, 42.4976],
    [-89.2470, 42.4981],
    [-89.2626, 42.4982],
    [-89.3616, 42.5000],
    [-89.4014, 42.5004],
    [-89.4192, 42.5006],
    [-89.4239, 42.5008],
    [-89.4551, 42.5011],
    [-89.4926, 42.5015],
    [-89.5638, 42.5026],
    [-89.5790, 42.5030],
    [-89.6000, 42.5037],
    [-89.6134, 42.5039],
    [-89.6503, 42.5046],
    [-89.6902, 42.5052],
    [-89.7342, 42.5053],
    [-89.7685, 42.5053],
    [-89.7940, 42.5055],
    [-89.8376, 42.5055],
    [-89.9265, 42.5058],
    [-89.9553, 42.5056],
    [-89.9807, 42.5063],
    [-89.9972, 42.5068],
    [-90.0185, 42.5073],
    [-90.0737, 42.5083],
    [-90.0950, 42.5079],
    [-90.1644, 42.5083],
    [-90.1928, 42.5079],
    [-90.2061, 42.5077],
    [-90.2506, 42.5075],
    [-90.2693, 42.5077],
    [-90.3038, 42.5075],
    [-90.3679, 42.5071],
    [-90.3819, 42.5070],
    [-90.4264, 42.5071],
    [-90.4750, 42.5075],
    [-90.4917, 42.5076],
    [-90.5443, 42.5077],
    [-90.5559, 42.5075],
    [-90.5854, 42.5078],
    [-90.6098, 42.5080],
    [-90.6146, 42.5081],
    [-90.6297, 42.5083],
    [-90.6428, 42.5085],
    [-90.6406, 42.5277],
    [-90.6456, 42.5441],
    [-90.6591, 42.5579],
    [-90.6683, 42.5732],
    [-90.6771, 42.5792],
    [-90.6870, 42.5918],
    [-90.6910, 42.6076],
    [-90.7001, 42.6225],
    [-90.7063, 42.6342],
    [-90.7311, 42.6434],
    [-90.7625, 42.6497],
    [-90.7794, 42.6530],
    [-90.7970, 42.6558],
    [-90.8327, 42.6617],
    [-90.8671, 42.6687],
    [-90.8969, 42.6753],
    [-90.9134, 42.6829],
    [-90.9299, 42.6841],
    [-90.9492, 42.6856],
    [-90.9650, 42.6932],
    [-90.9806, 42.6989],
    [-91.0001, 42.7162],
    [-91.0157, 42.7192],
    [-91.0268, 42.7242],
    [-91.0310, 42.7324],
    [-91.0354, 42.7373],
    [-91.0466, 42.7372],
    [-91.0537, 42.7382],
    [-91.0563, 42.7473],
    [-91.0647, 42.7509],
    [-91.0631, 42.7573],
    [-91.0603, 42.7618],
    [-91.0699, 42.7714],
    [-91.0724, 42.7877],
    [-91.0781, 42.8065],
    [-91.0787, 42.8277],
    [-91.0941, 42.8308],
    [-91.0930, 42.8435],
    [-91.0918, 42.8512],
    [-91.0988, 42.8644],
    [-91.1041, 42.8860],
    [-91.1174, 42.8958],
    [-91.1434, 42.9047],
    [-91.1462, 42.9098],
    [-91.1439, 42.9206],
    [-91.1443, 42.9266],
    [-91.1499, 42.9420],
    [-91.1454, 42.9582],
    [-91.1480, 42.9662],
    [-91.1566, 42.9782],
    [-91.1575, 42.9915],
    [-91.1726, 43.0324],
    [-91.1747, 43.0387],
    [-91.1766, 43.0515],
    [-91.1795, 43.0674],
    [-91.1772, 43.0802],
    [-91.1783, 43.1250],
    [-91.1753, 43.1347],
    [-91.1562, 43.1429],
    [-91.1460, 43.1527],
    [-91.1414, 43.1635],
    [-91.1342, 43.1744],
    [-91.1222, 43.1973],
    [-91.1094, 43.2056],
    [-91.0875, 43.2219],
    [-91.0719, 43.2352],
    [-91.0617, 43.2448],
    [-91.0579, 43.2554],
    [-91.0618, 43.2600],
    [-91.0726, 43.2621],
    [-91.0717, 43.2714],
    [-91.0857, 43.2919],
    [-91.1208, 43.3213],
    [-91.1373, 43.3298],
    [-91.1715, 43.3412],
    [-91.2018, 43.3491],
    [-91.2066, 43.3525],
    [-91.2148, 43.3659],
    [-91.2074, 43.3737],
    [-91.2007, 43.3859],
    [-91.1980, 43.3992],
    [-91.2004, 43.4127],
    [-91.2056, 43.4229],
    [-91.2287, 43.4455],
    [-91.2332, 43.4578],
    [-91.2295, 43.4626],
    [-91.2160, 43.4811],
    [-91.2180, 43.4947],
    [-91.2179, 43.5081],
    [-91.2226, 43.5179],
    [-91.2329, 43.5240],
    [-91.2441, 43.5456],
    [-91.2406, 43.5550],
    [-91.2318, 43.5727],
    [-91.2319, 43.5818],
    [-91.2391, 43.5898],
    [-91.2583, 43.6035],
    [-91.2687, 43.6153],
    [-91.2624, 43.6418],
    [-91.2639, 43.6477],
    [-91.2717, 43.6549],
    [-91.2685, 43.6929],
    [-91.2685, 43.7098],
    [-91.2613, 43.7195],
    [-91.2559, 43.7298],
    [-91.2554, 43.7449],
    [-91.2532, 43.7834],
    [-91.2624, 43.7922],
    [-91.2674, 43.8042],
    [-91.2757, 43.8249],
    [-91.2820, 43.8427],
    [-91.2967, 43.8552],
    [-91.3013, 43.8595],
    [-91.3153, 43.8818],
    [-91.3381, 43.8977],
    [-91.3463, 43.9101],
    [-91.3567, 43.9166],
    [-91.3632, 43.9266],
    [-91.3666, 43.9375],
    [-91.3876, 43.9553],
    [-91.4074, 43.9651],
    [-91.4241, 43.9826],
    [-91.4267, 43.9885],
    [-91.4353, 43.9986],
    [-91.4475, 44.0035],
    [-91.4635, 44.0090],
    [-91.4802, 44.0081],
    [-91.4950, 44.0125],
    [-91.5243, 44.0214],
    [-91.5531, 44.0238],
    [-91.5733, 44.0269],
    [-91.5826, 44.0274],
    [-91.5996, 44.0379],
    [-91.6105, 44.0493],
    [-91.6238, 44.0541],
    [-91.6334, 44.0604],
    [-91.6405, 44.0637],
    [-91.6479, 44.0641],
    [-91.6570, 44.0714],
    [-91.6653, 44.0850],
    [-91.6743, 44.0922],
    [-91.6913, 44.0979],
    [-91.7076, 44.1040],
    [-91.7095, 44.1176],
    [-91.7197, 44.1292],
    [-91.7331, 44.1331],
    [-91.7628, 44.1403],
    [-91.7967, 44.1543],
    [-91.8292, 44.1783],
    [-91.8387, 44.1826],
    [-91.8644, 44.1966],
    [-91.8755, 44.2013],
    [-91.8764, 44.2096],
    [-91.8898, 44.2263],
    [-91.8924, 44.2363],
    [-91.8870, 44.2518],
    [-91.8960, 44.2629],
    [-91.8964, 44.2747],
    [-91.9058, 44.2816],
    [-91.9237, 44.2903],
    [-91.9241, 44.2971],
    [-91.9136, 44.3104],
    [-91.9186, 44.3227],
    [-91.9362, 44.3388],
    [-91.9528, 44.3530],
    [-91.9667, 44.3639],
    [-91.9749, 44.3675],
    [-91.9870, 44.3691],
    [-92.0002, 44.3750],
    [-92.0086, 44.3796],
    [-92.0378, 44.3886],
    [-92.0463, 44.3944],
    [-92.0616, 44.4041],
    [-92.0836, 44.4072],
    [-92.1111, 44.4139],
    [-92.1245, 44.4221],
    [-92.1625, 44.4272],
    [-92.1893, 44.4325],
    [-92.2168, 44.4390],
    [-92.2373, 44.4494],
    [-92.2449, 44.4568],
    [-92.2768, 44.4736],
    [-92.2971, 44.4927],
    [-92.3025, 44.5165],
    [-92.3080, 44.5245],
    [-92.3141, 44.5380],
    [-92.3177, 44.5428],
    [-92.3357, 44.5538],
    [-92.3615, 44.5589],
    [-92.3890, 44.5577],
    [-92.4151, 44.5604],
    [-92.4311, 44.5658],
    [-92.4551, 44.5619],
    [-92.4810, 44.5683],
    [-92.4919, 44.5661],
    [-92.5088, 44.5703],
    [-92.5209, 44.5752],
    [-92.5406, 44.5673],
    [-92.5481, 44.5678],
    [-92.5512, 44.5734],
    [-92.5493, 44.5777],
    [-92.5672, 44.6018],
    [-92.5729, 44.6046],
    [-92.5789, 44.6039],
    [-92.5862, 44.6001],
    [-92.6015, 44.6121],
    [-92.6180, 44.6129],
    [-92.6233, 44.6207],
    [-92.6198, 44.6341],
    [-92.6321, 44.6490],
    [-92.6647, 44.6634],
    [-92.6950, 44.6883],
    [-92.7009, 44.6938],
    [-92.7373, 44.7172],
    [-92.7570, 44.7238],
    [-92.7879, 44.7374],
    [-92.8029, 44.7468],
    [-92.8046, 44.7487],
    [-92.8074, 44.7589],
    [-92.8003, 44.7774],
    [-92.7852, 44.7923],
    [-92.7804, 44.8126],
    [-92.7727, 44.8263],
    [-92.7694, 44.8318],
    [-92.7653, 44.8411],
    [-92.7691, 44.8620],
    [-92.7671, 44.8668],
    [-92.7641, 44.8759],
    [-92.7749, 44.8928],
    [-92.7731, 44.9014],
    [-92.7613, 44.9069],
    [-92.7576, 44.9112],
    [-92.7506, 44.9373],
    [-92.7533, 44.9509],
    [-92.7593, 44.9628],
    [-92.7685, 44.9698],
    [-92.7703, 44.9790],
    [-92.7690, 44.9882],
    [-92.7712, 45.0014],
    [-92.7675, 45.0104],
    [-92.7625, 45.0206],
    [-92.7646, 45.0288],
    [-92.7788, 45.0393],
    [-92.7879, 45.0435],
    [-92.8017, 45.0570],
    [-92.8029, 45.0654],
    [-92.7923, 45.0788],
    [-92.7915, 45.0796],
    [-92.7656, 45.0957],
    [-92.7449, 45.1083],
    [-92.7395, 45.1165],
    [-92.7457, 45.1231],
    [-92.7494, 45.1381],
    [-92.7578, 45.1605],
    [-92.7525, 45.1718],
    [-92.7649, 45.1828],
    [-92.7669, 45.1951],
    [-92.7580, 45.2096],
    [-92.7517, 45.2187],
    [-92.7557, 45.2259],
    [-92.7602, 45.2496],
    [-92.7517, 45.2617],
    [-92.7527, 45.2696],
    [-92.7619, 45.2849],
    [-92.7587, 45.2910],
    [-92.7371, 45.3005],
    [-92.7277, 45.3093],
    [-92.7061, 45.3252],
    [-92.6990, 45.3363],
    [-92.6990, 45.3395],
    [-92.7037, 45.3563],
    [-92.6792, 45.3727],
    [-92.6770, 45.3801],
    [-92.6707, 45.3877],
    [-92.6585, 45.3961],
    [-92.6505, 45.4019],
    [-92.6467, 45.4132],
    [-92.6503, 45.4192],
    [-92.6492, 45.4296],
    [-92.6467, 45.4418],
    [-92.6535, 45.4553],
    [-92.6802, 45.4643],
    [-92.6847, 45.4698],
    [-92.6952, 45.4829],
    [-92.7158, 45.5067],
    [-92.7277, 45.5188],
    [-92.7246, 45.5367],
    [-92.7400, 45.5496],
    [-92.7569, 45.5575],
    [-92.7734, 45.5682],
    [-92.7901, 45.5669],
    [-92.8166, 45.5610],
    [-92.8438, 45.5661],
    [-92.8811, 45.5734],
    [-92.8833, 45.5898],
    [-92.8860, 45.6004],
    [-92.8830, 45.6137],
    [-92.8881, 45.6284]
    ]
  },
  "Oregon": {
    coordinates: [
      [-124.5646, 42.8409],
    [-124.5524, 42.8406],
    [-124.5446, 42.8514],
    [-124.5365, 42.8624],
    [-124.5346, 42.8754],
    [-124.5257, 42.8800],
    [-124.4796, 42.9543],
    [-124.4486, 43.0271],
    [-124.4347, 43.0815],
    [-124.4342, 43.0897],
    [-124.4352, 43.1047],
    [-124.4345, 43.1119],
    [-124.4345, 43.1160],
    [-124.4276, 43.1232],
    [-124.4017, 43.1849],
    [-124.3974, 43.2196],
    [-124.3841, 43.2728],
    [-124.3940, 43.2993],
    [-124.4028, 43.3059],
    [-124.3876, 43.3260],
    [-124.3770, 43.3342],
    [-124.3432, 43.3515],
    [-124.3150, 43.3884],
    [-124.2782, 43.4546],
    [-124.2320, 43.5626],
    [-124.2105, 43.6533],
    [-124.2063, 43.6666],
    [-124.2002, 43.6896],
    [-124.1777, 43.7672],
    [-124.1587, 43.8637],
    [-124.1383, 43.9953],
    [-124.1369, 44.0230],
    [-124.1258, 44.0928],
    [-124.1254, 44.1112],
    [-124.1271, 44.1198],
    [-124.1239, 44.1341],
    [-124.1274, 44.1392],
    [-124.1170, 44.1719],
    [-124.1144, 44.1982],
    [-124.1132, 44.2217],
    [-124.1153, 44.2460],
    [-124.1118, 44.2605],
    [-124.1149, 44.2727],
    [-124.1133, 44.2780],
    [-124.1117, 44.2832],
    [-124.1133, 44.2917],
    [-124.1108, 44.2989],
    [-124.1081, 44.3098],
    [-124.1091, 44.3184],
    [-124.1006, 44.3319],
    [-124.0900, 44.3866],
    [-124.0849, 44.4185],
    [-124.0837, 44.4304],
    [-124.0835, 44.4624],
    [-124.0844, 44.4869],
    [-124.0804, 44.5129],
    [-124.0780, 44.5222],
    [-124.0754, 44.5316],
    [-124.0696, 44.5731],
    [-124.0665, 44.5976],
    [-124.0673, 44.6080],
    [-124.0687, 44.6153],
    [-124.0683, 44.6180],
    [-124.0670, 44.6279],
    [-124.0621, 44.6438],
    [-124.0600, 44.6694],
    [-124.0635, 44.6724],
    [-124.0780, 44.6756],
    [-124.0720, 44.6779],
    [-124.0654, 44.6951],
    [-124.0599, 44.7160],
    [-124.0602, 44.7451],
    [-124.0648, 44.7461],
    [-124.0673, 44.7592],
    [-124.0692, 44.7678],
    [-124.0746, 44.7785],
    [-124.0730, 44.7911],
    [-124.0741, 44.7981],
    [-124.0674, 44.8046],
    [-124.0636, 44.8096],
    [-124.0679, 44.8141],
    [-124.0677, 44.8197],
    [-124.0673, 44.8262],
    [-124.0610, 44.8344],
    [-124.0538, 44.8391],
    [-124.0323, 44.9008],
    [-124.0254, 44.9325],
    [-124.0239, 44.9490],
    [-124.0172, 44.9755],
    [-124.0145, 44.9873],
    [-124.0120, 45.0011],
    [-124.0102, 45.0238],
    [-124.0117, 45.0335],
    [-124.0055, 45.0429],
    [-124.0098, 45.0473],
    [-124.0159, 45.0648],
    [-124.0049, 45.0842],
    [-123.9877, 45.1008],
    [-123.9754, 45.1455],
    [-123.9687, 45.1953],
    [-123.9686, 45.2025],
    [-123.9713, 45.2268],
    [-123.9629, 45.2802],
    [-123.9641, 45.3161],
    [-123.9690, 45.3281],
    [-124.0078, 45.3368],
    [-123.9790, 45.3486],
    [-123.9606, 45.4308],
    [-123.9625, 45.4446],
    [-123.9743, 45.4679],
    [-123.9708, 45.4725],
    [-123.9701, 45.4816],
    [-123.9766, 45.4852],
    [-123.9765, 45.4897],
    [-123.9621, 45.4972],
    [-123.9494, 45.5454],
    [-123.9495, 45.5648],
    [-123.9526, 45.5670],
    [-123.9523, 45.5863],
    [-123.9483, 45.6117],
    [-123.9413, 45.6562],
    [-123.9409, 45.7036],
    [-123.9429, 45.7252],
    [-123.9460, 45.7332],
    [-123.9577, 45.7417],
    [-123.9686, 45.7570],
    [-123.9684, 45.7617],
    [-123.9826, 45.7618],
    [-123.9788, 45.7729],
    [-123.9693, 45.7806],
    [-123.9680, 45.7985],
    [-123.9615, 45.8371],
    [-123.9640, 45.8590],
    [-123.9643, 45.8819],
    [-123.9665, 45.8883],
    [-123.9676, 45.9078],
    [-123.9715, 45.9102],
    [-123.9784, 45.9182],
    [-123.9804, 45.9309],
    [-123.9851, 45.9350],
    [-123.9913, 45.9425],
    [-123.9857, 45.9512],
    [-123.9739, 45.9593],
    [-123.9729, 45.9663],
    [-123.9562, 45.9747],
    [-123.9376, 45.9773],
    [-123.9364, 45.9809],
    [-123.9279, 46.0105],
    [-123.9288, 46.0290],
    [-123.9300, 46.0468],
    [-123.9419, 46.0986],
    [-123.9616, 46.1461],
    [-123.9741, 46.1688],
    [-123.9968, 46.2040],
    [-124.0126, 46.2368],
    [-123.9993, 46.2337],
    [-123.9884, 46.2241],
    [-123.9955, 46.2165],
    [-123.9803, 46.2069],
    [-123.9540, 46.2072],
    [-123.9474, 46.2022],
    [-123.9236, 46.1906],
    [-123.9004, 46.1743],
    [-123.8833, 46.1687],
    [-123.8609, 46.1586],
    [-123.8576, 46.1579],
    [-123.8476, 46.1586],
    [-123.8428, 46.1605],
    [-123.8384, 46.1685],
    [-123.8384, 46.1700],
    [-123.8519, 46.1760],
    [-123.8629, 46.1834],
    [-123.8578, 46.1908],
    [-123.8462, 46.1927],
    [-123.8218, 46.1903],
    [-123.7878, 46.1976],
    [-123.7710, 46.2041],
    [-123.7633, 46.2110],
    [-123.7481, 46.2061],
    [-123.7253, 46.1951],
    [-123.6931, 46.1899],
    [-123.6754, 46.2124],
    [-123.6609, 46.2163],
    [-123.6323, 46.2132],
    [-123.6145, 46.2176],
    [-123.5824, 46.2305],
    [-123.5477, 46.2591],
    [-123.5162, 46.2662],
    [-123.4748, 46.2678],
    [-123.4476, 46.2498],
    [-123.4281, 46.2233],
    [-123.3904, 46.1544],
    [-123.3637, 46.1463],
    [-123.3407, 46.1462],
    [-123.3010, 46.1446],
    [-123.2420, 46.1610],
    [-123.2131, 46.1725],
    [-123.1159, 46.1853],
    [-123.0511, 46.1536],
    [-123.0229, 46.1394],
    [-123.0042, 46.1338],
    [-122.9397, 46.0965],
    [-122.9041, 46.0837],
    [-122.8845, 46.0603],
    [-122.8813, 46.0460],
    [-122.8586, 46.0163],
    [-122.8376, 45.9808],
    [-122.8122, 45.9545],
    [-122.8112, 45.9139],
    [-122.8084, 45.9060],
    [-122.7968, 45.8827],
    [-122.7851, 45.8644],
    [-122.7857, 45.8442],
    [-122.7956, 45.8100],
    [-122.7706, 45.7818],
    [-122.7610, 45.7504],
    [-122.7725, 45.6996],
    [-122.7638, 45.6571],
    [-122.7381, 45.6441],
    [-122.6912, 45.6248],
    [-122.6753, 45.6182],
    [-122.6350, 45.6093],
    [-122.5889, 45.6053],
    [-122.5814, 45.6039],
    [-122.5494, 45.5970],
    [-122.5237, 45.5896],
    [-122.4923, 45.5833],
    [-122.4747, 45.5783],
    [-122.4539, 45.5673],
    [-122.4347, 45.5642],
    [-122.4012, 45.5711],
    [-122.3834, 45.5756],
    [-122.3528, 45.5694],
    [-122.3315, 45.5482],
    [-122.2667, 45.5438],
    [-122.2490, 45.5477],
    [-122.1975, 45.5673],
    [-122.1407, 45.5845],
    [-122.1262, 45.5826],
    [-122.1017, 45.5835],
    [-122.0226, 45.6152],
    [-121.9798, 45.6248],
    [-121.9557, 45.6436],
    [-121.9220, 45.6492],
    [-121.9009, 45.6620],
    [-121.8772, 45.6868],
    [-121.8582, 45.6954],
    [-121.7351, 45.6940],
    [-121.6760, 45.7031],
    [-121.6312, 45.7047],
    [-121.5338, 45.7264],
    [-121.5237, 45.7249],
    [-121.4992, 45.7208],
    [-121.4837, 45.7125],
    [-121.4628, 45.7014],
    [-121.4017, 45.6929],
    [-121.3655, 45.7035],
    [-121.3122, 45.6999],
    [-121.2512, 45.6784],
    [-121.2004, 45.6498],
    [-121.1961, 45.6206],
    [-121.1705, 45.6062],
    [-121.1406, 45.6112],
    [-121.1292, 45.6115],
    [-121.1222, 45.6161],
    [-121.0849, 45.6479],
    [-121.0336, 45.6510],
    [-120.9780, 45.6493],
    [-120.9159, 45.6413],
    [-120.8956, 45.6429],
    [-120.8557, 45.6715],
    [-120.7242, 45.7064],
    [-120.6535, 45.7372],
    [-120.5595, 45.7383],
    [-120.5059, 45.7000],
    [-120.4040, 45.6992],
    [-120.2822, 45.7212],
    [-120.1911, 45.7435],
    [-120.0701, 45.7852],
    [-119.9995, 45.8125],
    [-119.9075, 45.8281],
    [-119.8681, 45.8360],
    [-119.7299, 45.8503],
    [-119.6234, 45.9056],
    [-119.5369, 45.9130],
    [-119.4562, 45.9156],
    [-119.3644, 45.9216],
    [-119.3225, 45.9332],
    [-119.2571, 45.9399],
    [-119.1955, 45.9279],
    [-119.1261, 45.9329],
    [-119.0271, 45.9691],
    [-118.9871, 45.9999],
    [-118.8681, 46.0007],
    [-118.7252, 46.0009],
    [-118.6393, 46.0010],
    [-118.5905, 46.0008],
    [-118.5694, 46.0008],
    [-118.4970, 46.0006],
    [-118.4038, 46.0006],
    [-118.3873, 46.0006],
    [-118.3672, 46.0006],
    [-118.2835, 46.0008],
    [-118.2367, 46.0004],
    [-118.1460, 46.0007],
    [-117.9969, 46.0008],
    [-117.7179, 45.9999],
    [-117.6032, 45.9989],
    [-117.4799, 45.9979],
    [-117.4399, 45.9986],
    [-117.3539, 45.9963],
    [-117.2167, 45.9984],
    [-117.0902, 45.9976],
    [-116.9859, 45.9970],
    [-116.9114, 45.9889],
    [-116.8947, 45.9697],
    [-116.8805, 45.9585],
    [-116.8757, 45.9450],
    [-116.8697, 45.9238],
    [-116.8573, 45.9042],
    [-116.8192, 45.8809],
    [-116.7961, 45.8585],
    [-116.7878, 45.8443],
    [-116.7891, 45.8335],
    [-116.7634, 45.8166],
    [-116.7510, 45.8185],
    [-116.7363, 45.8262],
    [-116.7084, 45.8251],
    [-116.6870, 45.8063],
    [-116.6596, 45.7800],
    [-116.6358, 45.7836],
    [-116.5930, 45.7785],
    [-116.5535, 45.7534],
    [-116.5439, 45.7470],
    [-116.5380, 45.7149],
    [-116.5283, 45.6815],
    [-116.4945, 45.6557],
    [-116.4878, 45.6443],
    [-116.4833, 45.6415],
    [-116.4829, 45.6361],
    [-116.4758, 45.6317],
    [-116.4729, 45.6249],
    [-116.4635, 45.6158],
    [-116.4747, 45.5918],
    [-116.4831, 45.5852],
    [-116.4819, 45.5779],
    [-116.5028, 45.5666],
    [-116.5040, 45.5610],
    [-116.5139, 45.5563],
    [-116.5259, 45.5537],
    [-116.5283, 45.5499],
    [-116.5236, 45.5466],
    [-116.5438, 45.5142],
    [-116.5546, 45.5079],
    [-116.5566, 45.5014],
    [-116.5532, 45.4959],
    [-116.5550, 45.4728],
    [-116.5640, 45.4602],
    [-116.5882, 45.4429],
    [-116.6191, 45.3982],
    [-116.6738, 45.3215],
    [-116.6722, 45.2889],
    [-116.6756, 45.2749],
    [-116.6872, 45.2677],
    [-116.7036, 45.2398],
    [-116.7085, 45.2074],
    [-116.7242, 45.1649],
    [-116.7275, 45.1560],
    [-116.7312, 45.1399],
    [-116.7455, 45.1330],
    [-116.7528, 45.1218],
    [-116.7825, 45.0958],
    [-116.7838, 45.0783],
    [-116.8086, 45.0507],
    [-116.8413, 45.0309],
    [-116.8448, 45.0153],
    [-116.8568, 44.9843],
    [-116.8523, 44.9725],
    [-116.8420, 44.9808],
    [-116.8305, 44.9846],
    [-116.8364, 44.9692],
    [-116.8465, 44.9515],
    [-116.8336, 44.9290],
    [-116.8461, 44.9052],
    [-116.8570, 44.8808],
    [-116.8760, 44.8667],
    [-116.8836, 44.8583],
    [-116.8924, 44.8552],
    [-116.8986, 44.8520],
    [-116.8984, 44.8423],
    [-116.9001, 44.8367],
    [-116.9205, 44.8144],
    [-116.9337, 44.7988],
    [-116.9308, 44.7910],
    [-116.9347, 44.7839],
    [-116.9668, 44.7752],
    [-116.9778, 44.7680],
    [-116.9989, 44.7564],
    [-117.0162, 44.7556],
    [-117.0294, 44.7511],
    [-117.0395, 44.7465],
    [-117.0478, 44.7415],
    [-117.0586, 44.7303],
    [-117.0618, 44.7067],
    [-117.0741, 44.6964],
    [-117.0795, 44.6887],
    [-117.0798, 44.6825],
    [-117.0810, 44.6737],
    [-117.0912, 44.6688],
    [-117.0950, 44.6520],
    [-117.1148, 44.6249],
    [-117.1253, 44.5938],
    [-117.1340, 44.5752],
    [-117.1460, 44.5686],
    [-117.1429, 44.5572],
    [-117.1524, 44.5318],
    [-117.1816, 44.5230],
    [-117.1916, 44.5099],
    [-117.1943, 44.4999],
    [-117.2111, 44.4854],
    [-117.2241, 44.4837],
    [-117.2258, 44.4772],
    [-117.2170, 44.4590],
    [-117.2151, 44.4272],
    [-117.2270, 44.4056],
    [-117.2430, 44.3910],
    [-117.2169, 44.3602],
    [-117.1973, 44.3474],
    [-117.1898, 44.3350],
    [-117.2033, 44.3130],
    [-117.2168, 44.3082],
    [-117.2201, 44.3014],
    [-117.2170, 44.2884],
    [-117.1931, 44.2710],
    [-117.1434, 44.2583],
    [-117.1331, 44.2642],
    [-117.1210, 44.2776],
    [-117.1077, 44.2808],
    [-117.0985, 44.2755],
    [-117.0909, 44.2603],
    [-117.0742, 44.2477],
    [-117.0565, 44.2309],
    [-117.0474, 44.2296],
    [-117.0423, 44.2428],
    [-117.0276, 44.2489],
    [-117.0169, 44.2454],
    [-117.0037, 44.2454],
    [-116.9837, 44.2447],
    [-116.9786, 44.2435],
    [-116.9728, 44.2380],
    [-116.9725, 44.2328],
    [-116.9704, 44.2212],
    [-116.9737, 44.2080],
    [-116.9655, 44.1941],
    [-116.9453, 44.1917],
    [-116.9354, 44.1940],
    [-116.9157, 44.1832],
    [-116.8958, 44.1713],
    [-116.8943, 44.1581],
    [-116.9008, 44.1501],
    [-116.9033, 44.1444],
    [-116.9138, 44.1284],
    [-116.9190, 44.1233],
    [-116.9294, 44.1126],
    [-116.9337, 44.1000],
    [-116.9400, 44.0958],
    [-116.9570, 44.0917],
    [-116.9774, 44.0854],
    [-116.9740, 44.0537],
    [-116.9720, 44.0486],
    [-116.9557, 44.0426],
    [-116.9373, 44.0294],
    [-116.9356, 44.0244],
    [-116.9359, 44.0127],
    [-116.9437, 44.0032],
    [-116.9358, 43.9909],
    [-116.9428, 43.9840],
    [-116.9734, 43.9771],
    [-116.9738, 43.9722],
    [-116.9686, 43.9684],
    [-116.9592, 43.9664],
    [-116.9723, 43.9584],
    [-116.9613, 43.9560],
    [-116.9623, 43.9481],
    [-116.9690, 43.9399],
    [-116.9676, 43.9348],
    [-116.9594, 43.9277],
    [-116.9724, 43.9165],
    [-116.9803, 43.9094],
    [-116.9773, 43.9058],
    [-116.9765, 43.8971],
    [-116.9809, 43.8857],
    [-116.9838, 43.8800],
    [-116.9822, 43.8712],
    [-116.9842, 43.8668],
    [-116.9942, 43.8641],
    [-117.0108, 43.8623],
    [-117.0220, 43.8564],
    [-117.0159, 43.8515],
    [-117.0090, 43.8423],
    [-117.0252, 43.8413],
    [-117.0329, 43.8300],
    [-117.0215, 43.8194],
    [-117.0240, 43.8123],
    [-117.0267, 43.7339],
    [-117.0268, 43.7062],
    [-117.0266, 43.6808],
    [-117.0267, 43.6317],
    [-117.0269, 43.6176],
    [-117.0268, 43.6004],
    [-117.0268, 43.5787],
    [-117.0267, 43.5647],
    [-117.0267, 43.3153],
    [-117.0263, 42.8074],
    [-117.0267, 42.6249],
    [-117.0266, 42.3786],
    [-117.0266, 42.1333],
    [-117.0409, 41.9999],
    [-117.0686, 42.0000],
    [-117.4036, 41.9993],
    [-117.5302, 41.9991],
    [-117.6237, 41.9985],
    [-117.6621, 41.9981],
    [-118.1239, 41.9973],
    [-118.5010, 41.9954],
    [-118.6447, 41.9929],
    [-118.7772, 41.9927],
    [-119.0010, 41.9938],
    [-119.2510, 41.9938],
    [-119.3602, 41.9944],
    [-119.7901, 41.9975],
    [-119.8761, 41.9972],
    [-120.0467, 41.9949],
    [-120.1607, 41.9946],
    [-120.2769, 41.9929],
    [-120.3264, 41.9926],
    [-120.4140, 41.9931],
    [-120.5649, 41.9932],
    [-120.7862, 41.9938],
    [-120.8799, 41.9938],
    [-121.0221, 41.9933],
    [-121.1250, 41.9961],
    [-121.2973, 41.9974],
    [-121.3449, 41.9962],
    [-121.4475, 41.9975],
    [-121.5911, 41.9992],
    [-121.6831, 42.0004],
    [-121.8010, 42.0021],
    [-121.9541, 42.0035],
    [-122.0472, 42.0053],
    [-122.1871, 42.0073],
    [-122.2607, 42.0076],
    [-122.3203, 42.0086],
    [-122.4035, 42.0088],
    [-122.5489, 42.0075],
    [-122.6725, 42.0047],
    [-122.8138, 42.0041],
    [-122.8755, 42.0039],
    [-122.8936, 42.0038],
    [-122.9877, 42.0034],
    [-123.0809, 42.0051],
    [-123.1457, 42.0088],
    [-123.2456, 42.0034],
    [-123.4447, 42.0006],
    [-123.5187, 42.0008],
    [-123.6240, 41.9998],
    [-123.7214, 41.9969],
    [-123.8117, 41.9952],
    [-123.9670, 41.9961],
    [-124.1025, 41.9968],
    [-124.2189, 42.0079],
    [-124.2315, 42.0152],
    [-124.2397, 42.0238],
    [-124.2485, 42.0260],
    [-124.2598, 42.0346],
    [-124.2701, 42.0453],
    [-124.2777, 42.0460],
    [-124.2823, 42.0451],
    [-124.2888, 42.0447],
    [-124.2898, 42.0465],
    [-124.2926, 42.0484],
    [-124.2968, 42.0513],
    [-124.3040, 42.0609],
    [-124.3136, 42.0656],
    [-124.3168, 42.0689],
    [-124.3202, 42.0742],
    [-124.3248, 42.0817],
    [-124.3352, 42.0874],
    [-124.3421, 42.0979],
    [-124.3511, 42.1002],
    [-124.3508, 42.1080],
    [-124.3553, 42.1136],
    [-124.3562, 42.1197],
    [-124.3515, 42.1298],
    [-124.3562, 42.1421],
    [-124.3660, 42.1523],
    [-124.3603, 42.1623],
    [-124.3617, 42.1720],
    [-124.3636, 42.1828],
    [-124.3703, 42.1913],
    [-124.3753, 42.2011],
    [-124.3782, 42.2112],
    [-124.3823, 42.2239],
    [-124.3884, 42.2294],
    [-124.3925, 42.2351],
    [-124.4015, 42.2428],
    [-124.4141, 42.2522],
    [-124.4085, 42.2606],
    [-124.4105, 42.2987],
    [-124.4118, 42.3074],
    [-124.4206, 42.3204],
    [-124.4278, 42.3189],
    [-124.4314, 42.3291],
    [-124.4272, 42.3349],
    [-124.4264, 42.3520],
    [-124.4262, 42.3956],
    [-124.4256, 42.4062],
    [-124.4298, 42.4206],
    [-124.4351, 42.4419],
    [-124.4220, 42.4612],
    [-124.4220, 42.4654],
    [-124.4258, 42.4763],
    [-124.4214, 42.4851],
    [-124.4222, 42.4964],
    [-124.4061, 42.5247],
    [-124.3977, 42.5467],
    [-124.3900, 42.5748],
    [-124.3948, 42.5785],
    [-124.3983, 42.5896],
    [-124.4049, 42.5911],
    [-124.4017, 42.5977],
    [-124.4015, 42.6100],
    [-124.4012, 42.6272],
    [-124.4063, 42.6365],
    [-124.4113, 42.6407],
    [-124.4131, 42.6579],
    [-124.4292, 42.6666],
    [-124.4507, 42.6758],
    [-124.4475, 42.6847],
    [-124.4553, 42.6944],
    [-124.4598, 42.7075],
    [-124.4644, 42.7173],
    [-124.4739, 42.7327],
    [-124.4912, 42.7416],
    [-124.4991, 42.7386],
    [-124.5052, 42.7364],
    [-124.5137, 42.7329],
    [-124.5136, 42.7458],
    [-124.5244, 42.7898],
    [-124.5442, 42.8230],
    [-124.5645, 42.8342],
    [-124.5646, 42.8409]
    ]
  },
  "North Dakota": {
    coordinates: [
      [-104.0487, 48.8638],
    [-104.0489, 48.8740],
    [-104.0487, 48.8799],
    [-104.0487, 48.9069],
    [-104.0487, 48.9403],
    [-104.0487, 48.9518],
    [-104.0486, 48.9638],
    [-104.0487, 48.9999],
    [-103.9838, 48.9996],
    [-103.9765, 48.9996],
    [-103.9233, 48.9996],
    [-103.9174, 48.9996],
    [-103.8627, 48.9996],
    [-103.8561, 48.9996],
    [-103.5967, 48.9992],
    [-103.3755, 48.9990],
    [-103.2018, 48.9995],
    [-102.9177, 48.9995],
    [-102.6766, 48.9992],
    [-102.5344, 48.9990],
    [-102.2835, 48.9986],
    [-102.2113, 48.9986],
    [-102.0211, 48.9990],
    [-101.7591, 48.9991],
    [-101.5004, 48.9997],
    [-101.3655, 48.9994],
    [-101.2342, 48.9995],
    [-101.2208, 48.9995],
    [-101.1028, 48.9991],
    [-100.9179, 48.9996],
    [-100.8406, 48.9996],
    [-100.5556, 48.9995],
    [-100.4344, 48.9996],
    [-100.3146, 48.9993],
    [-99.9651, 48.9991],
    [-99.8929, 48.9991],
    [-99.8331, 48.9992],
    [-99.6573, 48.9993],
    [-99.3761, 48.9994],
    [-99.1100, 48.9998],
    [-98.7371, 49.0002],
    [-98.3427, 49.0004],
    [-97.9502, 49.0005],
    [-97.6882, 49.0006],
    [-97.4112, 49.0005],
    [-97.2335, 48.9982],
    [-97.2282, 48.9948],
    [-97.2316, 48.9904],
    [-97.2384, 48.9826],
    [-97.2380, 48.9743],
    [-97.2391, 48.9678],
    [-97.2375, 48.9653],
    [-97.2280, 48.9629],
    [-97.2309, 48.9582],
    [-97.2338, 48.9496],
    [-97.2290, 48.9468],
    [-97.2268, 48.9435],
    [-97.2253, 48.9345],
    [-97.2160, 48.9327],
    [-97.2175, 48.9277],
    [-97.2180, 48.9197],
    [-97.2108, 48.9139],
    [-97.2105, 48.9044],
    [-97.1943, 48.8988],
    [-97.1910, 48.8922],
    [-97.2000, 48.8926],
    [-97.2009, 48.8906],
    [-97.1974, 48.8867],
    [-97.1995, 48.8813],
    [-97.1893, 48.8766],
    [-97.1796, 48.8770],
    [-97.1851, 48.8692],
    [-97.1900, 48.8635],
    [-97.1794, 48.8631],
    [-97.1764, 48.8547],
    [-97.1761, 48.8484],
    [-97.1810, 48.8459],
    [-97.1738, 48.8383],
    [-97.1784, 48.8350],
    [-97.1839, 48.8303],
    [-97.1796, 48.8201],
    [-97.1903, 48.8157],
    [-97.1854, 48.8148],
    [-97.1740, 48.8121],
    [-97.1588, 48.8109],
    [-97.1624, 48.8054],
    [-97.1704, 48.8037],
    [-97.1815, 48.7995],
    [-97.1759, 48.7976],
    [-97.1652, 48.8013],
    [-97.1634, 48.7962],
    [-97.1739, 48.7952],
    [-97.1643, 48.7909],
    [-97.1571, 48.7900],
    [-97.1581, 48.7873],
    [-97.1575, 48.7827],
    [-97.1487, 48.7819],
    [-97.1486, 48.7792],
    [-97.1590, 48.7757],
    [-97.1526, 48.7726],
    [-97.1459, 48.7656],
    [-97.1515, 48.7601],
    [-97.1491, 48.7504],
    [-97.1363, 48.7468],
    [-97.1421, 48.7375],
    [-97.1345, 48.7344],
    [-97.1305, 48.7295],
    [-97.1369, 48.7260],
    [-97.1243, 48.7192],
    [-97.1213, 48.7136],
    [-97.1100, 48.7078],
    [-97.1169, 48.7050],
    [-97.1097, 48.6917],
    [-97.0903, 48.6845],
    [-97.0974, 48.6833],
    [-97.1014, 48.6787],
    [-97.1024, 48.6668],
    [-97.1093, 48.6641],
    [-97.1040, 48.6627],
    [-97.0994, 48.6591],
    [-97.1055, 48.6540],
    [-97.1109, 48.6461],
    [-97.1146, 48.6426],
    [-97.1090, 48.6345],
    [-97.1120, 48.6308],
    [-97.1171, 48.6309],
    [-97.1301, 48.6325],
    [-97.1308, 48.6296],
    [-97.1201, 48.6217],
    [-97.1204, 48.6180],
    [-97.1300, 48.6226],
    [-97.1347, 48.6202],
    [-97.1288, 48.6148],
    [-97.1381, 48.6147],
    [-97.1507, 48.6105],
    [-97.1375, 48.6089],
    [-97.1382, 48.6042],
    [-97.1465, 48.5978],
    [-97.1528, 48.5964],
    [-97.1452, 48.5941],
    [-97.1429, 48.5837],
    [-97.1484, 48.5810],
    [-97.1606, 48.5809],
    [-97.1526, 48.5779],
    [-97.1481, 48.5721],
    [-97.1576, 48.5664],
    [-97.1753, 48.5625],
    [-97.1657, 48.5572],
    [-97.1410, 48.5563],
    [-97.1409, 48.5513],
    [-97.1558, 48.5512],
    [-97.1656, 48.5532],
    [-97.1631, 48.5439],
    [-97.1492, 48.5391],
    [-97.1425, 48.5321],
    [-97.1548, 48.5242],
    [-97.1474, 48.5188],
    [-97.1308, 48.5227],
    [-97.1283, 48.5177],
    [-97.1421, 48.5115],
    [-97.1495, 48.5085],
    [-97.1445, 48.4976],
    [-97.1312, 48.4903],
    [-97.1373, 48.4889],
    [-97.1430, 48.4923],
    [-97.1393, 48.4863],
    [-97.1574, 48.4816],
    [-97.1610, 48.4758],
    [-97.1493, 48.4755],
    [-97.1289, 48.4757],
    [-97.1341, 48.4717],
    [-97.1461, 48.4741],
    [-97.1421, 48.4633],
    [-97.1299, 48.4629],
    [-97.1290, 48.4564],
    [-97.1353, 48.4489],
    [-97.1505, 48.4412],
    [-97.1411, 48.4386],
    [-97.1266, 48.4431],
    [-97.1246, 48.4336],
    [-97.1315, 48.4311],
    [-97.1452, 48.4326],
    [-97.1391, 48.4264],
    [-97.1268, 48.4234],
    [-97.1225, 48.4183],
    [-97.1301, 48.4190],
    [-97.1404, 48.4216],
    [-97.1548, 48.4175],
    [-97.1505, 48.4127],
    [-97.1412, 48.4186],
    [-97.1372, 48.4136],
    [-97.1315, 48.4066],
    [-97.1435, 48.3989],
    [-97.1534, 48.3970],
    [-97.1633, 48.3920],
    [-97.1566, 48.3906],
    [-97.1506, 48.3824],
    [-97.1406, 48.3832],
    [-97.1334, 48.3820],
    [-97.1414, 48.3785],
    [-97.1393, 48.3704],
    [-97.1498, 48.3711],
    [-97.1553, 48.3688],
    [-97.1485, 48.3607],
    [-97.1439, 48.3545],
    [-97.1363, 48.3501],
    [-97.1396, 48.3442],
    [-97.1276, 48.3427],
    [-97.1282, 48.3339],
    [-97.1349, 48.3313],
    [-97.1423, 48.3270],
    [-97.1382, 48.3254],
    [-97.1338, 48.3278],
    [-97.1175, 48.3259],
    [-97.1197, 48.3208],
    [-97.1312, 48.3195],
    [-97.1379, 48.3120],
    [-97.1337, 48.3089],
    [-97.1238, 48.3109],
    [-97.1257, 48.3064],
    [-97.1247, 48.3024],
    [-97.1131, 48.2978],
    [-97.1153, 48.2939],
    [-97.1242, 48.2984],
    [-97.1307, 48.2972],
    [-97.1381, 48.2908],
    [-97.1355, 48.2871],
    [-97.1272, 48.2918],
    [-97.1177, 48.2835],
    [-97.1167, 48.2807],
    [-97.1206, 48.2767],
    [-97.1249, 48.2745],
    [-97.1253, 48.2705],
    [-97.1404, 48.2711],
    [-97.1439, 48.2657],
    [-97.1310, 48.2653],
    [-97.1230, 48.2617],
    [-97.1306, 48.2589],
    [-97.1249, 48.2532],
    [-97.1274, 48.2494],
    [-97.1400, 48.2473],
    [-97.1468, 48.2421],
    [-97.1357, 48.2409],
    [-97.1358, 48.2369],
    [-97.1444, 48.2332],
    [-97.1303, 48.2297],
    [-97.1217, 48.2236],
    [-97.1372, 48.2270],
    [-97.1497, 48.2231],
    [-97.1498, 48.2181],
    [-97.1406, 48.2221],
    [-97.1195, 48.2135],
    [-97.1229, 48.2074],
    [-97.1279, 48.2144],
    [-97.1390, 48.2171],
    [-97.1307, 48.2109],
    [-97.1316, 48.2071],
    [-97.1410, 48.2027],
    [-97.1359, 48.1983],
    [-97.1403, 48.1948],
    [-97.1423, 48.1916],
    [-97.1498, 48.1854],
    [-97.1468, 48.1821],
    [-97.1370, 48.1812],
    [-97.1389, 48.1747],
    [-97.1475, 48.1724],
    [-97.1442, 48.1625],
    [-97.1345, 48.1603],
    [-97.1237, 48.1625],
    [-97.1236, 48.1570],
    [-97.1467, 48.1432],
    [-97.1407, 48.1422],
    [-97.1266, 48.1415],
    [-97.1231, 48.1370],
    [-97.1325, 48.1376],
    [-97.1295, 48.1331],
    [-97.1216, 48.1169],
    [-97.1210, 48.1123],
    [-97.1236, 48.1078],
    [-97.1132, 48.1062],
    [-97.1084, 48.0998],
    [-97.1023, 48.0949],
    [-97.1099, 48.0914],
    [-97.1022, 48.0891],
    [-97.1008, 48.0775],
    [-97.1045, 48.0724],
    [-97.0952, 48.0668],
    [-97.0829, 48.0558],
    [-97.0723, 48.0481],
    [-97.0690, 48.0263],
    [-97.0722, 48.0195],
    [-97.0693, 48.0162],
    [-97.0630, 48.0132],
    [-97.0643, 47.9985],
    [-97.0536, 47.9916],
    [-97.0535, 47.9879],
    [-97.0594, 47.9740],
    [-97.0616, 47.9659],
    [-97.0614, 47.9636],
    [-97.0525, 47.9572],
    [-97.0552, 47.9505],
    [-97.0546, 47.9463],
    [-97.0395, 47.9405],
    [-97.0356, 47.9366],
    [-97.0373, 47.9332],
    [-97.0285, 47.9268],
    [-97.0208, 47.9218],
    [-97.0238, 47.9159],
    [-97.0154, 47.9103],
    [-97.0173, 47.9057],
    [-97.0250, 47.9082],
    [-97.0202, 47.9005],
    [-97.0250, 47.8950],
    [-97.0250, 47.8869],
    [-97.0194, 47.8803],
    [-97.0232, 47.8750],
    [-97.0174, 47.8716],
    [-97.0054, 47.8702],
    [-97.0034, 47.8659],
    [-97.0018, 47.8613],
    [-96.9981, 47.8589],
    [-96.9975, 47.8500],
    [-96.9940, 47.8460],
    [-96.9979, 47.8432],
    [-96.9932, 47.8428],
    [-96.9930, 47.8379],
    [-96.9848, 47.8330],
    [-96.9867, 47.8266],
    [-96.9817, 47.8258],
    [-96.9742, 47.8230],
    [-96.9801, 47.8224],
    [-96.9779, 47.8116],
    [-96.9880, 47.8099],
    [-96.9862, 47.8070],
    [-96.9791, 47.8040],
    [-96.9730, 47.8018],
    [-96.9766, 47.7980],
    [-96.9671, 47.7999],
    [-96.9579, 47.7920],
    [-96.9616, 47.7887],
    [-96.9653, 47.7835],
    [-96.9583, 47.7857],
    [-96.9588, 47.7803],
    [-96.9532, 47.7784],
    [-96.9526, 47.7746],
    [-96.9454, 47.7724],
    [-96.9348, 47.7665],
    [-96.9381, 47.7610],
    [-96.9371, 47.7596],
    [-96.9288, 47.7557],
    [-96.9346, 47.7554],
    [-96.9385, 47.7539],
    [-96.9291, 47.7503],
    [-96.9293, 47.7430],
    [-96.9328, 47.7371],
    [-96.9240, 47.7261],
    [-96.9195, 47.7225],
    [-96.9307, 47.7176],
    [-96.9262, 47.7150],
    [-96.9199, 47.7170],
    [-96.9202, 47.7114],
    [-96.9128, 47.7083],
    [-96.9152, 47.7035],
    [-96.9205, 47.6996],
    [-96.9128, 47.7017],
    [-96.9076, 47.6951],
    [-96.9099, 47.6895],
    [-96.9053, 47.6892],
    [-96.9003, 47.6908],
    [-96.8960, 47.6783],
    [-96.8919, 47.6732],
    [-96.8851, 47.6738],
    [-96.8897, 47.6706],
    [-96.8856, 47.6634],
    [-96.8870, 47.6530],
    [-96.8829, 47.6417],
    [-96.8886, 47.6384],
    [-96.8794, 47.6287],
    [-96.8754, 47.6266],
    [-96.8793, 47.6246],
    [-96.8795, 47.6206],
    [-96.8709, 47.6180],
    [-96.8741, 47.6148],
    [-96.8692, 47.6149],
    [-96.8603, 47.6122],
    [-96.8552, 47.6079],
    [-96.8556, 47.6009],
    [-96.8522, 47.5964],
    [-96.8589, 47.5951],
    [-96.8499, 47.5909],
    [-96.8519, 47.5850],
    [-96.8591, 47.5755],
    [-96.8541, 47.5720],
    [-96.8544, 47.5674],
    [-96.8664, 47.5694],
    [-96.8655, 47.5632],
    [-96.8528, 47.5655],
    [-96.8474, 47.5650],
    [-96.8564, 47.5600],
    [-96.8617, 47.5595],
    [-96.8531, 47.5548],
    [-96.8546, 47.5488],
    [-96.8589, 47.5451],
    [-96.8454, 47.5396],
    [-96.8504, 47.5380],
    [-96.8557, 47.5422],
    [-96.8632, 47.5388],
    [-96.8551, 47.5383],
    [-96.8573, 47.5334],
    [-96.8695, 47.5288],
    [-96.8675, 47.5259],
    [-96.8636, 47.5203],
    [-96.8585, 47.5149],
    [-96.8458, 47.5170],
    [-96.8433, 47.5129],
    [-96.8514, 47.5135],
    [-96.8524, 47.5099],
    [-96.8433, 47.5099],
    [-96.8487, 47.5064],
    [-96.8533, 47.5039],
    [-96.8491, 47.4992],
    [-96.8490, 47.4978],
    [-96.8561, 47.4943],
    [-96.8636, 47.4926],
    [-96.8634, 47.4897],
    [-96.8538, 47.4836],
    [-96.8634, 47.4837],
    [-96.8684, 47.4775],
    [-96.8605, 47.4807],
    [-96.8519, 47.4787],
    [-96.8600, 47.4737],
    [-96.8573, 47.4641],
    [-96.8547, 47.4595],
    [-96.8636, 47.4573],
    [-96.8562, 47.4555],
    [-96.8557, 47.4527],
    [-96.8570, 47.4490],
    [-96.8595, 47.4457],
    [-96.8567, 47.4384],
    [-96.8626, 47.4357],
    [-96.8544, 47.4334],
    [-96.8569, 47.4312],
    [-96.8637, 47.4291],
    [-96.8625, 47.4265],
    [-96.8554, 47.4266],
    [-96.8595, 47.4233],
    [-96.8703, 47.4202],
    [-96.8688, 47.4183],
    [-96.8612, 47.4178],
    [-96.8618, 47.4143],
    [-96.8557, 47.4096],
    [-96.8423, 47.4119],
    [-96.8434, 47.4096],
    [-96.8527, 47.4059],
    [-96.8421, 47.4007],
    [-96.8433, 47.3966],
    [-96.8489, 47.3935],
    [-96.8418, 47.3925],
    [-96.8374, 47.3893],
    [-96.8418, 47.3857],
    [-96.8398, 47.3809],
    [-96.8482, 47.3827],
    [-96.8468, 47.3791],
    [-96.8461, 47.3747],
    [-96.8546, 47.3738],
    [-96.8489, 47.3706],
    [-96.8384, 47.3735],
    [-96.8425, 47.3685],
    [-96.8573, 47.3689],
    [-96.8524, 47.3662],
    [-96.8482, 47.3628],
    [-96.8522, 47.3584],
    [-96.8381, 47.3560],
    [-96.8438, 47.3546],
    [-96.8429, 47.3509],
    [-96.8466, 47.3470],
    [-96.8380, 47.3406],
    [-96.8306, 47.3386],
    [-96.8364, 47.3319],
    [-96.8461, 47.3299],
    [-96.8429, 47.3266],
    [-96.8362, 47.3305],
    [-96.8300, 47.3295],
    [-96.8305, 47.3260],
    [-96.8370, 47.3245],
    [-96.8347, 47.3202],
    [-96.8386, 47.3185],
    [-96.8470, 47.3158],
    [-96.8424, 47.3130],
    [-96.8403, 47.3091],
    [-96.8357, 47.3108],
    [-96.8307, 47.3054],
    [-96.8441, 47.2900],
    [-96.8404, 47.2755],
    [-96.8475, 47.2718],
    [-96.8398, 47.2688],
    [-96.8358, 47.2652],
    [-96.8450, 47.2653],
    [-96.8439, 47.2615],
    [-96.8365, 47.2629],
    [-96.8388, 47.2593],
    [-96.8453, 47.2578],
    [-96.8396, 47.2565],
    [-96.8414, 47.2539],
    [-96.8423, 47.2494],
    [-96.8365, 47.2522],
    [-96.8332, 47.2459],
    [-96.8430, 47.2421],
    [-96.8400, 47.2398],
    [-96.8367, 47.2425],
    [-96.8324, 47.2376],
    [-96.8289, 47.2322],
    [-96.8346, 47.2339],
    [-96.8428, 47.2313],
    [-96.8342, 47.2291],
    [-96.8388, 47.2243],
    [-96.8450, 47.2186],
    [-96.8401, 47.2216],
    [-96.8347, 47.2224],
    [-96.8366, 47.2172],
    [-96.8329, 47.2131],
    [-96.8328, 47.2087],
    [-96.8357, 47.2064],
    [-96.8272, 47.2017],
    [-96.8316, 47.2021],
    [-96.8386, 47.1991],
    [-96.8420, 47.1909],
    [-96.8404, 47.1954],
    [-96.8354, 47.1951],
    [-96.8263, 47.1891],
    [-96.8349, 47.1867],
    [-96.8319, 47.1835],
    [-96.8216, 47.1843],
    [-96.8276, 47.1818],
    [-96.8265, 47.1774],
    [-96.8334, 47.1763],
    [-96.8264, 47.1742],
    [-96.8245, 47.1699],
    [-96.8225, 47.1660],
    [-96.8200, 47.1630],
    [-96.8303, 47.1609],
    [-96.8250, 47.1586],
    [-96.8227, 47.1562],
    [-96.8331, 47.1555],
    [-96.8366, 47.1552],
    [-96.8407, 47.1525],
    [-96.8398, 47.1505],
    [-96.8333, 47.1497],
    [-96.8286, 47.1464],
    [-96.8346, 47.1441],
    [-96.8295, 47.1409],
    [-96.8270, 47.1333],
    [-96.8292, 47.1287],
    [-96.8200, 47.1309],
    [-96.8248, 47.1250],
    [-96.8299, 47.1228],
    [-96.8376, 47.1220],
    [-96.8290, 47.1209],
    [-96.8212, 47.1157],
    [-96.8227, 47.1096],
    [-96.8168, 47.1091],
    [-96.8194, 47.1024],
    [-96.8177, 47.0951],
    [-96.8254, 47.0903],
    [-96.8249, 47.0881],
    [-96.8156, 47.0876],
    [-96.8204, 47.0830],
    [-96.8167, 47.0785],
    [-96.8293, 47.0746],
    [-96.8264, 47.0728],
    [-96.8219, 47.0747],
    [-96.8231, 47.0721],
    [-96.8218, 47.0644],
    [-96.8199, 47.0623],
    [-96.8284, 47.0619],
    [-96.8263, 47.0591],
    [-96.8219, 47.0581],
    [-96.8187, 47.0531],
    [-96.8268, 47.0469],
    [-96.8205, 47.0476],
    [-96.8208, 47.0414],
    [-96.8184, 47.0367],
    [-96.8138, 47.0397],
    [-96.8188, 47.0331],
    [-96.8273, 47.0313],
    [-96.8192, 47.0294],
    [-96.8153, 47.0239],
    [-96.8264, 47.0232],
    [-96.8307, 47.0188],
    [-96.8330, 47.0160],
    [-96.8335, 47.0101],
    [-96.8381, 47.0061],
    [-96.8333, 47.0044],
    [-96.8281, 47.0043],
    [-96.8232, 47.0037],
    [-96.8230, 47.0014],
    [-96.8194, 46.9977],
    [-96.8245, 46.9962],
    [-96.8225, 46.9901],
    [-96.8262, 46.9875],
    [-96.8201, 46.9768],
    [-96.8216, 46.9725],
    [-96.8196, 46.9675],
    [-96.8133, 46.9662],
    [-96.8073, 46.9646],
    [-96.8039, 46.9656],
    [-96.8022, 46.9675],
    [-96.7981, 46.9622],
    [-96.8031, 46.9565],
    [-96.7987, 46.9519],
    [-96.8003, 46.9485],
    [-96.8031, 46.9484],
    [-96.7988, 46.9448],
    [-96.7927, 46.9468],
    [-96.7922, 46.9406],
    [-96.7916, 46.9339],
    [-96.7918, 46.9285],
    [-96.7877, 46.9302],
    [-96.7858, 46.9250],
    [-96.7786, 46.9281],
    [-96.7767, 46.9264],
    [-96.7655, 46.9339],
    [-96.7613, 46.9322],
    [-96.7591, 46.9278],
    [-96.7653, 46.9276],
    [-96.7538, 46.9231],
    [-96.7633, 46.9234],
    [-96.7592, 46.9182],
    [-96.7625, 46.9181],
    [-96.7640, 46.9125],
    [-96.7657, 46.9051],
    [-96.7736, 46.9036],
    [-96.7751, 46.8995],
    [-96.7702, 46.8937],
    [-96.7736, 46.8895],
    [-96.7719, 46.8841],
    [-96.7680, 46.8846],
    [-96.7698, 46.8776],
    [-96.7714, 46.8798],
    [-96.7756, 46.8792],
    [-96.7814, 46.8794],
    [-96.7803, 46.8770],
    [-96.7762, 46.8739],
    [-96.7809, 46.8694],
    [-96.7808, 46.8672],
    [-96.7840, 46.8617],
    [-96.7773, 46.8573],
    [-96.7839, 46.8558],
    [-96.7814, 46.8512],
    [-96.7735, 46.8517],
    [-96.7807, 46.8476],
    [-96.7793, 46.8437],
    [-96.7754, 46.8389],
    [-96.7872, 46.8411],
    [-96.7828, 46.8371],
    [-96.7872, 46.8326],
    [-96.7869, 46.8303],
    [-96.7803, 46.8257],
    [-96.7894, 46.8274],
    [-96.7926, 46.8233],
    [-96.8002, 46.8197],
    [-96.8004, 46.8135],
    [-96.8014, 46.8104],
    [-96.7968, 46.8065],
    [-96.8017, 46.8043],
    [-96.7963, 46.8034],
    [-96.7981, 46.7991],
    [-96.7996, 46.7963],
    [-96.7943, 46.7946],
    [-96.7962, 46.7899],
    [-96.7893, 46.7892],
    [-96.7874, 46.7851],
    [-96.7967, 46.7775],
    [-96.7888, 46.7776],
    [-96.7831, 46.7761],
    [-96.7889, 46.7750],
    [-96.7850, 46.7688],
    [-96.7782, 46.7645],
    [-96.7879, 46.7642],
    [-96.7779, 46.7616],
    [-96.7843, 46.7617],
    [-96.7836, 46.7591],
    [-96.7877, 46.7579],
    [-96.7872, 46.7551],
    [-96.7847, 46.7532],
    [-96.7863, 46.7513],
    [-96.7846, 46.7487],
    [-96.7820, 46.7459],
    [-96.7819, 46.7444],
    [-96.7853, 46.7427],
    [-96.7812, 46.7409],
    [-96.7811, 46.7375],
    [-96.7843, 46.7330],
    [-96.7810, 46.7295],
    [-96.7795, 46.7260],
    [-96.7848, 46.7205],
    [-96.7891, 46.7175],
    [-96.7821, 46.7165],
    [-96.7844, 46.7159],
    [-96.7838, 46.7120],
    [-96.7892, 46.7099],
    [-96.7841, 46.7063],
    [-96.7895, 46.7047],
    [-96.7909, 46.7030],
    [-96.7844, 46.7009],
    [-96.7849, 46.6944],
    [-96.7861, 46.6915],
    [-96.7898, 46.6884],
    [-96.7842, 46.6868],
    [-96.7882, 46.6819],
    [-96.7947, 46.6824],
    [-96.7875, 46.6778],
    [-96.7934, 46.6775],
    [-96.7967, 46.6789],
    [-96.7967, 46.6733],
    [-96.7923, 46.6718],
    [-96.7942, 46.6680],
    [-96.8013, 46.6685],
    [-96.7983, 46.6641],
    [-96.7997, 46.6606],
    [-96.7989, 46.6541],
    [-96.7909, 46.6478],
    [-96.7908, 46.6426],
    [-96.7859, 46.6402],
    [-96.7930, 46.6343],
    [-96.7979, 46.6291],
    [-96.7958, 46.6314],
    [-96.7852, 46.6311],
    [-96.7857, 46.6274],
    [-96.7903, 46.6244],
    [-96.7784, 46.6270],
    [-96.7872, 46.6213],
    [-96.7828, 46.6201],
    [-96.7755, 46.6212],
    [-96.7794, 46.6173],
    [-96.7770, 46.6139],
    [-96.7712, 46.6157],
    [-96.7741, 46.6133],
    [-96.7752, 46.6084],
    [-96.7764, 46.6054],
    [-96.7685, 46.6054],
    [-96.7722, 46.6011],
    [-96.7705, 46.5955],
    [-96.7653, 46.5977],
    [-96.7575, 46.5955],
    [-96.7575, 46.5915],
    [-96.7627, 46.5895],
    [-96.7530, 46.5884],
    [-96.7516, 46.5846],
    [-96.7527, 46.5828],
    [-96.7521, 46.5808],
    [-96.7557, 46.5780],
    [-96.7565, 46.5751],
    [-96.7523, 46.5763],
    [-96.7461, 46.5744],
    [-96.7524, 46.5730],
    [-96.7510, 46.5709],
    [-96.7459, 46.5690],
    [-96.7438, 46.5672],
    [-96.7419, 46.5642],
    [-96.7454, 46.5652],
    [-96.7506, 46.5628],
    [-96.7475, 46.5600],
    [-96.7516, 46.5583],
    [-96.7521, 46.5556],
    [-96.7466, 46.5542],
    [-96.7463, 46.5506],
    [-96.7405, 46.5461],
    [-96.7445, 46.5483],
    [-96.7500, 46.5450],
    [-96.7428, 46.5436],
    [-96.7410, 46.5426],
    [-96.7432, 46.5403],
    [-96.7417, 46.5378],
    [-96.7384, 46.5359],
    [-96.7451, 46.5354],
    [-96.7427, 46.5321],
    [-96.7454, 46.5252],
    [-96.7367, 46.5241],
    [-96.7438, 46.5193],
    [-96.7380, 46.5157],
    [-96.7395, 46.5116],
    [-96.7348, 46.5073],
    [-96.7423, 46.5002],
    [-96.7367, 46.5011],
    [-96.7358, 46.4978],
    [-96.7332, 46.4928],
    [-96.7385, 46.4881],
    [-96.7355, 46.4849],
    [-96.7363, 46.4814],
    [-96.7355, 46.4777],
    [-96.7292, 46.4769],
    [-96.7269, 46.4720],
    [-96.7174, 46.4728],
    [-96.7170, 46.4707],
    [-96.7215, 46.4652],
    [-96.7130, 46.4663],
    [-96.7187, 46.4621],
    [-96.7117, 46.4600],
    [-96.7124, 46.4563],
    [-96.7166, 46.4560],
    [-96.7139, 46.4525],
    [-96.7209, 46.4495],
    [-96.7199, 46.4467],
    [-96.7168, 46.4463],
    [-96.7138, 46.4457],
    [-96.7180, 46.4420],
    [-96.7174, 46.4386],
    [-96.7118, 46.4362],
    [-96.7033, 46.4365],
    [-96.7075, 46.4296],
    [-96.7008, 46.4299],
    [-96.6989, 46.4264],
    [-96.7023, 46.4227],
    [-96.7032, 46.4175],
    [-96.6935, 46.4221],
    [-96.6920, 46.4166],
    [-96.6999, 46.4171],
    [-96.6977, 46.4126],
    [-96.6851, 46.4139],
    [-96.6899, 46.4095],
    [-96.6820, 46.4078],
    [-96.6763, 46.4001],
    [-96.6752, 46.3918],
    [-96.6676, 46.3910],
    [-96.6693, 46.3884],
    [-96.6669, 46.3801],
    [-96.6580, 46.3745],
    [-96.6580, 46.3705],
    [-96.6565, 46.3694],
    [-96.6465, 46.3625],
    [-96.6477, 46.3590],
    [-96.6427, 46.3500],
    [-96.6332, 46.3527],
    [-96.6292, 46.3527],
    [-96.6208, 46.3476],
    [-96.6181, 46.3443],
    [-96.6165, 46.3394],
    [-96.6088, 46.3351],
    [-96.6010, 46.3311],
    [-96.6051, 46.3277],
    [-96.6055, 46.3259],
    [-96.6010, 46.3196],
    [-96.5971, 46.3159],
    [-96.6003, 46.3089],
    [-96.6035, 46.3029],
    [-96.6003, 46.3004],
    [-96.6051, 46.2947],
    [-96.5970, 46.2918],
    [-96.5961, 46.2893],
    [-96.6018, 46.2860],
    [-96.5948, 46.2863],
    [-96.5991, 46.2830],
    [-96.5987, 46.2796],
    [-96.5950, 46.2751],
    [-96.5959, 46.2715],
    [-96.5968, 46.2679],
    [-96.5991, 46.2637],
    [-96.5982, 46.2611],
    [-96.5932, 46.2576],
    [-96.5952, 46.2539],
    [-96.5911, 46.2497],
    [-96.5853, 46.2504],
    [-96.5855, 46.2475],
    [-96.5914, 46.2453],
    [-96.5952, 46.2441],
    [-96.5982, 46.2395],
    [-96.5986, 46.2351],
    [-96.5975, 46.2277],
    [-96.5917, 46.2182],
    [-96.5910, 46.2086],
    [-96.5843, 46.2074],
    [-96.5890, 46.2048],
    [-96.5844, 46.2042],
    [-96.5843, 46.1981],
    [-96.5909, 46.1959],
    [-96.5877, 46.1953],
    [-96.5877, 46.1918],
    [-96.5873, 46.1883],
    [-96.5874, 46.1858],
    [-96.5872, 46.1827],
    [-96.5890, 46.1815],
    [-96.5918, 46.1769],
    [-96.5881, 46.1764],
    [-96.5845, 46.1771],
    [-96.5833, 46.1742],
    [-96.5801, 46.1717],
    [-96.5809, 46.1697],
    [-96.5777, 46.1664],
    [-96.5780, 46.1607],
    [-96.5783, 46.1532],
    [-96.5795, 46.1476],
    [-96.5711, 46.1368],
    [-96.5686, 46.1323],
    [-96.5697, 46.1262],
    [-96.5700, 46.1238],
    [-96.5657, 46.1194],
    [-96.5628, 46.1163],
    [-96.5631, 46.1101],
    [-96.5632, 46.1080],
    [-96.5588, 46.1007],
    [-96.5572, 46.0895],
    [-96.5558, 46.0797],
    [-96.5569, 46.0762],
    [-96.5581, 46.0712],
    [-96.5585, 46.0632],
    [-96.5609, 46.0554],
    [-96.5779, 46.0269],
    [-96.5743, 46.0165],
    [-96.5736, 46.0023],
    [-96.5703, 45.9636],
    [-96.5654, 45.9535],
    [-96.5613, 45.9457],
    [-96.5769, 45.9353],
    [-96.6071, 45.9353],
    [-96.6391, 45.9353],
    [-96.7013, 45.9358],
    [-96.7638, 45.9358],
    [-96.7990, 45.9356],
    [-96.8440, 45.9355],
    [-96.9667, 45.9357],
    [-97.0004, 45.9352],
    [-97.0750, 45.9358],
    [-97.1181, 45.9355],
    [-97.2283, 45.9351],
    [-97.3122, 45.9351],
    [-97.3541, 45.9351],
    [-97.4804, 45.9351],
    [-97.4919, 45.9351],
    [-97.5190, 45.9353],
    [-97.6048, 45.9353],
    [-97.7295, 45.9354],
    [-97.7846, 45.9353],
    [-97.9587, 45.9359],
    [-98.0081, 45.9361],
    [-98.1027, 45.9362],
    [-98.1856, 45.9362],
    [-98.3522, 45.9364],
    [-98.4763, 45.9370],
    [-98.6254, 45.9382],
    [-98.7563, 45.9388],
    [-98.8456, 45.9392],
    [-98.9055, 45.9395],
    [-99.0058, 45.9399],
    [-99.1024, 45.9402],
    [-99.2217, 45.9401],
    [-99.2763, 45.9402],
    [-99.3179, 45.9403],
    [-99.3785, 45.9404],
    [-99.4428, 45.9404],
    [-99.4931, 45.9404],
    [-99.6300, 45.9411],
    [-99.7181, 45.9409],
    [-99.7493, 45.9409],
    [-99.8387, 45.9413],
    [-99.9658, 45.9418],
    [-100.0676, 45.9422],
    [-100.0842, 45.9423],
    [-100.1103, 45.9424],
    [-100.1708, 45.9425],
    [-100.2841, 45.9430],
    [-100.4104, 45.9435],
    [-100.4306, 45.9436],
    [-100.5035, 45.9436],
    [-100.6277, 45.9436],
    [-100.7081, 45.9440],
    [-100.7621, 45.9438],
    [-100.7938, 45.9438],
    [-100.8902, 45.9439],
    [-100.9600, 45.9438],
    [-100.9773, 45.9439],
    [-101.1013, 45.9438],
    [-101.1461, 45.9438],
    [-101.1757, 45.9440],
    [-101.2055, 45.9439],
    [-101.2872, 45.9441],
    [-101.3339, 45.9442],
    [-101.3738, 45.9443],
    [-101.5573, 45.9441],
    [-101.6286, 45.9443],
    [-101.6818, 45.9444],
    [-101.7212, 45.9442],
    [-101.7586, 45.9445],
    [-101.7662, 45.9443],
    [-101.8242, 45.9444],
    [-101.8744, 45.9445],
    [-101.9737, 45.9445],
    [-101.9915, 45.9445],
    [-101.9987, 45.9446],
    [-102.0007, 45.9445],
    [-102.0876, 45.9446],
    [-102.1246, 45.9448],
    [-102.1454, 45.9447],
    [-102.1580, 45.9446],
    [-102.1767, 45.9446],
    [-102.1971, 45.9447],
    [-102.3207, 45.9448],
    [-102.3543, 45.9449],
    [-102.3928, 45.9450],
    [-102.4062, 45.9450],
    [-102.4254, 45.9450],
    [-102.4464, 45.9451],
    [-102.4760, 45.9452],
    [-102.5586, 45.9451],
    [-102.6426, 45.9454],
    [-102.6667, 45.9453],
    [-102.6937, 45.9451],
    [-102.8179, 45.9451],
    [-102.9205, 45.9450],
    [-102.9899, 45.9452],
    [-103.0261, 45.9453],
    [-103.0979, 45.9453],
    [-103.1613, 45.9453],
    [-103.2451, 45.9452],
    [-103.2841, 45.9452],
    [-103.3755, 45.9448],
    [-103.4324, 45.9453],
    [-103.5587, 45.9451],
    [-103.6608, 45.9452],
    [-103.7428, 45.9453],
    [-104.0458, 46.1191],
    [-104.0453, 46.2059],
    [-104.0455, 46.3419],
    [-104.0450, 46.5098],
    [-104.0453, 46.6414],
    [-104.0456, 46.7139],
    [-104.0454, 46.7254],
    [-104.0456, 46.9186],
    [-104.0455, 46.9340],
    [-104.0451, 47.0376],
    [-104.0452, 47.0575],
    [-104.0454, 47.0786],
    [-104.0448, 47.1274],
    [-104.0452, 47.2639],
    [-104.0451, 47.2714],
    [-104.0453, 47.3301],
    [-104.0449, 47.3750],
    [-104.0448, 47.4384],
    [-104.0439, 47.5904],
    [-104.0437, 47.6250],
    [-104.0432, 47.7473],
    [-104.0425, 47.8067],
    [-104.0419, 47.8417],
    [-104.0417, 47.8583],
    [-104.0422, 47.8910],
    [-104.0439, 47.9715],
    [-104.0443, 48.0248],
    [-104.0452, 48.1373],
    [-104.0455, 48.1762],
    [-104.0456, 48.1981],
    [-104.0456, 48.2462],
    [-104.0460, 48.2568],
    [-104.0462, 48.2994],
    [-104.0463, 48.3211],
    [-104.0464, 48.3732],
    [-104.0468, 48.3808],
    [-104.0469, 48.3893],
    [-104.0471, 48.4111],
    [-104.0472, 48.4473],
    [-104.0473, 48.4600],
    [-104.0481, 48.5000],
    [-104.0479, 48.5308],
    [-104.0478, 48.5396],
    [-104.0478, 48.5628],
    [-104.0482, 48.5976],
    [-104.0479, 48.6210],
    [-104.0476, 48.6340],
    [-104.0479, 48.6499],
    [-104.0478, 48.6632],
    [-104.0480, 48.6772],
    [-104.0485, 48.7514],
    [-104.0486, 48.7971],
    [-104.0487, 48.8638]
    ]
  },
  "Arkansas": {
    coordinates: [
      [-94.6178, 36.4994],
    [-94.5546, 36.4995],
    [-94.4764, 36.4993],
    [-94.4474, 36.4994],
    [-94.3612, 36.4996],
    [-94.3274, 36.4995],
    [-94.3071, 36.4994],
    [-94.2761, 36.4993],
    [-94.2537, 36.4992],
    [-94.2154, 36.4990],
    [-94.1841, 36.4989],
    [-94.1160, 36.4986],
    [-94.1115, 36.4986],
    [-94.0986, 36.4987],
    [-94.0734, 36.4987],
    [-93.9895, 36.4987],
    [-93.9671, 36.4987],
    [-93.9592, 36.4987],
    [-93.9061, 36.4987],
    [-93.8343, 36.4988],
    [-93.7522, 36.4990],
    [-93.7276, 36.4991],
    [-93.7098, 36.4992],
    [-93.6894, 36.4991],
    [-93.6588, 36.4990],
    [-93.5834, 36.4989],
    [-93.4923, 36.4988],
    [-93.4748, 36.4988],
    [-93.4334, 36.4986],
    [-93.4013, 36.4987],
    [-93.3968, 36.4987],
    [-93.3952, 36.4986],
    [-93.3858, 36.4985],
    [-93.3153, 36.4984],
    [-93.2908, 36.4983],
    [-93.1512, 36.4979],
    [-93.0876, 36.4982],
    [-93.0144, 36.4981],
    [-92.9345, 36.4980],
    [-92.9164, 36.4979],
    [-92.8540, 36.4980],
    [-92.7849, 36.4978],
    [-92.6306, 36.4981],
    [-92.6016, 36.4982],
    [-92.5291, 36.4986],
    [-92.4441, 36.4985],
    [-92.4231, 36.4980],
    [-92.3752, 36.4972],
    [-92.3184, 36.4977],
    [-92.2594, 36.4982],
    [-92.2141, 36.4984],
    [-92.1503, 36.4986],
    [-92.1203, 36.4989],
    [-92.0749, 36.4988],
    [-92.0428, 36.4987],
    [-91.9888, 36.4985],
    [-91.9546, 36.4985],
    [-91.9258, 36.4986],
    [-91.8456, 36.4989],
    [-91.8020, 36.4990],
    [-91.7817, 36.4991],
    [-91.7267, 36.4992],
    [-91.6876, 36.4994],
    [-91.6426, 36.4993],
    [-91.6177, 36.4993],
    [-91.5824, 36.4992],
    [-91.5551, 36.4992],
    [-91.5447, 36.4991],
    [-91.5369, 36.4992],
    [-91.5298, 36.4990],
    [-91.5001, 36.4988],
    [-91.4365, 36.4974],
    [-91.4073, 36.4971],
    [-91.4049, 36.4971],
    [-91.2356, 36.4976],
    [-91.2174, 36.4975],
    [-91.1265, 36.4977],
    [-91.0959, 36.4979],
    [-91.0086, 36.4983],
    [-90.9631, 36.4984],
    [-90.9404, 36.4984],
    [-90.8769, 36.4984],
    [-90.8726, 36.4981],
    [-90.8026, 36.4985],
    [-90.7789, 36.4985],
    [-90.7112, 36.4983],
    [-90.6485, 36.4984],
    [-90.6054, 36.4985],
    [-90.5843, 36.4985],
    [-90.5142, 36.4984],
    [-90.4946, 36.4984],
    [-90.4315, 36.4983],
    [-90.3708, 36.4982],
    [-90.3178, 36.4981],
    [-90.2289, 36.4978],
    [-90.2177, 36.4978],
    [-90.1525, 36.4980],
    [-90.1550, 36.4936],
    [-90.1593, 36.4924],
    [-90.1564, 36.4877],
    [-90.1571, 36.4843],
    [-90.1594, 36.4807],
    [-90.1568, 36.4789],
    [-90.1446, 36.4763],
    [-90.1422, 36.4706],
    [-90.1557, 36.4661],
    [-90.1438, 36.4632],
    [-90.1415, 36.4630],
    [-90.1416, 36.4608],
    [-90.1373, 36.4554],
    [-90.1340, 36.4379],
    [-90.1390, 36.4313],
    [-90.1441, 36.4258],
    [-90.1378, 36.4212],
    [-90.1342, 36.4228],
    [-90.1362, 36.4153],
    [-90.1350, 36.4137],
    [-90.1214, 36.4109],
    [-90.1147, 36.4060],
    [-90.1036, 36.4047],
    [-90.0787, 36.3991],
    [-90.0767, 36.3959],
    [-90.0689, 36.3887],
    [-90.0650, 36.3669],
    [-90.0754, 36.3501],
    [-90.0747, 36.3448],
    [-90.0772, 36.3413],
    [-90.0756, 36.3340],
    [-90.0814, 36.3256],
    [-90.0791, 36.3184],
    [-90.0693, 36.3132],
    [-90.0701, 36.2947],
    [-90.0778, 36.2883],
    [-90.0865, 36.2715],
    [-90.1002, 36.2690],
    [-90.1129, 36.2666],
    [-90.1182, 36.2535],
    [-90.1297, 36.2432],
    [-90.1273, 36.2364],
    [-90.1247, 36.2338],
    [-90.1348, 36.2264],
    [-90.1514, 36.2192],
    [-90.1574, 36.2138],
    [-90.1677, 36.2133],
    [-90.1829, 36.2051],
    [-90.1901, 36.2015],
    [-90.1943, 36.2007],
    [-90.1999, 36.1968],
    [-90.2006, 36.1922],
    [-90.2113, 36.1834],
    [-90.2204, 36.1848],
    [-90.2303, 36.1671],
    [-90.2314, 36.1473],
    [-90.2409, 36.1373],
    [-90.2485, 36.1301],
    [-90.2556, 36.1271],
    [-90.2663, 36.1206],
    [-90.2931, 36.1144],
    [-90.2979, 36.1048],
    [-90.3063, 36.0948],
    [-90.3207, 36.0871],
    [-90.3184, 36.0767],
    [-90.3333, 36.0675],
    [-90.3371, 36.0478],
    [-90.3479, 36.0419],
    [-90.3510, 36.0316],
    [-90.3517, 36.0253],
    [-90.3779, 35.9957],
    [-90.3394, 35.9960],
    [-90.2888, 35.9964],
    [-90.1950, 35.9971],
    [-90.1273, 35.9976],
    [-90.1190, 35.9978],
    [-89.9956, 35.9988],
    [-89.9653, 35.9988],
    [-89.9594, 35.9990],
    [-89.9014, 35.9994],
    [-89.8756, 35.9996],
    [-89.8745, 35.9996],
    [-89.8418, 35.9999],
    [-89.7703, 36.0005],
    [-89.7376, 36.0006],
    [-89.7312, 35.9969],
    [-89.7188, 35.9850],
    [-89.7188, 35.9683],
    [-89.6999, 35.9541],
    [-89.6711, 35.9358],
    [-89.6503, 35.9178],
    [-89.6466, 35.8998],
    [-89.6484, 35.8938],
    [-89.6696, 35.8833],
    [-89.6881, 35.8969],
    [-89.7549, 35.8989],
    [-89.7687, 35.8867],
    [-89.7736, 35.8717],
    [-89.7694, 35.8616],
    [-89.7295, 35.8476],
    [-89.7029, 35.8342],
    [-89.7017, 35.8242],
    [-89.7061, 35.8183],
    [-89.7234, 35.8094],
    [-89.7579, 35.8104],
    [-89.7818, 35.8051],
    [-89.7971, 35.7826],
    [-89.8093, 35.7644],
    [-89.8212, 35.7567],
    [-89.8463, 35.7557],
    [-89.8728, 35.7413],
    [-89.8882, 35.7501],
    [-89.9100, 35.7594],
    [-89.9192, 35.7532],
    [-89.9446, 35.7412],
    [-89.9563, 35.7334],
    [-89.9582, 35.7193],
    [-89.9558, 35.6906],
    [-89.9502, 35.6824],
    [-89.9327, 35.6615],
    [-89.9154, 35.6528],
    [-89.8905, 35.6524],
    [-89.8829, 35.6575],
    [-89.8721, 35.6685],
    [-89.8589, 35.6691],
    [-89.8509, 35.6502],
    [-89.8533, 35.6400],
    [-89.8639, 35.6308],
    [-89.8970, 35.6149],
    [-89.9107, 35.6175],
    [-89.9244, 35.6106],
    [-89.9511, 35.5975],
    [-89.9579, 35.5873],
    [-89.9542, 35.5760],
    [-89.9414, 35.5566],
    [-89.9193, 35.5498],
    [-89.9132, 35.5496],
    [-89.9083, 35.5464],
    [-89.9073, 35.5433],
    [-89.9113, 35.5397],
    [-89.9123, 35.5377],
    [-89.9092, 35.5379],
    [-89.9044, 35.5357],
    [-89.9090, 35.5205],
    [-89.9193, 35.5139],
    [-89.9340, 35.5186],
    [-89.9512, 35.5219],
    [-89.9577, 35.5301],
    [-89.9567, 35.5394],
    [-89.9894, 35.5600],
    [-90.0001, 35.5610],
    [-90.0173, 35.5560],
    [-90.0286, 35.5552],
    [-90.0397, 35.5480],
    [-90.0462, 35.5296],
    [-90.0485, 35.5044],
    [-90.0350, 35.4807],
    [-90.0189, 35.4662],
    [-90.0242, 35.4543],
    [-90.0266, 35.4401],
    [-90.0313, 35.4316],
    [-90.0426, 35.4212],
    [-90.0466, 35.4130],
    [-90.0416, 35.3966],
    [-90.0545, 35.3897],
    [-90.0620, 35.4152],
    [-90.0741, 35.4396],
    [-90.0671, 35.4648],
    [-90.0801, 35.4768],
    [-90.0987, 35.4786],
    [-90.1144, 35.4725],
    [-90.1231, 35.4599],
    [-90.1690, 35.4219],
    [-90.1793, 35.3852],
    [-90.1662, 35.3747],
    [-90.1435, 35.3876],
    [-90.1451, 35.4038],
    [-90.1379, 35.4115],
    [-90.1169, 35.4117],
    [-90.1068, 35.4033],
    [-90.0936, 35.3933],
    [-90.0780, 35.3845],
    [-90.0879, 35.3633],
    [-90.0968, 35.3572],
    [-90.1088, 35.3426],
    [-90.1068, 35.3246],
    [-90.1219, 35.3045],
    [-90.1395, 35.2988],
    [-90.1589, 35.3006],
    [-90.1652, 35.2932],
    [-90.1666, 35.2746],
    [-90.1450, 35.2538],
    [-90.1236, 35.2550],
    [-90.1051, 35.2543],
    [-90.0909, 35.2422],
    [-90.0787, 35.2278],
    [-90.0742, 35.2171],
    [-90.0768, 35.2088],
    [-90.0886, 35.2124],
    [-90.0974, 35.1948],
    [-90.1175, 35.1906],
    [-90.1111, 35.1786],
    [-90.1081, 35.1746],
    [-90.0998, 35.1645],
    [-90.0904, 35.1563],
    [-90.0687, 35.1531],
    [-90.0648, 35.1419],
    [-90.0654, 35.1377],
    [-90.0757, 35.1280],
    [-90.0867, 35.1198],
    [-90.1094, 35.1189],
    [-90.1447, 35.1350],
    [-90.1653, 35.1252],
    [-90.1731, 35.1185],
    [-90.1814, 35.0914],
    [-90.1966, 35.0561],
    [-90.1961, 35.0374],
    [-90.2094, 35.0265],
    [-90.2248, 35.0300],
    [-90.2624, 35.0364],
    [-90.2653, 35.0403],
    [-90.2956, 35.0401],
    [-90.3069, 35.0182],
    [-90.3099, 35.0011],
    [-90.3025, 34.9821],
    [-90.2872, 34.9725],
    [-90.2597, 34.9578],
    [-90.2495, 34.9504],
    [-90.2445, 34.9376],
    [-90.2483, 34.9097],
    [-90.3020, 34.8801],
    [-90.3044, 34.8606],
    [-90.3027, 34.8544],
    [-90.3113, 34.8442],
    [-90.3323, 34.8525],
    [-90.3482, 34.8551],
    [-90.4016, 34.8353],
    [-90.4149, 34.8318],
    [-90.4288, 34.8414],
    [-90.4317, 34.8589],
    [-90.4301, 34.8712],
    [-90.4413, 34.8863],
    [-90.4598, 34.8919],
    [-90.4799, 34.8833],
    [-90.4850, 34.8693],
    [-90.4744, 34.8495],
    [-90.4568, 34.8204],
    [-90.4705, 34.8050],
    [-90.4746, 34.7932],
    [-90.4589, 34.7643],
    [-90.4513, 34.7445],
    [-90.4550, 34.7356],
    [-90.4797, 34.7248],
    [-90.5114, 34.7276],
    [-90.5244, 34.7421],
    [-90.5165, 34.7583],
    [-90.5010, 34.7712],
    [-90.5128, 34.7965],
    [-90.5229, 34.8023],
    [-90.5402, 34.7958],
    [-90.5482, 34.7819],
    [-90.5426, 34.7644],
    [-90.5354, 34.7501],
    [-90.5501, 34.7420],
    [-90.5635, 34.7387],
    [-90.5681, 34.7281],
    [-90.5675, 34.7233],
    [-90.5461, 34.7021],
    [-90.5221, 34.6966],
    [-90.4870, 34.7015],
    [-90.4712, 34.6991],
    [-90.4637, 34.6911],
    [-90.4637, 34.6814],
    [-90.4797, 34.6599],
    [-90.5031, 34.6408],
    [-90.5245, 34.6285],
    [-90.5437, 34.6296],
    [-90.5541, 34.6409],
    [-90.5526, 34.6597],
    [-90.5381, 34.6732],
    [-90.5428, 34.6888],
    [-90.5523, 34.6971],
    [-90.5634, 34.6959],
    [-90.5787, 34.6838],
    [-90.5885, 34.6686],
    [-90.5850, 34.6471],
    [-90.5834, 34.6414],
    [-90.5817, 34.6042],
    [-90.5649, 34.5826],
    [-90.5459, 34.5633],
    [-90.5413, 34.5453],
    [-90.5553, 34.5310],
    [-90.5798, 34.5146],
    [-90.5865, 34.5001],
    [-90.5899, 34.4848],
    [-90.5837, 34.4588],
    [-90.5673, 34.4404],
    [-90.5665, 34.4295],
    [-90.5711, 34.4203],
    [-90.5807, 34.4106],
    [-90.6316, 34.3872],
    [-90.6585, 34.3757],
    [-90.6669, 34.3486],
    [-90.6574, 34.3273],
    [-90.6693, 34.3130],
    [-90.6900, 34.3186],
    [-90.6916, 34.3386],
    [-90.6762, 34.3711],
    [-90.7001, 34.3659],
    [-90.7249, 34.3637],
    [-90.7416, 34.3672],
    [-90.7621, 34.3648],
    [-90.7684, 34.3535],
    [-90.7652, 34.3428],
    [-90.7427, 34.3203],
    [-90.7431, 34.3023],
    [-90.7652, 34.2805],
    [-90.7976, 34.2824],
    [-90.8209, 34.2778],
    [-90.8306, 34.2712],
    [-90.8370, 34.2501],
    [-90.8395, 34.2262],
    [-90.8448, 34.2110],
    [-90.8567, 34.2116],
    [-90.8946, 34.2244],
    [-90.9043, 34.2410],
    [-90.9124, 34.2459],
    [-90.9335, 34.2402],
    [-90.9370, 34.2270],
    [-90.9160, 34.1969],
    [-90.8879, 34.1820],
    [-90.8738, 34.1832],
    [-90.8591, 34.1863],
    [-90.8382, 34.1838],
    [-90.8124, 34.1808],
    [-90.8087, 34.1759],
    [-90.8109, 34.1559],
    [-90.8257, 34.1420],
    [-90.8472, 34.1369],
    [-90.8679, 34.1421],
    [-90.8944, 34.1610],
    [-90.9381, 34.1488],
    [-90.9585, 34.1251],
    [-90.9485, 34.1113],
    [-90.9184, 34.0931],
    [-90.8935, 34.0978],
    [-90.8789, 34.0946],
    [-90.8705, 34.0827],
    [-90.8719, 34.0764],
    [-90.8864, 34.0586],
    [-90.8891, 34.0464],
    [-90.8874, 34.0325],
    [-90.8995, 34.0238],
    [-90.9237, 34.0231],
    [-90.9503, 34.0178],
    [-90.9769, 34.0213],
    [-90.9799, 34.0001],
    [-90.9615, 33.9799],
    [-90.9652, 33.9655],
    [-90.9769, 33.9605],
    [-90.9949, 33.9631],
    [-91.0050, 33.9770],
    [-91.0338, 33.9953],
    [-91.0484, 33.9851],
    [-91.0754, 33.9836],
    [-91.0879, 33.9753],
    [-91.0898, 33.9660],
    [-91.0841, 33.9562],
    [-91.0467, 33.9474],
    [-91.0130, 33.9323],
    [-91.0100, 33.9270],
    [-91.0264, 33.9080],
    [-91.0553, 33.8830],
    [-91.0728, 33.8624],
    [-91.0675, 33.8404],
    [-91.0528, 33.8242],
    [-91.0424, 33.8129],
    [-91.0201, 33.8044],
    [-90.9917, 33.7926],
    [-90.9885, 33.7845],
    [-90.9938, 33.7736],
    [-91.0233, 33.7630],
    [-91.0605, 33.7776],
    [-91.1073, 33.7706],
    [-91.1178, 33.7790],
    [-91.1322, 33.7834],
    [-91.1399, 33.7771],
    [-91.1448, 33.7640],
    [-91.1408, 33.7597],
    [-91.1445, 33.7493],
    [-91.1466, 33.7325],
    [-91.1323, 33.7142],
    [-91.1076, 33.7047],
    [-91.0754, 33.7144],
    [-91.0599, 33.7148],
    [-91.0413, 33.6999],
    [-91.0361, 33.6891],
    [-91.0303, 33.6816],
    [-91.0346, 33.6730],
    [-91.0505, 33.6681],
    [-91.0785, 33.6583],
    [-91.0940, 33.6584],
    [-91.1334, 33.6768],
    [-91.1625, 33.7068],
    [-91.1901, 33.7019],
    [-91.2121, 33.6982],
    [-91.2253, 33.6877],
    [-91.2282, 33.6713],
    [-91.2190, 33.6615],
    [-91.1783, 33.6511],
    [-91.1505, 33.6330],
    [-91.1330, 33.6160],
    [-91.1316, 33.5994],
    [-91.1384, 33.5909],
    [-91.1608, 33.5814],
    [-91.1811, 33.5815],
    [-91.2032, 33.5708],
    [-91.2285, 33.5647],
    [-91.2325, 33.5575],
    [-91.2263, 33.5412],
    [-91.1874, 33.5106],
    [-91.1831, 33.4986],
    [-91.1956, 33.4885],
    [-91.2068, 33.4703],
    [-91.2202, 33.4630],
    [-91.2326, 33.4540],
    [-91.2343, 33.4423],
    [-91.2174, 33.4347],
    [-91.1947, 33.4364],
    [-91.1773, 33.4436],
    [-91.1756, 33.4718],
    [-91.1755, 33.4908],
    [-91.1640, 33.4974],
    [-91.1367, 33.4813],
    [-91.1190, 33.4576],
    [-91.1211, 33.4436],
    [-91.1306, 33.4319],
    [-91.1449, 33.4277],
    [-91.1763, 33.4170],
    [-91.1920, 33.4177],
    [-91.2053, 33.4142],
    [-91.2090, 33.4036],
    [-91.1930, 33.3909],
    [-91.1720, 33.3810],
    [-91.1409, 33.3805],
    [-91.1072, 33.3991],
    [-91.0953, 33.4257],
    [-91.0967, 33.4376],
    [-91.0865, 33.4516],
    [-91.0746, 33.4558],
    [-91.0598, 33.4503],
    [-91.0582, 33.4287],
    [-91.0700, 33.4121],
    [-91.0843, 33.4001],
    [-91.1068, 33.3811],
    [-91.1303, 33.3571],
    [-91.1422, 33.3490],
    [-91.1419, 33.3330],
    [-91.1437, 33.3284],
    [-91.1416, 33.2995],
    [-91.1255, 33.2747],
    [-91.1172, 33.2607],
    [-91.1106, 33.2459],
    [-91.0991, 33.2382],
    [-91.0915, 33.2548],
    [-91.0837, 33.2786],
    [-91.0726, 33.2859],
    [-91.0524, 33.2854],
    [-91.0436, 33.2746],
    [-91.0476, 33.2600],
    [-91.0639, 33.2374],
    [-91.0711, 33.2301],
    [-91.0777, 33.2275],
    [-91.0796, 33.2232],
    [-91.0917, 33.2208],
    [-91.0844, 33.1809],
    [-91.0869, 33.1487],
    [-91.0932, 33.1367],
    [-91.1317, 33.1291],
    [-91.1519, 33.1318],
    [-91.1617, 33.1418],
    [-91.1887, 33.1398],
    [-91.2018, 33.1251],
    [-91.2011, 33.1082],
    [-91.1863, 33.1006],
    [-91.1735, 33.0893],
    [-91.1607, 33.0856],
    [-91.1212, 33.0592],
    [-91.1234, 33.0466],
    [-91.1374, 33.0287],
    [-91.1562, 33.0236],
    [-91.1661, 33.0041],
    [-91.3055, 33.0052],
    [-91.3225, 33.0053],
    [-91.3264, 33.0054],
    [-91.3583, 33.0057],
    [-91.4358, 33.0061],
    [-91.4892, 33.0062],
    [-91.5723, 33.0069],
    [-91.6090, 33.0066],
    [-91.6267, 33.0066],
    [-91.6991, 33.0073],
    [-91.8003, 33.0073],
    [-91.9243, 33.0076],
    [-91.9778, 33.0076],
    [-92.1889, 33.0089],
    [-92.2927, 33.0101],
    [-92.3680, 33.0107],
    [-92.4398, 33.0116],
    [-92.5014, 33.0122],
    [-92.5250, 33.0124],
    [-92.6639, 33.0138],
    [-92.7082, 33.0143],
    [-92.7158, 33.0144],
    [-92.7247, 33.0143],
    [-92.7965, 33.0148],
    [-92.8441, 33.0160],
    [-92.8675, 33.0161],
    [-92.9710, 33.0172],
    [-93.0366, 33.0176],
    [-93.0814, 33.0179],
    [-93.1197, 33.0178],
    [-93.1974, 33.0180],
    [-93.2386, 33.0180],
    [-93.3404, 33.0183],
    [-93.3959, 33.0183],
    [-93.4670, 33.0186],
    [-93.4895, 33.0184],
    [-93.4910, 33.0184],
    [-93.5210, 33.0186],
    [-93.5315, 33.0186],
    [-93.6763, 33.0193],
    [-93.8146, 33.0194],
    [-93.9182, 33.0193],
    [-94.0358, 33.0191],
    [-94.0430, 33.0795],
    [-94.0430, 33.1173],
    [-94.0431, 33.1382],
    [-94.0429, 33.1998],
    [-94.0429, 33.2152],
    [-94.0430, 33.2518],
    [-94.0430, 33.2712],
    [-94.0431, 33.3305],
    [-94.0431, 33.3474],
    [-94.0431, 33.3528],
    [-94.0429, 33.3712],
    [-94.0430, 33.3859],
    [-94.0429, 33.4054],
    [-94.0429, 33.4194],
    [-94.0430, 33.4310],
    [-94.0430, 33.4384],
    [-94.0431, 33.4480],
    [-94.0431, 33.4537],
    [-94.0432, 33.4704],
    [-94.0433, 33.4910],
    [-94.0430, 33.4939],
    [-94.0434, 33.5423],
    [-94.0450, 33.5517],
    [-94.0519, 33.5526],
    [-94.0655, 33.5509],
    [-94.0738, 33.5558],
    [-94.0680, 33.5610],
    [-94.0598, 33.5592],
    [-94.0561, 33.5673],
    [-94.0662, 33.5689],
    [-94.0683, 33.5720],
    [-94.0704, 33.5746],
    [-94.0720, 33.5742],
    [-94.0727, 33.5722],
    [-94.0974, 33.5737],
    [-94.1128, 33.5670],
    [-94.1207, 33.5606],
    [-94.1269, 33.5506],
    [-94.1330, 33.5580],
    [-94.1360, 33.5714],
    [-94.1452, 33.5650],
    [-94.1518, 33.5695],
    [-94.1457, 33.5756],
    [-94.1422, 33.5814],
    [-94.1487, 33.5802],
    [-94.1613, 33.5793],
    [-94.1623, 33.5889],
    [-94.1839, 33.5947],
    [-94.1945, 33.5829],
    [-94.2036, 33.5808],
    [-94.2130, 33.5835],
    [-94.2174, 33.5793],
    [-94.2097, 33.5735],
    [-94.2011, 33.5759],
    [-94.1925, 33.5704],
    [-94.1932, 33.5562],
    [-94.1995, 33.5561],
    [-94.2056, 33.5672],
    [-94.2158, 33.5604],
    [-94.2264, 33.5529],
    [-94.2379, 33.5527],
    [-94.2523, 33.5604],
    [-94.2444, 33.5735],
    [-94.2368, 33.5809],
    [-94.2402, 33.5895],
    [-94.2527, 33.5861],
    [-94.2657, 33.5736],
    [-94.2720, 33.5615],
    [-94.2791, 33.5570],
    [-94.2909, 33.5589],
    [-94.2822, 33.5730],
    [-94.2826, 33.5810],
    [-94.2891, 33.5821],
    [-94.3010, 33.5730],
    [-94.3062, 33.5577],
    [-94.3096, 33.5517],
    [-94.3276, 33.5515],
    [-94.3332, 33.5554],
    [-94.3344, 33.5625],
    [-94.3406, 33.5679],
    [-94.3524, 33.5622],
    [-94.3474, 33.5511],
    [-94.3559, 33.5432],
    [-94.3633, 33.5450],
    [-94.3817, 33.5440],
    [-94.3926, 33.5511],
    [-94.4016, 33.5594],
    [-94.3944, 33.5656],
    [-94.3825, 33.5671],
    [-94.3778, 33.5746],
    [-94.3829, 33.5833],
    [-94.4033, 33.5684],
    [-94.4125, 33.5689],
    [-94.4276, 33.5893],
    [-94.4415, 33.5915],
    [-94.4516, 33.5914],
    [-94.4591, 33.5984],
    [-94.4720, 33.6027],
    [-94.4623, 33.6106],
    [-94.4523, 33.6188],
    [-94.4603, 33.6244],
    [-94.4588, 33.6324],
    [-94.4469, 33.6402],
    [-94.4592, 33.6451],
    [-94.4661, 33.6363],
    [-94.4859, 33.6379],
    [-94.4845, 33.6879],
    [-94.4839, 33.7167],
    [-94.4833, 33.7360],
    [-94.4829, 33.7508],
    [-94.4827, 33.7563],
    [-94.4818, 33.7890],
    [-94.4814, 33.8026],
    [-94.4806, 33.8302],
    [-94.4790, 33.8812],
    [-94.4773, 33.9409],
    [-94.4770, 33.9574],
    [-94.4749, 34.0217],
    [-94.4739, 34.0595],
    [-94.4703, 34.1899],
    [-94.4658, 34.3521],
    [-94.4649, 34.3779],
    [-94.4637, 34.4196],
    [-94.4629, 34.4469],
    [-94.4611, 34.5075],
    [-94.4601, 34.5453],
    [-94.4579, 34.6218],
    [-94.4575, 34.6430],
    [-94.4562, 34.6816],
    [-94.4553, 34.7067],
    [-94.4533, 34.7661],
    [-94.4508, 34.8401],
    [-94.4501, 34.8587],
    [-94.4496, 34.8754],
    [-94.4491, 34.8942],
    [-94.4476, 34.9419],
    [-94.4455, 35.0015],
    [-94.4426, 35.0802],
    [-94.4412, 35.1197],
    [-94.4395, 35.1690],
    [-94.4389, 35.1872],
    [-94.4388, 35.2019],
    [-94.4379, 35.2215],
    [-94.4376, 35.2309],
    [-94.4376, 35.2422],
    [-94.4363, 35.2581],
    [-94.4357, 35.2743],
    [-94.4353, 35.2760],
    [-94.4353, 35.2875],
    [-94.4344, 35.3020],
    [-94.4339, 35.3142],
    [-94.4334, 35.3285],
    [-94.4326, 35.3521],
    [-94.4331, 35.3658],
    [-94.4334, 35.3763],
    [-94.4318, 35.3911],
    [-94.4307, 35.3925],
    [-94.4389, 35.4378],
    [-94.4412, 35.4504],
    [-94.4497, 35.4967],
    [-94.4547, 35.5284],
    [-94.4600, 35.5617],
    [-94.4641, 35.5873],
    [-94.4653, 35.5940],
    [-94.4726, 35.6386],
    [-94.4843, 35.7068],
    [-94.4882, 35.7292],
    [-94.4934, 35.7619],
    [-94.4990, 35.7935],
    [-94.5006, 35.8029],
    [-94.5030, 35.8172],
    [-94.5074, 35.8445],
    [-94.5176, 35.9019],
    [-94.5222, 35.9316],
    [-94.5226, 35.9349],
    [-94.5246, 35.9457],
    [-94.5283, 35.9662],
    [-94.5321, 35.9879],
    [-94.5349, 36.0027],
    [-94.5373, 36.0170],
    [-94.5479, 36.0783],
    [-94.5572, 36.1301],
    [-94.5612, 36.1521],
    [-94.5638, 36.1674],
    [-94.5662, 36.1814],
    [-94.5678, 36.1909],
    [-94.5713, 36.2110],
    [-94.5749, 36.2327],
    [-94.5779, 36.2495],
    [-94.5826, 36.2783],
    [-94.5862, 36.3000],
    [-94.5931, 36.3439],
    [-94.6005, 36.3927],
    [-94.6025, 36.4046],
    [-94.6054, 36.4219],
    [-94.6138, 36.4762],
    [-94.6179, 36.4994],
    [-94.6178, 36.4994]
    ]
  },
  "Indiana": {
    coordinates: [
      [-88.0978, 37.9040],
    [-88.0714, 37.8958],
    [-88.0449, 37.8912],
    [-88.0248, 37.8889],
    [-88.0145, 37.8923],
    [-88.0200, 37.9098],
    [-88.0318, 37.9138],
    [-88.0630, 37.9182],
    [-88.0676, 37.9302],
    [-88.0528, 37.9305],
    [-88.0353, 37.9255],
    [-88.0368, 37.9568],
    [-88.0163, 37.9616],
    [-88.0229, 37.9980],
    [-88.0251, 38.0111],
    [-88.0169, 38.0240],
    [-88.0089, 38.0319],
    [-88.0277, 38.0317],
    [-88.0416, 38.0380],
    [-88.0378, 38.0502],
    [-88.0013, 38.0515],
    [-87.9580, 38.0838],
    [-87.9575, 38.0891],
    [-87.9622, 38.1001],
    [-88.0114, 38.0847],
    [-88.0131, 38.1035],
    [-87.9753, 38.1101],
    [-87.9710, 38.1280],
    [-87.9605, 38.1321],
    [-87.9475, 38.1272],
    [-87.9386, 38.1357],
    [-87.9266, 38.1425],
    [-87.9283, 38.1509],
    [-87.9168, 38.1569],
    [-87.9106, 38.1666],
    [-87.9191, 38.1740],
    [-87.9253, 38.1703],
    [-87.9264, 38.1588],
    [-87.9353, 38.1587],
    [-87.9405, 38.1749],
    [-87.9758, 38.1978],
    [-87.9856, 38.2180],
    [-87.9805, 38.2354],
    [-87.9835, 38.2500],
    [-87.9876, 38.2574],
    [-87.9723, 38.2470],
    [-87.9690, 38.2374],
    [-87.9580, 38.2401],
    [-87.9540, 38.2530],
    [-87.9421, 38.2603],
    [-87.9522, 38.2731],
    [-87.9392, 38.2829],
    [-87.9228, 38.2992],
    [-87.9080, 38.2923],
    [-87.9176, 38.2701],
    [-87.8978, 38.2795],
    [-87.8836, 38.2952],
    [-87.8705, 38.3122],
    [-87.8605, 38.3031],
    [-87.8630, 38.2802],
    [-87.8434, 38.2782],
    [-87.8310, 38.2994],
    [-87.8320, 38.3270],
    [-87.8138, 38.3538],
    [-87.8061, 38.3631],
    [-87.7697, 38.3807],
    [-87.7568, 38.3956],
    [-87.7453, 38.4090],
    [-87.7435, 38.4173],
    [-87.7307, 38.4429],
    [-87.7405, 38.4547],
    [-87.7567, 38.4603],
    [-87.7446, 38.4773],
    [-87.7140, 38.4799],
    [-87.6724, 38.5074],
    [-87.6567, 38.5018],
    [-87.6462, 38.5151],
    [-87.6595, 38.5267],
    [-87.6701, 38.5452],
    [-87.6573, 38.5533],
    [-87.6502, 38.5584],
    [-87.6502, 38.5701],
    [-87.6396, 38.5742],
    [-87.6400, 38.5852],
    [-87.6376, 38.5927],
    [-87.6229, 38.5862],
    [-87.6109, 38.5914],
    [-87.6194, 38.5948],
    [-87.6273, 38.6054],
    [-87.6204, 38.6128],
    [-87.6162, 38.6232],
    [-87.6209, 38.6361],
    [-87.6115, 38.6439],
    [-87.6029, 38.6512],
    [-87.5972, 38.6653],
    [-87.5644, 38.6748],
    [-87.5354, 38.6817],
    [-87.5287, 38.6866],
    [-87.5190, 38.6995],
    [-87.5085, 38.7258],
    [-87.4965, 38.7393],
    [-87.5033, 38.7471],
    [-87.4977, 38.7626],
    [-87.4982, 38.7683],
    [-87.5120, 38.7675],
    [-87.5118, 38.7736],
    [-87.4952, 38.7820],
    [-87.5082, 38.7957],
    [-87.5265, 38.8205],
    [-87.5222, 38.8305],
    [-87.5259, 38.8488],
    [-87.5372, 38.8536],
    [-87.5521, 38.8645],
    [-87.5426, 38.8666],
    [-87.5452, 38.8767],
    [-87.5355, 38.8816],
    [-87.5451, 38.8915],
    [-87.5416, 38.8964],
    [-87.5384, 38.8926],
    [-87.5363, 38.8874],
    [-87.5344, 38.8904],
    [-87.5366, 38.8956],
    [-87.5225, 38.9024],
    [-87.5177, 38.9057],
    [-87.5279, 38.9092],
    [-87.5261, 38.9214],
    [-87.5188, 38.9278],
    [-87.5174, 38.9349],
    [-87.5198, 38.9430],
    [-87.5129, 38.9501],
    [-87.5174, 38.9582],
    [-87.5270, 38.9688],
    [-87.5480, 38.9785],
    [-87.5785, 38.9897],
    [-87.5652, 38.9888],
    [-87.5629, 38.9944],
    [-87.5787, 38.9995],
    [-87.5697, 39.0194],
    [-87.5803, 39.0394],
    [-87.5726, 39.0573],
    [-87.5901, 39.0723],
    [-87.6011, 39.0814],
    [-87.6182, 39.0850],
    [-87.6155, 39.0958],
    [-87.6184, 39.1043],
    [-87.6446, 39.1044],
    [-87.6548, 39.1106],
    [-87.6510, 39.1164],
    [-87.6350, 39.1201],
    [-87.6409, 39.1228],
    [-87.6431, 39.1286],
    [-87.6552, 39.1323],
    [-87.6532, 39.1440],
    [-87.6450, 39.1543],
    [-87.6344, 39.1534],
    [-87.6277, 39.1562],
    [-87.6374, 39.1590],
    [-87.6404, 39.1667],
    [-87.6205, 39.1703],
    [-87.6208, 39.1748],
    [-87.6204, 39.1852],
    [-87.6052, 39.1859],
    [-87.5942, 39.1949],
    [-87.5770, 39.2111],
    [-87.5793, 39.2436],
    [-87.5713, 39.2514],
    [-87.5852, 39.2531],
    [-87.5935, 39.2475],
    [-87.6041, 39.2595],
    [-87.6015, 39.2722],
    [-87.6094, 39.2785],
    [-87.5999, 39.2936],
    [-87.6053, 39.3032],
    [-87.6212, 39.3042],
    [-87.6059, 39.3111],
    [-87.5902, 39.3321],
    [-87.5849, 39.3373],
    [-87.5544, 39.3405],
    [-87.5495, 39.3477],
    [-87.5404, 39.3529],
    [-87.5317, 39.3481],
    [-87.5317, 39.3710],
    [-87.5314, 39.4367],
    [-87.5317, 39.4801],
    [-87.5319, 39.5233],
    [-87.5320, 39.5684],
    [-87.5322, 39.6073],
    [-87.5327, 39.6649],
    [-87.5328, 39.7065],
    [-87.5329, 39.7308],
    [-87.5331, 39.8110],
    [-87.5332, 39.8534],
    [-87.5330, 39.9104],
    [-87.5327, 39.9470],
    [-87.5326, 39.9712],
    [-87.5324, 40.0000],
    [-87.5322, 40.0561],
    [-87.5319, 40.0975],
    [-87.5317, 40.1181],
    [-87.5315, 40.1480],
    [-87.5311, 40.1700],
    [-87.5308, 40.1918],
    [-87.5306, 40.2117],
    [-87.5300, 40.2520],
    [-87.5294, 40.2938],
    [-87.5282, 40.3742],
    [-87.5273, 40.4327],
    [-87.5264, 40.4912],
    [-87.5262, 40.5642],
    [-87.5262, 40.5787],
    [-87.5262, 40.6605],
    [-87.5260, 40.7369],
    [-87.5259, 40.7929],
    [-87.5258, 40.8173],
    [-87.5260, 40.8650],
    [-87.5260, 40.9064],
    [-87.5261, 40.9376],
    [-87.5263, 41.0015],
    [-87.5264, 41.0244],
    [-87.5266, 41.0872],
    [-87.5267, 41.1492],
    [-87.5266, 41.1662],
    [-87.5267, 41.2830],
    [-87.5265, 41.3484],
    [-87.5261, 41.3993],
    [-87.5259, 41.4268],
    [-87.5258, 41.4435],
    [-87.5258, 41.4541],
    [-87.5257, 41.4718],
    [-87.5255, 41.4828],
    [-87.5256, 41.4946],
    [-87.5256, 41.5227],
    [-87.5254, 41.5478],
    [-87.5254, 41.5503],
    [-87.5253, 41.5588],
    [-87.5254, 41.5703],
    [-87.5254, 41.5785],
    [-87.5254, 41.5831],
    [-87.5253, 41.5920],
    [-87.5253, 41.6008],
    [-87.5252, 41.6095],
    [-87.5252, 41.6155],
    [-87.5251, 41.6231],
    [-87.5251, 41.6330],
    [-87.5250, 41.6446],
    [-87.5249, 41.6604],
    [-87.5246, 41.6918],
    [-87.5244, 41.7027],
    [-87.5149, 41.7046],
    [-87.5112, 41.6975],
    [-87.5065, 41.6954],
    [-87.5045, 41.6916],
    [-87.4909, 41.6849],
    [-87.4840, 41.6827],
    [-87.4799, 41.6788],
    [-87.4755, 41.6770],
    [-87.4680, 41.6724],
    [-87.4624, 41.6783],
    [-87.4181, 41.6887],
    [-87.4063, 41.6812],
    [-87.4212, 41.6595],
    [-87.4330, 41.6489],
    [-87.4185, 41.6419],
    [-87.4103, 41.6425],
    [-87.4057, 41.6416],
    [-87.3945, 41.6372],
    [-87.3578, 41.6280],
    [-87.3186, 41.6236],
    [-87.3110, 41.6221],
    [-87.2990, 41.6191],
    [-87.2907, 41.6230],
    [-87.2871, 41.6207],
    [-87.2615, 41.6205],
    [-87.2207, 41.6244],
    [-87.1832, 41.6304],
    [-87.1782, 41.6344],
    [-87.1621, 41.6354],
    [-87.1485, 41.6478],
    [-87.1445, 41.6482],
    [-87.1284, 41.6464],
    [-87.1204, 41.6471],
    [-87.0675, 41.6614],
    [-87.0096, 41.6815],
    [-86.9434, 41.7066],
    [-86.9227, 41.7127],
    [-86.9133, 41.7226],
    [-86.9091, 41.7269],
    [-86.8754, 41.7379],
    [-86.8375, 41.7546],
    [-86.8248, 41.7602],
    [-86.8161, 41.7602],
    [-86.8044, 41.7602],
    [-86.8006, 41.7603],
    [-86.7510, 41.7600],
    [-86.7462, 41.7600],
    [-86.6997, 41.7598],
    [-86.6412, 41.7596],
    [-86.5833, 41.7596],
    [-86.5193, 41.7594],
    [-86.4262, 41.7598],
    [-86.3607, 41.7599],
    [-86.3320, 41.7600],
    [-86.3038, 41.7601],
    [-86.2655, 41.7602],
    [-86.2261, 41.7600],
    [-86.2175, 41.7600],
    [-86.1718, 41.7603],
    [-86.1255, 41.7606],
    [-86.1085, 41.7606],
    [-86.0411, 41.7605],
    [-85.9958, 41.7600],
    [-85.9750, 41.7598],
    [-85.9423, 41.7597],
    [-85.8888, 41.7594],
    [-85.8780, 41.7594],
    [-85.8479, 41.7593],
    [-85.7913, 41.7591],
    [-85.7505, 41.7591],
    [-85.7245, 41.7591],
    [-85.6626, 41.7591],
    [-85.6477, 41.7591],
    [-85.6226, 41.7590],
    [-85.6075, 41.7591],
    [-85.5183, 41.7595],
    [-85.4866, 41.7595],
    [-85.4087, 41.7598],
    [-85.3683, 41.7599],
    [-85.3306, 41.7600],
    [-85.2984, 41.7600],
    [-85.2737, 41.7598],
    [-85.2328, 41.7598],
    [-85.1749, 41.7596],
    [-85.1173, 41.7597],
    [-85.0585, 41.7599],
    [-85.0379, 41.7598],
    [-85.0198, 41.7597],
    [-84.9716, 41.7595],
    [-84.9609, 41.7594],
    [-84.9325, 41.7597],
    [-84.9177, 41.7597],
    [-84.8251, 41.7600],
    [-84.8059, 41.7602],
    [-84.8061, 41.7329],
    [-84.8060, 41.7027],
    [-84.8060, 41.6891],
    [-84.8057, 41.6323],
    [-84.8058, 41.6164],
    [-84.8049, 41.5419],
    [-84.8047, 41.5301],
    [-84.8046, 41.5003],
    [-84.8040, 41.4454],
    [-84.8040, 41.4260],
    [-84.8041, 41.4083],
    [-84.8039, 41.3565],
    [-84.8036, 41.2713],
    [-84.8036, 41.2709],
    [-84.8035, 41.1851],
    [-84.8034, 41.1646],
    [-84.8038, 41.1405],
    [-84.8033, 41.0969],
    [-84.8033, 41.0096],
    [-84.8029, 40.9226],
    [-84.8024, 40.8347],
    [-84.8025, 40.7717],
    [-84.8023, 40.7423],
    [-84.8022, 40.7186],
    [-84.8022, 40.6893],
    [-84.8022, 40.6603],
    [-84.8021, 40.6449],
    [-84.8022, 40.5824],
    [-84.8025, 40.5280],
    [-84.8031, 40.4847],
    [-84.8041, 40.4475],
    [-84.8044, 40.4025],
    [-84.8043, 40.3814],
    [-84.8041, 40.3436],
    [-84.8041, 40.3025],
    [-84.8056, 40.2237],
    [-84.8059, 40.2088],
    [-84.8062, 40.1980],
    [-84.8063, 40.1923],
    [-84.8068, 40.1801],
    [-84.8083, 40.1270],
    [-84.8089, 40.0971],
    [-84.8097, 40.0489],
    [-84.8109, 40.0051],
    [-84.8115, 39.9728],
    [-84.8124, 39.9218],
    [-84.8127, 39.8917],
    [-84.8130, 39.8730],
    [-84.8136, 39.8502],
    [-84.8137, 39.8431],
    [-84.8138, 39.8287],
    [-84.8142, 39.8142],
    [-84.8141, 39.8114],
    [-84.8142, 39.7856],
    [-84.8141, 39.7266],
    [-84.8146, 39.6692],
    [-84.8144, 39.6538],
    [-84.8147, 39.6289],
    [-84.8151, 39.5737],
    [-84.8150, 39.5677],
    [-84.8150, 39.5652],
    [-84.8152, 39.5481],
    [-84.8156, 39.5110],
    [-84.8158, 39.4774],
    [-84.8175, 39.3918],
    [-84.8194, 39.3095],
    [-84.8196, 39.2716],
    [-84.8196, 39.2631],
    [-84.8199, 39.2514],
    [-84.8198, 39.2486],
    [-84.8198, 39.2443],
    [-84.8201, 39.2187],
    [-84.8198, 39.1614],
    [-84.8200, 39.1491],
    [-84.8201, 39.1200],
    [-84.8202, 39.1055],
    [-84.8373, 39.0971],
    [-84.8498, 39.0865],
    [-84.8701, 39.0735],
    [-84.8889, 39.0664],
    [-84.8968, 39.0576],
    [-84.8968, 39.0545],
    [-84.8932, 39.0490],
    [-84.8791, 39.0337],
    [-84.8718, 39.0278],
    [-84.8477, 38.9980],
    [-84.8371, 38.9881],
    [-84.8305, 38.9742],
    [-84.8329, 38.9611],
    [-84.8402, 38.9546],
    [-84.8442, 38.9510],
    [-84.8537, 38.9429],
    [-84.8708, 38.9292],
    [-84.8793, 38.9161],
    [-84.8706, 38.9010],
    [-84.8608, 38.8977],
    [-84.8286, 38.8970],
    [-84.8011, 38.8913],
    [-84.7864, 38.8822],
    [-84.7858, 38.8695],
    [-84.7937, 38.8578],
    [-84.8032, 38.8507],
    [-84.8234, 38.8392],
    [-84.8300, 38.8304],
    [-84.8165, 38.8053],
    [-84.8129, 38.7861],
    [-84.8214, 38.7831],
    [-84.8529, 38.7894],
    [-84.8772, 38.7925],
    [-84.8964, 38.7927],
    [-84.9152, 38.7841],
    [-84.9436, 38.7754],
    [-84.9800, 38.7796],
    [-84.9930, 38.7780],
    [-85.0236, 38.7620],
    [-85.0524, 38.7481],
    [-85.0637, 38.7441],
    [-85.0944, 38.7292],
    [-85.1070, 38.7216],
    [-85.1252, 38.7089],
    [-85.1367, 38.7002],
    [-85.1766, 38.6885],
    [-85.1921, 38.6891],
    [-85.2133, 38.6954],
    [-85.2351, 38.7180],
    [-85.2487, 38.7329],
    [-85.2788, 38.7416],
    [-85.3053, 38.7415],
    [-85.3364, 38.7349],
    [-85.3514, 38.7320],
    [-85.3670, 38.7310],
    [-85.3723, 38.7304],
    [-85.3978, 38.7356],
    [-85.4234, 38.7338],
    [-85.4423, 38.7199],
    [-85.4509, 38.7089],
    [-85.4565, 38.6933],
    [-85.4555, 38.6821],
    [-85.4387, 38.6593],
    [-85.4381, 38.6459],
    [-85.4393, 38.6074],
    [-85.4286, 38.5864],
    [-85.4158, 38.5628],
    [-85.4224, 38.5329],
    [-85.4384, 38.5219],
    [-85.4671, 38.5106],
    [-85.4795, 38.4945],
    [-85.4888, 38.4780],
    [-85.5094, 38.4635],
    [-85.5382, 38.4552],
    [-85.5625, 38.4533],
    [-85.5860, 38.4501],
    [-85.6097, 38.4348],
    [-85.6207, 38.4223],
    [-85.6241, 38.4123],
    [-85.6329, 38.3957],
    [-85.6369, 38.3832],
    [-85.6384, 38.3770],
    [-85.6387, 38.3639],
    [-85.6423, 38.3524],
    [-85.6463, 38.3417],
    [-85.6541, 38.3260],
    [-85.6599, 38.3194],
    [-85.6736, 38.3023],
    [-85.6836, 38.2955],
    [-85.6994, 38.2879],
    [-85.7051, 38.2851],
    [-85.7325, 38.2719],
    [-85.7448, 38.2672],
    [-85.7515, 38.2680],
    [-85.7672, 38.2773],
    [-85.7714, 38.2841],
    [-85.7795, 38.2877],
    [-85.7911, 38.2878],
    [-85.8024, 38.2848],
    [-85.8174, 38.2824],
    [-85.8237, 38.2802],
    [-85.8321, 38.2718],
    [-85.8366, 38.2634],
    [-85.8374, 38.2509],
    [-85.8391, 38.2397],
    [-85.8454, 38.2299],
    [-85.8562, 38.2195],
    [-85.8746, 38.2076],
    [-85.8949, 38.1870],
    [-85.9080, 38.1615],
    [-85.9061, 38.1169],
    [-85.9042, 38.0998],
    [-85.9077, 38.0833],
    [-85.9154, 38.0652],
    [-85.9213, 38.0303],
    [-85.9396, 38.0098],
    [-85.9546, 38.0047],
    [-85.9990, 38.0000],
    [-86.0256, 37.9945],
    [-86.0325, 37.9901],
    [-86.0336, 37.9702],
    [-86.0360, 37.9617],
    [-86.0467, 37.9590],
    [-86.0649, 37.9756],
    [-86.0759, 37.9955],
    [-86.0863, 38.0049],
    [-86.1175, 38.0154],
    [-86.1479, 38.0147],
    [-86.1694, 38.0100],
    [-86.1909, 38.0164],
    [-86.2061, 38.0224],
    [-86.2334, 38.0382],
    [-86.2527, 38.0478],
    [-86.2714, 38.0620],
    [-86.2777, 38.0825],
    [-86.2779, 38.1050],
    [-86.2706, 38.1358],
    [-86.2871, 38.1579],
    [-86.3297, 38.1817],
    [-86.3477, 38.1954],
    [-86.3675, 38.1973],
    [-86.3782, 38.1858],
    [-86.3717, 38.1642],
    [-86.3449, 38.1590],
    [-86.3212, 38.1470],
    [-86.3337, 38.1292],
    [-86.3753, 38.1306],
    [-86.3918, 38.1171],
    [-86.4051, 38.1058],
    [-86.4264, 38.1230],
    [-86.4498, 38.1272],
    [-86.4632, 38.1193],
    [-86.4639, 38.1012],
    [-86.4475, 38.0918],
    [-86.4301, 38.0786],
    [-86.4382, 38.0604],
    [-86.4719, 38.0462],
    [-86.5001, 38.0458],
    [-86.5194, 38.0412],
    [-86.5249, 38.0282],
    [-86.5247, 38.0129],
    [-86.5249, 37.9818],
    [-86.5205, 37.9544],
    [-86.5094, 37.9425],
    [-86.5078, 37.9288],
    [-86.5261, 37.9195],
    [-86.5407, 37.9169],
    [-86.5803, 37.9231],
    [-86.5961, 37.9143],
    [-86.6001, 37.9012],
    [-86.5994, 37.8748],
    [-86.5981, 37.8674],
    [-86.6092, 37.8554],
    [-86.6335, 37.8442],
    [-86.6480, 37.8414],
    [-86.6583, 37.8441],
    [-86.6612, 37.8628],
    [-86.6448, 37.8948],
    [-86.6455, 37.9065],
    [-86.6609, 37.9131],
    [-86.6809, 37.9150],
    [-86.7034, 37.9012],
    [-86.7161, 37.8941],
    [-86.7222, 37.8926],
    [-86.7377, 37.8995],
    [-86.7510, 37.9129],
    [-86.7647, 37.9324],
    [-86.7748, 37.9483],
    [-86.7772, 37.9517],
    [-86.7792, 37.9583],
    [-86.7905, 37.9800],
    [-86.8001, 37.9913],
    [-86.8051, 37.9936],
    [-86.8148, 37.9987],
    [-86.8235, 37.9989],
    [-86.8559, 37.9873],
    [-86.8759, 37.9708],
    [-86.8903, 37.9574],
    [-86.9073, 37.9433],
    [-86.9179, 37.9372],
    [-86.9446, 37.9335],
    [-86.9788, 37.9302],
    [-87.0124, 37.9187],
    [-87.0367, 37.9041],
    [-87.0461, 37.8915],
    [-87.0456, 37.8870],
    [-87.0431, 37.8755],
    [-87.0433, 37.8686],
    [-87.0545, 37.8353],
    [-87.0640, 37.8161],
    [-87.0676, 37.8049],
    [-87.0743, 37.7979],
    [-87.0893, 37.7879],
    [-87.0992, 37.7845],
    [-87.1110, 37.7824],
    [-87.1261, 37.7847],
    [-87.1296, 37.7866],
    [-87.1354, 37.7978],
    [-87.1371, 37.8073],
    [-87.1480, 37.8251],
    [-87.1563, 37.8359],
    [-87.1704, 37.8422],
    [-87.2118, 37.8466],
    [-87.2495, 37.8650],
    [-87.2690, 37.8780],
    [-87.2983, 37.8959],
    [-87.3198, 37.9055],
    [-87.3449, 37.9112],
    [-87.3578, 37.9204],
    [-87.3705, 37.9282],
    [-87.3735, 37.9322],
    [-87.3914, 37.9391],
    [-87.4022, 37.9427],
    [-87.4141, 37.9447],
    [-87.4283, 37.9450],
    [-87.4505, 37.9415],
    [-87.4807, 37.9235],
    [-87.5054, 37.9076],
    [-87.5203, 37.9126],
    [-87.5485, 37.9241],
    [-87.5621, 37.9333],
    [-87.5731, 37.9500],
    [-87.5765, 37.9521],
    [-87.5754, 37.9665],
    [-87.5845, 37.9747],
    [-87.5962, 37.9749],
    [-87.6033, 37.9673],
    [-87.6048, 37.9525],
    [-87.6108, 37.9446],
    [-87.6195, 37.9375],
    [-87.6182, 37.9350],
    [-87.6224, 37.9276],
    [-87.6271, 37.9285],
    [-87.6279, 37.9223],
    [-87.6208, 37.9077],
    [-87.6020, 37.8957],
    [-87.5871, 37.8849],
    [-87.5839, 37.8725],
    [-87.5880, 37.8690],
    [-87.5915, 37.8604],
    [-87.5979, 37.8477],
    [-87.6066, 37.8387],
    [-87.6150, 37.8322],
    [-87.6358, 37.8270],
    [-87.6459, 37.8259],
    [-87.6724, 37.8291],
    [-87.6807, 37.8406],
    [-87.6754, 37.8659],
    [-87.6686, 37.8745],
    [-87.6635, 37.8866],
    [-87.6710, 37.8997],
    [-87.6840, 37.9035],
    [-87.7007, 37.8974],
    [-87.7180, 37.8926],
    [-87.7333, 37.8943],
    [-87.7623, 37.8909],
    [-87.7836, 37.8778],
    [-87.7909, 37.8757],
    [-87.8157, 37.8756],
    [-87.8381, 37.8798],
    [-87.8417, 37.8877],
    [-87.8572, 37.9006],
    [-87.8656, 37.9151],
    [-87.8833, 37.9262],
    [-87.8944, 37.9278],
    [-87.9065, 37.9231],
    [-87.9278, 37.9009],
    [-87.9372, 37.8921],
    [-87.9408, 37.8833],
    [-87.9381, 37.8707],
    [-87.9149, 37.8496],
    [-87.9038, 37.8178],
    [-87.9111, 37.8052],
    [-87.9326, 37.7977],
    [-87.9359, 37.7897],
    [-87.9445, 37.7753],
    [-87.9526, 37.7717],
    [-87.9718, 37.7846],
    [-87.9872, 37.7922],
    [-87.9971, 37.7977],
    [-88.0210, 37.8014],
    [-88.0300, 37.8065],
    [-88.0458, 37.8081],
    [-88.0764, 37.8046],
    [-88.0918, 37.8221],
    [-88.0809, 37.8309],
    [-88.0581, 37.8224],
    [-88.0287, 37.8271],
    [-88.0333, 37.8419],
    [-88.0650, 37.8532],
    [-88.0844, 37.8856],
    [-88.0950, 37.8937],
    [-88.0978, 37.9040]
    ]
  },
  "Minnesota": {
    coordinates: [
      [-97.2392, 48.9687],
    [-97.2380, 48.9751],
    [-97.2373, 48.9857],
    [-97.2267, 48.9929],
    [-97.2321, 48.9950],
    [-97.2287, 49.0006],
    [-97.0829, 49.0004],
    [-96.9310, 49.0000],
    [-96.6692, 49.0000],
    [-96.2088, 49.0000],
    [-95.9754, 49.0000],
    [-95.4844, 48.9990],
    [-95.3558, 48.9987],
    [-95.3199, 48.9988],
    [-95.1533, 49.1805],
    [-95.1534, 49.2500],
    [-95.1533, 49.3084],
    [-95.1533, 49.3437],
    [-95.1533, 49.3659],
    [-95.1533, 49.3831],
    [-95.1497, 49.3806],
    [-95.1418, 49.3783],
    [-95.1265, 49.3694],
    [-95.1031, 49.3651],
    [-95.0898, 49.3611],
    [-95.0494, 49.3531],
    [-94.9743, 49.3677],
    [-94.9093, 49.3502],
    [-94.8542, 49.3242],
    [-94.8243, 49.3088],
    [-94.7981, 49.1979],
    [-94.7503, 49.0993],
    [-94.6842, 48.8724],
    [-94.6902, 48.8634],
    [-94.6905, 48.8382],
    [-94.7043, 48.8243],
    [-94.6960, 48.7998],
    [-94.6948, 48.7927],
    [-94.6909, 48.7781],
    [-94.6728, 48.7693],
    [-94.6520, 48.7559],
    [-94.6454, 48.7441],
    [-94.6190, 48.7374],
    [-94.6014, 48.7284],
    [-94.5896, 48.7179],
    [-94.5506, 48.7150],
    [-94.5386, 48.7026],
    [-94.5173, 48.7007],
    [-94.4996, 48.6980],
    [-94.4645, 48.6955],
    [-94.4466, 48.6929],
    [-94.4242, 48.7054],
    [-94.4162, 48.7109],
    [-94.3842, 48.7118],
    [-94.3530, 48.7041],
    [-94.3084, 48.7102],
    [-94.2743, 48.6999],
    [-94.2581, 48.6918],
    [-94.2506, 48.6782],
    [-94.2505, 48.6567],
    [-94.2444, 48.6534],
    [-94.2144, 48.6494],
    [-94.1677, 48.6481],
    [-94.1263, 48.6444],
    [-94.0912, 48.6437],
    [-94.0658, 48.6461],
    [-94.0525, 48.6440],
    [-94.0295, 48.6409],
    [-94.0002, 48.6419],
    [-93.9634, 48.6372],
    [-93.9442, 48.6323],
    [-93.9155, 48.6327],
    [-93.8869, 48.6308],
    [-93.8440, 48.6294],
    [-93.8343, 48.6250],
    [-93.8226, 48.6091],
    [-93.8120, 48.5849],
    [-93.8053, 48.5703],
    [-93.8090, 48.5559],
    [-93.8113, 48.5455],
    [-93.8176, 48.5358],
    [-93.8183, 48.5300],
    [-93.8015, 48.5206],
    [-93.7847, 48.5155],
    [-93.7565, 48.5154],
    [-93.7321, 48.5180],
    [-93.7091, 48.5180],
    [-93.6909, 48.5146],
    [-93.6454, 48.5173],
    [-93.6382, 48.5225],
    [-93.6289, 48.5312],
    [-93.6183, 48.5240],
    [-93.6059, 48.5225],
    [-93.5944, 48.5288],
    [-93.5807, 48.5267],
    [-93.5472, 48.5287],
    [-93.5187, 48.5340],
    [-93.4829, 48.5430],
    [-93.4654, 48.5467],
    [-93.4567, 48.5618],
    [-93.4648, 48.5836],
    [-93.4643, 48.5918],
    [-93.4522, 48.5925],
    [-93.4311, 48.5976],
    [-93.4147, 48.6054],
    [-93.4053, 48.6093],
    [-93.4037, 48.6076],
    [-93.3950, 48.6033],
    [-93.3712, 48.6051],
    [-93.3621, 48.6138],
    [-93.3541, 48.6123],
    [-93.3531, 48.6157],
    [-93.3475, 48.6266],
    [-93.1841, 48.6284],
    [-93.1424, 48.6249],
    [-92.9549, 48.6315],
    [-92.9296, 48.6069],
    [-92.7280, 48.5393],
    [-92.6278, 48.5222],
    [-92.6266, 48.5144],
    [-92.6265, 48.5122],
    [-92.6309, 48.5092],
    [-92.6272, 48.5034],
    [-92.6471, 48.4999],
    [-92.6849, 48.4976],
    [-92.7093, 48.4731],
    [-92.6880, 48.4439],
    [-92.5756, 48.4408],
    [-92.5073, 48.4479],
    [-92.4841, 48.4295],
    [-92.4812, 48.4253],
    [-92.4563, 48.4121],
    [-92.4699, 48.3518],
    [-92.4413, 48.3156],
    [-92.4289, 48.3058],
    [-92.4163, 48.2955],
    [-92.3938, 48.2606],
    [-92.3893, 48.2533],
    [-92.3867, 48.2517],
    [-92.3881, 48.2467],
    [-92.3839, 48.2447],
    [-92.3832, 48.2384],
    [-92.3783, 48.2334],
    [-92.3728, 48.2237],
    [-92.3675, 48.2240],
    [-92.3492, 48.2314],
    [-92.3368, 48.2354],
    [-92.3322, 48.2339],
    [-92.3147, 48.2405],
    [-92.2737, 48.2567],
    [-92.2930, 48.2764],
    [-92.3015, 48.2886],
    [-92.3046, 48.3230],
    [-92.2623, 48.3549],
    [-92.2170, 48.3451],
    [-92.2077, 48.3478],
    [-92.1942, 48.3487],
    [-92.1789, 48.3553],
    [-92.1450, 48.3657],
    [-92.0835, 48.3539],
    [-92.0552, 48.3592],
    [-92.0452, 48.3458],
    [-92.0377, 48.3332],
    [-92.0130, 48.2974],
    [-92.0066, 48.2654],
    [-91.9776, 48.2471],
    [-91.9769, 48.2446],
    [-91.9704, 48.2494],
    [-91.9702, 48.2536],
    [-91.9544, 48.2512],
    [-91.9496, 48.2445],
    [-91.9592, 48.2363],
    [-91.9513, 48.2326],
    [-91.9407, 48.2320],
    [-91.9208, 48.2367],
    [-91.9070, 48.2378],
    [-91.8935, 48.2377],
    [-91.8644, 48.2070],
    [-91.8344, 48.2098],
    [-91.8145, 48.2087],
    [-91.7981, 48.2028],
    [-91.7861, 48.1964],
    [-91.7632, 48.2015],
    [-91.7539, 48.2012],
    [-91.7419, 48.1991],
    [-91.7149, 48.1991],
    [-91.7124, 48.1875],
    [-91.7246, 48.1707],
    [-91.7094, 48.1727],
    [-91.7073, 48.1537],
    [-91.7017, 48.1448],
    [-91.6982, 48.1416],
    [-91.7081, 48.1230],
    [-91.7120, 48.1147],
    [-91.6915, 48.1176],
    [-91.6838, 48.1177],
    [-91.6769, 48.1073],
    [-91.6652, 48.1070],
    [-91.6533, 48.1141],
    [-91.6536, 48.1096],
    [-91.6402, 48.0969],
    [-91.5759, 48.1065],
    [-91.5697, 48.0933],
    [-91.5757, 48.0488],
    [-91.4886, 48.0681],
    [-91.4466, 48.0674],
    [-91.4389, 48.0500],
    [-91.4270, 48.0500],
    [-91.3911, 48.0571],
    [-91.3651, 48.0670],
    [-91.3367, 48.0709],
    [-91.3300, 48.0698],
    [-91.3248, 48.0726],
    [-91.3026, 48.0730],
    [-91.2664, 48.0787],
    [-91.2262, 48.0997],
    [-91.1832, 48.1222],
    [-91.1377, 48.1491],
    [-91.1430, 48.1542],
    [-91.1180, 48.1621],
    [-91.0979, 48.1712],
    [-91.0827, 48.1808],
    [-91.0757, 48.1792],
    [-91.0593, 48.1853],
    [-91.0359, 48.1894],
    [-91.0318, 48.1885],
    [-91.0227, 48.1925],
    [-91.0042, 48.2026],
    [-90.9150, 48.2306],
    [-90.8855, 48.2458],
    [-90.8671, 48.2382],
    [-90.8392, 48.2395],
    [-90.8396, 48.2277],
    [-90.8349, 48.2022],
    [-90.8326, 48.1738],
    [-90.8254, 48.1812],
    [-90.8193, 48.1827],
    [-90.8042, 48.1778],
    [-90.7938, 48.1612],
    [-90.7834, 48.1639],
    [-90.7763, 48.1619],
    [-90.7780, 48.1487],
    [-90.7968, 48.1395],
    [-90.7938, 48.1356],
    [-90.7821, 48.1354],
    [-90.7899, 48.1299],
    [-90.7827, 48.1262],
    [-90.7760, 48.1222],
    [-90.7730, 48.1175],
    [-90.7676, 48.1103],
    [-90.7516, 48.0910],
    [-90.6866, 48.1005],
    [-90.6204, 48.1119],
    [-90.5915, 48.1175],
    [-90.5799, 48.1239],
    [-90.5705, 48.1215],
    [-90.5558, 48.1171],
    [-90.5643, 48.0988],
    [-90.5109, 48.0974],
    [-90.4961, 48.0988],
    [-90.4938, 48.1013],
    [-90.4834, 48.1004],
    [-90.4710, 48.1061],
    [-90.4632, 48.1074],
    [-90.4474, 48.1034],
    [-90.4103, 48.1050],
    [-90.3902, 48.1001],
    [-90.3846, 48.0946],
    [-90.3730, 48.0912],
    [-90.3537, 48.0950],
    [-90.3435, 48.0951],
    [-90.3372, 48.0998],
    [-90.3124, 48.1053],
    [-90.2981, 48.1025],
    [-90.2746, 48.1033],
    [-90.2338, 48.1071],
    [-90.2114, 48.1063],
    [-90.1766, 48.1124],
    [-90.1452, 48.1116],
    [-90.1326, 48.1118],
    [-90.1239, 48.1071],
    [-90.0916, 48.1046],
    [-90.0490, 48.0917],
    [-90.0392, 48.0899],
    [-90.0188, 48.0720],
    [-90.0100, 48.0689],
    [-89.9938, 48.0490],
    [-89.9947, 48.0307],
    [-89.9889, 48.0257],
    [-89.9843, 48.0261],
    [-89.9734, 48.0204],
    [-89.9546, 48.0115],
    [-89.9506, 48.0159],
    [-89.9411, 48.0141],
    [-89.9330, 48.0132],
    [-89.9254, 48.0067],
    [-89.9216, 47.9999],
    [-89.9161, 47.9966],
    [-89.9048, 47.9923],
    [-89.8974, 47.9876],
    [-89.8865, 47.9863],
    [-89.8712, 47.9859],
    [-89.8462, 47.9927],
    [-89.8442, 48.0018],
    [-89.8417, 48.0029],
    [-89.8318, 47.9994],
    [-89.8254, 48.0069],
    [-89.8198, 48.0151],
    [-89.8049, 48.0138],
    [-89.7952, 48.0172],
    [-89.7827, 48.0178],
    [-89.7744, 48.0220],
    [-89.7640, 48.0230],
    [-89.7493, 48.0233],
    [-89.7426, 48.0198],
    [-89.7340, 48.0219],
    [-89.7240, 48.0190],
    [-89.7232, 48.0205],
    [-89.7208, 48.0172],
    [-89.7240, 48.0137],
    [-89.7171, 48.0172],
    [-89.7159, 48.0092],
    [-89.7071, 48.0095],
    [-89.7014, 48.0062],
    [-89.6860, 48.0098],
    [-89.6769, 48.0112],
    [-89.6716, 48.0102],
    [-89.6648, 48.0079],
    [-89.6558, 48.0075],
    [-89.6491, 48.0039],
    [-89.6415, 48.0059],
    [-89.6373, 48.0041],
    [-89.6388, 48.0082],
    [-89.6205, 48.0107],
    [-89.6142, 48.0155],
    [-89.6094, 48.0167],
    [-89.6078, 48.0066],
    [-89.5922, 48.0020],
    [-89.5860, 47.9999],
    [-89.5810, 47.9959],
    [-89.5666, 47.9992],
    [-89.5533, 47.9997],
    [-89.5452, 48.0011],
    [-89.5241, 48.0014],
    [-89.5147, 48.0020],
    [-89.5113, 48.0052],
    [-89.5051, 48.0056],
    [-89.4953, 48.0024],
    [-89.5119, 48.0009],
    [-89.5272, 47.9968],
    [-89.5457, 47.9933],
    [-89.5569, 47.9933],
    [-89.5628, 47.9896],
    [-89.5734, 47.9849],
    [-89.5841, 47.9813],
    [-89.5952, 47.9805],
    [-89.6021, 47.9797],
    [-89.6092, 47.9800],
    [-89.6153, 47.9850],
    [-89.6069, 47.9915],
    [-89.6208, 47.9955],
    [-89.6258, 47.9916],
    [-89.6331, 47.9888],
    [-89.6418, 47.9842],
    [-89.6496, 47.9793],
    [-89.6450, 47.9682],
    [-89.6398, 47.9597],
    [-89.6395, 47.9536],
    [-89.6524, 47.9620],
    [-89.6564, 47.9665],
    [-89.6761, 47.9654],
    [-89.6857, 47.9600],
    [-89.6897, 47.9535],
    [-89.6858, 47.9517],
    [-89.6814, 47.9498],
    [-89.6825, 47.9442],
    [-89.6972, 47.9410],
    [-89.7122, 47.9344],
    [-89.7216, 47.9290],
    [-89.7303, 47.9232],
    [-89.7356, 47.9177],
    [-89.7449, 47.9126],
    [-89.7568, 47.9044],
    [-89.7754, 47.9000],
    [-89.7886, 47.8939],
    [-89.8012, 47.8901],
    [-89.8120, 47.8862],
    [-89.8226, 47.8836],
    [-89.8291, 47.8803],
    [-89.8382, 47.8807],
    [-89.8388, 47.8764],
    [-89.8430, 47.8795],
    [-89.8480, 47.8767],
    [-89.8575, 47.8747],
    [-89.8716, 47.8742],
    [-89.8845, 47.8671],
    [-89.8962, 47.8680],
    [-89.9111, 47.8645],
    [-89.9189, 47.8631],
    [-89.9295, 47.8559],
    [-89.9306, 47.8501],
    [-89.9349, 47.8476],
    [-89.9423, 47.8434],
    [-89.9555, 47.8402],
    [-89.9641, 47.8401],
    [-89.9695, 47.8329],
    [-89.9822, 47.8293],
    [-90.0034, 47.8250],
    [-90.0184, 47.8206],
    [-90.0244, 47.8179],
    [-90.0403, 47.8172],
    [-90.0520, 47.8139],
    [-90.0720, 47.8111],
    [-90.0801, 47.8025],
    [-90.0974, 47.8003],
    [-90.1101, 47.7972],
    [-90.1321, 47.7957],
    [-90.1681, 47.7902],
    [-90.1876, 47.7781],
    [-90.2014, 47.7751],
    [-90.2488, 47.7728],
    [-90.2638, 47.7675],
    [-90.2960, 47.7591],
    [-90.3140, 47.7567],
    [-90.3212, 47.7538],
    [-90.3321, 47.7492],
    [-90.3367, 47.7450],
    [-90.3491, 47.7455],
    [-90.3568, 47.7439],
    [-90.3908, 47.7410],
    [-90.3979, 47.7374],
    [-90.4377, 47.7316],
    [-90.4402, 47.7254],
    [-90.4507, 47.7222],
    [-90.4647, 47.7206],
    [-90.4836, 47.7164],
    [-90.5170, 47.7077],
    [-90.5268, 47.7065],
    [-90.5513, 47.6903],
    [-90.5850, 47.6807],
    [-90.6378, 47.6598],
    [-90.6478, 47.6562],
    [-90.6592, 47.6507],
    [-90.6713, 47.6464],
    [-90.7039, 47.6368],
    [-90.7159, 47.6318],
    [-90.7359, 47.6243],
    [-90.7534, 47.6154],
    [-90.7709, 47.6084],
    [-90.7838, 47.6018],
    [-90.7968, 47.5923],
    [-90.8056, 47.5880],
    [-90.8277, 47.5770],
    [-90.8417, 47.5688],
    [-90.8569, 47.5625],
    [-90.8680, 47.5555],
    [-90.8733, 47.5537],
    [-90.8811, 47.5492],
    [-90.8912, 47.5433],
    [-90.9139, 47.5279],
    [-90.9280, 47.5190],
    [-90.9433, 47.5120],
    [-90.9513, 47.5080],
    [-90.9696, 47.4953],
    [-90.9822, 47.4886],
    [-90.9914, 47.4831],
    [-91.0016, 47.4765],
    [-91.0102, 47.4709],
    [-91.0231, 47.4650],
    [-91.0335, 47.4581],
    [-91.0428, 47.4566],
    [-91.0487, 47.4519],
    [-91.0569, 47.4459],
    [-91.0649, 47.4407],
    [-91.0777, 47.4288],
    [-91.0910, 47.4190],
    [-91.0997, 47.4143],
    [-91.1062, 47.4118],
    [-91.1165, 47.4056],
    [-91.1283, 47.3974],
    [-91.1355, 47.3919],
    [-91.1417, 47.3879],
    [-91.1507, 47.3794],
    [-91.1565, 47.3788],
    [-91.1624, 47.3714],
    [-91.1675, 47.3671],
    [-91.1738, 47.3614],
    [-91.1752, 47.3569],
    [-91.1806, 47.3498],
    [-91.1854, 47.3467],
    [-91.1846, 47.3399],
    [-91.1888, 47.3401],
    [-91.1954, 47.3379],
    [-91.2005, 47.3333],
    [-91.2076, 47.3244],
    [-91.2141, 47.3174],
    [-91.2217, 47.3166],
    [-91.2286, 47.3120],
    [-91.2312, 47.3061],
    [-91.2398, 47.3024],
    [-91.2466, 47.2944],
    [-91.2465, 47.2905],
    [-91.2492, 47.2842],
    [-91.2559, 47.2810],
    [-91.2629, 47.2790],
    [-91.2736, 47.2739],
    [-91.2749, 47.2689],
    [-91.2786, 47.2665],
    [-91.2885, 47.2660],
    [-91.2930, 47.2613],
    [-91.2904, 47.2590],
    [-91.2924, 47.2569],
    [-91.2997, 47.2553],
    [-91.3068, 47.2518],
    [-91.3187, 47.2434],
    [-91.3260, 47.2390],
    [-91.3278, 47.2333],
    [-91.3337, 47.2291],
    [-91.3383, 47.2264],
    [-91.3445, 47.2216],
    [-91.3510, 47.2175],
    [-91.3530, 47.2104],
    [-91.3567, 47.2059],
    [-91.3650, 47.2041],
    [-91.3697, 47.1998],
    [-91.3768, 47.1956],
    [-91.3806, 47.1916],
    [-91.3870, 47.1873],
    [-91.3985, 47.1839],
    [-91.4074, 47.1816],
    [-91.4096, 47.1775],
    [-91.4149, 47.1736],
    [-91.4213, 47.1665],
    [-91.4274, 47.1644],
    [-91.4366, 47.1569],
    [-91.4409, 47.1537],
    [-91.4510, 47.1459],
    [-91.4544, 47.1404],
    [-91.4590, 47.1373],
    [-91.4650, 47.1319],
    [-91.4716, 47.1295],
    [-91.4774, 47.1257],
    [-91.4907, 47.1233],
    [-91.5029, 47.1191],
    [-91.5077, 47.1169],
    [-91.5182, 47.1069],
    [-91.5241, 47.1034],
    [-91.5352, 47.1026],
    [-91.5450, 47.0994],
    [-91.5500, 47.0935],
    [-91.5613, 47.0941],
    [-91.5738, 47.0899],
    [-91.5799, 47.0818],
    [-91.5846, 47.0737],
    [-91.5915, 47.0687],
    [-91.5950, 47.0624],
    [-91.6033, 47.0638],
    [-91.6159, 47.0568],
    [-91.6219, 47.0512],
    [-91.6330, 47.0442],
    [-91.6421, 47.0386],
    [-91.6372, 47.0336],
    [-91.6362, 47.0312],
    [-91.6381, 47.0266],
    [-91.6463, 47.0257],
    [-91.6504, 47.0293],
    [-91.6564, 47.0284],
    [-91.6594, 47.0237],
    [-91.6600, 47.0183],
    [-91.6605, 47.0153],
    [-91.6661, 47.0143],
    [-91.6726, 47.0172],
    [-91.6780, 47.0149],
    [-91.6848, 47.0064],
    [-91.6974, 47.0073],
    [-91.7047, 47.0052],
    [-91.7195, 46.9941],
    [-91.7400, 46.9798],
    [-91.7485, 46.9736],
    [-91.7593, 46.9636],
    [-91.7671, 46.9575],
    [-91.7775, 46.9525],
    [-91.7804, 46.9471],
    [-91.7841, 46.9419],
    [-91.7940, 46.9399],
    [-91.8069, 46.9337],
    [-91.8134, 46.9276],
    [-91.8223, 46.9253],
    [-91.8349, 46.9271],
    [-91.8509, 46.9198],
    [-91.8584, 46.9125],
    [-91.8713, 46.9084],
    [-91.8878, 46.9019],
    [-91.9049, 46.8912],
    [-91.9178, 46.8816],
    [-91.9207, 46.8805],
    [-91.9521, 46.8671],
    [-91.9720, 46.8559],
    [-91.9943, 46.8419],
    [-92.0018, 46.8375],
    [-92.0113, 46.8352],
    [-92.0195, 46.8316],
    [-92.0259, 46.8286],
    [-92.0339, 46.8219],
    [-92.0421, 46.8200],
    [-92.0505, 46.8144],
    [-92.0547, 46.8116],
    [-92.0621, 46.8040],
    [-92.0696, 46.8021],
    [-92.0764, 46.7985],
    [-92.0826, 46.7958],
    [-92.0869, 46.7945],
    [-92.0912, 46.7808],
    [-92.0883, 46.7736],
    [-92.0505, 46.7320],
    [-92.0174, 46.7071],
    [-92.0247, 46.7056],
    [-92.0648, 46.7313],
    [-92.1074, 46.7491],
    [-92.1253, 46.7449],
    [-92.1434, 46.7281],
    [-92.1463, 46.7159],
    [-92.1673, 46.7199],
    [-92.1789, 46.7167],
    [-92.1933, 46.7112],
    [-92.2047, 46.7040],
    [-92.1985, 46.6961],
    [-92.1765, 46.6902],
    [-92.1814, 46.6802],
    [-92.1925, 46.6767],
    [-92.2055, 46.6647],
    [-92.2016, 46.6567],
    [-92.2071, 46.6519],
    [-92.2235, 46.6526],
    [-92.2356, 46.6500],
    [-92.2597, 46.6571],
    [-92.2728, 46.6528],
    [-92.2837, 46.6588],
    [-92.2874, 46.6673],
    [-92.2922, 46.6633],
    [-92.2917, 46.6341],
    [-92.2917, 46.5953],
    [-92.2920, 46.5040],
    [-92.2927, 46.4320],
    [-92.2930, 46.3322],
    [-92.2928, 46.3193],
    [-92.2928, 46.3071],
    [-92.2931, 46.2951],
    [-92.2936, 46.2246],
    [-92.2937, 46.1667],
    [-92.2935, 46.1138],
    [-92.2986, 46.0730],
    [-92.3166, 46.0700],
    [-92.3298, 46.0652],
    [-92.3382, 46.0521],
    [-92.3435, 46.0430],
    [-92.3437, 46.0285],
    [-92.3493, 46.0236],
    [-92.3500, 46.0170],
    [-92.3580, 46.0134],
    [-92.3649, 46.0134],
    [-92.3927, 46.0195],
    [-92.4106, 46.0273],
    [-92.4286, 46.0242],
    [-92.4444, 46.0118],
    [-92.4516, 46.0004],
    [-92.4534, 45.9929],
    [-92.4645, 45.9850],
    [-92.4642, 45.9824],
    [-92.4613, 45.9794],
    [-92.4728, 45.9730],
    [-92.4910, 45.9756],
    [-92.5195, 45.9839],
    [-92.5271, 45.9832],
    [-92.5457, 45.9701],
    [-92.5507, 45.9608],
    [-92.5519, 45.9517],
    [-92.5698, 45.9481],
    [-92.5901, 45.9418],
    [-92.6108, 45.9366],
    [-92.6277, 45.9327],
    [-92.6388, 45.9342],
    [-92.6401, 45.9325],
    [-92.6561, 45.9244],
    [-92.6704, 45.9162],
    [-92.6757, 45.9075],
    [-92.6862, 45.9028],
    [-92.7077, 45.8949],
    [-92.7340, 45.8681],
    [-92.7366, 45.8574],
    [-92.7456, 45.8415],
    [-92.7617, 45.8339],
    [-92.7649, 45.8249],
    [-92.7609, 45.8166],
    [-92.7578, 45.8066],
    [-92.7684, 45.7980],
    [-92.7774, 45.7878],
    [-92.7814, 45.7731],
    [-92.7986, 45.7537],
    [-92.8053, 45.7475],
    [-92.8166, 45.7420],
    [-92.8307, 45.7331],
    [-92.8431, 45.7292],
    [-92.8505, 45.7244],
    [-92.8626, 45.7222],
    [-92.8697, 45.7151],
    [-92.8700, 45.6973],
    [-92.8769, 45.6753],
    [-92.8840, 45.6549],
    [-92.8871, 45.6441],
    [-92.8879, 45.6390],
    [-92.8881, 45.6284],
    [-92.8830, 45.6137],
    [-92.8860, 45.6004],
    [-92.8833, 45.5898],
    [-92.8811, 45.5734],
    [-92.8438, 45.5661],
    [-92.8166, 45.5610],
    [-92.7901, 45.5669],
    [-92.7734, 45.5682],
    [-92.7569, 45.5575],
    [-92.7400, 45.5496],
    [-92.7246, 45.5367],
    [-92.7277, 45.5188],
    [-92.7158, 45.5067],
    [-92.6952, 45.4829],
    [-92.6847, 45.4698],
    [-92.6802, 45.4643],
    [-92.6535, 45.4553],
    [-92.6467, 45.4418],
    [-92.6492, 45.4296],
    [-92.6503, 45.4192],
    [-92.6467, 45.4132],
    [-92.6505, 45.4019],
    [-92.6585, 45.3961],
    [-92.6707, 45.3877],
    [-92.6770, 45.3801],
    [-92.6792, 45.3727],
    [-92.7037, 45.3563],
    [-92.6990, 45.3395],
    [-92.6990, 45.3363],
    [-92.7061, 45.3252],
    [-92.7277, 45.3093],
    [-92.7371, 45.3005],
    [-92.7587, 45.2910],
    [-92.7619, 45.2849],
    [-92.7527, 45.2696],
    [-92.7517, 45.2617],
    [-92.7602, 45.2496],
    [-92.7557, 45.2259],
    [-92.7517, 45.2187],
    [-92.7580, 45.2096],
    [-92.7669, 45.1951],
    [-92.7649, 45.1828],
    [-92.7525, 45.1718],
    [-92.7578, 45.1605],
    [-92.7494, 45.1381],
    [-92.7457, 45.1231],
    [-92.7395, 45.1165],
    [-92.7449, 45.1083],
    [-92.7656, 45.0957],
    [-92.7915, 45.0796],
    [-92.7923, 45.0788],
    [-92.8029, 45.0654],
    [-92.8017, 45.0570],
    [-92.7879, 45.0435],
    [-92.7788, 45.0393],
    [-92.7646, 45.0288],
    [-92.7625, 45.0206],
    [-92.7675, 45.0104],
    [-92.7712, 45.0014],
    [-92.7690, 44.9882],
    [-92.7703, 44.9790],
    [-92.7685, 44.9698],
    [-92.7593, 44.9628],
    [-92.7533, 44.9509],
    [-92.7506, 44.9373],
    [-92.7576, 44.9112],
    [-92.7613, 44.9069],
    [-92.7731, 44.9014],
    [-92.7749, 44.8928],
    [-92.7641, 44.8759],
    [-92.7671, 44.8668],
    [-92.7691, 44.8620],
    [-92.7653, 44.8411],
    [-92.7694, 44.8318],
    [-92.7727, 44.8263],
    [-92.7804, 44.8126],
    [-92.7852, 44.7923],
    [-92.8003, 44.7774],
    [-92.8074, 44.7589],
    [-92.8046, 44.7487],
    [-92.8029, 44.7468],
    [-92.7879, 44.7374],
    [-92.7570, 44.7238],
    [-92.7373, 44.7172],
    [-92.7009, 44.6938],
    [-92.6950, 44.6883],
    [-92.6647, 44.6634],
    [-92.6321, 44.6490],
    [-92.6198, 44.6341],
    [-92.6233, 44.6207],
    [-92.6180, 44.6129],
    [-92.6015, 44.6121],
    [-92.5862, 44.6001],
    [-92.5789, 44.6039],
    [-92.5729, 44.6046],
    [-92.5672, 44.6018],
    [-92.5493, 44.5777],
    [-92.5512, 44.5734],
    [-92.5481, 44.5678],
    [-92.5406, 44.5673],
    [-92.5209, 44.5752],
    [-92.5088, 44.5703],
    [-92.4919, 44.5661],
    [-92.4810, 44.5683],
    [-92.4551, 44.5619],
    [-92.4311, 44.5658],
    [-92.4151, 44.5604],
    [-92.3890, 44.5577],
    [-92.3615, 44.5589],
    [-92.3357, 44.5538],
    [-92.3177, 44.5428],
    [-92.3141, 44.5380],
    [-92.3080, 44.5245],
    [-92.3025, 44.5165],
    [-92.2971, 44.4927],
    [-92.2768, 44.4736],
    [-92.2449, 44.4568],
    [-92.2373, 44.4494],
    [-92.2168, 44.4390],
    [-92.1893, 44.4325],
    [-92.1625, 44.4272],
    [-92.1245, 44.4221],
    [-92.1111, 44.4139],
    [-92.0836, 44.4072],
    [-92.0616, 44.4041],
    [-92.0463, 44.3944],
    [-92.0378, 44.3886],
    [-92.0086, 44.3796],
    [-92.0002, 44.3750],
    [-91.9870, 44.3691],
    [-91.9749, 44.3675],
    [-91.9667, 44.3639],
    [-91.9528, 44.3530],
    [-91.9362, 44.3388],
    [-91.9186, 44.3227],
    [-91.9136, 44.3104],
    [-91.9241, 44.2971],
    [-91.9237, 44.2903],
    [-91.9058, 44.2816],
    [-91.8964, 44.2747],
    [-91.8960, 44.2629],
    [-91.8870, 44.2518],
    [-91.8924, 44.2363],
    [-91.8898, 44.2263],
    [-91.8764, 44.2096],
    [-91.8755, 44.2013],
    [-91.8644, 44.1966],
    [-91.8387, 44.1826],
    [-91.8292, 44.1783],
    [-91.7967, 44.1543],
    [-91.7628, 44.1403],
    [-91.7331, 44.1331],
    [-91.7197, 44.1292],
    [-91.7095, 44.1176],
    [-91.7076, 44.1040],
    [-91.6913, 44.0979],
    [-91.6743, 44.0922],
    [-91.6653, 44.0850],
    [-91.6570, 44.0714],
    [-91.6479, 44.0641],
    [-91.6405, 44.0637],
    [-91.6334, 44.0604],
    [-91.6238, 44.0541],
    [-91.6105, 44.0493],
    [-91.5996, 44.0379],
    [-91.5826, 44.0274],
    [-91.5733, 44.0269],
    [-91.5531, 44.0238],
    [-91.5243, 44.0214],
    [-91.4950, 44.0125],
    [-91.4802, 44.0081],
    [-91.4635, 44.0090],
    [-91.4475, 44.0035],
    [-91.4353, 43.9986],
    [-91.4267, 43.9885],
    [-91.4241, 43.9826],
    [-91.4074, 43.9651],
    [-91.3876, 43.9553],
    [-91.3666, 43.9375],
    [-91.3632, 43.9266],
    [-91.3567, 43.9166],
    [-91.3463, 43.9101],
    [-91.3381, 43.8977],
    [-91.3153, 43.8818],
    [-91.3013, 43.8595],
    [-91.2967, 43.8552],
    [-91.2820, 43.8427],
    [-91.2757, 43.8249],
    [-91.2674, 43.8042],
    [-91.2624, 43.7922],
    [-91.2532, 43.7834],
    [-91.2554, 43.7449],
    [-91.2559, 43.7298],
    [-91.2613, 43.7195],
    [-91.2685, 43.7098],
    [-91.2685, 43.6929],
    [-91.2717, 43.6549],
    [-91.2639, 43.6477],
    [-91.2624, 43.6418],
    [-91.2687, 43.6153],
    [-91.2583, 43.6035],
    [-91.2391, 43.5898],
    [-91.2319, 43.5818],
    [-91.2318, 43.5727],
    [-91.2406, 43.5550],
    [-91.2441, 43.5456],
    [-91.2329, 43.5240],
    [-91.2226, 43.5179],
    [-91.2179, 43.5081],
    [-91.2618, 43.5010],
    [-91.3693, 43.5008],
    [-91.3769, 43.5005],
    [-91.4418, 43.5004],
    [-91.4616, 43.5006],
    [-91.4655, 43.5006],
    [-91.5338, 43.5006],
    [-91.5911, 43.5005],
    [-91.6109, 43.5005],
    [-91.6174, 43.5007],
    [-91.6342, 43.5005],
    [-91.6398, 43.5006],
    [-91.6584, 43.5005],
    [-91.7302, 43.5007],
    [-91.7333, 43.5006],
    [-91.7614, 43.5006],
    [-91.7906, 43.5008],
    [-91.8072, 43.5006],
    [-91.8497, 43.5007],
    [-91.9418, 43.5006],
    [-91.9697, 43.5005],
    [-92.0798, 43.5006],
    [-92.0900, 43.5007],
    [-92.1979, 43.5005],
    [-92.2090, 43.5005],
    [-92.2894, 43.5004],
    [-92.3294, 43.5004],
    [-92.3762, 43.5005],
    [-92.4061, 43.5005],
    [-92.4455, 43.5004],
    [-92.5388, 43.5003],
    [-92.5689, 43.5003],
    [-92.6533, 43.5000],
    [-92.6890, 43.5001],
    [-92.7073, 43.5001],
    [-92.7903, 43.4996],
    [-92.8358, 43.4996],
    [-92.9055, 43.4996],
    [-92.9469, 43.4996],
    [-93.0243, 43.4996],
    [-93.0643, 43.4996],
    [-93.1692, 43.4996],
    [-93.2289, 43.4996],
    [-93.2718, 43.4994],
    [-93.3537, 43.4994],
    [-93.3990, 43.4995],
    [-93.4686, 43.4995],
    [-93.4820, 43.4995],
    [-93.4974, 43.4995],
    [-93.5322, 43.4995],
    [-93.6046, 43.4995],
    [-93.6485, 43.4996],
    [-93.7049, 43.4996],
    [-93.7162, 43.4996],
    [-93.7943, 43.4995],
    [-93.8884, 43.4996],
    [-94.0683, 43.5002],
    [-94.0929, 43.5003],
    [-94.1069, 43.5003],
    [-94.1281, 43.5003],
    [-94.2480, 43.5003],
    [-94.3775, 43.5004],
    [-94.4375, 43.5006],
    [-94.4470, 43.5006],
    [-94.5608, 43.5004],
    [-94.6142, 43.5005],
    [-94.7342, 43.5006],
    [-94.8546, 43.5006],
    [-94.8727, 43.5006],
    [-94.9145, 43.5005],
    [-94.9150, 43.5005],
    [-94.9545, 43.5005],
    [-94.9945, 43.5005],
    [-95.0340, 43.5008],
    [-95.0940, 43.5007],
    [-95.1513, 43.5005],
    [-95.1679, 43.5009],
    [-95.2013, 43.5008],
    [-95.2508, 43.5004],
    [-95.3248, 43.5004],
    [-95.3753, 43.5003],
    [-95.3879, 43.5002],
    [-95.4343, 43.5004],
    [-95.4547, 43.5006],
    [-95.4868, 43.5002],
    [-95.5148, 43.4999],
    [-95.6233, 43.4999],
    [-95.6841, 43.4999],
    [-95.7414, 43.4999],
    [-95.8156, 43.5000],
    [-95.8344, 43.5000],
    [-95.9337, 43.5000],
    [-96.0962, 43.5002],
    [-96.1927, 43.5003],
    [-96.2088, 43.5004],
    [-96.2737, 43.5004],
    [-96.3321, 43.5004],
    [-96.4533, 43.5004],
    [-96.4533, 43.5812],
    [-96.4534, 43.5882],
    [-96.4534, 43.6099],
    [-96.4534, 43.6750],
    [-96.4534, 43.6896],
    [-96.4531, 43.8051],
    [-96.4533, 43.8496],
    [-96.4532, 43.8787],
    [-96.4533, 43.9203],
    [-96.4534, 43.9491],
    [-96.4532, 43.9665],
    [-96.4533, 43.9803],
    [-96.4533, 43.9947],
    [-96.4531, 44.0089],
    [-96.4534, 44.0237],
    [-96.4533, 44.0364],
    [-96.4528, 44.1693],
    [-96.4527, 44.2546],
    [-96.4524, 44.2720],
    [-96.4526, 44.2842],
    [-96.4522, 44.2987],
    [-96.4522, 44.3134],
    [-96.4522, 44.3406],
    [-96.4523, 44.3453],
    [-96.4522, 44.3717],
    [-96.4521, 44.3897],
    [-96.4518, 44.4589],
    [-96.4521, 44.4730],
    [-96.4522, 44.5269],
    [-96.4520, 44.5437],
    [-96.4517, 44.6307],
    [-96.4517, 44.6668],
    [-96.4512, 44.7183],
    [-96.4514, 44.7618],
    [-96.4518, 44.7905],
    [-96.4516, 44.8048],
    [-96.4518, 44.8487],
    [-96.4520, 44.8925],
    [-96.4523, 44.9627],
    [-96.4521, 44.9795],
    [-96.4522, 45.0516],
    [-96.4522, 45.0668],
    [-96.4520, 45.0951],
    [-96.4523, 45.1505],
    [-96.4522, 45.2031],
    [-96.4526, 45.2400],
    [-96.4529, 45.2761],
    [-96.4529, 45.2892],
    [-96.4541, 45.3015],
    [-96.4578, 45.3076],
    [-96.4680, 45.3186],
    [-96.4699, 45.3258],
    [-96.4826, 45.3463],
    [-96.5020, 45.3655],
    [-96.5309, 45.3785],
    [-96.5555, 45.3840],
    [-96.5748, 45.3910],
    [-96.6012, 45.4032],
    [-96.6177, 45.4081],
    [-96.6479, 45.4101],
    [-96.6754, 45.4102],
    [-96.6838, 45.4116],
    [-96.7020, 45.4262],
    [-96.7242, 45.4515],
    [-96.7368, 45.4668],
    [-96.7435, 45.4806],
    [-96.7516, 45.4998],
    [-96.7638, 45.5193],
    [-96.7849, 45.5413],
    [-96.8020, 45.5554],
    [-96.8440, 45.5940],
    [-96.8494, 45.5989],
    [-96.8578, 45.6060],
    [-96.8516, 45.6194],
    [-96.8442, 45.6396],
    [-96.8327, 45.6517],
    [-96.8262, 45.6542],
    [-96.7609, 45.6875],
    [-96.7451, 45.7016],
    [-96.6872, 45.7259],
    [-96.6626, 45.7387],
    [-96.6421, 45.7596],
    [-96.6389, 45.7691],
    [-96.6305, 45.7812],
    [-96.6253, 45.7879],
    [-96.6076, 45.7991],
    [-96.5932, 45.8139],
    [-96.5831, 45.8200],
    [-96.5775, 45.8379],
    [-96.5742, 45.8466],
    [-96.5747, 45.8668],
    [-96.5714, 45.8867],
    [-96.5689, 45.8952],
    [-96.5673, 45.9054],
    [-96.5662, 45.9087],
    [-96.5666, 45.9114],
    [-96.5702, 45.9120],
    [-96.5689, 45.9171],
    [-96.5640, 45.9196],
    [-96.5637, 45.9352],
    [-96.5621, 45.9477],
    [-96.5653, 45.9573],
    [-96.5724, 45.9802],
    [-96.5741, 46.0044],
    [-96.5766, 46.0218],
    [-96.5736, 46.0379],
    [-96.5593, 46.0583],
    [-96.5569, 46.0648],
    [-96.5581, 46.0721],
    [-96.5573, 46.0776],
    [-96.5545, 46.0840],
    [-96.5565, 46.0915],
    [-96.5580, 46.1024],
    [-96.5632, 46.1086],
    [-96.5657, 46.1120],
    [-96.5603, 46.1166],
    [-96.5673, 46.1198],
    [-96.5720, 46.1246],
    [-96.5692, 46.1303],
    [-96.5693, 46.1337],
    [-96.5748, 46.1431],
    [-96.5804, 46.1512],
    [-96.5781, 46.1567],
    [-96.5799, 46.1613],
    [-96.5807, 46.1671],
    [-96.5832, 46.1698],
    [-96.5799, 46.1735],
    [-96.5797, 46.1764],
    [-96.5860, 46.1769],
    [-96.5911, 46.1745],
    [-96.5918, 46.1784],
    [-96.5874, 46.1812],
    [-96.5896, 46.1837],
    [-96.5896, 46.1868],
    [-96.5886, 46.1897],
    [-96.5877, 46.1937],
    [-96.5912, 46.1957],
    [-96.5896, 46.1969],
    [-96.5836, 46.2010],
    [-96.5849, 46.2044],
    [-96.5875, 46.2070],
    [-96.5838, 46.2084],
    [-96.5885, 46.2129],
    [-96.5957, 46.2199],
    [-96.5969, 46.2320],
    [-96.5990, 46.2359],
    [-96.5986, 46.2416],
    [-96.5942, 46.2453],
    [-96.5906, 46.2451],
    [-96.5851, 46.2477],
    [-96.5857, 46.2504],
    [-96.5925, 46.2508],
    [-96.5937, 46.2550],
    [-96.5934, 46.2579],
    [-96.6004, 46.2619],
    [-96.5991, 46.2638],
    [-96.5976, 46.2700],
    [-96.5973, 46.2727],
    [-96.5955, 46.2767],
    [-96.6004, 46.2807],
    [-96.5957, 46.2850],
    [-96.5952, 46.2863],
    [-96.6016, 46.2873],
    [-96.5961, 46.2898],
    [-96.6020, 46.2925],
    [-96.5978, 46.2970],
    [-96.6014, 46.3008],
    [-96.6014, 46.3041],
    [-96.5982, 46.3126],
    [-96.5970, 46.3176],
    [-96.5999, 46.3253],
    [-96.6057, 46.3263],
    [-96.5999, 46.3293],
    [-96.6053, 46.3310],
    [-96.6110, 46.3368],
    [-96.6200, 46.3401],
    [-96.6162, 46.3459],
    [-96.6285, 46.3496],
    [-96.6293, 46.3542],
    [-96.6354, 46.3528],
    [-96.6454, 46.3508],
    [-96.6437, 46.3607],
    [-96.6507, 46.3637],
    [-96.6567, 46.3695],
    [-96.6603, 46.3718],
    [-96.6660, 46.3746],
    [-96.6698, 46.3846],
    [-96.6709, 46.3898],
    [-96.6700, 46.3914],
    [-96.6730, 46.3935],
    [-96.6785, 46.4048],
    [-96.6848, 46.4065],
    [-96.6883, 46.4109],
    [-96.6871, 46.4146],
    [-96.7008, 46.4144],
    [-96.6969, 46.4169],
    [-96.6929, 46.4190],
    [-96.6969, 46.4200],
    [-96.7047, 46.4182],
    [-96.7021, 46.4251],
    [-96.7010, 46.4272],
    [-96.7025, 46.4303],
    [-96.7072, 46.4318],
    [-96.7046, 46.4382],
    [-96.7130, 46.4378],
    [-96.7186, 46.4400],
    [-96.7123, 46.4415],
    [-96.7137, 46.4466],
    [-96.7173, 46.4462],
    [-96.7217, 46.4483],
    [-96.7142, 46.4496],
    [-96.7172, 46.4531],
    [-96.7143, 46.4550],
    [-96.7124, 46.4566],
    [-96.7145, 46.4610],
    [-96.7173, 46.4634],
    [-96.7166, 46.4665],
    [-96.7231, 46.4683],
    [-96.7142, 46.4710],
    [-96.7202, 46.4732],
    [-96.7267, 46.4741],
    [-96.7303, 46.4786],
    [-96.7381, 46.4778],
    [-96.7327, 46.4825],
    [-96.7381, 46.4853],
    [-96.7341, 46.4886],
    [-96.7348, 46.4955],
    [-96.7386, 46.4981],
    [-96.7387, 46.5013],
    [-96.7359, 46.5050],
    [-96.7373, 46.5081],
    [-96.7345, 46.5112],
    [-96.7374, 46.5176],
    [-96.7446, 46.5207],
    [-96.7385, 46.5258],
    [-96.7436, 46.5263],
    [-96.7434, 46.5337],
    [-96.7419, 46.5354],
    [-96.7392, 46.5366],
    [-96.7419, 46.5387],
    [-96.7421, 46.5407],
    [-96.7412, 46.5428],
    [-96.7456, 46.5430],
    [-96.7478, 46.5458],
    [-96.7430, 46.5470],
    [-96.7409, 46.5475],
    [-96.7485, 46.5494],
    [-96.7459, 46.5559],
    [-96.7544, 46.5567],
    [-96.7481, 46.5584],
    [-96.7508, 46.5611],
    [-96.7468, 46.5625],
    [-96.7452, 46.5653],
    [-96.7432, 46.5653],
    [-96.7458, 46.5671],
    [-96.7452, 46.5707],
    [-96.7526, 46.5712],
    [-96.7505, 46.5736],
    [-96.7469, 46.5757],
    [-96.7542, 46.5757],
    [-96.7565, 46.5766],
    [-96.7538, 46.5783],
    [-96.7514, 46.5821],
    [-96.7549, 46.5832],
    [-96.7518, 46.5865],
    [-96.7569, 46.5869],
    [-96.7626, 46.5918],
    [-96.7558, 46.5928],
    [-96.7618, 46.5941],
    [-96.7674, 46.5989],
    [-96.7718, 46.5969],
    [-96.7701, 46.6023],
    [-96.7687, 46.6067],
    [-96.7786, 46.6067],
    [-96.7724, 46.6094],
    [-96.7735, 46.6141],
    [-96.7729, 46.6164],
    [-96.7801, 46.6145],
    [-96.7762, 46.6169],
    [-96.7776, 46.6203],
    [-96.7850, 46.6192],
    [-96.7832, 46.6235],
    [-96.7839, 46.6263],
    [-96.7911, 46.6255],
    [-96.7848, 46.6294],
    [-96.7892, 46.6292],
    [-96.7957, 46.6295],
    [-96.7980, 46.6303],
    [-96.7911, 46.6383],
    [-96.7866, 46.6411],
    [-96.7915, 46.6447],
    [-96.7907, 46.6491],
    [-96.7988, 46.6581],
    [-96.7995, 46.6608],
    [-96.7960, 46.6657],
    [-96.7978, 46.6688],
    [-96.7939, 46.6692],
    [-96.7921, 46.6735],
    [-96.7990, 46.6744],
    [-96.7965, 46.6790],
    [-96.7921, 46.6766],
    [-96.7883, 46.6786],
    [-96.7944, 46.6835],
    [-96.7878, 46.6846],
    [-96.7851, 46.6876],
    [-96.7903, 46.6903],
    [-96.7868, 46.6928],
    [-96.7873, 46.6992],
    [-96.7848, 46.7019],
    [-96.7909, 46.7030],
    [-96.7867, 46.7054],
    [-96.7849, 46.7072],
    [-96.7862, 46.7104],
    [-96.7862, 46.7129],
    [-96.7825, 46.7164],
    [-96.7828, 46.7175],
    [-96.7911, 46.7178],
    [-96.7798, 46.7233],
    [-96.7793, 46.7274],
    [-96.7825, 46.7289],
    [-96.7808, 46.7338],
    [-96.7814, 46.7388],
    [-96.7810, 46.7420],
    [-96.7861, 46.7442],
    [-96.7820, 46.7453],
    [-96.7855, 46.7469],
    [-96.7839, 46.7497],
    [-96.7870, 46.7522],
    [-96.7845, 46.7540],
    [-96.7893, 46.7561],
    [-96.7848, 46.7564],
    [-96.7860, 46.7601],
    [-96.7822, 46.7610],
    [-96.7793, 46.7630],
    [-96.7895, 46.7660],
    [-96.7757, 46.7660],
    [-96.7884, 46.7703],
    [-96.7859, 46.7740],
    [-96.7838, 46.7782],
    [-96.7914, 46.7762],
    [-96.7907, 46.7825],
    [-96.7876, 46.7862],
    [-96.7942, 46.7885],
    [-96.7970, 46.7916],
    [-96.7949, 46.7958],
    [-96.8019, 46.7970],
    [-96.7960, 46.8003],
    [-96.7965, 46.8036],
    [-96.8031, 46.8051],
    [-96.7958, 46.8078],
    [-96.8025, 46.8115],
    [-96.7993, 46.8154],
    [-96.7983, 46.8219],
    [-96.7930, 46.8258],
    [-96.7839, 46.8263],
    [-96.7803, 46.8258],
    [-96.7939, 46.8331],
    [-96.7852, 46.8331],
    [-96.7868, 46.8388],
    [-96.7820, 46.8410],
    [-96.7751, 46.8404],
    [-96.7817, 46.8457],
    [-96.7790, 46.8487],
    [-96.7747, 46.8524],
    [-96.7842, 46.8520],
    [-96.7781, 46.8540],
    [-96.7794, 46.8587],
    [-96.7839, 46.8633],
    [-96.7807, 46.8672],
    [-96.7820, 46.8708],
    [-96.7764, 46.8750],
    [-96.7803, 46.8770],
    [-96.7804, 46.8802],
    [-96.7756, 46.8792],
    [-96.7720, 46.8783],
    [-96.7685, 46.8796],
    [-96.7681, 46.8848],
    [-96.7736, 46.8848],
    [-96.7735, 46.8896],
    [-96.7749, 46.8941],
    [-96.7707, 46.9003],
    [-96.7705, 46.9068],
    [-96.7645, 46.9075],
    [-96.7615, 46.9144],
    [-96.7557, 46.9138],
    [-96.7612, 46.9197],
    [-96.7614, 46.9244],
    [-96.7533, 46.9246],
    [-96.7651, 46.9291],
    [-96.7569, 46.9285],
    [-96.7618, 46.9347],
    [-96.7752, 46.9309],
    [-96.7768, 46.9263],
    [-96.7803, 46.9283],
    [-96.7851, 46.9292],
    [-96.7892, 46.9280],
    [-96.7916, 46.9312],
    [-96.7916, 46.9343],
    [-96.7920, 46.9413],
    [-96.7954, 46.9470],
    [-96.8029, 46.9463],
    [-96.8028, 46.9486],
    [-96.7992, 46.9493],
    [-96.7988, 46.9530],
    [-96.8035, 46.9584],
    [-96.7950, 46.9654],
    [-96.8013, 46.9659],
    [-96.8048, 46.9673],
    [-96.8098, 46.9639],
    [-96.8156, 46.9670],
    [-96.8219, 46.9694],
    [-96.8201, 46.9767],
    [-96.8199, 46.9774],
    [-96.8260, 46.9888],
    [-96.8225, 46.9913],
    [-96.8232, 46.9980],
    [-96.8209, 46.9990],
    [-96.8211, 47.0028],
    [-96.8262, 47.0019],
    [-96.8298, 47.0054],
    [-96.8342, 47.0067],
    [-96.8395, 47.0067],
    [-96.8339, 47.0128],
    [-96.8347, 47.0170],
    [-96.8300, 47.0205],
    [-96.8196, 47.0245],
    [-96.8149, 47.0252],
    [-96.8212, 47.0306],
    [-96.8266, 47.0329],
    [-96.8163, 47.0338],
    [-96.8156, 47.0398],
    [-96.8215, 47.0358],
    [-96.8176, 47.0459],
    [-96.8264, 47.0452],
    [-96.8210, 47.0488],
    [-96.8247, 47.0553],
    [-96.8222, 47.0595],
    [-96.8289, 47.0594],
    [-96.8244, 47.0613],
    [-96.8206, 47.0631],
    [-96.8235, 47.0659],
    [-96.8212, 47.0731],
    [-96.8233, 47.0745],
    [-96.8274, 47.0726],
    [-96.8261, 47.0765],
    [-96.8157, 47.0799],
    [-96.8198, 47.0847],
    [-96.8160, 47.0885],
    [-96.8263, 47.0887],
    [-96.8192, 47.0911],
    [-96.8173, 47.0981],
    [-96.8159, 47.1041],
    [-96.8200, 47.1077],
    [-96.8222, 47.1117],
    [-96.8233, 47.1175],
    [-96.8315, 47.1204],
    [-96.8370, 47.1232],
    [-96.8267, 47.1229],
    [-96.8245, 47.1272],
    [-96.8231, 47.1313],
    [-96.8307, 47.1297],
    [-96.8263, 47.1349],
    [-96.8314, 47.1418],
    [-96.8330, 47.1449],
    [-96.8309, 47.1485],
    [-96.8357, 47.1486],
    [-96.8400, 47.1506],
    [-96.8377, 47.1528],
    [-96.8365, 47.1565],
    [-96.8303, 47.1548],
    [-96.8224, 47.1569],
    [-96.8306, 47.1582],
    [-96.8243, 47.1611],
    [-96.8190, 47.1649],
    [-96.8245, 47.1665],
    [-96.8224, 47.1727],
    [-96.8285, 47.1739],
    [-96.8324, 47.1777],
    [-96.8248, 47.1780],
    [-96.8263, 47.1825],
    [-96.8231, 47.1857],
    [-96.8348, 47.1838],
    [-96.8326, 47.1876],
    [-96.8259, 47.1908],
    [-96.8382, 47.1964],
    [-96.8399, 47.1932],
    [-96.8447, 47.1929],
    [-96.8357, 47.2019],
    [-96.8298, 47.2004],
    [-96.8296, 47.2040],
    [-96.8372, 47.2075],
    [-96.8308, 47.2095],
    [-96.8358, 47.2145],
    [-96.8335, 47.2189],
    [-96.8367, 47.2230],
    [-96.8404, 47.2188],
    [-96.8456, 47.2211],
    [-96.8321, 47.2259],
    [-96.8374, 47.2293],
    [-96.8412, 47.2334],
    [-96.8316, 47.2313],
    [-96.8289, 47.2342],
    [-96.8333, 47.2382],
    [-96.8385, 47.2422],
    [-96.8419, 47.2388],
    [-96.8399, 47.2439],
    [-96.8325, 47.2480],
    [-96.8385, 47.2522],
    [-96.8440, 47.2503],
    [-96.8394, 47.2548],
    [-96.8411, 47.2568],
    [-96.8448, 47.2589],
    [-96.8366, 47.2602],
    [-96.8404, 47.2628],
    [-96.8465, 47.2609],
    [-96.8421, 47.2653],
    [-96.8346, 47.2670],
    [-96.8439, 47.2686],
    [-96.8458, 47.2731],
    [-96.8402, 47.2770],
    [-96.8439, 47.2930],
    [-96.8315, 47.3070],
    [-96.8370, 47.3114],
    [-96.8429, 47.3087],
    [-96.8436, 47.3143],
    [-96.8460, 47.3170],
    [-96.8371, 47.3187],
    [-96.8359, 47.3223],
    [-96.8350, 47.3257],
    [-96.8291, 47.3269],
    [-96.8323, 47.3306],
    [-96.8382, 47.3282],
    [-96.8449, 47.3272],
    [-96.8446, 47.3314],
    [-96.8348, 47.3325],
    [-96.8319, 47.3401],
    [-96.8406, 47.3410],
    [-96.8473, 47.3494],
    [-96.8445, 47.3525],
    [-96.8384, 47.3534],
    [-96.8458, 47.3564],
    [-96.8521, 47.3599],
    [-96.8485, 47.3648],
    [-96.8567, 47.3662],
    [-96.8523, 47.3697],
    [-96.8378, 47.3708],
    [-96.8415, 47.3731],
    [-96.8520, 47.3719],
    [-96.8527, 47.3750],
    [-96.8439, 47.3756],
    [-96.8489, 47.3799],
    [-96.8457, 47.3821],
    [-96.8382, 47.3822],
    [-96.8417, 47.3870],
    [-96.8395, 47.3925],
    [-96.8434, 47.3922],
    [-96.8487, 47.3950],
    [-96.8399, 47.3982],
    [-96.8450, 47.4031],
    [-96.8521, 47.4071],
    [-96.8419, 47.4108],
    [-96.8447, 47.4120],
    [-96.8581, 47.4103],
    [-96.8621, 47.4152],
    [-96.8635, 47.4180],
    [-96.8710, 47.4182],
    [-96.8643, 47.4210],
    [-96.8559, 47.4240],
    [-96.8573, 47.4272],
    [-96.8641, 47.4270],
    [-96.8608, 47.4302],
    [-96.8534, 47.4315],
    [-96.8590, 47.4341],
    [-96.8624, 47.4373],
    [-96.8558, 47.4399],
    [-96.8591, 47.4470],
    [-96.8592, 47.4516],
    [-96.8545, 47.4535],
    [-96.8592, 47.4553],
    [-96.8622, 47.4583],
    [-96.8539, 47.4604],
    [-96.8596, 47.4669],
    [-96.8575, 47.4738],
    [-96.8527, 47.4800],
    [-96.8645, 47.4771],
    [-96.8684, 47.4790],
    [-96.8608, 47.4842],
    [-96.8522, 47.4858],
    [-96.8647, 47.4905],
    [-96.8612, 47.4921],
    [-96.8553, 47.4950],
    [-96.8490, 47.4979],
    [-96.8508, 47.4999],
    [-96.8531, 47.5068],
    [-96.8437, 47.5074],
    [-96.8457, 47.5105],
    [-96.8536, 47.5114],
    [-96.8492, 47.5133],
    [-96.8420, 47.5152],
    [-96.8484, 47.5163],
    [-96.8614, 47.5159],
    [-96.8661, 47.5229],
    [-96.8704, 47.5265],
    [-96.8624, 47.5291],
    [-96.8538, 47.5360],
    [-96.8590, 47.5371],
    [-96.8632, 47.5406],
    [-96.8528, 47.5408],
    [-96.8485, 47.5372],
    [-96.8473, 47.5417],
    [-96.8605, 47.5465],
    [-96.8499, 47.5525],
    [-96.8575, 47.5553],
    [-96.8612, 47.5602],
    [-96.8539, 47.5605],
    [-96.8475, 47.5662],
    [-96.8575, 47.5644],
    [-96.8684, 47.5658],
    [-96.8647, 47.5695],
    [-96.8517, 47.5685],
    [-96.8558, 47.5727],
    [-96.8560, 47.5770],
    [-96.8516, 47.5860],
    [-96.8510, 47.5923],
    [-96.8583, 47.5962],
    [-96.8511, 47.5979],
    [-96.8569, 47.6023],
    [-96.8554, 47.6088],
    [-96.8649, 47.6124],
    [-96.8722, 47.6135],
    [-96.8710, 47.6168],
    [-96.8764, 47.6192],
    [-96.8759, 47.6226],
    [-96.8806, 47.6256],
    [-96.8744, 47.6278],
    [-96.8815, 47.6300],
    [-96.8882, 47.6397],
    [-96.8824, 47.6490],
    [-96.8876, 47.6589],
    [-96.8871, 47.6664],
    [-96.8868, 47.6721],
    [-96.8851, 47.6738],
    [-96.8953, 47.6736],
    [-96.8991, 47.6856],
    [-96.9017, 47.6916],
    [-96.9072, 47.6885],
    [-96.9101, 47.6912],
    [-96.9098, 47.6973],
    [-96.9144, 47.7016],
    [-96.9208, 47.7014],
    [-96.9129, 47.7047],
    [-96.9165, 47.7086],
    [-96.9203, 47.7124],
    [-96.9223, 47.7179],
    [-96.9285, 47.7143],
    [-96.9284, 47.7187],
    [-96.9186, 47.7239],
    [-96.9254, 47.7302],
    [-96.9333, 47.7387],
    [-96.9285, 47.7449],
    [-96.9314, 47.7518],
    [-96.9398, 47.7553],
    [-96.9322, 47.7547],
    [-96.9304, 47.7567],
    [-96.9379, 47.7602],
    [-96.9384, 47.7624],
    [-96.9352, 47.7675],
    [-96.9468, 47.7751],
    [-96.9557, 47.7747],
    [-96.9527, 47.7798],
    [-96.9596, 47.7818],
    [-96.9619, 47.7833],
    [-96.9654, 47.7849],
    [-96.9573, 47.7901],
    [-96.9635, 47.7946],
    [-96.9717, 47.7983],
    [-96.9772, 47.7995],
    [-96.9721, 47.8026],
    [-96.9834, 47.8054],
    [-96.9910, 47.8077],
    [-96.9815, 47.8090],
    [-96.9804, 47.8157],
    [-96.9787, 47.8225],
    [-96.9750, 47.8245],
    [-96.9842, 47.8253],
    [-96.9824, 47.8284],
    [-96.9867, 47.8376],
    [-96.9942, 47.8388],
    [-96.9961, 47.8418],
    [-96.9964, 47.8444],
    [-96.9965, 47.8480],
    [-96.9968, 47.8544],
    [-96.9996, 47.8602],
    [-97.0056, 47.8640],
    [-97.0016, 47.8674],
    [-97.0099, 47.8707],
    [-97.0213, 47.8726],
    [-97.0190, 47.8769],
    [-97.0234, 47.8821],
    [-97.0192, 47.8898],
    [-97.0240, 47.8981],
    [-97.0203, 47.9022],
    [-97.0236, 47.9085],
    [-97.0171, 47.9058],
    [-97.0173, 47.9131],
    [-97.0181, 47.9181],
    [-97.0216, 47.9223],
    [-97.0297, 47.9276],
    [-97.0373, 47.9332],
    [-97.0361, 47.9394],
    [-97.0450, 47.9411],
    [-97.0556, 47.9491],
    [-97.0552, 47.9508],
    [-97.0541, 47.9597],
    [-97.0615, 47.9636],
    [-97.0579, 47.9690],
    [-97.0592, 47.9754],
    [-97.0531, 47.9903],
    [-97.0549, 47.9929],
    [-97.0668, 48.0096],
    [-97.0633, 48.0150],
    [-97.0707, 48.0169],
    [-97.0720, 48.0206],
    [-97.0687, 48.0277],
    [-97.0740, 48.0512],
    [-97.0841, 48.0565],
    [-97.0978, 48.0711],
    [-97.1047, 48.0731],
    [-97.0994, 48.0821],
    [-97.1047, 48.0901],
    [-97.1089, 48.0929],
    [-97.1022, 48.0967],
    [-97.1095, 48.1047],
    [-97.1198, 48.1054],
    [-97.1237, 48.1080],
    [-97.1206, 48.1134],
    [-97.1269, 48.1243],
    [-97.1322, 48.1358],
    [-97.1277, 48.1362],
    [-97.1223, 48.1386],
    [-97.1319, 48.1424],
    [-97.1436, 48.1410],
    [-97.1459, 48.1451],
    [-97.1210, 48.1591],
    [-97.1274, 48.1627],
    [-97.1380, 48.1595],
    [-97.1452, 48.1667],
    [-97.1464, 48.1732],
    [-97.1364, 48.1760],
    [-97.1396, 48.1826],
    [-97.1485, 48.1824],
    [-97.1478, 48.1876],
    [-97.1415, 48.1925],
    [-97.1365, 48.1963],
    [-97.1368, 48.1995],
    [-97.1409, 48.2045],
    [-97.1296, 48.2080],
    [-97.1354, 48.2115],
    [-97.1355, 48.2179],
    [-97.1261, 48.2100],
    [-97.1198, 48.2075],
    [-97.1248, 48.2174],
    [-97.1448, 48.2208],
    [-97.1517, 48.2189],
    [-97.1465, 48.2243],
    [-97.1333, 48.2269],
    [-97.1207, 48.2258],
    [-97.1393, 48.2302],
    [-97.1443, 48.2350],
    [-97.1344, 48.2377],
    [-97.1405, 48.2415],
    [-97.1467, 48.2445],
    [-97.1357, 48.2494],
    [-97.1251, 48.2500],
    [-97.1274, 48.2554],
    [-97.1292, 48.2599],
    [-97.1242, 48.2636],
    [-97.1351, 48.2658],
    [-97.1451, 48.2677],
    [-97.1361, 48.2710],
    [-97.1241, 48.2712],
    [-97.1255, 48.2762],
    [-97.1175, 48.2780],
    [-97.1167, 48.2812],
    [-97.1222, 48.2901],
    [-97.1304, 48.2902],
    [-97.1375, 48.2877],
    [-97.1355, 48.2929],
    [-97.1283, 48.2988],
    [-97.1206, 48.2950],
    [-97.1129, 48.2948],
    [-97.1180, 48.3004],
    [-97.1262, 48.3037],
    [-97.1230, 48.3080],
    [-97.1270, 48.3119],
    [-97.1366, 48.3091],
    [-97.1349, 48.3159],
    [-97.1275, 48.3195],
    [-97.1165, 48.3221],
    [-97.1222, 48.3274],
    [-97.1353, 48.3273],
    [-97.1398, 48.3251],
    [-97.1416, 48.3286],
    [-97.1311, 48.3319],
    [-97.1259, 48.3383],
    [-97.1320, 48.3439],
    [-97.1410, 48.3456],
    [-97.1364, 48.3524],
    [-97.1455, 48.3579],
    [-97.1555, 48.3638],
    [-97.1548, 48.3700],
    [-97.1438, 48.3703],
    [-97.1374, 48.3718],
    [-97.1404, 48.3797],
    [-97.1344, 48.3833],
    [-97.1443, 48.3816],
    [-97.1572, 48.3857],
    [-97.1577, 48.3912],
    [-97.1621, 48.3948],
    [-97.1482, 48.3968],
    [-97.1406, 48.4018],
    [-97.1316, 48.4095],
    [-97.1385, 48.4145],
    [-97.1435, 48.4180],
    [-97.1533, 48.4131],
    [-97.1509, 48.4195],
    [-97.1367, 48.4215],
    [-97.1260, 48.4161],
    [-97.1228, 48.4203],
    [-97.1347, 48.4261],
    [-97.1426, 48.4276],
    [-97.1412, 48.4338],
    [-97.1291, 48.4311],
    [-97.1234, 48.4370],
    [-97.1314, 48.4440],
    [-97.1464, 48.4381],
    [-97.1481, 48.4441],
    [-97.1315, 48.4516],
    [-97.1290, 48.4566],
    [-97.1334, 48.4638],
    [-97.1455, 48.4659],
    [-97.1420, 48.4746],
    [-97.1295, 48.4715],
    [-97.1324, 48.4772],
    [-97.1549, 48.4749],
    [-97.1627, 48.4778],
    [-97.1456, 48.4830],
    [-97.1397, 48.4881],
    [-97.1415, 48.4926],
    [-97.1350, 48.4876],
    [-97.1322, 48.4924],
    [-97.1479, 48.4995],
    [-97.1499, 48.5120],
    [-97.1390, 48.5117],
    [-97.1269, 48.5198],
    [-97.1366, 48.5221],
    [-97.1506, 48.5195],
    [-97.1536, 48.5295],
    [-97.1410, 48.5342],
    [-97.1597, 48.5413],
    [-97.1632, 48.5440],
    [-97.1625, 48.5541],
    [-97.1534, 48.5512],
    [-97.1386, 48.5523],
    [-97.1461, 48.5573],
    [-97.1722, 48.5591],
    [-97.1736, 48.5644],
    [-97.1516, 48.5676],
    [-97.1479, 48.5746],
    [-97.1573, 48.5780],
    [-97.1585, 48.5823],
    [-97.1449, 48.5815],
    [-97.1416, 48.5908],
    [-97.1526, 48.5939],
    [-97.1522, 48.5975],
    [-97.1438, 48.5984],
    [-97.1348, 48.6064],
    [-97.1437, 48.6080],
    [-97.1498, 48.6127],
    [-97.1329, 48.6134],
    [-97.1298, 48.6171],
    [-97.1352, 48.6221],
    [-97.1259, 48.6194],
    [-97.1194, 48.6194],
    [-97.1276, 48.6265],
    [-97.1308, 48.6308],
    [-97.1280, 48.6338],
    [-97.1169, 48.6309],
    [-97.1113, 48.6310],
    [-97.1097, 48.6389],
    [-97.1157, 48.6445],
    [-97.1078, 48.6477],
    [-97.1030, 48.6561],
    [-97.0987, 48.6613],
    [-97.1065, 48.6625],
    [-97.1077, 48.6652],
    [-97.1006, 48.6684],
    [-97.1018, 48.6812],
    [-97.0937, 48.6820],
    [-97.0925, 48.6862],
    [-97.1201, 48.7014],
    [-97.1123, 48.7055],
    [-97.1136, 48.7097],
    [-97.1232, 48.7171],
    [-97.1264, 48.7211],
    [-97.1376, 48.7276],
    [-97.1283, 48.7321],
    [-97.1377, 48.7342],
    [-97.1401, 48.7390],
    [-97.1382, 48.7502],
    [-97.1530, 48.7528],
    [-97.1472, 48.7617],
    [-97.1489, 48.7679],
    [-97.1563, 48.7730],
    [-97.1575, 48.7769],
    [-97.1473, 48.7811],
    [-97.1500, 48.7826],
    [-97.1594, 48.7838],
    [-97.1579, 48.7876],
    [-97.1581, 48.7911],
    [-97.1712, 48.7920],
    [-97.1714, 48.7965],
    [-97.1616, 48.7976],
    [-97.1699, 48.8012],
    [-97.1786, 48.7971],
    [-97.1790, 48.8011],
    [-97.1696, 48.8040],
    [-97.1587, 48.8065],
    [-97.1641, 48.8120],
    [-97.1785, 48.8145],
    [-97.1875, 48.8142],
    [-97.1886, 48.8170],
    [-97.1777, 48.8248],
    [-97.1845, 48.8334],
    [-97.1757, 48.8362],
    [-97.1744, 48.8426],
    [-97.1829, 48.8469],
    [-97.1733, 48.8503],
    [-97.1790, 48.8573],
    [-97.1828, 48.8640],
    [-97.1904, 48.8653],
    [-97.1801, 48.8726],
    [-97.1823, 48.8772],
    [-97.1937, 48.8779],
    [-97.1999, 48.8826],
    [-97.1981, 48.8886],
    [-97.2010, 48.8908],
    [-97.1973, 48.8920],
    [-97.1898, 48.8945],
    [-97.2016, 48.9010],
    [-97.2127, 48.9081],
    [-97.2112, 48.9166],
    [-97.2198, 48.9220],
    [-97.2149, 48.9297],
    [-97.2202, 48.9324],
    [-97.2255, 48.9350],
    [-97.2265, 48.9456],
    [-97.2321, 48.9464],
    [-97.2332, 48.9508],
    [-97.2295, 48.9596],
    [-97.2296, 48.9640],
    [-97.2382, 48.9659],
    [-97.2392, 48.9687]
    ]
  },
  "Connecticut": {
    coordinates: [
      [-73.7278, 41.1007],
    [-73.6684, 41.1282],
    [-73.6340, 41.1441],
    [-73.6144, 41.1529],
    [-73.5862, 41.1656],
    [-73.5547, 41.1799],
    [-73.5128, 41.1993],
    [-73.5092, 41.2009],
    [-73.4849, 41.2118],
    [-73.5174, 41.2555],
    [-73.5405, 41.2830],
    [-73.5499, 41.3015],
    [-73.5496, 41.3159],
    [-73.5452, 41.3615],
    [-73.5436, 41.3751],
    [-73.5424, 41.3894],
    [-73.5412, 41.4060],
    [-73.5373, 41.4379],
    [-73.5361, 41.4513],
    [-73.5359, 41.4552],
    [-73.5353, 41.4635],
    [-73.5343, 41.4764],
    [-73.5341, 41.4789],
    [-73.5324, 41.4986],
    [-73.5306, 41.5203],
    [-73.5257, 41.5717],
    [-73.5200, 41.6412],
    [-73.5168, 41.6876],
    [-73.5119, 41.7409],
    [-73.5110, 41.7577],
    [-73.5050, 41.8238],
    [-73.5020, 41.8587],
    [-73.4995, 41.8819],
    [-73.4965, 41.9224],
    [-73.4896, 42.0001],
    [-73.4368, 42.0505],
    [-73.3405, 42.0482],
    [-73.2963, 42.0470],
    [-73.2334, 42.0450],
    [-73.2298, 42.0449],
    [-73.0533, 42.0399],
    [-72.9995, 42.0387],
    [-72.8636, 42.0377],
    [-72.8350, 42.0367],
    [-72.8167, 41.9976],
    [-72.7706, 42.0026],
    [-72.7661, 42.0077],
    [-72.7612, 42.0146],
    [-72.7623, 42.0198],
    [-72.7582, 42.0209],
    [-72.7517, 42.0302],
    [-72.7558, 42.0362],
    [-72.7146, 42.0366],
    [-72.6959, 42.0368],
    [-72.6431, 42.0324],
    [-72.6080, 42.0308],
    [-72.6069, 42.0250],
    [-72.5823, 42.0247],
    [-72.5634, 42.0310],
    [-72.5531, 42.0320],
    [-72.5315, 42.0340],
    [-72.5092, 42.0342],
    [-72.4583, 42.0340],
    [-72.3974, 42.0331],
    [-72.3213, 42.0320],
    [-72.2495, 42.0316],
    [-72.1988, 42.0310],
    [-72.1357, 42.0302],
    [-72.0997, 42.0288],
    [-72.0100, 42.0270],
    [-71.9873, 42.0269],
    [-71.9210, 42.0252],
    [-71.8839, 42.0243],
    [-71.8660, 42.0241],
    [-71.8416, 42.0239],
    [-71.7992, 42.0081],
    [-71.7984, 41.9606],
    [-71.7977, 41.9286],
    [-71.7947, 41.8544],
    [-71.7942, 41.8401],
    [-71.7927, 41.8046],
    [-71.7911, 41.7702],
    [-71.7886, 41.6983],
    [-71.7876, 41.6399],
    [-71.7894, 41.5969],
    [-71.7926, 41.5268],
    [-71.7955, 41.4640],
    [-71.7972, 41.4264],
    [-71.8014, 41.4155],
    [-71.8129, 41.4194],
    [-71.8239, 41.4172],
    [-71.8341, 41.4116],
    [-71.8426, 41.4099],
    [-71.8433, 41.4045],
    [-71.8422, 41.3969],
    [-71.8386, 41.3912],
    [-71.8327, 41.3872],
    [-71.8316, 41.3800],
    [-71.8327, 41.3756],
    [-71.8320, 41.3702],
    [-71.8349, 41.3676],
    [-71.8377, 41.3637],
    [-71.8368, 41.3551],
    [-71.8299, 41.3466],
    [-71.8362, 41.3360],
    [-71.8519, 41.3247],
    [-71.8596, 41.3224],
    [-71.8824, 41.3362],
    [-71.8937, 41.3333],
    [-71.9091, 41.3275],
    [-71.9327, 41.3333],
    [-71.9457, 41.3378],
    [-71.9624, 41.3215],
    [-71.9803, 41.3299],
    [-71.9892, 41.3159],
    [-72.0007, 41.3182],
    [-72.0057, 41.3067],
    [-72.0116, 41.3077],
    [-72.0275, 41.3160],
    [-72.0364, 41.3159],
    [-72.0548, 41.3133],
    [-72.0650, 41.3152],
    [-72.0820, 41.3172],
    [-72.0944, 41.3142],
    [-72.1011, 41.3041],
    [-72.1118, 41.2991],
    [-72.1342, 41.2994],
    [-72.1560, 41.3131],
    [-72.1611, 41.3069],
    [-72.1739, 41.3176],
    [-72.1841, 41.3240],
    [-72.2014, 41.3157],
    [-72.2036, 41.3044],
    [-72.2014, 41.2885],
    [-72.2129, 41.2914],
    [-72.2252, 41.2973],
    [-72.2318, 41.2966],
    [-72.2454, 41.2975],
    [-72.2515, 41.2987],
    [-72.2513, 41.2900],
    [-72.2780, 41.2841],
    [-72.2988, 41.2789],
    [-72.3289, 41.2794],
    [-72.3417, 41.2964],
    [-72.3505, 41.3117],
    [-72.3564, 41.2912],
    [-72.3493, 41.2846],
    [-72.3455, 41.2757],
    [-72.3481, 41.2701],
    [-72.3640, 41.2655],
    [-72.3866, 41.2618],
    [-72.3982, 41.2774],
    [-72.4167, 41.2783],
    [-72.4262, 41.2741],
    [-72.4519, 41.2789],
    [-72.4710, 41.2697],
    [-72.4725, 41.2701],
    [-72.4995, 41.2659],
    [-72.5103, 41.2566],
    [-72.5213, 41.2656],
    [-72.5332, 41.2627],
    [-72.5368, 41.2509],
    [-72.5706, 41.2677],
    [-72.5833, 41.2717],
    [-72.5980, 41.2687],
    [-72.6078, 41.2704],
    [-72.6172, 41.2720],
    [-72.6314, 41.2691],
    [-72.6545, 41.2658],
    [-72.6622, 41.2689],
    [-72.6732, 41.2676],
    [-72.6771, 41.2583],
    [-72.6851, 41.2580],
    [-72.6855, 41.2513],
    [-72.6934, 41.2455],
    [-72.7018, 41.2448],
    [-72.7112, 41.2510],
    [-72.7180, 41.2559],
    [-72.7148, 41.2614],
    [-72.7328, 41.2547],
    [-72.7368, 41.2613],
    [-72.7517, 41.2621],
    [-72.7575, 41.2669],
    [-72.7861, 41.2648],
    [-72.7999, 41.2578],
    [-72.8057, 41.2550],
    [-72.8185, 41.2485],
    [-72.8224, 41.2589],
    [-72.8275, 41.2629],
    [-72.8358, 41.2483],
    [-72.8478, 41.2567],
    [-72.8511, 41.2501],
    [-72.8613, 41.2453],
    [-72.8954, 41.2437],
    [-72.9010, 41.2465],
    [-72.9041, 41.2496],
    [-72.9006, 41.2544],
    [-72.8988, 41.2556],
    [-72.8947, 41.2565],
    [-72.8964, 41.2639],
    [-72.9050, 41.2716],
    [-72.9059, 41.2827],
    [-72.9073, 41.2953],
    [-72.9219, 41.2893],
    [-72.9297, 41.2809],
    [-72.9365, 41.2817],
    [-72.9382, 41.2809],
    [-72.9386, 41.2800],
    [-72.9366, 41.2770],
    [-72.9359, 41.2726],
    [-72.9317, 41.2691],
    [-72.9307, 41.2669],
    [-72.9302, 41.2657],
    [-72.9310, 41.2627],
    [-72.9362, 41.2599],
    [-72.9532, 41.2554],
    [-72.9572, 41.2524],
    [-72.9635, 41.2480],
    [-72.9693, 41.2431],
    [-72.9720, 41.2372],
    [-72.9787, 41.2335],
    [-72.9817, 41.2347],
    [-72.9869, 41.2351],
    [-72.9903, 41.2265],
    [-72.9928, 41.2236],
    [-73.0010, 41.2227],
    [-73.0038, 41.2216],
    [-73.0062, 41.2159],
    [-73.0087, 41.2099],
    [-73.0145, 41.2047],
    [-73.0202, 41.2048],
    [-73.0233, 41.2076],
    [-73.0352, 41.2056],
    [-73.0364, 41.2040],
    [-73.0447, 41.2092],
    [-73.0496, 41.2108],
    [-73.0608, 41.2058],
    [-73.0743, 41.1970],
    [-73.0782, 41.1950],
    [-73.0828, 41.1923],
    [-73.0909, 41.1852],
    [-73.1033, 41.1741],
    [-73.1058, 41.1717],
    [-73.1104, 41.1597],
    [-73.1030, 41.1514],
    [-73.1303, 41.1468],
    [-73.1722, 41.1591],
    [-73.1778, 41.1667],
    [-73.1844, 41.1644],
    [-73.2027, 41.1581],
    [-73.2165, 41.1487],
    [-73.2197, 41.1533],
    [-73.2227, 41.1483],
    [-73.2276, 41.1430],
    [-73.2351, 41.1440],
    [-73.2378, 41.1381],
    [-73.2526, 41.1250],
    [-73.2676, 41.1194],
    [-73.2863, 41.1278],
    [-73.2987, 41.1248],
    [-73.2992, 41.1199],
    [-73.3085, 41.1155],
    [-73.3108, 41.1157],
    [-73.3155, 41.1166],
    [-73.3195, 41.1154],
    [-73.3286, 41.1112],
    [-73.3311, 41.1101],
    [-73.3504, 41.1064],
    [-73.3682, 41.1072],
    [-73.3654, 41.0973],
    [-73.3797, 41.0905],
    [-73.3877, 41.0913],
    [-73.3930, 41.0821],
    [-73.4026, 41.0859],
    [-73.4072, 41.0755],
    [-73.4220, 41.0642],
    [-73.4382, 41.0555],
    [-73.4467, 41.0574],
    [-73.4589, 41.0491],
    [-73.4774, 41.0360],
    [-73.4933, 41.0482],
    [-73.5059, 41.0343],
    [-73.5212, 41.0377],
    [-73.5226, 41.0362],
    [-73.5172, 41.0297],
    [-73.5207, 41.0228],
    [-73.5289, 41.0164],
    [-73.5302, 41.0288],
    [-73.5353, 41.0319],
    [-73.5399, 41.0290],
    [-73.5515, 41.0243],
    [-73.5572, 41.0172],
    [-73.5677, 41.0109],
    [-73.5851, 41.0055],
    [-73.5932, 41.0124],
    [-73.6040, 41.0151],
    [-73.6249, 41.0065],
    [-73.6410, 41.0023],
    [-73.6488, 40.9968],
    [-73.6537, 40.9911],
    [-73.6576, 40.9855],
    [-73.6596, 40.9943],
    [-73.6603, 41.0005],
    [-73.6579, 41.0052],
    [-73.6552, 41.0119],
    [-73.6557, 41.0127],
    [-73.6604, 41.0184],
    [-73.6667, 41.0255],
    [-73.6758, 41.0366],
    [-73.6872, 41.0507],
    [-73.7062, 41.0742],
    [-73.7278, 41.1007]
    ]
  }
};

export function getStateBoundary(stateName: string): StateBoundary | null {
  return stateBoundaries[stateName] || null;
}

// Helper function to get all state names
export function getAllStateNames(): string[] {
  return Object.keys(stateBoundaries);
}
